

export const mar_cap = [


  {
    "Rank": "1",
    "Name": "Microsoft",
    "Symbol": "MSFT",
    " marketcap ": " $3 188 758 151 168 ",
    "price (USD)": "429.04",
    "country": "United States"
  },
  {
    "Rank": "2",
    "Name": "Apple",
    "Symbol": "AAPL",
    " marketcap ": " $2 949 514 264 576 ",
    "price (USD)": "192.35",
    "country": "United States"
  },
  {
    "Rank": "3",
    "Name": "NVIDIA",
    "Symbol": "NVDA",
    " marketcap ": " $2 346 333 503 488 ",
    "price (USD)": "953.86",
    "country": "United States"
  },
  {
    "Rank": "4",
    "Name": "Alphabet (Google)",
    "Symbol": "GOOG",
    " marketcap ": " $2 207 354 454 016 ",
    "price (USD)": "179.54",
    "country": "United States"
  },
  {
    "Rank": "5",
    "Name": "Saudi Aramco",
    "Symbol": "2222.SR",
    " marketcap ": " $1 937 162 801 830 ",
    "price (USD)": "8.00576",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6",
    "Name": "Amazon",
    "Symbol": "AMZN",
    " marketcap ": " $1 905 968 676 864 ",
    "price (USD)": "183.15",
    "country": "United States"
  },
  {
    "Rank": "7",
    "Name": "Meta Platforms (Facebook)",
    "Symbol": "META",
    " marketcap ": " $1 178 547 912 704 ",
    "price (USD)": "464.63",
    "country": "United States"
  },
  {
    "Rank": "8",
    "Name": "Berkshire Hathaway",
    "Symbol": "BRK-B",
    " marketcap ": " $895 068 143 616 ",
    "price (USD)": "414.37",
    "country": "United States"
  },
  {
    "Rank": "9",
    "Name": "TSMC",
    "Symbol": "TSM",
    " marketcap ": " $797 044 768 768 ",
    "price (USD)": "153.67",
    "country": "Taiwan"
  },
  {
    "Rank": "10",
    "Name": "Eli Lilly",
    "Symbol": "LLY",
    " marketcap ": " $763 336 785 920 ",
    "price (USD)": "803.17",
    "country": "United States"
  },
  {
    "Rank": "11",
    "Name": "Broadcom",
    "Symbol": "AVGO",
    " marketcap ": " $648 418 623 488 ",
    "price (USD)": "1399.2",
    "country": "United States"
  },
  {
    "Rank": "12",
    "Name": "Novo Nordisk",
    "Symbol": "NVO",
    " marketcap ": " $602 091 880 448 ",
    "price (USD)": "135.16",
    "country": "Denmark"
  },
  {
    "Rank": "13",
    "Name": "Tesla",
    "Symbol": "TSLA",
    " marketcap ": " $595 104 694 272 ",
    "price (USD)": "186.6",
    "country": "United States"
  },
  {
    "Rank": "14",
    "Name": "JPMorgan Chase",
    "Symbol": "JPM",
    " marketcap ": " $572 955 623 424 ",
    "price (USD)": "199.52",
    "country": "United States"
  },
  {
    "Rank": "15",
    "Name": "Visa",
    "Symbol": "V",
    " marketcap ": " $564 621 279 232 ",
    "price (USD)": "275.95",
    "country": "United States"
  },
  {
    "Rank": "16",
    "Name": "Exxon Mobil",
    "Symbol": "XOM",
    " marketcap ": " $528 666 853 376 ",
    "price (USD)": "117.85",
    "country": "United States"
  },
  {
    "Rank": "17",
    "Name": "Walmart",
    "Symbol": "WMT",
    " marketcap ": " $525 095 305 216 ",
    "price (USD)": "65.15",
    "country": "United States"
  },
  {
    "Rank": "18",
    "Name": "UnitedHealth",
    "Symbol": "UNH",
    " marketcap ": " $481 867 563 008 ",
    "price (USD)": "523.55",
    "country": "United States"
  },
  {
    "Rank": "19",
    "Name": "Tencent",
    "Symbol": "TCEHY",
    " marketcap ": " $463 095 627 776 ",
    "price (USD)": "49.18",
    "country": "China"
  },
  {
    "Rank": "20",
    "Name": "Mastercard",
    "Symbol": "MA",
    " marketcap ": " $426 786 226 176 ",
    "price (USD)": "459.1",
    "country": "United States"
  },
  {
    "Rank": "21",
    "Name": "LVMH",
    "Symbol": "MC.PA",
    " marketcap ": " $420 376 718 775 ",
    "price (USD)": "829.623",
    "country": "France"
  },
  {
    "Rank": "22",
    "Name": "Procter & Gamble",
    "Symbol": "PG",
    " marketcap ": " $397 329 596 416 ",
    "price (USD)": "168.35",
    "country": "United States"
  },
  {
    "Rank": "23",
    "Name": "Samsung",
    "Symbol": "005930.KS",
    " marketcap ": " $379 103 491 030 ",
    "price (USD)": "57.0627",
    "country": "South Korea"
  },
  {
    "Rank": "24",
    "Name": "ASML",
    "Symbol": "ASML",
    " marketcap ": " $370 988 875 776 ",
    "price (USD)": "925.27",
    "country": "Netherlands"
  },
  {
    "Rank": "25",
    "Name": "Johnson & Johnson",
    "Symbol": "JNJ",
    " marketcap ": " $363 986 321 408 ",
    "price (USD)": "151.24",
    "country": "United States"
  },
  {
    "Rank": "26",
    "Name": "Costco",
    "Symbol": "COST",
    " marketcap ": " $355 215 671 296 ",
    "price (USD)": "800.93",
    "country": "United States"
  },
  {
    "Rank": "27",
    "Name": "Oracle",
    "Symbol": "ORCL",
    " marketcap ": " $342 546 776 064 ",
    "price (USD)": "124.63",
    "country": "United States"
  },
  {
    "Rank": "28",
    "Name": "Home Depot",
    "Symbol": "HD",
    " marketcap ": " $333 331 038 208 ",
    "price (USD)": "336.15",
    "country": "United States"
  },
  {
    "Rank": "29",
    "Name": "Merck",
    "Symbol": "MRK",
    " marketcap ": " $331 190 206 464 ",
    "price (USD)": "130.76",
    "country": "United States"
  },
  {
    "Rank": "30",
    "Name": "Bank of America",
    "Symbol": "BAC",
    " marketcap ": " $310 077 685 760 ",
    "price (USD)": "39.65",
    "country": "United States"
  },
  {
    "Rank": "31",
    "Name": "Toyota",
    "Symbol": "TM",
    " marketcap ": " $295 999 995 904 ",
    "price (USD)": "219.36",
    "country": "Japan"
  },
  {
    "Rank": "32",
    "Name": "Chevron",
    "Symbol": "CVX",
    " marketcap ": " $294 819 921 920 ",
    "price (USD)": "159.97",
    "country": "United States"
  },
  {
    "Rank": "33",
    "Name": "Kweichow Moutai",
    "Symbol": "600519.SS",
    " marketcap ": " $294 595 224 108 ",
    "price (USD)": "234.513",
    "country": "China"
  },
  {
    "Rank": "34",
    "Name": "AbbVie",
    "Symbol": "ABBV",
    " marketcap ": " $287 713 165 312 ",
    "price (USD)": "162.93",
    "country": "United States"
  },
  {
    "Rank": "35",
    "Name": "Netflix",
    "Symbol": "NFLX",
    " marketcap ": " $280 348 491 776 ",
    "price (USD)": "650.61",
    "country": "United States"
  },
  {
    "Rank": "36",
    "Name": "Salesforce",
    "Symbol": "CRM",
    " marketcap ": " $275 602 210 816 ",
    "price (USD)": "283.76",
    "country": "United States"
  },
  {
    "Rank": "37",
    "Name": "Nestl\u0413\u00a9",
    "Symbol": "NESN.SW",
    " marketcap ": " $273 065 821 676 ",
    "price (USD)": "104.224",
    "country": "Switzerland"
  },
  {
    "Rank": "38",
    "Name": "Coca-Cola",
    "Symbol": "KO",
    " marketcap ": " $271 013 756 928 ",
    "price (USD)": "62.91",
    "country": "United States"
  },
  {
    "Rank": "39",
    "Name": "AMD",
    "Symbol": "AMD",
    " marketcap ": " $266 141 614 080 ",
    "price (USD)": "164.66",
    "country": "United States"
  },
  {
    "Rank": "40",
    "Name": "L'Or\u0413\u00a9al",
    "Symbol": "OR.PA",
    " marketcap ": " $261 791 643 479 ",
    "price (USD)": "488.109",
    "country": "France"
  },
  {
    "Rank": "41",
    "Name": "ICBC",
    "Symbol": "1398.HK",
    " marketcap ": " $258 343 297 796 ",
    "price (USD)": "0.611231",
    "country": "China"
  },
  {
    "Rank": "42",
    "Name": "Herm\u0413\u0401s",
    "Symbol": "RMS.PA",
    " marketcap ": " $255 379 662 157 ",
    "price (USD)": "2417.2",
    "country": "France"
  },
  {
    "Rank": "43",
    "Name": "Pepsico",
    "Symbol": "PEP",
    " marketcap ": " $248 946 982 912 ",
    "price (USD)": "181.08",
    "country": "United States"
  },
  {
    "Rank": "44",
    "Name": "AstraZeneca",
    "Symbol": "AZN",
    " marketcap ": " $245 495 218 176 ",
    "price (USD)": "79.18",
    "country": "United Kingdom"
  },
  {
    "Rank": "45",
    "Name": "PetroChina",
    "Symbol": "601857.SS",
    " marketcap ": " $245 493 602 990 ",
    "price (USD)": "1.38826",
    "country": "China"
  },
  {
    "Rank": "46",
    "Name": "International Holding Company",
    "Symbol": "IHC.AE",
    " marketcap ": " $238 603 529 844 ",
    "price (USD)": "108.78",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "47",
    "Name": "Reliance Industries",
    "Symbol": "RELIANCE.NS",
    " marketcap ": " $238 525 567 144 ",
    "price (USD)": "35.253",
    "country": "India"
  },
  {
    "Rank": "48",
    "Name": "SAP",
    "Symbol": "SAP",
    " marketcap ": " $228 170 940 416 ",
    "price (USD)": "194.72",
    "country": "Germany"
  },
  {
    "Rank": "49",
    "Name": "Shell",
    "Symbol": "SHEL",
    " marketcap ": " $227 390 455 808 ",
    "price (USD)": "71.4",
    "country": "United Kingdom"
  },
  {
    "Rank": "50",
    "Name": "Thermo Fisher Scientific",
    "Symbol": "TMO",
    " marketcap ": " $225 258 242 048 ",
    "price (USD)": "590.12",
    "country": "United States"
  },
  {
    "Rank": "51",
    "Name": "QUALCOMM",
    "Symbol": "QCOM",
    " marketcap ": " $224 148 602 880 ",
    "price (USD)": "200.85",
    "country": "United States"
  },
  {
    "Rank": "52",
    "Name": "Adobe",
    "Symbol": "ADBE",
    " marketcap ": " $215 868 801 024 ",
    "price (USD)": "481.85",
    "country": "United States"
  },
  {
    "Rank": "53",
    "Name": "Wells Fargo",
    "Symbol": "WFC",
    " marketcap ": " $214 269 231 104 ",
    "price (USD)": "61.46",
    "country": "United States"
  },
  {
    "Rank": "54",
    "Name": "Alibaba",
    "Symbol": "BABA",
    " marketcap ": " $210 694 651 904 ",
    "price (USD)": "86.13",
    "country": "China"
  },
  {
    "Rank": "55",
    "Name": "Novartis",
    "Symbol": "NVS",
    " marketcap ": " $210 469 257 216 ",
    "price (USD)": "102.84",
    "country": "Switzerland"
  },
  {
    "Rank": "56",
    "Name": "Agricultural Bank of China",
    "Symbol": "601288.SS",
    " marketcap ": " $210 035 017 635 ",
    "price (USD)": "0.610556",
    "country": "China"
  },
  {
    "Rank": "57",
    "Name": "Linde",
    "Symbol": "LIN",
    " marketcap ": " $209 130 700 800 ",
    "price (USD)": "435.04",
    "country": "United Kingdom"
  },
  {
    "Rank": "58",
    "Name": "Roche",
    "Symbol": "ROG.SW",
    " marketcap ": " $207 029 911 104 ",
    "price (USD)": "256.115",
    "country": "Switzerland"
  },
  {
    "Rank": "59",
    "Name": "China Mobile",
    "Symbol": "0941.HK",
    " marketcap ": " $205 822 373 710 ",
    "price (USD)": "9.45037",
    "country": "China"
  },
  {
    "Rank": "60",
    "Name": "Pinduoduo",
    "Symbol": "PDD",
    " marketcap ": " $201 996 599 296 ",
    "price (USD)": "145.45",
    "country": "China"
  },
  {
    "Rank": "61",
    "Name": "Danaher",
    "Symbol": "DHR",
    " marketcap ": " $197 430 099 968 ",
    "price (USD)": "266.55",
    "country": "United States"
  },
  {
    "Rank": "62",
    "Name": "T-Mobile US",
    "Symbol": "TMUS",
    " marketcap ": " $192 605 257 728 ",
    "price (USD)": "164.36",
    "country": "United States"
  },
  {
    "Rank": "63",
    "Name": "McDonald",
    "Symbol": "MCD",
    " marketcap ": " $191 607 717 888 ",
    "price (USD)": "265.87",
    "country": "United States"
  },
  {
    "Rank": "64",
    "Name": "Accenture",
    "Symbol": "ACN",
    " marketcap ": " $190 907 285 504 ",
    "price (USD)": "303.64",
    "country": "Ireland"
  },
  {
    "Rank": "65",
    "Name": "China Construction Bank",
    "Symbol": "601939.SS",
    " marketcap ": " $190 810 671 662 ",
    "price (USD)": "0.989046",
    "country": "China"
  },
  {
    "Rank": "66",
    "Name": "Cisco",
    "Symbol": "CSCO",
    " marketcap ": " $190 068 965 376 ",
    "price (USD)": "46.94",
    "country": "United States"
  },
  {
    "Rank": "67",
    "Name": "Walt Disney",
    "Symbol": "DIS",
    " marketcap ": " $187 791 360 000 ",
    "price (USD)": "103.01",
    "country": "United States"
  },
  {
    "Rank": "68",
    "Name": "Intuit",
    "Symbol": "INTU",
    " marketcap ": " $186 975 584 256 ",
    "price (USD)": "667.82",
    "country": "United States"
  },
  {
    "Rank": "69",
    "Name": "Applied Materials",
    "Symbol": "AMAT",
    " marketcap ": " $182 631 170 048 ",
    "price (USD)": "219.8",
    "country": "United States"
  },
  {
    "Rank": "70",
    "Name": "Texas Instruments",
    "Symbol": "TXN",
    " marketcap ": " $181 195 014 144 ",
    "price (USD)": "199.01",
    "country": "United States"
  },
  {
    "Rank": "71",
    "Name": "Abbott Laboratories",
    "Symbol": "ABT",
    " marketcap ": " $179 112 296 448 ",
    "price (USD)": "102.96",
    "country": "United States"
  },
  {
    "Rank": "72",
    "Name": "General Electric",
    "Symbol": "GE",
    " marketcap ": " $176 232 218 624 ",
    "price (USD)": "161",
    "country": "United States"
  },
  {
    "Rank": "73",
    "Name": "Caterpillar",
    "Symbol": "CAT",
    " marketcap ": " $175 604 269 056 ",
    "price (USD)": "359.07",
    "country": "United States"
  },
  {
    "Rank": "74",
    "Name": "American Express",
    "Symbol": "AXP",
    " marketcap ": " $174 848 163 840 ",
    "price (USD)": "243.08",
    "country": "United States"
  },
  {
    "Rank": "75",
    "Name": "Bank of China",
    "Symbol": "601988.SS",
    " marketcap ": " $174 502 579 465 ",
    "price (USD)": "0.625751",
    "country": "China"
  },
  {
    "Rank": "76",
    "Name": "Amgen",
    "Symbol": "AMGN",
    " marketcap ": " $168 896 561 152 ",
    "price (USD)": "314.85",
    "country": "United States"
  },
  {
    "Rank": "77",
    "Name": "TotalEnergies",
    "Symbol": "TTE",
    " marketcap ": " $168 313 651 200 ",
    "price (USD)": "71.85",
    "country": "France"
  },
  {
    "Rank": "78",
    "Name": "HSBC",
    "Symbol": "HSBC",
    " marketcap ": " $167 605 207 040 ",
    "price (USD)": "44.58",
    "country": "United Kingdom"
  },
  {
    "Rank": "79",
    "Name": "Verizon",
    "Symbol": "VZ",
    " marketcap ": " $166 770 475 008 ",
    "price (USD)": "39.62",
    "country": "United States"
  },
  {
    "Rank": "80",
    "Name": "Tata Consultancy Services",
    "Symbol": "TCS.NS",
    " marketcap ": " $166 699 853 515 ",
    "price (USD)": "46.074",
    "country": "India"
  },
  {
    "Rank": "81",
    "Name": "Prosus",
    "Symbol": "PRX.AS",
    " marketcap ": " $165 569 066 460 ",
    "price (USD)": "37.8923",
    "country": "Netherlands"
  },
  {
    "Rank": "82",
    "Name": "Morgan Stanley",
    "Symbol": "MS",
    " marketcap ": " $165 002 493 952 ",
    "price (USD)": "101.53",
    "country": "United States"
  },
  {
    "Rank": "83",
    "Name": "Pfizer",
    "Symbol": "PFE",
    " marketcap ": " $161 837 809 664 ",
    "price (USD)": "28.56",
    "country": "United States"
  },
  {
    "Rank": "84",
    "Name": "ServiceNow",
    "Symbol": "NOW",
    " marketcap ": " $159 592 087 552 ",
    "price (USD)": "777.05",
    "country": "United States"
  },
  {
    "Rank": "85",
    "Name": "IBM",
    "Symbol": "IBM",
    " marketcap ": " $159 350 063 104 ",
    "price (USD)": "173.47",
    "country": "United States"
  },
  {
    "Rank": "86",
    "Name": "Nextera Energy",
    "Symbol": "NEE",
    " marketcap ": " $158 096 080 896 ",
    "price (USD)": "76.95",
    "country": "United States"
  },
  {
    "Rank": "87",
    "Name": "BHP Group",
    "Symbol": "BHP",
    " marketcap ": " $155 954 715 000 ",
    "price (USD)": "61.63",
    "country": "Australia"
  },
  {
    "Rank": "88",
    "Name": "Philip Morris",
    "Symbol": "PM",
    " marketcap ": " $155 813 560 320 ",
    "price (USD)": "100.23",
    "country": "United States"
  },
  {
    "Rank": "89",
    "Name": "Comcast",
    "Symbol": "CMCSA",
    " marketcap ": " $153 845 530 624 ",
    "price (USD)": "39.21",
    "country": "United States"
  },
  {
    "Rank": "90",
    "Name": "Goldman Sachs",
    "Symbol": "GS",
    " marketcap ": " $151 689 822 208 ",
    "price (USD)": "470.41",
    "country": "United States"
  },
  {
    "Rank": "91",
    "Name": "Siemens",
    "Symbol": "SIE.DE",
    " marketcap ": " $150 658 645 899 ",
    "price (USD)": "190.726",
    "country": "Germany"
  },
  {
    "Rank": "92",
    "Name": "Royal Bank Of Canada",
    "Symbol": "RY",
    " marketcap ": " $149 984 313 344 ",
    "price (USD)": "105.88",
    "country": "Canada"
  },
  {
    "Rank": "93",
    "Name": "Inditex",
    "Symbol": "IDEXY",
    " marketcap ": " $146 563 350 528 ",
    "price (USD)": "23.54",
    "country": "Spain"
  },
  {
    "Rank": "94",
    "Name": "Charles Schwab",
    "Symbol": "SCHW",
    " marketcap ": " $144 242 622 464 ",
    "price (USD)": "78.9",
    "country": "United States"
  },
  {
    "Rank": "95",
    "Name": "Dior",
    "Symbol": "CDI.PA",
    " marketcap ": " $144 073 137 218 ",
    "price (USD)": "786.73",
    "country": "France"
  },
  {
    "Rank": "96",
    "Name": "Union Pacific Corporation",
    "Symbol": "UNP",
    " marketcap ": " $143 354 265 600 ",
    "price (USD)": "234.96",
    "country": "United States"
  },
  {
    "Rank": "97",
    "Name": "Intuitive Surgical",
    "Symbol": "ISRG",
    " marketcap ": " $142 630 813 696 ",
    "price (USD)": "402.11",
    "country": "United States"
  },
  {
    "Rank": "98",
    "Name": "HDFC Bank",
    "Symbol": "HDB",
    " marketcap ": " $142 355 562 496 ",
    "price (USD)": "56.17",
    "country": "India"
  },
  {
    "Rank": "99",
    "Name": "Schneider Electric",
    "Symbol": "SU.PA",
    " marketcap ": " $141 762 742 361 ",
    "price (USD)": "252.579",
    "country": "France"
  },
  {
    "Rank": "100",
    "Name": "Micron Technology",
    "Symbol": "MU",
    " marketcap ": " $141 189 677 056 ",
    "price (USD)": "127.5",
    "country": "United States"
  },
  {
    "Rank": "101",
    "Name": "ConocoPhillips",
    "Symbol": "COP",
    " marketcap ": " $140 823 117 824 ",
    "price (USD)": "120.41",
    "country": "United States"
  },
  {
    "Rank": "102",
    "Name": "Raytheon Technologies",
    "Symbol": "RTX",
    " marketcap ": " $140 170 248 192 ",
    "price (USD)": "105.43",
    "country": "United States"
  },
  {
    "Rank": "103",
    "Name": "Nike",
    "Symbol": "NKE",
    " marketcap ": " $140 098 797 568 ",
    "price (USD)": "92.82",
    "country": "United States"
  },
  {
    "Rank": "104",
    "Name": "Airbus",
    "Symbol": "AIR.PA",
    " marketcap ": " $139 100 942 817 ",
    "price (USD)": "175.871",
    "country": "Netherlands"
  },
  {
    "Rank": "105",
    "Name": "S&P Global",
    "Symbol": "SPGI",
    " marketcap ": " $137 635 315 712 ",
    "price (USD)": "439.87",
    "country": "United States"
  },
  {
    "Rank": "106",
    "Name": "Unilever",
    "Symbol": "UL",
    " marketcap ": " $136 366 555 136 ",
    "price (USD)": "54.28",
    "country": "United Kingdom"
  },
  {
    "Rank": "107",
    "Name": "Commonwealth Bank",
    "Symbol": "CBA.AX",
    " marketcap ": " $135 559 737 629 ",
    "price (USD)": "81.0173",
    "country": "Australia"
  },
  {
    "Rank": "108",
    "Name": "Intel",
    "Symbol": "INTC",
    " marketcap ": " $135 113 048 064 ",
    "price (USD)": "31.74",
    "country": "United States"
  },
  {
    "Rank": "109",
    "Name": "Eaton",
    "Symbol": "ETN",
    " marketcap ": " $134 655 639 552 ",
    "price (USD)": "336.73",
    "country": "Ireland"
  },
  {
    "Rank": "110",
    "Name": "Uber",
    "Symbol": "UBER",
    " marketcap ": " $133 666 594 816 ",
    "price (USD)": "63.97",
    "country": "United States"
  },
  {
    "Rank": "111",
    "Name": "Honeywell",
    "Symbol": "HON",
    " marketcap ": " $132 522 852 352 ",
    "price (USD)": "203.51",
    "country": "United States"
  },
  {
    "Rank": "112",
    "Name": "Anheuser-Busch Inbev",
    "Symbol": "BUD",
    " marketcap ": " $132 056 719 360 ",
    "price (USD)": "66.24",
    "country": "Belgium"
  },
  {
    "Rank": "113",
    "Name": "Booking Holdings (Booking.com)",
    "Symbol": "BKNG",
    " marketcap ": " $129 682 440 192 ",
    "price (USD)": "3822.34",
    "country": "United States"
  },
  {
    "Rank": "114",
    "Name": "Lowe's Companies",
    "Symbol": "LOW",
    " marketcap ": " $128 663 093 248 ",
    "price (USD)": "224.86",
    "country": "United States"
  },
  {
    "Rank": "115",
    "Name": "Elevance Health",
    "Symbol": "ELV",
    " marketcap ": " $126 809 579 520 ",
    "price (USD)": "545.61",
    "country": "United States"
  },
  {
    "Rank": "116",
    "Name": "CM Bank",
    "Symbol": "3968.HK",
    " marketcap ": " $126 045 820 708 ",
    "price (USD)": "4.86934",
    "country": "China"
  },
  {
    "Rank": "117",
    "Name": "Lam Research",
    "Symbol": "LRCX",
    " marketcap ": " $126 034 321 408 ",
    "price (USD)": "964",
    "country": "United States"
  },
  {
    "Rank": "118",
    "Name": "Stryker Corporation",
    "Symbol": "SYK",
    " marketcap ": " $125 907 795 968 ",
    "price (USD)": "330.51",
    "country": "United States"
  },
  {
    "Rank": "119",
    "Name": "CATL",
    "Symbol": "300750.SZ",
    " marketcap ": " $124 503 652 974 ",
    "price (USD)": "28.3025",
    "country": "China"
  },
  {
    "Rank": "120",
    "Name": "United Parcel Service",
    "Symbol": "UPS",
    " marketcap ": " $124 415 385 600 ",
    "price (USD)": "145.42",
    "country": "United States"
  },
  {
    "Rank": "121",
    "Name": "AT&T",
    "Symbol": "T",
    " marketcap ": " $123 828 838 400 ",
    "price (USD)": "17.27",
    "country": "United States"
  },
  {
    "Rank": "122",
    "Name": "Citigroup",
    "Symbol": "C",
    " marketcap ": " $123 487 657 984 ",
    "price (USD)": "64.74",
    "country": "United States"
  },
  {
    "Rank": "123",
    "Name": "Progressive",
    "Symbol": "PGR",
    " marketcap ": " $122 631 356 416 ",
    "price (USD)": "209.38",
    "country": "United States"
  },
  {
    "Rank": "124",
    "Name": "Sanofi",
    "Symbol": "SNY",
    " marketcap ": " $122 345 136 128 ",
    "price (USD)": "48.95",
    "country": "France"
  },
  {
    "Rank": "125",
    "Name": "CNOOC",
    "Symbol": "0883.HK",
    " marketcap ": " $120 110 375 846 ",
    "price (USD)": "2.43211",
    "country": "China"
  },
  {
    "Rank": "126",
    "Name": "BlackRock",
    "Symbol": "BLK",
    " marketcap ": " $119 612 596 224 ",
    "price (USD)": "804.93",
    "country": "United States"
  },
  {
    "Rank": "127",
    "Name": "Rio Tinto",
    "Symbol": "RIO",
    " marketcap ": " $119 552 704 512 ",
    "price (USD)": "73.48",
    "country": "United Kingdom"
  },
  {
    "Rank": "128",
    "Name": "Deutsche Telekom",
    "Symbol": "DTE.DE",
    " marketcap ": " $119 532 292 809 ",
    "price (USD)": "24.0091",
    "country": "Germany"
  },
  {
    "Rank": "129",
    "Name": "Arm Holdings",
    "Symbol": "ARM",
    " marketcap ": " $119 398 670 336 ",
    "price (USD)": "114.77",
    "country": "United Kingdom"
  },
  {
    "Rank": "130",
    "Name": "Mitsubishi UFJ Financial",
    "Symbol": "MUFG",
    " marketcap ": " $117 027 471 360 ",
    "price (USD)": "\u0441\u0435\u043d.98",
    "country": "Japan"
  },
  {
    "Rank": "131",
    "Name": "Vertex Pharmaceuticals",
    "Symbol": "VRTX",
    " marketcap ": " $114 059 419 648 ",
    "price (USD)": "442",
    "country": "United States"
  },
  {
    "Rank": "132",
    "Name": "Allianz",
    "Symbol": "ALV.DE",
    " marketcap ": " $113 667 215 776 ",
    "price (USD)": "290.368",
    "country": "Germany"
  },
  {
    "Rank": "133",
    "Name": "Boeing",
    "Symbol": "BA",
    " marketcap ": " $113 433 493 504 ",
    "price (USD)": "184.78",
    "country": "United States"
  },
  {
    "Rank": "134",
    "Name": "Medtronic",
    "Symbol": "MDT",
    " marketcap ": " $113 090 428 928 ",
    "price (USD)": "85.17",
    "country": "Ireland"
  },
  {
    "Rank": "135",
    "Name": "Lockheed Martin",
    "Symbol": "LMT",
    " marketcap ": " $112 365 363 200 ",
    "price (USD)": "468.31",
    "country": "United States"
  },
  {
    "Rank": "136",
    "Name": "Keyence",
    "Symbol": "6861.T",
    " marketcap ": " $111 573 445 269 ",
    "price (USD)": "460.047",
    "country": "Japan"
  },
  {
    "Rank": "137",
    "Name": "Boston Scientific",
    "Symbol": "BSX",
    " marketcap ": " $111 248 515 072 ",
    "price (USD)": "75.67",
    "country": "United States"
  },
  {
    "Rank": "138",
    "Name": "China Shenhua Energy",
    "Symbol": "601088.SS",
    " marketcap ": " $110 942 273 548 ",
    "price (USD)": "5.76575",
    "country": "China"
  },
  {
    "Rank": "139",
    "Name": "TJX Companies",
    "Symbol": "TJX",
    " marketcap ": " $110 645 239 808 ",
    "price (USD)": "97.7",
    "country": "United States"
  },
  {
    "Rank": "140",
    "Name": "Ping An Insurance",
    "Symbol": "601318.SS",
    " marketcap ": " $109 767 626 320 ",
    "price (USD)": "6.27132",
    "country": "China"
  },
  {
    "Rank": "141",
    "Name": "Regeneron Pharmaceuticals",
    "Symbol": "REGN",
    " marketcap ": " $109 519 372 288 ",
    "price (USD)": "993.95",
    "country": "United States"
  },
  {
    "Rank": "142",
    "Name": "Dell",
    "Symbol": "DELL",
    " marketcap ": " $107 734 925 312 ",
    "price (USD)": "147.24",
    "country": "United States"
  },
  {
    "Rank": "143",
    "Name": "Deere & Company",
    "Symbol": "DE",
    " marketcap ": " $107 652 177 920 ",
    "price (USD)": "386.74",
    "country": "United States"
  },
  {
    "Rank": "144",
    "Name": "Chubb",
    "Symbol": "CB",
    " marketcap ": " $107 606 163 456 ",
    "price (USD)": "265",
    "country": "Switzerland"
  },
  {
    "Rank": "145",
    "Name": "Analog Devices",
    "Symbol": "ADI",
    " marketcap ": " $107 433 508 864 ",
    "price (USD)": "216.64",
    "country": "United States"
  },
  {
    "Rank": "146",
    "Name": "Tokyo Electron",
    "Symbol": "8035.T",
    " marketcap ": " $107 160 249 044 ",
    "price (USD)": "231.463",
    "country": "Japan"
  },
  {
    "Rank": "147",
    "Name": "China Life Insurance",
    "Symbol": "601628.SS",
    " marketcap ": " $106 048 895 344 ",
    "price (USD)": "4.53497",
    "country": "China"
  },
  {
    "Rank": "148",
    "Name": "EssilorLuxottica",
    "Symbol": "EL.PA",
    " marketcap ": " $104 954 722 658 ",
    "price (USD)": "226.843",
    "country": "France"
  },
  {
    "Rank": "149",
    "Name": "Air Liquide",
    "Symbol": "AI.PA",
    " marketcap ": " $104 647 983 008 ",
    "price (USD)": "199.5",
    "country": "France"
  },
  {
    "Rank": "150",
    "Name": "BP",
    "Symbol": "BP",
    " marketcap ": " $104 498 823 168 ",
    "price (USD)": "37.06",
    "country": "United Kingdom"
  },
  {
    "Rank": "151",
    "Name": "Marsh & McLennan Companies",
    "Symbol": "MMC",
    " marketcap ": " $103 437 549 568 ",
    "price (USD)": "209.93",
    "country": "United States"
  },
  {
    "Rank": "152",
    "Name": "Automatic Data Processing",
    "Symbol": "ADP",
    " marketcap ": " $103 198 638 080 ",
    "price (USD)": "252.14",
    "country": "United States"
  },
  {
    "Rank": "153",
    "Name": "KLA",
    "Symbol": "KLAC",
    " marketcap ": " $103 018 455 040 ",
    "price (USD)": "765.14",
    "country": "United States"
  },
  {
    "Rank": "154",
    "Name": "Prologis",
    "Symbol": "PLD",
    " marketcap ": " $102 398 345 216 ",
    "price (USD)": "110.6",
    "country": "United States"
  },
  {
    "Rank": "155",
    "Name": "Sinopec",
    "Symbol": "600028.SS",
    " marketcap ": " $102 362 727 322 ",
    "price (USD)": "0.885445",
    "country": "China"
  },
  {
    "Rank": "156",
    "Name": "Toronto Dominion Bank",
    "Symbol": "TD",
    " marketcap ": " $100 749 672 448 ",
    "price (USD)": "56.86",
    "country": "Canada"
  },
  {
    "Rank": "157",
    "Name": "Palo Alto Networks",
    "Symbol": "PANW",
    " marketcap ": " $100 697 350 144 ",
    "price (USD)": "311.66",
    "country": "United States"
  },
  {
    "Rank": "158",
    "Name": "Sony",
    "Symbol": "SONY",
    " marketcap ": " $100 547 575 808 ",
    "price (USD)": "82",
    "country": "Japan"
  },
  {
    "Rank": "159",
    "Name": "SK Hynix",
    "Symbol": "000660.KS",
    " marketcap ": " $99 980 738 802 ",
    "price (USD)": "145.19",
    "country": "South Korea"
  },
  {
    "Rank": "160",
    "Name": "Arista Networks",
    "Symbol": "ANET",
    " marketcap ": " $99 332 939 776 ",
    "price (USD)": "316.99",
    "country": "United States"
  },
  {
    "Rank": "161",
    "Name": "Southern Copper",
    "Symbol": "SCCO",
    " marketcap ": " $98 980 274 176 ",
    "price (USD)": "126.71",
    "country": "United States"
  },
  {
    "Rank": "162",
    "Name": "KKR & Co.",
    "Symbol": "KKR",
    " marketcap ": " $98 180 579 328 ",
    "price (USD)": "106.49",
    "country": "United States"
  },
  {
    "Rank": "163",
    "Name": "ABB",
    "Symbol": "ABBN.SW",
    " marketcap ": " $97 790 156 079 ",
    "price (USD)": "52.9019",
    "country": "Switzerland"
  },
  {
    "Rank": "164",
    "Name": "UBS",
    "Symbol": "UBS",
    " marketcap ": " $97 578 524 672 ",
    "price (USD)": "30.\u0430\u043f\u0440",
    "country": "Switzerland"
  },
  {
    "Rank": "165",
    "Name": "Petrobras",
    "Symbol": "PBR",
    " marketcap ": " $96 948 699 136 ",
    "price (USD)": "15.\u0444\u0435\u0432",
    "country": "Brazil"
  },
  {
    "Rank": "166",
    "Name": "Safran",
    "Symbol": "SAF.PA",
    " marketcap ": " $96 016 031 065 ",
    "price (USD)": "232.381",
    "country": "France"
  },
  {
    "Rank": "167",
    "Name": "Cigna",
    "Symbol": "CI",
    " marketcap ": " $95 556 804 608 ",
    "price (USD)": "336.38",
    "country": "United States"
  },
  {
    "Rank": "168",
    "Name": "Meituan",
    "Symbol": "3690.HK",
    " marketcap ": " $95 522 818 346 ",
    "price (USD)": "15.4153",
    "country": "China"
  },
  {
    "Rank": "169",
    "Name": "Bharti Airtel",
    "Symbol": "BHARTIARTL.NS",
    " marketcap ": " $95 397 476 681 ",
    "price (USD)": "16.0405",
    "country": "India"
  },
  {
    "Rank": "170",
    "Name": "ICICI Bank",
    "Symbol": "IBN",
    " marketcap ": " $94 890 688 512 ",
    "price (USD)": "27",
    "country": "India"
  },
  {
    "Rank": "171",
    "Name": "Mondelez",
    "Symbol": "MDLZ",
    " marketcap ": " $94 780 506 112 ",
    "price (USD)": "70.66",
    "country": "United States"
  },
  {
    "Rank": "172",
    "Name": "GlaxoSmithKline",
    "Symbol": "GSK",
    " marketcap ": " $93 474 037 760 ",
    "price (USD)": "44.46",
    "country": "United Kingdom"
  },
  {
    "Rank": "173",
    "Name": "ACWA POWER Company",
    "Symbol": "2082.SR",
    " marketcap ": " $93 092 634 923 ",
    "price (USD)": "127.078",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "174",
    "Name": "Blackstone Group",
    "Symbol": "BX",
    " marketcap ": " $92 206 620 000 ",
    "price (USD)": "127.71",
    "country": "United States"
  },
  {
    "Rank": "175",
    "Name": "Compagnie Financi\u0413\u0401re Richemont",
    "Symbol": "CFR.SW",
    " marketcap ": " $91 881 894 855 ",
    "price (USD)": "156.972",
    "country": "Switzerland"
  },
  {
    "Rank": "176",
    "Name": "Airbnb",
    "Symbol": "ABNB",
    " marketcap ": " $91 481 030 656 ",
    "price (USD)": "144.1",
    "country": "United States"
  },
  {
    "Rank": "177",
    "Name": "American Tower",
    "Symbol": "AMT",
    " marketcap ": " $90 653 859 840 ",
    "price (USD)": "194.13",
    "country": "United States"
  },
  {
    "Rank": "178",
    "Name": "Fiserv",
    "Symbol": "FI",
    " marketcap ": " $89 945 325 568 ",
    "price (USD)": "152.77",
    "country": "United States"
  },
  {
    "Rank": "179",
    "Name": "MercadoLibre",
    "Symbol": "MELI",
    " marketcap ": " $89 839 337 472 ",
    "price (USD)": "1772.07",
    "country": "Argentina"
  },
  {
    "Rank": "180",
    "Name": "CSL",
    "Symbol": "CSL.AX",
    " marketcap ": " $89 611 001 472 ",
    "price (USD)": "185.433",
    "country": "Australia"
  },
  {
    "Rank": "181",
    "Name": "AIA",
    "Symbol": "1299.HK",
    " marketcap ": " $89 313 361 013 ",
    "price (USD)": "7.95112",
    "country": "Hong Kong"
  },
  {
    "Rank": "182",
    "Name": "BNP Paribas",
    "Symbol": "BNP.PA",
    " marketcap ": " $89 136 708 107 ",
    "price (USD)": "73.8951",
    "country": "France"
  },
  {
    "Rank": "183",
    "Name": "Starbucks",
    "Symbol": "SBUX",
    " marketcap ": " $88 033 443 840 ",
    "price (USD)": "77.72",
    "country": "United States"
  },
  {
    "Rank": "184",
    "Name": "Hitachi",
    "Symbol": "6501.T",
    " marketcap ": " $87 830 936 601 ",
    "price (USD)": "94.7796",
    "country": "Japan"
  },
  {
    "Rank": "185",
    "Name": "China Yangtze Power",
    "Symbol": "600900.SS",
    " marketcap ": " $87 810 119 630 ",
    "price (USD)": "3.58874",
    "country": "China"
  },
  {
    "Rank": "186",
    "Name": "State Bank of India",
    "Symbol": "SBIN.NS",
    " marketcap ": " $87 731 981 039 ",
    "price (USD)": "9.83034",
    "country": "India"
  },
  {
    "Rank": "187",
    "Name": "Mitsubishi Corporation",
    "Symbol": "8058.T",
    " marketcap ": " $87 718 243 693 ",
    "price (USD)": "21.4062",
    "country": "Japan"
  },
  {
    "Rank": "188",
    "Name": "Atlas Copco",
    "Symbol": "ATCO-B.ST",
    " marketcap ": " $87 576 209 300 ",
    "price (USD)": "16.2307",
    "country": "Sweden"
  },
  {
    "Rank": "189",
    "Name": "Southern Company",
    "Symbol": "SO",
    " marketcap ": " $87 233 847 296 ",
    "price (USD)": "79.78",
    "country": "United States"
  },
  {
    "Rank": "190",
    "Name": "Synopsys",
    "Symbol": "SNPS",
    " marketcap ": " $87 183 474 688 ",
    "price (USD)": "571.53",
    "country": "United States"
  },
  {
    "Rank": "191",
    "Name": "Chipotle Mexican Grill",
    "Symbol": "CMG",
    " marketcap ": " $87 148 249 088 ",
    "price (USD)": "3172.8",
    "country": "United States"
  },
  {
    "Rank": "192",
    "Name": "Bristol-Myers Squibb",
    "Symbol": "BMY",
    " marketcap ": " $85 685 518 336 ",
    "price (USD)": "42.27",
    "country": "United States"
  },
  {
    "Rank": "193",
    "Name": "TAQA",
    "Symbol": "TAQA.AE",
    " marketcap ": " $85 411 701 881 ",
    "price (USD)": "0.76",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "194",
    "Name": "CrowdStrike",
    "Symbol": "CRWD",
    " marketcap ": " $84 946 944 000 ",
    "price (USD)": "349.32",
    "country": "United States"
  },
  {
    "Rank": "195",
    "Name": "BYD",
    "Symbol": "002594.SZ",
    " marketcap ": " $84 541 358 525 ",
    "price (USD)": "29.9642",
    "country": "China"
  },
  {
    "Rank": "196",
    "Name": "Al Rajhi Bank",
    "Symbol": "1120.SR",
    " marketcap ": " $84 540 862 868 ",
    "price (USD)": "21.1352",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "197",
    "Name": "HCA Healthcare",
    "Symbol": "HCA",
    " marketcap ": " $84 105 822 208 ",
    "price (USD)": "321.12",
    "country": "United States"
  },
  {
    "Rank": "198",
    "Name": "Equinor",
    "Symbol": "EQNR",
    " marketcap ": " $83 908 493 312 ",
    "price (USD)": "28.67",
    "country": "Norway"
  },
  {
    "Rank": "199",
    "Name": "Gilead Sciences",
    "Symbol": "GILD",
    " marketcap ": " $83 833 249 792 ",
    "price (USD)": "67.29",
    "country": "United States"
  },
  {
    "Rank": "200",
    "Name": "Iberdrola",
    "Symbol": "IBE.MC",
    " marketcap ": " $83 627 278 984 ",
    "price (USD)": "13.2913",
    "country": "Spain"
  },
  {
    "Rank": "201",
    "Name": "Waste Management",
    "Symbol": "WM",
    " marketcap ": " $83 557 621 760 ",
    "price (USD)": "208.33",
    "country": "United States"
  },
  {
    "Rank": "202",
    "Name": "Wuliangye Yibin",
    "Symbol": "000858.SZ",
    " marketcap ": " $83 173 144 135 ",
    "price (USD)": "21.4275",
    "country": "China"
  },
  {
    "Rank": "203",
    "Name": "Sumitomo Mitsui Financial Group",
    "Symbol": "SMFG",
    " marketcap ": " $83 107 971 072 ",
    "price (USD)": "\u0434\u0435\u043a.65",
    "country": "Japan"
  },
  {
    "Rank": "204",
    "Name": "AXA",
    "Symbol": "CS.PA",
    " marketcap ": " $83 005 019 681 ",
    "price (USD)": "36.8553",
    "country": "France"
  },
  {
    "Rank": "205",
    "Name": "RELX",
    "Symbol": "RELX",
    " marketcap ": " $82 601 295 872 ",
    "price (USD)": "44.23",
    "country": "United Kingdom"
  },
  {
    "Rank": "206",
    "Name": "Canadian Natural Resources",
    "Symbol": "CNQ",
    " marketcap ": " $82 549 825 536 ",
    "price (USD)": "77.14",
    "country": "Canada"
  },
  {
    "Rank": "207",
    "Name": "NTT (Nippon Telegraph &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "208",
    "Name": "Investor AB",
    "Symbol": "INVE-B.ST",
    " marketcap ": " $82 284 640 980 ",
    "price (USD)": "26.878",
    "country": "Sweden"
  },
  {
    "Rank": "209",
    "Name": "Santander",
    "Symbol": "SAN",
    " marketcap ": " $81 932 754 944 ",
    "price (USD)": "05.\u0444\u0435\u0432",
    "country": "Spain"
  },
  {
    "Rank": "210",
    "Name": "General Dynamics",
    "Symbol": "GD",
    " marketcap ": " $81 502 568 448 ",
    "price (USD)": "297.06",
    "country": "United States"
  },
  {
    "Rank": "211",
    "Name": "Amphenol",
    "Symbol": "APH",
    " marketcap ": " $81 321 779 200 ",
    "price (USD)": "135.4",
    "country": "United States"
  },
  {
    "Rank": "212",
    "Name": "Canadian National Railway",
    "Symbol": "CNI",
    " marketcap ": " $80 762 978 304 ",
    "price (USD)": "126.69",
    "country": "Canada"
  },
  {
    "Rank": "213",
    "Name": "Duke Energy",
    "Symbol": "DUK",
    " marketcap ": " $80 557 252 608 ",
    "price (USD)": "104.38",
    "country": "United States"
  },
  {
    "Rank": "214",
    "Name": "Fast Retailing",
    "Symbol": "9983.T",
    " marketcap ": " $79 822 173 159 ",
    "price (USD)": "260.252",
    "country": "Japan"
  },
  {
    "Rank": "215",
    "Name": "Life Insurance Corporation of India (LIC)",
    "Symbol": "LICI.NS",
    " marketcap ": " $79 800 598 235 ",
    "price (USD)": "\u0434\u0435\u043a.67",
    "country": "India"
  },
  {
    "Rank": "216",
    "Name": "Altria Group",
    "Symbol": "MO",
    " marketcap ": " $79 577 800 704 ",
    "price (USD)": "46.33",
    "country": "United States"
  },
  {
    "Rank": "217",
    "Name": "Mitsui Bussan",
    "Symbol": "8031.T",
    " marketcap ": " $78 958 370 850 ",
    "price (USD)": "52.7286",
    "country": "Japan"
  },
  {
    "Rank": "218",
    "Name": "Cadence Design Systems",
    "Symbol": "CDNS",
    " marketcap ": " $78 946 082 816 ",
    "price (USD)": "290.1",
    "country": "United States"
  },
  {
    "Rank": "219",
    "Name": "Diageo",
    "Symbol": "DEO",
    " marketcap ": " $78 920 056 832 ",
    "price (USD)": "139.73",
    "country": "United Kingdom"
  },
  {
    "Rank": "220",
    "Name": "Zoetis",
    "Symbol": "ZTS",
    " marketcap ": " $78 843 207 680 ",
    "price (USD)": "172.79",
    "country": "United States"
  },
  {
    "Rank": "221",
    "Name": "Intercontinental Exchange",
    "Symbol": "ICE",
    " marketcap ": " $78 736 015 360 ",
    "price (USD)": "137.27",
    "country": "United States"
  },
  {
    "Rank": "222",
    "Name": "Sherwin-Williams",
    "Symbol": "SHW",
    " marketcap ": " $78 590 042 112 ",
    "price (USD)": "309.96",
    "country": "United States"
  },
  {
    "Rank": "223",
    "Name": "SoftBank",
    "Symbol": "9984.T",
    " marketcap ": " $78 515 555 274 ",
    "price (USD)": "53.5602",
    "country": "Japan"
  },
  {
    "Rank": "224",
    "Name": "Merck KGaA",
    "Symbol": "MRK.DE",
    " marketcap ": " $78 372 398 758 ",
    "price (USD)": "180.258",
    "country": "Germany"
  },
  {
    "Rank": "225",
    "Name": "Enbridge",
    "Symbol": "ENB",
    " marketcap ": " $78 335 516 672 ",
    "price (USD)": "36.78",
    "country": "Canada"
  },
  {
    "Rank": "226",
    "Name": "Thomson Reuters",
    "Symbol": "TRI",
    " marketcap ": " $78 111 375 360 ",
    "price (USD)": "173.1",
    "country": "Canada"
  },
  {
    "Rank": "227",
    "Name": "Colgate-Palmolive",
    "Symbol": "CL",
    " marketcap ": " $78 081 368 064 ",
    "price (USD)": "95.17",
    "country": "United States"
  },
  {
    "Rank": "228",
    "Name": "Freeport-McMoRan",
    "Symbol": "FCX",
    " marketcap ": " $78 030 135 296 ",
    "price (USD)": "54.32",
    "country": "United States"
  },
  {
    "Rank": "229",
    "Name": "Glencore",
    "Symbol": "GLCNF",
    " marketcap ": " $77 443 964 928 ",
    "price (USD)": "\u0438\u044e\u043d.35",
    "country": "Switzerland"
  },
  {
    "Rank": "230",
    "Name": "Sberbank",
    "Symbol": "SBER.ME",
    " marketcap ": " $76 741 020 883 ",
    "price (USD)": "\u043c\u0430\u0440.53",
    "country": "Russia"
  },
  {
    "Rank": "231",
    "Name": "Porsche",
    "Symbol": "P911.DE",
    " marketcap ": " $76 350 287 762 ",
    "price (USD)": "83.8093",
    "country": "Germany"
  },
  {
    "Rank": "232",
    "Name": "Mercedes-Benz",
    "Symbol": "MBG.DE",
    " marketcap ": " $76 128 365 416 ",
    "price (USD)": "71.1586",
    "country": "Germany"
  },
  {
    "Rank": "233",
    "Name": "Trane Technologies",
    "Symbol": "TT",
    " marketcap ": " $75 959 197 696 ",
    "price (USD)": "335.58",
    "country": "Ireland"
  },
  {
    "Rank": "234",
    "Name": "Canadian Pacific Railway",
    "Symbol": "CP",
    " marketcap ": " $75 891 310 592 ",
    "price (USD)": "81.21",
    "country": "Canada"
  },
  {
    "Rank": "235",
    "Name": "Recruit",
    "Symbol": "6098.T",
    " marketcap ": " $75 859 359 484 ",
    "price (USD)": "49.1715",
    "country": "Japan"
  },
  {
    "Rank": "236",
    "Name": "CME Group",
    "Symbol": "CME",
    " marketcap ": " $75 739 676 672 ",
    "price (USD)": "210.35",
    "country": "United States"
  },
  {
    "Rank": "237",
    "Name": "Moody's",
    "Symbol": "MCO",
    " marketcap ": " $75 408 384 000 ",
    "price (USD)": "412.95",
    "country": "United States"
  },
  {
    "Rank": "238",
    "Name": "DBS Group",
    "Symbol": "D05.SI",
    " marketcap ": " $75 338 988 928 ",
    "price (USD)": "26.4895",
    "country": "Singapore"
  },
  {
    "Rank": "239",
    "Name": "Ferrari",
    "Symbol": "RACE",
    " marketcap ": " $75 289 452 544 ",
    "price (USD)": "418.37",
    "country": "Italy"
  },
  {
    "Rank": "240",
    "Name": "Equinix",
    "Symbol": "EQIX",
    " marketcap ": " $75 188 084 736 ",
    "price (USD)": "792.24",
    "country": "United States"
  },
  {
    "Rank": "241",
    "Name": "TransDigm",
    "Symbol": "TDG",
    " marketcap ": " $74 807 558 144 ",
    "price (USD)": "1336.84",
    "country": "United States"
  },
  {
    "Rank": "242",
    "Name": "Zurich Insurance Group",
    "Symbol": "ZURN.SW",
    " marketcap ": " $74 735 565 390 ",
    "price (USD)": "519.033",
    "country": "Switzerland"
  },
  {
    "Rank": "243",
    "Name": "Shin-Etsu Chemical",
    "Symbol": "4063.T",
    " marketcap ": " $74 473 570 119 ",
    "price (USD)": "37.3105",
    "country": "Japan"
  },
  {
    "Rank": "244",
    "Name": "Illinois Tool Works",
    "Symbol": "ITW",
    " marketcap ": " $74 235 953 152 ",
    "price (USD)": "248.78",
    "country": "United States"
  },
  {
    "Rank": "245",
    "Name": "EOG Resources",
    "Symbol": "EOG",
    " marketcap ": " $74 080 239 616 ",
    "price (USD)": "128.9",
    "country": "United States"
  },
  {
    "Rank": "246",
    "Name": "Enel",
    "Symbol": "ENEL.MI",
    " marketcap ": " $73 769 809 534 ",
    "price (USD)": "7.23531",
    "country": "Italy"
  },
  {
    "Rank": "247",
    "Name": "Shopify",
    "Symbol": "SHOP",
    " marketcap ": " $73 465 135 104 ",
    "price (USD)": "57.02",
    "country": "Canada"
  },
  {
    "Rank": "248",
    "Name": "China Telecom",
    "Symbol": "0728.HK",
    " marketcap ": " $73 204 645 754 ",
    "price (USD)": "0.567663",
    "country": "China"
  },
  {
    "Rank": "249",
    "Name": "Foxconn (Hon Hai Precision Industry)",
    "Symbol": "2317.TW",
    " marketcap ": " $72 645 311 184 ",
    "price (USD)": "\u043c\u0430\u0439.08",
    "country": "Taiwan"
  },
  {
    "Rank": "250",
    "Name": "Bank Central Asia",
    "Symbol": "BBCA.JK",
    " marketcap ": " $72 258 539 925 ",
    "price (USD)": "0.586157",
    "country": "Indonesia"
  },
  {
    "Rank": "251",
    "Name": "Target",
    "Symbol": "TGT",
    " marketcap ": " $72 068 808 704 ",
    "price (USD)": "155.78",
    "country": "United States"
  },
  {
    "Rank": "252",
    "Name": "CVS Health",
    "Symbol": "CVS",
    " marketcap ": " $71 957 807 104 ",
    "price (USD)": "57.32",
    "country": "United States"
  },
  {
    "Rank": "253",
    "Name": "McKesson",
    "Symbol": "MCK",
    " marketcap ": " $71 802 970 112 ",
    "price (USD)": "552.39",
    "country": "United States"
  },
  {
    "Rank": "254",
    "Name": "National Australia Bank",
    "Symbol": "NAB.AX",
    " marketcap ": " $71 778 964 088 ",
    "price (USD)": "23.1983",
    "country": "Australia"
  },
  {
    "Rank": "255",
    "Name": "Walmex",
    "Symbol": "WMMVF",
    " marketcap ": " $71 648 681 984 ",
    "price (USD)": "4.075",
    "country": "Mexico"
  },
  {
    "Rank": "256",
    "Name": "Infosys",
    "Symbol": "INFY",
    " marketcap ": " $71 280 746 496 ",
    "price (USD)": "17.\u044f\u043d\u0432",
    "country": "India"
  },
  {
    "Rank": "257",
    "Name": "Vinci",
    "Symbol": "DG.PA",
    " marketcap ": " $71 046 385 406 ",
    "price (USD)": "125.041",
    "country": "France"
  },
  {
    "Rank": "258",
    "Name": "Cintas",
    "Symbol": "CTAS",
    " marketcap ": " $71 019 028 480 ",
    "price (USD)": "699.95",
    "country": "United States"
  },
  {
    "Rank": "259",
    "Name": "Intesa Sanpaolo",
    "Symbol": "ISP.MI",
    " marketcap ": " $70 517 325 781 ",
    "price (USD)": "3.85275",
    "country": "Italy"
  },
  {
    "Rank": "260",
    "Name": "Parker-Hannifin",
    "Symbol": "PH",
    " marketcap ": " $70 295 216 128 ",
    "price (USD)": "546.87",
    "country": "United States"
  },
  {
    "Rank": "261",
    "Name": "Volkswagen",
    "Symbol": "VOW3.DE",
    " marketcap ": " $70 223 329 143 ",
    "price (USD)": "127.918",
    "country": "Germany"
  },
  {
    "Rank": "262",
    "Name": "Constellation Energy",
    "Symbol": "CEG",
    " marketcap ": " $70 168 158 208 ",
    "price (USD)": "222.59",
    "country": "United States"
  },
  {
    "Rank": "263",
    "Name": "NXP Semiconductors",
    "Symbol": "NXPI",
    " marketcap ": " $70 164 807 680 ",
    "price (USD)": "274.42",
    "country": "Netherlands"
  },
  {
    "Rank": "264",
    "Name": "British American Tobacco",
    "Symbol": "BTI",
    " marketcap ": " $69 960 949 760 ",
    "price (USD)": "31.47",
    "country": "United Kingdom"
  },
  {
    "Rank": "265",
    "Name": "Northrop Grumman",
    "Symbol": "NOC",
    " marketcap ": " $69 907 267 584 ",
    "price (USD)": "471.9",
    "country": "United States"
  },
  {
    "Rank": "266",
    "Name": "Foxconn Industrial Internet",
    "Symbol": "601138.SS",
    " marketcap ": " $69 777 675 539 ",
    "price (USD)": "3.51277",
    "country": "China"
  },
  {
    "Rank": "267",
    "Name": "Rosneft",
    "Symbol": "ROSN.ME",
    " marketcap ": " $69 500 026 540 ",
    "price (USD)": "\u0438\u044e\u043d.55",
    "country": "Russia"
  },
  {
    "Rank": "268",
    "Name": "Schlumberger",
    "Symbol": "SLB",
    " marketcap ": " $69 022 834 688 ",
    "price (USD)": "48.29",
    "country": "United States"
  },
  {
    "Rank": "269",
    "Name": "Bank of Montreal",
    "Symbol": "BMO",
    " marketcap ": " $68 776 230 912 ",
    "price (USD)": "94.63",
    "country": "Canada"
  },
  {
    "Rank": "270",
    "Name": "Workday",
    "Symbol": "WDAY",
    " marketcap ": " $68 673 224 704 ",
    "price (USD)": "258.86",
    "country": "United States"
  },
  {
    "Rank": "271",
    "Name": "Marriott International",
    "Symbol": "MAR",
    " marketcap ": " $68 058 013 696 ",
    "price (USD)": "238.28",
    "country": "United States"
  },
  {
    "Rank": "272",
    "Name": "Becton Dickinson",
    "Symbol": "BDX",
    " marketcap ": " $67 875 954 688 ",
    "price (USD)": "234.86",
    "country": "United States"
  },
  {
    "Rank": "273",
    "Name": "Munich RE (M\u0413\u0458nchener R\u0413\u0458ck)",
    "Symbol": "MUV2.DE",
    " marketcap ": " $67 614 249 643 ",
    "price (USD)": "502.335",
    "country": "Germany"
  },
  {
    "Rank": "274",
    "Name": "Postal Savings Bank of China",
    "Symbol": "601658.SS",
    " marketcap ": " $67 406 486 864 ",
    "price (USD)": "0.703107",
    "country": "China"
  },
  {
    "Rank": "275",
    "Name": "Brookfield Corporation",
    "Symbol": "BN",
    " marketcap ": " $67 322 490 880 ",
    "price (USD)": "44.58",
    "country": "Canada"
  },
  {
    "Rank": "276",
    "Name": "It\u0415\u040cch\u0415\u00ab Sh\u0415\u040cji",
    "Symbol": "8001.T",
    " marketcap ": " $67 224 422 215 ",
    "price (USD)": "46.7213",
    "country": "Japan"
  },
  {
    "Rank": "277",
    "Name": "Ecolab",
    "Symbol": "ECL",
    " marketcap ": " $67 108 945 920 ",
    "price (USD)": "235",
    "country": "United States"
  },
  {
    "Rank": "278",
    "Name": "PayPal",
    "Symbol": "PYPL",
    " marketcap ": " $67 051 802 624 ",
    "price (USD)": "64.1",
    "country": "United States"
  },
  {
    "Rank": "279",
    "Name": "Stellantis",
    "Symbol": "STLA",
    " marketcap ": " $67 035 860 992 ",
    "price (USD)": "22.\u0441\u0435\u043d",
    "country": "Netherlands"
  },
  {
    "Rank": "280",
    "Name": "Hindustan Unilever",
    "Symbol": "HINDUNILVR.NS",
    " marketcap ": " $66 724 212 993 ",
    "price (USD)": "28.3982",
    "country": "India"
  },
  {
    "Rank": "281",
    "Name": "Bank of Communications",
    "Symbol": "601328.SS",
    " marketcap ": " $66 631 978 318 ",
    "price (USD)": "0.979376",
    "country": "China"
  },
  {
    "Rank": "282",
    "Name": "Daiichi Sanky\u0415\u040c",
    "Symbol": "4568.T",
    " marketcap ": " $66 562 660 802 ",
    "price (USD)": "34.7131",
    "country": "Japan"
  },
  {
    "Rank": "283",
    "Name": "UniCredit",
    "Symbol": "UCG.MI",
    " marketcap ": " $66 036 428 989 ",
    "price (USD)": "39.6677",
    "country": "Italy"
  },
  {
    "Rank": "284",
    "Name": "ITC",
    "Symbol": "ITC.NS",
    " marketcap ": " $65 988 438 348 ",
    "price (USD)": "5.28554",
    "country": "India"
  },
  {
    "Rank": "285",
    "Name": "Nongfu Spring",
    "Symbol": "9633.HK",
    " marketcap ": " $65 931 827 050 ",
    "price (USD)": "5.86243",
    "country": "China"
  },
  {
    "Rank": "286",
    "Name": "Zijin Mining",
    "Symbol": "601899.SS",
    " marketcap ": " $65 868 419 145 ",
    "price (USD)": "2.54583",
    "country": "China"
  },
  {
    "Rank": "287",
    "Name": "NetEase",
    "Symbol": "NTES",
    " marketcap ": " $65 491 582 976 ",
    "price (USD)": "98.9",
    "country": "China"
  },
  {
    "Rank": "288",
    "Name": "Apollo Global Management",
    "Symbol": "APO",
    " marketcap ": " $65 264 758 784 ",
    "price (USD)": "114.7",
    "country": "United States"
  },
  {
    "Rank": "289",
    "Name": "Emerson",
    "Symbol": "EMR",
    " marketcap ": " $65 047 764 992 ",
    "price (USD)": "113.7",
    "country": "United States"
  },
  {
    "Rank": "290",
    "Name": "Siemens Healthineers",
    "Symbol": "SHL.DE",
    " marketcap ": " $64 919 131 458 ",
    "price (USD)": "58.1822",
    "country": "Germany"
  },
  {
    "Rank": "291",
    "Name": "CSX Corporation",
    "Symbol": "CSX",
    " marketcap ": " $64 649 535 488 ",
    "price (USD)": "33.07",
    "country": "United States"
  },
  {
    "Rank": "292",
    "Name": "Tokio Marine",
    "Symbol": "8766.T",
    " marketcap ": " $64 593 053 882 ",
    "price (USD)": "32.909",
    "country": "Japan"
  },
  {
    "Rank": "293",
    "Name": "ADNOC Gas",
    "Symbol": "ADNOCGAS.AE",
    " marketcap ": " $64 365 284 340 ",
    "price (USD)": "0.84",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "294",
    "Name": "U.S. Bancorp",
    "Symbol": "USB",
    " marketcap ": " $64 259 743 744 ",
    "price (USD)": "41.18",
    "country": "United States"
  },
  {
    "Rank": "295",
    "Name": "BMW",
    "Symbol": "BMW.DE",
    " marketcap ": " $63 987 677 307 ",
    "price (USD)": "100.728",
    "country": "Germany"
  },
  {
    "Rank": "296",
    "Name": "Marvell Technology Group",
    "Symbol": "MRVL",
    " marketcap ": " $63 439 319 040 ",
    "price (USD)": "73.3",
    "country": "United States"
  },
  {
    "Rank": "297",
    "Name": "Ita\u0413\u0454 Unibanco",
    "Symbol": "ITUB",
    " marketcap ": " $63 223 414 784 ",
    "price (USD)": "\u0438\u044e\u043d.45",
    "country": "Brazil"
  },
  {
    "Rank": "298",
    "Name": "London Stock Exchange",
    "Symbol": "LSEG.L",
    " marketcap ": " $63 206 981 604 ",
    "price (USD)": "118.972",
    "country": "United Kingdom"
  },
  {
    "Rank": "299",
    "Name": "PNC Financial Services",
    "Symbol": "PNC",
    " marketcap ": " $63 088 156 672 ",
    "price (USD)": "158.55",
    "country": "United States"
  },
  {
    "Rank": "300",
    "Name": "Aon",
    "Symbol": "AON",
    " marketcap ": " $63 050 645 504 ",
    "price (USD)": "289.98",
    "country": "United Kingdom"
  },
  {
    "Rank": "301",
    "Name": "Midea",
    "Symbol": "000333.SZ",
    " marketcap ": " $63 024 836 793 ",
    "price (USD)": "9.0354",
    "country": "China"
  },
  {
    "Rank": "302",
    "Name": "SABIC",
    "Symbol": "2010.SR",
    " marketcap ": " $63 005 362 154 ",
    "price (USD)": "21.0018",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "303",
    "Name": "Pioneer Natural Resources",
    "Symbol": "PXD",
    " marketcap ": " $63 003 455 488 ",
    "price (USD)": "269.62",
    "country": "United States"
  },
  {
    "Rank": "304",
    "Name": "Banco Bilbao Vizcaya Argentaria",
    "Symbol": "BBVA",
    " marketcap ": " $62 646 964 224 ",
    "price (USD)": "\u043e\u043a\u0442.87",
    "country": "Spain"
  },
  {
    "Rank": "305",
    "Name": "Westpac Banking",
    "Symbol": "WBC.AX",
    " marketcap ": " $62 617 064 675 ",
    "price (USD)": "18.0505",
    "country": "Australia"
  },
  {
    "Rank": "306",
    "Name": "LG Energy Solution",
    "Symbol": "373220.KS",
    " marketcap ": " $62 553 055 921 ",
    "price (USD)": "267.321",
    "country": "South Korea"
  },
  {
    "Rank": "307",
    "Name": "Nintendo",
    "Symbol": "7974.T",
    " marketcap ": " $62 410 945 793 ",
    "price (USD)": "53.4259",
    "country": "Japan"
  },
  {
    "Rank": "308",
    "Name": "Enterprise Products",
    "Symbol": "EPD",
    " marketcap ": " $62 280 339 456 ",
    "price (USD)": "28.68",
    "country": "United States"
  },
  {
    "Rank": "309",
    "Name": "Marathon Petroleum",
    "Symbol": "MPC",
    " marketcap ": " $62 214 430 720 ",
    "price (USD)": "176.58",
    "country": "United States"
  },
  {
    "Rank": "310",
    "Name": "FedEx",
    "Symbol": "FDX",
    " marketcap ": " $62 093 619 200 ",
    "price (USD)": "252.33",
    "country": "United States"
  },
  {
    "Rank": "311",
    "Name": "Xiaomi",
    "Symbol": "XIACF",
    " marketcap ": " $61 687 205 888 ",
    "price (USD)": "\u0444\u0435\u0432.46",
    "country": "China"
  },
  {
    "Rank": "312",
    "Name": "Motorola Solutions",
    "Symbol": "MSI",
    " marketcap ": " $61 667 827 712 ",
    "price (USD)": "369.74",
    "country": "United States"
  },
  {
    "Rank": "313",
    "Name": "America Movil",
    "Symbol": "AMX",
    " marketcap ": " $61 162 786 816 ",
    "price (USD)": "19.65",
    "country": "Mexico"
  },
  {
    "Rank": "314",
    "Name": "Phillips 66",
    "Symbol": "PSX",
    " marketcap ": " $61 108 441 088 ",
    "price (USD)": "144.14",
    "country": "United States"
  },
  {
    "Rank": "315",
    "Name": "Spotify",
    "Symbol": "SPOT",
    " marketcap ": " $60 697 534 464 ",
    "price (USD)": "304.93",
    "country": "Sweden"
  },
  {
    "Rank": "316",
    "Name": "Welltower",
    "Symbol": "WELL",
    " marketcap ": " $60 449 308 672 ",
    "price (USD)": "101.1",
    "country": "United States"
  },
  {
    "Rank": "317",
    "Name": "Lukoil",
    "Symbol": "LKOH.ME",
    " marketcap ": " $60 062 543 836 ",
    "price (USD)": "86.68",
    "country": "Russia"
  },
  {
    "Rank": "318",
    "Name": "Carrier",
    "Symbol": "CARR",
    " marketcap ": " $59 665 014 784 ",
    "price (USD)": "66.22",
    "country": "United States"
  },
  {
    "Rank": "319",
    "Name": "Scotiabank",
    "Symbol": "BNS",
    " marketcap ": " $59 390 042 112 ",
    "price (USD)": "48.53",
    "country": "Canada"
  },
  {
    "Rank": "320",
    "Name": "ING",
    "Symbol": "ING",
    " marketcap ": " $58 953 003 008 ",
    "price (USD)": "17.98",
    "country": "Netherlands"
  },
  {
    "Rank": "321",
    "Name": "Air Products and Chemicals",
    "Symbol": "APD",
    " marketcap ": " $58 835 505 152 ",
    "price (USD)": "264.66",
    "country": "United States"
  },
  {
    "Rank": "322",
    "Name": "Republic Services",
    "Symbol": "RSG",
    " marketcap ": " $58 728 517 632 ",
    "price (USD)": "186.48",
    "country": "United States"
  },
  {
    "Rank": "323",
    "Name": "O'Reilly Automotive",
    "Symbol": "ORLY",
    " marketcap ": " $58 634 379 264 ",
    "price (USD)": "995.59",
    "country": "United States"
  },
  {
    "Rank": "324",
    "Name": "Heineken",
    "Symbol": "HEIA.AS",
    " marketcap ": " $58 602 613 756 ",
    "price (USD)": "104.007",
    "country": "Netherlands"
  },
  {
    "Rank": "325",
    "Name": "MediaTek",
    "Symbol": "2454.TW",
    " marketcap ": " $58 485 646 215 ",
    "price (USD)": "36.7476",
    "country": "Taiwan"
  },
  {
    "Rank": "326",
    "Name": "Roper Technologies",
    "Symbol": "ROP",
    " marketcap ": " $57 954 164 736 ",
    "price (USD)": "541.4",
    "country": "United States"
  },
  {
    "Rank": "327",
    "Name": "KDDI",
    "Symbol": "9433.T",
    " marketcap ": " $57 947 586 840 ",
    "price (USD)": "27.8293",
    "country": "Japan"
  },
  {
    "Rank": "328",
    "Name": "Constellation Software",
    "Symbol": "CSU.TO",
    " marketcap ": " $57 609 589 091 ",
    "price (USD)": "2718.52",
    "country": "Canada"
  },
  {
    "Rank": "329",
    "Name": "Nu Holdings",
    "Symbol": "NU",
    " marketcap ": " $57 468 702 720 ",
    "price (USD)": "12.\u0444\u0435\u0432",
    "country": "Brazil"
  },
  {
    "Rank": "330",
    "Name": "Larsen &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "331",
    "Name": "ANZ Bank",
    "Symbol": "ANZ.AX",
    " marketcap ": " $57 289 238 451 ",
    "price (USD)": "19.0841",
    "country": "Australia"
  },
  {
    "Rank": "332",
    "Name": "3M",
    "Symbol": "MMM",
    " marketcap ": " $57 073 655 808 ",
    "price (USD)": "103.14",
    "country": "United States"
  },
  {
    "Rank": "333",
    "Name": "Arthur J. Gallagher & Co.",
    "Symbol": "AJG",
    " marketcap ": " $56 342 163 456 ",
    "price (USD)": "257.84",
    "country": "United States"
  },
  {
    "Rank": "334",
    "Name": "Occidental Petroleum",
    "Symbol": "OXY",
    " marketcap ": " $56 168 452 096 ",
    "price (USD)": "63.35",
    "country": "United States"
  },
  {
    "Rank": "335",
    "Name": "Fortescue",
    "Symbol": "FMG.AX",
    " marketcap ": " $56 049 027 291 ",
    "price (USD)": "18.2039",
    "country": "Australia"
  },
  {
    "Rank": "336",
    "Name": "Universal Music Group",
    "Symbol": "UMG.AS",
    " marketcap ": " $56 014 185 497 ",
    "price (USD)": "30.7525",
    "country": "Netherlands"
  },
  {
    "Rank": "337",
    "Name": "Monster Beverage",
    "Symbol": "MNST",
    " marketcap ": " $55 954 518 016 ",
    "price (USD)": "53.38",
    "country": "United States"
  },
  {
    "Rank": "338",
    "Name": "Dassault Syst\u0413\u0401mes",
    "Symbol": "DSY.PA",
    " marketcap ": " $55 767 802 802 ",
    "price (USD)": "42.5345",
    "country": "France"
  },
  {
    "Rank": "339",
    "Name": "Cement Roadstone Holding",
    "Symbol": "CRH",
    " marketcap ": " $55 616 397 312 ",
    "price (USD)": "81.11",
    "country": "Ireland"
  },
  {
    "Rank": "340",
    "Name": "Vale",
    "Symbol": "VALE",
    " marketcap ": " $55 463 981 056 ",
    "price (USD)": "\u0434\u0435\u043a.88",
    "country": "Brazil"
  },
  {
    "Rank": "341",
    "Name": "Simon Property Group",
    "Symbol": "SPG",
    " marketcap ": " $55 457 382 400 ",
    "price (USD)": "147.97",
    "country": "United States"
  },
  {
    "Rank": "342",
    "Name": "Coinbase",
    "Symbol": "COIN",
    " marketcap ": " $55 444 566 016 ",
    "price (USD)": "225.78",
    "country": "United States"
  },
  {
    "Rank": "343",
    "Name": "Paccar",
    "Symbol": "PCAR",
    " marketcap ": " $55 349 710 848 ",
    "price (USD)": "105.6",
    "country": "United States"
  },
  {
    "Rank": "344",
    "Name": "Moderna",
    "Symbol": "MRNA",
    " marketcap ": " $55 067 754 496 ",
    "price (USD)": "143.69",
    "country": "United States"
  },
  {
    "Rank": "345",
    "Name": "The Saudi National Bank",
    "Symbol": "1180.SR",
    " marketcap ": " $54 812 728 183 ",
    "price (USD)": "9.21997",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "346",
    "Name": "Volvo Group",
    "Symbol": "VOLVF",
    " marketcap ": " $54 590 189 568 ",
    "price (USD)": "26.9375",
    "country": "Sweden"
  },
  {
    "Rank": "347",
    "Name": "Edwards Lifesciences",
    "Symbol": "EW",
    " marketcap ": " $54 438 883 328 ",
    "price (USD)": "90.34",
    "country": "United States"
  },
  {
    "Rank": "348",
    "Name": "Snowflake",
    "Symbol": "SNOW",
    " marketcap ": " $54 377 684 992 ",
    "price (USD)": "162.71",
    "country": "United States"
  },
  {
    "Rank": "349",
    "Name": "National Grid",
    "Symbol": "NGG",
    " marketcap ": " $54 123 315 200 ",
    "price (USD)": "72.72",
    "country": "United Kingdom"
  },
  {
    "Rank": "350",
    "Name": "Grupo M\u0413\u00a9xico",
    "Symbol": "GMBXF",
    " marketcap ": " $53 869 936 640 ",
    "price (USD)": "\u0438\u044e\u043d.86",
    "country": "Mexico"
  },
  {
    "Rank": "351",
    "Name": "Honda",
    "Symbol": "HMC",
    " marketcap ": " $53 845 614 592 ",
    "price (USD)": "33.38",
    "country": "Japan"
  },
  {
    "Rank": "352",
    "Name": "Energy Transfer Partners",
    "Symbol": "ET",
    " marketcap ": " $53 684 420 608 ",
    "price (USD)": "15.93",
    "country": "United States"
  },
  {
    "Rank": "353",
    "Name": "Capital One",
    "Symbol": "COF",
    " marketcap ": " $53 629 485 056 ",
    "price (USD)": "140.42",
    "country": "United States"
  },
  {
    "Rank": "354",
    "Name": "Alimentation Couche-Tard",
    "Symbol": "ATD.TO",
    " marketcap ": " $53 527 811 500 ",
    "price (USD)": "55.6545",
    "country": "Canada"
  },
  {
    "Rank": "355",
    "Name": "Valero Energy",
    "Symbol": "VLO",
    " marketcap ": " $53 500 039 168 ",
    "price (USD)": "162.39",
    "country": "United States"
  },
  {
    "Rank": "356",
    "Name": "BAE Systems",
    "Symbol": "BA.L",
    " marketcap ": " $53 410 716 239 ",
    "price (USD)": "17.6017",
    "country": "United Kingdom"
  },
  {
    "Rank": "357",
    "Name": "Truist Financial",
    "Symbol": "TFC",
    " marketcap ": " $52 908 474 368 ",
    "price (USD)": "39.54",
    "country": "United States"
  },
  {
    "Rank": "358",
    "Name": "Suncor Energy",
    "Symbol": "SU",
    " marketcap ": " $52 840 787 968 ",
    "price (USD)": "41.05",
    "country": "Canada"
  },
  {
    "Rank": "359",
    "Name": "Copart",
    "Symbol": "CPRT",
    " marketcap ": " $52 813 107 200 ",
    "price (USD)": "54.93",
    "country": "United States"
  },
  {
    "Rank": "360",
    "Name": "Interactive Brokers",
    "Symbol": "IBKR",
    " marketcap ": " $52 766 879 744 ",
    "price (USD)": "126.6",
    "country": "United States"
  },
  {
    "Rank": "361",
    "Name": "Supermicro",
    "Symbol": "SMCI",
    " marketcap ": " $52 639 367 168 ",
    "price (USD)": "898.95",
    "country": "United States"
  },
  {
    "Rank": "362",
    "Name": "American International Group",
    "Symbol": "AIG",
    " marketcap ": " $52 217 397 248 ",
    "price (USD)": "78.68",
    "country": "United States"
  },
  {
    "Rank": "363",
    "Name": "Cr\u0413\u00a9dit Agricole",
    "Symbol": "ACA.PA",
    " marketcap ": " $52 192 620 610 ",
    "price (USD)": "17.1517",
    "country": "France"
  },
  {
    "Rank": "364",
    "Name": "Industrial Bank",
    "Symbol": "601166.SS",
    " marketcap ": " $52 170 342 304 ",
    "price (USD)": "2.51129",
    "country": "China"
  },
  {
    "Rank": "365",
    "Name": "DexCom",
    "Symbol": "DXCM",
    " marketcap ": " $52 032 974 848 ",
    "price (USD)": "130.84",
    "country": "United States"
  },
  {
    "Rank": "366",
    "Name": "Jingdong Mall",
    "Symbol": "JD",
    " marketcap ": " $51 799 904 256 ",
    "price (USD)": "33.29",
    "country": "China"
  },
  {
    "Rank": "367",
    "Name": "Microchip Technology",
    "Symbol": "MCHP",
    " marketcap ": " $51 758 358 528 ",
    "price (USD)": "95.78",
    "country": "United States"
  },
  {
    "Rank": "368",
    "Name": "Mizuho Financial Group",
    "Symbol": "MFG",
    " marketcap ": " $51 704 205 312 ",
    "price (USD)": "04.\u0430\u0432\u0433",
    "country": "Japan"
  },
  {
    "Rank": "369",
    "Name": "MetLife",
    "Symbol": "MET",
    " marketcap ": " $51 620 417 536 ",
    "price (USD)": "72.59",
    "country": "United States"
  },
  {
    "Rank": "370",
    "Name": "Hilton Worldwide",
    "Symbol": "HLT",
    " marketcap ": " $51 459 469 312 ",
    "price (USD)": "205.8",
    "country": "United States"
  },
  {
    "Rank": "371",
    "Name": "General Motors",
    "Symbol": "GM",
    " marketcap ": " $51 251 920 896 ",
    "price (USD)": "44.92",
    "country": "United States"
  },
  {
    "Rank": "372",
    "Name": "Infineon",
    "Symbol": "IFX.DE",
    " marketcap ": " $51 229 275 570 ",
    "price (USD)": "39.4885",
    "country": "Germany"
  },
  {
    "Rank": "373",
    "Name": "Mindray",
    "Symbol": "300760.SZ",
    " marketcap ": " $51 081 488 546 ",
    "price (USD)": "42.1311",
    "country": "China"
  },
  {
    "Rank": "374",
    "Name": "Chugai Pharmaceutical",
    "Symbol": "4519.T",
    " marketcap ": " $51 010 885 207 ",
    "price (USD)": "31.0025",
    "country": "Japan"
  },
  {
    "Rank": "375",
    "Name": "Williams Companies",
    "Symbol": "WMB",
    " marketcap ": " $50 919 370 752 ",
    "price (USD)": "41.78",
    "country": "United States"
  },
  {
    "Rank": "376",
    "Name": "ENI",
    "Symbol": "E",
    " marketcap ": " $50 915 930 112 ",
    "price (USD)": "31.38",
    "country": "Italy"
  },
  {
    "Rank": "377",
    "Name": "Wesfarmers",
    "Symbol": "WES.AX",
    " marketcap ": " $50 796 020 911 ",
    "price (USD)": "44.7629",
    "country": "Australia"
  },
  {
    "Rank": "378",
    "Name": "Newmont",
    "Symbol": "NEM",
    " marketcap ": " $50 784 284 672 ",
    "price (USD)": "44.04",
    "country": "United States"
  },
  {
    "Rank": "379",
    "Name": "Norfolk Southern",
    "Symbol": "NSC",
    " marketcap ": " $50 765 135 872 ",
    "price (USD)": "224.71",
    "country": "United States"
  },
  {
    "Rank": "380",
    "Name": "Maaden",
    "Symbol": "1211.SR",
    " marketcap ": " $50 736 840 370 ",
    "price (USD)": "13.7432",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "381",
    "Name": "Saudi Telecom Company",
    "Symbol": "7010.SR",
    " marketcap ": " $50 413 077 875 ",
    "price (USD)": "10.1139",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "382",
    "Name": "Japan Tobacco",
    "Symbol": "2914.T",
    " marketcap ": " $50 315 119 367 ",
    "price (USD)": "28.3411",
    "country": "Japan"
  },
  {
    "Rank": "383",
    "Name": "Macquarie",
    "Symbol": "MQG.AX",
    " marketcap ": " $50 259 483 367 ",
    "price (USD)": "130.488",
    "country": "Australia"
  },
  {
    "Rank": "384",
    "Name": "Bajaj Finance",
    "Symbol": "BAJFINANCE.NS",
    " marketcap ": " $50 258 244 956 ",
    "price (USD)": "81.2579",
    "country": "India"
  },
  {
    "Rank": "385",
    "Name": "DHL Group (Deutsche Post)",
    "Symbol": "DHL.DE",
    " marketcap ": " $49 937 405 443 ",
    "price (USD)": "42.2847",
    "country": "Germany"
  },
  {
    "Rank": "386",
    "Name": "Aflac",
    "Symbol": "AFL",
    " marketcap ": " $49 770 565 632 ",
    "price (USD)": "87.59",
    "country": "United States"
  },
  {
    "Rank": "387",
    "Name": "Public Storage",
    "Symbol": "PSA",
    " marketcap ": " $49 735 442 432 ",
    "price (USD)": "283.03",
    "country": "United States"
  },
  {
    "Rank": "388",
    "Name": "Sika",
    "Symbol": "SIKA.SW",
    " marketcap ": " $49 679 727 829 ",
    "price (USD)": "309.664",
    "country": "Switzerland"
  },
  {
    "Rank": "389",
    "Name": "Sempra Energy",
    "Symbol": "SRE",
    " marketcap ": " $49 615 130 624 ",
    "price (USD)": "78.4",
    "country": "United States"
  },
  {
    "Rank": "390",
    "Name": "The Travelers Companies",
    "Symbol": "TRV",
    " marketcap ": " $49 519 734 784 ",
    "price (USD)": "216.25",
    "country": "United States"
  },
  {
    "Rank": "391",
    "Name": "Pacific Gas and Electric",
    "Symbol": "PCG",
    " marketcap ": " $49 473 908 736 ",
    "price (USD)": "18.92",
    "country": "United States"
  },
  {
    "Rank": "392",
    "Name": "Chandra Asri Petrochemical",
    "Symbol": "TPIA.JK",
    " marketcap ": " $49 357 100 915 ",
    "price (USD)": "0.570526",
    "country": "Indonesia"
  },
  {
    "Rank": "393",
    "Name": "D. R. Horton",
    "Symbol": "DHI",
    " marketcap ": " $49 192 628 224 ",
    "price (USD)": "149.38",
    "country": "United States"
  },
  {
    "Rank": "394",
    "Name": "Johnson Controls",
    "Symbol": "JCI",
    " marketcap ": " $49 084 035 072 ",
    "price (USD)": "72.86",
    "country": "Ireland"
  },
  {
    "Rank": "395",
    "Name": "American Electric Power",
    "Symbol": "AEP",
    " marketcap ": " $48 822 038 528 ",
    "price (USD)": "92.62",
    "country": "United States"
  },
  {
    "Rank": "396",
    "Name": "Oneok",
    "Symbol": "OKE",
    " marketcap ": " $48 448 536 576 ",
    "price (USD)": "83.01",
    "country": "United States"
  },
  {
    "Rank": "397",
    "Name": "AutoZone",
    "Symbol": "AZO",
    " marketcap ": " $48 360 312 832 ",
    "price (USD)": "2820.83",
    "country": "United States"
  },
  {
    "Rank": "398",
    "Name": "Holcim Group",
    "Symbol": "HOLN.SW",
    " marketcap ": " $48 358 293 533 ",
    "price (USD)": "86.0739",
    "country": "Switzerland"
  },
  {
    "Rank": "399",
    "Name": "Oriental Land",
    "Symbol": "4661.T",
    " marketcap ": " $48 332 162 910 ",
    "price (USD)": "29.4991",
    "country": "Japan"
  },
  {
    "Rank": "400",
    "Name": "Ford",
    "Symbol": "F",
    " marketcap ": " $48 279 601 152 ",
    "price (USD)": "\u0434\u0435\u043a.15",
    "country": "United States"
  },
  {
    "Rank": "401",
    "Name": "Compass Group",
    "Symbol": "CPG.L",
    " marketcap ": " $48 175 806 715 ",
    "price (USD)": "28.3001",
    "country": "United Kingdom"
  },
  {
    "Rank": "402",
    "Name": "OCBC Bank",
    "Symbol": "O39.SI",
    " marketcap ": " $48 042 405 019 ",
    "price (USD)": "10.676",
    "country": "Singapore"
  },
  {
    "Rank": "403",
    "Name": "Realty Income",
    "Symbol": "O",
    " marketcap ": " $47 962 234 880 ",
    "price (USD)": "55.08",
    "country": "United States"
  },
  {
    "Rank": "404",
    "Name": "Digital Realty",
    "Symbol": "DLR",
    " marketcap ": " $47 763 038 208 ",
    "price (USD)": "144.26",
    "country": "United States"
  },
  {
    "Rank": "405",
    "Name": "Denso",
    "Symbol": "6902.T",
    " marketcap ": " $47 729 746 565 ",
    "price (USD)": "16.3969",
    "country": "Japan"
  },
  {
    "Rank": "406",
    "Name": "Hess",
    "Symbol": "HES",
    " marketcap ": " $47 637 196 800 ",
    "price (USD)": "154.61",
    "country": "United States"
  },
  {
    "Rank": "407",
    "Name": "Estee Lauder",
    "Symbol": "EL",
    " marketcap ": " $47 588 614 144 ",
    "price (USD)": "132.72",
    "country": "United States"
  },
  {
    "Rank": "408",
    "Name": "Manulife Financial",
    "Symbol": "MFC",
    " marketcap ": " $47 447 539 712 ",
    "price (USD)": "26.37",
    "country": "Canada"
  },
  {
    "Rank": "409",
    "Name": "Maruti Suzuki India",
    "Symbol": "MARUTI.NS",
    " marketcap ": " $47 443 400 935 ",
    "price (USD)": "150.9",
    "country": "India"
  },
  {
    "Rank": "410",
    "Name": "CITIC Bank",
    "Symbol": "601998.SS",
    " marketcap ": " $47 399 570 818 ",
    "price (USD)": "0.979376",
    "country": "China"
  },
  {
    "Rank": "411",
    "Name": "Palantir",
    "Symbol": "PLTR",
    " marketcap ": " $47 299 354 624 ",
    "price (USD)": "21.24",
    "country": "United States"
  },
  {
    "Rank": "412",
    "Name": "BASF",
    "Symbol": "BAS.DE",
    " marketcap ": " $47 194 437 581 ",
    "price (USD)": "52.8776",
    "country": "Germany"
  },
  {
    "Rank": "413",
    "Name": "Autodesk",
    "Symbol": "ADSK",
    " marketcap ": " $47 121 199 104 ",
    "price (USD)": "220.28",
    "country": "United States"
  },
  {
    "Rank": "414",
    "Name": "W. W. Grainger",
    "Symbol": "GWW",
    " marketcap ": " $47 009 173 504 ",
    "price (USD)": "956.77",
    "country": "United States"
  },
  {
    "Rank": "415",
    "Name": "Fortinet",
    "Symbol": "FTNT",
    " marketcap ": " $46 837 039 104 ",
    "price (USD)": "61.31",
    "country": "United States"
  },
  {
    "Rank": "416",
    "Name": "The Trade Desk",
    "Symbol": "TTD",
    " marketcap ": " $46 784 999 424 ",
    "price (USD)": "95.65",
    "country": "United States"
  },
  {
    "Rank": "417",
    "Name": "Rolls-Royce Holdings",
    "Symbol": "RR.L",
    " marketcap ": " $46 697 024 539 ",
    "price (USD)": "5.54814",
    "country": "United Kingdom"
  },
  {
    "Rank": "418",
    "Name": "United Rentals",
    "Symbol": "URI",
    " marketcap ": " $46 655 823 872 ",
    "price (USD)": "694.59",
    "country": "United States"
  },
  {
    "Rank": "419",
    "Name": "TE Connectivity",
    "Symbol": "TEL",
    " marketcap ": " $46 485 409 792 ",
    "price (USD)": "151.8",
    "country": "Switzerland"
  },
  {
    "Rank": "420",
    "Name": "Atlassian",
    "Symbol": "TEAM",
    " marketcap ": " $46 346 059 776 ",
    "price (USD)": "178.05",
    "country": "Australia"
  },
  {
    "Rank": "421",
    "Name": "DoorDash",
    "Symbol": "DASH",
    " marketcap ": " $46 133 673 984 ",
    "price (USD)": "112.82",
    "country": "United States"
  },
  {
    "Rank": "422",
    "Name": "CIBC",
    "Symbol": "CM",
    " marketcap ": " $46 104 207 360 ",
    "price (USD)": "49.07",
    "country": "Canada"
  },
  {
    "Rank": "423",
    "Name": "Keurig Dr Pepper",
    "Symbol": "KDP",
    " marketcap ": " $46 035 156 992 ",
    "price (USD)": "33.96",
    "country": "United States"
  },
  {
    "Rank": "424",
    "Name": "Hong Kong Exchanges & Clearing",
    "Symbol": "0388.HK",
    " marketcap ": " $46 009 166 225 ",
    "price (USD)": "36.2894",
    "country": "Hong Kong"
  },
  {
    "Rank": "425",
    "Name": "Constellation Brands",
    "Symbol": "STZ",
    " marketcap ": " $45 923 315 712 ",
    "price (USD)": "250.98",
    "country": "United States"
  },
  {
    "Rank": "426",
    "Name": "Paychex",
    "Symbol": "PAYX",
    " marketcap ": " $45 319 344 128 ",
    "price (USD)": "125.9",
    "country": "United States"
  },
  {
    "Rank": "427",
    "Name": "Dominion Energy",
    "Symbol": "D",
    " marketcap ": " $45 213 102 080 ",
    "price (USD)": "53.94",
    "country": "United States"
  },
  {
    "Rank": "428",
    "Name": "Agilent Technologies",
    "Symbol": "A",
    " marketcap ": " $45 033 762 816 ",
    "price (USD)": "153.67",
    "country": "United States"
  },
  {
    "Rank": "429",
    "Name": "Kimberly-Clark",
    "Symbol": "KMB",
    " marketcap ": " $45 031 460 864 ",
    "price (USD)": "133.74",
    "country": "United States"
  },
  {
    "Rank": "430",
    "Name": "Lloyds Banking Group",
    "Symbol": "LYG",
    " marketcap ": " $44 987 092 992 ",
    "price (USD)": "\u0444\u0435\u0432.83",
    "country": "United Kingdom"
  },
  {
    "Rank": "431",
    "Name": "Daikin",
    "Symbol": "6367.T",
    " marketcap ": " $44 875 910 531 ",
    "price (USD)": "153.285",
    "country": "Japan"
  },
  {
    "Rank": "432",
    "Name": "Lennar",
    "Symbol": "LEN",
    " marketcap ": " $44 836 691 968 ",
    "price (USD)": "162.71",
    "country": "United States"
  },
  {
    "Rank": "433",
    "Name": "Hyundai",
    "Symbol": "HYMTF",
    " marketcap ": " $44 726 870 016 ",
    "price (USD)": "58.23",
    "country": "South Korea"
  },
  {
    "Rank": "434",
    "Name": "Kering",
    "Symbol": "KER.PA",
    " marketcap ": " $44 539 336 458 ",
    "price (USD)": "360.517",
    "country": "France"
  },
  {
    "Rank": "435",
    "Name": "Bank Rakyat Indonesia",
    "Symbol": "BBRI.JK",
    " marketcap ": " $44 500 032 896 ",
    "price (USD)": "0.295111",
    "country": "Indonesia"
  },
  {
    "Rank": "436",
    "Name": "Ares Management",
    "Symbol": "ARES",
    " marketcap ": " $44 495 486 976 ",
    "price (USD)": "143.62",
    "country": "United States"
  },
  {
    "Rank": "437",
    "Name": "Allstate",
    "Symbol": "ALL",
    " marketcap ": " $44 387 864 576 ",
    "price (USD)": "168.19",
    "country": "United States"
  },
  {
    "Rank": "438",
    "Name": "Ross Stores",
    "Symbol": "ROST",
    " marketcap ": " $44 361 117 696 ",
    "price (USD)": "132.3",
    "country": "United States"
  },
  {
    "Rank": "439",
    "Name": "Compagnie de Saint-Gobain",
    "Symbol": "SGO.PA",
    " marketcap ": " $44 343 876 886 ",
    "price (USD)": "87.4579",
    "country": "France"
  },
  {
    "Rank": "440",
    "Name": "Adidas",
    "Symbol": "ADS.DE",
    " marketcap ": " $44 283 404 287 ",
    "price (USD)": "248.018",
    "country": "Germany"
  },
  {
    "Rank": "441",
    "Name": "Bank of New York Mellon",
    "Symbol": "BK",
    " marketcap ": " $44 180 971 520 ",
    "price (USD)": "59.08",
    "country": "United States"
  },
  {
    "Rank": "442",
    "Name": "Block",
    "Symbol": "SQ",
    " marketcap ": " $44 124 606 464 ",
    "price (USD)": "71.51",
    "country": "United States"
  },
  {
    "Rank": "443",
    "Name": "Kinder Morgan",
    "Symbol": "KMI",
    " marketcap ": " $43 810 562 048 ",
    "price (USD)": "19.74",
    "country": "United States"
  },
  {
    "Rank": "444",
    "Name": "Crown Castle",
    "Symbol": "CCI",
    " marketcap ": " $43 778 191 360 ",
    "price (USD)": "100.75",
    "country": "United States"
  },
  {
    "Rank": "445",
    "Name": "Alcon",
    "Symbol": "ALC",
    " marketcap ": " $43 750 739 968 ",
    "price (USD)": "88.7",
    "country": "Switzerland"
  },
  {
    "Rank": "446",
    "Name": "Sun Pharmaceutical",
    "Symbol": "SUNPHARMA.NS",
    " marketcap ": " $43 749 065 604 ",
    "price (USD)": "18.2339",
    "country": "India"
  },
  {
    "Rank": "447",
    "Name": "HCL Technologies",
    "Symbol": "HCLTECH.NS",
    " marketcap ": " $43 673 323 634 ",
    "price (USD)": "16.1276",
    "country": "India"
  },
  {
    "Rank": "448",
    "Name": "Kraft Heinz",
    "Symbol": "KHC",
    " marketcap ": " $43 617 656 832 ",
    "price (USD)": "35.92",
    "country": "United States"
  },
  {
    "Rank": "449",
    "Name": "NTPC Limited",
    "Symbol": "NTPC.NS",
    " marketcap ": " $43 451 924 754 ",
    "price (USD)": "4.48112",
    "country": "India"
  },
  {
    "Rank": "450",
    "Name": "Fidelity National Information Services",
    "Symbol": "FIS",
    " marketcap ": " $43 448 766 464 ",
    "price (USD)": "78.11",
    "country": "United States"
  },
  {
    "Rank": "451",
    "Name": "Experian",
    "Symbol": "EXPGF",
    " marketcap ": " $43 345 018 880 ",
    "price (USD)": "47.518",
    "country": "Ireland"
  },
  {
    "Rank": "452",
    "Name": "Cencora",
    "Symbol": "COR",
    " marketcap ": " $43 297 042 432 ",
    "price (USD)": "217.08",
    "country": "United States"
  },
  {
    "Rank": "453",
    "Name": "Ameriprise Financial",
    "Symbol": "AMP",
    " marketcap ": " $43 114 950 656 ",
    "price (USD)": "434.08",
    "country": "United States"
  },
  {
    "Rank": "454",
    "Name": "Goodman Group",
    "Symbol": "GMG.AX",
    " marketcap ": " $42 968 618 116 ",
    "price (USD)": "22.6248",
    "country": "Australia"
  },
  {
    "Rank": "455",
    "Name": "Humana",
    "Symbol": "HUM",
    " marketcap ": " $42 853 769 216 ",
    "price (USD)": "355.63",
    "country": "United States"
  },
  {
    "Rank": "456",
    "Name": "Nordea Bank",
    "Symbol": "NDA-FI.HE",
    " marketcap ": " $42 830 718 680 ",
    "price (USD)": "\u0434\u0435\u043a.17",
    "country": "Finland"
  },
  {
    "Rank": "457",
    "Name": "Ferguson",
    "Symbol": "FERG",
    " marketcap ": " $42 827 436 032 ",
    "price (USD)": "211.91",
    "country": "United Kingdom"
  },
  {
    "Rank": "458",
    "Name": "IDEXX Laboratories",
    "Symbol": "IDXX",
    " marketcap ": " $42 816 557 056 ",
    "price (USD)": "518.44",
    "country": "United States"
  },
  {
    "Rank": "459",
    "Name": "Adani Enterprises",
    "Symbol": "ADANIENT.NS",
    " marketcap ": " $42 735 448 611 ",
    "price (USD)": "37.4872",
    "country": "India"
  },
  {
    "Rank": "460",
    "Name": "L3Harris Technologies",
    "Symbol": "LHX",
    " marketcap ": " $42 725 421 056 ",
    "price (USD)": "225.25",
    "country": "United States"
  },
  {
    "Rank": "461",
    "Name": "Grayscale Bitcoin Trust",
    "Symbol": "GBTC",
    " marketcap ": " $42 649 989 120 ",
    "price (USD)": "61.6",
    "country": "United States"
  },
  {
    "Rank": "462",
    "Name": "Waste Connections",
    "Symbol": "WCN",
    " marketcap ": " $42 611 838 976 ",
    "price (USD)": "165.15",
    "country": "United States"
  },
  {
    "Rank": "463",
    "Name": "Hikvision",
    "Symbol": "002415.SZ",
    " marketcap ": " $42 571 753 057 ",
    "price (USD)": "\u0430\u043f\u0440.26",
    "country": "China"
  },
  {
    "Rank": "464",
    "Name": "Givaudan",
    "Symbol": "GIVN.SW",
    " marketcap ": " $42 404 587 120 ",
    "price (USD)": "4595.58",
    "country": "Switzerland"
  },
  {
    "Rank": "465",
    "Name": "Prudential Financial",
    "Symbol": "PRU",
    " marketcap ": " $42 313 515 008 ",
    "price (USD)": "117.84",
    "country": "United States"
  },
  {
    "Rank": "466",
    "Name": "Sea (Garena)",
    "Symbol": "SE",
    " marketcap ": " $42 076 147 712 ",
    "price (USD)": "73.26",
    "country": "Singapore"
  },
  {
    "Rank": "467",
    "Name": "Fomento Econ\u0413\u0456mico Mexicano",
    "Symbol": "FMX",
    " marketcap ": " $42 047 780 730 ",
    "price (USD)": "117.51",
    "country": "Mexico"
  },
  {
    "Rank": "468",
    "Name": "Oil &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "469",
    "Name": "The Hershey Company",
    "Symbol": "HSY",
    " marketcap ": " $41 932 181 504 ",
    "price (USD)": "207.35",
    "country": "United States"
  },
  {
    "Rank": "470",
    "Name": "Tata Motors",
    "Symbol": "TATAMOTORS.NS",
    " marketcap ": " $41 845 739 522 ",
    "price (USD)": "\u043d\u043e\u044f.16",
    "country": "India"
  },
  {
    "Rank": "471",
    "Name": "Centene",
    "Symbol": "CNC",
    " marketcap ": " $41 838 632 960 ",
    "price (USD)": "78.4",
    "country": "United States"
  },
  {
    "Rank": "472",
    "Name": "MPLX",
    "Symbol": "MPLX",
    " marketcap ": " $41 809 616 896 ",
    "price (USD)": "40.9",
    "country": "United States"
  },
  {
    "Rank": "473",
    "Name": "IQVIA",
    "Symbol": "IQV",
    " marketcap ": " $41 793 036 288 ",
    "price (USD)": "229.38",
    "country": "United States"
  },
  {
    "Rank": "474",
    "Name": "Axis Bank",
    "Symbol": "AXISBANK.BO",
    " marketcap ": " $41 745 968 130 ",
    "price (USD)": "13.5154",
    "country": "India"
  },
  {
    "Rank": "475",
    "Name": "Barclays",
    "Symbol": "BCS",
    " marketcap ": " $41 737 039 872 ",
    "price (USD)": "\u043d\u043e\u044f.17",
    "country": "United Kingdom"
  },
  {
    "Rank": "476",
    "Name": "Danone",
    "Symbol": "BN.PA",
    " marketcap ": " $41 736 665 471 ",
    "price (USD)": "65.0233",
    "country": "France"
  },
  {
    "Rank": "477",
    "Name": "Takeda Pharmaceutical",
    "Symbol": "TAK",
    " marketcap ": " $41 463 971 840 ",
    "price (USD)": "13.\u0444\u0435\u0432",
    "country": "Japan"
  },
  {
    "Rank": "478",
    "Name": "Dow",
    "Symbol": "DOW",
    " marketcap ": " $41 425 866 752 ",
    "price (USD)": "58.91",
    "country": "United States"
  },
  {
    "Rank": "479",
    "Name": "Nucor",
    "Symbol": "NUE",
    " marketcap ": " $41 267 834 880 ",
    "price (USD)": "172.12",
    "country": "United States"
  },
  {
    "Rank": "480",
    "Name": "Anglo American",
    "Symbol": "AAL.L",
    " marketcap ": " $41 160 063 852 ",
    "price (USD)": "33.9512",
    "country": "United Kingdom"
  },
  {
    "Rank": "481",
    "Name": "Adyen",
    "Symbol": "ADYEN.AS",
    " marketcap ": " $41 136 863 225 ",
    "price (USD)": "1325.01",
    "country": "Netherlands"
  },
  {
    "Rank": "482",
    "Name": "Hoya",
    "Symbol": "7741.T",
    " marketcap ": " $41 115 748 207 ",
    "price (USD)": "117.299",
    "country": "Japan"
  },
  {
    "Rank": "483",
    "Name": "ENGIE",
    "Symbol": "ENGI.PA",
    " marketcap ": " $41 095 809 821 ",
    "price (USD)": "16.9399",
    "country": "France"
  },
  {
    "Rank": "484",
    "Name": "Coupang",
    "Symbol": "CPNG",
    " marketcap ": " $41 052 250 112 ",
    "price (USD)": "22.96",
    "country": "South Korea"
  },
  {
    "Rank": "485",
    "Name": "Banco Santander Brasil",
    "Symbol": "BSBR",
    " marketcap ": " $41 015 185 408 ",
    "price (USD)": "\u043c\u0430\u0439.49",
    "country": "Brazil"
  },
  {
    "Rank": "486",
    "Name": "Datadog",
    "Symbol": "DDOG",
    " marketcap ": " $40 919 265 280 ",
    "price (USD)": "122.33",
    "country": "United States"
  },
  {
    "Rank": "487",
    "Name": "lululemon athletica",
    "Symbol": "LULU",
    " marketcap ": " $40 698 064 896 ",
    "price (USD)": "322.98",
    "country": "Canada"
  },
  {
    "Rank": "488",
    "Name": "TC Energy",
    "Symbol": "TRP",
    " marketcap ": " $40 693 112 832 ",
    "price (USD)": "39.16",
    "country": "Canada"
  },
  {
    "Rank": "489",
    "Name": "Samsung Biologics",
    "Symbol": "207940.KS",
    " marketcap ": " $40 613 805 689 ",
    "price (USD)": "570.627",
    "country": "South Korea"
  },
  {
    "Rank": "490",
    "Name": "Kotak Mahindra Bank",
    "Symbol": "KOTAKBANK.NS",
    " marketcap ": " $40 557 814 195 ",
    "price (USD)": "20.402",
    "country": "India"
  },
  {
    "Rank": "491",
    "Name": "Kuwait Finance House",
    "Symbol": "KFH.KW",
    " marketcap ": " $40 345 342 999 ",
    "price (USD)": "2428.29",
    "country": "Kuwait"
  },
  {
    "Rank": "492",
    "Name": "Lonza",
    "Symbol": "LONN.SW",
    " marketcap ": " $40 295 590 515 ",
    "price (USD)": "558.756",
    "country": "Switzerland"
  },
  {
    "Rank": "493",
    "Name": "Generali",
    "Symbol": "G.MI",
    " marketcap ": " $40 191 834 319 ",
    "price (USD)": "25.4859",
    "country": "Italy"
  },
  {
    "Rank": "494",
    "Name": "Pernod Ricard",
    "Symbol": "RI.PA",
    " marketcap ": " $40 176 791 782 ",
    "price (USD)": "156.097",
    "country": "France"
  },
  {
    "Rank": "495",
    "Name": "Reckitt Benckiser",
    "Symbol": "RKT.L",
    " marketcap ": " $40 052 622 765 ",
    "price (USD)": "56.9053",
    "country": "United Kingdom"
  },
  {
    "Rank": "496",
    "Name": "MSCI",
    "Symbol": "MSCI",
    " marketcap ": " $40 050 208 768 ",
    "price (USD)": "505.53",
    "country": "United States"
  },
  {
    "Rank": "497",
    "Name": "Disco Corp.",
    "Symbol": "6146.T",
    " marketcap ": " $39 974 966 466 ",
    "price (USD)": "368.946",
    "country": "Japan"
  },
  {
    "Rank": "498",
    "Name": "CaixaBank",
    "Symbol": "CABK.MC",
    " marketcap ": " $39 935 426 231 ",
    "price (USD)": "5.49462",
    "country": "Spain"
  },
  {
    "Rank": "499",
    "Name": "General Mills",
    "Symbol": "GIS",
    " marketcap ": " $39 874 093 056 ",
    "price (USD)": "70.63",
    "country": "United States"
  },
  {
    "Rank": "500",
    "Name": "Quanta Services",
    "Symbol": "PWR",
    " marketcap ": " $39 824 855 040 ",
    "price (USD)": "272.05",
    "country": "United States"
  },
  {
    "Rank": "501",
    "Name": "Novatek",
    "Symbol": "NVTK.ME",
    " marketcap ": " $39 772 260 952 ",
    "price (USD)": "\u0434\u0435\u043a.96",
    "country": "Russia"
  },
  {
    "Rank": "502",
    "Name": "Otis Worldwide",
    "Symbol": "OTIS",
    " marketcap ": " $39 684 304 896 ",
    "price (USD)": "98.15",
    "country": "United States"
  },
  {
    "Rank": "503",
    "Name": "Charter Communications",
    "Symbol": "CHTR",
    " marketcap ": " $39 624 089 600 ",
    "price (USD)": "275.11",
    "country": "United States"
  },
  {
    "Rank": "504",
    "Name": "Wanhua Chemical",
    "Symbol": "600309.SS",
    " marketcap ": " $39 588 961 134 ",
    "price (USD)": "12.609",
    "country": "China"
  },
  {
    "Rank": "505",
    "Name": "QNB Finansbank",
    "Symbol": "QNBFB.IS",
    " marketcap ": " $39 542 638 014 ",
    "price (USD)": "\u043d\u043e\u044f.38",
    "country": "Turkey"
  },
  {
    "Rank": "506",
    "Name": "Corteva",
    "Symbol": "CTVA",
    " marketcap ": " $39 483 691 008 ",
    "price (USD)": "56.65",
    "country": "United States"
  },
  {
    "Rank": "507",
    "Name": "Yum! Brands",
    "Symbol": "YUM",
    " marketcap ": " $39 231 336 448 ",
    "price (USD)": "139.3",
    "country": "United States"
  },
  {
    "Rank": "508",
    "Name": "Ametek",
    "Symbol": "AME",
    " marketcap ": " $39 148 523 520 ",
    "price (USD)": "169.13",
    "country": "United States"
  },
  {
    "Rank": "509",
    "Name": "Cummins",
    "Symbol": "CMI",
    " marketcap ": " $39 113 609 216 ",
    "price (USD)": "285.96",
    "country": "United States"
  },
  {
    "Rank": "510",
    "Name": "Kroger",
    "Symbol": "KR",
    " marketcap ": " $39 042 748 416 ",
    "price (USD)": "53.66",
    "country": "United States"
  },
  {
    "Rank": "511",
    "Name": "Bayan Resources",
    "Symbol": "BYAN.JK",
    " marketcap ": " $38 920 847 263 ",
    "price (USD)": "1.16763",
    "country": "Indonesia"
  },
  {
    "Rank": "512",
    "Name": "Haleon",
    "Symbol": "HLN",
    " marketcap ": " $38 903 603 200 ",
    "price (USD)": "\u0430\u0432\u0433.52",
    "country": "United Kingdom"
  },
  {
    "Rank": "513",
    "Name": "Exor",
    "Symbol": "EXO.AS",
    " marketcap ": " $38 860 254 030 ",
    "price (USD)": "114.236",
    "country": "Netherlands"
  },
  {
    "Rank": "514",
    "Name": "Hindustan Aeronautics",
    "Symbol": "HAL.NS",
    " marketcap ": " $38 812 123 510 ",
    "price (USD)": "58.0347",
    "country": "India"
  },
  {
    "Rank": "515",
    "Name": "Royal Caribbean",
    "Symbol": "RCL",
    " marketcap ": " $38 795 362 304 ",
    "price (USD)": "150.75",
    "country": "United States"
  },
  {
    "Rank": "516",
    "Name": "Naspers",
    "Symbol": "NPSNY",
    " marketcap ": " $38 631 284 736 ",
    "price (USD)": "43.432",
    "country": "South Africa"
  },
  {
    "Rank": "517",
    "Name": "Exelon Corporation",
    "Symbol": "EXC",
    " marketcap ": " $38 521 155 584 ",
    "price (USD)": "38.52",
    "country": "United States"
  },
  {
    "Rank": "518",
    "Name": "Capgemini",
    "Symbol": "CAP.PA",
    " marketcap ": " $38 507 386 009 ",
    "price (USD)": "224.997",
    "country": "France"
  },
  {
    "Rank": "519",
    "Name": "Ingersoll Rand",
    "Symbol": "IR",
    " marketcap ": " $38 406 725 632 ",
    "price (USD)": "95.2",
    "country": "Ireland"
  },
  {
    "Rank": "520",
    "Name": "Jiangsu Hengrui Medicine",
    "Symbol": "600276.SS",
    " marketcap ": " $38 365 818 008 ",
    "price (USD)": "6.01439",
    "country": "China"
  },
  {
    "Rank": "521",
    "Name": "Kenvue",
    "Symbol": "KVUE",
    " marketcap ": " $38 238 752 768 ",
    "price (USD)": "19.97",
    "country": "United States"
  },
  {
    "Rank": "522",
    "Name": "Arch Capital",
    "Symbol": "ACGL",
    " marketcap ": " $38 168 969 216 ",
    "price (USD)": "101.65",
    "country": "Bermuda"
  },
  {
    "Rank": "523",
    "Name": "Old Dominion Freight Line",
    "Symbol": "ODFL",
    " marketcap ": " $38 124 826 624 ",
    "price (USD)": "175.46",
    "country": "United States"
  },
  {
    "Rank": "524",
    "Name": "Wolters Kluwer",
    "Symbol": "WKL.AS",
    " marketcap ": " $38 084 851 741 ",
    "price (USD)": "160.224",
    "country": "Netherlands"
  },
  {
    "Rank": "525",
    "Name": "Luzhou Laojiao",
    "Symbol": "000568.SZ",
    " marketcap ": " $38 025 341 862 ",
    "price (USD)": "25.8326",
    "country": "China"
  },
  {
    "Rank": "526",
    "Name": "Emirates Telecom (Etisalat Group)",
    "Symbol": "EAND.AE",
    " marketcap ": " $37 981 848 275 ",
    "price (USD)": "\u0430\u043f\u0440.37",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "527",
    "Name": "Fastenal",
    "Symbol": "FAST",
    " marketcap ": " $37 965 590 528 ",
    "price (USD)": "66.31",
    "country": "United States"
  },
  {
    "Rank": "528",
    "Name": "Cenovus Energy",
    "Symbol": "CVE",
    " marketcap ": " $37 865 984 000 ",
    "price (USD)": "20.27",
    "country": "Canada"
  },
  {
    "Rank": "529",
    "Name": "STMicroelectronics",
    "Symbol": "STM",
    " marketcap ": " $37 850 521 600 ",
    "price (USD)": "40.96",
    "country": "Switzerland"
  },
  {
    "Rank": "530",
    "Name": "EQT",
    "Symbol": "EQT.ST",
    " marketcap ": " $37 670 396 082 ",
    "price (USD)": "31.8436",
    "country": "Sweden"
  },
  {
    "Rank": "531",
    "Name": "Thales",
    "Symbol": "HO.PA",
    " marketcap ": " $37 627 513 259 ",
    "price (USD)": "181.67",
    "country": "France"
  },
  {
    "Rank": "532",
    "Name": "DMart",
    "Symbol": "DMART.NS",
    " marketcap ": " $37 627 456 345 ",
    "price (USD)": "57.8232",
    "country": "India"
  },
  {
    "Rank": "533",
    "Name": "UOB",
    "Symbol": "U11.SI",
    " marketcap ": " $37 586 464 519 ",
    "price (USD)": "22.4433",
    "country": "Singapore"
  },
  {
    "Rank": "534",
    "Name": "Hindustan Zinc",
    "Symbol": "HINDZINC.NS",
    " marketcap ": " $37 530 516 576 ",
    "price (USD)": "8.87332",
    "country": "India"
  },
  {
    "Rank": "535",
    "Name": "Sysco",
    "Symbol": "SYY",
    " marketcap ": " $37 508 005 888 ",
    "price (USD)": "75.32",
    "country": "United States"
  },
  {
    "Rank": "536",
    "Name": "PSEG",
    "Symbol": "PEG",
    " marketcap ": " $37 430 714 368 ",
    "price (USD)": "75.15",
    "country": "United States"
  },
  {
    "Rank": "537",
    "Name": "GE HealthCare Technologies",
    "Symbol": "GEHC",
    " marketcap ": " $37 402 742 784 ",
    "price (USD)": "81.94",
    "country": "United States"
  },
  {
    "Rank": "538",
    "Name": "Imperial Oil",
    "Symbol": "IMO",
    " marketcap ": " $37 389 438 976 ",
    "price (USD)": "69.58",
    "country": "Canada"
  },
  {
    "Rank": "539",
    "Name": "Ambev",
    "Symbol": "ABEV",
    " marketcap ": " $37 331 582 976 ",
    "price (USD)": "\u0444\u0435\u0432.32",
    "country": "Brazil"
  },
  {
    "Rank": "540",
    "Name": "Flutter Entertainment",
    "Symbol": "FLUT",
    " marketcap ": " $37 229 621 248 ",
    "price (USD)": "209.69",
    "country": "Ireland"
  },
  {
    "Rank": "541",
    "Name": "Coal India",
    "Symbol": "COALINDIA.NS",
    " marketcap ": " $37 223 551 664 ",
    "price (USD)": "6.04011",
    "country": "India"
  },
  {
    "Rank": "542",
    "Name": "Vertiv Holdings",
    "Symbol": "VRT",
    " marketcap ": " $37 108 817 920 ",
    "price (USD)": "99.13",
    "country": "United States"
  },
  {
    "Rank": "543",
    "Name": "Deutsche B\u0413\u00b6rse",
    "Symbol": "DB1.DE",
    " marketcap ": " $37 096 774 581 ",
    "price (USD)": "200.402",
    "country": "Germany"
  },
  {
    "Rank": "544",
    "Name": "CITIC Securities",
    "Symbol": "600030.SS",
    " marketcap ": " $37 010 766 402 ",
    "price (USD)": "2.66738",
    "country": "China"
  },
  {
    "Rank": "545",
    "Name": "Gazprom",
    "Symbol": "GAZP.ME",
    " marketcap ": " $37 003 469 301 ",
    "price (USD)": "\u044f\u043d\u0432.55",
    "country": "Russia"
  },
  {
    "Rank": "546",
    "Name": "Baidu",
    "Symbol": "BIDU",
    " marketcap ": " $36 976 685 056 ",
    "price (USD)": "105.14",
    "country": "China"
  },
  {
    "Rank": "547",
    "Name": "Monolithic Power Systems",
    "Symbol": "MPWR",
    " marketcap ": " $36 832 047 104 ",
    "price (USD)": "756.74",
    "country": "United States"
  },
  {
    "Rank": "548",
    "Name": "Mitsubishi Electric",
    "Symbol": "6503.T",
    " marketcap ": " $36 791 473 992 ",
    "price (USD)": "17.6188",
    "country": "Japan"
  },
  {
    "Rank": "549",
    "Name": "Muyuan Foods",
    "Symbol": "002714.SZ",
    " marketcap ": " $36 660 644 489 ",
    "price (USD)": "6.70783",
    "country": "China"
  },
  {
    "Rank": "550",
    "Name": "Cheniere Energy",
    "Symbol": "LNG",
    " marketcap ": " $36 591 583 232 ",
    "price (USD)": "159.85",
    "country": "United States"
  },
  {
    "Rank": "551",
    "Name": "Haier Smart Home",
    "Symbol": "600690.SS",
    " marketcap ": " $36 564 345 233 ",
    "price (USD)": "4.12333",
    "country": "China"
  },
  {
    "Rank": "552",
    "Name": "Trip.com",
    "Symbol": "TCOM",
    " marketcap ": " $36 485 296 128 ",
    "price (USD)": "55.83",
    "country": "China"
  },
  {
    "Rank": "553",
    "Name": "Mahindra &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "554",
    "Name": "Titan Company",
    "Symbol": "TITAN.NS",
    " marketcap ": " $36 237 838 280 ",
    "price (USD)": "40.8515",
    "country": "India"
  },
  {
    "Rank": "555",
    "Name": "First Abu Dhabi Bank",
    "Symbol": "FAB.AE",
    " marketcap ": " $36 216 749 738 ",
    "price (USD)": "\u043c\u0430\u0440.28",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "556",
    "Name": "Powergrid Corporation of India",
    "Symbol": "POWERGRID.NS",
    " marketcap ": " $36 184 582 355 ",
    "price (USD)": "3.89056",
    "country": "India"
  },
  {
    "Rank": "557",
    "Name": "Beiersdorf",
    "Symbol": "BEI.DE",
    " marketcap ": " $36 083 162 471 ",
    "price (USD)": "159.084",
    "country": "Germany"
  },
  {
    "Rank": "558",
    "Name": "Nasdaq",
    "Symbol": "NDAQ",
    " marketcap ": " $35 998 720 000 ",
    "price (USD)": "62.44",
    "country": "United States"
  },
  {
    "Rank": "559",
    "Name": "Verisk Analytics",
    "Symbol": "VRSK",
    " marketcap ": " $35 882 766 336 ",
    "price (USD)": "251.5",
    "country": "United States"
  },
  {
    "Rank": "560",
    "Name": "Partners Group",
    "Symbol": "PGHN.SW",
    " marketcap ": " $35 863 994 575 ",
    "price (USD)": "1380.43",
    "country": "Switzerland"
  },
  {
    "Rank": "561",
    "Name": "E.ON",
    "Symbol": "EOAN.DE",
    " marketcap ": " $35 861 051 545 ",
    "price (USD)": "13.7311",
    "country": "Germany"
  },
  {
    "Rank": "562",
    "Name": "3i Group",
    "Symbol": "III.L",
    " marketcap ": " $35 849 511 352 ",
    "price (USD)": "37.1741",
    "country": "United Kingdom"
  },
  {
    "Rank": "563",
    "Name": "Martin Marietta",
    "Symbol": "MLM",
    " marketcap ": " $35 832 066 048 ",
    "price (USD)": "581.31",
    "country": "United States"
  },
  {
    "Rank": "564",
    "Name": "NatWest Group",
    "Symbol": "NWG",
    " marketcap ": " $35 828 031 488 ",
    "price (USD)": "\u0430\u0432\u0433.21",
    "country": "United Kingdom"
  },
  {
    "Rank": "565",
    "Name": "Henkel",
    "Symbol": "HEN3.DE",
    " marketcap ": " $35 794 750 075 ",
    "price (USD)": "91.5626",
    "country": "Germany"
  },
  {
    "Rank": "566",
    "Name": "Murata Manufacturing (Murata Seisakusho)",
    "Symbol": "6981.T",
    " marketcap ": " $35 721 444 802 ",
    "price (USD)": "18.9079",
    "country": "Japan"
  },
  {
    "Rank": "567",
    "Name": "Adani Ports & SEZ",
    "Symbol": "ADANIPORTS.NS",
    " marketcap ": " $35 669 683 732 ",
    "price (USD)": "16.5127",
    "country": "India"
  },
  {
    "Rank": "568",
    "Name": "Adani Green Energy",
    "Symbol": "ADANIGREEN.NS",
    " marketcap ": " $35 496 838 206 ",
    "price (USD)": "22.4092",
    "country": "India"
  },
  {
    "Rank": "569",
    "Name": "China Pacific Insurance",
    "Symbol": "601601.SS",
    " marketcap ": " $35 483 720 479 ",
    "price (USD)": "4.09294",
    "country": "China"
  },
  {
    "Rank": "570",
    "Name": "CoStar Group",
    "Symbol": "CSGP",
    " marketcap ": " $35 476 922 368 ",
    "price (USD)": "86.85",
    "country": "United States"
  },
  {
    "Rank": "571",
    "Name": "Bank Mandiri",
    "Symbol": "BMRI.JK",
    " marketcap ": " $35 450 779 795 ",
    "price (USD)": "0.37983",
    "country": "Indonesia"
  },
  {
    "Rank": "572",
    "Name": "Woodside Energy",
    "Symbol": "WDS",
    " marketcap ": " $35 448 426 496 ",
    "price (USD)": "18.65",
    "country": "Australia"
  },
  {
    "Rank": "573",
    "Name": "Xylem",
    "Symbol": "XYL",
    " marketcap ": " $35 385 139 200 ",
    "price (USD)": "145.95",
    "country": "United States"
  },
  {
    "Rank": "574",
    "Name": "Swiss Re",
    "Symbol": "SREN.SW",
    " marketcap ": " $35 244 639 247 ",
    "price (USD)": "121.364",
    "country": "Switzerland"
  },
  {
    "Rank": "575",
    "Name": "Loblaw Companies",
    "Symbol": "L.TO",
    " marketcap ": " $35 163 671 255 ",
    "price (USD)": "114.388",
    "country": "Canada"
  },
  {
    "Rank": "576",
    "Name": "ASM International",
    "Symbol": "ASM.AS",
    " marketcap ": " $35 107 176 718 ",
    "price (USD)": "716.473",
    "country": "Netherlands"
  },
  {
    "Rank": "577",
    "Name": "Diamondback Energy",
    "Symbol": "FANG",
    " marketcap ": " $35 055 296 512 ",
    "price (USD)": "196.56",
    "country": "United States"
  },
  {
    "Rank": "578",
    "Name": "Agnico Eagle Mines",
    "Symbol": "AEM",
    " marketcap ": " $34 996 752 384 ",
    "price (USD)": "70.12",
    "country": "Canada"
  },
  {
    "Rank": "579",
    "Name": "QNB (Qatar National Bank)",
    "Symbol": "QNBK.QA",
    " marketcap ": " $34 941 110 295 ",
    "price (USD)": "3.78297",
    "country": "Qatar"
  },
  {
    "Rank": "580",
    "Name": "Gartner",
    "Symbol": "IT",
    " marketcap ": " $34 883 264 512 ",
    "price (USD)": "449.35",
    "country": "United States"
  },
  {
    "Rank": "581",
    "Name": "Alpha Dhabi",
    "Symbol": "ALPHADHABI.AE",
    " marketcap ": " $34 851 743 949 ",
    "price (USD)": "\u043c\u0430\u0440.49",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "582",
    "Name": "Bank of China (Hong Kong)",
    "Symbol": "2388.HK",
    " marketcap ": " $34 682 996 900 ",
    "price (USD)": "\u043c\u0430\u0440.04",
    "country": "Hong Kong"
  },
  {
    "Rank": "583",
    "Name": "Vulcan Materials",
    "Symbol": "VMC",
    " marketcap ": " $34 673 827 840 ",
    "price (USD)": "262.18",
    "country": "United States"
  },
  {
    "Rank": "584",
    "Name": "Howmet Aerospace",
    "Symbol": "HWM",
    " marketcap ": " $34 609 836 032 ",
    "price (USD)": "84.79",
    "country": "United States"
  },
  {
    "Rank": "585",
    "Name": "Shanghai Pudong Development Bank",
    "Symbol": "600000.SS",
    " marketcap ": " $34 585 423 824 ",
    "price (USD)": "1.17829",
    "country": "China"
  },
  {
    "Rank": "586",
    "Name": "Electronic Arts",
    "Symbol": "EA",
    " marketcap ": " $34 448 048 128 ",
    "price (USD)": "128.85",
    "country": "United States"
  },
  {
    "Rank": "587",
    "Name": "Las Vegas Sands",
    "Symbol": "LVS",
    " marketcap ": " $34 428 620 800 ",
    "price (USD)": "46.21",
    "country": "United States"
  },
  {
    "Rank": "588",
    "Name": "Japan Post Bank",
    "Symbol": "7182.T",
    " marketcap ": " $34 424 101 156 ",
    "price (USD)": "9.51954",
    "country": "Japan"
  },
  {
    "Rank": "589",
    "Name": "UltraTech Cement",
    "Symbol": "ULTRACEMCO.NS",
    " marketcap ": " $34 266 354 818 ",
    "price (USD)": "118.901",
    "country": "India"
  },
  {
    "Rank": "590",
    "Name": "Kia",
    "Symbol": "000270.KS",
    " marketcap ": " $34 247 822 297 ",
    "price (USD)": "87.3199",
    "country": "South Korea"
  },
  {
    "Rank": "591",
    "Name": "Coca-Cola European Partners",
    "Symbol": "CCEP",
    " marketcap ": " $34 231 920 640 ",
    "price (USD)": "74.01",
    "country": "United Kingdom"
  },
  {
    "Rank": "592",
    "Name": "Cognizant Technology Solutions",
    "Symbol": "CTSH",
    " marketcap ": " $34 202 320 896 ",
    "price (USD)": "68.79",
    "country": "United States"
  },
  {
    "Rank": "593",
    "Name": "Quanta Computer",
    "Symbol": "2382.TW",
    " marketcap ": " $34 126 131 748 ",
    "price (USD)": "8.85354",
    "country": "Taiwan"
  },
  {
    "Rank": "594",
    "Name": "Daimler Truck",
    "Symbol": "DTG.F",
    " marketcap ": " $34 103 543 299 ",
    "price (USD)": "42.3282",
    "country": "Germany"
  },
  {
    "Rank": "595",
    "Name": "FICO",
    "Symbol": "FICO",
    " marketcap ": " $33 972 545 536 ",
    "price (USD)": "1374.8",
    "country": "United States"
  },
  {
    "Rank": "596",
    "Name": "China State Construction Engineering",
    "Symbol": "601668.SS",
    " marketcap ": " $33 862 638 503 ",
    "price (USD)": "0.813615",
    "country": "China"
  },
  {
    "Rank": "597",
    "Name": "Veeva Systems",
    "Symbol": "VEEV",
    " marketcap ": " $33 816 115 200 ",
    "price (USD)": "209.24",
    "country": "United States"
  },
  {
    "Rank": "598",
    "Name": "7-Eleven",
    "Symbol": "3382.T",
    " marketcap ": " $33 758 958 754 ",
    "price (USD)": "12.987",
    "country": "Japan"
  },
  {
    "Rank": "599",
    "Name": "BTG Pactual",
    "Symbol": "BPAC3.SA",
    " marketcap ": " $33 747 352 201 ",
    "price (USD)": "\u043c\u0430\u0440.65",
    "country": "Brazil"
  },
  {
    "Rank": "600",
    "Name": "SMC corp",
    "Symbol": "6273.T",
    " marketcap ": " $33 734 553 920 ",
    "price (USD)": "526.006",
    "country": "Japan"
  },
  {
    "Rank": "601",
    "Name": "Delta Air Lines",
    "Symbol": "DAL",
    " marketcap ": " $33 704 699 904 ",
    "price (USD)": "52.23",
    "country": "United States"
  },
  {
    "Rank": "602",
    "Name": "Deutsche Bank",
    "Symbol": "DB",
    " marketcap ": " $33 348 294 656 ",
    "price (USD)": "16.88",
    "country": "Germany"
  },
  {
    "Rank": "603",
    "Name": "Consolidated Edison",
    "Symbol": "ED",
    " marketcap ": " $33 317 742 592 ",
    "price (USD)": "96.34",
    "country": "United States"
  },
  {
    "Rank": "604",
    "Name": "Halliburton",
    "Symbol": "HAL",
    " marketcap ": " $33 313 878 016 ",
    "price (USD)": "37.63",
    "country": "United States"
  },
  {
    "Rank": "605",
    "Name": "Asian Paints",
    "Symbol": "ASIANPAINT.NS",
    " marketcap ": " $33 249 043 171 ",
    "price (USD)": "34.6762",
    "country": "India"
  },
  {
    "Rank": "606",
    "Name": "Dupont De Nemours",
    "Symbol": "DD",
    " marketcap ": " $33 247 629 312 ",
    "price (USD)": "79.52",
    "country": "United States"
  },
  {
    "Rank": "607",
    "Name": "Baker Hughes",
    "Symbol": "BKR",
    " marketcap ": " $33 168 920 576 ",
    "price (USD)": "33.02",
    "country": "United States"
  },
  {
    "Rank": "608",
    "Name": "Biogen",
    "Symbol": "BIIB",
    " marketcap ": " $33 150 980 096 ",
    "price (USD)": "227.69",
    "country": "United States"
  },
  {
    "Rank": "609",
    "Name": "Garmin",
    "Symbol": "GRMN",
    " marketcap ": " $32 793 477 120 ",
    "price (USD)": "170.73",
    "country": "Switzerland"
  },
  {
    "Rank": "610",
    "Name": "Marubeni",
    "Symbol": "8002.T",
    " marketcap ": " $32 778 472 092 ",
    "price (USD)": "19.5765",
    "country": "Japan"
  },
  {
    "Rank": "611",
    "Name": "Vistra",
    "Symbol": "VST",
    " marketcap ": " $32 744 630 272 ",
    "price (USD)": "94.24",
    "country": "United States"
  },
  {
    "Rank": "612",
    "Name": "WEG ON",
    "Symbol": "WEGE3.SA",
    " marketcap ": " $32 637 350 194 ",
    "price (USD)": "7.76184",
    "country": "Brazil"
  },
  {
    "Rank": "613",
    "Name": "LyondellBasell",
    "Symbol": "LYB",
    " marketcap ": " $32 607 789 056 ",
    "price (USD)": "100.14",
    "country": "United States"
  },
  {
    "Rank": "614",
    "Name": "Luxshare Precision",
    "Symbol": "002475.SZ",
    " marketcap ": " $32 581 799 562 ",
    "price (USD)": "4.53911",
    "country": "China"
  },
  {
    "Rank": "615",
    "Name": "Mettler-Toledo",
    "Symbol": "MTD",
    " marketcap ": " $32 490 799 104 ",
    "price (USD)": "1521.29",
    "country": "United States"
  },
  {
    "Rank": "616",
    "Name": "Anta Sports",
    "Symbol": "2020.HK",
    " marketcap ": " $32 377 238 935 ",
    "price (USD)": "\u043d\u043e\u044f.01",
    "country": "China"
  },
  {
    "Rank": "617",
    "Name": "Adani Power",
    "Symbol": "ADANIPOWER.NS",
    " marketcap ": " $32 349 528 919 ",
    "price (USD)": "\u0430\u0432\u0433.49",
    "country": "India"
  },
  {
    "Rank": "618",
    "Name": "Gree Electric Appliances",
    "Symbol": "000651.SZ",
    " marketcap ": " $32 329 287 298 ",
    "price (USD)": "5.74089",
    "country": "China"
  },
  {
    "Rank": "619",
    "Name": "Invest Bank",
    "Symbol": "INVESTB.AE",
    " marketcap ": " $32 246 424 147 ",
    "price (USD)": "0.12",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "620",
    "Name": "Extra Space Storage",
    "Symbol": "EXR",
    " marketcap ": " $32 204 357 632 ",
    "price (USD)": "146.08",
    "country": "United States"
  },
  {
    "Rank": "621",
    "Name": "Assa Abloy",
    "Symbol": "ASAZF",
    " marketcap ": " $32 198 514 688 ",
    "price (USD)": "26.25",
    "country": "Sweden"
  },
  {
    "Rank": "622",
    "Name": "CITIC limited",
    "Symbol": "0267.HK",
    " marketcap ": " $32 132 320 711 ",
    "price (USD)": "1.10457",
    "country": "China"
  },
  {
    "Rank": "623",
    "Name": "ResMed",
    "Symbol": "RMD",
    " marketcap ": " $32 066 861 056 ",
    "price (USD)": "218.28",
    "country": "United States"
  },
  {
    "Rank": "624",
    "Name": "Kuaishou Technology",
    "Symbol": "1024.HK",
    " marketcap ": " $32 040 362 482 ",
    "price (USD)": "\u0438\u044e\u043b.73",
    "country": "China"
  },
  {
    "Rank": "625",
    "Name": "HP",
    "Symbol": "HPQ",
    " marketcap ": " $31 986 542 592 ",
    "price (USD)": "32.69",
    "country": "United States"
  },
  {
    "Rank": "626",
    "Name": "Sumitomo",
    "Symbol": "8053.T",
    " marketcap ": " $31 949 771 017 ",
    "price (USD)": "26.1468",
    "country": "Japan"
  },
  {
    "Rank": "627",
    "Name": "Ashtead",
    "Symbol": "AHT.L",
    " marketcap ": " $31 779 670 824 ",
    "price (USD)": "72.8225",
    "country": "United Kingdom"
  },
  {
    "Rank": "628",
    "Name": "MS&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "629",
    "Name": "DSM-Firmenich",
    "Symbol": "DSFIR.AS",
    " marketcap ": " $31 529 301 370 ",
    "price (USD)": "118.851",
    "country": "Switzerland"
  },
  {
    "Rank": "630",
    "Name": "Xcel Energy",
    "Symbol": "XEL",
    " marketcap ": " $31 526 957 056 ",
    "price (USD)": "56.74",
    "country": "United States"
  },
  {
    "Rank": "631",
    "Name": "K\u0413\u0458hne + Nagel",
    "Symbol": "KNIN.SW",
    " marketcap ": " $31 483 675 605 ",
    "price (USD)": "266.1",
    "country": "Switzerland"
  },
  {
    "Rank": "632",
    "Name": "Devon Energy",
    "Symbol": "DVN",
    " marketcap ": " $31 454 640 128 ",
    "price (USD)": "49.77",
    "country": "United States"
  },
  {
    "Rank": "633",
    "Name": "VICI Properties",
    "Symbol": "VICI",
    " marketcap ": " $31 420 583 936 ",
    "price (USD)": "30.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "634",
    "Name": "Discover Financial Services",
    "Symbol": "DFS",
    " marketcap ": " $31 369 984 000 ",
    "price (USD)": "125.18",
    "country": "United States"
  },
  {
    "Rank": "635",
    "Name": "PPG Industries",
    "Symbol": "PPG",
    " marketcap ": " $31 359 684 608 ",
    "price (USD)": "133.73",
    "country": "United States"
  },
  {
    "Rank": "636",
    "Name": "Orange",
    "Symbol": "ORAN",
    " marketcap ": " $31 331 151 872 ",
    "price (USD)": "\u043d\u043e\u044f.77",
    "country": "France"
  },
  {
    "Rank": "637",
    "Name": "ON Semiconductor",
    "Symbol": "ON",
    " marketcap ": " $31 329 495 040 ",
    "price (USD)": "72.82",
    "country": "United States"
  },
  {
    "Rank": "638",
    "Name": "Barrick Gold",
    "Symbol": "GOLD",
    " marketcap ": " $31 325 151 232 ",
    "price (USD)": "17.\u0430\u0432\u0433",
    "country": "Canada"
  },
  {
    "Rank": "639",
    "Name": "Dollar General",
    "Symbol": "DG",
    " marketcap ": " $31 325 087 744 ",
    "price (USD)": "142.6",
    "country": "United States"
  },
  {
    "Rank": "640",
    "Name": "Dubai Electricity and Water Authority (DEWA)",
    "Symbol": "DEWA.AE",
    " marketcap ": " $31 312 111 613 ",
    "price (USD)": "0.626242",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "641",
    "Name": "DSV",
    "Symbol": "DSV.VI",
    " marketcap ": " $31 306 400 956 ",
    "price (USD)": "150.233",
    "country": "Denmark"
  },
  {
    "Rank": "642",
    "Name": "Corning",
    "Symbol": "GLW",
    " marketcap ": " $31 249 461 248 ",
    "price (USD)": "36.48",
    "country": "United States"
  },
  {
    "Rank": "643",
    "Name": "HubSpot",
    "Symbol": "HUBS",
    " marketcap ": " $31 135 479 808 ",
    "price (USD)": "610.95",
    "country": "United States"
  },
  {
    "Rank": "644",
    "Name": "Restaurant Brands International",
    "Symbol": "QSR",
    " marketcap ": " $31 114 377 216 ",
    "price (USD)": "69",
    "country": "Canada"
  },
  {
    "Rank": "645",
    "Name": "Amadeus IT Group",
    "Symbol": "AMS.MC",
    " marketcap ": " $31 112 960 695 ",
    "price (USD)": "71.4301",
    "country": "Spain"
  },
  {
    "Rank": "646",
    "Name": "Banco do Brasil",
    "Symbol": "BBAS3.SA",
    " marketcap ": " $31 087 054 374 ",
    "price (USD)": "5.44656",
    "country": "Brazil"
  },
  {
    "Rank": "647",
    "Name": "Ping An Bank",
    "Symbol": "000001.SZ",
    " marketcap ": " $30 988 106 859 ",
    "price (USD)": "1.59684",
    "country": "China"
  },
  {
    "Rank": "648",
    "Name": "CDW Corporation",
    "Symbol": "CDW",
    " marketcap ": " $30 962 612 224 ",
    "price (USD)": "230.38",
    "country": "United States"
  },
  {
    "Rank": "649",
    "Name": "BCE",
    "Symbol": "BCE",
    " marketcap ": " $30 947 733 504 ",
    "price (USD)": "33.85",
    "country": "Canada"
  },
  {
    "Rank": "650",
    "Name": "Siemens India",
    "Symbol": "SIEMENS.NS",
    " marketcap ": " $30 846 589 250 ",
    "price (USD)": "86.6185",
    "country": "India"
  },
  {
    "Rank": "651",
    "Name": "Rockwell Automation",
    "Symbol": "ROK",
    " marketcap ": " $30 821 849 088 ",
    "price (USD)": "270.36",
    "country": "United States"
  },
  {
    "Rank": "652",
    "Name": "Tractor Supply",
    "Symbol": "TSCO",
    " marketcap ": " $30 799 159 296 ",
    "price (USD)": "285.68",
    "country": "United States"
  },
  {
    "Rank": "653",
    "Name": "Renesas Electronics",
    "Symbol": "6723.T",
    " marketcap ": " $30 753 317 008 ",
    "price (USD)": "17.2798",
    "country": "Japan"
  },
  {
    "Rank": "654",
    "Name": "KBC",
    "Symbol": "KBCSF",
    " marketcap ": " $30 655 307 776 ",
    "price (USD)": "76.3472",
    "country": "Belgium"
  },
  {
    "Rank": "655",
    "Name": "The People's Insurance Company (PICC)",
    "Symbol": "601319.SS",
    " marketcap ": " $30 544 786 277 ",
    "price (USD)": "0.769411",
    "country": "China"
  },
  {
    "Rank": "656",
    "Name": "GlobalFoundries",
    "Symbol": "GFS",
    " marketcap ": " $30 462 302 208 ",
    "price (USD)": "54.84",
    "country": "United States"
  },
  {
    "Rank": "657",
    "Name": "Chunghwa Telecom",
    "Symbol": "CHT",
    " marketcap ": " $30 441 836 544 ",
    "price (USD)": "38.88",
    "country": "Taiwan"
  },
  {
    "Rank": "658",
    "Name": "Bajaj Finserv",
    "Symbol": "BAJAJFINSV.NS",
    " marketcap ": " $30 414 503 781 ",
    "price (USD)": "19.0894",
    "country": "India"
  },
  {
    "Rank": "659",
    "Name": "Hapag-Lloyd",
    "Symbol": "HLAG.DE",
    " marketcap ": " $30 403 484 035 ",
    "price (USD)": "172.983",
    "country": "Germany"
  },
  {
    "Rank": "660",
    "Name": "Archer Daniels Midland (ADM)",
    "Symbol": "ADM",
    " marketcap ": " $30 294 216 704 ",
    "price (USD)": "61.27",
    "country": "United States"
  },
  {
    "Rank": "661",
    "Name": "The Hartford",
    "Symbol": "HIG",
    " marketcap ": " $30 202 503 168 ",
    "price (USD)": "102.12",
    "country": "United States"
  },
  {
    "Rank": "662",
    "Name": "Ahold Delhaize",
    "Symbol": "AD.AS",
    " marketcap ": " $30 078 977 557 ",
    "price (USD)": "32.0665",
    "country": "Netherlands"
  },
  {
    "Rank": "663",
    "Name": "Wabtec",
    "Symbol": "WAB",
    " marketcap ": " $29 994 268 672 ",
    "price (USD)": "170.05",
    "country": "United States"
  },
  {
    "Rank": "664",
    "Name": "Hexagon",
    "Symbol": "HXGBF",
    " marketcap ": " $29 974 429 696 ",
    "price (USD)": "\u043d\u043e\u044f.19",
    "country": "Sweden"
  },
  {
    "Rank": "665",
    "Name": "Bayer",
    "Symbol": "BAYN.DE",
    " marketcap ": " $29 945 316 034 ",
    "price (USD)": "30.4811",
    "country": "Germany"
  },
  {
    "Rank": "666",
    "Name": "Bridgestone",
    "Symbol": "5108.T",
    " marketcap ": " $29 907 217 930 ",
    "price (USD)": "43.6824",
    "country": "Japan"
  },
  {
    "Rank": "667",
    "Name": "COSCO Shipping",
    "Symbol": "601919.SS",
    " marketcap ": " $29 851 506 324 ",
    "price (USD)": "1.93389",
    "country": "China"
  },
  {
    "Rank": "668",
    "Name": "Sun Life Financial",
    "Symbol": "SLF",
    " marketcap ": " $29 817 479 168 ",
    "price (USD)": "51.24",
    "country": "Canada"
  },
  {
    "Rank": "669",
    "Name": "Intact Financial",
    "Symbol": "IFC.TO",
    " marketcap ": " $29 770 413 895 ",
    "price (USD)": "166.971",
    "country": "Canada"
  },
  {
    "Rank": "670",
    "Name": "Hannover R\u0413\u0458ck",
    "Symbol": "HNR1.DE",
    " marketcap ": " $29 687 631 421 ",
    "price (USD)": "246.172",
    "country": "Germany"
  },
  {
    "Rank": "671",
    "Name": "Fubon Financial",
    "Symbol": "2881.TW",
    " marketcap ": " $29 664 851 184 ",
    "price (USD)": "2.27928",
    "country": "Taiwan"
  },
  {
    "Rank": "672",
    "Name": "Japan Post Holdings",
    "Symbol": "6178.T",
    " marketcap ": " $29 649 709 369 ",
    "price (USD)": "9.25085",
    "country": "Japan"
  },
  {
    "Rank": "673",
    "Name": "Banorte",
    "Symbol": "GFNORTEO.MX",
    " marketcap ": " $29 573 092 384 ",
    "price (USD)": "10.0813",
    "country": "Mexico"
  },
  {
    "Rank": "674",
    "Name": "Antofagasta",
    "Symbol": "ANTO.L",
    " marketcap ": " $29 566 811 732 ",
    "price (USD)": "29.991",
    "country": "United Kingdom"
  },
  {
    "Rank": "675",
    "Name": "Sun Hung Kai Properties",
    "Symbol": "0016.HK",
    " marketcap ": " $29 559 566 653 ",
    "price (USD)": "10.\u0444\u0435\u0432",
    "country": "Hong Kong"
  },
  {
    "Rank": "676",
    "Name": "Edison International",
    "Symbol": "EIX",
    " marketcap ": " $29 537 486 848 ",
    "price (USD)": "76.77",
    "country": "United States"
  },
  {
    "Rank": "677",
    "Name": "China Resources Land",
    "Symbol": "1109.HK",
    " marketcap ": " $29 514 533 343 ",
    "price (USD)": "4.13894",
    "country": "Hong Kong"
  },
  {
    "Rank": "678",
    "Name": "Nutrien",
    "Symbol": "NTR",
    " marketcap ": " $29 511 346 176 ",
    "price (USD)": "59.58",
    "country": "Canada"
  },
  {
    "Rank": "679",
    "Name": "Bajaj Auto",
    "Symbol": "BAJAJ-AUTO.NS",
    " marketcap ": " $29 508 173 476 ",
    "price (USD)": "105.696",
    "country": "India"
  },
  {
    "Rank": "680",
    "Name": "Toyota Industries",
    "Symbol": "6201.T",
    " marketcap ": " $29 496 407 703 ",
    "price (USD)": "95.0035",
    "country": "Japan"
  },
  {
    "Rank": "681",
    "Name": "Equifax",
    "Symbol": "EFX",
    " marketcap ": " $29 425 598 464 ",
    "price (USD)": "238.05",
    "country": "United States"
  },
  {
    "Rank": "682",
    "Name": "Great-West Lifeco",
    "Symbol": "GWO.TO",
    " marketcap ": " $29 423 006 908 ",
    "price (USD)": "31.5407",
    "country": "Canada"
  },
  {
    "Rank": "683",
    "Name": "Singtel",
    "Symbol": "Z74.SI",
    " marketcap ": " $29 405 636 949 ",
    "price (USD)": "\u044f\u043d\u0432.18",
    "country": "Singapore"
  },
  {
    "Rank": "684",
    "Name": "MicroStrategy",
    "Symbol": "MSTR",
    " marketcap ": " $29 362 847 744 ",
    "price (USD)": "1655.42",
    "country": "United States"
  },
  {
    "Rank": "685",
    "Name": "Foshan Haitian Flavouring and Food",
    "Symbol": "603288.SS",
    " marketcap ": " $29 119 161 236 ",
    "price (USD)": "5.23669",
    "country": "China"
  },
  {
    "Rank": "686",
    "Name": "Rocket Companies",
    "Symbol": "RKT",
    " marketcap ": " $28 895 340 544 ",
    "price (USD)": "14.54",
    "country": "United States"
  },
  {
    "Rank": "687",
    "Name": "Wipro",
    "Symbol": "WIT",
    " marketcap ": " $28 885 571 584 ",
    "price (USD)": "05.\u0430\u043f\u0440",
    "country": "India"
  },
  {
    "Rank": "688",
    "Name": "Novozymes",
    "Symbol": "NZYM.VI",
    " marketcap ": " $28 870 263 924 ",
    "price (USD)": "62.3955",
    "country": "Denmark"
  },
  {
    "Rank": "689",
    "Name": "Legrand",
    "Symbol": "LR.PA",
    " marketcap ": " $28 853 742 487 ",
    "price (USD)": "110.381",
    "country": "France"
  },
  {
    "Rank": "690",
    "Name": "Aena",
    "Symbol": "AENA.MC",
    " marketcap ": " $28 797 915 639 ",
    "price (USD)": "191.986",
    "country": "Spain"
  },
  {
    "Rank": "691",
    "Name": "National Bank of Canada",
    "Symbol": "NA.TO",
    " marketcap ": " $28 746 115 092 ",
    "price (USD)": "84.5852",
    "country": "Canada"
  },
  {
    "Rank": "692",
    "Name": "Nestl\u0413\u00a9 India",
    "Symbol": "NESTLEIND.NS",
    " marketcap ": " $28 670 888 779 ",
    "price (USD)": "29.7367",
    "country": "India"
  },
  {
    "Rank": "693",
    "Name": "Skandinaviska Enskilda Banken",
    "Symbol": "SEB-A.ST",
    " marketcap ": " $28 654 266 367 ",
    "price (USD)": "13.9094",
    "country": "Sweden"
  },
  {
    "Rank": "694",
    "Name": "Publicis Groupe",
    "Symbol": "PUB.PA",
    " marketcap ": " $28 587 538 069 ",
    "price (USD)": "114.345",
    "country": "France"
  },
  {
    "Rank": "695",
    "Name": "Ferrovial",
    "Symbol": "FER.MC",
    " marketcap ": " $28 549 867 234 ",
    "price (USD)": "39.2877",
    "country": "Spain"
  },
  {
    "Rank": "696",
    "Name": "Ansys",
    "Symbol": "ANSS",
    " marketcap ": " $28 528 766 976 ",
    "price (USD)": "326.79",
    "country": "United States"
  },
  {
    "Rank": "697",
    "Name": "East Money Information",
    "Symbol": "300059.SZ",
    " marketcap ": " $28 455 895 871 ",
    "price (USD)": "1.80266",
    "country": "China"
  },
  {
    "Rank": "698",
    "Name": "Verbund AG",
    "Symbol": "OEWA.F",
    " marketcap ": " $28 454 314 657 ",
    "price (USD)": "79.7589",
    "country": "Austria"
  },
  {
    "Rank": "699",
    "Name": "Swisscom",
    "Symbol": "SCMN.SW",
    " marketcap ": " $28 450 088 949 ",
    "price (USD)": "549.209",
    "country": "Switzerland"
  },
  {
    "Rank": "700",
    "Name": "Pinterest",
    "Symbol": "PINS",
    " marketcap ": " $28 358 385 664 ",
    "price (USD)": "41.51",
    "country": "United States"
  },
  {
    "Rank": "701",
    "Name": "DNB",
    "Symbol": "DNB.OL",
    " marketcap ": " $28 350 612 825 ",
    "price (USD)": "18.7811",
    "country": "Norway"
  },
  {
    "Rank": "702",
    "Name": "Coloplast",
    "Symbol": "COLO-B.CO",
    " marketcap ": " $28 336 945 979 ",
    "price (USD)": "125.92",
    "country": "Denmark"
  },
  {
    "Rank": "703",
    "Name": "H&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "704",
    "Name": "AvalonBay Communities",
    "Symbol": "AVB",
    " marketcap ": " $28 219 656 192 ",
    "price (USD)": "198.47",
    "country": "United States"
  },
  {
    "Rank": "705",
    "Name": "Emirates NBD Bank PJSC",
    "Symbol": "EMIRATESNBD.AE",
    " marketcap ": " $28 206 014 897 ",
    "price (USD)": "4.46538",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "706",
    "Name": "Jardine Matheson",
    "Symbol": "J36.SI",
    " marketcap ": " $28 198 310 000 ",
    "price (USD)": "39.11",
    "country": "Hong Kong"
  },
  {
    "Rank": "707",
    "Name": "Prudential",
    "Symbol": "PUK",
    " marketcap ": " $28 164 300 800 ",
    "price (USD)": "20.48",
    "country": "United Kingdom"
  },
  {
    "Rank": "708",
    "Name": "Indian Oil",
    "Symbol": "IOC.NS",
    " marketcap ": " $28 105 984 770 ",
    "price (USD)": "1.99034",
    "country": "India"
  },
  {
    "Rank": "709",
    "Name": "Hang Seng Bank",
    "Symbol": "0011.HK",
    " marketcap ": " $28 101 423 762 ",
    "price (USD)": "14.7874",
    "country": "Hong Kong"
  },
  {
    "Rank": "710",
    "Name": "Mitsubishi Heavy Industries",
    "Symbol": "7011.T",
    " marketcap ": " $28 080 964 251 ",
    "price (USD)": "8.35519",
    "country": "Japan"
  },
  {
    "Rank": "711",
    "Name": "Celltrion",
    "Symbol": "068270.KS",
    " marketcap ": " $28 073 133 982 ",
    "price (USD)": "135.717",
    "country": "South Korea"
  },
  {
    "Rank": "712",
    "Name": "Michelin",
    "Symbol": "ML.PA",
    " marketcap ": " $28 062 690 533 ",
    "price (USD)": "39.3419",
    "country": "France"
  },
  {
    "Rank": "713",
    "Name": "Nidec",
    "Symbol": "6594.T",
    " marketcap ": " $28 033 343 632 ",
    "price (USD)": "48.7877",
    "country": "Japan"
  },
  {
    "Rank": "714",
    "Name": "Sandvik",
    "Symbol": "SAND.ST",
    " marketcap ": " $28 026 799 247 ",
    "price (USD)": "22.343",
    "country": "Sweden"
  },
  {
    "Rank": "715",
    "Name": "Vestas Wind Systems",
    "Symbol": "VWS.CO",
    " marketcap ": " $27 943 971 616 ",
    "price (USD)": "27.6895",
    "country": "Denmark"
  },
  {
    "Rank": "716",
    "Name": "Komatsu",
    "Symbol": "6301.T",
    " marketcap ": " $27 930 121 182 ",
    "price (USD)": "29.5119",
    "country": "Japan"
  },
  {
    "Rank": "717",
    "Name": "Banco Bradesco",
    "Symbol": "BBD",
    " marketcap ": " $27 929 548 800 ",
    "price (USD)": "\u0444\u0435\u0432.63",
    "country": "Brazil"
  },
  {
    "Rank": "718",
    "Name": "Chocoladefabriken Lindt &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "719",
    "Name": "RWE",
    "Symbol": "RWE.DE",
    " marketcap ": " $27 810 236 560 ",
    "price (USD)": "37.3873",
    "country": "Germany"
  },
  {
    "Rank": "720",
    "Name": "Ryanair",
    "Symbol": "RYAAY",
    " marketcap ": " $27 764 654 080 ",
    "price (USD)": "121.77",
    "country": "Ireland"
  },
  {
    "Rank": "721",
    "Name": "Maybank",
    "Symbol": "MLYBY",
    " marketcap ": " $27 754 008 576 ",
    "price (USD)": "04.\u0438\u044e\u043d",
    "country": "Malaysia"
  },
  {
    "Rank": "722",
    "Name": "CBRE Group",
    "Symbol": "CBRE",
    " marketcap ": " $27 743 025 152 ",
    "price (USD)": "90.42",
    "country": "United States"
  },
  {
    "Rank": "723",
    "Name": "Indian Railway Finance",
    "Symbol": "IRFC.NS",
    " marketcap ": " $27 722 298 316 ",
    "price (USD)": "2.12131",
    "country": "India"
  },
  {
    "Rank": "724",
    "Name": "Teck Resources",
    "Symbol": "TECK",
    " marketcap ": " $27 713 105 920 ",
    "price (USD)": "53.4",
    "country": "Canada"
  },
  {
    "Rank": "725",
    "Name": "Schindler Group",
    "Symbol": "SCHN.SW",
    " marketcap ": " $27 705 807 666 ",
    "price (USD)": "255.676",
    "country": "Switzerland"
  },
  {
    "Rank": "726",
    "Name": "AppLovin",
    "Symbol": "APP",
    " marketcap ": " $27 637 178 368 ",
    "price (USD)": "84",
    "country": "United States"
  },
  {
    "Rank": "727",
    "Name": "KONE",
    "Symbol": "KNEBV.HE",
    " marketcap ": " $27 542 619 959 ",
    "price (USD)": "53.2197",
    "country": "Finland"
  },
  {
    "Rank": "728",
    "Name": "Fanuc",
    "Symbol": "6954.T",
    " marketcap ": " $27 526 700 159 ",
    "price (USD)": "29.1088",
    "country": "Japan"
  },
  {
    "Rank": "729",
    "Name": "Canon",
    "Symbol": "7751.T",
    " marketcap ": " $27 490 242 169 ",
    "price (USD)": "27.8293",
    "country": "Japan"
  },
  {
    "Rank": "730",
    "Name": "Great Wall Motors",
    "Symbol": "601633.SS",
    " marketcap ": " $27 468 275 149 ",
    "price (USD)": "3.73517",
    "country": "China"
  },
  {
    "Rank": "731",
    "Name": "Tesco",
    "Symbol": "TSCDF",
    " marketcap ": " $27 438 473 216 ",
    "price (USD)": "3.885",
    "country": "United Kingdom"
  },
  {
    "Rank": "732",
    "Name": "Global Payments",
    "Symbol": "GPN",
    " marketcap ": " $27 403 640 832 ",
    "price (USD)": "107.36",
    "country": "United States"
  },
  {
    "Rank": "733",
    "Name": "Jio Financial Services",
    "Symbol": "JIOFIN.NS",
    " marketcap ": " $27 401 083 948 ",
    "price (USD)": "\u0430\u043f\u0440.29",
    "country": "India"
  },
  {
    "Rank": "734",
    "Name": "Fujitsu",
    "Symbol": "6702.T",
    " marketcap ": " $27 316 944 707 ",
    "price (USD)": "14.8519",
    "country": "Japan"
  },
  {
    "Rank": "735",
    "Name": "Dr. Sulaiman Al Habib Medical Services Group Company",
    "Symbol": "4013.SR",
    " marketcap ": " $27 216 929 147 ",
    "price (USD)": "77.7627",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "736",
    "Name": "Fortive",
    "Symbol": "FTV",
    " marketcap ": " $27 141 435 392 ",
    "price (USD)": "77.1",
    "country": "United States"
  },
  {
    "Rank": "737",
    "Name": "Blue Owl Capital",
    "Symbol": "OWL",
    " marketcap ": " $27 032 895 488 ",
    "price (USD)": "18.92",
    "country": "United States"
  },
  {
    "Rank": "738",
    "Name": "JSW Steel",
    "Symbol": "JSWSTEEL.NS",
    " marketcap ": " $26 934 738 678 ",
    "price (USD)": "11.0511",
    "country": "India"
  },
  {
    "Rank": "739",
    "Name": "MongoDB",
    "Symbol": "MDB",
    " marketcap ": " $26 791 821 312 ",
    "price (USD)": "365.26",
    "country": "United States"
  },
  {
    "Rank": "740",
    "Name": "CRRC",
    "Symbol": "1766.HK",
    " marketcap ": " $26 754 822 816 ",
    "price (USD)": "0.6202",
    "country": "China"
  },
  {
    "Rank": "741",
    "Name": "WEC Energy Group",
    "Symbol": "WEC",
    " marketcap ": " $26 712 309 760 ",
    "price (USD)": "84.58",
    "country": "United States"
  },
  {
    "Rank": "742",
    "Name": "Fairfax Financial",
    "Symbol": "FFH.TO",
    " marketcap ": " $26 541 200 109 ",
    "price (USD)": "1136.41",
    "country": "Canada"
  },
  {
    "Rank": "743",
    "Name": "Zscaler",
    "Symbol": "ZS",
    " marketcap ": " $26 521 868 288 ",
    "price (USD)": "176.98",
    "country": "United States"
  },
  {
    "Rank": "744",
    "Name": "Vodafone",
    "Symbol": "VOD",
    " marketcap ": " $26 506 508 288 ",
    "price (USD)": "\u0441\u0435\u043d.54",
    "country": "United Kingdom"
  },
  {
    "Rank": "745",
    "Name": "PTT PCL",
    "Symbol": "PTT-R.BK",
    " marketcap ": " $26 506 124 135 ",
    "price (USD)": "0.927988",
    "country": "Thailand"
  },
  {
    "Rank": "746",
    "Name": "UCB",
    "Symbol": "UCB.VI",
    " marketcap ": " $26 460 364 600 ",
    "price (USD)": "131.719",
    "country": "Belgium"
  },
  {
    "Rank": "747",
    "Name": "Splunk",
    "Symbol": "SPLK",
    " marketcap ": " $26 443 769 856 ",
    "price (USD)": "156.9",
    "country": "United States"
  },
  {
    "Rank": "748",
    "Name": "HEICO",
    "Symbol": "HEI",
    " marketcap ": " $26 430 531 584 ",
    "price (USD)": "216.16",
    "country": "United States"
  },
  {
    "Rank": "749",
    "Name": "eBay",
    "Symbol": "EBAY",
    " marketcap ": " $26 421 182 464 ",
    "price (USD)": "52.17",
    "country": "United States"
  },
  {
    "Rank": "750",
    "Name": "Fujifilm",
    "Symbol": "4901.T",
    " marketcap ": " $26 406 192 610 ",
    "price (USD)": "21.9308",
    "country": "Japan"
  },
  {
    "Rank": "751",
    "Name": "Delta Electronics",
    "Symbol": "2308.TW",
    " marketcap ": " $26 380 572 475 ",
    "price (USD)": "10.156",
    "country": "Taiwan"
  },
  {
    "Rank": "752",
    "Name": "Telstra",
    "Symbol": "TLS.AX",
    " marketcap ": " $26 349 654 198 ",
    "price (USD)": "2.28049",
    "country": "Australia"
  },
  {
    "Rank": "753",
    "Name": "ICON plc",
    "Symbol": "ICLR",
    " marketcap ": " $26 283 526 144 ",
    "price (USD)": "317.88",
    "country": "Ireland"
  },
  {
    "Rank": "754",
    "Name": "T. Rowe Price",
    "Symbol": "TROW",
    " marketcap ": " $26 266 777 600 ",
    "price (USD)": "117.63",
    "country": "United States"
  },
  {
    "Rank": "755",
    "Name": "Wheaton Precious Metals",
    "Symbol": "WPM",
    " marketcap ": " $26 257 969 152 ",
    "price (USD)": "57.82",
    "country": "Canada"
  },
  {
    "Rank": "756",
    "Name": "Naturgy",
    "Symbol": "NTGY.MC",
    " marketcap ": " $26 252 784 711 ",
    "price (USD)": "27.0822",
    "country": "Spain"
  },
  {
    "Rank": "757",
    "Name": "Advantest",
    "Symbol": "6857.T",
    " marketcap ": " $26 241 948 012 ",
    "price (USD)": "35.5384",
    "country": "Japan"
  },
  {
    "Rank": "758",
    "Name": "Targa Resources",
    "Symbol": "TRGP",
    " marketcap ": " $26 206 947 328 ",
    "price (USD)": "118.2",
    "country": "United States"
  },
  {
    "Rank": "759",
    "Name": "Church & Dwight",
    "Symbol": "CHD",
    " marketcap ": " $26 178 631 680 ",
    "price (USD)": "107.06",
    "country": "United States"
  },
  {
    "Rank": "760",
    "Name": "American Water Works",
    "Symbol": "AWK",
    " marketcap ": " $26 176 419 840 ",
    "price (USD)": "134.36",
    "country": "United States"
  },
  {
    "Rank": "761",
    "Name": "Cellnex Telecom",
    "Symbol": "CLNX.MC",
    " marketcap ": " $26 078 912 646 ",
    "price (USD)": "36.9638",
    "country": "Spain"
  },
  {
    "Rank": "762",
    "Name": "S.F. Express",
    "Symbol": "002352.SZ",
    " marketcap ": " $26 047 147 091 ",
    "price (USD)": "5.32096",
    "country": "China"
  },
  {
    "Rank": "763",
    "Name": "Fifth Third Bank",
    "Symbol": "FITB",
    " marketcap ": " $26 021 072 896 ",
    "price (USD)": "38.04",
    "country": "United States"
  },
  {
    "Rank": "764",
    "Name": "Willis Towers Watson",
    "Symbol": "WTW",
    " marketcap ": " $25 956 698 112 ",
    "price (USD)": "253.89",
    "country": "United Kingdom"
  },
  {
    "Rank": "765",
    "Name": "Telef\u0413\u0456nica",
    "Symbol": "TEF",
    " marketcap ": " $25 930 483 712 ",
    "price (USD)": "\u0430\u043f\u0440.54",
    "country": "Spain"
  },
  {
    "Rank": "766",
    "Name": "Airports of Thailand",
    "Symbol": "AOT.BK",
    " marketcap ": " $25 924 722 547 ",
    "price (USD)": "1.81473",
    "country": "Thailand"
  },
  {
    "Rank": "767",
    "Name": "Transurban",
    "Symbol": "TCL.AX",
    " marketcap ": " $25 917 996 629 ",
    "price (USD)": "8.38179",
    "country": "Australia"
  },
  {
    "Rank": "768",
    "Name": "Tencent Music",
    "Symbol": "TME",
    " marketcap ": " $25 898 823 680 ",
    "price (USD)": "14.99",
    "country": "China"
  },
  {
    "Rank": "769",
    "Name": "Philips",
    "Symbol": "PHG",
    " marketcap ": " $25 884 801 024 ",
    "price (USD)": "27.31",
    "country": "Netherlands"
  },
  {
    "Rank": "770",
    "Name": "Tata Steel",
    "Symbol": "TATASTEEL.NS",
    " marketcap ": " $25 873 861 303 ",
    "price (USD)": "2.07264",
    "country": "India"
  },
  {
    "Rank": "771",
    "Name": "Raymond James",
    "Symbol": "RJF",
    " marketcap ": " $25 866 096 640 ",
    "price (USD)": "124.79",
    "country": "United States"
  },
  {
    "Rank": "772",
    "Name": "Take 2 Interactive",
    "Symbol": "TTWO",
    " marketcap ": " $25 862 535 168 ",
    "price (USD)": "151.42",
    "country": "United States"
  },
  {
    "Rank": "773",
    "Name": "Associated British Foods",
    "Symbol": "ABF.L",
    " marketcap ": " $25 800 857 983 ",
    "price (USD)": "34.3517",
    "country": "United Kingdom"
  },
  {
    "Rank": "774",
    "Name": "\u0413\u0098rsted",
    "Symbol": "DOGEF",
    " marketcap ": " $25 760 100 352 ",
    "price (USD)": "61.3",
    "country": "Denmark"
  },
  {
    "Rank": "775",
    "Name": "Yili Group",
    "Symbol": "600887.SS",
    " marketcap ": " $25 704 294 583 ",
    "price (USD)": "4.03768",
    "country": "China"
  },
  {
    "Rank": "776",
    "Name": "Snap",
    "Symbol": "SNAP",
    " marketcap ": " $25 649 455 104 ",
    "price (USD)": "15.63",
    "country": "United States"
  },
  {
    "Rank": "777",
    "Name": "First Citizens BancShares",
    "Symbol": "FCNCA",
    " marketcap ": " $25 646 960 640 ",
    "price (USD)": "1777.41",
    "country": "United States"
  },
  {
    "Rank": "778",
    "Name": "Brown &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "779",
    "Name": "M&T Bank",
    "Symbol": "MTB",
    " marketcap ": " $25 592 068 096 ",
    "price (USD)": "153.38",
    "country": "United States"
  },
  {
    "Rank": "780",
    "Name": "Dover",
    "Symbol": "DOV",
    " marketcap ": " $25 570 226 176 ",
    "price (USD)": "186.06",
    "country": "United States"
  },
  {
    "Rank": "781",
    "Name": "Keysight",
    "Symbol": "KEYS",
    " marketcap ": " $25 554 456 576 ",
    "price (USD)": "146.36",
    "country": "United States"
  },
  {
    "Rank": "782",
    "Name": "Delta Electronics (Thailand)",
    "Symbol": "DELTA.BK",
    " marketcap ": " $25 551 928 310 ",
    "price (USD)": "2.04845",
    "country": "Thailand"
  },
  {
    "Rank": "783",
    "Name": "Maersk",
    "Symbol": "MAERSK-B.CO",
    " marketcap ": " $25 520 874 461 ",
    "price (USD)": "1650.02",
    "country": "Denmark"
  },
  {
    "Rank": "784",
    "Name": "Woolworths Group",
    "Symbol": "WOW.AX",
    " marketcap ": " $25 520 386 813 ",
    "price (USD)": "20.8911",
    "country": "Australia"
  },
  {
    "Rank": "785",
    "Name": "Cathay Financial Holding",
    "Symbol": "2882.TW",
    " marketcap ": " $25 474 467 776 ",
    "price (USD)": "\u044f\u043d\u0432.66",
    "country": "Taiwan"
  },
  {
    "Rank": "786",
    "Name": "Symbotic",
    "Symbol": "SYM",
    " marketcap ": " $25 460 547 584 ",
    "price (USD)": "43.55",
    "country": "United States"
  },
  {
    "Rank": "787",
    "Name": "Mitsui Fudosan",
    "Symbol": "8801.T",
    " marketcap ": " $25 384 456 546 ",
    "price (USD)": "9.05892",
    "country": "Japan"
  },
  {
    "Rank": "788",
    "Name": "China Everbright Bank",
    "Symbol": "601818.SS",
    " marketcap ": " $25 352 672 167 ",
    "price (USD)": "0.454464",
    "country": "China"
  },
  {
    "Rank": "789",
    "Name": "Equity Residential",
    "Symbol": "EQR",
    " marketcap ": " $25 315 330 048 ",
    "price (USD)": "66.8",
    "country": "United States"
  },
  {
    "Rank": "790",
    "Name": "Dollarama",
    "Symbol": "DOL.TO",
    " marketcap ": " $25 276 185 815 ",
    "price (USD)": "90.6733",
    "country": "Canada"
  },
  {
    "Rank": "791",
    "Name": "Cloudflare",
    "Symbol": "NET",
    " marketcap ": " $25 273 802 752 ",
    "price (USD)": "74.38",
    "country": "United States"
  },
  {
    "Rank": "792",
    "Name": "Ecopetrol",
    "Symbol": "EC",
    " marketcap ": " $25 266 151 424 ",
    "price (USD)": "\u0434\u0435\u043a.29",
    "country": "Colombia"
  },
  {
    "Rank": "793",
    "Name": "Nornickel",
    "Symbol": "GMKN.ME",
    " marketcap ": " $25 258 079 843 ",
    "price (USD)": "\u044f\u043d\u0432.66",
    "country": "Russia"
  },
  {
    "Rank": "794",
    "Name": "Standard Chartered",
    "Symbol": "STAN.L",
    " marketcap ": " $25 169 669 263 ",
    "price (USD)": "9.87325",
    "country": "United Kingdom"
  },
  {
    "Rank": "795",
    "Name": "Vonovia",
    "Symbol": "VNA.DE",
    " marketcap ": " $25 123 160 039 ",
    "price (USD)": "30.8394",
    "country": "Germany"
  },
  {
    "Rank": "796",
    "Name": "Epiroc",
    "Symbol": "EPI-A.ST",
    " marketcap ": " $25 096 378 273 ",
    "price (USD)": "21.4631",
    "country": "Sweden"
  },
  {
    "Rank": "797",
    "Name": "DLF",
    "Symbol": "DLF.NS",
    " marketcap ": " $25 052 897 021 ",
    "price (USD)": "10.1211",
    "country": "India"
  },
  {
    "Rank": "798",
    "Name": "Dollar Tree",
    "Symbol": "DLTR",
    " marketcap ": " $25 029 832 704 ",
    "price (USD)": "114.7",
    "country": "United States"
  },
  {
    "Rank": "799",
    "Name": "Terumo",
    "Symbol": "4543.T",
    " marketcap ": " $25 024 802 219 ",
    "price (USD)": "16.8543",
    "country": "Japan"
  },
  {
    "Rank": "800",
    "Name": "International Flavors & Fragrances",
    "Symbol": "IFF",
    " marketcap ": " $24 998 864 896 ",
    "price (USD)": "97.9",
    "country": "United States"
  },
  {
    "Rank": "801",
    "Name": "Danske Bank",
    "Symbol": "DANS.VI",
    " marketcap ": " $24 907 282 736 ",
    "price (USD)": "29.2214",
    "country": "Denmark"
  },
  {
    "Rank": "802",
    "Name": "Klabin",
    "Symbol": "KLBN11.SA",
    " marketcap ": " $24 864 897 337 ",
    "price (USD)": "4.1796",
    "country": "Brazil"
  },
  {
    "Rank": "803",
    "Name": "Rheinmetall",
    "Symbol": "RHM.F",
    " marketcap ": " $24 846 360 908 ",
    "price (USD)": "570.529",
    "country": "Germany"
  },
  {
    "Rank": "804",
    "Name": "PulteGroup",
    "Symbol": "PHM",
    " marketcap ": " $24 799 322 112 ",
    "price (USD)": "117.9",
    "country": "United States"
  },
  {
    "Rank": "805",
    "Name": "ORIX",
    "Symbol": "IX",
    " marketcap ": " $24 761 532 416 ",
    "price (USD)": "107.52",
    "country": "Japan"
  },
  {
    "Rank": "806",
    "Name": "Franco-Nevada",
    "Symbol": "FNV",
    " marketcap ": " $24 734 461 952 ",
    "price (USD)": "128.38",
    "country": "Canada"
  },
  {
    "Rank": "807",
    "Name": "Lasertec",
    "Symbol": "6920.T",
    " marketcap ": " $24 677 368 756 ",
    "price (USD)": "273.623",
    "country": "Japan"
  },
  {
    "Rank": "808",
    "Name": "SSE",
    "Symbol": "SSE.L",
    " marketcap ": " $24 675 154 476 ",
    "price (USD)": "22.5663",
    "country": "United Kingdom"
  },
  {
    "Rank": "809",
    "Name": "West Pharmaceutical",
    "Symbol": "WST",
    " marketcap ": " $24 670 953 472 ",
    "price (USD)": "337.01",
    "country": "United States"
  },
  {
    "Rank": "810",
    "Name": "Bharat Electronics",
    "Symbol": "BEL.NS",
    " marketcap ": " $24 552 717 167 ",
    "price (USD)": "3.35889",
    "country": "India"
  },
  {
    "Rank": "811",
    "Name": "China Unicom",
    "Symbol": "0762.HK",
    " marketcap ": " $24 544 491 379 ",
    "price (USD)": "0.80216",
    "country": "Hong Kong"
  },
  {
    "Rank": "812",
    "Name": "Zimmer Biomet",
    "Symbol": "ZBH",
    " marketcap ": " $24 481 632 256 ",
    "price (USD)": "119",
    "country": "United States"
  },
  {
    "Rank": "813",
    "Name": "Entergy",
    "Symbol": "ETR",
    " marketcap ": " $24 390 195 200 ",
    "price (USD)": "114.22",
    "country": "United States"
  },
  {
    "Rank": "814",
    "Name": "CGI",
    "Symbol": "GIB",
    " marketcap ": " $24 323 717 120 ",
    "price (USD)": "105.18",
    "country": "Canada"
  },
  {
    "Rank": "815",
    "Name": "Iron Mountain",
    "Symbol": "IRM",
    " marketcap ": " $24 286 068 736 ",
    "price (USD)": "82.85",
    "country": "United States"
  },
  {
    "Rank": "816",
    "Name": "Tradeweb",
    "Symbol": "TW",
    " marketcap ": " $24 254 208 000 ",
    "price (USD)": "111.29",
    "country": "United States"
  },
  {
    "Rank": "817",
    "Name": "Telus",
    "Symbol": "TU",
    " marketcap ": " $24 251 627 520 ",
    "price (USD)": "16.39",
    "country": "Canada"
  },
  {
    "Rank": "818",
    "Name": "DTE Energy",
    "Symbol": "DTE",
    " marketcap ": " $24 248 877 056 ",
    "price (USD)": "117.18",
    "country": "United States"
  },
  {
    "Rank": "819",
    "Name": "Soci\u0413\u00a9t\u0413\u00a9 G\u0413\u00a9n\u0413\u00a9rale",
    "Symbol": "GLE.PA",
    " marketcap ": " $24 216 675 965 ",
    "price (USD)": "29.8675",
    "country": "France"
  },
  {
    "Rank": "820",
    "Name": "Western Digital",
    "Symbol": "WDC",
    " marketcap ": " $24 166 115 328 ",
    "price (USD)": "74.01",
    "country": "United States"
  },
  {
    "Rank": "821",
    "Name": "Veolia",
    "Symbol": "VIE.PA",
    " marketcap ": " $24 082 854 321 ",
    "price (USD)": "33.641",
    "country": "France"
  },
  {
    "Rank": "822",
    "Name": "Cheniere Energy",
    "Symbol": "CQP",
    " marketcap ": " $23 945 508 864 ",
    "price (USD)": "49.47",
    "country": "United States"
  },
  {
    "Rank": "823",
    "Name": "NVR",
    "Symbol": "NVR",
    " marketcap ": " $23 869 349 888 ",
    "price (USD)": "7620.22",
    "country": "United States"
  },
  {
    "Rank": "824",
    "Name": "SMIC",
    "Symbol": "0981.HK",
    " marketcap ": " $23 863 657 012 ",
    "price (USD)": "2.06306",
    "country": "China"
  },
  {
    "Rank": "825",
    "Name": "Techtronic Industries",
    "Symbol": "0669.HK",
    " marketcap ": " $23 790 902 498 ",
    "price (USD)": "\u0434\u0435\u043a.78",
    "country": "Hong Kong"
  },
  {
    "Rank": "826",
    "Name": "CTBC Financial Holding",
    "Symbol": "2891.TW",
    " marketcap ": " $23 649 448 708 ",
    "price (USD)": "1.1753",
    "country": "Taiwan"
  },
  {
    "Rank": "827",
    "Name": "Broadridge Financial Solutions",
    "Symbol": "BR",
    " marketcap ": " $23 632 455 680 ",
    "price (USD)": "199.97",
    "country": "United States"
  },
  {
    "Rank": "828",
    "Name": "Varun Beverages",
    "Symbol": "VBL.NS",
    " marketcap ": " $23 623 376 384 ",
    "price (USD)": "18.1798",
    "country": "India"
  },
  {
    "Rank": "829",
    "Name": "Live Nation",
    "Symbol": "LYV",
    " marketcap ": " $23 602 558 976 ",
    "price (USD)": "101.98",
    "country": "United States"
  },
  {
    "Rank": "830",
    "Name": "National Bank of Kuwait",
    "Symbol": "NBK.KW",
    " marketcap ": " $23 584 342 112 ",
    "price (USD)": "2832.46",
    "country": "Kuwait"
  },
  {
    "Rank": "831",
    "Name": "Uniper",
    "Symbol": "UN0.DE",
    " marketcap ": " $23 471 661 201 ",
    "price (USD)": "56.3579",
    "country": "Germany"
  },
  {
    "Rank": "832",
    "Name": "ASE Group",
    "Symbol": "ASX",
    " marketcap ": " $23 455 428 608 ",
    "price (USD)": "\u043e\u043a\u0442.86",
    "country": "Taiwan"
  },
  {
    "Rank": "833",
    "Name": "Dai-ichi Life Holdings",
    "Symbol": "8750.T",
    " marketcap ": " $23 436 059 628 ",
    "price (USD)": "24.6945",
    "country": "Japan"
  },
  {
    "Rank": "834",
    "Name": "Evolution Gaming",
    "Symbol": "EVO.ST",
    " marketcap ": " $23 428 591 679 ",
    "price (USD)": "111.013",
    "country": "Sweden"
  },
  {
    "Rank": "835",
    "Name": "Cameco",
    "Symbol": "CCJ",
    " marketcap ": " $23 398 770 688 ",
    "price (USD)": "53.73",
    "country": "Canada"
  },
  {
    "Rank": "836",
    "Name": "Cardinal Health",
    "Symbol": "CAH",
    " marketcap ": " $23 384 868 864 ",
    "price (USD)": "96.01",
    "country": "United States"
  },
  {
    "Rank": "837",
    "Name": "Bank of Ningbo",
    "Symbol": "002142.SZ",
    " marketcap ": " $23 379 334 077 ",
    "price (USD)": "\u043c\u0430\u0440.04",
    "country": "China"
  },
  {
    "Rank": "838",
    "Name": "NetApp",
    "Symbol": "NTAP",
    " marketcap ": " $23 310 280 704 ",
    "price (USD)": "112.95",
    "country": "United States"
  },
  {
    "Rank": "839",
    "Name": "FirstEnergy",
    "Symbol": "FE",
    " marketcap ": " $23 268 112 384 ",
    "price (USD)": "40.43",
    "country": "United States"
  },
  {
    "Rank": "840",
    "Name": "State Street Corporation",
    "Symbol": "STT",
    " marketcap ": " $23 221 045 248 ",
    "price (USD)": "77.08",
    "country": "United States"
  },
  {
    "Rank": "841",
    "Name": "KE Holdings",
    "Symbol": "BEKE",
    " marketcap ": " $23 162 292 224 ",
    "price (USD)": "18.91",
    "country": "China"
  },
  {
    "Rank": "842",
    "Name": "Hewlett Packard Enterprise",
    "Symbol": "HPE",
    " marketcap ": " $23 110 979 584 ",
    "price (USD)": "17.78",
    "country": "United States"
  },
  {
    "Rank": "843",
    "Name": "Deckers Brands",
    "Symbol": "DECK",
    " marketcap ": " $23 094 706 176 ",
    "price (USD)": "899.74",
    "country": "United States"
  },
  {
    "Rank": "844",
    "Name": "China Minsheng Bank",
    "Symbol": "600016.SS",
    " marketcap ": " $23 089 791 298 ",
    "price (USD)": "0.556684",
    "country": "China"
  },
  {
    "Rank": "845",
    "Name": "SAIC Motor",
    "Symbol": "600104.SS",
    " marketcap ": " $23 072 891 967 ",
    "price (USD)": "1.99329",
    "country": "China"
  },
  {
    "Rank": "846",
    "Name": "MTR Corporation",
    "Symbol": "0066.HK",
    " marketcap ": " $23 063 758 351 ",
    "price (USD)": "3.70967",
    "country": "Hong Kong"
  },
  {
    "Rank": "847",
    "Name": "Yankuang Energy (Yanzhou Coal Mining)",
    "Symbol": "600188.SS",
    " marketcap ": " $22 900 596 643 ",
    "price (USD)": "3.45475",
    "country": "China"
  },
  {
    "Rank": "848",
    "Name": "Steris",
    "Symbol": "STE",
    " marketcap ": " $22 786 508 800 ",
    "price (USD)": "230.6",
    "country": "Ireland"
  },
  {
    "Rank": "849",
    "Name": "KB Financial Group",
    "Symbol": "KB",
    " marketcap ": " $22 779 312 128 ",
    "price (USD)": "59.7",
    "country": "South Korea"
  },
  {
    "Rank": "850",
    "Name": "DiDi",
    "Symbol": "DIDIY",
    " marketcap ": " $22 758 338 560 ",
    "price (USD)": "04.\u0438\u044e\u043b",
    "country": "China"
  },
  {
    "Rank": "851",
    "Name": "First Solar",
    "Symbol": "FSLR",
    " marketcap ": " $22 704 465 920 ",
    "price (USD)": "212.11",
    "country": "United States"
  },
  {
    "Rank": "852",
    "Name": "Weyerhaeuser",
    "Symbol": "WY",
    " marketcap ": " $22 679 719 936 ",
    "price (USD)": "31.11",
    "country": "United States"
  },
  {
    "Rank": "853",
    "Name": "China Overseas Land &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "854",
    "Name": "Suzuki Motor",
    "Symbol": "7269.T",
    " marketcap ": " $22 634 899 522 ",
    "price (USD)": "\u043d\u043e\u044f.31",
    "country": "Japan"
  },
  {
    "Rank": "855",
    "Name": "Galaxy Entertainment",
    "Symbol": "0027.HK",
    " marketcap ": " $22 585 502 498 ",
    "price (USD)": "5.16406",
    "country": "Hong Kong"
  },
  {
    "Rank": "856",
    "Name": "BOE Technology",
    "Symbol": "000725.SZ",
    " marketcap ": " $22 548 240 949 ",
    "price (USD)": "0.60365",
    "country": "China"
  },
  {
    "Rank": "857",
    "Name": "Samsara",
    "Symbol": "IOT",
    " marketcap ": " $22 543 917 056 ",
    "price (USD)": "40.95",
    "country": "United States"
  },
  {
    "Rank": "858",
    "Name": "Rollins",
    "Symbol": "ROL",
    " marketcap ": " $22 530 877 440 ",
    "price (USD)": "46.5",
    "country": "United States"
  },
  {
    "Rank": "859",
    "Name": "Kaspi.kz Joint Stock Company",
    "Symbol": "KKS.F",
    " marketcap ": " $22 492 751 004 ",
    "price (USD)": "112.933",
    "country": "Kazakhstan"
  },
  {
    "Rank": "860",
    "Name": "Brown Forman",
    "Symbol": "BF-A",
    " marketcap ": " $22 492 104 704 ",
    "price (USD)": "48.12",
    "country": "United States"
  },
  {
    "Rank": "861",
    "Name": "Swedbank",
    "Symbol": "SWED-A.ST",
    " marketcap ": " $22 487 200 835 ",
    "price (USD)": "19.9842",
    "country": "Sweden"
  },
  {
    "Rank": "862",
    "Name": "China Railway Group",
    "Symbol": "0390.HK",
    " marketcap ": " $22 435 502 736 ",
    "price (USD)": "0.581758",
    "country": "China"
  },
  {
    "Rank": "863",
    "Name": "Aptiv",
    "Symbol": "APTV",
    " marketcap ": " $22 393 423 872 ",
    "price (USD)": "82.31",
    "country": "Ireland"
  },
  {
    "Rank": "864",
    "Name": "Celsius Holdings",
    "Symbol": "CELH",
    " marketcap ": " $22 366 451 712 ",
    "price (USD)": "95.96",
    "country": "United States"
  },
  {
    "Rank": "865",
    "Name": "Sampo",
    "Symbol": "SAMPO.HE",
    " marketcap ": " $22 275 450 399 ",
    "price (USD)": "44.3914",
    "country": "Finland"
  },
  {
    "Rank": "866",
    "Name": "WiseTech Global",
    "Symbol": "WTC.AX",
    " marketcap ": " $22 241 213 358 ",
    "price (USD)": "66.7009",
    "country": "Australia"
  },
  {
    "Rank": "867",
    "Name": "BioNTech",
    "Symbol": "BNTX",
    " marketcap ": " $22 187 950 080 ",
    "price (USD)": "92.07",
    "country": "Germany"
  },
  {
    "Rank": "868",
    "Name": "Mobileye",
    "Symbol": "MBLY",
    " marketcap ": " $22 184 091 648 ",
    "price (USD)": "27.51",
    "country": "Israel"
  },
  {
    "Rank": "869",
    "Name": "Shenzhen Inovance",
    "Symbol": "300124.SZ",
    " marketcap ": " $22 183 591 541 ",
    "price (USD)": "8.28395",
    "country": "China"
  },
  {
    "Rank": "870",
    "Name": "Freddie Mac",
    "Symbol": "FMCCT",
    " marketcap ": " $22 162 612 224 ",
    "price (USD)": "\u0438\u044e\u043d.88",
    "country": "United States"
  },
  {
    "Rank": "871",
    "Name": "China Tourism Group Duty Free",
    "Symbol": "601888.SS",
    " marketcap ": " $22 141 142 919 ",
    "price (USD)": "\u043e\u043a\u0442.59",
    "country": "China"
  },
  {
    "Rank": "872",
    "Name": "Otsuka Holdings",
    "Symbol": "4578.T",
    " marketcap ": " $22 043 835 316 ",
    "price (USD)": "40.6308",
    "country": "Japan"
  },
  {
    "Rank": "873",
    "Name": "PPL",
    "Symbol": "PPL",
    " marketcap ": " $22 014 191 616 ",
    "price (USD)": "29.84",
    "country": "United States"
  },
  {
    "Rank": "874",
    "Name": "Central Japan Railway",
    "Symbol": "9022.T",
    " marketcap ": " $21 944 896 121 ",
    "price (USD)": "22.3018",
    "country": "Japan"
  },
  {
    "Rank": "875",
    "Name": "POSCO",
    "Symbol": "PKX",
    " marketcap ": " $21 922 166 784 ",
    "price (USD)": "72.23",
    "country": "South Korea"
  },
  {
    "Rank": "876",
    "Name": "Teradyne",
    "Symbol": "TER",
    " marketcap ": " $21 897 830 400 ",
    "price (USD)": "140.27",
    "country": "United States"
  },
  {
    "Rank": "877",
    "Name": "\u0414\u040aEZ Group",
    "Symbol": "CEZ.PR",
    " marketcap ": " $21 885 584 336 ",
    "price (USD)": "40.7697",
    "country": "Czech Republic"
  },
  {
    "Rank": "878",
    "Name": "China Tower",
    "Symbol": "0788.HK",
    " marketcap ": " $21 877 152 674 ",
    "price (USD)": "0.124296",
    "country": "China"
  },
  {
    "Rank": "879",
    "Name": "PTC",
    "Symbol": "PTC",
    " marketcap ": " $21 873 635 328 ",
    "price (USD)": "182.67",
    "country": "United States"
  },
  {
    "Rank": "880",
    "Name": "The Saudi British Bank",
    "Symbol": "1060.SR",
    " marketcap ": " $21 851 301 406 ",
    "price (USD)": "\u043e\u043a\u0442.43",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "881",
    "Name": "Ball Corporation",
    "Symbol": "BALL",
    " marketcap ": " $21 822 674 944 ",
    "price (USD)": "70.31",
    "country": "United States"
  },
  {
    "Rank": "882",
    "Name": "Fleetcor",
    "Symbol": "FLT",
    " marketcap ": " $21 790 322 688 ",
    "price (USD)": "303.26",
    "country": "United States"
  },
  {
    "Rank": "883",
    "Name": "Polyus",
    "Symbol": "PLZL.ME",
    " marketcap ": " $21 766 936 725 ",
    "price (USD)": "159.92",
    "country": "Russia"
  },
  {
    "Rank": "884",
    "Name": "Tyson Foods",
    "Symbol": "TSN",
    " marketcap ": " $21 731 766 272 ",
    "price (USD)": "61.04",
    "country": "United States"
  },
  {
    "Rank": "885",
    "Name": "Axon Enterprise",
    "Symbol": "AXON",
    " marketcap ": " $21 730 781 184 ",
    "price (USD)": "287.95",
    "country": "United States"
  },
  {
    "Rank": "886",
    "Name": "Hubbell",
    "Symbol": "HUBB",
    " marketcap ": " $21 689 143 296 ",
    "price (USD)": "404",
    "country": "United States"
  },
  {
    "Rank": "887",
    "Name": "Argenx",
    "Symbol": "ARGX",
    " marketcap ": " $21 621 657 600 ",
    "price (USD)": "356.66",
    "country": "Netherlands"
  },
  {
    "Rank": "888",
    "Name": "Alexandria Real Estate Equities",
    "Symbol": "ARE",
    " marketcap ": " $21 596 301 312 ",
    "price (USD)": "123.49",
    "country": "United States"
  },
  {
    "Rank": "889",
    "Name": "CLP Group",
    "Symbol": "0002.HK",
    " marketcap ": " $21 593 505 803 ",
    "price (USD)": "8.54698",
    "country": "Hong Kong"
  },
  {
    "Rank": "890",
    "Name": "Vedanta",
    "Symbol": "VEDL.NS",
    " marketcap ": " $21 583 500 886 ",
    "price (USD)": "5.81302",
    "country": "India"
  },
  {
    "Rank": "891",
    "Name": "Eversource Energy",
    "Symbol": "ES",
    " marketcap ": " $21 565 052 928 ",
    "price (USD)": "61.22",
    "country": "United States"
  },
  {
    "Rank": "892",
    "Name": "PKN Orlen",
    "Symbol": "PKN.WA",
    " marketcap ": " $21 554 891 409 ",
    "price (USD)": "18.5668",
    "country": "Poland"
  },
  {
    "Rank": "893",
    "Name": "Invitation Homes",
    "Symbol": "INVH",
    " marketcap ": " $21 549 017 088 ",
    "price (USD)": "35.18",
    "country": "United States"
  },
  {
    "Rank": "894",
    "Name": "Pembina Pipeline",
    "Symbol": "PBA",
    " marketcap ": " $21 548 431 360 ",
    "price (USD)": "37.13",
    "country": "Canada"
  },
  {
    "Rank": "895",
    "Name": "ABB India",
    "Symbol": "ABB.NS",
    " marketcap ": " $21 534 213 642 ",
    "price (USD)": "101.359",
    "country": "India"
  },
  {
    "Rank": "896",
    "Name": "Sungrow Power Supply",
    "Symbol": "300274.SZ",
    " marketcap ": " $21 516 241 095 ",
    "price (USD)": "14.4876",
    "country": "China"
  },
  {
    "Rank": "897",
    "Name": "FirstRand",
    "Symbol": "FSR.JO",
    " marketcap ": " $21 418 261 500 ",
    "price (USD)": "3.82186",
    "country": "South Africa"
  },
  {
    "Rank": "898",
    "Name": "Rogers Communication",
    "Symbol": "RCI",
    " marketcap ": " $21 400 750 080 ",
    "price (USD)": "39.23",
    "country": "Canada"
  },
  {
    "Rank": "899",
    "Name": "Imperial Brands",
    "Symbol": "IMB.L",
    " marketcap ": " $21 324 176 086 ",
    "price (USD)": "24.753",
    "country": "United Kingdom"
  },
  {
    "Rank": "900",
    "Name": "Toyota Tsusho",
    "Symbol": "8015.T",
    " marketcap ": " $21 320 505 028 ",
    "price (USD)": "60.5911",
    "country": "Japan"
  },
  {
    "Rank": "901",
    "Name": "SBA Communications",
    "Symbol": "SBAC",
    " marketcap ": " $21 313 466 368 ",
    "price (USD)": "198.37",
    "country": "United States"
  },
  {
    "Rank": "902",
    "Name": "United Microelectronics",
    "Symbol": "UMC",
    " marketcap ": " $21 298 620 416 ",
    "price (USD)": "08.\u043c\u0430\u0439",
    "country": "Taiwan"
  },
  {
    "Rank": "903",
    "Name": "Markel",
    "Symbol": "MKL",
    " marketcap ": " $21 287 987 200 ",
    "price (USD)": "1637.21",
    "country": "United States"
  },
  {
    "Rank": "904",
    "Name": "Kellogg's",
    "Symbol": "K",
    " marketcap ": " $21 282 279 424 ",
    "price (USD)": "62.25",
    "country": "United States"
  },
  {
    "Rank": "905",
    "Name": "LG Chem",
    "Symbol": "051910.KS",
    " marketcap ": " $21 277 727 749 ",
    "price (USD)": "281.274",
    "country": "South Korea"
  },
  {
    "Rank": "906",
    "Name": "Mitsubishi Estate",
    "Symbol": "8802.T",
    " marketcap ": " $21 264 666 729 ",
    "price (USD)": "16.7936",
    "country": "Japan"
  },
  {
    "Rank": "907",
    "Name": "Nokia",
    "Symbol": "NOK",
    " marketcap ": " $21 229 056 000 ",
    "price (USD)": "\u043c\u0430\u0440.84",
    "country": "Finland"
  },
  {
    "Rank": "908",
    "Name": "Carnival Corporation",
    "Symbol": "CCL",
    " marketcap ": " $21 222 000 640 ",
    "price (USD)": "16.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "909",
    "Name": "Bank of Jiangsu",
    "Symbol": "600919.SS",
    " marketcap ": " $21 166 877 354 ",
    "price (USD)": "1.15343",
    "country": "China"
  },
  {
    "Rank": "910",
    "Name": "ArcelorMittal",
    "Symbol": "MT",
    " marketcap ": " $21 116 264 448 ",
    "price (USD)": "26.19",
    "country": "Luxembourg"
  },
  {
    "Rank": "911",
    "Name": "Steel Dynamics",
    "Symbol": "STLD",
    " marketcap ": " $21 110 818 816 ",
    "price (USD)": "134.35",
    "country": "United States"
  },
  {
    "Rank": "912",
    "Name": "Genuine Parts Company",
    "Symbol": "GPC",
    " marketcap ": " $21 105 192 960 ",
    "price (USD)": "151.51",
    "country": "United States"
  },
  {
    "Rank": "913",
    "Name": "Tyler Technologies",
    "Symbol": "TYL",
    " marketcap ": " $21 056 980 992 ",
    "price (USD)": "495.98",
    "country": "United States"
  },
  {
    "Rank": "914",
    "Name": "NTT Data",
    "Symbol": "9613.T",
    " marketcap ": " $21 011 015 446 ",
    "price (USD)": "14.9862",
    "country": "Japan"
  },
  {
    "Rank": "915",
    "Name": "Alinma Bank",
    "Symbol": "1150.SR",
    " marketcap ": " $20 947 597 427 ",
    "price (USD)": "8.43274",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "916",
    "Name": "Ko\u0413\u00a7 Holding",
    "Symbol": "KCHOL.IS",
    " marketcap ": " $20 906 503 311 ",
    "price (USD)": "8.24711",
    "country": "Turkey"
  },
  {
    "Rank": "917",
    "Name": "EnBW Energie",
    "Symbol": "EBK.DE",
    " marketcap ": " $20 882 512 394 ",
    "price (USD)": "77.0985",
    "country": "Germany"
  },
  {
    "Rank": "918",
    "Name": "Waters Corporation",
    "Symbol": "WAT",
    " marketcap ": " $20 859 772 928 ",
    "price (USD)": "351.65",
    "country": "United States"
  },
  {
    "Rank": "919",
    "Name": "Roblox",
    "Symbol": "RBLX",
    " marketcap ": " $20 831 283 200 ",
    "price (USD)": "32.55",
    "country": "United States"
  },
  {
    "Rank": "920",
    "Name": "Endesa",
    "Symbol": "ELE.MC",
    " marketcap ": " $20 811 536 262 ",
    "price (USD)": "19.6764",
    "country": "Spain"
  },
  {
    "Rank": "921",
    "Name": "Li Auto",
    "Symbol": "LI",
    " marketcap ": " $20 809 736 192 ",
    "price (USD)": "20.96",
    "country": "China"
  },
  {
    "Rank": "922",
    "Name": "Erie Indemnity",
    "Symbol": "ERIE",
    " marketcap ": " $20 739 743 744 ",
    "price (USD)": "396.63",
    "country": "United States"
  },
  {
    "Rank": "923",
    "Name": "Coterra Energy",
    "Symbol": "CTRA",
    " marketcap ": " $20 719 448 064 ",
    "price (USD)": "27.84",
    "country": "United States"
  },
  {
    "Rank": "924",
    "Name": "Straumann",
    "Symbol": "STMN.SW",
    " marketcap ": " $20 706 542 766 ",
    "price (USD)": "129.868",
    "country": "Switzerland"
  },
  {
    "Rank": "925",
    "Name": "Siemens Energy",
    "Symbol": "ENR.F",
    " marketcap ": " $20 704 154 701 ",
    "price (USD)": "26.0289",
    "country": "Germany"
  },
  {
    "Rank": "926",
    "Name": "CK Hutchison Holdings",
    "Symbol": "0001.HK",
    " marketcap ": " $20 661 983 910 ",
    "price (USD)": "5.39472",
    "country": "Hong Kong"
  },
  {
    "Rank": "927",
    "Name": "DraftKings",
    "Symbol": "DKNG",
    " marketcap ": " $20 658 597 888 ",
    "price (USD)": "43.38",
    "country": "United States"
  },
  {
    "Rank": "928",
    "Name": "Formosa Petrochemical",
    "Symbol": "6505.TW",
    " marketcap ": " $20 648 882 920 ",
    "price (USD)": "2.16764",
    "country": "Taiwan"
  },
  {
    "Rank": "929",
    "Name": "Westlake Chemical",
    "Symbol": "WLK",
    " marketcap ": " $20 645 771 264 ",
    "price (USD)": "160.58",
    "country": "United States"
  },
  {
    "Rank": "930",
    "Name": "Ita\u0413\u0454sa",
    "Symbol": "ITSA3.SA",
    " marketcap ": " $20 617 457 682 ",
    "price (USD)": "2.00098",
    "country": "Brazil"
  },
  {
    "Rank": "931",
    "Name": "Riyad Bank",
    "Symbol": "1010.SR",
    " marketcap ": " $20 540 524 568 ",
    "price (USD)": "6.85827",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "932",
    "Name": "Erste Group Bank",
    "Symbol": "EBO.F",
    " marketcap ": " $20 516 961 407 ",
    "price (USD)": "51.4822",
    "country": "Austria"
  },
  {
    "Rank": "933",
    "Name": "Huntington Bancshares",
    "Symbol": "HBAN",
    " marketcap ": " $20 506 888 192 ",
    "price (USD)": "14.15",
    "country": "United States"
  },
  {
    "Rank": "934",
    "Name": "Builders FirstSource",
    "Symbol": "BLDR",
    " marketcap ": " $20 498 253 824 ",
    "price (USD)": "167.94",
    "country": "United States"
  },
  {
    "Rank": "935",
    "Name": "Ka\u0415\u040c",
    "Symbol": "4452.T",
    " marketcap ": " $20 496 766 426 ",
    "price (USD)": "44.0919",
    "country": "Japan"
  },
  {
    "Rank": "936",
    "Name": "LONGi Green Energy Technology",
    "Symbol": "601012.SS",
    " marketcap ": " $20 475 247 275 ",
    "price (USD)": "2.70192",
    "country": "China"
  },
  {
    "Rank": "937",
    "Name": "Coca-Cola FEMSA",
    "Symbol": "KOF",
    " marketcap ": " $20 441 055 232 ",
    "price (USD)": "96.9",
    "country": "Mexico"
  },
  {
    "Rank": "938",
    "Name": "Carvana",
    "Symbol": "CVNA",
    " marketcap ": " $20 429 328 384 ",
    "price (USD)": "115.03",
    "country": "United States"
  },
  {
    "Rank": "939",
    "Name": "UPM-Kymmene",
    "Symbol": "UPM.HE",
    " marketcap ": " $20 426 036 790 ",
    "price (USD)": "38.2995",
    "country": "Finland"
  },
  {
    "Rank": "940",
    "Name": "Commerzbank",
    "Symbol": "CBK.F",
    " marketcap ": " $20 364 728 001 ",
    "price (USD)": "17.1517",
    "country": "Germany"
  },
  {
    "Rank": "941",
    "Name": "Geberit",
    "Symbol": "GEBN.SW",
    " marketcap ": " $20 352 678 408 ",
    "price (USD)": "611.208",
    "country": "Switzerland"
  },
  {
    "Rank": "942",
    "Name": "Talanx",
    "Symbol": "TLX.DE",
    " marketcap ": " $20 329 679 157 ",
    "price (USD)": "78.7273",
    "country": "Germany"
  },
  {
    "Rank": "943",
    "Name": "Leidos",
    "Symbol": "LDOS",
    " marketcap ": " $20 319 660 032 ",
    "price (USD)": "150.28",
    "country": "United States"
  },
  {
    "Rank": "944",
    "Name": "Carlisle Companies",
    "Symbol": "CSL",
    " marketcap ": " $20 316 446 720 ",
    "price (USD)": "426.8",
    "country": "United States"
  },
  {
    "Rank": "945",
    "Name": "InterGlobe Aviation",
    "Symbol": "INDIGO.NS",
    " marketcap ": " $20 278 658 267 ",
    "price (USD)": "52.5382",
    "country": "India"
  },
  {
    "Rank": "946",
    "Name": "W. R. Berkley",
    "Symbol": "WRB",
    " marketcap ": " $20 256 100 352 ",
    "price (USD)": "79.23",
    "country": "United States"
  },
  {
    "Rank": "947",
    "Name": "Naver",
    "Symbol": "035420.KS",
    " marketcap ": " $20 246 840 324 ",
    "price (USD)": "134.101",
    "country": "South Korea"
  },
  {
    "Rank": "948",
    "Name": "East Japan Railway",
    "Symbol": "9020.T",
    " marketcap ": " $20 244 297 484 ",
    "price (USD)": "17.8939",
    "country": "Japan"
  },
  {
    "Rank": "949",
    "Name": "Fortis",
    "Symbol": "FTS",
    " marketcap ": " $20 219 971 584 ",
    "price (USD)": "40.91",
    "country": "Canada"
  },
  {
    "Rank": "950",
    "Name": "Williams-Sonoma",
    "Symbol": "WSM",
    " marketcap ": " $20 199 575 552 ",
    "price (USD)": "314.38",
    "country": "United States"
  },
  {
    "Rank": "951",
    "Name": "LPL Financial",
    "Symbol": "LPLA",
    " marketcap ": " $20 145 252 352 ",
    "price (USD)": "269.65",
    "country": "United States"
  },
  {
    "Rank": "952",
    "Name": "YANGHE",
    "Symbol": "002304.SZ",
    " marketcap ": " $20 070 600 293 ",
    "price (USD)": "13.3231",
    "country": "China"
  },
  {
    "Rank": "953",
    "Name": "Samsung SDI",
    "Symbol": "006405.KS",
    " marketcap ": " $20 064 399 533 ",
    "price (USD)": "172.216",
    "country": "South Korea"
  },
  {
    "Rank": "954",
    "Name": "Molina Healthcare",
    "Symbol": "MOH",
    " marketcap ": " $20 054 407 168 ",
    "price (USD)": "342.32",
    "country": "United States"
  },
  {
    "Rank": "955",
    "Name": "Prada",
    "Symbol": "1913.HK",
    " marketcap ": " $20 050 391 669 ",
    "price (USD)": "\u0438\u044e\u043b.58",
    "country": "Italy"
  },
  {
    "Rank": "956",
    "Name": "China Securities",
    "Symbol": "601066.SS",
    " marketcap ": " $20 045 207 164 ",
    "price (USD)": "3.08593",
    "country": "China"
  },
  {
    "Rank": "957",
    "Name": "Booz Allen Hamilton",
    "Symbol": "BAH",
    " marketcap ": " $20 000 346 112 ",
    "price (USD)": "154.15",
    "country": "United States"
  },
  {
    "Rank": "958",
    "Name": "Panasonic",
    "Symbol": "6752.T",
    " marketcap ": " $19 996 767 535 ",
    "price (USD)": "8.56631",
    "country": "Japan"
  },
  {
    "Rank": "959",
    "Name": "ZTO Express",
    "Symbol": "ZTO",
    " marketcap ": " $19 973 076 992 ",
    "price (USD)": "24.75",
    "country": "China"
  },
  {
    "Rank": "960",
    "Name": "Hormel Foods",
    "Symbol": "HRL",
    " marketcap ": " $19 952 273 408 ",
    "price (USD)": "36.43",
    "country": "United States"
  },
  {
    "Rank": "961",
    "Name": "Borouge",
    "Symbol": "BOROUGE.AE",
    " marketcap ": " $19 887 328 273 ",
    "price (USD)": "0.66",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "962",
    "Name": "Ameren",
    "Symbol": "AEE",
    " marketcap ": " $19 882 913 792 ",
    "price (USD)": "74.56",
    "country": "United States"
  },
  {
    "Rank": "963",
    "Name": "Saudi Electricity",
    "Symbol": "5110.SR",
    " marketcap ": " $19 880 613 092 ",
    "price (USD)": "4.77144",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "964",
    "Name": "Align Technology",
    "Symbol": "ALGN",
    " marketcap ": " $19 875 872 768 ",
    "price (USD)": "264.02",
    "country": "United States"
  },
  {
    "Rank": "965",
    "Name": "McCormick & Company",
    "Symbol": "MKC",
    " marketcap ": " $19 865 006 080 ",
    "price (USD)": "74",
    "country": "United States"
  },
  {
    "Rank": "966",
    "Name": "Industries Qatar",
    "Symbol": "IQCD.QA",
    " marketcap ": " $19 861 949 609 ",
    "price (USD)": "3.28297",
    "country": "Qatar"
  },
  {
    "Rank": "967",
    "Name": "Grasim Industries",
    "Symbol": "GRASIM.NS",
    " marketcap ": " $19 857 174 847 ",
    "price (USD)": "29.2693",
    "country": "India"
  },
  {
    "Rank": "968",
    "Name": "Sany Heavy Industry",
    "Symbol": "600031.SS",
    " marketcap ": " $19 844 954 503 ",
    "price (USD)": "2.33862",
    "country": "China"
  },
  {
    "Rank": "969",
    "Name": "Zoom",
    "Symbol": "ZM",
    " marketcap ": " $19 823 994 880 ",
    "price (USD)": "63.86",
    "country": "United States"
  },
  {
    "Rank": "970",
    "Name": "Ivanhoe Mines",
    "Symbol": "IVN.TO",
    " marketcap ": " $19 809 536 197 ",
    "price (USD)": "15.6017",
    "country": "Canada"
  },
  {
    "Rank": "971",
    "Name": "Tenaris",
    "Symbol": "TS",
    " marketcap ": " $19 740 835 840 ",
    "price (USD)": "34.44",
    "country": "Luxembourg"
  },
  {
    "Rank": "972",
    "Name": "Entegris",
    "Symbol": "ENTG",
    " marketcap ": " $19 691 796 480 ",
    "price (USD)": "130.59",
    "country": "United States"
  },
  {
    "Rank": "973",
    "Name": "Trent Limited",
    "Symbol": "TRENT.NS",
    " marketcap ": " $19 664 348 899 ",
    "price (USD)": "55.3162",
    "country": "India"
  },
  {
    "Rank": "974",
    "Name": "Seagate Technology",
    "Symbol": "STX",
    " marketcap ": " $19 654 969 344 ",
    "price (USD)": "93.6",
    "country": "Ireland"
  },
  {
    "Rank": "975",
    "Name": "Aristocrat",
    "Symbol": "ALL.AX",
    " marketcap ": " $19 618 180 220 ",
    "price (USD)": "30.9666",
    "country": "Australia"
  },
  {
    "Rank": "976",
    "Name": "Ajinomoto",
    "Symbol": "2802.T",
    " marketcap ": " $19 615 993 769 ",
    "price (USD)": "38.2701",
    "country": "Japan"
  },
  {
    "Rank": "977",
    "Name": "Ems-Chemie",
    "Symbol": "EMSN.SW",
    " marketcap ": " $19 595 418 885 ",
    "price (USD)": "837.805",
    "country": "Switzerland"
  },
  {
    "Rank": "978",
    "Name": "Ventas",
    "Symbol": "VTR",
    " marketcap ": " $19 578 918 912 ",
    "price (USD)": "48.37",
    "country": "United States"
  },
  {
    "Rank": "979",
    "Name": "GoDaddy",
    "Symbol": "GDDY",
    " marketcap ": " $19 572 473 856 ",
    "price (USD)": "138.87",
    "country": "United States"
  },
  {
    "Rank": "980",
    "Name": "Principal",
    "Symbol": "PFG",
    " marketcap ": " $19 568 719 872 ",
    "price (USD)": "83.49",
    "country": "United States"
  },
  {
    "Rank": "981",
    "Name": "Grupo Carso",
    "Symbol": "GCARSOA1.MX",
    " marketcap ": " $19 566 342 472 ",
    "price (USD)": "8.34517",
    "country": "Mexico"
  },
  {
    "Rank": "982",
    "Name": "Weichai Power",
    "Symbol": "2338.HK",
    " marketcap ": " $19 564 418 219 ",
    "price (USD)": "1.95542",
    "country": "China"
  },
  {
    "Rank": "983",
    "Name": "Carlsberg",
    "Symbol": "CARL-B.CO",
    " marketcap ": " $19 562 977 176 ",
    "price (USD)": "141.663",
    "country": "Denmark"
  },
  {
    "Rank": "984",
    "Name": "Ericsson",
    "Symbol": "ERIC",
    " marketcap ": " $19 497 129 984 ",
    "price (USD)": "\u043c\u0430\u0439.79",
    "country": "Sweden"
  },
  {
    "Rank": "985",
    "Name": "Pure Storage",
    "Symbol": "PSTG",
    " marketcap ": " $19 476 441 088 ",
    "price (USD)": "59.91",
    "country": "United States"
  },
  {
    "Rank": "986",
    "Name": "Nippon Steel",
    "Symbol": "5401.T",
    " marketcap ": " $19 468 446 156 ",
    "price (USD)": "21.1375",
    "country": "Japan"
  },
  {
    "Rank": "987",
    "Name": "CenterPoint Energy",
    "Symbol": "CNP",
    " marketcap ": " $19 454 007 296 ",
    "price (USD)": "30.41",
    "country": "United States"
  },
  {
    "Rank": "988",
    "Name": "Emaar Properties",
    "Symbol": "EMAAR.AE",
    " marketcap ": " $19 421 414 802 ",
    "price (USD)": "2.19729",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "989",
    "Name": "Teledyne",
    "Symbol": "TDY",
    " marketcap ": " $19 343 636 480 ",
    "price (USD)": "407.9",
    "country": "United States"
  },
  {
    "Rank": "990",
    "Name": "Watsco",
    "Symbol": "WSO",
    " marketcap ": " $19 338 141 696 ",
    "price (USD)": "485.4",
    "country": "United States"
  },
  {
    "Rank": "991",
    "Name": "Cboe",
    "Symbol": "CBOE",
    " marketcap ": " $19 320 995 840 ",
    "price (USD)": "183.74",
    "country": "United States"
  },
  {
    "Rank": "992",
    "Name": "Inpex",
    "Symbol": "1605.T",
    " marketcap ": " $19 315 429 594 ",
    "price (USD)": "15.3509",
    "country": "Japan"
  },
  {
    "Rank": "993",
    "Name": "Bollor\u0413\u00a9",
    "Symbol": "BOL.PA",
    " marketcap ": " $19 284 516 417 ",
    "price (USD)": "6.69997",
    "country": "France"
  },
  {
    "Rank": "994",
    "Name": "Repsol",
    "Symbol": "REP.MC",
    " marketcap ": " $19 283 006 381 ",
    "price (USD)": "16.0061",
    "country": "Spain"
  },
  {
    "Rank": "995",
    "Name": "Zomato",
    "Symbol": "ZOMATO.NS",
    " marketcap ": " $19 274 268 458 ",
    "price (USD)": "2.21863",
    "country": "India"
  },
  {
    "Rank": "996",
    "Name": "HeidelbergCement",
    "Symbol": "HEI.DE",
    " marketcap ": " $19 248 713 667 ",
    "price (USD)": "105.723",
    "country": "Germany"
  },
  {
    "Rank": "997",
    "Name": "Cooper Companies",
    "Symbol": "COO",
    " marketcap ": " $19 231 631 360 ",
    "price (USD)": "96.76",
    "country": "United States"
  },
  {
    "Rank": "998",
    "Name": "NEC Corp",
    "Symbol": "6701.T",
    " marketcap ": " $19 092 163 604 ",
    "price (USD)": "71.6525",
    "country": "Japan"
  },
  {
    "Rank": "999",
    "Name": "SM Investments Corporation",
    "Symbol": "SVTMF",
    " marketcap ": " $19 063 511 040 ",
    "price (USD)": "15.\u0438\u044e\u043d",
    "country": "Philippines"
  },
  {
    "Rank": "1000",
    "Name": "Sompo Holdings",
    "Symbol": "8630.T",
    " marketcap ": " $19 049 473 593 ",
    "price (USD)": "19.2886",
    "country": "Japan"
  },
  {
    "Rank": "1001",
    "Name": "Alfa Laval",
    "Symbol": "ALFA.ST",
    " marketcap ": " $19 046 319 295 ",
    "price (USD)": "46.0806",
    "country": "Sweden"
  },
  {
    "Rank": "1002",
    "Name": "WSP Global",
    "Symbol": "WSP.TO",
    " marketcap ": " $19 014 702 885 ",
    "price (USD)": "152.498",
    "country": "Canada"
  },
  {
    "Rank": "1003",
    "Name": "Asahi Group",
    "Symbol": "2502.T",
    " marketcap ": " $19 004 883 453 ",
    "price (USD)": "37.5088",
    "country": "Japan"
  },
  {
    "Rank": "1004",
    "Name": "Warner Bros. Discovery",
    "Symbol": "WBD",
    " marketcap ": " $18 991 230 000 ",
    "price (USD)": "\u0438\u044e\u043b.89",
    "country": "United States"
  },
  {
    "Rank": "1005",
    "Name": "BeiGene",
    "Symbol": "BGNE",
    " marketcap ": " $18 986 881 024 ",
    "price (USD)": "167.39",
    "country": "China"
  },
  {
    "Rank": "1006",
    "Name": "Olympus",
    "Symbol": "7733.T",
    " marketcap ": " $18 930 022 062 ",
    "price (USD)": "16.2402",
    "country": "Japan"
  },
  {
    "Rank": "1007",
    "Name": "Alnylam Pharmaceuticals",
    "Symbol": "ALNY",
    " marketcap ": " $18 925 731 840 ",
    "price (USD)": "149.62",
    "country": "United States"
  },
  {
    "Rank": "1008",
    "Name": "Corebridge Financial",
    "Symbol": "CRBG",
    " marketcap ": " $18 909 308 928 ",
    "price (USD)": "31.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "1009",
    "Name": "Legal &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1010",
    "Name": "George Weston",
    "Symbol": "WN.TO",
    " marketcap ": " $18 831 320 585 ",
    "price (USD)": "140.782",
    "country": "Canada"
  },
  {
    "Rank": "1011",
    "Name": "Genmab",
    "Symbol": "GMAB",
    " marketcap ": " $18 828 304 384 ",
    "price (USD)": "29.15",
    "country": "Denmark"
  },
  {
    "Rank": "1012",
    "Name": "Teva Pharmaceutical Industries",
    "Symbol": "TEVA",
    " marketcap ": " $18 790 498 304 ",
    "price (USD)": "16.59",
    "country": "Israel"
  },
  {
    "Rank": "1013",
    "Name": "Ambuja Cements",
    "Symbol": "AMBUJACEM.NS",
    " marketcap ": " $18 775 197 315 ",
    "price (USD)": "7.62253",
    "country": "India"
  },
  {
    "Rank": "1014",
    "Name": "Swiss Life",
    "Symbol": "SLHN.SW",
    " marketcap ": " $18 754 022 162 ",
    "price (USD)": "675.731",
    "country": "Switzerland"
  },
  {
    "Rank": "1015",
    "Name": "Power Corporation of Canada",
    "Symbol": "POW.TO",
    " marketcap ": " $18 748 217 386 ",
    "price (USD)": "28.7327",
    "country": "Canada"
  },
  {
    "Rank": "1016",
    "Name": "CMS Energy",
    "Symbol": "CMS",
    " marketcap ": " $18 697 537 536 ",
    "price (USD)": "62.61",
    "country": "United States"
  },
  {
    "Rank": "1017",
    "Name": "Sonova",
    "Symbol": "SOON.SW",
    " marketcap ": " $18 689 020 843 ",
    "price (USD)": "313.505",
    "country": "Switzerland"
  },
  {
    "Rank": "1018",
    "Name": "Omnicom",
    "Symbol": "OMC",
    " marketcap ": " $18 598 354 944 ",
    "price (USD)": "94.97",
    "country": "United States"
  },
  {
    "Rank": "1019",
    "Name": "Cincinnati Financial",
    "Symbol": "CINF",
    " marketcap ": " $18 581 747 712 ",
    "price (USD)": "118.59",
    "country": "United States"
  },
  {
    "Rank": "1020",
    "Name": "Moncler",
    "Symbol": "MONC.MI",
    " marketcap ": " $18 577 677 316 ",
    "price (USD)": "66.2395",
    "country": "Italy"
  },
  {
    "Rank": "1021",
    "Name": "Pidilite",
    "Symbol": "PIDILITIND.NS",
    " marketcap ": " $18 533 762 893 ",
    "price (USD)": "36.4401",
    "country": "India"
  },
  {
    "Rank": "1022",
    "Name": "Brookfield Renewable Partners",
    "Symbol": "BEP",
    " marketcap ": " $18 480 664 576 ",
    "price (USD)": "27.96",
    "country": "Bermuda"
  },
  {
    "Rank": "1023",
    "Name": "Avery Dennison",
    "Symbol": "AVY",
    " marketcap ": " $18 458 005 504 ",
    "price (USD)": "229.14",
    "country": "United States"
  },
  {
    "Rank": "1024",
    "Name": "ULTA Beauty",
    "Symbol": "ULTA",
    " marketcap ": " $18 430 437 376 ",
    "price (USD)": "381.83",
    "country": "United States"
  },
  {
    "Rank": "1025",
    "Name": "Robinhood",
    "Symbol": "HOOD",
    " marketcap ": " $18 420 400 128 ",
    "price (USD)": "20.96",
    "country": "United States"
  },
  {
    "Rank": "1026",
    "Name": "Unicharm",
    "Symbol": "8113.T",
    " marketcap ": " $18 411 508 234 ",
    "price (USD)": "31.1944",
    "country": "Japan"
  },
  {
    "Rank": "1027",
    "Name": "Shinhan Financial Group",
    "Symbol": "SHG",
    " marketcap ": " $18 399 057 920 ",
    "price (USD)": "36.12",
    "country": "South Korea"
  },
  {
    "Rank": "1028",
    "Name": "Z Holdings",
    "Symbol": "4689.T",
    " marketcap ": " $18 389 236 643 ",
    "price (USD)": "2.45154",
    "country": "Japan"
  },
  {
    "Rank": "1029",
    "Name": "Power Finance Corp",
    "Symbol": "PFC.NS",
    " marketcap ": " $18 388 521 751 ",
    "price (USD)": "5.57211",
    "country": "India"
  },
  {
    "Rank": "1030",
    "Name": "Hindalco Industries",
    "Symbol": "HINDALCO.NS",
    " marketcap ": " $18 366 791 645 ",
    "price (USD)": "8.21068",
    "country": "India"
  },
  {
    "Rank": "1031",
    "Name": "Grupo Bimbo",
    "Symbol": "BIMBOA.MX",
    " marketcap ": " $18 323 564 983 ",
    "price (USD)": "4.21864",
    "country": "Mexico"
  },
  {
    "Rank": "1032",
    "Name": "Severstal",
    "Symbol": "CHMF.ME",
    " marketcap ": " $18 322 582 087 ",
    "price (USD)": "21.69",
    "country": "Russia"
  },
  {
    "Rank": "1033",
    "Name": "ADNOC Drilling Company",
    "Symbol": "ADNOCDRILL.AE",
    " marketcap ": " $18 297 165 573 ",
    "price (USD)": "\u044f\u043d\u0432.14",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1034",
    "Name": "Emcor",
    "Symbol": "EME",
    " marketcap ": " $18 272 477 184 ",
    "price (USD)": "388.24",
    "country": "United States"
  },
  {
    "Rank": "1035",
    "Name": "Elm Company",
    "Symbol": "7203.SR",
    " marketcap ": " $18 270 221 226 ",
    "price (USD)": "228.378",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "1036",
    "Name": "Aeon",
    "Symbol": "8267.T",
    " marketcap ": " $18 266 815 008 ",
    "price (USD)": "21.3422",
    "country": "Japan"
  },
  {
    "Rank": "1037",
    "Name": "Essity",
    "Symbol": "ESSITY-B.ST",
    " marketcap ": " $18 245 447 960 ",
    "price (USD)": "25.9748",
    "country": "Sweden"
  },
  {
    "Rank": "1038",
    "Name": "PKO Bank Polski",
    "Symbol": "PKO.WA",
    " marketcap ": " $18 228 367 416 ",
    "price (USD)": "14.5827",
    "country": "Poland"
  },
  {
    "Rank": "1039",
    "Name": "Telkom Indonesia",
    "Symbol": "TLK",
    " marketcap ": " $18 217 537 536 ",
    "price (USD)": "18.39",
    "country": "Indonesia"
  },
  {
    "Rank": "1040",
    "Name": "Regions Financial",
    "Symbol": "RF",
    " marketcap ": " $18 215 798 784 ",
    "price (USD)": "19.89",
    "country": "United States"
  },
  {
    "Rank": "1041",
    "Name": "EQT Corporation",
    "Symbol": "EQT",
    " marketcap ": " $18 189 174 784 ",
    "price (USD)": "41.19",
    "country": "United States"
  },
  {
    "Rank": "1042",
    "Name": "AerCap",
    "Symbol": "AER",
    " marketcap ": " $18 186 070 016 ",
    "price (USD)": "91.69",
    "country": "Ireland"
  },
  {
    "Rank": "1043",
    "Name": "Lenovo",
    "Symbol": "0992.HK",
    " marketcap ": " $18 164 461 723 ",
    "price (USD)": "1.46593",
    "country": "Hong Kong"
  },
  {
    "Rank": "1044",
    "Name": "Budweiser APAC",
    "Symbol": "1876.HK",
    " marketcap ": " $18 158 079 380 ",
    "price (USD)": "\u044f\u043d\u0432.11",
    "country": "Hong Kong"
  },
  {
    "Rank": "1045",
    "Name": "Seres Group",
    "Symbol": "601127.SS",
    " marketcap ": " $18 152 479 812 ",
    "price (USD)": "12.0233",
    "country": "China"
  },
  {
    "Rank": "1046",
    "Name": "TDK",
    "Symbol": "6762.T",
    " marketcap ": " $18 126 108 195 ",
    "price (USD)": "47.7769",
    "country": "Japan"
  },
  {
    "Rank": "1047",
    "Name": "Svenska Handelsbanken",
    "Symbol": "SHB-A.ST",
    " marketcap ": " $18 072 123 491 ",
    "price (USD)": "9.0907",
    "country": "Sweden"
  },
  {
    "Rank": "1048",
    "Name": "Synchrony",
    "Symbol": "SYF",
    " marketcap ": " $17 989 171 200 ",
    "price (USD)": "44.8",
    "country": "United States"
  },
  {
    "Rank": "1049",
    "Name": "Nutanix",
    "Symbol": "NTNX",
    " marketcap ": " $17 926 418 432 ",
    "price (USD)": "73.37",
    "country": "United States"
  },
  {
    "Rank": "1050",
    "Name": "Domino's Pizza",
    "Symbol": "DPZ",
    " marketcap ": " $17 918 654 464 ",
    "price (USD)": "513.72",
    "country": "United States"
  },
  {
    "Rank": "1051",
    "Name": "China Communications Construction",
    "Symbol": "601800.SS",
    " marketcap ": " $17 905 719 477 ",
    "price (USD)": "1.27775",
    "country": "China"
  },
  {
    "Rank": "1052",
    "Name": "QBE Insurance",
    "Symbol": "QBE.AX",
    " marketcap ": " $17 892 393 897 ",
    "price (USD)": "\u043d\u043e\u044f.92",
    "country": "Australia"
  },
  {
    "Rank": "1053",
    "Name": "Atmos Energy",
    "Symbol": "ATO",
    " marketcap ": " $17 878 923 264 ",
    "price (USD)": "118.5",
    "country": "United States"
  },
  {
    "Rank": "1054",
    "Name": "Darden Restaurants",
    "Symbol": "DRI",
    " marketcap ": " $17 866 848 256 ",
    "price (USD)": "149.69",
    "country": "United States"
  },
  {
    "Rank": "1055",
    "Name": "Grupo Financiero Inbursa",
    "Symbol": "GFINBURO.MX",
    " marketcap ": " $17 818 389 020 ",
    "price (USD)": "2.86359",
    "country": "Mexico"
  },
  {
    "Rank": "1056",
    "Name": "Hydro One",
    "Symbol": "H.TO",
    " marketcap ": " $17 728 513 239 ",
    "price (USD)": "29.5759",
    "country": "Canada"
  },
  {
    "Rank": "1057",
    "Name": "MFHC",
    "Symbol": "2886.TW",
    " marketcap ": " $17 724 951 590 ",
    "price (USD)": "1.25748",
    "country": "Taiwan"
  },
  {
    "Rank": "1058",
    "Name": "Tatneft",
    "Symbol": "TATN.ME",
    " marketcap ": " $17 698 746 201 ",
    "price (USD)": "08.\u044f\u043d\u0432",
    "country": "Russia"
  },
  {
    "Rank": "1059",
    "Name": "Chongqing Changan",
    "Symbol": "000625.SZ",
    " marketcap ": " $17 625 359 641 ",
    "price (USD)": "2.02644",
    "country": "China"
  },
  {
    "Rank": "1060",
    "Name": "Traton",
    "Symbol": "8TRA.DE",
    " marketcap ": " $17 618 634 432 ",
    "price (USD)": "35.2373",
    "country": "Germany"
  },
  {
    "Rank": "1061",
    "Name": "Sartorius",
    "Symbol": "SRT.DE",
    " marketcap ": " $17 594 884 170 ",
    "price (USD)": "227.495",
    "country": "Germany"
  },
  {
    "Rank": "1062",
    "Name": "Lennox",
    "Symbol": "LII",
    " marketcap ": " $17 575 348 224 ",
    "price (USD)": "493.35",
    "country": "United States"
  },
  {
    "Rank": "1063",
    "Name": "Essex Property Trust",
    "Symbol": "ESS",
    " marketcap ": " $17 558 161 408 ",
    "price (USD)": "264.16",
    "country": "United States"
  },
  {
    "Rank": "1064",
    "Name": "Baxter",
    "Symbol": "BAX",
    " marketcap ": " $17 555 032 064 ",
    "price (USD)": "34.45",
    "country": "United States"
  },
  {
    "Rank": "1065",
    "Name": "Kingspan Group",
    "Symbol": "KRX.IR",
    " marketcap ": " $17 537 220 371 ",
    "price (USD)": "95.9388",
    "country": "Ireland"
  },
  {
    "Rank": "1066",
    "Name": "Volvo Car",
    "Symbol": "VOLCAR-B.ST",
    " marketcap ": " $17 508 818 584 ",
    "price (USD)": "2.93819",
    "country": "Sweden"
  },
  {
    "Rank": "1067",
    "Name": "Anhui Conch Cement",
    "Symbol": "AHCHF",
    " marketcap ": " $17 493 762 048 ",
    "price (USD)": "\u0444\u0435\u0432.72",
    "country": "China"
  },
  {
    "Rank": "1068",
    "Name": "Arca Continental",
    "Symbol": "AC.MX",
    " marketcap ": " $17 473 942 345 ",
    "price (USD)": "10.0355",
    "country": "Mexico"
  },
  {
    "Rank": "1069",
    "Name": "Dassault Aviation",
    "Symbol": "AM.PA",
    " marketcap ": " $17 469 106 413 ",
    "price (USD)": "221.305",
    "country": "France"
  },
  {
    "Rank": "1070",
    "Name": "Astellas Pharma",
    "Symbol": "4503.T",
    " marketcap ": " $17 459 525 183 ",
    "price (USD)": "9.73706",
    "country": "Japan"
  },
  {
    "Rank": "1071",
    "Name": "WuXi AppTec",
    "Symbol": "2359.HK",
    " marketcap ": " $17 450 407 679 ",
    "price (USD)": "4.99748",
    "country": "China"
  },
  {
    "Rank": "1072",
    "Name": "United Airlines Holdings",
    "Symbol": "UAL",
    " marketcap ": " $17 436 422 144 ",
    "price (USD)": "53.03",
    "country": "United States"
  },
  {
    "Rank": "1073",
    "Name": "Hologic",
    "Symbol": "HOLX",
    " marketcap ": " $17 398 255 616 ",
    "price (USD)": "74.55",
    "country": "United States"
  },
  {
    "Rank": "1074",
    "Name": "Tourmaline Oil",
    "Symbol": "TOU.TO",
    " marketcap ": " $17 395 186 017 ",
    "price (USD)": "49.4666",
    "country": "Canada"
  },
  {
    "Rank": "1075",
    "Name": "Jacobs Engineering",
    "Symbol": "J",
    " marketcap ": " $17 378 312 192 ",
    "price (USD)": "138.79",
    "country": "United States"
  },
  {
    "Rank": "1076",
    "Name": "Nomura Holdings",
    "Symbol": "NMR",
    " marketcap ": " $17 373 689 856 ",
    "price (USD)": "\u043c\u0430\u0439.83",
    "country": "Japan"
  },
  {
    "Rank": "1077",
    "Name": "Poste Italiane",
    "Symbol": "PST.MI",
    " marketcap ": " $17 365 319 805 ",
    "price (USD)": "13.3565",
    "country": "Italy"
  },
  {
    "Rank": "1078",
    "Name": "VeriSign",
    "Symbol": "VRSN",
    " marketcap ": " $17 352 312 832 ",
    "price (USD)": "174.22",
    "country": "United States"
  },
  {
    "Rank": "1079",
    "Name": "PBBank (Public Bank Bhd)",
    "Symbol": "1295.KL",
    " marketcap ": " $17 328 397 009 ",
    "price (USD)": "0.892724",
    "country": "Malaysia"
  },
  {
    "Rank": "1080",
    "Name": "Standard Bank Group",
    "Symbol": "SBK.JO",
    " marketcap ": " $17 311 396 600 ",
    "price (USD)": "\u043e\u043a\u0442.66",
    "country": "South Africa"
  },
  {
    "Rank": "1081",
    "Name": "NRG Energy",
    "Symbol": "NRG",
    " marketcap ": " $17 309 761 536 ",
    "price (USD)": "83.03",
    "country": "United States"
  },
  {
    "Rank": "1082",
    "Name": "LabCorp",
    "Symbol": "LH",
    " marketcap ": " $17 308 848 128 ",
    "price (USD)": "205.34",
    "country": "United States"
  },
  {
    "Rank": "1083",
    "Name": "Northern Trust",
    "Symbol": "NTRS",
    " marketcap ": " $17 308 483 584 ",
    "price (USD)": "84.6",
    "country": "United States"
  },
  {
    "Rank": "1084",
    "Name": "Aluminum Corporation of China",
    "Symbol": "601600.SS",
    " marketcap ": " $17 278 757 007 ",
    "price (USD)": "1.09403",
    "country": "China"
  },
  {
    "Rank": "1085",
    "Name": "Reliance Steel &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1086",
    "Name": "Bank of Beijing",
    "Symbol": "601169.SS",
    " marketcap ": " $17 202 251 718 ",
    "price (USD)": "0.813615",
    "country": "China"
  },
  {
    "Rank": "1087",
    "Name": "SGS",
    "Symbol": "SGSN.SW",
    " marketcap ": " $17 192 938 763 ",
    "price (USD)": "89.3878",
    "country": "Switzerland"
  },
  {
    "Rank": "1088",
    "Name": "Abiomed",
    "Symbol": "ABMD",
    " marketcap ": " $17 180 649 472 ",
    "price (USD)": "381.02",
    "country": "United States"
  },
  {
    "Rank": "1089",
    "Name": "SBI Life Insurance",
    "Symbol": "SBILIFE.NS",
    " marketcap ": " $17 179 762 170 ",
    "price (USD)": "17.1537",
    "country": "India"
  },
  {
    "Rank": "1090",
    "Name": "Tata Power",
    "Symbol": "TATAPOWER.NS",
    " marketcap ": " $17 165 542 636 ",
    "price (USD)": "5.37206",
    "country": "India"
  },
  {
    "Rank": "1091",
    "Name": "Daiwa House",
    "Symbol": "1925.T",
    " marketcap ": " $17 150 880 849 ",
    "price (USD)": "26.8057",
    "country": "Japan"
  },
  {
    "Rank": "1092",
    "Name": "FactSet",
    "Symbol": "FDS",
    " marketcap ": " $17 149 442 048 ",
    "price (USD)": "449.93",
    "country": "United States"
  },
  {
    "Rank": "1093",
    "Name": "Illumina",
    "Symbol": "ILMN",
    " marketcap ": " $17 142 273 024 ",
    "price (USD)": "107.61",
    "country": "United States"
  },
  {
    "Rank": "1094",
    "Name": "Everest Group",
    "Symbol": "EG",
    " marketcap ": " $17 129 484 288 ",
    "price (USD)": "394.16",
    "country": "Bermuda"
  },
  {
    "Rank": "1095",
    "Name": "Kubota",
    "Symbol": "6326.T",
    " marketcap ": " $17 127 450 397 ",
    "price (USD)": "14.5768",
    "country": "Japan"
  },
  {
    "Rank": "1096",
    "Name": "Check Point Software",
    "Symbol": "CHKP",
    " marketcap ": " $17 114 291 200 ",
    "price (USD)": "151.58",
    "country": "Israel"
  },
  {
    "Rank": "1097",
    "Name": "SM Prime Holdings",
    "Symbol": "SPHXF",
    " marketcap ": " $17 088 977 920 ",
    "price (USD)": "0.59174",
    "country": "Philippines"
  },
  {
    "Rank": "1098",
    "Name": "Prysmian Group",
    "Symbol": "PRY.MI",
    " marketcap ": " $17 056 933 348 ",
    "price (USD)": "62.4824",
    "country": "Italy"
  },
  {
    "Rank": "1099",
    "Name": "Okta",
    "Symbol": "OKTA",
    " marketcap ": " $17 052 420 096 ",
    "price (USD)": "101.38",
    "country": "United States"
  },
  {
    "Rank": "1100",
    "Name": "LTIMindtree",
    "Symbol": "LTIM.NS",
    " marketcap ": " $17 032 744 570 ",
    "price (USD)": "57.5114",
    "country": "India"
  },
  {
    "Rank": "1101",
    "Name": "Bentley Systems",
    "Symbol": "BSY",
    " marketcap ": " $17 016 000 512 ",
    "price (USD)": "56.72",
    "country": "United States"
  },
  {
    "Rank": "1102",
    "Name": "Aviva",
    "Symbol": "AV.L",
    " marketcap ": " $16 987 180 615 ",
    "price (USD)": "6.29188",
    "country": "United Kingdom"
  },
  {
    "Rank": "1103",
    "Name": "Celanese",
    "Symbol": "CE",
    " marketcap ": " $16 976 063 488 ",
    "price (USD)": "155.43",
    "country": "United States"
  },
  {
    "Rank": "1104",
    "Name": "Rural Electrification Corp",
    "Symbol": "RECLTD.NS",
    " marketcap ": " $16 956 930 155 ",
    "price (USD)": "6.43962",
    "country": "India"
  },
  {
    "Rank": "1105",
    "Name": "ZTE",
    "Symbol": "000063.SZ",
    " marketcap ": " $16 950 536 102 ",
    "price (USD)": "3.79595",
    "country": "China"
  },
  {
    "Rank": "1106",
    "Name": "Textron",
    "Symbol": "TXT",
    " marketcap ": " $16 937 885 696 ",
    "price (USD)": "88.82",
    "country": "United States"
  },
  {
    "Rank": "1107",
    "Name": "OMV",
    "Symbol": "OMV.F",
    " marketcap ": " $16 930 021 396 ",
    "price (USD)": "51.6886",
    "country": "Austria"
  },
  {
    "Rank": "1108",
    "Name": "EDP Group",
    "Symbol": "EDP.F",
    " marketcap ": " $16 923 119 487 ",
    "price (USD)": "4.0569",
    "country": "Portugal"
  },
  {
    "Rank": "1109",
    "Name": "PTT Exploration and Production",
    "Symbol": "PTTEP.BK",
    " marketcap ": " $16 919 586 844 ",
    "price (USD)": "4.26187",
    "country": "Thailand"
  },
  {
    "Rank": "1110",
    "Name": "Avantor",
    "Symbol": "AVTR",
    " marketcap ": " $16 913 722 368 ",
    "price (USD)": "24.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "1111",
    "Name": "Loews Corporation",
    "Symbol": "L",
    " marketcap ": " $16 873 351 168 ",
    "price (USD)": "76.21",
    "country": "United States"
  },
  {
    "Rank": "1112",
    "Name": "Shandong Gold Mining",
    "Symbol": "600547.SS",
    " marketcap ": " $16 862 839 278 ",
    "price (USD)": "4.12471",
    "country": "China"
  },
  {
    "Rank": "1113",
    "Name": "Formula One Group",
    "Symbol": "FWONK",
    " marketcap ": " $16 847 927 296 ",
    "price (USD)": "72.35",
    "country": "United States"
  },
  {
    "Rank": "1114",
    "Name": "Advanced Info Service (AIS)",
    "Symbol": "ADVANC.BK",
    " marketcap ": " $16 845 226 574 ",
    "price (USD)": "5.66416",
    "country": "Thailand"
  },
  {
    "Rank": "1115",
    "Name": "Fresenius",
    "Symbol": "FRE.DE",
    " marketcap ": " $16 801 085 686 ",
    "price (USD)": "29.8295",
    "country": "Germany"
  },
  {
    "Rank": "1116",
    "Name": "Terna",
    "Symbol": "TRN.MI",
    " marketcap ": " $16 788 436 078 ",
    "price (USD)": "\u0430\u0432\u0433.79",
    "country": "Italy"
  },
  {
    "Rank": "1117",
    "Name": "Southwest Airlines",
    "Symbol": "LUV",
    " marketcap ": " $16 738 813 952 ",
    "price (USD)": "27.97",
    "country": "United States"
  },
  {
    "Rank": "1118",
    "Name": "Novolipetsk Steel",
    "Symbol": "NLMK.ME",
    " marketcap ": " $16 731 067 607 ",
    "price (USD)": "\u0444\u0435\u0432.79",
    "country": "Russia"
  },
  {
    "Rank": "1119",
    "Name": "Galp Energia",
    "Symbol": "GZ5.F",
    " marketcap ": " $16 724 839 996 ",
    "price (USD)": "21.403",
    "country": "Portugal"
  },
  {
    "Rank": "1120",
    "Name": "Nippon Paint",
    "Symbol": "4612.T",
    " marketcap ": " $16 701 014 839 ",
    "price (USD)": "7.11087",
    "country": "Japan"
  },
  {
    "Rank": "1121",
    "Name": "Clorox",
    "Symbol": "CLX",
    " marketcap ": " $16 685 899 776 ",
    "price (USD)": "134.36",
    "country": "United States"
  },
  {
    "Rank": "1122",
    "Name": "Punjab National Bank",
    "Symbol": "PNB.NS",
    " marketcap ": " $16 656 674 205 ",
    "price (USD)": "1.51273",
    "country": "India"
  },
  {
    "Rank": "1123",
    "Name": "Citizens Financial Group",
    "Symbol": "CFG",
    " marketcap ": " $16 640 080 896 ",
    "price (USD)": "36.57",
    "country": "United States"
  },
  {
    "Rank": "1124",
    "Name": "Kyocera",
    "Symbol": "6971.T",
    " marketcap ": " $16 631 342 326 ",
    "price (USD)": "\u043d\u043e\u044f.67",
    "country": "Japan"
  },
  {
    "Rank": "1125",
    "Name": "REA Group",
    "Symbol": "REA.AX",
    " marketcap ": " $16 630 913 133 ",
    "price (USD)": "125.88",
    "country": "Australia"
  },
  {
    "Rank": "1126",
    "Name": "Expeditors",
    "Symbol": "EXPD",
    " marketcap ": " $16 628 186 112 ",
    "price (USD)": "117.72",
    "country": "United States"
  },
  {
    "Rank": "1127",
    "Name": "Henderson Land Development",
    "Symbol": "0012.HK",
    " marketcap ": " $16 626 142 744 ",
    "price (USD)": "3.43417",
    "country": "Hong Kong"
  },
  {
    "Rank": "1128",
    "Name": "Huaneng Power",
    "Symbol": "600011.SS",
    " marketcap ": " $16 614 079 403 ",
    "price (USD)": "1.23078",
    "country": "China"
  },
  {
    "Rank": "1129",
    "Name": "Santos",
    "Symbol": "STO.AX",
    " marketcap ": " $16 588 817 753 ",
    "price (USD)": "5.10776",
    "country": "Australia"
  },
  {
    "Rank": "1130",
    "Name": "Zebra Technologies",
    "Symbol": "ZBRA",
    " marketcap ": " $16 545 734 656 ",
    "price (USD)": "321.78",
    "country": "United States"
  },
  {
    "Rank": "1131",
    "Name": "Centrais Electricas Brasileiras",
    "Symbol": "EBR",
    " marketcap ": " $16 540 807 168 ",
    "price (USD)": "\u0438\u044e\u043b.35",
    "country": "Brazil"
  },
  {
    "Rank": "1132",
    "Name": "Sumitomo Mitsui Trust Holdings",
    "Symbol": "8309.T",
    " marketcap ": " $16 535 106 581 ",
    "price (USD)": "22.9416",
    "country": "Japan"
  },
  {
    "Rank": "1133",
    "Name": "Bharat Petroleum",
    "Symbol": "BPCL.NS",
    " marketcap ": " $16 533 862 412 ",
    "price (USD)": "7.62193",
    "country": "India"
  },
  {
    "Rank": "1134",
    "Name": "AIER Eye Hospital",
    "Symbol": "300015.SZ",
    " marketcap ": " $16 519 581 657 ",
    "price (USD)": "1.77089",
    "country": "China"
  },
  {
    "Rank": "1135",
    "Name": "Telenor",
    "Symbol": "TEL.OL",
    " marketcap ": " $16 514 464 451 ",
    "price (USD)": "\u043d\u043e\u044f.35",
    "country": "Norway"
  },
  {
    "Rank": "1136",
    "Name": "Neste",
    "Symbol": "NESTE.HE",
    " marketcap ": " $16 504 672 768 ",
    "price (USD)": "21.4844",
    "country": "Finland"
  },
  {
    "Rank": "1137",
    "Name": "J. B. Hunt",
    "Symbol": "JBHT",
    " marketcap ": " $16 445 473 792 ",
    "price (USD)": "159.36",
    "country": "United States"
  },
  {
    "Rank": "1138",
    "Name": "IDEX",
    "Symbol": "IEX",
    " marketcap ": " $16 434 984 960 ",
    "price (USD)": "217.12",
    "country": "United States"
  },
  {
    "Rank": "1139",
    "Name": "Bank of Baroda",
    "Symbol": "BANKBARODA.NS",
    " marketcap ": " $16 431 761 782 ",
    "price (USD)": "3.17745",
    "country": "India"
  },
  {
    "Rank": "1140",
    "Name": "BT Group",
    "Symbol": "BT-A.L",
    " marketcap ": " $16 429 309 758 ",
    "price (USD)": "1.65084",
    "country": "United Kingdom"
  },
  {
    "Rank": "1141",
    "Name": "EDP Renov\u0413\u040eveis",
    "Symbol": "EDPR.LS",
    " marketcap ": " $16 421 471 795 ",
    "price (USD)": "15.5717",
    "country": "Spain"
  },
  {
    "Rank": "1142",
    "Name": "Warner Music Group",
    "Symbol": "WMG",
    " marketcap ": " $16 412 694 528 ",
    "price (USD)": "31.69",
    "country": "United States"
  },
  {
    "Rank": "1143",
    "Name": "Huatai Securities",
    "Symbol": "601688.SS",
    " marketcap ": " $16 383 775 943 ",
    "price (USD)": "1.94218",
    "country": "China"
  },
  {
    "Rank": "1144",
    "Name": "Mid-America Apartment Communities",
    "Symbol": "MAA",
    " marketcap ": " $16 374 403 072 ",
    "price (USD)": "136.5",
    "country": "United States"
  },
  {
    "Rank": "1145",
    "Name": "Packaging Corporation of America",
    "Symbol": "PKG",
    " marketcap ": " $16 329 766 912 ",
    "price (USD)": "181.85",
    "country": "United States"
  },
  {
    "Rank": "1146",
    "Name": "Snam",
    "Symbol": "SRG.MI",
    " marketcap ": " $16 319 116 273 ",
    "price (USD)": "4.80508",
    "country": "Italy"
  },
  {
    "Rank": "1147",
    "Name": "InterContinental Hotels Group",
    "Symbol": "IHG",
    " marketcap ": " $16 306 028 544 ",
    "price (USD)": "100.28",
    "country": "United Kingdom"
  },
  {
    "Rank": "1148",
    "Name": "Royalty Pharma",
    "Symbol": "RPRX",
    " marketcap ": " $16 232 363 008 ",
    "price (USD)": "27.17",
    "country": "United Kingdom"
  },
  {
    "Rank": "1149",
    "Name": "Porsche SE",
    "Symbol": "PAH3.DE",
    " marketcap ": " $16 165 502 930 ",
    "price (USD)": "52.7853",
    "country": "Germany"
  },
  {
    "Rank": "1150",
    "Name": "China Merchants Securities",
    "Symbol": "600999.SS",
    " marketcap ": " $16 141 590 671 ",
    "price (USD)": "2.02368",
    "country": "China"
  },
  {
    "Rank": "1151",
    "Name": "Godrej",
    "Symbol": "GODREJCP.NS",
    " marketcap ": " $16 077 150 644 ",
    "price (USD)": "15.7185",
    "country": "India"
  },
  {
    "Rank": "1152",
    "Name": "Abu Dhabi Commercial Bank (ADCB)",
    "Symbol": "ADCB.AE",
    " marketcap ": " $16 064 141 613 ",
    "price (USD)": "\u0444\u0435\u0432.19",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1153",
    "Name": "Subaru",
    "Symbol": "7270.T",
    " marketcap ": " $16 049 772 056 ",
    "price (USD)": "21.3486",
    "country": "Japan"
  },
  {
    "Rank": "1154",
    "Name": "Guotai Junan Securities",
    "Symbol": "601211.SS",
    " marketcap ": " $16 032 333 451 ",
    "price (USD)": "1.92284",
    "country": "China"
  },
  {
    "Rank": "1155",
    "Name": "China Longyuan Power Group",
    "Symbol": "0916.HK",
    " marketcap ": " $15 994 759 990 ",
    "price (USD)": "0.882888",
    "country": "China"
  },
  {
    "Rank": "1156",
    "Name": "Carlyle Group",
    "Symbol": "CG",
    " marketcap ": " $15 975 116 800 ",
    "price (USD)": "44.39",
    "country": "United States"
  },
  {
    "Rank": "1157",
    "Name": "Sun Communities",
    "Symbol": "SUI",
    " marketcap ": " $15 953 231 872 ",
    "price (USD)": "122.72",
    "country": "United States"
  },
  {
    "Rank": "1158",
    "Name": "Quest Diagnostics",
    "Symbol": "DGX",
    " marketcap ": " $15 923 927 040 ",
    "price (USD)": "143.34",
    "country": "United States"
  },
  {
    "Rank": "1159",
    "Name": "GAIL",
    "Symbol": "GAIL.NS",
    " marketcap ": " $15 863 555 263 ",
    "price (USD)": "2.41268",
    "country": "India"
  },
  {
    "Rank": "1160",
    "Name": "Symrise",
    "Symbol": "SY1.DE",
    " marketcap ": " $15 860 760 352 ",
    "price (USD)": "113.476",
    "country": "Germany"
  },
  {
    "Rank": "1161",
    "Name": "Brookfield Asset Management",
    "Symbol": "BAM",
    " marketcap ": " $15 852 145 664 ",
    "price (USD)": "40.5",
    "country": "Canada"
  },
  {
    "Rank": "1162",
    "Name": "China Railway Construction",
    "Symbol": "601186.SS",
    " marketcap ": " $15 841 957 405 ",
    "price (USD)": "\u044f\u043d\u0432.46",
    "country": "China"
  },
  {
    "Rank": "1163",
    "Name": "Amundi",
    "Symbol": "AMUN.PA",
    " marketcap ": " $15 835 582 339 ",
    "price (USD)": "76.2841",
    "country": "France"
  },
  {
    "Rank": "1164",
    "Name": "TPG Capital",
    "Symbol": "TPG",
    " marketcap ": " $15 834 535 936 ",
    "price (USD)": "43.41",
    "country": "United States"
  },
  {
    "Rank": "1165",
    "Name": "Tenaga Nasional",
    "Symbol": "TNABY",
    " marketcap ": " $15 781 920 768 ",
    "price (USD)": "\u043e\u043a\u0442.51",
    "country": "Malaysia"
  },
  {
    "Rank": "1166",
    "Name": "Best Buy",
    "Symbol": "BBY",
    " marketcap ": " $15 722 299 392 ",
    "price (USD)": "72.67",
    "country": "United States"
  },
  {
    "Rank": "1167",
    "Name": "CK Asset Holdings",
    "Symbol": "1113.HK",
    " marketcap ": " $15 700 803 746 ",
    "price (USD)": "4.47211",
    "country": "Hong Kong"
  },
  {
    "Rank": "1168",
    "Name": "Gen Digital",
    "Symbol": "GEN",
    " marketcap ": " $15 684 956 160 ",
    "price (USD)": "25.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "1169",
    "Name": "SS&C Technologies",
    "Symbol": "SSNC",
    " marketcap ": " $15 662 966 784 ",
    "price (USD)": "63.33",
    "country": "United States"
  },
  {
    "Rank": "1170",
    "Name": "Tech Mahindra",
    "Symbol": "TECHM.NS",
    " marketcap ": " $15 639 093 254 ",
    "price (USD)": "16.002",
    "country": "India"
  },
  {
    "Rank": "1171",
    "Name": "SEGRO",
    "Symbol": "SGRO.L",
    " marketcap ": " $15 605 188 746 ",
    "price (USD)": "\u043d\u043e\u044f.89",
    "country": "United Kingdom"
  },
  {
    "Rank": "1172",
    "Name": "CIMB Group",
    "Symbol": "1023.KL",
    " marketcap ": " $15 565 499 902 ",
    "price (USD)": "1.45733",
    "country": "Malaysia"
  },
  {
    "Rank": "1173",
    "Name": "Aker BP",
    "Symbol": "AKRBP.OL",
    " marketcap ": " $15 563 728 704 ",
    "price (USD)": "24.6537",
    "country": "Norway"
  },
  {
    "Rank": "1174",
    "Name": "Nomura Research Institute",
    "Symbol": "4307.T",
    " marketcap ": " $15 561 829 675 ",
    "price (USD)": "27.004",
    "country": "Japan"
  },
  {
    "Rank": "1175",
    "Name": "Owens Corning",
    "Symbol": "OC",
    " marketcap ": " $15 469 050 880 ",
    "price (USD)": "178.51",
    "country": "United States"
  },
  {
    "Rank": "1176",
    "Name": "Lodha Group",
    "Symbol": "LODHA.NS",
    " marketcap ": " $15 451 721 093 ",
    "price (USD)": "15.5352",
    "country": "India"
  },
  {
    "Rank": "1177",
    "Name": "Bank of Shanghai",
    "Symbol": "601229.SS",
    " marketcap ": " $15 444 411 220 ",
    "price (USD)": "1.08712",
    "country": "China"
  },
  {
    "Rank": "1178",
    "Name": "VAT Group",
    "Symbol": "VACN.SW",
    " marketcap ": " $15 435 394 024 ",
    "price (USD)": "514.863",
    "country": "Switzerland"
  },
  {
    "Rank": "1179",
    "Name": "Dick's Sporting Goods",
    "Symbol": "DKS",
    " marketcap ": " $15 419 401 216 ",
    "price (USD)": "188.51",
    "country": "United States"
  },
  {
    "Rank": "1180",
    "Name": "Eicher Motors",
    "Symbol": "EICHERMOT.NS",
    " marketcap ": " $15 418 656 622 ",
    "price (USD)": "56.3093",
    "country": "India"
  },
  {
    "Rank": "1181",
    "Name": "Air China",
    "Symbol": "601111.SS",
    " marketcap ": " $15 399 435 733 ",
    "price (USD)": "1.07607",
    "country": "China"
  },
  {
    "Rank": "1182",
    "Name": "Masco",
    "Symbol": "MAS",
    " marketcap ": " $15 395 055 616 ",
    "price (USD)": "69.9",
    "country": "United States"
  },
  {
    "Rank": "1183",
    "Name": "Hua Xia Bank",
    "Symbol": "600015.SS",
    " marketcap ": " $15 388 822 446 ",
    "price (USD)": "0.966944",
    "country": "China"
  },
  {
    "Rank": "1184",
    "Name": "Hong Kong and China Gas",
    "Symbol": "0003.HK",
    " marketcap ": " $15 374 709 044 ",
    "price (USD)": "0.823944",
    "country": "Hong Kong"
  },
  {
    "Rank": "1185",
    "Name": "CK Infrastructure",
    "Symbol": "1038.HK",
    " marketcap ": " $15 368 338 248 ",
    "price (USD)": "6.09949",
    "country": "Hong Kong"
  },
  {
    "Rank": "1186",
    "Name": "AMH (American Homes 4 Rent)",
    "Symbol": "AMH",
    " marketcap ": " $15 337 908 224 ",
    "price (USD)": "36.72",
    "country": "United States"
  },
  {
    "Rank": "1187",
    "Name": "Britannia Industries",
    "Symbol": "BRITANNIA.NS",
    " marketcap ": " $15 216 801 924 ",
    "price (USD)": "63.1382",
    "country": "India"
  },
  {
    "Rank": "1188",
    "Name": "Hyatt Hotels",
    "Symbol": "H",
    " marketcap ": " $15 207 804 928 ",
    "price (USD)": "150.3",
    "country": "United States"
  },
  {
    "Rank": "1189",
    "Name": "Hyundai Mobis",
    "Symbol": "012330.KS",
    " marketcap ": " $15 203 484 520 ",
    "price (USD)": "168.911",
    "country": "South Korea"
  },
  {
    "Rank": "1190",
    "Name": "Industrivarden",
    "Symbol": "INDU-A.ST",
    " marketcap ": " $15 173 484 574 ",
    "price (USD)": "35.1197",
    "country": "Sweden"
  },
  {
    "Rank": "1191",
    "Name": "Enphase Energy",
    "Symbol": "ENPH",
    " marketcap ": " $15 171 024 896 ",
    "price (USD)": "111.5",
    "country": "United States"
  },
  {
    "Rank": "1192",
    "Name": "News Corp",
    "Symbol": "NWS",
    " marketcap ": " $15 128 708 096 ",
    "price (USD)": "27.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "1193",
    "Name": "Renault",
    "Symbol": "RNO.PA",
    " marketcap ": " $15 120 681 559 ",
    "price (USD)": "51.5148",
    "country": "France"
  },
  {
    "Rank": "1194",
    "Name": "Indian Overseas Bank",
    "Symbol": "IOB.NS",
    " marketcap ": " $15 116 983 286 ",
    "price (USD)": "0.79962",
    "country": "India"
  },
  {
    "Rank": "1195",
    "Name": "ENEOS Holdings",
    "Symbol": "5020.T",
    " marketcap ": " $15 076 436 453 ",
    "price (USD)": "5.05534",
    "country": "Japan"
  },
  {
    "Rank": "1196",
    "Name": "Sandoz Group",
    "Symbol": "SDZ.SW",
    " marketcap ": " $15 068 343 549 ",
    "price (USD)": "35.0484",
    "country": "Switzerland"
  },
  {
    "Rank": "1197",
    "Name": "Sumitomo Realty &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1198",
    "Name": "Gold Fields",
    "Symbol": "GFI",
    " marketcap ": " $15 044 313 088 ",
    "price (USD)": "16.56",
    "country": "South Africa"
  },
  {
    "Rank": "1199",
    "Name": "Next plc",
    "Symbol": "NXT.L",
    " marketcap ": " $15 025 207 186 ",
    "price (USD)": "118.26",
    "country": "United Kingdom"
  },
  {
    "Rank": "1200",
    "Name": "UDR Apartments",
    "Symbol": "UDR",
    " marketcap ": " $14 961 463 296 ",
    "price (USD)": "39.69",
    "country": "United States"
  },
  {
    "Rank": "1201",
    "Name": "AES",
    "Symbol": "AES",
    " marketcap ": " $14 952 434 688 ",
    "price (USD)": "21.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "1202",
    "Name": "Leonardo",
    "Symbol": "LDO.MI",
    " marketcap ": " $14 926 167 150 ",
    "price (USD)": "25.7248",
    "country": "Italy"
  },
  {
    "Rank": "1203",
    "Name": "Singapore Airlines",
    "Symbol": "C6L.SI",
    " marketcap ": " $14 924 998 992 ",
    "price (USD)": "5.01875",
    "country": "Singapore"
  },
  {
    "Rank": "1204",
    "Name": "Yum China",
    "Symbol": "YUMC",
    " marketcap ": " $14 902 300 672 ",
    "price (USD)": "38.3",
    "country": "China"
  },
  {
    "Rank": "1205",
    "Name": "POSCO Chemical",
    "Symbol": "003670.KS",
    " marketcap ": " $14 899 495 594 ",
    "price (USD)": "192.412",
    "country": "South Korea"
  },
  {
    "Rank": "1206",
    "Name": "Pan Pacific International Holdings",
    "Symbol": "7532.T",
    " marketcap ": " $14 892 306 746 ",
    "price (USD)": "24.9504",
    "country": "Japan"
  },
  {
    "Rank": "1207",
    "Name": "Albemarle",
    "Symbol": "ALB",
    " marketcap ": " $14 883 618 816 ",
    "price (USD)": "126.64",
    "country": "United States"
  },
  {
    "Rank": "1208",
    "Name": "TransUnion",
    "Symbol": "TRU",
    " marketcap ": " $14 881 825 792 ",
    "price (USD)": "76.62",
    "country": "United States"
  },
  {
    "Rank": "1209",
    "Name": "Yandex",
    "Symbol": "YNDX.ME",
    " marketcap ": " $14 849 420 492 ",
    "price (USD)": "46.62",
    "country": "Netherlands"
  },
  {
    "Rank": "1210",
    "Name": "Resona Holdings",
    "Symbol": "8308.T",
    " marketcap ": " $14 842 841 342 ",
    "price (USD)": "6.37067",
    "country": "Japan"
  },
  {
    "Rank": "1211",
    "Name": "Skyworks Solutions",
    "Symbol": "SWKS",
    " marketcap ": " $14 833 325 056 ",
    "price (USD)": "92.45",
    "country": "United States"
  },
  {
    "Rank": "1212",
    "Name": "Marathon Oil",
    "Symbol": "MRO",
    " marketcap ": " $14 828 506 112 ",
    "price (USD)": "26.29",
    "country": "United States"
  },
  {
    "Rank": "1213",
    "Name": "Sekisui House",
    "Symbol": "1928.T",
    " marketcap ": " $14 823 573 397 ",
    "price (USD)": "22.8776",
    "country": "Japan"
  },
  {
    "Rank": "1214",
    "Name": "Shimano",
    "Symbol": "7309.T",
    " marketcap ": " $14 813 982 190 ",
    "price (USD)": "165.025",
    "country": "Japan"
  },
  {
    "Rank": "1215",
    "Name": "Expedia Group",
    "Symbol": "EXPE",
    " marketcap ": " $14 798 334 976 ",
    "price (USD)": "111.71",
    "country": "United States"
  },
  {
    "Rank": "1216",
    "Name": "Vanke",
    "Symbol": "2202.HK",
    " marketcap ": " $14 761 356 410 ",
    "price (USD)": "0.895703",
    "country": "China"
  },
  {
    "Rank": "1217",
    "Name": "Fox Corporation",
    "Symbol": "FOX",
    " marketcap ": " $14 759 564 288 ",
    "price (USD)": "30.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "1218",
    "Name": "Kerry Group",
    "Symbol": "KRZ.IR",
    " marketcap ": " $14 759 317 085 ",
    "price (USD)": "85.1884",
    "country": "Ireland"
  },
  {
    "Rank": "1219",
    "Name": "Kakao",
    "Symbol": "035720.KS",
    " marketcap ": " $14 752 863 142 ",
    "price (USD)": "33.6354",
    "country": "South Korea"
  },
  {
    "Rank": "1220",
    "Name": "Telefonica Brasil",
    "Symbol": "VIV",
    " marketcap ": " $14 748 656 640 ",
    "price (USD)": "\u0430\u0432\u0433.84",
    "country": "Brazil"
  },
  {
    "Rank": "1221",
    "Name": "Toast",
    "Symbol": "TOST",
    " marketcap ": " $14 728 474 624 ",
    "price (USD)": "26.53",
    "country": "United States"
  },
  {
    "Rank": "1222",
    "Name": "Conagra Brands",
    "Symbol": "CAG",
    " marketcap ": " $14 719 560 704 ",
    "price (USD)": "30.79",
    "country": "United States"
  },
  {
    "Rank": "1223",
    "Name": "Grab Holdings",
    "Symbol": "GRAB",
    " marketcap ": " $14 705 160 192 ",
    "price (USD)": "\u043c\u0430\u0440.72",
    "country": "Singapore"
  },
  {
    "Rank": "1224",
    "Name": "Kongsberg Gruppen",
    "Symbol": "KOG.OL",
    " marketcap ": " $14 697 622 245 ",
    "price (USD)": "83.5862",
    "country": "Norway"
  },
  {
    "Rank": "1225",
    "Name": "BioMarin Pharmaceutical",
    "Symbol": "BMRN",
    " marketcap ": " $14 685 318 144 ",
    "price (USD)": "77.34",
    "country": "United States"
  },
  {
    "Rank": "1226",
    "Name": "Capitec Bank",
    "Symbol": "CPI.JO",
    " marketcap ": " $14 680 473 700 ",
    "price (USD)": "126.171",
    "country": "South Africa"
  },
  {
    "Rank": "1227",
    "Name": "Western Midstream",
    "Symbol": "WES",
    " marketcap ": " $14 664 123 392 ",
    "price (USD)": "38.54",
    "country": "United States"
  },
  {
    "Rank": "1228",
    "Name": "KPN",
    "Symbol": "KPN.AS",
    " marketcap ": " $14 656 792 546 ",
    "price (USD)": "3.72896",
    "country": "Netherlands"
  },
  {
    "Rank": "1229",
    "Name": "CP All",
    "Symbol": "CPALL.BK",
    " marketcap ": " $14 634 517 702 ",
    "price (USD)": "1.62913",
    "country": "Thailand"
  },
  {
    "Rank": "1230",
    "Name": "Bunge",
    "Symbol": "BG",
    " marketcap ": " $14 628 179 968 ",
    "price (USD)": "103.31",
    "country": "United States"
  },
  {
    "Rank": "1231",
    "Name": "China Resources Beer",
    "Symbol": "0291.HK",
    " marketcap ": " $14 590 647 623 ",
    "price (USD)": "4.49773",
    "country": "Hong Kong"
  },
  {
    "Rank": "1232",
    "Name": "Bouygues",
    "Symbol": "EN.PA",
    " marketcap ": " $14 584 301 931 ",
    "price (USD)": "38.3755",
    "country": "France"
  },
  {
    "Rank": "1233",
    "Name": "Snap-on",
    "Symbol": "SNA",
    " marketcap ": " $14 555 578 368 ",
    "price (USD)": "276.1",
    "country": "United States"
  },
  {
    "Rank": "1234",
    "Name": "Amcor",
    "Symbol": "AMCR",
    " marketcap ": " $14 554 573 824 ",
    "price (USD)": "10.\u0438\u044e\u043b",
    "country": "Switzerland"
  },
  {
    "Rank": "1235",
    "Name": "Wilmar International",
    "Symbol": "F34.SI",
    " marketcap ": " $14 553 006 351 ",
    "price (USD)": "2.33119",
    "country": "Singapore"
  },
  {
    "Rank": "1236",
    "Name": "Nexon",
    "Symbol": "3659.T",
    " marketcap ": " $14 550 813 492 ",
    "price (USD)": "17.3405",
    "country": "Japan"
  },
  {
    "Rank": "1237",
    "Name": "International Paper",
    "Symbol": "IP",
    " marketcap ": " $14 549 737 472 ",
    "price (USD)": "41.89",
    "country": "United States"
  },
  {
    "Rank": "1238",
    "Name": "HDFC Life",
    "Symbol": "HDFCLIFE.NS",
    " marketcap ": " $14 532 454 777 ",
    "price (USD)": "6.75802",
    "country": "India"
  },
  {
    "Rank": "1239",
    "Name": "RPM International",
    "Symbol": "RPM",
    " marketcap ": " $14 516 740 096 ",
    "price (USD)": "112.74",
    "country": "United States"
  },
  {
    "Rank": "1240",
    "Name": "Cipla",
    "Symbol": "CIPLA.NS",
    " marketcap ": " $14 461 205 920 ",
    "price (USD)": "17.8986",
    "country": "India"
  },
  {
    "Rank": "1241",
    "Name": "KeyCorp (KeyBank)",
    "Symbol": "KEY",
    " marketcap ": " $14 444 615 680 ",
    "price (USD)": "15.32",
    "country": "United States"
  },
  {
    "Rank": "1242",
    "Name": "Grupo Elektra",
    "Symbol": "XEKT.MC",
    " marketcap ": " $14 442 371 906 ",
    "price (USD)": "62.9819",
    "country": "Mexico"
  },
  {
    "Rank": "1243",
    "Name": "Informa plc",
    "Symbol": "INF.L",
    " marketcap ": " $14 436 395 143 ",
    "price (USD)": "\u043e\u043a\u0442.39",
    "country": "United Kingdom"
  },
  {
    "Rank": "1244",
    "Name": "Fidelity National Financial",
    "Symbol": "FNF",
    " marketcap ": " $14 435 165 184 ",
    "price (USD)": "52.83",
    "country": "United States"
  },
  {
    "Rank": "1245",
    "Name": "Coles Group",
    "Symbol": "COL.AX",
    " marketcap ": " $14 415 234 909 ",
    "price (USD)": "\u043e\u043a\u0442.23",
    "country": "Australia"
  },
  {
    "Rank": "1246",
    "Name": "Adani Energy Solutions",
    "Symbol": "ADANIENSOL.NS",
    " marketcap ": " $14 408 206 699 ",
    "price (USD)": "\u0434\u0435\u043a.65",
    "country": "India"
  },
  {
    "Rank": "1247",
    "Name": "CNH Industrial",
    "Symbol": "CNHI",
    " marketcap ": " $14 398 145 536 ",
    "price (USD)": "\u043d\u043e\u044f.45",
    "country": "United Kingdom"
  },
  {
    "Rank": "1248",
    "Name": "Akamai",
    "Symbol": "AKAM",
    " marketcap ": " $14 393 955 328 ",
    "price (USD)": "94.5",
    "country": "United States"
  },
  {
    "Rank": "1249",
    "Name": "Walgreens Boots Alliance",
    "Symbol": "WBA",
    " marketcap ": " $14 390 053 888 ",
    "price (USD)": "16.68",
    "country": "United States"
  },
  {
    "Rank": "1250",
    "Name": "CF Industries",
    "Symbol": "CF",
    " marketcap ": " $14 363 010 048 ",
    "price (USD)": "78.58",
    "country": "United States"
  },
  {
    "Rank": "1251",
    "Name": "Bank of Nanjing",
    "Symbol": "601009.SS",
    " marketcap ": " $14 359 702 517 ",
    "price (USD)": "1.38826",
    "country": "China"
  },
  {
    "Rank": "1252",
    "Name": "Dynatrace",
    "Symbol": "DT",
    " marketcap ": " $14 340 343 808 ",
    "price (USD)": "48.29",
    "country": "United States"
  },
  {
    "Rank": "1253",
    "Name": "Almarai",
    "Symbol": "2280.SR",
    " marketcap ": " $14 323 782 939 ",
    "price (USD)": "14.4104",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "1254",
    "Name": "Nippon Y\u0415\u00absen",
    "Symbol": "9101.T",
    " marketcap ": " $14 319 668 592 ",
    "price (USD)": "31.188",
    "country": "Japan"
  },
  {
    "Rank": "1255",
    "Name": "Fortum",
    "Symbol": "FORTUM.HE",
    " marketcap ": " $14 264 247 723 ",
    "price (USD)": "15.8975",
    "country": "Finland"
  },
  {
    "Rank": "1256",
    "Name": "Jer\u0413\u0456nimo Martins",
    "Symbol": "JEM.F",
    " marketcap ": " $14 263 159 118 ",
    "price (USD)": "22.4563",
    "country": "Portugal"
  },
  {
    "Rank": "1257",
    "Name": "Saudi Arabian Fertilizer Company",
    "Symbol": "2020.SR",
    " marketcap ": " $14 253 229 604 ",
    "price (USD)": "29.9416",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "1258",
    "Name": "ABN AMRO",
    "Symbol": "ABN.AS",
    " marketcap ": " $14 233 930 251 ",
    "price (USD)": "17.0865",
    "country": "Netherlands"
  },
  {
    "Rank": "1259",
    "Name": "POOLCORP",
    "Symbol": "POOL",
    " marketcap ": " $14 225 351 680 ",
    "price (USD)": "371.14",
    "country": "United States"
  },
  {
    "Rank": "1260",
    "Name": "Texas Pacific Land Trust",
    "Symbol": "TPL",
    " marketcap ": " $14 214 133 760 ",
    "price (USD)": "618.28",
    "country": "United States"
  },
  {
    "Rank": "1261",
    "Name": "Jabil",
    "Symbol": "JBL",
    " marketcap ": " $14 205 120 512 ",
    "price (USD)": "117.79",
    "country": "United States"
  },
  {
    "Rank": "1262",
    "Name": "Logitech",
    "Symbol": "LOGI",
    " marketcap ": " $14 187 431 936 ",
    "price (USD)": "92.46",
    "country": "Switzerland"
  },
  {
    "Rank": "1263",
    "Name": "Uni-President Enterprises",
    "Symbol": "1216.TW",
    " marketcap ": " $14 149 105 071 ",
    "price (USD)": "2.49015",
    "country": "Taiwan"
  },
  {
    "Rank": "1264",
    "Name": "Neurocrine Biosciences",
    "Symbol": "NBIX",
    " marketcap ": " $14 144 530 432 ",
    "price (USD)": "140.55",
    "country": "United States"
  },
  {
    "Rank": "1265",
    "Name": "KEPCO",
    "Symbol": "9503.T",
    " marketcap ": " $14 095 713 323 ",
    "price (USD)": "15.7955",
    "country": "Japan"
  },
  {
    "Rank": "1266",
    "Name": "Wiwynn",
    "Symbol": "6669.TW",
    " marketcap ": " $14 069 908 883 ",
    "price (USD)": "80.4726",
    "country": "Taiwan"
  },
  {
    "Rank": "1267",
    "Name": "Ryan Specialty Group",
    "Symbol": "RYAN",
    " marketcap ": " $14 064 138 240 ",
    "price (USD)": "54",
    "country": "United States"
  },
  {
    "Rank": "1268",
    "Name": "Graco",
    "Symbol": "GGG",
    " marketcap ": " $14 063 659 008 ",
    "price (USD)": "83.15",
    "country": "United States"
  },
  {
    "Rank": "1269",
    "Name": "AspenTech",
    "Symbol": "AZPN",
    " marketcap ": " $14 013 197 312 ",
    "price (USD)": "221.28",
    "country": "United States"
  },
  {
    "Rank": "1270",
    "Name": "Trimble",
    "Symbol": "TRMB",
    " marketcap ": " $13 993 118 720 ",
    "price (USD)": "57.3",
    "country": "United States"
  },
  {
    "Rank": "1271",
    "Name": "Pentair",
    "Symbol": "PNR",
    " marketcap ": " $13 990 925 312 ",
    "price (USD)": "84.27",
    "country": "United Kingdom"
  },
  {
    "Rank": "1272",
    "Name": "Brookfield Infrastructure Partners",
    "Symbol": "BIP",
    " marketcap ": " $13 985 572 864 ",
    "price (USD)": "30.25",
    "country": "Bermuda"
  },
  {
    "Rank": "1273",
    "Name": "Revvity",
    "Symbol": "RVTY",
    " marketcap ": " $13 971 789 824 ",
    "price (USD)": "113.23",
    "country": "United States"
  },
  {
    "Rank": "1274",
    "Name": "Avangrid",
    "Symbol": "AGR",
    " marketcap ": " $13 928 489 984 ",
    "price (USD)": "35.99",
    "country": "United States"
  },
  {
    "Rank": "1275",
    "Name": "Turkish Airlines",
    "Symbol": "THYAO.IS",
    " marketcap ": " $13 910 123 944 ",
    "price (USD)": "10.0798",
    "country": "Turkey"
  },
  {
    "Rank": "1276",
    "Name": "Nordson",
    "Symbol": "NDSN",
    " marketcap ": " $13 905 711 104 ",
    "price (USD)": "243.14",
    "country": "United States"
  },
  {
    "Rank": "1277",
    "Name": "Ritchie Bros. Auctioneers",
    "Symbol": "RBA",
    " marketcap ": " $13 902 202 880 ",
    "price (USD)": "75.53",
    "country": "Canada"
  },
  {
    "Rank": "1278",
    "Name": "Physicians Realty Trust",
    "Symbol": "DOC",
    " marketcap ": " $13 899 695 104 ",
    "price (USD)": "19.75",
    "country": "United States"
  },
  {
    "Rank": "1279",
    "Name": "Chow Tai Fook",
    "Symbol": "1929.HK",
    " marketcap ": " $13 899 003 162 ",
    "price (USD)": "1.39161",
    "country": "Hong Kong"
  },
  {
    "Rank": "1280",
    "Name": "Havells India",
    "Symbol": "HAVELLS.NS",
    " marketcap ": " $13 898 136 639 ",
    "price (USD)": "22.1773",
    "country": "India"
  },
  {
    "Rank": "1281",
    "Name": "Manhattan Associates",
    "Symbol": "MANH",
    " marketcap ": " $13 894 478 848 ",
    "price (USD)": "225.67",
    "country": "United States"
  },
  {
    "Rank": "1282",
    "Name": "Advanced Drainage Systems",
    "Symbol": "WMS",
    " marketcap ": " $13 877 891 072 ",
    "price (USD)": "179.24",
    "country": "United States"
  },
  {
    "Rank": "1283",
    "Name": "Cochlear",
    "Symbol": "COH.AX",
    " marketcap ": " $13 845 807 660 ",
    "price (USD)": "211.405",
    "country": "Australia"
  },
  {
    "Rank": "1284",
    "Name": "E.SUN Bank",
    "Symbol": "2884.TW",
    " marketcap ": " $13 843 891 295 ",
    "price (USD)": "0.883803",
    "country": "Taiwan"
  },
  {
    "Rank": "1285",
    "Name": "Hai Di Lao Hot Pot",
    "Symbol": "6862.HK",
    " marketcap ": " $13 813 702 304 ",
    "price (USD)": "2.47824",
    "country": "China"
  },
  {
    "Rank": "1286",
    "Name": "nVent Electric",
    "Symbol": "NVT",
    " marketcap ": " $13 812 781 056 ",
    "price (USD)": "83.2",
    "country": "United Kingdom"
  },
  {
    "Rank": "1287",
    "Name": "Rede D'Or Sao Luiz",
    "Symbol": "RDOR3.SA",
    " marketcap ": " $13 797 069 550 ",
    "price (USD)": "6.04978",
    "country": "Brazil"
  },
  {
    "Rank": "1288",
    "Name": "Reinsurance Group of America",
    "Symbol": "RGA",
    " marketcap ": " $13 795 924 992 ",
    "price (USD)": "209.69",
    "country": "United States"
  },
  {
    "Rank": "1289",
    "Name": "A\u0413\u00a9roports de Paris",
    "Symbol": "ADP.PA",
    " marketcap ": " $13 728 169 434 ",
    "price (USD)": "138.777",
    "country": "France"
  },
  {
    "Rank": "1290",
    "Name": "Campbell Soup",
    "Symbol": "CPB",
    " marketcap ": " $13 721 680 896 ",
    "price (USD)": "46.03",
    "country": "United States"
  },
  {
    "Rank": "1291",
    "Name": "Evergreen Marine",
    "Symbol": "2603.TW",
    " marketcap ": " $13 716 988 593 ",
    "price (USD)": "6.48122",
    "country": "Taiwan"
  },
  {
    "Rank": "1292",
    "Name": "Suncorp",
    "Symbol": "SUN.AX",
    " marketcap ": " $13 710 052 278 ",
    "price (USD)": "\u043e\u043a\u0442.56",
    "country": "Australia"
  },
  {
    "Rank": "1293",
    "Name": "Sodexo",
    "Symbol": "SW.PA",
    " marketcap ": " $13 660 198 918 ",
    "price (USD)": "92.7354",
    "country": "France"
  },
  {
    "Rank": "1294",
    "Name": "Sage Group",
    "Symbol": "SGE.L",
    " marketcap ": " $13 652 630 332 ",
    "price (USD)": "13.6733",
    "country": "United Kingdom"
  },
  {
    "Rank": "1295",
    "Name": "Union Bank of India",
    "Symbol": "UNIONBANK.NS",
    " marketcap ": " $13 643 403 985 ",
    "price (USD)": "1.78728",
    "country": "India"
  },
  {
    "Rank": "1296",
    "Name": "Westrock",
    "Symbol": "WRK",
    " marketcap ": " $13 618 735 104 ",
    "price (USD)": "52.73",
    "country": "United States"
  },
  {
    "Rank": "1297",
    "Name": "AIB Group (Allied Irish Banks)",
    "Symbol": "A5G.IR",
    " marketcap ": " $13 588 975 932 ",
    "price (USD)": "5.61407",
    "country": "Ireland"
  },
  {
    "Rank": "1298",
    "Name": "Tsingtao",
    "Symbol": "600600.SS",
    " marketcap ": " $13 571 712 076 ",
    "price (USD)": "\u043d\u043e\u044f.41",
    "country": "China"
  },
  {
    "Rank": "1299",
    "Name": "Stanley Black &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1300",
    "Name": "Toll Brothers",
    "Symbol": "TOL",
    " marketcap ": " $13 565 017 088 ",
    "price (USD)": "130.22",
    "country": "United States"
  },
  {
    "Rank": "1301",
    "Name": "NN Group",
    "Symbol": "NN.AS",
    " marketcap ": " $13 559 002 055 ",
    "price (USD)": "49.6579",
    "country": "Netherlands"
  },
  {
    "Rank": "1302",
    "Name": "Rentokil Initial",
    "Symbol": "RTO",
    " marketcap ": " $13 555 023 872 ",
    "price (USD)": "26.91",
    "country": "United Kingdom"
  },
  {
    "Rank": "1303",
    "Name": "Sociedad Qu\u0413\u00admica y Minera",
    "Symbol": "SQM",
    " marketcap ": " $13 513 534 464 ",
    "price (USD)": "47.31",
    "country": "Chile"
  },
  {
    "Rank": "1304",
    "Name": "James Hardie Industries",
    "Symbol": "JHX",
    " marketcap ": " $13 503 241 216 ",
    "price (USD)": "30.99",
    "country": "Ireland"
  },
  {
    "Rank": "1305",
    "Name": "Lundbergf\u0413\u00b6retagen",
    "Symbol": "LUND-B.ST",
    " marketcap ": " $13 487 029 626 ",
    "price (USD)": "54.3832",
    "country": "Sweden"
  },
  {
    "Rank": "1306",
    "Name": "OTP Bank",
    "Symbol": "OTP.BD",
    " marketcap ": " $13 452 175 025 ",
    "price (USD)": "50.485",
    "country": "Hungary"
  },
  {
    "Rank": "1307",
    "Name": "US Foods",
    "Symbol": "USFD",
    " marketcap ": " $13 451 383 808 ",
    "price (USD)": "54.71",
    "country": "United States"
  },
  {
    "Rank": "1308",
    "Name": "Mediobanca",
    "Symbol": "MB.MI",
    " marketcap ": " $13 421 945 731 ",
    "price (USD)": "15.8215",
    "country": "Italy"
  },
  {
    "Rank": "1309",
    "Name": "MTU Aero Engines",
    "Symbol": "MTX.DE",
    " marketcap ": " $13 406 231 573 ",
    "price (USD)": "249.321",
    "country": "Germany"
  },
  {
    "Rank": "1310",
    "Name": "Nan Ya Plastics",
    "Symbol": "1303.TW",
    " marketcap ": " $13 403 716 696 ",
    "price (USD)": "1.69008",
    "country": "Taiwan"
  },
  {
    "Rank": "1311",
    "Name": "China Southern Airlines",
    "Symbol": "600029.SS",
    " marketcap ": " $13 402 966 585 ",
    "price (USD)": "0.846767",
    "country": "China"
  },
  {
    "Rank": "1312",
    "Name": "Santander Polska",
    "Symbol": "SPL.WA",
    " marketcap ": " $13 388 230 414 ",
    "price (USD)": "131.014",
    "country": "Poland"
  },
  {
    "Rank": "1313",
    "Name": "Magna International",
    "Symbol": "MGA",
    " marketcap ": " $13 387 028 480 ",
    "price (USD)": "46.49",
    "country": "Canada"
  },
  {
    "Rank": "1314",
    "Name": "Secom",
    "Symbol": "9735.T",
    " marketcap ": " $13 374 384 628 ",
    "price (USD)": "63.6875",
    "country": "Japan"
  },
  {
    "Rank": "1315",
    "Name": "Alliant Energy",
    "Symbol": "LNT",
    " marketcap ": " $13 362 473 984 ",
    "price (USD)": "52.12",
    "country": "United States"
  },
  {
    "Rank": "1316",
    "Name": "Geely",
    "Symbol": "0175.HK",
    " marketcap ": " $13 359 528 250 ",
    "price (USD)": "1.32754",
    "country": "China"
  },
  {
    "Rank": "1317",
    "Name": "Ford Otosan",
    "Symbol": "FROTO.IS",
    " marketcap ": " $13 352 699 174 ",
    "price (USD)": "38.0516",
    "country": "Turkey"
  },
  {
    "Rank": "1318",
    "Name": "Formosa Plastics",
    "Symbol": "1301.TW",
    " marketcap ": " $13 324 880 228 ",
    "price (USD)": "2.09322",
    "country": "Taiwan"
  },
  {
    "Rank": "1319",
    "Name": "Gulf Energy Development Public Company",
    "Symbol": "GULF.BK",
    " marketcap ": " $13 307 771 808 ",
    "price (USD)": "1.13421",
    "country": "Thailand"
  },
  {
    "Rank": "1320",
    "Name": "Natera",
    "Symbol": "NTRA",
    " marketcap ": " $13 294 653 440 ",
    "price (USD)": "108.26",
    "country": "United States"
  },
  {
    "Rank": "1321",
    "Name": "Bureau Veritas",
    "Symbol": "BVI.PA",
    " marketcap ": " $13 294 506 713 ",
    "price (USD)": "29.5363",
    "country": "France"
  },
  {
    "Rank": "1322",
    "Name": "China Resources Power Holdings",
    "Symbol": "0836.HK",
    " marketcap ": " $13 283 689 636 ",
    "price (USD)": "2.76143",
    "country": "Hong Kong"
  },
  {
    "Rank": "1323",
    "Name": "Equitable Holdings",
    "Symbol": "EQH",
    " marketcap ": " $13 250 481 152 ",
    "price (USD)": "40.74",
    "country": "United States"
  },
  {
    "Rank": "1324",
    "Name": "Continental",
    "Symbol": "CON.DE",
    " marketcap ": " $13 248 307 178 ",
    "price (USD)": "66.2395",
    "country": "Germany"
  },
  {
    "Rank": "1325",
    "Name": "Brambles",
    "Symbol": "BXB.AX",
    " marketcap ": " $13 232 903 019 ",
    "price (USD)": "9.50203",
    "country": "Australia"
  },
  {
    "Rank": "1326",
    "Name": "Nissan",
    "Symbol": "7201.T",
    " marketcap ": " $13 227 448 310 ",
    "price (USD)": "3.53656",
    "country": "Japan"
  },
  {
    "Rank": "1327",
    "Name": "Norsk Hydro",
    "Symbol": "NHY.OL",
    " marketcap ": " $13 202 874 238 ",
    "price (USD)": "6.58182",
    "country": "Norway"
  },
  {
    "Rank": "1328",
    "Name": "Ovintiv",
    "Symbol": "OVV",
    " marketcap ": " $13 202 209 792 ",
    "price (USD)": "49.45",
    "country": "United States"
  },
  {
    "Rank": "1329",
    "Name": "New Oriental",
    "Symbol": "EDU",
    " marketcap ": " $13 199 582 208 ",
    "price (USD)": "79.75",
    "country": "China"
  },
  {
    "Rank": "1330",
    "Name": "Ares Capital",
    "Symbol": "ARCC",
    " marketcap ": " $13 187 556 352 ",
    "price (USD)": "21.46",
    "country": "United States"
  },
  {
    "Rank": "1331",
    "Name": "Credicorp",
    "Symbol": "BAP",
    " marketcap ": " $13 166 508 032 ",
    "price (USD)": "165.67",
    "country": "Bermuda"
  },
  {
    "Rank": "1332",
    "Name": "Permian Resources",
    "Symbol": "PR",
    " marketcap ": " $13 141 505 024 ",
    "price (USD)": "16.19",
    "country": "United States"
  },
  {
    "Rank": "1333",
    "Name": "IndusInd Bank",
    "Symbol": "INDUSINDBK.NS",
    " marketcap ": " $13 130 493 640 ",
    "price (USD)": "16.8677",
    "country": "India"
  },
  {
    "Rank": "1334",
    "Name": "China Merchants Shekou Industrial Zone",
    "Symbol": "001979.SZ",
    " marketcap ": " $13 129 475 568 ",
    "price (USD)": "1.44904",
    "country": "China"
  },
  {
    "Rank": "1335",
    "Name": "W. P. Carey",
    "Symbol": "WPC",
    " marketcap ": " $13 127 311 360 ",
    "price (USD)": "59.99",
    "country": "United States"
  },
  {
    "Rank": "1336",
    "Name": "Yuanta Financial Holding",
    "Symbol": "2885.TW",
    " marketcap ": " $13 123 125 408 ",
    "price (USD)": "1.0342",
    "country": "Taiwan"
  },
  {
    "Rank": "1337",
    "Name": "Kazatomprom",
    "Symbol": "0ZQ.F",
    " marketcap ": " $13 109 958 762 ",
    "price (USD)": "46.5849",
    "country": "Kazakhstan"
  },
  {
    "Rank": "1338",
    "Name": "Host Hotels & Resorts",
    "Symbol": "HST",
    " marketcap ": " $13 108 478 976 ",
    "price (USD)": "18.34",
    "country": "United States"
  },
  {
    "Rank": "1339",
    "Name": "Pandora",
    "Symbol": "PNDORA.CO",
    " marketcap ": " $13 095 666 471 ",
    "price (USD)": "161.583",
    "country": "Denmark"
  },
  {
    "Rank": "1340",
    "Name": "NiSource",
    "Symbol": "NI",
    " marketcap ": " $13 094 988 800 ",
    "price (USD)": "29.21",
    "country": "United States"
  },
  {
    "Rank": "1341",
    "Name": "Jindal Steel &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1342",
    "Name": "Tryg",
    "Symbol": "TRYG.CO",
    " marketcap ": " $13 064 368 841 ",
    "price (USD)": "21.2291",
    "country": "Denmark"
  },
  {
    "Rank": "1343",
    "Name": "Viatris",
    "Symbol": "VTRS",
    " marketcap ": " $13 049 853 952 ",
    "price (USD)": "\u043e\u043a\u0442.96",
    "country": "United States"
  },
  {
    "Rank": "1344",
    "Name": "BB Seguridade Participa\u0413\u00a7\u0413\u00b5es",
    "Symbol": "BBSE3.SA",
    " marketcap ": " $13 035 942 794 ",
    "price (USD)": "6.62372",
    "country": "Brazil"
  },
  {
    "Rank": "1345",
    "Name": "Adevinta",
    "Symbol": "ADE.OL",
    " marketcap ": " $13 034 465 631 ",
    "price (USD)": "\u043e\u043a\u0442.58",
    "country": "Norway"
  },
  {
    "Rank": "1346",
    "Name": "Coca-Cola HBC",
    "Symbol": "CCH.L",
    " marketcap ": " $13 033 561 880 ",
    "price (USD)": "35.6896",
    "country": "Switzerland"
  },
  {
    "Rank": "1347",
    "Name": "GarantiBank",
    "Symbol": "GARAN.IS",
    " marketcap ": " $13 033 228 198 ",
    "price (USD)": "3.10315",
    "country": "Turkey"
  },
  {
    "Rank": "1348",
    "Name": "Bio-Techne",
    "Symbol": "TECH",
    " marketcap ": " $13 029 127 168 ",
    "price (USD)": "82.68",
    "country": "United States"
  },
  {
    "Rank": "1349",
    "Name": "Nitori Holdings",
    "Symbol": "9843.T",
    " marketcap ": " $13 021 215 559 ",
    "price (USD)": "115.22",
    "country": "Japan"
  },
  {
    "Rank": "1350",
    "Name": "Hansoh Pharma",
    "Symbol": "3692.HK",
    " marketcap ": " $13 009 299 263 ",
    "price (USD)": "2.19377",
    "country": "China"
  },
  {
    "Rank": "1351",
    "Name": "Power Assets",
    "Symbol": "0006.HK",
    " marketcap ": " $12 985 031 663 ",
    "price (USD)": "6.09308",
    "country": "Hong Kong"
  },
  {
    "Rank": "1352",
    "Name": "Hana Financial Group",
    "Symbol": "086790.KS",
    " marketcap ": " $12 983 185 769 ",
    "price (USD)": "45.753",
    "country": "South Korea"
  },
  {
    "Rank": "1353",
    "Name": "Bunzl",
    "Symbol": "BNZL.L",
    " marketcap ": " $12 978 736 865 ",
    "price (USD)": "38.6488",
    "country": "United Kingdom"
  },
  {
    "Rank": "1354",
    "Name": "Surgutneftegas",
    "Symbol": "SNGS.ME",
    " marketcap ": " $12 973 984 880 ",
    "price (USD)": "0.37",
    "country": "Russia"
  },
  {
    "Rank": "1355",
    "Name": "TopBuild",
    "Symbol": "BLD",
    " marketcap ": " $12 969 848 832 ",
    "price (USD)": "407.63",
    "country": "United States"
  },
  {
    "Rank": "1356",
    "Name": "T\u0413\u0458rkiye Is Bankasi",
    "Symbol": "ISCTR.IS",
    " marketcap ": " $12 929 261 142 ",
    "price (USD)": "0.492652",
    "country": "Turkey"
  },
  {
    "Rank": "1357",
    "Name": "Knorr-Bremse",
    "Symbol": "KBX.DE",
    " marketcap ": " $12 927 157 694 ",
    "price (USD)": "80.1933",
    "country": "Germany"
  },
  {
    "Rank": "1358",
    "Name": "Q Holding",
    "Symbol": "QHOLDING.AE",
    " marketcap ": " $12 907 815 250 ",
    "price (USD)": "0.79",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1359",
    "Name": "Incyte",
    "Symbol": "INCY",
    " marketcap ": " $12 906 678 272 ",
    "price (USD)": "57.4",
    "country": "United States"
  },
  {
    "Rank": "1360",
    "Name": "Bandai Namco",
    "Symbol": "7832.T",
    " marketcap ": " $12 894 285 939 ",
    "price (USD)": "19.7044",
    "country": "Japan"
  },
  {
    "Rank": "1361",
    "Name": "Zydus Lifesciences",
    "Symbol": "ZYDUSLIFE.NS",
    " marketcap ": " $12 887 606 398 ",
    "price (USD)": "\u0434\u0435\u043a.65",
    "country": "India"
  },
  {
    "Rank": "1362",
    "Name": "Cholamandalam Investment and Finance",
    "Symbol": "CHOLAFIN.NS",
    " marketcap ": " $12 886 554 382 ",
    "price (USD)": "15.3424",
    "country": "India"
  },
  {
    "Rank": "1363",
    "Name": "Divis Laboratories",
    "Symbol": "DIVISLAB.NS",
    " marketcap ": " $12 881 276 193 ",
    "price (USD)": "48.5227",
    "country": "India"
  },
  {
    "Rank": "1364",
    "Name": "JSW Energy",
    "Symbol": "JSWENERGY.NS",
    " marketcap ": " $12 845 222 612 ",
    "price (USD)": "\u0438\u044e\u043b.42",
    "country": "India"
  },
  {
    "Rank": "1365",
    "Name": "Suzano",
    "Symbol": "SUZ",
    " marketcap ": " $12 834 720 768 ",
    "price (USD)": "09.\u0438\u044e\u043d",
    "country": "Brazil"
  },
  {
    "Rank": "1366",
    "Name": "Morningstar",
    "Symbol": "MORN",
    " marketcap ": " $12 825 390 080 ",
    "price (USD)": "300.04",
    "country": "United States"
  },
  {
    "Rank": "1367",
    "Name": "Kimco Realty",
    "Symbol": "KIM",
    " marketcap ": " $12 821 686 272 ",
    "price (USD)": "19.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "1368",
    "Name": "Lincoln Electric",
    "Symbol": "LECO",
    " marketcap ": " $12 806 074 368 ",
    "price (USD)": "225.03",
    "country": "United States"
  },
  {
    "Rank": "1369",
    "Name": "Insulet",
    "Symbol": "PODD",
    " marketcap ": " $12 802 520 064 ",
    "price (USD)": "182.79",
    "country": "United States"
  },
  {
    "Rank": "1370",
    "Name": "MGM Resorts",
    "Symbol": "MGM",
    " marketcap ": " $12 801 281 024 ",
    "price (USD)": "40.81",
    "country": "United States"
  },
  {
    "Rank": "1371",
    "Name": "Longfor Group",
    "Symbol": "0960.HK",
    " marketcap ": " $12 799 346 413 ",
    "price (USD)": "1.89135",
    "country": "China"
  },
  {
    "Rank": "1372",
    "Name": "Evergy",
    "Symbol": "EVRG",
    " marketcap ": " $12 790 949 888 ",
    "price (USD)": "55.63",
    "country": "United States"
  },
  {
    "Rank": "1373",
    "Name": "Tata Consumer Products",
    "Symbol": "TATACONSUM.NS",
    " marketcap ": " $12 786 485 339 ",
    "price (USD)": "13.4151",
    "country": "India"
  },
  {
    "Rank": "1374",
    "Name": "JBS",
    "Symbol": "JBSS3.SA",
    " marketcap ": " $12 769 616 036 ",
    "price (USD)": "5.75695",
    "country": "Brazil"
  },
  {
    "Rank": "1375",
    "Name": "Power Financial",
    "Symbol": "PWF-PS.TO",
    " marketcap ": " $12 743 506 011 ",
    "price (USD)": "13.8641",
    "country": "Canada"
  },
  {
    "Rank": "1376",
    "Name": "Tenet Healthcare",
    "Symbol": "THC",
    " marketcap ": " $12 733 956 096 ",
    "price (USD)": "130.36",
    "country": "United States"
  },
  {
    "Rank": "1377",
    "Name": "Al Dar Properties",
    "Symbol": "ALDAR.AE",
    " marketcap ": " $12 716 535 476 ",
    "price (USD)": "\u044f\u043d\u0432.62",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1378",
    "Name": "Amerco",
    "Symbol": "UHAL",
    " marketcap ": " $12 714 047 488 ",
    "price (USD)": "67.56",
    "country": "United States"
  },
  {
    "Rank": "1379",
    "Name": "Davide Campari-Milano",
    "Symbol": "CPR.MI",
    " marketcap ": " $12 699 493 661 ",
    "price (USD)": "\u043e\u043a\u0442.16",
    "country": "Italy"
  },
  {
    "Rank": "1380",
    "Name": "Canara Bank",
    "Symbol": "CANBK.NS",
    " marketcap ": " $12 686 073 761 ",
    "price (USD)": "1.39798",
    "country": "India"
  },
  {
    "Rank": "1381",
    "Name": "Viking Holdings",
    "Symbol": "VIK",
    " marketcap ": " $12 663 204 864 ",
    "price (USD)": "29.35",
    "country": "Bermuda"
  },
  {
    "Rank": "1382",
    "Name": "Equity LifeStyle Properties",
    "Symbol": "ELS",
    " marketcap ": " $12 641 691 648 ",
    "price (USD)": "64.63",
    "country": "United States"
  },
  {
    "Rank": "1383",
    "Name": "Fresenius Medical Care",
    "Symbol": "FMS",
    " marketcap ": " $12 618 414 080 ",
    "price (USD)": "21.42",
    "country": "Germany"
  },
  {
    "Rank": "1384",
    "Name": "Edenred",
    "Symbol": "EDEN.PA",
    " marketcap ": " $12 606 494 134 ",
    "price (USD)": "50.581",
    "country": "France"
  },
  {
    "Rank": "1385",
    "Name": "NHPC Limited",
    "Symbol": "NHPC.NS",
    " marketcap ": " $12 606 488 311 ",
    "price (USD)": "1.255",
    "country": "India"
  },
  {
    "Rank": "1386",
    "Name": "Smurfit Kappa Group",
    "Symbol": "SK3.IR",
    " marketcap ": " $12 602 533 348 ",
    "price (USD)": "48.268",
    "country": "Ireland"
  },
  {
    "Rank": "1387",
    "Name": "NICE",
    "Symbol": "NICE",
    " marketcap ": " $12 602 281 984 ",
    "price (USD)": "199.85",
    "country": "Israel"
  },
  {
    "Rank": "1388",
    "Name": "Karuna Therapeutics",
    "Symbol": "KRTX",
    " marketcap ": " $12 599 274 496 ",
    "price (USD)": "329.83",
    "country": "United States"
  },
  {
    "Rank": "1389",
    "Name": "SAAB AB",
    "Symbol": "SAAB-B.ST",
    " marketcap ": " $12 598 548 300 ",
    "price (USD)": "23.1854",
    "country": "Sweden"
  },
  {
    "Rank": "1390",
    "Name": "Lamb Weston",
    "Symbol": "LW",
    " marketcap ": " $12 595 227 648 ",
    "price (USD)": "87.23",
    "country": "United States"
  },
  {
    "Rank": "1391",
    "Name": "Xero",
    "Symbol": "XRO.AX",
    " marketcap ": " $12 595 052 513 ",
    "price (USD)": "82.6843",
    "country": "New Zealand"
  },
  {
    "Rank": "1392",
    "Name": "Gaming and Leisure Properties",
    "Symbol": "GLPI",
    " marketcap ": " $12 578 641 920 ",
    "price (USD)": "46.33",
    "country": "United States"
  },
  {
    "Rank": "1393",
    "Name": "A. O. Smith",
    "Symbol": "AOS",
    " marketcap ": " $12 575 485 952 ",
    "price (USD)": "85.74",
    "country": "United States"
  },
  {
    "Rank": "1394",
    "Name": "Bangkok Dusit Medical Services (BDMS)",
    "Symbol": "BDMS.BK",
    " marketcap ": " $12 562 759 967 ",
    "price (USD)": "0.790508",
    "country": "Thailand"
  },
  {
    "Rank": "1395",
    "Name": "Franklin Resources",
    "Symbol": "BEN",
    " marketcap ": " $12 560 035 840 ",
    "price (USD)": "23.87",
    "country": "United States"
  },
  {
    "Rank": "1396",
    "Name": "Shanghai Airport (AVINEX)",
    "Symbol": "600009.SS",
    " marketcap ": " $12 526 101 324 ",
    "price (USD)": "5.03364",
    "country": "China"
  },
  {
    "Rank": "1397",
    "Name": "Floor &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1398",
    "Name": "BDO Unibank",
    "Symbol": "BDOUY",
    " marketcap ": " $12 489 024 512 ",
    "price (USD)": "23.41",
    "country": "Philippines"
  },
  {
    "Rank": "1399",
    "Name": "New China Life Insurance",
    "Symbol": "601336.SS",
    " marketcap ": " $12 462 317 495 ",
    "price (USD)": "4.85544",
    "country": "China"
  },
  {
    "Rank": "1400",
    "Name": "Nippon Sanso",
    "Symbol": "4091.T",
    " marketcap ": " $12 453 217 040 ",
    "price (USD)": "28.7698",
    "country": "Japan"
  },
  {
    "Rank": "1401",
    "Name": "XPO Logistics",
    "Symbol": "XPO",
    " marketcap ": " $12 448 580 608 ",
    "price (USD)": "107.01",
    "country": "United States"
  },
  {
    "Rank": "1402",
    "Name": "Casey's General Stores",
    "Symbol": "CASY",
    " marketcap ": " $12 444 072 960 ",
    "price (USD)": "336.17",
    "country": "United States"
  },
  {
    "Rank": "1403",
    "Name": "B3",
    "Symbol": "B3SA3.SA",
    " marketcap ": " $12 431 743 413 ",
    "price (USD)": "2.22743",
    "country": "Brazil"
  },
  {
    "Rank": "1404",
    "Name": "Banco de Chile",
    "Symbol": "BCH",
    " marketcap ": " $12 394 785 792 ",
    "price (USD)": "24.54",
    "country": "Chile"
  },
  {
    "Rank": "1405",
    "Name": "ShockWave Medical",
    "Symbol": "SWAV",
    " marketcap ": " $12 375 839 744 ",
    "price (USD)": "329.64",
    "country": "United States"
  },
  {
    "Rank": "1406",
    "Name": "Lamar Advertising",
    "Symbol": "LAMR",
    " marketcap ": " $12 344 578 048 ",
    "price (USD)": "120.74",
    "country": "United States"
  },
  {
    "Rank": "1407",
    "Name": "Huazhu Hotels",
    "Symbol": "HTHT",
    " marketcap ": " $12 332 264 448 ",
    "price (USD)": "37.76",
    "country": "China"
  },
  {
    "Rank": "1408",
    "Name": "Plains All American Pipeline",
    "Symbol": "PAA",
    " marketcap ": " $12 331 838 464 ",
    "price (USD)": "17.59",
    "country": "United States"
  },
  {
    "Rank": "1409",
    "Name": "Jack Henry &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1410",
    "Name": "Cummins India",
    "Symbol": "CUMMINSIND.NS",
    " marketcap ": " $12 317 243 090 ",
    "price (USD)": "44.4345",
    "country": "India"
  },
  {
    "Rank": "1411",
    "Name": "Adani Total Gas",
    "Symbol": "ATGL.NS",
    " marketcap ": " $12 302 146 351 ",
    "price (USD)": "11.1839",
    "country": "India"
  },
  {
    "Rank": "1412",
    "Name": "Medpace",
    "Symbol": "MEDP",
    " marketcap ": " $12 289 565 696 ",
    "price (USD)": "396.65",
    "country": "United States"
  },
  {
    "Rank": "1413",
    "Name": "Shionogi",
    "Symbol": "4507.T",
    " marketcap ": " $12 285 681 178 ",
    "price (USD)": "43.337",
    "country": "Japan"
  },
  {
    "Rank": "1414",
    "Name": "AEGON",
    "Symbol": "AEG",
    " marketcap ": " $12 271 194 112 ",
    "price (USD)": "\u0438\u044e\u043d.87",
    "country": "Netherlands"
  },
  {
    "Rank": "1415",
    "Name": "AECOM",
    "Symbol": "ACM",
    " marketcap ": " $12 270 488 576 ",
    "price (USD)": "90.14",
    "country": "United States"
  },
  {
    "Rank": "1416",
    "Name": "DocuSign",
    "Symbol": "DOCU",
    " marketcap ": " $12 262 298 624 ",
    "price (USD)": "59.89",
    "country": "United States"
  },
  {
    "Rank": "1417",
    "Name": "RenaissanceRe",
    "Symbol": "RNR",
    " marketcap ": " $12 255 766 528 ",
    "price (USD)": "231.77",
    "country": "Bermuda"
  },
  {
    "Rank": "1418",
    "Name": "Japan Exchange Group",
    "Symbol": "8697.T",
    " marketcap ": " $12 253 060 341 ",
    "price (USD)": "23.5494",
    "country": "Japan"
  },
  {
    "Rank": "1419",
    "Name": "Metro",
    "Symbol": "MRU.TO",
    " marketcap ": " $12 250 946 958 ",
    "price (USD)": "54.2908",
    "country": "Canada"
  },
  {
    "Rank": "1420",
    "Name": "Shiseido",
    "Symbol": "4911.T",
    " marketcap ": " $12 229 437 864 ",
    "price (USD)": "30.5995",
    "country": "Japan"
  },
  {
    "Rank": "1421",
    "Name": "First Quantum Minerals",
    "Symbol": "FM.TO",
    " marketcap ": " $12 222 309 944 ",
    "price (USD)": "14.6633",
    "country": "Canada"
  },
  {
    "Rank": "1422",
    "Name": "United Therapeutics",
    "Symbol": "UTHR",
    " marketcap ": " $12 209 217 536 ",
    "price (USD)": "275.19",
    "country": "United States"
  },
  {
    "Rank": "1423",
    "Name": "Core &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1424",
    "Name": "Sarepta Therapeutics",
    "Symbol": "SRPT",
    " marketcap ": " $12 204 912 640 ",
    "price (USD)": "129.12",
    "country": "United States"
  },
  {
    "Rank": "1425",
    "Name": "CNA Financial",
    "Symbol": "CNA",
    " marketcap ": " $12 188 699 648 ",
    "price (USD)": "44.93",
    "country": "United States"
  },
  {
    "Rank": "1426",
    "Name": "Carrefour",
    "Symbol": "CA.PA",
    " marketcap ": " $12 186 170 433 ",
    "price (USD)": "17.5806",
    "country": "France"
  },
  {
    "Rank": "1427",
    "Name": "Julius B\u0413\u00a4r",
    "Symbol": "BAER.SW",
    " marketcap ": " $12 185 889 904 ",
    "price (USD)": "59.4968",
    "country": "Switzerland"
  },
  {
    "Rank": "1428",
    "Name": "Eurofins Scientific",
    "Symbol": "ERF.PA",
    " marketcap ": " $12 170 525 217 ",
    "price (USD)": "63.4162",
    "country": "Luxembourg"
  },
  {
    "Rank": "1429",
    "Name": "DaVita",
    "Symbol": "DVA",
    " marketcap ": " $12 163 473 408 ",
    "price (USD)": "138.69",
    "country": "United States"
  },
  {
    "Rank": "1430",
    "Name": "TVS Motor",
    "Symbol": "TVSMOTOR.NS",
    " marketcap ": " $12 158 739 149 ",
    "price (USD)": "25.5927",
    "country": "India"
  },
  {
    "Rank": "1431",
    "Name": "W\u0413\u00a4rtsil\u0413\u00a4",
    "Symbol": "WRT1V.HE",
    " marketcap ": " $12 150 715 726 ",
    "price (USD)": "20.6266",
    "country": "Finland"
  },
  {
    "Rank": "1432",
    "Name": "Burlington Stores",
    "Symbol": "BURL",
    " marketcap ": " $12 134 274 048 ",
    "price (USD)": "190",
    "country": "United States"
  },
  {
    "Rank": "1433",
    "Name": "Taiwan Cooperative Financial",
    "Symbol": "5880.TW",
    " marketcap ": " $12 133 532 275 ",
    "price (USD)": "0.824883",
    "country": "Taiwan"
  },
  {
    "Rank": "1434",
    "Name": "International Container Terminal Services",
    "Symbol": "ICTEF",
    " marketcap ": " $12 122 233 856 ",
    "price (USD)": "\u043c\u0430\u0439.79",
    "country": "Philippines"
  },
  {
    "Rank": "1435",
    "Name": "JDE Peet's",
    "Symbol": "JDEP.AS",
    " marketcap ": " $12 118 087 610 ",
    "price (USD)": "24.9321",
    "country": "Netherlands"
  },
  {
    "Rank": "1436",
    "Name": "Eisai",
    "Symbol": "4523.T",
    " marketcap ": " $12 106 892 125 ",
    "price (USD)": "42.179",
    "country": "Japan"
  },
  {
    "Rank": "1437",
    "Name": "Lifco",
    "Symbol": "LIFCO-B.ST",
    " marketcap ": " $12 083 006 193 ",
    "price (USD)": "26.6019",
    "country": "Sweden"
  },
  {
    "Rank": "1438",
    "Name": "YPF ",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": " (Yacimientos Petrol\u0413\u00adferos Fiscales)\"",
    "Name": "YPF",
    "Symbol": "12076490752",
    " marketcap ": " 23.53 ",
    "price (USD)": "Argentina",
    "country": null
  },
  {
    "Rank": "1439",
    "Name": "Universal Health Services",
    "Symbol": "UHS",
    " marketcap ": " $12 060 641 280 ",
    "price (USD)": "180.2",
    "country": "United States"
  },
  {
    "Rank": "1440",
    "Name": "Bank Hapoalim",
    "Symbol": "POLI.TA",
    " marketcap ": " $12 059 295 497 ",
    "price (USD)": "9.01778",
    "country": "Israel"
  },
  {
    "Rank": "1441",
    "Name": "bioM\u0413\u00a9rieux",
    "Symbol": "BIM.PA",
    " marketcap ": " $12 046 333 109 ",
    "price (USD)": "100.88",
    "country": "France"
  },
  {
    "Rank": "1442",
    "Name": "Bank Leumi",
    "Symbol": "LUMI.TA",
    " marketcap ": " $12 042 685 654 ",
    "price (USD)": "7.90794",
    "country": "Israel"
  },
  {
    "Rank": "1443",
    "Name": "First Financial Holding",
    "Symbol": "2892.TW",
    " marketcap ": " $12 037 486 181 ",
    "price (USD)": "0.883803",
    "country": "Taiwan"
  },
  {
    "Rank": "1444",
    "Name": "ASUS",
    "Symbol": "2357.TW",
    " marketcap ": " $12 023 465 254 ",
    "price (USD)": "16.1876",
    "country": "Taiwan"
  },
  {
    "Rank": "1445",
    "Name": "VinFast Auto",
    "Symbol": "VFS",
    " marketcap ": " $12 017 474 560 ",
    "price (USD)": "\u043c\u0430\u0439.14",
    "country": "Vietnam"
  },
  {
    "Rank": "1446",
    "Name": "PChem (Petronas Chemicals Group)",
    "Symbol": "5183.KL",
    " marketcap ": " $11 982 529 030 ",
    "price (USD)": "1.49782",
    "country": "Malaysia"
  },
  {
    "Rank": "1447",
    "Name": "Hero MotoCorp",
    "Symbol": "HEROMOTOCO.NS",
    " marketcap ": " $11 972 030 797 ",
    "price (USD)": "59.8808",
    "country": "India"
  },
  {
    "Rank": "1448",
    "Name": "Ally",
    "Symbol": "ALLY",
    " marketcap ": " $11 964 692 480 ",
    "price (USD)": "39.36",
    "country": "United States"
  },
  {
    "Rank": "1449",
    "Name": "Flex",
    "Symbol": "FLEX",
    " marketcap ": " $11 948 819 456 ",
    "price (USD)": "29.75",
    "country": "Singapore"
  },
  {
    "Rank": "1450",
    "Name": "LG Electronics",
    "Symbol": "066570.KS",
    " marketcap ": " $11 946 408 835 ",
    "price (USD)": "69.9881",
    "country": "South Korea"
  },
  {
    "Rank": "1451",
    "Name": "Unibail-Rodamco-Westfield",
    "Symbol": "URW.PA",
    " marketcap ": " $11 928 006 567 ",
    "price (USD)": "85.7205",
    "country": "France"
  },
  {
    "Rank": "1452",
    "Name": "Astra International",
    "Symbol": "ASII.JK",
    " marketcap ": " $11 921 829 479 ",
    "price (USD)": "0.294485",
    "country": "Indonesia"
  },
  {
    "Rank": "1453",
    "Name": "On Holding",
    "Symbol": "ONON",
    " marketcap ": " $11 913 120 768 ",
    "price (USD)": "37.31",
    "country": "Switzerland"
  },
  {
    "Rank": "1454",
    "Name": "GFL Environmental",
    "Symbol": "GFL",
    " marketcap ": " $11 900 249 088 ",
    "price (USD)": "31.61",
    "country": "Canada"
  },
  {
    "Rank": "1455",
    "Name": "J.M. Smucker Company",
    "Symbol": "SJM",
    " marketcap ": " $11 898 082 304 ",
    "price (USD)": "112.06",
    "country": "United States"
  },
  {
    "Rank": "1456",
    "Name": "Chesapeake Energy",
    "Symbol": "CHK",
    " marketcap ": " $11 889 985 536 ",
    "price (USD)": "90.73",
    "country": "United States"
  },
  {
    "Rank": "1457",
    "Name": "Polycab India",
    "Symbol": "POLYCAB.NS",
    " marketcap ": " $11 887 834 118 ",
    "price (USD)": "79.1204",
    "country": "India"
  },
  {
    "Rank": "1458",
    "Name": "Interpublic Group",
    "Symbol": "IPG",
    " marketcap ": " $11 881 307 136 ",
    "price (USD)": "31.48",
    "country": "United States"
  },
  {
    "Rank": "1459",
    "Name": "Abu Dhabi National Oil Company (ADNOC)",
    "Symbol": "ADNOCDIST.AE",
    " marketcap ": " $11 878 182 264 ",
    "price (USD)": "0.95",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1460",
    "Name": "Bank of Ireland Group",
    "Symbol": "BIRG.IR",
    " marketcap ": " $11 874 418 087 ",
    "price (USD)": "\u043d\u043e\u044f.42",
    "country": "Ireland"
  },
  {
    "Rank": "1461",
    "Name": "LKQ Corporation",
    "Symbol": "LKQ",
    " marketcap ": " $11 871 532 032 ",
    "price (USD)": "44.5",
    "country": "United States"
  },
  {
    "Rank": "1462",
    "Name": "AkzoNobel",
    "Symbol": "AKZA.AS",
    " marketcap ": " $11 869 428 741 ",
    "price (USD)": "69.5624",
    "country": "Netherlands"
  },
  {
    "Rank": "1463",
    "Name": "China Steel",
    "Symbol": "2002A.TW",
    " marketcap ": " $11 859 728 912 ",
    "price (USD)": "1.34896",
    "country": "Taiwan"
  },
  {
    "Rank": "1464",
    "Name": "Albertsons",
    "Symbol": "ACI",
    " marketcap ": " $11 836 864 512 ",
    "price (USD)": "20.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "1465",
    "Name": "Sumitomo Denki K\u0415\u040cgy\u0415\u040c",
    "Symbol": "5802.T",
    " marketcap ": " $11 814 503 704 ",
    "price (USD)": "15.1494",
    "country": "Japan"
  },
  {
    "Rank": "1466",
    "Name": "monday.com",
    "Symbol": "MNDY",
    " marketcap ": " $11 812 675 584 ",
    "price (USD)": "241.45",
    "country": "Israel"
  },
  {
    "Rank": "1467",
    "Name": "IHH Healthcare",
    "Symbol": "Q0F.SI",
    " marketcap ": " $11 787 469 682 ",
    "price (USD)": "1.33635",
    "country": "Malaysia"
  },
  {
    "Rank": "1468",
    "Name": "CG Power and Industrial Solutions",
    "Symbol": "CGPOWER.NS",
    " marketcap ": " $11 781 892 371 ",
    "price (USD)": "7.71384",
    "country": "India"
  },
  {
    "Rank": "1469",
    "Name": "South32",
    "Symbol": "S32.AX",
    " marketcap ": " $11 778 589 224 ",
    "price (USD)": "2.60055",
    "country": "Australia"
  },
  {
    "Rank": "1470",
    "Name": "XP Inc.",
    "Symbol": "XP",
    " marketcap ": " $11 763 073 024 ",
    "price (USD)": "21.45",
    "country": "Brazil"
  },
  {
    "Rank": "1471",
    "Name": "Eastman Chemical",
    "Symbol": "EMN",
    " marketcap ": " $11 754 019 840 ",
    "price (USD)": "99.95",
    "country": "United States"
  },
  {
    "Rank": "1472",
    "Name": "OBIC",
    "Symbol": "4684.T",
    " marketcap ": " $11 746 094 869 ",
    "price (USD)": "133.517",
    "country": "Japan"
  },
  {
    "Rank": "1473",
    "Name": "Dabur",
    "Symbol": "DABUR.NS",
    " marketcap ": " $11 738 085 687 ",
    "price (USD)": "6.62405",
    "country": "India"
  },
  {
    "Rank": "1474",
    "Name": "Abu Dhabi Islamic Bank (ADIB)",
    "Symbol": "ADIB.AE",
    " marketcap ": " $11 708 791 897 ",
    "price (USD)": "\u043c\u0430\u0440.22",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1475",
    "Name": "Molson Coors",
    "Symbol": "TAP",
    " marketcap ": " $11 701 311 488 ",
    "price (USD)": "55.16",
    "country": "United States"
  },
  {
    "Rank": "1476",
    "Name": "Mitsui O.S.K. Lines",
    "Symbol": "9104.T",
    " marketcap ": " $11 699 509 007 ",
    "price (USD)": "32.2884",
    "country": "Japan"
  },
  {
    "Rank": "1477",
    "Name": "Comfort Systems",
    "Symbol": "FIX",
    " marketcap ": " $11 693 920 256 ",
    "price (USD)": "327.36",
    "country": "United States"
  },
  {
    "Rank": "1478",
    "Name": "Tetra Tech",
    "Symbol": "TTEK",
    " marketcap ": " $11 691 835 392 ",
    "price (USD)": "218.55",
    "country": "United States"
  },
  {
    "Rank": "1479",
    "Name": "Origin Energy",
    "Symbol": "ORG.AX",
    " marketcap ": " $11 671 249 760 ",
    "price (USD)": "6.77478",
    "country": "Australia"
  },
  {
    "Rank": "1480",
    "Name": "Clean Harbors",
    "Symbol": "CLH",
    " marketcap ": " $11 624 092 672 ",
    "price (USD)": "215.52",
    "country": "United States"
  },
  {
    "Rank": "1481",
    "Name": "WPP",
    "Symbol": "WPP",
    " marketcap ": " $11 611 994 112 ",
    "price (USD)": "53.04",
    "country": "United Kingdom"
  },
  {
    "Rank": "1482",
    "Name": "JD Health",
    "Symbol": "6618.HK",
    " marketcap ": " $11 607 093 202 ",
    "price (USD)": "3.63919",
    "country": "China"
  },
  {
    "Rank": "1483",
    "Name": "Swire Pacific",
    "Symbol": "0019.HK",
    " marketcap ": " $11 597 941 677 ",
    "price (USD)": "9.08517",
    "country": "Hong Kong"
  },
  {
    "Rank": "1484",
    "Name": "Nemetschek",
    "Symbol": "NEM.F",
    " marketcap ": " $11 593 042 146 ",
    "price (USD)": "98.382",
    "country": "Germany"
  },
  {
    "Rank": "1485",
    "Name": "Bank Albilad",
    "Symbol": "1140.SR",
    " marketcap ": " $11 591 678 907 ",
    "price (USD)": "9.27334",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "1486",
    "Name": "Novatek Microelectronics",
    "Symbol": "3034.TW",
    " marketcap ": " $11 586 390 949 ",
    "price (USD)": "19.0405",
    "country": "Taiwan"
  },
  {
    "Rank": "1487",
    "Name": "Banque Saudi Fransi",
    "Symbol": "1050.SR",
    " marketcap ": " $11 577 402 533 ",
    "price (USD)": "9.67363",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "1488",
    "Name": "Stora Enso",
    "Symbol": "STEAV.HE",
    " marketcap ": " $11 574 354 618 ",
    "price (USD)": "14.7139",
    "country": "Finland"
  },
  {
    "Rank": "1489",
    "Name": "T\u0413\u0458rkiye Petrol Rafinerileri",
    "Symbol": "TUPRS.IS",
    " marketcap ": " $11 569 263 589 ",
    "price (USD)": "6.00439",
    "country": "Turkey"
  },
  {
    "Rank": "1490",
    "Name": "D'Ieteren Group",
    "Symbol": "DIE.BR",
    " marketcap ": " $11 564 640 573 ",
    "price (USD)": "218.482",
    "country": "Belgium"
  },
  {
    "Rank": "1491",
    "Name": "BE Semiconductor",
    "Symbol": "BESI.AS",
    " marketcap ": " $11 560 718 706 ",
    "price (USD)": "150.722",
    "country": "Netherlands"
  },
  {
    "Rank": "1492",
    "Name": "Dr. Reddy's",
    "Symbol": "RDY",
    " marketcap ": " $11 554 299 904 ",
    "price (USD)": "68.92",
    "country": "India"
  },
  {
    "Rank": "1493",
    "Name": "Qatar Islamic Bank",
    "Symbol": "QIBK.QA",
    " marketcap ": " $11 509 887 156 ",
    "price (USD)": "4.87088",
    "country": "Qatar"
  },
  {
    "Rank": "1494",
    "Name": "Bank of the Philippine Islands",
    "Symbol": "BPHLY",
    " marketcap ": " $11 488 721 920 ",
    "price (USD)": "43.69",
    "country": null
  },
  {
    "Rank": "1495",
    "Name": "Samsung Life Insurance",
    "Symbol": "032830.KS",
    " marketcap ": " $11 473 513 901 ",
    "price (USD)": "63.8926",
    "country": "South Korea"
  },
  {
    "Rank": "1496",
    "Name": "UWM Holdings",
    "Symbol": "UWMC",
    " marketcap ": " $11 471 127 552 ",
    "price (USD)": "\u0438\u044e\u043b.18",
    "country": "United States"
  },
  {
    "Rank": "1497",
    "Name": "TechnipFMC",
    "Symbol": "FTI",
    " marketcap ": " $11 459 599 360 ",
    "price (USD)": "26.59",
    "country": "United Kingdom"
  },
  {
    "Rank": "1498",
    "Name": "ITT",
    "Symbol": "ITT",
    " marketcap ": " $11 448 152 064 ",
    "price (USD)": "139.17",
    "country": "United States"
  },
  {
    "Rank": "1499",
    "Name": "AMEC",
    "Symbol": "688012.SS",
    " marketcap ": " $11 447 619 822 ",
    "price (USD)": "18.4617",
    "country": "China"
  },
  {
    "Rank": "1500",
    "Name": "Powszechny Zak\u0415\u201aad Ubezpiecze\u0415\u201e",
    "Symbol": "PZU.WA",
    " marketcap ": " $11 436 894 800 ",
    "price (USD)": "13.2445",
    "country": "Poland"
  },
  {
    "Rank": "1501",
    "Name": "Astera Labs",
    "Symbol": "ALAB",
    " marketcap ": " $11 419 110 400 ",
    "price (USD)": "73.34",
    "country": "United States"
  },
  {
    "Rank": "1502",
    "Name": "Charles River Laboratories",
    "Symbol": "CRL",
    " marketcap ": " $11 408 811 008 ",
    "price (USD)": "221.48",
    "country": "United States"
  },
  {
    "Rank": "1503",
    "Name": "Apache Corporation",
    "Symbol": "APA",
    " marketcap ": " $11 403 018 240 ",
    "price (USD)": "30.72",
    "country": "United States"
  },
  {
    "Rank": "1504",
    "Name": "Swire Properties",
    "Symbol": "1972.HK",
    " marketcap ": " $11 394 258 850 ",
    "price (USD)": "1.94774",
    "country": "Hong Kong"
  },
  {
    "Rank": "1505",
    "Name": "UiPath",
    "Symbol": "PATH",
    " marketcap ": " $11 393 983 488 ",
    "price (USD)": "19.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "1506",
    "Name": "Link REIT",
    "Symbol": "0823.HK",
    " marketcap ": " $11 388 317 392 ",
    "price (USD)": "4.45929",
    "country": "Hong Kong"
  },
  {
    "Rank": "1507",
    "Name": "Cemex",
    "Symbol": "CX",
    " marketcap ": " $11 377 000 448 ",
    "price (USD)": "\u0438\u044e\u043b.75",
    "country": "Mexico"
  },
  {
    "Rank": "1508",
    "Name": "Kirin Holdings",
    "Symbol": "2503.T",
    " marketcap ": " $11 375 291 330 ",
    "price (USD)": "14.0458",
    "country": "Japan"
  },
  {
    "Rank": "1509",
    "Name": "Smith & Nephew",
    "Symbol": "SNN",
    " marketcap ": " $11 364 099 072 ",
    "price (USD)": "25.85",
    "country": "United Kingdom"
  },
  {
    "Rank": "1510",
    "Name": "Onto Innovation",
    "Symbol": "ONTO",
    " marketcap ": " $11 362 036 736 ",
    "price (USD)": "230.58",
    "country": "United States"
  },
  {
    "Rank": "1511",
    "Name": "ZoomInfo",
    "Symbol": "ZI",
    " marketcap ": " $11 333 559 296 ",
    "price (USD)": "13.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "1512",
    "Name": "CarMax",
    "Symbol": "KMX",
    " marketcap ": " $11 322 824 704 ",
    "price (USD)": "71.97",
    "country": "United States"
  },
  {
    "Rank": "1513",
    "Name": "Recordati",
    "Symbol": "REC.MI",
    " marketcap ": " $11 305 356 968 ",
    "price (USD)": "53.1002",
    "country": "Italy"
  },
  {
    "Rank": "1514",
    "Name": "Camden Property Trust",
    "Symbol": "CPT",
    " marketcap ": " $11 284 187 136 ",
    "price (USD)": "105.92",
    "country": "United States"
  },
  {
    "Rank": "1515",
    "Name": "Arab National Bank",
    "Symbol": "1080.SR",
    " marketcap ": " $11 282 789 593 ",
    "price (USD)": "\u043c\u0430\u0439.14",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "1516",
    "Name": "ARC Resources",
    "Symbol": "ARX.TO",
    " marketcap ": " $11 266 312 343 ",
    "price (USD)": "18.8497",
    "country": "Canada"
  },
  {
    "Rank": "1517",
    "Name": "Northern Star",
    "Symbol": "NST.AX",
    " marketcap ": " $11 259 741 299 ",
    "price (USD)": "9.79542",
    "country": "Australia"
  },
  {
    "Rank": "1518",
    "Name": "IDBI Bank",
    "Symbol": "IDBI.NS",
    " marketcap ": " $11 259 228 047 ",
    "price (USD)": "1.04714",
    "country": "India"
  },
  {
    "Rank": "1519",
    "Name": "Pure Health Holding",
    "Symbol": "PUREHEALTH.AE",
    " marketcap ": " $11 254 208 983 ",
    "price (USD)": "01.\u044f\u043d\u0432",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1520",
    "Name": "Halma",
    "Symbol": "HLMA.L",
    " marketcap ": " $11 232 862 235 ",
    "price (USD)": "29.7367",
    "country": "United Kingdom"
  },
  {
    "Rank": "1521",
    "Name": "Juniper Networks",
    "Symbol": "JNPR",
    " marketcap ": " $11 228 335 104 ",
    "price (USD)": "34.55",
    "country": "United States"
  },
  {
    "Rank": "1522",
    "Name": "Banco Sabadell",
    "Symbol": "SAB.MC",
    " marketcap ": " $11 213 151 378 ",
    "price (USD)": "2.09143",
    "country": "Spain"
  },
  {
    "Rank": "1523",
    "Name": "Texas Roadhouse",
    "Symbol": "TXRH",
    " marketcap ": " $11 206 794 240 ",
    "price (USD)": "167.79",
    "country": "United States"
  },
  {
    "Rank": "1524",
    "Name": "Vivendi",
    "Symbol": "VIV.PA",
    " marketcap ": " $11 194 201 429 ",
    "price (USD)": "\u043e\u043a\u0442.04",
    "country": "France"
  },
  {
    "Rank": "1525",
    "Name": "Bath &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1526",
    "Name": "Regency Centers",
    "Symbol": "REG",
    " marketcap ": " $11 184 339 968 ",
    "price (USD)": "60.17",
    "country": "United States"
  },
  {
    "Rank": "1527",
    "Name": "TFI International",
    "Symbol": "TFII",
    " marketcap ": " $11 182 635 008 ",
    "price (USD)": "131.92",
    "country": "Canada"
  },
  {
    "Rank": "1528",
    "Name": "Wingstop Restaurants",
    "Symbol": "WING",
    " marketcap ": " $11 170 585 600 ",
    "price (USD)": "380.34",
    "country": "United States"
  },
  {
    "Rank": "1529",
    "Name": "ASR Nederland",
    "Symbol": "ASRNL.AS",
    " marketcap ": " $11 161 564 417 ",
    "price (USD)": "52.8613",
    "country": "Netherlands"
  },
  {
    "Rank": "1530",
    "Name": "Performance Food Group",
    "Symbol": "PFGC",
    " marketcap ": " $11 137 007 616 ",
    "price (USD)": "71.57",
    "country": "United States"
  },
  {
    "Rank": "1531",
    "Name": "Shinkin Central Bank",
    "Symbol": "8421.T",
    " marketcap ": " $11 132 443 781 ",
    "price (USD)": "1659.52",
    "country": "Japan"
  },
  {
    "Rank": "1532",
    "Name": "Shree Cement",
    "Symbol": "SHREECEM.NS",
    " marketcap ": " $11 127 870 990 ",
    "price (USD)": "308.416",
    "country": "India"
  },
  {
    "Rank": "1533",
    "Name": "American Financial Group",
    "Symbol": "AFG",
    " marketcap ": " $11 122 441 216 ",
    "price (USD)": "132.62",
    "country": "United States"
  },
  {
    "Rank": "1534",
    "Name": "Woodward",
    "Symbol": "WWD",
    " marketcap ": " $11 117 254 656 ",
    "price (USD)": "182.49",
    "country": "United States"
  },
  {
    "Rank": "1535",
    "Name": "Sirius XM",
    "Symbol": "SIRI",
    " marketcap ": " $11 116 761 088 ",
    "price (USD)": "\u0444\u0435\u0432.89",
    "country": "United States"
  },
  {
    "Rank": "1536",
    "Name": "Pershing Square Holdings",
    "Symbol": "PSHZF",
    " marketcap ": " $11 111 163 904 ",
    "price (USD)": "51.52",
    "country": "United States"
  },
  {
    "Rank": "1537",
    "Name": "Orient Overseas Container Line",
    "Symbol": "0316.HK",
    " marketcap ": " $11 110 681 261 ",
    "price (USD)": "16.8249",
    "country": "Hong Kong"
  },
  {
    "Rank": "1538",
    "Name": "Vodafone Idea",
    "Symbol": "IDEA.NS",
    " marketcap ": " $11 108 363 818 ",
    "price (USD)": "0.163409",
    "country": "India"
  },
  {
    "Rank": "1539",
    "Name": "Suntory",
    "Symbol": "2587.T",
    " marketcap ": " $11 105 892 289 ",
    "price (USD)": "35.9414",
    "country": "Japan"
  },
  {
    "Rank": "1540",
    "Name": "Bruker",
    "Symbol": "BRKR",
    " marketcap ": " $11 103 594 496 ",
    "price (USD)": "76.4",
    "country": "United States"
  },
  {
    "Rank": "1541",
    "Name": "Svenska Cellulosa Aktiebolaget (SCA)",
    "Symbol": "SCA-B.ST",
    " marketcap ": " $11 100 989 862 ",
    "price (USD)": "15.8048",
    "country": "Sweden"
  },
  {
    "Rank": "1542",
    "Name": "EPAM Systems",
    "Symbol": "EPAM",
    " marketcap ": " $11 088 183 296 ",
    "price (USD)": "191.26",
    "country": "United States"
  },
  {
    "Rank": "1543",
    "Name": "Bank Negara Indonesia",
    "Symbol": "BBNI.JK",
    " marketcap ": " $11 085 317 321 ",
    "price (USD)": "0.297612",
    "country": "Indonesia"
  },
  {
    "Rank": "1544",
    "Name": "ENN Energy",
    "Symbol": "2688.HK",
    " marketcap ": " $11 066 326 075 ",
    "price (USD)": "\u0441\u0435\u043d.12",
    "country": "China"
  },
  {
    "Rank": "1545",
    "Name": "China Eastern Airlines",
    "Symbol": "600115.SS",
    " marketcap ": " $11 055 779 170 ",
    "price (USD)": "0.559446",
    "country": "China"
  },
  {
    "Rank": "1546",
    "Name": "Kikkoman",
    "Symbol": "2801.T",
    " marketcap ": " $11 054 085 684 ",
    "price (USD)": "\u043d\u043e\u044f.79",
    "country": "Japan"
  },
  {
    "Rank": "1547",
    "Name": "Scentre Group",
    "Symbol": "SCG.AX",
    " marketcap ": " $11 050 518 724 ",
    "price (USD)": "2.12712",
    "country": "Australia"
  },
  {
    "Rank": "1548",
    "Name": "Elastic NV",
    "Symbol": "ESTC",
    " marketcap ": " $11 028 395 008 ",
    "price (USD)": "109.4",
    "country": "United States"
  },
  {
    "Rank": "1549",
    "Name": "International Consolidated Airlines",
    "Symbol": "BABWF",
    " marketcap ": " $11 023 054 848 ",
    "price (USD)": "\u0444\u0435\u0432.22",
    "country": "Spain"
  },
  {
    "Rank": "1550",
    "Name": "Accor",
    "Symbol": "AC.PA",
    " marketcap ": " $11 018 095 446 ",
    "price (USD)": "44.6737",
    "country": "France"
  },
  {
    "Rank": "1551",
    "Name": "Enel Am\u0413\u00a9ricas",
    "Symbol": "ENELAM.SN",
    " marketcap ": " $11 015 529 407 ",
    "price (USD)": "0.10268",
    "country": "Chile"
  },
  {
    "Rank": "1552",
    "Name": "EVE Energy",
    "Symbol": "300014.SZ",
    " marketcap ": " $11 009 524 974 ",
    "price (USD)": "5.38174",
    "country": "China"
  },
  {
    "Rank": "1553",
    "Name": "Boston Properties",
    "Symbol": "BXP",
    " marketcap ": " $10 987 128 832 ",
    "price (USD)": "62.35",
    "country": "United States"
  },
  {
    "Rank": "1554",
    "Name": "Dubai Islamic Bank",
    "Symbol": "DIB.AE",
    " marketcap ": " $10 980 280 038 ",
    "price (USD)": "1.51932",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1555",
    "Name": "Indus Towers",
    "Symbol": "INDUSTOWER.NS",
    " marketcap ": " $10 971 463 994 ",
    "price (USD)": "4.072",
    "country": "India"
  },
  {
    "Rank": "1556",
    "Name": "Reece Group",
    "Symbol": "REH.AX",
    " marketcap ": " $10 962 534 258 ",
    "price (USD)": "16.9703",
    "country": "Australia"
  },
  {
    "Rank": "1557",
    "Name": "NIO",
    "Symbol": "NIO",
    " marketcap ": " $10 956 907 520 ",
    "price (USD)": "\u043c\u0430\u0439.25",
    "country": "China"
  },
  {
    "Rank": "1558",
    "Name": "HF Sinclair",
    "Symbol": "DINO",
    " marketcap ": " $10 933 733 376 ",
    "price (USD)": "56.9",
    "country": "United States"
  },
  {
    "Rank": "1559",
    "Name": "Curtiss-Wright",
    "Symbol": "CW",
    " marketcap ": " $10 923 200 512 ",
    "price (USD)": "285.21",
    "country": "United States"
  },
  {
    "Rank": "1560",
    "Name": "TD Synnex",
    "Symbol": "SNX",
    " marketcap ": " $10 922 634 240 ",
    "price (USD)": "127.9",
    "country": "United States"
  },
  {
    "Rank": "1561",
    "Name": "China Zheshang Bank",
    "Symbol": "2016.HK",
    " marketcap ": " $10 922 087 217 ",
    "price (USD)": "0.299849",
    "country": "China"
  },
  {
    "Rank": "1562",
    "Name": "Swatch",
    "Symbol": "UHR.SW",
    " marketcap ": " $10 918 695 662 ",
    "price (USD)": "213.21",
    "country": "Switzerland"
  },
  {
    "Rank": "1563",
    "Name": "Nitto Denko",
    "Symbol": "6988.T",
    " marketcap ": " $10 914 745 689 ",
    "price (USD)": "77.6342",
    "country": "Japan"
  },
  {
    "Rank": "1564",
    "Name": "BOSCH India",
    "Symbol": "BOSCHLTD.NS",
    " marketcap ": " $10 909 705 326 ",
    "price (USD)": "369.892",
    "country": "India"
  },
  {
    "Rank": "1565",
    "Name": "Samvardhana Motherson",
    "Symbol": "MOTHERSON.NS",
    " marketcap ": " $10 877 836 971 ",
    "price (USD)": "1.60525",
    "country": "India"
  },
  {
    "Rank": "1566",
    "Name": "Ahli United Bank",
    "Symbol": "AUB.BH",
    " marketcap ": " $10 861 061 648 ",
    "price (USD)": "0",
    "country": "Bahrain"
  },
  {
    "Rank": "1567",
    "Name": "Torrent Pharmaceuticals",
    "Symbol": "TORNTPHARM.NS",
    " marketcap ": " $10 839 536 045 ",
    "price (USD)": "32.0275",
    "country": "India"
  },
  {
    "Rank": "1568",
    "Name": "Bajaj Holdings &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1569",
    "Name": "Ipsen",
    "Symbol": "IPN.PA",
    " marketcap ": " $10 830 673 089 ",
    "price (USD)": "130.524",
    "country": "France"
  },
  {
    "Rank": "1570",
    "Name": "Hua Nan Financial Holdings",
    "Symbol": "2880.TW",
    " marketcap ": " $10 830 560 550 ",
    "price (USD)": "0.793872",
    "country": "Taiwan"
  },
  {
    "Rank": "1571",
    "Name": "Wynn Resorts",
    "Symbol": "WYNN",
    " marketcap ": " $10 824 937 472 ",
    "price (USD)": "96.59",
    "country": "United States"
  },
  {
    "Rank": "1572",
    "Name": "Sysmex",
    "Symbol": "6869.T",
    " marketcap ": " $10 823 776 806 ",
    "price (USD)": "17.3597",
    "country": "Japan"
  },
  {
    "Rank": "1573",
    "Name": "SharkNinja",
    "Symbol": "SN",
    " marketcap ": " $10 823 390 208 ",
    "price (USD)": "77.41",
    "country": "United States"
  },
  {
    "Rank": "1574",
    "Name": "Allegion",
    "Symbol": "ALLE",
    " marketcap ": " $10 803 299 328 ",
    "price (USD)": "123.55",
    "country": "Ireland"
  },
  {
    "Rank": "1575",
    "Name": "Indian Railway Catering & Tourism",
    "Symbol": "IRCTC.NS",
    " marketcap ": " $10 802 744 636 ",
    "price (USD)": "13.5034",
    "country": "India"
  },
  {
    "Rank": "1576",
    "Name": "Empresas Copec",
    "Symbol": "COPEC.SN",
    " marketcap ": " $10 797 391 355 ",
    "price (USD)": "8.30664",
    "country": "Chile"
  },
  {
    "Rank": "1577",
    "Name": "Essential Utilities",
    "Symbol": "WTRG",
    " marketcap ": " $10 765 904 896 ",
    "price (USD)": "39.36",
    "country": "United States"
  },
  {
    "Rank": "1578",
    "Name": "Computershare",
    "Symbol": "CPU.AX",
    " marketcap ": " $10 756 815 193 ",
    "price (USD)": "17.9838",
    "country": "Australia"
  },
  {
    "Rank": "1579",
    "Name": "Ayala Corporation",
    "Symbol": "AYALY",
    " marketcap ": " $10 755 510 272 ",
    "price (USD)": "\u0441\u0435\u043d.85",
    "country": "Philippines"
  },
  {
    "Rank": "1580",
    "Name": "Ralph Lauren",
    "Symbol": "RL",
    " marketcap ": " $10 739 501 056 ",
    "price (USD)": "168",
    "country": "United States"
  },
  {
    "Rank": "1581",
    "Name": "Banco BPM",
    "Symbol": "BAMI.MI",
    " marketcap ": " $10 737 345 536 ",
    "price (USD)": "7.12129",
    "country": "Italy"
  },
  {
    "Rank": "1582",
    "Name": "Brenntag",
    "Symbol": "BNR.DE",
    " marketcap ": " $10 733 626 044 ",
    "price (USD)": "74.3403",
    "country": "Germany"
  },
  {
    "Rank": "1583",
    "Name": "Futu Holdings",
    "Symbol": "FUTU",
    " marketcap ": " $10 718 076 928 ",
    "price (USD)": "76.76",
    "country": "Hong Kong"
  },
  {
    "Rank": "1584",
    "Name": "BJ's Wholesale Club",
    "Symbol": "BJ",
    " marketcap ": " $10 687 623 168 ",
    "price (USD)": "80.47",
    "country": "United States"
  },
  {
    "Rank": "1585",
    "Name": "Antero Resources",
    "Symbol": "AR",
    " marketcap ": " $10 685 545 472 ",
    "price (USD)": "34.38",
    "country": "United States"
  },
  {
    "Rank": "1586",
    "Name": "Rakuten",
    "Symbol": "4755.T",
    " marketcap ": " $10 674 315 648 ",
    "price (USD)": "4.97665",
    "country": "Japan"
  },
  {
    "Rank": "1587",
    "Name": "Etihad Etisalat (Mobily)",
    "Symbol": "7020.SR",
    " marketcap ": " $10 664 478 646 ",
    "price (USD)": "13.85",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "1588",
    "Name": "AngloGold Ashanti",
    "Symbol": "AU",
    " marketcap ": " $10 656 944 128 ",
    "price (USD)": "25.39",
    "country": "South Africa"
  },
  {
    "Rank": "1589",
    "Name": "Akbank",
    "Symbol": "AKBNK.IS",
    " marketcap ": " $10 628 364 940 ",
    "price (USD)": "2.04392",
    "country": "Turkey"
  },
  {
    "Rank": "1590",
    "Name": "Grupo Aeroportuario del Sureste",
    "Symbol": "ASR",
    " marketcap ": " $10 616 449 024 ",
    "price (USD)": "345.94",
    "country": "Mexico"
  },
  {
    "Rank": "1591",
    "Name": "Hotai Motor",
    "Symbol": "2207.TW",
    " marketcap ": " $10 607 535 542 ",
    "price (USD)": "19.0405",
    "country": "Taiwan"
  },
  {
    "Rank": "1592",
    "Name": "Demant",
    "Symbol": "DEMANT.CO",
    " marketcap ": " $10 583 712 511 ",
    "price (USD)": "47.9874",
    "country": "Denmark"
  },
  {
    "Rank": "1593",
    "Name": "East West Bancorp",
    "Symbol": "EWBC",
    " marketcap ": " $10 577 650 688 ",
    "price (USD)": "76.02",
    "country": "United States"
  },
  {
    "Rank": "1594",
    "Name": "Solar Industries India",
    "Symbol": "SOLARINDS.NS",
    " marketcap ": " $10 573 904 478 ",
    "price (USD)": "116.852",
    "country": "India"
  },
  {
    "Rank": "1595",
    "Name": "Shriram Transport Finance",
    "Symbol": "SHRIRAMFIN.NS",
    " marketcap ": " $10 567 576 636 ",
    "price (USD)": "28.1159",
    "country": "India"
  },
  {
    "Rank": "1596",
    "Name": "Mashreqbank",
    "Symbol": "MASQ.AE",
    " marketcap ": " $10 542 034 693 ",
    "price (USD)": "52.5499",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1597",
    "Name": "Grupo ACS",
    "Symbol": "ACS.MC",
    " marketcap ": " $10 523 020 523 ",
    "price (USD)": "42.6974",
    "country": "Spain"
  },
  {
    "Rank": "1598",
    "Name": "Emera",
    "Symbol": "EMA.TO",
    " marketcap ": " $10 502 047 752 ",
    "price (USD)": "36.6436",
    "country": "Canada"
  },
  {
    "Rank": "1599",
    "Name": "Regal Rexnord",
    "Symbol": "RRX",
    " marketcap ": " $10 499 992 576 ",
    "price (USD)": "157.85",
    "country": "United States"
  },
  {
    "Rank": "1600",
    "Name": "Metso",
    "Symbol": "METSO.HE",
    " marketcap ": " $10 497 492 245 ",
    "price (USD)": "\u0434\u0435\u043a.87",
    "country": "Finland"
  },
  {
    "Rank": "1601",
    "Name": "Bank Pekao (Bank Polska Kasa Opieki)",
    "Symbol": "PEO.WA",
    " marketcap ": " $10 453 620 480 ",
    "price (USD)": "39.8279",
    "country": "Poland"
  },
  {
    "Rank": "1602",
    "Name": "Paycom",
    "Symbol": "PAYC",
    " marketcap ": " $10 440 623 104 ",
    "price (USD)": "179.67",
    "country": "United States"
  },
  {
    "Rank": "1603",
    "Name": "Wharf Holdings",
    "Symbol": "0004.HK",
    " marketcap ": " $10 436 177 801 ",
    "price (USD)": "3.41495",
    "country": "Hong Kong"
  },
  {
    "Rank": "1604",
    "Name": "Skechers",
    "Symbol": "SKX",
    " marketcap ": " $10 430 637 056 ",
    "price (USD)": "68.39",
    "country": "United States"
  },
  {
    "Rank": "1605",
    "Name": "Sabesp",
    "Symbol": "SBS",
    " marketcap ": " $10 418 004 992 ",
    "price (USD)": "14.98",
    "country": "Brazil"
  },
  {
    "Rank": "1606",
    "Name": "CyberArk",
    "Symbol": "CYBR",
    " marketcap ": " $10 402 030 592 ",
    "price (USD)": "245.84",
    "country": "Israel"
  },
  {
    "Rank": "1607",
    "Name": "Wise PLC",
    "Symbol": "WISE.L",
    " marketcap ": " $10 396 715 339 ",
    "price (USD)": "10.1453",
    "country": "United Kingdom"
  },
  {
    "Rank": "1608",
    "Name": "Vodacom",
    "Symbol": "VOD.JO",
    " marketcap ": " $10 395 176 700 ",
    "price (USD)": "5.34674",
    "country": "South Africa"
  },
  {
    "Rank": "1609",
    "Name": "Penske Automotive",
    "Symbol": "PAG",
    " marketcap ": " $10 360 940 544 ",
    "price (USD)": "154.92",
    "country": "United States"
  },
  {
    "Rank": "1610",
    "Name": "Crown Holdings",
    "Symbol": "CCK",
    " marketcap ": " $10 352 497 664 ",
    "price (USD)": "85.73",
    "country": "United States"
  },
  {
    "Rank": "1611",
    "Name": "Twilio",
    "Symbol": "TWLO",
    " marketcap ": " $10 347 347 968 ",
    "price (USD)": "60.45",
    "country": "United States"
  },
  {
    "Rank": "1612",
    "Name": "Admiral Group",
    "Symbol": "ADM.L",
    " marketcap ": " $10 325 309 900 ",
    "price (USD)": "34.8348",
    "country": "United Kingdom"
  },
  {
    "Rank": "1613",
    "Name": "Eiffage",
    "Symbol": "FGR.PA",
    " marketcap ": " $10 290 506 140 ",
    "price (USD)": "110.653",
    "country": "France"
  },
  {
    "Rank": "1614",
    "Name": "Guidewire Software",
    "Symbol": "GWRE",
    " marketcap ": " $10 281 947 136 ",
    "price (USD)": "123.4",
    "country": "United States"
  },
  {
    "Rank": "1615",
    "Name": "Procore",
    "Symbol": "PCOR",
    " marketcap ": " $10 277 867 520 ",
    "price (USD)": "70.24",
    "country": "United States"
  },
  {
    "Rank": "1616",
    "Name": "Autoliv",
    "Symbol": "ALV",
    " marketcap ": " $10 274 357 248 ",
    "price (USD)": "126.26",
    "country": "Sweden"
  },
  {
    "Rank": "1617",
    "Name": "Wharf REIC",
    "Symbol": "1997.HK",
    " marketcap ": " $10 271 295 001 ",
    "price (USD)": "3.38291",
    "country": "Hong Kong"
  },
  {
    "Rank": "1618",
    "Name": "Covestro",
    "Symbol": "1COV.F",
    " marketcap ": " $10 253 933 917 ",
    "price (USD)": "53.8604",
    "country": "Germany"
  },
  {
    "Rank": "1619",
    "Name": "Mineral Resources",
    "Symbol": "MIN.AX",
    " marketcap ": " $10 247 705 537 ",
    "price (USD)": "52.2978",
    "country": "Australia"
  },
  {
    "Rank": "1620",
    "Name": "Seven Group Holdings",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": " (SGH)\"",
    "Name": "SVW.AX",
    "Symbol": "10241939187",
    " marketcap ": " 26.0989 ",
    "price (USD)": "Australia",
    "country": null
  },
  {
    "Rank": "1621",
    "Name": "Fisher & Paykel Healthcare",
    "Symbol": "FPH.NZ",
    " marketcap ": " $10 239 865 742 ",
    "price (USD)": "17.5346",
    "country": "New Zealand"
  },
  {
    "Rank": "1622",
    "Name": "GAC (Guangzhou Automobile Group)",
    "Symbol": "601238.SS",
    " marketcap ": " $10 239 446 647 ",
    "price (USD)": "1.19901",
    "country": "China"
  },
  {
    "Rank": "1623",
    "Name": "Wistron Corporation",
    "Symbol": "3231.TW",
    " marketcap ": " $10 237 805 991 ",
    "price (USD)": "3.56622",
    "country": "Taiwan"
  },
  {
    "Rank": "1624",
    "Name": "Yaskawa",
    "Symbol": "6506.T",
    " marketcap ": " $10 232 286 622 ",
    "price (USD)": "39.1466",
    "country": "Japan"
  },
  {
    "Rank": "1625",
    "Name": "Rexford Industrial",
    "Symbol": "REXR",
    " marketcap ": " $10 228 926 464 ",
    "price (USD)": "45.8",
    "country": "United States"
  },
  {
    "Rank": "1626",
    "Name": "Dino Polska",
    "Symbol": "DNP.WA",
    " marketcap ": " $10 220 638 251 ",
    "price (USD)": "104.25",
    "country": "Poland"
  },
  {
    "Rank": "1627",
    "Name": "NIBE Industrier",
    "Symbol": "NIBE-B.ST",
    " marketcap ": " $10 212 965 545 ",
    "price (USD)": "5.06578",
    "country": "Sweden"
  },
  {
    "Rank": "1628",
    "Name": "INWIT",
    "Symbol": "INW.MI",
    " marketcap ": " $10 210 811 163 ",
    "price (USD)": "\u043e\u043a\u0442.55",
    "country": "Italy"
  },
  {
    "Rank": "1629",
    "Name": "Insurance Australia Group",
    "Symbol": "IAG.AX",
    " marketcap ": " $10 210 011 565 ",
    "price (USD)": "4.30759",
    "country": "Australia"
  },
  {
    "Rank": "1630",
    "Name": "Service Corporation International",
    "Symbol": "SCI",
    " marketcap ": " $10 207 400 960 ",
    "price (USD)": "70.1",
    "country": "United States"
  },
  {
    "Rank": "1631",
    "Name": "Formosa Chemicals &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1632",
    "Name": "\u0432\u0402\u045aK\u0432\u0402\u045c Line",
    "Symbol": "9107.T",
    " marketcap ": " $10 192 074 493 ",
    "price (USD)": "14.4169",
    "country": "Japan"
  },
  {
    "Rank": "1633",
    "Name": "Mankind Pharma",
    "Symbol": "MANKIND.NS",
    " marketcap ": " $10 188 146 678 ",
    "price (USD)": "25.4329",
    "country": "India"
  },
  {
    "Rank": "1634",
    "Name": "Evonik Industries",
    "Symbol": "EVK.DE",
    " marketcap ": " $10 176 197 094 ",
    "price (USD)": "21.8373",
    "country": "Germany"
  },
  {
    "Rank": "1635",
    "Name": "Melrose Industries",
    "Symbol": "MRO.L",
    " marketcap ": " $10 171 747 654 ",
    "price (USD)": "7.80096",
    "country": "United Kingdom"
  },
  {
    "Rank": "1636",
    "Name": "F5 Networks",
    "Symbol": "FFIV",
    " marketcap ": " $10 165 561 344 ",
    "price (USD)": "173.44",
    "country": "United States"
  },
  {
    "Rank": "1637",
    "Name": "Apollo Hospitals",
    "Symbol": "APOLLOHOSP.NS",
    " marketcap ": " $10 158 172 496 ",
    "price (USD)": "70.6483",
    "country": "India"
  },
  {
    "Rank": "1638",
    "Name": "Celcomdigi",
    "Symbol": "6947.KL",
    " marketcap ": " $10 148 053 592 ",
    "price (USD)": "0.865026",
    "country": "Malaysia"
  },
  {
    "Rank": "1639",
    "Name": "Daiwa Securities Group",
    "Symbol": "8601.T",
    " marketcap ": " $10 125 901 203 ",
    "price (USD)": "7.22603",
    "country": "Japan"
  },
  {
    "Rank": "1640",
    "Name": "Lundin Mining",
    "Symbol": "LUN.TO",
    " marketcap ": " $10 121 433 871 ",
    "price (USD)": "13.043",
    "country": "Canada"
  },
  {
    "Rank": "1641",
    "Name": "Kinross Gold",
    "Symbol": "KGC",
    " marketcap ": " $10 111 669 248 ",
    "price (USD)": "\u0430\u0432\u0433.22",
    "country": "Canada"
  },
  {
    "Rank": "1642",
    "Name": "CapitaLand Investment Limited",
    "Symbol": "9CI.SI",
    " marketcap ": " $10 106 163 477 ",
    "price (USD)": "1.98968",
    "country": "Singapore"
  },
  {
    "Rank": "1643",
    "Name": "Annaly Capital Management",
    "Symbol": "NLY",
    " marketcap ": " $10 093 875 200 ",
    "price (USD)": "20.17",
    "country": "United States"
  },
  {
    "Rank": "1644",
    "Name": "Lattice Semiconductor",
    "Symbol": "LSCC",
    " marketcap ": " $10 080 746 496 ",
    "price (USD)": "73.29",
    "country": "United States"
  },
  {
    "Rank": "1645",
    "Name": "Saia",
    "Symbol": "SAIA",
    " marketcap ": " $10 064 414 720 ",
    "price (USD)": "379.52",
    "country": "United States"
  },
  {
    "Rank": "1646",
    "Name": "United Spirits",
    "Symbol": "UNITDSPR.BO",
    " marketcap ": " $10 057 130 181 ",
    "price (USD)": "14.1781",
    "country": "India"
  },
  {
    "Rank": "1647",
    "Name": "Yap\u0414\u00b1 Kredi",
    "Symbol": "YKBNK.IS",
    " marketcap ": " $10 049 420 619 ",
    "price (USD)": "1.1897",
    "country": "Turkey"
  },
  {
    "Rank": "1648",
    "Name": "APi Group",
    "Symbol": "APG",
    " marketcap ": " $10 044 390 400 ",
    "price (USD)": "36.62",
    "country": "United States"
  },
  {
    "Rank": "1649",
    "Name": "Euronext",
    "Symbol": "ENX.PA",
    " marketcap ": " $10 043 075 982 ",
    "price (USD)": "94.9072",
    "country": "Netherlands"
  },
  {
    "Rank": "1650",
    "Name": "Kanzhun",
    "Symbol": "BZ",
    " marketcap ": " $10 036 024 320 ",
    "price (USD)": "21.98",
    "country": "China"
  },
  {
    "Rank": "1651",
    "Name": "Taiwan Mobile",
    "Symbol": "3045.TW",
    " marketcap ": " $10 035 741 243 ",
    "price (USD)": "3.31814",
    "country": "Taiwan"
  },
  {
    "Rank": "1652",
    "Name": "Teleflex",
    "Symbol": "TFX",
    " marketcap ": " $10 032 382 976 ",
    "price (USD)": "212.99",
    "country": "United States"
  },
  {
    "Rank": "1653",
    "Name": "Intertek",
    "Symbol": "ITRK.L",
    " marketcap ": " $10 028 593 737 ",
    "price (USD)": "62.2449",
    "country": "United Kingdom"
  },
  {
    "Rank": "1654",
    "Name": "Confluent",
    "Symbol": "CFLT",
    " marketcap ": " $10 024 516 608 ",
    "price (USD)": "31.54",
    "country": "United States"
  },
  {
    "Rank": "1655",
    "Name": "HELLA",
    "Symbol": "HLE.F",
    " marketcap ": " $10 014 347 495 ",
    "price (USD)": "90.1292",
    "country": "Germany"
  },
  {
    "Rank": "1656",
    "Name": "Max Healthcare Institute",
    "Symbol": "MAXHEALTH.NS",
    " marketcap ": " $10 012 050 999 ",
    "price (USD)": "\u043e\u043a\u0442.95",
    "country": "India"
  },
  {
    "Rank": "1657",
    "Name": "Jefferies Financial Group",
    "Symbol": "JEF",
    " marketcap ": " $10 010 597 376 ",
    "price (USD)": "47.21",
    "country": "United States"
  },
  {
    "Rank": "1658",
    "Name": "GBL",
    "Symbol": "GBLB.VI",
    " marketcap ": " $10 009 956 382 ",
    "price (USD)": "77.5328",
    "country": "Belgium"
  },
  {
    "Rank": "1659",
    "Name": "Huntington Ingalls Industries",
    "Symbol": "HII",
    " marketcap ": " $10 006 593 536 ",
    "price (USD)": "253.76",
    "country": "United States"
  },
  {
    "Rank": "1660",
    "Name": "Rivian",
    "Symbol": "RIVN",
    " marketcap ": " $10 002 966 528 ",
    "price (USD)": "10.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "1661",
    "Name": "Unum",
    "Symbol": "UNM",
    " marketcap ": " $9 989 953 536 ",
    "price (USD)": "52.75",
    "country": "United States"
  },
  {
    "Rank": "1662",
    "Name": "Qiagen",
    "Symbol": "QGEN",
    " marketcap ": " $9 987 552 256 ",
    "price (USD)": "45.02",
    "country": "Netherlands"
  },
  {
    "Rank": "1663",
    "Name": "Allegro.eu",
    "Symbol": "ALE.WA",
    " marketcap ": " $9 984 739 573 ",
    "price (USD)": "9.46726",
    "country": "Poland"
  },
  {
    "Rank": "1664",
    "Name": "Thai Beverage",
    "Symbol": "TBVPF",
    " marketcap ": " $9 983 235 072 ",
    "price (USD)": "0.3973",
    "country": "Thailand"
  },
  {
    "Rank": "1665",
    "Name": "Churchill Downs",
    "Symbol": "CHDN",
    " marketcap ": " $9 982 675 968 ",
    "price (USD)": "135.47",
    "country": "United States"
  },
  {
    "Rank": "1666",
    "Name": "Oracle Corp Japan",
    "Symbol": "4716.T",
    " marketcap ": " $9 979 434 467 ",
    "price (USD)": "77.8901",
    "country": "Japan"
  },
  {
    "Rank": "1667",
    "Name": "ICICI Prulife",
    "Symbol": "ICICIPRULI.NS",
    " marketcap ": " $9 978 803 843 ",
    "price (USD)": "6.92323",
    "country": "India"
  },
  {
    "Rank": "1668",
    "Name": "Affirm",
    "Symbol": "AFRM",
    " marketcap ": " $9 978 554 368 ",
    "price (USD)": "32.28",
    "country": "United States"
  },
  {
    "Rank": "1669",
    "Name": "Zillow",
    "Symbol": "Z",
    " marketcap ": " $9 965 201 408 ",
    "price (USD)": "42.33",
    "country": "United States"
  },
  {
    "Rank": "1670",
    "Name": "Centrica",
    "Symbol": "CNA.L",
    " marketcap ": " $9 956 157 229 ",
    "price (USD)": "1.87396",
    "country": "United Kingdom"
  },
  {
    "Rank": "1671",
    "Name": "SCB (Siam Commercial Bank)",
    "Symbol": "SCB.BK",
    " marketcap ": " $9 952 550 699 ",
    "price (USD)": "2.95581",
    "country": "Thailand"
  },
  {
    "Rank": "1672",
    "Name": "CapitaLand Mall Trust",
    "Symbol": "C38U.SI",
    " marketcap ": " $9 949 719 814 ",
    "price (USD)": "1.47741",
    "country": "Singapore"
  },
  {
    "Rank": "1673",
    "Name": "Catalent",
    "Symbol": "CTLT",
    " marketcap ": " $9 946 660 864 ",
    "price (USD)": "54.96",
    "country": "United States"
  },
  {
    "Rank": "1674",
    "Name": "SKF (Svenska Kullagerfabriken)",
    "Symbol": "SKF-B.ST",
    " marketcap ": " $9 945 287 136 ",
    "price (USD)": "21.8469",
    "country": "Sweden"
  },
  {
    "Rank": "1675",
    "Name": "Grupo Aeroportuario del Pac\u0413\u00adfico",
    "Symbol": "PAC",
    " marketcap ": " $9 943 299 072 ",
    "price (USD)": "194.72",
    "country": "Mexico"
  },
  {
    "Rank": "1676",
    "Name": "The Mosaic Company",
    "Symbol": "MOS",
    " marketcap ": " $9 918 187 520 ",
    "price (USD)": "30.86",
    "country": "United States"
  },
  {
    "Rank": "1677",
    "Name": "FinecoBank",
    "Symbol": "FBK.MI",
    " marketcap ": " $9 917 715 209 ",
    "price (USD)": "16.2341",
    "country": "Italy"
  },
  {
    "Rank": "1678",
    "Name": "Info Edge",
    "Symbol": "NAUKRI.NS",
    " marketcap ": " $9 915 815 986 ",
    "price (USD)": "76.7912",
    "country": "India"
  },
  {
    "Rank": "1679",
    "Name": "Sino Land",
    "Symbol": "0083.HK",
    " marketcap ": " $9 908 928 015 ",
    "price (USD)": "1.14558",
    "country": "Hong Kong"
  },
  {
    "Rank": "1680",
    "Name": "Meridian Energy",
    "Symbol": "MEZ.AX",
    " marketcap ": " $9 906 052 875 ",
    "price (USD)": "3.80081",
    "country": "New Zealand"
  },
  {
    "Rank": "1681",
    "Name": "Severn Trent",
    "Symbol": "SVT.L",
    " marketcap ": " $9 901 834 080 ",
    "price (USD)": "33.1058",
    "country": "United Kingdom"
  },
  {
    "Rank": "1682",
    "Name": "West Japan Railway",
    "Symbol": "9021.T",
    " marketcap ": " $9 893 313 177 ",
    "price (USD)": "20.2866",
    "country": "Japan"
  },
  {
    "Rank": "1683",
    "Name": "Exact Sciences",
    "Symbol": "EXAS",
    " marketcap ": " $9 876 045 824 ",
    "price (USD)": "53.52",
    "country": "United States"
  },
  {
    "Rank": "1684",
    "Name": "Rational AG",
    "Symbol": "RAA.F",
    " marketcap ": " $9 871 120 643 ",
    "price (USD)": "868.172",
    "country": "Germany"
  },
  {
    "Rank": "1685",
    "Name": "Telia Company",
    "Symbol": "TELIA.ST",
    " marketcap ": " $9 849 184 140 ",
    "price (USD)": "2.50481",
    "country": "Sweden"
  },
  {
    "Rank": "1686",
    "Name": "AptarGroup",
    "Symbol": "ATR",
    " marketcap ": " $9 846 108 160 ",
    "price (USD)": "148.59",
    "country": "United States"
  },
  {
    "Rank": "1687",
    "Name": "Indian Hotels Company",
    "Symbol": "INDHOTEL.NS",
    " marketcap ": " $9 829 940 491 ",
    "price (USD)": "6.90581",
    "country": "India"
  },
  {
    "Rank": "1688",
    "Name": "CubeSmart",
    "Symbol": "CUBE",
    " marketcap ": " $9 821 989 888 ",
    "price (USD)": "43.41",
    "country": "United States"
  },
  {
    "Rank": "1689",
    "Name": "Boliden",
    "Symbol": "BOL.ST",
    " marketcap ": " $9 768 055 855 ",
    "price (USD)": "35.7188",
    "country": "Sweden"
  },
  {
    "Rank": "1690",
    "Name": "ICICI Lombard",
    "Symbol": "ICICIGI.NS",
    " marketcap ": " $9 748 775 443 ",
    "price (USD)": "19.7742",
    "country": "India"
  },
  {
    "Rank": "1691",
    "Name": "Barry Callebaut",
    "Symbol": "BARN.SW",
    " marketcap ": " $9 742 287 301 ",
    "price (USD)": "1779.86",
    "country": "Switzerland"
  },
  {
    "Rank": "1692",
    "Name": "Paylocity",
    "Symbol": "PCTY",
    " marketcap ": " $9 738 913 792 ",
    "price (USD)": "172.58",
    "country": "United States"
  },
  {
    "Rank": "1693",
    "Name": "Aisin Seiki",
    "Symbol": "7259.T",
    " marketcap ": " $9 737 435 520 ",
    "price (USD)": "36.1269",
    "country": "Japan"
  },
  {
    "Rank": "1694",
    "Name": "Tapestry",
    "Symbol": "TPR",
    " marketcap ": " $9 730 885 632 ",
    "price (USD)": "42.35",
    "country": "United States"
  },
  {
    "Rank": "1695",
    "Name": "Sagax",
    "Symbol": "SAGA-B.ST",
    " marketcap ": " $9 704 404 326 ",
    "price (USD)": "27.5754",
    "country": "Sweden"
  },
  {
    "Rank": "1696",
    "Name": "Getlink",
    "Symbol": "GET.PA",
    " marketcap ": " $9 699 977 605 ",
    "price (USD)": "17.8738",
    "country": "France"
  },
  {
    "Rank": "1697",
    "Name": "Reddit",
    "Symbol": "RDDT",
    " marketcap ": " $9 697 718 272 ",
    "price (USD)": "59.31",
    "country": "United States"
  },
  {
    "Rank": "1698",
    "Name": "Konami Holdings",
    "Symbol": "9766.T",
    " marketcap ": " $9 682 714 155 ",
    "price (USD)": "71.4286",
    "country": "Japan"
  },
  {
    "Rank": "1699",
    "Name": "C. H. Robinson",
    "Symbol": "CHRW",
    " marketcap ": " $9 672 046 592 ",
    "price (USD)": "82.6",
    "country": "United States"
  },
  {
    "Rank": "1700",
    "Name": "Full Truck Alliance",
    "Symbol": "YMM",
    " marketcap ": " $9 662 730 240 ",
    "price (USD)": "\u0441\u0435\u043d.24",
    "country": "China"
  },
  {
    "Rank": "1701",
    "Name": "Localiza",
    "Symbol": "RENT3.SA",
    " marketcap ": " $9 659 736 932 ",
    "price (USD)": "9.10102",
    "country": "Brazil"
  },
  {
    "Rank": "1702",
    "Name": "Red El\u0413\u00a9ctrica",
    "Symbol": "RED.MC",
    " marketcap ": " $9 644 355 357 ",
    "price (USD)": "17.8738",
    "country": "Spain"
  },
  {
    "Rank": "1703",
    "Name": "Randstad",
    "Symbol": "RAND.AS",
    " marketcap ": " $9 640 713 702 ",
    "price (USD)": "54.3816",
    "country": "Netherlands"
  },
  {
    "Rank": "1704",
    "Name": "Bupa Arabia for Cooperative Insurance Company",
    "Symbol": "8210.SR",
    " marketcap ": " $9 630 934 102 ",
    "price (USD)": "64.2062",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "1705",
    "Name": "Wix.com",
    "Symbol": "WIX",
    " marketcap ": " $9 626 723 328 ",
    "price (USD)": "173",
    "country": "Israel"
  },
  {
    "Rank": "1706",
    "Name": "Mowi",
    "Symbol": "MNHVF",
    " marketcap ": " $9 611 794 432 ",
    "price (USD)": "18.015",
    "country": "Norway"
  },
  {
    "Rank": "1707",
    "Name": "Everbright Securities Company",
    "Symbol": "6178.HK",
    " marketcap ": " $9 598 444 861 ",
    "price (USD)": "0.747059",
    "country": "Hong Kong"
  },
  {
    "Rank": "1708",
    "Name": "Indutrade",
    "Symbol": "INDT.ST",
    " marketcap ": " $9 589 377 634 ",
    "price (USD)": "26.3211",
    "country": "Sweden"
  },
  {
    "Rank": "1709",
    "Name": "Isuzu",
    "Symbol": "7202.T",
    " marketcap ": " $9 580 065 265 ",
    "price (USD)": "\u0434\u0435\u043a.51",
    "country": "Japan"
  },
  {
    "Rank": "1710",
    "Name": "National Mineral Development Corporation",
    "Symbol": "NMDC.NS",
    " marketcap ": " $9 577 732 359 ",
    "price (USD)": "3.26817",
    "country": "India"
  },
  {
    "Rank": "1711",
    "Name": "WESCO International",
    "Symbol": "WCC",
    " marketcap ": " $9 570 837 504 ",
    "price (USD)": "188.3",
    "country": "United States"
  },
  {
    "Rank": "1712",
    "Name": "Chubu Electric Power",
    "Symbol": "9502.T",
    " marketcap ": " $9 570 479 927 ",
    "price (USD)": "\u0434\u0435\u043a.75",
    "country": "Japan"
  },
  {
    "Rank": "1713",
    "Name": "Yamaha Motor",
    "Symbol": "7272.T",
    " marketcap ": " $9 569 326 936 ",
    "price (USD)": "9.74666",
    "country": "Japan"
  },
  {
    "Rank": "1714",
    "Name": "Trex",
    "Symbol": "TREX",
    " marketcap ": " $9 559 548 928 ",
    "price (USD)": "87.95",
    "country": "United States"
  },
  {
    "Rank": "1715",
    "Name": "Advantech",
    "Symbol": "2395.TW",
    " marketcap ": " $9 552 527 337 ",
    "price (USD)": "11.1018",
    "country": "Taiwan"
  },
  {
    "Rank": "1716",
    "Name": "Korea Electric Power",
    "Symbol": "KEP",
    " marketcap ": " $9 552 439 296 ",
    "price (USD)": "\u0438\u044e\u043b.44",
    "country": "South Korea"
  },
  {
    "Rank": "1717",
    "Name": "Amdocs",
    "Symbol": "DOX",
    " marketcap ": " $9 521 422 336 ",
    "price (USD)": "82.14",
    "country": "United States"
  },
  {
    "Rank": "1718",
    "Name": "CACI",
    "Symbol": "CACI",
    " marketcap ": " $9 518 110 720 ",
    "price (USD)": "426.89",
    "country": "United States"
  },
  {
    "Rank": "1719",
    "Name": "Jones Lang LaSalle",
    "Symbol": "JLL",
    " marketcap ": " $9 513 526 272 ",
    "price (USD)": "200.03",
    "country": "United States"
  },
  {
    "Rank": "1720",
    "Name": "Linde India",
    "Symbol": "LINDEINDIA.NS",
    " marketcap ": " $9 511 227 022 ",
    "price (USD)": "111.524",
    "country": "India"
  },
  {
    "Rank": "1721",
    "Name": "Celulosa Argentina",
    "Symbol": "CELU.BA",
    " marketcap ": " $9 503 387 008 ",
    "price (USD)": "0.941507",
    "country": "Argentina"
  },
  {
    "Rank": "1722",
    "Name": "InPost",
    "Symbol": "INPST.AS",
    " marketcap ": " $9 498 115 391 ",
    "price (USD)": "19.0031",
    "country": "Luxembourg"
  },
  {
    "Rank": "1723",
    "Name": "ST Engineering",
    "Symbol": "S63.SI",
    " marketcap ": " $9 496 007 115 ",
    "price (USD)": "3.04391",
    "country": "Singapore"
  },
  {
    "Rank": "1724",
    "Name": "Healthpeak Properties",
    "Symbol": "PEAK",
    " marketcap ": " $9 495 476 224 ",
    "price (USD)": "17.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "1725",
    "Name": "Brookfield Property Partners",
    "Symbol": "BPYPP",
    " marketcap ": " $9 469 736 960 ",
    "price (USD)": "14.33",
    "country": "Bermuda"
  },
  {
    "Rank": "1726",
    "Name": "Zoomlion",
    "Symbol": "1157.HK",
    " marketcap ": " $9 463 783 717 ",
    "price (USD)": "0.754748",
    "country": "China"
  },
  {
    "Rank": "1727",
    "Name": "Mizrahi-Tefahot",
    "Symbol": "MZTF.TA",
    " marketcap ": " $9 458 313 159 ",
    "price (USD)": "36.6219",
    "country": "Israel"
  },
  {
    "Rank": "1728",
    "Name": "Trelleborg AB",
    "Symbol": "TREL-B.ST",
    " marketcap ": " $9 453 926 629 ",
    "price (USD)": "39.5565",
    "country": "Sweden"
  },
  {
    "Rank": "1729",
    "Name": "ASICS Corporation",
    "Symbol": "7936.T",
    " marketcap ": " $9 453 767 064 ",
    "price (USD)": "52.2807",
    "country": "Japan"
  },
  {
    "Rank": "1730",
    "Name": "Dayforce",
    "Symbol": "DAY",
    " marketcap ": " $9 443 946 600 ",
    "price (USD)": "61.05",
    "country": "United States"
  },
  {
    "Rank": "1731",
    "Name": "ageas",
    "Symbol": "AGS.BR",
    " marketcap ": " $9 429 867 999 ",
    "price (USD)": "51.3411",
    "country": "Belgium"
  },
  {
    "Rank": "1732",
    "Name": "Sumitomo Metal Mining",
    "Symbol": "5713.T",
    " marketcap ": " $9 425 265 130 ",
    "price (USD)": "34.3036",
    "country": "Japan"
  },
  {
    "Rank": "1733",
    "Name": "Banco Santander-Chile",
    "Symbol": "BSAC",
    " marketcap ": " $9 423 821 824 ",
    "price (USD)": "19.95",
    "country": "Chile"
  },
  {
    "Rank": "1734",
    "Name": "Houlihan Lokey",
    "Symbol": "HLI",
    " marketcap ": " $9 411 458 048 ",
    "price (USD)": "136.21",
    "country": "United States"
  },
  {
    "Rank": "1735",
    "Name": "Godrej Properties",
    "Symbol": "GODREJPROP.NS",
    " marketcap ": " $9 395 538 383 ",
    "price (USD)": "33.7919",
    "country": "India"
  },
  {
    "Rank": "1736",
    "Name": "Marico",
    "Symbol": "MARICO.NS",
    " marketcap ": " $9 394 046 978 ",
    "price (USD)": "7.25846",
    "country": "India"
  },
  {
    "Rank": "1737",
    "Name": "Far EasTone",
    "Symbol": "4904.TW",
    " marketcap ": " $9 392 464 400 ",
    "price (USD)": "2.60489",
    "country": "Taiwan"
  },
  {
    "Rank": "1738",
    "Name": "PMetal (Press Metal Aluminium)",
    "Symbol": "8869.KL",
    " marketcap ": " $9 392 131 054 ",
    "price (USD)": "1.13987",
    "country": "Malaysia"
  },
  {
    "Rank": "1739",
    "Name": "Henry Schein",
    "Symbol": "HSIC",
    " marketcap ": " $9 379 735 552 ",
    "price (USD)": "73.25",
    "country": "United States"
  },
  {
    "Rank": "1740",
    "Name": "Qorvo",
    "Symbol": "QRVO",
    " marketcap ": " $9 370 695 680 ",
    "price (USD)": "97.99",
    "country": "United States"
  },
  {
    "Rank": "1741",
    "Name": "CCL Industries",
    "Symbol": "CCL-B.TO",
    " marketcap ": " $9 361 644 565 ",
    "price (USD)": "52.1427",
    "country": "Canada"
  },
  {
    "Rank": "1742",
    "Name": "United Utilities",
    "Symbol": "UU.L",
    " marketcap ": " $9 349 660 140 ",
    "price (USD)": "13.7114",
    "country": "United Kingdom"
  },
  {
    "Rank": "1743",
    "Name": "Generac Power Systems",
    "Symbol": "GNRC",
    " marketcap ": " $9 348 558 848 ",
    "price (USD)": "154.23",
    "country": "United States"
  },
  {
    "Rank": "1744",
    "Name": "Lupin Limited",
    "Symbol": "LUPIN.NS",
    " marketcap ": " $9 342 344 665 ",
    "price (USD)": "20.4933",
    "country": "India"
  },
  {
    "Rank": "1745",
    "Name": "YTL Power International",
    "Symbol": "6742.KL",
    " marketcap ": " $9 333 094 024 ",
    "price (USD)": "1.14627",
    "country": "Malaysia"
  },
  {
    "Rank": "1746",
    "Name": "JFE Holdings",
    "Symbol": "5411.T",
    " marketcap ": " $9 331 380 648 ",
    "price (USD)": "14.6728",
    "country": "Japan"
  },
  {
    "Rank": "1747",
    "Name": "Repligen",
    "Symbol": "RGEN",
    " marketcap ": " $9 325 408 256 ",
    "price (USD)": "166.895",
    "country": "United States"
  },
  {
    "Rank": "1748",
    "Name": "WH Group",
    "Symbol": "0288.HK",
    " marketcap ": " $9 288 990 440 ",
    "price (USD)": "0.723994",
    "country": "Hong Kong"
  },
  {
    "Rank": "1749",
    "Name": "Asahi Kasei",
    "Symbol": "3407.T",
    " marketcap ": " $9 280 448 639 ",
    "price (USD)": "6.69503",
    "country": "Japan"
  },
  {
    "Rank": "1750",
    "Name": "RaiaDrogasil",
    "Symbol": "RADL3.SA",
    " marketcap ": " $9 271 190 651 ",
    "price (USD)": "5.40556",
    "country": "Brazil"
  },
  {
    "Rank": "1751",
    "Name": "PhosAgro",
    "Symbol": "PHOR.ME",
    " marketcap ": " $9 255 445 877 ",
    "price (USD)": "71.99",
    "country": "Russia"
  },
  {
    "Rank": "1752",
    "Name": "GitLab",
    "Symbol": "GTLB",
    " marketcap ": " $9 243 968 512 ",
    "price (USD)": "58.17",
    "country": "United States"
  },
  {
    "Rank": "1753",
    "Name": "Ganfeng Lithium",
    "Symbol": "002460.SZ",
    " marketcap ": " $9 242 747 656 ",
    "price (USD)": "4.90103",
    "country": "China"
  },
  {
    "Rank": "1754",
    "Name": "China Oilfield Services",
    "Symbol": "2883.HK",
    " marketcap ": " $9 235 597 100 ",
    "price (USD)": "1.08407",
    "country": "China"
  },
  {
    "Rank": "1755",
    "Name": "Largan Precision",
    "Symbol": "3008.TW",
    " marketcap ": " $9 229 808 233 ",
    "price (USD)": "69.1537",
    "country": "Taiwan"
  },
  {
    "Rank": "1756",
    "Name": "DWS Group",
    "Symbol": "DWS.F",
    " marketcap ": " $9 221 413 556 ",
    "price (USD)": "46.1071",
    "country": "Germany"
  },
  {
    "Rank": "1757",
    "Name": "Magnit",
    "Symbol": "MGNT.ME",
    " marketcap ": " $9 210 969 570 ",
    "price (USD)": "90",
    "country": "Russia"
  },
  {
    "Rank": "1758",
    "Name": "American Airlines",
    "Symbol": "AAL",
    " marketcap ": " $9 204 941 824 ",
    "price (USD)": "14.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "1759",
    "Name": "Coca-Cola Consolidated",
    "Symbol": "COKE",
    " marketcap ": " $9 197 182 976 ",
    "price (USD)": "981.17",
    "country": "United States"
  },
  {
    "Rank": "1760",
    "Name": "Stantec",
    "Symbol": "STN",
    " marketcap ": " $9 183 351 808 ",
    "price (USD)": "80.39",
    "country": "Canada"
  },
  {
    "Rank": "1761",
    "Name": "Ubiquiti",
    "Symbol": "UI",
    " marketcap ": " $9 153 251 328 ",
    "price (USD)": "151.39",
    "country": "United States"
  },
  {
    "Rank": "1762",
    "Name": "ANA Holdings",
    "Symbol": "9202.T",
    " marketcap ": " $9 148 166 626 ",
    "price (USD)": "19.4613",
    "country": "Japan"
  },
  {
    "Rank": "1763",
    "Name": "Kunlun Energy Company",
    "Symbol": "0135.HK",
    " marketcap ": " $9 142 849 476 ",
    "price (USD)": "1.05588",
    "country": "Hong Kong"
  },
  {
    "Rank": "1764",
    "Name": "Murphy USA",
    "Symbol": "MUSA",
    " marketcap ": " $9 136 712 704 ",
    "price (USD)": "441.01",
    "country": "United States"
  },
  {
    "Rank": "1765",
    "Name": "Tempur Sealy",
    "Symbol": "TPX",
    " marketcap ": " $9 123 993 600 ",
    "price (USD)": "52.55",
    "country": "United States"
  },
  {
    "Rank": "1766",
    "Name": "Range Resources",
    "Symbol": "RRC",
    " marketcap ": " $9 113 070 592 ",
    "price (USD)": "37.56",
    "country": "United States"
  },
  {
    "Rank": "1767",
    "Name": "Indian Bank",
    "Symbol": "INDIANB.NS",
    " marketcap ": " $9 111 634 345 ",
    "price (USD)": "6.76103",
    "country": "India"
  },
  {
    "Rank": "1768",
    "Name": "Coty",
    "Symbol": "COTY",
    " marketcap ": " $9 103 630 336 ",
    "price (USD)": "\u043e\u043a\u0442.49",
    "country": "United States"
  },
  {
    "Rank": "1769",
    "Name": "Bancolombia",
    "Symbol": "CIB",
    " marketcap ": " $9 100 589 056 ",
    "price (USD)": "37.27",
    "country": "Colombia"
  },
  {
    "Rank": "1770",
    "Name": "LG Corp",
    "Symbol": "003550.KS",
    " marketcap ": " $9 100 439 065 ",
    "price (USD)": "59.4862",
    "country": "South Korea"
  },
  {
    "Rank": "1771",
    "Name": "Osaka Gas",
    "Symbol": "9532.T",
    " marketcap ": " $9 096 744 910 ",
    "price (USD)": "22.2443",
    "country": "Japan"
  },
  {
    "Rank": "1772",
    "Name": "Great Eastern",
    "Symbol": "G07.SI",
    " marketcap ": " $9 094 246 670 ",
    "price (USD)": "19.2138",
    "country": "Singapore"
  },
  {
    "Rank": "1773",
    "Name": "Rexel",
    "Symbol": "RXL.PA",
    " marketcap ": " $9 085 448 618 ",
    "price (USD)": "30.5462",
    "country": "France"
  },
  {
    "Rank": "1774",
    "Name": "Idemitsu Kosan",
    "Symbol": "5019.T",
    " marketcap ": " $9 080 558 595 ",
    "price (USD)": "6.61506",
    "country": "Japan"
  },
  {
    "Rank": "1775",
    "Name": "Arabian Internet and Communications Services",
    "Symbol": "7202.SR",
    " marketcap ": " $9 061 466 805 ",
    "price (USD)": "76.1615",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "1776",
    "Name": "LATAM Airlines",
    "Symbol": "LTM.SN",
    " marketcap ": " $9 052 956 469 ",
    "price (USD)": "0.0149775",
    "country": "Chile"
  },
  {
    "Rank": "1777",
    "Name": "Roivant Sciences",
    "Symbol": "ROIV",
    " marketcap ": " $9 049 650 176 ",
    "price (USD)": "\u043d\u043e\u044f.23",
    "country": "United Kingdom"
  },
  {
    "Rank": "1778",
    "Name": "Weatherford International",
    "Symbol": "WFRD",
    " marketcap ": " $9 045 504 000 ",
    "price (USD)": "123.65",
    "country": "United States"
  },
  {
    "Rank": "1779",
    "Name": "Donaldson",
    "Symbol": "DCI",
    " marketcap ": " $9 044 526 080 ",
    "price (USD)": "75.14",
    "country": "United States"
  },
  {
    "Rank": "1780",
    "Name": "Informatica",
    "Symbol": "INFA",
    " marketcap ": " $9 036 960 768 ",
    "price (USD)": "30.16",
    "country": "United States"
  },
  {
    "Rank": "1781",
    "Name": "Keppel",
    "Symbol": "BN4.SI",
    " marketcap ": " $9 010 272 512 ",
    "price (USD)": "4.98905",
    "country": "Singapore"
  },
  {
    "Rank": "1782",
    "Name": "Nexi",
    "Symbol": "NEXI.MI",
    " marketcap ": " $9 004 794 579 ",
    "price (USD)": "6.70648",
    "country": "Italy"
  },
  {
    "Rank": "1783",
    "Name": "The Toro Company",
    "Symbol": "TTC",
    " marketcap ": " $9 003 016 192 ",
    "price (USD)": "86.23",
    "country": "United States"
  },
  {
    "Rank": "1784",
    "Name": "SEI Investments",
    "Symbol": "SEIC",
    " marketcap ": " $8 993 508 352 ",
    "price (USD)": "68.45",
    "country": "United States"
  },
  {
    "Rank": "1785",
    "Name": "Fortune Brands Innovations",
    "Symbol": "FBIN",
    " marketcap ": " $8 981 922 816 ",
    "price (USD)": "71.81",
    "country": "United States"
  },
  {
    "Rank": "1786",
    "Name": "Globus Medical",
    "Symbol": "GMED",
    " marketcap ": " $8 981 289 984 ",
    "price (USD)": "66.5",
    "country": "United States"
  },
  {
    "Rank": "1787",
    "Name": "Kinsale Capital Group",
    "Symbol": "KNSL",
    " marketcap ": " $8 971 655 168 ",
    "price (USD)": "385.44",
    "country": "United States"
  },
  {
    "Rank": "1788",
    "Name": "B\u0414\u00b0M Birle\u0415\u045fik Ma\u0414\u045fazalar",
    "Symbol": "BIMAS.IS",
    " marketcap ": " $8 970 827 177 ",
    "price (USD)": "15.0265",
    "country": "Turkey"
  },
  {
    "Rank": "1789",
    "Name": "Ascendas Reit",
    "Symbol": "A17U.SI",
    " marketcap ": " $8 970 766 844 ",
    "price (USD)": "1.95998",
    "country": "Singapore"
  },
  {
    "Rank": "1790",
    "Name": "Chailease Holding",
    "Symbol": "5871.TW",
    " marketcap ": " $8 965 762 004 ",
    "price (USD)": "4.79114",
    "country": "Taiwan"
  },
  {
    "Rank": "1791",
    "Name": "Hindustan Petroleum",
    "Symbol": "HINDPETRO.NS",
    " marketcap ": " $8 959 362 967 ",
    "price (USD)": "6.31586",
    "country": "India"
  },
  {
    "Rank": "1792",
    "Name": "Pilgrim's Pride",
    "Symbol": "PPC",
    " marketcap ": " $8 954 076 160 ",
    "price (USD)": "37.79",
    "country": "United States"
  },
  {
    "Rank": "1793",
    "Name": "Birkenstock",
    "Symbol": "BIRK",
    " marketcap ": " $8 940 517 376 ",
    "price (USD)": "47.6",
    "country": "Germany"
  },
  {
    "Rank": "1794",
    "Name": "KBR",
    "Symbol": "KBR",
    " marketcap ": " $8 940 096 512 ",
    "price (USD)": "66.58",
    "country": "United States"
  },
  {
    "Rank": "1795",
    "Name": "Pinnacle West Capital",
    "Symbol": "PNW",
    " marketcap ": " $8 928 009 216 ",
    "price (USD)": "78.62",
    "country": "United States"
  },
  {
    "Rank": "1796",
    "Name": "Vipshop",
    "Symbol": "VIPS",
    " marketcap ": " $8 922 036 224 ",
    "price (USD)": "16.45",
    "country": "China"
  },
  {
    "Rank": "1797",
    "Name": "CAVA Group",
    "Symbol": "CAVA",
    " marketcap ": " $8 917 862 400 ",
    "price (USD)": "78.22",
    "country": "United States"
  },
  {
    "Rank": "1798",
    "Name": "MakeMyTrip",
    "Symbol": "MMYT",
    " marketcap ": " $8 913 883 136 ",
    "price (USD)": "81.73",
    "country": "India"
  },
  {
    "Rank": "1799",
    "Name": "Assurant",
    "Symbol": "AIZ",
    " marketcap ": " $8 909 326 336 ",
    "price (USD)": "171.38",
    "country": "United States"
  },
  {
    "Rank": "1800",
    "Name": "First Horizon National",
    "Symbol": "FHN",
    " marketcap ": " $8 886 604 800 ",
    "price (USD)": "16.25",
    "country": "United States"
  },
  {
    "Rank": "1801",
    "Name": "Mondi",
    "Symbol": "MNDI.L",
    " marketcap ": " $8 884 827 644 ",
    "price (USD)": "20.1539",
    "country": "United Kingdom"
  },
  {
    "Rank": "1802",
    "Name": "Elbit Systems",
    "Symbol": "ESLT",
    " marketcap ": " $8 877 530 112 ",
    "price (USD)": "199.6",
    "country": "Israel"
  },
  {
    "Rank": "1803",
    "Name": "MKS Instruments",
    "Symbol": "MKSI",
    " marketcap ": " $8 858 527 744 ",
    "price (USD)": "131.83",
    "country": "United States"
  },
  {
    "Rank": "1804",
    "Name": "Hong Kong Telecom",
    "Symbol": "6823.HK",
    " marketcap ": " $8 858 001 718 ",
    "price (USD)": "1.16864",
    "country": "Hong Kong"
  },
  {
    "Rank": "1805",
    "Name": "President Chain Store (PSCS)",
    "Symbol": "2912.TW",
    " marketcap ": " $8 849 681 369 ",
    "price (USD)": "8.51242",
    "country": "Taiwan"
  },
  {
    "Rank": "1806",
    "Name": "Banque Cantonale Vaudoise",
    "Symbol": "BCVN.SW",
    " marketcap ": " $8 845 118 416 ",
    "price (USD)": "102.984",
    "country": "Switzerland"
  },
  {
    "Rank": "1807",
    "Name": "Colgate-Palmolive India",
    "Symbol": "COLPAL.NS",
    " marketcap ": " $8 842 886 103 ",
    "price (USD)": "32.5123",
    "country": "India"
  },
  {
    "Rank": "1808",
    "Name": "Pegatron",
    "Symbol": "4938.TW",
    " marketcap ": " $8 839 452 738 ",
    "price (USD)": "3.31814",
    "country": "Taiwan"
  },
  {
    "Rank": "1809",
    "Name": "Royal Gold",
    "Symbol": "RGLD",
    " marketcap ": " $8 828 612 608 ",
    "price (USD)": "134.31",
    "country": "United States"
  },
  {
    "Rank": "1810",
    "Name": "Swedish Orphan Biovitrum",
    "Symbol": "SOBI.ST",
    " marketcap ": " $8 824 807 070 ",
    "price (USD)": "25.9654",
    "country": "Sweden"
  },
  {
    "Rank": "1811",
    "Name": "e.l.f. Cosmetics",
    "Symbol": "ELF",
    " marketcap ": " $8 823 931 904 ",
    "price (USD)": "158.97",
    "country": "United States"
  },
  {
    "Rank": "1812",
    "Name": "kyowa Kirin",
    "Symbol": "4151.T",
    " marketcap ": " $8 823 737 636 ",
    "price (USD)": "16.4129",
    "country": "Japan"
  },
  {
    "Rank": "1813",
    "Name": "Lotus Bakeries",
    "Symbol": "LOTB.BR",
    " marketcap ": " $8 800 606 711 ",
    "price (USD)": "10837.2",
    "country": "Belgium"
  },
  {
    "Rank": "1814",
    "Name": "Carl Zeiss Meditec",
    "Symbol": "AFXA.F",
    " marketcap ": " $8 782 263 890 ",
    "price (USD)": "97.1875",
    "country": "Germany"
  },
  {
    "Rank": "1815",
    "Name": "Carsales",
    "Symbol": "CAR.AX",
    " marketcap ": " $8 779 689 747 ",
    "price (USD)": "23.2783",
    "country": "Australia"
  },
  {
    "Rank": "1816",
    "Name": "MTN Group",
    "Symbol": "MTN.JO",
    " marketcap ": " $8 772 834 100 ",
    "price (USD)": "4.85634",
    "country": "South Africa"
  },
  {
    "Rank": "1817",
    "Name": "Crocs",
    "Symbol": "CROX",
    " marketcap ": " $8 766 654 464 ",
    "price (USD)": "144.42",
    "country": "United States"
  },
  {
    "Rank": "1818",
    "Name": "Accton Technology",
    "Symbol": "2345.TW",
    " marketcap ": " $8 759 243 442 ",
    "price (USD)": "15.6914",
    "country": "Taiwan"
  },
  {
    "Rank": "1819",
    "Name": "Delivery Hero",
    "Symbol": "DHER.F",
    " marketcap ": " $8 758 840 543 ",
    "price (USD)": "32.5117",
    "country": "Germany"
  },
  {
    "Rank": "1820",
    "Name": "HMM",
    "Symbol": "011200.KS",
    " marketcap ": " $8 748 038 805 ",
    "price (USD)": "\u0434\u0435\u043a.79",
    "country": "South Korea"
  },
  {
    "Rank": "1821",
    "Name": "Levi Strauss",
    "Symbol": "LEVI",
    " marketcap ": " $8 736 736 256 ",
    "price (USD)": "21.95",
    "country": "United States"
  },
  {
    "Rank": "1822",
    "Name": "Light &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1823",
    "Name": "Kasikornbank",
    "Symbol": "KBANK.BK",
    " marketcap ": " $8 729 693 126 ",
    "price (USD)": "3.68446",
    "country": "Thailand"
  },
  {
    "Rank": "1824",
    "Name": "CP Axtra",
    "Symbol": "CPAXT.BK",
    " marketcap ": " $8 727 212 709 ",
    "price (USD)": "0.824878",
    "country": "Thailand"
  },
  {
    "Rank": "1825",
    "Name": "Sinopac Financial Holdings",
    "Symbol": "2890.TW",
    " marketcap ": " $8 712 260 431 ",
    "price (USD)": "0.703941",
    "country": "Taiwan"
  },
  {
    "Rank": "1826",
    "Name": "Banca Mediolanum",
    "Symbol": "BMED.MI",
    " marketcap ": " $8 710 244 743 ",
    "price (USD)": "\u043d\u043e\u044f.22",
    "country": "Italy"
  },
  {
    "Rank": "1827",
    "Name": "Ooredoo",
    "Symbol": "ORDS.AE",
    " marketcap ": " $8 704 205 625 ",
    "price (USD)": "\u0444\u0435\u0432.72",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1828",
    "Name": "Aselsan",
    "Symbol": "ASELS.IS",
    " marketcap ": " $8 704 101 595 ",
    "price (USD)": "1.90879",
    "country": "Turkey"
  },
  {
    "Rank": "1829",
    "Name": "Hasbro",
    "Symbol": "HAS",
    " marketcap ": " $8 698 215 424 ",
    "price (USD)": "62.48",
    "country": "United States"
  },
  {
    "Rank": "1830",
    "Name": "TKO Group",
    "Symbol": "TKO",
    " marketcap ": " $8 676 605 952 ",
    "price (USD)": "107.53",
    "country": "United States"
  },
  {
    "Rank": "1831",
    "Name": "MinebeaMitsumi",
    "Symbol": "6479.T",
    " marketcap ": " $8 661 533 204 ",
    "price (USD)": "21.419",
    "country": "Japan"
  },
  {
    "Rank": "1832",
    "Name": "Yes Bank",
    "Symbol": "YESBANK.NS",
    " marketcap ": " $8 658 818 814 ",
    "price (USD)": "0.276353",
    "country": "India"
  },
  {
    "Rank": "1833",
    "Name": "Old Republic International",
    "Symbol": "ORI",
    " marketcap ": " $8 657 881 088 ",
    "price (USD)": "31.85",
    "country": "United States"
  },
  {
    "Rank": "1834",
    "Name": "Aramark",
    "Symbol": "ARMK",
    " marketcap ": " $8 655 067 136 ",
    "price (USD)": "32.91",
    "country": "United States"
  },
  {
    "Rank": "1835",
    "Name": "MasTec",
    "Symbol": "MTZ",
    " marketcap ": " $8 649 841 664 ",
    "price (USD)": "108.86",
    "country": "United States"
  },
  {
    "Rank": "1836",
    "Name": "HealthSouth",
    "Symbol": "EHC",
    " marketcap ": " $8 638 773 248 ",
    "price (USD)": "85.8",
    "country": "United States"
  },
  {
    "Rank": "1837",
    "Name": "(HLBank) Hong Leong Bank",
    "Symbol": "5819.KL",
    " marketcap ": " $8 633 676 825 ",
    "price (USD)": "4.13764",
    "country": "Malaysia"
  },
  {
    "Rank": "1838",
    "Name": "AppFolio",
    "Symbol": "APPF",
    " marketcap ": " $8 632 164 352 ",
    "price (USD)": "238.37",
    "country": "United States"
  },
  {
    "Rank": "1839",
    "Name": "RBC Bearings",
    "Symbol": "RBC",
    " marketcap ": " $8 627 937 280 ",
    "price (USD)": "295.36",
    "country": "United States"
  },
  {
    "Rank": "1840",
    "Name": "Unimicron",
    "Symbol": "3037.TW",
    " marketcap ": " $8 624 082 437 ",
    "price (USD)": "5.65944",
    "country": "Taiwan"
  },
  {
    "Rank": "1841",
    "Name": "Instacart (Maplebear Inc.)",
    "Symbol": "CART",
    " marketcap ": " $8 623 894 528 ",
    "price (USD)": "32.58",
    "country": "United States"
  },
  {
    "Rank": "1842",
    "Name": "Sainsbury's",
    "Symbol": "SBRY.L",
    " marketcap ": " $8 616 796 552 ",
    "price (USD)": "3.64113",
    "country": "United Kingdom"
  },
  {
    "Rank": "1843",
    "Name": "Samsung Electro-Mechanics",
    "Symbol": "009155.KS",
    " marketcap ": " $8 613 548 845 ",
    "price (USD)": "55.0798",
    "country": "South Korea"
  },
  {
    "Rank": "1844",
    "Name": "T&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1845",
    "Name": "Aurobindo Pharma",
    "Symbol": "AUROPHARMA.NS",
    " marketcap ": " $8 581 714 578 ",
    "price (USD)": "14.6461",
    "country": "India"
  },
  {
    "Rank": "1846",
    "Name": "IMCD",
    "Symbol": "IMCD.AS",
    " marketcap ": " $8 580 412 240 ",
    "price (USD)": "150.668",
    "country": "Netherlands"
  },
  {
    "Rank": "1847",
    "Name": "YTL Corporation Berhad",
    "Symbol": "1773.T",
    " marketcap ": " $8 580 039 810 ",
    "price (USD)": "0.7805",
    "country": "Malaysia"
  },
  {
    "Rank": "1848",
    "Name": "Sinopharm",
    "Symbol": "1099.HK",
    " marketcap ": " $8 577 493 533 ",
    "price (USD)": "2.74862",
    "country": "China"
  },
  {
    "Rank": "1849",
    "Name": "Oil India",
    "Symbol": "OIL.NS",
    " marketcap ": " $8 566 926 515 ",
    "price (USD)": "7.90008",
    "country": "India"
  },
  {
    "Rank": "1850",
    "Name": "Spirax-Sarco Engineering",
    "Symbol": "SPX.L",
    " marketcap ": " $8 561 248 357 ",
    "price (USD)": "116.264",
    "country": "United Kingdom"
  },
  {
    "Rank": "1851",
    "Name": "Saputo",
    "Symbol": "SAP.TO",
    " marketcap ": " $8 552 162 411 ",
    "price (USD)": "20.1547",
    "country": "Canada"
  },
  {
    "Rank": "1852",
    "Name": "Tube Investments of India",
    "Symbol": "TIINDIA.NS",
    " marketcap ": " $8 547 538 246 ",
    "price (USD)": "44.1948",
    "country": "India"
  },
  {
    "Rank": "1853",
    "Name": "Realtek",
    "Symbol": "2379.TW",
    " marketcap ": " $8 540 559 455 ",
    "price (USD)": "16.6527",
    "country": "Taiwan"
  },
  {
    "Rank": "1854",
    "Name": "Krafton",
    "Symbol": "259960.KS",
    " marketcap ": " $8 532 700 546 ",
    "price (USD)": "186.904",
    "country": "South Korea"
  },
  {
    "Rank": "1855",
    "Name": "Ternium",
    "Symbol": "TX",
    " marketcap ": " $8 527 619 072 ",
    "price (USD)": "43.44",
    "country": "Luxembourg"
  },
  {
    "Rank": "1856",
    "Name": "Gjensidige Forsikring",
    "Symbol": "GJF.OL",
    " marketcap ": " $8 526 760 696 ",
    "price (USD)": "17.055",
    "country": "Norway"
  },
  {
    "Rank": "1857",
    "Name": "V\u0413\u0490r Energi",
    "Symbol": "VAR.OL",
    " marketcap ": " $8 519 915 624 ",
    "price (USD)": "3.41287",
    "country": "Norway"
  },
  {
    "Rank": "1858",
    "Name": "Graphic Packaging",
    "Symbol": "GPK",
    " marketcap ": " $8 512 044 544 ",
    "price (USD)": "27.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "1859",
    "Name": "Amorepacific",
    "Symbol": "090430.KS",
    " marketcap ": " $8 497 180 214 ",
    "price (USD)": "138.507",
    "country": "South Korea"
  },
  {
    "Rank": "1860",
    "Name": "Amplifon",
    "Symbol": "AMP.MI",
    " marketcap ": " $8 496 436 790 ",
    "price (USD)": "36.182",
    "country": "Italy"
  },
  {
    "Rank": "1861",
    "Name": "Doosan Enerbility",
    "Symbol": "034020.KS",
    " marketcap ": " $8 494 629 736 ",
    "price (USD)": "13.2632",
    "country": "South Korea"
  },
  {
    "Rank": "1862",
    "Name": "T\u0415\u040cky\u0415\u040c Gas",
    "Symbol": "9531.T",
    " marketcap ": " $8 487 801 379 ",
    "price (USD)": "21.2718",
    "country": "Japan"
  },
  {
    "Rank": "1863",
    "Name": "Sanlam",
    "Symbol": "SLM.JO",
    " marketcap ": " $8 482 118 800 ",
    "price (USD)": "4.0975",
    "country": "South Africa"
  },
  {
    "Rank": "1864",
    "Name": "Federal Realty Investment Trust",
    "Symbol": "FRT",
    " marketcap ": " $8 466 213 888 ",
    "price (USD)": "101.29",
    "country": "United States"
  },
  {
    "Rank": "1865",
    "Name": "KGHM Polska Mied\u0415\u0454",
    "Symbol": "KGH.WA",
    " marketcap ": " $8 463 581 244 ",
    "price (USD)": "42.3179",
    "country": "Poland"
  },
  {
    "Rank": "1866",
    "Name": "Crane Co.",
    "Symbol": "CR",
    " marketcap ": " $8 455 940 096 ",
    "price (USD)": "147.94",
    "country": "United States"
  },
  {
    "Rank": "1867",
    "Name": "Paramount Global",
    "Symbol": "PARA",
    " marketcap ": " $8 455 540 736 ",
    "price (USD)": "12.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "1868",
    "Name": "CTS Eventim",
    "Symbol": "EVD.F",
    " marketcap ": " $8 448 439 222 ",
    "price (USD)": "87.7403",
    "country": "Germany"
  },
  {
    "Rank": "1869",
    "Name": "Chemed",
    "Symbol": "CHE",
    " marketcap ": " $8 444 341 760 ",
    "price (USD)": "559.81",
    "country": "United States"
  },
  {
    "Rank": "1870",
    "Name": "Descartes Systems",
    "Symbol": "DSGX",
    " marketcap ": " $8 425 763 328 ",
    "price (USD)": "98.57",
    "country": "Canada"
  },
  {
    "Rank": "1871",
    "Name": "Emaar Development",
    "Symbol": "EMAARDEV.AE",
    " marketcap ": " $8 418 874 258 ",
    "price (USD)": "2.10472",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1872",
    "Name": "Stifel",
    "Symbol": "SF",
    " marketcap ": " $8 416 760 320 ",
    "price (USD)": "82.15",
    "country": "United States"
  },
  {
    "Rank": "1873",
    "Name": "Lufthansa",
    "Symbol": "LHA.DE",
    " marketcap ": " $8 394 141 870 ",
    "price (USD)": "7.01488",
    "country": "Germany"
  },
  {
    "Rank": "1874",
    "Name": "Steel Authority of India",
    "Symbol": "SAIL.NS",
    " marketcap ": " $8 392 380 912 ",
    "price (USD)": "2.03179",
    "country": "India"
  },
  {
    "Rank": "1875",
    "Name": "Supreme Industries",
    "Symbol": "SUPREMEIND.NS",
    " marketcap ": " $8 373 388 724 ",
    "price (USD)": "65.8933",
    "country": "India"
  },
  {
    "Rank": "1876",
    "Name": "Ooredoo Qatar",
    "Symbol": "ORDS.QA",
    " marketcap ": " $8 373 200 176 ",
    "price (USD)": "2.61401",
    "country": "Qatar"
  },
  {
    "Rank": "1877",
    "Name": "Fabrinet",
    "Symbol": "FN",
    " marketcap ": " $8 370 144 256 ",
    "price (USD)": "231.57",
    "country": "Cayman Islands"
  },
  {
    "Rank": "1878",
    "Name": "Schaeffler India",
    "Symbol": "SCHAEFFLER.NS",
    " marketcap ": " $8 365 560 815 ",
    "price (USD)": "53.5211",
    "country": "India"
  },
  {
    "Rank": "1879",
    "Name": "National Bank of Greece",
    "Symbol": "ETE.AT",
    " marketcap ": " $8 365 114 822 ",
    "price (USD)": "9.1606",
    "country": "Greece"
  },
  {
    "Rank": "1880",
    "Name": "Eurobank Ergasias Services and Holdings",
    "Symbol": "EUROB.AT",
    " marketcap ": " $8 361 578 247 ",
    "price (USD)": "2.28472",
    "country": "Greece"
  },
  {
    "Rank": "1881",
    "Name": "Roku",
    "Symbol": "ROKU",
    " marketcap ": " $8 357 419 008 ",
    "price (USD)": "57.97",
    "country": "United States"
  },
  {
    "Rank": "1882",
    "Name": "OpenText",
    "Symbol": "OTEX",
    " marketcap ": " $8 348 996 608 ",
    "price (USD)": "30.93",
    "country": "Canada"
  },
  {
    "Rank": "1883",
    "Name": "Eagle Materials",
    "Symbol": "EXP",
    " marketcap ": " $8 346 938 880 ",
    "price (USD)": "242.29",
    "country": "United States"
  },
  {
    "Rank": "1884",
    "Name": "Cleveland-Cliffs",
    "Symbol": "CLF",
    " marketcap ": " $8 325 584 896 ",
    "price (USD)": "17.51",
    "country": "United States"
  },
  {
    "Rank": "1885",
    "Name": "Mengniu Dairy",
    "Symbol": "2319.HK",
    " marketcap ": " $8 320 459 879 ",
    "price (USD)": "2.11432",
    "country": "China"
  },
  {
    "Rank": "1886",
    "Name": "ADNOC Logistics &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1887",
    "Name": "BorgWarner",
    "Symbol": "BWA",
    " marketcap ": " $8 316 086 784 ",
    "price (USD)": "36.5",
    "country": "United States"
  },
  {
    "Rank": "1888",
    "Name": "FTAI Aviation",
    "Symbol": "FTAI",
    " marketcap ": " $8 313 400 832 ",
    "price (USD)": "82.93",
    "country": "United States"
  },
  {
    "Rank": "1889",
    "Name": "Universal Display Corporation",
    "Symbol": "OLED",
    " marketcap ": " $8 306 181 632 ",
    "price (USD)": "175.09",
    "country": "United States"
  },
  {
    "Rank": "1890",
    "Name": "Croda International",
    "Symbol": "CRDA.L",
    " marketcap ": " $8 302 795 011 ",
    "price (USD)": "59.4607",
    "country": "United Kingdom"
  },
  {
    "Rank": "1891",
    "Name": "China Resources Gas Group",
    "Symbol": "1193.HK",
    " marketcap ": " $8 287 694 209 ",
    "price (USD)": "3.58153",
    "country": "Hong Kong"
  },
  {
    "Rank": "1892",
    "Name": "Rockwool",
    "Symbol": "ROCK-B.CO",
    " marketcap ": " $8 284 178 237 ",
    "price (USD)": "388.788",
    "country": "Denmark"
  },
  {
    "Rank": "1893",
    "Name": "XPeng",
    "Symbol": "XPEV",
    " marketcap ": " $8 273 442 816 ",
    "price (USD)": "\u0430\u0432\u0433.77",
    "country": "China"
  },
  {
    "Rank": "1894",
    "Name": "BKW AG",
    "Symbol": "BKW.SW",
    " marketcap ": " $8 270 698 138 ",
    "price (USD)": "156.698",
    "country": "Switzerland"
  },
  {
    "Rank": "1895",
    "Name": "Yageo",
    "Symbol": "2327.TW",
    " marketcap ": " $8 267 545 645 ",
    "price (USD)": "19.7228",
    "country": "Taiwan"
  },
  {
    "Rank": "1896",
    "Name": "Cognex",
    "Symbol": "CGNX",
    " marketcap ": " $8 267 241 984 ",
    "price (USD)": "48.16",
    "country": "United States"
  },
  {
    "Rank": "1897",
    "Name": "Hainan Airlines",
    "Symbol": "900945.SS",
    " marketcap ": " $8 256 026 624 ",
    "price (USD)": "0.183",
    "country": "China"
  },
  {
    "Rank": "1898",
    "Name": "Elanco",
    "Symbol": "ELAN",
    " marketcap ": " $8 252 839 936 ",
    "price (USD)": "16.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "1899",
    "Name": "Obayashi",
    "Symbol": "1802.T",
    " marketcap ": " $8 245 202 038 ",
    "price (USD)": "\u043d\u043e\u044f.96",
    "country": "Japan"
  },
  {
    "Rank": "1900",
    "Name": "MarketAxess",
    "Symbol": "MKTX",
    " marketcap ": " $8 244 849 664 ",
    "price (USD)": "217.56",
    "country": "United States"
  },
  {
    "Rank": "1901",
    "Name": "SalMar ASA",
    "Symbol": "SALM.OL",
    " marketcap ": " $8 244 533 452 ",
    "price (USD)": "62.5724",
    "country": "Norway"
  },
  {
    "Rank": "1902",
    "Name": "Bharat Forge",
    "Symbol": "BHARATFORG.NS",
    " marketcap ": " $8 234 332 110 ",
    "price (USD)": "17.6806",
    "country": "India"
  },
  {
    "Rank": "1903",
    "Name": "Muthoot Finance",
    "Symbol": "MUTHOOTFIN.NS",
    " marketcap ": " $8 234 054 932 ",
    "price (USD)": "20.5102",
    "country": "India"
  },
  {
    "Rank": "1904",
    "Name": "Woori Financial Group",
    "Symbol": "WF",
    " marketcap ": " $8 229 807 104 ",
    "price (USD)": "33.25",
    "country": "South Korea"
  },
  {
    "Rank": "1905",
    "Name": "Hochtief",
    "Symbol": "HOT.F",
    " marketcap ": " $8 224 933 904 ",
    "price (USD)": "108.101",
    "country": "Germany"
  },
  {
    "Rank": "1906",
    "Name": "Southwestern Energy",
    "Symbol": "SWN",
    " marketcap ": " $8 216 232 448 ",
    "price (USD)": "\u0438\u044e\u043b.45",
    "country": "United States"
  },
  {
    "Rank": "1907",
    "Name": "ASX",
    "Symbol": "ASX.AX",
    " marketcap ": " $8 216 140 830 ",
    "price (USD)": "42.3757",
    "country": "Australia"
  },
  {
    "Rank": "1908",
    "Name": "Bio-Rad Laboratories",
    "Symbol": "BIO",
    " marketcap ": " $8 208 049 664 ",
    "price (USD)": "289.45",
    "country": "United States"
  },
  {
    "Rank": "1909",
    "Name": "Parsons",
    "Symbol": "PSN",
    " marketcap ": " $8 194 753 536 ",
    "price (USD)": "77.13",
    "country": "United States"
  },
  {
    "Rank": "1910",
    "Name": "Pearson",
    "Symbol": "PSO",
    " marketcap ": " $8 189 330 944 ",
    "price (USD)": "\u0434\u0435\u043a.15",
    "country": "United Kingdom"
  },
  {
    "Rank": "1911",
    "Name": "Kajima",
    "Symbol": "1812.T",
    " marketcap ": " $8 182 205 971 ",
    "price (USD)": "17.0047",
    "country": "Japan"
  },
  {
    "Rank": "1912",
    "Name": "Industrial Bank of Korea (IBK)",
    "Symbol": "024110.KS",
    " marketcap ": " $8 169 507 731 ",
    "price (USD)": "\u043e\u043a\u0442.48",
    "country": "South Korea"
  },
  {
    "Rank": "1913",
    "Name": "SRF Limited",
    "Symbol": "SRF.NS",
    " marketcap ": " $8 164 001 405 ",
    "price (USD)": "27.5415",
    "country": "India"
  },
  {
    "Rank": "1914",
    "Name": "Gecina",
    "Symbol": "GFC.PA",
    " marketcap ": " $8 161 841 538 ",
    "price (USD)": "110.435",
    "country": "France"
  },
  {
    "Rank": "1915",
    "Name": "Acuity Brands",
    "Symbol": "AYI",
    " marketcap ": " $8 160 827 904 ",
    "price (USD)": "264.98",
    "country": "United States"
  },
  {
    "Rank": "1916",
    "Name": "Makita",
    "Symbol": "6586.T",
    " marketcap ": " $8 156 258 227 ",
    "price (USD)": "30.318",
    "country": "Japan"
  },
  {
    "Rank": "1917",
    "Name": "KakaoBank",
    "Symbol": "323410.KS",
    " marketcap ": " $8 150 875 843 ",
    "price (USD)": "17.1115",
    "country": "South Korea"
  },
  {
    "Rank": "1918",
    "Name": "Pilbara Minerals",
    "Symbol": "PLS.AX",
    " marketcap ": " $8 148 047 370 ",
    "price (USD)": "2.70724",
    "country": "Australia"
  },
  {
    "Rank": "1919",
    "Name": "U.S. Steel",
    "Symbol": "X",
    " marketcap ": " $8 130 575 872 ",
    "price (USD)": "36.16",
    "country": "United States"
  },
  {
    "Rank": "1920",
    "Name": "SK Telecom",
    "Symbol": "SKM",
    " marketcap ": " $8 128 039 424 ",
    "price (USD)": "21.19",
    "country": "South Korea"
  },
  {
    "Rank": "1921",
    "Name": "CTP N.V.",
    "Symbol": "CTPNV.AS",
    " marketcap ": " $8 127 018 977 ",
    "price (USD)": "18.1344",
    "country": "Netherlands"
  },
  {
    "Rank": "1922",
    "Name": "SIG Combibloc",
    "Symbol": "SIGN.SW",
    " marketcap ": " $8 124 364 829 ",
    "price (USD)": "21.2551",
    "country": "Switzerland"
  },
  {
    "Rank": "1923",
    "Name": "PUMA",
    "Symbol": "PUM.DE",
    " marketcap ": " $8 117 892 045 ",
    "price (USD)": "54.1753",
    "country": "Germany"
  },
  {
    "Rank": "1924",
    "Name": "Genting Singapore",
    "Symbol": "G13.SI",
    " marketcap ": " $8 111 371 641 ",
    "price (USD)": "0.671888",
    "country": "Singapore"
  },
  {
    "Rank": "1925",
    "Name": "SBI Card",
    "Symbol": "SBICARD.NS",
    " marketcap ": " $8 097 196 055 ",
    "price (USD)": "8.51286",
    "country": "India"
  },
  {
    "Rank": "1926",
    "Name": "LPP SA",
    "Symbol": "LPP.WA",
    " marketcap ": " $8 097 148 979 ",
    "price (USD)": "4364.59",
    "country": "Poland"
  },
  {
    "Rank": "1927",
    "Name": "Endeavor Group",
    "Symbol": "EDR",
    " marketcap ": " $8 096 880 640 ",
    "price (USD)": "26.77",
    "country": "United States"
  },
  {
    "Rank": "1928",
    "Name": "New York Times",
    "Symbol": "NYT",
    " marketcap ": " $8 090 674 176 ",
    "price (USD)": "49.24",
    "country": "United States"
  },
  {
    "Rank": "1929",
    "Name": "BWX Technologies",
    "Symbol": "BWXT",
    " marketcap ": " $8 086 022 144 ",
    "price (USD)": "88.46",
    "country": "United States"
  },
  {
    "Rank": "1930",
    "Name": "Siam Cement",
    "Symbol": "SCC.BK",
    " marketcap ": " $8 083 807 889 ",
    "price (USD)": "6.73651",
    "country": "Thailand"
  },
  {
    "Rank": "1931",
    "Name": "Pan American Silver",
    "Symbol": "PAAS",
    " marketcap ": " $8 076 902 912 ",
    "price (USD)": "22.22",
    "country": "Canada"
  },
  {
    "Rank": "1932",
    "Name": "Sofina",
    "Symbol": "SOF.VI",
    " marketcap ": " $8 076 289 334 ",
    "price (USD)": "242.589",
    "country": "Belgium"
  },
  {
    "Rank": "1933",
    "Name": "Amkor Technology",
    "Symbol": "AMKR",
    " marketcap ": " $8 074 375 680 ",
    "price (USD)": "32.8",
    "country": "United States"
  },
  {
    "Rank": "1934",
    "Name": "Omega Healthcare",
    "Symbol": "OHI",
    " marketcap ": " $8 073 881 600 ",
    "price (USD)": "31.72",
    "country": "United States"
  },
  {
    "Rank": "1935",
    "Name": "Zhuzhou CRRC Times Electric",
    "Symbol": "3898.HK",
    " marketcap ": " $8 072 969 823 ",
    "price (USD)": "4.06846",
    "country": "Hong Kong"
  },
  {
    "Rank": "1936",
    "Name": "Shimadzu",
    "Symbol": "7701.T",
    " marketcap ": " $8 071 839 170 ",
    "price (USD)": "27.3879",
    "country": "Japan"
  },
  {
    "Rank": "1937",
    "Name": "MBME GROUP",
    "Symbol": "MBME.AE",
    " marketcap ": " $8 071 718 354 ",
    "price (USD)": "\u0444\u0435\u0432.94",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "1938",
    "Name": "AGCO",
    "Symbol": "AGCO",
    " marketcap ": " $8 069 352 960 ",
    "price (USD)": "108.14",
    "country": "United States"
  },
  {
    "Rank": "1939",
    "Name": "WEX",
    "Symbol": "WEX",
    " marketcap ": " $8 066 684 416 ",
    "price (USD)": "192.52",
    "country": "United States"
  },
  {
    "Rank": "1940",
    "Name": "Korea Zinc",
    "Symbol": "010130.KS",
    " marketcap ": " $8 043 157 429 ",
    "price (USD)": "388.496",
    "country": "South Korea"
  },
  {
    "Rank": "1941",
    "Name": "Bid Corp",
    "Symbol": "BID.JO",
    " marketcap ": " $8 038 631 500 ",
    "price (USD)": "23.814",
    "country": "South Africa"
  },
  {
    "Rank": "1942",
    "Name": "Unity Software",
    "Symbol": "U",
    " marketcap ": " $8 036 122 624 ",
    "price (USD)": "20.56",
    "country": "United States"
  },
  {
    "Rank": "1943",
    "Name": "True Corporation",
    "Symbol": "TRUE.BK",
    " marketcap ": " $8 027 860 192 ",
    "price (USD)": "0.232341",
    "country": "Thailand"
  },
  {
    "Rank": "1944",
    "Name": "Gap Inc.",
    "Symbol": "GPS",
    " marketcap ": " $8 026 793 984 ",
    "price (USD)": "21.49",
    "country": "United States"
  },
  {
    "Rank": "1945",
    "Name": "Taiwan Cement",
    "Symbol": "1101.TW",
    " marketcap ": " $8 022 327 780 ",
    "price (USD)": "1.06522",
    "country": "Taiwan"
  },
  {
    "Rank": "1946",
    "Name": "Coherent",
    "Symbol": "COHR",
    " marketcap ": " $8 019 055 800 ",
    "price (USD)": "57.82",
    "country": "United States"
  },
  {
    "Rank": "1947",
    "Name": "Vaxcyte",
    "Symbol": "PCVX",
    " marketcap ": " $8 012 751 872 ",
    "price (USD)": "73.65",
    "country": "United States"
  },
  {
    "Rank": "1948",
    "Name": "UL Solutions",
    "Symbol": "ULS",
    " marketcap ": " $8 010 160 128 ",
    "price (USD)": "40.05",
    "country": "United States"
  },
  {
    "Rank": "1949",
    "Name": "General Insurance Corporation of India",
    "Symbol": "GICRE.NS",
    " marketcap ": " $8 009 500 793 ",
    "price (USD)": "4.55021",
    "country": "India"
  },
  {
    "Rank": "1950",
    "Name": "Hess Midstream",
    "Symbol": "HESM",
    " marketcap ": " $8 005 182 464 ",
    "price (USD)": "35.81",
    "country": "United States"
  },
  {
    "Rank": "1951",
    "Name": "Falabella",
    "Symbol": "FALABELLA.SN",
    " marketcap ": " $7 998 339 939 ",
    "price (USD)": "3.18806",
    "country": "Chile"
  },
  {
    "Rank": "1952",
    "Name": "FMC",
    "Symbol": "FMC",
    " marketcap ": " $7 992 096 256 ",
    "price (USD)": "64.03",
    "country": "United States"
  },
  {
    "Rank": "1953",
    "Name": "Shoprite",
    "Symbol": "SHP.JO",
    " marketcap ": " $7 982 618 600 ",
    "price (USD)": "14.6736",
    "country": "South Africa"
  },
  {
    "Rank": "1954",
    "Name": "Match Group",
    "Symbol": "MTCH",
    " marketcap ": " $7 978 010 112 ",
    "price (USD)": "30.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "1955",
    "Name": "Sasa Polyester",
    "Symbol": "SASA.IS",
    " marketcap ": " $7 974 267 989 ",
    "price (USD)": "1.49846",
    "country": "Turkey"
  },
  {
    "Rank": "1956",
    "Name": "Jardine Cycle &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1957",
    "Name": "Boubyan Bank",
    "Symbol": "BOUBYAN.KW",
    " marketcap ": " $7 967 822 269 ",
    "price (USD)": "1897",
    "country": "Kuwait"
  },
  {
    "Rank": "1958",
    "Name": "FTI Consulting",
    "Symbol": "FCN",
    " marketcap ": " $7 965 562 368 ",
    "price (USD)": "223.14",
    "country": "United States"
  },
  {
    "Rank": "1959",
    "Name": "EastGroup Properties",
    "Symbol": "EGP",
    " marketcap ": " $7 965 474 304 ",
    "price (USD)": "165.45",
    "country": "United States"
  },
  {
    "Rank": "1960",
    "Name": "Beijer Ref",
    "Symbol": "BEIJ-B.ST",
    " marketcap ": " $7 960 245 867 ",
    "price (USD)": "15.7065",
    "country": "Sweden"
  },
  {
    "Rank": "1961",
    "Name": "WillScot",
    "Symbol": "WSC",
    " marketcap ": " $7 958 523 392 ",
    "price (USD)": "41.87",
    "country": "United States"
  },
  {
    "Rank": "1962",
    "Name": "TIM S.A.",
    "Symbol": "TIMB",
    " marketcap ": " $7 955 293 696 ",
    "price (USD)": "16.24",
    "country": "Brazil"
  },
  {
    "Rank": "1963",
    "Name": "Torrent Power",
    "Symbol": "TORNTPOWER.NS",
    " marketcap ": " $7 951 861 995 ",
    "price (USD)": "16.5451",
    "country": "India"
  },
  {
    "Rank": "1964",
    "Name": "Li Ning Company",
    "Symbol": "2331.HK",
    " marketcap ": " $7 948 241 725 ",
    "price (USD)": "3.07537",
    "country": "China"
  },
  {
    "Rank": "1965",
    "Name": "Primerica",
    "Symbol": "PRI",
    " marketcap ": " $7 947 266 560 ",
    "price (USD)": "230.95",
    "country": "United States"
  },
  {
    "Rank": "1966",
    "Name": "Gentex",
    "Symbol": "GNTX",
    " marketcap ": " $7 941 170 176 ",
    "price (USD)": "34.35",
    "country": "United States"
  },
  {
    "Rank": "1967",
    "Name": "Buzzi Unicem",
    "Symbol": "BZU.MI",
    " marketcap ": " $7 928 410 346 ",
    "price (USD)": "42.8711",
    "country": "Italy"
  },
  {
    "Rank": "1968",
    "Name": "Evercore",
    "Symbol": "EVR",
    " marketcap ": " $7 925 540 352 ",
    "price (USD)": "205.77",
    "country": "United States"
  },
  {
    "Rank": "1969",
    "Name": "Alcoa",
    "Symbol": "AA",
    " marketcap ": " $7 916 800 512 ",
    "price (USD)": "44.09",
    "country": "United States"
  },
  {
    "Rank": "1970",
    "Name": "Container Corporation of India",
    "Symbol": "CONCOR.NS",
    " marketcap ": " $7 915 953 302 ",
    "price (USD)": "\u0434\u0435\u043a.78",
    "country": "India"
  },
  {
    "Rank": "1971",
    "Name": "MISC Berhad",
    "Symbol": "3816.KL",
    " marketcap ": " $7 903 212 796 ",
    "price (USD)": "1.77053",
    "country": "Malaysia"
  },
  {
    "Rank": "1972",
    "Name": "TAL Education Group",
    "Symbol": "TAL",
    " marketcap ": " $7 898 826 240 ",
    "price (USD)": "\u0434\u0435\u043a.37",
    "country": "China"
  },
  {
    "Rank": "1973",
    "Name": "Kl\u0413\u00a9pierre",
    "Symbol": "LI.PA",
    " marketcap ": " $7 894 922 133 ",
    "price (USD)": "27.6469",
    "country": "France"
  },
  {
    "Rank": "1974",
    "Name": "Deutsche Wohnen",
    "Symbol": "DWNI.DE",
    " marketcap ": " $7 887 838 419 ",
    "price (USD)": "19.8719",
    "country": "Germany"
  },
  {
    "Rank": "1975",
    "Name": "Schroders",
    "Symbol": "SDR.L",
    " marketcap ": " $7 886 450 101 ",
    "price (USD)": "4.89213",
    "country": "United Kingdom"
  },
  {
    "Rank": "1976",
    "Name": "Webster Financial",
    "Symbol": "WBS",
    " marketcap ": " $7 884 972 544 ",
    "price (USD)": "45.98",
    "country": "United States"
  },
  {
    "Rank": "1977",
    "Name": "Toray Industries",
    "Symbol": "3402.T",
    " marketcap ": " $7 882 679 069 ",
    "price (USD)": "4.92163",
    "country": "Japan"
  },
  {
    "Rank": "1978",
    "Name": "Fastighets AB Balder",
    "Symbol": "BALD-B.ST",
    " marketcap ": " $7 881 019 229 ",
    "price (USD)": "6.72442",
    "country": "Sweden"
  },
  {
    "Rank": "1979",
    "Name": "Sprouts Farmers Market",
    "Symbol": "SFM",
    " marketcap ": " $7 879 406 080 ",
    "price (USD)": "78.42",
    "country": "United States"
  },
  {
    "Rank": "1980",
    "Name": "Tianqi Lithium",
    "Symbol": "002466.SZ",
    " marketcap ": " $7 869 786 765 ",
    "price (USD)": "5.32786",
    "country": "China"
  },
  {
    "Rank": "1981",
    "Name": "Sonic Healthcare",
    "Symbol": "SHL.AX",
    " marketcap ": " $7 864 289 683 ",
    "price (USD)": "16.3702",
    "country": "Australia"
  },
  {
    "Rank": "1982",
    "Name": "Nissin Foods",
    "Symbol": "2897.T",
    " marketcap ": " $7 861 142 039 ",
    "price (USD)": "25.8525",
    "country": "Japan"
  },
  {
    "Rank": "1983",
    "Name": "CPFL Energia",
    "Symbol": "CPFE3.SA",
    " marketcap ": " $7 850 370 811 ",
    "price (USD)": "6.81308",
    "country": "Brazil"
  },
  {
    "Rank": "1984",
    "Name": "Elia Group",
    "Symbol": "ELI.BR",
    " marketcap ": " $7 849 598 263 ",
    "price (USD)": "106.798",
    "country": "Belgium"
  },
  {
    "Rank": "1985",
    "Name": "Intermediate Capital Group (ICG)",
    "Symbol": "ICP.L",
    " marketcap ": " $7 847 515 527 ",
    "price (USD)": "27.0033",
    "country": "United Kingdom"
  },
  {
    "Rank": "1986",
    "Name": "Wayfair",
    "Symbol": "W",
    " marketcap ": " $7 832 782 848 ",
    "price (USD)": "64.24",
    "country": "United States"
  },
  {
    "Rank": "1987",
    "Name": "Legend Biotech",
    "Symbol": "LEGN",
    " marketcap ": " $7 830 877 696 ",
    "price (USD)": "42.96",
    "country": "United States"
  },
  {
    "Rank": "1988",
    "Name": "Spring Airlines",
    "Symbol": "601021.SS",
    " marketcap ": " $7 829 148 706 ",
    "price (USD)": "8.00077",
    "country": "China"
  },
  {
    "Rank": "1989",
    "Name": "Dolby",
    "Symbol": "DLB",
    " marketcap ": " $7 823 043 584 ",
    "price (USD)": "81.63",
    "country": "United States"
  },
  {
    "Rank": "1990",
    "Name": "JD Sports Fashion",
    "Symbol": "JD.L",
    " marketcap ": " $7 821 791 525 ",
    "price (USD)": "1.50908",
    "country": "United Kingdom"
  },
  {
    "Rank": "1991",
    "Name": "Edison",
    "Symbol": "EDNR.MI",
    " marketcap ": " $7 817 238 128 ",
    "price (USD)": "\u044f\u043d\u0432.97",
    "country": "Italy"
  },
  {
    "Rank": "1992",
    "Name": "Trump Media &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "1993",
    "Name": "Duolingo",
    "Symbol": "DUOL",
    " marketcap ": " $7 800 356 864 ",
    "price (USD)": "180.89",
    "country": "United States"
  },
  {
    "Rank": "1994",
    "Name": "Ingredion",
    "Symbol": "INGR",
    " marketcap ": " $7 799 579 136 ",
    "price (USD)": "118.81",
    "country": "United States"
  },
  {
    "Rank": "1995",
    "Name": "Matador Resources",
    "Symbol": "MTDR",
    " marketcap ": " $7 798 750 208 ",
    "price (USD)": "62.5",
    "country": "United States"
  },
  {
    "Rank": "1996",
    "Name": "Yang Ming",
    "Symbol": "2609.TW",
    " marketcap ": " $7 797 041 316 ",
    "price (USD)": "2.23277",
    "country": "Taiwan"
  },
  {
    "Rank": "1997",
    "Name": "Yara International",
    "Symbol": "YAR.OL",
    " marketcap ": " $7 792 570 393 ",
    "price (USD)": "30.592",
    "country": "Norway"
  },
  {
    "Rank": "1998",
    "Name": "Arkema",
    "Symbol": "AKE.PA",
    " marketcap ": " $7 791 854 403 ",
    "price (USD)": "103.757",
    "country": "France"
  },
  {
    "Rank": "1999",
    "Name": "NNN REIT",
    "Symbol": "NNN",
    " marketcap ": " $7 783 164 928 ",
    "price (USD)": "42.45",
    "country": "United States"
  },
  {
    "Rank": "2000",
    "Name": "Telef\u0413\u0456nica Deutschland (O2)",
    "Symbol": "O2D.DE",
    " marketcap ": " $7 782 253 368 ",
    "price (USD)": "\u0444\u0435\u0432.62",
    "country": "Germany"
  },
  {
    "Rank": "2001",
    "Name": "Prestige Group",
    "Symbol": "PRESTIGE.NS",
    " marketcap ": " $7 776 946 296 ",
    "price (USD)": "19.4006",
    "country": "India"
  },
  {
    "Rank": "2002",
    "Name": "Applied Industrial Technologies",
    "Symbol": "AIT",
    " marketcap ": " $7 762 210 816 ",
    "price (USD)": "201.08",
    "country": "United States"
  },
  {
    "Rank": "2003",
    "Name": "Penumbra",
    "Symbol": "PEN",
    " marketcap ": " $7 761 895 936 ",
    "price (USD)": "200.23",
    "country": "United States"
  },
  {
    "Rank": "2004",
    "Name": "Orkla",
    "Symbol": "ORK.OL",
    " marketcap ": " $7 758 839 948 ",
    "price (USD)": "7.77698",
    "country": "Norway"
  },
  {
    "Rank": "2005",
    "Name": "Ayala Land",
    "Symbol": "AYAAF",
    " marketcap ": " $7 753 719 296 ",
    "price (USD)": "0.52",
    "country": "Philippines"
  },
  {
    "Rank": "2006",
    "Name": "UnipolSai Assicurazioni",
    "Symbol": "US.MI",
    " marketcap ": " $7 752 700 775 ",
    "price (USD)": "\u0444\u0435\u0432.08",
    "country": "Italy"
  },
  {
    "Rank": "2007",
    "Name": "Toppan",
    "Symbol": "7911.T",
    " marketcap ": " $7 747 139 333 ",
    "price (USD)": "24.605",
    "country": "Japan"
  },
  {
    "Rank": "2008",
    "Name": "Oshkosh Corporation",
    "Symbol": "OSK",
    " marketcap ": " $7 743 490 560 ",
    "price (USD)": "118.4",
    "country": "United States"
  },
  {
    "Rank": "2009",
    "Name": "Washington H. Soul Pattinson and Company (WHSP)",
    "Symbol": "SOL.AX",
    " marketcap ": " $7 743 212 035 ",
    "price (USD)": "21.4512",
    "country": "Australia"
  },
  {
    "Rank": "2010",
    "Name": "Saudi Tadawul Group Holding Company",
    "Symbol": "1111.SR",
    " marketcap ": " $7 743 175 223 ",
    "price (USD)": "64.5265",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2011",
    "Name": "SBI Holdings",
    "Symbol": "8473.T",
    " marketcap ": " $7 734 280 340 ",
    "price (USD)": "25.6222",
    "country": "Japan"
  },
  {
    "Rank": "2012",
    "Name": "Bankinter",
    "Symbol": "BKT.MC",
    " marketcap ": " $7 730 561 181 ",
    "price (USD)": "8.60245",
    "country": "Spain"
  },
  {
    "Rank": "2013",
    "Name": "PetGas (Petronas Gas)",
    "Symbol": "6033.KL",
    " marketcap ": " $7 715 086 318 ",
    "price (USD)": "3.89901",
    "country": "Malaysia"
  },
  {
    "Rank": "2014",
    "Name": "Axalta",
    "Symbol": "AXTA",
    " marketcap ": " $7 711 578 112 ",
    "price (USD)": "34.95",
    "country": "United States"
  },
  {
    "Rank": "2015",
    "Name": "GlobalWafers",
    "Symbol": "6488.TWO",
    " marketcap ": " $7 709 841 372 ",
    "price (USD)": "16.1255",
    "country": "Taiwan"
  },
  {
    "Rank": "2016",
    "Name": "Liberty Media",
    "Symbol": "LSXMB",
    " marketcap ": " $7 704 602 624 ",
    "price (USD)": "24.28",
    "country": "United States"
  },
  {
    "Rank": "2017",
    "Name": "Jabal Omar Development",
    "Symbol": "4250.SR",
    " marketcap ": " $7 696 250 429 ",
    "price (USD)": "6.66613",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2018",
    "Name": "Caesars Entertainment",
    "Symbol": "CZR",
    " marketcap ": " $7 689 326 080 ",
    "price (USD)": "35.59",
    "country": "United States"
  },
  {
    "Rank": "2019",
    "Name": "Globe Life",
    "Symbol": "GL",
    " marketcap ": " $7 688 834 048 ",
    "price (USD)": "83.33",
    "country": "United States"
  },
  {
    "Rank": "2020",
    "Name": "Marks &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2021",
    "Name": "Indofood CBP",
    "Symbol": "ICBP.JK",
    " marketcap ": " $7 674 221 052 ",
    "price (USD)": "0.658059",
    "country": "Indonesia"
  },
  {
    "Rank": "2022",
    "Name": "Hongkong Land",
    "Symbol": "H78.SI",
    " marketcap ": " $7 656 971 264 ",
    "price (USD)": "\u043c\u0430\u0440.47",
    "country": "Hong Kong"
  },
  {
    "Rank": "2023",
    "Name": "Gerdau",
    "Symbol": "GGB",
    " marketcap ": " $7 638 899 712 ",
    "price (USD)": "\u043c\u0430\u0440.63",
    "country": "Brazil"
  },
  {
    "Rank": "2024",
    "Name": "Mohawk Industries",
    "Symbol": "MHK",
    " marketcap ": " $7 635 471 872 ",
    "price (USD)": "119.56",
    "country": "United States"
  },
  {
    "Rank": "2025",
    "Name": "Vail Resorts",
    "Symbol": "MTN",
    " marketcap ": " $7 616 421 376 ",
    "price (USD)": "200.6",
    "country": "United States"
  },
  {
    "Rank": "2026",
    "Name": "Lumine Group",
    "Symbol": "LMN.V",
    " marketcap ": " $7 610 393 976 ",
    "price (USD)": "28.5348",
    "country": "Canada"
  },
  {
    "Rank": "2027",
    "Name": "Cerevel Therapeutics",
    "Symbol": "CERE",
    " marketcap ": " $7 610 285 568 ",
    "price (USD)": "41.77",
    "country": "United States"
  },
  {
    "Rank": "2028",
    "Name": "Cemig",
    "Symbol": "CIG",
    " marketcap ": " $7 609 409 024 ",
    "price (USD)": "\u0444\u0435\u0432.66",
    "country": "Brazil"
  },
  {
    "Rank": "2029",
    "Name": "B\u0413\u045eloise",
    "Symbol": "BALN.SW",
    " marketcap ": " $7 604 581 256 ",
    "price (USD)": "167.451",
    "country": "Switzerland"
  },
  {
    "Rank": "2030",
    "Name": "BellRing Brands",
    "Symbol": "BRBR",
    " marketcap ": " $7 601 693 184 ",
    "price (USD)": "58.28",
    "country": "United States"
  },
  {
    "Rank": "2031",
    "Name": "Dropbox",
    "Symbol": "DBX",
    " marketcap ": " $7 596 973 568 ",
    "price (USD)": "23.63",
    "country": "United States"
  },
  {
    "Rank": "2032",
    "Name": "Alkem Laboratories",
    "Symbol": "ALKEM.NS",
    " marketcap ": " $7 578 278 355 ",
    "price (USD)": "63.3821",
    "country": "India"
  },
  {
    "Rank": "2033",
    "Name": "NOV",
    "Symbol": "NOV",
    " marketcap ": " $7 558 693 376 ",
    "price (USD)": "19.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "2034",
    "Name": "Japan Airlines",
    "Symbol": "9201.T",
    " marketcap ": " $7 549 980 410 ",
    "price (USD)": "17.2766",
    "country": "Japan"
  },
  {
    "Rank": "2035",
    "Name": "Azrieli Group",
    "Symbol": "AZRG.TA",
    " marketcap ": " $7 543 185 759 ",
    "price (USD)": "62.2",
    "country": "Israel"
  },
  {
    "Rank": "2036",
    "Name": "Oberoi Realty",
    "Symbol": "OBEROIRLTY.NS",
    " marketcap ": " $7 542 964 964 ",
    "price (USD)": "20.7403",
    "country": "India"
  },
  {
    "Rank": "2037",
    "Name": "The Lottery Corporation",
    "Symbol": "TLC.AX",
    " marketcap ": " $7 539 650 656 ",
    "price (USD)": "3.38739",
    "country": "Australia"
  },
  {
    "Rank": "2038",
    "Name": "Suzlon",
    "Symbol": "SUZLON.NS",
    " marketcap ": " $7 535 625 266 ",
    "price (USD)": "0.553907",
    "country": "India"
  },
  {
    "Rank": "2039",
    "Name": "Altair Engineering",
    "Symbol": "ALTR",
    " marketcap ": " $7 534 404 608 ",
    "price (USD)": "90.74",
    "country": "United States"
  },
  {
    "Rank": "2040",
    "Name": "Mapfre",
    "Symbol": "MAP.MC",
    " marketcap ": " $7 533 767 818 ",
    "price (USD)": "2.45846",
    "country": "Spain"
  },
  {
    "Rank": "2041",
    "Name": "Allegheny Technologies",
    "Symbol": "ATI",
    " marketcap ": " $7 527 436 288 ",
    "price (USD)": "60.49",
    "country": "United States"
  },
  {
    "Rank": "2042",
    "Name": "Liberty Broadband",
    "Symbol": "LBRDA",
    " marketcap ": " $7 525 812 736 ",
    "price (USD)": "52.91",
    "country": "United States"
  },
  {
    "Rank": "2043",
    "Name": "Chord Energy",
    "Symbol": "CHRD",
    " marketcap ": " $7 521 072 640 ",
    "price (USD)": "180.39",
    "country": "United States"
  },
  {
    "Rank": "2044",
    "Name": "H&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2045",
    "Name": "Knight-Swift",
    "Symbol": "KNX",
    " marketcap ": " $7 510 063 616 ",
    "price (USD)": "46.47",
    "country": "United States"
  },
  {
    "Rank": "2046",
    "Name": "Alstom",
    "Symbol": "ALO.PA",
    " marketcap ": " $7 509 099 637 ",
    "price (USD)": "19.4918",
    "country": "France"
  },
  {
    "Rank": "2047",
    "Name": "Singapore Exchange",
    "Symbol": "S68.SI",
    " marketcap ": " $7 508 432 960 ",
    "price (USD)": "7.01585",
    "country": "Singapore"
  },
  {
    "Rank": "2048",
    "Name": "Globant",
    "Symbol": "GLOB",
    " marketcap ": " $7 506 847 232 ",
    "price (USD)": "174",
    "country": "Luxembourg"
  },
  {
    "Rank": "2049",
    "Name": "Etsy",
    "Symbol": "ETSY",
    " marketcap ": " $7 504 759 808 ",
    "price (USD)": "64.18",
    "country": "United States"
  },
  {
    "Rank": "2050",
    "Name": "Americana Restaurants International",
    "Symbol": "AMR.AE",
    " marketcap ": " $7 500 008 233 ",
    "price (USD)": "0.89",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "2051",
    "Name": "Petro Rio",
    "Symbol": "PRIO3.SA",
    " marketcap ": " $7 498 276 332 ",
    "price (USD)": "8.95071",
    "country": "Brazil"
  },
  {
    "Rank": "2052",
    "Name": "AGC",
    "Symbol": "5201.T",
    " marketcap ": " $7 492 437 362 ",
    "price (USD)": "35.308",
    "country": "Japan"
  },
  {
    "Rank": "2053",
    "Name": "Voya Financial",
    "Symbol": "VOYA",
    " marketcap ": " $7 491 147 264 ",
    "price (USD)": "74.39",
    "country": "United States"
  },
  {
    "Rank": "2054",
    "Name": "BPER Banca",
    "Symbol": "BPE.MI",
    " marketcap ": " $7 486 381 826 ",
    "price (USD)": "\u043c\u0430\u0439.31",
    "country": "Italy"
  },
  {
    "Rank": "2055",
    "Name": "Ramsay Health Care",
    "Symbol": "RHC.AX",
    " marketcap ": " $7 485 450 379 ",
    "price (USD)": "32.5803",
    "country": "Australia"
  },
  {
    "Rank": "2056",
    "Name": "SoFi",
    "Symbol": "SOFI",
    " marketcap ": " $7 485 117 440 ",
    "price (USD)": "07.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "2057",
    "Name": "MSA Safety",
    "Symbol": "MSA",
    " marketcap ": " $7 479 860 736 ",
    "price (USD)": "189.93",
    "country": "United States"
  },
  {
    "Rank": "2058",
    "Name": "APA Group",
    "Symbol": "APA.AX",
    " marketcap ": " $7 479 248 394 ",
    "price (USD)": "5.82791",
    "country": "Australia"
  },
  {
    "Rank": "2059",
    "Name": "TMX Group",
    "Symbol": "X.TO",
    " marketcap ": " $7 468 940 158 ",
    "price (USD)": "26.9511",
    "country": "Canada"
  },
  {
    "Rank": "2060",
    "Name": "Rumo",
    "Symbol": "RAIL3.SA",
    " marketcap ": " $7 466 640 579 ",
    "price (USD)": "4.03709",
    "country": "Brazil"
  },
  {
    "Rank": "2061",
    "Name": "Hanwha Aerospace",
    "Symbol": "012450.KS",
    " marketcap ": " $7 464 748 026 ",
    "price (USD)": "147.614",
    "country": "South Korea"
  },
  {
    "Rank": "2062",
    "Name": "OGE Energy",
    "Symbol": "OGE",
    " marketcap ": " $7 460 385 792 ",
    "price (USD)": "37.2",
    "country": "United States"
  },
  {
    "Rank": "2063",
    "Name": "Amer Sports",
    "Symbol": "AS",
    " marketcap ": " $7 457 489 920 ",
    "price (USD)": "14.76",
    "country": "Finland"
  },
  {
    "Rank": "2064",
    "Name": "Toyo Suisan",
    "Symbol": "2875.T",
    " marketcap ": " $7 454 859 083 ",
    "price (USD)": "72.996",
    "country": "Japan"
  },
  {
    "Rank": "2065",
    "Name": "Acciona Energ\u0413\u00adas Renovables",
    "Symbol": "ANE.MC",
    " marketcap ": " $7 440 802 207 ",
    "price (USD)": "22.9558",
    "country": "Spain"
  },
  {
    "Rank": "2066",
    "Name": "Universal Forest Products",
    "Symbol": "UFPI",
    " marketcap ": " $7 440 110 080 ",
    "price (USD)": "120.48",
    "country": "United States"
  },
  {
    "Rank": "2067",
    "Name": "Central Pattana",
    "Symbol": "CPN.BK",
    " marketcap ": " $7 434 958 404 ",
    "price (USD)": "1.65663",
    "country": "Thailand"
  },
  {
    "Rank": "2068",
    "Name": "SK Innovation",
    "Symbol": "096775.KS",
    " marketcap ": " $7 421 445 348 ",
    "price (USD)": "55.3001",
    "country": "South Korea"
  },
  {
    "Rank": "2069",
    "Name": "Toromont",
    "Symbol": "TIH.TO",
    " marketcap ": " $7 418 153 451 ",
    "price (USD)": "90.2306",
    "country": "Canada"
  },
  {
    "Rank": "2070",
    "Name": "Icahn Enterprises",
    "Symbol": "IEP",
    " marketcap ": " $7 413 117 440 ",
    "price (USD)": "16.43",
    "country": "United States"
  },
  {
    "Rank": "2071",
    "Name": "China Development Financial",
    "Symbol": "2883.TW",
    " marketcap ": " $7 412 076 023 ",
    "price (USD)": "0.440351",
    "country": "Taiwan"
  },
  {
    "Rank": "2072",
    "Name": "Abu Dhabi Ports",
    "Symbol": "ADPORTS.AE",
    " marketcap ": " $7 400 713 372 ",
    "price (USD)": "\u044f\u043d\u0432.45",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "2073",
    "Name": "Helvetia Holding",
    "Symbol": "HELN.SW",
    " marketcap ": " $7 387 539 011 ",
    "price (USD)": "139.799",
    "country": "Switzerland"
  },
  {
    "Rank": "2074",
    "Name": "MACOM",
    "Symbol": "MTSI",
    " marketcap ": " $7 380 831 744 ",
    "price (USD)": "102.36",
    "country": "United States"
  },
  {
    "Rank": "2075",
    "Name": "Abercrombie &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2076",
    "Name": "Ashok Leyland",
    "Symbol": "ASHOKLEY.NS",
    " marketcap ": " $7 375 457 471 ",
    "price (USD)": "\u0444\u0435\u0432.12",
    "country": "India"
  },
  {
    "Rank": "2077",
    "Name": "Kesko",
    "Symbol": "KESKOA.HE",
    " marketcap ": " $7 373 384 333 ",
    "price (USD)": "18.8077",
    "country": "Finland"
  },
  {
    "Rank": "2078",
    "Name": "Alfamart",
    "Symbol": "AMRT.JK",
    " marketcap ": " $7 373 363 526 ",
    "price (USD)": "0.177567",
    "country": "Indonesia"
  },
  {
    "Rank": "2079",
    "Name": "Civitas Resources",
    "Symbol": "CIVI",
    " marketcap ": " $7 371 702 272 ",
    "price (USD)": "73.65",
    "country": "United States"
  },
  {
    "Rank": "2080",
    "Name": "Commerce Bancshares",
    "Symbol": "CBSH",
    " marketcap ": " $7 366 712 320 ",
    "price (USD)": "56.87",
    "country": "United States"
  },
  {
    "Rank": "2081",
    "Name": "Mitsubishi Chemical Holdings",
    "Symbol": "4188.T",
    " marketcap ": " $7 362 722 954 ",
    "price (USD)": "5.17561",
    "country": "Japan"
  },
  {
    "Rank": "2082",
    "Name": "Chongqing Rural Commercial Bank",
    "Symbol": "3618.HK",
    " marketcap ": " $7 361 091 339 ",
    "price (USD)": "0.499748",
    "country": "China"
  },
  {
    "Rank": "2083",
    "Name": "Bachem",
    "Symbol": "BANB.SW",
    " marketcap ": " $7 359 063 853 ",
    "price (USD)": "98.1554",
    "country": "Switzerland"
  },
  {
    "Rank": "2084",
    "Name": "Americold",
    "Symbol": "COLD",
    " marketcap ": " $7 339 857 408 ",
    "price (USD)": "25.75",
    "country": "United States"
  },
  {
    "Rank": "2085",
    "Name": "Elisa",
    "Symbol": "ELISA.HE",
    " marketcap ": " $7 335 007 406 ",
    "price (USD)": "45.6944",
    "country": "Finland"
  },
  {
    "Rank": "2086",
    "Name": "Taishin Financial Holdings",
    "Symbol": "2887.TW",
    " marketcap ": " $7 312 840 722 ",
    "price (USD)": "0.586101",
    "country": "Taiwan"
  },
  {
    "Rank": "2087",
    "Name": "DCC plc",
    "Symbol": "DCC.L",
    " marketcap ": " $7 301 740 204 ",
    "price (USD)": "73.865",
    "country": "Ireland"
  },
  {
    "Rank": "2088",
    "Name": "Balkrishna Industries",
    "Symbol": "BALKRISIND.NS",
    " marketcap ": " $7 300 459 628 ",
    "price (USD)": "37.7642",
    "country": "India"
  },
  {
    "Rank": "2089",
    "Name": "Unilever Indonesia",
    "Symbol": "UNVR.JK",
    " marketcap ": " $7 298 924 464 ",
    "price (USD)": "0.191322",
    "country": "Indonesia"
  },
  {
    "Rank": "2090",
    "Name": "Bangkok Bank",
    "Symbol": "BBL.BK",
    " marketcap ": " $7 295 464 873 ",
    "price (USD)": "3.82194",
    "country": "Thailand"
  },
  {
    "Rank": "2091",
    "Name": "KT&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2092",
    "Name": "Five Below",
    "Symbol": "FIVE",
    " marketcap ": " $7 285 370 368 ",
    "price (USD)": "132",
    "country": "United States"
  },
  {
    "Rank": "2093",
    "Name": "Simpson Manufacturing Company",
    "Symbol": "SSD",
    " marketcap ": " $7 282 355 712 ",
    "price (USD)": "172.74",
    "country": "United States"
  },
  {
    "Rank": "2094",
    "Name": "Lear Corporation",
    "Symbol": "LEA",
    " marketcap ": " $7 279 628 288 ",
    "price (USD)": "128.19",
    "country": "United States"
  },
  {
    "Rank": "2095",
    "Name": "Dai Nippon Printing",
    "Symbol": "7912.T",
    " marketcap ": " $7 274 543 051 ",
    "price (USD)": "30.6442",
    "country": "Japan"
  },
  {
    "Rank": "2096",
    "Name": "Skanska",
    "Symbol": "SKA-B.ST",
    " marketcap ": " $7 265 723 422 ",
    "price (USD)": "17.705",
    "country": "Sweden"
  },
  {
    "Rank": "2097",
    "Name": "Norwegian Cruise Line",
    "Symbol": "NCLH",
    " marketcap ": " $7 263 664 128 ",
    "price (USD)": "16.93",
    "country": "United States"
  },
  {
    "Rank": "2098",
    "Name": "Chewy",
    "Symbol": "CHWY",
    " marketcap ": " $7 263 097 344 ",
    "price (USD)": "16.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "2099",
    "Name": "Lithia Motors",
    "Symbol": "LAD",
    " marketcap ": " $7 258 611 712 ",
    "price (USD)": "264.85",
    "country": "United States"
  },
  {
    "Rank": "2100",
    "Name": "Isetan Mitsukoshi Holdings",
    "Symbol": "3099.T",
    " marketcap ": " $7 256 550 524 ",
    "price (USD)": "19.3334",
    "country": "Japan"
  },
  {
    "Rank": "2101",
    "Name": "Hulic",
    "Symbol": "3003.T",
    " marketcap ": " $7 241 387 227 ",
    "price (USD)": "9.51635",
    "country": "Japan"
  },
  {
    "Rank": "2102",
    "Name": "Swiss Prime Site",
    "Symbol": "SPSN.SW",
    " marketcap ": " $7 240 443 862 ",
    "price (USD)": "93.6564",
    "country": "Switzerland"
  },
  {
    "Rank": "2103",
    "Name": "Ebara Corporation",
    "Symbol": "6361.T",
    " marketcap ": " $7 236 583 238 ",
    "price (USD)": "78.3699",
    "country": "Japan"
  },
  {
    "Rank": "2104",
    "Name": "Dillard's",
    "Symbol": "DDS",
    " marketcap ": " $7 220 122 112 ",
    "price (USD)": "444.86",
    "country": "United States"
  },
  {
    "Rank": "2105",
    "Name": "Robert Half",
    "Symbol": "RHI",
    " marketcap ": " $7 214 144 000 ",
    "price (USD)": "68.75",
    "country": "United States"
  },
  {
    "Rank": "2106",
    "Name": "MINISO Group",
    "Symbol": "MNSO",
    " marketcap ": " $7 209 400 832 ",
    "price (USD)": "22.\u0441\u0435\u043d",
    "country": "China"
  },
  {
    "Rank": "2107",
    "Name": "SPS Commerce",
    "Symbol": "SPSC",
    " marketcap ": " $7 208 005 632 ",
    "price (USD)": "194.64",
    "country": "United States"
  },
  {
    "Rank": "2108",
    "Name": "Schibsted",
    "Symbol": "SCHA.OL",
    " marketcap ": " $7 199 144 042 ",
    "price (USD)": "31.577",
    "country": "Norway"
  },
  {
    "Rank": "2109",
    "Name": "Watts Water Technologies",
    "Symbol": "WTS",
    " marketcap ": " $7 197 392 384 ",
    "price (USD)": "215.68",
    "country": "United States"
  },
  {
    "Rank": "2110",
    "Name": "Diploma plc",
    "Symbol": "DPLM.L",
    " marketcap ": " $7 197 345 111 ",
    "price (USD)": "53.7015",
    "country": "United Kingdom"
  },
  {
    "Rank": "2111",
    "Name": "Stockland",
    "Symbol": "SGP.AX",
    " marketcap ": " $7 194 874 128 ",
    "price (USD)": "3.01398",
    "country": "Australia"
  },
  {
    "Rank": "2112",
    "Name": "Tingyi (master kang)",
    "Symbol": "0322.HK",
    " marketcap ": " $7 191 020 787 ",
    "price (USD)": "1.27628",
    "country": "China"
  },
  {
    "Rank": "2113",
    "Name": "Shanghai Commercial and Savings Bank",
    "Symbol": "5876.TW",
    " marketcap ": " $7 189 506 253 ",
    "price (USD)": "1.48231",
    "country": "Taiwan"
  },
  {
    "Rank": "2114",
    "Name": "The Weir Group",
    "Symbol": "WEIR.L",
    " marketcap ": " $7 188 615 523 ",
    "price (USD)": "27.6898",
    "country": "United Kingdom"
  },
  {
    "Rank": "2115",
    "Name": "Tokyu",
    "Symbol": "9005.T",
    " marketcap ": " $7 184 967 820 ",
    "price (USD)": "\u043d\u043e\u044f.22",
    "country": "Japan"
  },
  {
    "Rank": "2116",
    "Name": "Emirates Integrated Telecommunications Company",
    "Symbol": "DU.AE",
    " marketcap ": " $7 183 145 174 ",
    "price (USD)": "1.58467",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "2117",
    "Name": "AGNC Investment",
    "Symbol": "AGNC",
    " marketcap ": " $7 182 059 008 ",
    "price (USD)": "\u0441\u0435\u043d.88",
    "country": "United States"
  },
  {
    "Rank": "2118",
    "Name": "Invesco",
    "Symbol": "IVZ",
    " marketcap ": " $7 179 302 912 ",
    "price (USD)": "15.96",
    "country": "United States"
  },
  {
    "Rank": "2119",
    "Name": "Acciona",
    "Symbol": "ANA.MC",
    " marketcap ": " $7 165 170 073 ",
    "price (USD)": "132.045",
    "country": "Spain"
  },
  {
    "Rank": "2120",
    "Name": "Whitbread",
    "Symbol": "WTB.L",
    " marketcap ": " $7 152 593 198 ",
    "price (USD)": "39.153",
    "country": "United Kingdom"
  },
  {
    "Rank": "2121",
    "Name": "Middleby",
    "Symbol": "MIDD",
    " marketcap ": " $7 149 060 096 ",
    "price (USD)": "132.96",
    "country": "United States"
  },
  {
    "Rank": "2122",
    "Name": "Ciena",
    "Symbol": "CIEN",
    " marketcap ": " $7 147 726 848 ",
    "price (USD)": "49.43",
    "country": "United States"
  },
  {
    "Rank": "2123",
    "Name": "Antero Midstream",
    "Symbol": "AM",
    " marketcap ": " $7 146 428 928 ",
    "price (USD)": "14.85",
    "country": "United States"
  },
  {
    "Rank": "2124",
    "Name": "Cathay Pacific",
    "Symbol": "0293.HK",
    " marketcap ": " $7 135 870 203 ",
    "price (USD)": "1.10842",
    "country": "Hong Kong"
  },
  {
    "Rank": "2125",
    "Name": "Western Alliance Bancorporation",
    "Symbol": "WAL",
    " marketcap ": " $7 123 080 704 ",
    "price (USD)": "64.69",
    "country": "United States"
  },
  {
    "Rank": "2126",
    "Name": "Unipol Gruppo",
    "Symbol": "UNI.MI",
    " marketcap ": " $7 119 542 639 ",
    "price (USD)": "9.93593",
    "country": "Italy"
  },
  {
    "Rank": "2127",
    "Name": "Dentsu",
    "Symbol": "4324.T",
    " marketcap ": " $7 116 548 084 ",
    "price (USD)": "27.0296",
    "country": "Japan"
  },
  {
    "Rank": "2128",
    "Name": "ENGIE Brasil",
    "Symbol": "EGIE3.SA",
    " marketcap ": " $7 108 808 102 ",
    "price (USD)": "8.71254",
    "country": "Brazil"
  },
  {
    "Rank": "2129",
    "Name": "Barito Pacific",
    "Symbol": "BRPT.JK",
    " marketcap ": " $7 107 514 304 ",
    "price (USD)": "0.075966",
    "country": "Indonesia"
  },
  {
    "Rank": "2130",
    "Name": "Comerica",
    "Symbol": "CMA",
    " marketcap ": " $7 106 662 912 ",
    "price (USD)": "53.6",
    "country": "United States"
  },
  {
    "Rank": "2131",
    "Name": "AAK",
    "Symbol": "AAK.ST",
    " marketcap ": " $7 103 983 670 ",
    "price (USD)": "27.3694",
    "country": "Sweden"
  },
  {
    "Rank": "2132",
    "Name": "Gruma (Maseca)",
    "Symbol": "GRUMAB.MX",
    " marketcap ": " $7 099 358 713 ",
    "price (USD)": "19.3715",
    "country": "Mexico"
  },
  {
    "Rank": "2133",
    "Name": "Equatorial Energia",
    "Symbol": "EQTL3.SA",
    " marketcap ": " $7 099 327 931 ",
    "price (USD)": "5.97169",
    "country": "Brazil"
  },
  {
    "Rank": "2134",
    "Name": "SAIC",
    "Symbol": "SAIC",
    " marketcap ": " $7 098 556 416 ",
    "price (USD)": "137.44",
    "country": "United States"
  },
  {
    "Rank": "2135",
    "Name": "Kirby Corporation",
    "Symbol": "KEX",
    " marketcap ": " $7 097 441 792 ",
    "price (USD)": "121.74",
    "country": "United States"
  },
  {
    "Rank": "2136",
    "Name": "Otsuka",
    "Symbol": "4768.T",
    " marketcap ": " $7 097 149 327 ",
    "price (USD)": "18.716",
    "country": "Japan"
  },
  {
    "Rank": "2137",
    "Name": "Capcom",
    "Symbol": "9697.T",
    " marketcap ": " $7 095 961 956 ",
    "price (USD)": "16.9663",
    "country": "Japan"
  },
  {
    "Rank": "2138",
    "Name": "Becle",
    "Symbol": "CUERVO.MX",
    " marketcap ": " $7 095 032 911 ",
    "price (USD)": "1.96966",
    "country": "Mexico"
  },
  {
    "Rank": "2139",
    "Name": "CCC Intelligent Solutions",
    "Symbol": "CCCS",
    " marketcap ": " $7 092 967 936 ",
    "price (USD)": "\u043d\u043e\u044f.47",
    "country": "United States"
  },
  {
    "Rank": "2140",
    "Name": "Viking Therapeutics",
    "Symbol": "VKTX",
    " marketcap ": " $7 082 513 920 ",
    "price (USD)": "64.23",
    "country": "United States"
  },
  {
    "Rank": "2141",
    "Name": "Intra-Cellular Therapies",
    "Symbol": "ITCI",
    " marketcap ": " $7 073 525 248 ",
    "price (USD)": "67",
    "country": "United States"
  },
  {
    "Rank": "2142",
    "Name": "Teleperformance",
    "Symbol": "TEP.PA",
    " marketcap ": " $7 072 573 074 ",
    "price (USD)": "116.191",
    "country": "France"
  },
  {
    "Rank": "2143",
    "Name": "Sunoco",
    "Symbol": "SUN",
    " marketcap ": " $7 065 397 248 ",
    "price (USD)": "52.32",
    "country": "United States"
  },
  {
    "Rank": "2144",
    "Name": "Sino Biopharmaceutical",
    "Symbol": "1177.HK",
    " marketcap ": " $7 055 191 296 ",
    "price (USD)": "0.375452",
    "country": "China"
  },
  {
    "Rank": "2145",
    "Name": "Element Fleet Management",
    "Symbol": "EFN.TO",
    " marketcap ": " $7 051 376 089 ",
    "price (USD)": "18.1385",
    "country": "Canada"
  },
  {
    "Rank": "2146",
    "Name": "NEXTDC",
    "Symbol": "NXT.AX",
    " marketcap ": " $7 045 526 683 ",
    "price (USD)": "\u043d\u043e\u044f.58",
    "country": "Australia"
  },
  {
    "Rank": "2147",
    "Name": "Summit Materials",
    "Symbol": "SUM",
    " marketcap ": " $7 039 655 424 ",
    "price (USD)": "40.12",
    "country": "United States"
  },
  {
    "Rank": "2148",
    "Name": "AirTAC International",
    "Symbol": "1590.TW",
    " marketcap ": " $7 039 413 844 ",
    "price (USD)": "35.1971",
    "country": "Taiwan"
  },
  {
    "Rank": "2149",
    "Name": "Arrow Electronics",
    "Symbol": "ARW",
    " marketcap ": " $7 026 878 976 ",
    "price (USD)": "132.01",
    "country": "United States"
  },
  {
    "Rank": "2150",
    "Name": "WuXi Biologics",
    "Symbol": "WXXWY",
    " marketcap ": " $7 026 744 832 ",
    "price (USD)": "3.335",
    "country": "China"
  },
  {
    "Rank": "2151",
    "Name": "SentinelOne",
    "Symbol": "S",
    " marketcap ": " $7 026 421 760 ",
    "price (USD)": "22.55",
    "country": "United States"
  },
  {
    "Rank": "2152",
    "Name": "MGM China Holdings",
    "Symbol": "2282.HK",
    " marketcap ": " $7 021 608 413 ",
    "price (USD)": "1.84266",
    "country": "Macau"
  },
  {
    "Rank": "2153",
    "Name": "Ascendis Pharma",
    "Symbol": "ASND",
    " marketcap ": " $7 016 430 080 ",
    "price (USD)": "122.85",
    "country": "Denmark"
  },
  {
    "Rank": "2154",
    "Name": "Fluor Corporation",
    "Symbol": "FLR",
    " marketcap ": " $6 998 288 384 ",
    "price (USD)": "40.88",
    "country": "United States"
  },
  {
    "Rank": "2155",
    "Name": "Compagnie de l'Odet",
    "Symbol": "ODET.PA",
    " marketcap ": " $6 987 546 826 ",
    "price (USD)": "1637.53",
    "country": "France"
  },
  {
    "Rank": "2156",
    "Name": "B&M European Value Retail",
    "Symbol": "BME.L",
    " marketcap ": " $6 986 395 799 ",
    "price (USD)": "6.96696",
    "country": "Luxembourg"
  },
  {
    "Rank": "2157",
    "Name": "Daifuku",
    "Symbol": "6383.T",
    " marketcap ": " $6 985 738 545 ",
    "price (USD)": "18.8472",
    "country": "Japan"
  },
  {
    "Rank": "2158",
    "Name": "SiteOne Landscape Supply",
    "Symbol": "SITE",
    " marketcap ": " $6 982 556 672 ",
    "price (USD)": "154.44",
    "country": "United States"
  },
  {
    "Rank": "2159",
    "Name": "Aditya Birla Capital",
    "Symbol": "ABCAPITAL.NS",
    " marketcap ": " $6 977 471 165 ",
    "price (USD)": "2.68302",
    "country": "India"
  },
  {
    "Rank": "2160",
    "Name": "Kingdom Holding",
    "Symbol": "4280.SR",
    " marketcap ": " $6 972 300 218 ",
    "price (USD)": "1.88135",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2161",
    "Name": "Jindal Stainless",
    "Symbol": "JSL.NS",
    " marketcap ": " $6 937 563 868 ",
    "price (USD)": "8.42515",
    "country": "India"
  },
  {
    "Rank": "2162",
    "Name": "Bank of India",
    "Symbol": "BANKINDIA.NS",
    " marketcap ": " $6 936 275 621 ",
    "price (USD)": "1.52294",
    "country": "India"
  },
  {
    "Rank": "2163",
    "Name": "Brunello Cucinelli",
    "Symbol": "BC.MI",
    " marketcap ": " $6 932 323 214 ",
    "price (USD)": "100.88",
    "country": "Italy"
  },
  {
    "Rank": "2164",
    "Name": "ENKA",
    "Symbol": "ENKAI.IS",
    " marketcap ": " $6 928 972 239 ",
    "price (USD)": "\u044f\u043d\u0432.02",
    "country": "Turkey"
  },
  {
    "Rank": "2165",
    "Name": "Choice Properties REIT",
    "Symbol": "CHP-UN.TO",
    " marketcap ": " $6 918 403 613 ",
    "price (USD)": "9.56047",
    "country": "Canada"
  },
  {
    "Rank": "2166",
    "Name": "Berry Global",
    "Symbol": "BERY",
    " marketcap ": " $6 912 047 616 ",
    "price (USD)": "60.42",
    "country": "United States"
  },
  {
    "Rank": "2167",
    "Name": "Phoenix Mills",
    "Symbol": "PHOENIXLTD.NS",
    " marketcap ": " $6 904 715 942 ",
    "price (USD)": "38.6293",
    "country": "India"
  },
  {
    "Rank": "2168",
    "Name": "Auckland Airport",
    "Symbol": "AIA.AX",
    " marketcap ": " $6 904 600 363 ",
    "price (USD)": "4.65433",
    "country": "New Zealand"
  },
  {
    "Rank": "2169",
    "Name": "Japan Post Insurance",
    "Symbol": "7181.T",
    " marketcap ": " $6 901 818 000 ",
    "price (USD)": "18.0315",
    "country": "Japan"
  },
  {
    "Rank": "2170",
    "Name": "HealthEquity",
    "Symbol": "HQY",
    " marketcap ": " $6 900 755 456 ",
    "price (USD)": "79.31",
    "country": "United States"
  },
  {
    "Rank": "2171",
    "Name": "GEA Group",
    "Symbol": "G1A.F",
    " marketcap ": " $6 897 388 902 ",
    "price (USD)": "40.7645",
    "country": "Germany"
  },
  {
    "Rank": "2172",
    "Name": "The AZEK Company",
    "Symbol": "AZEK",
    " marketcap ": " $6 890 278 400 ",
    "price (USD)": "47.25",
    "country": "United States"
  },
  {
    "Rank": "2173",
    "Name": "PB Fintech",
    "Symbol": "POLICYBZR.NS",
    " marketcap ": " $6 889 530 223 ",
    "price (USD)": "15.349",
    "country": "India"
  },
  {
    "Rank": "2174",
    "Name": "Sembcorp",
    "Symbol": "U96.SI",
    " marketcap ": " $6 881 974 856 ",
    "price (USD)": "3.86057",
    "country": "Singapore"
  },
  {
    "Rank": "2175",
    "Name": "Alamos Gold",
    "Symbol": "AGI",
    " marketcap ": " $6 879 041 024 ",
    "price (USD)": "17.25",
    "country": "Canada"
  },
  {
    "Rank": "2176",
    "Name": "Sabanc\u0414\u00b1 Holding",
    "Symbol": "SAHOL.IS",
    " marketcap ": " $6 876 630 425 ",
    "price (USD)": "3.27399",
    "country": "Turkey"
  },
  {
    "Rank": "2177",
    "Name": "SITC International",
    "Symbol": "1308.HK",
    " marketcap ": " $6 875 048 608 ",
    "price (USD)": "2.56281",
    "country": "Hong Kong"
  },
  {
    "Rank": "2178",
    "Name": "SJVN",
    "Symbol": "SJVN.NS",
    " marketcap ": " $6 874 919 334 ",
    "price (USD)": "1.74943",
    "country": "India"
  },
  {
    "Rank": "2179",
    "Name": "Trina Solar",
    "Symbol": "688599.SS",
    " marketcap ": " $6 872 872 769 ",
    "price (USD)": "3.15362",
    "country": "China"
  },
  {
    "Rank": "2180",
    "Name": "Topicus",
    "Symbol": "TOI.V",
    " marketcap ": " $6 872 809 918 ",
    "price (USD)": "82.9209",
    "country": "Canada"
  },
  {
    "Rank": "2181",
    "Name": "Fran\u0413\u00a7aise des Jeux",
    "Symbol": "FDJ.VI",
    " marketcap ": " $6 870 183 238 ",
    "price (USD)": "37.1159",
    "country": "France"
  },
  {
    "Rank": "2182",
    "Name": "M3, Inc",
    "Symbol": "2413.T",
    " marketcap ": " $6 861 422 231 ",
    "price (USD)": "10.1049",
    "country": "Japan"
  },
  {
    "Rank": "2183",
    "Name": "Banca Monte dei Paschi di Siena",
    "Symbol": "BMPS.MI",
    " marketcap ": " $6 851 780 371 ",
    "price (USD)": "5.41861",
    "country": "Italy"
  },
  {
    "Rank": "2184",
    "Name": "Darling Ingredients",
    "Symbol": "DAR",
    " marketcap ": " $6 849 768 448 ",
    "price (USD)": "42.87",
    "country": "United States"
  },
  {
    "Rank": "2185",
    "Name": "Holmen",
    "Symbol": "HOLM-B.ST",
    " marketcap ": " $6 849 507 911 ",
    "price (USD)": "43.1509",
    "country": "Sweden"
  },
  {
    "Rank": "2186",
    "Name": "Berger Paints",
    "Symbol": "BERGEPAINT.NS",
    " marketcap ": " $6 844 751 842 ",
    "price (USD)": "5.87129",
    "country": "India"
  },
  {
    "Rank": "2187",
    "Name": "Want Want China",
    "Symbol": "0151.HK",
    " marketcap ": " $6 841 398 018 ",
    "price (USD)": "0.579195",
    "country": "Hong Kong"
  },
  {
    "Rank": "2188",
    "Name": "MOL Group",
    "Symbol": "MOL.BD",
    " marketcap ": " $6 826 066 776 ",
    "price (USD)": "8.62234",
    "country": "Hungary"
  },
  {
    "Rank": "2189",
    "Name": "Galicia Financial Group",
    "Symbol": "GGAL",
    " marketcap ": " $6 823 837 696 ",
    "price (USD)": "36.18",
    "country": "Argentina"
  },
  {
    "Rank": "2190",
    "Name": "Mobile TeleSystems",
    "Symbol": "MTSS.ME",
    " marketcap ": " $6 817 879 465 ",
    "price (USD)": "\u043c\u0430\u0440.39",
    "country": "Russia"
  },
  {
    "Rank": "2191",
    "Name": "DSME (Daewoo Shipbuilding)",
    "Symbol": "042660.KS",
    " marketcap ": " $6 816 821 160 ",
    "price (USD)": "22.2523",
    "country": "South Korea"
  },
  {
    "Rank": "2192",
    "Name": "AutoNation",
    "Symbol": "AN",
    " marketcap ": " $6 816 715 264 ",
    "price (USD)": "169.29",
    "country": "United States"
  },
  {
    "Rank": "2193",
    "Name": "ZOZO",
    "Symbol": "3092.T",
    " marketcap ": " $6 816 328 129 ",
    "price (USD)": "22.9544",
    "country": "Japan"
  },
  {
    "Rank": "2194",
    "Name": "Central Bank of India",
    "Symbol": "CENTRALBK.NS",
    " marketcap ": " $6 808 940 792 ",
    "price (USD)": "0.7834",
    "country": "India"
  },
  {
    "Rank": "2195",
    "Name": "Hikari Tsushin",
    "Symbol": "9435.T",
    " marketcap ": " $6 807 615 292 ",
    "price (USD)": "154.213",
    "country": "Japan"
  },
  {
    "Rank": "2196",
    "Name": "Nextracker",
    "Symbol": "NXT",
    " marketcap ": " $6 807 335 424 ",
    "price (USD)": "47.05",
    "country": "United States"
  },
  {
    "Rank": "2197",
    "Name": "Astral Poly Technik",
    "Symbol": "ASTRAL.NS",
    " marketcap ": " $6 800 642 783 ",
    "price (USD)": "25.3163",
    "country": "India"
  },
  {
    "Rank": "2198",
    "Name": "Noble Corporation",
    "Symbol": "NE",
    " marketcap ": " $6 798 279 168 ",
    "price (USD)": "47.6",
    "country": "United Kingdom"
  },
  {
    "Rank": "2199",
    "Name": "The Ensign Group",
    "Symbol": "ENSG",
    " marketcap ": " $6 796 037 120 ",
    "price (USD)": "119.39",
    "country": "United States"
  },
  {
    "Rank": "2200",
    "Name": "Qantas Airways",
    "Symbol": "QAN.AX",
    " marketcap ": " $6 790 864 995 ",
    "price (USD)": "4.16756",
    "country": "Australia"
  },
  {
    "Rank": "2201",
    "Name": "mBank",
    "Symbol": "MBK.WA",
    " marketcap ": " $6 786 883 498 ",
    "price (USD)": "159.822",
    "country": "Poland"
  },
  {
    "Rank": "2202",
    "Name": "LEG Immobilien",
    "Symbol": "LEG.DE",
    " marketcap ": " $6 785 640 135 ",
    "price (USD)": "91.5626",
    "country": "Germany"
  },
  {
    "Rank": "2203",
    "Name": "Insight Enterprises",
    "Symbol": "NSIT",
    " marketcap ": " $6 783 651 840 ",
    "price (USD)": "208.37",
    "country": "United States"
  },
  {
    "Rank": "2204",
    "Name": "Daito Trust Construction",
    "Symbol": "1878.T",
    " marketcap ": " $6 781 250 793 ",
    "price (USD)": "104.216",
    "country": "Japan"
  },
  {
    "Rank": "2205",
    "Name": "Cullen/Frost Bankers",
    "Symbol": "CFR",
    " marketcap ": " $6 778 828 800 ",
    "price (USD)": "105.5",
    "country": "United States"
  },
  {
    "Rank": "2206",
    "Name": "Bosideng",
    "Symbol": "3998.HK",
    " marketcap ": " $6 778 585 473 ",
    "price (USD)": "0.618919",
    "country": "Hong Kong"
  },
  {
    "Rank": "2207",
    "Name": "GameStop",
    "Symbol": "GME",
    " marketcap ": " $6 772 856 832 ",
    "price (USD)": "22.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "2208",
    "Name": "Chart Industries",
    "Symbol": "GTLS",
    " marketcap ": " $6 771 974 144 ",
    "price (USD)": "158.22",
    "country": "United States"
  },
  {
    "Rank": "2209",
    "Name": "West Fraser Timber",
    "Symbol": "WFG",
    " marketcap ": " $6 763 783 168 ",
    "price (USD)": "82.8",
    "country": "Canada"
  },
  {
    "Rank": "2210",
    "Name": "Viper Energy Partners",
    "Symbol": "VNOM",
    " marketcap ": " $6 762 935 808 ",
    "price (USD)": "38.24",
    "country": "United States"
  },
  {
    "Rank": "2211",
    "Name": "PI Industries",
    "Symbol": "PIIND.NS",
    " marketcap ": " $6 762 320 596 ",
    "price (USD)": "44.5793",
    "country": "India"
  },
  {
    "Rank": "2212",
    "Name": "Ono Pharmaceutical",
    "Symbol": "4528.T",
    " marketcap ": " $6 761 823 526 ",
    "price (USD)": "14.3977",
    "country": "Japan"
  },
  {
    "Rank": "2213",
    "Name": "Zalando",
    "Symbol": "ZAL.DE",
    " marketcap ": " $6 754 961 833 ",
    "price (USD)": "25.9312",
    "country": "Germany"
  },
  {
    "Rank": "2214",
    "Name": "China State Construction International",
    "Symbol": "3311.HK",
    " marketcap ": " $6 752 175 903 ",
    "price (USD)": "1.34035",
    "country": "Hong Kong"
  },
  {
    "Rank": "2215",
    "Name": "Alchip Technologies",
    "Symbol": "3661.TW",
    " marketcap ": " $6 750 679 078 ",
    "price (USD)": "85.2792",
    "country": "Taiwan"
  },
  {
    "Rank": "2216",
    "Name": "Jazz Pharmaceuticals",
    "Symbol": "JAZZ",
    " marketcap ": " $6 743 346 176 ",
    "price (USD)": "106.97",
    "country": "Ireland"
  },
  {
    "Rank": "2217",
    "Name": "Thermax",
    "Symbol": "THERMAX.NS",
    " marketcap ": " $6 741 062 952 ",
    "price (USD)": "59.8562",
    "country": "India"
  },
  {
    "Rank": "2218",
    "Name": "RLI Corp.",
    "Symbol": "RLI",
    " marketcap ": " $6 728 954 880 ",
    "price (USD)": "147.21",
    "country": "United States"
  },
  {
    "Rank": "2219",
    "Name": "AtkinsR\u0413\u00a9alis",
    "Symbol": "ATRL.TO",
    " marketcap ": " $6 728 025 725 ",
    "price (USD)": "38.3518",
    "country": "Canada"
  },
  {
    "Rank": "2220",
    "Name": "Medibank",
    "Symbol": "MPL.AX",
    " marketcap ": " $6 702 830 001 ",
    "price (USD)": "2.43385",
    "country": "Australia"
  },
  {
    "Rank": "2221",
    "Name": "Brixmor Property Group",
    "Symbol": "BRX",
    " marketcap ": " $6 700 890 112 ",
    "price (USD)": "22.24",
    "country": "United States"
  },
  {
    "Rank": "2222",
    "Name": "Abbott India",
    "Symbol": "ABBOTINDIA.NS",
    " marketcap ": " $6 695 084 518 ",
    "price (USD)": "314.889",
    "country": "India"
  },
  {
    "Rank": "2223",
    "Name": "Zeekr",
    "Symbol": "ZK",
    " marketcap ": " $6 694 698 496 ",
    "price (USD)": "27.\u0430\u043f\u0440",
    "country": "China"
  },
  {
    "Rank": "2224",
    "Name": "HashiCorp",
    "Symbol": "HCP",
    " marketcap ": " $6 692 867 072 ",
    "price (USD)": "33.3",
    "country": "United States"
  },
  {
    "Rank": "2225",
    "Name": "Mueller Industries",
    "Symbol": "MLI",
    " marketcap ": " $6 691 999 232 ",
    "price (USD)": "58.91",
    "country": "United States"
  },
  {
    "Rank": "2226",
    "Name": "STAG Industrial",
    "Symbol": "STAG",
    " marketcap ": " $6 687 696 896 ",
    "price (USD)": "35.96",
    "country": "United States"
  },
  {
    "Rank": "2227",
    "Name": "ADT",
    "Symbol": "ADT",
    " marketcap ": " $6 682 145 280 ",
    "price (USD)": "\u0438\u044e\u043b.34",
    "country": "United States"
  },
  {
    "Rank": "2228",
    "Name": "New Hope Liuhe",
    "Symbol": "000876.SZ",
    " marketcap ": " $6 681 185 197 ",
    "price (USD)": "1.46976",
    "country": "China"
  },
  {
    "Rank": "2229",
    "Name": "AltaGas",
    "Symbol": "ALA.TO",
    " marketcap ": " $6 679 787 851 ",
    "price (USD)": "22.5521",
    "country": "Canada"
  },
  {
    "Rank": "2230",
    "Name": "Banco de Cr\u0413\u00a9dito e Inversiones",
    "Symbol": "BCI.SN",
    " marketcap ": " $6 676 284 573 ",
    "price (USD)": "30.5405",
    "country": "Chile"
  },
  {
    "Rank": "2231",
    "Name": "SPX Corporation",
    "Symbol": "SPXC",
    " marketcap ": " $6 671 537 664 ",
    "price (USD)": "144.31",
    "country": "United States"
  },
  {
    "Rank": "2232",
    "Name": "Hamilton Lane",
    "Symbol": "HLNE",
    " marketcap ": " $6 670 677 504 ",
    "price (USD)": "119.39",
    "country": "United States"
  },
  {
    "Rank": "2233",
    "Name": "Olin",
    "Symbol": "OLN",
    " marketcap ": " $6 667 274 752 ",
    "price (USD)": "55.83",
    "country": "United States"
  },
  {
    "Rank": "2234",
    "Name": "iA Financial",
    "Symbol": "IAG.TO",
    " marketcap ": " $6 666 329 716 ",
    "price (USD)": "67.7811",
    "country": "Canada"
  },
  {
    "Rank": "2235",
    "Name": "Dixon Technologies",
    "Symbol": "DIXON.NS",
    " marketcap ": " $6 661 116 069 ",
    "price (USD)": "111.35",
    "country": "India"
  },
  {
    "Rank": "2236",
    "Name": "Groupe SEB",
    "Symbol": "SK.PA",
    " marketcap ": " $6 658 479 661 ",
    "price (USD)": "121.403",
    "country": "France"
  },
  {
    "Rank": "2237",
    "Name": "Hapvida",
    "Symbol": "HAPV3.SA",
    " marketcap ": " $6 656 680 868 ",
    "price (USD)": "0.874573",
    "country": "Brazil"
  },
  {
    "Rank": "2238",
    "Name": "SPIE",
    "Symbol": "SPIE.PA",
    " marketcap ": " $6 655 256 102 ",
    "price (USD)": "39.874",
    "country": "France"
  },
  {
    "Rank": "2239",
    "Name": "Warehouses De Pauw",
    "Symbol": "WDP.BR",
    " marketcap ": " $6 653 913 415 ",
    "price (USD)": "29.7318",
    "country": "Belgium"
  },
  {
    "Rank": "2240",
    "Name": "Convatec Group",
    "Symbol": "CTEC.L",
    " marketcap ": " $6 645 262 952 ",
    "price (USD)": "3.24192",
    "country": "United Kingdom"
  },
  {
    "Rank": "2241",
    "Name": "FirstService",
    "Symbol": "FSV",
    " marketcap ": " $6 642 840 576 ",
    "price (USD)": "147.54",
    "country": "Canada"
  },
  {
    "Rank": "2242",
    "Name": "KT Corporation",
    "Symbol": "KT",
    " marketcap ": " $6 637 315 584 ",
    "price (USD)": "13.\u043c\u0430\u0439",
    "country": "South Korea"
  },
  {
    "Rank": "2243",
    "Name": "Flowserve",
    "Symbol": "FLS",
    " marketcap ": " $6 636 678 144 ",
    "price (USD)": "50.41",
    "country": "United States"
  },
  {
    "Rank": "2244",
    "Name": "Pirelli",
    "Symbol": "PIRC.MI",
    " marketcap ": " $6 636 583 586 ",
    "price (USD)": "6.49582",
    "country": "Italy"
  },
  {
    "Rank": "2245",
    "Name": "Lawson",
    "Symbol": "2651.T",
    " marketcap ": " $6 629 823 262 ",
    "price (USD)": "66.2466",
    "country": "Japan"
  },
  {
    "Rank": "2246",
    "Name": "Tele2",
    "Symbol": "TEL2-A.ST",
    " marketcap ": " $6 624 241 618 ",
    "price (USD)": "9.64108",
    "country": "Sweden"
  },
  {
    "Rank": "2247",
    "Name": "Omron",
    "Symbol": "6645.T",
    " marketcap ": " $6 618 876 976 ",
    "price (USD)": "33.6127",
    "country": "Japan"
  },
  {
    "Rank": "2248",
    "Name": "Multiply Group",
    "Symbol": "MULTIPLY.AE",
    " marketcap ": " $6 617 474 882 ",
    "price (USD)": "0.59",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "2249",
    "Name": "Louisiana-Pacific",
    "Symbol": "LPX",
    " marketcap ": " $6 614 590 464 ",
    "price (USD)": "92.29",
    "country": "United States"
  },
  {
    "Rank": "2250",
    "Name": "Masimo",
    "Symbol": "MASI",
    " marketcap ": " $6 610 218 496 ",
    "price (USD)": "124.52",
    "country": "United States"
  },
  {
    "Rank": "2251",
    "Name": "Krung Thai Bank",
    "Symbol": "KTB.BK",
    " marketcap ": " $6 609 720 866 ",
    "price (USD)": "0.47293",
    "country": "Thailand"
  },
  {
    "Rank": "2252",
    "Name": "Frontier Communications",
    "Symbol": "FYBR",
    " marketcap ": " $6 608 997 888 ",
    "price (USD)": "26.59",
    "country": "United States"
  },
  {
    "Rank": "2253",
    "Name": "Banco Popular",
    "Symbol": "BPOP",
    " marketcap ": " $6 598 415 360 ",
    "price (USD)": "91.3",
    "country": "United States"
  },
  {
    "Rank": "2254",
    "Name": "Madras Rubber Factory",
    "Symbol": "MRF.NS",
    " marketcap ": " $6 585 978 850 ",
    "price (USD)": "1552.17",
    "country": "India"
  },
  {
    "Rank": "2255",
    "Name": "Starwood Property Trust",
    "Symbol": "STWD",
    " marketcap ": " $6 583 649 280 ",
    "price (USD)": "20.21",
    "country": "United States"
  },
  {
    "Rank": "2256",
    "Name": "Sime Darby Plantation",
    "Symbol": "5285.KL",
    " marketcap ": " $6 571 655 650 ",
    "price (USD)": "0.95025",
    "country": "Malaysia"
  },
  {
    "Rank": "2257",
    "Name": "Allison Transmission",
    "Symbol": "ALSN",
    " marketcap ": " $6 569 612 800 ",
    "price (USD)": "75.1",
    "country": "United States"
  },
  {
    "Rank": "2258",
    "Name": "Adecco Group",
    "Symbol": "ADEN.SW",
    " marketcap ": " $6 568 451 938 ",
    "price (USD)": "38.9988",
    "country": "Switzerland"
  },
  {
    "Rank": "2259",
    "Name": "Murphy Oil",
    "Symbol": "MUR",
    " marketcap ": " $6 562 293 248 ",
    "price (USD)": "43.01",
    "country": "United States"
  },
  {
    "Rank": "2260",
    "Name": "Fomento de Construcciones y Contratas",
    "Symbol": "FCC.MC",
    " marketcap ": " $6 554 154 866 ",
    "price (USD)": "15.0288",
    "country": "Spain"
  },
  {
    "Rank": "2261",
    "Name": "First Industrial Realty Trust",
    "Symbol": "FR",
    " marketcap ": " $6 552 828 416 ",
    "price (USD)": "48.19",
    "country": "United States"
  },
  {
    "Rank": "2262",
    "Name": "Lucid Motors",
    "Symbol": "LCID",
    " marketcap ": " $6 552 306 176 ",
    "price (USD)": "\u0444\u0435\u0432.84",
    "country": "United States"
  },
  {
    "Rank": "2263",
    "Name": "IDFC FIRST Bank",
    "Symbol": "IDFCFIRSTB.NS",
    " marketcap ": " $6 550 688 689 ",
    "price (USD)": "0.926382",
    "country": "India"
  },
  {
    "Rank": "2264",
    "Name": "Revolution Medicines",
    "Symbol": "RVMD",
    " marketcap ": " $6 543 344 640 ",
    "price (USD)": "39.66",
    "country": "United States"
  },
  {
    "Rank": "2265",
    "Name": "Savola Group",
    "Symbol": "2050.SR",
    " marketcap ": " $6 540 636 930 ",
    "price (USD)": "\u0434\u0435\u043a.88",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2266",
    "Name": "Taylor Wimpey",
    "Symbol": "TW.L",
    " marketcap ": " $6 523 902 086 ",
    "price (USD)": "1.84324",
    "country": "United Kingdom"
  },
  {
    "Rank": "2267",
    "Name": "Commercial Metals Company",
    "Symbol": "CMC",
    " marketcap ": " $6 523 617 280 ",
    "price (USD)": "56.38",
    "country": "United States"
  },
  {
    "Rank": "2268",
    "Name": "ChampionX",
    "Symbol": "CHX",
    " marketcap ": " $6 518 110 720 ",
    "price (USD)": "34.23",
    "country": "United States"
  },
  {
    "Rank": "2269",
    "Name": "ESAB",
    "Symbol": "ESAB",
    " marketcap ": " $6 517 376 000 ",
    "price (USD)": "107.86",
    "country": "United States"
  },
  {
    "Rank": "2270",
    "Name": "Addtech AB",
    "Symbol": "ADDT-B.ST",
    " marketcap ": " $6 504 927 783 ",
    "price (USD)": "24.1121",
    "country": "Sweden"
  },
  {
    "Rank": "2271",
    "Name": "Zions Bancorporation",
    "Symbol": "ZION",
    " marketcap ": " $6 502 726 656 ",
    "price (USD)": "44.04",
    "country": "United States"
  },
  {
    "Rank": "2272",
    "Name": "Mouwasat Medical Services Company",
    "Symbol": "4002.SR",
    " marketcap ": " $6 500 680 900 ",
    "price (USD)": "32.5034",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2273",
    "Name": "Alibaba Health Information Technology",
    "Symbol": "0241.HK",
    " marketcap ": " $6 495 298 659 ",
    "price (USD)": "0.403643",
    "country": "Hong Kong"
  },
  {
    "Rank": "2274",
    "Name": "Blueprint Medicines",
    "Symbol": "BPMC",
    " marketcap ": " $6 488 989 184 ",
    "price (USD)": "103.63",
    "country": "United States"
  },
  {
    "Rank": "2275",
    "Name": "Littelfuse",
    "Symbol": "LFUS",
    " marketcap ": " $6 486 573 056 ",
    "price (USD)": "261.72",
    "country": "United States"
  },
  {
    "Rank": "2276",
    "Name": "DT Midstream",
    "Symbol": "DTM",
    " marketcap ": " $6 482 032 640 ",
    "price (USD)": "66.75",
    "country": "United States"
  },
  {
    "Rank": "2277",
    "Name": "Grifols",
    "Symbol": "GRFS",
    " marketcap ": " $6 481 012 224 ",
    "price (USD)": "\u0438\u044e\u043b.67",
    "country": "Spain"
  },
  {
    "Rank": "2278",
    "Name": "Klaviyo",
    "Symbol": "KVYO",
    " marketcap ": " $6 479 074 304 ",
    "price (USD)": "24.49",
    "country": "United States"
  },
  {
    "Rank": "2279",
    "Name": "A2A",
    "Symbol": "A2A.MI",
    " marketcap ": " $6 475 660 245 ",
    "price (USD)": "2.06537",
    "country": "Italy"
  },
  {
    "Rank": "2280",
    "Name": "Meritage Homes",
    "Symbol": "MTH",
    " marketcap ": " $6 474 588 160 ",
    "price (USD)": "178.27",
    "country": "United States"
  },
  {
    "Rank": "2281",
    "Name": "Zain (Mobile Telecommunications Company)",
    "Symbol": "ZAIN.KW",
    " marketcap ": " $6 473 665 502 ",
    "price (USD)": "1496.09",
    "country": "Kuwait"
  },
  {
    "Rank": "2282",
    "Name": "Nestle Malaysia",
    "Symbol": "4707.KL",
    " marketcap ": " $6 470 171 544 ",
    "price (USD)": "27.5914",
    "country": "Malaysia"
  },
  {
    "Rank": "2283",
    "Name": "Komer\u0414\u040cn\u0413\u00ad banka",
    "Symbol": "KOMB.PR",
    " marketcap ": " $6 467 501 148 ",
    "price (USD)": "34.2457",
    "country": "Czech Republic"
  },
  {
    "Rank": "2284",
    "Name": "Timken Company",
    "Symbol": "TKR",
    " marketcap ": " $6 464 570 880 ",
    "price (USD)": "91.81",
    "country": "United States"
  },
  {
    "Rank": "2285",
    "Name": "Phillips-Van Heusen",
    "Symbol": "PVH",
    " marketcap ": " $6 461 047 296 ",
    "price (USD)": "114.13",
    "country": "United States"
  },
  {
    "Rank": "2286",
    "Name": "Lyft",
    "Symbol": "LYFT",
    " marketcap ": " $6 459 779 072 ",
    "price (USD)": "16.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "2287",
    "Name": "ALD Automotive",
    "Symbol": "ALD.PA",
    " marketcap ": " $6 459 443 484 ",
    "price (USD)": "7.91617",
    "country": "France"
  },
  {
    "Rank": "2288",
    "Name": "Investec",
    "Symbol": "INVR.L",
    " marketcap ": " $6 446 963 764 ",
    "price (USD)": "7.31022",
    "country": "United Kingdom"
  },
  {
    "Rank": "2289",
    "Name": "Liberty Global",
    "Symbol": "LBTYB",
    " marketcap ": " $6 443 109 376 ",
    "price (USD)": "17.8732",
    "country": "United Kingdom"
  },
  {
    "Rank": "2290",
    "Name": "Qatar Gas Transport Company",
    "Symbol": "QGTS.QA",
    " marketcap ": " $6 436 746 971 ",
    "price (USD)": "1.16181",
    "country": "Qatar"
  },
  {
    "Rank": "2291",
    "Name": "Frontline",
    "Symbol": "FRO",
    " marketcap ": " $6 436 030 976 ",
    "price (USD)": "28.91",
    "country": "Bermuda"
  },
  {
    "Rank": "2292",
    "Name": "Dutch Bros",
    "Symbol": "BROS",
    " marketcap ": " $6 429 826 560 ",
    "price (USD)": "36.29",
    "country": "United States"
  },
  {
    "Rank": "2293",
    "Name": "DS Smith",
    "Symbol": "SMDS.L",
    " marketcap ": " $6 425 660 211 ",
    "price (USD)": "\u0430\u043f\u0440.82",
    "country": "United Kingdom"
  },
  {
    "Rank": "2294",
    "Name": "Persistent Systems",
    "Symbol": "PERSISTENT.NS",
    " marketcap ": " $6 423 681 039 ",
    "price (USD)": "42.2627",
    "country": "India"
  },
  {
    "Rank": "2295",
    "Name": "Sensata Technologies",
    "Symbol": "ST",
    " marketcap ": " $6 415 452 160 ",
    "price (USD)": "42.56",
    "country": "United States"
  },
  {
    "Rank": "2296",
    "Name": "IGM Financial",
    "Symbol": "IGM.TO",
    " marketcap ": " $6 414 442 758 ",
    "price (USD)": "27.0245",
    "country": "Canada"
  },
  {
    "Rank": "2297",
    "Name": "Phoenix Group",
    "Symbol": "PHNX.L",
    " marketcap ": " $6 411 195 952 ",
    "price (USD)": "6.40121",
    "country": "United Kingdom"
  },
  {
    "Rank": "2298",
    "Name": "Pinnacle Financial Partners",
    "Symbol": "PNFP",
    " marketcap ": " $6 410 962 432 ",
    "price (USD)": "83.02",
    "country": "United States"
  },
  {
    "Rank": "2299",
    "Name": "Bilibili",
    "Symbol": "BILI",
    " marketcap ": " $6 409 680 896 ",
    "price (USD)": "15.53",
    "country": "China"
  },
  {
    "Rank": "2300",
    "Name": "BRF",
    "Symbol": "BRFS",
    " marketcap ": " $6 407 539 200 ",
    "price (USD)": "\u043c\u0430\u0440.84",
    "country": "Brazil"
  },
  {
    "Rank": "2301",
    "Name": "Kyndryl",
    "Symbol": "KD",
    " marketcap ": " $6 401 465 856 ",
    "price (USD)": "27.82",
    "country": "United States"
  },
  {
    "Rank": "2302",
    "Name": "Landstar System",
    "Symbol": "LSTR",
    " marketcap ": " $6 399 252 480 ",
    "price (USD)": "178.94",
    "country": "United States"
  },
  {
    "Rank": "2303",
    "Name": "Post Holdings",
    "Symbol": "POST",
    " marketcap ": " $6 398 476 800 ",
    "price (USD)": "105.61",
    "country": "United States"
  },
  {
    "Rank": "2304",
    "Name": "Hudco",
    "Symbol": "HUDCO.NS",
    " marketcap ": " $6 381 391 352 ",
    "price (USD)": "3.18767",
    "country": "India"
  },
  {
    "Rank": "2305",
    "Name": "Zurich Airport",
    "Symbol": "FHZN.SW",
    " marketcap ": " $6 376 367 805 ",
    "price (USD)": "207.723",
    "country": "Switzerland"
  },
  {
    "Rank": "2306",
    "Name": "OTE Group",
    "Symbol": "OTE.F",
    " marketcap ": " $6 368 168 044 ",
    "price (USD)": "15.2025",
    "country": "Greece"
  },
  {
    "Rank": "2307",
    "Name": "Leonardo DRS",
    "Symbol": "DRS",
    " marketcap ": " $6 365 405 184 ",
    "price (USD)": "24.19",
    "country": "United States"
  },
  {
    "Rank": "2308",
    "Name": "SG Holdings",
    "Symbol": "9143.T",
    " marketcap ": " $6 362 319 738 ",
    "price (USD)": "10.1721",
    "country": "Japan"
  },
  {
    "Rank": "2309",
    "Name": "Mazda",
    "Symbol": "7261.T",
    " marketcap ": " $6 360 821 269 ",
    "price (USD)": "10.0953",
    "country": "Japan"
  },
  {
    "Rank": "2310",
    "Name": "Procter &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2311",
    "Name": "GXO Logistics",
    "Symbol": "GXO",
    " marketcap ": " $6 346 616 320 ",
    "price (USD)": "53.14",
    "country": "United States"
  },
  {
    "Rank": "2312",
    "Name": "KION Group",
    "Symbol": "KGX.DE",
    " marketcap ": " $6 344 804 187 ",
    "price (USD)": "48.3874",
    "country": "Germany"
  },
  {
    "Rank": "2313",
    "Name": "Bright Horizons",
    "Symbol": "BFAM",
    " marketcap ": " $6 344 499 200 ",
    "price (USD)": "109.38",
    "country": "United States"
  },
  {
    "Rank": "2314",
    "Name": "Nippon Building Fund",
    "Symbol": "8951.T",
    " marketcap ": " $6 344 297 862 ",
    "price (USD)": "3729.77",
    "country": "Japan"
  },
  {
    "Rank": "2315",
    "Name": "Harmony Gold",
    "Symbol": "HMY",
    " marketcap ": " $6 341 934 592 ",
    "price (USD)": "\u043e\u043a\u0442.23",
    "country": "South Africa"
  },
  {
    "Rank": "2316",
    "Name": "Maxis Berhad",
    "Symbol": "6012.KL",
    " marketcap ": " $6 341 089 292 ",
    "price (USD)": "0.80963",
    "country": "Malaysia"
  },
  {
    "Rank": "2317",
    "Name": "Howden Joinery",
    "Symbol": "HWDN.L",
    " marketcap ": " $6 339 947 387 ",
    "price (USD)": "\u043d\u043e\u044f.74",
    "country": "United Kingdom"
  },
  {
    "Rank": "2318",
    "Name": "Rambus",
    "Symbol": "RMBS",
    " marketcap ": " $6 339 678 208 ",
    "price (USD)": "58.82",
    "country": "United States"
  },
  {
    "Rank": "2319",
    "Name": "Masraf Al Rayan",
    "Symbol": "MARK.QA",
    " marketcap ": " $6 328 598 505 ",
    "price (USD)": "0.680495",
    "country": "Qatar"
  },
  {
    "Rank": "2320",
    "Name": "ESR",
    "Symbol": "1821.HK",
    " marketcap ": " $6 326 363 912 ",
    "price (USD)": "1.50181",
    "country": "Hong Kong"
  },
  {
    "Rank": "2321",
    "Name": "CAE",
    "Symbol": "CAE",
    " marketcap ": " $6 321 803 776 ",
    "price (USD)": "19.83",
    "country": "Canada"
  },
  {
    "Rank": "2322",
    "Name": "Bechtle",
    "Symbol": "BC8.F",
    " marketcap ": " $6 318 470 852 ",
    "price (USD)": "50.1466",
    "country": "Germany"
  },
  {
    "Rank": "2323",
    "Name": "Hankyu Hanshin Holdings",
    "Symbol": "9042.T",
    " marketcap ": " $6 316 591 701 ",
    "price (USD)": "26.0956",
    "country": "Japan"
  },
  {
    "Rank": "2324",
    "Name": "Aaon",
    "Symbol": "AAON",
    " marketcap ": " $6 312 851 968 ",
    "price (USD)": "76.79",
    "country": "United States"
  },
  {
    "Rank": "2325",
    "Name": "Cytokinetics",
    "Symbol": "CYTK",
    " marketcap ": " $6 305 919 488 ",
    "price (USD)": "60.14",
    "country": "United States"
  },
  {
    "Rank": "2326",
    "Name": "GMR Group",
    "Symbol": "GMRINFRA.NS",
    " marketcap ": " $6 295 078 436 ",
    "price (USD)": "1.04293",
    "country": "India"
  },
  {
    "Rank": "2327",
    "Name": "Celestica",
    "Symbol": "CLS",
    " marketcap ": " $6 289 006 080 ",
    "price (USD)": "52.64",
    "country": "Canada"
  },
  {
    "Rank": "2328",
    "Name": "Mattel",
    "Symbol": "MAT",
    " marketcap ": " $6 285 958 144 ",
    "price (USD)": "18.27",
    "country": "United States"
  },
  {
    "Rank": "2329",
    "Name": "Raiffeisen Bank International",
    "Symbol": "RAW.F",
    " marketcap ": " $6 270 342 630 ",
    "price (USD)": "18.8294",
    "country": "Austria"
  },
  {
    "Rank": "2330",
    "Name": "BlueScope Steel",
    "Symbol": "BSL.AX",
    " marketcap ": " $6 265 083 111 ",
    "price (USD)": "14.163",
    "country": "Australia"
  },
  {
    "Rank": "2331",
    "Name": "Sunny Optical",
    "Symbol": "2382.HK",
    " marketcap ": " $6 263 872 583 ",
    "price (USD)": "5.72148",
    "country": "China"
  },
  {
    "Rank": "2332",
    "Name": "IMI plc",
    "Symbol": "IMI.L",
    " marketcap ": " $6 261 040 009 ",
    "price (USD)": "24.1047",
    "country": "United Kingdom"
  },
  {
    "Rank": "2333",
    "Name": "Mesaieed Petrochemical Holding Company",
    "Symbol": "MPHC.QA",
    " marketcap ": " $6 260 891 288 ",
    "price (USD)": "0.498352",
    "country": "Qatar"
  },
  {
    "Rank": "2334",
    "Name": "Treasury Wine Estates",
    "Symbol": "TWE.AX",
    " marketcap ": " $6 260 134 087 ",
    "price (USD)": "7.71498",
    "country": "Australia"
  },
  {
    "Rank": "2335",
    "Name": "Israel Discount Bank",
    "Symbol": "ISDAY",
    " marketcap ": " $6 258 335 744 ",
    "price (USD)": "48",
    "country": "Israel"
  },
  {
    "Rank": "2336",
    "Name": "Ryman Hospitality Properties",
    "Symbol": "RHP",
    " marketcap ": " $6 256 151 040 ",
    "price (USD)": "104.46",
    "country": "United States"
  },
  {
    "Rank": "2337",
    "Name": "Vontier",
    "Symbol": "VNT",
    " marketcap ": " $6 254 743 552 ",
    "price (USD)": "40.51",
    "country": "United States"
  },
  {
    "Rank": "2338",
    "Name": "Saudi International Petrochemical Company (Sipchem)",
    "Symbol": "2310.SR",
    " marketcap ": " $6 252 499 239 ",
    "price (USD)": "8.52614",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2339",
    "Name": "Meiji Holdings",
    "Symbol": "2269.T",
    " marketcap ": " $6 251 359 670 ",
    "price (USD)": "22.3978",
    "country": "Japan"
  },
  {
    "Rank": "2340",
    "Name": "Land Securities Group",
    "Symbol": "LAND.L",
    " marketcap ": " $6 250 243 727 ",
    "price (USD)": "8.39086",
    "country": "United Kingdom"
  },
  {
    "Rank": "2341",
    "Name": "Barratt Developments",
    "Symbol": "BDEV.L",
    " marketcap ": " $6 249 719 730 ",
    "price (USD)": "6.41265",
    "country": "United Kingdom"
  },
  {
    "Rank": "2342",
    "Name": "Trend Micro",
    "Symbol": "4704.T",
    " marketcap ": " $6 246 759 865 ",
    "price (USD)": "46.8364",
    "country": "Japan"
  },
  {
    "Rank": "2343",
    "Name": "Chang Hwa Commercial Bank",
    "Symbol": "2801.TW",
    " marketcap ": " $6 246 207 686 ",
    "price (USD)": "0.575247",
    "country": "Taiwan"
  },
  {
    "Rank": "2344",
    "Name": "Taylor Morrison",
    "Symbol": "TMHC",
    " marketcap ": " $6 243 248 640 ",
    "price (USD)": "59.03",
    "country": "United States"
  },
  {
    "Rank": "2345",
    "Name": "Tata Communications",
    "Symbol": "TATACOMM.NS",
    " marketcap ": " $6 234 407 218 ",
    "price (USD)": "21.8751",
    "country": "India"
  },
  {
    "Rank": "2346",
    "Name": "Lotus Technology",
    "Symbol": "LOT",
    " marketcap ": " $6 225 971 200 ",
    "price (USD)": "09.\u0444\u0435\u0432",
    "country": "China"
  },
  {
    "Rank": "2347",
    "Name": "Rubrik",
    "Symbol": "RBRK",
    " marketcap ": " $6 224 474 112 ",
    "price (USD)": "35.38",
    "country": "United States"
  },
  {
    "Rank": "2348",
    "Name": "A1 Telekom Austria",
    "Symbol": "TA1.F",
    " marketcap ": " $6 223 211 832 ",
    "price (USD)": "9.30611",
    "country": "Austria"
  },
  {
    "Rank": "2349",
    "Name": "Beacon Roofing Supply",
    "Symbol": "BECN",
    " marketcap ": " $6 210 463 232 ",
    "price (USD)": "97.04",
    "country": "United States"
  },
  {
    "Rank": "2350",
    "Name": "Nedbank",
    "Symbol": "NED.JO",
    " marketcap ": " $6 209 521 700 ",
    "price (USD)": "13.3663",
    "country": "South Africa"
  },
  {
    "Rank": "2351",
    "Name": "China Merchants Port",
    "Symbol": "0144.HK",
    " marketcap ": " $6 207 774 095 ",
    "price (USD)": "1.47874",
    "country": "Hong Kong"
  },
  {
    "Rank": "2352",
    "Name": "Nanya Technology",
    "Symbol": "2408.TW",
    " marketcap ": " $6 206 423 128 ",
    "price (USD)": "2.00329",
    "country": "Taiwan"
  },
  {
    "Rank": "2353",
    "Name": "Wan Hai Lines",
    "Symbol": "2615.TW",
    " marketcap ": " $6 195 858 657 ",
    "price (USD)": "2.20796",
    "country": "Taiwan"
  },
  {
    "Rank": "2354",
    "Name": "Kingfisher",
    "Symbol": "KGF.L",
    " marketcap ": " $6 189 328 634 ",
    "price (USD)": "3.33473",
    "country": "United Kingdom"
  },
  {
    "Rank": "2355",
    "Name": "Wintrust Financial",
    "Symbol": "WTFC",
    " marketcap ": " $6 184 005 632 ",
    "price (USD)": "100.14",
    "country": "United States"
  },
  {
    "Rank": "2356",
    "Name": "Castellum",
    "Symbol": "CAST.ST",
    " marketcap ": " $6 178 578 169 ",
    "price (USD)": "\u0434\u0435\u043a.28",
    "country": "Sweden"
  },
  {
    "Rank": "2357",
    "Name": "Luberef (Saudi Aramco Base Oil Company)",
    "Symbol": "2223.SR",
    " marketcap ": " $6 178 285 814 ",
    "price (USD)": "36.7198",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2358",
    "Name": "Keyera",
    "Symbol": "KEY.TO",
    " marketcap ": " $6 170 892 998 ",
    "price (USD)": "26.9291",
    "country": "Canada"
  },
  {
    "Rank": "2359",
    "Name": "Prosperity Bancshares",
    "Symbol": "PB",
    " marketcap ": " $6 170 725 888 ",
    "price (USD)": "64.32",
    "country": "United States"
  },
  {
    "Rank": "2360",
    "Name": "M&G plc",
    "Symbol": "MNG.L",
    " marketcap ": " $6 170 063 786 ",
    "price (USD)": "2.59227",
    "country": "United Kingdom"
  },
  {
    "Rank": "2361",
    "Name": "Georg Fischer",
    "Symbol": "GF.SW",
    " marketcap ": " $6 169 972 773 ",
    "price (USD)": "75.3311",
    "country": "Switzerland"
  },
  {
    "Rank": "2362",
    "Name": "MatsukiyoCocokara",
    "Symbol": "3088.T",
    " marketcap ": " $6 163 163 416 ",
    "price (USD)": "14.7751",
    "country": "Japan"
  },
  {
    "Rank": "2363",
    "Name": "Kunlun Tech",
    "Symbol": "300418.SZ",
    " marketcap ": " $6 157 876 825 ",
    "price (USD)": "5.06817",
    "country": "China"
  },
  {
    "Rank": "2364",
    "Name": "Patanjali Foods",
    "Symbol": "PATANJALI.NS",
    " marketcap ": " $6 140 246 707 ",
    "price (USD)": "16.9092",
    "country": "India"
  },
  {
    "Rank": "2365",
    "Name": "Reynolds Consumer",
    "Symbol": "REYN",
    " marketcap ": " $6 140 232 192 ",
    "price (USD)": "29.22",
    "country": "United States"
  },
  {
    "Rank": "2366",
    "Name": "Turkcell",
    "Symbol": "TKC",
    " marketcap ": " $6 135 506 944 ",
    "price (USD)": "7",
    "country": "Turkey"
  },
  {
    "Rank": "2367",
    "Name": "Freshpet",
    "Symbol": "FRPT",
    " marketcap ": " $6 134 754 816 ",
    "price (USD)": "126.67",
    "country": "United States"
  },
  {
    "Rank": "2368",
    "Name": "Agree Realty",
    "Symbol": "ADC",
    " marketcap ": " $6 134 170 624 ",
    "price (USD)": "60.75",
    "country": "United States"
  },
  {
    "Rank": "2369",
    "Name": "Cirrus Logic",
    "Symbol": "CRUS",
    " marketcap ": " $6 133 488 128 ",
    "price (USD)": "113.72",
    "country": "United States"
  },
  {
    "Rank": "2370",
    "Name": "Nykaa",
    "Symbol": "NYKAA.NS",
    " marketcap ": " $6 127 856 389 ",
    "price (USD)": "2.14534",
    "country": "India"
  },
  {
    "Rank": "2371",
    "Name": "Healthcare Realty",
    "Symbol": "HR",
    " marketcap ": " $6 124 873 728 ",
    "price (USD)": "15.99",
    "country": "United States"
  },
  {
    "Rank": "2372",
    "Name": "Exelixis",
    "Symbol": "EXEL",
    " marketcap ": " $6 122 978 816 ",
    "price (USD)": "21.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "2373",
    "Name": "Genpact",
    "Symbol": "G",
    " marketcap ": " $6 121 085 952 ",
    "price (USD)": "34.01",
    "country": "Bermuda"
  },
  {
    "Rank": "2374",
    "Name": "BOK Financial",
    "Symbol": "BOKF",
    " marketcap ": " $6 092 151 296 ",
    "price (USD)": "94.43",
    "country": "United States"
  },
  {
    "Rank": "2375",
    "Name": "Orica",
    "Symbol": "ORI.AX",
    " marketcap ": " $6 090 587 005 ",
    "price (USD)": "\u0434\u0435\u043a.93",
    "country": "Australia"
  },
  {
    "Rank": "2376",
    "Name": "AXIS Capital",
    "Symbol": "AXS",
    " marketcap ": " $6 090 440 704 ",
    "price (USD)": "71.94",
    "country": "Bermuda"
  },
  {
    "Rank": "2377",
    "Name": "Canadian Tire",
    "Symbol": "CTC.TO",
    " marketcap ": " $6 089 766 552 ",
    "price (USD)": "179.625",
    "country": "Canada"
  },
  {
    "Rank": "2378",
    "Name": "Colruyt",
    "Symbol": "COLR.BR",
    " marketcap ": " $6 089 392 412 ",
    "price (USD)": "48.4743",
    "country": "Belgium"
  },
  {
    "Rank": "2379",
    "Name": "Coca-Cola \u0414\u00b0\u0413\u00a7ecek",
    "Symbol": "CCOLA.IS",
    " marketcap ": " $6 088 039 447 ",
    "price (USD)": "23.9337",
    "country": "Turkey"
  },
  {
    "Rank": "2380",
    "Name": "Capstone Copper",
    "Symbol": "CS.TO",
    " marketcap ": " $6 087 117 117 ",
    "price (USD)": "8.07948",
    "country": "Canada"
  },
  {
    "Rank": "2381",
    "Name": "Eurazeo",
    "Symbol": "RF.PA",
    " marketcap ": " $6 075 767 619 ",
    "price (USD)": "83.6139",
    "country": "France"
  },
  {
    "Rank": "2382",
    "Name": "Israel Chemicals",
    "Symbol": "ICL",
    " marketcap ": " $6 074 816 512 ",
    "price (USD)": "\u0430\u043f\u0440.71",
    "country": "Israel"
  },
  {
    "Rank": "2383",
    "Name": "Gildan",
    "Symbol": "GIL",
    " marketcap ": " $6 074 326 016 ",
    "price (USD)": "35.97",
    "country": "Canada"
  },
  {
    "Rank": "2384",
    "Name": "SK Group",
    "Symbol": "034730.KS",
    " marketcap ": " $6 065 996 915 ",
    "price (USD)": "111.261",
    "country": "South Korea"
  },
  {
    "Rank": "2385",
    "Name": "Acadia Healthcare",
    "Symbol": "ACHC",
    " marketcap ": " $6 063 748 096 ",
    "price (USD)": "65.36",
    "country": "United States"
  },
  {
    "Rank": "2386",
    "Name": "OPAP (Organization of Football Prognostics)",
    "Symbol": "OPAP.AT",
    " marketcap ": " $6 061 909 315 ",
    "price (USD)": "16.4622",
    "country": "Greece"
  },
  {
    "Rank": "2387",
    "Name": "Intouch Holdings",
    "Symbol": "INTUCH.BK",
    " marketcap ": " $6 061 754 460 ",
    "price (USD)": "1.89035",
    "country": "Thailand"
  },
  {
    "Rank": "2388",
    "Name": "South State Corp",
    "Symbol": "SSB",
    " marketcap ": " $6 057 874 944 ",
    "price (USD)": "79.51",
    "country": "United States"
  },
  {
    "Rank": "2389",
    "Name": "EnLink Midstream",
    "Symbol": "ENLC",
    " marketcap ": " $6 056 499 712 ",
    "price (USD)": "13.42",
    "country": "United States"
  },
  {
    "Rank": "2390",
    "Name": "Equitrans Midstream",
    "Symbol": "ETRN",
    " marketcap ": " $6 049 570 816 ",
    "price (USD)": "13.95",
    "country": "United States"
  },
  {
    "Rank": "2391",
    "Name": "Sekisui Chemical",
    "Symbol": "4204.T",
    " marketcap ": " $6 045 410 345 ",
    "price (USD)": "14.3465",
    "country": "Japan"
  },
  {
    "Rank": "2392",
    "Name": "Squarespace",
    "Symbol": "SQSP",
    " marketcap ": " $6 041 752 576 ",
    "price (USD)": "43.98",
    "country": "United States"
  },
  {
    "Rank": "2393",
    "Name": "Sonoco",
    "Symbol": "SON",
    " marketcap ": " $6 037 818 880 ",
    "price (USD)": "61.45",
    "country": "United States"
  },
  {
    "Rank": "2394",
    "Name": "Australian Foundation Investment Company",
    "Symbol": "AFI.AX",
    " marketcap ": " $6 017 163 512 ",
    "price (USD)": "4.80769",
    "country": "Australia"
  },
  {
    "Rank": "2395",
    "Name": "Bill.com",
    "Symbol": "BILL",
    " marketcap ": " $6 007 353 856 ",
    "price (USD)": "56.6",
    "country": "United States"
  },
  {
    "Rank": "2396",
    "Name": "MEG Energy",
    "Symbol": "MEG.TO",
    " marketcap ": " $6 005 902 081 ",
    "price (USD)": "22.0316",
    "country": "Canada"
  },
  {
    "Rank": "2397",
    "Name": "Essent Group",
    "Symbol": "ESNT",
    " marketcap ": " $6 005 689 856 ",
    "price (USD)": "56.3",
    "country": "Bermuda"
  },
  {
    "Rank": "2398",
    "Name": "Global Unichip Corp.",
    "Symbol": "3443.TW",
    " marketcap ": " $6 005 081 883 ",
    "price (USD)": "44.8104",
    "country": "Taiwan"
  },
  {
    "Rank": "2399",
    "Name": "Installed Building Products",
    "Symbol": "IBP",
    " marketcap ": " $6 004 013 056 ",
    "price (USD)": "211.07",
    "country": "United States"
  },
  {
    "Rank": "2400",
    "Name": "First American",
    "Symbol": "FAF",
    " marketcap ": " $5 987 986 432 ",
    "price (USD)": "57.73",
    "country": "United States"
  },
  {
    "Rank": "2401",
    "Name": "Fresnillo",
    "Symbol": "FNLPF",
    " marketcap ": " $5 987 163 648 ",
    "price (USD)": "08.\u043c\u0430\u0439",
    "country": "Mexico"
  },
  {
    "Rank": "2402",
    "Name": "OCI",
    "Symbol": "OCI.AS",
    " marketcap ": " $5 986 838 406 ",
    "price (USD)": "28.3636",
    "country": "Netherlands"
  },
  {
    "Rank": "2403",
    "Name": "Ackermans &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2404",
    "Name": "Credit Acceptance",
    "Symbol": "CACC",
    " marketcap ": " $5 976 536 576 ",
    "price (USD)": "493.48",
    "country": "United States"
  },
  {
    "Rank": "2405",
    "Name": "Empire Company",
    "Symbol": "EMP-A.TO",
    " marketcap ": " $5 967 863 667 ",
    "price (USD)": "24.451",
    "country": "Canada"
  },
  {
    "Rank": "2406",
    "Name": "Entain",
    "Symbol": "ENT.L",
    " marketcap ": " $5 966 098 926 ",
    "price (USD)": "9.33723",
    "country": "Isle of Man"
  },
  {
    "Rank": "2407",
    "Name": "L'Occitane International",
    "Symbol": "COC.F",
    " marketcap ": " $5 959 413 687 ",
    "price (USD)": "\u043c\u0430\u0440.74",
    "country": "Luxembourg"
  },
  {
    "Rank": "2408",
    "Name": "Hitachi Construction Machinery",
    "Symbol": "6305.T",
    " marketcap ": " $5 958 000 221 ",
    "price (USD)": "28.0148",
    "country": "Japan"
  },
  {
    "Rank": "2409",
    "Name": "Novanta",
    "Symbol": "NOVT",
    " marketcap ": " $5 951 567 360 ",
    "price (USD)": "165.81",
    "country": "United States"
  },
  {
    "Rank": "2410",
    "Name": "Jackson Financial",
    "Symbol": "JXN",
    " marketcap ": " $5 950 910 976 ",
    "price (USD)": "78.03",
    "country": "United States"
  },
  {
    "Rank": "2411",
    "Name": "Endeavour Group",
    "Symbol": "EDV.AX",
    " marketcap ": " $5 947 322 053 ",
    "price (USD)": "3.32071",
    "country": "Australia"
  },
  {
    "Rank": "2412",
    "Name": "PTT Oil and Retail Business",
    "Symbol": "OR.BK",
    " marketcap ": " $5 939 124 255 ",
    "price (USD)": "0.494927",
    "country": "Thailand"
  },
  {
    "Rank": "2413",
    "Name": "Shift4 Payments",
    "Symbol": "FOUR",
    " marketcap ": " $5 939 065 856 ",
    "price (USD)": "67.84",
    "country": "United States"
  },
  {
    "Rank": "2414",
    "Name": "Vicinity Centres",
    "Symbol": "VCX.AX",
    " marketcap ": " $5 934 404 609 ",
    "price (USD)": "1.30361",
    "country": "Australia"
  },
  {
    "Rank": "2415",
    "Name": "PBF Energy",
    "Symbol": "PBF",
    " marketcap ": " $5 928 200 192 ",
    "price (USD)": "50",
    "country": "United States"
  },
  {
    "Rank": "2416",
    "Name": "Nova Measuring Instruments",
    "Symbol": "NVMI",
    " marketcap ": " $5 928 059 392 ",
    "price (USD)": "204.09",
    "country": "Israel"
  },
  {
    "Rank": "2417",
    "Name": "Ezdan Holding Group",
    "Symbol": "ERES.QA",
    " marketcap ": " $5 917 115 358 ",
    "price (USD)": "0.223077",
    "country": "Qatar"
  },
  {
    "Rank": "2418",
    "Name": "BELIMO Holding",
    "Symbol": "BEAN.SW",
    " marketcap ": " $5 908 481 461 ",
    "price (USD)": "480.407",
    "country": "Switzerland"
  },
  {
    "Rank": "2419",
    "Name": "EVA Air",
    "Symbol": "2618.TW",
    " marketcap ": " $5 903 354 966 ",
    "price (USD)": "1.09312",
    "country": "Taiwan"
  },
  {
    "Rank": "2420",
    "Name": "National Marine Dredging",
    "Symbol": "NMDC.AE",
    " marketcap ": " $5 903 286 411 ",
    "price (USD)": "\u0438\u044e\u043b.16",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "2421",
    "Name": "Colliers International",
    "Symbol": "CIGI",
    " marketcap ": " $5 902 799 360 ",
    "price (USD)": "114.01",
    "country": "Canada"
  },
  {
    "Rank": "2422",
    "Name": "CSN Minera\u0413\u00a7\u0413\u0408o",
    "Symbol": "CMIN3.SA",
    " marketcap ": " $5 900 288 200 ",
    "price (USD)": "1.07565",
    "country": "Brazil"
  },
  {
    "Rank": "2423",
    "Name": "Andritz",
    "Symbol": "AZ2.F",
    " marketcap ": " $5 898 184 402 ",
    "price (USD)": "59.1269",
    "country": "Austria"
  },
  {
    "Rank": "2424",
    "Name": "Securitas AB",
    "Symbol": "SECU-B.ST",
    " marketcap ": " $5 896 254 005 ",
    "price (USD)": "\u043e\u043a\u0442.16",
    "country": "Sweden"
  },
  {
    "Rank": "2425",
    "Name": "Telecom Italia",
    "Symbol": "TIT.MI",
    " marketcap ": " $5 886 984 784 ",
    "price (USD)": "0.268324",
    "country": "Italy"
  },
  {
    "Rank": "2426",
    "Name": "Bharat Dynamics",
    "Symbol": "BDL.NS",
    " marketcap ": " $5 886 542 445 ",
    "price (USD)": "32.1176",
    "country": "India"
  },
  {
    "Rank": "2427",
    "Name": "Selective Insurance",
    "Symbol": "SIGI",
    " marketcap ": " $5 882 841 600 ",
    "price (USD)": "96.77",
    "country": "United States"
  },
  {
    "Rank": "2428",
    "Name": "SSAB",
    "Symbol": "SSAB-B.ST",
    " marketcap ": " $5 882 303 731 ",
    "price (USD)": "5.88948",
    "country": "Sweden"
  },
  {
    "Rank": "2429",
    "Name": "United Breweries",
    "Symbol": "UBL.NS",
    " marketcap ": " $5 873 954 481 ",
    "price (USD)": "22.2157",
    "country": "India"
  },
  {
    "Rank": "2430",
    "Name": "SAL Saudi Logistics Services",
    "Symbol": "4263.SR",
    " marketcap ": " $5 866 623 969 ",
    "price (USD)": "73.3328",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2431",
    "Name": "Qui\u0413\u00b1enco",
    "Symbol": "QUINENCO.SN",
    " marketcap ": " $5 861 415 853 ",
    "price (USD)": "3.52511",
    "country": "Chile"
  },
  {
    "Rank": "2432",
    "Name": "Elis",
    "Symbol": "ELIS.PA",
    " marketcap ": " $5 861 089 004 ",
    "price (USD)": "24.8887",
    "country": "France"
  },
  {
    "Rank": "2433",
    "Name": "L&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2434",
    "Name": "Dentsply Sirona",
    "Symbol": "XRAY",
    " marketcap ": " $5 855 194 624 ",
    "price (USD)": "28.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "2435",
    "Name": "Banco Comercial Portugu\u0413\u0404s (Millennium bcp)",
    "Symbol": "BCP.LS",
    " marketcap ": " $5 854 226 570 ",
    "price (USD)": "0.386578",
    "country": "Portugal"
  },
  {
    "Rank": "2436",
    "Name": "Fertiglobe",
    "Symbol": "FERTIGLB.AE",
    " marketcap ": " $5 854 117 139 ",
    "price (USD)": "0.71",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "2437",
    "Name": "OneMain Financial",
    "Symbol": "OMF",
    " marketcap ": " $5 852 669 440 ",
    "price (USD)": "48.85",
    "country": "United States"
  },
  {
    "Rank": "2438",
    "Name": "Arcadis",
    "Symbol": "ARCAD.AS",
    " marketcap ": " $5 852 332 353 ",
    "price (USD)": "65.0451",
    "country": "Netherlands"
  },
  {
    "Rank": "2439",
    "Name": "Hexcel",
    "Symbol": "HXL",
    " marketcap ": " $5 852 085 248 ",
    "price (USD)": "70.41",
    "country": "United States"
  },
  {
    "Rank": "2440",
    "Name": "Synovus",
    "Symbol": "SNV",
    " marketcap ": " $5 842 956 288 ",
    "price (USD)": "39.9",
    "country": "United States"
  },
  {
    "Rank": "2441",
    "Name": "Aspen Pharmacare",
    "Symbol": "APN.JO",
    " marketcap ": " $5 839 953 800 ",
    "price (USD)": "\u0434\u0435\u043a.22",
    "country": "South Africa"
  },
  {
    "Rank": "2442",
    "Name": "Element Solutions",
    "Symbol": "ESI",
    " marketcap ": " $5 838 583 808 ",
    "price (USD)": "24.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "2443",
    "Name": "Korean Air Lines",
    "Symbol": "003495.KS",
    " marketcap ": " $5 830 954 829 ",
    "price (USD)": "17.1115",
    "country": "South Korea"
  },
  {
    "Rank": "2444",
    "Name": "Chiba Bank",
    "Symbol": "CHBAY",
    " marketcap ": " $5 829 984 768 ",
    "price (USD)": "37.04",
    "country": "Japan"
  },
  {
    "Rank": "2445",
    "Name": "Badger Meter",
    "Symbol": "BMI",
    " marketcap ": " $5 828 770 816 ",
    "price (USD)": "198.3",
    "country": "United States"
  },
  {
    "Rank": "2446",
    "Name": "Marathon Digital Holdings",
    "Symbol": "MARA",
    " marketcap ": " $5 827 610 624 ",
    "price (USD)": "21.35",
    "country": "United States"
  },
  {
    "Rank": "2447",
    "Name": "Sojitz Corporation",
    "Symbol": "2768.T",
    " marketcap ": " $5 827 145 820 ",
    "price (USD)": "26.8249",
    "country": "Japan"
  },
  {
    "Rank": "2448",
    "Name": "Cencosud",
    "Symbol": "CENCOSUD.SN",
    " marketcap ": " $5 825 729 435 ",
    "price (USD)": "2.07759",
    "country": "Chile"
  },
  {
    "Rank": "2449",
    "Name": "S-OIL",
    "Symbol": "010950.KS",
    " marketcap ": " $5 813 561 987 ",
    "price (USD)": "50.4531",
    "country": "South Korea"
  },
  {
    "Rank": "2450",
    "Name": "Persimmon",
    "Symbol": "PSN.L",
    " marketcap ": " $5 806 876 214 ",
    "price (USD)": "18.1611",
    "country": "United Kingdom"
  },
  {
    "Rank": "2451",
    "Name": "Halozyme Therapeutics",
    "Symbol": "HALO",
    " marketcap ": " $5 796 058 112 ",
    "price (USD)": "45.54",
    "country": "United States"
  },
  {
    "Rank": "2452",
    "Name": "SCSK Corporation",
    "Symbol": "9719.T",
    " marketcap ": " $5 790 367 508 ",
    "price (USD)": "18.5337",
    "country": "Japan"
  },
  {
    "Rank": "2453",
    "Name": "Fuchs Petrolub",
    "Symbol": "FPE.F",
    " marketcap ": " $5 774 564 396 ",
    "price (USD)": "37.8434",
    "country": "Germany"
  },
  {
    "Rank": "2454",
    "Name": "China Gas",
    "Symbol": "0384.HK",
    " marketcap ": " $5 774 126 413 ",
    "price (USD)": "1.06229",
    "country": "China"
  },
  {
    "Rank": "2455",
    "Name": "The Company for Cooperative Insurance",
    "Symbol": "8010.SR",
    " marketcap ": " $5 772 155 713 ",
    "price (USD)": "38.481",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2456",
    "Name": "Planet Fitness",
    "Symbol": "PLNT",
    " marketcap ": " $5 771 334 656 ",
    "price (USD)": "65.45",
    "country": "United States"
  },
  {
    "Rank": "2457",
    "Name": "Airtel Africa",
    "Symbol": "AAF.L",
    " marketcap ": " $5 766 302 605 ",
    "price (USD)": "1.54036",
    "country": "United Kingdom"
  },
  {
    "Rank": "2458",
    "Name": "TPG Telecom",
    "Symbol": "TPG.AX",
    " marketcap ": " $5 765 183 911 ",
    "price (USD)": "3.10066",
    "country": "Australia"
  },
  {
    "Rank": "2459",
    "Name": "Scout24",
    "Symbol": "G24.F",
    " marketcap ": " $5 763 199 653 ",
    "price (USD)": "77.8043",
    "country": "Germany"
  },
  {
    "Rank": "2460",
    "Name": "Casella Waste Systems",
    "Symbol": "CWST",
    " marketcap ": " $5 741 670 912 ",
    "price (USD)": "98.81",
    "country": "United States"
  },
  {
    "Rank": "2461",
    "Name": "DiaSorin",
    "Symbol": "DIA.MI",
    " marketcap ": " $5 737 516 256 ",
    "price (USD)": "107.59",
    "country": "Italy"
  },
  {
    "Rank": "2462",
    "Name": "Smartsheet",
    "Symbol": "SMAR",
    " marketcap ": " $5 733 664 256 ",
    "price (USD)": "41.65",
    "country": "United States"
  },
  {
    "Rank": "2463",
    "Name": "ACC",
    "Symbol": "ACC.NS",
    " marketcap ": " $5 731 061 081 ",
    "price (USD)": "30.5189",
    "country": "India"
  },
  {
    "Rank": "2464",
    "Name": "Bank of Maharashtra",
    "Symbol": "MAHABANK.NS",
    " marketcap ": " $5 725 360 826 ",
    "price (USD)": "0.808031",
    "country": "India"
  },
  {
    "Rank": "2465",
    "Name": "PSP Swiss Property",
    "Symbol": "PSPN.SW",
    " marketcap ": " $5 722 729 135 ",
    "price (USD)": "124.765",
    "country": "Switzerland"
  },
  {
    "Rank": "2466",
    "Name": "APL Apollo",
    "Symbol": "APLAPOLLO.NS",
    " marketcap ": " $5 719 256 222 ",
    "price (USD)": "20.6063",
    "country": "India"
  },
  {
    "Rank": "2467",
    "Name": "HYBE",
    "Symbol": "352820.KS",
    " marketcap ": " $5 714 063 704 ",
    "price (USD)": "137.185",
    "country": "South Korea"
  },
  {
    "Rank": "2468",
    "Name": "Axfood",
    "Symbol": "AXFO.ST",
    " marketcap ": " $5 713 846 484 ",
    "price (USD)": "26.4802",
    "country": "Sweden"
  },
  {
    "Rank": "2469",
    "Name": "Orion Corporation",
    "Symbol": "ORNAV.HE",
    " marketcap ": " $5 713 247 823 ",
    "price (USD)": "40.8296",
    "country": "Finland"
  },
  {
    "Rank": "2470",
    "Name": "Wyndham Hotels &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2471",
    "Name": "SM Energy",
    "Symbol": "SM",
    " marketcap ": " $5 705 785 344 ",
    "price (USD)": "49.6",
    "country": "United States"
  },
  {
    "Rank": "2472",
    "Name": "Scor",
    "Symbol": "SCR.PA",
    " marketcap ": " $5 703 569 360 ",
    "price (USD)": "29.8404",
    "country": "France"
  },
  {
    "Rank": "2473",
    "Name": "Brookfield Renewable",
    "Symbol": "BEPC",
    " marketcap ": " $5 700 093 440 ",
    "price (USD)": "31.67",
    "country": "United States"
  },
  {
    "Rank": "2474",
    "Name": "Yakult",
    "Symbol": "2267.T",
    " marketcap ": " $5 692 034 158 ",
    "price (USD)": "18.7768",
    "country": "Japan"
  },
  {
    "Rank": "2475",
    "Name": "Technoprobe",
    "Symbol": "TPRO.MI",
    " marketcap ": " $5 689 750 531 ",
    "price (USD)": "9.469",
    "country": "Italy"
  },
  {
    "Rank": "2476",
    "Name": "Honeywell Automation India",
    "Symbol": "HONAUT.NS",
    " marketcap ": " $5 684 825 942 ",
    "price (USD)": "642.82",
    "country": "India"
  },
  {
    "Rank": "2477",
    "Name": "Choice Hotels International",
    "Symbol": "CHH",
    " marketcap ": " $5 669 160 960 ",
    "price (USD)": "117.71",
    "country": "United States"
  },
  {
    "Rank": "2478",
    "Name": "Embraer",
    "Symbol": "ERJ",
    " marketcap ": " $5 664 012 800 ",
    "price (USD)": "30.84",
    "country": "Brazil"
  },
  {
    "Rank": "2479",
    "Name": "Yonyou",
    "Symbol": "600588.SS",
    " marketcap ": " $5 661 880 776 ",
    "price (USD)": "1.65624",
    "country": "China"
  },
  {
    "Rank": "2480",
    "Name": "Covivio",
    "Symbol": "COV.PA",
    " marketcap ": " $5 655 014 147 ",
    "price (USD)": "54.349",
    "country": "France"
  },
  {
    "Rank": "2481",
    "Name": "FS KKR Capital",
    "Symbol": "FSK",
    " marketcap ": " $5 654 532 608 ",
    "price (USD)": "20.19",
    "country": "United States"
  },
  {
    "Rank": "2482",
    "Name": "Axiata Group",
    "Symbol": "6888.KL",
    " marketcap ": " $5 653 723 156 ",
    "price (USD)": "0.615745",
    "country": "Malaysia"
  },
  {
    "Rank": "2483",
    "Name": "Tidewater",
    "Symbol": "TDW",
    " marketcap ": " $5 649 248 768 ",
    "price (USD)": "107.07",
    "country": "United States"
  },
  {
    "Rank": "2484",
    "Name": "Atkore",
    "Symbol": "ATKR",
    " marketcap ": " $5 646 727 680 ",
    "price (USD)": "155",
    "country": "United States"
  },
  {
    "Rank": "2485",
    "Name": "Copel",
    "Symbol": "ELP",
    " marketcap ": " $5 644 971 520 ",
    "price (USD)": "\u0438\u044e\u043b.57",
    "country": "Brazil"
  },
  {
    "Rank": "2486",
    "Name": "Bombardier",
    "Symbol": "BBD-B.TO",
    " marketcap ": " $5 643 425 076 ",
    "price (USD)": "57.7734",
    "country": "Canada"
  },
  {
    "Rank": "2487",
    "Name": "China Power International Development",
    "Symbol": "2380.HK",
    " marketcap ": " $5 643 042 740 ",
    "price (USD)": "0.45618",
    "country": "Hong Kong"
  },
  {
    "Rank": "2488",
    "Name": "EVN Group",
    "Symbol": "EVN.F",
    " marketcap ": " $5 642 890 494 ",
    "price (USD)": "31.3823",
    "country": "Austria"
  },
  {
    "Rank": "2489",
    "Name": "Zurn Water Solutions",
    "Symbol": "ZWS",
    " marketcap ": " $5 640 283 648 ",
    "price (USD)": "32.66",
    "country": "United States"
  },
  {
    "Rank": "2490",
    "Name": "Adaro Energy",
    "Symbol": "ADRO.JK",
    " marketcap ": " $5 637 933 401 ",
    "price (USD)": "0.182568",
    "country": "Indonesia"
  },
  {
    "Rank": "2491",
    "Name": "Sampoerna",
    "Symbol": "HMSP.JK",
    " marketcap ": " $5 636 267 113 ",
    "price (USD)": "0.0484557",
    "country": "Indonesia"
  },
  {
    "Rank": "2492",
    "Name": "Zealand Pharma",
    "Symbol": "ZEAL.CO",
    " marketcap ": " $5 633 555 525 ",
    "price (USD)": "90.431",
    "country": "Denmark"
  },
  {
    "Rank": "2493",
    "Name": "Apartment Income REIT",
    "Symbol": "AIRC",
    " marketcap ": " $5 630 034 944 ",
    "price (USD)": "38.8",
    "country": "United States"
  },
  {
    "Rank": "2494",
    "Name": "Far Eastern New Century",
    "Symbol": "1402.TW",
    " marketcap ": " $5 626 451 309 ",
    "price (USD)": "1.05126",
    "country": "Taiwan"
  },
  {
    "Rank": "2495",
    "Name": "Luckin Coffee",
    "Symbol": "LKNCY",
    " marketcap ": " $5 619 248 640 ",
    "price (USD)": "20.\u044f\u043d\u0432",
    "country": "China"
  },
  {
    "Rank": "2496",
    "Name": "Organon",
    "Symbol": "OGN",
    " marketcap ": " $5 619 186 688 ",
    "price (USD)": "21.85",
    "country": "United States"
  },
  {
    "Rank": "2497",
    "Name": "Cabot Corporation",
    "Symbol": "CBT",
    " marketcap ": " $5 618 653 696 ",
    "price (USD)": "101.68",
    "country": "United States"
  },
  {
    "Rank": "2498",
    "Name": "Southwest Gas",
    "Symbol": "SWX",
    " marketcap ": " $5 615 273 984 ",
    "price (USD)": "78.35",
    "country": "United States"
  },
  {
    "Rank": "2499",
    "Name": "Endeavour Mining",
    "Symbol": "EDV.TO",
    " marketcap ": " $5 612 470 463 ",
    "price (USD)": "22.6475",
    "country": "United Kingdom"
  },
  {
    "Rank": "2500",
    "Name": "Yunnan Energy New Material",
    "Symbol": "002812.SZ",
    " marketcap ": " $5 611 835 717 ",
    "price (USD)": "5.73951",
    "country": "China"
  },
  {
    "Rank": "2501",
    "Name": "New Fortress Energy",
    "Symbol": "NFE",
    " marketcap ": " $5 608 500 224 ",
    "price (USD)": "27.35",
    "country": "United States"
  },
  {
    "Rank": "2502",
    "Name": "Canadian Apartment Properties REIT",
    "Symbol": "CAR-UN.TO",
    " marketcap ": " $5 608 497 062 ",
    "price (USD)": "33.2344",
    "country": "Canada"
  },
  {
    "Rank": "2503",
    "Name": "Valaris",
    "Symbol": "VAL",
    " marketcap ": " $5 608 216 064 ",
    "price (USD)": "77.45",
    "country": "United Kingdom"
  },
  {
    "Rank": "2504",
    "Name": "Hargreaves Lansdown",
    "Symbol": "HL.L",
    " marketcap ": " $5 594 432 373 ",
    "price (USD)": "\u043d\u043e\u044f.57",
    "country": "United Kingdom"
  },
  {
    "Rank": "2505",
    "Name": "Terreno Realty",
    "Symbol": "TRNO",
    " marketcap ": " $5 594 331 648 ",
    "price (USD)": "57.85",
    "country": "United States"
  },
  {
    "Rank": "2506",
    "Name": "Lantheus Holdings",
    "Symbol": "LNTH",
    " marketcap ": " $5 593 526 784 ",
    "price (USD)": "80.7",
    "country": "United States"
  },
  {
    "Rank": "2507",
    "Name": "Yanbu National Petrochemical",
    "Symbol": "2290.SR",
    " marketcap ": " $5 591 525 316 ",
    "price (USD)": "9.94049",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2508",
    "Name": "MGIC Investment",
    "Symbol": "MTG",
    " marketcap ": " $5 587 663 360 ",
    "price (USD)": "20.96",
    "country": "United States"
  },
  {
    "Rank": "2509",
    "Name": "GPT Group",
    "Symbol": "GPT.AX",
    " marketcap ": " $5 581 913 667 ",
    "price (USD)": "2.91396",
    "country": "Australia"
  },
  {
    "Rank": "2510",
    "Name": "Sealed Air",
    "Symbol": "SEE",
    " marketcap ": " $5 575 598 592 ",
    "price (USD)": "38.29",
    "country": "United States"
  },
  {
    "Rank": "2511",
    "Name": "FAW Car",
    "Symbol": "000800.SZ",
    " marketcap ": " $5 572 011 844 ",
    "price (USD)": "1.20177",
    "country": "China"
  },
  {
    "Rank": "2512",
    "Name": "McDonald's Japan",
    "Symbol": "2702.T",
    " marketcap ": " $5 571 501 750 ",
    "price (USD)": "41.9039",
    "country": "Japan"
  },
  {
    "Rank": "2513",
    "Name": "Ampol",
    "Symbol": "ALD.AX",
    " marketcap ": " $5 571 100 651 ",
    "price (USD)": "23.3783",
    "country": "Australia"
  },
  {
    "Rank": "2514",
    "Name": "HK Electric Investments",
    "Symbol": "2638.HK",
    " marketcap ": " $5 570 796 819 ",
    "price (USD)": "0.630452",
    "country": "Hong Kong"
  },
  {
    "Rank": "2515",
    "Name": "Strathcona Resources",
    "Symbol": "SCR.TO",
    " marketcap ": " $5 569 711 640 ",
    "price (USD)": "25.998",
    "country": "Canada"
  },
  {
    "Rank": "2516",
    "Name": "Carpenter Technology",
    "Symbol": "CRS",
    " marketcap ": " $5 565 555 200 ",
    "price (USD)": "112.19",
    "country": "United States"
  },
  {
    "Rank": "2517",
    "Name": "Aalberts",
    "Symbol": "AALB.AS",
    " marketcap ": " $5 564 423 117 ",
    "price (USD)": "50.3203",
    "country": "Netherlands"
  },
  {
    "Rank": "2518",
    "Name": "Allegro MicroSystems",
    "Symbol": "ALGM",
    " marketcap ": " $5 556 235 264 ",
    "price (USD)": "28.77",
    "country": "United States"
  },
  {
    "Rank": "2519",
    "Name": "Alaska Airlines",
    "Symbol": "ALK",
    " marketcap ": " $5 551 524 864 ",
    "price (USD)": "43.75",
    "country": "United States"
  },
  {
    "Rank": "2520",
    "Name": "Macy's",
    "Symbol": "M",
    " marketcap ": " $5 550 111 744 ",
    "price (USD)": "20.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "2521",
    "Name": "Cargotec",
    "Symbol": "CGCBV.HE",
    " marketcap ": " $5 539 039 392 ",
    "price (USD)": "86.1114",
    "country": "Finland"
  },
  {
    "Rank": "2522",
    "Name": "AeroVironment",
    "Symbol": "AVAV",
    " marketcap ": " $5 536 543 232 ",
    "price (USD)": "196.78",
    "country": "United States"
  },
  {
    "Rank": "2523",
    "Name": "Mytilineos",
    "Symbol": "MYTIL.AT",
    " marketcap ": " $5 532 480 521 ",
    "price (USD)": "40.0043",
    "country": "Greece"
  },
  {
    "Rank": "2524",
    "Name": "Reply",
    "Symbol": "REY.MI",
    " marketcap ": " $5 529 593 328 ",
    "price (USD)": "148.333",
    "country": "Italy"
  },
  {
    "Rank": "2525",
    "Name": "Vistry Group",
    "Symbol": "VTY.L",
    " marketcap ": " $5 528 127 602 ",
    "price (USD)": "16.286",
    "country": "United Kingdom"
  },
  {
    "Rank": "2526",
    "Name": "Copenhagen Airport",
    "Symbol": "KBHL.CO",
    " marketcap ": " $5 526 938 325 ",
    "price (USD)": "704.242",
    "country": "Denmark"
  },
  {
    "Rank": "2527",
    "Name": "Petronet LNG",
    "Symbol": "PETRONET.NS",
    " marketcap ": " $5 526 737 374 ",
    "price (USD)": "\u043c\u0430\u0440.27",
    "country": "India"
  },
  {
    "Rank": "2528",
    "Name": "Impala Platinum",
    "Symbol": "IMP.JO",
    " marketcap ": " $5 524 892 900 ",
    "price (USD)": "6.11498",
    "country": "South Africa"
  },
  {
    "Rank": "2529",
    "Name": "Old National Bank",
    "Symbol": "ONB",
    " marketcap ": " $5 524 577 792 ",
    "price (USD)": "17.32",
    "country": "United States"
  },
  {
    "Rank": "2530",
    "Name": "Infratil",
    "Symbol": "IFT.NZ",
    " marketcap ": " $5 524 268 575 ",
    "price (USD)": "6.63522",
    "country": "New Zealand"
  },
  {
    "Rank": "2531",
    "Name": "Oscar Health",
    "Symbol": "OSCR",
    " marketcap ": " $5 522 574 848 ",
    "price (USD)": "23.28",
    "country": "United States"
  },
  {
    "Rank": "2532",
    "Name": "Gaztransport & Technigaz",
    "Symbol": "GTT.PA",
    " marketcap ": " $5 517 331 237 ",
    "price (USD)": "144.098",
    "country": "France"
  },
  {
    "Rank": "2533",
    "Name": "Beazley",
    "Symbol": "BEZ.L",
    " marketcap ": " $5 517 306 584 ",
    "price (USD)": "8.43536",
    "country": "United Kingdom"
  },
  {
    "Rank": "2534",
    "Name": "Janus Henderson",
    "Symbol": "JHG",
    " marketcap ": " $5 507 055 616 ",
    "price (USD)": "34.32",
    "country": "United Kingdom"
  },
  {
    "Rank": "2535",
    "Name": "Emmi AG",
    "Symbol": "EMMN.SW",
    " marketcap ": " $5 488 881 474 ",
    "price (USD)": "1026",
    "country": "Switzerland"
  },
  {
    "Rank": "2536",
    "Name": "Mr. Cooper Group",
    "Symbol": "COOP",
    " marketcap ": " $5 485 104 640 ",
    "price (USD)": "84.75",
    "country": "United States"
  },
  {
    "Rank": "2537",
    "Name": "Yadea Group",
    "Symbol": "1585.HK",
    " marketcap ": " $5 484 623 113 ",
    "price (USD)": "1.83241",
    "country": "China"
  },
  {
    "Rank": "2538",
    "Name": "BridgeBio Pharma",
    "Symbol": "BBIO",
    " marketcap ": " $5 479 136 768 ",
    "price (USD)": "29.28",
    "country": "United States"
  },
  {
    "Rank": "2539",
    "Name": "Rightmove",
    "Symbol": "RMV.L",
    " marketcap ": " $5 478 373 312 ",
    "price (USD)": "6.89576",
    "country": "United Kingdom"
  },
  {
    "Rank": "2540",
    "Name": "Bank OZK",
    "Symbol": "OZK",
    " marketcap ": " $5 475 209 216 ",
    "price (USD)": "48.33",
    "country": "United States"
  },
  {
    "Rank": "2541",
    "Name": "Brunswick Corporation",
    "Symbol": "BC",
    " marketcap ": " $5 468 213 760 ",
    "price (USD)": "80.93",
    "country": "United States"
  },
  {
    "Rank": "2542",
    "Name": "Rithm Capital",
    "Symbol": "RITM",
    " marketcap ": " $5 468 136 448 ",
    "price (USD)": "\u043d\u043e\u044f.31",
    "country": "United States"
  },
  {
    "Rank": "2543",
    "Name": "Onex",
    "Symbol": "ONEX.TO",
    " marketcap ": " $5 466 481 299 ",
    "price (USD)": "71.0803",
    "country": "Canada"
  },
  {
    "Rank": "2544",
    "Name": "Glaukos",
    "Symbol": "GKOS",
    " marketcap ": " $5 466 384 896 ",
    "price (USD)": "108.53",
    "country": "United States"
  },
  {
    "Rank": "2545",
    "Name": "Mercury NZ",
    "Symbol": "MCY.AX",
    " marketcap ": " $5 463 434 461 ",
    "price (USD)": "3.89416",
    "country": "New Zealand"
  },
  {
    "Rank": "2546",
    "Name": "Ryder",
    "Symbol": "R",
    " marketcap ": " $5 461 506 560 ",
    "price (USD)": "124.61",
    "country": "United States"
  },
  {
    "Rank": "2547",
    "Name": "Boise Cascade",
    "Symbol": "BCC",
    " marketcap ": " $5 461 171 712 ",
    "price (USD)": "138.33",
    "country": "United States"
  },
  {
    "Rank": "2548",
    "Name": "Ionis Pharmaceuticals",
    "Symbol": "IONS",
    " marketcap ": " $5 454 711 808 ",
    "price (USD)": "37.37",
    "country": "United States"
  },
  {
    "Rank": "2549",
    "Name": "AU Small Finance Bank",
    "Symbol": "AUBANK.NS",
    " marketcap ": " $5 437 944 033 ",
    "price (USD)": "7.32154",
    "country": "India"
  },
  {
    "Rank": "2550",
    "Name": "Empresas CMPC",
    "Symbol": "CMPC.SN",
    " marketcap ": " $5 433 558 468 ",
    "price (USD)": "2.17342",
    "country": "Chile"
  },
  {
    "Rank": "2551",
    "Name": "Yancoal",
    "Symbol": "YAL.AX",
    " marketcap ": " $5 432 569 295 ",
    "price (USD)": "4.11421",
    "country": "Australia"
  },
  {
    "Rank": "2552",
    "Name": "Dukhan Bank",
    "Symbol": "DUBK.QA",
    " marketcap ": " $5 432 536 053 ",
    "price (USD)": "1.03791",
    "country": "Qatar"
  },
  {
    "Rank": "2553",
    "Name": "Air Lease Corporation",
    "Symbol": "AL",
    " marketcap ": " $5 431 368 704 ",
    "price (USD)": "48.77",
    "country": "United States"
  },
  {
    "Rank": "2554",
    "Name": "Mphasis",
    "Symbol": "MPHASIS.NS",
    " marketcap ": " $5 428 077 449 ",
    "price (USD)": "28.7166",
    "country": "India"
  },
  {
    "Rank": "2555",
    "Name": "FirstCash",
    "Symbol": "FCFS",
    " marketcap ": " $5 427 238 400 ",
    "price (USD)": "119.35",
    "country": "United States"
  },
  {
    "Rank": "2556",
    "Name": "Seek Limited",
    "Symbol": "SEK.AX",
    " marketcap ": " $5 425 200 725 ",
    "price (USD)": "15.2299",
    "country": "Australia"
  },
  {
    "Rank": "2557",
    "Name": "Xinyi Glass Holdings",
    "Symbol": "0868.HK",
    " marketcap ": " $5 421 621 092 ",
    "price (USD)": "1.28397",
    "country": "Hong Kong"
  },
  {
    "Rank": "2558",
    "Name": "Bumrungrad Hospital",
    "Symbol": "BH.BK",
    " marketcap ": " $5 420 527 326 ",
    "price (USD)": "6.81899",
    "country": "Thailand"
  },
  {
    "Rank": "2559",
    "Name": "KB Home",
    "Symbol": "KBH",
    " marketcap ": " $5 412 753 920 ",
    "price (USD)": "71.3",
    "country": "United States"
  },
  {
    "Rank": "2560",
    "Name": "Tata Elxsi",
    "Symbol": "TATAELXSI.NS",
    " marketcap ": " $5 406 038 275 ",
    "price (USD)": "86.8072",
    "country": "India"
  },
  {
    "Rank": "2561",
    "Name": "Hikma Pharmaceuticals",
    "Symbol": "HIK.L",
    " marketcap ": " $5 394 430 360 ",
    "price (USD)": "24.3118",
    "country": "United Kingdom"
  },
  {
    "Rank": "2562",
    "Name": "eMemory Technology",
    "Symbol": "3529.TWO",
    " marketcap ": " $5 393 963 852 ",
    "price (USD)": "72.2548",
    "country": "Taiwan"
  },
  {
    "Rank": "2563",
    "Name": "Metropolitan Bank (Metrobank)",
    "Symbol": "MTPOY",
    " marketcap ": " $5 388 289 536 ",
    "price (USD)": "23.68",
    "country": "Philippines"
  },
  {
    "Rank": "2564",
    "Name": "Lufax",
    "Symbol": "LU",
    " marketcap ": " $5 380 722 176 ",
    "price (USD)": "\u0430\u043f\u0440.43",
    "country": "China"
  },
  {
    "Rank": "2565",
    "Name": "Banco Macro",
    "Symbol": "BMA",
    " marketcap ": " $5 376 643 072 ",
    "price (USD)": "64.65",
    "country": "Argentina"
  },
  {
    "Rank": "2566",
    "Name": "Wacker Chemie",
    "Symbol": "WCH.F",
    " marketcap ": " $5 367 533 013 ",
    "price (USD)": "108.046",
    "country": "Germany"
  },
  {
    "Rank": "2567",
    "Name": "Mirvac Group",
    "Symbol": "MGR.AX",
    " marketcap ": " $5 367 514 691 ",
    "price (USD)": "1.36029",
    "country": "Australia"
  },
  {
    "Rank": "2568",
    "Name": "LondonMetric Property",
    "Symbol": "LMP.L",
    " marketcap ": " $5 359 634 382 ",
    "price (USD)": "2.62654",
    "country": "United Kingdom"
  },
  {
    "Rank": "2569",
    "Name": "Charoen Pokphand Indonesia",
    "Symbol": "CPIN.JK",
    " marketcap ": " $5 356 980 594 ",
    "price (USD)": "0.326685",
    "country": "Indonesia"
  },
  {
    "Rank": "2570",
    "Name": "Toho Co.",
    "Symbol": "9602.T",
    " marketcap ": " $5 355 378 015 ",
    "price (USD)": "31.3096",
    "country": "Japan"
  },
  {
    "Rank": "2571",
    "Name": "Wynn Macau",
    "Symbol": "1128.HK",
    " marketcap ": " $5 347 146 074 ",
    "price (USD)": "1.01872",
    "country": "Macau"
  },
  {
    "Rank": "2572",
    "Name": "Megacable Holdings",
    "Symbol": "MEGACPO.MX",
    " marketcap ": " $5 345 728 262 ",
    "price (USD)": "3.11341",
    "country": "Mexico"
  },
  {
    "Rank": "2573",
    "Name": "Qualys",
    "Symbol": "QLYS",
    " marketcap ": " $5 338 467 840 ",
    "price (USD)": "144.52",
    "country": "United States"
  },
  {
    "Rank": "2574",
    "Name": "Adani Wilmar",
    "Symbol": "AWL.NS",
    " marketcap ": " $5 336 795 807 ",
    "price (USD)": "4.10504",
    "country": "India"
  },
  {
    "Rank": "2575",
    "Name": "Merlin Properties",
    "Symbol": "MRL.MC",
    " marketcap ": " $5 330 153 511 ",
    "price (USD)": "\u043d\u043e\u044f.02",
    "country": "Spain"
  },
  {
    "Rank": "2576",
    "Name": "PLDT",
    "Symbol": "PHI",
    " marketcap ": " $5 329 214 976 ",
    "price (USD)": "24.39",
    "country": "Philippines"
  },
  {
    "Rank": "2577",
    "Name": "Hera Group",
    "Symbol": "HER.MI",
    " marketcap ": " $5 324 701 592 ",
    "price (USD)": "3.67467",
    "country": "Italy"
  },
  {
    "Rank": "2578",
    "Name": "Nexstar Media Group",
    "Symbol": "NXST",
    " marketcap ": " $5 324 353 024 ",
    "price (USD)": "162.18",
    "country": "United States"
  },
  {
    "Rank": "2579",
    "Name": "Oberbank",
    "Symbol": "OBS.VI",
    " marketcap ": " $5 321 440 226 ",
    "price (USD)": "75.3611",
    "country": "Austria"
  },
  {
    "Rank": "2580",
    "Name": "Worley",
    "Symbol": "WOR.AX",
    " marketcap ": " $5 316 026 203 ",
    "price (USD)": "10.0755",
    "country": "Australia"
  },
  {
    "Rank": "2581",
    "Name": "Subsea 7",
    "Symbol": "SUBC.OL",
    " marketcap ": " $5 312 094 310 ",
    "price (USD)": "17.7585",
    "country": "Luxembourg"
  },
  {
    "Rank": "2582",
    "Name": "Valvoline",
    "Symbol": "VVV",
    " marketcap ": " $5 311 403 008 ",
    "price (USD)": "41.22",
    "country": "United States"
  },
  {
    "Rank": "2583",
    "Name": "Crescent Point Energy",
    "Symbol": "CPG",
    " marketcap ": " $5 308 336 640 ",
    "price (USD)": "\u0430\u0432\u0433.59",
    "country": "Canada"
  },
  {
    "Rank": "2584",
    "Name": "Telekom Malaysia",
    "Symbol": "4863.KL",
    " marketcap ": " $5 306 534 030 ",
    "price (USD)": "1.38276",
    "country": "Malaysia"
  },
  {
    "Rank": "2585",
    "Name": "Central Retail Corporation",
    "Symbol": "CRC.BK",
    " marketcap ": " $5 306 497 494 ",
    "price (USD)": "0.87987",
    "country": "Thailand"
  },
  {
    "Rank": "2586",
    "Name": "Taiwan High Speed Rail",
    "Symbol": "2633.TW",
    " marketcap ": " $5 305 919 990 ",
    "price (USD)": "0.942723",
    "country": "Taiwan"
  },
  {
    "Rank": "2587",
    "Name": "Clariant",
    "Symbol": "CLN.SW",
    " marketcap ": " $5 304 523 607 ",
    "price (USD)": "16.1306",
    "country": "Switzerland"
  },
  {
    "Rank": "2588",
    "Name": "Darktrace",
    "Symbol": "DARK.L",
    " marketcap ": " $5 303 488 961 ",
    "price (USD)": "7.53906",
    "country": "United Kingdom"
  },
  {
    "Rank": "2589",
    "Name": "Clearwater Analytics",
    "Symbol": "CWAN",
    " marketcap ": " $5 300 754 944 ",
    "price (USD)": "19.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "2590",
    "Name": "Cadence Bancorp",
    "Symbol": "CADE",
    " marketcap ": " $5 299 256 832 ",
    "price (USD)": "29",
    "country": "United States"
  },
  {
    "Rank": "2591",
    "Name": "Maximus",
    "Symbol": "MMS",
    " marketcap ": " $5 298 284 544 ",
    "price (USD)": "87.15",
    "country": "United States"
  },
  {
    "Rank": "2592",
    "Name": "Modine Manufacturing",
    "Symbol": "MOD",
    " marketcap ": " $5 297 525 760 ",
    "price (USD)": "101.47",
    "country": "United States"
  },
  {
    "Rank": "2593",
    "Name": "Strabag",
    "Symbol": "XD4.F",
    " marketcap ": " $5 295 534 438 ",
    "price (USD)": "44.7931",
    "country": "Austria"
  },
  {
    "Rank": "2594",
    "Name": "Clearway Energy",
    "Symbol": "CWEN",
    " marketcap ": " $5 286 708 736 ",
    "price (USD)": "26.93",
    "country": "United States"
  },
  {
    "Rank": "2595",
    "Name": "TriNet",
    "Symbol": "TNET",
    " marketcap ": " $5 282 400 256 ",
    "price (USD)": "104.47",
    "country": "United States"
  },
  {
    "Rank": "2596",
    "Name": "Federal Signal",
    "Symbol": "FSS",
    " marketcap ": " $5 282 189 824 ",
    "price (USD)": "86.45",
    "country": "United States"
  },
  {
    "Rank": "2597",
    "Name": "Evolution Mining",
    "Symbol": "EVN.AX",
    " marketcap ": " $5 270 326 256 ",
    "price (USD)": "\u0444\u0435\u0432.39",
    "country": "Australia"
  },
  {
    "Rank": "2598",
    "Name": "Lundbeck",
    "Symbol": "HLUN-B.CO",
    " marketcap ": " $5 262 928 863 ",
    "price (USD)": "\u043c\u0430\u0439.06",
    "country": "Denmark"
  },
  {
    "Rank": "2599",
    "Name": "Ultrapar Participacoes",
    "Symbol": "UGP",
    " marketcap ": " $5 261 711 872 ",
    "price (USD)": "04.\u0430\u0432\u0433",
    "country": "Brazil"
  },
  {
    "Rank": "2600",
    "Name": "MDU Resources",
    "Symbol": "MDU",
    " marketcap ": " $5 260 310 016 ",
    "price (USD)": "25.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "2601",
    "Name": "Lancaster Colony Corporation",
    "Symbol": "LANC",
    " marketcap ": " $5 257 932 288 ",
    "price (USD)": "191.01",
    "country": "United States"
  },
  {
    "Rank": "2602",
    "Name": "Thor Industries",
    "Symbol": "THO",
    " marketcap ": " $5 255 662 592 ",
    "price (USD)": "98.56",
    "country": "United States"
  },
  {
    "Rank": "2603",
    "Name": "Akeso",
    "Symbol": "9926.HK",
    " marketcap ": " $5 253 549 220 ",
    "price (USD)": "6.06746",
    "country": "China"
  },
  {
    "Rank": "2604",
    "Name": "Stevanato",
    "Symbol": "STVN",
    " marketcap ": " $5 253 530 624 ",
    "price (USD)": "19.26",
    "country": "Italy"
  },
  {
    "Rank": "2605",
    "Name": "Doximity",
    "Symbol": "DOCS",
    " marketcap ": " $5 253 360 640 ",
    "price (USD)": "28.16",
    "country": "United States"
  },
  {
    "Rank": "2606",
    "Name": "Pegasystems",
    "Symbol": "PEGA",
    " marketcap ": " $5 252 377 088 ",
    "price (USD)": "61.77",
    "country": "United States"
  },
  {
    "Rank": "2607",
    "Name": "BOC Aviation",
    "Symbol": "2588.HK",
    " marketcap ": " $5 246 919 142 ",
    "price (USD)": "7.56029",
    "country": "Singapore"
  },
  {
    "Rank": "2608",
    "Name": "Red Rock Resorts",
    "Symbol": "RRR",
    " marketcap ": " $5 245 995 520 ",
    "price (USD)": "51.15",
    "country": "United States"
  },
  {
    "Rank": "2609",
    "Name": "NewMarket Corp",
    "Symbol": "NEU",
    " marketcap ": " $5 242 298 368 ",
    "price (USD)": "546.4",
    "country": "United States"
  },
  {
    "Rank": "2610",
    "Name": "Fukuoka Financial Group",
    "Symbol": "8354.T",
    " marketcap ": " $5 238 041 279 ",
    "price (USD)": "27.7078",
    "country": "Japan"
  },
  {
    "Rank": "2611",
    "Name": "Euronet Worldwide",
    "Symbol": "EEFT",
    " marketcap ": " $5 236 186 112 ",
    "price (USD)": "114.15",
    "country": "United States"
  },
  {
    "Rank": "2612",
    "Name": "\u0415\u045bi\u0415\u045fecam",
    "Symbol": "SISE.IS",
    " marketcap ": " $5 233 312 136 ",
    "price (USD)": "1.70844",
    "country": "Turkey"
  },
  {
    "Rank": "2613",
    "Name": "Silergy",
    "Symbol": "6415.TW",
    " marketcap ": " $5 232 658 665 ",
    "price (USD)": "13.6137",
    "country": "China"
  },
  {
    "Rank": "2614",
    "Name": "Umicore",
    "Symbol": "UMI.VI",
    " marketcap ": " $5 231 443 536 ",
    "price (USD)": "21.7613",
    "country": "Belgium"
  },
  {
    "Rank": "2615",
    "Name": "UNO Minda",
    "Symbol": "UNOMINDA.NS",
    " marketcap ": " $5 230 356 400 ",
    "price (USD)": "9.11003",
    "country": "India"
  },
  {
    "Rank": "2616",
    "Name": "Boyd Gaming",
    "Symbol": "BYD",
    " marketcap ": " $5 224 887 296 ",
    "price (USD)": "55.07",
    "country": "United States"
  },
  {
    "Rank": "2617",
    "Name": "Cosan",
    "Symbol": "CSAN",
    " marketcap ": " $5 223 680 512 ",
    "price (USD)": "\u043d\u043e\u044f.21",
    "country": "Brazil"
  },
  {
    "Rank": "2618",
    "Name": "Lincoln National Corporation",
    "Symbol": "LNC",
    " marketcap ": " $5 214 728 192 ",
    "price (USD)": "30.67",
    "country": "United States"
  },
  {
    "Rank": "2619",
    "Name": "Budimex",
    "Symbol": "BDX.WA",
    " marketcap ": " $5 209 558 942 ",
    "price (USD)": "204.056",
    "country": "Poland"
  },
  {
    "Rank": "2620",
    "Name": "SFS Group",
    "Symbol": "SFSN.SW",
    " marketcap ": " $5 205 874 374 ",
    "price (USD)": "133.873",
    "country": "Switzerland"
  },
  {
    "Rank": "2621",
    "Name": "Interpump Group",
    "Symbol": "IP.MI",
    " marketcap ": " $5 203 950 987 ",
    "price (USD)": "47.8445",
    "country": "Italy"
  },
  {
    "Rank": "2622",
    "Name": "Nexans",
    "Symbol": "NEX.PA",
    " marketcap ": " $5 199 106 196 ",
    "price (USD)": "117.385",
    "country": "France"
  },
  {
    "Rank": "2623",
    "Name": "Voestalpine",
    "Symbol": "VAS.F",
    " marketcap ": " $5 195 099 264 ",
    "price (USD)": "29.0802",
    "country": "Austria"
  },
  {
    "Rank": "2624",
    "Name": "Unite Group (Unite Students)",
    "Symbol": "UTG.L",
    " marketcap ": " $5 195 015 808 ",
    "price (USD)": "\u043d\u043e\u044f.88",
    "country": "United Kingdom"
  },
  {
    "Rank": "2625",
    "Name": "Grupo Simec",
    "Symbol": "SIM",
    " marketcap ": " $5 194 122 240 ",
    "price (USD)": "32.5161",
    "country": "Mexico"
  },
  {
    "Rank": "2626",
    "Name": "Valmont Industries",
    "Symbol": "VMI",
    " marketcap ": " $5 188 231 680 ",
    "price (USD)": "256.95",
    "country": "United States"
  },
  {
    "Rank": "2627",
    "Name": "National Fuel Gas",
    "Symbol": "NFG",
    " marketcap ": " $5 186 008 064 ",
    "price (USD)": "56.42",
    "country": "United States"
  },
  {
    "Rank": "2628",
    "Name": "Haitian International Holdings",
    "Symbol": "1882.HK",
    " marketcap ": " $5 184 387 924 ",
    "price (USD)": "3.24836",
    "country": "Hong Kong"
  },
  {
    "Rank": "2629",
    "Name": "IOI Corporation Berhad",
    "Symbol": "1961.KL",
    " marketcap ": " $5 181 315 641 ",
    "price (USD)": "0.835198",
    "country": "Malaysia"
  },
  {
    "Rank": "2630",
    "Name": "Magnolia Oil &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2631",
    "Name": "LG Household &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2632",
    "Name": "JAC Motors",
    "Symbol": "600418.SS",
    " marketcap ": " $5 176 965 932 ",
    "price (USD)": "2.37039",
    "country": "China"
  },
  {
    "Rank": "2633",
    "Name": "Atlas Arteria",
    "Symbol": "ALX.AX",
    " marketcap ": " $5 175 730 801 ",
    "price (USD)": "3.56743",
    "country": "Australia"
  },
  {
    "Rank": "2634",
    "Name": "UGI Corporation",
    "Symbol": "UGI",
    " marketcap ": " $5 175 567 360 ",
    "price (USD)": "24.69",
    "country": "United States"
  },
  {
    "Rank": "2635",
    "Name": "R1 RCM",
    "Symbol": "RCM",
    " marketcap ": " $5 173 011 456 ",
    "price (USD)": "\u0434\u0435\u043a.28",
    "country": "United States"
  },
  {
    "Rank": "2636",
    "Name": "Hyundai Glovis",
    "Symbol": "086280.KS",
    " marketcap ": " $5 171 995 915 ",
    "price (USD)": "137.92",
    "country": "South Korea"
  },
  {
    "Rank": "2637",
    "Name": "Piraeus Financial Holdings",
    "Symbol": "TPEIR.AT",
    " marketcap ": " $5 168 096 532 ",
    "price (USD)": "4.14812",
    "country": "Greece"
  },
  {
    "Rank": "2638",
    "Name": "Madrigal Pharmaceuticals",
    "Symbol": "MDGL",
    " marketcap ": " $5 167 825 920 ",
    "price (USD)": "242.49",
    "country": "United States"
  },
  {
    "Rank": "2639",
    "Name": "Apellis Pharmaceuticals",
    "Symbol": "APLS",
    " marketcap ": " $5 165 337 088 ",
    "price (USD)": "42.56",
    "country": "United States"
  },
  {
    "Rank": "2640",
    "Name": "Tenable",
    "Symbol": "TENB",
    " marketcap ": " $5 162 437 120 ",
    "price (USD)": "43.43",
    "country": "United States"
  },
  {
    "Rank": "2641",
    "Name": "Fraport",
    "Symbol": "FRA.DE",
    " marketcap ": " $5 161 833 441 ",
    "price (USD)": "55.8693",
    "country": "Germany"
  },
  {
    "Rank": "2642",
    "Name": "ADES Holding Company",
    "Symbol": "2382.SR",
    " marketcap ": " $5 155 485 441 ",
    "price (USD)": "4.70739",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2643",
    "Name": "BAWAG Group",
    "Symbol": "0B2.F",
    " marketcap ": " $5 153 445 959 ",
    "price (USD)": "65.4251",
    "country": "Austria"
  },
  {
    "Rank": "2644",
    "Name": "Fosun",
    "Symbol": "0656.HK",
    " marketcap ": " $5 151 268 496 ",
    "price (USD)": "0.630452",
    "country": "China"
  },
  {
    "Rank": "2645",
    "Name": "Voltas",
    "Symbol": "VOLTAS.NS",
    " marketcap ": " $5 144 546 657 ",
    "price (USD)": "15.5478",
    "country": "India"
  },
  {
    "Rank": "2646",
    "Name": "Monotaro",
    "Symbol": "3064.T",
    " marketcap ": " $5 142 975 295 ",
    "price (USD)": "\u043e\u043a\u0442.12",
    "country": "Japan"
  },
  {
    "Rank": "2647",
    "Name": "Saipem",
    "Symbol": "SPM.MI",
    " marketcap ": " $5 138 897 687 ",
    "price (USD)": "2.60506",
    "country": "Italy"
  },
  {
    "Rank": "2648",
    "Name": "Bausch + Lomb",
    "Symbol": "BLCO",
    " marketcap ": " $5 138 846 208 ",
    "price (USD)": "14.59",
    "country": "Canada"
  },
  {
    "Rank": "2649",
    "Name": "MSC Industrial Direct",
    "Symbol": "MSM",
    " marketcap ": " $5 136 304 128 ",
    "price (USD)": "91.23",
    "country": "United States"
  },
  {
    "Rank": "2650",
    "Name": "Vanguard International Semiconductor",
    "Symbol": "5347.TWO",
    " marketcap ": " $5 133 406 597 ",
    "price (USD)": "3.13207",
    "country": "Taiwan"
  },
  {
    "Rank": "2651",
    "Name": "Indosat",
    "Symbol": "ISAT.JK",
    " marketcap ": " $5 129 283 961 ",
    "price (USD)": "0.636176",
    "country": "Indonesia"
  },
  {
    "Rank": "2652",
    "Name": "Flowers Foods",
    "Symbol": "FLO",
    " marketcap ": " $5 122 305 024 ",
    "price (USD)": "24.26",
    "country": "United States"
  },
  {
    "Rank": "2653",
    "Name": "Bombardier Recreational Products",
    "Symbol": "DOOO",
    " marketcap ": " $5 112 353 792 ",
    "price (USD)": "68.09",
    "country": "Canada"
  },
  {
    "Rank": "2654",
    "Name": "United Tractors",
    "Symbol": "UNTR.JK",
    " marketcap ": " $5 109 148 994 ",
    "price (USD)": "1.40678",
    "country": "Indonesia"
  },
  {
    "Rank": "2655",
    "Name": "GCL Technology",
    "Symbol": "3800.HK",
    " marketcap ": " $5 105 476 757 ",
    "price (USD)": "0.189648",
    "country": "Hong Kong"
  },
  {
    "Rank": "2656",
    "Name": "Vornado Realty Trust",
    "Symbol": "VNO",
    " marketcap ": " $5 104 884 224 ",
    "price (USD)": "24.59",
    "country": "United States"
  },
  {
    "Rank": "2657",
    "Name": "Hiscox",
    "Symbol": "HSX.L",
    " marketcap ": " $5 104 238 768 ",
    "price (USD)": "14.8239",
    "country": "Bermuda"
  },
  {
    "Rank": "2658",
    "Name": "Erdemir",
    "Symbol": "EREGL.IS",
    " marketcap ": " $5 100 954 480 ",
    "price (USD)": "1.51772",
    "country": "Turkey"
  },
  {
    "Rank": "2659",
    "Name": "Ternium Argentina",
    "Symbol": "TXAR.BA",
    " marketcap ": " $5 098 874 776 ",
    "price (USD)": "1.1288",
    "country": "Argentina"
  },
  {
    "Rank": "2660",
    "Name": "Vopak",
    "Symbol": "VPK.AS",
    " marketcap ": " $5 096 115 192 ",
    "price (USD)": "40.721",
    "country": "Netherlands"
  },
  {
    "Rank": "2661",
    "Name": "Arcadium Lithium",
    "Symbol": "ALTM",
    " marketcap ": " $5 093 082 112 ",
    "price (USD)": "\u0430\u043f\u0440.74",
    "country": "United States"
  },
  {
    "Rank": "2662",
    "Name": "Valmet",
    "Symbol": "VALMT.HE",
    " marketcap ": " $5 087 778 860 ",
    "price (USD)": "27.6251",
    "country": "Finland"
  },
  {
    "Rank": "2663",
    "Name": "Mapletree Logistics Trust",
    "Symbol": "M44U.SI",
    " marketcap ": " $5 087 038 444 ",
    "price (USD)": "1.01711",
    "country": "Singapore"
  },
  {
    "Rank": "2664",
    "Name": "Quebecor",
    "Symbol": "QBR-B.TO",
    " marketcap ": " $5 081 020 507 ",
    "price (USD)": "22.0243",
    "country": "Canada"
  },
  {
    "Rank": "2665",
    "Name": "F.N.B. Corporation",
    "Symbol": "FNB",
    " marketcap ": " $5 079 712 256 ",
    "price (USD)": "14.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "2666",
    "Name": "Columbia Sportswear",
    "Symbol": "COLM",
    " marketcap ": " $5 074 613 248 ",
    "price (USD)": "85.83",
    "country": "United States"
  },
  {
    "Rank": "2667",
    "Name": "Affiliated Managers Group",
    "Symbol": "AMG",
    " marketcap ": " $5 071 554 048 ",
    "price (USD)": "159.16",
    "country": "United States"
  },
  {
    "Rank": "2668",
    "Name": "De' Longhi",
    "Symbol": "DLG.MI",
    " marketcap ": " $5 071 268 542 ",
    "price (USD)": "33.7713",
    "country": "Italy"
  },
  {
    "Rank": "2669",
    "Name": "Vertex",
    "Symbol": "VERX",
    " marketcap ": " $5 070 676 480 ",
    "price (USD)": "32.69",
    "country": "United States"
  },
  {
    "Rank": "2670",
    "Name": "Bank Muscat",
    "Symbol": "BKMB.OM",
    " marketcap ": " $5 070 572 190 ",
    "price (USD)": "0.6755",
    "country": "Oman"
  },
  {
    "Rank": "2671",
    "Name": "Glanbia plc",
    "Symbol": "GL9.IR",
    " marketcap ": " $5 068 535 911 ",
    "price (USD)": "19.4484",
    "country": "Ireland"
  },
  {
    "Rank": "2672",
    "Name": "R\u0413\u00a9my Cointreau",
    "Symbol": "RCO.PA",
    " marketcap ": " $5 063 499 307 ",
    "price (USD)": "98.1648",
    "country": "France"
  },
  {
    "Rank": "2673",
    "Name": "Dexus",
    "Symbol": "DXS.AX",
    " marketcap ": " $5 063 429 681 ",
    "price (USD)": "4.70767",
    "country": "Australia"
  },
  {
    "Rank": "2674",
    "Name": "Option Care Health",
    "Symbol": "OPCH",
    " marketcap ": " $5 063 260 160 ",
    "price (USD)": "29.13",
    "country": "United States"
  },
  {
    "Rank": "2675",
    "Name": "EXL Service",
    "Symbol": "EXLS",
    " marketcap ": " $5 058 319 360 ",
    "price (USD)": "31.14",
    "country": "United States"
  },
  {
    "Rank": "2676",
    "Name": "Transocean",
    "Symbol": "RIG",
    " marketcap ": " $5 048 612 864 ",
    "price (USD)": "\u0438\u044e\u043d.16",
    "country": "Switzerland"
  },
  {
    "Rank": "2677",
    "Name": "Kuala Lumpur Kepong",
    "Symbol": "2445.KL",
    " marketcap ": " $5 045 798 562 ",
    "price (USD)": "4.60211",
    "country": "Malaysia"
  },
  {
    "Rank": "2678",
    "Name": "Tritax Big Box REIT",
    "Symbol": "BBOX.L",
    " marketcap ": " $5 042 916 847 ",
    "price (USD)": "2.03288",
    "country": "United Kingdom"
  },
  {
    "Rank": "2679",
    "Name": "Parkland Corp",
    "Symbol": "PKI.TO",
    " marketcap ": " $5 041 969 316 ",
    "price (USD)": "28.8647",
    "country": "Canada"
  },
  {
    "Rank": "2680",
    "Name": "Balchem",
    "Symbol": "BCPC",
    " marketcap ": " $5 041 854 464 ",
    "price (USD)": "155.5",
    "country": "United States"
  },
  {
    "Rank": "2681",
    "Name": "ALK-Abell\u0413\u0456",
    "Symbol": "ALK-B.CO",
    " marketcap ": " $5 036 830 693 ",
    "price (USD)": "22.7569",
    "country": "Denmark"
  },
  {
    "Rank": "2682",
    "Name": "Neoen",
    "Symbol": "NEOEN.PA",
    " marketcap ": " $5 034 669 076 ",
    "price (USD)": "33.1198",
    "country": "France"
  },
  {
    "Rank": "2683",
    "Name": "Armstrong World Industries",
    "Symbol": "AWI",
    " marketcap ": " $5 028 692 480 ",
    "price (USD)": "114.92",
    "country": "United States"
  },
  {
    "Rank": "2684",
    "Name": "Restoration Hardware",
    "Symbol": "RH",
    " marketcap ": " $5 026 844 160 ",
    "price (USD)": "274.05",
    "country": "United States"
  },
  {
    "Rank": "2685",
    "Name": "Emperador Brandy",
    "Symbol": "EMI.SI",
    " marketcap ": " $5 023 716 860 ",
    "price (USD)": "0.31924",
    "country": "Philippines"
  },
  {
    "Rank": "2686",
    "Name": "Jyske Bank",
    "Symbol": "JYSK.CO",
    " marketcap ": " $5 021 404 181 ",
    "price (USD)": "78.1359",
    "country": "Denmark"
  },
  {
    "Rank": "2687",
    "Name": "Escorts Limited",
    "Symbol": "ESCORTS.NS",
    " marketcap ": " $5 021 373 037 ",
    "price (USD)": "46.3047",
    "country": "India"
  },
  {
    "Rank": "2688",
    "Name": "Sweco",
    "Symbol": "SWEC-A.ST",
    " marketcap ": " $5 021 282 430 ",
    "price (USD)": "13.9468",
    "country": "Sweden"
  },
  {
    "Rank": "2689",
    "Name": "Loar Holdings",
    "Symbol": "LOAR",
    " marketcap ": " $5 018 916 352 ",
    "price (USD)": "55.95",
    "country": "United States"
  },
  {
    "Rank": "2690",
    "Name": "JCDecaux",
    "Symbol": "DEC.PA",
    " marketcap ": " $5 017 229 719 ",
    "price (USD)": "23.2381",
    "country": "France"
  },
  {
    "Rank": "2691",
    "Name": "Global-e",
    "Symbol": "GLBE",
    " marketcap ": " $5 016 439 808 ",
    "price (USD)": "30.\u0430\u043f\u0440",
    "country": "Israel"
  },
  {
    "Rank": "2692",
    "Name": "Commercial International Bank",
    "Symbol": "CIN.F",
    " marketcap ": " $5 016 165 577 ",
    "price (USD)": "1.50939",
    "country": "Egypt"
  },
  {
    "Rank": "2693",
    "Name": "Silgan Holdings",
    "Symbol": "SLGN",
    " marketcap ": " $5 014 153 728 ",
    "price (USD)": "46.96",
    "country": "United States"
  },
  {
    "Rank": "2694",
    "Name": "Fannie Mae",
    "Symbol": "FNMAL",
    " marketcap ": " $5 012 906 496 ",
    "price (USD)": "06.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "2695",
    "Name": "Punjab &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2696",
    "Name": "GATX",
    "Symbol": "GATX",
    " marketcap ": " $5 010 365 440 ",
    "price (USD)": "140.83",
    "country": "United States"
  },
  {
    "Rank": "2697",
    "Name": "RTL Group",
    "Symbol": "RRTL.F",
    " marketcap ": " $5 007 428 941 ",
    "price (USD)": "32.3596",
    "country": "Luxembourg"
  },
  {
    "Rank": "2698",
    "Name": "Ricoh Company",
    "Symbol": "7752.T",
    " marketcap ": " $5 003 946 399 ",
    "price (USD)": "\u0430\u0432\u0433.28",
    "country": "Japan"
  },
  {
    "Rank": "2699",
    "Name": "Commercial Bank of Dubai",
    "Symbol": "CBD.AE",
    " marketcap ": " $4 998 752 177 ",
    "price (USD)": "1.67452",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "2700",
    "Name": "Minor International",
    "Symbol": "MINT.BK",
    " marketcap ": " $4 988 846 823 ",
    "price (USD)": "0.87987",
    "country": "Thailand"
  },
  {
    "Rank": "2701",
    "Name": "Fluidra",
    "Symbol": "FDR.MC",
    " marketcap ": " $4 988 027 538 ",
    "price (USD)": "26.2786",
    "country": "Spain"
  },
  {
    "Rank": "2702",
    "Name": "Ashland",
    "Symbol": "ASH",
    " marketcap ": " $4 981 159 936 ",
    "price (USD)": "99.37",
    "country": "United States"
  },
  {
    "Rank": "2703",
    "Name": "Hisense Visual Technology",
    "Symbol": "600060.SS",
    " marketcap ": " $4 975 065 094 ",
    "price (USD)": "3.81114",
    "country": "China"
  },
  {
    "Rank": "2704",
    "Name": "Ambu",
    "Symbol": "AMBU-B.CO",
    " marketcap ": " $4 957 824 054 ",
    "price (USD)": "18.6173",
    "country": "Denmark"
  },
  {
    "Rank": "2705",
    "Name": "Globe Telecom, Inc.",
    "Symbol": "GTMEY",
    " marketcap ": " $4 954 790 912 ",
    "price (USD)": "32.87",
    "country": "Philippines"
  },
  {
    "Rank": "2706",
    "Name": "Idacorp",
    "Symbol": "IDA",
    " marketcap ": " $4 941 212 672 ",
    "price (USD)": "97.47",
    "country": "United States"
  },
  {
    "Rank": "2707",
    "Name": "Acer",
    "Symbol": "2353.TW",
    " marketcap ": " $4 940 897 276 ",
    "price (USD)": "1.64356",
    "country": "Taiwan"
  },
  {
    "Rank": "2708",
    "Name": "Grupo Aeroportuario Centro Norte",
    "Symbol": "OMAB",
    " marketcap ": " $4 932 785 152 ",
    "price (USD)": "85.74",
    "country": "Mexico"
  },
  {
    "Rank": "2709",
    "Name": "Sopra Steria Group",
    "Symbol": "SOP.PA",
    " marketcap ": " $4 931 078 171 ",
    "price (USD)": "241.503",
    "country": "France"
  },
  {
    "Rank": "2710",
    "Name": "Rohm",
    "Symbol": "6963.T",
    " marketcap ": " $4 927 037 715 ",
    "price (USD)": "\u0434\u0435\u043a.63",
    "country": "Japan"
  },
  {
    "Rank": "2711",
    "Name": "Tokyu Fudosan Holdings",
    "Symbol": "3289.T",
    " marketcap ": " $4 921 921 371 ",
    "price (USD)": "6.90935",
    "country": "Japan"
  },
  {
    "Rank": "2712",
    "Name": "Exponent",
    "Symbol": "EXPO",
    " marketcap ": " $4 921 606 144 ",
    "price (USD)": "97.13",
    "country": "United States"
  },
  {
    "Rank": "2713",
    "Name": "JSC Halyk Bank",
    "Symbol": "H4L1.F",
    " marketcap ": " $4 919 683 961 ",
    "price (USD)": "17.9173",
    "country": "Kazakhstan"
  },
  {
    "Rank": "2714",
    "Name": "Itron",
    "Symbol": "ITRI",
    " marketcap ": " $4 909 860 864 ",
    "price (USD)": "107.04",
    "country": "United States"
  },
  {
    "Rank": "2715",
    "Name": "Public Power Corporation",
    "Symbol": "PPC.AT",
    " marketcap ": " $4 907 221 162 ",
    "price (USD)": "\u0434\u0435\u043a.61",
    "country": "Greece"
  },
  {
    "Rank": "2716",
    "Name": "MISUMI Group",
    "Symbol": "9962.T",
    " marketcap ": " $4 905 222 709 ",
    "price (USD)": "17.4013",
    "country": "Japan"
  },
  {
    "Rank": "2717",
    "Name": "Azelis Group",
    "Symbol": "AZE.BR",
    " marketcap ": " $4 902 419 737 ",
    "price (USD)": "20.1325",
    "country": "Belgium"
  },
  {
    "Rank": "2718",
    "Name": "EchoStar",
    "Symbol": "SATS",
    " marketcap ": " $4 901 242 368 ",
    "price (USD)": "18.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "2719",
    "Name": "Samsonite International",
    "Symbol": "1SO.F",
    " marketcap ": " $4 899 761 607 ",
    "price (USD)": "3.28266",
    "country": "Luxembourg"
  },
  {
    "Rank": "2720",
    "Name": "T\u0413\u0458rk Telekom",
    "Symbol": "TTKOM.IS",
    " marketcap ": " $4 898 876 105 ",
    "price (USD)": "1.39968",
    "country": "Turkey"
  },
  {
    "Rank": "2721",
    "Name": "New India Assurance",
    "Symbol": "NIACL.NS",
    " marketcap ": " $4 897 843 495 ",
    "price (USD)": "2.97199",
    "country": "India"
  },
  {
    "Rank": "2722",
    "Name": "Sasol",
    "Symbol": "SSL",
    " marketcap ": " $4 897 248 256 ",
    "price (USD)": "\u0438\u044e\u043b.58",
    "country": "South Africa"
  },
  {
    "Rank": "2723",
    "Name": "Avnet",
    "Symbol": "AVT",
    " marketcap ": " $4 893 184 000 ",
    "price (USD)": "54.14",
    "country": "United States"
  },
  {
    "Rank": "2724",
    "Name": "Laboratorios Farmaceuticos Rovi",
    "Symbol": "ROVI.MC",
    " marketcap ": " $4 891 598 740 ",
    "price (USD)": "95.613",
    "country": "Spain"
  },
  {
    "Rank": "2725",
    "Name": "Whirlpool",
    "Symbol": "WHR",
    " marketcap ": " $4 890 987 520 ",
    "price (USD)": "89.52",
    "country": "United States"
  },
  {
    "Rank": "2726",
    "Name": "Enact Holdings",
    "Symbol": "ACT",
    " marketcap ": " $4 888 635 392 ",
    "price (USD)": "31.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "2727",
    "Name": "AutoStore Holdings",
    "Symbol": "AUTO.OL",
    " marketcap ": " $4 885 966 077 ",
    "price (USD)": "1.45502",
    "country": "Norway"
  },
  {
    "Rank": "2728",
    "Name": "Hamamatsu",
    "Symbol": "6965.T",
    " marketcap ": " $4 882 569 164 ",
    "price (USD)": "31.5271",
    "country": "Japan"
  },
  {
    "Rank": "2729",
    "Name": "Hensoldt",
    "Symbol": "HAG.F",
    " marketcap ": " $4 881 299 807 ",
    "price (USD)": "42.2196",
    "country": "Germany"
  },
  {
    "Rank": "2730",
    "Name": "Mapletree Commercial Trust",
    "Symbol": "N2IU.SI",
    " marketcap ": " $4 878 661 153 ",
    "price (USD)": "0.928023",
    "country": "Singapore"
  },
  {
    "Rank": "2731",
    "Name": "China Resources Pharmaceutical Group",
    "Symbol": "3320.HK",
    " marketcap ": " $4 878 568 709 ",
    "price (USD)": "0.776532",
    "country": "Hong Kong"
  },
  {
    "Rank": "2732",
    "Name": "Varonis",
    "Symbol": "VRNS",
    " marketcap ": " $4 877 141 504 ",
    "price (USD)": "43.74",
    "country": "United States"
  },
  {
    "Rank": "2733",
    "Name": "ASM Pacific Technology",
    "Symbol": "0522.HK",
    " marketcap ": " $4 873 292 254 ",
    "price (USD)": "\u043d\u043e\u044f.69",
    "country": "Hong Kong"
  },
  {
    "Rank": "2734",
    "Name": "Zhongsheng Group",
    "Symbol": "0881.HK",
    " marketcap ": " $4 872 874 987 ",
    "price (USD)": "2.04256",
    "country": "China"
  },
  {
    "Rank": "2735",
    "Name": "Hanover Insurance Group",
    "Symbol": "THG",
    " marketcap ": " $4 859 120 640 ",
    "price (USD)": "135.19",
    "country": "United States"
  },
  {
    "Rank": "2736",
    "Name": "Home BancShares",
    "Symbol": "HOMB",
    " marketcap ": " $4 857 783 808 ",
    "price (USD)": "24.25",
    "country": "United States"
  },
  {
    "Rank": "2737",
    "Name": "Air Canada",
    "Symbol": "AC.TO",
    " marketcap ": " $4 856 949 607 ",
    "price (USD)": "13.5489",
    "country": "Canada"
  },
  {
    "Rank": "2738",
    "Name": "ABC-Mart",
    "Symbol": "2670.T",
    " marketcap ": " $4 855 390 444 ",
    "price (USD)": "19.6085",
    "country": "Japan"
  },
  {
    "Rank": "2739",
    "Name": "KPIT Technologies",
    "Symbol": "KPITTECH.NS",
    " marketcap ": " $4 847 028 230 ",
    "price (USD)": "17.8482",
    "country": "India"
  },
  {
    "Rank": "2740",
    "Name": "Leapmotor",
    "Symbol": "9863.HK",
    " marketcap ": " $4 846 757 980 ",
    "price (USD)": "4.15175",
    "country": "China"
  },
  {
    "Rank": "2741",
    "Name": "VF Corporation",
    "Symbol": "VFC",
    " marketcap ": " $4 844 647 424 ",
    "price (USD)": "\u0434\u0435\u043a.46",
    "country": "United States"
  },
  {
    "Rank": "2742",
    "Name": "The Bidvest Group",
    "Symbol": "BVT.JO",
    " marketcap ": " $4 842 825 100 ",
    "price (USD)": "14.1799",
    "country": "South Africa"
  },
  {
    "Rank": "2743",
    "Name": "Asbury Automotive Group",
    "Symbol": "ABG",
    " marketcap ": " $4 841 328 128 ",
    "price (USD)": "240",
    "country": "United States"
  },
  {
    "Rank": "2744",
    "Name": "Banca Generali",
    "Symbol": "BGN.MI",
    " marketcap ": " $4 839 870 561 ",
    "price (USD)": "42.3499",
    "country": "Italy"
  },
  {
    "Rank": "2745",
    "Name": "37 Interactive Entertainment",
    "Symbol": "002555.SZ",
    " marketcap ": " $4 834 422 351 ",
    "price (USD)": "2.17977",
    "country": "China"
  },
  {
    "Rank": "2746",
    "Name": "Kobe Bussan",
    "Symbol": "3038.T",
    " marketcap ": " $4 831 771 321 ",
    "price (USD)": "21.886",
    "country": "Japan"
  },
  {
    "Rank": "2747",
    "Name": "Grupo Catalana Occidente",
    "Symbol": "GCO.MC",
    " marketcap ": " $4 831 650 985 ",
    "price (USD)": "40.9382",
    "country": "Spain"
  },
  {
    "Rank": "2748",
    "Name": "Asia Cement",
    "Symbol": "1102.TW",
    " marketcap ": " $4 828 169 449 ",
    "price (USD)": "1.36137",
    "country": "Taiwan"
  },
  {
    "Rank": "2749",
    "Name": "Essential Properties Realty Trust",
    "Symbol": "EPRT",
    " marketcap ": " $4 826 174 464 ",
    "price (USD)": "27.53",
    "country": "United States"
  },
  {
    "Rank": "2750",
    "Name": "Ibiden",
    "Symbol": "4062.T",
    " marketcap ": " $4 823 290 339 ",
    "price (USD)": "34.5275",
    "country": "Japan"
  },
  {
    "Rank": "2751",
    "Name": "Hualan Biological Engineering",
    "Symbol": "002007.SZ",
    " marketcap ": " $4 814 905 627 ",
    "price (USD)": "2.63285",
    "country": "China"
  },
  {
    "Rank": "2752",
    "Name": "Commvault",
    "Symbol": "CVLT",
    " marketcap ": " $4 804 512 768 ",
    "price (USD)": "110.7",
    "country": "United States"
  },
  {
    "Rank": "2753",
    "Name": "Husqvarna",
    "Symbol": "HUSQ-A.ST",
    " marketcap ": " $4 802 869 737 ",
    "price (USD)": "8.46169",
    "country": "Sweden"
  },
  {
    "Rank": "2754",
    "Name": "Burberry",
    "Symbol": "BRBY.L",
    " marketcap ": " $4 791 331 762 ",
    "price (USD)": "13.3618",
    "country": "United Kingdom"
  },
  {
    "Rank": "2755",
    "Name": "Charoen Pokphand Foods",
    "Symbol": "CPF.BK",
    " marketcap ": " $4 790 627 402 ",
    "price (USD)": "0.618659",
    "country": "Thailand"
  },
  {
    "Rank": "2756",
    "Name": "Canadian Utilities",
    "Symbol": "CU.TO",
    " marketcap ": " $4 789 696 467 ",
    "price (USD)": "23.4026",
    "country": "Canada"
  },
  {
    "Rank": "2757",
    "Name": "Exide Industries",
    "Symbol": "EXIDEIND.NS",
    " marketcap ": " $4 788 376 394 ",
    "price (USD)": "5.63279",
    "country": "India"
  },
  {
    "Rank": "2758",
    "Name": "VZ Holding",
    "Symbol": "VZN.SW",
    " marketcap ": " $4 786 743 514 ",
    "price (USD)": "121.583",
    "country": "Switzerland"
  },
  {
    "Rank": "2759",
    "Name": "Merit Medical",
    "Symbol": "MMSI",
    " marketcap ": " $4 782 680 064 ",
    "price (USD)": "82.31",
    "country": "United States"
  },
  {
    "Rank": "2760",
    "Name": "PennyMac",
    "Symbol": "PFSI",
    " marketcap ": " $4 782 660 096 ",
    "price (USD)": "93.92",
    "country": "United States"
  },
  {
    "Rank": "2761",
    "Name": "Page Industries",
    "Symbol": "PAGEIND.NS",
    " marketcap ": " $4 768 588 107 ",
    "price (USD)": "427.527",
    "country": "India"
  },
  {
    "Rank": "2762",
    "Name": "Federal Bank",
    "Symbol": "FEDERALBNK.NS",
    " marketcap ": " $4 764 842 270 ",
    "price (USD)": "1.95309",
    "country": "India"
  },
  {
    "Rank": "2763",
    "Name": "Krystal Biotech",
    "Symbol": "KRYS",
    " marketcap ": " $4 764 398 080 ",
    "price (USD)": "166.83",
    "country": "United States"
  },
  {
    "Rank": "2764",
    "Name": "Buenaventura Mining Company",
    "Symbol": "BVN",
    " marketcap ": " $4 741 937 664 ",
    "price (USD)": "18.67",
    "country": "Peru"
  },
  {
    "Rank": "2765",
    "Name": "Haemonetics",
    "Symbol": "HAE",
    " marketcap ": " $4 737 910 272 ",
    "price (USD)": "93.19",
    "country": "United States"
  },
  {
    "Rank": "2766",
    "Name": "Japan Real Estate Investment",
    "Symbol": "8952.T",
    " marketcap ": " $4 733 460 611 ",
    "price (USD)": "3326.72",
    "country": "Japan"
  },
  {
    "Rank": "2767",
    "Name": "Radian Group",
    "Symbol": "RDN",
    " marketcap ": " $4 732 666 368 ",
    "price (USD)": "31.43",
    "country": "United States"
  },
  {
    "Rank": "2768",
    "Name": "Romgaz",
    "Symbol": "RZ8G.F",
    " marketcap ": " $4 731 796 251 ",
    "price (USD)": "11.0761",
    "country": "Romania"
  },
  {
    "Rank": "2769",
    "Name": "ALTEN",
    "Symbol": "ATE.PA",
    " marketcap ": " $4 731 606 663 ",
    "price (USD)": "136.171",
    "country": "France"
  },
  {
    "Rank": "2770",
    "Name": "CorVel Corporation",
    "Symbol": "CRVL",
    " marketcap ": " $4 726 574 080 ",
    "price (USD)": "276.5",
    "country": "United States"
  },
  {
    "Rank": "2771",
    "Name": "MDC Holdings",
    "Symbol": "MDC",
    " marketcap ": " $4 726 503 936 ",
    "price (USD)": "62.98",
    "country": "United States"
  },
  {
    "Rank": "2772",
    "Name": "TMBThanachart Bank (ttb)",
    "Symbol": "TTB.BK",
    " marketcap ": " $4 725 816 245 ",
    "price (USD)": "0.0486678",
    "country": "Thailand"
  },
  {
    "Rank": "2773",
    "Name": "National Storage",
    "Symbol": "NSA",
    " marketcap ": " $4 725 306 880 ",
    "price (USD)": "37",
    "country": "United States"
  },
  {
    "Rank": "2774",
    "Name": "Vista Oil &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2775",
    "Name": "British Land",
    "Symbol": "BLND.L",
    " marketcap ": " $4 722 791 706 ",
    "price (USD)": "5.0919",
    "country": "United Kingdom"
  },
  {
    "Rank": "2776",
    "Name": "Kite Realty",
    "Symbol": "KRG",
    " marketcap ": " $4 720 794 624 ",
    "price (USD)": "21.14",
    "country": "United States"
  },
  {
    "Rank": "2777",
    "Name": "iQIYI",
    "Symbol": "IQ",
    " marketcap ": " $4 711 945 216 ",
    "price (USD)": "\u0430\u043f\u0440.91",
    "country": "China"
  },
  {
    "Rank": "2778",
    "Name": "Tokyo Century",
    "Symbol": "8439.T",
    " marketcap ": " $4 709 838 134 ",
    "price (USD)": "9.61871",
    "country": "Japan"
  },
  {
    "Rank": "2779",
    "Name": "ImmunityBio",
    "Symbol": "IBRX",
    " marketcap ": " $4 706 120 192 ",
    "price (USD)": "6.805",
    "country": "United States"
  },
  {
    "Rank": "2780",
    "Name": "Harley-Davidson",
    "Symbol": "HOG",
    " marketcap ": " $4 700 984 832 ",
    "price (USD)": "34.95",
    "country": "United States"
  },
  {
    "Rank": "2781",
    "Name": "Saudi Research and Media Group",
    "Symbol": "4210.SR",
    " marketcap ": " $4 696 714 968 ",
    "price (USD)": "58.7089",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2782",
    "Name": "Tofa\u0415\u045f T\u0413\u0458rk Otomobil Fabrikas\u0414\u00b1",
    "Symbol": "TOASO.IS",
    " marketcap ": " $4 694 328 915 ",
    "price (USD)": "9.38866",
    "country": "Turkey"
  },
  {
    "Rank": "2783",
    "Name": "AGL Energy",
    "Symbol": "AGL.AX",
    " marketcap ": " $4 692 290 110 ",
    "price (USD)": "6.97482",
    "country": "Australia"
  },
  {
    "Rank": "2784",
    "Name": "StoneCo",
    "Symbol": "STNE",
    " marketcap ": " $4 687 529 984 ",
    "price (USD)": "15.17",
    "country": "Brazil"
  },
  {
    "Rank": "2785",
    "Name": "Hang Lung Properties",
    "Symbol": "0101.HK",
    " marketcap ": " $4 687 251 671 ",
    "price (USD)": "1.04178",
    "country": "Hong Kong"
  },
  {
    "Rank": "2786",
    "Name": "Frasers Group",
    "Symbol": "FRAS.L",
    " marketcap ": " $4 680 236 348 ",
    "price (USD)": "\u043e\u043a\u0442.32",
    "country": "United Kingdom"
  },
  {
    "Rank": "2787",
    "Name": "Verallia",
    "Symbol": "VRLA.PA",
    " marketcap ": " $4 675 978 299 ",
    "price (USD)": "39.4614",
    "country": "France"
  },
  {
    "Rank": "2788",
    "Name": "Portland General Electric",
    "Symbol": "POR",
    " marketcap ": " $4 667 304 448 ",
    "price (USD)": "45.3",
    "country": "United States"
  },
  {
    "Rank": "2789",
    "Name": "Getinge",
    "Symbol": "GETI-B.ST",
    " marketcap ": " $4 665 506 733 ",
    "price (USD)": "17.1293",
    "country": "Sweden"
  },
  {
    "Rank": "2790",
    "Name": "Gates Industrial Corp",
    "Symbol": "GTES",
    " marketcap ": " $4 663 019 008 ",
    "price (USD)": "17.84",
    "country": "United States"
  },
  {
    "Rank": "2791",
    "Name": "Spark New Zealand",
    "Symbol": "NZTCF",
    " marketcap ": " $4 662 391 296 ",
    "price (USD)": "\u0444\u0435\u0432.57",
    "country": "New Zealand"
  },
  {
    "Rank": "2792",
    "Name": "UPL",
    "Symbol": "UPL.NS",
    " marketcap ": " $4 653 703 047 ",
    "price (USD)": "6.19991",
    "country": "India"
  },
  {
    "Rank": "2793",
    "Name": "Alight",
    "Symbol": "ALIT",
    " marketcap ": " $4 652 931 584 ",
    "price (USD)": "08.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "2794",
    "Name": "Mapletree Industrial Trust",
    "Symbol": "ME8U.SI",
    " marketcap ": " $4 652 132 465 ",
    "price (USD)": "1.64074",
    "country": "Singapore"
  },
  {
    "Rank": "2795",
    "Name": "CRISPR Therapeutics",
    "Symbol": "CRSP",
    " marketcap ": " $4 650 114 560 ",
    "price (USD)": "54.76",
    "country": "Switzerland"
  },
  {
    "Rank": "2796",
    "Name": "Impinj",
    "Symbol": "PI",
    " marketcap ": " $4 649 266 688 ",
    "price (USD)": "167.74",
    "country": "United States"
  },
  {
    "Rank": "2797",
    "Name": "Polaris",
    "Symbol": "PII",
    " marketcap ": " $4 647 105 536 ",
    "price (USD)": "82.23",
    "country": "United States"
  },
  {
    "Rank": "2798",
    "Name": "DEME Group",
    "Symbol": "DEME.BR",
    " marketcap ": " $4 645 618 851 ",
    "price (USD)": "183.516",
    "country": "Belgium"
  },
  {
    "Rank": "2799",
    "Name": "Nahdi Medical Company",
    "Symbol": "4164.SR",
    " marketcap ": " $4 641 742 020 ",
    "price (USD)": "35.7057",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2800",
    "Name": "Gujarat Gas",
    "Symbol": "GUJGASLTD.NS",
    " marketcap ": " $4 639 339 019 ",
    "price (USD)": "\u0438\u044e\u043d.88",
    "country": "India"
  },
  {
    "Rank": "2801",
    "Name": "Tecan",
    "Symbol": "TECN.SW",
    " marketcap ": " $4 637 910 349 ",
    "price (USD)": "362.116",
    "country": "Switzerland"
  },
  {
    "Rank": "2802",
    "Name": "American Eagle Outfitters",
    "Symbol": "AEO",
    " marketcap ": " $4 637 712 384 ",
    "price (USD)": "23.61",
    "country": "United States"
  },
  {
    "Rank": "2803",
    "Name": "Richter Gedeon",
    "Symbol": "RIG2.F",
    " marketcap ": " $4 636 309 280 ",
    "price (USD)": "25.3665",
    "country": "Hungary"
  },
  {
    "Rank": "2804",
    "Name": "Dun &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2805",
    "Name": "Natura&Co",
    "Symbol": "NTCO",
    " marketcap ": " $4 625 982 976 ",
    "price (USD)": "\u0438\u044e\u043d.57",
    "country": "Brazil"
  },
  {
    "Rank": "2806",
    "Name": "The Commercial Bank (P.S.Q.C.)",
    "Symbol": "CBQK.QA",
    " marketcap ": " $4 625 428 255 ",
    "price (USD)": "1.14286",
    "country": "Qatar"
  },
  {
    "Rank": "2807",
    "Name": "Vak\u0414\u00b1fBank",
    "Symbol": "VAKBN.IS",
    " marketcap ": " $4 620 571 244 ",
    "price (USD)": "0.693316",
    "country": "Turkey"
  },
  {
    "Rank": "2808",
    "Name": "Sallie Mae",
    "Symbol": "SLM",
    " marketcap ": " $4 618 430 464 ",
    "price (USD)": "21.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "2809",
    "Name": "Ringkj\u0413\u0451bing Landbobank",
    "Symbol": "RILBA.CO",
    " marketcap ": " $4 613 298 617 ",
    "price (USD)": "175.915",
    "country": "Denmark"
  },
  {
    "Rank": "2810",
    "Name": "United Bankshares",
    "Symbol": "UBSI",
    " marketcap ": " $4 611 535 872 ",
    "price (USD)": "34.11",
    "country": "United States"
  },
  {
    "Rank": "2811",
    "Name": "Seatrium",
    "Symbol": "S51.SI",
    " marketcap ": " $4 608 743 511 ",
    "price (USD)": "\u044f\u043d\u0432.12",
    "country": "Singapore"
  },
  {
    "Rank": "2812",
    "Name": "Patterson-UTI Energy",
    "Symbol": "PTEN",
    " marketcap ": " $4 607 510 528 ",
    "price (USD)": "\u043d\u043e\u044f.47",
    "country": "United States"
  },
  {
    "Rank": "2813",
    "Name": "Nippon Prologis REIT",
    "Symbol": "3283.T",
    " marketcap ": " $4 604 063 591 ",
    "price (USD)": "1621.78",
    "country": "Japan"
  },
  {
    "Rank": "2814",
    "Name": "Algonquin Power & Utilities",
    "Symbol": "AQN",
    " marketcap ": " $4 601 199 616 ",
    "price (USD)": "\u0438\u044e\u043d.67",
    "country": "Canada"
  },
  {
    "Rank": "2815",
    "Name": "Storebrand",
    "Symbol": "STB.OL",
    " marketcap ": " $4 597 661 881 ",
    "price (USD)": "\u043e\u043a\u0442.56",
    "country": "Norway"
  },
  {
    "Rank": "2816",
    "Name": "Banco del Baj\u0413\u00ado",
    "Symbol": "BBAJIOO.MX",
    " marketcap ": " $4 592 234 888 ",
    "price (USD)": "3.76114",
    "country": "Mexico"
  },
  {
    "Rank": "2817",
    "Name": "Konecranes",
    "Symbol": "KCR.HE",
    " marketcap ": " $4 588 777 900 ",
    "price (USD)": "57.9325",
    "country": "Finland"
  },
  {
    "Rank": "2818",
    "Name": "International Games System",
    "Symbol": "3293.TWO",
    " marketcap ": " $4 587 900 774 ",
    "price (USD)": "32.5612",
    "country": "Taiwan"
  },
  {
    "Rank": "2819",
    "Name": "PTT Global Chemical",
    "Symbol": "PTTGC.BK",
    " marketcap ": " $4 587 078 642 ",
    "price (USD)": "1.01735",
    "country": "Thailand"
  },
  {
    "Rank": "2820",
    "Name": "ALS Global",
    "Symbol": "ALQ.AX",
    " marketcap ": " $4 577 978 107 ",
    "price (USD)": "9.45535",
    "country": "Australia"
  },
  {
    "Rank": "2821",
    "Name": "Whitecap Resources",
    "Symbol": "WCP.TO",
    " marketcap ": " $4 577 521 407 ",
    "price (USD)": "7.64097",
    "country": "Canada"
  },
  {
    "Rank": "2822",
    "Name": "Franklin Electric",
    "Symbol": "FELE",
    " marketcap ": " $4 575 312 896 ",
    "price (USD)": "99.29",
    "country": "United States"
  },
  {
    "Rank": "2823",
    "Name": "Temenos",
    "Symbol": "TEMN.SW",
    " marketcap ": " $4 570 090 055 ",
    "price (USD)": "63.0411",
    "country": "Switzerland"
  },
  {
    "Rank": "2824",
    "Name": "Aboitiz Power",
    "Symbol": "ABZPY",
    " marketcap ": " $4 564 912 128 ",
    "price (USD)": "\u0434\u0435\u043a.67",
    "country": "Philippines"
  },
  {
    "Rank": "2825",
    "Name": "White Mountains Insurance Group",
    "Symbol": "WTM",
    " marketcap ": " $4 564 407 808 ",
    "price (USD)": "1778.99",
    "country": "Bermuda"
  },
  {
    "Rank": "2826",
    "Name": "Rayonier",
    "Symbol": "RYN",
    " marketcap ": " $4 563 762 688 ",
    "price (USD)": "30.23",
    "country": "United States"
  },
  {
    "Rank": "2827",
    "Name": "Northland Power",
    "Symbol": "NPI.TO",
    " marketcap ": " $4 563 140 925 ",
    "price (USD)": "17.7939",
    "country": "Canada"
  },
  {
    "Rank": "2828",
    "Name": "TransMedics Group",
    "Symbol": "TMDX",
    " marketcap ": " $4 559 180 800 ",
    "price (USD)": "138.42",
    "country": "United States"
  },
  {
    "Rank": "2829",
    "Name": "RS Group",
    "Symbol": "RS1.L",
    " marketcap ": " $4 559 014 455 ",
    "price (USD)": "9.61771",
    "country": "United Kingdom"
  },
  {
    "Rank": "2830",
    "Name": "PrairieSky Royalty",
    "Symbol": "PSK.TO",
    " marketcap ": " $4 555 885 574 ",
    "price (USD)": "19.0623",
    "country": "Canada"
  },
  {
    "Rank": "2831",
    "Name": "Camtek",
    "Symbol": "CAMT",
    " marketcap ": " $4 552 701 952 ",
    "price (USD)": "100.85",
    "country": "Israel"
  },
  {
    "Rank": "2832",
    "Name": "PPB Group Berhad",
    "Symbol": "4065.KL",
    " marketcap ": " $4 552 562 405 ",
    "price (USD)": "3.20017",
    "country": "Malaysia"
  },
  {
    "Rank": "2833",
    "Name": "NKT A/S",
    "Symbol": "NKT.CO",
    " marketcap ": " $4 549 631 774 ",
    "price (USD)": "84.8291",
    "country": "Denmark"
  },
  {
    "Rank": "2834",
    "Name": "Finning",
    "Symbol": "FTT.TO",
    " marketcap ": " $4 547 890 723 ",
    "price (USD)": "31.988",
    "country": "Canada"
  },
  {
    "Rank": "2835",
    "Name": "Topsports International",
    "Symbol": "6110.HK",
    " marketcap ": " $4 545 271 302 ",
    "price (USD)": "0.732964",
    "country": "Hong Kong"
  },
  {
    "Rank": "2836",
    "Name": "Workiva",
    "Symbol": "WK",
    " marketcap ": " $4 544 984 064 ",
    "price (USD)": "82.9",
    "country": "United States"
  },
  {
    "Rank": "2837",
    "Name": "Verra Mobility",
    "Symbol": "VRRM",
    " marketcap ": " $4 544 466 944 ",
    "price (USD)": "27.29",
    "country": "United States"
  },
  {
    "Rank": "2838",
    "Name": "Qatar Electricity &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2839",
    "Name": "NexGen Energy",
    "Symbol": "NXE",
    " marketcap ": " $4 532 718 080 ",
    "price (USD)": "08.\u0438\u044e\u043d",
    "country": "Canada"
  },
  {
    "Rank": "2840",
    "Name": "Hindustan Copper",
    "Symbol": "HINDCOPPER.NS",
    " marketcap ": " $4 531 454 665 ",
    "price (USD)": "4.68598",
    "country": "India"
  },
  {
    "Rank": "2841",
    "Name": "Aurizon Holdings",
    "Symbol": "AZJ.AX",
    " marketcap ": " $4 529 088 403 ",
    "price (USD)": "2.46052",
    "country": "Australia"
  },
  {
    "Rank": "2842",
    "Name": "Scorpio Tankers",
    "Symbol": "STNG",
    " marketcap ": " $4 528 683 520 ",
    "price (USD)": "82.98",
    "country": "Monaco"
  },
  {
    "Rank": "2843",
    "Name": "Inspire Medical Systems",
    "Symbol": "INSP",
    " marketcap ": " $4 527 065 088 ",
    "price (USD)": "152.37",
    "country": "United States"
  },
  {
    "Rank": "2844",
    "Name": "Enstar Group",
    "Symbol": "ESGR",
    " marketcap ": " $4 525 364 224 ",
    "price (USD)": "308.61",
    "country": "Bermuda"
  },
  {
    "Rank": "2845",
    "Name": "ASGN",
    "Symbol": "ASGN",
    " marketcap ": " $4 517 477 888 ",
    "price (USD)": "98.42",
    "country": "United States"
  },
  {
    "Rank": "2846",
    "Name": "Nuvei",
    "Symbol": "NVEI",
    " marketcap ": " $4 515 606 528 ",
    "price (USD)": "32.17",
    "country": "Canada"
  },
  {
    "Rank": "2847",
    "Name": "Vienna Airport",
    "Symbol": "FLW1.F",
    " marketcap ": " $4 508 358 206 ",
    "price (USD)": "53.426",
    "country": "Austria"
  },
  {
    "Rank": "2848",
    "Name": "Beijing Enterprises Holdings",
    "Symbol": "0392.HK",
    " marketcap ": " $4 505 563 260 ",
    "price (USD)": "3.58153",
    "country": "Hong Kong"
  },
  {
    "Rank": "2849",
    "Name": "Nuvalent",
    "Symbol": "NUVL",
    " marketcap ": " $4 501 496 832 ",
    "price (USD)": "69.73",
    "country": "United States"
  },
  {
    "Rank": "2850",
    "Name": "Flughafen Wien (Vienna Airport)",
    "Symbol": "FLU.VI",
    " marketcap ": " $4 499 305 497 ",
    "price (USD)": "53.6432",
    "country": "Austria"
  },
  {
    "Rank": "2851",
    "Name": "Taisho Pharmaceutical",
    "Symbol": "4581.T",
    " marketcap ": " $4 499 271 815 ",
    "price (USD)": "54.8909",
    "country": "Japan"
  },
  {
    "Rank": "2852",
    "Name": "FormFactor",
    "Symbol": "FORM",
    " marketcap ": " $4 498 239 488 ",
    "price (USD)": "58.29",
    "country": "United States"
  },
  {
    "Rank": "2853",
    "Name": "Freedom Holding",
    "Symbol": "FRHC",
    " marketcap ": " $4 494 724 096 ",
    "price (USD)": "75.34",
    "country": "Kazakhstan"
  },
  {
    "Rank": "2854",
    "Name": "American Equity Investment Life Holding",
    "Symbol": "AEL",
    " marketcap ": " $4 493 442 048 ",
    "price (USD)": "56.47",
    "country": "United States"
  },
  {
    "Rank": "2855",
    "Name": "Dycom Industries",
    "Symbol": "DY",
    " marketcap ": " $4 491 758 080 ",
    "price (USD)": "154.4",
    "country": "United States"
  },
  {
    "Rank": "2856",
    "Name": "Skyline Champion",
    "Symbol": "SKY",
    " marketcap ": " $4 486 291 968 ",
    "price (USD)": "77.68",
    "country": "United States"
  },
  {
    "Rank": "2857",
    "Name": "Aluminium Bahrain (Alba)",
    "Symbol": "ALBH.BH",
    " marketcap ": " $4 482 228 117 ",
    "price (USD)": "0",
    "country": "Bahrain"
  },
  {
    "Rank": "2858",
    "Name": "Saudi Industrial Investment Group",
    "Symbol": "2250.SR",
    " marketcap ": " $4 479 692 442 ",
    "price (USD)": "5.93494",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2859",
    "Name": "Ollie's Bargain Outlet",
    "Symbol": "OLLI",
    " marketcap ": " $4 469 967 360 ",
    "price (USD)": "72.93",
    "country": "United States"
  },
  {
    "Rank": "2860",
    "Name": "H.B. Fuller",
    "Symbol": "FUL",
    " marketcap ": " $4 465 984 000 ",
    "price (USD)": "81.96",
    "country": "United States"
  },
  {
    "Rank": "2861",
    "Name": "Alpha Services and Holdings",
    "Symbol": "ALPHA.AT",
    " marketcap ": " $4 465 433 658 ",
    "price (USD)": "1.90466",
    "country": "Greece"
  },
  {
    "Rank": "2862",
    "Name": "PGE Polska",
    "Symbol": "PGE.WA",
    " marketcap ": " $4 463 811 511 ",
    "price (USD)": "1.98948",
    "country": "Poland"
  },
  {
    "Rank": "2863",
    "Name": "Jollibee",
    "Symbol": "JBFCF",
    " marketcap ": " $4 460 942 848 ",
    "price (USD)": "\u043c\u0430\u0440.98",
    "country": "Philippines"
  },
  {
    "Rank": "2864",
    "Name": "MSG Sports",
    "Symbol": "MSGS",
    " marketcap ": " $4 460 402 688 ",
    "price (USD)": "186.27",
    "country": "United States"
  },
  {
    "Rank": "2865",
    "Name": "Signet Jewelers",
    "Symbol": "SIG",
    " marketcap ": " $4 460 261 376 ",
    "price (USD)": "99.88",
    "country": "Bermuda"
  },
  {
    "Rank": "2866",
    "Name": "easyJet",
    "Symbol": "EZJ.L",
    " marketcap ": " $4 457 088 656 ",
    "price (USD)": "5.91835",
    "country": "United Kingdom"
  },
  {
    "Rank": "2867",
    "Name": "Alpine Immune Sciences",
    "Symbol": "ALPN",
    " marketcap ": " $4 456 779 776 ",
    "price (USD)": "64.97",
    "country": "United States"
  },
  {
    "Rank": "2868",
    "Name": "GN Store Nord",
    "Symbol": "GN.CO",
    " marketcap ": " $4 453 579 625 ",
    "price (USD)": "30.585",
    "country": "Denmark"
  },
  {
    "Rank": "2869",
    "Name": "Select Medical Holdings",
    "Symbol": "SEM",
    " marketcap ": " $4 452 295 680 ",
    "price (USD)": "34.24",
    "country": "United States"
  },
  {
    "Rank": "2870",
    "Name": "GamaLife",
    "Symbol": "BTRVB.LS",
    " marketcap ": " $4 452 166 359 ",
    "price (USD)": "89.0433",
    "country": "Portugal"
  },
  {
    "Rank": "2871",
    "Name": "Brink's",
    "Symbol": "BCO",
    " marketcap ": " $4 451 090 944 ",
    "price (USD)": "100.11",
    "country": "United States"
  },
  {
    "Rank": "2872",
    "Name": "Nomura Real Estate Master Fund",
    "Symbol": "3462.T",
    " marketcap ": " $4 449 440 388 ",
    "price (USD)": "943.638",
    "country": "Japan"
  },
  {
    "Rank": "2873",
    "Name": "Enel Chile",
    "Symbol": "ENIC",
    " marketcap ": " $4 447 351 808 ",
    "price (USD)": "\u043c\u0430\u0440.17",
    "country": "Chile"
  },
  {
    "Rank": "2874",
    "Name": "First Financial Bankshares",
    "Symbol": "FFIN",
    " marketcap ": " $4 446 640 128 ",
    "price (USD)": "31.13",
    "country": "United States"
  },
  {
    "Rank": "2875",
    "Name": "Technip Energies",
    "Symbol": "TE.PA",
    " marketcap ": " $4 442 423 959 ",
    "price (USD)": "24.4543",
    "country": "France"
  },
  {
    "Rank": "2876",
    "Name": "Biocon",
    "Symbol": "BIOCON.NS",
    " marketcap ": " $4 441 966 410 ",
    "price (USD)": "3.71154",
    "country": "India"
  },
  {
    "Rank": "2877",
    "Name": "Soitec",
    "Symbol": "SOI.PA",
    " marketcap ": " $4 437 173 304 ",
    "price (USD)": "123.249",
    "country": "France"
  },
  {
    "Rank": "2878",
    "Name": "MBC Group Co.",
    "Symbol": "4072.SR",
    " marketcap ": " $4 436 527 753 ",
    "price (USD)": "13.3429",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2879",
    "Name": "Vienna Insurance Group",
    "Symbol": "WSV2.F",
    " marketcap ": " $4 434 264 984 ",
    "price (USD)": "34.3686",
    "country": "Austria"
  },
  {
    "Rank": "2880",
    "Name": "TOTO",
    "Symbol": "5332.T",
    " marketcap ": " $4 434 111 479 ",
    "price (USD)": "26.1404",
    "country": "Japan"
  },
  {
    "Rank": "2881",
    "Name": "Glacier Bancorp",
    "Symbol": "GBCI",
    " marketcap ": " $4 430 108 160 ",
    "price (USD)": "39.07",
    "country": "United States"
  },
  {
    "Rank": "2882",
    "Name": "Atacad\u0413\u0408o",
    "Symbol": "CRFB3.SA",
    " marketcap ": " $4 428 559 218 ",
    "price (USD)": "2.09858",
    "country": "Brazil"
  },
  {
    "Rank": "2883",
    "Name": "BGC Group",
    "Symbol": "BGC",
    " marketcap ": " $4 423 977 984 ",
    "price (USD)": "\u0430\u0432\u0433.84",
    "country": "United States"
  },
  {
    "Rank": "2884",
    "Name": "DKSH Holding",
    "Symbol": "DKSH.SW",
    " marketcap ": " $4 418 803 665 ",
    "price (USD)": "68.0339",
    "country": "Switzerland"
  },
  {
    "Rank": "2885",
    "Name": "GoTo",
    "Symbol": "GOTO.JK",
    " marketcap ": " $4 417 716 642 ",
    "price (USD)": "0.00412655",
    "country": "Indonesia"
  },
  {
    "Rank": "2886",
    "Name": "Schaeffler",
    "Symbol": "SHA.F",
    " marketcap ": " $4 411 579 976 ",
    "price (USD)": "6.58052",
    "country": "Germany"
  },
  {
    "Rank": "2887",
    "Name": "Encore Wire",
    "Symbol": "WIRE",
    " marketcap ": " $4 409 997 824 ",
    "price (USD)": "279.31",
    "country": "United States"
  },
  {
    "Rank": "2888",
    "Name": "Western Union",
    "Symbol": "WU",
    " marketcap ": " $4 407 752 704 ",
    "price (USD)": "\u0434\u0435\u043a.95",
    "country": "United States"
  },
  {
    "Rank": "2889",
    "Name": "Lynas",
    "Symbol": "LYC.AX",
    " marketcap ": " $4 406 577 873 ",
    "price (USD)": "4.71434",
    "country": "Australia"
  },
  {
    "Rank": "2890",
    "Name": "New Jersey Resources",
    "Symbol": "NJR",
    " marketcap ": " $4 404 510 208 ",
    "price (USD)": "44.57",
    "country": "United States"
  },
  {
    "Rank": "2891",
    "Name": "Italgas",
    "Symbol": "IG.MI",
    " marketcap ": " $4 403 553 602 ",
    "price (USD)": "5.40124",
    "country": "Italy"
  },
  {
    "Rank": "2892",
    "Name": "Immunovant",
    "Symbol": "IMVT",
    " marketcap ": " $4 402 377 728 ",
    "price (USD)": "30.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "2893",
    "Name": "Swissquote",
    "Symbol": "SQN.SW",
    " marketcap ": " $4 398 553 116 ",
    "price (USD)": "296.057",
    "country": "Switzerland"
  },
  {
    "Rank": "2894",
    "Name": "IAC/InterActiveCorp",
    "Symbol": "IAC",
    " marketcap ": " $4 396 830 720 ",
    "price (USD)": "51.07",
    "country": "United States"
  },
  {
    "Rank": "2895",
    "Name": "Wendel",
    "Symbol": "MF.PA",
    " marketcap ": " $4 391 986 205 ",
    "price (USD)": "98.2191",
    "country": "France"
  },
  {
    "Rank": "2896",
    "Name": "Sunway",
    "Symbol": "5211.KL",
    " marketcap ": " $4 390 479 579 ",
    "price (USD)": "0.779802",
    "country": "Malaysia"
  },
  {
    "Rank": "2897",
    "Name": "Argo Investments",
    "Symbol": "ARG.AX",
    " marketcap ": " $4 385 689 619 ",
    "price (USD)": "5.76123",
    "country": "Australia"
  },
  {
    "Rank": "2898",
    "Name": "Herc Holdings",
    "Symbol": "HRI",
    " marketcap ": " $4 378 409 472 ",
    "price (USD)": "154.34",
    "country": "United States"
  },
  {
    "Rank": "2899",
    "Name": "Power Integrations",
    "Symbol": "POWI",
    " marketcap ": " $4 377 064 448 ",
    "price (USD)": "77.11",
    "country": "United States"
  },
  {
    "Rank": "2900",
    "Name": "Copa Holdings",
    "Symbol": "CPA",
    " marketcap ": " $4 375 884 288 ",
    "price (USD)": "104.97",
    "country": "Panama"
  },
  {
    "Rank": "2901",
    "Name": "Vallourec",
    "Symbol": "VK.PA",
    " marketcap ": " $4 369 721 516 ",
    "price (USD)": "18.2322",
    "country": "France"
  },
  {
    "Rank": "2902",
    "Name": "Ormat Technologies",
    "Symbol": "ORA",
    " marketcap ": " $4 363 655 168 ",
    "price (USD)": "72.22",
    "country": "United States"
  },
  {
    "Rank": "2903",
    "Name": "Saudi Investment Bank",
    "Symbol": "1030.SR",
    " marketcap ": " $4 363 141 496 ",
    "price (USD)": "3.49051",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2904",
    "Name": "Taiwan Business Bank",
    "Symbol": "2834.TW",
    " marketcap ": " $4 360 194 842 ",
    "price (USD)": "0.530282",
    "country": "Taiwan"
  },
  {
    "Rank": "2905",
    "Name": "Coromandel",
    "Symbol": "COROMANDEL.NS",
    " marketcap ": " $4 357 015 366 ",
    "price (USD)": "14.7975",
    "country": "India"
  },
  {
    "Rank": "2906",
    "Name": "Hilton Grand Vacations",
    "Symbol": "HGV",
    " marketcap ": " $4 355 526 144 ",
    "price (USD)": "42",
    "country": "United States"
  },
  {
    "Rank": "2907",
    "Name": "National Aluminum &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2908",
    "Name": "Aker ASA",
    "Symbol": "AKER.OL",
    " marketcap ": " $4 349 208 118 ",
    "price (USD)": "58.5385",
    "country": "Norway"
  },
  {
    "Rank": "2909",
    "Name": "Grand Canyon Education",
    "Symbol": "LOPE",
    " marketcap ": " $4 347 159 040 ",
    "price (USD)": "146.18",
    "country": "United States"
  },
  {
    "Rank": "2910",
    "Name": "Qatar International Islamic Bank",
    "Symbol": "QIIK.QA",
    " marketcap ": " $4 345 620 818 ",
    "price (USD)": "2.87088",
    "country": "Qatar"
  },
  {
    "Rank": "2911",
    "Name": "GOL Airlines",
    "Symbol": "GOL",
    " marketcap ": " $4 345 520 128 ",
    "price (USD)": "2.715",
    "country": "Brazil"
  },
  {
    "Rank": "2912",
    "Name": "Plains GP",
    "Symbol": "PAGP",
    " marketcap ": " $4 343 650 304 ",
    "price (USD)": "18.67",
    "country": "United States"
  },
  {
    "Rank": "2913",
    "Name": "Sulzer",
    "Symbol": "SUN.SW",
    " marketcap ": " $4 340 918 212 ",
    "price (USD)": "128.387",
    "country": "Switzerland"
  },
  {
    "Rank": "2914",
    "Name": "Huntsman Corporation",
    "Symbol": "HUN",
    " marketcap ": " $4 340 469 760 ",
    "price (USD)": "25.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "2915",
    "Name": "LIC Housing Finance",
    "Symbol": "LICHSGFIN.NS",
    " marketcap ": " $4 339 924 444 ",
    "price (USD)": "7.88987",
    "country": "India"
  },
  {
    "Rank": "2916",
    "Name": "Universal Robina Corporation",
    "Symbol": "UVRBF",
    " marketcap ": " $4 339 279 872 ",
    "price (USD)": "2",
    "country": "Philippines"
  },
  {
    "Rank": "2917",
    "Name": "Kingsoft",
    "Symbol": "3888.HK",
    " marketcap ": " $4 336 139 601 ",
    "price (USD)": "3.27399",
    "country": "China"
  },
  {
    "Rank": "2918",
    "Name": "Braze",
    "Symbol": "BRZE",
    " marketcap ": " $4 334 768 128 ",
    "price (USD)": "42.91",
    "country": "United States"
  },
  {
    "Rank": "2919",
    "Name": "Phillips Edison &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2920",
    "Name": "BSE",
    "Symbol": "BSE.NS",
    " marketcap ": " $4 330 399 215 ",
    "price (USD)": "31.9674",
    "country": "India"
  },
  {
    "Rank": "2921",
    "Name": "Krones",
    "Symbol": "KRN.F",
    " marketcap ": " $4 329 547 669 ",
    "price (USD)": "136.171",
    "country": "Germany"
  },
  {
    "Rank": "2922",
    "Name": "Discovery Limited",
    "Symbol": "DSY.JO",
    " marketcap ": " $4 329 089 700 ",
    "price (USD)": "6.53674",
    "country": "South Africa"
  },
  {
    "Rank": "2923",
    "Name": "National Beverage",
    "Symbol": "FIZZ",
    " marketcap ": " $4 324 413 952 ",
    "price (USD)": "46.23",
    "country": "United States"
  },
  {
    "Rank": "2924",
    "Name": "TIS",
    "Symbol": "3626.T",
    " marketcap ": " $4 323 121 644 ",
    "price (USD)": "18.4505",
    "country": "Japan"
  },
  {
    "Rank": "2925",
    "Name": "Shurgard Self Storage",
    "Symbol": "SHUR.BR",
    " marketcap ": " $4 318 096 471 ",
    "price (USD)": "44.3588",
    "country": "Luxembourg"
  },
  {
    "Rank": "2926",
    "Name": "Softcat",
    "Symbol": "SCT.L",
    " marketcap ": " $4 314 622 444 ",
    "price (USD)": "21.6001",
    "country": "United Kingdom"
  },
  {
    "Rank": "2927",
    "Name": "Contact Energy",
    "Symbol": "CEN.NZ",
    " marketcap ": " $4 312 537 542 ",
    "price (USD)": "5.46502",
    "country": "New Zealand"
  },
  {
    "Rank": "2928",
    "Name": "C&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "2929",
    "Name": "Merdeka Copper Gold",
    "Symbol": "MDKA.JK",
    " marketcap ": " $4 303 312 372 ",
    "price (USD)": "0.176316",
    "country": "Indonesia"
  },
  {
    "Rank": "2930",
    "Name": "RadNet",
    "Symbol": "RDNT",
    " marketcap ": " $4 302 038 016 ",
    "price (USD)": "58.23",
    "country": "United States"
  },
  {
    "Rank": "2931",
    "Name": "Shin Kong Financial Holding",
    "Symbol": "2888.TW",
    " marketcap ": " $4 298 508 554 ",
    "price (USD)": "0.277545",
    "country": "Taiwan"
  },
  {
    "Rank": "2932",
    "Name": "Bank AlJazira",
    "Symbol": "1020.SR",
    " marketcap ": " $4 294 425 311 ",
    "price (USD)": "4.18968",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2933",
    "Name": "Doosan Bobcat",
    "Symbol": "241560.KS",
    " marketcap ": " $4 288 089 400 ",
    "price (USD)": "42.8154",
    "country": "South Korea"
  },
  {
    "Rank": "2934",
    "Name": "Boral",
    "Symbol": "BLD.AX",
    " marketcap ": " $4 287 854 902 ",
    "price (USD)": "3.93417",
    "country": "Australia"
  },
  {
    "Rank": "2935",
    "Name": "Nippon Express",
    "Symbol": "9147.T",
    " marketcap ": " $4 287 149 587 ",
    "price (USD)": "48.8708",
    "country": "Japan"
  },
  {
    "Rank": "2936",
    "Name": "Huhtam\u0413\u00a4ki",
    "Symbol": "HUH1V.HE",
    " marketcap ": " $4 277 351 912 ",
    "price (USD)": "40.8296",
    "country": "Finland"
  },
  {
    "Rank": "2937",
    "Name": "Halkbank",
    "Symbol": "HALKB.IS",
    " marketcap ": " $4 271 619 669 ",
    "price (USD)": "0.594537",
    "country": "Turkey"
  },
  {
    "Rank": "2938",
    "Name": "Fortis Healthcare",
    "Symbol": "FORTIS.NS",
    " marketcap ": " $4 270 694 970 ",
    "price (USD)": "5.65442",
    "country": "India"
  },
  {
    "Rank": "2939",
    "Name": "Koito Manufacturing",
    "Symbol": "7276.T",
    " marketcap ": " $4 261 414 411 ",
    "price (USD)": "13.9051",
    "country": "Japan"
  },
  {
    "Rank": "2940",
    "Name": "StepStone Group",
    "Symbol": "STEP",
    " marketcap ": " $4 260 077 056 ",
    "price (USD)": "37.19",
    "country": "United States"
  },
  {
    "Rank": "2941",
    "Name": "Inchcape",
    "Symbol": "INCH.L",
    " marketcap ": " $4 258 428 203 ",
    "price (USD)": "10.336",
    "country": "United Kingdom"
  },
  {
    "Rank": "2942",
    "Name": "Compagnie du Cambodge",
    "Symbol": "CBDG.PA",
    " marketcap ": " $4 254 691 089 ",
    "price (USD)": "7601.26",
    "country": "France"
  },
  {
    "Rank": "2943",
    "Name": "Qube Holdings",
    "Symbol": "QUB.AX",
    " marketcap ": " $4 252 789 075 ",
    "price (USD)": "2.40718",
    "country": "Australia"
  },
  {
    "Rank": "2944",
    "Name": "Bucher Industries",
    "Symbol": "BUCN.SW",
    " marketcap ": " $4 252 751 577 ",
    "price (USD)": "415.336",
    "country": "Switzerland"
  },
  {
    "Rank": "2945",
    "Name": "Jarir",
    "Symbol": "4190.SR",
    " marketcap ": " $4 246 257 442 ",
    "price (USD)": "3.53855",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2946",
    "Name": "Johnson Matthey",
    "Symbol": "JMAT.L",
    " marketcap ": " $4 244 815 683 ",
    "price (USD)": "23.1384",
    "country": "United Kingdom"
  },
  {
    "Rank": "2947",
    "Name": "Wallenius Wilhelmsen",
    "Symbol": "WAWI.OL",
    " marketcap ": " $4 239 041 032 ",
    "price (USD)": "10.0285",
    "country": "Norway"
  },
  {
    "Rank": "2948",
    "Name": "United Internet",
    "Symbol": "UTDI.F",
    " marketcap ": " $4 233 607 297 ",
    "price (USD)": "24.4978",
    "country": "Germany"
  },
  {
    "Rank": "2949",
    "Name": "3M India",
    "Symbol": "3MINDIA.NS",
    " marketcap ": " $4 231 014 455 ",
    "price (USD)": "375.586",
    "country": "India"
  },
  {
    "Rank": "2950",
    "Name": "Group 1 Automotive",
    "Symbol": "GPI",
    " marketcap ": " $4 222 795 520 ",
    "price (USD)": "312.03",
    "country": "United States"
  },
  {
    "Rank": "2951",
    "Name": "COSCO SHIPPING Development",
    "Symbol": "601866.SS",
    " marketcap ": " $4 221 576 605 ",
    "price (USD)": "0.377108",
    "country": "China"
  },
  {
    "Rank": "2952",
    "Name": "Shake Shack",
    "Symbol": "SHAK",
    " marketcap ": " $4 216 934 912 ",
    "price (USD)": "99.37",
    "country": "United States"
  },
  {
    "Rank": "2953",
    "Name": "Advance Auto Parts",
    "Symbol": "AAP",
    " marketcap ": " $4 215 584 000 ",
    "price (USD)": "70.72",
    "country": "United States"
  },
  {
    "Rank": "2954",
    "Name": "Stericycle",
    "Symbol": "SRCL",
    " marketcap ": " $4 212 452 608 ",
    "price (USD)": "45.4",
    "country": "United States"
  },
  {
    "Rank": "2955",
    "Name": "Columbia Banking System",
    "Symbol": "COLB",
    " marketcap ": " $4 210 591 744 ",
    "price (USD)": "20.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "2956",
    "Name": "Synnex Technology International",
    "Symbol": "2347.TW",
    " marketcap ": " $4 205 176 614 ",
    "price (USD)": "2.52116",
    "country": "Taiwan"
  },
  {
    "Rank": "2957",
    "Name": "China Taiping Insurance",
    "Symbol": "0966.HK",
    " marketcap ": " $4 204 728 151 ",
    "price (USD)": "1.16992",
    "country": "Hong Kong"
  },
  {
    "Rank": "2958",
    "Name": "Hong Leong Financial Group",
    "Symbol": "1082.KL",
    " marketcap ": " $4 204 397 169 ",
    "price (USD)": "3.70725",
    "country": "Malaysia"
  },
  {
    "Rank": "2959",
    "Name": "Tohoku Electric Power",
    "Symbol": "9506.T",
    " marketcap ": " $4 203 951 023 ",
    "price (USD)": "8.40637",
    "country": "Japan"
  },
  {
    "Rank": "2960",
    "Name": "Concentrix",
    "Symbol": "CNXC",
    " marketcap ": " $4 203 024 128 ",
    "price (USD)": "63.69",
    "country": "United States"
  },
  {
    "Rank": "2961",
    "Name": "Main Street Capital",
    "Symbol": "MAIN",
    " marketcap ": " $4 200 064 512 ",
    "price (USD)": "49",
    "country": "United States"
  },
  {
    "Rank": "2962",
    "Name": "CleanSpark",
    "Symbol": "CLSK",
    " marketcap ": " $4 197 365 504 ",
    "price (USD)": "18.42",
    "country": "United States"
  },
  {
    "Rank": "2963",
    "Name": "MARAFIQ (The Power and Water Utility Company for Jubail and Yanbu)",
    "Symbol": "2083.SR",
    " marketcap ": " $4 196 354 897 ",
    "price (USD)": "16.7854",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2964",
    "Name": "Arcosa",
    "Symbol": "ACA",
    " marketcap ": " $4 191 697 920 ",
    "price (USD)": "86.28",
    "country": "United States"
  },
  {
    "Rank": "2965",
    "Name": "HEXPOL AB",
    "Symbol": "HPOL-B.ST",
    " marketcap ": " $4 191 231 152 ",
    "price (USD)": "12.1684",
    "country": "Sweden"
  },
  {
    "Rank": "2966",
    "Name": "Fielmann",
    "Symbol": "FIE.F",
    " marketcap ": " $4 186 704 172 ",
    "price (USD)": "49.8425",
    "country": "Germany"
  },
  {
    "Rank": "2967",
    "Name": "International Game Technology",
    "Symbol": "IGT",
    " marketcap ": " $4 185 921 792 ",
    "price (USD)": "20.76",
    "country": "United Kingdom"
  },
  {
    "Rank": "2968",
    "Name": "Royal Unibrew",
    "Symbol": "RBREW.CO",
    " marketcap ": " $4 184 046 859 ",
    "price (USD)": "83.5923",
    "country": "Denmark"
  },
  {
    "Rank": "2969",
    "Name": "China Airlines",
    "Symbol": "2610.TW",
    " marketcap ": " $4 183 433 152 ",
    "price (USD)": "0.691537",
    "country": "Taiwan"
  },
  {
    "Rank": "2970",
    "Name": "Terex",
    "Symbol": "TEX",
    " marketcap ": " $4 182 695 168 ",
    "price (USD)": "62.15",
    "country": "United States"
  },
  {
    "Rank": "2971",
    "Name": "Zhejiang Century Huatong",
    "Symbol": "002602.SZ",
    " marketcap ": " $4 179 602 125 ",
    "price (USD)": "0.560828",
    "country": "China"
  },
  {
    "Rank": "2972",
    "Name": "UMB Financial",
    "Symbol": "UMBF",
    " marketcap ": " $4 172 520 448 ",
    "price (USD)": "85.6",
    "country": "United States"
  },
  {
    "Rank": "2973",
    "Name": "Dalmia Bharat",
    "Symbol": "DALBHARAT.NS",
    " marketcap ": " $4 165 824 925 ",
    "price (USD)": "22.2055",
    "country": "India"
  },
  {
    "Rank": "2974",
    "Name": "JB Hi-Fi",
    "Symbol": "JBH.AX",
    " marketcap ": " $4 165 056 225 ",
    "price (USD)": "38.0948",
    "country": "Australia"
  },
  {
    "Rank": "2975",
    "Name": "Avient",
    "Symbol": "AVNT",
    " marketcap ": " $4 160 328 960 ",
    "price (USD)": "45.59",
    "country": "United States"
  },
  {
    "Rank": "2976",
    "Name": "Bendigo and Adelaide Bank",
    "Symbol": "BEN.AX",
    " marketcap ": " $4 160 327 750 ",
    "price (USD)": "7.34823",
    "country": "Australia"
  },
  {
    "Rank": "2977",
    "Name": "Knife River Corporation",
    "Symbol": "KNF",
    " marketcap ": " $4 160 246 784 ",
    "price (USD)": "73.49",
    "country": "United States"
  },
  {
    "Rank": "2978",
    "Name": "Indoritel",
    "Symbol": "DNET.JK",
    " marketcap ": " $4 159 244 559 ",
    "price (USD)": "0.293235",
    "country": "Indonesia"
  },
  {
    "Rank": "2979",
    "Name": "Spectris",
    "Symbol": "SXS.L",
    " marketcap ": " $4 157 398 406 ",
    "price (USD)": "41.3186",
    "country": "United Kingdom"
  },
  {
    "Rank": "2980",
    "Name": "Gujarat Fluorochemicals",
    "Symbol": "FLUOROCHEM.NS",
    " marketcap ": " $4 154 731 515 ",
    "price (USD)": "37.8219",
    "country": "India"
  },
  {
    "Rank": "2981",
    "Name": "QNB Finans Finansal Kiralama (QNB Finansleasing)",
    "Symbol": "QNBFL.IS",
    " marketcap ": " $4 149 957 600 ",
    "price (USD)": "4.14996",
    "country": "Turkey"
  },
  {
    "Rank": "2982",
    "Name": "PCCW",
    "Symbol": "0008.HK",
    " marketcap ": " $4 145 564 197 ",
    "price (USD)": "0.535628",
    "country": "Hong Kong"
  },
  {
    "Rank": "2983",
    "Name": "Siegfried Holding",
    "Symbol": "SFZN.SW",
    " marketcap ": " $4 141 980 332 ",
    "price (USD)": "965.643",
    "country": "Switzerland"
  },
  {
    "Rank": "2984",
    "Name": "PJT Partners",
    "Symbol": "PJT",
    " marketcap ": " $4 141 084 928 ",
    "price (USD)": "104.49",
    "country": "United States"
  },
  {
    "Rank": "2985",
    "Name": "Northern Oil and Gas",
    "Symbol": "NOG",
    " marketcap ": " $4 139 212 800 ",
    "price (USD)": "40.96",
    "country": "United States"
  },
  {
    "Rank": "2986",
    "Name": "Chemours",
    "Symbol": "CC",
    " marketcap ": " $4 137 792 512 ",
    "price (USD)": "27.79",
    "country": "United States"
  },
  {
    "Rank": "2987",
    "Name": "Kintetsu GHD",
    "Symbol": "9041.T",
    " marketcap ": " $4 136 597 909 ",
    "price (USD)": "21.7516",
    "country": "Japan"
  },
  {
    "Rank": "2988",
    "Name": "Enerplus",
    "Symbol": "ERF",
    " marketcap ": " $4 135 980 544 ",
    "price (USD)": "20.22",
    "country": "Canada"
  },
  {
    "Rank": "2989",
    "Name": "Mainfreight",
    "Symbol": "MFT.NZ",
    " marketcap ": " $4 135 432 971 ",
    "price (USD)": "41.0673",
    "country": "New Zealand"
  },
  {
    "Rank": "2990",
    "Name": "Virtu Financial",
    "Symbol": "VIRT",
    " marketcap ": " $4 133 978 751 ",
    "price (USD)": "22.69",
    "country": "United States"
  },
  {
    "Rank": "2991",
    "Name": "Cleanaway Waste Management",
    "Symbol": "CWY.AX",
    " marketcap ": " $4 132 665 998 ",
    "price (USD)": "1.85373",
    "country": "Australia"
  },
  {
    "Rank": "2992",
    "Name": "Riyadh Cables Group Company",
    "Symbol": "4142.SR",
    " marketcap ": " $4 131 198 787 ",
    "price (USD)": "27.5932",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "2993",
    "Name": "Blackbaud",
    "Symbol": "BLKB",
    " marketcap ": " $4 125 957 888 ",
    "price (USD)": "79.92",
    "country": "United States"
  },
  {
    "Rank": "2994",
    "Name": "Steadfast Group",
    "Symbol": "SDF.AX",
    " marketcap ": " $4 123 654 241 ",
    "price (USD)": "3.72746",
    "country": "Australia"
  },
  {
    "Rank": "2995",
    "Name": "Ebos Group",
    "Symbol": "EBO.NZ",
    " marketcap ": " $4 119 989 844 ",
    "price (USD)": "21.3209",
    "country": "New Zealand"
  },
  {
    "Rank": "2996",
    "Name": "Alkermes",
    "Symbol": "ALKS",
    " marketcap ": " $4 118 839 040 ",
    "price (USD)": "24.34",
    "country": "Ireland"
  },
  {
    "Rank": "2997",
    "Name": "Mirati Therapeutics",
    "Symbol": "MRTX",
    " marketcap ": " $4 117 669 888 ",
    "price (USD)": "58.7",
    "country": "United States"
  },
  {
    "Rank": "2998",
    "Name": "Deepak Nitrite",
    "Symbol": "DEEPAKNTR.NS",
    " marketcap ": " $4 114 225 372 ",
    "price (USD)": "30.1645",
    "country": "India"
  },
  {
    "Rank": "2999",
    "Name": "PagSeguro",
    "Symbol": "PAGS",
    " marketcap ": " $4 112 614 400 ",
    "price (USD)": "13.\u0444\u0435\u0432",
    "country": "Brazil"
  },
  {
    "Rank": "3000",
    "Name": "Assured Guaranty",
    "Symbol": "AGO",
    " marketcap ": " $4 110 438 912 ",
    "price (USD)": "75.5",
    "country": "Bermuda"
  },
  {
    "Rank": "3001",
    "Name": "Millicom",
    "Symbol": "TIGO",
    " marketcap ": " $4 108 493 312 ",
    "price (USD)": "23.98",
    "country": "Luxembourg"
  },
  {
    "Rank": "3002",
    "Name": "AIA Engineering",
    "Symbol": "AIAENG.NS",
    " marketcap ": " $4 108 349 519 ",
    "price (USD)": "43.5574",
    "country": "India"
  },
  {
    "Rank": "3003",
    "Name": "Makkah Construction &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3004",
    "Name": "Games Workshop Group",
    "Symbol": "GAW.L",
    " marketcap ": " $4 107 611 569 ",
    "price (USD)": "124.655",
    "country": "United Kingdom"
  },
  {
    "Rank": "3005",
    "Name": "Freshworks",
    "Symbol": "FRSH",
    " marketcap ": " $4 105 786 624 ",
    "price (USD)": "13.74",
    "country": "United States"
  },
  {
    "Rank": "3006",
    "Name": "Bellway",
    "Symbol": "BWY.L",
    " marketcap ": " $4 102 047 767 ",
    "price (USD)": "34.4788",
    "country": "United Kingdom"
  },
  {
    "Rank": "3007",
    "Name": "Capri Holdings",
    "Symbol": "CPRI",
    " marketcap ": " $4 097 330 176 ",
    "price (USD)": "35.15",
    "country": "United Kingdom"
  },
  {
    "Rank": "3008",
    "Name": "Hancock Whitney",
    "Symbol": "HWC",
    " marketcap ": " $4 095 880 704 ",
    "price (USD)": "47.28",
    "country": "United States"
  },
  {
    "Rank": "3009",
    "Name": "Sime Darby",
    "Symbol": "4197.KL",
    " marketcap ": " $4 095 023 453 ",
    "price (USD)": "0.600831",
    "country": "Malaysia"
  },
  {
    "Rank": "3010",
    "Name": "PACS Group",
    "Symbol": "PACS",
    " marketcap ": " $4 094 789 376 ",
    "price (USD)": "27.71",
    "country": "United States"
  },
  {
    "Rank": "3011",
    "Name": "Clicks Group",
    "Symbol": "CLS.JO",
    " marketcap ": " $4 094 139 700 ",
    "price (USD)": "16.8162",
    "country": "South Africa"
  },
  {
    "Rank": "3012",
    "Name": "Euronav",
    "Symbol": "EURN",
    " marketcap ": " $4 094 094 080 ",
    "price (USD)": "21.\u0430\u0432\u0433",
    "country": "Belgium"
  },
  {
    "Rank": "3013",
    "Name": "Silicon Labs",
    "Symbol": "SLAB",
    " marketcap ": " $4 093 985 280 ",
    "price (USD)": "128.24",
    "country": "United States"
  },
  {
    "Rank": "3014",
    "Name": "Mitsubishi Motors",
    "Symbol": "7211.T",
    " marketcap ": " $4 091 081 603 ",
    "price (USD)": "2.75158",
    "country": "Japan"
  },
  {
    "Rank": "3015",
    "Name": "Tower Semiconductor",
    "Symbol": "TSEM",
    " marketcap ": " $4 086 057 472 ",
    "price (USD)": "36.81",
    "country": "Israel"
  },
  {
    "Rank": "3016",
    "Name": "Kontoor Brands",
    "Symbol": "KTB",
    " marketcap ": " $4 085 059 072 ",
    "price (USD)": "73.17",
    "country": "United States"
  },
  {
    "Rank": "3017",
    "Name": "Ryohin Keikaku",
    "Symbol": "7453.T",
    " marketcap ": " $4 075 699 866 ",
    "price (USD)": "15.4021",
    "country": "Japan"
  },
  {
    "Rank": "3018",
    "Name": "Moelis &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3019",
    "Name": "Munters Group AB",
    "Symbol": "MTRS.ST",
    " marketcap ": " $4 069 786 397 ",
    "price (USD)": "22.2962",
    "country": "Sweden"
  },
  {
    "Rank": "3020",
    "Name": "Charter Hall Group",
    "Symbol": "CHC.AX",
    " marketcap ": " $4 068 642 100 ",
    "price (USD)": "8.60184",
    "country": "Australia"
  },
  {
    "Rank": "3021",
    "Name": "GLP J-REIT",
    "Symbol": "3281.T",
    " marketcap ": " $4 067 080 526 ",
    "price (USD)": "830.401",
    "country": "Japan"
  },
  {
    "Rank": "3022",
    "Name": "Integer Holdings",
    "Symbol": "ITGR",
    " marketcap ": " $4 064 333 824 ",
    "price (USD)": "121.31",
    "country": "United States"
  },
  {
    "Rank": "3023",
    "Name": "Shimizu Corporation",
    "Symbol": "1803.T",
    " marketcap ": " $4 060 012 901 ",
    "price (USD)": "5.72196",
    "country": "Japan"
  },
  {
    "Rank": "3024",
    "Name": "Avis Budget Group",
    "Symbol": "CAR",
    " marketcap ": " $4 058 433 792 ",
    "price (USD)": "113.85",
    "country": "United States"
  },
  {
    "Rank": "3025",
    "Name": "Str\u0413\u00b6er",
    "Symbol": "SAX.F",
    " marketcap ": " $4 052 906 713 ",
    "price (USD)": "72.7006",
    "country": "Germany"
  },
  {
    "Rank": "3026",
    "Name": "Max Financial Services",
    "Symbol": "MFSL.NS",
    " marketcap ": " $4 051 214 286 ",
    "price (USD)": "\u043d\u043e\u044f.73",
    "country": "India"
  },
  {
    "Rank": "3027",
    "Name": "Perrigo",
    "Symbol": "PRGO",
    " marketcap ": " $4 050 067 200 ",
    "price (USD)": "29.71",
    "country": "Ireland"
  },
  {
    "Rank": "3028",
    "Name": "Kilroy Realty",
    "Symbol": "KRC",
    " marketcap ": " $4 042 683 136 ",
    "price (USD)": "34.11",
    "country": "United States"
  },
  {
    "Rank": "3029",
    "Name": "Nissan Chemical",
    "Symbol": "4021.T",
    " marketcap ": " $4 041 955 387 ",
    "price (USD)": "29.16",
    "country": "Japan"
  },
  {
    "Rank": "3030",
    "Name": "Wienerberger",
    "Symbol": "WIB.F",
    " marketcap ": " $4 039 931 302 ",
    "price (USD)": "38.3321",
    "country": "Austria"
  },
  {
    "Rank": "3031",
    "Name": "Qatar Fuel Company (WOQOD)",
    "Symbol": "QFLS.QA",
    " marketcap ": " $4 031 653 415 ",
    "price (USD)": "4.05495",
    "country": "Qatar"
  },
  {
    "Rank": "3032",
    "Name": "Computacenter",
    "Symbol": "CCC.L",
    " marketcap ": " $4 031 220 677 ",
    "price (USD)": "35.3179",
    "country": "United Kingdom"
  },
  {
    "Rank": "3033",
    "Name": "Advanced Energy",
    "Symbol": "AEIS",
    " marketcap ": " $4 029 957 632 ",
    "price (USD)": "107.63",
    "country": "United States"
  },
  {
    "Rank": "3034",
    "Name": "Sterling Construction",
    "Symbol": "STRL",
    " marketcap ": " $4 029 538 560 ",
    "price (USD)": "130.56",
    "country": "United States"
  },
  {
    "Rank": "3035",
    "Name": "Ipca Laboratories",
    "Symbol": "IPCALAB.NS",
    " marketcap ": " $4 026 397 034 ",
    "price (USD)": "15.8705",
    "country": "India"
  },
  {
    "Rank": "3036",
    "Name": "Greencoat UK Wind",
    "Symbol": "UKW.L",
    " marketcap ": " $4 024 987 396 ",
    "price (USD)": "1.75801",
    "country": "United Kingdom"
  },
  {
    "Rank": "3037",
    "Name": "Clarivate",
    "Symbol": "CLVT",
    " marketcap ": " $4 022 792 960 ",
    "price (USD)": "06.\u0444\u0435\u0432",
    "country": "United Kingdom"
  },
  {
    "Rank": "3038",
    "Name": "Sibanye-Stillwater",
    "Symbol": "SBSW",
    " marketcap ": " $4 018 067 712 ",
    "price (USD)": "\u043c\u0430\u0439.66",
    "country": "South Africa"
  },
  {
    "Rank": "3039",
    "Name": "Hankook Tire",
    "Symbol": "161390.KS",
    " marketcap ": " $4 018 041 775 ",
    "price (USD)": "32.9377",
    "country": "South Korea"
  },
  {
    "Rank": "3040",
    "Name": "NLC India",
    "Symbol": "NLCINDIA.NS",
    " marketcap ": " $4 012 787 370 ",
    "price (USD)": "2.89389",
    "country": "India"
  },
  {
    "Rank": "3041",
    "Name": "Liberty Energy",
    "Symbol": "LBRT",
    " marketcap ": " $4 009 647 104 ",
    "price (USD)": "24.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "3042",
    "Name": "AntarChile",
    "Symbol": "ANTARCHILE.SN",
    " marketcap ": " $4 001 544 616 ",
    "price (USD)": "8.81194",
    "country": "Chile"
  },
  {
    "Rank": "3043",
    "Name": "Sanwa Holdings",
    "Symbol": "5929.T",
    " marketcap ": " $3 998 522 431 ",
    "price (USD)": "18.2682",
    "country": "Japan"
  },
  {
    "Rank": "3044",
    "Name": "Zeta Global",
    "Symbol": "ZETA",
    " marketcap ": " $3 990 729 472 ",
    "price (USD)": "18.24",
    "country": "United States"
  },
  {
    "Rank": "3045",
    "Name": "Rohto Pharmaceutical",
    "Symbol": "4527.T",
    " marketcap ": " $3 988 893 490 ",
    "price (USD)": "17.4845",
    "country": "Japan"
  },
  {
    "Rank": "3046",
    "Name": "IPG Photonics",
    "Symbol": "IPGP",
    " marketcap ": " $3 985 850 624 ",
    "price (USD)": "87.47",
    "country": "United States"
  },
  {
    "Rank": "3047",
    "Name": "Acushnet Holdings",
    "Symbol": "GOLF",
    " marketcap ": " $3 984 737 280 ",
    "price (USD)": "63.18",
    "country": "United States"
  },
  {
    "Rank": "3048",
    "Name": "First International Bank of Israel",
    "Symbol": "FIBI.TA",
    " marketcap ": " $3 983 433 717 ",
    "price (USD)": "39.7033",
    "country": "Israel"
  },
  {
    "Rank": "3049",
    "Name": "Al Rajhi Company for Cooperative Insurance",
    "Symbol": "8230.SR",
    " marketcap ": " $3 976 196 126 ",
    "price (USD)": "39.762",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3050",
    "Name": "Remgro Limited",
    "Symbol": "REM.JO",
    " marketcap ": " $3 971 645 300 ",
    "price (USD)": "7.09024",
    "country": "South Africa"
  },
  {
    "Rank": "3051",
    "Name": "Jumbo S.A.",
    "Symbol": "5JB.F",
    " marketcap ": " $3 968 191 534 ",
    "price (USD)": "29.0151",
    "country": "Greece"
  },
  {
    "Rank": "3052",
    "Name": "Matson",
    "Symbol": "MATX",
    " marketcap ": " $3 961 119 488 ",
    "price (USD)": "115.93",
    "country": "United States"
  },
  {
    "Rank": "3053",
    "Name": "ITV plc",
    "Symbol": "ITV.L",
    " marketcap ": " $3 960 751 597 ",
    "price (USD)": "0.995461",
    "country": "United Kingdom"
  },
  {
    "Rank": "3054",
    "Name": "IONOS Group",
    "Symbol": "IOS.DE",
    " marketcap ": " $3 960 256 063 ",
    "price (USD)": "28.2875",
    "country": "Germany"
  },
  {
    "Rank": "3055",
    "Name": "International Distributions Services (Royal Mail)",
    "Symbol": "IDS.L",
    " marketcap ": " $3 959 540 221 ",
    "price (USD)": "4.13186",
    "country": "United Kingdom"
  },
  {
    "Rank": "3056",
    "Name": "Alpha Metallurgical Resources",
    "Symbol": "AMR",
    " marketcap ": " $3 955 099 392 ",
    "price (USD)": "304.07",
    "country": "United States"
  },
  {
    "Rank": "3057",
    "Name": "Netmarble",
    "Symbol": "251270.KS",
    " marketcap ": " $3 953 338 802 ",
    "price (USD)": "48.2499",
    "country": "South Korea"
  },
  {
    "Rank": "3058",
    "Name": "Yuhan",
    "Symbol": "000100.KS",
    " marketcap ": " $3 952 691 171 ",
    "price (USD)": "53.5376",
    "country": "South Korea"
  },
  {
    "Rank": "3059",
    "Name": "Telecom Argentina",
    "Symbol": "TEO",
    " marketcap ": " $3 949 867 264 ",
    "price (USD)": "\u0441\u0435\u043d.17",
    "country": "Argentina"
  },
  {
    "Rank": "3060",
    "Name": "Academy Sports",
    "Symbol": "ASO",
    " marketcap ": " $3 944 866 816 ",
    "price (USD)": "53.46",
    "country": "United States"
  },
  {
    "Rank": "3061",
    "Name": "Valley Bank",
    "Symbol": "VLY",
    " marketcap ": " $3 941 076 480 ",
    "price (USD)": "\u0438\u044e\u043b.74",
    "country": "United States"
  },
  {
    "Rank": "3062",
    "Name": "Enag\u0413\u040es",
    "Symbol": "ENG.MC",
    " marketcap ": " $3 940 084 074 ",
    "price (USD)": "15.1048",
    "country": "Spain"
  },
  {
    "Rank": "3063",
    "Name": "Innolux",
    "Symbol": "3481.TW",
    " marketcap ": " $3 939 471 510 ",
    "price (USD)": "0.434149",
    "country": "Taiwan"
  },
  {
    "Rank": "3064",
    "Name": "CBIZ",
    "Symbol": "CBZ",
    " marketcap ": " $3 936 806 400 ",
    "price (USD)": "78.56",
    "country": "United States"
  },
  {
    "Rank": "3065",
    "Name": "City Developments",
    "Symbol": "C09.SI",
    " marketcap ": " $3 934 659 656 ",
    "price (USD)": "4.34315",
    "country": "Singapore"
  },
  {
    "Rank": "3066",
    "Name": "Independence Realty Trust",
    "Symbol": "IRT",
    " marketcap ": " $3 934 304 768 ",
    "price (USD)": "17.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "3067",
    "Name": "Nelnet",
    "Symbol": "NNI",
    " marketcap ": " $3 928 727 040 ",
    "price (USD)": "108.03",
    "country": "United States"
  },
  {
    "Rank": "3068",
    "Name": "Tikehau Capital",
    "Symbol": "TKO.PA",
    " marketcap ": " $3 923 952 933 ",
    "price (USD)": "22.6952",
    "country": "France"
  },
  {
    "Rank": "3069",
    "Name": "Porto Seguro",
    "Symbol": "PSSA3.SA",
    " marketcap ": " $3 916 345 322 ",
    "price (USD)": "6.10249",
    "country": "Brazil"
  },
  {
    "Rank": "3070",
    "Name": "EnerSys",
    "Symbol": "ENS",
    " marketcap ": " $3 915 098 112 ",
    "price (USD)": "96.87",
    "country": "United States"
  },
  {
    "Rank": "3071",
    "Name": "AllianceBernstein",
    "Symbol": "AB",
    " marketcap ": " $3 912 121 344 ",
    "price (USD)": "33.97",
    "country": "United States"
  },
  {
    "Rank": "3072",
    "Name": "Black Hills",
    "Symbol": "BKH",
    " marketcap ": " $3 911 964 672 ",
    "price (USD)": "56.75",
    "country": "United States"
  },
  {
    "Rank": "3073",
    "Name": "Burjeel Holdings",
    "Symbol": "BURJEEL.AE",
    " marketcap ": " $3 911 610 075 ",
    "price (USD)": "0.75",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3074",
    "Name": "Insperity",
    "Symbol": "NSP",
    " marketcap ": " $3 903 745 536 ",
    "price (USD)": "103.67",
    "country": "United States"
  },
  {
    "Rank": "3075",
    "Name": "Crinetics Pharmaceuticals",
    "Symbol": "CRNX",
    " marketcap ": " $3 903 545 344 ",
    "price (USD)": "49.5",
    "country": "United States"
  },
  {
    "Rank": "3076",
    "Name": "ERG",
    "Symbol": "ERG.MI",
    " marketcap ": " $3 897 329 656 ",
    "price (USD)": "26.6696",
    "country": "Italy"
  },
  {
    "Rank": "3077",
    "Name": "Alvotech",
    "Symbol": "ALVO",
    " marketcap ": " $3 897 164 032 ",
    "price (USD)": "13.94",
    "country": "Iceland"
  },
  {
    "Rank": "3078",
    "Name": "Pepkor",
    "Symbol": "PPH.JO",
    " marketcap ": " $3 896 359 300 ",
    "price (USD)": "1.05717",
    "country": "South Africa"
  },
  {
    "Rank": "3079",
    "Name": "Kemper",
    "Symbol": "KMPR",
    " marketcap ": " $3 894 067 968 ",
    "price (USD)": "60.49",
    "country": "United States"
  },
  {
    "Rank": "3080",
    "Name": "EFG International",
    "Symbol": "EFGN.SW",
    " marketcap ": " $3 892 385 739 ",
    "price (USD)": "\u0434\u0435\u043a.64",
    "country": "Switzerland"
  },
  {
    "Rank": "3081",
    "Name": "Genting Berhad",
    "Symbol": "3182.KL",
    " marketcap ": " $3 888 728 524 ",
    "price (USD)": "1.00991",
    "country": "Malaysia"
  },
  {
    "Rank": "3082",
    "Name": "Acom",
    "Symbol": "8572.T",
    " marketcap ": " $3 885 706 258 ",
    "price (USD)": "2.48033",
    "country": "Japan"
  },
  {
    "Rank": "3083",
    "Name": "ACEA",
    "Symbol": "ACE.MI",
    " marketcap ": " $3 884 384 824 ",
    "price (USD)": "18.1887",
    "country": "Italy"
  },
  {
    "Rank": "3084",
    "Name": "CRISIL",
    "Symbol": "CRISIL.NS",
    " marketcap ": " $3 881 772 455 ",
    "price (USD)": "53.0849",
    "country": "India"
  },
  {
    "Rank": "3085",
    "Name": "Curaleaf",
    "Symbol": "CURLF",
    " marketcap ": " $3 881 327 616 ",
    "price (USD)": "\u043c\u0430\u0439.26",
    "country": "United States"
  },
  {
    "Rank": "3086",
    "Name": "CSW Industrials",
    "Symbol": "CSWI",
    " marketcap ": " $3 880 484 608 ",
    "price (USD)": "249.83",
    "country": "United States"
  },
  {
    "Rank": "3087",
    "Name": "EngageSmart",
    "Symbol": "ESMT",
    " marketcap ": " $3 880 121 856 ",
    "price (USD)": "23.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "3088",
    "Name": "Topdanmark",
    "Symbol": "TOP.CO",
    " marketcap ": " $3 879 251 665 ",
    "price (USD)": "43.6513",
    "country": "Denmark"
  },
  {
    "Rank": "3089",
    "Name": "KBC Ancora",
    "Symbol": "KBCA.BR",
    " marketcap ": " $3 876 096 028 ",
    "price (USD)": "50.3312",
    "country": "Belgium"
  },
  {
    "Rank": "3090",
    "Name": "Interparfums",
    "Symbol": "IPAR",
    " marketcap ": " $3 875 816 192 ",
    "price (USD)": "121.03",
    "country": "United States"
  },
  {
    "Rank": "3091",
    "Name": "Five9",
    "Symbol": "FIVN",
    " marketcap ": " $3 874 376 704 ",
    "price (USD)": "52.45",
    "country": "United States"
  },
  {
    "Rank": "3092",
    "Name": "Sharp Corporation",
    "Symbol": "6753.T",
    " marketcap ": " $3 873 962 522 ",
    "price (USD)": "5.96635",
    "country": "Japan"
  },
  {
    "Rank": "3093",
    "Name": "ACI Worldwide",
    "Symbol": "ACIW",
    " marketcap ": " $3 873 865 728 ",
    "price (USD)": "36.74",
    "country": "United States"
  },
  {
    "Rank": "3094",
    "Name": "Hecla Mining",
    "Symbol": "HL",
    " marketcap ": " $3 870 471 936 ",
    "price (USD)": "\u0438\u044e\u043d.18",
    "country": "United States"
  },
  {
    "Rank": "3095",
    "Name": "Jungheinrich",
    "Symbol": "JUN3.F",
    " marketcap ": " $3 868 051 028 ",
    "price (USD)": "38.1149",
    "country": "Germany"
  },
  {
    "Rank": "3096",
    "Name": "ScottsMiracle-Gro",
    "Symbol": "SMG",
    " marketcap ": " $3 868 018 688 ",
    "price (USD)": "68.1",
    "country": "United States"
  },
  {
    "Rank": "3097",
    "Name": "RioCan REIT",
    "Symbol": "REI-UN.TO",
    " marketcap ": " $3 866 030 749 ",
    "price (USD)": "12.867",
    "country": "Canada"
  },
  {
    "Rank": "3098",
    "Name": "Presight AI",
    "Symbol": "PRESIGHT.AE",
    " marketcap ": " $3 863 631 770 ",
    "price (USD)": "0.69",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3099",
    "Name": "Galenica",
    "Symbol": "GALE.SW",
    " marketcap ": " $3 863 279 367 ",
    "price (USD)": "77.5258",
    "country": "Switzerland"
  },
  {
    "Rank": "3100",
    "Name": "Belden",
    "Symbol": "BDC",
    " marketcap ": " $3 859 547 392 ",
    "price (USD)": "94.88",
    "country": "United States"
  },
  {
    "Rank": "3101",
    "Name": "Box",
    "Symbol": "BOX",
    " marketcap ": " $3 854 938 112 ",
    "price (USD)": "26.59",
    "country": "United States"
  },
  {
    "Rank": "3102",
    "Name": "Indra Sistemas",
    "Symbol": "IDR.MC",
    " marketcap ": " $3 851 301 918 ",
    "price (USD)": "22.2608",
    "country": "Spain"
  },
  {
    "Rank": "3103",
    "Name": "Aurora Innovation",
    "Symbol": "AUR",
    " marketcap ": " $3 849 902 592 ",
    "price (USD)": "\u0444\u0435\u0432.48",
    "country": "United States"
  },
  {
    "Rank": "3104",
    "Name": "Otter Tail",
    "Symbol": "OTTR",
    " marketcap ": " $3 849 851 904 ",
    "price (USD)": "92.07",
    "country": "United States"
  },
  {
    "Rank": "3105",
    "Name": "Vidrala",
    "Symbol": "VID.MC",
    " marketcap ": " $3 846 457 405 ",
    "price (USD)": "119.666",
    "country": "Spain"
  },
  {
    "Rank": "3106",
    "Name": "Korea Aerospace Industries",
    "Symbol": "047810.KS",
    " marketcap ": " $3 844 141 080 ",
    "price (USD)": "39.4372",
    "country": "South Korea"
  },
  {
    "Rank": "3107",
    "Name": "Indorama Ventures",
    "Symbol": "IVL.BK",
    " marketcap ": " $3 843 996 265 ",
    "price (USD)": "0.684649",
    "country": "Thailand"
  },
  {
    "Rank": "3108",
    "Name": "NWS holdings",
    "Symbol": "0659.HK",
    " marketcap ": " $3 841 852 835 ",
    "price (USD)": "0.961054",
    "country": "Hong Kong"
  },
  {
    "Rank": "3109",
    "Name": "Urban Outfitters",
    "Symbol": "URBN",
    " marketcap ": " $3 841 441 792 ",
    "price (USD)": "41.32",
    "country": "United States"
  },
  {
    "Rank": "3110",
    "Name": "Helmerich &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3111",
    "Name": "Blue Star",
    "Symbol": "BLUESTARCO.NS",
    " marketcap ": " $3 823 149 360 ",
    "price (USD)": "18.5937",
    "country": "India"
  },
  {
    "Rank": "3112",
    "Name": "Apar Industries",
    "Symbol": "APARINDS.NS",
    " marketcap ": " $3 822 955 651 ",
    "price (USD)": "95.1734",
    "country": "India"
  },
  {
    "Rank": "3113",
    "Name": "Unicaja Banco",
    "Symbol": "UNI.MC",
    " marketcap ": " $3 819 793 541 ",
    "price (USD)": "1.45075",
    "country": "Spain"
  },
  {
    "Rank": "3114",
    "Name": "Efes Beverage Group",
    "Symbol": "AEFES.IS",
    " marketcap ": " $3 818 240 839 ",
    "price (USD)": "6.44859",
    "country": "Turkey"
  },
  {
    "Rank": "3115",
    "Name": "Q2",
    "Symbol": "QTWO",
    " marketcap ": " $3 818 121 216 ",
    "price (USD)": "63.53",
    "country": "United States"
  },
  {
    "Rank": "3116",
    "Name": "Tomra",
    "Symbol": "TOM.OL",
    " marketcap ": " $3 817 563 790 ",
    "price (USD)": "\u0434\u0435\u043a.79",
    "country": "Norway"
  },
  {
    "Rank": "3117",
    "Name": "Accelleron Industries",
    "Symbol": "ACLN.SW",
    " marketcap ": " $3 817 154 365 ",
    "price (USD)": "40.7106",
    "country": "Switzerland"
  },
  {
    "Rank": "3118",
    "Name": "GMO Payment Gateway",
    "Symbol": "3769.T",
    " marketcap ": " $3 807 675 190 ",
    "price (USD)": "50.2015",
    "country": "Japan"
  },
  {
    "Rank": "3119",
    "Name": "Solvay",
    "Symbol": "SOLB.VI",
    " marketcap ": " $3 805 100 159 ",
    "price (USD)": "36.2363",
    "country": "Belgium"
  },
  {
    "Rank": "3120",
    "Name": "Melco Resorts &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3121",
    "Name": "INFICON",
    "Symbol": "IFCN.SW",
    " marketcap ": " $3 797 209 450 ",
    "price (USD)": "1553.81",
    "country": "Switzerland"
  },
  {
    "Rank": "3122",
    "Name": "Jubilant FoodWorks",
    "Symbol": "JUBLFOOD.NS",
    " marketcap ": " $3 796 622 977 ",
    "price (USD)": "5.76616",
    "country": "India"
  },
  {
    "Rank": "3123",
    "Name": "GMS",
    "Symbol": "GMS",
    " marketcap ": " $3 788 175 360 ",
    "price (USD)": "95.1",
    "country": "United States"
  },
  {
    "Rank": "3124",
    "Name": "Transportadora de Gas del Sur",
    "Symbol": "TGS",
    " marketcap ": " $3 787 022 080 ",
    "price (USD)": "19.39",
    "country": "Argentina"
  },
  {
    "Rank": "3125",
    "Name": "Iridium Communications",
    "Symbol": "IRDM",
    " marketcap ": " $3 783 727 616 ",
    "price (USD)": "31.16",
    "country": "United States"
  },
  {
    "Rank": "3126",
    "Name": "IHI Corporation",
    "Symbol": "7013.T",
    " marketcap ": " $3 779 325 451 ",
    "price (USD)": "24.9696",
    "country": "Japan"
  },
  {
    "Rank": "3127",
    "Name": "CNX Resources",
    "Symbol": "CNX",
    " marketcap ": " $3 779 021 568 ",
    "price (USD)": "24.66",
    "country": "United States"
  },
  {
    "Rank": "3128",
    "Name": "Simply Good Foods",
    "Symbol": "SMPL",
    " marketcap ": " $3 778 584 320 ",
    "price (USD)": "37.79",
    "country": "United States"
  },
  {
    "Rank": "3129",
    "Name": "Brembo",
    "Symbol": "BRE.MI",
    " marketcap ": " $3 777 978 169 ",
    "price (USD)": "\u043d\u043e\u044f.47",
    "country": "Italy"
  },
  {
    "Rank": "3130",
    "Name": "Logista (Compa\u0413\u00b1\u0413\u00ada de Distribuci\u0413\u0456n Integral Logista)",
    "Symbol": "LOG.MC",
    " marketcap ": " $3 776 959 618 ",
    "price (USD)": "28.6242",
    "country": "Spain"
  },
  {
    "Rank": "3131",
    "Name": "Odakyu Electric Railway",
    "Symbol": "9007.T",
    " marketcap ": " $3 774 861 070 ",
    "price (USD)": "\u043e\u043a\u0442.95",
    "country": "Japan"
  },
  {
    "Rank": "3132",
    "Name": "B2Gold",
    "Symbol": "BTG",
    " marketcap ": " $3 773 491 456 ",
    "price (USD)": "\u0444\u0435\u0432.88",
    "country": "Canada"
  },
  {
    "Rank": "3133",
    "Name": "Hims &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3134",
    "Name": "Apollo Tyres",
    "Symbol": "APOLLOTYRE.NS",
    " marketcap ": " $3 770 070 214 ",
    "price (USD)": "5.93617",
    "country": "India"
  },
  {
    "Rank": "3135",
    "Name": "Man Group",
    "Symbol": "EMG.L",
    " marketcap ": " $3 768 876 087 ",
    "price (USD)": "3.24009",
    "country": "Jersey"
  },
  {
    "Rank": "3136",
    "Name": "Azimut Holding",
    "Symbol": "AZM.MI",
    " marketcap ": " $3 768 583 533 ",
    "price (USD)": "26.9085",
    "country": "Italy"
  },
  {
    "Rank": "3137",
    "Name": "Nan Ya PCB",
    "Symbol": "8046.TW",
    " marketcap ": " $3 767 147 376 ",
    "price (USD)": "\u043c\u0430\u0439.83",
    "country": "Taiwan"
  },
  {
    "Rank": "3138",
    "Name": "Yamato Holdings",
    "Symbol": "9064.T",
    " marketcap ": " $3 763 849 379 ",
    "price (USD)": "10.975",
    "country": "Japan"
  },
  {
    "Rank": "3139",
    "Name": "IG Group",
    "Symbol": "IGG.L",
    " marketcap ": " $3 759 807 692 ",
    "price (USD)": "10.069",
    "country": "United Kingdom"
  },
  {
    "Rank": "3140",
    "Name": "LG Display",
    "Symbol": "LPL",
    " marketcap ": " $3 754 520 064 ",
    "price (USD)": "\u043c\u0430\u0440.71",
    "country": "South Korea"
  },
  {
    "Rank": "3141",
    "Name": "Asahi Intecc",
    "Symbol": "7747.T",
    " marketcap ": " $3 752 647 339 ",
    "price (USD)": "13.8155",
    "country": "Japan"
  },
  {
    "Rank": "3142",
    "Name": "Carborundum Universal",
    "Symbol": "CARBORUNIV.NS",
    " marketcap ": " $3 751 347 329 ",
    "price (USD)": "19.7172",
    "country": "India"
  },
  {
    "Rank": "3143",
    "Name": "RayzeBio",
    "Symbol": "RYZB",
    " marketcap ": " $3 750 424 832 ",
    "price (USD)": "62.49",
    "country": "United States"
  },
  {
    "Rank": "3144",
    "Name": "Atlas Energy Solutions",
    "Symbol": "AESI",
    " marketcap ": " $3 744 923 392 ",
    "price (USD)": "24.62",
    "country": "United States"
  },
  {
    "Rank": "3145",
    "Name": "Bank Mega",
    "Symbol": "MEGA.JK",
    " marketcap ": " $3 743 815 977 ",
    "price (USD)": "0.31887",
    "country": "Indonesia"
  },
  {
    "Rank": "3146",
    "Name": "Global Power Synergy",
    "Symbol": "GPSC.BK",
    " marketcap ": " $3 740 877 387 ",
    "price (USD)": "1.32668",
    "country": "Thailand"
  },
  {
    "Rank": "3147",
    "Name": "Tri Pointe Homes",
    "Symbol": "TPH",
    " marketcap ": " $3 739 061 248 ",
    "price (USD)": "38.96",
    "country": "United States"
  },
  {
    "Rank": "3148",
    "Name": "Ocado",
    "Symbol": "OCDO.L",
    " marketcap ": " $3 738 248 324 ",
    "price (USD)": "4.56094",
    "country": "United Kingdom"
  },
  {
    "Rank": "3149",
    "Name": "Iida Group",
    "Symbol": "3291.T",
    " marketcap ": " $3 738 147 745 ",
    "price (USD)": "13.3325",
    "country": "Japan"
  },
  {
    "Rank": "3150",
    "Name": "Square Enix",
    "Symbol": "9684.T",
    " marketcap ": " $3 735 974 252 ",
    "price (USD)": "31.1432",
    "country": "Japan"
  },
  {
    "Rank": "3151",
    "Name": "Luzerner Kantonalbank",
    "Symbol": "LUKN.SW",
    " marketcap ": " $3 733 530 676 ",
    "price (USD)": "75.7152",
    "country": "Switzerland"
  },
  {
    "Rank": "3152",
    "Name": "Viva Energy",
    "Symbol": "VEA.AX",
    " marketcap ": " $3 732 651 659 ",
    "price (USD)": "\u0444\u0435\u0432.05",
    "country": "Australia"
  },
  {
    "Rank": "3153",
    "Name": "LOTTE Chemical",
    "Symbol": "011170.KS",
    " marketcap ": " $3 731 574 293 ",
    "price (USD)": "88.4949",
    "country": "South Korea"
  },
  {
    "Rank": "3154",
    "Name": "TECOM Group",
    "Symbol": "TECOM.AE",
    " marketcap ": " $3 730 225 650 ",
    "price (USD)": "0.746045",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3155",
    "Name": "Schneider",
    "Symbol": "SNDR",
    " marketcap ": " $3 729 213 184 ",
    "price (USD)": "21.24",
    "country": "United States"
  },
  {
    "Rank": "3156",
    "Name": "CymaBay Therapeutics",
    "Symbol": "CBAY",
    " marketcap ": " $3 728 216 832 ",
    "price (USD)": "32.48",
    "country": "United States"
  },
  {
    "Rank": "3157",
    "Name": "HUGO BOSS",
    "Symbol": "BOSS.DE",
    " marketcap ": " $3 726 979 711 ",
    "price (USD)": "54.0015",
    "country": "Germany"
  },
  {
    "Rank": "3158",
    "Name": "Envestnet",
    "Symbol": "ENV",
    " marketcap ": " $3 726 477 568 ",
    "price (USD)": "67.62",
    "country": "United States"
  },
  {
    "Rank": "3159",
    "Name": "TFS Financial",
    "Symbol": "TFSL",
    " marketcap ": " $3 725 035 264 ",
    "price (USD)": "13.27",
    "country": "United States"
  },
  {
    "Rank": "3160",
    "Name": "Rotork",
    "Symbol": "ROR.L",
    " marketcap ": " $3 722 971 382 ",
    "price (USD)": "4.34697",
    "country": "United Kingdom"
  },
  {
    "Rank": "3161",
    "Name": "HASI (Hannon Armstrong)",
    "Symbol": "HASI",
    " marketcap ": " $3 718 331 904 ",
    "price (USD)": "32.31",
    "country": "United States"
  },
  {
    "Rank": "3162",
    "Name": "Cohen &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3163",
    "Name": "DMG Mori",
    "Symbol": "GIL.F",
    " marketcap ": " $3 714 518 858 ",
    "price (USD)": "46.802",
    "country": "Germany"
  },
  {
    "Rank": "3164",
    "Name": "Lazard",
    "Symbol": "LAZ",
    " marketcap ": " $3 712 817 152 ",
    "price (USD)": "41.16",
    "country": "Bermuda"
  },
  {
    "Rank": "3165",
    "Name": "Axsome Therapeutics",
    "Symbol": "AXSM",
    " marketcap ": " $3 710 372 096 ",
    "price (USD)": "78.12",
    "country": "United States"
  },
  {
    "Rank": "3166",
    "Name": "JK Cement",
    "Symbol": "JKCEMENT.NS",
    " marketcap ": " $3 708 459 584 ",
    "price (USD)": "47.9946",
    "country": "India"
  },
  {
    "Rank": "3167",
    "Name": "International Bancshares Corp",
    "Symbol": "IBOC",
    " marketcap ": " $3 708 236 288 ",
    "price (USD)": "59.64",
    "country": "United States"
  },
  {
    "Rank": "3168",
    "Name": "Sanmina",
    "Symbol": "SANM",
    " marketcap ": " $3 708 182 272 ",
    "price (USD)": "66.87",
    "country": "United States"
  },
  {
    "Rank": "3169",
    "Name": "Embracer Group",
    "Symbol": "EMBRAC-B.ST",
    " marketcap ": " $3 706 368 453 ",
    "price (USD)": "\u0444\u0435\u0432.69",
    "country": "Sweden"
  },
  {
    "Rank": "3170",
    "Name": "Indraprastha Gas",
    "Symbol": "IGL.NS",
    " marketcap ": " $3 706 194 522 ",
    "price (USD)": "5.29456",
    "country": "India"
  },
  {
    "Rank": "3171",
    "Name": "Nikon",
    "Symbol": "NINOY",
    " marketcap ": " $3 706 162 432 ",
    "price (USD)": "\u043e\u043a\u0442.66",
    "country": "Japan"
  },
  {
    "Rank": "3172",
    "Name": "Kemira",
    "Symbol": "KEMIRA.HE",
    " marketcap ": " $3 705 357 177 ",
    "price (USD)": "24.0634",
    "country": "Finland"
  },
  {
    "Rank": "3173",
    "Name": "Mabanee Company",
    "Symbol": "MABANEE.KW",
    " marketcap ": " $3 705 301 278 ",
    "price (USD)": "2656.45",
    "country": "Kuwait"
  },
  {
    "Rank": "3174",
    "Name": "Renishaw",
    "Symbol": "RSW.L",
    " marketcap ": " $3 702 683 601 ",
    "price (USD)": "50.9173",
    "country": "United Kingdom"
  },
  {
    "Rank": "3175",
    "Name": "Companhia Sider\u0413\u0454rgica Nacional",
    "Symbol": "SID",
    " marketcap ": " $3 699 791 104 ",
    "price (USD)": "\u0444\u0435\u0432.79",
    "country": "Brazil"
  },
  {
    "Rank": "3176",
    "Name": "Indian Telephone Industries",
    "Symbol": "ITI.NS",
    " marketcap ": " $3 697 983 919 ",
    "price (USD)": "3.84851",
    "country": "India"
  },
  {
    "Rank": "3177",
    "Name": "Mr D.I.Y. Group",
    "Symbol": "5296.KL",
    " marketcap ": " $3 684 302 474 ",
    "price (USD)": "0.389901",
    "country": "Malaysia"
  },
  {
    "Rank": "3178",
    "Name": "Sixt",
    "Symbol": "SIX2.F",
    " marketcap ": " $3 684 004 569 ",
    "price (USD)": "85.7856",
    "country": "Germany"
  },
  {
    "Rank": "3179",
    "Name": "Sino-American Silicon Products",
    "Symbol": "5483.TWO",
    " marketcap ": " $3 681 271 230 ",
    "price (USD)": "6.27965",
    "country": "Taiwan"
  },
  {
    "Rank": "3180",
    "Name": "Dar Al Arkan Real Estate Development Company",
    "Symbol": "4300.SR",
    " marketcap ": " $3 677 527 957 ",
    "price (USD)": "3.40512",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3181",
    "Name": "Aurubis",
    "Symbol": "NDA.F",
    " marketcap ": " $3 676 572 536 ",
    "price (USD)": "84.2111",
    "country": "Germany"
  },
  {
    "Rank": "3182",
    "Name": "Bank of East Asia",
    "Symbol": "0023.HK",
    " marketcap ": " $3 673 340 340 ",
    "price (USD)": "1.39161",
    "country": "Hong Kong"
  },
  {
    "Rank": "3183",
    "Name": "Coforge",
    "Symbol": "COFORGE.NS",
    " marketcap ": " $3 669 068 058 ",
    "price (USD)": "59.3437",
    "country": "India"
  },
  {
    "Rank": "3184",
    "Name": "Allete",
    "Symbol": "ALE",
    " marketcap ": " $3 662 373 888 ",
    "price (USD)": "63.51",
    "country": "United States"
  },
  {
    "Rank": "3185",
    "Name": "Wendy\u0432\u0402\u2122s Company",
    "Symbol": "WEN",
    " marketcap ": " $3 659 572 736 ",
    "price (USD)": "17.84",
    "country": "United States"
  },
  {
    "Rank": "3186",
    "Name": "U.S. Cellular",
    "Symbol": "USM",
    " marketcap ": " $3 655 849 984 ",
    "price (USD)": "43.01",
    "country": "United States"
  },
  {
    "Rank": "3187",
    "Name": "Nordex",
    "Symbol": "NDX1.F",
    " marketcap ": " $3 653 694 325 ",
    "price (USD)": "15.398",
    "country": "Germany"
  },
  {
    "Rank": "3188",
    "Name": "Spire Energy",
    "Symbol": "SR",
    " marketcap ": " $3 651 983 616 ",
    "price (USD)": "63.24",
    "country": "United States"
  },
  {
    "Rank": "3189",
    "Name": "Fonterra",
    "Symbol": "FCG.NZ",
    " marketcap ": " $3 651 186 433 ",
    "price (USD)": "1.89315",
    "country": "New Zealand"
  },
  {
    "Rank": "3190",
    "Name": "Axcelis Technologies",
    "Symbol": "ACLS",
    " marketcap ": " $3 649 821 184 ",
    "price (USD)": "112.19",
    "country": "United States"
  },
  {
    "Rank": "3191",
    "Name": "CD Projekt",
    "Symbol": "CDR.WA",
    " marketcap ": " $3 648 789 784 ",
    "price (USD)": "36.5206",
    "country": "Poland"
  },
  {
    "Rank": "3192",
    "Name": "Hudbay Minerals",
    "Symbol": "HBM",
    " marketcap ": " $3 645 673 728 ",
    "price (USD)": "\u043e\u043a\u0442.36",
    "country": "Canada"
  },
  {
    "Rank": "3193",
    "Name": "Insmed",
    "Symbol": "INSM",
    " marketcap ": " $3 645 280 512 ",
    "price (USD)": "24.53",
    "country": "United States"
  },
  {
    "Rank": "3194",
    "Name": "Tobu Railway",
    "Symbol": "9001.T",
    " marketcap ": " $3 644 704 753 ",
    "price (USD)": "17.6316",
    "country": "Japan"
  },
  {
    "Rank": "3195",
    "Name": "Rubis",
    "Symbol": "RUI.PA",
    " marketcap ": " $3 643 443 206 ",
    "price (USD)": "35.183",
    "country": "France"
  },
  {
    "Rank": "3196",
    "Name": "CareTrust REIT",
    "Symbol": "CTRE",
    " marketcap ": " $3 638 259 200 ",
    "price (USD)": "25.61",
    "country": "United States"
  },
  {
    "Rank": "3197",
    "Name": "Seadrill",
    "Symbol": "SDRL",
    " marketcap ": " $3 636 333 824 ",
    "price (USD)": "52.12",
    "country": "Bermuda"
  },
  {
    "Rank": "3198",
    "Name": "Boyd Group",
    "Symbol": "BYD.TO",
    " marketcap ": " $3 635 609 915 ",
    "price (USD)": "169.317",
    "country": "Canada"
  },
  {
    "Rank": "3199",
    "Name": "Spirit AeroSystems",
    "Symbol": "SPR",
    " marketcap ": " $3 635 256 832 ",
    "price (USD)": "31.19",
    "country": "United States"
  },
  {
    "Rank": "3200",
    "Name": "Synaptics",
    "Symbol": "SYNA",
    " marketcap ": " $3 633 769 984 ",
    "price (USD)": "92",
    "country": "United States"
  },
  {
    "Rank": "3201",
    "Name": "EIH Limited",
    "Symbol": "EIHOTEL.NS",
    " marketcap ": " $3 629 240 686 ",
    "price (USD)": "5.80341",
    "country": "India"
  },
  {
    "Rank": "3202",
    "Name": "Credito Emiliano",
    "Symbol": "CE.MI",
    " marketcap ": " $3 626 666 574 ",
    "price (USD)": "\u043e\u043a\u0442.66",
    "country": "Italy"
  },
  {
    "Rank": "3203",
    "Name": "ONE Gas",
    "Symbol": "OGS",
    " marketcap ": " $3 626 664 192 ",
    "price (USD)": "64.11",
    "country": "United States"
  },
  {
    "Rank": "3204",
    "Name": "Greggs",
    "Symbol": "GRG.L",
    " marketcap ": " $3 625 345 609 ",
    "price (USD)": "35.7247",
    "country": "United Kingdom"
  },
  {
    "Rank": "3205",
    "Name": "nCino",
    "Symbol": "NCNO",
    " marketcap ": " $3 624 451 328 ",
    "price (USD)": "31.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "3206",
    "Name": "Hanwha Solutions",
    "Symbol": "009830.KS",
    " marketcap ": " $3 624 143 116 ",
    "price (USD)": "21.1507",
    "country": "South Korea"
  },
  {
    "Rank": "3207",
    "Name": "Endurance Technologies",
    "Symbol": "ENDURANCE.NS",
    " marketcap ": " $3 619 798 925 ",
    "price (USD)": "25.7338",
    "country": "India"
  },
  {
    "Rank": "3208",
    "Name": "Capital Power",
    "Symbol": "CPX.TO",
    " marketcap ": " $3 619 650 245 ",
    "price (USD)": "28.0289",
    "country": "Canada"
  },
  {
    "Rank": "3209",
    "Name": "Sweetgreen",
    "Symbol": "SG",
    " marketcap ": " $3 616 887 040 ",
    "price (USD)": "31.92",
    "country": "United States"
  },
  {
    "Rank": "3210",
    "Name": "Home Product Center",
    "Symbol": "HMPRO.BK",
    " marketcap ": " $3 616 046 747 ",
    "price (USD)": "0.274959",
    "country": "Thailand"
  },
  {
    "Rank": "3211",
    "Name": "Cousins Properties",
    "Symbol": "CUZ",
    " marketcap ": " $3 613 824 512 ",
    "price (USD)": "23.76",
    "country": "United States"
  },
  {
    "Rank": "3212",
    "Name": "Jet2",
    "Symbol": "JET2.L",
    " marketcap ": " $3 610 787 617 ",
    "price (USD)": "16.8193",
    "country": "United Kingdom"
  },
  {
    "Rank": "3213",
    "Name": "Methanex",
    "Symbol": "MEOH",
    " marketcap ": " $3 608 090 112 ",
    "price (USD)": "53.46",
    "country": "Canada"
  },
  {
    "Rank": "3214",
    "Name": "D\u0413\u00a4twyler",
    "Symbol": "DAE.SW",
    " marketcap ": " $3 607 773 214 ",
    "price (USD)": "212.222",
    "country": "Switzerland"
  },
  {
    "Rank": "3215",
    "Name": "Yamaha",
    "Symbol": "7951.T",
    " marketcap ": " $3 604 409 609 ",
    "price (USD)": "21.8604",
    "country": "Japan"
  },
  {
    "Rank": "3216",
    "Name": "Sitio Royalties",
    "Symbol": "STR",
    " marketcap ": " $3 603 476 480 ",
    "price (USD)": "23.32",
    "country": "United States"
  },
  {
    "Rank": "3217",
    "Name": "Lundin Gold",
    "Symbol": "LUG.TO",
    " marketcap ": " $3 594 095 479 ",
    "price (USD)": "15.0445",
    "country": "Canada"
  },
  {
    "Rank": "3218",
    "Name": "Ar\u0413\u00a7elik",
    "Symbol": "ARCLK.IS",
    " marketcap ": " $3 592 881 255 ",
    "price (USD)": "5.92052",
    "country": "Turkey"
  },
  {
    "Rank": "3219",
    "Name": "Melexis NV",
    "Symbol": "MELE.BR",
    " marketcap ": " $3 590 769 864 ",
    "price (USD)": "88.8804",
    "country": "Belgium"
  },
  {
    "Rank": "3220",
    "Name": "Brederode",
    "Symbol": "BREB.BR",
    " marketcap ": " $3 589 609 816 ",
    "price (USD)": "122.489",
    "country": "Luxembourg"
  },
  {
    "Rank": "3221",
    "Name": "Harvey Norman",
    "Symbol": "HVN.AX",
    " marketcap ": " $3 589 274 725 ",
    "price (USD)": "2.88061",
    "country": "Australia"
  },
  {
    "Rank": "3222",
    "Name": "Triple Flag Precious Metals",
    "Symbol": "TFPM",
    " marketcap ": " $3 587 696 640 ",
    "price (USD)": "17.\u0430\u0432\u0433",
    "country": "Canada"
  },
  {
    "Rank": "3223",
    "Name": "Bandhan Bank",
    "Symbol": "BANDHANBNK.NS",
    " marketcap ": " $3 577 051 738 ",
    "price (USD)": "2.22043",
    "country": "India"
  },
  {
    "Rank": "3224",
    "Name": "Assa\u0413\u00ad Atacadista",
    "Symbol": "ASAI",
    " marketcap ": " $3 571 548 160 ",
    "price (USD)": "13.21",
    "country": "Brazil"
  },
  {
    "Rank": "3225",
    "Name": "Worldline",
    "Symbol": "WLN.PA",
    " marketcap ": " $3 570 098 886 ",
    "price (USD)": "12.314",
    "country": "France"
  },
  {
    "Rank": "3226",
    "Name": "Banca Popolare di Sondrio",
    "Symbol": "BPSO.MI",
    " marketcap ": " $3 567 646 468 ",
    "price (USD)": "7.93246",
    "country": "Italy"
  },
  {
    "Rank": "3227",
    "Name": "Timken India",
    "Symbol": "TIMKEN.NS",
    " marketcap ": " $3 561 566 399 ",
    "price (USD)": "47.3362",
    "country": "India"
  },
  {
    "Rank": "3228",
    "Name": "ServisFirst Bancshares",
    "Symbol": "SFBS",
    " marketcap ": " $3 559 457 536 ",
    "price (USD)": "65.3",
    "country": "United States"
  },
  {
    "Rank": "3229",
    "Name": "M/I Homes",
    "Symbol": "MHO",
    " marketcap ": " $3 556 102 912 ",
    "price (USD)": "128.14",
    "country": "United States"
  },
  {
    "Rank": "3230",
    "Name": "Apple Hospitality REIT",
    "Symbol": "APLE",
    " marketcap ": " $3 555 215 872 ",
    "price (USD)": "14.67",
    "country": "United States"
  },
  {
    "Rank": "3231",
    "Name": "Gerresheimer",
    "Symbol": "GXI.F",
    " marketcap ": " $3 553 768 149 ",
    "price (USD)": "102.888",
    "country": "Germany"
  },
  {
    "Rank": "3232",
    "Name": "CIE Automotive",
    "Symbol": "CIE.MC",
    " marketcap ": " $3 550 897 079 ",
    "price (USD)": "29.6449",
    "country": "Spain"
  },
  {
    "Rank": "3233",
    "Name": "Santen Pharmaceutical",
    "Symbol": "4536.T",
    " marketcap ": " $3 550 530 136 ",
    "price (USD)": "9.77545",
    "country": "Japan"
  },
  {
    "Rank": "3234",
    "Name": "Gland Pharma",
    "Symbol": "GLAND.NS",
    " marketcap ": " $3 547 262 610 ",
    "price (USD)": "21.5363",
    "country": "India"
  },
  {
    "Rank": "3235",
    "Name": "Primo Water",
    "Symbol": "PRMW",
    " marketcap ": " $3 546 938 368 ",
    "price (USD)": "22.14",
    "country": "United States"
  },
  {
    "Rank": "3236",
    "Name": "\u0414\u00b0sdemir",
    "Symbol": "ISDMR.IS",
    " marketcap ": " $3 545 604 557 ",
    "price (USD)": "1.22262",
    "country": "Turkey"
  },
  {
    "Rank": "3237",
    "Name": "TORM",
    "Symbol": "TRMD",
    " marketcap ": " $3 544 477 440 ",
    "price (USD)": "37.5",
    "country": "United Kingdom"
  },
  {
    "Rank": "3238",
    "Name": "T\u0413\u0458rkiye Kalk\u0414\u00b1nma",
    "Symbol": "KLNMA.IS",
    " marketcap ": " $3 543 305 979 ",
    "price (USD)": "0.644237",
    "country": "Turkey"
  },
  {
    "Rank": "3239",
    "Name": "ManpowerGroup",
    "Symbol": "MAN",
    " marketcap ": " $3 541 969 920 ",
    "price (USD)": "74.25",
    "country": "United States"
  },
  {
    "Rank": "3240",
    "Name": "SKF India",
    "Symbol": "SKFINDIA.NS",
    " marketcap ": " $3 540 323 323 ",
    "price (USD)": "71.6114",
    "country": "India"
  },
  {
    "Rank": "3241",
    "Name": "Babcock International Group",
    "Symbol": "BAB.L",
    " marketcap ": " $3 538 484 875 ",
    "price (USD)": "6.99863",
    "country": "United Kingdom"
  },
  {
    "Rank": "3242",
    "Name": "Macerich",
    "Symbol": "MAC",
    " marketcap ": " $3 536 485 632 ",
    "price (USD)": "15.64",
    "country": "United States"
  },
  {
    "Rank": "3243",
    "Name": "Immofinanz",
    "Symbol": "IMO1.F",
    " marketcap ": " $3 535 834 527 ",
    "price (USD)": "25.4642",
    "country": "Austria"
  },
  {
    "Rank": "3244",
    "Name": "Goodyear",
    "Symbol": "GT",
    " marketcap ": " $3 532 965 632 ",
    "price (USD)": "\u0434\u0435\u043a.41",
    "country": "United States"
  },
  {
    "Rank": "3245",
    "Name": "PROCEPT BioRobotics",
    "Symbol": "PRCT",
    " marketcap ": " $3 532 842 496 ",
    "price (USD)": "68.7",
    "country": "United States"
  },
  {
    "Rank": "3246",
    "Name": "Inmobiliaria Colonial",
    "Symbol": "COL.MC",
    " marketcap ": " $3 531 852 336 ",
    "price (USD)": "6.64024",
    "country": "Spain"
  },
  {
    "Rank": "3247",
    "Name": "Alumina Limited",
    "Symbol": "AWC.AX",
    " marketcap ": " $3 531 130 865 ",
    "price (USD)": "1.21693",
    "country": "Australia"
  },
  {
    "Rank": "3248",
    "Name": "DigitalOcean",
    "Symbol": "DOCN",
    " marketcap ": " $3 530 698 496 ",
    "price (USD)": "38.76",
    "country": "United States"
  },
  {
    "Rank": "3249",
    "Name": "Alteryx",
    "Symbol": "AYX",
    " marketcap ": " $3 527 897 856 ",
    "price (USD)": "48.26",
    "country": "United States"
  },
  {
    "Rank": "3250",
    "Name": "Autohome",
    "Symbol": "ATHM",
    " marketcap ": " $3 526 557 696 ",
    "price (USD)": "28.64",
    "country": "China"
  },
  {
    "Rank": "3251",
    "Name": "Kimberly-Clark de M\u0413\u00a9xico",
    "Symbol": "KIMBERA.MX",
    " marketcap ": " $3 520 268 144 ",
    "price (USD)": "2.14965",
    "country": "Mexico"
  },
  {
    "Rank": "3252",
    "Name": "Jfrog",
    "Symbol": "FROG",
    " marketcap ": " $3 517 144 576 ",
    "price (USD)": "32.44",
    "country": "United States"
  },
  {
    "Rank": "3253",
    "Name": "Telix Pharmaceuticals",
    "Symbol": "TLX.AX",
    " marketcap ": " $3 515 766 222 ",
    "price (USD)": "\u043e\u043a\u0442.22",
    "country": "Australia"
  },
  {
    "Rank": "3254",
    "Name": "HUTCHMED",
    "Symbol": "HCM",
    " marketcap ": " $3 513 961 728 ",
    "price (USD)": "19.\u0441\u0435\u043d",
    "country": "Hong Kong"
  },
  {
    "Rank": "3255",
    "Name": "Quaker Houghton",
    "Symbol": "KWR",
    " marketcap ": " $3 510 728 960 ",
    "price (USD)": "195.15",
    "country": "United States"
  },
  {
    "Rank": "3256",
    "Name": "Axos Financial",
    "Symbol": "AX",
    " marketcap ": " $3 504 070 912 ",
    "price (USD)": "61.51",
    "country": "United States"
  },
  {
    "Rank": "3257",
    "Name": "PNM Resources",
    "Symbol": "PNM",
    " marketcap ": " $3 503 383 552 ",
    "price (USD)": "38.84",
    "country": "United States"
  },
  {
    "Rank": "3258",
    "Name": "UOL Group",
    "Symbol": "U14.SI",
    " marketcap ": " $3 500 305 989 ",
    "price (USD)": "4.14269",
    "country": "Singapore"
  },
  {
    "Rank": "3259",
    "Name": "PotlatchDeltic",
    "Symbol": "PCH",
    " marketcap ": " $3 499 951 104 ",
    "price (USD)": "44.02",
    "country": "United States"
  },
  {
    "Rank": "3260",
    "Name": "Delhivery",
    "Symbol": "DELHIVERY.NS",
    " marketcap ": " $3 498 178 131 ",
    "price (USD)": "4.74365",
    "country": "India"
  },
  {
    "Rank": "3261",
    "Name": "KIOCL",
    "Symbol": "KIOCL.NS",
    " marketcap ": " $3 494 894 913 ",
    "price (USD)": "5.75054",
    "country": "India"
  },
  {
    "Rank": "3262",
    "Name": "Virgin Money UK",
    "Symbol": "VMUK.L",
    " marketcap ": " $3 494 306 104 ",
    "price (USD)": "2.69525",
    "country": "United Kingdom"
  },
  {
    "Rank": "3263",
    "Name": "Rinnai Corporation",
    "Symbol": "5947.T",
    " marketcap ": " $3 494 210 725 ",
    "price (USD)": "24.4002",
    "country": "Japan"
  },
  {
    "Rank": "3264",
    "Name": "Glenmark Pharmaceuticals",
    "Symbol": "GLENMARK.NS",
    " marketcap ": " $3 493 118 062 ",
    "price (USD)": "\u0434\u0435\u043a.84",
    "country": "India"
  },
  {
    "Rank": "3265",
    "Name": "Stella-Jones",
    "Symbol": "SJ.TO",
    " marketcap ": " $3 478 663 024 ",
    "price (USD)": "61.4392",
    "country": "Canada"
  },
  {
    "Rank": "3266",
    "Name": "Kos\u0413\u00a9",
    "Symbol": "4922.T",
    " marketcap ": " $3 477 985 209 ",
    "price (USD)": "60.9558",
    "country": "Japan"
  },
  {
    "Rank": "3267",
    "Name": "Rush Enterprises",
    "Symbol": "RUSHA",
    " marketcap ": " $3 474 503 936 ",
    "price (USD)": "44.89",
    "country": "United States"
  },
  {
    "Rank": "3268",
    "Name": "TUI",
    "Symbol": "TUI1.F",
    " marketcap ": " $3 473 607 262 ",
    "price (USD)": "6.84548",
    "country": "Germany"
  },
  {
    "Rank": "3269",
    "Name": "TOTVS",
    "Symbol": "TOTS3.SA",
    " marketcap ": " $3 472 518 035 ",
    "price (USD)": "5.77843",
    "country": "Brazil"
  },
  {
    "Rank": "3270",
    "Name": "Warrior Met Coal",
    "Symbol": "HCC",
    " marketcap ": " $3 465 967 104 ",
    "price (USD)": "66.27",
    "country": "United States"
  },
  {
    "Rank": "3271",
    "Name": "Joby Aviation",
    "Symbol": "JOBY",
    " marketcap ": " $3 464 276 480 ",
    "price (USD)": "\u0430\u043f\u0440.89",
    "country": "United States"
  },
  {
    "Rank": "3272",
    "Name": "Milaha - Qatar Navigation",
    "Symbol": "QNNS.QA",
    " marketcap ": " $3 461 542 541 ",
    "price (USD)": "3.0467",
    "country": "Qatar"
  },
  {
    "Rank": "3273",
    "Name": "Nordstrom",
    "Symbol": "JWN",
    " marketcap ": " $3 461 069 824 ",
    "price (USD)": "21.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "3274",
    "Name": "Paramount Resources",
    "Symbol": "POU.TO",
    " marketcap ": " $3 459 826 064 ",
    "price (USD)": "23.6812",
    "country": "Canada"
  },
  {
    "Rank": "3275",
    "Name": "Asana",
    "Symbol": "ASAN",
    " marketcap ": " $3 453 751 040 ",
    "price (USD)": "15.16",
    "country": "United States"
  },
  {
    "Rank": "3276",
    "Name": "Boot Barn Holdings",
    "Symbol": "BOOT",
    " marketcap ": " $3 451 817 984 ",
    "price (USD)": "113.55",
    "country": "United States"
  },
  {
    "Rank": "3277",
    "Name": "Axonics Modulation Tech",
    "Symbol": "AXNX",
    " marketcap ": " $3 448 340 224 ",
    "price (USD)": "67.59",
    "country": "United States"
  },
  {
    "Rank": "3278",
    "Name": "SL Green Realty",
    "Symbol": "SLG",
    " marketcap ": " $3 447 023 872 ",
    "price (USD)": "52.94",
    "country": "United States"
  },
  {
    "Rank": "3279",
    "Name": "Alarm.com",
    "Symbol": "ALRM",
    " marketcap ": " $3 446 457 856 ",
    "price (USD)": "68.67",
    "country": "United States"
  },
  {
    "Rank": "3280",
    "Name": "Gamuda Berhad",
    "Symbol": "5398.KL",
    " marketcap ": " $3 440 650 254 ",
    "price (USD)": "1.24214",
    "country": "Malaysia"
  },
  {
    "Rank": "3281",
    "Name": "Pampa Energ\u0413\u00ada",
    "Symbol": "PAM",
    " marketcap ": " $3 435 905 024 ",
    "price (USD)": "47.27",
    "country": "Argentina"
  },
  {
    "Rank": "3282",
    "Name": "Bloom Energy",
    "Symbol": "BE",
    " marketcap ": " $3 434 812 672 ",
    "price (USD)": "15.13",
    "country": "United States"
  },
  {
    "Rank": "3283",
    "Name": "National Shipping Company of Saudi Arabia (Bahri)",
    "Symbol": "4030.SR",
    " marketcap ": " $3 434 660 456 ",
    "price (USD)": "6.97836",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3284",
    "Name": "PowerSchool",
    "Symbol": "PWSC",
    " marketcap ": " $3 434 498 816 ",
    "price (USD)": "20.69",
    "country": "United States"
  },
  {
    "Rank": "3285",
    "Name": "Signify",
    "Symbol": "LIGHT.AS",
    " marketcap ": " $3 433 303 316 ",
    "price (USD)": "27.2777",
    "country": "Netherlands"
  },
  {
    "Rank": "3286",
    "Name": "Ameris Bancorp",
    "Symbol": "ABCB",
    " marketcap ": " $3 433 250 560 ",
    "price (USD)": "49.68",
    "country": "United States"
  },
  {
    "Rank": "3287",
    "Name": "Shaftesbury Capital",
    "Symbol": "SHC.L",
    " marketcap ": " $3 431 416 098 ",
    "price (USD)": "1.75954",
    "country": "United Kingdom"
  },
  {
    "Rank": "3288",
    "Name": "abrdn",
    "Symbol": "ABDN.L",
    " marketcap ": " $3 422 855 100 ",
    "price (USD)": "1.92036",
    "country": "United Kingdom"
  },
  {
    "Rank": "3289",
    "Name": "Biohaven Pharmaceutical",
    "Symbol": "BHVN",
    " marketcap ": " $3 418 662 656 ",
    "price (USD)": "38.72",
    "country": "United States"
  },
  {
    "Rank": "3290",
    "Name": "Park Hotels &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3291",
    "Name": "Victory Capital",
    "Symbol": "VCTR",
    " marketcap ": " $3 416 682 752 ",
    "price (USD)": "52.8",
    "country": "United States"
  },
  {
    "Rank": "3292",
    "Name": "YETI Holdings",
    "Symbol": "YETI",
    " marketcap ": " $3 416 359 168 ",
    "price (USD)": "40.08",
    "country": "United States"
  },
  {
    "Rank": "3293",
    "Name": "ISS A/S",
    "Symbol": "ISS.CO",
    " marketcap ": " $3 415 935 410 ",
    "price (USD)": "18.5809",
    "country": "Denmark"
  },
  {
    "Rank": "3294",
    "Name": "Korn Ferry",
    "Symbol": "KFY",
    " marketcap ": " $3 415 193 856 ",
    "price (USD)": "65.45",
    "country": "United States"
  },
  {
    "Rank": "3295",
    "Name": "Asset World Corp",
    "Symbol": "AWC.BK",
    " marketcap ": " $3 414 429 929 ",
    "price (USD)": "0.106684",
    "country": "Thailand"
  },
  {
    "Rank": "3296",
    "Name": "Paladin Energy",
    "Symbol": "PDN.AX",
    " marketcap ": " $3 413 246 730 ",
    "price (USD)": "\u043d\u043e\u044f.58",
    "country": "Australia"
  },
  {
    "Rank": "3297",
    "Name": "Newell Brands",
    "Symbol": "NWL",
    " marketcap ": " $3 412 623 360 ",
    "price (USD)": "\u0430\u0432\u0433.22",
    "country": "United States"
  },
  {
    "Rank": "3298",
    "Name": "Tate &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3299",
    "Name": "St. Joe Company",
    "Symbol": "JOE",
    " marketcap ": " $3 394 646 784 ",
    "price (USD)": "58.13",
    "country": "United States"
  },
  {
    "Rank": "3300",
    "Name": "COSMOS Pharmaceutical",
    "Symbol": "3349.T",
    " marketcap ": " $3 389 655 626 ",
    "price (USD)": "85.5352",
    "country": "Japan"
  },
  {
    "Rank": "3301",
    "Name": "Nisshin Seifun Group",
    "Symbol": "2002.T",
    " marketcap ": " $3 386 976 285 ",
    "price (USD)": "\u043d\u043e\u044f.76",
    "country": "Japan"
  },
  {
    "Rank": "3302",
    "Name": "Saudi Kayan Petrochemical Company",
    "Symbol": "2350.SR",
    " marketcap ": " $3 386 438 201 ",
    "price (USD)": "2.25763",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3303",
    "Name": "Sumitomo Chemical",
    "Symbol": "4005.T",
    " marketcap ": " $3 384 723 970 ",
    "price (USD)": "2.06897",
    "country": "Japan"
  },
  {
    "Rank": "3304",
    "Name": "Black Stone Minerals",
    "Symbol": "BSM",
    " marketcap ": " $3 383 890 176 ",
    "price (USD)": "16.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "3305",
    "Name": "ATCO",
    "Symbol": "ACO-X.TO",
    " marketcap ": " $3 380 735 306 ",
    "price (USD)": "30.0158",
    "country": "Canada"
  },
  {
    "Rank": "3306",
    "Name": "Fluence Energy",
    "Symbol": "FLNC",
    " marketcap ": " $3 379 820 544 ",
    "price (USD)": "18.84",
    "country": "United States"
  },
  {
    "Rank": "3307",
    "Name": "Groupe Lagard\u0413\u0401re",
    "Symbol": "MMB.PA",
    " marketcap ": " $3 378 861 132 ",
    "price (USD)": "23.7268",
    "country": "France"
  },
  {
    "Rank": "3308",
    "Name": "Indofood",
    "Symbol": "INDF.JK",
    " marketcap ": " $3 376 244 000 ",
    "price (USD)": "0.384519",
    "country": "Indonesia"
  },
  {
    "Rank": "3309",
    "Name": "Eldorado Gold",
    "Symbol": "EGO",
    " marketcap ": " $3 375 762 944 ",
    "price (USD)": "16.52",
    "country": "Canada"
  },
  {
    "Rank": "3310",
    "Name": "Ultragenyx",
    "Symbol": "RARE",
    " marketcap ": " $3 373 549 312 ",
    "price (USD)": "40.58",
    "country": "United States"
  },
  {
    "Rank": "3311",
    "Name": "Powerchip Semiconductor Manufacturing",
    "Symbol": "6770.TW",
    " marketcap ": " $3 371 344 266 ",
    "price (USD)": "0.810928",
    "country": "Taiwan"
  },
  {
    "Rank": "3312",
    "Name": "Wolfspeed",
    "Symbol": "WOLF",
    " marketcap ": " $3 370 396 928 ",
    "price (USD)": "26.78",
    "country": "United States"
  },
  {
    "Rank": "3313",
    "Name": "Cactus Inc",
    "Symbol": "WHD",
    " marketcap ": " $3 370 071 040 ",
    "price (USD)": "51.29",
    "country": "United States"
  },
  {
    "Rank": "3314",
    "Name": "Bakkafrost",
    "Symbol": "BAKKA.OL",
    " marketcap ": " $3 369 789 466 ",
    "price (USD)": "56.8967",
    "country": "Denmark"
  },
  {
    "Rank": "3315",
    "Name": "Walker &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3316",
    "Name": "Vontobel",
    "Symbol": "VONN.SW",
    " marketcap ": " $3 366 291 146 ",
    "price (USD)": "60.9013",
    "country": "Switzerland"
  },
  {
    "Rank": "3317",
    "Name": "Pegasus Airlines",
    "Symbol": "PGSUS.IS",
    " marketcap ": " $3 365 627 947 ",
    "price (USD)": "6.73126",
    "country": "Turkey"
  },
  {
    "Rank": "3318",
    "Name": "1&1",
    "Symbol": "1U1.DE",
    " marketcap ": " $3 365 570 759 ",
    "price (USD)": "19.\u0441\u0435\u043d",
    "country": "Germany"
  },
  {
    "Rank": "3319",
    "Name": "Griffon Corporation",
    "Symbol": "GFF",
    " marketcap ": " $3 362 198 016 ",
    "price (USD)": "67.85",
    "country": "United States"
  },
  {
    "Rank": "3320",
    "Name": "Syngene International",
    "Symbol": "SYNGENE.NS",
    " marketcap ": " $3 359 738 474 ",
    "price (USD)": "8.37228",
    "country": "India"
  },
  {
    "Rank": "3321",
    "Name": "Astra Industrial Group Company",
    "Symbol": "1212.SR",
    " marketcap ": " $3 356 016 332 ",
    "price (USD)": "41.9502",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3322",
    "Name": "Bezeq",
    "Symbol": "BEZQ.TA",
    " marketcap ": " $3 353 749 389 ",
    "price (USD)": "\u044f\u043d\u0432.21",
    "country": "Israel"
  },
  {
    "Rank": "3323",
    "Name": "Corporaci\u0413\u0456n Financiera Alba",
    "Symbol": "ALB.MC",
    " marketcap ": " $3 352 835 530 ",
    "price (USD)": "55.5978",
    "country": "Spain"
  },
  {
    "Rank": "3324",
    "Name": "RingCentral",
    "Symbol": "RNG",
    " marketcap ": " $3 350 532 096 ",
    "price (USD)": "36.35",
    "country": "United States"
  },
  {
    "Rank": "3325",
    "Name": "Direct Line Group",
    "Symbol": "DLG.L",
    " marketcap ": " $3 348 724 879 ",
    "price (USD)": "2.58051",
    "country": "United Kingdom"
  },
  {
    "Rank": "3326",
    "Name": "Kingnet Network",
    "Symbol": "002517.SZ",
    " marketcap ": " $3 348 027 501 ",
    "price (USD)": "\u044f\u043d\u0432.54",
    "country": "China"
  },
  {
    "Rank": "3327",
    "Name": "Kadant",
    "Symbol": "KAI",
    " marketcap ": " $3 346 726 400 ",
    "price (USD)": "285",
    "country": "United States"
  },
  {
    "Rank": "3328",
    "Name": "Diodes Incorporated",
    "Symbol": "DIOD",
    " marketcap ": " $3 344 832 512 ",
    "price (USD)": "72.52",
    "country": "United States"
  },
  {
    "Rank": "3329",
    "Name": "Howard Hughes Holdings",
    "Symbol": "HHH",
    " marketcap ": " $3 339 730 432 ",
    "price (USD)": "66.45",
    "country": "United States"
  },
  {
    "Rank": "3330",
    "Name": "QL Resources",
    "Symbol": "7084.KL",
    " marketcap ": " $3 339 249 928 ",
    "price (USD)": "1.37211",
    "country": "Malaysia"
  },
  {
    "Rank": "3331",
    "Name": "Marriott Vacations Worldwide",
    "Symbol": "VAC",
    " marketcap ": " $3 336 702 464 ",
    "price (USD)": "94.89",
    "country": "United States"
  },
  {
    "Rank": "3332",
    "Name": "Sabra Health Care REIT",
    "Symbol": "SBRA",
    " marketcap ": " $3 331 227 392 ",
    "price (USD)": "14.39",
    "country": "United States"
  },
  {
    "Rank": "3333",
    "Name": "Graham Holdings",
    "Symbol": "GHC",
    " marketcap ": " $3 330 894 080 ",
    "price (USD)": "750.58",
    "country": "United States"
  },
  {
    "Rank": "3334",
    "Name": "The a2 Milk Company",
    "Symbol": "A2M.AX",
    " marketcap ": " $3 326 210 690 ",
    "price (USD)": "4.60098",
    "country": "New Zealand"
  },
  {
    "Rank": "3335",
    "Name": "Netwealth",
    "Symbol": "NWL.AX",
    " marketcap ": " $3 326 079 590 ",
    "price (USD)": "13.6296",
    "country": "Australia"
  },
  {
    "Rank": "3336",
    "Name": "Tata Chemicals",
    "Symbol": "TATACHEM.NS",
    " marketcap ": " $3 321 620 233 ",
    "price (USD)": "13.0384",
    "country": "India"
  },
  {
    "Rank": "3337",
    "Name": "Kinnevik",
    "Symbol": "KINV-A.ST",
    " marketcap ": " $3 320 031 434 ",
    "price (USD)": "\u043d\u043e\u044f.27",
    "country": "Sweden"
  },
  {
    "Rank": "3338",
    "Name": "Sprinklr",
    "Symbol": "CXM",
    " marketcap ": " $3 319 160 832 ",
    "price (USD)": "\u0434\u0435\u043a.28",
    "country": "United States"
  },
  {
    "Rank": "3339",
    "Name": "Iveco Group",
    "Symbol": "IVG.MI",
    " marketcap ": " $3 316 330 025 ",
    "price (USD)": "12.1892",
    "country": "Italy"
  },
  {
    "Rank": "3340",
    "Name": "360 DigiTech",
    "Symbol": "QFIN",
    " marketcap ": " $3 300 633 344 ",
    "price (USD)": "20.51",
    "country": "China"
  },
  {
    "Rank": "3341",
    "Name": "Kakao Pay",
    "Symbol": "377300.KS",
    " marketcap ": " $3 300 093 820 ",
    "price (USD)": "24.5656",
    "country": "South Korea"
  },
  {
    "Rank": "3342",
    "Name": "United Parks &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3343",
    "Name": "Bangkok Expressway and Metro (BEM)",
    "Symbol": "BEM.BK",
    " marketcap ": " $3 298 280 975 ",
    "price (USD)": "0.217218",
    "country": "Thailand"
  },
  {
    "Rank": "3344",
    "Name": "Mallplaza",
    "Symbol": "MALLPLAZA.SN",
    " marketcap ": " $3 297 567 532 ",
    "price (USD)": "1.68243",
    "country": "Chile"
  },
  {
    "Rank": "3345",
    "Name": "Genting Malaysia Berhad",
    "Symbol": "4715.KL",
    " marketcap ": " $3 296 672 167 ",
    "price (USD)": "0.581655",
    "country": "Malaysia"
  },
  {
    "Rank": "3346",
    "Name": "Forvia SE",
    "Symbol": "FRVIA.PA",
    " marketcap ": " $3 296 463 269 ",
    "price (USD)": "16.3699",
    "country": "France"
  },
  {
    "Rank": "3347",
    "Name": "Archrock",
    "Symbol": "AROC",
    " marketcap ": " $3 285 131 776 ",
    "price (USD)": "21.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "3348",
    "Name": "Indah Kiat Pulp &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3349",
    "Name": "California Resources Corporation",
    "Symbol": "CRC",
    " marketcap ": " $3 283 305 984 ",
    "price (USD)": "47.91",
    "country": "United States"
  },
  {
    "Rank": "3350",
    "Name": "Mercury General",
    "Symbol": "MCY",
    " marketcap ": " $3 280 737 792 ",
    "price (USD)": "59.25",
    "country": "United States"
  },
  {
    "Rank": "3351",
    "Name": "Associated Banc-Corp",
    "Symbol": "ASB",
    " marketcap ": " $3 279 182 336 ",
    "price (USD)": "21.75",
    "country": "United States"
  },
  {
    "Rank": "3352",
    "Name": "Barwa Real Estate Company",
    "Symbol": "BRES.QA",
    " marketcap ": " $3 278 698 620 ",
    "price (USD)": "0.842582",
    "country": "Qatar"
  },
  {
    "Rank": "3353",
    "Name": "LivaNova",
    "Symbol": "LIVN",
    " marketcap ": " $3 278 614 528 ",
    "price (USD)": "60.545",
    "country": "United Kingdom"
  },
  {
    "Rank": "3354",
    "Name": "Playtika",
    "Symbol": "PLTK",
    " marketcap ": " $3 277 060 096 ",
    "price (USD)": "\u0430\u0432\u0433.83",
    "country": "Israel"
  },
  {
    "Rank": "3355",
    "Name": "Yuexiu Property",
    "Symbol": "0123.HK",
    " marketcap ": " $3 275 430 106 ",
    "price (USD)": "0.813693",
    "country": "Hong Kong"
  },
  {
    "Rank": "3356",
    "Name": "ALSO Holding",
    "Symbol": "ALSN.SW",
    " marketcap ": " $3 273 760 507 ",
    "price (USD)": "267.198",
    "country": "Switzerland"
  },
  {
    "Rank": "3357",
    "Name": "Seaboard",
    "Symbol": "SEB",
    " marketcap ": " $3 273 183 744 ",
    "price (USD)": "3370.75",
    "country": "United States"
  },
  {
    "Rank": "3358",
    "Name": "Vesta Real Estate",
    "Symbol": "VTMX",
    " marketcap ": " $3 262 928 128 ",
    "price (USD)": "37.28",
    "country": "Mexico"
  },
  {
    "Rank": "3359",
    "Name": "St. James's Place",
    "Symbol": "STJ.L",
    " marketcap ": " $3 259 951 069 ",
    "price (USD)": "5.94226",
    "country": "United Kingdom"
  },
  {
    "Rank": "3360",
    "Name": "Kratos Defense &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3361",
    "Name": "BlackLine",
    "Symbol": "BL",
    " marketcap ": " $3 255 922 432 ",
    "price (USD)": "52.67",
    "country": "United States"
  },
  {
    "Rank": "3362",
    "Name": "Virbac SA",
    "Symbol": "VIRP.PA",
    " marketcap ": " $3 255 623 082 ",
    "price (USD)": "388.75",
    "country": "France"
  },
  {
    "Rank": "3363",
    "Name": "momo.com Inc.",
    "Symbol": "8454.TW",
    " marketcap ": " $3 253 276 282 ",
    "price (USD)": "13.5361",
    "country": "Taiwan"
  },
  {
    "Rank": "3364",
    "Name": "Sportradar",
    "Symbol": "SRAD",
    " marketcap ": " $3 250 427 136 ",
    "price (USD)": "\u043e\u043a\u0442.91",
    "country": "Switzerland"
  },
  {
    "Rank": "3365",
    "Name": "CyberAgent",
    "Symbol": "4751.T",
    " marketcap ": " $3 250 297 394 ",
    "price (USD)": "6.41993",
    "country": "Japan"
  },
  {
    "Rank": "3366",
    "Name": "Innospec",
    "Symbol": "IOSP",
    " marketcap ": " $3 249 793 280 ",
    "price (USD)": "130.34",
    "country": "United States"
  },
  {
    "Rank": "3367",
    "Name": "Galaxy Digital Holdings",
    "Symbol": "7LX.F",
    " marketcap ": " $3 248 779 550 ",
    "price (USD)": "9.66229",
    "country": "United States"
  },
  {
    "Rank": "3368",
    "Name": "Prestige Consumer Healthcare",
    "Symbol": "PBH",
    " marketcap ": " $3 246 996 992 ",
    "price (USD)": "65.05",
    "country": "United States"
  },
  {
    "Rank": "3369",
    "Name": "Boston Beer Company",
    "Symbol": "SAM",
    " marketcap ": " $3 246 559 744 ",
    "price (USD)": "271.59",
    "country": "United States"
  },
  {
    "Rank": "3370",
    "Name": "Vishay Intertechnology",
    "Symbol": "VSH",
    " marketcap ": " $3 240 165 376 ",
    "price (USD)": "23.61",
    "country": "United States"
  },
  {
    "Rank": "3371",
    "Name": "ATS Automation",
    "Symbol": "ATS",
    " marketcap ": " $3 238 568 192 ",
    "price (USD)": "33.01",
    "country": "Canada"
  },
  {
    "Rank": "3372",
    "Name": "Motor Oil (Hellas) Corinth Refineries",
    "Symbol": "MOH.AT",
    " marketcap ": " $3 237 962 167 ",
    "price (USD)": "29.949",
    "country": "Greece"
  },
  {
    "Rank": "3373",
    "Name": "Imerys",
    "Symbol": "NK.PA",
    " marketcap ": " $3 237 306 948 ",
    "price (USD)": "37.181",
    "country": "France"
  },
  {
    "Rank": "3374",
    "Name": "NorthWestern Corporation",
    "Symbol": "NWE",
    " marketcap ": " $3 237 147 648 ",
    "price (USD)": "52.82",
    "country": "United States"
  },
  {
    "Rank": "3375",
    "Name": "Granite Real Estate",
    "Symbol": "GRP-UN",
    " marketcap ": " $3 236 402 432 ",
    "price (USD)": "51.06",
    "country": "Canada"
  },
  {
    "Rank": "3376",
    "Name": "Aluar Aluminio Argentino",
    "Symbol": "ALUA.BA",
    " marketcap ": " $3 236 220 463 ",
    "price (USD)": "1.15579",
    "country": "Argentina"
  },
  {
    "Rank": "3377",
    "Name": "Arabian Drilling Company",
    "Symbol": "2381.SR",
    " marketcap ": " $3 234 808 977 ",
    "price (USD)": "36.3462",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3378",
    "Name": "Piper Sandler",
    "Symbol": "PIPR",
    " marketcap ": " $3 232 284 416 ",
    "price (USD)": "215.5",
    "country": "United States"
  },
  {
    "Rank": "3379",
    "Name": "WD-40 Company",
    "Symbol": "WDFC",
    " marketcap ": " $3 231 888 640 ",
    "price (USD)": "238.47",
    "country": "United States"
  },
  {
    "Rank": "3380",
    "Name": "Valeo",
    "Symbol": "FR.PA",
    " marketcap ": " $3 230 432 003 ",
    "price (USD)": "\u0434\u0435\u043a.21",
    "country": "France"
  },
  {
    "Rank": "3381",
    "Name": "DoubleVerify",
    "Symbol": "DV",
    " marketcap ": " $3 229 764 608 ",
    "price (USD)": "18.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "3382",
    "Name": "Surgery Partners",
    "Symbol": "SGRY",
    " marketcap ": " $3 228 187 648 ",
    "price (USD)": "25.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "3383",
    "Name": "Melisron",
    "Symbol": "MLSR.TA",
    " marketcap ": " $3 227 988 551 ",
    "price (USD)": "67.9265",
    "country": "Israel"
  },
  {
    "Rank": "3384",
    "Name": "National Bank of Bahrain",
    "Symbol": "NBB.BH",
    " marketcap ": " $3 227 804 528 ",
    "price (USD)": "3.1565",
    "country": "Bahrain"
  },
  {
    "Rank": "3385",
    "Name": "IES Holdings",
    "Symbol": "IESC",
    " marketcap ": " $3 222 157 824 ",
    "price (USD)": "159.17",
    "country": "United States"
  },
  {
    "Rank": "3386",
    "Name": "IDP Education",
    "Symbol": "IEL.AX",
    " marketcap ": " $3 221 962 659 ",
    "price (USD)": "\u043d\u043e\u044f.58",
    "country": "Australia"
  },
  {
    "Rank": "3387",
    "Name": "Linamar",
    "Symbol": "LNR.TO",
    " marketcap ": " $3 221 687 411 ",
    "price (USD)": "52.3186",
    "country": "Canada"
  },
  {
    "Rank": "3388",
    "Name": "Sensient Technologies",
    "Symbol": "SXT",
    " marketcap ": " $3 219 308 544 ",
    "price (USD)": "75.99",
    "country": "United States"
  },
  {
    "Rank": "3389",
    "Name": "International Seaways",
    "Symbol": "INSW",
    " marketcap ": " $3 218 714 112 ",
    "price (USD)": "64.92",
    "country": "United States"
  },
  {
    "Rank": "3390",
    "Name": "Kinaxis",
    "Symbol": "KXS.TO",
    " marketcap ": " $3 216 630 287 ",
    "price (USD)": "113.421",
    "country": "Canada"
  },
  {
    "Rank": "3391",
    "Name": "Comstock Resources",
    "Symbol": "CRK",
    " marketcap ": " $3 214 221 824 ",
    "price (USD)": "11",
    "country": "United States"
  },
  {
    "Rank": "3392",
    "Name": "Travel + Leisure",
    "Symbol": "TNL",
    " marketcap ": " $3 211 133 696 ",
    "price (USD)": "45.06",
    "country": "United States"
  },
  {
    "Rank": "3393",
    "Name": "Gulf Bank",
    "Symbol": "GBK.KW",
    " marketcap ": " $3 210 063 729 ",
    "price (USD)": "844.198",
    "country": "Kuwait"
  },
  {
    "Rank": "3394",
    "Name": "Artisan Partners",
    "Symbol": "APAM",
    " marketcap ": " $3 209 412 096 ",
    "price (USD)": "45.91",
    "country": "United States"
  },
  {
    "Rank": "3395",
    "Name": "Ermenegildo Zegna",
    "Symbol": "ZGN",
    " marketcap ": " $3 208 974 080 ",
    "price (USD)": "\u0434\u0435\u043a.82",
    "country": "Italy"
  },
  {
    "Rank": "3396",
    "Name": "Derwent London",
    "Symbol": "DLN.L",
    " marketcap ": " $3 206 396 989 ",
    "price (USD)": "28.5544",
    "country": "United Kingdom"
  },
  {
    "Rank": "3397",
    "Name": "National Bank of Fujairah",
    "Symbol": "NBF.AE",
    " marketcap ": " $3 206 235 195 ",
    "price (USD)": "\u044f\u043d\u0432.44",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3398",
    "Name": "FLSmidth",
    "Symbol": "FLS.CO",
    " marketcap ": " $3 204 874 573 ",
    "price (USD)": "56.3393",
    "country": "Denmark"
  },
  {
    "Rank": "3399",
    "Name": "Japan Airport Terminal",
    "Symbol": "9706.T",
    " marketcap ": " $3 202 056 046 ",
    "price (USD)": "34.3804",
    "country": "Japan"
  },
  {
    "Rank": "3400",
    "Name": "Mayora",
    "Symbol": "MYOR.JK",
    " marketcap ": " $3 201 289 547 ",
    "price (USD)": "0.143179",
    "country": "Indonesia"
  },
  {
    "Rank": "3401",
    "Name": "The Navigator Company",
    "Symbol": "NVG.LS",
    " marketcap ": " $3 200 284 939 ",
    "price (USD)": "4.49995",
    "country": "Portugal"
  },
  {
    "Rank": "3402",
    "Name": "New World Development Company",
    "Symbol": "0017.HK",
    " marketcap ": " $3 198 987 374 ",
    "price (USD)": "1.27115",
    "country": "Hong Kong"
  },
  {
    "Rank": "3403",
    "Name": "NBCC India",
    "Symbol": "NBCC.NS",
    " marketcap ": " $3 198 721 626 ",
    "price (USD)": "1.77707",
    "country": "India"
  },
  {
    "Rank": "3404",
    "Name": "United Community Bank",
    "Symbol": "UCBI",
    " marketcap ": " $3 197 744 384 ",
    "price (USD)": "26.84",
    "country": "United States"
  },
  {
    "Rank": "3405",
    "Name": "C3 AI",
    "Symbol": "AI",
    " marketcap ": " $3 191 581 184 ",
    "price (USD)": "26.15",
    "country": "United States"
  },
  {
    "Rank": "3406",
    "Name": "NCsoft",
    "Symbol": "036570.KS",
    " marketcap ": " $3 191 533 525 ",
    "price (USD)": "157.161",
    "country": "South Korea"
  },
  {
    "Rank": "3407",
    "Name": "Olam",
    "Symbol": "VC2.SI",
    " marketcap ": " $3 188 756 678 ",
    "price (USD)": "0.838932",
    "country": "Singapore"
  },
  {
    "Rank": "3408",
    "Name": "Innovative Industrial",
    "Symbol": "IIPR",
    " marketcap ": " $3 187 817 216 ",
    "price (USD)": "112.53",
    "country": "United States"
  },
  {
    "Rank": "3409",
    "Name": "Sun TV Network",
    "Symbol": "SUNTV.NS",
    " marketcap ": " $3 186 223 429 ",
    "price (USD)": "8.08512",
    "country": "India"
  },
  {
    "Rank": "3410",
    "Name": "Tandem Diabetes Care",
    "Symbol": "TNDM",
    " marketcap ": " $3 185 554 176 ",
    "price (USD)": "49.32",
    "country": "United States"
  },
  {
    "Rank": "3411",
    "Name": "Hercules Capital",
    "Symbol": "HTGC",
    " marketcap ": " $3 185 156 096 ",
    "price (USD)": "19.64",
    "country": "United States"
  },
  {
    "Rank": "3412",
    "Name": "Resideo Technologies",
    "Symbol": "REZI",
    " marketcap ": " $3 184 630 528 ",
    "price (USD)": "21.81",
    "country": "United States"
  },
  {
    "Rank": "3413",
    "Name": "SpringWorks Therapeutics",
    "Symbol": "SWTX",
    " marketcap ": " $3 184 233 472 ",
    "price (USD)": "42.98",
    "country": "United States"
  },
  {
    "Rank": "3414",
    "Name": "Life Time Group",
    "Symbol": "LTH",
    " marketcap ": " $3 183 348 480 ",
    "price (USD)": "16.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "3415",
    "Name": "VGP NV",
    "Symbol": "VGP.BR",
    " marketcap ": " $3 182 848 917 ",
    "price (USD)": "116.625",
    "country": "Belgium"
  },
  {
    "Rank": "3416",
    "Name": "Hayward",
    "Symbol": "HAYW",
    " marketcap ": " $3 179 898 368 ",
    "price (USD)": "14.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "3417",
    "Name": "Teradata",
    "Symbol": "TDC",
    " marketcap ": " $3 179 496 192 ",
    "price (USD)": "32.88",
    "country": "United States"
  },
  {
    "Rank": "3418",
    "Name": "Instructure Holdings",
    "Symbol": "INST",
    " marketcap ": " $3 173 934 080 ",
    "price (USD)": "21.75",
    "country": "United States"
  },
  {
    "Rank": "3419",
    "Name": "Coway",
    "Symbol": "021240.KS",
    " marketcap ": " $3 170 791 448 ",
    "price (USD)": "43.6967",
    "country": "South Korea"
  },
  {
    "Rank": "3420",
    "Name": "NextEra Energy Partners",
    "Symbol": "NEP",
    " marketcap ": " $3 170 046 720 ",
    "price (USD)": "33.89",
    "country": "United States"
  },
  {
    "Rank": "3421",
    "Name": "J&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3422",
    "Name": "Grindwell Norton",
    "Symbol": "GRINDWELL.NS",
    " marketcap ": " $3 168 863 991 ",
    "price (USD)": "28.6205",
    "country": "India"
  },
  {
    "Rank": "3423",
    "Name": "Constellium",
    "Symbol": "CSTM",
    " marketcap ": " $3 164 554 496 ",
    "price (USD)": "21.\u0438\u044e\u043b",
    "country": "France"
  },
  {
    "Rank": "3424",
    "Name": "Thyssenkrupp",
    "Symbol": "TKA.F",
    " marketcap ": " $3 161 670 053 ",
    "price (USD)": "5.07873",
    "country": "Germany"
  },
  {
    "Rank": "3425",
    "Name": "First National of Nebraska",
    "Symbol": "FINN",
    " marketcap ": " $3 160 914 432 ",
    "price (USD)": "12101",
    "country": "United States"
  },
  {
    "Rank": "3426",
    "Name": "EPR Properties",
    "Symbol": "EPR",
    " marketcap ": " $3 158 574 336 ",
    "price (USD)": "41.74",
    "country": "United States"
  },
  {
    "Rank": "3427",
    "Name": "Pepco Group",
    "Symbol": "PCO.WA",
    " marketcap ": " $3 158 468 583 ",
    "price (USD)": "\u043c\u0430\u0439.32",
    "country": "United Kingdom"
  },
  {
    "Rank": "3428",
    "Name": "Eramet",
    "Symbol": "ERA.PA",
    " marketcap ": " $3 158 213 817 ",
    "price (USD)": "108.915",
    "country": "France"
  },
  {
    "Rank": "3429",
    "Name": "Envista",
    "Symbol": "NVST",
    " marketcap ": " $3 153 594 368 ",
    "price (USD)": "18.35",
    "country": "United States"
  },
  {
    "Rank": "3430",
    "Name": "Golden Ocean Group",
    "Symbol": "GOGL",
    " marketcap ": " $3 148 133 632 ",
    "price (USD)": "15.77",
    "country": "Bermuda"
  },
  {
    "Rank": "3431",
    "Name": "Amedisys",
    "Symbol": "AMED",
    " marketcap ": " $3 143 844 608 ",
    "price (USD)": "96.21",
    "country": "United States"
  },
  {
    "Rank": "3432",
    "Name": "Credo Technology",
    "Symbol": "CRDO",
    " marketcap ": " $3 143 351 808 ",
    "price (USD)": "19.25",
    "country": "United States"
  },
  {
    "Rank": "3433",
    "Name": "SOL S.p.A.",
    "Symbol": "SOL.MI",
    " marketcap ": " $3 141 850 277 ",
    "price (USD)": "34.64",
    "country": "Italy"
  },
  {
    "Rank": "3434",
    "Name": "Hillenbrand",
    "Symbol": "HI",
    " marketcap ": " $3 141 244 160 ",
    "price (USD)": "44.75",
    "country": "United States"
  },
  {
    "Rank": "3435",
    "Name": "Britvic",
    "Symbol": "BVIC.L",
    " marketcap ": " $3 137 683 136 ",
    "price (USD)": "\u0434\u0435\u043a.72",
    "country": "United Kingdom"
  },
  {
    "Rank": "3436",
    "Name": "EnPro Industries",
    "Symbol": "NPO",
    " marketcap ": " $3 135 691 264 ",
    "price (USD)": "149.66",
    "country": "United States"
  },
  {
    "Rank": "3437",
    "Name": "Soci\u0413\u00a9t\u0413\u00a9 Fonci\u0413\u0401re Lyonnaise",
    "Symbol": "FLY.PA",
    " marketcap ": " $3 124 707 256 ",
    "price (USD)": "72.7549",
    "country": "France"
  },
  {
    "Rank": "3438",
    "Name": "Braskem",
    "Symbol": "BAK",
    " marketcap ": " $3 120 129 792 ",
    "price (USD)": "\u0438\u044e\u043b.83",
    "country": "Brazil"
  },
  {
    "Rank": "3439",
    "Name": "CA Immo",
    "Symbol": "BZY.F",
    " marketcap ": " $3 117 502 061 ",
    "price (USD)": "31.9036",
    "country": "Austria"
  },
  {
    "Rank": "3440",
    "Name": "ACV Auctions",
    "Symbol": "ACVA",
    " marketcap ": " $3 116 861 184 ",
    "price (USD)": "18.88",
    "country": "United States"
  },
  {
    "Rank": "3441",
    "Name": "Ipsos",
    "Symbol": "IPS.PA",
    " marketcap ": " $3 116 743 429 ",
    "price (USD)": "72.5377",
    "country": "France"
  },
  {
    "Rank": "3442",
    "Name": "S\u0413\u0458dzucker",
    "Symbol": "SZU.F",
    " marketcap ": " $3 116 249 165 ",
    "price (USD)": "15.2242",
    "country": "Germany"
  },
  {
    "Rank": "3443",
    "Name": "Fulton Financial",
    "Symbol": "FULT",
    " marketcap ": " $3 115 383 296 ",
    "price (USD)": "17.14",
    "country": "United States"
  },
  {
    "Rank": "3444",
    "Name": "AmTrust Financial Services",
    "Symbol": "AFFS",
    " marketcap ": " $3 113 790 720 ",
    "price (USD)": "15.75",
    "country": "United States"
  },
  {
    "Rank": "3445",
    "Name": "Harbour Energy",
    "Symbol": "HBR.L",
    " marketcap ": " $3 111 693 230 ",
    "price (USD)": "4.07132",
    "country": "United Kingdom"
  },
  {
    "Rank": "3446",
    "Name": "Stadler Rail",
    "Symbol": "SRAIL.SW",
    " marketcap ": " $3 110 896 797 ",
    "price (USD)": "31.1091",
    "country": "Switzerland"
  },
  {
    "Rank": "3447",
    "Name": "Lumentum",
    "Symbol": "LITE",
    " marketcap ": " $3 110 275 840 ",
    "price (USD)": "46.01",
    "country": "United States"
  },
  {
    "Rank": "3448",
    "Name": "RLX Technology",
    "Symbol": "RLX",
    " marketcap ": " $3 110 164 224 ",
    "price (USD)": "\u044f\u043d\u0432.98",
    "country": "China"
  },
  {
    "Rank": "3449",
    "Name": "Blackstone Mortgage Trust",
    "Symbol": "BXMT",
    " marketcap ": " $3 108 889 344 ",
    "price (USD)": "17.91",
    "country": "United States"
  },
  {
    "Rank": "3450",
    "Name": "Petro Rabigh",
    "Symbol": "2380.SR",
    " marketcap ": " $3 108 069 951 ",
    "price (USD)": "1.86001",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3451",
    "Name": "Arrowhead Pharmaceuticals",
    "Symbol": "ARWR",
    " marketcap ": " $3 107 484 160 ",
    "price (USD)": "25.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "3452",
    "Name": "Burford Capital",
    "Symbol": "BUR",
    " marketcap ": " $3 105 766 656 ",
    "price (USD)": "14.17",
    "country": "Guernsey"
  },
  {
    "Rank": "3453",
    "Name": "Visteon",
    "Symbol": "VC",
    " marketcap ": " $3 104 341 504 ",
    "price (USD)": "112.49",
    "country": "United States"
  },
  {
    "Rank": "3454",
    "Name": "IDEAYA Biosciences",
    "Symbol": "IDYA",
    " marketcap ": " $3 103 150 592 ",
    "price (USD)": "41",
    "country": "United States"
  },
  {
    "Rank": "3455",
    "Name": "Genscript Biotech",
    "Symbol": "1548.HK",
    " marketcap ": " $3 102 787 983 ",
    "price (USD)": "\u044f\u043d\u0432.08",
    "country": "China"
  },
  {
    "Rank": "3456",
    "Name": "Thai Oil",
    "Symbol": "TOP.BK",
    " marketcap ": " $3 101 788 070 ",
    "price (USD)": "1.38855",
    "country": "Thailand"
  },
  {
    "Rank": "3457",
    "Name": "Krungthai Card",
    "Symbol": "KTC.BK",
    " marketcap ": " $3 101 595 935 ",
    "price (USD)": "1.20295",
    "country": "Thailand"
  },
  {
    "Rank": "3458",
    "Name": "Arch Resources",
    "Symbol": "ARCH",
    " marketcap ": " $3 101 035 520 ",
    "price (USD)": "171.17",
    "country": "United States"
  },
  {
    "Rank": "3459",
    "Name": "CNO Financial Group",
    "Symbol": "CNO",
    " marketcap ": " $3 098 401 280 ",
    "price (USD)": "28.62",
    "country": "United States"
  },
  {
    "Rank": "3460",
    "Name": "ZF Commercial Vehicle Control Systems India",
    "Symbol": "ZFCVINDIA.NS",
    " marketcap ": " $3 095 365 034 ",
    "price (USD)": "163.192",
    "country": "India"
  },
  {
    "Rank": "3461",
    "Name": "BBVA Argentina",
    "Symbol": "BBAR",
    " marketcap ": " $3 094 797 312 ",
    "price (USD)": "\u043d\u043e\u044f.32",
    "country": "Argentina"
  },
  {
    "Rank": "3462",
    "Name": "Broadstone Net Lease",
    "Symbol": "BNL",
    " marketcap ": " $3 093 083 904 ",
    "price (USD)": "15.68",
    "country": "United States"
  },
  {
    "Rank": "3463",
    "Name": "Osisko Gold Royalties",
    "Symbol": "OR",
    " marketcap ": " $3 092 907 008 ",
    "price (USD)": "16.59",
    "country": "Canada"
  },
  {
    "Rank": "3464",
    "Name": "Mets\u0413\u00a4 Board",
    "Symbol": "METSA.HE",
    " marketcap ": " $3 092 831 378 ",
    "price (USD)": "9.44728",
    "country": "Finland"
  },
  {
    "Rank": "3465",
    "Name": "Steve Madden",
    "Symbol": "SHOO",
    " marketcap ": " $3 089 956 096 ",
    "price (USD)": "42.11",
    "country": "United States"
  },
  {
    "Rank": "3466",
    "Name": "Aedifica",
    "Symbol": "AED.BR",
    " marketcap ": " $3 089 238 649 ",
    "price (USD)": "64.9908",
    "country": "Belgium"
  },
  {
    "Rank": "3467",
    "Name": "Sotera Health",
    "Symbol": "SHC",
    " marketcap ": " $3 082 643 456 ",
    "price (USD)": "\u043e\u043a\u0442.89",
    "country": "United States"
  },
  {
    "Rank": "3468",
    "Name": "Summit Therapeutics",
    "Symbol": "SMMT",
    " marketcap ": " $3 081 692 160 ",
    "price (USD)": "\u0430\u043f\u0440.39",
    "country": "United Kingdom"
  },
  {
    "Rank": "3469",
    "Name": "Big Yellow Group",
    "Symbol": "BYG.L",
    " marketcap ": " $3 078 858 172 ",
    "price (USD)": "15.6884",
    "country": "United Kingdom"
  },
  {
    "Rank": "3470",
    "Name": "California Water Service Group",
    "Symbol": "CWT",
    " marketcap ": " $3 078 293 504 ",
    "price (USD)": "53.3",
    "country": "United States"
  },
  {
    "Rank": "3471",
    "Name": "NOF Corporation",
    "Symbol": "4403.T",
    " marketcap ": " $3 075 043 201 ",
    "price (USD)": "\u0434\u0435\u043a.87",
    "country": "Japan"
  },
  {
    "Rank": "3472",
    "Name": "Tronox",
    "Symbol": "TROX",
    " marketcap ": " $3 074 703 872 ",
    "price (USD)": "19.48",
    "country": "United States"
  },
  {
    "Rank": "3473",
    "Name": "Sega Sammy Holdings",
    "Symbol": "6460.T",
    " marketcap ": " $3 072 800 110 ",
    "price (USD)": "14.2249",
    "country": "Japan"
  },
  {
    "Rank": "3474",
    "Name": "Viscofan",
    "Symbol": "VIS.MC",
    " marketcap ": " $3 069 368 279 ",
    "price (USD)": "67.8684",
    "country": "Spain"
  },
  {
    "Rank": "3475",
    "Name": "Tricon Residential",
    "Symbol": "TCN",
    " marketcap ": " $3 067 177 728 ",
    "price (USD)": "\u043d\u043e\u044f.25",
    "country": "Canada"
  },
  {
    "Rank": "3476",
    "Name": "LEENO Industrial",
    "Symbol": "058470.KQ",
    " marketcap ": " $3 065 561 521 ",
    "price (USD)": "201.959",
    "country": "South Korea"
  },
  {
    "Rank": "3477",
    "Name": "Venture Corporation",
    "Symbol": "V03.SI",
    " marketcap ": " $3 065 247 393 ",
    "price (USD)": "\u043e\u043a\u0442.46",
    "country": "Singapore"
  },
  {
    "Rank": "3478",
    "Name": "UniFirst",
    "Symbol": "UNF",
    " marketcap ": " $3 064 642 304 ",
    "price (USD)": "164.25",
    "country": "United States"
  },
  {
    "Rank": "3479",
    "Name": "Riot Blockchain",
    "Symbol": "RIOT",
    " marketcap ": " $3 064 008 704 ",
    "price (USD)": "\u043e\u043a\u0442.61",
    "country": "United States"
  },
  {
    "Rank": "3480",
    "Name": "ABM Industries",
    "Symbol": "ABM",
    " marketcap ": " $3 062 042 880 ",
    "price (USD)": "48.38",
    "country": "United States"
  },
  {
    "Rank": "3481",
    "Name": "Greif",
    "Symbol": "GEF",
    " marketcap ": " $3 061 873 664 ",
    "price (USD)": "64.68",
    "country": "United States"
  },
  {
    "Rank": "3482",
    "Name": "SkyWest",
    "Symbol": "SKYW",
    " marketcap ": " $3 061 332 480 ",
    "price (USD)": "76.04",
    "country": "United States"
  },
  {
    "Rank": "3483",
    "Name": "Bachoco",
    "Symbol": "BACHOCOB.MX",
    " marketcap ": " $3 060 228 754 ",
    "price (USD)": "05.\u043d\u043e\u044f",
    "country": "Mexico"
  },
  {
    "Rank": "3484",
    "Name": "Ubisoft",
    "Symbol": "UBI.PA",
    " marketcap ": " $3 055 128 574 ",
    "price (USD)": "23.2924",
    "country": "France"
  },
  {
    "Rank": "3485",
    "Name": "Freenet",
    "Symbol": "FNTN.F",
    " marketcap ": " $3 052 500 189 ",
    "price (USD)": "25.3882",
    "country": "Germany"
  },
  {
    "Rank": "3486",
    "Name": "SES S.A.",
    "Symbol": "SESG.PA",
    " marketcap ": " $3 050 974 308 ",
    "price (USD)": "\u043c\u0430\u0439.95",
    "country": "Luxembourg"
  },
  {
    "Rank": "3487",
    "Name": "Ecopro BM",
    "Symbol": "247540.KQ",
    " marketcap ": " $3 050 486 596 ",
    "price (USD)": "149.817",
    "country": "South Korea"
  },
  {
    "Rank": "3488",
    "Name": "Nomad Foods",
    "Symbol": "NOMD",
    " marketcap ": " $3 047 904 768 ",
    "price (USD)": "18.56",
    "country": "United Kingdom"
  },
  {
    "Rank": "3489",
    "Name": "Air France-KLM",
    "Symbol": "AF.PA",
    " marketcap ": " $3 045 720 317 ",
    "price (USD)": "\u043d\u043e\u044f.96",
    "country": "France"
  },
  {
    "Rank": "3490",
    "Name": "Saudia Dairy &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3491",
    "Name": "Construction Partners",
    "Symbol": "ROAD",
    " marketcap ": " $3 043 914 752 ",
    "price (USD)": "57.62",
    "country": "United States"
  },
  {
    "Rank": "3492",
    "Name": "BIC",
    "Symbol": "BB.PA",
    " marketcap ": " $3 040 827 990 ",
    "price (USD)": "72.7549",
    "country": "France"
  },
  {
    "Rank": "3493",
    "Name": "Cranswick",
    "Symbol": "CWK.L",
    " marketcap ": " $3 036 879 535 ",
    "price (USD)": "56.1933",
    "country": "United Kingdom"
  },
  {
    "Rank": "3494",
    "Name": "Bayer Crop Science",
    "Symbol": "BAYERCROP.NS",
    " marketcap ": " $3 032 294 496 ",
    "price (USD)": "67.4192",
    "country": "India"
  },
  {
    "Rank": "3495",
    "Name": "Plexus",
    "Symbol": "PLXS",
    " marketcap ": " $3 031 829 504 ",
    "price (USD)": "110.7",
    "country": "United States"
  },
  {
    "Rank": "3496",
    "Name": "Hagerty",
    "Symbol": "HGTY",
    " marketcap ": " $3 030 632 960 ",
    "price (USD)": "9",
    "country": "United States"
  },
  {
    "Rank": "3497",
    "Name": "Atlantic Union Bankshares",
    "Symbol": "AUB",
    " marketcap ": " $3 029 626 368 ",
    "price (USD)": "33.75",
    "country": "United States"
  },
  {
    "Rank": "3498",
    "Name": "Elekta AB",
    "Symbol": "EKTA-B.ST",
    " marketcap ": " $3 029 211 581 ",
    "price (USD)": "7.92815",
    "country": "Sweden"
  },
  {
    "Rank": "3499",
    "Name": "Arabian Contracting Services Company",
    "Symbol": "4071.SR",
    " marketcap ": " $3 026 178 917 ",
    "price (USD)": "60.5236",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3500",
    "Name": "Vale Indonesia",
    "Symbol": "INCO.JK",
    " marketcap ": " $3 025 507 981 ",
    "price (USD)": "0.304489",
    "country": "Indonesia"
  },
  {
    "Rank": "3501",
    "Name": "Cavco Industries",
    "Symbol": "CVCO",
    " marketcap ": " $3 024 481 024 ",
    "price (USD)": "362.36",
    "country": "United States"
  },
  {
    "Rank": "3502",
    "Name": "Tanger Factory Outlet Centers",
    "Symbol": "SKT",
    " marketcap ": " $3 023 610 368 ",
    "price (USD)": "27.65",
    "country": "United States"
  },
  {
    "Rank": "3503",
    "Name": "Vedant Fashions",
    "Symbol": "MANYAVAR.NS",
    " marketcap ": " $3 017 495 015 ",
    "price (USD)": "\u0434\u0435\u043a.44",
    "country": "India"
  },
  {
    "Rank": "3504",
    "Name": "Green Thumb Industries",
    "Symbol": "GTII.CN",
    " marketcap ": " $3 015 169 107 ",
    "price (USD)": "\u0434\u0435\u043a.04",
    "country": "United States"
  },
  {
    "Rank": "3505",
    "Name": "Capstone Infrastructure",
    "Symbol": "CSE-PA.TO",
    " marketcap ": " $3 014 935 621 ",
    "price (USD)": "9.89772",
    "country": "Canada"
  },
  {
    "Rank": "3506",
    "Name": "Stride (K12 Education)",
    "Symbol": "LRN",
    " marketcap ": " $3 014 866 432 ",
    "price (USD)": "69.7",
    "country": "United States"
  },
  {
    "Rank": "3507",
    "Name": "Software AG",
    "Symbol": "SOW.F",
    " marketcap ": " $3 009 324 617 ",
    "price (USD)": "40.6776",
    "country": "Germany"
  },
  {
    "Rank": "3508",
    "Name": "John Bean Technologies",
    "Symbol": "JBT",
    " marketcap ": " $3 005 839 104 ",
    "price (USD)": "94.43",
    "country": "United States"
  },
  {
    "Rank": "3509",
    "Name": "Corporaci\u0413\u0456n Am\u0413\u00a9rica Airports",
    "Symbol": "CAAP",
    " marketcap ": " $3 005 347 328 ",
    "price (USD)": "18.67",
    "country": "Luxembourg"
  },
  {
    "Rank": "3510",
    "Name": "CVR Energy",
    "Symbol": "CVI",
    " marketcap ": " $3 004 871 424 ",
    "price (USD)": "29.89",
    "country": "United States"
  },
  {
    "Rank": "3511",
    "Name": "Redrow",
    "Symbol": "RDW.L",
    " marketcap ": " $3 004 629 660 ",
    "price (USD)": "9.08374",
    "country": "United Kingdom"
  },
  {
    "Rank": "3512",
    "Name": "Dongfeng Motor",
    "Symbol": "0489.HK",
    " marketcap ": " $3 003 275 915 ",
    "price (USD)": "0.363919",
    "country": "China"
  },
  {
    "Rank": "3513",
    "Name": "Lechwerke",
    "Symbol": "LEC.F",
    " marketcap ": " $3 002 148 889 ",
    "price (USD)": "84.6997",
    "country": "Germany"
  },
  {
    "Rank": "3514",
    "Name": "Medical Properties Trust",
    "Symbol": "MPW",
    " marketcap ": " $3 001 520 128 ",
    "price (USD)": "5",
    "country": "United States"
  },
  {
    "Rank": "3515",
    "Name": "Corcept Therapeutics",
    "Symbol": "CORT",
    " marketcap ": " $2 998 425 600 ",
    "price (USD)": "28.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "3516",
    "Name": "Crompton Greaves Consumer Electricals",
    "Symbol": "CROMPTON.NS",
    " marketcap ": " $2 998 183 325 ",
    "price (USD)": "4.66195",
    "country": "India"
  },
  {
    "Rank": "3517",
    "Name": "BancFirst",
    "Symbol": "BANF",
    " marketcap ": " $2 994 923 008 ",
    "price (USD)": "90.78",
    "country": "United States"
  },
  {
    "Rank": "3518",
    "Name": "Cal-Maine Foods",
    "Symbol": "CALM",
    " marketcap ": " $2 994 768 896 ",
    "price (USD)": "61.07",
    "country": "United States"
  },
  {
    "Rank": "3519",
    "Name": "Uranium Energy",
    "Symbol": "UEC",
    " marketcap ": " $2 994 677 248 ",
    "price (USD)": "\u0438\u044e\u043b.41",
    "country": "United States"
  },
  {
    "Rank": "3520",
    "Name": "Avista",
    "Symbol": "AVA",
    " marketcap ": " $2 994 630 912 ",
    "price (USD)": "38.3",
    "country": "United States"
  },
  {
    "Rank": "3521",
    "Name": "Guoco",
    "Symbol": "0053.HK",
    " marketcap ": " $2 993 699 513 ",
    "price (USD)": "9.09798",
    "country": "Hong Kong"
  },
  {
    "Rank": "3522",
    "Name": "Just Eat Takeaway",
    "Symbol": "TKWY.AS",
    " marketcap ": " $2 992 374 799 ",
    "price (USD)": "14.5293",
    "country": "Netherlands"
  },
  {
    "Rank": "3523",
    "Name": "Grupo Aval",
    "Symbol": "AVAL",
    " marketcap ": " $2 991 668 480 ",
    "price (USD)": "\u0444\u0435\u0432.52",
    "country": "Colombia"
  },
  {
    "Rank": "3524",
    "Name": "Olink Holding",
    "Symbol": "OLK",
    " marketcap ": " $2 987 962 368 ",
    "price (USD)": "24.\u043c\u0430\u0440",
    "country": "Sweden"
  },
  {
    "Rank": "3525",
    "Name": "Mueller Water Products",
    "Symbol": "MWA",
    " marketcap ": " $2 981 903 616 ",
    "price (USD)": "19.15",
    "country": "United States"
  },
  {
    "Rank": "3526",
    "Name": "Phoenix Group",
    "Symbol": "PHX.AE",
    " marketcap ": " $2 981 014 128 ",
    "price (USD)": "0.49",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3527",
    "Name": "Commercial Bank of Kuwait",
    "Symbol": "CBK.KW",
    " marketcap ": " $2 980 408 031 ",
    "price (USD)": "1662.32",
    "country": "Kuwait"
  },
  {
    "Rank": "3528",
    "Name": "Star Bulk Carriers",
    "Symbol": "SBLK",
    " marketcap ": " $2 980 283 392 ",
    "price (USD)": "26.28",
    "country": "Greece"
  },
  {
    "Rank": "3529",
    "Name": "PTC Therapeutics",
    "Symbol": "PTCT",
    " marketcap ": " $2 979 670 528 ",
    "price (USD)": "38.85",
    "country": "United States"
  },
  {
    "Rank": "3530",
    "Name": "MGE Energy",
    "Symbol": "MGEE",
    " marketcap ": " $2 976 552 960 ",
    "price (USD)": "82.28",
    "country": "United States"
  },
  {
    "Rank": "3531",
    "Name": "Deliveroo",
    "Symbol": "ROO.L",
    " marketcap ": " $2 972 440 973 ",
    "price (USD)": "1.79895",
    "country": "United Kingdom"
  },
  {
    "Rank": "3532",
    "Name": "SITE Centers",
    "Symbol": "SITC",
    " marketcap ": " $2 971 222 272 ",
    "price (USD)": "14.17",
    "country": "United States"
  },
  {
    "Rank": "3533",
    "Name": "Welcia Holdings",
    "Symbol": "3141.T",
    " marketcap ": " $2 967 821 130 ",
    "price (USD)": "14.3657",
    "country": "Japan"
  },
  {
    "Rank": "3534",
    "Name": "Encavis",
    "Symbol": "ECV.F",
    " marketcap ": " $2 965 651 723 ",
    "price (USD)": "18.4168",
    "country": "Germany"
  },
  {
    "Rank": "3535",
    "Name": "Peabody Energy",
    "Symbol": "BTU",
    " marketcap ": " $2 963 847 936 ",
    "price (USD)": "23.56",
    "country": "United States"
  },
  {
    "Rank": "3536",
    "Name": "Inter &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3537",
    "Name": "Laurus Labs",
    "Symbol": "LAURUSLABS.NS",
    " marketcap ": " $2 952 990 161 ",
    "price (USD)": "5.47899",
    "country": "India"
  },
  {
    "Rank": "3538",
    "Name": "Abdullah Al-Othaim Markets Company",
    "Symbol": "4001.SR",
    " marketcap ": " $2 949 323 581 ",
    "price (USD)": "3.27703",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3539",
    "Name": "Sylvamo",
    "Symbol": "SLVM",
    " marketcap ": " $2 949 274 624 ",
    "price (USD)": "71.71",
    "country": "United States"
  },
  {
    "Rank": "3540",
    "Name": "Alliance Resource Partners",
    "Symbol": "ARLP",
    " marketcap ": " $2 947 987 200 ",
    "price (USD)": "23.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "3541",
    "Name": "Premium Brands",
    "Symbol": "PBH.TO",
    " marketcap ": " $2 945 476 183 ",
    "price (USD)": "66.3221",
    "country": "Canada"
  },
  {
    "Rank": "3542",
    "Name": "Dialog Group",
    "Symbol": "7277.KL",
    " marketcap ": " $2 945 418 459 ",
    "price (USD)": "0.521999",
    "country": "Malaysia"
  },
  {
    "Rank": "3543",
    "Name": "Trigano",
    "Symbol": "TRI.PA",
    " marketcap ": " $2 943 070 127 ",
    "price (USD)": "152.351",
    "country": "France"
  },
  {
    "Rank": "3544",
    "Name": "Vitesco Technologies Group",
    "Symbol": "VTSC.DE",
    " marketcap ": " $2 942 159 991 ",
    "price (USD)": "73.515",
    "country": "Germany"
  },
  {
    "Rank": "3545",
    "Name": "Xenon Pharmaceuticals",
    "Symbol": "XENE",
    " marketcap ": " $2 941 777 408 ",
    "price (USD)": "38.98",
    "country": "Canada"
  },
  {
    "Rank": "3546",
    "Name": "Worthington Industries",
    "Symbol": "WOR",
    " marketcap ": " $2 939 080 448 ",
    "price (USD)": "58.61",
    "country": "United States"
  },
  {
    "Rank": "3547",
    "Name": "Giant Network Group",
    "Symbol": "002558.SZ",
    " marketcap ": " $2 938 787 067 ",
    "price (USD)": "1.48909",
    "country": "China"
  },
  {
    "Rank": "3548",
    "Name": "Industrie De Nora",
    "Symbol": "DNR.MI",
    " marketcap ": " $2 936 369 482 ",
    "price (USD)": "14.779",
    "country": "Italy"
  },
  {
    "Rank": "3549",
    "Name": "Amicus Therapeutics",
    "Symbol": "FOLD",
    " marketcap ": " $2 935 332 096 ",
    "price (USD)": "\u0441\u0435\u043d.91",
    "country": "United States"
  },
  {
    "Rank": "3550",
    "Name": "Under Armour",
    "Symbol": "UA",
    " marketcap ": " $2 932 911 616 ",
    "price (USD)": "\u0438\u044e\u043d.62",
    "country": "United States"
  },
  {
    "Rank": "3551",
    "Name": "Kansai Paint",
    "Symbol": "4613.T",
    " marketcap ": " $2 932 688 031 ",
    "price (USD)": "14.0554",
    "country": "Japan"
  },
  {
    "Rank": "3552",
    "Name": "Cogent Communications",
    "Symbol": "CCOI",
    " marketcap ": " $2 932 149 504 ",
    "price (USD)": "59.81",
    "country": "United States"
  },
  {
    "Rank": "3553",
    "Name": "Tsuruha Holdings",
    "Symbol": "3391.T",
    " marketcap ": " $2 932 010 073 ",
    "price (USD)": "60.3032",
    "country": "Japan"
  },
  {
    "Rank": "3554",
    "Name": "MP Materials",
    "Symbol": "MP",
    " marketcap ": " $2 921 151 232 ",
    "price (USD)": "17.67",
    "country": "United States"
  },
  {
    "Rank": "3555",
    "Name": "ALSOK",
    "Symbol": "2331.T",
    " marketcap ": " $2 920 623 764 ",
    "price (USD)": "5.83392",
    "country": "Japan"
  },
  {
    "Rank": "3556",
    "Name": "Masonite",
    "Symbol": "DOOR",
    " marketcap ": " $2 920 354 560 ",
    "price (USD)": "132.84",
    "country": "United States"
  },
  {
    "Rank": "3557",
    "Name": "Kosmos Energy",
    "Symbol": "KOS",
    " marketcap ": " $2 918 888 192 ",
    "price (USD)": "\u0438\u044e\u043d.19",
    "country": "United States"
  },
  {
    "Rank": "3558",
    "Name": "First Interstate BancSystem",
    "Symbol": "FIBK",
    " marketcap ": " $2 916 401 408 ",
    "price (USD)": "27.89",
    "country": "United States"
  },
  {
    "Rank": "3559",
    "Name": "St. Galler Kantonalbank",
    "Symbol": "SGKN.SW",
    " marketcap ": " $2 913 315 451 ",
    "price (USD)": "487.211",
    "country": "Switzerland"
  },
  {
    "Rank": "3560",
    "Name": "Brady",
    "Symbol": "BRC",
    " marketcap ": " $2 912 945 664 ",
    "price (USD)": "60.27",
    "country": "United States"
  },
  {
    "Rank": "3561",
    "Name": "Lottomatica Group",
    "Symbol": "LTMC.MI",
    " marketcap ": " $2 912 776 284 ",
    "price (USD)": "\u043d\u043e\u044f.56",
    "country": "Italy"
  },
  {
    "Rank": "3562",
    "Name": "Kingboard Holdings",
    "Symbol": "0148.HK",
    " marketcap ": " $2 911 399 302 ",
    "price (USD)": "2.62688",
    "country": "Hong Kong"
  },
  {
    "Rank": "3563",
    "Name": "Aldrees Petroleum and Transport Services",
    "Symbol": "4200.SR",
    " marketcap ": " $2 908 760 906 ",
    "price (USD)": "29.0876",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3564",
    "Name": "Westports",
    "Symbol": "5246.KL",
    " marketcap ": " $2 906 146 690 ",
    "price (USD)": "0.852242",
    "country": "Malaysia"
  },
  {
    "Rank": "3565",
    "Name": "KLCC Property Holdings",
    "Symbol": "5235SS.KL",
    " marketcap ": " $2 900 221 300 ",
    "price (USD)": "1.60648",
    "country": "Malaysia"
  },
  {
    "Rank": "3566",
    "Name": "American States Water",
    "Symbol": "AWR",
    " marketcap ": " $2 896 408 576 ",
    "price (USD)": "77.8",
    "country": "United States"
  },
  {
    "Rank": "3567",
    "Name": "Neogen",
    "Symbol": "NEOG",
    " marketcap ": " $2 896 048 896 ",
    "price (USD)": "13.37",
    "country": "United States"
  },
  {
    "Rank": "3568",
    "Name": "SoftwareONE",
    "Symbol": "SWON.SW",
    " marketcap ": " $2 895 301 823 ",
    "price (USD)": "18.7861",
    "country": "Switzerland"
  },
  {
    "Rank": "3569",
    "Name": "Leejam Sports Company",
    "Symbol": "1830.SR",
    " marketcap ": " $2 893 646 980 ",
    "price (USD)": "55.2398",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3570",
    "Name": "Iovance Biotherapeutics",
    "Symbol": "IOVA",
    " marketcap ": " $2 887 876 352 ",
    "price (USD)": "\u043e\u043a\u0442.32",
    "country": "United States"
  },
  {
    "Rank": "3571",
    "Name": "Tradegate Exchange",
    "Symbol": "T2G.F",
    " marketcap ": " $2 886 765 972 ",
    "price (USD)": "118.362",
    "country": "Germany"
  },
  {
    "Rank": "3572",
    "Name": "Guardant Health",
    "Symbol": "GH",
    " marketcap ": " $2 884 237 312 ",
    "price (USD)": "23.57",
    "country": "United States"
  },
  {
    "Rank": "3573",
    "Name": "Kohl's",
    "Symbol": "KSS",
    " marketcap ": " $2 882 472 960 ",
    "price (USD)": "25.99",
    "country": "United States"
  },
  {
    "Rank": "3574",
    "Name": "Alm. Brand",
    "Symbol": "ALMB.CO",
    " marketcap ": " $2 882 353 550 ",
    "price (USD)": "1.89883",
    "country": "Denmark"
  },
  {
    "Rank": "3575",
    "Name": "SiTime",
    "Symbol": "SITM",
    " marketcap ": " $2 882 266 368 ",
    "price (USD)": "126.02",
    "country": "United States"
  },
  {
    "Rank": "3576",
    "Name": "Highwoods Properties",
    "Symbol": "HIW",
    " marketcap ": " $2 882 117 632 ",
    "price (USD)": "26.65",
    "country": "United States"
  },
  {
    "Rank": "3577",
    "Name": "CONSOL Energy",
    "Symbol": "CEIX",
    " marketcap ": " $2 879 730 176 ",
    "price (USD)": "97.99",
    "country": "United States"
  },
  {
    "Rank": "3578",
    "Name": "Dubai Financial Market (DFM)",
    "Symbol": "DFM.AE",
    " marketcap ": " $2 873 745 158 ",
    "price (USD)": "0.359409",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3579",
    "Name": "Zain Saudi Arabia",
    "Symbol": "7030.SR",
    " marketcap ": " $2 873 208 243 ",
    "price (USD)": "3.19697",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3580",
    "Name": "Strategic Education",
    "Symbol": "STRA",
    " marketcap ": " $2 871 741 952 ",
    "price (USD)": "116.7",
    "country": "United States"
  },
  {
    "Rank": "3581",
    "Name": "Sydbank A/S",
    "Symbol": "SYDB.CO",
    " marketcap ": " $2 868 236 420 ",
    "price (USD)": "53.3128",
    "country": "Denmark"
  },
  {
    "Rank": "3582",
    "Name": "Boardwalk Real Estate Investment Trust",
    "Symbol": "BEI-UN.TO",
    " marketcap ": " $2 867 118 355 ",
    "price (USD)": "53.2278",
    "country": "Canada"
  },
  {
    "Rank": "3583",
    "Name": "10x Genomics",
    "Symbol": "TXG",
    " marketcap ": " $2 867 006 720 ",
    "price (USD)": "23.95",
    "country": "United States"
  },
  {
    "Rank": "3584",
    "Name": "Ibotta",
    "Symbol": "IBTA",
    " marketcap ": " $2 865 684 992 ",
    "price (USD)": "105.73",
    "country": "United States"
  },
  {
    "Rank": "3585",
    "Name": "Kerry Properties",
    "Symbol": "0683.HK",
    " marketcap ": " $2 863 963 690 ",
    "price (USD)": "1.97336",
    "country": "Hong Kong"
  },
  {
    "Rank": "3586",
    "Name": "Manchester United",
    "Symbol": "MANU",
    " marketcap ": " $2 863 202 304 ",
    "price (USD)": "16.92",
    "country": "United Kingdom"
  },
  {
    "Rank": "3587",
    "Name": "National Health Investors",
    "Symbol": "NHI",
    " marketcap ": " $2 861 694 464 ",
    "price (USD)": "65.9",
    "country": "United States"
  },
  {
    "Rank": "3588",
    "Name": "COPT Defense Properties",
    "Symbol": "CDP",
    " marketcap ": " $2 861 579 776 ",
    "price (USD)": "24.99",
    "country": "United States"
  },
  {
    "Rank": "3589",
    "Name": "LifeStance Health Group",
    "Symbol": "LFST",
    " marketcap ": " $2 859 514 368 ",
    "price (USD)": "\u0438\u044e\u043b.48",
    "country": "United States"
  },
  {
    "Rank": "3590",
    "Name": "Global Business Travel Group",
    "Symbol": "GBTG",
    " marketcap ": " $2 859 332 864 ",
    "price (USD)": "06.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "3591",
    "Name": "SmartCentres REIT",
    "Symbol": "SRU-UN.TO",
    " marketcap ": " $2 859 096 102 ",
    "price (USD)": "16.7895",
    "country": "Canada"
  },
  {
    "Rank": "3592",
    "Name": "Genworth Financial",
    "Symbol": "GNW",
    " marketcap ": " $2 858 318 080 ",
    "price (USD)": "\u0438\u044e\u043d.53",
    "country": "United States"
  },
  {
    "Rank": "3593",
    "Name": "HELLENiQ ENERGY",
    "Symbol": "ELPE.AT",
    " marketcap ": " $2 855 890 021 ",
    "price (USD)": "9.34412",
    "country": "Greece"
  },
  {
    "Rank": "3594",
    "Name": "Taiba Investments",
    "Symbol": "4090.SR",
    " marketcap ": " $2 853 190 058 ",
    "price (USD)": "\u043e\u043a\u0442.46",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3595",
    "Name": "Dorman Products",
    "Symbol": "DORM",
    " marketcap ": " $2 852 575 744 ",
    "price (USD)": "91.98",
    "country": "United States"
  },
  {
    "Rank": "3596",
    "Name": "Baytex Energy",
    "Symbol": "BTE",
    " marketcap ": " $2 851 330 560 ",
    "price (USD)": "\u043c\u0430\u0440.46",
    "country": "Canada"
  },
  {
    "Rank": "3597",
    "Name": "ESCO Technologies",
    "Symbol": "ESE",
    " marketcap ": " $2 850 131 712 ",
    "price (USD)": "110.68",
    "country": "United States"
  },
  {
    "Rank": "3598",
    "Name": "Arcellx",
    "Symbol": "ACLX",
    " marketcap ": " $2 850 083 584 ",
    "price (USD)": "53.27",
    "country": "United States"
  },
  {
    "Rank": "3599",
    "Name": "Denali Therapeutics",
    "Symbol": "DNLI",
    " marketcap ": " $2 849 327 616 ",
    "price (USD)": "19.98",
    "country": "United States"
  },
  {
    "Rank": "3600",
    "Name": "Texas Capital Bancshares",
    "Symbol": "TCBI",
    " marketcap ": " $2 848 171 776 ",
    "price (USD)": "61.05",
    "country": "United States"
  },
  {
    "Rank": "3601",
    "Name": "RAKBANK (The National Bank of Ras Al Khaimah)",
    "Symbol": "RAKBANK.AE",
    " marketcap ": " $2 847 978 726 ",
    "price (USD)": "\u044f\u043d\u0432.42",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3602",
    "Name": "ZhongAn Insurance",
    "Symbol": "6060.HK",
    " marketcap ": " $2 847 735 428 ",
    "price (USD)": "1.93749",
    "country": "China"
  },
  {
    "Rank": "3603",
    "Name": "USA Compression Partners",
    "Symbol": "USAC",
    " marketcap ": " $2 847 633 920 ",
    "price (USD)": "24.34",
    "country": "United States"
  },
  {
    "Rank": "3604",
    "Name": "DXC Technology",
    "Symbol": "DXC",
    " marketcap ": " $2 846 505 728 ",
    "price (USD)": "15.91",
    "country": "United States"
  },
  {
    "Rank": "3605",
    "Name": "iRhythm",
    "Symbol": "IRTC",
    " marketcap ": " $2 846 098 432 ",
    "price (USD)": "91.5",
    "country": "United States"
  },
  {
    "Rank": "3606",
    "Name": "Gulfport Energy",
    "Symbol": "GPOR",
    " marketcap ": " $2 846 012 928 ",
    "price (USD)": "157.05",
    "country": "United States"
  },
  {
    "Rank": "3607",
    "Name": "QuantumScape",
    "Symbol": "QS",
    " marketcap ": " $2 842 337 024 ",
    "price (USD)": "\u043c\u0430\u0439.69",
    "country": "United States"
  },
  {
    "Rank": "3608",
    "Name": "Orange Polska",
    "Symbol": "OPL.WA",
    " marketcap ": " $2 842 172 724 ",
    "price (USD)": "2.1657",
    "country": "Poland"
  },
  {
    "Rank": "3609",
    "Name": "Brinker International",
    "Symbol": "EAT",
    " marketcap ": " $2 840 273 408 ",
    "price (USD)": "63.84",
    "country": "United States"
  },
  {
    "Rank": "3610",
    "Name": "SJM Holdings",
    "Symbol": "0880.HK",
    " marketcap ": " $2 839 293 519 ",
    "price (USD)": "0.399799",
    "country": "Hong Kong"
  },
  {
    "Rank": "3611",
    "Name": "Emami",
    "Symbol": "EMAMILTD.NS",
    " marketcap ": " $2 833 942 120 ",
    "price (USD)": "6.46966",
    "country": "India"
  },
  {
    "Rank": "3612",
    "Name": "Albany International",
    "Symbol": "AIN",
    " marketcap ": " $2 833 766 144 ",
    "price (USD)": "90.72",
    "country": "United States"
  },
  {
    "Rank": "3613",
    "Name": "Thai Life Insurance",
    "Symbol": "TLI.BK",
    " marketcap ": " $2 833 457 210 ",
    "price (USD)": "0.247464",
    "country": "Thailand"
  },
  {
    "Rank": "3614",
    "Name": "Comg\u0413\u040es",
    "Symbol": "CGAS5.SA",
    " marketcap ": " $2 833 097 652 ",
    "price (USD)": "22.448",
    "country": "Brazil"
  },
  {
    "Rank": "3615",
    "Name": "Ratnamani Metals &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3616",
    "Name": "Agilysys",
    "Symbol": "AGYS",
    " marketcap ": " $2 828 033 792 ",
    "price (USD)": "103.3",
    "country": "United States"
  },
  {
    "Rank": "3617",
    "Name": "Golar LNG",
    "Symbol": "GLNG",
    " marketcap ": " $2 825 400 320 ",
    "price (USD)": "27.\u0444\u0435\u0432",
    "country": "Bermuda"
  },
  {
    "Rank": "3618",
    "Name": "Avidity Biosciences",
    "Symbol": "RNA",
    " marketcap ": " $2 822 242 048 ",
    "price (USD)": "29.51",
    "country": "United States"
  },
  {
    "Rank": "3619",
    "Name": "New York Community Bank",
    "Symbol": "NYCB",
    " marketcap ": " $2 815 056 128 ",
    "price (USD)": "\u043c\u0430\u0440.43",
    "country": "United States"
  },
  {
    "Rank": "3620",
    "Name": "SATS",
    "Symbol": "S58.SI",
    " marketcap ": " $2 810 943 290 ",
    "price (USD)": "1.88574",
    "country": "Singapore"
  },
  {
    "Rank": "3621",
    "Name": "Primoris Services Corporation",
    "Symbol": "PRIM",
    " marketcap ": " $2 810 741 248 ",
    "price (USD)": "52.4",
    "country": "United States"
  },
  {
    "Rank": "3622",
    "Name": "Douglas Emmett",
    "Symbol": "DEI",
    " marketcap ": " $2 809 372 672 ",
    "price (USD)": "14.17",
    "country": "United States"
  },
  {
    "Rank": "3623",
    "Name": "Intapp",
    "Symbol": "INTA",
    " marketcap ": " $2 807 982 336 ",
    "price (USD)": "38.24",
    "country": "United States"
  },
  {
    "Rank": "3624",
    "Name": "Golub Capital",
    "Symbol": "GBDC",
    " marketcap ": " $2 804 302 848 ",
    "price (USD)": "16.35",
    "country": "United States"
  },
  {
    "Rank": "3625",
    "Name": "LCI Industries",
    "Symbol": "LCII",
    " marketcap ": " $2 804 058 880 ",
    "price (USD)": "110.18",
    "country": "United States"
  },
  {
    "Rank": "3626",
    "Name": "Morphosys",
    "Symbol": "MOR",
    " marketcap ": " $2 803 709 696 ",
    "price (USD)": "18.51",
    "country": "Germany"
  },
  {
    "Rank": "3627",
    "Name": "L.D.C. S.A.",
    "Symbol": "LOUP.PA",
    " marketcap ": " $2 800 766 207 ",
    "price (USD)": "160.712",
    "country": "France"
  },
  {
    "Rank": "3628",
    "Name": "Cenomi Centers (Arabian Centres Company)",
    "Symbol": "4321.SR",
    " marketcap ": " $2 793 744 881 ",
    "price (USD)": "5.88157",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3629",
    "Name": "E-L Financial",
    "Symbol": "ELF.TO",
    " marketcap ": " $2 791 811 993 ",
    "price (USD)": "806.481",
    "country": "Canada"
  },
  {
    "Rank": "3630",
    "Name": "Uniqa Insurance Group",
    "Symbol": "UN9.F",
    " marketcap ": " $2 786 921 525 ",
    "price (USD)": "8.95863",
    "country": "Austria"
  },
  {
    "Rank": "3631",
    "Name": "Granite Construction",
    "Symbol": "GVA",
    " marketcap ": " $2 780 636 160 ",
    "price (USD)": "62.98",
    "country": "United States"
  },
  {
    "Rank": "3632",
    "Name": "Koei Tecmo",
    "Symbol": "3635.T",
    " marketcap ": " $2 780 328 254 ",
    "price (USD)": "8.80302",
    "country": "Japan"
  },
  {
    "Rank": "3633",
    "Name": "Azenta",
    "Symbol": "AZTA",
    " marketcap ": " $2 779 519 232 ",
    "price (USD)": "51.55",
    "country": "United States"
  },
  {
    "Rank": "3634",
    "Name": "Kumho Petrochemical",
    "Symbol": "011780.KS",
    " marketcap ": " $2 778 852 045 ",
    "price (USD)": "112.73",
    "country": "South Korea"
  },
  {
    "Rank": "3635",
    "Name": "NuStar Energy",
    "Symbol": "NS",
    " marketcap ": " $2 778 708 480 ",
    "price (USD)": "21.96",
    "country": "United States"
  },
  {
    "Rank": "3636",
    "Name": "Central Garden &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3637",
    "Name": "Lendlease",
    "Symbol": "LLC.AX",
    " marketcap ": " $2 778 155 126 ",
    "price (USD)": "4.02753",
    "country": "Australia"
  },
  {
    "Rank": "3638",
    "Name": "Frasers Logistics &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3639",
    "Name": "InterDigital",
    "Symbol": "IDCC",
    " marketcap ": " $2 775 905 024 ",
    "price (USD)": "110",
    "country": "United States"
  },
  {
    "Rank": "3640",
    "Name": "Marqeta",
    "Symbol": "MQ",
    " marketcap ": " $2 775 086 592 ",
    "price (USD)": "\u043c\u0430\u0439.41",
    "country": "United States"
  },
  {
    "Rank": "3641",
    "Name": "Apogee Therapeutics",
    "Symbol": "APGE",
    " marketcap ": " $2 773 859 328 ",
    "price (USD)": "49.21",
    "country": "United States"
  },
  {
    "Rank": "3642",
    "Name": "Brighthouse Financial",
    "Symbol": "BHF",
    " marketcap ": " $2 772 648 448 ",
    "price (USD)": "44.64",
    "country": "United States"
  },
  {
    "Rank": "3643",
    "Name": "TAG Immobilien",
    "Symbol": "TEG.F",
    " marketcap ": " $2 772 462 765 ",
    "price (USD)": "15.6043",
    "country": "Germany"
  },
  {
    "Rank": "3644",
    "Name": "Alkami Technology",
    "Symbol": "ALKT",
    " marketcap ": " $2 771 390 720 ",
    "price (USD)": "28.42",
    "country": "United States"
  },
  {
    "Rank": "3645",
    "Name": "Frontdoor",
    "Symbol": "FTDR",
    " marketcap ": " $2 770 112 768 ",
    "price (USD)": "35.61",
    "country": "United States"
  },
  {
    "Rank": "3646",
    "Name": "QuidelOrtho",
    "Symbol": "QDEL",
    " marketcap ": " $2 769 283 840 ",
    "price (USD)": "41.35",
    "country": "United States"
  },
  {
    "Rank": "3647",
    "Name": "BBB Foods",
    "Symbol": "TBBB",
    " marketcap ": " $2 767 998 720 ",
    "price (USD)": "24.67",
    "country": "Mexico"
  },
  {
    "Rank": "3648",
    "Name": "McGrath RentCorp",
    "Symbol": "MGRC",
    " marketcap ": " $2 767 375 104 ",
    "price (USD)": "112.73",
    "country": "United States"
  },
  {
    "Rank": "3649",
    "Name": "Advanced Petrochemical",
    "Symbol": "2330.SR",
    " marketcap ": " $2 764 924 062 ",
    "price (USD)": "\u043e\u043a\u0442.43",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3650",
    "Name": "First Hawaiian Bank",
    "Symbol": "FHB",
    " marketcap ": " $2 763 944 192 ",
    "price (USD)": "21.62",
    "country": "United States"
  },
  {
    "Rank": "3651",
    "Name": "Enovis",
    "Symbol": "ENOV",
    " marketcap ": " $2 763 936 768 ",
    "price (USD)": "50.39",
    "country": "United States"
  },
  {
    "Rank": "3652",
    "Name": "Century Communities",
    "Symbol": "CCS",
    " marketcap ": " $2 762 938 624 ",
    "price (USD)": "86.91",
    "country": "United States"
  },
  {
    "Rank": "3653",
    "Name": "Allreal Holding",
    "Symbol": "ALLN.SW",
    " marketcap ": " $2 761 046 985 ",
    "price (USD)": "167.232",
    "country": "Switzerland"
  },
  {
    "Rank": "3654",
    "Name": "Maravai LifeSciences",
    "Symbol": "MRVI",
    " marketcap ": " $2 758 578 688 ",
    "price (USD)": "\u043e\u043a\u0442.95",
    "country": "United States"
  },
  {
    "Rank": "3655",
    "Name": "Spectrum Brands",
    "Symbol": "SPB",
    " marketcap ": " $2 756 490 240 ",
    "price (USD)": "94.56",
    "country": "United States"
  },
  {
    "Rank": "3656",
    "Name": "Federated Hermes",
    "Symbol": "FHI",
    " marketcap ": " $2 755 365 888 ",
    "price (USD)": "32.74",
    "country": "United States"
  },
  {
    "Rank": "3657",
    "Name": "SolarEdge",
    "Symbol": "SEDG",
    " marketcap ": " $2 753 348 864 ",
    "price (USD)": "48.48",
    "country": "Israel"
  },
  {
    "Rank": "3658",
    "Name": "Leroy Seafood",
    "Symbol": "LSG.OL",
    " marketcap ": " $2 749 555 554 ",
    "price (USD)": "4.61741",
    "country": "Norway"
  },
  {
    "Rank": "3659",
    "Name": "Aixtron",
    "Symbol": "AIXA.F",
    " marketcap ": " $2 747 178 560 ",
    "price (USD)": "24.4109",
    "country": "Germany"
  },
  {
    "Rank": "3660",
    "Name": "Hatsun Agro Products",
    "Symbol": "HATSUN.NS",
    " marketcap ": " $2 745 442 098 ",
    "price (USD)": "\u0434\u0435\u043a.53",
    "country": "India"
  },
  {
    "Rank": "3661",
    "Name": "Migros Ticaret A.S.",
    "Symbol": "MGROS.IS",
    " marketcap ": " $2 745 251 467 ",
    "price (USD)": "15.4148",
    "country": "Turkey"
  },
  {
    "Rank": "3662",
    "Name": "Acerinox",
    "Symbol": "ACX.MC",
    " marketcap ": " $2 744 252 449 ",
    "price (USD)": "11.011",
    "country": "Spain"
  },
  {
    "Rank": "3663",
    "Name": "China Gold International Resources",
    "Symbol": "CGG.TO",
    " marketcap ": " $2 743 610 907 ",
    "price (USD)": "6.92107",
    "country": "Canada"
  },
  {
    "Rank": "3664",
    "Name": "Kojamo",
    "Symbol": "KOJAMO.HE",
    " marketcap ": " $2 742 764 374 ",
    "price (USD)": "11.0978",
    "country": "Finland"
  },
  {
    "Rank": "3665",
    "Name": "Lojas Renner",
    "Symbol": "LREN3.SA",
    " marketcap ": " $2 741 904 180 ",
    "price (USD)": "2.75451",
    "country": "Brazil"
  },
  {
    "Rank": "3666",
    "Name": "Radico Khaitan",
    "Symbol": "RADICO.NS",
    " marketcap ": " $2 741 156 867 ",
    "price (USD)": "20.4982",
    "country": "India"
  },
  {
    "Rank": "3667",
    "Name": "Dunelm Group",
    "Symbol": "DNLM.L",
    " marketcap ": " $2 740 466 054 ",
    "price (USD)": "13.5551",
    "country": "United Kingdom"
  },
  {
    "Rank": "3668",
    "Name": "VisEra Technologies",
    "Symbol": "6789.TW",
    " marketcap ": " $2 740 173 149 ",
    "price (USD)": "8.65197",
    "country": "Taiwan"
  },
  {
    "Rank": "3669",
    "Name": "Aarti Industries",
    "Symbol": "AARTIIND.NS",
    " marketcap ": " $2 739 676 092 ",
    "price (USD)": "7.55764",
    "country": "India"
  },
  {
    "Rank": "3670",
    "Name": "CJ Group",
    "Symbol": "001040.KS",
    " marketcap ": " $2 738 320 278 ",
    "price (USD)": "101.2",
    "country": "South Korea"
  },
  {
    "Rank": "3671",
    "Name": "Topgolf Callaway Brands",
    "Symbol": "MODG",
    " marketcap ": " $2 737 028 608 ",
    "price (USD)": "14.91",
    "country": "United States"
  },
  {
    "Rank": "3672",
    "Name": "Metcash",
    "Symbol": "MTS.AX",
    " marketcap ": " $2 736 735 730 ",
    "price (USD)": "\u0444\u0435\u0432.72",
    "country": "Australia"
  },
  {
    "Rank": "3673",
    "Name": "MultiChoice Group",
    "Symbol": "MCG.JO",
    " marketcap ": " $2 734 535 900 ",
    "price (USD)": "6.37623",
    "country": "South Africa"
  },
  {
    "Rank": "3674",
    "Name": "Dream Industrial REIT",
    "Symbol": "DIR-UN.TO",
    " marketcap ": " $2 734 130 489 ",
    "price (USD)": "9.48715",
    "country": "Canada"
  },
  {
    "Rank": "3675",
    "Name": "JBM Auto",
    "Symbol": "JBMA.NS",
    " marketcap ": " $2 732 580 499 ",
    "price (USD)": "23.1091",
    "country": "India"
  },
  {
    "Rank": "3676",
    "Name": "Gibson Energy",
    "Symbol": "GEI.TO",
    " marketcap ": " $2 730 470 343 ",
    "price (USD)": "16.8041",
    "country": "Canada"
  },
  {
    "Rank": "3677",
    "Name": "ORION",
    "Symbol": "271560.KS",
    " marketcap ": " $2 728 806 811 ",
    "price (USD)": "69.0334",
    "country": "South Korea"
  },
  {
    "Rank": "3678",
    "Name": "dLocal",
    "Symbol": "DLO",
    " marketcap ": " $2 722 380 032 ",
    "price (USD)": "\u0441\u0435\u043d.42",
    "country": "Uruguay"
  },
  {
    "Rank": "3679",
    "Name": "CDSL",
    "Symbol": "CDSL.NS",
    " marketcap ": " $2 722 333 781 ",
    "price (USD)": "26.051",
    "country": "India"
  },
  {
    "Rank": "3680",
    "Name": "WSFS Financial",
    "Symbol": "WSFS",
    " marketcap ": " $2 721 042 688 ",
    "price (USD)": "45.28",
    "country": "United States"
  },
  {
    "Rank": "3681",
    "Name": "Aritzia",
    "Symbol": "ATZ.TO",
    " marketcap ": " $2 719 371 848 ",
    "price (USD)": "24.4144",
    "country": "Canada"
  },
  {
    "Rank": "3682",
    "Name": "Cathay General Bancorp",
    "Symbol": "CATY",
    " marketcap ": " $2 714 483 456 ",
    "price (USD)": "37.28",
    "country": "United States"
  },
  {
    "Rank": "3683",
    "Name": "ICF International",
    "Symbol": "ICFI",
    " marketcap ": " $2 711 748 096 ",
    "price (USD)": "144.73",
    "country": "United States"
  },
  {
    "Rank": "3684",
    "Name": "Samyang Foods",
    "Symbol": "003230.KS",
    " marketcap ": " $2 711 230 692 ",
    "price (USD)": "363.527",
    "country": "South Korea"
  },
  {
    "Rank": "3685",
    "Name": "NMI Holdings",
    "Symbol": "NMIH",
    " marketcap ": " $2 710 893 568 ",
    "price (USD)": "33.77",
    "country": "United States"
  },
  {
    "Rank": "3686",
    "Name": "Expro Group",
    "Symbol": "XPRO",
    " marketcap ": " $2 709 329 664 ",
    "price (USD)": "23.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "3687",
    "Name": "Kadokawa",
    "Symbol": "9468.T",
    " marketcap ": " $2 706 388 208 ",
    "price (USD)": "20.1523",
    "country": "Japan"
  },
  {
    "Rank": "3688",
    "Name": "Shangri-La",
    "Symbol": "0069.HK",
    " marketcap ": " $2 706 163 927 ",
    "price (USD)": "0.754748",
    "country": "Hong Kong"
  },
  {
    "Rank": "3689",
    "Name": "BillerudKorsn\u0413\u00a4s",
    "Symbol": "BILL.ST",
    " marketcap ": " $2 701 083 198 ",
    "price (USD)": "\u043e\u043a\u0442.73",
    "country": "Sweden"
  },
  {
    "Rank": "3690",
    "Name": "Paytm",
    "Symbol": "PAYTM.NS",
    " marketcap ": " $2 700 097 944 ",
    "price (USD)": "4.24622",
    "country": "India"
  },
  {
    "Rank": "3691",
    "Name": "Sacyr",
    "Symbol": "SCYR.MC",
    " marketcap ": " $2 697 501 105 ",
    "price (USD)": "3.99609",
    "country": "Spain"
  },
  {
    "Rank": "3692",
    "Name": "Remitly",
    "Symbol": "RELY",
    " marketcap ": " $2 696 658 688 ",
    "price (USD)": "14.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "3693",
    "Name": "Mitra Keluarga",
    "Symbol": "MIKA.JK",
    " marketcap ": " $2 695 589 022 ",
    "price (USD)": "0.193823",
    "country": "Indonesia"
  },
  {
    "Rank": "3694",
    "Name": "QinetiQ",
    "Symbol": "QQ.L",
    " marketcap ": " $2 695 327 165 ",
    "price (USD)": "4.72431",
    "country": "United Kingdom"
  },
  {
    "Rank": "3695",
    "Name": "Toyo Tire",
    "Symbol": "5105.T",
    " marketcap ": " $2 692 543 932 ",
    "price (USD)": "17.4877",
    "country": "Japan"
  },
  {
    "Rank": "3696",
    "Name": "Empire State Realty Trust",
    "Symbol": "ESRT",
    " marketcap ": " $2 690 219 520 ",
    "price (USD)": "\u0441\u0435\u043d.35",
    "country": "United States"
  },
  {
    "Rank": "3697",
    "Name": "GoodRx",
    "Symbol": "GDRX",
    " marketcap ": " $2 686 467 584 ",
    "price (USD)": "\u0438\u044e\u043b.16",
    "country": "United States"
  },
  {
    "Rank": "3698",
    "Name": "Dream Finders Homes",
    "Symbol": "DFH",
    " marketcap ": " $2 686 250 240 ",
    "price (USD)": "28.66",
    "country": "United States"
  },
  {
    "Rank": "3699",
    "Name": "Saudi Ground Services Company",
    "Symbol": "4031.SR",
    " marketcap ": " $2 684 065 963 ",
    "price (USD)": "14.2769",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3700",
    "Name": "Minerals Technologies",
    "Symbol": "MTX",
    " marketcap ": " $2 682 405 376 ",
    "price (USD)": "83.18",
    "country": "United States"
  },
  {
    "Rank": "3701",
    "Name": "Interroll",
    "Symbol": "INRN.SW",
    " marketcap ": " $2 681 198 503 ",
    "price (USD)": "3253.56",
    "country": "Switzerland"
  },
  {
    "Rank": "3702",
    "Name": "TAV Airports Holding",
    "Symbol": "TAVHL.IS",
    " marketcap ": " $2 678 925 050 ",
    "price (USD)": "7.37425",
    "country": "Turkey"
  },
  {
    "Rank": "3703",
    "Name": "Intercorp Financial Services",
    "Symbol": "IFS",
    " marketcap ": " $2 678 834 944 ",
    "price (USD)": "22.96",
    "country": "Peru"
  },
  {
    "Rank": "3704",
    "Name": "Marel",
    "Symbol": "MAREL.AS",
    " marketcap ": " $2 677 185 119 ",
    "price (USD)": "3.55087",
    "country": "Iceland"
  },
  {
    "Rank": "3705",
    "Name": "K+S",
    "Symbol": "SDF.F",
    " marketcap ": " $2 667 342 921 ",
    "price (USD)": "14.7953",
    "country": "Germany"
  },
  {
    "Rank": "3706",
    "Name": "Muangthai Capital",
    "Symbol": "MTC.BK",
    " marketcap ": " $2 666 831 804 ",
    "price (USD)": "1.25794",
    "country": "Thailand"
  },
  {
    "Rank": "3707",
    "Name": "Old Mutual",
    "Symbol": "OMU.JO",
    " marketcap ": " $2 666 823 000 ",
    "price (USD)": "0.608842",
    "country": "South Africa"
  },
  {
    "Rank": "3708",
    "Name": "Multiplan Empreendimentos Imobili\u0413\u040erios",
    "Symbol": "MULT3.SA",
    " marketcap ": " $2 666 695 902 ",
    "price (USD)": "4.58175",
    "country": "Brazil"
  },
  {
    "Rank": "3709",
    "Name": "KOBAYASHI Pharmaceutical",
    "Symbol": "4967.T",
    " marketcap ": " $2 658 527 557 ",
    "price (USD)": "35.7623",
    "country": "Japan"
  },
  {
    "Rank": "3710",
    "Name": "Inari Medical",
    "Symbol": "NARI",
    " marketcap ": " $2 658 078 464 ",
    "price (USD)": "45.72",
    "country": "United States"
  },
  {
    "Rank": "3711",
    "Name": "Certara",
    "Symbol": "CERT",
    " marketcap ": " $2 653 876 480 ",
    "price (USD)": "16.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "3712",
    "Name": "Sunrun",
    "Symbol": "RUN",
    " marketcap ": " $2 653 306 368 ",
    "price (USD)": "\u043d\u043e\u044f.97",
    "country": "United States"
  },
  {
    "Rank": "3713",
    "Name": "CGN Mining Company",
    "Symbol": "1164.HK",
    " marketcap ": " $2 649 158 737 ",
    "price (USD)": "0.348542",
    "country": "Hong Kong"
  },
  {
    "Rank": "3714",
    "Name": "Maruwa",
    "Symbol": "5344.T",
    " marketcap ": " $2 648 177 053 ",
    "price (USD)": "214.638",
    "country": "Japan"
  },
  {
    "Rank": "3715",
    "Name": "MYR Group",
    "Symbol": "MYRG",
    " marketcap ": " $2 646 250 752 ",
    "price (USD)": "157.84",
    "country": "United States"
  },
  {
    "Rank": "3716",
    "Name": "Silicon Motion",
    "Symbol": "SIMO",
    " marketcap ": " $2 645 016 064 ",
    "price (USD)": "78.53",
    "country": "Hong Kong"
  },
  {
    "Rank": "3717",
    "Name": "Atlantica",
    "Symbol": "AY",
    " marketcap ": " $2 642 617 344 ",
    "price (USD)": "22.75",
    "country": "United Kingdom"
  },
  {
    "Rank": "3718",
    "Name": "Evolent Health",
    "Symbol": "EVH",
    " marketcap ": " $2 635 254 528 ",
    "price (USD)": "22.98",
    "country": "United States"
  },
  {
    "Rank": "3719",
    "Name": "Iren",
    "Symbol": "IRE.MI",
    " marketcap ": " $2 634 272 803 ",
    "price (USD)": "2.00999",
    "country": "Italy"
  },
  {
    "Rank": "3720",
    "Name": "Aroundtown",
    "Symbol": "AT1.F",
    " marketcap ": " $2 633 398 528 ",
    "price (USD)": "2.36942",
    "country": "Luxembourg"
  },
  {
    "Rank": "3721",
    "Name": "Rand Merchant Investment",
    "Symbol": "RMI.JO",
    " marketcap ": " $2 633 224 000 ",
    "price (USD)": "\u044f\u043d\u0432.69",
    "country": "South Africa"
  },
  {
    "Rank": "3722",
    "Name": "Kulicke and Soffa Industries",
    "Symbol": "KLIC",
    " marketcap ": " $2 632 861 952 ",
    "price (USD)": "47.47",
    "country": "Singapore"
  },
  {
    "Rank": "3723",
    "Name": "Nerolac Paints",
    "Symbol": "KANSAINER.NS",
    " marketcap ": " $2 632 696 110 ",
    "price (USD)": "3.25676",
    "country": "India"
  },
  {
    "Rank": "3724",
    "Name": "Perfect World Entertainment",
    "Symbol": "002624.SZ",
    " marketcap ": " $2 631 539 823 ",
    "price (USD)": "1.35648",
    "country": "China"
  },
  {
    "Rank": "3725",
    "Name": "Ebro Foods",
    "Symbol": "EBRO.MC",
    " marketcap ": " $2 626 514 966 ",
    "price (USD)": "17.0703",
    "country": "Spain"
  },
  {
    "Rank": "3726",
    "Name": "Zuger Kantonalbank",
    "Symbol": "ZUGER.SW",
    " marketcap ": " $2 625 760 630 ",
    "price (USD)": "9129.71",
    "country": "Switzerland"
  },
  {
    "Rank": "3727",
    "Name": "Semtech",
    "Symbol": "SMTC",
    " marketcap ": " $2 623 702 528 ",
    "price (USD)": "40.62",
    "country": "United States"
  },
  {
    "Rank": "3728",
    "Name": "Hub Group",
    "Symbol": "HUBG",
    " marketcap ": " $2 623 507 712 ",
    "price (USD)": "42.1",
    "country": "United States"
  },
  {
    "Rank": "3729",
    "Name": "PriceSmart",
    "Symbol": "PSMT",
    " marketcap ": " $2 621 606 912 ",
    "price (USD)": "85.52",
    "country": "United States"
  },
  {
    "Rank": "3730",
    "Name": "Mr Price Group",
    "Symbol": "MRP.JO",
    " marketcap ": " $2 618 226 400 ",
    "price (USD)": "\u043e\u043a\u0442.27",
    "country": "South Africa"
  },
  {
    "Rank": "3731",
    "Name": "Schneider Electric Infrastructure",
    "Symbol": "SCHNEIDER.NS",
    " marketcap ": " $2 617 384 598 ",
    "price (USD)": "\u043e\u043a\u0442.42",
    "country": "India"
  },
  {
    "Rank": "3732",
    "Name": "Progyny",
    "Symbol": "PGNY",
    " marketcap ": " $2 614 760 448 ",
    "price (USD)": "27.46",
    "country": "United States"
  },
  {
    "Rank": "3733",
    "Name": "Tower Bersama Infrastructure",
    "Symbol": "TBIG.JK",
    " marketcap ": " $2 611 250 836 ",
    "price (USD)": "0.115356",
    "country": "Indonesia"
  },
  {
    "Rank": "3734",
    "Name": "Hartalega",
    "Symbol": "5168.KL",
    " marketcap ": " $2 610 760 161 ",
    "price (USD)": "0.764888",
    "country": "Malaysia"
  },
  {
    "Rank": "3735",
    "Name": "Tecnoglass",
    "Symbol": "TGLS",
    " marketcap ": " $2 609 256 704 ",
    "price (USD)": "55.52",
    "country": "Colombia"
  },
  {
    "Rank": "3736",
    "Name": "The National Agricultural Development Company",
    "Symbol": "6010.SR",
    " marketcap ": " $2 608 047 633 ",
    "price (USD)": "8.64623",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3737",
    "Name": "Orpea",
    "Symbol": "ORP.PA",
    " marketcap ": " $2 601 623 553 ",
    "price (USD)": "16.3427",
    "country": "France"
  },
  {
    "Rank": "3738",
    "Name": "Arbor Realty Trust",
    "Symbol": "ABR",
    " marketcap ": " $2 599 621 888 ",
    "price (USD)": "13.79",
    "country": "United States"
  },
  {
    "Rank": "3739",
    "Name": "Dr Lal PathLabs",
    "Symbol": "LALPATHLAB.NS",
    " marketcap ": " $2 599 444 032 ",
    "price (USD)": "31.2375",
    "country": "India"
  },
  {
    "Rank": "3740",
    "Name": "Maire Tecnimont",
    "Symbol": "MAIRE.MI",
    " marketcap ": " $2 599 305 966 ",
    "price (USD)": "8.06819",
    "country": "Italy"
  },
  {
    "Rank": "3741",
    "Name": "Ahli Bank",
    "Symbol": "ABQK.QA",
    " marketcap ": " $2 594 603 604 ",
    "price (USD)": "1.01703",
    "country": "Qatar"
  },
  {
    "Rank": "3742",
    "Name": "Sapporo",
    "Symbol": "2501.T",
    " marketcap ": " $2 594 453 758 ",
    "price (USD)": "33.3056",
    "country": "Japan"
  },
  {
    "Rank": "3743",
    "Name": "Perficient",
    "Symbol": "PRFT",
    " marketcap ": " $2 592 376 320 ",
    "price (USD)": "73.73",
    "country": "United States"
  },
  {
    "Rank": "3744",
    "Name": "CATRION Catering Holding Company",
    "Symbol": "6004.SR",
    " marketcap ": " $2 590 878 766 ",
    "price (USD)": "31.5961",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3745",
    "Name": "LXP Industrial Trust",
    "Symbol": "LXP",
    " marketcap ": " $2 585 435 136 ",
    "price (USD)": "\u0430\u0432\u0433.76",
    "country": "United States"
  },
  {
    "Rank": "3746",
    "Name": "Taiyo Yuden",
    "Symbol": "6976.T",
    " marketcap ": " $2 583 273 520 ",
    "price (USD)": "20.728",
    "country": "Japan"
  },
  {
    "Rank": "3747",
    "Name": "Carmila",
    "Symbol": "CARM.PA",
    " marketcap ": " $2 582 839 292 ",
    "price (USD)": "18.1562",
    "country": "France"
  },
  {
    "Rank": "3748",
    "Name": "Antin Infrastructure Partners",
    "Symbol": "ANTIN.PA",
    " marketcap ": " $2 574 404 274 ",
    "price (USD)": "14.399",
    "country": "France"
  },
  {
    "Rank": "3749",
    "Name": "Meitetsu",
    "Symbol": "9048.T",
    " marketcap ": " $2 573 161 371 ",
    "price (USD)": "13.0894",
    "country": "Japan"
  },
  {
    "Rank": "3750",
    "Name": "Ziff Davis",
    "Symbol": "ZD",
    " marketcap ": " $2 572 102 656 ",
    "price (USD)": "55.76",
    "country": "United States"
  },
  {
    "Rank": "3751",
    "Name": "Beach Energy",
    "Symbol": "BPT.AX",
    " marketcap ": " $2 570 846 986 ",
    "price (USD)": "1.12691",
    "country": "Australia"
  },
  {
    "Rank": "3752",
    "Name": "Filo Mining",
    "Symbol": "FIL.TO",
    " marketcap ": " $2 569 482 107 ",
    "price (USD)": "19.6342",
    "country": "Canada"
  },
  {
    "Rank": "3753",
    "Name": "African Rainbow Minerals",
    "Symbol": "ARI.JO",
    " marketcap ": " $2 569 143 900 ",
    "price (USD)": "\u0434\u0435\u043a.22",
    "country": "South Africa"
  },
  {
    "Rank": "3754",
    "Name": "Community Bank System",
    "Symbol": "CBU",
    " marketcap ": " $2 568 374 272 ",
    "price (USD)": "48.67",
    "country": "United States"
  },
  {
    "Rank": "3755",
    "Name": "Merus",
    "Symbol": "MRUS",
    " marketcap ": " $2 565 821 952 ",
    "price (USD)": "43.72",
    "country": "Netherlands"
  },
  {
    "Rank": "3756",
    "Name": "TG Therapeutics",
    "Symbol": "TGTX",
    " marketcap ": " $2 565 413 888 ",
    "price (USD)": "16.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "3757",
    "Name": "Twist Bioscience",
    "Symbol": "TWST",
    " marketcap ": " $2 564 273 152 ",
    "price (USD)": "44.04",
    "country": "United States"
  },
  {
    "Rank": "3758",
    "Name": "Anan Investment Holding",
    "Symbol": "ANAN.AE",
    " marketcap ": " $2 562 912 072 ",
    "price (USD)": "01.\u043d\u043e\u044f",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3759",
    "Name": "Proximus",
    "Symbol": "PROX.VI",
    " marketcap ": " $2 562 707 056 ",
    "price (USD)": "7.93789",
    "country": "Belgium"
  },
  {
    "Rank": "3760",
    "Name": "Enerjisa Enerji",
    "Symbol": "ENJSA.IS",
    " marketcap ": " $2 562 590 512 ",
    "price (USD)": "2.16972",
    "country": "Turkey"
  },
  {
    "Rank": "3761",
    "Name": "Toho Gas",
    "Symbol": "9533.T",
    " marketcap ": " $2 561 730 620 ",
    "price (USD)": "24.4898",
    "country": "Japan"
  },
  {
    "Rank": "3762",
    "Name": "CapitaLand Ascott Trust",
    "Symbol": "HMN.SI",
    " marketcap ": " $2 558 181 325 ",
    "price (USD)": "0.6756",
    "country": "Singapore"
  },
  {
    "Rank": "3763",
    "Name": "Webuild S.p.A.",
    "Symbol": "WBD.MI",
    " marketcap ": " $2 557 088 900 ",
    "price (USD)": "2.51927",
    "country": "Italy"
  },
  {
    "Rank": "3764",
    "Name": "Berner Kantonalbank",
    "Symbol": "BEKN.SW",
    " marketcap ": " $2 553 517 622 ",
    "price (USD)": "276.525",
    "country": "Switzerland"
  },
  {
    "Rank": "3765",
    "Name": "Solvac",
    "Symbol": "SOLV.BR",
    " marketcap ": " $2 553 208 731 ",
    "price (USD)": "119.448",
    "country": "Belgium"
  },
  {
    "Rank": "3766",
    "Name": "Wizz Air",
    "Symbol": "WIZZ.L",
    " marketcap ": " $2 553 073 318 ",
    "price (USD)": "24.7005",
    "country": "Jersey"
  },
  {
    "Rank": "3767",
    "Name": "ArcBest",
    "Symbol": "ARCB",
    " marketcap ": " $2 551 935 744 ",
    "price (USD)": "108.91",
    "country": "United States"
  },
  {
    "Rank": "3768",
    "Name": "Immunocore",
    "Symbol": "IMCR",
    " marketcap ": " $2 550 591 488 ",
    "price (USD)": "51",
    "country": "United Kingdom"
  },
  {
    "Rank": "3769",
    "Name": "Agility Public Warehousing Company",
    "Symbol": "AGLTY.KW",
    " marketcap ": " $2 545 684 694 ",
    "price (USD)": "997.392",
    "country": "Kuwait"
  },
  {
    "Rank": "3770",
    "Name": "Exxaro Resources",
    "Symbol": "EXX.JO",
    " marketcap ": " $2 545 281 200 ",
    "price (USD)": "\u043e\u043a\u0442.79",
    "country": "South Africa"
  },
  {
    "Rank": "3771",
    "Name": "Energy Absolute",
    "Symbol": "EA.BK",
    " marketcap ": " $2 542 334 528 ",
    "price (USD)": "0.684649",
    "country": "Thailand"
  },
  {
    "Rank": "3772",
    "Name": "AAR",
    "Symbol": "AIR",
    " marketcap ": " $2 538 351 872 ",
    "price (USD)": "71.65",
    "country": "United States"
  },
  {
    "Rank": "3773",
    "Name": "AssetMark",
    "Symbol": "AMK",
    " marketcap ": " $2 537 797 632 ",
    "price (USD)": "34.11",
    "country": "United States"
  },
  {
    "Rank": "3774",
    "Name": "Green Brick Partners",
    "Symbol": "GRBK",
    " marketcap ": " $2 537 236 736 ",
    "price (USD)": "56.47",
    "country": "United States"
  },
  {
    "Rank": "3775",
    "Name": "Titan Cement International",
    "Symbol": "TITC.BR",
    " marketcap ": " $2 536 615 294 ",
    "price (USD)": "33.9885",
    "country": "Belgium"
  },
  {
    "Rank": "3776",
    "Name": "MM Group (Mayr-Melnhof AG)",
    "Symbol": "MYM.F",
    " marketcap ": " $2 536 594 723 ",
    "price (USD)": "126.398",
    "country": "Austria"
  },
  {
    "Rank": "3777",
    "Name": "Adient",
    "Symbol": "ADNT",
    " marketcap ": " $2 534 821 888 ",
    "price (USD)": "28.22",
    "country": "Ireland"
  },
  {
    "Rank": "3778",
    "Name": "Helen of Troy",
    "Symbol": "HELE",
    " marketcap ": " $2 533 622 272 ",
    "price (USD)": "106.41",
    "country": "United States"
  },
  {
    "Rank": "3779",
    "Name": "TripAdvisor",
    "Symbol": "TRIP",
    " marketcap ": " $2 533 503 232 ",
    "price (USD)": "18.19",
    "country": "United States"
  },
  {
    "Rank": "3780",
    "Name": "Compa\u0413\u00b1\u0413\u00ada Cervecer\u0413\u00adas Unidas",
    "Symbol": "CCU",
    " marketcap ": " $2 532 936 448 ",
    "price (USD)": "13.71",
    "country": "Chile"
  },
  {
    "Rank": "3781",
    "Name": "Newmark",
    "Symbol": "NMRK",
    " marketcap ": " $2 532 439 296 ",
    "price (USD)": "\u043e\u043a\u0442.48",
    "country": "United States"
  },
  {
    "Rank": "3782",
    "Name": "Trinity Industries",
    "Symbol": "TRN",
    " marketcap ": " $2 531 999 744 ",
    "price (USD)": "30.94",
    "country": "United States"
  },
  {
    "Rank": "3783",
    "Name": "DFI Retail Group",
    "Symbol": "D01.SI",
    " marketcap ": " $2 531 325 696 ",
    "price (USD)": "\u044f\u043d\u0432.87",
    "country": "Hong Kong"
  },
  {
    "Rank": "3784",
    "Name": "Electrolux",
    "Symbol": "ELUX-A.ST",
    " marketcap ": " $2 530 783 155 ",
    "price (USD)": "\u043e\u043a\u0442.07",
    "country": "Sweden"
  },
  {
    "Rank": "3785",
    "Name": "Breville Group",
    "Symbol": "BRG.AX",
    " marketcap ": " $2 528 750 069 ",
    "price (USD)": "17.6304",
    "country": "Australia"
  },
  {
    "Rank": "3786",
    "Name": "Mirion Technologies",
    "Symbol": "MIR",
    " marketcap ": " $2 523 795 968 ",
    "price (USD)": "11.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "3787",
    "Name": "ACADIA Pharmaceuticals",
    "Symbol": "ACAD",
    " marketcap ": " $2 522 924 544 ",
    "price (USD)": "15.27",
    "country": "United States"
  },
  {
    "Rank": "3788",
    "Name": "ID Logistics Group",
    "Symbol": "IDL.PA",
    " marketcap ": " $2 522 083 979 ",
    "price (USD)": "408.839",
    "country": "France"
  },
  {
    "Rank": "3789",
    "Name": "Laureate Education",
    "Symbol": "LAUR",
    " marketcap ": " $2 518 246 656 ",
    "price (USD)": "16.23",
    "country": "United States"
  },
  {
    "Rank": "3790",
    "Name": "Atmus Filtration Technologies",
    "Symbol": "ATMU",
    " marketcap ": " $2 512 346 880 ",
    "price (USD)": "30.14",
    "country": "United States"
  },
  {
    "Rank": "3791",
    "Name": "Cushman &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3792",
    "Name": "Patrick Industries",
    "Symbol": "PATK",
    " marketcap ": " $2 510 983 936 ",
    "price (USD)": "112.09",
    "country": "United States"
  },
  {
    "Rank": "3793",
    "Name": "Jamjoom Pharmaceuticals Factory Company",
    "Symbol": "4015.SR",
    " marketcap ": " $2 510 607 637 ",
    "price (USD)": "35.8658",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3794",
    "Name": "Harmonic Drive Systems",
    "Symbol": "6324.T",
    " marketcap ": " $2 509 452 546 ",
    "price (USD)": "26.4219",
    "country": "Japan"
  },
  {
    "Rank": "3795",
    "Name": "Kajaria Ceramics",
    "Symbol": "KAJARIACER.NS",
    " marketcap ": " $2 506 543 223 ",
    "price (USD)": "15.7389",
    "country": "India"
  },
  {
    "Rank": "3796",
    "Name": "Sumitomo Chemical",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": " India\"",
    "Name": "SUMICHEM.NS",
    "Symbol": "2506050878",
    " marketcap ": " 5.0146 ",
    "price (USD)": "India",
    "country": null
  },
  {
    "Rank": "3797",
    "Name": "OYAK \u0413\u2021imento",
    "Symbol": "OYAKC.IS",
    " marketcap ": " $2 505 310 815 ",
    "price (USD)": "2.00975",
    "country": "Turkey"
  },
  {
    "Rank": "3798",
    "Name": "Grafton Group",
    "Symbol": "GFTU.L",
    " marketcap ": " $2 504 683 372 ",
    "price (USD)": "\u0434\u0435\u043a.75",
    "country": "Ireland"
  },
  {
    "Rank": "3799",
    "Name": "Vericel",
    "Symbol": "VCEL",
    " marketcap ": " $2 504 445 440 ",
    "price (USD)": "51.53",
    "country": "United States"
  },
  {
    "Rank": "3800",
    "Name": "ICU Medical",
    "Symbol": "ICUI",
    " marketcap ": " $2 503 362 816 ",
    "price (USD)": "102.74",
    "country": "United States"
  },
  {
    "Rank": "3801",
    "Name": "NetLink Trust",
    "Symbol": "CJLU.SI",
    " marketcap ": " $2 502 601 415 ",
    "price (USD)": "0.642192",
    "country": "Singapore"
  },
  {
    "Rank": "3802",
    "Name": "TietoEVRY",
    "Symbol": "TIETO.HE",
    " marketcap ": " $2 502 437 945 ",
    "price (USD)": "21.0989",
    "country": "Finland"
  },
  {
    "Rank": "3803",
    "Name": "Penn National Gaming",
    "Symbol": "PENN",
    " marketcap ": " $2 501 638 912 ",
    "price (USD)": "16.41",
    "country": "United States"
  },
  {
    "Rank": "3804",
    "Name": "Gelsenwasser",
    "Symbol": "WWG.F",
    " marketcap ": " $2 500 950 149 ",
    "price (USD)": "727.549",
    "country": "Germany"
  },
  {
    "Rank": "3805",
    "Name": "Dubai Investments",
    "Symbol": "DIC.AE",
    " marketcap ": " $2 500 711 607 ",
    "price (USD)": "0.588123",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3806",
    "Name": "Kindred Group",
    "Symbol": "KIND-SDB.ST",
    " marketcap ": " $2 500 636 860 ",
    "price (USD)": "\u043d\u043e\u044f.67",
    "country": "Malta"
  },
  {
    "Rank": "3807",
    "Name": "Chesapeake Utilities",
    "Symbol": "CPK",
    " marketcap ": " $2 500 052 736 ",
    "price (USD)": "112.26",
    "country": "United States"
  },
  {
    "Rank": "3808",
    "Name": "Eastern Bankshares",
    "Symbol": "EBC",
    " marketcap ": " $2 499 328 768 ",
    "price (USD)": "14.15",
    "country": "United States"
  },
  {
    "Rank": "3809",
    "Name": "AZZ",
    "Symbol": "AZZ",
    " marketcap ": " $2 498 812 416 ",
    "price (USD)": "84.13",
    "country": "United States"
  },
  {
    "Rank": "3810",
    "Name": "Ghitha",
    "Symbol": "GHITHA.AE",
    " marketcap ": " $2 497 110 028 ",
    "price (USD)": "\u043e\u043a\u0442.34",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3811",
    "Name": "Golden Agri-Resources",
    "Symbol": "E5H.SI",
    " marketcap ": " $2 495 007 607 ",
    "price (USD)": "0.196741",
    "country": "Singapore"
  },
  {
    "Rank": "3812",
    "Name": "Berli Jucker (BJC)",
    "Symbol": "BJC.BK",
    " marketcap ": " $2 490 480 467 ",
    "price (USD)": "0.621408",
    "country": "Thailand"
  },
  {
    "Rank": "3813",
    "Name": "Yelp",
    "Symbol": "YELP",
    " marketcap ": " $2 488 540 416 ",
    "price (USD)": "36.89",
    "country": "United States"
  },
  {
    "Rank": "3814",
    "Name": "Paycor",
    "Symbol": "PYCR",
    " marketcap ": " $2 487 811 584 ",
    "price (USD)": "13.96",
    "country": "United States"
  },
  {
    "Rank": "3815",
    "Name": "CarGurus",
    "Symbol": "CARG",
    " marketcap ": " $2 487 063 040 ",
    "price (USD)": "23.87",
    "country": "United States"
  },
  {
    "Rank": "3816",
    "Name": "Adtalem Global Education",
    "Symbol": "ATGE",
    " marketcap ": " $2 486 541 824 ",
    "price (USD)": "66.12",
    "country": "United States"
  },
  {
    "Rank": "3817",
    "Name": "Celldex Therapeutics",
    "Symbol": "CLDX",
    " marketcap ": " $2 482 848 512 ",
    "price (USD)": "37.67",
    "country": "United States"
  },
  {
    "Rank": "3818",
    "Name": "Intellia Therapeutics",
    "Symbol": "NTLA",
    " marketcap ": " $2 480 382 464 ",
    "price (USD)": "25.71",
    "country": "United States"
  },
  {
    "Rank": "3819",
    "Name": "Relaxo Footwear",
    "Symbol": "RELAXO.NS",
    " marketcap ": " $2 480 211 336 ",
    "price (USD)": "\u0441\u0435\u043d.05",
    "country": "India"
  },
  {
    "Rank": "3820",
    "Name": "Braves Group",
    "Symbol": "BATRK",
    " marketcap ": " $2 479 596 544 ",
    "price (USD)": "39.48",
    "country": "United States"
  },
  {
    "Rank": "3821",
    "Name": "Covivio Hotels",
    "Symbol": "COVH.PA",
    " marketcap ": " $2 477 211 007 ",
    "price (USD)": "16.7228",
    "country": "France"
  },
  {
    "Rank": "3822",
    "Name": "NV Bekaert",
    "Symbol": "BEKB.BR",
    " marketcap ": " $2 476 493 239 ",
    "price (USD)": "47.4319",
    "country": "Belgium"
  },
  {
    "Rank": "3823",
    "Name": "Kinetik",
    "Symbol": "KNTK",
    " marketcap ": " $2 474 601 984 ",
    "price (USD)": "41.44",
    "country": "United States"
  },
  {
    "Rank": "3824",
    "Name": "CLEAR Secure",
    "Symbol": "YOU",
    " marketcap ": " $2 473 696 512 ",
    "price (USD)": "17.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "3825",
    "Name": "Outfront Media",
    "Symbol": "OUT",
    " marketcap ": " $2 471 701 248 ",
    "price (USD)": "14.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "3826",
    "Name": "Balfour Beatty",
    "Symbol": "BBY.L",
    " marketcap ": " $2 471 452 224 ",
    "price (USD)": "4.676",
    "country": "United Kingdom"
  },
  {
    "Rank": "3827",
    "Name": "Carter's",
    "Symbol": "CRI",
    " marketcap ": " $2 470 590 208 ",
    "price (USD)": "67.69",
    "country": "United States"
  },
  {
    "Rank": "3828",
    "Name": "SYNLAB",
    "Symbol": "SYAB.DE",
    " marketcap ": " $2 467 666 535 ",
    "price (USD)": "\u043d\u043e\u044f.64",
    "country": "Germany"
  },
  {
    "Rank": "3829",
    "Name": "Keppel REIT",
    "Symbol": "K71U.SI",
    " marketcap ": " $2 466 286 458 ",
    "price (USD)": "0.645904",
    "country": "Singapore"
  },
  {
    "Rank": "3830",
    "Name": "Tegna",
    "Symbol": "TGNA",
    " marketcap ": " $2 464 360 448 ",
    "price (USD)": "14.53",
    "country": "United States"
  },
  {
    "Rank": "3831",
    "Name": "Serco Group",
    "Symbol": "SRP.L",
    " marketcap ": " $2 464 009 520 ",
    "price (USD)": "2.29732",
    "country": "United Kingdom"
  },
  {
    "Rank": "3832",
    "Name": "OSI Systems",
    "Symbol": "OSIS",
    " marketcap ": " $2 463 878 144 ",
    "price (USD)": "144.52",
    "country": "United States"
  },
  {
    "Rank": "3833",
    "Name": "Sanofi India Limited",
    "Symbol": "SANOFI.NS",
    " marketcap ": " $2 463 507 046 ",
    "price (USD)": "106.955",
    "country": "India"
  },
  {
    "Rank": "3834",
    "Name": "KEC International",
    "Symbol": "KEC.NS",
    " marketcap ": " $2 462 093 794 ",
    "price (USD)": "9.57622",
    "country": "India"
  },
  {
    "Rank": "3835",
    "Name": "Oceaneering International",
    "Symbol": "OII",
    " marketcap ": " $2 461 724 928 ",
    "price (USD)": "24.28",
    "country": "United States"
  },
  {
    "Rank": "3836",
    "Name": "Teekay Tankers",
    "Symbol": "TNK",
    " marketcap ": " $2 460 730 624 ",
    "price (USD)": "71.83",
    "country": "Canada"
  },
  {
    "Rank": "3837",
    "Name": "Danieli &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3838",
    "Name": "Goosehead Insurance",
    "Symbol": "GSHD",
    " marketcap ": " $2 457 146 112 ",
    "price (USD)": "64.69",
    "country": "United States"
  },
  {
    "Rank": "3839",
    "Name": "DigitalBridge Group",
    "Symbol": "DBRG",
    " marketcap ": " $2 456 150 272 ",
    "price (USD)": "13.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "3840",
    "Name": "Elgi Equipments",
    "Symbol": "ELGIEQUIP.NS",
    " marketcap ": " $2 455 369 477 ",
    "price (USD)": "\u0438\u044e\u043b.47",
    "country": "India"
  },
  {
    "Rank": "3841",
    "Name": "MoonLake Immunotherapeutics",
    "Symbol": "MLTX",
    " marketcap ": " $2 453 995 520 ",
    "price (USD)": "39.03",
    "country": "Switzerland"
  },
  {
    "Rank": "3842",
    "Name": "Ansell",
    "Symbol": "ANN.AX",
    " marketcap ": " $2 453 355 468 ",
    "price (USD)": "16.8103",
    "country": "Australia"
  },
  {
    "Rank": "3843",
    "Name": "Nordic Semiconductor",
    "Symbol": "NOD.OL",
    " marketcap ": " $2 450 134 360 ",
    "price (USD)": "\u0434\u0435\u043a.96",
    "country": "Norway"
  },
  {
    "Rank": "3844",
    "Name": "Banc of California",
    "Symbol": "BANC",
    " marketcap ": " $2 449 768 960 ",
    "price (USD)": "14.55",
    "country": "United States"
  },
  {
    "Rank": "3845",
    "Name": "Novocure",
    "Symbol": "NVCR",
    " marketcap ": " $2 448 150 272 ",
    "price (USD)": "22.75",
    "country": "Jersey"
  },
  {
    "Rank": "3846",
    "Name": "National Central Cooling Company",
    "Symbol": "TABREED.AE",
    " marketcap ": " $2 448 077 388 ",
    "price (USD)": "0.860402",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3847",
    "Name": "RxSight",
    "Symbol": "RXST",
    " marketcap ": " $2 447 623 680 ",
    "price (USD)": "62.36",
    "country": "United States"
  },
  {
    "Rank": "3848",
    "Name": "BB Biotech",
    "Symbol": "BION.SW",
    " marketcap ": " $2 443 457 651 ",
    "price (USD)": "44.5512",
    "country": "Switzerland"
  },
  {
    "Rank": "3849",
    "Name": "EMSTEEL Building Materials PJSC",
    "Symbol": "EMSTEEL.AE",
    " marketcap ": " $2 443 297 846 ",
    "price (USD)": "0.36",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "3850",
    "Name": "Colb\u0413\u0454n",
    "Symbol": "COLBUN.SN",
    " marketcap ": " $2 438 874 712 ",
    "price (USD)": "0.139077",
    "country": "Chile"
  },
  {
    "Rank": "3851",
    "Name": "Pennon Group",
    "Symbol": "PNN.L",
    " marketcap ": " $2 438 305 860 ",
    "price (USD)": "8.52435",
    "country": "United Kingdom"
  },
  {
    "Rank": "3852",
    "Name": "Bank of Bahrain and Kuwait",
    "Symbol": "BBK.BH",
    " marketcap ": " $2 438 182 220 ",
    "price (USD)": "\u044f\u043d\u0432.44",
    "country": "Bahrain"
  },
  {
    "Rank": "3853",
    "Name": "Ero Copper",
    "Symbol": "ERO",
    " marketcap ": " $2 437 836 032 ",
    "price (USD)": "23.63",
    "country": "Canada"
  },
  {
    "Rank": "3854",
    "Name": "Gentera, S.A.B. de C.V.",
    "Symbol": "GENTERA.MX",
    " marketcap ": " $2 437 425 745 ",
    "price (USD)": "1.52059",
    "country": "Mexico"
  },
  {
    "Rank": "3855",
    "Name": "Ardagh Metal Packaging",
    "Symbol": "AMBP",
    " marketcap ": " $2 432 439 808 ",
    "price (USD)": "04.\u0438\u044e\u043b",
    "country": "Luxembourg"
  },
  {
    "Rank": "3856",
    "Name": "Siltronic",
    "Symbol": "WAF.F",
    " marketcap ": " $2 431 860 172 ",
    "price (USD)": "81.062",
    "country": "Germany"
  },
  {
    "Rank": "3857",
    "Name": "Siam Global House",
    "Symbol": "GLOBAL.BK",
    " marketcap ": " $2 431 511 084 ",
    "price (USD)": "0.467431",
    "country": "Thailand"
  },
  {
    "Rank": "3858",
    "Name": "Cellebrite",
    "Symbol": "CLBT",
    " marketcap ": " $2 428 663 296 ",
    "price (USD)": "\u043d\u043e\u044f.83",
    "country": "Israel"
  },
  {
    "Rank": "3859",
    "Name": "Emaar The Economic City",
    "Symbol": "4220.SR",
    " marketcap ": " $2 423 072 074 ",
    "price (USD)": "1.81731",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3860",
    "Name": "Cofinimmo",
    "Symbol": "COFB.BR",
    " marketcap ": " $2 417 893 174 ",
    "price (USD)": "65.8052",
    "country": "Belgium"
  },
  {
    "Rank": "3861",
    "Name": "Safestore",
    "Symbol": "SAFE.L",
    " marketcap ": " $2 415 781 980 ",
    "price (USD)": "11.0569",
    "country": "United Kingdom"
  },
  {
    "Rank": "3862",
    "Name": "Boralex",
    "Symbol": "BLX.TO",
    " marketcap ": " $2 414 788 061 ",
    "price (USD)": "23.4979",
    "country": "Canada"
  },
  {
    "Rank": "3863",
    "Name": "Kodiak Gas Services",
    "Symbol": "KGS",
    " marketcap ": " $2 409 968 128 ",
    "price (USD)": "28.59",
    "country": "United States"
  },
  {
    "Rank": "3864",
    "Name": "Bank of Georgia Group",
    "Symbol": "BGEO.L",
    " marketcap ": " $2 407 339 451 ",
    "price (USD)": "53.2057",
    "country": "United Kingdom"
  },
  {
    "Rank": "3865",
    "Name": "Centuri Holdings",
    "Symbol": "CTRI",
    " marketcap ": " $2 406 790 912 ",
    "price (USD)": "27.19",
    "country": "United States"
  },
  {
    "Rank": "3866",
    "Name": "Bausch Health",
    "Symbol": "BHC",
    " marketcap ": " $2 406 777 856 ",
    "price (USD)": "\u0438\u044e\u043d.55",
    "country": "Canada"
  },
  {
    "Rank": "3867",
    "Name": "PGT Innovations",
    "Symbol": "PGTI",
    " marketcap ": " $2 404 418 816 ",
    "price (USD)": "41.99",
    "country": "United States"
  },
  {
    "Rank": "3868",
    "Name": "Topaz Energy",
    "Symbol": "TPZ.TO",
    " marketcap ": " $2 402 243 828 ",
    "price (USD)": "16.5786",
    "country": "Canada"
  },
  {
    "Rank": "3869",
    "Name": "First Advantage",
    "Symbol": "FA",
    " marketcap ": " $2 397 219 072 ",
    "price (USD)": "16.51",
    "country": "United States"
  },
  {
    "Rank": "3870",
    "Name": "Materion",
    "Symbol": "MTRN",
    " marketcap ": " $2 390 272 768 ",
    "price (USD)": "115.3",
    "country": "United States"
  },
  {
    "Rank": "3871",
    "Name": "Tejas Networks",
    "Symbol": "TEJASNET.NS",
    " marketcap ": " $2 383 393 620 ",
    "price (USD)": "13.9618",
    "country": "India"
  },
  {
    "Rank": "3872",
    "Name": "CVB Financial",
    "Symbol": "CVBF",
    " marketcap ": " $2 382 258 432 ",
    "price (USD)": "17.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "3873",
    "Name": "First Capital REIT",
    "Symbol": "FCR-UN.TO",
    " marketcap ": " $2 380 372 629 ",
    "price (USD)": "\u043d\u043e\u044f.01",
    "country": "Canada"
  },
  {
    "Rank": "3874",
    "Name": "Ita\u0413\u0454 CorpBanca",
    "Symbol": "ITCLY",
    " marketcap ": " $2 378 989 568 ",
    "price (USD)": "03.\u044f\u043d\u0432",
    "country": "Chile"
  },
  {
    "Rank": "3875",
    "Name": "Callon Petroleum",
    "Symbol": "CPE",
    " marketcap ": " $2 378 336 768 ",
    "price (USD)": "35.76",
    "country": "United States"
  },
  {
    "Rank": "3876",
    "Name": "ENAV",
    "Symbol": "ENAV.MI",
    " marketcap ": " $2 377 525 012 ",
    "price (USD)": "4.30883",
    "country": "Italy"
  },
  {
    "Rank": "3877",
    "Name": "Prospect Capital",
    "Symbol": "PSEC",
    " marketcap ": " $2 377 043 200 ",
    "price (USD)": "\u043c\u0430\u0439.69",
    "country": "United States"
  },
  {
    "Rank": "3878",
    "Name": "Inox Wind",
    "Symbol": "INOXWIND.NS",
    " marketcap ": " $2 376 827 578 ",
    "price (USD)": "\u0438\u044e\u043b.55",
    "country": "India"
  },
  {
    "Rank": "3879",
    "Name": "Rapid7",
    "Symbol": "RPD",
    " marketcap ": " $2 373 317 120 ",
    "price (USD)": "38.08",
    "country": "United States"
  },
  {
    "Rank": "3880",
    "Name": "RXO",
    "Symbol": "RXO",
    " marketcap ": " $2 372 118 784 ",
    "price (USD)": "20.18",
    "country": "United States"
  },
  {
    "Rank": "3881",
    "Name": "Arvinas",
    "Symbol": "ARVN",
    " marketcap ": " $2 371 165 696 ",
    "price (USD)": "34.65",
    "country": "United States"
  },
  {
    "Rank": "3882",
    "Name": "Evertec",
    "Symbol": "EVTC",
    " marketcap ": " $2 361 248 512 ",
    "price (USD)": "36.66",
    "country": "United States"
  },
  {
    "Rank": "3883",
    "Name": "ViaSat",
    "Symbol": "VSAT",
    " marketcap ": " $2 361 028 864 ",
    "price (USD)": "18.84",
    "country": "United States"
  },
  {
    "Rank": "3884",
    "Name": "LGI Homes",
    "Symbol": "LGIH",
    " marketcap ": " $2 360 039 424 ",
    "price (USD)": "100.14",
    "country": "United States"
  },
  {
    "Rank": "3885",
    "Name": "Lanxess",
    "Symbol": "LXS.F",
    " marketcap ": " $2 358 904 202 ",
    "price (USD)": "27.1474",
    "country": "Germany"
  },
  {
    "Rank": "3886",
    "Name": "Janux Therapeutics",
    "Symbol": "JANX",
    " marketcap ": " $2 358 688 512 ",
    "price (USD)": "45.49",
    "country": "United States"
  },
  {
    "Rank": "3887",
    "Name": "Dexerials Corporation",
    "Symbol": "4980.T",
    " marketcap ": " $2 358 294 815 ",
    "price (USD)": "41.2514",
    "country": "Japan"
  },
  {
    "Rank": "3888",
    "Name": "WNS",
    "Symbol": "WNS",
    " marketcap ": " $2 357 299 456 ",
    "price (USD)": "51.6",
    "country": "India"
  },
  {
    "Rank": "3889",
    "Name": "WaFd Bank",
    "Symbol": "WAFD",
    " marketcap ": " $2 356 144 384 ",
    "price (USD)": "28.94",
    "country": "United States"
  },
  {
    "Rank": "3890",
    "Name": "StoneX Group",
    "Symbol": "SNEX",
    " marketcap ": " $2 354 920 448 ",
    "price (USD)": "74.25",
    "country": "United States"
  },
  {
    "Rank": "3891",
    "Name": "CT REIT",
    "Symbol": "CRT-UN.TO",
    " marketcap ": " $2 354 778 823 ",
    "price (USD)": "9.99303",
    "country": "Canada"
  },
  {
    "Rank": "3892",
    "Name": "Suntec REIT",
    "Symbol": "T82U.SI",
    " marketcap ": " $2 354 414 676 ",
    "price (USD)": "0.809236",
    "country": "Singapore"
  },
  {
    "Rank": "3893",
    "Name": "Coeur Mining",
    "Symbol": "CDE",
    " marketcap ": " $2 352 000 512 ",
    "price (USD)": "\u043c\u0430\u0439.89",
    "country": "United States"
  },
  {
    "Rank": "3894",
    "Name": "Grainger plc",
    "Symbol": "GRI.L",
    " marketcap ": " $2 341 307 093 ",
    "price (USD)": "3.172",
    "country": "United Kingdom"
  },
  {
    "Rank": "3895",
    "Name": "Sovos Brands",
    "Symbol": "SOVO",
    " marketcap ": " $2 340 650 752 ",
    "price (USD)": "22.98",
    "country": "United States"
  },
  {
    "Rank": "3896",
    "Name": "Piramal Pharma",
    "Symbol": "PPLPHARMA.NS",
    " marketcap ": " $2 339 830 254 ",
    "price (USD)": "1.77406",
    "country": "India"
  },
  {
    "Rank": "3897",
    "Name": "Yulon Motor Company",
    "Symbol": "2201.TW",
    " marketcap ": " $2 336 025 870 ",
    "price (USD)": "2.19865",
    "country": "Taiwan"
  },
  {
    "Rank": "3898",
    "Name": "Bank of Hawaii",
    "Symbol": "BOH",
    " marketcap ": " $2 333 319 168 ",
    "price (USD)": "58.78",
    "country": "United States"
  },
  {
    "Rank": "3899",
    "Name": "Whirlpool India",
    "Symbol": "WHIRLPOOL.NS",
    " marketcap ": " $2 332 573 827 ",
    "price (USD)": "18.3612",
    "country": "India"
  },
  {
    "Rank": "3900",
    "Name": "Mahindra CIE",
    "Symbol": "MAHINDCIE.NS",
    " marketcap ": " $2 330 249 104 ",
    "price (USD)": "\u0438\u044e\u043d.14",
    "country": "India"
  },
  {
    "Rank": "3901",
    "Name": "Semrush",
    "Symbol": "SEMR",
    " marketcap ": " $2 329 922 304 ",
    "price (USD)": "16.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "3902",
    "Name": "Pactiv Evergreen",
    "Symbol": "PTVE",
    " marketcap ": " $2 327 145 472 ",
    "price (USD)": "\u0434\u0435\u043a.99",
    "country": "United States"
  },
  {
    "Rank": "3903",
    "Name": "Alamo Group",
    "Symbol": "ALG",
    " marketcap ": " $2 325 311 488 ",
    "price (USD)": "194.26",
    "country": "United States"
  },
  {
    "Rank": "3904",
    "Name": "Hypoport",
    "Symbol": "HYQ.F",
    " marketcap ": " $2 321 155 391 ",
    "price (USD)": "347.052",
    "country": "Germany"
  },
  {
    "Rank": "3905",
    "Name": "Cyient",
    "Symbol": "CYIENT.NS",
    " marketcap ": " $2 320 664 829 ",
    "price (USD)": "21.1115",
    "country": "India"
  },
  {
    "Rank": "3906",
    "Name": "EQB (Equitable Bank)",
    "Symbol": "EQB.TO",
    " marketcap ": " $2 320 345 373 ",
    "price (USD)": "60.728",
    "country": "Canada"
  },
  {
    "Rank": "3907",
    "Name": "GlobalData",
    "Symbol": "DATA.L",
    " marketcap ": " $2 320 320 704 ",
    "price (USD)": "2.88201",
    "country": "United Kingdom"
  },
  {
    "Rank": "3908",
    "Name": "Liontown Resources",
    "Symbol": "LTR.AX",
    " marketcap ": " $2 319 933 084 ",
    "price (USD)": "0.956871",
    "country": "Australia"
  },
  {
    "Rank": "3909",
    "Name": "Gudang Garam",
    "Symbol": "GGRM.JK",
    " marketcap ": " $2 319 519 868 ",
    "price (USD)": "1.20514",
    "country": "Indonesia"
  },
  {
    "Rank": "3910",
    "Name": "Rhythm Pharmaceuticals",
    "Symbol": "RYTM",
    " marketcap ": " $2 317 579 776 ",
    "price (USD)": "38.01",
    "country": "United States"
  },
  {
    "Rank": "3911",
    "Name": "Coface",
    "Symbol": "COFA.PA",
    " marketcap ": " $2 317 115 656 ",
    "price (USD)": "15.5066",
    "country": "France"
  },
  {
    "Rank": "3912",
    "Name": "Landis+Gyr",
    "Symbol": "LAND.SW",
    " marketcap ": " $2 316 858 711 ",
    "price (USD)": "80.2142",
    "country": "Switzerland"
  },
  {
    "Rank": "3913",
    "Name": "N-Able",
    "Symbol": "NABL",
    " marketcap ": " $2 315 080 448 ",
    "price (USD)": "\u0434\u0435\u043a.53",
    "country": "United States"
  },
  {
    "Rank": "3914",
    "Name": "Appian",
    "Symbol": "APPN",
    " marketcap ": " $2 313 172 992 ",
    "price (USD)": "32.02",
    "country": "United States"
  },
  {
    "Rank": "3915",
    "Name": "Cembra Money Bank",
    "Symbol": "CMBN.SW",
    " marketcap ": " $2 312 838 125 ",
    "price (USD)": "78.8425",
    "country": "Switzerland"
  },
  {
    "Rank": "3916",
    "Name": "CONMED",
    "Symbol": "CNMD",
    " marketcap ": " $2 305 740 544 ",
    "price (USD)": "74.86",
    "country": "United States"
  },
  {
    "Rank": "3917",
    "Name": "Finolex Industries",
    "Symbol": "FINPIPE.NS",
    " marketcap ": " $2 304 653 483 ",
    "price (USD)": "3.72716",
    "country": "India"
  },
  {
    "Rank": "3918",
    "Name": "Paymentus",
    "Symbol": "PAY",
    " marketcap ": " $2 304 632 320 ",
    "price (USD)": "18.56",
    "country": "United States"
  },
  {
    "Rank": "3919",
    "Name": "Sarana Menara Nusantara",
    "Symbol": "TOWR.JK",
    " marketcap ": " $2 304 067 763 ",
    "price (USD)": "0.0462674",
    "country": "Indonesia"
  },
  {
    "Rank": "3920",
    "Name": "Indivior PLC",
    "Symbol": "INDV",
    " marketcap ": " $2 302 756 096 ",
    "price (USD)": "17.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "3921",
    "Name": "Trident",
    "Symbol": "TRIDENT.NS",
    " marketcap ": " $2 300 620 035 ",
    "price (USD)": "0.457183",
    "country": "India"
  },
  {
    "Rank": "3922",
    "Name": "Werner Enterprises",
    "Symbol": "WERN",
    " marketcap ": " $2 299 347 968 ",
    "price (USD)": "36.26",
    "country": "United States"
  },
  {
    "Rank": "3923",
    "Name": "Altarea",
    "Symbol": "ALTA.PA",
    " marketcap ": " $2 298 796 464 ",
    "price (USD)": "110.544",
    "country": "France"
  },
  {
    "Rank": "3924",
    "Name": "Veeco",
    "Symbol": "VECO",
    " marketcap ": " $2 298 358 016 ",
    "price (USD)": "40.58",
    "country": "United States"
  },
  {
    "Rank": "3925",
    "Name": "Qt Group",
    "Symbol": "QTCOM.HE",
    " marketcap ": " $2 298 139 299 ",
    "price (USD)": "90.5093",
    "country": "Finland"
  },
  {
    "Rank": "3926",
    "Name": "Grocery Outlet",
    "Symbol": "GO",
    " marketcap ": " $2 296 818 944 ",
    "price (USD)": "23",
    "country": "United States"
  },
  {
    "Rank": "3927",
    "Name": "Icade",
    "Symbol": "ICAD.PA",
    " marketcap ": " $2 295 998 228 ",
    "price (USD)": "30.2965",
    "country": "France"
  },
  {
    "Rank": "3928",
    "Name": "Multi Commodity Exchange",
    "Symbol": "MCX.NS",
    " marketcap ": " $2 295 265 268 ",
    "price (USD)": "45.0911",
    "country": "India"
  },
  {
    "Rank": "3929",
    "Name": "BinDawood",
    "Symbol": "4161.SR",
    " marketcap ": " $2 290 697 537 ",
    "price (USD)": "2.00411",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3930",
    "Name": "Four Corners Property Trust",
    "Symbol": "FCPT",
    " marketcap ": " $2 287 788 800 ",
    "price (USD)": "24.84",
    "country": "United States"
  },
  {
    "Rank": "3931",
    "Name": "Plug Power",
    "Symbol": "PLUG",
    " marketcap ": " $2 287 081 472 ",
    "price (USD)": "03.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "3932",
    "Name": "Agilon Health",
    "Symbol": "AGL",
    " marketcap ": " $2 282 504 192 ",
    "price (USD)": "\u043c\u0430\u0439.55",
    "country": "United States"
  },
  {
    "Rank": "3933",
    "Name": "Simmons First National",
    "Symbol": "SFNC",
    " marketcap ": " $2 281 281 024 ",
    "price (USD)": "18.18",
    "country": "United States"
  },
  {
    "Rank": "3934",
    "Name": "Batelco (Bahrain Telecommunication Company)",
    "Symbol": "BEYON.BH",
    " marketcap ": " $2 280 833 952 ",
    "price (USD)": "1.34218",
    "country": "Bahrain"
  },
  {
    "Rank": "3935",
    "Name": "BEML",
    "Symbol": "BEML.NS",
    " marketcap ": " $2 278 800 555 ",
    "price (USD)": "54.6824",
    "country": "India"
  },
  {
    "Rank": "3936",
    "Name": "Cedar Fair",
    "Symbol": "FUN",
    " marketcap ": " $2 278 681 600 ",
    "price (USD)": "44.46",
    "country": "United States"
  },
  {
    "Rank": "3937",
    "Name": "\u0413\u2013sterreichische Post",
    "Symbol": "POST.VI",
    " marketcap ": " $2 277 672 086 ",
    "price (USD)": "33.717",
    "country": "Austria"
  },
  {
    "Rank": "3938",
    "Name": "Energix Renewable Energies",
    "Symbol": "ENRG.TA",
    " marketcap ": " $2 272 625 061 ",
    "price (USD)": "4.13667",
    "country": "Israel"
  },
  {
    "Rank": "3939",
    "Name": "KRUK Sp\u0413\u0456lka Akcyjna",
    "Symbol": "KRU.WA",
    " marketcap ": " $2 271 522 860 ",
    "price (USD)": "117.581",
    "country": "Poland"
  },
  {
    "Rank": "3940",
    "Name": "Kangwon Land",
    "Symbol": "035250.KS",
    " marketcap ": " $2 269 099 741 ",
    "price (USD)": "\u043d\u043e\u044f.22",
    "country": "South Korea"
  },
  {
    "Rank": "3941",
    "Name": "AvidXchange",
    "Symbol": "AVDX",
    " marketcap ": " $2 268 478 720 ",
    "price (USD)": "\u043e\u043a\u0442.98",
    "country": "United States"
  },
  {
    "Rank": "3942",
    "Name": "Keywords Studios",
    "Symbol": "KWS.L",
    " marketcap ": " $2 266 524 642 ",
    "price (USD)": "28.6314",
    "country": "Ireland"
  },
  {
    "Rank": "3943",
    "Name": "BASF India",
    "Symbol": "BASF.NS",
    " marketcap ": " $2 262 031 104 ",
    "price (USD)": "52.2583",
    "country": "India"
  },
  {
    "Rank": "3944",
    "Name": "Uponor",
    "Symbol": "UPONOR.HE",
    " marketcap ": " $2 261 952 785 ",
    "price (USD)": "31.0566",
    "country": "Finland"
  },
  {
    "Rank": "3945",
    "Name": "Park National Corp",
    "Symbol": "PRK",
    " marketcap ": " $2 261 737 472 ",
    "price (USD)": "140.05",
    "country": "United States"
  },
  {
    "Rank": "3946",
    "Name": "WHA Corporation",
    "Symbol": "WHA.BK",
    " marketcap ": " $2 260 370 156 ",
    "price (USD)": "0.151228",
    "country": "Thailand"
  },
  {
    "Rank": "3947",
    "Name": "Recursion Pharmaceuticals",
    "Symbol": "RXRX",
    " marketcap ": " $2 260 184 576 ",
    "price (USD)": "\u0441\u0435\u043d.51",
    "country": "United States"
  },
  {
    "Rank": "3948",
    "Name": "Independent Bank Corp (Massachusetts)",
    "Symbol": "INDB",
    " marketcap ": " $2 258 755 840 ",
    "price (USD)": "53.19",
    "country": "United States"
  },
  {
    "Rank": "3949",
    "Name": "Peyto Exploration &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "3950",
    "Name": "Powell Industries",
    "Symbol": "POWL",
    " marketcap ": " $2 253 106 944 ",
    "price (USD)": "187.95",
    "country": "United States"
  },
  {
    "Rank": "3951",
    "Name": "dormakaba",
    "Symbol": "DOKA.SW",
    " marketcap ": " $2 251 001 868 ",
    "price (USD)": "537.688",
    "country": "Switzerland"
  },
  {
    "Rank": "3952",
    "Name": "Land and Houses",
    "Symbol": "LH.BK",
    " marketcap ": " $2 250 692 878 ",
    "price (USD)": "0.188347",
    "country": "Thailand"
  },
  {
    "Rank": "3953",
    "Name": "Chartwell Retirement Residences",
    "Symbol": "CSH-UN.TO",
    " marketcap ": " $2 250 305 035 ",
    "price (USD)": "9.23054",
    "country": "Canada"
  },
  {
    "Rank": "3954",
    "Name": "Lightspeed POS",
    "Symbol": "LSPD",
    " marketcap ": " $2 247 397 888 ",
    "price (USD)": "14.61",
    "country": "Canada"
  },
  {
    "Rank": "3955",
    "Name": "Pacific Premier Bancorp",
    "Symbol": "PPBI",
    " marketcap ": " $2 246 853 888 ",
    "price (USD)": "23.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "3956",
    "Name": "Jasa Marga",
    "Symbol": "JSMR.JK",
    " marketcap ": " $2 246 245 949 ",
    "price (USD)": "0.309491",
    "country": "Indonesia"
  },
  {
    "Rank": "3957",
    "Name": "Alembic Pharmaceuticals",
    "Symbol": "APLLTD.NS",
    " marketcap ": " $2 244 744 111 ",
    "price (USD)": "\u043d\u043e\u044f.42",
    "country": "India"
  },
  {
    "Rank": "3958",
    "Name": "Perseus Mining",
    "Symbol": "PRU.AX",
    " marketcap ": " $2 244 335 688 ",
    "price (USD)": "1.63368",
    "country": "Australia"
  },
  {
    "Rank": "3959",
    "Name": "Lion Corp",
    "Symbol": "4912.T",
    " marketcap ": " $2 241 880 262 ",
    "price (USD)": "8.11208",
    "country": "Japan"
  },
  {
    "Rank": "3960",
    "Name": "Future Care Trading Company",
    "Symbol": "9544.SR",
    " marketcap ": " $2 241 613 825 ",
    "price (USD)": "4.48323",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3961",
    "Name": "Six Flags",
    "Symbol": "SIX",
    " marketcap ": " $2 241 590 016 ",
    "price (USD)": "26.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "3962",
    "Name": "Arhaus",
    "Symbol": "ARHS",
    " marketcap ": " $2 241 501 184 ",
    "price (USD)": "15.97",
    "country": "United States"
  },
  {
    "Rank": "3963",
    "Name": "Equinox Gold",
    "Symbol": "EQX",
    " marketcap ": " $2 240 434 688 ",
    "price (USD)": "\u043c\u0430\u0439.79",
    "country": "Canada"
  },
  {
    "Rank": "3964",
    "Name": "TeamViewer",
    "Symbol": "TMV.DE",
    " marketcap ": " $2 239 209 538 ",
    "price (USD)": "13.0199",
    "country": "Germany"
  },
  {
    "Rank": "3965",
    "Name": "Travis Perkins",
    "Symbol": "TPK.L",
    " marketcap ": " $2 236 886 777 ",
    "price (USD)": "\u043e\u043a\u0442.94",
    "country": "United Kingdom"
  },
  {
    "Rank": "3966",
    "Name": "Iamgold",
    "Symbol": "IAG",
    " marketcap ": " $2 235 867 392 ",
    "price (USD)": "\u0430\u043f\u0440.49",
    "country": "Canada"
  },
  {
    "Rank": "3967",
    "Name": "Plus500",
    "Symbol": "PLUS.L",
    " marketcap ": " $2 235 303 396 ",
    "price (USD)": "28.9103",
    "country": "Israel"
  },
  {
    "Rank": "3968",
    "Name": "Al Hammadi Holding Company",
    "Symbol": "4007.SR",
    " marketcap ": " $2 233 074 480 ",
    "price (USD)": "13.9567",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "3969",
    "Name": "Eutelsat",
    "Symbol": "ETL.PA",
    " marketcap ": " $2 232 218 534 ",
    "price (USD)": "4.70192",
    "country": "France"
  },
  {
    "Rank": "3970",
    "Name": "Weibo",
    "Symbol": "WB",
    " marketcap ": " $2 230 839 040 ",
    "price (USD)": "09.\u0438\u044e\u043b",
    "country": "China"
  },
  {
    "Rank": "3971",
    "Name": "Vector Limited",
    "Symbol": "VCT.NZ",
    " marketcap ": " $2 230 118 858 ",
    "price (USD)": "2.23012",
    "country": "New Zealand"
  },
  {
    "Rank": "3972",
    "Name": "SiriusPoint",
    "Symbol": "SPNT",
    " marketcap ": " $2 226 494 976 ",
    "price (USD)": "13.\u0438\u044e\u043d",
    "country": "Bermuda"
  },
  {
    "Rank": "3973",
    "Name": "First Financial Bank",
    "Symbol": "FFBC",
    " marketcap ": " $2 226 122 496 ",
    "price (USD)": "23.32",
    "country": "United States"
  },
  {
    "Rank": "3974",
    "Name": "Payoneer",
    "Symbol": "PAYO",
    " marketcap ": " $2 225 643 008 ",
    "price (USD)": "\u043c\u0430\u0439.96",
    "country": "United States"
  },
  {
    "Rank": "3975",
    "Name": "ADMA Biologics",
    "Symbol": "ADMA",
    " marketcap ": " $2 225 366 528 ",
    "price (USD)": "09.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "3976",
    "Name": "Domino's Pizza Enterprises (Australia)",
    "Symbol": "DMP.AX",
    " marketcap ": " $2 225 245 962 ",
    "price (USD)": "24.4719",
    "country": "Australia"
  },
  {
    "Rank": "3977",
    "Name": "First Majestic Silver",
    "Symbol": "AG",
    " marketcap ": " $2 223 950 336 ",
    "price (USD)": "\u0438\u044e\u043b.64",
    "country": "Canada"
  },
  {
    "Rank": "3978",
    "Name": "Mister Car Wash",
    "Symbol": "MCW",
    " marketcap ": " $2 223 782 656 ",
    "price (USD)": "\u0438\u044e\u043d.96",
    "country": "United States"
  },
  {
    "Rank": "3979",
    "Name": "Gibraltar Industries",
    "Symbol": "ROCK",
    " marketcap ": " $2 223 678 720 ",
    "price (USD)": "72.98",
    "country": "United States"
  },
  {
    "Rank": "3980",
    "Name": "Offcn Education",
    "Symbol": "002607.SZ",
    " marketcap ": " $2 223 545 565 ",
    "price (USD)": "0.360532",
    "country": "China"
  },
  {
    "Rank": "3981",
    "Name": "Netcompany Group",
    "Symbol": "NETC.CO",
    " marketcap ": " $2 223 330 111 ",
    "price (USD)": "45.3392",
    "country": "Denmark"
  },
  {
    "Rank": "3982",
    "Name": "Tianjin FAW",
    "Symbol": "000927.SZ",
    " marketcap ": " $2 223 133 662 ",
    "price (USD)": "0.367439",
    "country": "China"
  },
  {
    "Rank": "3983",
    "Name": "Qatar Aluminium Manufacturing Company",
    "Symbol": "QAMC.QA",
    " marketcap ": " $2 222 850 110 ",
    "price (USD)": "0.398352",
    "country": "Qatar"
  },
  {
    "Rank": "3984",
    "Name": "Patterson Companies",
    "Symbol": "PDCO",
    " marketcap ": " $2 222 777 600 ",
    "price (USD)": "24.81",
    "country": "United States"
  },
  {
    "Rank": "3985",
    "Name": "Devyani International",
    "Symbol": "DEVYANI.NS",
    " marketcap ": " $2 221 569 846 ",
    "price (USD)": "1.84135",
    "country": "India"
  },
  {
    "Rank": "3986",
    "Name": "Magazine Lu\u0413\u00adza",
    "Symbol": "MGLU3.SA",
    " marketcap ": " $2 219 521 249 ",
    "price (USD)": "0.302587",
    "country": "Brazil"
  },
  {
    "Rank": "3987",
    "Name": "ComfortDelGro",
    "Symbol": "C52.SI",
    " marketcap ": " $2 219 423 545 ",
    "price (USD)": "1.02454",
    "country": "Singapore"
  },
  {
    "Rank": "3988",
    "Name": "Progress Software",
    "Symbol": "PRGS",
    " marketcap ": " $2 217 520 896 ",
    "price (USD)": "51.31",
    "country": "United States"
  },
  {
    "Rank": "3989",
    "Name": "Iluka Resources",
    "Symbol": "ILU.AX",
    " marketcap ": " $2 217 171 194 ",
    "price (USD)": "5.18111",
    "country": "Australia"
  },
  {
    "Rank": "3990",
    "Name": "Spin Master",
    "Symbol": "TOY.TO",
    " marketcap ": " $2 216 460 181 ",
    "price (USD)": "21.3351",
    "country": "Canada"
  },
  {
    "Rank": "3991",
    "Name": "Puyi Inc.",
    "Symbol": "PUYI",
    " marketcap ": " $2 213 424 640 ",
    "price (USD)": "\u0430\u0432\u0433.96",
    "country": "China"
  },
  {
    "Rank": "3992",
    "Name": "Nifco Inc.",
    "Symbol": "7988.T",
    " marketcap ": " $2 210 586 413 ",
    "price (USD)": "22.6665",
    "country": "Japan"
  },
  {
    "Rank": "3993",
    "Name": "Minera Valpara\u0413\u00adso",
    "Symbol": "MINERA.SN",
    " marketcap ": " $2 210 022 557 ",
    "price (USD)": "17.6802",
    "country": "Chile"
  },
  {
    "Rank": "3994",
    "Name": "NH Hotel Group",
    "Symbol": "NHH.MC",
    " marketcap ": " $2 209 276 664 ",
    "price (USD)": "5.07113",
    "country": "Spain"
  },
  {
    "Rank": "3995",
    "Name": "BTS Group",
    "Symbol": "BTS.BK",
    " marketcap ": " $2 208 539 069 ",
    "price (USD)": "0.167725",
    "country": "Thailand"
  },
  {
    "Rank": "3996",
    "Name": "Rogers Corporation",
    "Symbol": "ROG",
    " marketcap ": " $2 207 448 832 ",
    "price (USD)": "118.32",
    "country": "United States"
  },
  {
    "Rank": "3997",
    "Name": "Myriad Genetics",
    "Symbol": "MYGN",
    " marketcap ": " $2 206 585 088 ",
    "price (USD)": "24.38",
    "country": "United States"
  },
  {
    "Rank": "3998",
    "Name": "Burgan Bank",
    "Symbol": "BURG.KW",
    " marketcap ": " $2 206 301 330 ",
    "price (USD)": "609.518",
    "country": "Kuwait"
  },
  {
    "Rank": "3999",
    "Name": "Talos Energy",
    "Symbol": "TALO",
    " marketcap ": " $2 205 188 864 ",
    "price (USD)": "\u043d\u043e\u044f.99",
    "country": "United States"
  },
  {
    "Rank": "4000",
    "Name": "Globalstar",
    "Symbol": "GSAT",
    " marketcap ": " $2 204 186 368 ",
    "price (USD)": "\u044f\u043d\u0432.17",
    "country": "United States"
  },
  {
    "Rank": "4001",
    "Name": "IDFC",
    "Symbol": "IDFC.NS",
    " marketcap ": " $2 203 106 028 ",
    "price (USD)": "1.37636",
    "country": "India"
  },
  {
    "Rank": "4002",
    "Name": "Urban Edge Properties",
    "Symbol": "UE",
    " marketcap ": " $2 202 791 680 ",
    "price (USD)": "17.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "4003",
    "Name": "Piramal Enterprises",
    "Symbol": "PEL.NS",
    " marketcap ": " $2 202 720 577 ",
    "price (USD)": "9.80451",
    "country": "India"
  },
  {
    "Rank": "4004",
    "Name": "Deciphera Pharmaceuticals",
    "Symbol": "DCPH",
    " marketcap ": " $2 202 543 616 ",
    "price (USD)": "25.47",
    "country": "United States"
  },
  {
    "Rank": "4005",
    "Name": "Rocket Lab",
    "Symbol": "RKLB",
    " marketcap ": " $2 197 798 912 ",
    "price (USD)": "\u0430\u043f\u0440.46",
    "country": "United States"
  },
  {
    "Rank": "4006",
    "Name": "Koza Gold",
    "Symbol": "KOZAL.IS",
    " marketcap ": " $2 196 470 855 ",
    "price (USD)": "0.685861",
    "country": "Turkey"
  },
  {
    "Rank": "4007",
    "Name": "Novavax",
    "Symbol": "NVAX",
    " marketcap ": " $2 196 213 248 ",
    "price (USD)": "14.91",
    "country": "United States"
  },
  {
    "Rank": "4008",
    "Name": "ZIM Integrated Shipping Services",
    "Symbol": "ZIM",
    " marketcap ": " $2 195 858 176 ",
    "price (USD)": "18.25",
    "country": "Israel"
  },
  {
    "Rank": "4009",
    "Name": "Ramco Cements",
    "Symbol": "RAMCOCEM.NS",
    " marketcap ": " $2 195 354 894 ",
    "price (USD)": "9.29086",
    "country": "India"
  },
  {
    "Rank": "4010",
    "Name": "Action Construction Equipment",
    "Symbol": "ACE.NS",
    " marketcap ": " $2 195 232 447 ",
    "price (USD)": "18.4459",
    "country": "India"
  },
  {
    "Rank": "4011",
    "Name": "Secure Energy Services",
    "Symbol": "SES.TO",
    " marketcap ": " $2 195 127 317 ",
    "price (USD)": "8.34341",
    "country": "Canada"
  },
  {
    "Rank": "4012",
    "Name": "Geron",
    "Symbol": "GERN",
    " marketcap ": " $2 194 592 000 ",
    "price (USD)": "03.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "4013",
    "Name": "Jamf",
    "Symbol": "JAMF",
    " marketcap ": " $2 193 976 832 ",
    "price (USD)": "17.35",
    "country": "United States"
  },
  {
    "Rank": "4014",
    "Name": "TransAlta",
    "Symbol": "TAC",
    " marketcap ": " $2 191 082 240 ",
    "price (USD)": "07.\u0444\u0435\u0432",
    "country": "Canada"
  },
  {
    "Rank": "4015",
    "Name": "MVV Energie",
    "Symbol": "MVV1.F",
    " marketcap ": " $2 189 975 198 ",
    "price (USD)": "33.0112",
    "country": "Germany"
  },
  {
    "Rank": "4016",
    "Name": "INFRONEER Holdings",
    "Symbol": "5076.T",
    " marketcap ": " $2 189 527 559 ",
    "price (USD)": "8.87019",
    "country": "Japan"
  },
  {
    "Rank": "4017",
    "Name": "sterling &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4018",
    "Name": "Tootsie Roll Industries",
    "Symbol": "TR",
    " marketcap ": " $2 186 276 352 ",
    "price (USD)": "30.25",
    "country": "United States"
  },
  {
    "Rank": "4019",
    "Name": "Grupa Kety",
    "Symbol": "KTY.WA",
    " marketcap ": " $2 185 906 565 ",
    "price (USD)": "225.764",
    "country": "Poland"
  },
  {
    "Rank": "4020",
    "Name": "ReNew Power",
    "Symbol": "RNW",
    " marketcap ": " $2 180 894 720 ",
    "price (USD)": "\u043c\u0430\u0439.97",
    "country": "India"
  },
  {
    "Rank": "4021",
    "Name": "BankUnited",
    "Symbol": "BKU",
    " marketcap ": " $2 180 655 872 ",
    "price (USD)": "29.17",
    "country": "United States"
  },
  {
    "Rank": "4022",
    "Name": "Arcos Dorados Holdings",
    "Symbol": "ARCO",
    " marketcap ": " $2 180 300 032 ",
    "price (USD)": "\u043e\u043a\u0442.35",
    "country": "Uruguay"
  },
  {
    "Rank": "4023",
    "Name": "Energizer Holdings",
    "Symbol": "ENR",
    " marketcap ": " $2 180 274 432 ",
    "price (USD)": "30.37",
    "country": "United States"
  },
  {
    "Rank": "4024",
    "Name": "MONETA Money Bank",
    "Symbol": "MONET.PR",
    " marketcap ": " $2 177 620 627 ",
    "price (USD)": "4.26149",
    "country": "Czech Republic"
  },
  {
    "Rank": "4025",
    "Name": "Trulieve Cannabis",
    "Symbol": "TRUL.CN",
    " marketcap ": " $2 176 433 564 ",
    "price (USD)": "\u043d\u043e\u044f.07",
    "country": "United States"
  },
  {
    "Rank": "4026",
    "Name": "Vera Therapeutics",
    "Symbol": "VERA",
    " marketcap ": " $2 174 919 680 ",
    "price (USD)": "39.76",
    "country": "United States"
  },
  {
    "Rank": "4027",
    "Name": "Kerry Logistics Network",
    "Symbol": "0636.HK",
    " marketcap ": " $2 172 455 956 ",
    "price (USD)": "1.20196",
    "country": "Hong Kong"
  },
  {
    "Rank": "4028",
    "Name": "Carel Industries",
    "Symbol": "CRL.MI",
    " marketcap ": " $2 171 924 821 ",
    "price (USD)": "19.3072",
    "country": "Italy"
  },
  {
    "Rank": "4029",
    "Name": "Al Ahli Bank of Kuwait",
    "Symbol": "ABK.KW",
    " marketcap ": " $2 171 806 623 ",
    "price (USD)": "876.793",
    "country": "Kuwait"
  },
  {
    "Rank": "4030",
    "Name": "NCC Limited",
    "Symbol": "NCC.NS",
    " marketcap ": " $2 171 102 628 ",
    "price (USD)": "3.45801",
    "country": "India"
  },
  {
    "Rank": "4031",
    "Name": "Upstart",
    "Symbol": "UPST",
    " marketcap ": " $2 170 586 624 ",
    "price (USD)": "24.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "4032",
    "Name": "CIMC Enric",
    "Symbol": "3899.HK",
    " marketcap ": " $2 170 206 521 ",
    "price (USD)": "1.06997",
    "country": "China"
  },
  {
    "Rank": "4033",
    "Name": "Merida Industry",
    "Symbol": "9914.TW",
    " marketcap ": " $2 169 573 850 ",
    "price (USD)": "7.25649",
    "country": "Taiwan"
  },
  {
    "Rank": "4034",
    "Name": "Kymera Therapeutics",
    "Symbol": "KYMR",
    " marketcap ": " $2 167 175 168 ",
    "price (USD)": "35.32",
    "country": "United States"
  },
  {
    "Rank": "4035",
    "Name": "Almirall",
    "Symbol": "ALM.MC",
    " marketcap ": " $2 165 860 215 ",
    "price (USD)": "10.354",
    "country": "Spain"
  },
  {
    "Rank": "4036",
    "Name": "Foot Locker",
    "Symbol": "FL",
    " marketcap ": " $2 164 871 168 ",
    "price (USD)": "22.91",
    "country": "United States"
  },
  {
    "Rank": "4037",
    "Name": "LiveRamp",
    "Symbol": "RAMP",
    " marketcap ": " $2 164 207 104 ",
    "price (USD)": "32.7",
    "country": "United States"
  },
  {
    "Rank": "4038",
    "Name": "TISCO Financial Group",
    "Symbol": "TISCO.BK",
    " marketcap ": " $2 162 926 371 ",
    "price (USD)": "2.70148",
    "country": "Thailand"
  },
  {
    "Rank": "4039",
    "Name": "Telephone and Data Systems",
    "Symbol": "TDS",
    " marketcap ": " $2 162 378 496 ",
    "price (USD)": "19.13",
    "country": "United States"
  },
  {
    "Rank": "4040",
    "Name": "Natco Pharma",
    "Symbol": "NATCOPHARM.NS",
    " marketcap ": " $2 161 319 907 ",
    "price (USD)": "12.067",
    "country": "India"
  },
  {
    "Rank": "4041",
    "Name": "BRP Group",
    "Symbol": "BRP",
    " marketcap ": " $2 160 187 904 ",
    "price (USD)": "32.66",
    "country": "United States"
  },
  {
    "Rank": "4042",
    "Name": "4imprint Group",
    "Symbol": "FOUR.L",
    " marketcap ": " $2 159 327 958 ",
    "price (USD)": "76.6467",
    "country": "United Kingdom"
  },
  {
    "Rank": "4043",
    "Name": "ODDITY Tech",
    "Symbol": "ODD",
    " marketcap ": " $2 159 228 672 ",
    "price (USD)": "37.97",
    "country": "Israel"
  },
  {
    "Rank": "4044",
    "Name": "Integra LifeSciences",
    "Symbol": "IART",
    " marketcap ": " $2 157 535 488 ",
    "price (USD)": "27.38",
    "country": "United States"
  },
  {
    "Rank": "4045",
    "Name": "National Industrialization Company (Saudi Arabia)",
    "Symbol": "2060.SR",
    " marketcap ": " $2 156 347 442 ",
    "price (USD)": "3.22365",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4046",
    "Name": "Grand City Properties",
    "Symbol": "GYC.DE",
    " marketcap ": " $2 152 344 394 ",
    "price (USD)": "\u0434\u0435\u043a.78",
    "country": "Luxembourg"
  },
  {
    "Rank": "4047",
    "Name": "Enlight Renewable Energy",
    "Symbol": "ENLT",
    " marketcap ": " $2 151 645 184 ",
    "price (USD)": "18.24",
    "country": "Israel"
  },
  {
    "Rank": "4048",
    "Name": "Mainova",
    "Symbol": "MNV6.F",
    " marketcap ": " $2 149 796 903 ",
    "price (USD)": "390.922",
    "country": "Germany"
  },
  {
    "Rank": "4049",
    "Name": "Coca-Cola Bottlers Japan",
    "Symbol": "2579.T",
    " marketcap ": " $2 149 094 475 ",
    "price (USD)": "\u043d\u043e\u044f.98",
    "country": "Japan"
  },
  {
    "Rank": "4050",
    "Name": "goeasy",
    "Symbol": "GSY.TO",
    " marketcap ": " $2 145 867 846 ",
    "price (USD)": "128.238",
    "country": "Canada"
  },
  {
    "Rank": "4051",
    "Name": "ePlus",
    "Symbol": "PLUS",
    " marketcap ": " $2 144 262 400 ",
    "price (USD)": "79.55",
    "country": "United States"
  },
  {
    "Rank": "4052",
    "Name": "HNI Corporation",
    "Symbol": "HNI",
    " marketcap ": " $2 142 558 592 ",
    "price (USD)": "45.3",
    "country": "United States"
  },
  {
    "Rank": "4053",
    "Name": "Olav Thon",
    "Symbol": "OLT.OL",
    " marketcap ": " $2 141 979 685 ",
    "price (USD)": "21.1076",
    "country": "Norway"
  },
  {
    "Rank": "4054",
    "Name": "H\u0413\u00b6egh Autoliners",
    "Symbol": "HAUTO.OL",
    " marketcap ": " $2 140 414 625 ",
    "price (USD)": "\u043d\u043e\u044f.99",
    "country": "Norway"
  },
  {
    "Rank": "4055",
    "Name": "Cinemark Theatres",
    "Symbol": "CNK",
    " marketcap ": " $2 138 608 000 ",
    "price (USD)": "17.48",
    "country": "United States"
  },
  {
    "Rank": "4056",
    "Name": "MFE-Mediaforeurope",
    "Symbol": "MFEA.MI",
    " marketcap ": " $2 134 938 534 ",
    "price (USD)": "3.37496",
    "country": "Italy"
  },
  {
    "Rank": "4057",
    "Name": "Maple Leaf Foods",
    "Symbol": "MFI.TO",
    " marketcap ": " $2 134 204 216 ",
    "price (USD)": "17.3833",
    "country": "Canada"
  },
  {
    "Rank": "4058",
    "Name": "Winpak",
    "Symbol": "WPK.TO",
    " marketcap ": " $2 132 402 578 ",
    "price (USD)": "32.9118",
    "country": "Canada"
  },
  {
    "Rank": "4059",
    "Name": "TODA corp",
    "Symbol": "1860.T",
    " marketcap ": " $2 132 235 652 ",
    "price (USD)": "6.94453",
    "country": "Japan"
  },
  {
    "Rank": "4060",
    "Name": "Saudi Chemical Holding Company",
    "Symbol": "2230.SR",
    " marketcap ": " $2 130 895 414 ",
    "price (USD)": "2.52715",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4061",
    "Name": "AUB Group",
    "Symbol": "AUB.AX",
    " marketcap ": " $2 129 548 106 ",
    "price (USD)": "19.6442",
    "country": "Australia"
  },
  {
    "Rank": "4062",
    "Name": "Argan SA",
    "Symbol": "ARG.PA",
    " marketcap ": " $2 128 122 524 ",
    "price (USD)": "82.6366",
    "country": "France"
  },
  {
    "Rank": "4063",
    "Name": "Zhejiang Jinke Tom Culture Industry",
    "Symbol": "300459.SZ",
    " marketcap ": " $2 127 173 746 ",
    "price (USD)": "0.605031",
    "country": "China"
  },
  {
    "Rank": "4064",
    "Name": "Compass",
    "Symbol": "COMP",
    " marketcap ": " $2 126 315 648 ",
    "price (USD)": "04.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "4065",
    "Name": "Mandarin Oriental",
    "Symbol": "M04.SI",
    " marketcap ": " $2 123 200 768 ",
    "price (USD)": "\u044f\u043d\u0432.68",
    "country": "Hong Kong"
  },
  {
    "Rank": "4066",
    "Name": "AMN Healthcare Services",
    "Symbol": "AMN",
    " marketcap ": " $2 122 143 616 ",
    "price (USD)": "55.85",
    "country": "United States"
  },
  {
    "Rank": "4067",
    "Name": "Aperam",
    "Symbol": "APAM.AS",
    " marketcap ": " $2 115 119 036 ",
    "price (USD)": "29.0151",
    "country": "Luxembourg"
  },
  {
    "Rank": "4068",
    "Name": "LEM Holding",
    "Symbol": "LEHN.SW",
    " marketcap ": " $2 112 133 715 ",
    "price (USD)": "1854.47",
    "country": "Switzerland"
  },
  {
    "Rank": "4069",
    "Name": "Sunstone Hotel Investors",
    "Symbol": "SHO",
    " marketcap ": " $2 110 062 592 ",
    "price (USD)": "\u043e\u043a\u0442.36",
    "country": "United States"
  },
  {
    "Rank": "4070",
    "Name": "Atul",
    "Symbol": "ATUL.NS",
    " marketcap ": " $2 109 659 131 ",
    "price (USD)": "71.6552",
    "country": "India"
  },
  {
    "Rank": "4071",
    "Name": "Bread Financial",
    "Symbol": "BFH",
    " marketcap ": " $2 108 824 448 ",
    "price (USD)": "42.53",
    "country": "United States"
  },
  {
    "Rank": "4072",
    "Name": "RITES",
    "Symbol": "RITES.NS",
    " marketcap ": " $2 108 019 688 ",
    "price (USD)": "8.77179",
    "country": "India"
  },
  {
    "Rank": "4073",
    "Name": "Bata India",
    "Symbol": "BATAINDIA.NS",
    " marketcap ": " $2 106 356 818 ",
    "price (USD)": "16.3883",
    "country": "India"
  },
  {
    "Rank": "4074",
    "Name": "IIFL Wealth Management",
    "Symbol": "IIFLWAM.NS",
    " marketcap ": " $2 105 477 693 ",
    "price (USD)": "23.66",
    "country": "India"
  },
  {
    "Rank": "4075",
    "Name": "VIZIO",
    "Symbol": "VZIO",
    " marketcap ": " $2 104 037 248 ",
    "price (USD)": "\u043e\u043a\u0442.61",
    "country": "United States"
  },
  {
    "Rank": "4076",
    "Name": "RHI Magnesita",
    "Symbol": "RHF.F",
    " marketcap ": " $2 103 767 358 ",
    "price (USD)": "44.6303",
    "country": "Austria"
  },
  {
    "Rank": "4077",
    "Name": "Atoss",
    "Symbol": "AOF.F",
    " marketcap ": " $2 102 931 445 ",
    "price (USD)": "264.415",
    "country": "Germany"
  },
  {
    "Rank": "4078",
    "Name": "SolarWinds",
    "Symbol": "SWI",
    " marketcap ": " $2 102 400 000 ",
    "price (USD)": "12.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "4079",
    "Name": "Cimpress",
    "Symbol": "CMPR",
    " marketcap ": " $2 100 717 312 ",
    "price (USD)": "82.54",
    "country": "Ireland"
  },
  {
    "Rank": "4080",
    "Name": "KWS",
    "Symbol": "KWS.F",
    " marketcap ": " $2 100 301 392 ",
    "price (USD)": "62.6561",
    "country": "Germany"
  },
  {
    "Rank": "4081",
    "Name": "Janus International Group",
    "Symbol": "JBI",
    " marketcap ": " $2 099 163 648 ",
    "price (USD)": "14.38",
    "country": "United States"
  },
  {
    "Rank": "4082",
    "Name": "Finolex Cables",
    "Symbol": "FINCABLES.NS",
    " marketcap ": " $2 099 105 313 ",
    "price (USD)": "13.7251",
    "country": "India"
  },
  {
    "Rank": "4083",
    "Name": "Bumble",
    "Symbol": "BMBL",
    " marketcap ": " $2 096 804 992 ",
    "price (USD)": "12.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "4084",
    "Name": "Bank f\u0413\u0458r Tirol und Vorarlberg",
    "Symbol": "BTS.VI",
    " marketcap ": " $2 095 336 232 ",
    "price (USD)": "56.4665",
    "country": "Austria"
  },
  {
    "Rank": "4085",
    "Name": "Hays plc",
    "Symbol": "HAS.L",
    " marketcap ": " $2 093 351 417 ",
    "price (USD)": "1.32091",
    "country": "United Kingdom"
  },
  {
    "Rank": "4086",
    "Name": "Criteo",
    "Symbol": "CRTO",
    " marketcap ": " $2 088 934 272 ",
    "price (USD)": "36.85",
    "country": "France"
  },
  {
    "Rank": "4087",
    "Name": "STAAR Surgical",
    "Symbol": "STAA",
    " marketcap ": " $2 088 562 944 ",
    "price (USD)": "42.51",
    "country": "United States"
  },
  {
    "Rank": "4088",
    "Name": "Spar Nord Bank A/S",
    "Symbol": "SPNO.CO",
    " marketcap ": " $2 088 160 246 ",
    "price (USD)": "17.9553",
    "country": "Denmark"
  },
  {
    "Rank": "4089",
    "Name": "Flywire",
    "Symbol": "FLYW",
    " marketcap ": " $2 085 334 912 ",
    "price (USD)": "16.79",
    "country": "United States"
  },
  {
    "Rank": "4090",
    "Name": "Enerpac Tool Group",
    "Symbol": "EPAC",
    " marketcap ": " $2 084 962 048 ",
    "price (USD)": "38.43",
    "country": "United States"
  },
  {
    "Rank": "4091",
    "Name": "Dermapharm",
    "Symbol": "DMP.F",
    " marketcap ": " $2 084 261 153 ",
    "price (USD)": "38.7121",
    "country": "Germany"
  },
  {
    "Rank": "4092",
    "Name": "Port of Tauranga",
    "Symbol": "POT.NZ",
    " marketcap ": " $2 083 895 993 ",
    "price (USD)": "3.06335",
    "country": "New Zealand"
  },
  {
    "Rank": "4093",
    "Name": "Barnes Group",
    "Symbol": "B",
    " marketcap ": " $2 081 828 352 ",
    "price (USD)": "41.06",
    "country": "United States"
  },
  {
    "Rank": "4094",
    "Name": "Equity Commonwealth",
    "Symbol": "EQC",
    " marketcap ": " $2 081 548 544 ",
    "price (USD)": "19.36",
    "country": "United States"
  },
  {
    "Rank": "4095",
    "Name": "Adeka Corporation",
    "Symbol": "4401.T",
    " marketcap ": " $2 080 406 197 ",
    "price (USD)": "20.3698",
    "country": "Japan"
  },
  {
    "Rank": "4096",
    "Name": "John Wiley &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4097",
    "Name": "Hilltop Holdings",
    "Symbol": "HTH",
    " marketcap ": " $2 078 750 848 ",
    "price (USD)": "31.85",
    "country": "United States"
  },
  {
    "Rank": "4098",
    "Name": "TowneBank",
    "Symbol": "TOWN",
    " marketcap ": " $2 078 269 440 ",
    "price (USD)": "27.71",
    "country": "United States"
  },
  {
    "Rank": "4099",
    "Name": "Strauss Group",
    "Symbol": "STRS.TA",
    " marketcap ": " $2 077 204 049 ",
    "price (USD)": "17.8201",
    "country": "Israel"
  },
  {
    "Rank": "4100",
    "Name": "Kennametal",
    "Symbol": "KMT",
    " marketcap ": " $2 075 993 216 ",
    "price (USD)": "26.39",
    "country": "United States"
  },
  {
    "Rank": "4101",
    "Name": "UCT (Ultra Clean Holdings)",
    "Symbol": "UCTT",
    " marketcap ": " $2 073 305 344 ",
    "price (USD)": "46.17",
    "country": "United States"
  },
  {
    "Rank": "4102",
    "Name": "Blue Dart Express",
    "Symbol": "BLUEDART.NS",
    " marketcap ": " $2 070 902 673 ",
    "price (USD)": "87.2698",
    "country": "India"
  },
  {
    "Rank": "4103",
    "Name": "Textainer Group",
    "Symbol": "TGH",
    " marketcap ": " $2 068 376 320 ",
    "price (USD)": "49.99",
    "country": "Bermuda"
  },
  {
    "Rank": "4104",
    "Name": "Amneal Pharmaceuticals",
    "Symbol": "AMRX",
    " marketcap ": " $2 064 875 264 ",
    "price (USD)": "\u0438\u044e\u043d.69",
    "country": "United States"
  },
  {
    "Rank": "4105",
    "Name": "Rumble",
    "Symbol": "RUM",
    " marketcap ": " $2 062 077 824 ",
    "price (USD)": "\u0438\u044e\u043b.31",
    "country": "United States"
  },
  {
    "Rank": "4106",
    "Name": "Bank Jago",
    "Symbol": "ARTO.JK",
    " marketcap ": " $2 061 882 896 ",
    "price (USD)": "0.148806",
    "country": "Indonesia"
  },
  {
    "Rank": "4107",
    "Name": "Growthpoint Properties",
    "Symbol": "GRT.JO",
    " marketcap ": " $2 061 865 200 ",
    "price (USD)": "0.607181",
    "country": "South Africa"
  },
  {
    "Rank": "4108",
    "Name": "Delek Group",
    "Symbol": "DLEKG.TA",
    " marketcap ": " $2 060 544 503 ",
    "price (USD)": "110.848",
    "country": "Israel"
  },
  {
    "Rank": "4109",
    "Name": "Palomar Holdings",
    "Symbol": "PLMR",
    " marketcap ": " $2 059 412 224 ",
    "price (USD)": "82.63",
    "country": "United States"
  },
  {
    "Rank": "4110",
    "Name": "Calix",
    "Symbol": "CALX",
    " marketcap ": " $2 058 795 520 ",
    "price (USD)": "31.42",
    "country": "United States"
  },
  {
    "Rank": "4111",
    "Name": "First Merchants Corporation",
    "Symbol": "FRME",
    " marketcap ": " $2 058 552 832 ",
    "price (USD)": "35.15",
    "country": "United States"
  },
  {
    "Rank": "4112",
    "Name": "Workman",
    "Symbol": "7564.T",
    " marketcap ": " $2 057 095 447 ",
    "price (USD)": "25.2063",
    "country": "Japan"
  },
  {
    "Rank": "4113",
    "Name": "Garrett Motion",
    "Symbol": "GTX",
    " marketcap ": " $2 056 509 056 ",
    "price (USD)": "09.\u044f\u043d\u0432",
    "country": "Switzerland"
  },
  {
    "Rank": "4114",
    "Name": "Savers Value Village",
    "Symbol": "SVV",
    " marketcap ": " $2 054 783 744 ",
    "price (USD)": "12.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "4115",
    "Name": "Dave & Buster's",
    "Symbol": "PLAY",
    " marketcap ": " $2 054 581 248 ",
    "price (USD)": "50.86",
    "country": "United States"
  },
  {
    "Rank": "4116",
    "Name": "Top Glove",
    "Symbol": "BVA.SI",
    " marketcap ": " $2 051 181 778 ",
    "price (USD)": "0.256134",
    "country": "Malaysia"
  },
  {
    "Rank": "4117",
    "Name": "DHT Holdings",
    "Symbol": "DHT",
    " marketcap ": " $2 050 491 520 ",
    "price (USD)": "\u0434\u0435\u043a.71",
    "country": "Bermuda"
  },
  {
    "Rank": "4118",
    "Name": "Amphastar Pharmaceuticals",
    "Symbol": "AMPH",
    " marketcap ": " $2 049 482 752 ",
    "price (USD)": "41.91",
    "country": "United States"
  },
  {
    "Rank": "4119",
    "Name": "National Medical Care Company",
    "Symbol": "4005.SR",
    " marketcap ": " $2 046 633 546 ",
    "price (USD)": "45.6329",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4120",
    "Name": "Aspen Aerogels",
    "Symbol": "ASPN",
    " marketcap ": " $2 046 451 456 ",
    "price (USD)": "26.87",
    "country": "United States"
  },
  {
    "Rank": "4121",
    "Name": "Standex",
    "Symbol": "SXI",
    " marketcap ": " $2 046 082 048 ",
    "price (USD)": "172.62",
    "country": "United States"
  },
  {
    "Rank": "4122",
    "Name": "NextDecade Corp",
    "Symbol": "NEXT",
    " marketcap ": " $2 045 892 352 ",
    "price (USD)": "\u0438\u044e\u043b.93",
    "country": "United States"
  },
  {
    "Rank": "4123",
    "Name": "Abu Dhabi National Hotels",
    "Symbol": "ADNH.AE",
    " marketcap ": " $2 044 708 253 ",
    "price (USD)": "0.16",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "4124",
    "Name": "Seacoast Banking",
    "Symbol": "SBCF",
    " marketcap ": " $2 044 387 968 ",
    "price (USD)": "24.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "4125",
    "Name": "Cable One",
    "Symbol": "CABO",
    " marketcap ": " $2 043 603 200 ",
    "price (USD)": "363.69",
    "country": "United States"
  },
  {
    "Rank": "4126",
    "Name": "Denison Mines",
    "Symbol": "DNN",
    " marketcap ": " $2 043 235 712 ",
    "price (USD)": "\u0444\u0435\u0432.28",
    "country": "Canada"
  },
  {
    "Rank": "4127",
    "Name": "Wheels Up",
    "Symbol": "UP",
    " marketcap ": " $2 043 097 728 ",
    "price (USD)": "\u0444\u0435\u0432.93",
    "country": "United States"
  },
  {
    "Rank": "4128",
    "Name": "Beam Therapeutics",
    "Symbol": "BEAM",
    " marketcap ": " $2 041 315 328 ",
    "price (USD)": "24.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "4129",
    "Name": "Bilfinger",
    "Symbol": "GBF.F",
    " marketcap ": " $2 041 294 212 ",
    "price (USD)": "54.1861",
    "country": "Germany"
  },
  {
    "Rank": "4130",
    "Name": "Metro AG",
    "Symbol": "B4B.F",
    " marketcap ": " $2 039 495 485 ",
    "price (USD)": "5.50548",
    "country": "Germany"
  },
  {
    "Rank": "4131",
    "Name": "Al-Dawaa Medical Services Company",
    "Symbol": "4163.SR",
    " marketcap ": " $2 039 201 601 ",
    "price (USD)": "23.9906",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4132",
    "Name": "PHINIA",
    "Symbol": "PHIN",
    " marketcap ": " $2 036 548 224 ",
    "price (USD)": "44.58",
    "country": "United States"
  },
  {
    "Rank": "4133",
    "Name": "Omantel (Oman Telecom)",
    "Symbol": "OTEL.OM",
    " marketcap ": " $2 036 243 180 ",
    "price (USD)": "2.71499",
    "country": "Oman"
  },
  {
    "Rank": "4134",
    "Name": "Provident Financial Services",
    "Symbol": "PFS",
    " marketcap ": " $2 036 109 056 ",
    "price (USD)": "15.64",
    "country": "United States"
  },
  {
    "Rank": "4135",
    "Name": "Permata Bank",
    "Symbol": "BNLI.JK",
    " marketcap ": " $2 035 961 552 ",
    "price (USD)": "0.0562711",
    "country": "Indonesia"
  },
  {
    "Rank": "4136",
    "Name": "Fidelis Insurance",
    "Symbol": "FIHL",
    " marketcap ": " $2 034 025 216 ",
    "price (USD)": "17.\u0430\u043f\u0440",
    "country": "Bermuda"
  },
  {
    "Rank": "4137",
    "Name": "Robertet",
    "Symbol": "CBE.PA",
    " marketcap ": " $2 030 224 276 ",
    "price (USD)": "931.697",
    "country": "France"
  },
  {
    "Rank": "4138",
    "Name": "TF1",
    "Symbol": "TFI.PA",
    " marketcap ": " $2 030 185 775 ",
    "price (USD)": "\u0441\u0435\u043d.93",
    "country": "France"
  },
  {
    "Rank": "4139",
    "Name": "Ambarella",
    "Symbol": "AMBA",
    " marketcap ": " $2 028 342 784 ",
    "price (USD)": "49.49",
    "country": "United States"
  },
  {
    "Rank": "4140",
    "Name": "IIFL Finance",
    "Symbol": "IIFL.NS",
    " marketcap ": " $2 027 625 737 ",
    "price (USD)": "\u0430\u043f\u0440.21",
    "country": "India"
  },
  {
    "Rank": "4141",
    "Name": "Premier",
    "Symbol": "PINC",
    " marketcap ": " $2 027 218 816 ",
    "price (USD)": "19.34",
    "country": "United States"
  },
  {
    "Rank": "4142",
    "Name": "Rocket Pharmaceuticals",
    "Symbol": "RCKT",
    " marketcap ": " $2 027 166 464 ",
    "price (USD)": "22.33",
    "country": "United States"
  },
  {
    "Rank": "4143",
    "Name": "Vista Outdoor",
    "Symbol": "VSTO",
    " marketcap ": " $2 021 934 080 ",
    "price (USD)": "34.74",
    "country": "United States"
  },
  {
    "Rank": "4144",
    "Name": "SUSE S.A.",
    "Symbol": "SUSE.DE",
    " marketcap ": " $2 021 608 038 ",
    "price (USD)": "\u043d\u043e\u044f.89",
    "country": "Luxembourg"
  },
  {
    "Rank": "4145",
    "Name": "XL Axiata",
    "Symbol": "EXCL.JK",
    " marketcap ": " $2 018 731 575 ",
    "price (USD)": "0.154433",
    "country": "Indonesia"
  },
  {
    "Rank": "4146",
    "Name": "First Pacific Company",
    "Symbol": "0142.HK",
    " marketcap ": " $2 017 252 169 ",
    "price (USD)": "0.475401",
    "country": "Hong Kong"
  },
  {
    "Rank": "4147",
    "Name": "Dana",
    "Symbol": "DAN",
    " marketcap ": " $2 016 435 456 ",
    "price (USD)": "13.91",
    "country": "United States"
  },
  {
    "Rank": "4148",
    "Name": "Kuwait Projects Company Holding",
    "Symbol": "KPROJ.KW",
    " marketcap ": " $2 016 030 665 ",
    "price (USD)": "404.172",
    "country": "Kuwait"
  },
  {
    "Rank": "4149",
    "Name": "Exclusive Networks",
    "Symbol": "EXN.PA",
    " marketcap ": " $2 015 962 333 ",
    "price (USD)": "21.6962",
    "country": "France"
  },
  {
    "Rank": "4150",
    "Name": "UFP Technologies",
    "Symbol": "UFPT",
    " marketcap ": " $2 014 117 120 ",
    "price (USD)": "262.58",
    "country": "United States"
  },
  {
    "Rank": "4151",
    "Name": "O-I Glass",
    "Symbol": "OI",
    " marketcap ": " $2 013 485 568 ",
    "price (USD)": "\u0434\u0435\u043a.93",
    "country": "United States"
  },
  {
    "Rank": "4152",
    "Name": "Sonos",
    "Symbol": "SONO",
    " marketcap ": " $2 013 118 336 ",
    "price (USD)": "16.38",
    "country": "United States"
  },
  {
    "Rank": "4153",
    "Name": "Doosan",
    "Symbol": "000150.KS",
    " marketcap ": " $2 011 217 710 ",
    "price (USD)": "130.282",
    "country": "South Korea"
  },
  {
    "Rank": "4154",
    "Name": "Aker Solutions ASA",
    "Symbol": "AKSO.OL",
    " marketcap ": " $2 010 644 710 ",
    "price (USD)": "4.16899",
    "country": "Norway"
  },
  {
    "Rank": "4155",
    "Name": "Ninety One Group",
    "Symbol": "N91.L",
    " marketcap ": " $2 008 881 864 ",
    "price (USD)": "2.20832",
    "country": "South Africa"
  },
  {
    "Rank": "4156",
    "Name": "Warby Parker",
    "Symbol": "WRBY",
    " marketcap ": " $2 008 767 744 ",
    "price (USD)": "16.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "4157",
    "Name": "Sharjah Islamic Bank",
    "Symbol": "SIB.AE",
    " marketcap ": " $2 008 697 965 ",
    "price (USD)": "0.62",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "4158",
    "Name": "Zai Lab",
    "Symbol": "ZLAB",
    " marketcap ": " $2 007 543 296 ",
    "price (USD)": "20.\u044f\u043d\u0432",
    "country": "China"
  },
  {
    "Rank": "4159",
    "Name": "Technogym",
    "Symbol": "TGYM.MI",
    " marketcap ": " $2 007 038 054 ",
    "price (USD)": "10.0825",
    "country": "Italy"
  },
  {
    "Rank": "4160",
    "Name": "Teladoc Health",
    "Symbol": "TDOC",
    " marketcap ": " $2 006 226 048 ",
    "price (USD)": "\u043d\u043e\u044f.83",
    "country": "United States"
  },
  {
    "Rank": "4161",
    "Name": "PageGroup",
    "Symbol": "PAGE.L",
    " marketcap ": " $2 005 304 367 ",
    "price (USD)": "6.09482",
    "country": "United Kingdom"
  },
  {
    "Rank": "4162",
    "Name": "Polestar",
    "Symbol": "PSNY",
    " marketcap ": " $2 004 670 976 ",
    "price (USD)": "0.95",
    "country": "Sweden"
  },
  {
    "Rank": "4163",
    "Name": "Amot Investment",
    "Symbol": "AMOT.TA",
    " marketcap ": " $2 000 587 784 ",
    "price (USD)": "4.24302",
    "country": "Israel"
  },
  {
    "Rank": "4164",
    "Name": "Sohar International Bank",
    "Symbol": "BKSB.OM",
    " marketcap ": " $1 999 636 231 ",
    "price (USD)": "0.358535",
    "country": "Oman"
  },
  {
    "Rank": "4165",
    "Name": "Sixth Street Specialty Lending",
    "Symbol": "TSLX",
    " marketcap ": " $1 998 150 400 ",
    "price (USD)": "21.55",
    "country": "United States"
  },
  {
    "Rank": "4166",
    "Name": "Rover",
    "Symbol": "ROVR",
    " marketcap ": " $1 998 059 008 ",
    "price (USD)": "\u043e\u043a\u0442.99",
    "country": "United States"
  },
  {
    "Rank": "4167",
    "Name": "Quilter",
    "Symbol": "QLT.L",
    " marketcap ": " $1 997 999 985 ",
    "price (USD)": "1.43916",
    "country": "United Kingdom"
  },
  {
    "Rank": "4168",
    "Name": "Chalet Hotels",
    "Symbol": "CHALET.NS",
    " marketcap ": " $1 997 902 754 ",
    "price (USD)": "9.16049",
    "country": "India"
  },
  {
    "Rank": "4169",
    "Name": "Vermilion Energy",
    "Symbol": "VET",
    " marketcap ": " $1 995 274 368 ",
    "price (USD)": "\u0434\u0435\u043a.45",
    "country": "Canada"
  },
  {
    "Rank": "4170",
    "Name": "Kainos Group",
    "Symbol": "KNOS.L",
    " marketcap ": " $1 994 401 332 ",
    "price (USD)": "15.8511",
    "country": "United Kingdom"
  },
  {
    "Rank": "4171",
    "Name": "Central Puerto",
    "Symbol": "CEPU",
    " marketcap ": " $1 994 116 864 ",
    "price (USD)": "10.\u0441\u0435\u043d",
    "country": "Argentina"
  },
  {
    "Rank": "4172",
    "Name": "Saudi Real Estate Company (Al Akaria)",
    "Symbol": "4020.SR",
    " marketcap ": " $1 991 433 790 ",
    "price (USD)": "5.31049",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4173",
    "Name": "Stepan Company",
    "Symbol": "SCL",
    " marketcap ": " $1 989 927 680 ",
    "price (USD)": "88.54",
    "country": "United States"
  },
  {
    "Rank": "4174",
    "Name": "Edgewell Personal Care",
    "Symbol": "EPC",
    " marketcap ": " $1 989 109 632 ",
    "price (USD)": "40.14",
    "country": "United States"
  },
  {
    "Rank": "4175",
    "Name": "SFL Corp",
    "Symbol": "SFL",
    " marketcap ": " $1 987 126 528 ",
    "price (USD)": "14.43",
    "country": "Bermuda"
  },
  {
    "Rank": "4176",
    "Name": "Redington India",
    "Symbol": "REDINGTON.NS",
    " marketcap ": " $1 983 389 900 ",
    "price (USD)": "2.53704",
    "country": "India"
  },
  {
    "Rank": "4177",
    "Name": "Inter Cars",
    "Symbol": "CAR.WA",
    " marketcap ": " $1 982 868 281 ",
    "price (USD)": "139.953",
    "country": "Poland"
  },
  {
    "Rank": "4178",
    "Name": "Verint Systems",
    "Symbol": "VRNT",
    " marketcap ": " $1 979 206 272 ",
    "price (USD)": "31.73",
    "country": "United States"
  },
  {
    "Rank": "4179",
    "Name": "Singapore Land",
    "Symbol": "U06.SI",
    " marketcap ": " $1 978 370 547 ",
    "price (USD)": "\u044f\u043d\u0432.09",
    "country": "Singapore"
  },
  {
    "Rank": "4180",
    "Name": "Tennant Company",
    "Symbol": "TNC",
    " marketcap ": " $1 978 110 464 ",
    "price (USD)": "104.07",
    "country": "United States"
  },
  {
    "Rank": "4181",
    "Name": "EverCommerce",
    "Symbol": "EVCM",
    " marketcap ": " $1 976 900 224 ",
    "price (USD)": "\u043e\u043a\u0442.68",
    "country": "United States"
  },
  {
    "Rank": "4182",
    "Name": "NCR Voyix Corporation",
    "Symbol": "VYX",
    " marketcap ": " $1 976 554 624 ",
    "price (USD)": "13.63",
    "country": "United States"
  },
  {
    "Rank": "4183",
    "Name": "MillerKnoll",
    "Symbol": "MLKN",
    " marketcap ": " $1 975 798 144 ",
    "price (USD)": "27.58",
    "country": "United States"
  },
  {
    "Rank": "4184",
    "Name": "V-Guard Industries",
    "Symbol": "VGUARD.NS",
    " marketcap ": " $1 974 392 451 ",
    "price (USD)": "4.53879",
    "country": "India"
  },
  {
    "Rank": "4185",
    "Name": "Formosa Sumco Technology",
    "Symbol": "3532.TW",
    " marketcap ": " $1 972 495 636 ",
    "price (USD)": "5.08574",
    "country": "Taiwan"
  },
  {
    "Rank": "4186",
    "Name": "Krispy Kreme",
    "Symbol": "DNUT",
    " marketcap ": " $1 972 465 408 ",
    "price (USD)": "\u043d\u043e\u044f.69",
    "country": "United States"
  },
  {
    "Rank": "4187",
    "Name": "JOYY",
    "Symbol": "YY",
    " marketcap ": " $1 970 935 552 ",
    "price (USD)": "33.37",
    "country": "China"
  },
  {
    "Rank": "4188",
    "Name": "WH Smith",
    "Symbol": "SMWH.L",
    " marketcap ": " $1 970 578 852 ",
    "price (USD)": "15.0527",
    "country": "United Kingdom"
  },
  {
    "Rank": "4189",
    "Name": "Sonae",
    "Symbol": "SON.LS",
    " marketcap ": " $1 969 753 763 ",
    "price (USD)": "1.02074",
    "country": "Portugal"
  },
  {
    "Rank": "4190",
    "Name": "Patria Investments",
    "Symbol": "PAX",
    " marketcap ": " $1 968 533 888 ",
    "price (USD)": "13.\u0438\u044e\u043d",
    "country": "Cayman Islands"
  },
  {
    "Rank": "4191",
    "Name": "Redcare Pharmacy",
    "Symbol": "RDC.DE",
    " marketcap ": " $1 966 370 220 ",
    "price (USD)": "108.046",
    "country": "Netherlands"
  },
  {
    "Rank": "4192",
    "Name": "NuVista Energy",
    "Symbol": "NVA.TO",
    " marketcap ": " $1 965 066 661 ",
    "price (USD)": "9.52381",
    "country": "Canada"
  },
  {
    "Rank": "4193",
    "Name": "Rush Street Interactive",
    "Symbol": "RSI",
    " marketcap ": " $1 964 800 000 ",
    "price (USD)": "\u0430\u0432\u0433.73",
    "country": "United States"
  },
  {
    "Rank": "4194",
    "Name": "Is Yatirim Menkul Degerler Anonim Sirketi",
    "Symbol": "ISMEN.IS",
    " marketcap ": " $1 961 600 408 ",
    "price (USD)": "1.30773",
    "country": "Turkey"
  },
  {
    "Rank": "4195",
    "Name": "BFF Bank",
    "Symbol": "BFF.MI",
    " marketcap ": " $1 959 362 537 ",
    "price (USD)": "\u043e\u043a\u0442.83",
    "country": "Italy"
  },
  {
    "Rank": "4196",
    "Name": "Bavarian Nordic",
    "Symbol": "BAVA.CO",
    " marketcap ": " $1 959 195 046 ",
    "price (USD)": "25.1359",
    "country": "Denmark"
  },
  {
    "Rank": "4197",
    "Name": "Cadeler A/S",
    "Symbol": "CDLR",
    " marketcap ": " $1 958 189 312 ",
    "price (USD)": "22.32",
    "country": "Denmark"
  },
  {
    "Rank": "4198",
    "Name": "Trainline",
    "Symbol": "TRN.L",
    " marketcap ": " $1 955 996 939 ",
    "price (USD)": "4.15475",
    "country": "United Kingdom"
  },
  {
    "Rank": "4199",
    "Name": "Mercari",
    "Symbol": "4385.T",
    " marketcap ": " $1 955 980 454 ",
    "price (USD)": "\u043d\u043e\u044f.06",
    "country": "Japan"
  },
  {
    "Rank": "4200",
    "Name": "Ariston Holding",
    "Symbol": "ARIS.MI",
    " marketcap ": " $1 955 362 137 ",
    "price (USD)": "5.25573",
    "country": "Italy"
  },
  {
    "Rank": "4201",
    "Name": "H&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4202",
    "Name": "Sonic Automotive",
    "Symbol": "SAH",
    " marketcap ": " $1 955 299 712 ",
    "price (USD)": "57.34",
    "country": "United States"
  },
  {
    "Rank": "4203",
    "Name": "Catalyst Pharmaceuticals",
    "Symbol": "CPRX",
    " marketcap ": " $1 952 441 088 ",
    "price (USD)": "16.53",
    "country": "United States"
  },
  {
    "Rank": "4204",
    "Name": "Mach Natural Resources LP",
    "Symbol": "MNR",
    " marketcap ": " $1 952 249 984 ",
    "price (USD)": "20.55",
    "country": "United States"
  },
  {
    "Rank": "4205",
    "Name": "Aktieselskabet Schouw & Co.",
    "Symbol": "SCHO.CO",
    " marketcap ": " $1 952 149 742 ",
    "price (USD)": "83.8106",
    "country": "Denmark"
  },
  {
    "Rank": "4206",
    "Name": "Bloomin' Brands",
    "Symbol": "BLMN",
    " marketcap ": " $1 949 178 112 ",
    "price (USD)": "22.54",
    "country": "United States"
  },
  {
    "Rank": "4207",
    "Name": "Chorus",
    "Symbol": "CNU.NZ",
    " marketcap ": " $1 948 530 621 ",
    "price (USD)": "4.49087",
    "country": "New Zealand"
  },
  {
    "Rank": "4208",
    "Name": "Entra",
    "Symbol": "ENTRA.OL",
    " marketcap ": " $1 943 746 943 ",
    "price (USD)": "\u043e\u043a\u0442.58",
    "country": "Norway"
  },
  {
    "Rank": "4209",
    "Name": "Excelerate Energy",
    "Symbol": "EE",
    " marketcap ": " $1 943 265 536 ",
    "price (USD)": "18.14",
    "country": "United States"
  },
  {
    "Rank": "4210",
    "Name": "Pacific Basin Shipping",
    "Symbol": "2343.HK",
    " marketcap ": " $1 941 172 249 ",
    "price (USD)": "0.369045",
    "country": "Hong Kong"
  },
  {
    "Rank": "4211",
    "Name": "KSB ltd",
    "Symbol": "KSB.NS",
    " marketcap ": " $1 939 487 149 ",
    "price (USD)": "55.7199",
    "country": "India"
  },
  {
    "Rank": "4212",
    "Name": "Independent Bank Group",
    "Symbol": "IBTX",
    " marketcap ": " $1 937 294 592 ",
    "price (USD)": "46.82",
    "country": "United States"
  },
  {
    "Rank": "4213",
    "Name": "Vodafone Qatar",
    "Symbol": "VFQS.QA",
    " marketcap ": " $1 936 987 991 ",
    "price (USD)": "0.458242",
    "country": "Qatar"
  },
  {
    "Rank": "4214",
    "Name": "HighPeak Energy",
    "Symbol": "HPK",
    " marketcap ": " $1 935 724 800 ",
    "price (USD)": "15.14",
    "country": "United States"
  },
  {
    "Rank": "4215",
    "Name": "Heartland Financial USA",
    "Symbol": "HTLF",
    " marketcap ": " $1 934 562 944 ",
    "price (USD)": "45.21",
    "country": "United States"
  },
  {
    "Rank": "4216",
    "Name": "eXp World Holdings",
    "Symbol": "EXPI",
    " marketcap ": " $1 934 039 040 ",
    "price (USD)": "\u0434\u0435\u043a.49",
    "country": "United States"
  },
  {
    "Rank": "4217",
    "Name": "PagerDuty",
    "Symbol": "PD",
    " marketcap ": " $1 933 743 232 ",
    "price (USD)": "20.23",
    "country": "United States"
  },
  {
    "Rank": "4218",
    "Name": "Galapagos NV",
    "Symbol": "GLPG",
    " marketcap ": " $1 933 112 064 ",
    "price (USD)": "28.38",
    "country": "Belgium"
  },
  {
    "Rank": "4219",
    "Name": "CG Oncology",
    "Symbol": "CGON",
    " marketcap ": " $1 930 566 528 ",
    "price (USD)": "28.97",
    "country": "United States"
  },
  {
    "Rank": "4220",
    "Name": "Super Group",
    "Symbol": "SGHC",
    " marketcap ": " $1 930 509 312 ",
    "price (USD)": "\u043c\u0430\u0440.85",
    "country": "Guernsey"
  },
  {
    "Rank": "4221",
    "Name": "Jetblue Airways",
    "Symbol": "JBLU",
    " marketcap ": " $1 928 565 504 ",
    "price (USD)": "\u043c\u0430\u0439.67",
    "country": "United States"
  },
  {
    "Rank": "4222",
    "Name": "Canadian Western Bank",
    "Symbol": "CWB.TO",
    " marketcap ": " $1 928 107 464 ",
    "price (USD)": "19.9714",
    "country": "Canada"
  },
  {
    "Rank": "4223",
    "Name": "Privia Health Group",
    "Symbol": "PRVA",
    " marketcap ": " $1 926 985 600 ",
    "price (USD)": "16.15",
    "country": "United States"
  },
  {
    "Rank": "4224",
    "Name": "Fox Factory Holding",
    "Symbol": "FOXF",
    " marketcap ": " $1 924 730 752 ",
    "price (USD)": "46.25",
    "country": "United States"
  },
  {
    "Rank": "4225",
    "Name": "Agios Pharmaceuticals",
    "Symbol": "AGIO",
    " marketcap ": " $1 923 469 312 ",
    "price (USD)": "33.88",
    "country": "United States"
  },
  {
    "Rank": "4226",
    "Name": "Sapiens",
    "Symbol": "SPNS",
    " marketcap ": " $1 922 795 392 ",
    "price (USD)": "34.5",
    "country": "Israel"
  },
  {
    "Rank": "4227",
    "Name": "VEON",
    "Symbol": "VEON",
    " marketcap ": " $1 921 107 072 ",
    "price (USD)": "25.53",
    "country": "Netherlands"
  },
  {
    "Rank": "4228",
    "Name": "Merchants Bancorp",
    "Symbol": "MBIN",
    " marketcap ": " $1 918 952 064 ",
    "price (USD)": "41.94",
    "country": "United States"
  },
  {
    "Rank": "4229",
    "Name": "Chambal Fertilisers",
    "Symbol": "CHAMBLFERT.NS",
    " marketcap ": " $1 918 844 493 ",
    "price (USD)": "4.78811",
    "country": "India"
  },
  {
    "Rank": "4230",
    "Name": "Buckle",
    "Symbol": "BKE",
    " marketcap ": " $1 918 521 216 ",
    "price (USD)": "37.78",
    "country": "United States"
  },
  {
    "Rank": "4231",
    "Name": "Fairfax India Holdings",
    "Symbol": "FIH-U.TO",
    " marketcap ": " $1 917 806 848 ",
    "price (USD)": "14.19",
    "country": "Canada"
  },
  {
    "Rank": "4232",
    "Name": "SJW Group",
    "Symbol": "SJW",
    " marketcap ": " $1 917 630 464 ",
    "price (USD)": "59.49",
    "country": "United States"
  },
  {
    "Rank": "4233",
    "Name": "Sigma Lithium",
    "Symbol": "SGML",
    " marketcap ": " $1 916 386 688 ",
    "price (USD)": "17.28",
    "country": "Canada"
  },
  {
    "Rank": "4234",
    "Name": "The Cheesecake Factory",
    "Symbol": "CAKE",
    " marketcap ": " $1 915 526 272 ",
    "price (USD)": "37.59",
    "country": "United States"
  },
  {
    "Rank": "4235",
    "Name": "G-bits Network Technology",
    "Symbol": "603444.SS",
    " marketcap ": " $1 913 552 915 ",
    "price (USD)": "26.562",
    "country": "China"
  },
  {
    "Rank": "4236",
    "Name": "AMP Limited",
    "Symbol": "AMP.AX",
    " marketcap ": " $1 911 990 611 ",
    "price (USD)": "0.710152",
    "country": "Australia"
  },
  {
    "Rank": "4237",
    "Name": "IndiaMART",
    "Symbol": "INDIAMART.NS",
    " marketcap ": " $1 911 412 074 ",
    "price (USD)": "31.8791",
    "country": "India"
  },
  {
    "Rank": "4238",
    "Name": "TTM Technologies",
    "Symbol": "TTMI",
    " marketcap ": " $1 910 335 616 ",
    "price (USD)": "18.77",
    "country": "United States"
  },
  {
    "Rank": "4239",
    "Name": "BrightSpring Health Services",
    "Symbol": "BTSG",
    " marketcap ": " $1 910 217 984 ",
    "price (USD)": "\u043d\u043e\u044f.15",
    "country": "United States"
  },
  {
    "Rank": "4240",
    "Name": "The Foschini Group",
    "Symbol": "TFG.JO",
    " marketcap ": " $1 908 561 800 ",
    "price (USD)": "\u043c\u0430\u0439.96",
    "country": "South Africa"
  },
  {
    "Rank": "4241",
    "Name": "SSP Group",
    "Symbol": "SSPG.L",
    " marketcap ": " $1 908 501 204 ",
    "price (USD)": "\u0444\u0435\u0432.14",
    "country": "United Kingdom"
  },
  {
    "Rank": "4242",
    "Name": "Savills",
    "Symbol": "SVS.L",
    " marketcap ": " $1 906 931 818 ",
    "price (USD)": "14.0809",
    "country": "United Kingdom"
  },
  {
    "Rank": "4243",
    "Name": "Federal Agricultural Mortgage",
    "Symbol": "AGM",
    " marketcap ": " $1 905 968 256 ",
    "price (USD)": "180.23",
    "country": "United States"
  },
  {
    "Rank": "4244",
    "Name": "Yellow Cake plc",
    "Symbol": "YCA.L",
    " marketcap ": " $1 905 075 047 ",
    "price (USD)": "8.78498",
    "country": "Jersey"
  },
  {
    "Rank": "4245",
    "Name": "Super Retail Group",
    "Symbol": "SUL.AX",
    " marketcap ": " $1 904 872 293 ",
    "price (USD)": "8.43513",
    "country": "Australia"
  },
  {
    "Rank": "4246",
    "Name": "Goodman Property Trust",
    "Symbol": "GMT.NZ",
    " marketcap ": " $1 904 367 876 ",
    "price (USD)": "1.35706",
    "country": "New Zealand"
  },
  {
    "Rank": "4247",
    "Name": "Loomis AB",
    "Symbol": "LOOMIS.ST",
    " marketcap ": " $1 903 619 110 ",
    "price (USD)": "27.0512",
    "country": "Sweden"
  },
  {
    "Rank": "4248",
    "Name": "Karur Vysya Bank",
    "Symbol": "KARURVYSYA.NS",
    " marketcap ": " $1 899 851 912 ",
    "price (USD)": "2.36582",
    "country": "India"
  },
  {
    "Rank": "4249",
    "Name": "\u0413\u2013ssur",
    "Symbol": "OSSR.CO",
    " marketcap ": " $1 894 684 882 ",
    "price (USD)": "4.43789",
    "country": "Iceland"
  },
  {
    "Rank": "4250",
    "Name": "NOS",
    "Symbol": "NOS.LS",
    " marketcap ": " $1 893 719 900 ",
    "price (USD)": "3.68661",
    "country": "Portugal"
  },
  {
    "Rank": "4251",
    "Name": "Bayanat AI",
    "Symbol": "BAYANAT.AE",
    " marketcap ": " $1 890 395 933 ",
    "price (USD)": "0.74",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "4252",
    "Name": "Stagwell",
    "Symbol": "STGW",
    " marketcap ": " $1 890 008 576 ",
    "price (USD)": "07.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "4253",
    "Name": "Qatar Insurance Company",
    "Symbol": "QATI.QA",
    " marketcap ": " $1 889 672 018 ",
    "price (USD)": "0.578571",
    "country": "Qatar"
  },
  {
    "Rank": "4254",
    "Name": "AJ Bell",
    "Symbol": "AJB.L",
    " marketcap ": " $1 889 541 478 ",
    "price (USD)": "4.58672",
    "country": "United Kingdom"
  },
  {
    "Rank": "4255",
    "Name": "Mercury Systems",
    "Symbol": "MRCY",
    " marketcap ": " $1 888 389 760 ",
    "price (USD)": "31.82",
    "country": "United States"
  },
  {
    "Rank": "4256",
    "Name": "NeoGenomics",
    "Symbol": "NEO",
    " marketcap ": " $1 887 583 360 ",
    "price (USD)": "14.78",
    "country": "United States"
  },
  {
    "Rank": "4257",
    "Name": "NexPoint Residential",
    "Symbol": "NXRT",
    " marketcap ": " $1 887 478 144 ",
    "price (USD)": "36.49",
    "country": "United States"
  },
  {
    "Rank": "4258",
    "Name": "Geo Group",
    "Symbol": "GEO",
    " marketcap ": " $1 886 475 008 ",
    "price (USD)": "13.84",
    "country": "United States"
  },
  {
    "Rank": "4259",
    "Name": "Playtech",
    "Symbol": "PTEC.L",
    " marketcap ": " $1 884 551 142 ",
    "price (USD)": "6.18508",
    "country": "Isle of Man"
  },
  {
    "Rank": "4260",
    "Name": "OPENLANE Corporate",
    "Symbol": "KAR",
    " marketcap ": " $1 884 454 784 ",
    "price (USD)": "17.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "4261",
    "Name": "Carabao Group",
    "Symbol": "CBG.BK",
    " marketcap ": " $1 883 472 261 ",
    "price (USD)": "1.88347",
    "country": "Thailand"
  },
  {
    "Rank": "4262",
    "Name": "United Electronics Company (eXtra Saudi)",
    "Symbol": "4003.SR",
    " marketcap ": " $1 881 099 996 ",
    "price (USD)": "24.6844",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4263",
    "Name": "Ecopro",
    "Symbol": "086520.KQ",
    " marketcap ": " $1 880 868 425 ",
    "price (USD)": "71.3835",
    "country": "South Korea"
  },
  {
    "Rank": "4264",
    "Name": "Delek Logistics Partners",
    "Symbol": "DKL",
    " marketcap ": " $1 880 141 056 ",
    "price (USD)": "39.82",
    "country": "United States"
  },
  {
    "Rank": "4265",
    "Name": "Televisa",
    "Symbol": "TV",
    " marketcap ": " $1 879 752 960 ",
    "price (USD)": "\u043c\u0430\u0440.27",
    "country": "Mexico"
  },
  {
    "Rank": "4266",
    "Name": "Vamos Loca\u0413\u00a7\u0413\u0408o de Caminh\u0413\u00b5es, M\u0413\u040equinas e Equipamentos S.A.",
    "Symbol": "VAMO3.SA",
    " marketcap ": " $1 879 740 358 ",
    "price (USD)": "1.63006",
    "country": "Brazil"
  },
  {
    "Rank": "4267",
    "Name": "Grosvenor Capital Management",
    "Symbol": "GCMG",
    " marketcap ": " $1 878 144 000 ",
    "price (USD)": "10.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "4268",
    "Name": "Kokuyo",
    "Symbol": "7984.T",
    " marketcap ": " $1 877 827 379 ",
    "price (USD)": "16.5568",
    "country": "Japan"
  },
  {
    "Rank": "4269",
    "Name": "Sappi",
    "Symbol": "SAP.JO",
    " marketcap ": " $1 874 794 200 ",
    "price (USD)": "3.12778",
    "country": "South Africa"
  },
  {
    "Rank": "4270",
    "Name": "Usiminas",
    "Symbol": "USIM5.SA",
    " marketcap ": " $1 873 580 366 ",
    "price (USD)": "1.61835",
    "country": "Brazil"
  },
  {
    "Rank": "4271",
    "Name": "WIN Semiconductors",
    "Symbol": "3105.TWO",
    " marketcap ": " $1 873 397 389 ",
    "price (USD)": "4.41902",
    "country": "Taiwan"
  },
  {
    "Rank": "4272",
    "Name": "Estun Automation",
    "Symbol": "002747.SZ",
    " marketcap ": " $1 868 951 847 ",
    "price (USD)": "2.14938",
    "country": "China"
  },
  {
    "Rank": "4273",
    "Name": "Shapir Civil and Marine Engineering",
    "Symbol": "SPEN.TA",
    " marketcap ": " $1 867 789 040 ",
    "price (USD)": "5.22742",
    "country": "Israel"
  },
  {
    "Rank": "4274",
    "Name": "Welspun India",
    "Symbol": "WELSPUNIND.NS",
    " marketcap ": " $1 867 418 314 ",
    "price (USD)": "\u044f\u043d\u0432.91",
    "country": "India"
  },
  {
    "Rank": "4275",
    "Name": "Borregaard",
    "Symbol": "BRG.OL",
    " marketcap ": " $1 865 867 242 ",
    "price (USD)": "18.706",
    "country": "Norway"
  },
  {
    "Rank": "4276",
    "Name": "Estithmar Holding",
    "Symbol": "IGRD.QA",
    " marketcap ": " $1 865 675 675 ",
    "price (USD)": "0.548077",
    "country": "Qatar"
  },
  {
    "Rank": "4277",
    "Name": "Ourpalm",
    "Symbol": "300315.SZ",
    " marketcap ": " $1 864 826 312 ",
    "price (USD)": "0.679624",
    "country": "China"
  },
  {
    "Rank": "4278",
    "Name": "Trustmark",
    "Symbol": "TRMK",
    " marketcap ": " $1 863 594 880 ",
    "price (USD)": "30.45",
    "country": "United States"
  },
  {
    "Rank": "4279",
    "Name": "Seera Holding Group",
    "Symbol": "1810.SR",
    " marketcap ": " $1 863 240 729 ",
    "price (USD)": "6.91164",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4280",
    "Name": "M\u0413\u00a9tropole T\u0413\u00a9l\u0413\u00a9vision (Groupe M6)",
    "Symbol": "MMT.PA",
    " marketcap ": " $1 862 841 724 ",
    "price (USD)": "14.703",
    "country": "France"
  },
  {
    "Rank": "4281",
    "Name": "Meli\u0413\u040e Hotels International",
    "Symbol": "MEL.MC",
    " marketcap ": " $1 860 960 712 ",
    "price (USD)": "8.45369",
    "country": "Spain"
  },
  {
    "Rank": "4282",
    "Name": "Protagonist Therapeutics",
    "Symbol": "PTGX",
    " marketcap ": " $1 859 858 048 ",
    "price (USD)": "31.71",
    "country": "United States"
  },
  {
    "Rank": "4283",
    "Name": "Acadia Realty Trust",
    "Symbol": "AKR",
    " marketcap ": " $1 859 348 736 ",
    "price (USD)": "16.88",
    "country": "United States"
  },
  {
    "Rank": "4284",
    "Name": "Donnelley Financial Solutions",
    "Symbol": "DFIN",
    " marketcap ": " $1 858 334 848 ",
    "price (USD)": "63.39",
    "country": "United States"
  },
  {
    "Rank": "4285",
    "Name": "F&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4286",
    "Name": "Montea Comm",
    "Symbol": "MONT.BR",
    " marketcap ": " $1 855 348 116 ",
    "price (USD)": "91.8667",
    "country": "Belgium"
  },
  {
    "Rank": "4287",
    "Name": "Hawkins",
    "Symbol": "HWKN",
    " marketcap ": " $1 854 502 784 ",
    "price (USD)": "88.68",
    "country": "United States"
  },
  {
    "Rank": "4288",
    "Name": "Vital Energy",
    "Symbol": "VTLE",
    " marketcap ": " $1 854 242 688 ",
    "price (USD)": "50.58",
    "country": "United States"
  },
  {
    "Rank": "4289",
    "Name": "Ingersoll Rand India",
    "Symbol": "INGERRAND.NS",
    " marketcap ": " $1 853 790 206 ",
    "price (USD)": "58.6949",
    "country": "India"
  },
  {
    "Rank": "4290",
    "Name": "Korea Gas",
    "Symbol": "036460.KS",
    " marketcap ": " $1 853 115 808 ",
    "price (USD)": "21.5913",
    "country": "South Korea"
  },
  {
    "Rank": "4291",
    "Name": "Hillman Solutions",
    "Symbol": "HLMN",
    " marketcap ": " $1 852 587 392 ",
    "price (USD)": "\u0441\u0435\u043d.45",
    "country": "United States"
  },
  {
    "Rank": "4292",
    "Name": "TreeHouse Foods",
    "Symbol": "THS",
    " marketcap ": " $1 852 045 952 ",
    "price (USD)": "35.21",
    "country": "United States"
  },
  {
    "Rank": "4293",
    "Name": "FB Financial",
    "Symbol": "FBK",
    " marketcap ": " $1 850 375 680 ",
    "price (USD)": "39.38",
    "country": "United States"
  },
  {
    "Rank": "4294",
    "Name": "Protector Forsikring",
    "Symbol": "PROT.OL",
    " marketcap ": " $1 850 279 658 ",
    "price (USD)": "22.4679",
    "country": "Norway"
  },
  {
    "Rank": "4295",
    "Name": "D\u0413\u0458rr",
    "Symbol": "DUE.F",
    " marketcap ": " $1 847 178 022 ",
    "price (USD)": "26.5827",
    "country": "Germany"
  },
  {
    "Rank": "4296",
    "Name": "Hamilton Insurance Group",
    "Symbol": "HG",
    " marketcap ": " $1 847 089 792 ",
    "price (USD)": "16.64",
    "country": "Bermuda"
  },
  {
    "Rank": "4297",
    "Name": "DCM Shriram",
    "Symbol": "DCMSHRIRAM.NS",
    " marketcap ": " $1 846 394 993 ",
    "price (USD)": "\u043d\u043e\u044f.98",
    "country": "India"
  },
  {
    "Rank": "4298",
    "Name": "Zug Estates Holding",
    "Symbol": "ZUGN.SW",
    " marketcap ": " $1 842 874 280 ",
    "price (USD)": "1925.8",
    "country": "Switzerland"
  },
  {
    "Rank": "4299",
    "Name": "Sana Biotechnology",
    "Symbol": "SANA",
    " marketcap ": " $1 838 475 008 ",
    "price (USD)": "08.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "4300",
    "Name": "Ingevity",
    "Symbol": "NGVT",
    " marketcap ": " $1 838 272 640 ",
    "price (USD)": "50.6",
    "country": "United States"
  },
  {
    "Rank": "4301",
    "Name": "Ramsay G\u0413\u00a9n\u0413\u00a9rale de Sant\u0413\u00a9",
    "Symbol": "GDS.PA",
    " marketcap ": " $1 837 826 613 ",
    "price (USD)": "15.7455",
    "country": "France"
  },
  {
    "Rank": "4302",
    "Name": "Gaotu Techedu",
    "Symbol": "GOTU",
    " marketcap ": " $1 835 922 816 ",
    "price (USD)": "07.\u043d\u043e\u044f",
    "country": "China"
  },
  {
    "Rank": "4303",
    "Name": "Evotec",
    "Symbol": "EVO",
    " marketcap ": " $1 835 723 776 ",
    "price (USD)": "05.\u0441\u0435\u043d",
    "country": "Germany"
  },
  {
    "Rank": "4304",
    "Name": "Shufersal",
    "Symbol": "SAE.TA",
    " marketcap ": " $1 833 711 972 ",
    "price (USD)": "6.90172",
    "country": "Israel"
  },
  {
    "Rank": "4305",
    "Name": "Cyfrowy Polsat",
    "Symbol": "CPS.WA",
    " marketcap ": " $1 832 585 768 ",
    "price (USD)": "3.32771",
    "country": "Poland"
  },
  {
    "Rank": "4306",
    "Name": "Apollo Medical Holdings",
    "Symbol": "AMEH",
    " marketcap ": " $1 830 332 032 ",
    "price (USD)": "40.82",
    "country": "United States"
  },
  {
    "Rank": "4307",
    "Name": "Stewart Information Services",
    "Symbol": "STC",
    " marketcap ": " $1 828 311 424 ",
    "price (USD)": "66.29",
    "country": "United States"
  },
  {
    "Rank": "4308",
    "Name": "Fusion Pharmaceuticals",
    "Symbol": "FUSN",
    " marketcap ": " $1 827 939 328 ",
    "price (USD)": "21.49",
    "country": "Canada"
  },
  {
    "Rank": "4309",
    "Name": "B.Grimm Power",
    "Symbol": "BGRIM.BK",
    " marketcap ": " $1 827 819 074 ",
    "price (USD)": "0.701147",
    "country": "Thailand"
  },
  {
    "Rank": "4310",
    "Name": "PC Connection",
    "Symbol": "CNXN",
    " marketcap ": " $1 827 247 232 ",
    "price (USD)": "69.31",
    "country": "United States"
  },
  {
    "Rank": "4311",
    "Name": "RBL Bank",
    "Symbol": "RBLBANK.NS",
    " marketcap ": " $1 824 929 072 ",
    "price (USD)": "3.01164",
    "country": "India"
  },
  {
    "Rank": "4312",
    "Name": "Global Net Lease",
    "Symbol": "GNL",
    " marketcap ": " $1 823 481 728 ",
    "price (USD)": "\u0438\u044e\u043b.83",
    "country": "United States"
  },
  {
    "Rank": "4313",
    "Name": "Saudi Cement Company",
    "Symbol": "3030.SR",
    " marketcap ": " $1 823 032 613 ",
    "price (USD)": "\u043d\u043e\u044f.52",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4314",
    "Name": "AEON REIT Investment",
    "Symbol": "3292.T",
    " marketcap ": " $1 822 159 093 ",
    "price (USD)": "857.911",
    "country": "Japan"
  },
  {
    "Rank": "4315",
    "Name": "Yamama Saudi Cement Company",
    "Symbol": "3020.SR",
    " marketcap ": " $1 821 111 298 ",
    "price (USD)": "8.99314",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4316",
    "Name": "Keros Therapeutics",
    "Symbol": "KROS",
    " marketcap ": " $1 819 711 104 ",
    "price (USD)": "50.43",
    "country": "United States"
  },
  {
    "Rank": "4317",
    "Name": "Dorian LPG",
    "Symbol": "LPG",
    " marketcap ": " $1 818 976 896 ",
    "price (USD)": "44.81",
    "country": "United States"
  },
  {
    "Rank": "4318",
    "Name": "Van Lanschot Kempen",
    "Symbol": "VLK.AS",
    " marketcap ": " $1 815 013 869 ",
    "price (USD)": "42.9471",
    "country": "Netherlands"
  },
  {
    "Rank": "4319",
    "Name": "ProSiebenSat.1 Media",
    "Symbol": "PSM.F",
    " marketcap ": " $1 814 396 595 ",
    "price (USD)": "7.94875",
    "country": "Germany"
  },
  {
    "Rank": "4320",
    "Name": "Santam",
    "Symbol": "SNT.JO",
    " marketcap ": " $1 813 688 100 ",
    "price (USD)": "16.6186",
    "country": "South Africa"
  },
  {
    "Rank": "4321",
    "Name": "Peab",
    "Symbol": "PEAB-B.ST",
    " marketcap ": " $1 813 483 876 ",
    "price (USD)": "6.30882",
    "country": "Sweden"
  },
  {
    "Rank": "4322",
    "Name": "Addus HomeCare",
    "Symbol": "ADUS",
    " marketcap ": " $1 813 174 400 ",
    "price (USD)": "110.76",
    "country": "United States"
  },
  {
    "Rank": "4323",
    "Name": "Viohalco",
    "Symbol": "VIO.BR",
    " marketcap ": " $1 812 556 864 ",
    "price (USD)": "6.99316",
    "country": "Belgium"
  },
  {
    "Rank": "4324",
    "Name": "ProKidney",
    "Symbol": "PROK",
    " marketcap ": " $1 811 823 360 ",
    "price (USD)": "03.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "4325",
    "Name": "NBT Bancorp",
    "Symbol": "NBTB",
    " marketcap ": " $1 810 061 568 ",
    "price (USD)": "38.39",
    "country": "United States"
  },
  {
    "Rank": "4326",
    "Name": "Gamma Communications",
    "Symbol": "GAMA.L",
    " marketcap ": " $1 809 303 767 ",
    "price (USD)": "18.6461",
    "country": "United Kingdom"
  },
  {
    "Rank": "4327",
    "Name": "Sandstorm Gold",
    "Symbol": "SAND",
    " marketcap ": " $1 807 782 784 ",
    "price (USD)": "06.\u0438\u044e\u043d",
    "country": "Canada"
  },
  {
    "Rank": "4328",
    "Name": "Tata Teleservices",
    "Symbol": "TTML.NS",
    " marketcap ": " $1 807 488 725 ",
    "price (USD)": "0.92458",
    "country": "India"
  },
  {
    "Rank": "4329",
    "Name": "Ardelyx",
    "Symbol": "ARDX",
    " marketcap ": " $1 806 302 336 ",
    "price (USD)": "\u0438\u044e\u043b.72",
    "country": "United States"
  },
  {
    "Rank": "4330",
    "Name": "TechnoPro Holdings",
    "Symbol": "6028.T",
    " marketcap ": " $1 805 822 261 ",
    "price (USD)": "16.9631",
    "country": "Japan"
  },
  {
    "Rank": "4331",
    "Name": "Bodycote",
    "Symbol": "BOY.L",
    " marketcap ": " $1 804 444 268 ",
    "price (USD)": "\u0441\u0435\u043d.11",
    "country": "United Kingdom"
  },
  {
    "Rank": "4332",
    "Name": "Pearl Abyss",
    "Symbol": "263750.KQ",
    " marketcap ": " $1 804 250 709 ",
    "price (USD)": "29.3759",
    "country": "South Korea"
  },
  {
    "Rank": "4333",
    "Name": "Delek US",
    "Symbol": "DK",
    " marketcap ": " $1 804 007 808 ",
    "price (USD)": "28.13",
    "country": "United States"
  },
  {
    "Rank": "4334",
    "Name": "Bowlero",
    "Symbol": "BOWL",
    " marketcap ": " $1 799 971 200 ",
    "price (USD)": "12.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "4335",
    "Name": "Madison Square Garden",
    "Symbol": "MSGE",
    " marketcap ": " $1 799 489 280 ",
    "price (USD)": "37.47",
    "country": "United States"
  },
  {
    "Rank": "4336",
    "Name": "Pebblebrook Hotel Trust",
    "Symbol": "PEB",
    " marketcap ": " $1 797 919 744 ",
    "price (USD)": "14.92",
    "country": "United States"
  },
  {
    "Rank": "4337",
    "Name": "Philip Morris \u0414\u040aR",
    "Symbol": "TABAK.PR",
    " marketcap ": " $1 794 719 469 ",
    "price (USD)": "653.721",
    "country": "Czech Republic"
  },
  {
    "Rank": "4338",
    "Name": "Helix Energy Solutions",
    "Symbol": "HLX",
    " marketcap ": " $1 794 371 840 ",
    "price (USD)": "\u043d\u043e\u044f.77",
    "country": "United States"
  },
  {
    "Rank": "4339",
    "Name": "Inhibrx",
    "Symbol": "INBX",
    " marketcap ": " $1 794 241 152 ",
    "price (USD)": "34.24",
    "country": "United States"
  },
  {
    "Rank": "4340",
    "Name": "Engineers India",
    "Symbol": "ENGINERSIN.NS",
    " marketcap ": " $1 793 629 050 ",
    "price (USD)": "3.19127",
    "country": "India"
  },
  {
    "Rank": "4341",
    "Name": "IonQ",
    "Symbol": "IONQ",
    " marketcap ": " $1 793 138 432 ",
    "price (USD)": "\u0430\u0432\u0433.48",
    "country": "United States"
  },
  {
    "Rank": "4342",
    "Name": "Fortuna Silver Mines",
    "Symbol": "FSM",
    " marketcap ": " $1 792 911 488 ",
    "price (USD)": "\u043c\u0430\u0439.83",
    "country": "Canada"
  },
  {
    "Rank": "4343",
    "Name": "Weis Markets",
    "Symbol": "WMK",
    " marketcap ": " $1 792 240 256 ",
    "price (USD)": "66.63",
    "country": "United States"
  },
  {
    "Rank": "4344",
    "Name": "Winnebago Industries",
    "Symbol": "WGO",
    " marketcap ": " $1 791 531 008 ",
    "price (USD)": "61.21",
    "country": "United States"
  },
  {
    "Rank": "4345",
    "Name": "HBL Power Systems",
    "Symbol": "HBLPOWER.NS",
    " marketcap ": " $1 791 024 800 ",
    "price (USD)": "6.46124",
    "country": "India"
  },
  {
    "Rank": "4346",
    "Name": "Compagnie Plastic Omnium",
    "Symbol": "POM.PA",
    " marketcap ": " $1 790 963 935 ",
    "price (USD)": "\u043d\u043e\u044f.83",
    "country": "France"
  },
  {
    "Rank": "4347",
    "Name": "Harel Group",
    "Symbol": "HARL.TA",
    " marketcap ": " $1 790 611 239 ",
    "price (USD)": "\u0430\u0432\u0433.51",
    "country": "Israel"
  },
  {
    "Rank": "4348",
    "Name": "Vicat S.A.",
    "Symbol": "VCT.PA",
    " marketcap ": " $1 790 429 502 ",
    "price (USD)": "40.2324",
    "country": "France"
  },
  {
    "Rank": "4349",
    "Name": "Photronics",
    "Symbol": "PLAB",
    " marketcap ": " $1 790 375 552 ",
    "price (USD)": "28.26",
    "country": "United States"
  },
  {
    "Rank": "4350",
    "Name": "REN (Redes Energ\u0413\u00a9ticas Nacionais)",
    "Symbol": "RENE.LS",
    " marketcap ": " $1 789 907 021 ",
    "price (USD)": "2.69845",
    "country": "Portugal"
  },
  {
    "Rank": "4351",
    "Name": "Raymond",
    "Symbol": "RAYMOND.NS",
    " marketcap ": " $1 789 104 635 ",
    "price (USD)": "26.8747",
    "country": "India"
  },
  {
    "Rank": "4352",
    "Name": "Gestamp Automoci\u0413\u0456n",
    "Symbol": "GEST.MC",
    " marketcap ": " $1 788 327 210 ",
    "price (USD)": "3.12738",
    "country": "Spain"
  },
  {
    "Rank": "4353",
    "Name": "Vtech",
    "Symbol": "0303.HK",
    " marketcap ": " $1 787 105 055 ",
    "price (USD)": "7.06695",
    "country": "Hong Kong"
  },
  {
    "Rank": "4354",
    "Name": "SMA Solar Technology",
    "Symbol": "S92.F",
    " marketcap ": " $1 786 810 642 ",
    "price (USD)": "51.4931",
    "country": "Germany"
  },
  {
    "Rank": "4355",
    "Name": "SeSa S.p.A.",
    "Symbol": "SES.MI",
    " marketcap ": " $1 786 464 129 ",
    "price (USD)": "115.322",
    "country": "Italy"
  },
  {
    "Rank": "4356",
    "Name": "CenturyPly",
    "Symbol": "CENTURYPLY.NS",
    " marketcap ": " $1 786 283 839 ",
    "price (USD)": "8.03225",
    "country": "India"
  },
  {
    "Rank": "4357",
    "Name": "Gulf Insurance Group",
    "Symbol": "GINS.KW",
    " marketcap ": " $1 785 004 850 ",
    "price (USD)": "6290.74",
    "country": "Kuwait"
  },
  {
    "Rank": "4358",
    "Name": "Verano Holdings",
    "Symbol": "VRNOF",
    " marketcap ": " $1 784 538 112 ",
    "price (USD)": "\u0430\u043f\u0440.97",
    "country": "United States"
  },
  {
    "Rank": "4359",
    "Name": "Diamondrock Hospitality Company",
    "Symbol": "DRH",
    " marketcap ": " $1 780 974 976 ",
    "price (USD)": "\u0430\u0432\u0433.44",
    "country": "United States"
  },
  {
    "Rank": "4360",
    "Name": "Applus Services",
    "Symbol": "APPS.MC",
    " marketcap ": " $1 780 813 865 ",
    "price (USD)": "13.8126",
    "country": "Spain"
  },
  {
    "Rank": "4361",
    "Name": "Thai Union Group",
    "Symbol": "TU.BK",
    " marketcap ": " $1 780 359 352 ",
    "price (USD)": "0.40969",
    "country": "Thailand"
  },
  {
    "Rank": "4362",
    "Name": "National Western Life",
    "Symbol": "NWLI",
    " marketcap ": " $1 776 632 064 ",
    "price (USD)": "488.62",
    "country": "United States"
  },
  {
    "Rank": "4363",
    "Name": "Fila",
    "Symbol": "081660.KS",
    " marketcap ": " $1 776 402 217 ",
    "price (USD)": "29.5595",
    "country": "South Korea"
  },
  {
    "Rank": "4364",
    "Name": "Osotspa",
    "Symbol": "OSP.BK",
    " marketcap ": " $1 775 705 303 ",
    "price (USD)": "0.591163",
    "country": "Thailand"
  },
  {
    "Rank": "4365",
    "Name": "Renasant Corp",
    "Symbol": "RNST",
    " marketcap ": " $1 773 488 768 ",
    "price (USD)": "31.48",
    "country": "United States"
  },
  {
    "Rank": "4366",
    "Name": "Coats Group",
    "Symbol": "COA.L",
    " marketcap ": " $1 772 658 993 ",
    "price (USD)": "1.1137",
    "country": "United Kingdom"
  },
  {
    "Rank": "4367",
    "Name": "Driven Brands",
    "Symbol": "DRVN",
    " marketcap ": " $1 772 064 000 ",
    "price (USD)": "10.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "4368",
    "Name": "Olectra Greentech",
    "Symbol": "OLECTRA.NS",
    " marketcap ": " $1 771 263 482 ",
    "price (USD)": "21.5795",
    "country": "India"
  },
  {
    "Rank": "4369",
    "Name": "Pets at Home",
    "Symbol": "PETS.L",
    " marketcap ": " $1 770 352 431 ",
    "price (USD)": "3.78352",
    "country": "United Kingdom"
  },
  {
    "Rank": "4370",
    "Name": "Tiger Brands",
    "Symbol": "TBS.JO",
    " marketcap ": " $1 769 831 100 ",
    "price (USD)": "11.315",
    "country": "South Africa"
  },
  {
    "Rank": "4371",
    "Name": "Triumph Financial",
    "Symbol": "TFIN",
    " marketcap ": " $1 769 236 992 ",
    "price (USD)": "75.82",
    "country": "United States"
  },
  {
    "Rank": "4372",
    "Name": "Stelco",
    "Symbol": "STLC.TO",
    " marketcap ": " $1 768 760 955 ",
    "price (USD)": "32.1786",
    "country": "Canada"
  },
  {
    "Rank": "4373",
    "Name": "Almunajem Foods Company",
    "Symbol": "4162.SR",
    " marketcap ": " $1 767 672 724 ",
    "price (USD)": "29.4612",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4374",
    "Name": "LeMaitre Vascular",
    "Symbol": "LMAT",
    " marketcap ": " $1 767 630 336 ",
    "price (USD)": "78.75",
    "country": "United States"
  },
  {
    "Rank": "4375",
    "Name": "Helios Technologies",
    "Symbol": "HLIO",
    " marketcap ": " $1 767 102 848 ",
    "price (USD)": "53.23",
    "country": "United States"
  },
  {
    "Rank": "4376",
    "Name": "Austevoll Seafood",
    "Symbol": "AUSS.OL",
    " marketcap ": " $1 765 542 973 ",
    "price (USD)": "8.74793",
    "country": "Norway"
  },
  {
    "Rank": "4377",
    "Name": "Electrical Industries Company (EIC)",
    "Symbol": "1303.SR",
    " marketcap ": " $1 763 469 660 ",
    "price (USD)": "1.58514",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4378",
    "Name": "MGP Ingredients",
    "Symbol": "MGPI",
    " marketcap ": " $1 762 953 216 ",
    "price (USD)": "80.08",
    "country": "United States"
  },
  {
    "Rank": "4379",
    "Name": "Nongshim",
    "Symbol": "004370.KS",
    " marketcap ": " $1 762 398 269 ",
    "price (USD)": "304.775",
    "country": "South Korea"
  },
  {
    "Rank": "4380",
    "Name": "OFG Bancorp",
    "Symbol": "OFG",
    " marketcap ": " $1 762 332 544 ",
    "price (USD)": "37.38",
    "country": "United States"
  },
  {
    "Rank": "4381",
    "Name": "Hornbach Baumarkt",
    "Symbol": "HBM.HM",
    " marketcap ": " $1 761 479 874 ",
    "price (USD)": "55.3806",
    "country": "Germany"
  },
  {
    "Rank": "4382",
    "Name": "Enovix",
    "Symbol": "ENVX",
    " marketcap ": " $1 761 200 000 ",
    "price (USD)": "\u043e\u043a\u0442.36",
    "country": "United States"
  },
  {
    "Rank": "4383",
    "Name": "Tauron Polska",
    "Symbol": "TPE.WA",
    " marketcap ": " $1 759 890 293 ",
    "price (USD)": "1.00419",
    "country": "Poland"
  },
  {
    "Rank": "4384",
    "Name": "H&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4385",
    "Name": "TKH Group",
    "Symbol": "TWEKA.AS",
    " marketcap ": " $1 758 903 890 ",
    "price (USD)": "44.1959",
    "country": "Netherlands"
  },
  {
    "Rank": "4386",
    "Name": "Blue Bird Corporation",
    "Symbol": "BLBD",
    " marketcap ": " $1 758 686 080 ",
    "price (USD)": "54.45",
    "country": "United States"
  },
  {
    "Rank": "4387",
    "Name": "Century Aluminum",
    "Symbol": "CENX",
    " marketcap ": " $1 757 601 280 ",
    "price (USD)": "18.96",
    "country": "United States"
  },
  {
    "Rank": "4388",
    "Name": "Upbound Group",
    "Symbol": "UPBD",
    " marketcap ": " $1 756 335 232 ",
    "price (USD)": "32.15",
    "country": "United States"
  },
  {
    "Rank": "4389",
    "Name": "Syndax Pharmaceuticals",
    "Symbol": "SNDX",
    " marketcap ": " $1 755 833 600 ",
    "price (USD)": "20.66",
    "country": "United States"
  },
  {
    "Rank": "4390",
    "Name": "The Andersons",
    "Symbol": "ANDE",
    " marketcap ": " $1 755 607 680 ",
    "price (USD)": "51.56",
    "country": "United States"
  },
  {
    "Rank": "4391",
    "Name": "Sprout Social",
    "Symbol": "SPT",
    " marketcap ": " $1 755 504 896 ",
    "price (USD)": "31.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "4392",
    "Name": "Kuwait Telecommunications Company",
    "Symbol": "STC.KW",
    " marketcap ": " $1 754 620 704 ",
    "price (USD)": "1756.84",
    "country": "Kuwait"
  },
  {
    "Rank": "4393",
    "Name": "Hanesbrands",
    "Symbol": "HBI",
    " marketcap ": " $1 754 299 392 ",
    "price (USD)": "\u0430\u043f\u0440.99",
    "country": "United States"
  },
  {
    "Rank": "4394",
    "Name": "Outokumpu",
    "Symbol": "OUT1V.HE",
    " marketcap ": " $1 753 358 011 ",
    "price (USD)": "4.13834",
    "country": "Finland"
  },
  {
    "Rank": "4395",
    "Name": "NewAmsterdam Pharma Company",
    "Symbol": "NAMS",
    " marketcap ": " $1 752 923 392 ",
    "price (USD)": "19.48",
    "country": "Netherlands"
  },
  {
    "Rank": "4396",
    "Name": "OC Oerlikon",
    "Symbol": "OERL.SW",
    " marketcap ": " $1 752 812 738 ",
    "price (USD)": "5.39443",
    "country": "Switzerland"
  },
  {
    "Rank": "4397",
    "Name": "Vector Group",
    "Symbol": "VGR",
    " marketcap ": " $1 752 073 600 ",
    "price (USD)": "\u043d\u043e\u044f.13",
    "country": "United States"
  },
  {
    "Rank": "4398",
    "Name": "Forestar Group",
    "Symbol": "FOR",
    " marketcap ": " $1 751 359 488 ",
    "price (USD)": "34.61",
    "country": "United States"
  },
  {
    "Rank": "4399",
    "Name": "BlackBerry",
    "Symbol": "BB",
    " marketcap ": " $1 749 978 752 ",
    "price (USD)": "\u0444\u0435\u0432.96",
    "country": "Canada"
  },
  {
    "Rank": "4400",
    "Name": "NAPCO Security Technologies",
    "Symbol": "NSSC",
    " marketcap ": " $1 749 973 504 ",
    "price (USD)": "47.46",
    "country": "United States"
  },
  {
    "Rank": "4401",
    "Name": "Jenoptik",
    "Symbol": "JEN.F",
    " marketcap ": " $1 749 032 086 ",
    "price (USD)": "30.5136",
    "country": "Germany"
  },
  {
    "Rank": "4402",
    "Name": "The Bancorp",
    "Symbol": "TBBK",
    " marketcap ": " $1 748 093 952 ",
    "price (USD)": "33.77",
    "country": "United States"
  },
  {
    "Rank": "4403",
    "Name": "Costamare",
    "Symbol": "CMRE",
    " marketcap ": " $1 746 756 992 ",
    "price (USD)": "14.64",
    "country": "Monaco"
  },
  {
    "Rank": "4404",
    "Name": "Superior Plus",
    "Symbol": "SPB.TO",
    " marketcap ": " $1 745 808 324 ",
    "price (USD)": "7.02372",
    "country": "Canada"
  },
  {
    "Rank": "4405",
    "Name": "AvePoint",
    "Symbol": "AVPT",
    " marketcap ": " $1 743 578 880 ",
    "price (USD)": "\u0441\u0435\u043d.41",
    "country": "United States"
  },
  {
    "Rank": "4406",
    "Name": "Beijing Airport",
    "Symbol": "0694.HK",
    " marketcap ": " $1 742 732 811 ",
    "price (USD)": "0.380577",
    "country": "China"
  },
  {
    "Rank": "4407",
    "Name": "Asahi India Glass",
    "Symbol": "ASAHIINDIA.NS",
    " marketcap ": " $1 741 965 518 ",
    "price (USD)": "7.16354",
    "country": "India"
  },
  {
    "Rank": "4408",
    "Name": "Momentum Metropolitan",
    "Symbol": "MTM.JO",
    " marketcap ": " $1 740 302 300 ",
    "price (USD)": "1.26252",
    "country": "South Africa"
  },
  {
    "Rank": "4409",
    "Name": "Xerox",
    "Symbol": "XRX",
    " marketcap ": " $1 740 013 952 ",
    "price (USD)": "14.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "4410",
    "Name": "National Company for Learning and Education",
    "Symbol": "4291.SR",
    " marketcap ": " $1 739 599 281 ",
    "price (USD)": "40.4558",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4411",
    "Name": "Country Garden",
    "Symbol": "2007.HK",
    " marketcap ": " $1 739 434 305 ",
    "price (USD)": "0.0621482",
    "country": "China"
  },
  {
    "Rank": "4412",
    "Name": "National Industries Group Holding",
    "Symbol": "NIND.KW",
    " marketcap ": " $1 737 261 538 ",
    "price (USD)": "769.231",
    "country": "Kuwait"
  },
  {
    "Rank": "4413",
    "Name": "AMTD IDEA Group",
    "Symbol": "AMTD",
    " marketcap ": " $1 737 200 000 ",
    "price (USD)": "\u044f\u043d\u0432.72",
    "country": "Hong Kong"
  },
  {
    "Rank": "4414",
    "Name": "Mitsui High-tec",
    "Symbol": "6966.T",
    " marketcap ": " $1 734 103 818 ",
    "price (USD)": "47.4442",
    "country": "Japan"
  },
  {
    "Rank": "4415",
    "Name": "Moltiply Group (Gruppo Mutuionline)",
    "Symbol": "MOL.MI",
    " marketcap ": " $1 734 053 209 ",
    "price (USD)": "41.9155",
    "country": "Italy"
  },
  {
    "Rank": "4416",
    "Name": "PVR Cinemas",
    "Symbol": "PVR.NS",
    " marketcap ": " $1 733 746 986 ",
    "price (USD)": "17.65",
    "country": "India"
  },
  {
    "Rank": "4417",
    "Name": "Crombie Real Estate Investment Trust",
    "Symbol": "CRR-UN.TO",
    " marketcap ": " $1 733 638 119 ",
    "price (USD)": "9.52381",
    "country": "Canada"
  },
  {
    "Rank": "4418",
    "Name": "Sinch",
    "Symbol": "SINCH.ST",
    " marketcap ": " $1 733 535 303 ",
    "price (USD)": "2.05458",
    "country": "Sweden"
  },
  {
    "Rank": "4419",
    "Name": "Cogeco",
    "Symbol": "CCA.TO",
    " marketcap ": " $1 733 514 056 ",
    "price (USD)": "41.0572",
    "country": "Canada"
  },
  {
    "Rank": "4420",
    "Name": "Salvatore Ferragamo",
    "Symbol": "SFER.MI",
    " marketcap ": " $1 733 151 135 ",
    "price (USD)": "10.1042",
    "country": "Italy"
  },
  {
    "Rank": "4421",
    "Name": "Jeudan",
    "Symbol": "JDAN.CO",
    " marketcap ": " $1 732 703 525 ",
    "price (USD)": "31.2835",
    "country": "Denmark"
  },
  {
    "Rank": "4422",
    "Name": "OPC Energy",
    "Symbol": "OPCE.TA",
    " marketcap ": " $1 732 047 749 ",
    "price (USD)": "7.71706",
    "country": "Israel"
  },
  {
    "Rank": "4423",
    "Name": "KCC Corp",
    "Symbol": "002380.KS",
    " marketcap ": " $1 730 983 767 ",
    "price (USD)": "235.374",
    "country": "South Korea"
  },
  {
    "Rank": "4424",
    "Name": "Kimbell Royalty Partners",
    "Symbol": "KRP",
    " marketcap ": " $1 730 836 480 ",
    "price (USD)": "16.69",
    "country": "United States"
  },
  {
    "Rank": "4425",
    "Name": "Zee Entertainment",
    "Symbol": "ZEEL.NS",
    " marketcap ": " $1 729 988 998 ",
    "price (USD)": "\u044f\u043d\u0432.11",
    "country": "India"
  },
  {
    "Rank": "4426",
    "Name": "Navient",
    "Symbol": "NAVI",
    " marketcap ": " $1 729 932 800 ",
    "price (USD)": "15.47",
    "country": "United States"
  },
  {
    "Rank": "4427",
    "Name": "Gasco (National Gas and Industrialization Company)",
    "Symbol": "2080.SR",
    " marketcap ": " $1 729 245 056 ",
    "price (USD)": "23.0566",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4428",
    "Name": "CoreCivic",
    "Symbol": "CXW",
    " marketcap ": " $1 728 933 760 ",
    "price (USD)": "15.54",
    "country": "United States"
  },
  {
    "Rank": "4429",
    "Name": "International Petroleum",
    "Symbol": "IPCO.TO",
    " marketcap ": " $1 728 065 598 ",
    "price (USD)": "13.8348",
    "country": "Canada"
  },
  {
    "Rank": "4430",
    "Name": "Aksa Energy",
    "Symbol": "AKSEN.IS",
    " marketcap ": " $1 727 910 039 ",
    "price (USD)": "1.409",
    "country": "Turkey"
  },
  {
    "Rank": "4431",
    "Name": "Fever-Tree Drinks",
    "Symbol": "FEVR.L",
    " marketcap ": " $1 727 416 606 ",
    "price (USD)": "14.8008",
    "country": "United Kingdom"
  },
  {
    "Rank": "4432",
    "Name": "Vital Farms",
    "Symbol": "VITL",
    " marketcap ": " $1 726 300 544 ",
    "price (USD)": "40.93",
    "country": "United States"
  },
  {
    "Rank": "4433",
    "Name": "Parex Resources",
    "Symbol": "PXT.TO",
    " marketcap ": " $1 726 272 781 ",
    "price (USD)": "16.8921",
    "country": "Canada"
  },
  {
    "Rank": "4434",
    "Name": "American Assets Trust",
    "Symbol": "AAT",
    " marketcap ": " $1 720 329 472 ",
    "price (USD)": "22.32",
    "country": "United States"
  },
  {
    "Rank": "4435",
    "Name": "National Mobile Telecommunications Company",
    "Symbol": "OOREDOO.KW",
    " marketcap ": " $1 720 089 804 ",
    "price (USD)": "3432.2",
    "country": "Kuwait"
  },
  {
    "Rank": "4436",
    "Name": "Ratch Group",
    "Symbol": "RATCH.BK",
    " marketcap ": " $1 719 355 878 ",
    "price (USD)": "0.790508",
    "country": "Thailand"
  },
  {
    "Rank": "4437",
    "Name": "American Healthcare REIT",
    "Symbol": "AHR",
    " marketcap ": " $1 718 171 520 ",
    "price (USD)": "14.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "4438",
    "Name": "DFDS A/S",
    "Symbol": "DFDS.CO",
    " marketcap ": " $1 715 875 700 ",
    "price (USD)": "30.9052",
    "country": "Denmark"
  },
  {
    "Rank": "4439",
    "Name": "Mitsui Fudosan Logistics Park",
    "Symbol": "3471.T",
    " marketcap ": " $1 715 360 484 ",
    "price (USD)": "2821.32",
    "country": "Japan"
  },
  {
    "Rank": "4440",
    "Name": "VIAVI Solutions",
    "Symbol": "VIAV",
    " marketcap ": " $1 714 467 840 ",
    "price (USD)": "\u0438\u044e\u043b.68",
    "country": "United States"
  },
  {
    "Rank": "4441",
    "Name": "Srisawad Corporation",
    "Symbol": "SAWAD.BK",
    " marketcap ": " $1 713 186 820 ",
    "price (USD)": "1.13421",
    "country": "Thailand"
  },
  {
    "Rank": "4442",
    "Name": "Russel Metals",
    "Symbol": "RUS.TO",
    " marketcap ": " $1 712 746 702 ",
    "price (USD)": "28.5054",
    "country": "Canada"
  },
  {
    "Rank": "4443",
    "Name": "Afya",
    "Symbol": "AFYA",
    " marketcap ": " $1 712 704 768 ",
    "price (USD)": "19.45",
    "country": "Brazil"
  },
  {
    "Rank": "4444",
    "Name": "Cementir",
    "Symbol": "CEM.MI",
    " marketcap ": " $1 712 294 738 ",
    "price (USD)": "\u043e\u043a\u0442.24",
    "country": "Italy"
  },
  {
    "Rank": "4445",
    "Name": "WesBanco",
    "Symbol": "WSBC",
    " marketcap ": " $1 711 982 336 ",
    "price (USD)": "28.81",
    "country": "United States"
  },
  {
    "Rank": "4446",
    "Name": "Pan Ocean",
    "Symbol": "028670.KS",
    " marketcap ": " $1 709 716 309 ",
    "price (USD)": "\u043c\u0430\u0440.83",
    "country": "South Korea"
  },
  {
    "Rank": "4447",
    "Name": "Liberty Latin America",
    "Symbol": "LILA",
    " marketcap ": " $1 709 032 320 ",
    "price (USD)": "\u0430\u0432\u0433.65",
    "country": "United States"
  },
  {
    "Rank": "4448",
    "Name": "GDS Holdings",
    "Symbol": "GDS",
    " marketcap ": " $1 708 856 448 ",
    "price (USD)": "09.\u043c\u0430\u0440",
    "country": "China"
  },
  {
    "Rank": "4449",
    "Name": "CASIO",
    "Symbol": "6952.T",
    " marketcap ": " $1 707 529 161 ",
    "price (USD)": "7.36677",
    "country": "Japan"
  },
  {
    "Rank": "4450",
    "Name": "China Lesso Group",
    "Symbol": "2128.HK",
    " marketcap ": " $1 705 471 683 ",
    "price (USD)": "0.549723",
    "country": "China"
  },
  {
    "Rank": "4451",
    "Name": "Deterra Royalties",
    "Symbol": "DRR.AX",
    " marketcap ": " $1 702 616 110 ",
    "price (USD)": "3.22069",
    "country": "Australia"
  },
  {
    "Rank": "4452",
    "Name": "Distribution Solutions Group",
    "Symbol": "DSGR",
    " marketcap ": " $1 702 355 968 ",
    "price (USD)": "36.37",
    "country": "United States"
  },
  {
    "Rank": "4453",
    "Name": "Bytes Technology",
    "Symbol": "BYIT.L",
    " marketcap ": " $1 700 559 340 ",
    "price (USD)": "7.07502",
    "country": "United Kingdom"
  },
  {
    "Rank": "4454",
    "Name": "G\u0413\u045aBRETA\u0415\u045b",
    "Symbol": "GUBRF.IS",
    " marketcap ": " $1 700 445 053 ",
    "price (USD)": "5.09115",
    "country": "Turkey"
  },
  {
    "Rank": "4455",
    "Name": "Telus International",
    "Symbol": "TIXT",
    " marketcap ": " $1 699 488 512 ",
    "price (USD)": "\u0438\u044e\u043d.16",
    "country": "Canada"
  },
  {
    "Rank": "4456",
    "Name": "Pfeiffer Vacuum",
    "Symbol": "PFV.F",
    " marketcap ": " $1 699 427 325 ",
    "price (USD)": "171.571",
    "country": "Germany"
  },
  {
    "Rank": "4457",
    "Name": "Montrose Environmental",
    "Symbol": "MEG",
    " marketcap ": " $1 697 925 376 ",
    "price (USD)": "49.82",
    "country": "United States"
  },
  {
    "Rank": "4458",
    "Name": "Compass Diversified Holdings",
    "Symbol": "CODI",
    " marketcap ": " $1 690 863 104 ",
    "price (USD)": "22.43",
    "country": "United States"
  },
  {
    "Rank": "4459",
    "Name": "Zensar",
    "Symbol": "ZENSARTECH.NS",
    " marketcap ": " $1 690 009 848 ",
    "price (USD)": "7.44951",
    "country": "India"
  },
  {
    "Rank": "4460",
    "Name": "Virtus Investment Partners",
    "Symbol": "VRTS",
    " marketcap ": " $1 689 307 520 ",
    "price (USD)": "237",
    "country": "United States"
  },
  {
    "Rank": "4461",
    "Name": "Endava",
    "Symbol": "DAVA",
    " marketcap ": " $1 689 216 768 ",
    "price (USD)": "29.25",
    "country": "United Kingdom"
  },
  {
    "Rank": "4462",
    "Name": "Kayne Anderson Capital Advisors",
    "Symbol": "KYN",
    " marketcap ": " $1 687 877 376 ",
    "price (USD)": "\u0441\u0435\u043d.98",
    "country": "United States"
  },
  {
    "Rank": "4463",
    "Name": "Elang Mahkota Teknologi",
    "Symbol": "EMTK.JK",
    " marketcap ": " $1 687 769 022 ",
    "price (USD)": "0.0276354",
    "country": "Indonesia"
  },
  {
    "Rank": "4464",
    "Name": "Array Technologies",
    "Symbol": "ARRY",
    " marketcap ": " $1 686 153 472 ",
    "price (USD)": "11.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "4465",
    "Name": "SoundHound AI",
    "Symbol": "SOUN",
    " marketcap ": " $1 685 350 272 ",
    "price (USD)": "05.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "4466",
    "Name": "Kura Oncology",
    "Symbol": "KURA",
    " marketcap ": " $1 684 353 152 ",
    "price (USD)": "22.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "4467",
    "Name": "Harmony Biosciences",
    "Symbol": "HRMY",
    " marketcap ": " $1 683 879 808 ",
    "price (USD)": "29.65",
    "country": "United States"
  },
  {
    "Rank": "4468",
    "Name": "Saras S.p.A.",
    "Symbol": "SRS.MI",
    " marketcap ": " $1 683 250 733 ",
    "price (USD)": "1.75698",
    "country": "Italy"
  },
  {
    "Rank": "4469",
    "Name": "Oxford Industries",
    "Symbol": "OXM",
    " marketcap ": " $1 682 270 592 ",
    "price (USD)": "107.56",
    "country": "United States"
  },
  {
    "Rank": "4470",
    "Name": "Hysan Development",
    "Symbol": "0014.HK",
    " marketcap ": " $1 681 868 954 ",
    "price (USD)": "1.63764",
    "country": "Hong Kong"
  },
  {
    "Rank": "4471",
    "Name": "Tessenderlo Group",
    "Symbol": "TESB.BR",
    " marketcap ": " $1 681 312 872 ",
    "price (USD)": "26.9302",
    "country": "Belgium"
  },
  {
    "Rank": "4472",
    "Name": "Grindr",
    "Symbol": "GRND",
    " marketcap ": " $1 677 705 856 ",
    "price (USD)": "\u0441\u0435\u043d.55",
    "country": "United States"
  },
  {
    "Rank": "4473",
    "Name": "Ashmore Group",
    "Symbol": "ASHM.L",
    " marketcap ": " $1 677 166 635 ",
    "price (USD)": "2.52743",
    "country": "United Kingdom"
  },
  {
    "Rank": "4474",
    "Name": "Danaos",
    "Symbol": "DAC",
    " marketcap ": " $1 674 280 320 ",
    "price (USD)": "86.22",
    "country": "Greece"
  },
  {
    "Rank": "4475",
    "Name": "InvenTrust Properties",
    "Symbol": "IVT",
    " marketcap ": " $1 673 106 304 ",
    "price (USD)": "24.65",
    "country": "United States"
  },
  {
    "Rank": "4476",
    "Name": "Enova International",
    "Symbol": "ENVA",
    " marketcap ": " $1 671 346 304 ",
    "price (USD)": "61.11",
    "country": "United States"
  },
  {
    "Rank": "4477",
    "Name": "Forbo Holding",
    "Symbol": "FORN.SW",
    " marketcap ": " $1 670 961 056 ",
    "price (USD)": "1187.3",
    "country": "Switzerland"
  },
  {
    "Rank": "4478",
    "Name": "Structure Therapeutics",
    "Symbol": "GPCR",
    " marketcap ": " $1 669 501 696 ",
    "price (USD)": "35.81",
    "country": "United States"
  },
  {
    "Rank": "4479",
    "Name": "Diebold Nixdorf",
    "Symbol": "DBD",
    " marketcap ": " $1 667 585 792 ",
    "price (USD)": "44.39",
    "country": "United States"
  },
  {
    "Rank": "4480",
    "Name": "New Gold",
    "Symbol": "NGD",
    " marketcap ": " $1 665 152 256 ",
    "price (USD)": "02.\u0430\u0432\u0433",
    "country": "Canada"
  },
  {
    "Rank": "4481",
    "Name": "Veracyte",
    "Symbol": "VCYT",
    " marketcap ": " $1 665 039 616 ",
    "price (USD)": "21.78",
    "country": "United States"
  },
  {
    "Rank": "4482",
    "Name": "Apex Investment",
    "Symbol": "APEX.AE",
    " marketcap ": " $1 664 033 600 ",
    "price (USD)": "0.47",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "4483",
    "Name": "SIG (Semen Indonesia)",
    "Symbol": "SMGR.JK",
    " marketcap ": " $1 663 190 490 ",
    "price (USD)": "0.246342",
    "country": "Indonesia"
  },
  {
    "Rank": "4484",
    "Name": "Indian Energy Exchange",
    "Symbol": "IEX.NS",
    " marketcap ": " $1 657 144 008 ",
    "price (USD)": "1.86358",
    "country": "India"
  },
  {
    "Rank": "4485",
    "Name": "CTS Corporation",
    "Symbol": "CTS",
    " marketcap ": " $1 654 737 920 ",
    "price (USD)": "54.13",
    "country": "United States"
  },
  {
    "Rank": "4486",
    "Name": "Casino Guichard-Perrachon",
    "Symbol": "CO.PA",
    " marketcap ": " $1 645 831 200 ",
    "price (USD)": "0.0415898",
    "country": "France"
  },
  {
    "Rank": "4487",
    "Name": "AVI Limited",
    "Symbol": "AVI.JO",
    " marketcap ": " $1 641 686 100 ",
    "price (USD)": "4.92885",
    "country": "South Africa"
  },
  {
    "Rank": "4488",
    "Name": "Helios Towers",
    "Symbol": "HTWS.L",
    " marketcap ": " $1 637 293 749 ",
    "price (USD)": "1.55764",
    "country": "United Kingdom"
  },
  {
    "Rank": "4489",
    "Name": "Par Pacific Holdings",
    "Symbol": "PARR",
    " marketcap ": " $1 633 269 376 ",
    "price (USD)": "28.19",
    "country": "United States"
  },
  {
    "Rank": "4490",
    "Name": "Fine Organics",
    "Symbol": "FINEORG.NS",
    " marketcap ": " $1 629 997 124 ",
    "price (USD)": "53.1636",
    "country": "India"
  },
  {
    "Rank": "4491",
    "Name": "Jahez International Company for Information Systems Technology",
    "Symbol": "9526.SR",
    " marketcap ": " $1 629 915 171 ",
    "price (USD)": "7.91236",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4492",
    "Name": "Richelieu Hardware",
    "Symbol": "RCH.TO",
    " marketcap ": " $1 629 136 552 ",
    "price (USD)": "29.0187",
    "country": "Canada"
  },
  {
    "Rank": "4493",
    "Name": "Ngern Tid Lor",
    "Symbol": "TIDLOR.BK",
    " marketcap ": " $1 626 221 402 ",
    "price (USD)": "0.558168",
    "country": "Thailand"
  },
  {
    "Rank": "4494",
    "Name": "Bank Danamon",
    "Symbol": "BDMN.JK",
    " marketcap ": " $1 625 462 209 ",
    "price (USD)": "0.166312",
    "country": "Indonesia"
  },
  {
    "Rank": "4495",
    "Name": "Genesis Energy  L.P.",
    "Symbol": "GEL",
    " marketcap ": " $1 622 648 064 ",
    "price (USD)": "13.25",
    "country": "United States"
  },
  {
    "Rank": "4496",
    "Name": "Bank of N. T. Butterfield & Son",
    "Symbol": "NTB",
    " marketcap ": " $1 621 891 328 ",
    "price (USD)": "35.09",
    "country": "Bermuda"
  },
  {
    "Rank": "4497",
    "Name": "Altus Group",
    "Symbol": "AIF.TO",
    " marketcap ": " $1 621 209 646 ",
    "price (USD)": "35.4632",
    "country": "Canada"
  },
  {
    "Rank": "4498",
    "Name": "Gulf International Services",
    "Symbol": "GISS.QA",
    " marketcap ": " $1 618 450 426 ",
    "price (USD)": "0.870879",
    "country": "Qatar"
  },
  {
    "Rank": "4499",
    "Name": "Papa John's Pizza",
    "Symbol": "PZZA",
    " marketcap ": " $1 618 280 576 ",
    "price (USD)": "49.08",
    "country": "United States"
  },
  {
    "Rank": "4500",
    "Name": "Fluxys Belgium",
    "Symbol": "FLUX.BR",
    " marketcap ": " $1 617 533 178 ",
    "price (USD)": "23.021",
    "country": "Belgium"
  },
  {
    "Rank": "4501",
    "Name": "Ginkgo Bioworks",
    "Symbol": "DNA",
    " marketcap ": " $1 617 108 992 ",
    "price (USD)": "0.7313",
    "country": "United States"
  },
  {
    "Rank": "4502",
    "Name": "Anima Holding",
    "Symbol": "ANIM.MI",
    " marketcap ": " $1 616 792 894 ",
    "price (USD)": "5.08198",
    "country": "Italy"
  },
  {
    "Rank": "4503",
    "Name": "Exchange Income Corporation",
    "Symbol": "EIF.TO",
    " marketcap ": " $1 616 445 131 ",
    "price (USD)": "34.1875",
    "country": "Canada"
  },
  {
    "Rank": "4504",
    "Name": "Jindal Stainless (Hisar)",
    "Symbol": "JSLHISAR.NS",
    " marketcap ": " $1 615 857 318 ",
    "price (USD)": "6.84874",
    "country": "India"
  },
  {
    "Rank": "4505",
    "Name": "First National Financial",
    "Symbol": "FN.TO",
    " marketcap ": " $1 614 430 840 ",
    "price (USD)": "26.9218",
    "country": "Canada"
  },
  {
    "Rank": "4506",
    "Name": "Kaiser Aluminum",
    "Symbol": "KALU",
    " marketcap ": " $1 613 789 568 ",
    "price (USD)": "100.43",
    "country": "United States"
  },
  {
    "Rank": "4507",
    "Name": "Gujarat Mineral Development",
    "Symbol": "GMDCLTD.NS",
    " marketcap ": " $1 613 740 098 ",
    "price (USD)": "5.07347",
    "country": "India"
  },
  {
    "Rank": "4508",
    "Name": "Centerra Gold",
    "Symbol": "CGAU",
    " marketcap ": " $1 611 149 952 ",
    "price (USD)": "07.\u043c\u0430\u0439",
    "country": "Canada"
  },
  {
    "Rank": "4509",
    "Name": "Victoria's Secret &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4510",
    "Name": "Dis-Chem Pharmacies",
    "Symbol": "DCP.JO",
    " marketcap ": " $1 609 933 600 ",
    "price (USD)": "1.86804",
    "country": "South Africa"
  },
  {
    "Rank": "4511",
    "Name": "Alok Industries",
    "Symbol": "ALOKINDS.NS",
    " marketcap ": " $1 606 633 973 ",
    "price (USD)": "0.323212",
    "country": "India"
  },
  {
    "Rank": "4512",
    "Name": "Vaisala",
    "Symbol": "VAIAS.HE",
    " marketcap ": " $1 604 364 009 ",
    "price (USD)": "44.1959",
    "country": "Finland"
  },
  {
    "Rank": "4513",
    "Name": "Live Oak Bank",
    "Symbol": "LOB",
    " marketcap ": " $1 604 054 912 ",
    "price (USD)": "35.67",
    "country": "United States"
  },
  {
    "Rank": "4514",
    "Name": "CompuGroup Medical",
    "Symbol": "COP.DE",
    " marketcap ": " $1 603 939 798 ",
    "price (USD)": "30.6222",
    "country": "Germany"
  },
  {
    "Rank": "4515",
    "Name": "BLS International",
    "Symbol": "BLS.NS",
    " marketcap ": " $1 603 792 704 ",
    "price (USD)": "3.89898",
    "country": "India"
  },
  {
    "Rank": "4516",
    "Name": "Gulf Navigation Holding",
    "Symbol": "GULFNAV.AE",
    " marketcap ": " $1 603 776 605 ",
    "price (USD)": "1.96041",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "4517",
    "Name": "Intercos",
    "Symbol": "ICOS.MI",
    " marketcap ": " $1 603 428 993 ",
    "price (USD)": "16.6576",
    "country": "Italy"
  },
  {
    "Rank": "4518",
    "Name": "Allied Properties REIT",
    "Symbol": "AP-UN.TO",
    " marketcap ": " $1 603 261 210 ",
    "price (USD)": "\u0434\u0435\u043a.98",
    "country": "Canada"
  },
  {
    "Rank": "4519",
    "Name": "The Greenbrier Companies",
    "Symbol": "GBX",
    " marketcap ": " $1 603 241 344 ",
    "price (USD)": "51.5",
    "country": "United States"
  },
  {
    "Rank": "4520",
    "Name": "Schr\u0413\u00b6dinger",
    "Symbol": "SDGR",
    " marketcap ": " $1 601 854 080 ",
    "price (USD)": "22.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "4521",
    "Name": "Hanmi Pharmaceutical",
    "Symbol": "008930.KS",
    " marketcap ": " $1 601 266 808 ",
    "price (USD)": "23.6476",
    "country": "South Korea"
  },
  {
    "Rank": "4522",
    "Name": "Ryman Healthcare",
    "Symbol": "RYM.NZ",
    " marketcap ": " $1 600 931 023 ",
    "price (USD)": "2.32815",
    "country": "New Zealand"
  },
  {
    "Rank": "4523",
    "Name": "Chennai Petroleum",
    "Symbol": "CHENNPETRO.NS",
    " marketcap ": " $1 600 274 141 ",
    "price (USD)": "\u043e\u043a\u0442.65",
    "country": "India"
  },
  {
    "Rank": "4524",
    "Name": "Taro Pharmaceutical",
    "Symbol": "TARO",
    " marketcap ": " $1 598 097 152 ",
    "price (USD)": "42.52",
    "country": "Israel"
  },
  {
    "Rank": "4525",
    "Name": "RLJ Lodging Trust",
    "Symbol": "RLJ",
    " marketcap ": " $1 598 054 400 ",
    "price (USD)": "10.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "4526",
    "Name": "LegalZoom",
    "Symbol": "LZ",
    " marketcap ": " $1 597 783 936 ",
    "price (USD)": "\u0430\u0432\u0433.49",
    "country": "United States"
  },
  {
    "Rank": "4527",
    "Name": "OQ Gas Network Company",
    "Symbol": "OQGN.OM",
    " marketcap ": " $1 597 684 065 ",
    "price (USD)": "0.368927",
    "country": "Oman"
  },
  {
    "Rank": "4528",
    "Name": "U.S. Physical Therapy",
    "Symbol": "USPH",
    " marketcap ": " $1 595 561 088 ",
    "price (USD)": "105.89",
    "country": "United States"
  },
  {
    "Rank": "4529",
    "Name": "Flex Lng",
    "Symbol": "FLNG",
    " marketcap ": " $1 595 251 200 ",
    "price (USD)": "29.66",
    "country": "Bermuda"
  },
  {
    "Rank": "4530",
    "Name": "Lakeland Financial Corp",
    "Symbol": "LKFN",
    " marketcap ": " $1 594 982 656 ",
    "price (USD)": "62.54",
    "country": "United States"
  },
  {
    "Rank": "4531",
    "Name": "OneSpaWorld",
    "Symbol": "OSW",
    " marketcap ": " $1 594 794 112 ",
    "price (USD)": "15.23",
    "country": "Bahamas"
  },
  {
    "Rank": "4532",
    "Name": "Banner Bank",
    "Symbol": "BANR",
    " marketcap ": " $1 592 600 320 ",
    "price (USD)": "46.23",
    "country": "United States"
  },
  {
    "Rank": "4533",
    "Name": "Primary Health Properties",
    "Symbol": "PHP.L",
    " marketcap ": " $1 591 890 095 ",
    "price (USD)": "1.19186",
    "country": "United Kingdom"
  },
  {
    "Rank": "4534",
    "Name": "PAR Technology",
    "Symbol": "PAR",
    " marketcap ": " $1 587 384 448 ",
    "price (USD)": "46.7",
    "country": "United States"
  },
  {
    "Rank": "4535",
    "Name": "InMode",
    "Symbol": "INMD",
    " marketcap ": " $1 586 608 256 ",
    "price (USD)": "18.75",
    "country": "Israel"
  },
  {
    "Rank": "4536",
    "Name": "Ramkrishna Forgings",
    "Symbol": "RKFORGE.NS",
    " marketcap ": " $1 586 566 638 ",
    "price (USD)": "8.78381",
    "country": "India"
  },
  {
    "Rank": "4537",
    "Name": "Believe S.A.",
    "Symbol": "BLV.PA",
    " marketcap ": " $1 585 698 443 ",
    "price (USD)": "16.3318",
    "country": "France"
  },
  {
    "Rank": "4538",
    "Name": "Retail Opportunity Investments",
    "Symbol": "ROIC",
    " marketcap ": " $1 585 527 680 ",
    "price (USD)": "\u0434\u0435\u043a.44",
    "country": "United States"
  },
  {
    "Rank": "4539",
    "Name": "Electricity Generating Public Company",
    "Symbol": "EGCO.BK",
    " marketcap ": " $1 585 083 906 ",
    "price (USD)": "3.01081",
    "country": "Thailand"
  },
  {
    "Rank": "4540",
    "Name": "Citizen Watch",
    "Symbol": "7762.T",
    " marketcap ": " $1 583 253 202 ",
    "price (USD)": "6.49351",
    "country": "Japan"
  },
  {
    "Rank": "4541",
    "Name": "flatexDEGIRO AG",
    "Symbol": "FTK.DE",
    " marketcap ": " $1 583 165 686 ",
    "price (USD)": "14.3881",
    "country": "Germany"
  },
  {
    "Rank": "4542",
    "Name": "Veris Residential",
    "Symbol": "VRE",
    " marketcap ": " $1 583 148 928 ",
    "price (USD)": "15.59",
    "country": "United States"
  },
  {
    "Rank": "4543",
    "Name": "Hang Lung Group",
    "Symbol": "0010.HK",
    " marketcap ": " $1 582 963 890 ",
    "price (USD)": "1.16223",
    "country": "Hong Kong"
  },
  {
    "Rank": "4544",
    "Name": "Anant Raj",
    "Symbol": "ANANTRAJ.NS",
    " marketcap ": " $1 579 089 827 ",
    "price (USD)": "4.61869",
    "country": "India"
  },
  {
    "Rank": "4545",
    "Name": "Tilray",
    "Symbol": "TLRY",
    " marketcap ": " $1 577 358 208 ",
    "price (USD)": "\u044f\u043d\u0432.91",
    "country": "Canada"
  },
  {
    "Rank": "4546",
    "Name": "Northern Data AG",
    "Symbol": "NB2.DE",
    " marketcap ": " $1 574 424 324 ",
    "price (USD)": "28.2332",
    "country": "Germany"
  },
  {
    "Rank": "4547",
    "Name": "John Wood Group",
    "Symbol": "WG.L",
    " marketcap ": " $1 574 128 726 ",
    "price (USD)": "2.28969",
    "country": "United Kingdom"
  },
  {
    "Rank": "4548",
    "Name": "Genus",
    "Symbol": "GNS.L",
    " marketcap ": " $1 570 724 701 ",
    "price (USD)": "23.787",
    "country": "United Kingdom"
  },
  {
    "Rank": "4549",
    "Name": "Banpu Public Company",
    "Symbol": "BANPU.BK",
    " marketcap ": " $1 570 230 908 ",
    "price (USD)": "0.156727",
    "country": "Thailand"
  },
  {
    "Rank": "4550",
    "Name": "Ceconomy",
    "Symbol": "CEC.DE",
    " marketcap ": " $1 570 158 028 ",
    "price (USD)": "3.23596",
    "country": null
  },
  {
    "Rank": "4551",
    "Name": "Arcus Biosciences",
    "Symbol": "RCUS",
    " marketcap ": " $1 568 029 696 ",
    "price (USD)": "17.24",
    "country": "United States"
  },
  {
    "Rank": "4552",
    "Name": "Better Collective A/S",
    "Symbol": "BETCO-DKK.CO",
    " marketcap ": " $1 567 957 983 ",
    "price (USD)": "24.7358",
    "country": "Denmark"
  },
  {
    "Rank": "4553",
    "Name": "Diamond Offshore Drilling",
    "Symbol": "DO",
    " marketcap ": " $1 565 909 632 ",
    "price (USD)": "15.28",
    "country": "United States"
  },
  {
    "Rank": "4554",
    "Name": "Gentherm",
    "Symbol": "THRM",
    " marketcap ": " $1 565 789 696 ",
    "price (USD)": "49.48",
    "country": "United States"
  },
  {
    "Rank": "4555",
    "Name": "Deutsche EuroShop",
    "Symbol": "DEQ.F",
    " marketcap ": " $1 565 695 472 ",
    "price (USD)": "20.5234",
    "country": "Germany"
  },
  {
    "Rank": "4556",
    "Name": "Hipgnosis Songs Fund",
    "Symbol": "SONG.L",
    " marketcap ": " $1 564 991 983 ",
    "price (USD)": "1.29423",
    "country": "United Kingdom"
  },
  {
    "Rank": "4557",
    "Name": "Integral Ad Science",
    "Symbol": "IAS",
    " marketcap ": " $1 563 698 560 ",
    "price (USD)": "\u0441\u0435\u043d.74",
    "country": "United States"
  },
  {
    "Rank": "4558",
    "Name": "Ligand Pharmaceuticals",
    "Symbol": "LGND",
    " marketcap ": " $1 562 841 856 ",
    "price (USD)": "87",
    "country": "United States"
  },
  {
    "Rank": "4559",
    "Name": "Magnite",
    "Symbol": "MGNI",
    " marketcap ": " $1 562 667 776 ",
    "price (USD)": "\u043d\u043e\u044f.16",
    "country": "United States"
  },
  {
    "Rank": "4560",
    "Name": "Knowles",
    "Symbol": "KN",
    " marketcap ": " $1 559 755 904 ",
    "price (USD)": "17.38",
    "country": "United States"
  },
  {
    "Rank": "4561",
    "Name": "thyssenkrupp nucera",
    "Symbol": "NCH2.DE",
    " marketcap ": " $1 559 562 897 ",
    "price (USD)": "\u0434\u0435\u043a.66",
    "country": "Germany"
  },
  {
    "Rank": "4562",
    "Name": "Leggett &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4563",
    "Name": "PROG Holdings",
    "Symbol": "PRG",
    " marketcap ": " $1 558 603 008 ",
    "price (USD)": "36.1",
    "country": "United States"
  },
  {
    "Rank": "4564",
    "Name": "Assura Plc",
    "Symbol": "AGR.L",
    " marketcap ": " $1 556 982 809 ",
    "price (USD)": "0.520826",
    "country": "United Kingdom"
  },
  {
    "Rank": "4565",
    "Name": "Killam Apartment REIT",
    "Symbol": "KMP-UN.TO",
    " marketcap ": " $1 556 775 518 ",
    "price (USD)": "13.1163",
    "country": "Canada"
  },
  {
    "Rank": "4566",
    "Name": "Opendoor",
    "Symbol": "OPEN",
    " marketcap ": " $1 556 045 952 ",
    "price (USD)": "\u0444\u0435\u0432.25",
    "country": "United States"
  },
  {
    "Rank": "4567",
    "Name": "Boss Energy",
    "Symbol": "BOE.AX",
    " marketcap ": " $1 555 933 853 ",
    "price (USD)": "3.80748",
    "country": "Australia"
  },
  {
    "Rank": "4568",
    "Name": "Ameresco",
    "Symbol": "AMRC",
    " marketcap ": " $1 554 456 448 ",
    "price (USD)": "29.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "4569",
    "Name": "Godawari Power &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4570",
    "Name": "RPC",
    "Symbol": "RES",
    " marketcap ": " $1 554 015 744 ",
    "price (USD)": "\u0438\u044e\u043b.25",
    "country": "United States"
  },
  {
    "Rank": "4571",
    "Name": "Al Salam Bank",
    "Symbol": "SALAM.BH",
    " marketcap ": " $1 552 457 369 ",
    "price (USD)": "1.37135",
    "country": "Bahrain"
  },
  {
    "Rank": "4572",
    "Name": "Hertz",
    "Symbol": "HTZ",
    " marketcap ": " $1 550 471 936 ",
    "price (USD)": "05.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "4573",
    "Name": "Sanlorenzo",
    "Symbol": "SL.MI",
    " marketcap ": " $1 549 563 080 ",
    "price (USD)": "44.5217",
    "country": "Italy"
  },
  {
    "Rank": "4574",
    "Name": "Eve Air Mobility",
    "Symbol": "EVEX",
    " marketcap ": " $1 548 854 528 ",
    "price (USD)": "\u043c\u0430\u0439.75",
    "country": "United States"
  },
  {
    "Rank": "4575",
    "Name": "MaxLinear",
    "Symbol": "MXL",
    " marketcap ": " $1 548 674 560 ",
    "price (USD)": "18.63",
    "country": "United States"
  },
  {
    "Rank": "4576",
    "Name": "Atea ASA",
    "Symbol": "ATEA.OL",
    " marketcap ": " $1 548 192 041 ",
    "price (USD)": "13.8654",
    "country": "Norway"
  },
  {
    "Rank": "4577",
    "Name": "PeptiDream",
    "Symbol": "4587.T",
    " marketcap ": " $1 547 236 492 ",
    "price (USD)": "\u043d\u043e\u044f.78",
    "country": "Japan"
  },
  {
    "Rank": "4578",
    "Name": "Betsson AB",
    "Symbol": "BETS-B.ST",
    " marketcap ": " $1 547 181 383 ",
    "price (USD)": "\u043d\u043e\u044f.98",
    "country": "Sweden"
  },
  {
    "Rank": "4579",
    "Name": "Basic-Fit",
    "Symbol": "BFIT.AS",
    " marketcap ": " $1 546 617 370 ",
    "price (USD)": "23.4336",
    "country": "Netherlands"
  },
  {
    "Rank": "4580",
    "Name": "Xenia Hotels &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4581",
    "Name": "KFin Technologies",
    "Symbol": "KFINTECH.NS",
    " marketcap ": " $1 542 341 432 ",
    "price (USD)": "9.0109",
    "country": "India"
  },
  {
    "Rank": "4582",
    "Name": "Supernus Pharmaceuticals",
    "Symbol": "SUPN",
    " marketcap ": " $1 542 029 056 ",
    "price (USD)": "28.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "4583",
    "Name": "Mahanagar Gas",
    "Symbol": "MGL.NS",
    " marketcap ": " $1 541 418 949 ",
    "price (USD)": "15.6049",
    "country": "India"
  },
  {
    "Rank": "4584",
    "Name": "The Chefs' Warehouse",
    "Symbol": "CHEF",
    " marketcap ": " $1 540 755 712 ",
    "price (USD)": "38.74",
    "country": "United States"
  },
  {
    "Rank": "4585",
    "Name": "Central Plaza Hotel",
    "Symbol": "CENTEL.BK",
    " marketcap ": " $1 540 460 379 ",
    "price (USD)": "1.14108",
    "country": "Thailand"
  },
  {
    "Rank": "4586",
    "Name": "Getty Images",
    "Symbol": "GETY",
    " marketcap ": " $1 540 399 360 ",
    "price (USD)": "\u043c\u0430\u0440.77",
    "country": "United States"
  },
  {
    "Rank": "4587",
    "Name": "TOD'S",
    "Symbol": "TOD.MI",
    " marketcap ": " $1 538 062 539 ",
    "price (USD)": "46.4763",
    "country": "Italy"
  },
  {
    "Rank": "4588",
    "Name": "Huron Consulting",
    "Symbol": "HURN",
    " marketcap ": " $1 538 055 424 ",
    "price (USD)": "85.42",
    "country": "United States"
  },
  {
    "Rank": "4589",
    "Name": "Upwork",
    "Symbol": "UPWK",
    " marketcap ": " $1 537 962 880 ",
    "price (USD)": "11.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "4590",
    "Name": "Avadel Pharmaceuticals",
    "Symbol": "AVDL",
    " marketcap ": " $1 537 895 936 ",
    "price (USD)": "16",
    "country": "Ireland"
  },
  {
    "Rank": "4591",
    "Name": "Alkhorayef Water and Power Technologies Company",
    "Symbol": "2081.SR",
    " marketcap ": " $1 537 106 717 ",
    "price (USD)": "61.4843",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4592",
    "Name": "D/S Norden (Dampskibsselskabet Norden)",
    "Symbol": "DNORD.CO",
    " marketcap ": " $1 535 991 656 ",
    "price (USD)": "49.5588",
    "country": "Denmark"
  },
  {
    "Rank": "4593",
    "Name": "NV5 Global",
    "Symbol": "NVEE",
    " marketcap ": " $1 533 698 944 ",
    "price (USD)": "94.99",
    "country": "United States"
  },
  {
    "Rank": "4594",
    "Name": "Nippon Shinyaku",
    "Symbol": "4516.T",
    " marketcap ": " $1 532 684 490 ",
    "price (USD)": "22.7561",
    "country": "Japan"
  },
  {
    "Rank": "4595",
    "Name": "E2open",
    "Symbol": "ETWO",
    " marketcap ": " $1 532 630 016 ",
    "price (USD)": "5",
    "country": "United States"
  },
  {
    "Rank": "4596",
    "Name": "Sterling Check",
    "Symbol": "STER",
    " marketcap ": " $1 531 764 480 ",
    "price (USD)": "15.67",
    "country": "United States"
  },
  {
    "Rank": "4597",
    "Name": "Amber Enterprises India",
    "Symbol": "AMBER.NS",
    " marketcap ": " $1 531 412 301 ",
    "price (USD)": "45.451",
    "country": "India"
  },
  {
    "Rank": "4598",
    "Name": "NOW Inc.",
    "Symbol": "DNOW",
    " marketcap ": " $1 530 487 040 ",
    "price (USD)": "14.33",
    "country": "United States"
  },
  {
    "Rank": "4599",
    "Name": "Aavas Financiers",
    "Symbol": "AAVAS.NS",
    " marketcap ": " $1 529 743 821 ",
    "price (USD)": "19.3297",
    "country": "India"
  },
  {
    "Rank": "4600",
    "Name": "Kronos Worldwide",
    "Symbol": "KRO",
    " marketcap ": " $1 526 408 320 ",
    "price (USD)": "13.27",
    "country": "United States"
  },
  {
    "Rank": "4601",
    "Name": "AUTO1",
    "Symbol": "AG1.F",
    " marketcap ": " $1 526 300 132 ",
    "price (USD)": "7.08546",
    "country": "Germany"
  },
  {
    "Rank": "4602",
    "Name": "La-Z-Boy",
    "Symbol": "LZB",
    " marketcap ": " $1 526 078 464 ",
    "price (USD)": "35.79",
    "country": "United States"
  },
  {
    "Rank": "4603",
    "Name": "LTC Properties",
    "Symbol": "LTC",
    " marketcap ": " $1 525 986 432 ",
    "price (USD)": "35.1",
    "country": "United States"
  },
  {
    "Rank": "4604",
    "Name": "Borr Drilling",
    "Symbol": "BORR",
    " marketcap ": " $1 525 565 952 ",
    "price (USD)": "06.\u043c\u0430\u0440",
    "country": "Bermuda"
  },
  {
    "Rank": "4605",
    "Name": "Perdoceo Education",
    "Symbol": "PRDO",
    " marketcap ": " $1 525 260 416 ",
    "price (USD)": "23.25",
    "country": "United States"
  },
  {
    "Rank": "4606",
    "Name": "Steelcase",
    "Symbol": "SCS",
    " marketcap ": " $1 524 748 416 ",
    "price (USD)": "13.29",
    "country": "United States"
  },
  {
    "Rank": "4607",
    "Name": "ProFrac",
    "Symbol": "ACDC",
    " marketcap ": " $1 524 190 080 ",
    "price (USD)": "\u0441\u0435\u043d.53",
    "country": "United States"
  },
  {
    "Rank": "4608",
    "Name": "Getty Realty",
    "Symbol": "GTY",
    " marketcap ": " $1 524 030 848 ",
    "price (USD)": "28.24",
    "country": "United States"
  },
  {
    "Rank": "4609",
    "Name": "City Holding Company",
    "Symbol": "CHCO",
    " marketcap ": " $1 519 998 464 ",
    "price (USD)": "102.96",
    "country": "United States"
  },
  {
    "Rank": "4610",
    "Name": "Bradespar",
    "Symbol": "BRAP3.SA",
    " marketcap ": " $1 519 831 695 ",
    "price (USD)": "\u043c\u0430\u0440.65",
    "country": "Brazil"
  },
  {
    "Rank": "4611",
    "Name": "Vicor",
    "Symbol": "VICR",
    " marketcap ": " $1 518 155 008 ",
    "price (USD)": "34.08",
    "country": "United States"
  },
  {
    "Rank": "4612",
    "Name": "Benchmark Electronics",
    "Symbol": "BHE",
    " marketcap ": " $1 517 888 640 ",
    "price (USD)": "42.11",
    "country": "United States"
  },
  {
    "Rank": "4613",
    "Name": "ams AG",
    "Symbol": "DQW1.F",
    " marketcap ": " $1 516 991 395 ",
    "price (USD)": "1.53328",
    "country": "Austria"
  },
  {
    "Rank": "4614",
    "Name": "NETSCOUT",
    "Symbol": "NTCT",
    " marketcap ": " $1 516 869 376 ",
    "price (USD)": "21.24",
    "country": "United States"
  },
  {
    "Rank": "4615",
    "Name": "Zuora",
    "Symbol": "ZUO",
    " marketcap ": " $1 515 103 872 ",
    "price (USD)": "\u043e\u043a\u0442.23",
    "country": "United States"
  },
  {
    "Rank": "4616",
    "Name": "National Healthcare",
    "Symbol": "NHC",
    " marketcap ": " $1 515 022 464 ",
    "price (USD)": "98.38",
    "country": "United States"
  },
  {
    "Rank": "4617",
    "Name": "Paradox Interactive",
    "Symbol": "PDX.ST",
    " marketcap ": " $1 512 649 892 ",
    "price (USD)": "14.3212",
    "country": "Sweden"
  },
  {
    "Rank": "4618",
    "Name": "Freehold Royalties",
    "Symbol": "FRU.TO",
    " marketcap ": " $1 512 469 096 ",
    "price (USD)": "10.037",
    "country": "Canada"
  },
  {
    "Rank": "4619",
    "Name": "Hudson Pacific Properties",
    "Symbol": "HPP",
    " marketcap ": " $1 510 304 128 ",
    "price (USD)": "\u043c\u0430\u0439.24",
    "country": "United States"
  },
  {
    "Rank": "4620",
    "Name": "Stabilus",
    "Symbol": "STM.DE",
    " marketcap ": " $1 510 055 294 ",
    "price (USD)": "61.1358",
    "country": "Luxembourg"
  },
  {
    "Rank": "4621",
    "Name": "The Vita Coco Company",
    "Symbol": "COCO",
    " marketcap ": " $1 509 494 912 ",
    "price (USD)": "26.63",
    "country": "United States"
  },
  {
    "Rank": "4622",
    "Name": "Wilh. Wilhelmsen Holding",
    "Symbol": "WWI.OL",
    " marketcap ": " $1 508 606 454 ",
    "price (USD)": "34.851",
    "country": "Norway"
  },
  {
    "Rank": "4623",
    "Name": "Al Yah Satellite Communications Company",
    "Symbol": "YAHSAT.AE",
    " marketcap ": " $1 507 958 314 ",
    "price (USD)": "0.62",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "4624",
    "Name": "HBM Healthcare Investments",
    "Symbol": "HBMN.SW",
    " marketcap ": " $1 507 700 273 ",
    "price (USD)": "218.148",
    "country": "Switzerland"
  },
  {
    "Rank": "4625",
    "Name": "Neumora Therapeutics",
    "Symbol": "NMRA",
    " marketcap ": " $1 507 501 824 ",
    "price (USD)": "\u0441\u0435\u043d.45",
    "country": "United States"
  },
  {
    "Rank": "4626",
    "Name": "Metrovacesa",
    "Symbol": "MVC.MC",
    " marketcap ": " $1 506 948 768 ",
    "price (USD)": "9.94679",
    "country": "Spain"
  },
  {
    "Rank": "4627",
    "Name": "Global Partners LP",
    "Symbol": "GLP",
    " marketcap ": " $1 506 227 072 ",
    "price (USD)": "44.33",
    "country": "United States"
  },
  {
    "Rank": "4628",
    "Name": "Fiskars",
    "Symbol": "FSKRS.HE",
    " marketcap ": " $1 505 546 730 ",
    "price (USD)": "18.6122",
    "country": "Finland"
  },
  {
    "Rank": "4629",
    "Name": "Orion Engineered Carbons",
    "Symbol": "OEC",
    " marketcap ": " $1 505 510 016 ",
    "price (USD)": "25.82",
    "country": "United States"
  },
  {
    "Rank": "4630",
    "Name": "Lenzing",
    "Symbol": "LEN.F",
    " marketcap ": " $1 505 498 360 ",
    "price (USD)": "38.5492",
    "country": "Austria"
  },
  {
    "Rank": "4631",
    "Name": "DOF Group",
    "Symbol": "DOFG.OL",
    " marketcap ": " $1 504 713 016 ",
    "price (USD)": "\u0430\u0432\u0433.81",
    "country": "Norway"
  },
  {
    "Rank": "4632",
    "Name": "Dundee Precious Metals",
    "Symbol": "DPM.TO",
    " marketcap ": " $1 503 978 761 ",
    "price (USD)": "8.28565",
    "country": "Canada"
  },
  {
    "Rank": "4633",
    "Name": "Perella Weinberg Partners",
    "Symbol": "PWP",
    " marketcap ": " $1 503 238 016 ",
    "price (USD)": "15.95",
    "country": "United States"
  },
  {
    "Rank": "4634",
    "Name": "Navios Maritime Partners",
    "Symbol": "NMM",
    " marketcap ": " $1 500 466 560 ",
    "price (USD)": "49.71",
    "country": "Monaco"
  },
  {
    "Rank": "4635",
    "Name": "Udemy",
    "Symbol": "UDMY",
    " marketcap ": " $1 500 419 200 ",
    "price (USD)": "09.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "4636",
    "Name": "World Kinect",
    "Symbol": "WKC",
    " marketcap ": " $1 500 255 744 ",
    "price (USD)": "25.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "4637",
    "Name": "Dynavax Technologies",
    "Symbol": "DVAX",
    " marketcap ": " $1 500 022 272 ",
    "price (USD)": "\u043d\u043e\u044f.46",
    "country": "United States"
  },
  {
    "Rank": "4638",
    "Name": "Customers Bancorp",
    "Symbol": "CUBI",
    " marketcap ": " $1 499 988 224 ",
    "price (USD)": "47.39",
    "country": "United States"
  },
  {
    "Rank": "4639",
    "Name": "Enterprise Financial Services Corp",
    "Symbol": "EFSC",
    " marketcap ": " $1 498 543 232 ",
    "price (USD)": "39.97",
    "country": "United States"
  },
  {
    "Rank": "4640",
    "Name": "Establishment Labs",
    "Symbol": "ESTA",
    " marketcap ": " $1 495 979 648 ",
    "price (USD)": "54.37",
    "country": "Costa Rica"
  },
  {
    "Rank": "4641",
    "Name": "Budget Saudi (United International Transportation Company)",
    "Symbol": "4260.SR",
    " marketcap ": " $1 494 627 919 ",
    "price (USD)": "21.0018",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4642",
    "Name": "Apollo Commercial Real Estate",
    "Symbol": "ARI",
    " marketcap ": " $1 494 122 624 ",
    "price (USD)": "\u043e\u043a\u0442.51",
    "country": "United States"
  },
  {
    "Rank": "4643",
    "Name": "Victrex",
    "Symbol": "VCT.L",
    " marketcap ": " $1 493 790 935 ",
    "price (USD)": "17.1631",
    "country": "United Kingdom"
  },
  {
    "Rank": "4644",
    "Name": "Utz Brands",
    "Symbol": "UTZ",
    " marketcap ": " $1 491 788 928 ",
    "price (USD)": "18.31",
    "country": "United States"
  },
  {
    "Rank": "4645",
    "Name": "TGS ASA",
    "Symbol": "TGS.OL",
    " marketcap ": " $1 489 420 347 ",
    "price (USD)": "\u043d\u043e\u044f.93",
    "country": "Norway"
  },
  {
    "Rank": "4646",
    "Name": "Extreme Networks",
    "Symbol": "EXTR",
    " marketcap ": " $1 486 605 056 ",
    "price (USD)": "\u043d\u043e\u044f.44",
    "country": "United States"
  },
  {
    "Rank": "4647",
    "Name": "Revolve",
    "Symbol": "RVLV",
    " marketcap ": " $1 486 459 392 ",
    "price (USD)": "20.99",
    "country": "United States"
  },
  {
    "Rank": "4648",
    "Name": "Al Masane Al Kobra Mining Company",
    "Symbol": "1322.SR",
    " marketcap ": " $1 485 706 825 ",
    "price (USD)": "16.5452",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4649",
    "Name": "Voltamp Transformers",
    "Symbol": "VOLTAMP.NS",
    " marketcap ": " $1 484 976 956 ",
    "price (USD)": "146.743",
    "country": "India"
  },
  {
    "Rank": "4650",
    "Name": "American Woodmark",
    "Symbol": "AMWD",
    " marketcap ": " $1 484 546 176 ",
    "price (USD)": "93.69",
    "country": "United States"
  },
  {
    "Rank": "4651",
    "Name": "BGF Retail",
    "Symbol": "282330.KS",
    " marketcap ": " $1 484 346 228 ",
    "price (USD)": "85.9245",
    "country": "South Korea"
  },
  {
    "Rank": "4652",
    "Name": "TS TECH",
    "Symbol": "7313.T",
    " marketcap ": " $1 482 847 927 ",
    "price (USD)": "\u043d\u043e\u044f.75",
    "country": "Japan"
  },
  {
    "Rank": "4653",
    "Name": "Net One Systems",
    "Symbol": "7518.T",
    " marketcap ": " $1 482 368 597 ",
    "price (USD)": "18.6936",
    "country": "Japan"
  },
  {
    "Rank": "4654",
    "Name": "Fagron",
    "Symbol": "FAGR.BR",
    " marketcap ": " $1 482 088 218 ",
    "price (USD)": "20.3062",
    "country": "Belgium"
  },
  {
    "Rank": "4655",
    "Name": "Asseco",
    "Symbol": "ACP.WA",
    " marketcap ": " $1 480 301 628 ",
    "price (USD)": "21.708",
    "country": "Poland"
  },
  {
    "Rank": "4656",
    "Name": "V2X",
    "Symbol": "VVX",
    " marketcap ": " $1 479 831 424 ",
    "price (USD)": "47.04",
    "country": "United States"
  },
  {
    "Rank": "4657",
    "Name": "PROS",
    "Symbol": "PRO",
    " marketcap ": " $1 479 698 432 ",
    "price (USD)": "31.48",
    "country": "United States"
  },
  {
    "Rank": "4658",
    "Name": "Biotest",
    "Symbol": "BIO.F",
    " marketcap ": " $1 479 521 685 ",
    "price (USD)": "44.3045",
    "country": "Germany"
  },
  {
    "Rank": "4659",
    "Name": "Financi\u0413\u0401re Moncey Soci\u0413\u00a9t\u0413\u00a9 anonyme",
    "Symbol": "FMONC.PA",
    " marketcap ": " $1 479 410 351 ",
    "price (USD)": "8089.91",
    "country": "France"
  },
  {
    "Rank": "4660",
    "Name": "Morphic Therapeutic",
    "Symbol": "MORF",
    " marketcap ": " $1 477 260 288 ",
    "price (USD)": "29.49",
    "country": "United States"
  },
  {
    "Rank": "4661",
    "Name": "WisdomTree",
    "Symbol": "WT",
    " marketcap ": " $1 475 661 184 ",
    "price (USD)": "\u0441\u0435\u043d.72",
    "country": "United States"
  },
  {
    "Rank": "4662",
    "Name": "Marex Group",
    "Symbol": "MRX",
    " marketcap ": " $1 474 432 768 ",
    "price (USD)": "20.82",
    "country": "United Kingdom"
  },
  {
    "Rank": "4663",
    "Name": "NW Natural",
    "Symbol": "NWN",
    " marketcap ": " $1 473 588 864 ",
    "price (USD)": "38.75",
    "country": "United States"
  },
  {
    "Rank": "4664",
    "Name": "Tamarack Valley Energy",
    "Symbol": "TVE.TO",
    " marketcap ": " $1 471 340 269 ",
    "price (USD)": "2.66139",
    "country": "Canada"
  },
  {
    "Rank": "4665",
    "Name": "Veidekke",
    "Symbol": "VEI.OL",
    " marketcap ": " $1 471 143 285 ",
    "price (USD)": "\u043e\u043a\u0442.09",
    "country": "Norway"
  },
  {
    "Rank": "4666",
    "Name": "Genesis Energy",
    "Symbol": "GNE.NZ",
    " marketcap ": " $1 469 130 391 ",
    "price (USD)": "1.35706",
    "country": "New Zealand"
  },
  {
    "Rank": "4667",
    "Name": "Happiest Minds Technologies",
    "Symbol": "HAPPSTMNDS.NS",
    " marketcap ": " $1 468 476 513 ",
    "price (USD)": "9.83034",
    "country": "India"
  },
  {
    "Rank": "4668",
    "Name": "RSA Insurance Group",
    "Symbol": "RSAB.L",
    " marketcap ": " $1 465 895 928 ",
    "price (USD)": "1.43674",
    "country": "United Kingdom"
  },
  {
    "Rank": "4669",
    "Name": "Xencor",
    "Symbol": "XNCR",
    " marketcap ": " $1 465 720 064 ",
    "price (USD)": "23.77",
    "country": "United States"
  },
  {
    "Rank": "4670",
    "Name": "Omnicell",
    "Symbol": "OMCL",
    " marketcap ": " $1 465 418 880 ",
    "price (USD)": "31.91",
    "country": "United States"
  },
  {
    "Rank": "4671",
    "Name": "Hansol Chemical",
    "Symbol": "014680.KS",
    " marketcap ": " $1 465 119 845 ",
    "price (USD)": "129.254",
    "country": "South Korea"
  },
  {
    "Rank": "4672",
    "Name": "Trisura Group",
    "Symbol": "TSU.TO",
    " marketcap ": " $1 464 287 905 ",
    "price (USD)": "30.8662",
    "country": "Canada"
  },
  {
    "Rank": "4673",
    "Name": "Apogee Enterprises",
    "Symbol": "APOG",
    " marketcap ": " $1 461 699 840 ",
    "price (USD)": "66.05",
    "country": "United States"
  },
  {
    "Rank": "4674",
    "Name": "Lisi S.A.",
    "Symbol": "FII.PA",
    " marketcap ": " $1 460 480 278 ",
    "price (USD)": "30.5679",
    "country": "France"
  },
  {
    "Rank": "4675",
    "Name": "MeridianLink",
    "Symbol": "MLNK",
    " marketcap ": " $1 458 999 552 ",
    "price (USD)": "19.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "4676",
    "Name": "AmRest",
    "Symbol": "EAT.MC",
    " marketcap ": " $1 458 958 567 ",
    "price (USD)": "6.65653",
    "country": "Spain"
  },
  {
    "Rank": "4677",
    "Name": "Ladder Capital",
    "Symbol": "LADR",
    " marketcap ": " $1 455 365 504 ",
    "price (USD)": "\u043d\u043e\u044f.38",
    "country": "United States"
  },
  {
    "Rank": "4678",
    "Name": "Cricut",
    "Symbol": "CRCT",
    " marketcap ": " $1 454 150 912 ",
    "price (USD)": "\u0438\u044e\u043d.71",
    "country": "United States"
  },
  {
    "Rank": "4679",
    "Name": "Shutterstock",
    "Symbol": "SSTK",
    " marketcap ": " $1 453 445 760 ",
    "price (USD)": "40.55",
    "country": "United States"
  },
  {
    "Rank": "4680",
    "Name": "Skyward Specialty Insurance Group",
    "Symbol": "SKWD",
    " marketcap ": " $1 453 018 368 ",
    "price (USD)": "36.33",
    "country": "United States"
  },
  {
    "Rank": "4681",
    "Name": "Labrador Iron Ore Royalty Corp.",
    "Symbol": "LIF.TO",
    " marketcap ": " $1 452 721 874 ",
    "price (USD)": "22.6988",
    "country": "Canada"
  },
  {
    "Rank": "4682",
    "Name": "Future plc",
    "Symbol": "FUTR.L",
    " marketcap ": " $1 451 538 259 ",
    "price (USD)": "\u0434\u0435\u043a.97",
    "country": "United Kingdom"
  },
  {
    "Rank": "4683",
    "Name": "Ready Capital",
    "Symbol": "RC",
    " marketcap ": " $1 449 371 392 ",
    "price (USD)": "\u0430\u0432\u0433.52",
    "country": "United States"
  },
  {
    "Rank": "4684",
    "Name": "Summerset Holdings",
    "Symbol": "SUM.NZ",
    " marketcap ": " $1 449 310 545 ",
    "price (USD)": "6.15121",
    "country": "New Zealand"
  },
  {
    "Rank": "4685",
    "Name": "Graphite India",
    "Symbol": "GRAPHITE.NS",
    " marketcap ": " $1 448 998 969 ",
    "price (USD)": "7.41646",
    "country": "India"
  },
  {
    "Rank": "4686",
    "Name": "3R Petroleum",
    "Symbol": "RRRP3.SA",
    " marketcap ": " $1 447 033 841 ",
    "price (USD)": "5.87409",
    "country": "Brazil"
  },
  {
    "Rank": "4687",
    "Name": "Everbridge",
    "Symbol": "EVBG",
    " marketcap ": " $1 446 156 032 ",
    "price (USD)": "34.75",
    "country": "United States"
  },
  {
    "Rank": "4688",
    "Name": "VSE Corporation",
    "Symbol": "VSEC",
    " marketcap ": " $1 445 373 440 ",
    "price (USD)": "78.5",
    "country": "United States"
  },
  {
    "Rank": "4689",
    "Name": "SpareBank 1",
    "Symbol": "SPOL.OL",
    " marketcap ": " $1 444 842 841 ",
    "price (USD)": "\u0434\u0435\u043a.69",
    "country": "Norway"
  },
  {
    "Rank": "4690",
    "Name": "Marten Transport",
    "Symbol": "MRTN",
    " marketcap ": " $1 444 188 032 ",
    "price (USD)": "17.75",
    "country": "United States"
  },
  {
    "Rank": "4691",
    "Name": "Southern Province Cement Company",
    "Symbol": "3050.SR",
    " marketcap ": " $1 443 973 079 ",
    "price (USD)": "\u043e\u043a\u0442.41",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4692",
    "Name": "Ivanhoe Electric",
    "Symbol": "IE",
    " marketcap ": " $1 443 683 968 ",
    "price (USD)": "12",
    "country": "Canada"
  },
  {
    "Rank": "4693",
    "Name": "Pet Valu",
    "Symbol": "PET.TO",
    " marketcap ": " $1 440 863 328 ",
    "price (USD)": "20.162",
    "country": "Canada"
  },
  {
    "Rank": "4694",
    "Name": "Safehold",
    "Symbol": "SAFE",
    " marketcap ": " $1 440 846 080 ",
    "price (USD)": "20.17",
    "country": "United States"
  },
  {
    "Rank": "4695",
    "Name": "ACM Research",
    "Symbol": "ACMR",
    " marketcap ": " $1 440 459 776 ",
    "price (USD)": "23.23",
    "country": "United States"
  },
  {
    "Rank": "4696",
    "Name": "Office Depot",
    "Symbol": "ODP",
    " marketcap ": " $1 440 103 296 ",
    "price (USD)": "40.12",
    "country": "United States"
  },
  {
    "Rank": "4697",
    "Name": "MAG Silver",
    "Symbol": "MAG",
    " marketcap ": " $1 439 876 224 ",
    "price (USD)": "13.96",
    "country": "Canada"
  },
  {
    "Rank": "4698",
    "Name": "Northwest Bank",
    "Symbol": "NWBI",
    " marketcap ": " $1 439 355 904 ",
    "price (USD)": "\u043d\u043e\u044f.31",
    "country": "United States"
  },
  {
    "Rank": "4699",
    "Name": "Pacira Biosciences",
    "Symbol": "PCRX",
    " marketcap ": " $1 438 274 432 ",
    "price (USD)": "30.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "4700",
    "Name": "Stock Yards Bancorp",
    "Symbol": "SYBT",
    " marketcap ": " $1 436 994 432 ",
    "price (USD)": "48.89",
    "country": "United States"
  },
  {
    "Rank": "4701",
    "Name": "Elme Communities",
    "Symbol": "ELME",
    " marketcap ": " $1 434 466 688 ",
    "price (USD)": "16.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "4702",
    "Name": "Orla Mining",
    "Symbol": "ORLA",
    " marketcap ": " $1 432 165 504 ",
    "price (USD)": "04.\u043c\u0430\u0439",
    "country": "Canada"
  },
  {
    "Rank": "4703",
    "Name": "Aston Martin",
    "Symbol": "AML.L",
    " marketcap ": " $1 432 137 041 ",
    "price (USD)": "1.73665",
    "country": "United Kingdom"
  },
  {
    "Rank": "4704",
    "Name": "Befesa",
    "Symbol": "BFSA.DE",
    " marketcap ": " $1 431 642 958 ",
    "price (USD)": "35.7911",
    "country": "Luxembourg"
  },
  {
    "Rank": "4705",
    "Name": "Tarsus Pharmaceuticals",
    "Symbol": "TARS",
    " marketcap ": " $1 429 281 792 ",
    "price (USD)": "37.83",
    "country": "United States"
  },
  {
    "Rank": "4706",
    "Name": "Cargojet",
    "Symbol": "CJT.TO",
    " marketcap ": " $1 427 160 726 ",
    "price (USD)": "86.6674",
    "country": "Canada"
  },
  {
    "Rank": "4707",
    "Name": "First Commonwealth Financial Corp",
    "Symbol": "FCF",
    " marketcap ": " $1 426 020 096 ",
    "price (USD)": "13.94",
    "country": "United States"
  },
  {
    "Rank": "4708",
    "Name": "Italmobiliare",
    "Symbol": "ITM.MI",
    " marketcap ": " $1 425 676 065 ",
    "price (USD)": "33.3912",
    "country": "Italy"
  },
  {
    "Rank": "4709",
    "Name": "TANLA",
    "Symbol": "TANLA.NS",
    " marketcap ": " $1 424 617 268 ",
    "price (USD)": "\u043e\u043a\u0442.39",
    "country": "India"
  },
  {
    "Rank": "4710",
    "Name": "Alignment Healthcare",
    "Symbol": "ALHC",
    " marketcap ": " $1 424 425 088 ",
    "price (USD)": "\u0438\u044e\u043b.45",
    "country": "United States"
  },
  {
    "Rank": "4711",
    "Name": "Gimv NV",
    "Symbol": "GIMB.BR",
    " marketcap ": " $1 424 384 945 ",
    "price (USD)": "51.1456",
    "country": "Belgium"
  },
  {
    "Rank": "4712",
    "Name": "Solaria Energ\u0413\u00ada",
    "Symbol": "SLR.MC",
    " marketcap ": " $1 423 320 665 ",
    "price (USD)": "11.391",
    "country": "Spain"
  },
  {
    "Rank": "4713",
    "Name": "Soci\u0413\u00a9t\u0413\u00a9 Industrielle et Financi\u0413\u0401re de l'Artois",
    "Symbol": "ARTO.PA",
    " marketcap ": " $1 422 199 952 ",
    "price (USD)": "5342.6",
    "country": "France"
  },
  {
    "Rank": "4714",
    "Name": "Kennedy Wilson",
    "Symbol": "KW",
    " marketcap ": " $1 422 039 552 ",
    "price (USD)": "\u043e\u043a\u0442.34",
    "country": "United States"
  },
  {
    "Rank": "4715",
    "Name": "Arion banki",
    "Symbol": "ARION.IC",
    " marketcap ": " $1 421 398 696 ",
    "price (USD)": "0.991676",
    "country": "Iceland"
  },
  {
    "Rank": "4716",
    "Name": "PIERER Mobility",
    "Symbol": "PKTM.VI",
    " marketcap ": " $1 420 267 790 ",
    "price (USD)": "42.0241",
    "country": "Austria"
  },
  {
    "Rank": "4717",
    "Name": "Marcopolo",
    "Symbol": "POMO4.SA",
    " marketcap ": " $1 416 881 663 ",
    "price (USD)": "1.39971",
    "country": "Brazil"
  },
  {
    "Rank": "4718",
    "Name": "Rai Way",
    "Symbol": "RWAY.MI",
    " marketcap ": " $1 416 334 664 ",
    "price (USD)": "5.27745",
    "country": "Italy"
  },
  {
    "Rank": "4719",
    "Name": "\u0413\u040cslandsbanki",
    "Symbol": "ISB.IC",
    " marketcap ": " $1 413 840 115 ",
    "price (USD)": "0.719508",
    "country": "Iceland"
  },
  {
    "Rank": "4720",
    "Name": "Couchbase",
    "Symbol": "BASE",
    " marketcap ": " $1 412 667 392 ",
    "price (USD)": "28.14",
    "country": "United States"
  },
  {
    "Rank": "4721",
    "Name": "Verbio",
    "Symbol": "VBK.F",
    " marketcap ": " $1 411 110 974 ",
    "price (USD)": "22.174",
    "country": "Germany"
  },
  {
    "Rank": "4722",
    "Name": "National Bank Holdings",
    "Symbol": "NBHC",
    " marketcap ": " $1 410 887 424 ",
    "price (USD)": "37.3",
    "country": "United States"
  },
  {
    "Rank": "4723",
    "Name": "REV Group",
    "Symbol": "REVG",
    " marketcap ": " $1 407 800 064 ",
    "price (USD)": "27.13",
    "country": "United States"
  },
  {
    "Rank": "4724",
    "Name": "Smith Douglas Homes",
    "Symbol": "SDHC",
    " marketcap ": " $1 406 668 032 ",
    "price (USD)": "27.43",
    "country": "United States"
  },
  {
    "Rank": "4725",
    "Name": "Semapa",
    "Symbol": "SEM.LS",
    " marketcap ": " $1 403 234 992 ",
    "price (USD)": "17.4829",
    "country": "Portugal"
  },
  {
    "Rank": "4726",
    "Name": "Ingles Markets",
    "Symbol": "IMKTA",
    " marketcap ": " $1 402 546 432 ",
    "price (USD)": "73.84",
    "country": "United States"
  },
  {
    "Rank": "4727",
    "Name": "Fletcher Building",
    "Symbol": "FBU.NZ",
    " marketcap ": " $1 400 862 835 ",
    "price (USD)": "1.789",
    "country": "New Zealand"
  },
  {
    "Rank": "4728",
    "Name": "Pathward Financial",
    "Symbol": "CASH",
    " marketcap ": " $1 400 496 640 ",
    "price (USD)": "55.42",
    "country": "United States"
  },
  {
    "Rank": "4729",
    "Name": "JYP Entertainment",
    "Symbol": "035900.KQ",
    " marketcap ": " $1 400 304 442 ",
    "price (USD)": "42.3013",
    "country": "South Korea"
  },
  {
    "Rank": "4730",
    "Name": "Akero Therapeutics",
    "Symbol": "AKRO",
    " marketcap ": " $1 399 616 256 ",
    "price (USD)": "20.24",
    "country": "United States"
  },
  {
    "Rank": "4731",
    "Name": "SM Entertainment",
    "Symbol": "041510.KQ",
    " marketcap ": " $1 399 214 116 ",
    "price (USD)": "59.9269",
    "country": "South Korea"
  },
  {
    "Rank": "4732",
    "Name": "Horace Mann Educators",
    "Symbol": "HMN",
    " marketcap ": " $1 398 910 464 ",
    "price (USD)": "34.15",
    "country": "United States"
  },
  {
    "Rank": "4733",
    "Name": "Boursa Kuwait Securities Company",
    "Symbol": "BOURSA.KW",
    " marketcap ": " $1 397 186 336 ",
    "price (USD)": "6958.93",
    "country": "Kuwait"
  },
  {
    "Rank": "4734",
    "Name": "Matterport",
    "Symbol": "MTTR",
    " marketcap ": " $1 396 460 032 ",
    "price (USD)": "\u0430\u043f\u0440.44",
    "country": "United States"
  },
  {
    "Rank": "4735",
    "Name": "GasLog",
    "Symbol": "GLOG-PA",
    " marketcap ": " $1 396 413 568 ",
    "price (USD)": "25.52",
    "country": "Greece"
  },
  {
    "Rank": "4736",
    "Name": "Hamburger Hafen",
    "Symbol": "HHFA.F",
    " marketcap ": " $1 393 447 558 ",
    "price (USD)": "18.4168",
    "country": "Germany"
  },
  {
    "Rank": "4737",
    "Name": "East India Distilleries Parry",
    "Symbol": "EIDPARRY.NS",
    " marketcap ": " $1 393 021 563 ",
    "price (USD)": "7.84721",
    "country": "India"
  },
  {
    "Rank": "4738",
    "Name": "Aica Kogyo Company",
    "Symbol": "4206.T",
    " marketcap ": " $1 391 065 347 ",
    "price (USD)": "21.7452",
    "country": "Japan"
  },
  {
    "Rank": "4739",
    "Name": "AF Gruppen",
    "Symbol": "AFG.OL",
    " marketcap ": " $1 390 135 193 ",
    "price (USD)": "\u0434\u0435\u043a.47",
    "country": "Norway"
  },
  {
    "Rank": "4740",
    "Name": "IntegraFin",
    "Symbol": "IHP.L",
    " marketcap ": " $1 390 038 471 ",
    "price (USD)": "4.19543",
    "country": "United Kingdom"
  },
  {
    "Rank": "4741",
    "Name": "Vir Biotechnology",
    "Symbol": "VIR",
    " marketcap ": " $1 389 162 496 ",
    "price (USD)": "\u043e\u043a\u0442.21",
    "country": "United States"
  },
  {
    "Rank": "4742",
    "Name": "Qassim Cement Company",
    "Symbol": "3040.SR",
    " marketcap ": " $1 388 199 469 ",
    "price (USD)": "15.4244",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4743",
    "Name": "Hollysys Automation Technologie",
    "Symbol": "HOLI",
    " marketcap ": " $1 384 565 376 ",
    "price (USD)": "22.26",
    "country": "China"
  },
  {
    "Rank": "4744",
    "Name": "Taboola.com",
    "Symbol": "TBLA",
    " marketcap ": " $1 384 043 904 ",
    "price (USD)": "04.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "4745",
    "Name": "Cohu",
    "Symbol": "COHU",
    " marketcap ": " $1 381 029 504 ",
    "price (USD)": "29.33",
    "country": "United States"
  },
  {
    "Rank": "4746",
    "Name": "Monex Group",
    "Symbol": "8698.T",
    " marketcap ": " $1 379 189 226 ",
    "price (USD)": "5.35474",
    "country": "Japan"
  },
  {
    "Rank": "4747",
    "Name": "BlueNord ASA",
    "Symbol": "BNOR.OL",
    " marketcap ": " $1 378 776 019 ",
    "price (USD)": "52.8159",
    "country": "Norway"
  },
  {
    "Rank": "4748",
    "Name": "Gogo Inflight Internet",
    "Symbol": "GOGO",
    " marketcap ": " $1 377 818 240 ",
    "price (USD)": "\u043e\u043a\u0442.84",
    "country": "United States"
  },
  {
    "Rank": "4749",
    "Name": "Polenergia",
    "Symbol": "PEP.WA",
    " marketcap ": " $1 376 514 275 ",
    "price (USD)": "17.8261",
    "country": "Poland"
  },
  {
    "Rank": "4750",
    "Name": "Redefine Properties",
    "Symbol": "RDF.JO",
    " marketcap ": " $1 375 183 000 ",
    "price (USD)": "0.203132",
    "country": "South Africa"
  },
  {
    "Rank": "4751",
    "Name": "AMC Entertainment",
    "Symbol": "AMC",
    " marketcap ": " $1 374 484 224 ",
    "price (USD)": "\u0430\u043f\u0440.65",
    "country": "United States"
  },
  {
    "Rank": "4752",
    "Name": "Canfor",
    "Symbol": "CFP.TO",
    " marketcap ": " $1 374 231 818 ",
    "price (USD)": "\u043d\u043e\u044f.67",
    "country": "Canada"
  },
  {
    "Rank": "4753",
    "Name": "Kiniksa Pharmaceuticals",
    "Symbol": "KNSA",
    " marketcap ": " $1 374 109 696 ",
    "price (USD)": "19.37",
    "country": "Bermuda"
  },
  {
    "Rank": "4754",
    "Name": "Sihanoukville Autonomous Port",
    "Symbol": "PAS.KH",
    " marketcap ": " $1 373 617 466 ",
    "price (USD)": "03.\u043c\u0430\u0439",
    "country": "Cambodia"
  },
  {
    "Rank": "4755",
    "Name": "LOTTE Corporation",
    "Symbol": "004990.KS",
    " marketcap ": " $1 373 355 779 ",
    "price (USD)": "19.1311",
    "country": "South Korea"
  },
  {
    "Rank": "4756",
    "Name": "Sparkassen Immobilien",
    "Symbol": "T1L.F",
    " marketcap ": " $1 371 100 167 ",
    "price (USD)": "19.4918",
    "country": "Austria"
  },
  {
    "Rank": "4757",
    "Name": "Corticeira Amorim",
    "Symbol": "COR.LS",
    " marketcap ": " $1 370 583 108 ",
    "price (USD)": "\u043e\u043a\u0442.51",
    "country": "Portugal"
  },
  {
    "Rank": "4758",
    "Name": "Agiliti",
    "Symbol": "AGTI",
    " marketcap ": " $1 367 613 952 ",
    "price (USD)": "10.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "4759",
    "Name": "PDF Solutions",
    "Symbol": "PDFS",
    " marketcap ": " $1 367 171 712 ",
    "price (USD)": "35.6",
    "country": "United States"
  },
  {
    "Rank": "4760",
    "Name": "MMTC",
    "Symbol": "MMTC.NS",
    " marketcap ": " $1 365 242 073 ",
    "price (USD)": "0.910161",
    "country": "India"
  },
  {
    "Rank": "4761",
    "Name": "Electra",
    "Symbol": "ELTR.TA",
    " marketcap ": " $1 365 113 857 ",
    "price (USD)": "355.639",
    "country": "Israel"
  },
  {
    "Rank": "4762",
    "Name": "K92 Mining",
    "Symbol": "KNT.TO",
    " marketcap ": " $1 364 768 011 ",
    "price (USD)": "5.77001",
    "country": "Canada"
  },
  {
    "Rank": "4763",
    "Name": "Force Motors",
    "Symbol": "FORCEMOT.NS",
    " marketcap ": " $1 361 689 847 ",
    "price (USD)": "103.344",
    "country": "India"
  },
  {
    "Rank": "4764",
    "Name": "Guess",
    "Symbol": "GES",
    " marketcap ": " $1 356 351 232 ",
    "price (USD)": "25.37",
    "country": "United States"
  },
  {
    "Rank": "4765",
    "Name": "Seabridge Gold",
    "Symbol": "SA",
    " marketcap ": " $1 355 665 792 ",
    "price (USD)": "15.46",
    "country": "Canada"
  },
  {
    "Rank": "4766",
    "Name": "Canada Goose",
    "Symbol": "GOOS",
    " marketcap ": " $1 354 889 472 ",
    "price (USD)": "13.99",
    "country": "Canada"
  },
  {
    "Rank": "4767",
    "Name": "Kontron AG",
    "Symbol": "KTN.F",
    " marketcap ": " $1 354 756 503 ",
    "price (USD)": "22.0219",
    "country": "Austria"
  },
  {
    "Rank": "4768",
    "Name": "Hornbach Holding",
    "Symbol": "HBH.DE",
    " marketcap ": " $1 354 611 532 ",
    "price (USD)": "84.6997",
    "country": "Germany"
  },
  {
    "Rank": "4769",
    "Name": "Phreesia",
    "Symbol": "PHR",
    " marketcap ": " $1 353 893 760 ",
    "price (USD)": "23.62",
    "country": "United States"
  },
  {
    "Rank": "4770",
    "Name": "Belite Bio",
    "Symbol": "BLTE",
    " marketcap ": " $1 353 261 568 ",
    "price (USD)": "45.42",
    "country": "United States"
  },
  {
    "Rank": "4771",
    "Name": "Spirent",
    "Symbol": "SPT.L",
    " marketcap ": " $1 352 242 694 ",
    "price (USD)": "\u0444\u0435\u0432.47",
    "country": "United Kingdom"
  },
  {
    "Rank": "4772",
    "Name": "Owens &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4773",
    "Name": "Jubilant Pharmova",
    "Symbol": "JUBLPHARMA.NS",
    " marketcap ": " $1 349 923 080 ",
    "price (USD)": "8.52488",
    "country": "India"
  },
  {
    "Rank": "4774",
    "Name": "Harmonic",
    "Symbol": "HLIT",
    " marketcap ": " $1 349 556 352 ",
    "price (USD)": "\u043d\u043e\u044f.58",
    "country": "United States"
  },
  {
    "Rank": "4775",
    "Name": "SilverCrest Metals",
    "Symbol": "SILV",
    " marketcap ": " $1 348 881 280 ",
    "price (USD)": "\u0441\u0435\u043d.14",
    "country": "Canada"
  },
  {
    "Rank": "4776",
    "Name": "Salzgitter",
    "Symbol": "SZG.F",
    " marketcap ": " $1 344 987 695 ",
    "price (USD)": "24.867",
    "country": "Germany"
  },
  {
    "Rank": "4777",
    "Name": "Lectra SA",
    "Symbol": "LSS.PA",
    " marketcap ": " $1 343 860 311 ",
    "price (USD)": "35.2916",
    "country": "France"
  },
  {
    "Rank": "4778",
    "Name": "BrightView",
    "Symbol": "BV",
    " marketcap ": " $1 343 790 080 ",
    "price (USD)": "14.22",
    "country": "United States"
  },
  {
    "Rank": "4779",
    "Name": "JBG SMITH",
    "Symbol": "JBGS",
    " marketcap ": " $1 343 623 424 ",
    "price (USD)": "14.62",
    "country": "United States"
  },
  {
    "Rank": "4780",
    "Name": "The North West Company",
    "Symbol": "NWC.TO",
    " marketcap ": " $1 343 089 515 ",
    "price (USD)": "28.2268",
    "country": "Canada"
  },
  {
    "Rank": "4781",
    "Name": "Aamal Company",
    "Symbol": "AHCS.QA",
    " marketcap ": " $1 343 076 993 ",
    "price (USD)": "0.213187",
    "country": "Qatar"
  },
  {
    "Rank": "4782",
    "Name": "Great Portland Estates",
    "Symbol": "GPE.L",
    " marketcap ": " $1 341 178 392 ",
    "price (USD)": "\u043c\u0430\u0439.15",
    "country": "United Kingdom"
  },
  {
    "Rank": "4783",
    "Name": "Champion REIT",
    "Symbol": "2778.HK",
    " marketcap ": " $1 341 065 733 ",
    "price (USD)": "0.221683",
    "country": "Hong Kong"
  },
  {
    "Rank": "4784",
    "Name": "eClerx Services",
    "Symbol": "ECLERX.NS",
    " marketcap ": " $1 340 796 983 ",
    "price (USD)": "27.8161",
    "country": "India"
  },
  {
    "Rank": "4785",
    "Name": "Jeld-Wen",
    "Symbol": "JELD",
    " marketcap ": " $1 340 528 000 ",
    "price (USD)": "15.59",
    "country": "United States"
  },
  {
    "Rank": "4786",
    "Name": "Tokai Carbon",
    "Symbol": "5301.T",
    " marketcap ": " $1 339 499 298 ",
    "price (USD)": "6.28239",
    "country": "Japan"
  },
  {
    "Rank": "4787",
    "Name": "W\u0413\u0458stenrot &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4788",
    "Name": "Huya",
    "Symbol": "HUYA",
    " marketcap ": " $1 338 858 368 ",
    "price (USD)": "\u043c\u0430\u0439.88",
    "country": "China"
  },
  {
    "Rank": "4789",
    "Name": "LiveWire Group",
    "Symbol": "LVWR",
    " marketcap ": " $1 338 844 288 ",
    "price (USD)": "\u0438\u044e\u043d.59",
    "country": "United States"
  },
  {
    "Rank": "4790",
    "Name": "Vesuvius India",
    "Symbol": "VESUVIUS.NS",
    " marketcap ": " $1 337 193 771 ",
    "price (USD)": "65.8843",
    "country": "India"
  },
  {
    "Rank": "4791",
    "Name": "Westamerica Bancorporation",
    "Symbol": "WABC",
    " marketcap ": " $1 336 587 776 ",
    "price (USD)": "50.1",
    "country": "United States"
  },
  {
    "Rank": "4792",
    "Name": "GVS S.p.A.",
    "Symbol": "GVS.MI",
    " marketcap ": " $1 336 002 259 ",
    "price (USD)": "\u0438\u044e\u043b.47",
    "country": "Italy"
  },
  {
    "Rank": "4793",
    "Name": "First Bancorp",
    "Symbol": "FBNC",
    " marketcap ": " $1 335 561 216 ",
    "price (USD)": "32.44",
    "country": "United States"
  },
  {
    "Rank": "4794",
    "Name": "First Busey",
    "Symbol": "BUSE",
    " marketcap ": " $1 334 840 448 ",
    "price (USD)": "23.53",
    "country": "United States"
  },
  {
    "Rank": "4795",
    "Name": "Corbion",
    "Symbol": "CRBN.AS",
    " marketcap ": " $1 329 954 332 ",
    "price (USD)": "22.5432",
    "country": "Netherlands"
  },
  {
    "Rank": "4796",
    "Name": "Brookdale Senior Living",
    "Symbol": "BKD",
    " marketcap ": " $1 329 859 456 ",
    "price (USD)": "\u0438\u044e\u043d.89",
    "country": "United States"
  },
  {
    "Rank": "4797",
    "Name": "Kossan Rubber Industries",
    "Symbol": "7153.KL",
    " marketcap ": " $1 326 505 439 ",
    "price (USD)": "0.519868",
    "country": "Malaysia"
  },
  {
    "Rank": "4798",
    "Name": "Global Industrial Company",
    "Symbol": "GIC",
    " marketcap ": " $1 326 401 024 ",
    "price (USD)": "34.74",
    "country": "United States"
  },
  {
    "Rank": "4799",
    "Name": "Hongkong and Shanghai Hotels",
    "Symbol": "0045.HK",
    " marketcap ": " $1 325 220 227 ",
    "price (USD)": "0.803441",
    "country": "Hong Kong"
  },
  {
    "Rank": "4800",
    "Name": "BioCryst Pharmaceuticals",
    "Symbol": "BCRX",
    " marketcap ": " $1 324 940 288 ",
    "price (USD)": "\u0438\u044e\u043d.42",
    "country": "United States"
  },
  {
    "Rank": "4801",
    "Name": "Zydus Wellness",
    "Symbol": "ZYDUSWELL.NS",
    " marketcap ": " $1 324 448 713 ",
    "price (USD)": "20.8142",
    "country": "India"
  },
  {
    "Rank": "4802",
    "Name": "Agthia Group",
    "Symbol": "AGTHIA.AE",
    " marketcap ": " $1 323 893 124 ",
    "price (USD)": "\u044f\u043d\u0432.59",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "4803",
    "Name": "Warba Bank",
    "Symbol": "WARBABANK.KW",
    " marketcap ": " $1 323 825 398 ",
    "price (USD)": "606.258",
    "country": "Kuwait"
  },
  {
    "Rank": "4804",
    "Name": "InterRent Real Estate Investment Trust",
    "Symbol": "IIP-UN.TO",
    " marketcap ": " $1 323 431 223 ",
    "price (USD)": "8.97394",
    "country": "Canada"
  },
  {
    "Rank": "4805",
    "Name": "Vetoquinol",
    "Symbol": "VETO.PA",
    " marketcap ": " $1 323 430 349 ",
    "price (USD)": "110.761",
    "country": "France"
  },
  {
    "Rank": "4806",
    "Name": "Ichor Systems",
    "Symbol": "ICHR",
    " marketcap ": " $1 323 274 624 ",
    "price (USD)": "39.53",
    "country": "United States"
  },
  {
    "Rank": "4807",
    "Name": "Norwegian Air Shuttle",
    "Symbol": "NAS.OL",
    " marketcap ": " $1 318 820 156 ",
    "price (USD)": "1.36824",
    "country": "Norway"
  },
  {
    "Rank": "4808",
    "Name": "Netstreit",
    "Symbol": "NTST",
    " marketcap ": " $1 318 757 504 ",
    "price (USD)": "17.86",
    "country": "United States"
  },
  {
    "Rank": "4809",
    "Name": "Two Harbors Investment",
    "Symbol": "TWO",
    " marketcap ": " $1 318 513 536 ",
    "price (USD)": "\u0434\u0435\u043a.74",
    "country": "United States"
  },
  {
    "Rank": "4810",
    "Name": "OVH Groupe",
    "Symbol": "OVH.PA",
    " marketcap ": " $1 318 395 969 ",
    "price (USD)": "\u0438\u044e\u043d.34",
    "country": "France"
  },
  {
    "Rank": "4811",
    "Name": "East Pipes Integrated Company for Industry",
    "Symbol": "1321.SR",
    " marketcap ": " $1 318 069 010 ",
    "price (USD)": "41.8435",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4812",
    "Name": "Oxford Lane Capital",
    "Symbol": "OXLC",
    " marketcap ": " $1 315 203 968 ",
    "price (USD)": "05.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "4813",
    "Name": "Marcus &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4814",
    "Name": "TaskUs",
    "Symbol": "TASK",
    " marketcap ": " $1 313 069 952 ",
    "price (USD)": "14.91",
    "country": "United States"
  },
  {
    "Rank": "4815",
    "Name": "Innergex Renewable Energy",
    "Symbol": "INE.TO",
    " marketcap ": " $1 312 673 948 ",
    "price (USD)": "6.45185",
    "country": "Canada"
  },
  {
    "Rank": "4816",
    "Name": "OdontoPrev",
    "Symbol": "ODPV3.SA",
    " marketcap ": " $1 310 358 976 ",
    "price (USD)": "\u0444\u0435\u0432.97",
    "country": "Brazil"
  },
  {
    "Rank": "4817",
    "Name": "Eurocommercial Properties",
    "Symbol": "ECMPA.AS",
    " marketcap ": " $1 308 999 388 ",
    "price (USD)": "24.4869",
    "country": "Netherlands"
  },
  {
    "Rank": "4818",
    "Name": "Advantage Energy",
    "Symbol": "AAV.TO",
    " marketcap ": " $1 308 690 225 ",
    "price (USD)": "8.12346",
    "country": "Canada"
  },
  {
    "Rank": "4819",
    "Name": "Polymetal",
    "Symbol": "PM6A.F",
    " marketcap ": " $1 308 353 833 ",
    "price (USD)": "02.\u043c\u0430\u0440",
    "country": "Cyprus"
  },
  {
    "Rank": "4820",
    "Name": "Kaman",
    "Symbol": "KAMN",
    " marketcap ": " $1 307 481 984 ",
    "price (USD)": "45.99",
    "country": "United States"
  },
  {
    "Rank": "4821",
    "Name": "Hyster-Yale Materials Handling",
    "Symbol": "HY",
    " marketcap ": " $1 305 302 016 ",
    "price (USD)": "74.61",
    "country": "United States"
  },
  {
    "Rank": "4822",
    "Name": "Universal Corporation",
    "Symbol": "UVV",
    " marketcap ": " $1 302 625 280 ",
    "price (USD)": "53.01",
    "country": "United States"
  },
  {
    "Rank": "4823",
    "Name": "Sparebanken Vest",
    "Symbol": "SVEG.OL",
    " marketcap ": " $1 302 347 063 ",
    "price (USD)": "\u043d\u043e\u044f.09",
    "country": "Norway"
  },
  {
    "Rank": "4824",
    "Name": "Ferrum S.A. de Cer\u0413\u040emica y Metalurgia",
    "Symbol": "FERR.BA",
    " marketcap ": " $1 302 258 116 ",
    "price (USD)": "0.137514",
    "country": "Argentina"
  },
  {
    "Rank": "4825",
    "Name": "4D Molecular Therapeutics",
    "Symbol": "FDMT",
    " marketcap ": " $1 300 340 480 ",
    "price (USD)": "25.15",
    "country": "United States"
  },
  {
    "Rank": "4826",
    "Name": "Knowledge Economic City Company",
    "Symbol": "4310.SR",
    " marketcap ": " $1 300 228 871 ",
    "price (USD)": "3.83209",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4827",
    "Name": "Bombay Burmah",
    "Symbol": "BBTC.NS",
    " marketcap ": " $1 300 086 205 ",
    "price (USD)": "18.6334",
    "country": "India"
  },
  {
    "Rank": "4828",
    "Name": "AdaptHealth",
    "Symbol": "AHCO",
    " marketcap ": " $1 300 051 584 ",
    "price (USD)": "\u0441\u0435\u043d.76",
    "country": "United States"
  },
  {
    "Rank": "4829",
    "Name": "Columbus McKinnon",
    "Symbol": "CMCO",
    " marketcap ": " $1 299 771 264 ",
    "price (USD)": "45.2",
    "country": "United States"
  },
  {
    "Rank": "4830",
    "Name": "VTEX",
    "Symbol": "VTEX",
    " marketcap ": " $1 299 298 688 ",
    "price (USD)": "07.\u043c\u0430\u0440",
    "country": "United Kingdom"
  },
  {
    "Rank": "4831",
    "Name": "Caverion",
    "Symbol": "CAV1V.HE",
    " marketcap ": " $1 298 190 344 ",
    "price (USD)": "9.51243",
    "country": "Finland"
  },
  {
    "Rank": "4832",
    "Name": "Reliance Power",
    "Symbol": "RPOWER.NS",
    " marketcap ": " $1 297 411 873 ",
    "price (USD)": "0.322612",
    "country": "India"
  },
  {
    "Rank": "4833",
    "Name": "Transcat",
    "Symbol": "TRNS",
    " marketcap ": " $1 295 299 584 ",
    "price (USD)": "141.86",
    "country": "United States"
  },
  {
    "Rank": "4834",
    "Name": "Kakao Games",
    "Symbol": "293490.KQ",
    " marketcap ": " $1 295 225 834 ",
    "price (USD)": "15.863",
    "country": "South Korea"
  },
  {
    "Rank": "4835",
    "Name": "Aether Industries",
    "Symbol": "AETHER.NS",
    " marketcap ": " $1 294 215 667 ",
    "price (USD)": "9.75405",
    "country": "India"
  },
  {
    "Rank": "4836",
    "Name": "ANI Pharmaceuticals",
    "Symbol": "ANIP",
    " marketcap ": " $1 293 540 352 ",
    "price (USD)": "61.71",
    "country": "United States"
  },
  {
    "Rank": "4837",
    "Name": "Dah Sing Banking Group",
    "Symbol": "2356.HK",
    " marketcap ": " $1 293 359 292 ",
    "price (USD)": "0.920049",
    "country": "Hong Kong"
  },
  {
    "Rank": "4838",
    "Name": "Day One Biopharmaceuticals",
    "Symbol": "DAWN",
    " marketcap ": " $1 292 496 640 ",
    "price (USD)": "14.79",
    "country": "United States"
  },
  {
    "Rank": "4839",
    "Name": "Bajaj Electricals",
    "Symbol": "BAJAJELEC.NS",
    " marketcap ": " $1 291 659 155 ",
    "price (USD)": "\u043d\u043e\u044f.27",
    "country": "India"
  },
  {
    "Rank": "4840",
    "Name": "Headwater Exploration",
    "Symbol": "HWX.TO",
    " marketcap ": " $1 291 404 805 ",
    "price (USD)": "5.44008",
    "country": "Canada"
  },
  {
    "Rank": "4841",
    "Name": "MannKind Corp",
    "Symbol": "MNKD",
    " marketcap ": " $1 290 777 728 ",
    "price (USD)": "\u0430\u043f\u0440.74",
    "country": "United States"
  },
  {
    "Rank": "4842",
    "Name": "Hope Bancorp",
    "Symbol": "HOPE",
    " marketcap ": " $1 290 580 480 ",
    "price (USD)": "10.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "4843",
    "Name": "Wesdome Gold Mines",
    "Symbol": "WDO.TO",
    " marketcap ": " $1 289 353 727 ",
    "price (USD)": "8.62202",
    "country": "Canada"
  },
  {
    "Rank": "4844",
    "Name": "GigaCloud Technology",
    "Symbol": "GCT",
    " marketcap ": " $1 289 138 688 ",
    "price (USD)": "31.45",
    "country": "China"
  },
  {
    "Rank": "4845",
    "Name": "Lindsay Corporation",
    "Symbol": "LNN",
    " marketcap ": " $1 288 279 936 ",
    "price (USD)": "116.71",
    "country": "United States"
  },
  {
    "Rank": "4846",
    "Name": "StorageVault Canada",
    "Symbol": "SVI.TO",
    " marketcap ": " $1 287 940 514 ",
    "price (USD)": "3.43854",
    "country": "Canada"
  },
  {
    "Rank": "4847",
    "Name": "Cadre",
    "Symbol": "CDRE",
    " marketcap ": " $1 286 404 480 ",
    "price (USD)": "31.68",
    "country": "United States"
  },
  {
    "Rank": "4848",
    "Name": "Coursera",
    "Symbol": "COUR",
    " marketcap ": " $1 286 362 880 ",
    "price (USD)": "\u0430\u0432\u0433.24",
    "country": "United States"
  },
  {
    "Rank": "4849",
    "Name": "City Union Bank",
    "Symbol": "CUB.NS",
    " marketcap ": " $1 284 631 282 ",
    "price (USD)": "1.73441",
    "country": "India"
  },
  {
    "Rank": "4850",
    "Name": "TriCo Bancshares",
    "Symbol": "TCBK",
    " marketcap ": " $1 284 180 992 ",
    "price (USD)": "38.71",
    "country": "United States"
  },
  {
    "Rank": "4851",
    "Name": "Caleres",
    "Symbol": "CAL",
    " marketcap ": " $1 282 139 648 ",
    "price (USD)": "36.45",
    "country": "United States"
  },
  {
    "Rank": "4852",
    "Name": "Cosmo Pharmaceuticals",
    "Symbol": "C43.F",
    " marketcap ": " $1 281 650 559 ",
    "price (USD)": "77.6414",
    "country": "Ireland"
  },
  {
    "Rank": "4853",
    "Name": "United Gulf Holding Company",
    "Symbol": "UGH.BH",
    " marketcap ": " $1 281 176 310 ",
    "price (USD)": "0.564987",
    "country": "Bahrain"
  },
  {
    "Rank": "4854",
    "Name": "Select Energy Services",
    "Symbol": "WTTR",
    " marketcap ": " $1 280 725 376 ",
    "price (USD)": "\u043e\u043a\u0442.77",
    "country": "United States"
  },
  {
    "Rank": "4855",
    "Name": "MapmyIndia",
    "Symbol": "MAPMYINDIA.NS",
    " marketcap ": " $1 280 639 959 ",
    "price (USD)": "24.0541",
    "country": "India"
  },
  {
    "Rank": "4856",
    "Name": "Lumen",
    "Symbol": "LUMN",
    " marketcap ": " $1 278 950 400 ",
    "price (USD)": "\u044f\u043d\u0432.26",
    "country": "United States"
  },
  {
    "Rank": "4857",
    "Name": "Com7 Public Company",
    "Symbol": "COM7.BK",
    " marketcap ": " $1 278 767 654 ",
    "price (USD)": "0.536171",
    "country": "Thailand"
  },
  {
    "Rank": "4858",
    "Name": "Adeia",
    "Symbol": "ADEA",
    " marketcap ": " $1 278 212 480 ",
    "price (USD)": "\u043d\u043e\u044f.78",
    "country": "United States"
  },
  {
    "Rank": "4859",
    "Name": "Super Hi International",
    "Symbol": "9658.HK",
    " marketcap ": " $1 276 135 756 ",
    "price (USD)": "2.0605",
    "country": "Singapore"
  },
  {
    "Rank": "4860",
    "Name": "Nokian Tyres",
    "Symbol": "TYRES.HE",
    " marketcap ": " $1 275 248 752 ",
    "price (USD)": "9.24965",
    "country": "Finland"
  },
  {
    "Rank": "4861",
    "Name": "Nakanishi",
    "Symbol": "7716.T",
    " marketcap ": " $1 275 097 525 ",
    "price (USD)": "15.0982",
    "country": "Japan"
  },
  {
    "Rank": "4862",
    "Name": "Winmark",
    "Symbol": "WINA",
    " marketcap ": " $1 274 988 032 ",
    "price (USD)": "364.55",
    "country": "United States"
  },
  {
    "Rank": "4863",
    "Name": "Melco International Development",
    "Symbol": "0200.HK",
    " marketcap ": " $1 274 924 371 ",
    "price (USD)": "0.840602",
    "country": "Hong Kong"
  },
  {
    "Rank": "4864",
    "Name": "Wacker Neuson",
    "Symbol": "WAC.F",
    " marketcap ": " $1 274 779 090 ",
    "price (USD)": "18.7425",
    "country": "Germany"
  },
  {
    "Rank": "4865",
    "Name": "Elkem",
    "Symbol": "ELK.OL",
    " marketcap ": " $1 273 867 428 ",
    "price (USD)": "2.00944",
    "country": "Norway"
  },
  {
    "Rank": "4866",
    "Name": "Cancom",
    "Symbol": "COK.F",
    " marketcap ": " $1 273 221 935 ",
    "price (USD)": "34.7052",
    "country": "Germany"
  },
  {
    "Rank": "4867",
    "Name": "Dorchester Minerals",
    "Symbol": "DMLP",
    " marketcap ": " $1 271 610 368 ",
    "price (USD)": "31.72",
    "country": "United States"
  },
  {
    "Rank": "4868",
    "Name": "Puravankara",
    "Symbol": "PURVA.NS",
    " marketcap ": " $1 270 408 697 ",
    "price (USD)": "5.35283",
    "country": "India"
  },
  {
    "Rank": "4869",
    "Name": "1st Source",
    "Symbol": "SRCE",
    " marketcap ": " $1 269 301 248 ",
    "price (USD)": "51.83",
    "country": "United States"
  },
  {
    "Rank": "4870",
    "Name": "Saul Centers",
    "Symbol": "BFS",
    " marketcap ": " $1 267 640 576 ",
    "price (USD)": "37.77",
    "country": "United States"
  },
  {
    "Rank": "4871",
    "Name": "Frontier Airlines",
    "Symbol": "ULCC",
    " marketcap ": " $1 265 362 688 ",
    "price (USD)": "\u043c\u0430\u0439.65",
    "country": "United States"
  },
  {
    "Rank": "4872",
    "Name": "Kenon Holdings",
    "Symbol": "KEN",
    " marketcap ": " $1 264 265 856 ",
    "price (USD)": "23.955",
    "country": "Singapore"
  },
  {
    "Rank": "4873",
    "Name": "Cannae Holdings",
    "Symbol": "CNNE",
    " marketcap ": " $1 263 608 320 ",
    "price (USD)": "20.13",
    "country": "United States"
  },
  {
    "Rank": "4874",
    "Name": "Retal Urban Development Company",
    "Symbol": "4322.SR",
    " marketcap ": " $1 262 242 114 ",
    "price (USD)": "2.52448",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4875",
    "Name": "Al Seer Marine Supplies &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4876",
    "Name": "Jinko Solar",
    "Symbol": "JKS",
    " marketcap ": " $1 260 535 680 ",
    "price (USD)": "24.\u0430\u043f\u0440",
    "country": "China"
  },
  {
    "Rank": "4877",
    "Name": "S&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4878",
    "Name": "Calumet Specialty Products Partners",
    "Symbol": "CLMT",
    " marketcap ": " $1 257 277 696 ",
    "price (USD)": "15.64",
    "country": "United States"
  },
  {
    "Rank": "4879",
    "Name": "DAQO New Energy",
    "Symbol": "DQ",
    " marketcap ": " $1 256 673 664 ",
    "price (USD)": "19.\u043d\u043e\u044f",
    "country": "China"
  },
  {
    "Rank": "4880",
    "Name": "Alony Hetz",
    "Symbol": "ALHE.TA",
    " marketcap ": " $1 256 571 169 ",
    "price (USD)": "6.99171",
    "country": "Israel"
  },
  {
    "Rank": "4881",
    "Name": "Easterly Government Properties",
    "Symbol": "DEA",
    " marketcap ": " $1 256 175 232 ",
    "price (USD)": "12.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "4882",
    "Name": "Trupanion",
    "Symbol": "TRUP",
    " marketcap ": " $1 255 992 704 ",
    "price (USD)": "29.89",
    "country": "United States"
  },
  {
    "Rank": "4883",
    "Name": "Monarch Casino &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4884",
    "Name": "HEG",
    "Symbol": "HEG.NS",
    " marketcap ": " $1 254 410 639 ",
    "price (USD)": "32.5015",
    "country": "India"
  },
  {
    "Rank": "4885",
    "Name": "Intershop Holding",
    "Symbol": "ISN.SW",
    " marketcap ": " $1 254 205 467 ",
    "price (USD)": "136.068",
    "country": "Switzerland"
  },
  {
    "Rank": "4886",
    "Name": "Hekta\u0415\u045f",
    "Symbol": "HEKTS.IS",
    " marketcap ": " $1 253 482 799 ",
    "price (USD)": "0.495448",
    "country": "Turkey"
  },
  {
    "Rank": "4887",
    "Name": "Voltalia",
    "Symbol": "VLTSA.PA",
    " marketcap ": " $1 250 583 768 ",
    "price (USD)": "9.57759",
    "country": "France"
  },
  {
    "Rank": "4888",
    "Name": "Electrosteel Castings",
    "Symbol": "ELECTCAST.NS",
    " marketcap ": " $1 249 710 232 ",
    "price (USD)": "2.02158",
    "country": "India"
  },
  {
    "Rank": "4889",
    "Name": "Esker",
    "Symbol": "ALESK.PA",
    " marketcap ": " $1 249 379 798 ",
    "price (USD)": "210.663",
    "country": "France"
  },
  {
    "Rank": "4890",
    "Name": "United Development Company",
    "Symbol": "UDCD.QA",
    " marketcap ": " $1 249 028 642 ",
    "price (USD)": "0.352747",
    "country": "Qatar"
  },
  {
    "Rank": "4891",
    "Name": "CSG International",
    "Symbol": "CSGS",
    " marketcap ": " $1 248 889 984 ",
    "price (USD)": "42.07",
    "country": "United States"
  },
  {
    "Rank": "4892",
    "Name": "Kforce",
    "Symbol": "KFRC",
    " marketcap ": " $1 248 788 352 ",
    "price (USD)": "64.07",
    "country": "United States"
  },
  {
    "Rank": "4893",
    "Name": "Barco NV",
    "Symbol": "BAR.BR",
    " marketcap ": " $1 247 574 955 ",
    "price (USD)": "14.084",
    "country": "Belgium"
  },
  {
    "Rank": "4894",
    "Name": "Cipher Mining",
    "Symbol": "CIFR",
    " marketcap ": " $1 246 316 544 ",
    "price (USD)": "04.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "4895",
    "Name": "Formula Systems",
    "Symbol": "FORTY",
    " marketcap ": " $1 245 168 512 ",
    "price (USD)": "81.21",
    "country": "Israel"
  },
  {
    "Rank": "4896",
    "Name": "Amara Raja Batteries",
    "Symbol": "AMARAJABAT.NS",
    " marketcap ": " $1 241 775 208 ",
    "price (USD)": "\u0438\u044e\u043b.26",
    "country": "India"
  },
  {
    "Rank": "4897",
    "Name": "Neurones",
    "Symbol": "NRO.PA",
    " marketcap ": " $1 241 524 109 ",
    "price (USD)": "51.1456",
    "country": "France"
  },
  {
    "Rank": "4898",
    "Name": "Green Plains",
    "Symbol": "GPRE",
    " marketcap ": " $1 241 325 184 ",
    "price (USD)": "19.21",
    "country": "United States"
  },
  {
    "Rank": "4899",
    "Name": "National Vision Holdings",
    "Symbol": "EYE",
    " marketcap ": " $1 241 263 872 ",
    "price (USD)": "15.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "4900",
    "Name": "Dexco",
    "Symbol": "DXCO3.SA",
    " marketcap ": " $1 240 019 022 ",
    "price (USD)": "1.52465",
    "country": "Brazil"
  },
  {
    "Rank": "4901",
    "Name": "Great Eagle",
    "Symbol": "0041.HK",
    " marketcap ": " $1 239 828 568 ",
    "price (USD)": "1.65814",
    "country": "Hong Kong"
  },
  {
    "Rank": "4902",
    "Name": "Stellar Bancorp",
    "Symbol": "STEL",
    " marketcap ": " $1 238 637 824 ",
    "price (USD)": "23.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "4903",
    "Name": "Dana Gas",
    "Symbol": "DANA.AE",
    " marketcap ": " $1 238 051 758 ",
    "price (USD)": "0.18",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "4904",
    "Name": "G-III Apparel Group",
    "Symbol": "GIII",
    " marketcap ": " $1 236 545 792 ",
    "price (USD)": "27.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "4905",
    "Name": "Formosa Taffeta",
    "Symbol": "1434.TW",
    " marketcap ": " $1 236 534 780 ",
    "price (USD)": "0.734952",
    "country": "Taiwan"
  },
  {
    "Rank": "4906",
    "Name": "Nicolet Bankshares",
    "Symbol": "NIC",
    " marketcap ": " $1 235 896 448 ",
    "price (USD)": "82.76",
    "country": "United States"
  },
  {
    "Rank": "4907",
    "Name": "NCC",
    "Symbol": "NCC-B.ST",
    " marketcap ": " $1 235 347 937 ",
    "price (USD)": "\u0434\u0435\u043a.51",
    "country": "Sweden"
  },
  {
    "Rank": "4908",
    "Name": "Cathay Real Estate Development",
    "Symbol": "2501.TW",
    " marketcap ": " $1 235 180 878 ",
    "price (USD)": "1.06522",
    "country": "Taiwan"
  },
  {
    "Rank": "4909",
    "Name": "Granules India",
    "Symbol": "GRANULES.NS",
    " marketcap ": " $1 234 894 608 ",
    "price (USD)": "5.0951",
    "country": "India"
  },
  {
    "Rank": "4910",
    "Name": "MOIL",
    "Symbol": "MOIL.NS",
    " marketcap ": " $1 234 572 350 ",
    "price (USD)": "6.06714",
    "country": "India"
  },
  {
    "Rank": "4911",
    "Name": "THG (The Hut Group)",
    "Symbol": "THG.L",
    " marketcap ": " $1 234 285 366 ",
    "price (USD)": "0.927692",
    "country": "United Kingdom"
  },
  {
    "Rank": "4912",
    "Name": "Precinct Properties",
    "Symbol": "PCT.NZ",
    " marketcap ": " $1 232 164 215 ",
    "price (USD)": "0.710697",
    "country": "New Zealand"
  },
  {
    "Rank": "4913",
    "Name": "Lumi Rental Company",
    "Symbol": "4262.SR",
    " marketcap ": " $1 231 419 913 ",
    "price (USD)": "22.3895",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4914",
    "Name": "XD Inc.",
    "Symbol": "2400.HK",
    " marketcap ": " $1 231 342 440 ",
    "price (USD)": "2.60766",
    "country": "China"
  },
  {
    "Rank": "4915",
    "Name": "Altri",
    "Symbol": "ALTR.LS",
    " marketcap ": " $1 230 756 486 ",
    "price (USD)": "5.70637",
    "country": "Portugal"
  },
  {
    "Rank": "4916",
    "Name": "Construcciones y Auxiliar de Ferrocarriles",
    "Symbol": "CAF.MC",
    " marketcap ": " $1 230 450 837 ",
    "price (USD)": "35.9431",
    "country": "Spain"
  },
  {
    "Rank": "4917",
    "Name": "Faes Farma",
    "Symbol": "FAE.MC",
    " marketcap ": " $1 230 259 859 ",
    "price (USD)": "3.95266",
    "country": "Spain"
  },
  {
    "Rank": "4918",
    "Name": "Dole PLC",
    "Symbol": "DOLE",
    " marketcap ": " $1 229 333 120 ",
    "price (USD)": "\u0434\u0435\u043a.95",
    "country": "Ireland"
  },
  {
    "Rank": "4919",
    "Name": "Sildarvinnslan",
    "Symbol": "SVN.IC",
    " marketcap ": " $1 229 217 273 ",
    "price (USD)": "0.665943",
    "country": "Iceland"
  },
  {
    "Rank": "4920",
    "Name": "ScanSource",
    "Symbol": "SCSC",
    " marketcap ": " $1 228 788 480 ",
    "price (USD)": "49.73",
    "country": "United States"
  },
  {
    "Rank": "4921",
    "Name": "Emerald Holding",
    "Symbol": "EEX",
    " marketcap ": " $1 227 098 624 ",
    "price (USD)": "06.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "4922",
    "Name": "Hawaiian Electric Industries",
    "Symbol": "HE",
    " marketcap ": " $1 226 569 344 ",
    "price (USD)": "11.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "4923",
    "Name": "Central Securities",
    "Symbol": "CET",
    " marketcap ": " $1 225 160 704 ",
    "price (USD)": "43.158",
    "country": "United States"
  },
  {
    "Rank": "4924",
    "Name": "Infinera",
    "Symbol": "INFN",
    " marketcap ": " $1 224 384 896 ",
    "price (USD)": "\u043c\u0430\u0439.23",
    "country": "United States"
  },
  {
    "Rank": "4925",
    "Name": "Black Rifle Coffee (BRC)",
    "Symbol": "BRCC",
    " marketcap ": " $1 223 747 328 ",
    "price (USD)": "\u043c\u0430\u0439.55",
    "country": "United States"
  },
  {
    "Rank": "4926",
    "Name": "Investcorp Capital",
    "Symbol": "ICAP.AE",
    " marketcap ": " $1 223 236 066 ",
    "price (USD)": "0.56",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "4927",
    "Name": "Cars.com",
    "Symbol": "CARS",
    " marketcap ": " $1 223 157 120 ",
    "price (USD)": "18.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "4928",
    "Name": "Bank Islam Malaysia",
    "Symbol": "5258.KL",
    " marketcap ": " $1 221 725 488 ",
    "price (USD)": "0.539043",
    "country": "Malaysia"
  },
  {
    "Rank": "4929",
    "Name": "Terveystalo",
    "Symbol": "TTALO.HE",
    " marketcap ": " $1 221 721 012 ",
    "price (USD)": "\u0441\u0435\u043d.36",
    "country": "Finland"
  },
  {
    "Rank": "4930",
    "Name": "Alpha Group International",
    "Symbol": "ALPH.L",
    " marketcap ": " $1 221 082 116 ",
    "price (USD)": "28.6052",
    "country": "United Kingdom"
  },
  {
    "Rank": "4931",
    "Name": "Doha Bank",
    "Symbol": "DHBK.QA",
    " marketcap ": " $1 220 597 029 ",
    "price (USD)": "0.393681",
    "country": "Qatar"
  },
  {
    "Rank": "4932",
    "Name": "Alexander &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4933",
    "Name": "Suburban Propane Partners",
    "Symbol": "SPH",
    " marketcap ": " $1 216 872 064 ",
    "price (USD)": "19",
    "country": "United States"
  },
  {
    "Rank": "4934",
    "Name": "Humansoft Holding Company",
    "Symbol": "HUMANSOFT.KW",
    " marketcap ": " $1 216 646 362 ",
    "price (USD)": "9071.06",
    "country": "Kuwait"
  },
  {
    "Rank": "4935",
    "Name": "Aimco",
    "Symbol": "AIV",
    " marketcap ": " $1 216 546 816 ",
    "price (USD)": "08.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "4936",
    "Name": "Mixi",
    "Symbol": "2121.T",
    " marketcap ": " $1 215 839 874 ",
    "price (USD)": "17.2926",
    "country": "Japan"
  },
  {
    "Rank": "4937",
    "Name": "Mirum Pharmaceuticals",
    "Symbol": "MIRM",
    " marketcap ": " $1 215 560 064 ",
    "price (USD)": "25.79",
    "country": "United States"
  },
  {
    "Rank": "4938",
    "Name": "Safari Industries India",
    "Symbol": "SAFARI.NS",
    " marketcap ": " $1 213 423 077 ",
    "price (USD)": "24.882",
    "country": "India"
  },
  {
    "Rank": "4939",
    "Name": "AST SpaceMobile",
    "Symbol": "ASTS",
    " marketcap ": " $1 212 975 744 ",
    "price (USD)": "\u0430\u043f\u0440.71",
    "country": "United States"
  },
  {
    "Rank": "4940",
    "Name": "Yanbu Cement Company",
    "Symbol": "3060.SR",
    " marketcap ": " $1 212 573 072 ",
    "price (USD)": "7.69888",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4941",
    "Name": "Peloton",
    "Symbol": "PTON",
    " marketcap ": " $1 212 561 792 ",
    "price (USD)": "\u043c\u0430\u0440.27",
    "country": "United States"
  },
  {
    "Rank": "4942",
    "Name": "Sanoma",
    "Symbol": "SANOMA.HE",
    " marketcap ": " $1 210 714 875 ",
    "price (USD)": "\u0438\u044e\u043b.58",
    "country": "Finland"
  },
  {
    "Rank": "4943",
    "Name": "Shikun &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "4944",
    "Name": "U.S. Silica",
    "Symbol": "SLCA",
    " marketcap ": " $1 209 526 656 ",
    "price (USD)": "15.48",
    "country": "United States"
  },
  {
    "Rank": "4945",
    "Name": "Sheela Foam",
    "Symbol": "SFL.NS",
    " marketcap ": " $1 209 356 360 ",
    "price (USD)": "11.1142",
    "country": "India"
  },
  {
    "Rank": "4946",
    "Name": "Truecaller",
    "Symbol": "TRUE-B.ST",
    " marketcap ": " $1 206 753 441 ",
    "price (USD)": "3.47828",
    "country": "Sweden"
  },
  {
    "Rank": "4947",
    "Name": "Mechel PAO",
    "Symbol": "MTL",
    " marketcap ": " $1 206 171 008 ",
    "price (USD)": "\u0444\u0435\u0432.25",
    "country": "Russia"
  },
  {
    "Rank": "4948",
    "Name": "Universal Logistics Holdings",
    "Symbol": "ULH",
    " marketcap ": " $1 205 332 352 ",
    "price (USD)": "45.8",
    "country": "United States"
  },
  {
    "Rank": "4949",
    "Name": "PNE AG",
    "Symbol": "PNE3.DE",
    " marketcap ": " $1 203 611 702 ",
    "price (USD)": "15.7672",
    "country": "Germany"
  },
  {
    "Rank": "4950",
    "Name": "NovaGold Resources",
    "Symbol": "NG",
    " marketcap ": " $1 202 536 576 ",
    "price (USD)": "\u043c\u0430\u0440.57",
    "country": "Canada"
  },
  {
    "Rank": "4951",
    "Name": "Iguatemi",
    "Symbol": "IGTI3.SA",
    " marketcap ": " $1 202 294 542 ",
    "price (USD)": "0.577843",
    "country": "Brazil"
  },
  {
    "Rank": "4952",
    "Name": "Doosan Fuel Cell",
    "Symbol": "336260.KS",
    " marketcap ": " $1 202 258 626 ",
    "price (USD)": "18.3599",
    "country": "South Korea"
  },
  {
    "Rank": "4953",
    "Name": "Shinsegae",
    "Symbol": "004170.KS",
    " marketcap ": " $1 201 675 489 ",
    "price (USD)": "127.345",
    "country": "South Korea"
  },
  {
    "Rank": "4954",
    "Name": "Lemonade",
    "Symbol": "LMND",
    " marketcap ": " $1 200 642 304 ",
    "price (USD)": "17.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "4955",
    "Name": "PCBL Limited",
    "Symbol": "PCBL.NS",
    " marketcap ": " $1 200 279 576 ",
    "price (USD)": "3.17866",
    "country": "India"
  },
  {
    "Rank": "4956",
    "Name": "MediaAlpha",
    "Symbol": "MAX",
    " marketcap ": " $1 198 129 920 ",
    "price (USD)": "18.26",
    "country": "United States"
  },
  {
    "Rank": "4957",
    "Name": "Jungfraubahn Holding AG",
    "Symbol": "JFN.SW",
    " marketcap ": " $1 198 001 260 ",
    "price (USD)": "214.417",
    "country": "Switzerland"
  },
  {
    "Rank": "4958",
    "Name": "B\u0413\u00a9n\u0413\u00a9teau",
    "Symbol": "BEN.PA",
    " marketcap ": " $1 197 816 467 ",
    "price (USD)": "14.4641",
    "country": "France"
  },
  {
    "Rank": "4959",
    "Name": "Corsair Gaming",
    "Symbol": "CRSR",
    " marketcap ": " $1 196 997 120 ",
    "price (USD)": "\u043d\u043e\u044f.52",
    "country": "United States"
  },
  {
    "Rank": "4960",
    "Name": "Perfect Presentation for Commercial Services CompanyPerfect Presentation for Commercial Services",
    "Symbol": "7204.SR",
    " marketcap ": " $1 194 860 274 ",
    "price (USD)": "7.96574",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "4961",
    "Name": "Arlo Technologies",
    "Symbol": "ARLO",
    " marketcap ": " $1 192 419 072 ",
    "price (USD)": "\u0434\u0435\u043a.22",
    "country": "United States"
  },
  {
    "Rank": "4962",
    "Name": "Pakuwon Jati Tbk",
    "Symbol": "PWON.JK",
    " marketcap ": " $1 192 397 305 ",
    "price (USD)": "0.0247593",
    "country": "Indonesia"
  },
  {
    "Rank": "4963",
    "Name": "PennyMac Mortgage Investment Trust",
    "Symbol": "PMT",
    " marketcap ": " $1 192 387 328 ",
    "price (USD)": "13.73",
    "country": "United States"
  },
  {
    "Rank": "4964",
    "Name": "Bank Dhofar",
    "Symbol": "BKDB.OM",
    " marketcap ": " $1 191 067 212 ",
    "price (USD)": "0.397506",
    "country": "Oman"
  },
  {
    "Rank": "4965",
    "Name": "CRA International",
    "Symbol": "CRAI",
    " marketcap ": " $1 190 727 936 ",
    "price (USD)": "172.18",
    "country": "United States"
  },
  {
    "Rank": "4966",
    "Name": "Thermon Group",
    "Symbol": "THR",
    " marketcap ": " $1 190 466 048 ",
    "price (USD)": "35.31",
    "country": "United States"
  },
  {
    "Rank": "4967",
    "Name": "Scandinavian Tobacco Group",
    "Symbol": "STG.CO",
    " marketcap ": " $1 190 234 614 ",
    "price (USD)": "14.2449",
    "country": "Denmark"
  },
  {
    "Rank": "4968",
    "Name": "Nagarro",
    "Symbol": "NA9.DE",
    " marketcap ": " $1 189 117 220 ",
    "price (USD)": "89.1519",
    "country": "Germany"
  },
  {
    "Rank": "4969",
    "Name": "Opera",
    "Symbol": "OPRA",
    " marketcap ": " $1 188 821 760 ",
    "price (USD)": "13.44",
    "country": "Norway"
  },
  {
    "Rank": "4970",
    "Name": "Mavi Giyim Sanayi ve Ticaret",
    "Symbol": "MAVI.IS",
    " marketcap ": " $1 187 087 421 ",
    "price (USD)": "2.98822",
    "country": "Turkey"
  },
  {
    "Rank": "4971",
    "Name": "Enghouse Systems",
    "Symbol": "ENGH.TO",
    " marketcap ": " $1 185 611 179 ",
    "price (USD)": "21.4011",
    "country": "Canada"
  },
  {
    "Rank": "4972",
    "Name": "Gold Road Resources",
    "Symbol": "GOR.AX",
    " marketcap ": " $1 184 704 492 ",
    "price (USD)": "1.09357",
    "country": "Australia"
  },
  {
    "Rank": "4973",
    "Name": "Indiabulls Housing Finance",
    "Symbol": "IBULHSGFIN.NS",
    " marketcap ": " $1 183 931 699 ",
    "price (USD)": "1.99815",
    "country": "India"
  },
  {
    "Rank": "4974",
    "Name": "Sprott Inc",
    "Symbol": "SII",
    " marketcap ": " $1 183 623 168 ",
    "price (USD)": "46.57",
    "country": "Canada"
  },
  {
    "Rank": "4975",
    "Name": "Veritex Holdings",
    "Symbol": "VBTX",
    " marketcap ": " $1 182 656 000 ",
    "price (USD)": "21.69",
    "country": "United States"
  },
  {
    "Rank": "4976",
    "Name": "Birchcliff Energy",
    "Symbol": "BIR.TO",
    " marketcap ": " $1 178 958 126 ",
    "price (USD)": "4.38432",
    "country": "Canada"
  },
  {
    "Rank": "4977",
    "Name": "Model N",
    "Symbol": "MODN",
    " marketcap ": " $1 175 593 856 ",
    "price (USD)": "29.82",
    "country": "United States"
  },
  {
    "Rank": "4978",
    "Name": "Fastly",
    "Symbol": "FSLY",
    " marketcap ": " $1 174 949 248 ",
    "price (USD)": "08.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "4979",
    "Name": "S\u0413\u045aSS MicroTec",
    "Symbol": "SMHN.DE",
    " marketcap ": " $1 174 869 454 ",
    "price (USD)": "61.4616",
    "country": "Germany"
  },
  {
    "Rank": "4980",
    "Name": "Perimeter Solutions",
    "Symbol": "PRM",
    " marketcap ": " $1 173 539 200 ",
    "price (USD)": "08.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "4981",
    "Name": "MiMedx Group",
    "Symbol": "MDXG",
    " marketcap ": " $1 173 451 776 ",
    "price (USD)": "\u0438\u044e\u043b.95",
    "country": "United States"
  },
  {
    "Rank": "4982",
    "Name": "tuya",
    "Symbol": "TUYA",
    " marketcap ": " $1 172 169 728 ",
    "price (USD)": "02.\u0430\u043f\u0440",
    "country": "China"
  },
  {
    "Rank": "4983",
    "Name": "Espressif Systems (Shanghai)",
    "Symbol": "688018.SS",
    " marketcap ": " $1 171 526 626 ",
    "price (USD)": "\u043e\u043a\u0442.13",
    "country": "China"
  },
  {
    "Rank": "4984",
    "Name": "Safety Insurance",
    "Symbol": "SAFT",
    " marketcap ": " $1 171 201 280 ",
    "price (USD)": "78.94",
    "country": "United States"
  },
  {
    "Rank": "4985",
    "Name": "YOOZOO Interactive",
    "Symbol": "002174.SZ",
    " marketcap ": " $1 170 277 763 ",
    "price (USD)": "1.27775",
    "country": "China"
  },
  {
    "Rank": "4986",
    "Name": "National Bank of Oman",
    "Symbol": "NBOB.OM",
    " marketcap ": " $1 170 140 661 ",
    "price (USD)": "0.719667",
    "country": "Oman"
  },
  {
    "Rank": "4987",
    "Name": "Trustpilot Group",
    "Symbol": "TRST.L",
    " marketcap ": " $1 169 187 821 ",
    "price (USD)": "2.81602",
    "country": "Denmark"
  },
  {
    "Rank": "4988",
    "Name": "Genius Sports",
    "Symbol": "GENI",
    " marketcap ": " $1 168 740 608 ",
    "price (USD)": "\u043c\u0430\u0439.54",
    "country": "United Kingdom"
  },
  {
    "Rank": "4989",
    "Name": "PolyPeptide Group",
    "Symbol": "PPGN.SW",
    " marketcap ": " $1 168 553 858 ",
    "price (USD)": "35.4435",
    "country": "Switzerland"
  },
  {
    "Rank": "4990",
    "Name": "Andlauer Healthcare Group",
    "Symbol": "AND.TO",
    " marketcap ": " $1 166 443 134 ",
    "price (USD)": "28.2268",
    "country": "Canada"
  },
  {
    "Rank": "4991",
    "Name": "CAMGSM Plc. (Cellcard)",
    "Symbol": "CGSM.KH",
    " marketcap ": " $1 166 404 920 ",
    "price (USD)": "0.6",
    "country": "Cambodia"
  },
  {
    "Rank": "4992",
    "Name": "Amplitude",
    "Symbol": "AMPL",
    " marketcap ": " $1 164 800 000 ",
    "price (USD)": "\u0441\u0435\u043d.56",
    "country": "United States"
  },
  {
    "Rank": "4993",
    "Name": "Prothena",
    "Symbol": "PRTA",
    " marketcap ": " $1 164 159 488 ",
    "price (USD)": "21.65",
    "country": "Ireland"
  },
  {
    "Rank": "4994",
    "Name": "Deep Yellow",
    "Symbol": "DYL.AX",
    " marketcap ": " $1 163 280 913 ",
    "price (USD)": "1.20026",
    "country": "Australia"
  },
  {
    "Rank": "4995",
    "Name": "CEAT",
    "Symbol": "CEATLTD.NS",
    " marketcap ": " $1 162 587 437 ",
    "price (USD)": "28.7413",
    "country": "India"
  },
  {
    "Rank": "4996",
    "Name": "MRC Global",
    "Symbol": "MRC",
    " marketcap ": " $1 162 078 080 ",
    "price (USD)": "13.66",
    "country": "United States"
  },
  {
    "Rank": "4997",
    "Name": "Pigeon",
    "Symbol": "7956.T",
    " marketcap ": " $1 161 012 224 ",
    "price (USD)": "9.70827",
    "country": "Japan"
  },
  {
    "Rank": "4998",
    "Name": "Shoals Technologies",
    "Symbol": "SHLS",
    " marketcap ": " $1 158 856 064 ",
    "price (USD)": "06.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "4999",
    "Name": "First Watch Restaurant",
    "Symbol": "FWRG",
    " marketcap ": " $1 157 340 800 ",
    "price (USD)": "19.17",
    "country": "United States"
  },
  {
    "Rank": "5000",
    "Name": "Sabre",
    "Symbol": "SABR",
    " marketcap ": " $1 153 434 624 ",
    "price (USD)": "03.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "5001",
    "Name": "Target Hospitality",
    "Symbol": "TH",
    " marketcap ": " $1 153 185 536 ",
    "price (USD)": "11.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5002",
    "Name": "Union Coop",
    "Symbol": "UNIONCOOP.AE",
    " marketcap ": " $1 152 812 952 ",
    "price (USD)": "0.65347",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5003",
    "Name": "PubMatic",
    "Symbol": "PUBM",
    " marketcap ": " $1 152 407 424 ",
    "price (USD)": "23.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "5004",
    "Name": "Boubyan Petrochemical Company",
    "Symbol": "BPCC.KW",
    " marketcap ": " $1 151 441 982 ",
    "price (USD)": "2157.76",
    "country": "Kuwait"
  },
  {
    "Rank": "5005",
    "Name": "SSR Mining",
    "Symbol": "SSRM",
    " marketcap ": " $1 151 010 048 ",
    "price (USD)": "\u043c\u0430\u0439.67",
    "country": "Canada"
  },
  {
    "Rank": "5006",
    "Name": "Praj Industries",
    "Symbol": "PRAJIND.NS",
    " marketcap ": " $1 150 197 217 ",
    "price (USD)": "6.24317",
    "country": "India"
  },
  {
    "Rank": "5007",
    "Name": "Ferroglobe",
    "Symbol": "GSM",
    " marketcap ": " $1 146 098 432 ",
    "price (USD)": "06.\u044f\u043d\u0432",
    "country": "United Kingdom"
  },
  {
    "Rank": "5008",
    "Name": "Triumph Group",
    "Symbol": "TGI",
    " marketcap ": " $1 146 073 472 ",
    "price (USD)": "14.91",
    "country": "United States"
  },
  {
    "Rank": "5009",
    "Name": "NWTN Inc.",
    "Symbol": "NWTN",
    " marketcap ": " $1 144 748 032 ",
    "price (USD)": "4",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5010",
    "Name": "Claros Mortgage Trust",
    "Symbol": "CMTG",
    " marketcap ": " $1 144 662 784 ",
    "price (USD)": "\u0430\u0432\u0433.25",
    "country": "United States"
  },
  {
    "Rank": "5011",
    "Name": "Guaranty Trust Bank",
    "Symbol": "9JO.F",
    " marketcap ": " $1 144 130 524 ",
    "price (USD)": "1.94375",
    "country": "Nigeria"
  },
  {
    "Rank": "5012",
    "Name": "Ecovyst",
    "Symbol": "ECVT",
    " marketcap ": " $1 143 138 944 ",
    "price (USD)": "\u0441\u0435\u043d.77",
    "country": "United States"
  },
  {
    "Rank": "5013",
    "Name": "Himax",
    "Symbol": "HIMX",
    " marketcap ": " $1 142 694 912 ",
    "price (USD)": "\u0438\u044e\u043d.54",
    "country": "Taiwan"
  },
  {
    "Rank": "5014",
    "Name": "Arvind",
    "Symbol": "ARVIND.NS",
    " marketcap ": " $1 142 525 122 ",
    "price (USD)": "4.36157",
    "country": "India"
  },
  {
    "Rank": "5015",
    "Name": "Unipar Carbocloro",
    "Symbol": "UNIP6.SA",
    " marketcap ": " $1 140 068 126 ",
    "price (USD)": "9.87799",
    "country": "Brazil"
  },
  {
    "Rank": "5016",
    "Name": "Ferretti",
    "Symbol": "F3T1.F",
    " marketcap ": " $1 138 073 867 ",
    "price (USD)": "3.17081",
    "country": "Italy"
  },
  {
    "Rank": "5017",
    "Name": "First Milling Company",
    "Symbol": "2283.SR",
    " marketcap ": " $1 137 459 039 ",
    "price (USD)": "20.4948",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5018",
    "Name": "Banco Latinoamericano de Comercio Exterior",
    "Symbol": "BLX",
    " marketcap ": " $1 137 121 664 ",
    "price (USD)": "31.\u0434\u0435\u043a",
    "country": "Panama"
  },
  {
    "Rank": "5019",
    "Name": "Ottogi",
    "Symbol": "007310.KS",
    " marketcap ": " $1 136 626 177 ",
    "price (USD)": "330.479",
    "country": "South Korea"
  },
  {
    "Rank": "5020",
    "Name": "Siam City Cement (INSEE)",
    "Symbol": "SCCC.BK",
    " marketcap ": " $1 134 840 141 ",
    "price (USD)": "3.80819",
    "country": "Thailand"
  },
  {
    "Rank": "5021",
    "Name": "Playa Hotels &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5022",
    "Name": "Manitou Group",
    "Symbol": "MTU.PA",
    " marketcap ": " $1 134 469 254 ",
    "price (USD)": "29.6449",
    "country": "France"
  },
  {
    "Rank": "5023",
    "Name": "Advantage Solutions",
    "Symbol": "ADV",
    " marketcap ": " $1 134 073 600 ",
    "price (USD)": "\u043c\u0430\u0440.52",
    "country": "United States"
  },
  {
    "Rank": "5024",
    "Name": "Toagosei",
    "Symbol": "4045.T",
    " marketcap ": " $1 133 737 072 ",
    "price (USD)": "9.98017",
    "country": "Japan"
  },
  {
    "Rank": "5025",
    "Name": "Fresh Del Monte Produce",
    "Symbol": "FDP",
    " marketcap ": " $1 132 313 472 ",
    "price (USD)": "23.64",
    "country": "Cayman Islands"
  },
  {
    "Rank": "5026",
    "Name": "AbCellera",
    "Symbol": "ABCL",
    " marketcap ": " $1 132 107 904 ",
    "price (USD)": "\u043c\u0430\u0440.85",
    "country": "Canada"
  },
  {
    "Rank": "5027",
    "Name": "Kinepolis Group",
    "Symbol": "KIN.BR",
    " marketcap ": " $1 131 931 702 ",
    "price (USD)": "42.3499",
    "country": "Belgium"
  },
  {
    "Rank": "5028",
    "Name": "Cymbria",
    "Symbol": "CYB.TO",
    " marketcap ": " $1 131 497 196 ",
    "price (USD)": "51.9081",
    "country": "Canada"
  },
  {
    "Rank": "5029",
    "Name": "GB Group (GBG)",
    "Symbol": "GBG.L",
    " marketcap ": " $1 130 403 855 ",
    "price (USD)": "4.48082",
    "country": "United Kingdom"
  },
  {
    "Rank": "5030",
    "Name": "Grendene",
    "Symbol": "GRND3.SA",
    " marketcap ": " $1 128 910 674 ",
    "price (USD)": "1.24549",
    "country": "Brazil"
  },
  {
    "Rank": "5031",
    "Name": "Al Moammar Information Systems",
    "Symbol": "7200.SR",
    " marketcap ": " $1 128 812 779 ",
    "price (USD)": "37.6271",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5032",
    "Name": "Collegium Pharmaceutical",
    "Symbol": "COLL",
    " marketcap ": " $1 128 677 888 ",
    "price (USD)": "34.5",
    "country": "United States"
  },
  {
    "Rank": "5033",
    "Name": "Nexus AG",
    "Symbol": "NXU.DE",
    " marketcap ": " $1 127 170 307 ",
    "price (USD)": "65.2622",
    "country": "Germany"
  },
  {
    "Rank": "5034",
    "Name": "Loma Negra",
    "Symbol": "LOMA",
    " marketcap ": " $1 126 572 672 ",
    "price (USD)": "\u0438\u044e\u043b.28",
    "country": "Argentina"
  },
  {
    "Rank": "5035",
    "Name": "A10 Networks",
    "Symbol": "ATEN",
    " marketcap ": " $1 126 507 136 ",
    "price (USD)": "15.13",
    "country": "United States"
  },
  {
    "Rank": "5036",
    "Name": "Archer Aviation",
    "Symbol": "ACHR",
    " marketcap ": " $1 125 981 952 ",
    "price (USD)": "\u043c\u0430\u0440.48",
    "country": "United States"
  },
  {
    "Rank": "5037",
    "Name": "Saudi Automotive Services Company",
    "Symbol": "4050.SR",
    " marketcap ": " $1 124 009 218 ",
    "price (USD)": "18.7335",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5038",
    "Name": "Herbalife",
    "Symbol": "HLF",
    " marketcap ": " $1 122 636 160 ",
    "price (USD)": "\u043d\u043e\u044f.23",
    "country": "United States"
  },
  {
    "Rank": "5039",
    "Name": "Fincantieri",
    "Symbol": "FCT.MI",
    " marketcap ": " $1 122 338 443 ",
    "price (USD)": "0.663481",
    "country": "Italy"
  },
  {
    "Rank": "5040",
    "Name": "Mercialys",
    "Symbol": "MERY.PA",
    " marketcap ": " $1 122 185 201 ",
    "price (USD)": "\u043d\u043e\u044f.91",
    "country": "France"
  },
  {
    "Rank": "5041",
    "Name": "Compa\u0413\u00b1\u0413\u00ada de Acero del Pac\u0413\u00adfico",
    "Symbol": "CAP.SN",
    " marketcap ": " $1 121 701 482 ",
    "price (USD)": "7.50563",
    "country": "Chile"
  },
  {
    "Rank": "5042",
    "Name": "Mahindra Lifespaces",
    "Symbol": "MAHLIFE.NS",
    " marketcap ": " $1 119 264 239 ",
    "price (USD)": "\u0438\u044e\u043b.92",
    "country": "India"
  },
  {
    "Rank": "5043",
    "Name": "Custom Truck One Source",
    "Symbol": "CTOS",
    " marketcap ": " $1 117 943 680 ",
    "price (USD)": "\u0430\u043f\u0440.65",
    "country": "United States"
  },
  {
    "Rank": "5044",
    "Name": "Cera Sanitaryware",
    "Symbol": "CERA.NS",
    " marketcap ": " $1 117 568 789 ",
    "price (USD)": "85.8658",
    "country": "India"
  },
  {
    "Rank": "5045",
    "Name": "Foran Mining",
    "Symbol": "FOM.TO",
    " marketcap ": " $1 116 946 985 ",
    "price (USD)": "3.35056",
    "country": "Canada"
  },
  {
    "Rank": "5046",
    "Name": "TriMas",
    "Symbol": "TRS",
    " marketcap ": " $1 116 499 712 ",
    "price (USD)": "27.41",
    "country": "United States"
  },
  {
    "Rank": "5047",
    "Name": "AS ONE Corporation",
    "Symbol": "7476.T",
    " marketcap ": " $1 116 439 484 ",
    "price (USD)": "15.5908",
    "country": "Japan"
  },
  {
    "Rank": "5048",
    "Name": "Kura Sushi USA",
    "Symbol": "KRUS",
    " marketcap ": " $1 115 994 752 ",
    "price (USD)": "99.37",
    "country": "United States"
  },
  {
    "Rank": "5049",
    "Name": "Docebo",
    "Symbol": "DCBO",
    " marketcap ": " $1 115 683 840 ",
    "price (USD)": "36.63",
    "country": "Canada"
  },
  {
    "Rank": "5050",
    "Name": "Silence Therapeutics",
    "Symbol": "SLN",
    " marketcap ": " $1 115 638 144 ",
    "price (USD)": "23.91",
    "country": "United Kingdom"
  },
  {
    "Rank": "5051",
    "Name": "Sally Beauty Holdings",
    "Symbol": "SBH",
    " marketcap ": " $1 113 810 688 ",
    "price (USD)": "\u043e\u043a\u0442.76",
    "country": "United States"
  },
  {
    "Rank": "5052",
    "Name": "Air New Zealand",
    "Symbol": "ANZFF",
    " marketcap ": " $1 110 901 888 ",
    "price (USD)": "0.32014",
    "country": "New Zealand"
  },
  {
    "Rank": "5053",
    "Name": "Paramount Group",
    "Symbol": "PGRE",
    " marketcap ": " $1 110 868 096 ",
    "price (USD)": "\u0430\u043f\u0440.68",
    "country": "United States"
  },
  {
    "Rank": "5054",
    "Name": "SPIMACO (Saudi Pharmaceutical Industries and Medical Appliances Corporation)",
    "Symbol": "2070.SR",
    " marketcap ": " $1 110 538 493 ",
    "price (USD)": "9.27334",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5055",
    "Name": "Modern Times Group (MTG)",
    "Symbol": "MTG-B.ST",
    " marketcap ": " $1 110 065 190 ",
    "price (USD)": "9.15435",
    "country": "Sweden"
  },
  {
    "Rank": "5056",
    "Name": "Red 5 Limited",
    "Symbol": "RED.AX",
    " marketcap ": " $1 108 652 513 ",
    "price (USD)": "0.320068",
    "country": "Australia"
  },
  {
    "Rank": "5057",
    "Name": "Pharvaris",
    "Symbol": "PHVS",
    " marketcap ": " $1 107 547 648 ",
    "price (USD)": "20.58",
    "country": "Netherlands"
  },
  {
    "Rank": "5058",
    "Name": "MFA Financial",
    "Symbol": "MFA",
    " marketcap ": " $1 106 568 832 ",
    "price (USD)": "\u043e\u043a\u0442.84",
    "country": "United States"
  },
  {
    "Rank": "5059",
    "Name": "Energy Fuels",
    "Symbol": "UUUU",
    " marketcap ": " $1 103 014 400 ",
    "price (USD)": "\u0438\u044e\u043d.74",
    "country": "United States"
  },
  {
    "Rank": "5060",
    "Name": "Bangkok Airways",
    "Symbol": "BA.BK",
    " marketcap ": " $1 102 862 418 ",
    "price (USD)": "0.525173",
    "country": "Thailand"
  },
  {
    "Rank": "5061",
    "Name": "Grenke",
    "Symbol": "GLJ.F",
    " marketcap ": " $1 101 509 150 ",
    "price (USD)": "23.8354",
    "country": "Germany"
  },
  {
    "Rank": "5062",
    "Name": "Fortune REIT",
    "Symbol": "0778.HK",
    " marketcap ": " $1 100 756 600 ",
    "price (USD)": "0.544597",
    "country": "Hong Kong"
  },
  {
    "Rank": "5063",
    "Name": "National Bank of Umm Al Qaiwain",
    "Symbol": "NBQ.AE",
    " marketcap ": " $1 100 008 168 ",
    "price (USD)": "0.55",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5064",
    "Name": "MDA Ltd.",
    "Symbol": "MDA.TO",
    " marketcap ": " $1 099 296 977 ",
    "price (USD)": "9.17189",
    "country": "Canada"
  },
  {
    "Rank": "5065",
    "Name": "Piaggio",
    "Symbol": "PIA.MI",
    " marketcap ": " $1 098 458 638 ",
    "price (USD)": "3.07525",
    "country": "Italy"
  },
  {
    "Rank": "5066",
    "Name": "UMH Properties",
    "Symbol": "UMH",
    " marketcap ": " $1 098 305 536 ",
    "price (USD)": "15.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "5067",
    "Name": "Paysafe",
    "Symbol": "PSFE",
    " marketcap ": " $1 098 169 856 ",
    "price (USD)": "18.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5068",
    "Name": "HPH Trust (Hutchison Port)",
    "Symbol": "NS8U.SI",
    " marketcap ": " $1 097 598 720 ",
    "price (USD)": "0.126",
    "country": "Singapore"
  },
  {
    "Rank": "5069",
    "Name": "Arcutis Biotherapeutics",
    "Symbol": "ARQT",
    " marketcap ": " $1 097 442 688 ",
    "price (USD)": "\u0441\u0435\u043d.48",
    "country": "United States"
  },
  {
    "Rank": "5070",
    "Name": "MIRAIT ONE Corporation",
    "Symbol": "1417.T",
    " marketcap ": " $1 097 441 967 ",
    "price (USD)": "\u043d\u043e\u044f.26",
    "country": "Japan"
  },
  {
    "Rank": "5071",
    "Name": "Retail Estates NV",
    "Symbol": "RET.BR",
    " marketcap ": " $1 097 409 856 ",
    "price (USD)": "76.3384",
    "country": "Belgium"
  },
  {
    "Rank": "5072",
    "Name": "GFH Financial Group",
    "Symbol": "GFH.AE",
    " marketcap ": " $1 095 712 563 ",
    "price (USD)": "0.29",
    "country": "Bahrain"
  },
  {
    "Rank": "5073",
    "Name": "Immatics",
    "Symbol": "IMTX",
    " marketcap ": " $1 095 453 440 ",
    "price (USD)": "\u043e\u043a\u0442.63",
    "country": "Germany"
  },
  {
    "Rank": "5074",
    "Name": "Craftsman Automation",
    "Symbol": "CRAFTSMAN.NS",
    " marketcap ": " $1 092 501 723 ",
    "price (USD)": "51.708",
    "country": "India"
  },
  {
    "Rank": "5075",
    "Name": "Oakley Capital Investments",
    "Symbol": "OCI.L",
    " marketcap ": " $1 090 935 520 ",
    "price (USD)": "6.18381",
    "country": "Bermuda"
  },
  {
    "Rank": "5076",
    "Name": "Hangzhou Shunwang Technology",
    "Symbol": "300113.SZ",
    " marketcap ": " $1 087 565 713 ",
    "price (USD)": "1.56645",
    "country": "China"
  },
  {
    "Rank": "5077",
    "Name": "Scatec ASA",
    "Symbol": "SCATC.OL",
    " marketcap ": " $1 086 812 204 ",
    "price (USD)": "6.83887",
    "country": "Norway"
  },
  {
    "Rank": "5078",
    "Name": "AtriCure",
    "Symbol": "ATRC",
    " marketcap ": " $1 086 182 656 ",
    "price (USD)": "22.45",
    "country": "United States"
  },
  {
    "Rank": "5079",
    "Name": "Quanex Building Products",
    "Symbol": "NX",
    " marketcap ": " $1 085 398 144 ",
    "price (USD)": "32.78",
    "country": "United States"
  },
  {
    "Rank": "5080",
    "Name": "Sandy Spring Bank",
    "Symbol": "SASR",
    " marketcap ": " $1 085 078 528 ",
    "price (USD)": "24.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "5081",
    "Name": "Iris Energy",
    "Symbol": "IREN",
    " marketcap ": " $1 084 721 664 ",
    "price (USD)": "07.\u0430\u043f\u0440",
    "country": "Australia"
  },
  {
    "Rank": "5082",
    "Name": "Westshore Terminals Investment",
    "Symbol": "WTE.TO",
    " marketcap ": " $1 084 583 288 ",
    "price (USD)": "17.3687",
    "country": "Canada"
  },
  {
    "Rank": "5083",
    "Name": "edenor",
    "Symbol": "EDN",
    " marketcap ": " $1 084 555 392 ",
    "price (USD)": "18.\u043d\u043e\u044f",
    "country": "Argentina"
  },
  {
    "Rank": "5084",
    "Name": "Pilot Corporation",
    "Symbol": "7846.T",
    " marketcap ": " $1 083 716 450 ",
    "price (USD)": "27.4711",
    "country": "Japan"
  },
  {
    "Rank": "5085",
    "Name": "Arezzo Ind\u0413\u0454stria e Com\u0413\u00a9rcio",
    "Symbol": "ARZZ3.SA",
    " marketcap ": " $1 082 612 181 ",
    "price (USD)": "9.75695",
    "country": "Brazil"
  },
  {
    "Rank": "5086",
    "Name": "Energiekontor",
    "Symbol": "EKT.DE",
    " marketcap ": " $1 082 452 731 ",
    "price (USD)": "77.8586",
    "country": "Germany"
  },
  {
    "Rank": "5087",
    "Name": "SMART Global Holdings",
    "Symbol": "SGH",
    " marketcap ": " $1 082 024 960 ",
    "price (USD)": "20.69",
    "country": "United States"
  },
  {
    "Rank": "5088",
    "Name": "IHS Towers",
    "Symbol": "IHS",
    " marketcap ": " $1 081 821 056 ",
    "price (USD)": "\u043c\u0430\u0440.25",
    "country": "United Kingdom"
  },
  {
    "Rank": "5089",
    "Name": "Electrica",
    "Symbol": "ECEA.F",
    " marketcap ": " $1 080 701 540 ",
    "price (USD)": "11.0761",
    "country": "Romania"
  },
  {
    "Rank": "5090",
    "Name": "Momo",
    "Symbol": "MOMO",
    " marketcap ": " $1 079 022 208 ",
    "price (USD)": "\u043c\u0430\u0439.83",
    "country": "China"
  },
  {
    "Rank": "5091",
    "Name": "NerdWallet",
    "Symbol": "NRDS",
    " marketcap ": " $1 079 002 112 ",
    "price (USD)": "13.88",
    "country": "United States"
  },
  {
    "Rank": "5092",
    "Name": "BMV (Bolsa Mexicana de Valores)",
    "Symbol": "BOLSAA.MX",
    " marketcap ": " $1 078 667 373 ",
    "price (USD)": "1.89682",
    "country": "Mexico"
  },
  {
    "Rank": "5093",
    "Name": "Quess",
    "Symbol": "QUESS.NS",
    " marketcap ": " $1 078 660 651 ",
    "price (USD)": "7.26327",
    "country": "India"
  },
  {
    "Rank": "5094",
    "Name": "SIMPAR",
    "Symbol": "SIMH3.SA",
    " marketcap ": " $1 078 245 213 ",
    "price (USD)": "1.22987",
    "country": "Brazil"
  },
  {
    "Rank": "5095",
    "Name": "Ironwood Pharmaceuticals",
    "Symbol": "IRWD",
    " marketcap ": " $1 077 728 384 ",
    "price (USD)": "\u0438\u044e\u043d.78",
    "country": "United States"
  },
  {
    "Rank": "5096",
    "Name": "Enliven Therapeutics",
    "Symbol": "ELVN",
    " marketcap ": " $1 077 140 352 ",
    "price (USD)": "22.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "5097",
    "Name": "CropEnergies",
    "Symbol": "CE2.F",
    " marketcap ": " $1 076 590 622 ",
    "price (USD)": "\u043d\u043e\u044f.89",
    "country": "Germany"
  },
  {
    "Rank": "5098",
    "Name": "Galaxy Surfactants",
    "Symbol": "GALAXYSURF.NS",
    " marketcap ": " $1 075 653 036 ",
    "price (USD)": "30.3387",
    "country": "India"
  },
  {
    "Rank": "5099",
    "Name": "Mishra Dhatu Nigam",
    "Symbol": "MIDHANI.NS",
    " marketcap ": " $1 075 167 385 ",
    "price (USD)": "5.73912",
    "country": "India"
  },
  {
    "Rank": "5100",
    "Name": "Bristow Group",
    "Symbol": "VTOL",
    " marketcap ": " $1 074 674 944 ",
    "price (USD)": "37.85",
    "country": "United States"
  },
  {
    "Rank": "5101",
    "Name": "NEUCA",
    "Symbol": "NEU.WA",
    " marketcap ": " $1 073 042 542 ",
    "price (USD)": "243.385",
    "country": "Poland"
  },
  {
    "Rank": "5102",
    "Name": "Riken Keiki",
    "Symbol": "7734.T",
    " marketcap ": " $1 072 664 613 ",
    "price (USD)": "23.0312",
    "country": "Japan"
  },
  {
    "Rank": "5103",
    "Name": "Tutor Perini",
    "Symbol": "TPC",
    " marketcap ": " $1 072 348 928 ",
    "price (USD)": "20.51",
    "country": "United States"
  },
  {
    "Rank": "5104",
    "Name": "Wolverine World Wide",
    "Symbol": "WWW",
    " marketcap ": " $1 070 243 968 ",
    "price (USD)": "13.39",
    "country": "United States"
  },
  {
    "Rank": "5105",
    "Name": "Wemade",
    "Symbol": "112040.KQ",
    " marketcap ": " $1 070 196 606 ",
    "price (USD)": "31.983",
    "country": "South Korea"
  },
  {
    "Rank": "5106",
    "Name": "Franklin BSP Realty Trust",
    "Symbol": "FBRT",
    " marketcap ": " $1 070 042 112 ",
    "price (USD)": "13.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5107",
    "Name": "SP Plus Corporation",
    "Symbol": "SP",
    " marketcap ": " $1 068 942 656 ",
    "price (USD)": "53.99",
    "country": "United States"
  },
  {
    "Rank": "5108",
    "Name": "ANGI Homeservices",
    "Symbol": "ANGI",
    " marketcap ": " $1 068 710 528 ",
    "price (USD)": "\u0444\u0435\u0432.13",
    "country": "United States"
  },
  {
    "Rank": "5109",
    "Name": "Varroc",
    "Symbol": "VARROC.NS",
    " marketcap ": " $1 068 513 839 ",
    "price (USD)": "6.98571",
    "country": "India"
  },
  {
    "Rank": "5110",
    "Name": "Cassava Sciences",
    "Symbol": "SAVA",
    " marketcap ": " $1 068 430 016 ",
    "price (USD)": "22.27",
    "country": "United States"
  },
  {
    "Rank": "5111",
    "Name": "Adecoagro",
    "Symbol": "AGRO",
    " marketcap ": " $1 068 425 152 ",
    "price (USD)": "\u043e\u043a\u0442.26",
    "country": "Luxembourg"
  },
  {
    "Rank": "5112",
    "Name": "Infibeam Avenues",
    "Symbol": "INFIBEAM.NS",
    " marketcap ": " $1 068 247 685 ",
    "price (USD)": "0.385692",
    "country": "India"
  },
  {
    "Rank": "5113",
    "Name": "Peoples Bancorp",
    "Symbol": "PEBO",
    " marketcap ": " $1 067 298 560 ",
    "price (USD)": "30.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5114",
    "Name": "Centerspace",
    "Symbol": "CSR",
    " marketcap ": " $1 066 372 864 ",
    "price (USD)": "67.68",
    "country": "United States"
  },
  {
    "Rank": "5115",
    "Name": "Rajesh Exports",
    "Symbol": "RAJESHEXPO.NS",
    " marketcap ": " $1 065 890 592 ",
    "price (USD)": "3.61001",
    "country": "India"
  },
  {
    "Rank": "5116",
    "Name": "ESAB India",
    "Symbol": "ESABINDIA.NS",
    " marketcap ": " $1 065 548 844 ",
    "price (USD)": "69.147",
    "country": "India"
  },
  {
    "Rank": "5117",
    "Name": "Cronos Group",
    "Symbol": "CRON",
    " marketcap ": " $1 065 450 048 ",
    "price (USD)": "\u0444\u0435\u0432.77",
    "country": "Canada"
  },
  {
    "Rank": "5118",
    "Name": "indie Semiconductor",
    "Symbol": "INDI",
    " marketcap ": " $1 064 503 424 ",
    "price (USD)": "\u0438\u044e\u043d.33",
    "country": "United States"
  },
  {
    "Rank": "5119",
    "Name": "Despegar",
    "Symbol": "DESP",
    " marketcap ": " $1 064 240 576 ",
    "price (USD)": "14.77",
    "country": "Argentina"
  },
  {
    "Rank": "5120",
    "Name": "Badger Infrastructure Solutions",
    "Symbol": "BDGI.TO",
    " marketcap ": " $1 063 053 068 ",
    "price (USD)": "30.8369",
    "country": "Canada"
  },
  {
    "Rank": "5121",
    "Name": "Altice USA",
    "Symbol": "ATUS",
    " marketcap ": " $1 062 512 128 ",
    "price (USD)": "\u0444\u0435\u0432.31",
    "country": "United States"
  },
  {
    "Rank": "5122",
    "Name": "ProPetro",
    "Symbol": "PUMP",
    " marketcap ": " $1 059 686 080 ",
    "price (USD)": "09.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "5123",
    "Name": "Eckert &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5124",
    "Name": "Employers Holdings",
    "Symbol": "EIG",
    " marketcap ": " $1 057 077 376 ",
    "price (USD)": "41.71",
    "country": "United States"
  },
  {
    "Rank": "5125",
    "Name": "Europris",
    "Symbol": "EPR.OL",
    " marketcap ": " $1 056 087 958 ",
    "price (USD)": "6.45424",
    "country": "Norway"
  },
  {
    "Rank": "5126",
    "Name": "DeNA",
    "Symbol": "2432.T",
    " marketcap ": " $1 055 024 167 ",
    "price (USD)": "9.47476",
    "country": "Japan"
  },
  {
    "Rank": "5127",
    "Name": "Marshalls plc",
    "Symbol": "MSLH.L",
    " marketcap ": " $1 054 460 557 ",
    "price (USD)": "\u0430\u043f\u0440.17",
    "country": "United Kingdom"
  },
  {
    "Rank": "5128",
    "Name": "HelloFresh",
    "Symbol": "HFG.DE",
    " marketcap ": " $1 051 675 813 ",
    "price (USD)": "6.14616",
    "country": "Germany"
  },
  {
    "Rank": "5129",
    "Name": "Arriyadh Development Company",
    "Symbol": "4150.SR",
    " marketcap ": " $1 051 306 393 ",
    "price (USD)": "5.91359",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5130",
    "Name": "HCI Group",
    "Symbol": "HCI",
    " marketcap ": " $1 050 992 448 ",
    "price (USD)": "100.32",
    "country": "United States"
  },
  {
    "Rank": "5131",
    "Name": "Shriram Pistons &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5132",
    "Name": "Preferred Bank",
    "Symbol": "PFBC",
    " marketcap ": " $1 049 318 016 ",
    "price (USD)": "78.35",
    "country": "United States"
  },
  {
    "Rank": "5133",
    "Name": "Bain Capital",
    "Symbol": "BCSF",
    " marketcap ": " $1 048 491 712 ",
    "price (USD)": "16.24",
    "country": "United States"
  },
  {
    "Rank": "5134",
    "Name": "Barings BDC",
    "Symbol": "BBDC",
    " marketcap ": " $1 047 855 424 ",
    "price (USD)": "\u0441\u0435\u043d.89",
    "country": "United States"
  },
  {
    "Rank": "5135",
    "Name": "Canadian Solar",
    "Symbol": "CSIQ",
    " marketcap ": " $1 047 366 592 ",
    "price (USD)": "15.83",
    "country": "Canada"
  },
  {
    "Rank": "5136",
    "Name": "EHang Holdings",
    "Symbol": "EH",
    " marketcap ": " $1 046 762 304 ",
    "price (USD)": "16.47",
    "country": "China"
  },
  {
    "Rank": "5137",
    "Name": "Encore Capital Group",
    "Symbol": "ECPG",
    " marketcap ": " $1 045 302 912 ",
    "price (USD)": "44.13",
    "country": "United States"
  },
  {
    "Rank": "5138",
    "Name": "Brim hf.",
    "Symbol": "BRIM.IC",
    " marketcap ": " $1 045 276 949 ",
    "price (USD)": "0.542888",
    "country": "Iceland"
  },
  {
    "Rank": "5139",
    "Name": "Byline Bancorp",
    "Symbol": "BY",
    " marketcap ": " $1 044 858 688 ",
    "price (USD)": "23.68",
    "country": "United States"
  },
  {
    "Rank": "5140",
    "Name": "Scholastic",
    "Symbol": "SCHL",
    " marketcap ": " $1 044 457 024 ",
    "price (USD)": "37.03",
    "country": "United States"
  },
  {
    "Rank": "5141",
    "Name": "Republic Bank",
    "Symbol": "RBCAA",
    " marketcap ": " $1 041 076 288 ",
    "price (USD)": "53.63",
    "country": "United States"
  },
  {
    "Rank": "5142",
    "Name": "Cracker Barrel",
    "Symbol": "CBRL",
    " marketcap ": " $1 041 009 536 ",
    "price (USD)": "46.89",
    "country": "United States"
  },
  {
    "Rank": "5143",
    "Name": "Vivid Seats",
    "Symbol": "SEAT",
    " marketcap ": " $1 040 336 576 ",
    "price (USD)": "05.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "5144",
    "Name": "IRSA Inversiones y Representaciones",
    "Symbol": "IRS",
    " marketcap ": " $1 040 153 856 ",
    "price (USD)": "11.\u0430\u0432\u0433",
    "country": "Argentina"
  },
  {
    "Rank": "5145",
    "Name": "Precision Drilling Corporation",
    "Symbol": "PDS",
    " marketcap ": " $1 038 260 416 ",
    "price (USD)": "71.71",
    "country": "Canada"
  },
  {
    "Rank": "5146",
    "Name": "AMAG Austria Metall",
    "Symbol": "AM8.F",
    " marketcap ": " $1 037 855 593 ",
    "price (USD)": "28.9934",
    "country": "Austria"
  },
  {
    "Rank": "5147",
    "Name": "Meiko Electronics",
    "Symbol": "6787.T",
    " marketcap ": " $1 036 979 755 ",
    "price (USD)": "40.4325",
    "country": "Japan"
  },
  {
    "Rank": "5148",
    "Name": "Mensch und Maschine",
    "Symbol": "MUM.F",
    " marketcap ": " $1 036 565 169 ",
    "price (USD)": "61.5702",
    "country": "Germany"
  },
  {
    "Rank": "5149",
    "Name": "GO (Etihad Atheeb Telecommunication Company)",
    "Symbol": "7040.SR",
    " marketcap ": " $1 036 156 260 ",
    "price (USD)": "30.4753",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5150",
    "Name": "Hovnanian Enterprises",
    "Symbol": "HOV",
    " marketcap ": " $1 035 196 416 ",
    "price (USD)": "169.1",
    "country": "United States"
  },
  {
    "Rank": "5151",
    "Name": "Mativ Holdings",
    "Symbol": "MATV",
    " marketcap ": " $1 034 849 280 ",
    "price (USD)": "19.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5152",
    "Name": "LendingClub",
    "Symbol": "LC",
    " marketcap ": " $1 034 527 232 ",
    "price (USD)": "\u0441\u0435\u043d.31",
    "country": "United States"
  },
  {
    "Rank": "5153",
    "Name": "Middlesex Water Company",
    "Symbol": "MSEX",
    " marketcap ": " $1 034 415 360 ",
    "price (USD)": "58.02",
    "country": "United States"
  },
  {
    "Rank": "5154",
    "Name": "Thoughtworks",
    "Symbol": "TWKS",
    " marketcap ": " $1 033 324 736 ",
    "price (USD)": "03.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "5155",
    "Name": "Magellan Financial Group",
    "Symbol": "MFG.AX",
    " marketcap ": " $1 032 882 450 ",
    "price (USD)": "5.71455",
    "country": "Australia"
  },
  {
    "Rank": "5156",
    "Name": "Network18",
    "Symbol": "NETWORK18.NS",
    " marketcap ": " $1 031 920 175 ",
    "price (USD)": "0.984056",
    "country": "India"
  },
  {
    "Rank": "5157",
    "Name": "IDT Corporation",
    "Symbol": "IDT",
    " marketcap ": " $1 031 752 064 ",
    "price (USD)": "40.64",
    "country": "United States"
  },
  {
    "Rank": "5158",
    "Name": "Hibbett Sports",
    "Symbol": "HIBB",
    " marketcap ": " $1 031 590 272 ",
    "price (USD)": "86.34",
    "country": "United States"
  },
  {
    "Rank": "5159",
    "Name": "Soho House & Co",
    "Symbol": "SHCO",
    " marketcap ": " $1 031 231 232 ",
    "price (USD)": "\u043c\u0430\u0439.25",
    "country": "United States"
  },
  {
    "Rank": "5160",
    "Name": "Elior Group",
    "Symbol": "ELIOR.PA",
    " marketcap ": " $1 030 856 249 ",
    "price (USD)": "3.82886",
    "country": "France"
  },
  {
    "Rank": "5161",
    "Name": "Autolus Therapeutics",
    "Symbol": "AUTL",
    " marketcap ": " $1 029 559 296 ",
    "price (USD)": "\u043c\u0430\u0440.87",
    "country": "United Kingdom"
  },
  {
    "Rank": "5162",
    "Name": "Kalpataru Power Transmission",
    "Symbol": "KALPATPOWR.NS",
    " marketcap ": " $1 029 335 063 ",
    "price (USD)": "\u0438\u044e\u043d.33",
    "country": "India"
  },
  {
    "Rank": "5163",
    "Name": "Bystronic AG",
    "Symbol": "BYS.SW",
    " marketcap ": " $1 025 661 187 ",
    "price (USD)": "495.989",
    "country": "Switzerland"
  },
  {
    "Rank": "5164",
    "Name": "TDCX",
    "Symbol": "TDCX",
    " marketcap ": " $1 025 557 696 ",
    "price (USD)": "07.\u0434\u0435\u043a",
    "country": "Singapore"
  },
  {
    "Rank": "5165",
    "Name": "Ellington Financial",
    "Symbol": "EFC",
    " marketcap ": " $1 024 754 944 ",
    "price (USD)": "12.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5166",
    "Name": "Equasens",
    "Symbol": "EQS.PA",
    " marketcap ": " $1 022 135 876 ",
    "price (USD)": "66.2395",
    "country": "France"
  },
  {
    "Rank": "5167",
    "Name": "Telia Lietuva",
    "Symbol": "ZWS.F",
    " marketcap ": " $1 021 739 950 ",
    "price (USD)": "1.69942",
    "country": "Lithuania"
  },
  {
    "Rank": "5168",
    "Name": "Origin Bancorp",
    "Symbol": "OBK",
    " marketcap ": " $1 021 630 784 ",
    "price (USD)": "32.94",
    "country": "United States"
  },
  {
    "Rank": "5169",
    "Name": "Vitasoy",
    "Symbol": "0345.HK",
    " marketcap ": " $1 021 405 598 ",
    "price (USD)": "0.952084",
    "country": "Hong Kong"
  },
  {
    "Rank": "5170",
    "Name": "Dalata Hotel Group",
    "Symbol": "DHG.IR",
    " marketcap ": " $1 019 914 814 ",
    "price (USD)": "4.54447",
    "country": "Ireland"
  },
  {
    "Rank": "5171",
    "Name": "Armada Hoffler Properties",
    "Symbol": "AHH",
    " marketcap ": " $1 018 338 752 ",
    "price (USD)": "\u043d\u043e\u044f.47",
    "country": "United States"
  },
  {
    "Rank": "5172",
    "Name": "Riverstone Holdings",
    "Symbol": "AP4.SI",
    " marketcap ": " $1 017 860 523 ",
    "price (USD)": "0.686737",
    "country": "Singapore"
  },
  {
    "Rank": "5173",
    "Name": "QuinStreet",
    "Symbol": "QNST",
    " marketcap ": " $1 017 645 888 ",
    "price (USD)": "18.41",
    "country": "United States"
  },
  {
    "Rank": "5174",
    "Name": "Jack in the Box",
    "Symbol": "JACK",
    " marketcap ": " $1 017 010 752 ",
    "price (USD)": "52.45",
    "country": "United States"
  },
  {
    "Rank": "5175",
    "Name": "Dr\u0413\u00a4gerwerk",
    "Symbol": "DRW8.F",
    " marketcap ": " $1 015 812 253 ",
    "price (USD)": "51.2542",
    "country": "Germany"
  },
  {
    "Rank": "5176",
    "Name": "Verona Pharma",
    "Symbol": "VRNA",
    " marketcap ": " $1 013 522 496 ",
    "price (USD)": "12.\u043c\u0430\u0439",
    "country": "United Kingdom"
  },
  {
    "Rank": "5177",
    "Name": "DNO ASA",
    "Symbol": "DNO.OL",
    " marketcap ": " $1 013 446 988 ",
    "price (USD)": "1.03943",
    "country": "Norway"
  },
  {
    "Rank": "5178",
    "Name": "HiteJinro",
    "Symbol": "000080.KS",
    " marketcap ": " $1 013 360 783 ",
    "price (USD)": "14.7614",
    "country": "South Korea"
  },
  {
    "Rank": "5179",
    "Name": "Liquidia Technologies",
    "Symbol": "LQDA",
    " marketcap ": " $1 012 070 848 ",
    "price (USD)": "13.25",
    "country": "United States"
  },
  {
    "Rank": "5180",
    "Name": "secunet",
    "Symbol": "YSN.F",
    " marketcap ": " $1 011 627 755 ",
    "price (USD)": "156.369",
    "country": "Germany"
  },
  {
    "Rank": "5181",
    "Name": "Bank ABC (Arab Banking Corporation)",
    "Symbol": "ABC.BH",
    " marketcap ": " $1 010 750 000 ",
    "price (USD)": "01.\u044f\u043d\u0432",
    "country": "Bahrain"
  },
  {
    "Rank": "5182",
    "Name": "Innoviva",
    "Symbol": "INVA",
    " marketcap ": " $1 008 483 520 ",
    "price (USD)": "16.15",
    "country": "United States"
  },
  {
    "Rank": "5183",
    "Name": "Jastrzebska Sp\u0413\u0456lka Weglowa",
    "Symbol": "JSW.WA",
    " marketcap ": " $1 008 419 083 ",
    "price (USD)": "8.58872",
    "country": "Poland"
  },
  {
    "Rank": "5184",
    "Name": "ChipMOS Technologies",
    "Symbol": "IMOS",
    " marketcap ": " $1 007 304 960 ",
    "price (USD)": "27.36",
    "country": "Taiwan"
  },
  {
    "Rank": "5185",
    "Name": "Zad Holding Company",
    "Symbol": "ZHCD.QA",
    " marketcap ": " $1 006 752 563 ",
    "price (USD)": "3.50275",
    "country": "Qatar"
  },
  {
    "Rank": "5186",
    "Name": "Nexa Resources",
    "Symbol": "NEXA",
    " marketcap ": " $1 006 536 384 ",
    "price (USD)": "07.\u0438\u044e\u043d",
    "country": "Luxembourg"
  },
  {
    "Rank": "5187",
    "Name": "Deluxe",
    "Symbol": "DLX",
    " marketcap ": " $1 005 125 120 ",
    "price (USD)": "22.82",
    "country": "United States"
  },
  {
    "Rank": "5188",
    "Name": "Relay Therapeutics",
    "Symbol": "RLAY",
    " marketcap ": " $1 003 529 536 ",
    "price (USD)": "\u0438\u044e\u043b.56",
    "country": "United States"
  },
  {
    "Rank": "5189",
    "Name": "Berkshire Hills Bancorp",
    "Symbol": "BHLB",
    " marketcap ": " $1 001 364 736 ",
    "price (USD)": "23.13",
    "country": "United States"
  },
  {
    "Rank": "5190",
    "Name": "Wabash National",
    "Symbol": "WNC",
    " marketcap ": " $999 928 704 ",
    "price (USD)": "22.14",
    "country": "United States"
  },
  {
    "Rank": "5191",
    "Name": "QCR Holdings",
    "Symbol": "QCRH",
    " marketcap ": " $998 462 272 ",
    "price (USD)": "59.41",
    "country": "United States"
  },
  {
    "Rank": "5192",
    "Name": "NeoGames",
    "Symbol": "NGMS",
    " marketcap ": " $998 207 744 ",
    "price (USD)": "29.45",
    "country": "Israel"
  },
  {
    "Rank": "5193",
    "Name": "Nel ASA",
    "Symbol": "NEL.OL",
    " marketcap ": " $998 188 901 ",
    "price (USD)": "0.597392",
    "country": "Norway"
  },
  {
    "Rank": "5194",
    "Name": "Biolife Solutions",
    "Symbol": "BLFS",
    " marketcap ": " $997 949 952 ",
    "price (USD)": "21.68",
    "country": "United States"
  },
  {
    "Rank": "5195",
    "Name": "Karnataka Bank",
    "Symbol": "KTKBANK.NS",
    " marketcap ": " $997 438 613 ",
    "price (USD)": "2.64157",
    "country": "India"
  },
  {
    "Rank": "5196",
    "Name": "Daiseki",
    "Symbol": "9793.T",
    " marketcap ": " $996 328 547 ",
    "price (USD)": "20.728",
    "country": "Japan"
  },
  {
    "Rank": "5197",
    "Name": "German American Bancorp",
    "Symbol": "GABC",
    " marketcap ": " $996 177 600 ",
    "price (USD)": "33.58",
    "country": "United States"
  },
  {
    "Rank": "5198",
    "Name": "Riskified",
    "Symbol": "RSKD",
    " marketcap ": " $995 754 368 ",
    "price (USD)": "06.\u0430\u043f\u0440",
    "country": "Israel"
  },
  {
    "Rank": "5199",
    "Name": "Vi\u0413\u00b1a Concha y Toro",
    "Symbol": "CONCHATORO.SN",
    " marketcap ": " $995 250 065 ",
    "price (USD)": "1.34673",
    "country": "Chile"
  },
  {
    "Rank": "5200",
    "Name": "Prosegur",
    "Symbol": "PSG.MC",
    " marketcap ": " $995 099 368 ",
    "price (USD)": "1.87208",
    "country": "Spain"
  },
  {
    "Rank": "5201",
    "Name": "Banco de Bras\u0413\u00adlia",
    "Symbol": "BSLI3.SA",
    " marketcap ": " $993 806 543 ",
    "price (USD)": "2.245",
    "country": "Brazil"
  },
  {
    "Rank": "5202",
    "Name": "X-FAB",
    "Symbol": "XFAB.PA",
    " marketcap ": " $993 642 567 ",
    "price (USD)": "7.51439",
    "country": "Belgium"
  },
  {
    "Rank": "5203",
    "Name": "Olaplex",
    "Symbol": "OLPX",
    " marketcap ": " $992 644 480 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5204",
    "Name": "Perspective Therapeutics",
    "Symbol": "CATX",
    " marketcap ": " $989 980 096 ",
    "price (USD)": "\u044f\u043d\u0432.59",
    "country": "United States"
  },
  {
    "Rank": "5205",
    "Name": "Gracell Biotechnologies",
    "Symbol": "GRCL",
    " marketcap ": " $989 867 072 ",
    "price (USD)": "\u043e\u043a\u0442.25",
    "country": "China"
  },
  {
    "Rank": "5206",
    "Name": "Ahlibank",
    "Symbol": "ABOB.OM",
    " marketcap ": " $988 943 906 ",
    "price (USD)": "0.420889",
    "country": "Oman"
  },
  {
    "Rank": "5207",
    "Name": "Mediaset Espa\u0413\u00b1a Comunicaci\u0413\u0456n",
    "Symbol": "TL5.MC",
    " marketcap ": " $988 369 326 ",
    "price (USD)": "\u043c\u0430\u0440.16",
    "country": "Spain"
  },
  {
    "Rank": "5208",
    "Name": "ZipRecruiter",
    "Symbol": "ZIP",
    " marketcap ": " $988 099 648 ",
    "price (USD)": "\u0441\u0435\u043d.95",
    "country": "United States"
  },
  {
    "Rank": "5209",
    "Name": "Glory Ltd.",
    "Symbol": "6457.T",
    " marketcap ": " $987 537 201 ",
    "price (USD)": "17.7564",
    "country": "Japan"
  },
  {
    "Rank": "5210",
    "Name": "Simulations Plus",
    "Symbol": "SLP",
    " marketcap ": " $987 453 888 ",
    "price (USD)": "49.41",
    "country": "United States"
  },
  {
    "Rank": "5211",
    "Name": "Nextdoor",
    "Symbol": "KIND",
    " marketcap ": " $987 413 440 ",
    "price (USD)": "\u0444\u0435\u0432.53",
    "country": "United States"
  },
  {
    "Rank": "5212",
    "Name": "Rashtriya Chemicals and Fertilizers",
    "Symbol": "RCF.NS",
    " marketcap ": " $986 352 782 ",
    "price (USD)": "1.78788",
    "country": "India"
  },
  {
    "Rank": "5213",
    "Name": "REX American Resources",
    "Symbol": "REX",
    " marketcap ": " $983 357 888 ",
    "price (USD)": "56.18",
    "country": "United States"
  },
  {
    "Rank": "5214",
    "Name": "Dah Sing Financial",
    "Symbol": "0440.HK",
    " marketcap ": " $982 812 498 ",
    "price (USD)": "3.07537",
    "country": "Hong Kong"
  },
  {
    "Rank": "5215",
    "Name": "Repay Holdings",
    "Symbol": "RPAY",
    " marketcap ": " $981 180 096 ",
    "price (USD)": "10.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "5216",
    "Name": "Global Blue Group",
    "Symbol": "GB",
    " marketcap ": " $979 913 280 ",
    "price (USD)": "\u0430\u043f\u0440.91",
    "country": "Switzerland"
  },
  {
    "Rank": "5217",
    "Name": "Bonheur ASA",
    "Symbol": "BONHR.OL",
    " marketcap ": " $979 541 708 ",
    "price (USD)": "23.0308",
    "country": "Norway"
  },
  {
    "Rank": "5218",
    "Name": "Artivion",
    "Symbol": "AORT",
    " marketcap ": " $979 088 960 ",
    "price (USD)": "23.46",
    "country": "United States"
  },
  {
    "Rank": "5219",
    "Name": "Frey SA",
    "Symbol": "FREY.PA",
    " marketcap ": " $978 857 865 ",
    "price (USD)": "30.8394",
    "country": "France"
  },
  {
    "Rank": "5220",
    "Name": "Scholar Rock Holding",
    "Symbol": "SRRK",
    " marketcap ": " $978 582 784 ",
    "price (USD)": "\u0434\u0435\u043a.27",
    "country": "United States"
  },
  {
    "Rank": "5221",
    "Name": "Volaris",
    "Symbol": "VLRS",
    " marketcap ": " $978 464 960 ",
    "price (USD)": "08.\u0444\u0435\u0432",
    "country": "Mexico"
  },
  {
    "Rank": "5222",
    "Name": "Standard BioTools",
    "Symbol": "LAB",
    " marketcap ": " $977 461 312 ",
    "price (USD)": "\u0444\u0435\u0432.58",
    "country": "United States"
  },
  {
    "Rank": "5223",
    "Name": "Al-Saif Stores for Development &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5224",
    "Name": "Sakata Seed",
    "Symbol": "1377.T",
    " marketcap ": " $976 045 760 ",
    "price (USD)": "22.2315",
    "country": "Japan"
  },
  {
    "Rank": "5225",
    "Name": "Ardmore Shipping",
    "Symbol": "ASC",
    " marketcap ": " $975 628 672 ",
    "price (USD)": "23.38",
    "country": "Bermuda"
  },
  {
    "Rank": "5226",
    "Name": "Tabcorp",
    "Symbol": "TAH.AX",
    " marketcap ": " $974 565 241 ",
    "price (USD)": "0.426758",
    "country": "Australia"
  },
  {
    "Rank": "5227",
    "Name": "Genco Shipping &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5228",
    "Name": "Nurix Therapeutics",
    "Symbol": "NRIX",
    " marketcap ": " $973 415 936 ",
    "price (USD)": "15.94",
    "country": "United States"
  },
  {
    "Rank": "5229",
    "Name": "GAG Immobilien",
    "Symbol": "GWK3.HM",
    " marketcap ": " $973 097 170 ",
    "price (USD)": "60.2671",
    "country": "Germany"
  },
  {
    "Rank": "5230",
    "Name": "SilverBow Resources",
    "Symbol": "SBOW",
    " marketcap ": " $973 016 832 ",
    "price (USD)": "38.1",
    "country": "United States"
  },
  {
    "Rank": "5231",
    "Name": "Shentel",
    "Symbol": "SHEN",
    " marketcap ": " $972 574 784 ",
    "price (USD)": "17.83",
    "country": "United States"
  },
  {
    "Rank": "5232",
    "Name": "Centessa Pharmaceuticals",
    "Symbol": "CNTA",
    " marketcap ": " $972 178 432 ",
    "price (USD)": "08.\u0438\u044e\u043d",
    "country": "United Kingdom"
  },
  {
    "Rank": "5233",
    "Name": "EaseMyTrip",
    "Symbol": "EASEMYTRIP.NS",
    " marketcap ": " $971 556 648 ",
    "price (USD)": "0.547899",
    "country": "India"
  },
  {
    "Rank": "5234",
    "Name": "Tyra Biosciences",
    "Symbol": "TYRA",
    " marketcap ": " $969 359 360 ",
    "price (USD)": "18.45",
    "country": "United States"
  },
  {
    "Rank": "5235",
    "Name": "Neuland Laboratories",
    "Symbol": "NEULANDLAB.NS",
    " marketcap ": " $968 096 552 ",
    "price (USD)": "75.4563",
    "country": "India"
  },
  {
    "Rank": "5236",
    "Name": "HireRight",
    "Symbol": "HRT",
    " marketcap ": " $966 515 584 ",
    "price (USD)": "14.35",
    "country": "United States"
  },
  {
    "Rank": "5237",
    "Name": "Sedlmayr Grund und Immobilien AG",
    "Symbol": "SPB.F",
    " marketcap ": " $964 811 085 ",
    "price (USD)": "1313.93",
    "country": "Germany"
  },
  {
    "Rank": "5238",
    "Name": "Prime Medicine",
    "Symbol": "PRME",
    " marketcap ": " $963 848 896 ",
    "price (USD)": "08.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "5239",
    "Name": "Campus Activewear",
    "Symbol": "CAMPUS.NS",
    " marketcap ": " $960 452 608 ",
    "price (USD)": "3.13961",
    "country": "India"
  },
  {
    "Rank": "5240",
    "Name": "Fiverr",
    "Symbol": "FVRR",
    " marketcap ": " $959 425 088 ",
    "price (USD)": "24.79",
    "country": "Israel"
  },
  {
    "Rank": "5241",
    "Name": "Digi International",
    "Symbol": "DGII",
    " marketcap ": " $958 470 720 ",
    "price (USD)": "26.35",
    "country": "United States"
  },
  {
    "Rank": "5242",
    "Name": "Plymouth Industrial REIT",
    "Symbol": "PLYM",
    " marketcap ": " $957 357 056 ",
    "price (USD)": "20.87",
    "country": "United States"
  },
  {
    "Rank": "5243",
    "Name": "Strides Pharma",
    "Symbol": "STAR.NS",
    " marketcap ": " $957 339 772 ",
    "price (USD)": "\u043e\u043a\u0442.61",
    "country": "India"
  },
  {
    "Rank": "5244",
    "Name": "FIGS",
    "Symbol": "FIGS",
    " marketcap ": " $956 681 344 ",
    "price (USD)": "\u043c\u0430\u0439.62",
    "country": "United States"
  },
  {
    "Rank": "5245",
    "Name": "Westrock Coffee",
    "Symbol": "WEST",
    " marketcap ": " $953 511 488 ",
    "price (USD)": "\u043e\u043a\u0442.65",
    "country": "United States"
  },
  {
    "Rank": "5246",
    "Name": "Fnac Darty",
    "Symbol": "FNAC.PA",
    " marketcap ": " $952 314 440 ",
    "price (USD)": "34.9658",
    "country": "France"
  },
  {
    "Rank": "5247",
    "Name": "XPEL",
    "Symbol": "XPEL",
    " marketcap ": " $951 711 488 ",
    "price (USD)": "34.44",
    "country": "United States"
  },
  {
    "Rank": "5248",
    "Name": "Ali Al-Ghanim Sons Automotive Company",
    "Symbol": "ALG.KW",
    " marketcap ": " $950 226 858 ",
    "price (USD)": "3468.06",
    "country": "Kuwait"
  },
  {
    "Rank": "5249",
    "Name": "USANA",
    "Symbol": "USNA",
    " marketcap ": " $948 148 352 ",
    "price (USD)": "49.77",
    "country": "United States"
  },
  {
    "Rank": "5250",
    "Name": "PolyNovo",
    "Symbol": "PNV.AX",
    " marketcap ": " $948 122 223 ",
    "price (USD)": "1.37363",
    "country": "Australia"
  },
  {
    "Rank": "5251",
    "Name": "Endeavour Silver",
    "Symbol": "EXK",
    " marketcap ": " $946 943 552 ",
    "price (USD)": "\u043c\u0430\u0440.94",
    "country": "Canada"
  },
  {
    "Rank": "5252",
    "Name": "Arendals Fossekompani",
    "Symbol": "AFK.OL",
    " marketcap ": " $944 851 978 ",
    "price (USD)": "17.2238",
    "country": "Norway"
  },
  {
    "Rank": "5253",
    "Name": "Ocular Therapeutix",
    "Symbol": "OCUL",
    " marketcap ": " $944 822 848 ",
    "price (USD)": "06.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "5254",
    "Name": "SD BioSensor",
    "Symbol": "137310.KS",
    " marketcap ": " $942 540 744 ",
    "price (USD)": "7.70383",
    "country": "South Korea"
  },
  {
    "Rank": "5255",
    "Name": "Per Aarsleff Holding A/S B",
    "Symbol": "PAAL-B.CO",
    " marketcap ": " $941 348 903 ",
    "price (USD)": "53.1091",
    "country": "Denmark"
  },
  {
    "Rank": "5256",
    "Name": "Fortress REIT",
    "Symbol": "FFA.JO",
    " marketcap ": " $939 337 400 ",
    "price (USD)": "0.8",
    "country": "South Africa"
  },
  {
    "Rank": "5257",
    "Name": "Pitney Bowes",
    "Symbol": "PBI",
    " marketcap ": " $939 093 760 ",
    "price (USD)": "\u043c\u0430\u0439.25",
    "country": "United States"
  },
  {
    "Rank": "5258",
    "Name": "ARMOUR Residential REIT",
    "Symbol": "ARR",
    " marketcap ": " $938 959 680 ",
    "price (USD)": "19.26",
    "country": "United States"
  },
  {
    "Rank": "5259",
    "Name": "Aedas Homes",
    "Symbol": "AEDAS.MC",
    " marketcap ": " $936 384 007 ",
    "price (USD)": "21.7179",
    "country": "Spain"
  },
  {
    "Rank": "5260",
    "Name": "Koppers",
    "Symbol": "KOP",
    " marketcap ": " $935 140 864 ",
    "price (USD)": "44.11",
    "country": "United States"
  },
  {
    "Rank": "5261",
    "Name": "Shoe Carnival",
    "Symbol": "SCVL",
    " marketcap ": " $934 517 120 ",
    "price (USD)": "34.41",
    "country": "United States"
  },
  {
    "Rank": "5262",
    "Name": "FDC India",
    "Symbol": "FDC.NS",
    " marketcap ": " $933 505 241 ",
    "price (USD)": "5.73191",
    "country": "India"
  },
  {
    "Rank": "5263",
    "Name": "NorthWest Healthcare Properties REIT",
    "Symbol": "NWH-UN.TO",
    " marketcap ": " $932 578 561 ",
    "price (USD)": "3.76847",
    "country": "Canada"
  },
  {
    "Rank": "5264",
    "Name": "Power Mech Projects",
    "Symbol": "POWERMECH.NS",
    " marketcap ": " $931 463 614 ",
    "price (USD)": "58.9232",
    "country": "India"
  },
  {
    "Rank": "5265",
    "Name": "Avanos Medical",
    "Symbol": "AVNS",
    " marketcap ": " $931 390 144 ",
    "price (USD)": "20.29",
    "country": "United States"
  },
  {
    "Rank": "5266",
    "Name": "National Energy Services Reunited",
    "Symbol": "NESR",
    " marketcap ": " $930 964 736 ",
    "price (USD)": "09.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "5267",
    "Name": "Texmaco Rail &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5268",
    "Name": "Kuwait International Bank",
    "Symbol": "KIB.KW",
    " marketcap ": " $930 663 364 ",
    "price (USD)": "589.961",
    "country": "Kuwait"
  },
  {
    "Rank": "5269",
    "Name": "AT&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5270",
    "Name": "Air Transport Services Group",
    "Symbol": "ATSG",
    " marketcap ": " $929 988 928 ",
    "price (USD)": "14.15",
    "country": "United States"
  },
  {
    "Rank": "5271",
    "Name": "Greenlam Industries",
    "Symbol": "GREENLAM.NS",
    " marketcap ": " $929 899 863 ",
    "price (USD)": "\u0438\u044e\u043b.91",
    "country": "India"
  },
  {
    "Rank": "5272",
    "Name": "GungHo Online Entertainment",
    "Symbol": "3765.T",
    " marketcap ": " $929 464 405 ",
    "price (USD)": "16.109",
    "country": "Japan"
  },
  {
    "Rank": "5273",
    "Name": "Synergie SE",
    "Symbol": "SDG.PA",
    " marketcap ": " $929 423 373 ",
    "price (USD)": "39.5266",
    "country": "France"
  },
  {
    "Rank": "5274",
    "Name": "Aris Water Solutions",
    "Symbol": "ARIS",
    " marketcap ": " $928 879 872 ",
    "price (USD)": "15.99",
    "country": "United States"
  },
  {
    "Rank": "5275",
    "Name": "OceanFirst Financial",
    "Symbol": "OCFC",
    " marketcap ": " $928 847 552 ",
    "price (USD)": "15.82",
    "country": "United States"
  },
  {
    "Rank": "5276",
    "Name": "Root Insurance",
    "Symbol": "ROOT",
    " marketcap ": " $928 459 328 ",
    "price (USD)": "62.22",
    "country": "United States"
  },
  {
    "Rank": "5277",
    "Name": "P10",
    "Symbol": "PX",
    " marketcap ": " $926 788 608 ",
    "price (USD)": "08.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "5278",
    "Name": "Mastek",
    "Symbol": "MASTEK.NS",
    " marketcap ": " $925 569 945 ",
    "price (USD)": "29.9819",
    "country": "India"
  },
  {
    "Rank": "5279",
    "Name": "Palfinger",
    "Symbol": "PFI.F",
    " marketcap ": " $925 346 526 ",
    "price (USD)": "26.1158",
    "country": "Austria"
  },
  {
    "Rank": "5280",
    "Name": "Lithium Americas",
    "Symbol": "LAC",
    " marketcap ": " $924 485 504 ",
    "price (USD)": "\u0430\u043f\u0440.25",
    "country": "Canada"
  },
  {
    "Rank": "5281",
    "Name": "Knr Constructions",
    "Symbol": "KNRCON.NS",
    " marketcap ": " $924 383 475 ",
    "price (USD)": "3.28499",
    "country": "India"
  },
  {
    "Rank": "5282",
    "Name": "CVR Partners",
    "Symbol": "UAN",
    " marketcap ": " $923 783 040 ",
    "price (USD)": "87.4",
    "country": "United States"
  },
  {
    "Rank": "5283",
    "Name": "ChemoMetec",
    "Symbol": "CHEMM.CO",
    " marketcap ": " $923 725 362 ",
    "price (USD)": "53.08",
    "country": "Denmark"
  },
  {
    "Rank": "5284",
    "Name": "Agrana",
    "Symbol": "AGR.VI",
    " marketcap ": " $922 847 684 ",
    "price (USD)": "14.7682",
    "country": "Austria"
  },
  {
    "Rank": "5285",
    "Name": "Savaria Corporation",
    "Symbol": "SIS.TO",
    " marketcap ": " $920 733 622 ",
    "price (USD)": "12.977",
    "country": "Canada"
  },
  {
    "Rank": "5286",
    "Name": "Leslie's",
    "Symbol": "LESL",
    " marketcap ": " $920 020 160 ",
    "price (USD)": "\u0430\u043f\u0440.98",
    "country": "United States"
  },
  {
    "Rank": "5287",
    "Name": "Kirloskar Ferrous Industries",
    "Symbol": "KIRLFER.NS",
    " marketcap ": " $919 917 527 ",
    "price (USD)": "5.52765",
    "country": "India"
  },
  {
    "Rank": "5288",
    "Name": "Tsakos Energy Navigation",
    "Symbol": "TNP",
    " marketcap ": " $918 214 272 ",
    "price (USD)": "31.\u0434\u0435\u043a",
    "country": "Greece"
  },
  {
    "Rank": "5289",
    "Name": "Guild Mortgage",
    "Symbol": "GHLD",
    " marketcap ": " $917 098 752 ",
    "price (USD)": "14.95",
    "country": "United States"
  },
  {
    "Rank": "5290",
    "Name": "Barloworld",
    "Symbol": "BAW.JO",
    " marketcap ": " $917 067 600 ",
    "price (USD)": "4.93604",
    "country": "South Africa"
  },
  {
    "Rank": "5291",
    "Name": "Syrma SGS Technology",
    "Symbol": "SYRMA.NS",
    " marketcap ": " $916 687 166 ",
    "price (USD)": "5.15578",
    "country": "India"
  },
  {
    "Rank": "5292",
    "Name": "MoneyLion",
    "Symbol": "ML",
    " marketcap ": " $916 656 384 ",
    "price (USD)": "84.97",
    "country": "United States"
  },
  {
    "Rank": "5293",
    "Name": "Tinexta",
    "Symbol": "TNXT.MI",
    " marketcap ": " $915 046 898 ",
    "price (USD)": "20.1542",
    "country": "Italy"
  },
  {
    "Rank": "5294",
    "Name": "B. Riley Financial",
    "Symbol": "RILY",
    " marketcap ": " $914 009 216 ",
    "price (USD)": "30.17",
    "country": "United States"
  },
  {
    "Rank": "5295",
    "Name": "Edelweiss Financial Services",
    "Symbol": "EDELWEISS.NS",
    " marketcap ": " $913 798 356 ",
    "price (USD)": "1.0165",
    "country": "India"
  },
  {
    "Rank": "5296",
    "Name": "Service Properties Trust",
    "Symbol": "SVC",
    " marketcap ": " $913 337 664 ",
    "price (USD)": "\u043c\u0430\u0439.51",
    "country": "United States"
  },
  {
    "Rank": "5297",
    "Name": "Wirtualna Polska (WP Holding)",
    "Symbol": "WPL.WA",
    " marketcap ": " $910 332 300 ",
    "price (USD)": "31.0553",
    "country": "Poland"
  },
  {
    "Rank": "5298",
    "Name": "NextNav",
    "Symbol": "NN",
    " marketcap ": " $908 871 040 ",
    "price (USD)": "\u0438\u044e\u043b.53",
    "country": "United States"
  },
  {
    "Rank": "5299",
    "Name": "Oklo",
    "Symbol": "OKLO",
    " marketcap ": " $908 394 240 ",
    "price (USD)": "\u0438\u044e\u043b.44",
    "country": "United States"
  },
  {
    "Rank": "5300",
    "Name": "Altareit",
    "Symbol": "AREIT.PA",
    " marketcap ": " $907 499 290 ",
    "price (USD)": "519.057",
    "country": "France"
  },
  {
    "Rank": "5301",
    "Name": "The Real Brokerage",
    "Symbol": "REAX",
    " marketcap ": " $906 747 008 ",
    "price (USD)": "\u0430\u043f\u0440.79",
    "country": "Canada"
  },
  {
    "Rank": "5302",
    "Name": "Nordic American Tankers",
    "Symbol": "NAT",
    " marketcap ": " $906 174 656 ",
    "price (USD)": "\u0430\u043f\u0440.34",
    "country": "Bermuda"
  },
  {
    "Rank": "5303",
    "Name": "OPKO Health",
    "Symbol": "OPK",
    " marketcap ": " $906 089 536 ",
    "price (USD)": "01.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "5304",
    "Name": "TCG BDC",
    "Symbol": "CGBD",
    " marketcap ": " $905 673 088 ",
    "price (USD)": "17.83",
    "country": "United States"
  },
  {
    "Rank": "5305",
    "Name": "Beazer Homes USA",
    "Symbol": "BZH",
    " marketcap ": " $905 407 552 ",
    "price (USD)": "28.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5306",
    "Name": "NTG Nordic Transport Group A/S",
    "Symbol": "NTG.CO",
    " marketcap ": " $904 907 836 ",
    "price (USD)": "42.5601",
    "country": "Denmark"
  },
  {
    "Rank": "5307",
    "Name": "Pick n Pay Stores",
    "Symbol": "PIK.JO",
    " marketcap ": " $904 707 700 ",
    "price (USD)": "1.25919",
    "country": "South Africa"
  },
  {
    "Rank": "5308",
    "Name": "Interface",
    "Symbol": "TILE",
    " marketcap ": " $903 345 856 ",
    "price (USD)": "15.51",
    "country": "United States"
  },
  {
    "Rank": "5309",
    "Name": "Mesoblast",
    "Symbol": "MESO",
    " marketcap ": " $902 720 832 ",
    "price (USD)": "\u0438\u044e\u043b.91",
    "country": "Australia"
  },
  {
    "Rank": "5310",
    "Name": "OHB SE",
    "Symbol": "OHB.DE",
    " marketcap ": " $902 601 264 ",
    "price (USD)": "47.1278",
    "country": "Germany"
  },
  {
    "Rank": "5311",
    "Name": "cBrain",
    "Symbol": "CBRAIN.CO",
    " marketcap ": " $902 148 196 ",
    "price (USD)": "46.1249",
    "country": "Denmark"
  },
  {
    "Rank": "5312",
    "Name": "Karooooo",
    "Symbol": "KARO",
    " marketcap ": " $901 662 016 ",
    "price (USD)": "29.18",
    "country": "Singapore"
  },
  {
    "Rank": "5313",
    "Name": "Heartland Express",
    "Symbol": "HTLD",
    " marketcap ": " $901 182 528 ",
    "price (USD)": "11.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5314",
    "Name": "Abivax",
    "Symbol": "ABVX",
    " marketcap ": " $900 352 320 ",
    "price (USD)": "14.31",
    "country": "France"
  },
  {
    "Rank": "5315",
    "Name": "JSW Holdings",
    "Symbol": "JSWHL.NS",
    " marketcap ": " $900 060 241 ",
    "price (USD)": "81.1077",
    "country": "India"
  },
  {
    "Rank": "5316",
    "Name": "Marksans Pharma",
    "Symbol": "MARKSANS.NS",
    " marketcap ": " $900 044 591 ",
    "price (USD)": "1.98613",
    "country": "India"
  },
  {
    "Rank": "5317",
    "Name": "Miramar Hotel and Investment",
    "Symbol": "0071.HK",
    " marketcap ": " $899 566 416 ",
    "price (USD)": "1.30191",
    "country": "Hong Kong"
  },
  {
    "Rank": "5318",
    "Name": "Camping World",
    "Symbol": "CWH",
    " marketcap ": " $899 188 416 ",
    "price (USD)": "19.95",
    "country": "United States"
  },
  {
    "Rank": "5319",
    "Name": "Ballard Power Systems",
    "Symbol": "BLDP",
    " marketcap ": " $898 731 264 ",
    "price (USD)": "\u0444\u0435\u0432.99",
    "country": "Canada"
  },
  {
    "Rank": "5320",
    "Name": "American Axle &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5321",
    "Name": "Sri Trang Gloves",
    "Symbol": "STGT.BK",
    " marketcap ": " $898 101 436 ",
    "price (USD)": "0.313454",
    "country": "Thailand"
  },
  {
    "Rank": "5322",
    "Name": "T\u0413\u00a9cnicas Reunidas",
    "Symbol": "TRE.MC",
    " marketcap ": " $897 426 848 ",
    "price (USD)": "\u043d\u043e\u044f.96",
    "country": "Spain"
  },
  {
    "Rank": "5323",
    "Name": "SunCoke Energy",
    "Symbol": "SXC",
    " marketcap ": " $896 244 864 ",
    "price (USD)": "\u043e\u043a\u0442.66",
    "country": "United States"
  },
  {
    "Rank": "5324",
    "Name": "dentalcorp",
    "Symbol": "DNTL.TO",
    " marketcap ": " $896 227 304 ",
    "price (USD)": "4.74722",
    "country": "Canada"
  },
  {
    "Rank": "5325",
    "Name": "Sinclair Broadcast",
    "Symbol": "SBGI",
    " marketcap ": " $896 047 424 ",
    "price (USD)": "13.54",
    "country": "United States"
  },
  {
    "Rank": "5326",
    "Name": "Piedmont Office Realty Trust",
    "Symbol": "PDM",
    " marketcap ": " $895 731 904 ",
    "price (USD)": "\u0438\u044e\u043b.23",
    "country": "United States"
  },
  {
    "Rank": "5327",
    "Name": "TimkenSteel",
    "Symbol": "TMST",
    " marketcap ": " $895 362 112 ",
    "price (USD)": "20.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5328",
    "Name": "Allegiant Air",
    "Symbol": "ALGT",
    " marketcap ": " $894 112 000 ",
    "price (USD)": "49.04",
    "country": "United States"
  },
  {
    "Rank": "5329",
    "Name": "BayWa",
    "Symbol": "BYW.F",
    " marketcap ": " $892 952 546 ",
    "price (USD)": "34.7486",
    "country": "Germany"
  },
  {
    "Rank": "5330",
    "Name": "Bluelinx",
    "Symbol": "BXC",
    " marketcap ": " $892 678 912 ",
    "price (USD)": "103.06",
    "country": "United States"
  },
  {
    "Rank": "5331",
    "Name": "PRA Group",
    "Symbol": "PRAA",
    " marketcap ": " $892 503 360 ",
    "price (USD)": "22.68",
    "country": "United States"
  },
  {
    "Rank": "5332",
    "Name": "Abu Dhabi National Insurance Company",
    "Symbol": "ADNIC.AE",
    " marketcap ": " $892 395 241 ",
    "price (USD)": "\u044f\u043d\u0432.57",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5333",
    "Name": "Close Brothers Group",
    "Symbol": "CBG.L",
    " marketcap ": " $892 315 425 ",
    "price (USD)": "5.92948",
    "country": "United Kingdom"
  },
  {
    "Rank": "5334",
    "Name": "SLR Investment",
    "Symbol": "SLRC",
    " marketcap ": " $891 422 144 ",
    "price (USD)": "16.34",
    "country": "United States"
  },
  {
    "Rank": "5335",
    "Name": "Deyaar Development",
    "Symbol": "DEYAAR.AE",
    " marketcap ": " $891 180 623 ",
    "price (USD)": "0.203659",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5336",
    "Name": "RattanIndia Power",
    "Symbol": "RTNPOWER.NS",
    " marketcap ": " $890 426 444 ",
    "price (USD)": "0.165812",
    "country": "India"
  },
  {
    "Rank": "5337",
    "Name": "Grupo Supervielle",
    "Symbol": "SUPV",
    " marketcap ": " $889 071 360 ",
    "price (USD)": "\u0438\u044e\u043b.51",
    "country": "Argentina"
  },
  {
    "Rank": "5338",
    "Name": "Vossloh AG",
    "Symbol": "VOS.DE",
    " marketcap ": " $888 795 431 ",
    "price (USD)": "50.6027",
    "country": "Germany"
  },
  {
    "Rank": "5339",
    "Name": "VIP Industries",
    "Symbol": "VIPIND.NS",
    " marketcap ": " $886 446 345 ",
    "price (USD)": "6.24377",
    "country": "India"
  },
  {
    "Rank": "5340",
    "Name": "South Indian Bank",
    "Symbol": "SOUTHBANK.NS",
    " marketcap ": " $886 396 736 ",
    "price (USD)": "0.338232",
    "country": "India"
  },
  {
    "Rank": "5341",
    "Name": "Argan",
    "Symbol": "AGX",
    " marketcap ": " $885 818 944 ",
    "price (USD)": "66.35",
    "country": "United States"
  },
  {
    "Rank": "5342",
    "Name": "A-Mark Precious Metals",
    "Symbol": "AMRK",
    " marketcap ": " $885 112 960 ",
    "price (USD)": "38.66",
    "country": "United States"
  },
  {
    "Rank": "5343",
    "Name": "Freightways",
    "Symbol": "FRW.NZ",
    " marketcap ": " $883 601 127 ",
    "price (USD)": "4.94425",
    "country": "New Zealand"
  },
  {
    "Rank": "5344",
    "Name": "Taseko Mines",
    "Symbol": "TGB",
    " marketcap ": " $883 093 440 ",
    "price (USD)": "03.\u043c\u0430\u0440",
    "country": "Canada"
  },
  {
    "Rank": "5345",
    "Name": "BASSAC",
    "Symbol": "BASS.PA",
    " marketcap ": " $880 994 575 ",
    "price (USD)": "52.883",
    "country": "France"
  },
  {
    "Rank": "5346",
    "Name": "CECO Environmental",
    "Symbol": "CECO",
    " marketcap ": " $880 723 904 ",
    "price (USD)": "25.21",
    "country": "United States"
  },
  {
    "Rank": "5347",
    "Name": "Ladun Investment Company",
    "Symbol": "9535.SR",
    " marketcap ": " $880 634 057 ",
    "price (USD)": "1.76127",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5348",
    "Name": "89bio",
    "Symbol": "ETNB",
    " marketcap ": " $880 536 768 ",
    "price (USD)": "\u0430\u0432\u0433.95",
    "country": "United States"
  },
  {
    "Rank": "5349",
    "Name": "Morguard",
    "Symbol": "MRC.TO",
    " marketcap ": " $880 325 525 ",
    "price (USD)": "81.4106",
    "country": "Canada"
  },
  {
    "Rank": "5350",
    "Name": "Eagle Point Credit Company",
    "Symbol": "ECC",
    " marketcap ": " $880 315 648 ",
    "price (USD)": "\u043e\u043a\u0442.32",
    "country": "United States"
  },
  {
    "Rank": "5351",
    "Name": "Pliant Therapeutics",
    "Symbol": "PLRX",
    " marketcap ": " $880 153 408 ",
    "price (USD)": "14.59",
    "country": "United States"
  },
  {
    "Rank": "5352",
    "Name": "Matthews International Corporation",
    "Symbol": "MATW",
    " marketcap ": " $879 838 592 ",
    "price (USD)": "28.65",
    "country": "United States"
  },
  {
    "Rank": "5353",
    "Name": "Rh\u0413\u00b6n-Klinikum",
    "Symbol": "RHK.DE",
    " marketcap ": " $879 526 446 ",
    "price (USD)": "13.1393",
    "country": "Germany"
  },
  {
    "Rank": "5354",
    "Name": "Core Laboratories",
    "Symbol": "CLB",
    " marketcap ": " $878 690 624 ",
    "price (USD)": "18.83",
    "country": "Netherlands"
  },
  {
    "Rank": "5355",
    "Name": "Mission Produce",
    "Symbol": "AVO",
    " marketcap ": " $878 501 504 ",
    "price (USD)": "12.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5356",
    "Name": "Hut 8 Mining",
    "Symbol": "HUT",
    " marketcap ": " $876 802 368 ",
    "price (USD)": "09.\u0438\u044e\u043b",
    "country": "Canada"
  },
  {
    "Rank": "5357",
    "Name": "Astra Microwave",
    "Symbol": "ASTRAMICRO.NS",
    " marketcap ": " $876 530 350 ",
    "price (USD)": "9.23198",
    "country": "India"
  },
  {
    "Rank": "5358",
    "Name": "enCore Energy",
    "Symbol": "EU",
    " marketcap ": " $876 338 624 ",
    "price (USD)": "\u0430\u043f\u0440.82",
    "country": "Canada"
  },
  {
    "Rank": "5359",
    "Name": "SUNeVision",
    "Symbol": "1686.HK",
    " marketcap ": " $875 207 162 ",
    "price (USD)": "0.37417",
    "country": "Hong Kong"
  },
  {
    "Rank": "5360",
    "Name": "Lakeland Bancorp",
    "Symbol": "LBAI",
    " marketcap ": " $875 024 960 ",
    "price (USD)": "13.43",
    "country": "United States"
  },
  {
    "Rank": "5361",
    "Name": "Unitil Corporation",
    "Symbol": "UTL",
    " marketcap ": " $874 877 568 ",
    "price (USD)": "54.11",
    "country": "United States"
  },
  {
    "Rank": "5362",
    "Name": "Laurentian Bank of Canada",
    "Symbol": "LB.TO",
    " marketcap ": " $872 794 176 ",
    "price (USD)": "19.9567",
    "country": "Canada"
  },
  {
    "Rank": "5363",
    "Name": "Imax Corp",
    "Symbol": "IMAX",
    " marketcap ": " $872 520 832 ",
    "price (USD)": "16.58",
    "country": "Canada"
  },
  {
    "Rank": "5364",
    "Name": "Esso (Thailand)",
    "Symbol": "ESSO.BK",
    " marketcap ": " $872 280 968 ",
    "price (USD)": "0.25",
    "country": "Thailand"
  },
  {
    "Rank": "5365",
    "Name": "Citycon",
    "Symbol": "CTY1S.HE",
    " marketcap ": " $872 243 484 ",
    "price (USD)": "4.74319",
    "country": "Finland"
  },
  {
    "Rank": "5366",
    "Name": "Fenix Outdoor",
    "Symbol": "FOI-B.ST",
    " marketcap ": " $872 008 781 ",
    "price (USD)": "65.4283",
    "country": "Switzerland"
  },
  {
    "Rank": "5367",
    "Name": "SWCC Corporation",
    "Symbol": "5805.T",
    " marketcap ": " $870 863 225 ",
    "price (USD)": "29.1088",
    "country": "Japan"
  },
  {
    "Rank": "5368",
    "Name": "Tokmanni",
    "Symbol": "TOKMAN.HE",
    " marketcap ": " $870 363 722 ",
    "price (USD)": "14.7899",
    "country": "Finland"
  },
  {
    "Rank": "5369",
    "Name": "Silk Road Medical",
    "Symbol": "SILK",
    " marketcap ": " $869 343 616 ",
    "price (USD)": "22.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5370",
    "Name": "PureCycle Technologies",
    "Symbol": "PCT",
    " marketcap ": " $869 251 776 ",
    "price (USD)": "\u043c\u0430\u0439.28",
    "country": "United States"
  },
  {
    "Rank": "5371",
    "Name": "Teekay",
    "Symbol": "TK",
    " marketcap ": " $869 044 736 ",
    "price (USD)": "\u0441\u0435\u043d.51",
    "country": "Canada"
  },
  {
    "Rank": "5372",
    "Name": "Religare",
    "Symbol": "RELIGARE.NS",
    " marketcap ": " $868 379 592 ",
    "price (USD)": "2.63136",
    "country": "India"
  },
  {
    "Rank": "5373",
    "Name": "HSBC Oman",
    "Symbol": "HBMO.OM",
    " marketcap ": " $867 893 572 ",
    "price (USD)": "0.433879",
    "country": "Oman"
  },
  {
    "Rank": "5374",
    "Name": "Gorman-Rupp",
    "Symbol": "GRC",
    " marketcap ": " $867 321 984 ",
    "price (USD)": "33.09",
    "country": "United States"
  },
  {
    "Rank": "5375",
    "Name": "RWS Holdings",
    "Symbol": "RWS.L",
    " marketcap ": " $867 218 836 ",
    "price (USD)": "2.35198",
    "country": "United Kingdom"
  },
  {
    "Rank": "5376",
    "Name": "TechTarget",
    "Symbol": "TTGT",
    " marketcap ": " $867 020 992 ",
    "price (USD)": "30.37",
    "country": "United States"
  },
  {
    "Rank": "5377",
    "Name": "Alfen",
    "Symbol": "ALFEN.AS",
    " marketcap ": " $866 755 704 ",
    "price (USD)": "39.9066",
    "country": "Netherlands"
  },
  {
    "Rank": "5378",
    "Name": "AMERISAFE",
    "Symbol": "AMSF",
    " marketcap ": " $866 241 472 ",
    "price (USD)": "45.27",
    "country": "United States"
  },
  {
    "Rank": "5379",
    "Name": "Riyadh Cement Company",
    "Symbol": "3092.SR",
    " marketcap ": " $864 622 528 ",
    "price (USD)": "7.20519",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5380",
    "Name": "Shui On Land",
    "Symbol": "0272.HK",
    " marketcap ": " $864 039 898 ",
    "price (USD)": "0.107638",
    "country": "China"
  },
  {
    "Rank": "5381",
    "Name": "Life Healthcare Group",
    "Symbol": "LHC.JO",
    " marketcap ": " $863 307 400 ",
    "price (USD)": "0.598879",
    "country": "South Africa"
  },
  {
    "Rank": "5382",
    "Name": "Golden Entertainment",
    "Symbol": "GDEN",
    " marketcap ": " $863 250 240 ",
    "price (USD)": "29.82",
    "country": "United States"
  },
  {
    "Rank": "5383",
    "Name": "EverQuote",
    "Symbol": "EVER",
    " marketcap ": " $862 576 448 ",
    "price (USD)": "24.84",
    "country": "United States"
  },
  {
    "Rank": "5384",
    "Name": "TAKKT AG",
    "Symbol": "TTK.DE",
    " marketcap ": " $862 517 416 ",
    "price (USD)": "13.3131",
    "country": "Germany"
  },
  {
    "Rank": "5385",
    "Name": "Ace Hardware Indonesia",
    "Symbol": "ACES.JK",
    " marketcap ": " $861 693 257 ",
    "price (USD)": "0.0503314",
    "country": "Indonesia"
  },
  {
    "Rank": "5386",
    "Name": "MPC Container Ships",
    "Symbol": "MPCC.OL",
    " marketcap ": " $861 621 370 ",
    "price (USD)": "\u044f\u043d\u0432.19",
    "country": "Norway"
  },
  {
    "Rank": "5387",
    "Name": "Ascential",
    "Symbol": "ASCL.L",
    " marketcap ": " $861 452 433 ",
    "price (USD)": "4.22276",
    "country": "United Kingdom"
  },
  {
    "Rank": "5388",
    "Name": "Osisko Mining",
    "Symbol": "OSK.TO",
    " marketcap ": " $861 055 282 ",
    "price (USD)": "2.35346",
    "country": "Canada"
  },
  {
    "Rank": "5389",
    "Name": "Redwood Trust",
    "Symbol": "RWT",
    " marketcap ": " $860 316 032 ",
    "price (USD)": "\u0438\u044e\u043d.51",
    "country": "United States"
  },
  {
    "Rank": "5390",
    "Name": "Algoma Steel",
    "Symbol": "ASTL",
    " marketcap ": " $859 819 200 ",
    "price (USD)": "08.\u0444\u0435\u0432",
    "country": "Canada"
  },
  {
    "Rank": "5391",
    "Name": "Emirates Driving Company",
    "Symbol": "DRIVE.AE",
    " marketcap ": " $859 555 592 ",
    "price (USD)": "0.8",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5392",
    "Name": "Radware",
    "Symbol": "RDWR",
    " marketcap ": " $857 467 200 ",
    "price (USD)": "20.52",
    "country": "Israel"
  },
  {
    "Rank": "5393",
    "Name": "(DIA) Distribuidora Internacional de Alimentaci\u0413\u0456n",
    "Symbol": "DIA.MC",
    " marketcap ": " $857 170 646 ",
    "price (USD)": "0.0147682",
    "country": "Spain"
  },
  {
    "Rank": "5394",
    "Name": "Skycity Entertainment Group",
    "Symbol": "SKC.NZ",
    " marketcap ": " $856 988 859 ",
    "price (USD)": "1.12731",
    "country": "New Zealand"
  },
  {
    "Rank": "5395",
    "Name": "Bel Fuse",
    "Symbol": "BELFB",
    " marketcap ": " $856 512 960 ",
    "price (USD)": "66.31",
    "country": "United States"
  },
  {
    "Rank": "5396",
    "Name": "Clearwater Paper",
    "Symbol": "CLW",
    " marketcap ": " $856 107 456 ",
    "price (USD)": "51.33",
    "country": "United States"
  },
  {
    "Rank": "5397",
    "Name": "ARS Pharmaceuticals",
    "Symbol": "SPRY",
    " marketcap ": " $855 585 472 ",
    "price (USD)": "\u0430\u0432\u0433.83",
    "country": "United States"
  },
  {
    "Rank": "5398",
    "Name": "Ducommun",
    "Symbol": "DCO",
    " marketcap ": " $854 722 752 ",
    "price (USD)": "58.08",
    "country": "United States"
  },
  {
    "Rank": "5399",
    "Name": "Hexatronic Group AB",
    "Symbol": "HTRO.ST",
    " marketcap ": " $851 943 999 ",
    "price (USD)": "4.19621",
    "country": "Sweden"
  },
  {
    "Rank": "5400",
    "Name": "Partner Communications",
    "Symbol": "PTNR.TA",
    " marketcap ": " $850 526 981 ",
    "price (USD)": "4.57024",
    "country": "Israel"
  },
  {
    "Rank": "5401",
    "Name": "Transcontinental",
    "Symbol": "TCL-A.TO",
    " marketcap ": " $848 443 160 ",
    "price (USD)": "9.78775",
    "country": "Canada"
  },
  {
    "Rank": "5402",
    "Name": "Prince Pipes And Fittings",
    "Symbol": "PRINCEPIPE.NS",
    " marketcap ": " $848 400 056 ",
    "price (USD)": "7.67359",
    "country": "India"
  },
  {
    "Rank": "5403",
    "Name": "Thermador Groupe",
    "Symbol": "THEP.PA",
    " marketcap ": " $848 201 194 ",
    "price (USD)": "91.6495",
    "country": "France"
  },
  {
    "Rank": "5404",
    "Name": "UNITI",
    "Symbol": "UNIT",
    " marketcap ": " $848 107 200 ",
    "price (USD)": "\u043c\u0430\u0440.53",
    "country": "United States"
  },
  {
    "Rank": "5405",
    "Name": "Enfusion",
    "Symbol": "ENFN",
    " marketcap ": " $847 423 104 ",
    "price (USD)": "\u0441\u0435\u043d.22",
    "country": "United States"
  },
  {
    "Rank": "5406",
    "Name": "Groupe CRIT",
    "Symbol": "CEN.PA",
    " marketcap ": " $847 074 575 ",
    "price (USD)": "80.3562",
    "country": "France"
  },
  {
    "Rank": "5407",
    "Name": "MSTC Limited",
    "Symbol": "MSTCLTD.NS",
    " marketcap ": " $847 020 467 ",
    "price (USD)": "12.0255",
    "country": "India"
  },
  {
    "Rank": "5408",
    "Name": "Jindal Worldwide",
    "Symbol": "JINDWORLD.NS",
    " marketcap ": " $846 284 312 ",
    "price (USD)": "4.21618",
    "country": "India"
  },
  {
    "Rank": "5409",
    "Name": "Southside Bancshares",
    "Symbol": "SBSI",
    " marketcap ": " $844 640 256 ",
    "price (USD)": "27.89",
    "country": "United States"
  },
  {
    "Rank": "5410",
    "Name": "Kelt Exploration",
    "Symbol": "KEL.TO",
    " marketcap ": " $844 449 019 ",
    "price (USD)": "4.32567",
    "country": "Canada"
  },
  {
    "Rank": "5411",
    "Name": "Phnom Penh Water Supply Authority",
    "Symbol": "PWSA.KH",
    " marketcap ": " $844 421 156 ",
    "price (USD)": "\u044f\u043d\u0432.77",
    "country": "Cambodia"
  },
  {
    "Rank": "5412",
    "Name": "Bank First",
    "Symbol": "BFC",
    " marketcap ": " $844 418 112 ",
    "price (USD)": "83.76",
    "country": "United States"
  },
  {
    "Rank": "5413",
    "Name": "Nuvation Bio",
    "Symbol": "NUVB",
    " marketcap ": " $843 781 440 ",
    "price (USD)": "03.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5414",
    "Name": "Transport Corporation of India",
    "Symbol": "TCI.NS",
    " marketcap ": " $842 579 520 ",
    "price (USD)": "\u043e\u043a\u0442.78",
    "country": "India"
  },
  {
    "Rank": "5415",
    "Name": "BrightSphere Investment Group",
    "Symbol": "BSIG",
    " marketcap ": " $842 130 496 ",
    "price (USD)": "22.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "5416",
    "Name": "Healthcare Services Group",
    "Symbol": "HCSG",
    " marketcap ": " $840 305 408 ",
    "price (USD)": "\u043d\u043e\u044f.41",
    "country": "United States"
  },
  {
    "Rank": "5417",
    "Name": "Prosegur Cash",
    "Symbol": "CASH.MC",
    " marketcap ": " $840 052 158 ",
    "price (USD)": "0.57118",
    "country": "Spain"
  },
  {
    "Rank": "5418",
    "Name": "Accel Entertainment",
    "Symbol": "ACEL",
    " marketcap ": " $839 974 336 ",
    "price (USD)": "10.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "5419",
    "Name": "Bukalapak.com",
    "Symbol": "BUKA.JK",
    " marketcap ": " $838 074 925 ",
    "price (USD)": "0.00812805",
    "country": "Indonesia"
  },
  {
    "Rank": "5420",
    "Name": "Humacyte",
    "Symbol": "HUMA",
    " marketcap ": " $837 160 576 ",
    "price (USD)": "07.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "5421",
    "Name": "flyExclusive",
    "Symbol": "FLYX",
    " marketcap ": " $836 154 688 ",
    "price (USD)": "06.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5422",
    "Name": "Symphony Limited",
    "Symbol": "SYMPHONY.NS",
    " marketcap ": " $834 465 378 ",
    "price (USD)": "12.1012",
    "country": "India"
  },
  {
    "Rank": "5423",
    "Name": "SPARC",
    "Symbol": "SPARC.NS",
    " marketcap ": " $833 852 358 ",
    "price (USD)": "2.56948",
    "country": "India"
  },
  {
    "Rank": "5424",
    "Name": "HealthStream",
    "Symbol": "HSTM",
    " marketcap ": " $833 510 400 ",
    "price (USD)": "27.42",
    "country": "United States"
  },
  {
    "Rank": "5425",
    "Name": "Allcargo Logistics",
    "Symbol": "ALLCARGO.NS",
    " marketcap ": " $832 612 736 ",
    "price (USD)": "0.847081",
    "country": "India"
  },
  {
    "Rank": "5426",
    "Name": "Deutsche Pfandbriefbank",
    "Symbol": "PBB.DE",
    " marketcap ": " $830 885 890 ",
    "price (USD)": "6.17874",
    "country": "Germany"
  },
  {
    "Rank": "5427",
    "Name": "Zeal Network",
    "Symbol": "TIMA.F",
    " marketcap ": " $830 165 204 ",
    "price (USD)": "38.3321",
    "country": "Germany"
  },
  {
    "Rank": "5428",
    "Name": "DXP Enterprises",
    "Symbol": "DXPE",
    " marketcap ": " $829 545 920 ",
    "price (USD)": "52.08",
    "country": "United States"
  },
  {
    "Rank": "5429",
    "Name": "Gatos Silver",
    "Symbol": "GATO",
    " marketcap ": " $829 480 192 ",
    "price (USD)": "\u043d\u043e\u044f.99",
    "country": "United States"
  },
  {
    "Rank": "5430",
    "Name": "Allscripts",
    "Symbol": "MDRX",
    " marketcap ": " $828 827 968 ",
    "price (USD)": "07.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5431",
    "Name": "NetDragon Websoft",
    "Symbol": "0777.HK",
    " marketcap ": " $827 808 290 ",
    "price (USD)": "1.55819",
    "country": "China"
  },
  {
    "Rank": "5432",
    "Name": "Pagaya Technologies",
    "Symbol": "PGY",
    " marketcap ": " $827 405 312 ",
    "price (USD)": "\u043d\u043e\u044f.67",
    "country": "Israel"
  },
  {
    "Rank": "5433",
    "Name": "Gulf Cable and Electrical Industries Company - KPSC",
    "Symbol": "CABLE.KW",
    " marketcap ": " $826 278 696 ",
    "price (USD)": "3966.75",
    "country": "Kuwait"
  },
  {
    "Rank": "5434",
    "Name": "BrightSpire Capital",
    "Symbol": "BRSP",
    " marketcap ": " $825 619 520 ",
    "price (USD)": "\u0438\u044e\u043d.32",
    "country": "United States"
  },
  {
    "Rank": "5435",
    "Name": "Revenio",
    "Symbol": "REG1V.HE",
    " marketcap ": " $825 403 045 ",
    "price (USD)": "31.0349",
    "country": "Finland"
  },
  {
    "Rank": "5436",
    "Name": "Hindustan Construction Company",
    "Symbol": "HCC.NS",
    " marketcap ": " $825 250 792 ",
    "price (USD)": "0.490826",
    "country": "India"
  },
  {
    "Rank": "5437",
    "Name": "Tianyu Digital Technology (Dalian)",
    "Symbol": "002354.SZ",
    " marketcap ": " $825 089 347 ",
    "price (USD)": "0.498667",
    "country": "China"
  },
  {
    "Rank": "5438",
    "Name": "MARR S.p.A.",
    "Symbol": "MARR.MI",
    " marketcap ": " $824 656 506 ",
    "price (USD)": "\u0434\u0435\u043a.58",
    "country": "Italy"
  },
  {
    "Rank": "5439",
    "Name": "Brandywine Realty Trust",
    "Symbol": "BDN",
    " marketcap ": " $824 189 248 ",
    "price (USD)": "\u0430\u043f\u0440.77",
    "country": "United States"
  },
  {
    "Rank": "5440",
    "Name": "Evolus",
    "Symbol": "EOLS",
    " marketcap ": " $823 954 176 ",
    "price (USD)": "13.16",
    "country": "United States"
  },
  {
    "Rank": "5441",
    "Name": "Bicycle Therapeutics",
    "Symbol": "BCYC",
    " marketcap ": " $822 378 944 ",
    "price (USD)": "21.\u0438\u044e\u043d",
    "country": "United Kingdom"
  },
  {
    "Rank": "5442",
    "Name": "Zentalis Pharmaceuticals",
    "Symbol": "ZNTL",
    " marketcap ": " $822 332 864 ",
    "price (USD)": "\u043d\u043e\u044f.58",
    "country": "United States"
  },
  {
    "Rank": "5443",
    "Name": "Burelle",
    "Symbol": "BUR.PA",
    " marketcap ": " $822 315 213 ",
    "price (USD)": "469.106",
    "country": "France"
  },
  {
    "Rank": "5444",
    "Name": "Viridian Therapeutics",
    "Symbol": "VRDN",
    " marketcap ": " $822 033 792 ",
    "price (USD)": "\u0434\u0435\u043a.88",
    "country": "United States"
  },
  {
    "Rank": "5445",
    "Name": "Mullen Group",
    "Symbol": "MTL.TO",
    " marketcap ": " $821 856 097 ",
    "price (USD)": "9.33319",
    "country": "Canada"
  },
  {
    "Rank": "5446",
    "Name": "Africa Oil",
    "Symbol": "AOI.TO",
    " marketcap ": " $821 353 369 ",
    "price (USD)": "1.83291",
    "country": "Canada"
  },
  {
    "Rank": "5447",
    "Name": "Immunome",
    "Symbol": "IMNM",
    " marketcap ": " $818 575 488 ",
    "price (USD)": "13.65",
    "country": "United States"
  },
  {
    "Rank": "5448",
    "Name": "Ontex Group",
    "Symbol": "ONTEX.BR",
    " marketcap ": " $817 898 317 ",
    "price (USD)": "10.088",
    "country": "Belgium"
  },
  {
    "Rank": "5449",
    "Name": "Barrett Business Services",
    "Symbol": "BBSI",
    " marketcap ": " $816 809 152 ",
    "price (USD)": "124.86",
    "country": "United States"
  },
  {
    "Rank": "5450",
    "Name": "Steel Partners",
    "Symbol": "SPLP",
    " marketcap ": " $815 731 968 ",
    "price (USD)": "40",
    "country": "United States"
  },
  {
    "Rank": "5451",
    "Name": "Commercial Real Estate Company (Kuwait)",
    "Symbol": "ALTIJARIA.KW",
    " marketcap ": " $813 359 322 ",
    "price (USD)": "446.545",
    "country": "Kuwait"
  },
  {
    "Rank": "5452",
    "Name": "BJ's Restaurants",
    "Symbol": "BJRI",
    " marketcap ": " $813 264 192 ",
    "price (USD)": "34.78",
    "country": "United States"
  },
  {
    "Rank": "5453",
    "Name": "Snap One",
    "Symbol": "SNPO",
    " marketcap ": " $812 808 064 ",
    "price (USD)": "\u043e\u043a\u0442.62",
    "country": "United States"
  },
  {
    "Rank": "5454",
    "Name": "Arabian Cement Company",
    "Symbol": "3010.SR",
    " marketcap ": " $812 585 112 ",
    "price (USD)": "8.12585",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5455",
    "Name": "Redfin",
    "Symbol": "RDFN",
    " marketcap ": " $812 402 816 ",
    "price (USD)": "06.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "5456",
    "Name": "Salhia Real Estate Company",
    "Symbol": "SRE.KW",
    " marketcap ": " $812 393 690 ",
    "price (USD)": "1417.86",
    "country": "Kuwait"
  },
  {
    "Rank": "5457",
    "Name": "Kiwi Property",
    "Symbol": "KWIPF",
    " marketcap ": " $811 843 648 ",
    "price (USD)": "0.4928",
    "country": "New Zealand"
  },
  {
    "Rank": "5458",
    "Name": "PTC India",
    "Symbol": "PTC.NS",
    " marketcap ": " $811 801 815 ",
    "price (USD)": "\u0444\u0435\u0432.25",
    "country": "India"
  },
  {
    "Rank": "5459",
    "Name": "Oeneo",
    "Symbol": "SBT.PA",
    " marketcap ": " $811 330 064 ",
    "price (USD)": "\u0434\u0435\u043a.78",
    "country": "France"
  },
  {
    "Rank": "5460",
    "Name": "Cardinal Energy",
    "Symbol": "CJ.TO",
    " marketcap ": " $810 708 522 ",
    "price (USD)": "5.09549",
    "country": "Canada"
  },
  {
    "Rank": "5461",
    "Name": "Jamieson Wellness",
    "Symbol": "JWEL.TO",
    " marketcap ": " $808 063 123 ",
    "price (USD)": "19.5022",
    "country": "Canada"
  },
  {
    "Rank": "5462",
    "Name": "7Road",
    "Symbol": "0797.HK",
    " marketcap ": " $807 904 276 ",
    "price (USD)": "0.293442",
    "country": "China"
  },
  {
    "Rank": "5463",
    "Name": "Protolabs",
    "Symbol": "PRLB",
    " marketcap ": " $807 583 552 ",
    "price (USD)": "31.9",
    "country": "United States"
  },
  {
    "Rank": "5464",
    "Name": "Juventus Turin",
    "Symbol": "JUVE.MI",
    " marketcap ": " $805 154 054 ",
    "price (USD)": "2.0708",
    "country": "Italy"
  },
  {
    "Rank": "5465",
    "Name": "Ryerson",
    "Symbol": "RYI",
    " marketcap ": " $804 831 168 ",
    "price (USD)": "23.44",
    "country": "United States"
  },
  {
    "Rank": "5466",
    "Name": "Arcturus Therapeutics",
    "Symbol": "ARCT",
    " marketcap ": " $803 914 240 ",
    "price (USD)": "29.85",
    "country": "United States"
  },
  {
    "Rank": "5467",
    "Name": "ACLEDA Bank",
    "Symbol": "ABC.KH",
    " marketcap ": " $803 456 089 ",
    "price (USD)": "\u044f\u043d\u0432.85",
    "country": "Cambodia"
  },
  {
    "Rank": "5468",
    "Name": "Dynex Capital",
    "Symbol": "DX",
    " marketcap ": " $802 652 864 ",
    "price (USD)": "\u0434\u0435\u043a.51",
    "country": "United States"
  },
  {
    "Rank": "5469",
    "Name": "MTY Food Group",
    "Symbol": "MTY.TO",
    " marketcap ": " $802 228 961 ",
    "price (USD)": "33.1977",
    "country": "Canada"
  },
  {
    "Rank": "5470",
    "Name": "The First Bancshares",
    "Symbol": "FBMS",
    " marketcap ": " $802 008 448 ",
    "price (USD)": "25.69",
    "country": "United States"
  },
  {
    "Rank": "5471",
    "Name": "AO World",
    "Symbol": "AO.L",
    " marketcap ": " $801 761 166 ",
    "price (USD)": "1.38576",
    "country": "United Kingdom"
  },
  {
    "Rank": "5472",
    "Name": "Reliance Infrastructure",
    "Symbol": "RELINFRA.NS",
    " marketcap ": " $800 139 187 ",
    "price (USD)": "2.02158",
    "country": "India"
  },
  {
    "Rank": "5473",
    "Name": "Stoke Therapeutics",
    "Symbol": "STOK",
    " marketcap ": " $800 040 512 ",
    "price (USD)": "15.35",
    "country": "United States"
  },
  {
    "Rank": "5474",
    "Name": "Mezzan Holding Company",
    "Symbol": "MEZZAN.KW",
    " marketcap ": " $799 831 186 ",
    "price (USD)": "2574.97",
    "country": "Kuwait"
  },
  {
    "Rank": "5475",
    "Name": "Energy Recovery",
    "Symbol": "ERII",
    " marketcap ": " $799 756 288 ",
    "price (USD)": "13.95",
    "country": "United States"
  },
  {
    "Rank": "5476",
    "Name": "Aurinia Pharmaceuticals",
    "Symbol": "AUPH",
    " marketcap ": " $799 476 288 ",
    "price (USD)": "\u043c\u0430\u0439.59",
    "country": "Canada"
  },
  {
    "Rank": "5477",
    "Name": "PureTech Health",
    "Symbol": "PRTC",
    " marketcap ": " $798 744 960 ",
    "price (USD)": "29.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5478",
    "Name": "DRDGOLD",
    "Symbol": "DRD",
    " marketcap ": " $798 381 056 ",
    "price (USD)": "\u0441\u0435\u043d.23",
    "country": "South Africa"
  },
  {
    "Rank": "5479",
    "Name": "Brookline Bancorp",
    "Symbol": "BRKL",
    " marketcap ": " $798 273 472 ",
    "price (USD)": "\u0430\u0432\u0433.98",
    "country": "United States"
  },
  {
    "Rank": "5480",
    "Name": "Tango Therapeutics",
    "Symbol": "TNGX",
    " marketcap ": " $798 139 584 ",
    "price (USD)": "\u0438\u044e\u043b.47",
    "country": "United States"
  },
  {
    "Rank": "5481",
    "Name": "ConnectOne Bancorp",
    "Symbol": "CNOB",
    " marketcap ": " $796 945 216 ",
    "price (USD)": "20.79",
    "country": "United States"
  },
  {
    "Rank": "5482",
    "Name": "Ambac",
    "Symbol": "AMBC",
    " marketcap ": " $796 412 288 ",
    "price (USD)": "17.61",
    "country": "United States"
  },
  {
    "Rank": "5483",
    "Name": "Paul Hartmann",
    "Symbol": "PHH2.F",
    " marketcap ": " $794 503 672 ",
    "price (USD)": "223.694",
    "country": "Germany"
  },
  {
    "Rank": "5484",
    "Name": "Atrion",
    "Symbol": "ATRI",
    " marketcap ": " $794 177 408 ",
    "price (USD)": "451.25",
    "country": "United States"
  },
  {
    "Rank": "5485",
    "Name": "National Building and Marketing Company",
    "Symbol": "9510.SR",
    " marketcap ": " $794 171 804 ",
    "price (USD)": "66.181",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5486",
    "Name": "Singapore Post",
    "Symbol": "S08.SI",
    " marketcap ": " $793 441 633 ",
    "price (USD)": "0.352649",
    "country": "Singapore"
  },
  {
    "Rank": "5487",
    "Name": "Longboard Pharmaceuticals",
    "Symbol": "LBPH",
    " marketcap ": " $793 154 048 ",
    "price (USD)": "20.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5488",
    "Name": "CEWE",
    "Symbol": "CWC.F",
    " marketcap ": " $792 798 071 ",
    "price (USD)": "112.281",
    "country": "Germany"
  },
  {
    "Rank": "5489",
    "Name": "Kelly Services",
    "Symbol": "KELYA",
    " marketcap ": " $792 117 824 ",
    "price (USD)": "22.25",
    "country": "United States"
  },
  {
    "Rank": "5490",
    "Name": "Borosil",
    "Symbol": "BORORENEW.NS",
    " marketcap ": " $790 424 136 ",
    "price (USD)": "6.05513",
    "country": "India"
  },
  {
    "Rank": "5491",
    "Name": "Monro",
    "Symbol": "MNRO",
    " marketcap ": " $790 312 512 ",
    "price (USD)": "26.43",
    "country": "United States"
  },
  {
    "Rank": "5492",
    "Name": "Cytek Biosciences",
    "Symbol": "CTKB",
    " marketcap ": " $790 263 488 ",
    "price (USD)": "06.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "5493",
    "Name": "Embecta",
    "Symbol": "EMBC",
    " marketcap ": " $789 505 024 ",
    "price (USD)": "13.69",
    "country": "United States"
  },
  {
    "Rank": "5494",
    "Name": "CARGO Therapeutics",
    "Symbol": "CRGX",
    " marketcap ": " $789 488 768 ",
    "price (USD)": "20.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5495",
    "Name": "Waha Capital Company",
    "Symbol": "WAHA.AE",
    " marketcap ": " $788 881 990 ",
    "price (USD)": "0.41",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5496",
    "Name": "Time Technoplast",
    "Symbol": "TIMETECHNO.NS",
    " marketcap ": " $788 133 236 ",
    "price (USD)": "3.47183",
    "country": "India"
  },
  {
    "Rank": "5497",
    "Name": "N\u0413\u0458rnberger Versicherung",
    "Symbol": "NBG6.F",
    " marketcap ": " $788 098 599 ",
    "price (USD)": "68.4113",
    "country": "Germany"
  },
  {
    "Rank": "5498",
    "Name": "CareDx",
    "Symbol": "CDNA",
    " marketcap ": " $788 027 904 ",
    "price (USD)": "15.13",
    "country": "United States"
  },
  {
    "Rank": "5499",
    "Name": "Westlake Chemical Partners",
    "Symbol": "WLKP",
    " marketcap ": " $787 348 032 ",
    "price (USD)": "22.35",
    "country": "United States"
  },
  {
    "Rank": "5500",
    "Name": "First Mid-Illinois Bancshares",
    "Symbol": "FMBH",
    " marketcap ": " $785 710 400 ",
    "price (USD)": "32.88",
    "country": "United States"
  },
  {
    "Rank": "5501",
    "Name": "OrthoPediatrics",
    "Symbol": "KIDS",
    " marketcap ": " $785 400 512 ",
    "price (USD)": "32.96",
    "country": "United States"
  },
  {
    "Rank": "5502",
    "Name": "About You",
    "Symbol": "YOU.DE",
    " marketcap ": " $784 849 743 ",
    "price (USD)": "4.50646",
    "country": "Germany"
  },
  {
    "Rank": "5503",
    "Name": "Patrizia Immobilien",
    "Symbol": "P1Z.VI",
    " marketcap ": " $782 098 556 ",
    "price (USD)": "9.11065",
    "country": "Germany"
  },
  {
    "Rank": "5504",
    "Name": "Grid Dynamics",
    "Symbol": "GDYN",
    " marketcap ": " $781 281 472 ",
    "price (USD)": "\u043e\u043a\u0442.21",
    "country": "United States"
  },
  {
    "Rank": "5505",
    "Name": "Amalgamated Financial",
    "Symbol": "AMAL",
    " marketcap ": " $781 109 184 ",
    "price (USD)": "25.59",
    "country": "United States"
  },
  {
    "Rank": "5506",
    "Name": "Community Trust Bancorp",
    "Symbol": "CTBI",
    " marketcap ": " $780 169 600 ",
    "price (USD)": "43.28",
    "country": "United States"
  },
  {
    "Rank": "5507",
    "Name": "Indus Holding",
    "Symbol": "INH.F",
    " marketcap ": " $780 114 549 ",
    "price (USD)": "30.2422",
    "country": "Germany"
  },
  {
    "Rank": "5508",
    "Name": "eMudhra",
    "Symbol": "EMUDHRA.NS",
    " marketcap ": " $779 533 295 ",
    "price (USD)": "\u0441\u0435\u043d.74",
    "country": "India"
  },
  {
    "Rank": "5509",
    "Name": "Savencia Fromage &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5510",
    "Name": "EuroGroup Laminations",
    "Symbol": "EGLA.MI",
    " marketcap ": " $777 384 281 ",
    "price (USD)": "4.77576",
    "country": "Italy"
  },
  {
    "Rank": "5511",
    "Name": "Sunteck Realty",
    "Symbol": "SUNTECK.NS",
    " marketcap ": " $776 716 879 ",
    "price (USD)": "5.29936",
    "country": "India"
  },
  {
    "Rank": "5512",
    "Name": "Tata Coffee",
    "Symbol": "TATACOFFEE.NS",
    " marketcap ": " $775 520 278 ",
    "price (USD)": "\u0430\u043f\u0440.15",
    "country": "India"
  },
  {
    "Rank": "5513",
    "Name": "Amerant Bancorp",
    "Symbol": "AMTB",
    " marketcap ": " $774 114 752 ",
    "price (USD)": "22.96",
    "country": "United States"
  },
  {
    "Rank": "5514",
    "Name": "Wave Life Sciences",
    "Symbol": "WVE",
    " marketcap ": " $773 947 200 ",
    "price (USD)": "\u0438\u044e\u043d.32",
    "country": "Singapore"
  },
  {
    "Rank": "5515",
    "Name": "Centrus Energy",
    "Symbol": "LEU",
    " marketcap ": " $772 975 040 ",
    "price (USD)": "48.32",
    "country": "United States"
  },
  {
    "Rank": "5516",
    "Name": "Disc Medicine",
    "Symbol": "IRON",
    " marketcap ": " $772 800 320 ",
    "price (USD)": "31.26",
    "country": "United States"
  },
  {
    "Rank": "5517",
    "Name": "AMTD Digital",
    "Symbol": "HKD",
    " marketcap ": " $772 419 712 ",
    "price (USD)": "04.\u0430\u043f\u0440",
    "country": "Hong Kong"
  },
  {
    "Rank": "5518",
    "Name": "Eastern Province Cement Company",
    "Symbol": "3080.SR",
    " marketcap ": " $772 262 704 ",
    "price (USD)": "\u0430\u0432\u0433.98",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5519",
    "Name": "Universal Technical Institute",
    "Symbol": "UTI",
    " marketcap ": " $772 051 520 ",
    "price (USD)": "14.35",
    "country": "United States"
  },
  {
    "Rank": "5520",
    "Name": "Capital A (Air Asia)",
    "Symbol": "5099.KL",
    " marketcap ": " $770 661 233 ",
    "price (USD)": "0.181102",
    "country": "Malaysia"
  },
  {
    "Rank": "5521",
    "Name": "TomTom",
    "Symbol": "TOM2.AS",
    " marketcap ": " $769 303 907 ",
    "price (USD)": "6.02671",
    "country": "Netherlands"
  },
  {
    "Rank": "5522",
    "Name": "Icosavax",
    "Symbol": "ICVX",
    " marketcap ": " $769 036 608 ",
    "price (USD)": "15.31",
    "country": "United States"
  },
  {
    "Rank": "5523",
    "Name": "Dime Community Bancshares",
    "Symbol": "DCOM",
    " marketcap ": " $768 490 368 ",
    "price (USD)": "19.72",
    "country": "United States"
  },
  {
    "Rank": "5524",
    "Name": "Clairvest Group",
    "Symbol": "CVG.TO",
    " marketcap ": " $768 190 646 ",
    "price (USD)": "52.348",
    "country": "Canada"
  },
  {
    "Rank": "5525",
    "Name": "Beyond, Inc.",
    "Symbol": "BYON",
    " marketcap ": " $767 942 720 ",
    "price (USD)": "16.79",
    "country": "United States"
  },
  {
    "Rank": "5526",
    "Name": "Sumitomo Pharma",
    "Symbol": "4506.T",
    " marketcap ": " $767 589 309 ",
    "price (USD)": "1.93206",
    "country": "Japan"
  },
  {
    "Rank": "5527",
    "Name": "Grieg Seafood",
    "Symbol": "GSF.OL",
    " marketcap ": " $766 336 715 ",
    "price (USD)": "6.83418",
    "country": "Norway"
  },
  {
    "Rank": "5528",
    "Name": "Xometry",
    "Symbol": "XMTR",
    " marketcap ": " $766 155 264 ",
    "price (USD)": "15.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5529",
    "Name": "Praxis Precision Medicines",
    "Symbol": "PRAX",
    " marketcap ": " $765 920 704 ",
    "price (USD)": "44.77",
    "country": "United States"
  },
  {
    "Rank": "5530",
    "Name": "Astec Industries",
    "Symbol": "ASTE",
    " marketcap ": " $764 003 520 ",
    "price (USD)": "33.56",
    "country": "United States"
  },
  {
    "Rank": "5531",
    "Name": "Thryv",
    "Symbol": "THRY",
    " marketcap ": " $763 912 640 ",
    "price (USD)": "21.32",
    "country": "United States"
  },
  {
    "Rank": "5532",
    "Name": "Alpha &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5533",
    "Name": "Kingsoft Cloud",
    "Symbol": "KC",
    " marketcap ": " $762 764 160 ",
    "price (USD)": "\u043c\u0430\u0440.19",
    "country": "China"
  },
  {
    "Rank": "5534",
    "Name": "u-blox",
    "Symbol": "UBXN.SW",
    " marketcap ": " $762 530 739 ",
    "price (USD)": "104.465",
    "country": "Switzerland"
  },
  {
    "Rank": "5535",
    "Name": "Vaibhav Global",
    "Symbol": "VAIBHAVGBL.NS",
    " marketcap ": " $762 065 486 ",
    "price (USD)": "4.60187",
    "country": "India"
  },
  {
    "Rank": "5536",
    "Name": "Theeb Rent A Car Company",
    "Symbol": "4261.SR",
    " marketcap ": " $761 935 260 ",
    "price (USD)": "17.7194",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5537",
    "Name": "CrossAmerica Partners",
    "Symbol": "CAPL",
    " marketcap ": " $761 304 576 ",
    "price (USD)": "20.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "5538",
    "Name": "Canopy Growth",
    "Symbol": "CGC",
    " marketcap ": " $760 725 888 ",
    "price (USD)": "10.\u043d\u043e\u044f",
    "country": "Canada"
  },
  {
    "Rank": "5539",
    "Name": "Jazeera Airways",
    "Symbol": "JAZEERA.KW",
    " marketcap ": " $760 104 302 ",
    "price (USD)": "3455.02",
    "country": "Kuwait"
  },
  {
    "Rank": "5540",
    "Name": "Sterlite Technologies",
    "Symbol": "STLTECH.NS",
    " marketcap ": " $759 884 237 ",
    "price (USD)": "1.55839",
    "country": "India"
  },
  {
    "Rank": "5541",
    "Name": "Blend Labs",
    "Symbol": "BLND",
    " marketcap ": " $759 657 792 ",
    "price (USD)": "03.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "5542",
    "Name": "B&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5543",
    "Name": "Cogent Biosciences",
    "Symbol": "COGT",
    " marketcap ": " $757 258 112 ",
    "price (USD)": "\u0438\u044e\u043b.92",
    "country": "United States"
  },
  {
    "Rank": "5544",
    "Name": "NGL Energy Partners",
    "Symbol": "NGL",
    " marketcap ": " $756 649 216 ",
    "price (USD)": "\u043c\u0430\u0439.71",
    "country": "United States"
  },
  {
    "Rank": "5545",
    "Name": "Maharah for Human Resources Company",
    "Symbol": "1831.SR",
    " marketcap ": " $755 343 873 ",
    "price (USD)": "1.67854",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5546",
    "Name": "Chow Sang Sang Holdings",
    "Symbol": "0116.HK",
    " marketcap ": " $755 218 911 ",
    "price (USD)": "1.11482",
    "country": "Hong Kong"
  },
  {
    "Rank": "5547",
    "Name": "REGENXBIO",
    "Symbol": "RGNX",
    " marketcap ": " $755 094 464 ",
    "price (USD)": "15.33",
    "country": "United States"
  },
  {
    "Rank": "5548",
    "Name": "Astronics Corporation",
    "Symbol": "ATRO",
    " marketcap ": " $754 925 120 ",
    "price (USD)": "21.75",
    "country": "United States"
  },
  {
    "Rank": "5549",
    "Name": "Softchoice",
    "Symbol": "SFTC.TO",
    " marketcap ": " $754 138 847 ",
    "price (USD)": "\u0434\u0435\u043a.05",
    "country": "Canada"
  },
  {
    "Rank": "5550",
    "Name": "Surya Roshni",
    "Symbol": "SURYAROSNI.NS",
    " marketcap ": " $753 482 769 ",
    "price (USD)": "6.94486",
    "country": "India"
  },
  {
    "Rank": "5551",
    "Name": "Haynes International",
    "Symbol": "HAYN",
    " marketcap ": " $753 424 128 ",
    "price (USD)": "58.94",
    "country": "United States"
  },
  {
    "Rank": "5552",
    "Name": "Nabors Industries",
    "Symbol": "NBR",
    " marketcap ": " $753 201 152 ",
    "price (USD)": "78.95",
    "country": "Bermuda"
  },
  {
    "Rank": "5553",
    "Name": "Conduent",
    "Symbol": "CNDT",
    " marketcap ": " $752 865 472 ",
    "price (USD)": "\u043c\u0430\u0440.68",
    "country": "United States"
  },
  {
    "Rank": "5554",
    "Name": "PennantPark Floating Rate",
    "Symbol": "PFLT",
    " marketcap ": " $752 692 928 ",
    "price (USD)": "\u043d\u043e\u044f.28",
    "country": "United States"
  },
  {
    "Rank": "5555",
    "Name": "Clear Channel Outdoor",
    "Symbol": "CCO",
    " marketcap ": " $752 608 768 ",
    "price (USD)": "\u044f\u043d\u0432.54",
    "country": "United States"
  },
  {
    "Rank": "5556",
    "Name": "Aktia Bank",
    "Symbol": "AKTIA.HE",
    " marketcap ": " $752 119 257 ",
    "price (USD)": "\u043e\u043a\u0442.77",
    "country": "Finland"
  },
  {
    "Rank": "5557",
    "Name": "Premier Financial",
    "Symbol": "PFC",
    " marketcap ": " $752 075 072 ",
    "price (USD)": "21",
    "country": "United States"
  },
  {
    "Rank": "5558",
    "Name": "Open Lending",
    "Symbol": "LPRO",
    " marketcap ": " $751 931 136 ",
    "price (USD)": "\u0438\u044e\u043d.31",
    "country": "United States"
  },
  {
    "Rank": "5559",
    "Name": "Olo",
    "Symbol": "OLO",
    " marketcap ": " $751 219 520 ",
    "price (USD)": "\u0430\u043f\u0440.68",
    "country": "United States"
  },
  {
    "Rank": "5560",
    "Name": "Converge Technology Solutions",
    "Symbol": "CTS.TO",
    " marketcap ": " $750 272 664 ",
    "price (USD)": "\u043c\u0430\u0440.38",
    "country": "Canada"
  },
  {
    "Rank": "5561",
    "Name": "Viad",
    "Symbol": "VVI",
    " marketcap ": " $748 994 688 ",
    "price (USD)": "35.45",
    "country": "United States"
  },
  {
    "Rank": "5562",
    "Name": "Sturm, Ruger &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5563",
    "Name": "Yalla Group",
    "Symbol": "YALA",
    " marketcap ": " $745 095 552 ",
    "price (USD)": "\u0430\u043f\u0440.69",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5564",
    "Name": "Phibro Animal Health",
    "Symbol": "PAHC",
    " marketcap ": " $744 051 136 ",
    "price (USD)": "18.37",
    "country": "United States"
  },
  {
    "Rank": "5565",
    "Name": "NRC Health",
    "Symbol": "NRC",
    " marketcap ": " $743 777 856 ",
    "price (USD)": "31.15",
    "country": "United States"
  },
  {
    "Rank": "5566",
    "Name": "Nexity",
    "Symbol": "NXI.PA",
    " marketcap ": " $742 855 137 ",
    "price (USD)": "13.4434",
    "country": "France"
  },
  {
    "Rank": "5567",
    "Name": "ProAssurance",
    "Symbol": "PRA",
    " marketcap ": " $741 205 824 ",
    "price (USD)": "14.53",
    "country": "United States"
  },
  {
    "Rank": "5568",
    "Name": "Astra Agro Lestari",
    "Symbol": "AALI.JK",
    " marketcap ": " $740 080 273 ",
    "price (USD)": "0.384519",
    "country": "Indonesia"
  },
  {
    "Rank": "5569",
    "Name": "City Cement Company",
    "Symbol": "3003.SR",
    " marketcap ": " $739 732 607 ",
    "price (USD)": "\u043c\u0430\u0439.38",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5570",
    "Name": "Ethan Allen",
    "Symbol": "ETD",
    " marketcap ": " $738 978 048 ",
    "price (USD)": "29.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "5571",
    "Name": "Digital Garage",
    "Symbol": "4819.T",
    " marketcap ": " $738 684 929 ",
    "price (USD)": "15.5908",
    "country": "Japan"
  },
  {
    "Rank": "5572",
    "Name": "Curevac",
    "Symbol": "CVAC",
    " marketcap ": " $737 966 720 ",
    "price (USD)": "\u043c\u0430\u0440.29",
    "country": "Germany"
  },
  {
    "Rank": "5573",
    "Name": "Emirates Stallions Group (ESG)",
    "Symbol": "ESG.AE",
    " marketcap ": " $737 876 766 ",
    "price (USD)": "\u0444\u0435\u0432.95",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5574",
    "Name": "Trinity Capital",
    "Symbol": "TRIN",
    " marketcap ": " $737 229 632 ",
    "price (USD)": "14.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "5575",
    "Name": "DEUTZ",
    "Symbol": "DEZ.DE",
    " marketcap ": " $736 964 761 ",
    "price (USD)": "5.84211",
    "country": "Germany"
  },
  {
    "Rank": "5576",
    "Name": "ChargePoint",
    "Symbol": "CHPT",
    " marketcap ": " $736 646 400 ",
    "price (USD)": "\u044f\u043d\u0432.74",
    "country": "United States"
  },
  {
    "Rank": "5577",
    "Name": "Ponsse",
    "Symbol": "PON1V.HE",
    " marketcap ": " $735 234 349 ",
    "price (USD)": "26.2786",
    "country": "Finland"
  },
  {
    "Rank": "5578",
    "Name": "Tian An China Investments Company",
    "Symbol": "0028.HK",
    " marketcap ": " $734 544 528 ",
    "price (USD)": "0.50103",
    "country": "Hong Kong"
  },
  {
    "Rank": "5579",
    "Name": "Ramaco Resources",
    "Symbol": "METC",
    " marketcap ": " $734 124 544 ",
    "price (USD)": "14.39",
    "country": "United States"
  },
  {
    "Rank": "5580",
    "Name": "JOST Werke SE",
    "Symbol": "JST.DE",
    " marketcap ": " $733 755 031 ",
    "price (USD)": "49.2453",
    "country": "Germany"
  },
  {
    "Rank": "5581",
    "Name": "Medgulf (The Mediterranean and Gulf Cooperative Insurance and Reinsurance Company)",
    "Symbol": "8030.SR",
    " marketcap ": " $732 727 568 ",
    "price (USD)": "6.97836",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5582",
    "Name": "Sky Harbour Group",
    "Symbol": "SKYH",
    " marketcap ": " $731 537 728 ",
    "price (USD)": "\u043e\u043a\u0442.97",
    "country": "United States"
  },
  {
    "Rank": "5583",
    "Name": "New Found Gold",
    "Symbol": "NFGC",
    " marketcap ": " $731 219 136 ",
    "price (USD)": "\u043c\u0430\u0440.86",
    "country": "Canada"
  },
  {
    "Rank": "5584",
    "Name": "Smith &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5585",
    "Name": "VA Tech Wabag",
    "Symbol": "WABAG.NS",
    " marketcap ": " $729 902 384 ",
    "price (USD)": "\u043d\u043e\u044f.66",
    "country": "India"
  },
  {
    "Rank": "5586",
    "Name": "Nikola",
    "Symbol": "NKLA",
    " marketcap ": " $729 688 192 ",
    "price (USD)": "0.5379",
    "country": "United States"
  },
  {
    "Rank": "5587",
    "Name": "Koh Young Technology",
    "Symbol": "098460.KQ",
    " marketcap ": " $729 608 574 ",
    "price (USD)": "11.0894",
    "country": "South Korea"
  },
  {
    "Rank": "5588",
    "Name": "Vitesse Energy",
    "Symbol": "VTS",
    " marketcap ": " $729 300 864 ",
    "price (USD)": "24.76",
    "country": "United States"
  },
  {
    "Rank": "5589",
    "Name": "AMC Networks",
    "Symbol": "AMCX",
    " marketcap ": " $726 714 432 ",
    "price (USD)": "16.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5590",
    "Name": "Al Meera Consumer Goods Company",
    "Symbol": "MERS.QA",
    " marketcap ": " $726 093 433 ",
    "price (USD)": "3.52473",
    "country": "Qatar"
  },
  {
    "Rank": "5591",
    "Name": "Sage Therapeutics",
    "Symbol": "SAGE",
    " marketcap ": " $725 193 088 ",
    "price (USD)": "12.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5592",
    "Name": "Saudi Ceramic Company",
    "Symbol": "2040.SR",
    " marketcap ": " $724 788 514 ",
    "price (USD)": "9.05986",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5593",
    "Name": "PropertyGuru",
    "Symbol": "PGRU",
    " marketcap ": " $723 032 640 ",
    "price (USD)": "\u0430\u043f\u0440.41",
    "country": "Singapore"
  },
  {
    "Rank": "5594",
    "Name": "World Acceptance Corporation",
    "Symbol": "WRLD",
    " marketcap ": " $722 512 000 ",
    "price (USD)": "129.02",
    "country": "United States"
  },
  {
    "Rank": "5595",
    "Name": "HilleVax",
    "Symbol": "HLVX",
    " marketcap ": " $722 444 672 ",
    "price (USD)": "14.53",
    "country": "United States"
  },
  {
    "Rank": "5596",
    "Name": "Amanat Holdings",
    "Symbol": "AMANAT.AE",
    " marketcap ": " $722 191 077 ",
    "price (USD)": "0.291339",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5597",
    "Name": "Paisalo Digital",
    "Symbol": "PAISALO.NS",
    " marketcap ": " $720 896 223 ",
    "price (USD)": "0.802624",
    "country": "India"
  },
  {
    "Rank": "5598",
    "Name": "Abacus Life",
    "Symbol": "ABL",
    " marketcap ": " $719 159 616 ",
    "price (USD)": "\u043d\u043e\u044f.25",
    "country": "United States"
  },
  {
    "Rank": "5599",
    "Name": "WalkMe",
    "Symbol": "WKME",
    " marketcap ": " $718 941 888 ",
    "price (USD)": "\u0438\u044e\u043b.82",
    "country": "Israel"
  },
  {
    "Rank": "5600",
    "Name": "Montauk Renewables",
    "Symbol": "MNTK",
    " marketcap ": " $718 489 984 ",
    "price (USD)": "5",
    "country": "United States"
  },
  {
    "Rank": "5601",
    "Name": "Cresco Labs",
    "Symbol": "CRLBF",
    " marketcap ": " $718 279 808 ",
    "price (USD)": "02.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "5602",
    "Name": "Core Scientific",
    "Symbol": "CORZ",
    " marketcap ": " $718 243 328 ",
    "price (USD)": "04.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5603",
    "Name": "Associated Capital Group",
    "Symbol": "AC",
    " marketcap ": " $718 016 960 ",
    "price (USD)": "33.55",
    "country": "United States"
  },
  {
    "Rank": "5604",
    "Name": "Heidrick &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5605",
    "Name": "Ataa Educational Company",
    "Symbol": "4292.SR",
    " marketcap ": " $716 559 460 ",
    "price (USD)": "17.0256",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5606",
    "Name": "Fission Uranium",
    "Symbol": "FCU.TO",
    " marketcap ": " $716 431 705 ",
    "price (USD)": "0.850471",
    "country": "Canada"
  },
  {
    "Rank": "5607",
    "Name": "India Tourism Development Corp",
    "Symbol": "ITDC.NS",
    " marketcap ": " $715 560 846 ",
    "price (USD)": "8.34285",
    "country": "India"
  },
  {
    "Rank": "5608",
    "Name": "Bpost",
    "Symbol": "13B.F",
    " marketcap ": " $714 521 950 ",
    "price (USD)": "3.57259",
    "country": "Belgium"
  },
  {
    "Rank": "5609",
    "Name": "Silvercorp Metals",
    "Symbol": "SVM",
    " marketcap ": " $714 352 768 ",
    "price (USD)": "04.\u0430\u043f\u0440",
    "country": "Canada"
  },
  {
    "Rank": "5610",
    "Name": "Lassonde Industries",
    "Symbol": "LAS-A.TO",
    " marketcap ": " $714 145 733 ",
    "price (USD)": "104.689",
    "country": "Canada"
  },
  {
    "Rank": "5611",
    "Name": "Luminar Technologies",
    "Symbol": "LAZR",
    " marketcap ": " $712 998 400 ",
    "price (USD)": "01.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "5612",
    "Name": "Schweiter Technologies",
    "Symbol": "SWTQ.SW",
    " marketcap ": " $711 733 570 ",
    "price (USD)": "497.087",
    "country": "Switzerland"
  },
  {
    "Rank": "5613",
    "Name": "SpartanNash",
    "Symbol": "SPTN",
    " marketcap ": " $711 710 528 ",
    "price (USD)": "20.65",
    "country": "United States"
  },
  {
    "Rank": "5614",
    "Name": "The Pennant Group",
    "Symbol": "PNTG",
    " marketcap ": " $711 484 544 ",
    "price (USD)": "23.68",
    "country": "United States"
  },
  {
    "Rank": "5615",
    "Name": "Alujain Corporation",
    "Symbol": "2170.SR",
    " marketcap ": " $710 965 211 ",
    "price (USD)": "\u043e\u043a\u0442.41",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5616",
    "Name": "Gokaldas Exports",
    "Symbol": "GOKEX.NS",
    " marketcap ": " $710 227 980 ",
    "price (USD)": "9.96972",
    "country": "India"
  },
  {
    "Rank": "5617",
    "Name": "ALX Oncology",
    "Symbol": "ALXO",
    " marketcap ": " $709 603 328 ",
    "price (USD)": "13.62",
    "country": "United States"
  },
  {
    "Rank": "5618",
    "Name": "PDS Multinational",
    "Symbol": "PDSL.NS",
    " marketcap ": " $709 336 601 ",
    "price (USD)": "5.35643",
    "country": "India"
  },
  {
    "Rank": "5619",
    "Name": "Energy Resources of Australia",
    "Symbol": "ERA.AX",
    " marketcap ": " $708 896 874 ",
    "price (USD)": "0.0320068",
    "country": "Australia"
  },
  {
    "Rank": "5620",
    "Name": "Gujarat Alkalies and Chemicals",
    "Symbol": "GUJALKALI.NS",
    " marketcap ": " $708 056 771 ",
    "price (USD)": "\u0441\u0435\u043d.17",
    "country": "India"
  },
  {
    "Rank": "5621",
    "Name": "Kornit Digital",
    "Symbol": "KRNT",
    " marketcap ": " $706 482 432 ",
    "price (USD)": "14.\u0430\u0432\u0433",
    "country": "Israel"
  },
  {
    "Rank": "5622",
    "Name": "Nitta Corporation",
    "Symbol": "5186.T",
    " marketcap ": " $705 938 783 ",
    "price (USD)": "25.3023",
    "country": "Japan"
  },
  {
    "Rank": "5623",
    "Name": "Malibu Boats",
    "Symbol": "MBUU",
    " marketcap ": " $705 779 392 ",
    "price (USD)": "34.53",
    "country": "United States"
  },
  {
    "Rank": "5624",
    "Name": "Interfor",
    "Symbol": "IFP.TO",
    " marketcap ": " $705 722 057 ",
    "price (USD)": "13.7175",
    "country": "Canada"
  },
  {
    "Rank": "5625",
    "Name": "Saudi Industrial Services Company",
    "Symbol": "2190.SR",
    " marketcap ": " $705 415 573 ",
    "price (USD)": "8.67291",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5626",
    "Name": "TPG Real Estate Finance Trust",
    "Symbol": "TRTX",
    " marketcap ": " $704 545 664 ",
    "price (USD)": "\u0430\u0432\u0433.75",
    "country": "United States"
  },
  {
    "Rank": "5627",
    "Name": "Azul",
    "Symbol": "AZUL",
    " marketcap ": " $704 124 800 ",
    "price (USD)": "06.\u0430\u0432\u0433",
    "country": "Brazil"
  },
  {
    "Rank": "5628",
    "Name": "West Holdings",
    "Symbol": "1407.T",
    " marketcap ": " $703 923 669 ",
    "price (USD)": "17.4845",
    "country": "Japan"
  },
  {
    "Rank": "5629",
    "Name": "Hawaiian Airlines",
    "Symbol": "HA",
    " marketcap ": " $703 589 568 ",
    "price (USD)": "13.57",
    "country": "United States"
  },
  {
    "Rank": "5630",
    "Name": "Bitfarms",
    "Symbol": "BITF",
    " marketcap ": " $703 148 096 ",
    "price (USD)": "\u044f\u043d\u0432.87",
    "country": "Canada"
  },
  {
    "Rank": "5631",
    "Name": "CBL Properties",
    "Symbol": "CBL",
    " marketcap ": " $703 105 152 ",
    "price (USD)": "22.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "5632",
    "Name": "Bawan Company",
    "Symbol": "1302.SR",
    " marketcap ": " $701 304 940 ",
    "price (USD)": "\u043d\u043e\u044f.84",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5633",
    "Name": "Placoplatre",
    "Symbol": "MLPLC.PA",
    " marketcap ": " $700 402 823 ",
    "price (USD)": "536.432",
    "country": "France"
  },
  {
    "Rank": "5634",
    "Name": "Tompkins Financial",
    "Symbol": "TMP",
    " marketcap ": " $699 194 432 ",
    "price (USD)": "48.54",
    "country": "United States"
  },
  {
    "Rank": "5635",
    "Name": "BML, Inc.",
    "Symbol": "4694.T",
    " marketcap ": " $698 326 947 ",
    "price (USD)": "17.9131",
    "country": "Japan"
  },
  {
    "Rank": "5636",
    "Name": "Bitdeer Technologies Group",
    "Symbol": "BTDR",
    " marketcap ": " $698 024 192 ",
    "price (USD)": "\u043c\u0430\u0439.91",
    "country": "Singapore"
  },
  {
    "Rank": "5637",
    "Name": "Kl\u0413\u00b6ckner &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5638",
    "Name": "Capitol Federal Savings Bank",
    "Symbol": "CFFN",
    " marketcap ": " $696 853 504 ",
    "price (USD)": "\u043c\u0430\u0439.25",
    "country": "United States"
  },
  {
    "Rank": "5639",
    "Name": "Oatly",
    "Symbol": "OTLY",
    " marketcap ": " $696 220 160 ",
    "price (USD)": "\u044f\u043d\u0432.17",
    "country": "Sweden"
  },
  {
    "Rank": "5640",
    "Name": "LSB Industries",
    "Symbol": "LXU",
    " marketcap ": " $695 404 736 ",
    "price (USD)": "\u0441\u0435\u043d.72",
    "country": "United States"
  },
  {
    "Rank": "5641",
    "Name": "Implenia AG",
    "Symbol": "IMPN.SW",
    " marketcap ": " $693 299 413 ",
    "price (USD)": "38.0771",
    "country": "Switzerland"
  },
  {
    "Rank": "5642",
    "Name": "Eagle Bulk Shipping",
    "Symbol": "EGLE",
    " marketcap ": " $693 163 520 ",
    "price (USD)": "62.6",
    "country": "United States"
  },
  {
    "Rank": "5643",
    "Name": "Rain Industries",
    "Symbol": "RAIN.NS",
    " marketcap ": " $693 081 888 ",
    "price (USD)": "2.05943",
    "country": "India"
  },
  {
    "Rank": "5644",
    "Name": "TXO Energy Partners",
    "Symbol": "TXO",
    " marketcap ": " $693 017 920 ",
    "price (USD)": "22.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5645",
    "Name": "Sundaram Finance",
    "Symbol": "SUNDARMHLD.NS",
    " marketcap ": " $692 620 844 ",
    "price (USD)": "3.1384",
    "country": "India"
  },
  {
    "Rank": "5646",
    "Name": "Martinrea International",
    "Symbol": "MRE.TO",
    " marketcap ": " $692 600 075 ",
    "price (USD)": "9.02526",
    "country": "Canada"
  },
  {
    "Rank": "5647",
    "Name": "Olvi plc",
    "Symbol": "OLVAS.HE",
    " marketcap ": " $691 185 475 ",
    "price (USD)": "33.3912",
    "country": "Finland"
  },
  {
    "Rank": "5648",
    "Name": "Sligro Food",
    "Symbol": "SLIGR.AS",
    " marketcap ": " $689 016 467 ",
    "price (USD)": "15.5934",
    "country": "Netherlands"
  },
  {
    "Rank": "5649",
    "Name": "Baladna",
    "Symbol": "BLDN.QA",
    " marketcap ": " $688 851 341 ",
    "price (USD)": "0.362363",
    "country": "Qatar"
  },
  {
    "Rank": "5650",
    "Name": "Sudarshan Chemical",
    "Symbol": "SUDARSCHEM.NS",
    " marketcap ": " $688 426 463 ",
    "price (USD)": "9.93968",
    "country": "India"
  },
  {
    "Rank": "5651",
    "Name": "Ethos Watches",
    "Symbol": "ETHOSLTD.NS",
    " marketcap ": " $688 170 300 ",
    "price (USD)": "28.1111",
    "country": "India"
  },
  {
    "Rank": "5652",
    "Name": "Navitas Semiconductor",
    "Symbol": "NVTS",
    " marketcap ": " $686 628 736 ",
    "price (USD)": "\u043c\u0430\u0440.75",
    "country": "Ireland"
  },
  {
    "Rank": "5653",
    "Name": "Cellcom Israel",
    "Symbol": "CEL.TA",
    " marketcap ": " $685 807 400 ",
    "price (USD)": "4.14212",
    "country": "Israel"
  },
  {
    "Rank": "5654",
    "Name": "Canaccord Genuity Group",
    "Symbol": "CF.TO",
    " marketcap ": " $684 781 325 ",
    "price (USD)": "6.70113",
    "country": "Canada"
  },
  {
    "Rank": "5655",
    "Name": "Allied Group Limited",
    "Symbol": "0373.HK",
    " marketcap ": " $684 372 277 ",
    "price (USD)": "0.194774",
    "country": "Hong Kong"
  },
  {
    "Rank": "5656",
    "Name": "Yext",
    "Symbol": "YEXT",
    " marketcap ": " $684 120 256 ",
    "price (USD)": "\u043c\u0430\u0439.43",
    "country": "United States"
  },
  {
    "Rank": "5657",
    "Name": "Pharma Mar",
    "Symbol": "PHM.MC",
    " marketcap ": " $683 678 593 ",
    "price (USD)": "39.0705",
    "country": "Spain"
  },
  {
    "Rank": "5658",
    "Name": "Invictus Investment Company",
    "Symbol": "INVICTUS.AE",
    " marketcap ": " $683 094 181 ",
    "price (USD)": "0.61",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5659",
    "Name": "CSB Bank",
    "Symbol": "CSBBANK.NS",
    " marketcap ": " $682 512 419 ",
    "price (USD)": "4.03355",
    "country": "India"
  },
  {
    "Rank": "5660",
    "Name": "IFB Industries",
    "Symbol": "IFBIND.NS",
    " marketcap ": " $682 510 598 ",
    "price (USD)": "16.8443",
    "country": "India"
  },
  {
    "Rank": "5661",
    "Name": "RAK Ceramics",
    "Symbol": "RAKCEC.AE",
    " marketcap ": " $681 823 719 ",
    "price (USD)": "0.69",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5662",
    "Name": "Yanlord",
    "Symbol": "Z25.SI",
    " marketcap ": " $681 154 810 ",
    "price (USD)": "0.352649",
    "country": "Singapore"
  },
  {
    "Rank": "5663",
    "Name": "International Money Express",
    "Symbol": "IMXI",
    " marketcap ": " $680 868 352 ",
    "price (USD)": "20.86",
    "country": "United States"
  },
  {
    "Rank": "5664",
    "Name": "Newpark Resources",
    "Symbol": "NR",
    " marketcap ": " $680 760 768 ",
    "price (USD)": "\u0438\u044e\u043b.99",
    "country": "United States"
  },
  {
    "Rank": "5665",
    "Name": "Spandana Sphoorty Financial",
    "Symbol": "SPANDANA.NS",
    " marketcap ": " $680 477 240 ",
    "price (USD)": "9.54318",
    "country": "India"
  },
  {
    "Rank": "5666",
    "Name": "TeraWulf",
    "Symbol": "WULF",
    " marketcap ": " $679 691 328 ",
    "price (USD)": "02.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5667",
    "Name": "loanDepot",
    "Symbol": "LDI",
    " marketcap ": " $679 539 008 ",
    "price (USD)": "02.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "5668",
    "Name": "Standard Motor Products (SMP)",
    "Symbol": "SMP",
    " marketcap ": " $679 091 584 ",
    "price (USD)": "31.13",
    "country": "United States"
  },
  {
    "Rank": "5669",
    "Name": "Suprajit Engineering",
    "Symbol": "SUPRAJIT.NS",
    " marketcap ": " $679 016 348 ",
    "price (USD)": "4.89505",
    "country": "India"
  },
  {
    "Rank": "5670",
    "Name": "adesso SE",
    "Symbol": "ADN1.DE",
    " marketcap ": " $679 003 027 ",
    "price (USD)": "104.137",
    "country": "Germany"
  },
  {
    "Rank": "5671",
    "Name": "Miller Industries",
    "Symbol": "MLR",
    " marketcap ": " $678 450 496 ",
    "price (USD)": "59.15",
    "country": "United States"
  },
  {
    "Rank": "5672",
    "Name": "IFA Hotels and Resorts",
    "Symbol": "IFAHR.KW",
    " marketcap ": " $678 206 884 ",
    "price (USD)": "3699.48",
    "country": "Kuwait"
  },
  {
    "Rank": "5673",
    "Name": "Diversified Energy",
    "Symbol": "DEC.L",
    " marketcap ": " $678 071 729 ",
    "price (USD)": "14.2772",
    "country": "United States"
  },
  {
    "Rank": "5674",
    "Name": "Telkom SA",
    "Symbol": "TKG.JO",
    " marketcap ": " $676 589 500 ",
    "price (USD)": "1.37598",
    "country": "South Africa"
  },
  {
    "Rank": "5675",
    "Name": "Omega Flex",
    "Symbol": "OFLX",
    " marketcap ": " $676 166 720 ",
    "price (USD)": "66.985",
    "country": "United States"
  },
  {
    "Rank": "5676",
    "Name": "E7 Group PJSC",
    "Symbol": "E7.AE",
    " marketcap ": " $674 467 013 ",
    "price (USD)": "0.32",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5677",
    "Name": "Saudi Advanced Industries Company",
    "Symbol": "2120.SR",
    " marketcap ": " $673 871 820 ",
    "price (USD)": "\u043d\u043e\u044f.16",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5678",
    "Name": "Glass House Brands",
    "Symbol": "GLASF",
    " marketcap ": " $673 120 000 ",
    "price (USD)": "\u0441\u0435\u043d.49",
    "country": "United States"
  },
  {
    "Rank": "5679",
    "Name": "Bioceres Crop Solutions",
    "Symbol": "BIOX",
    " marketcap ": " $672 932 672 ",
    "price (USD)": "11.\u043d\u043e\u044f",
    "country": "Argentina"
  },
  {
    "Rank": "5680",
    "Name": "KKR Real Estate Finance Trust",
    "Symbol": "KREF",
    " marketcap ": " $672 344 832 ",
    "price (USD)": "09.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5681",
    "Name": "Patriot Battery Metals",
    "Symbol": "PMET.V",
    " marketcap ": " $672 164 241 ",
    "price (USD)": "05.\u044f\u043d\u0432",
    "country": "Canada"
  },
  {
    "Rank": "5682",
    "Name": "Property For Industry",
    "Symbol": "PFI.NZ",
    " marketcap ": " $670 747 369 ",
    "price (USD)": "1.33562",
    "country": "New Zealand"
  },
  {
    "Rank": "5683",
    "Name": "MBB SE",
    "Symbol": "MBB.DE",
    " marketcap ": " $670 469 532 ",
    "price (USD)": "115.974",
    "country": "Germany"
  },
  {
    "Rank": "5684",
    "Name": "Vimeo",
    "Symbol": "VMEO",
    " marketcap ": " $670 293 376 ",
    "price (USD)": "\u043c\u0430\u0440.96",
    "country": "United States"
  },
  {
    "Rank": "5685",
    "Name": "National Investments Company (Kuwait)",
    "Symbol": "NINV.KW",
    " marketcap ": " $670 246 675 ",
    "price (USD)": "840.939",
    "country": "Kuwait"
  },
  {
    "Rank": "5686",
    "Name": "Enviri Corporation",
    "Symbol": "NVRI",
    " marketcap ": " $668 861 760 ",
    "price (USD)": "\u0430\u0432\u0433.35",
    "country": "United States"
  },
  {
    "Rank": "5687",
    "Name": "CION Investment",
    "Symbol": "CION",
    " marketcap ": " $668 791 936 ",
    "price (USD)": "\u0434\u0435\u043a.48",
    "country": "United States"
  },
  {
    "Rank": "5688",
    "Name": "Kaufman &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5689",
    "Name": "ArriVent BioPharma",
    "Symbol": "AVBP",
    " marketcap ": " $668 201 344 ",
    "price (USD)": "19.95",
    "country": "United States"
  },
  {
    "Rank": "5690",
    "Name": "PostNL",
    "Symbol": "PNL.AS",
    " marketcap ": " $668 137 413 ",
    "price (USD)": "1.35194",
    "country": "Netherlands"
  },
  {
    "Rank": "5691",
    "Name": "International General Insurance",
    "Symbol": "IGIC",
    " marketcap ": " $667 287 360 ",
    "price (USD)": "14.\u0430\u043f\u0440",
    "country": "Jordan"
  },
  {
    "Rank": "5692",
    "Name": "Norma Group",
    "Symbol": "NOEJ.F",
    " marketcap ": " $666 371 697 ",
    "price (USD)": "20.8926",
    "country": "Germany"
  },
  {
    "Rank": "5693",
    "Name": "Definitive Healthcare",
    "Symbol": "DH",
    " marketcap ": " $666 332 736 ",
    "price (USD)": "\u043c\u0430\u0439.65",
    "country": "United States"
  },
  {
    "Rank": "5694",
    "Name": "Nu Skin",
    "Symbol": "NUS",
    " marketcap ": " $666 039 808 ",
    "price (USD)": "13.41",
    "country": "United States"
  },
  {
    "Rank": "5695",
    "Name": "Mercer International",
    "Symbol": "MERC",
    " marketcap ": " $665 823 040 ",
    "price (USD)": "\u0441\u0435\u043d.96",
    "country": "Canada"
  },
  {
    "Rank": "5696",
    "Name": "Groupon",
    "Symbol": "GRPN",
    " marketcap ": " $665 471 680 ",
    "price (USD)": "16.83",
    "country": "United States"
  },
  {
    "Rank": "5697",
    "Name": "Lyell Immunopharma",
    "Symbol": "LYEL",
    " marketcap ": " $665 390 784 ",
    "price (USD)": "\u0444\u0435\u0432.61",
    "country": "United States"
  },
  {
    "Rank": "5698",
    "Name": "Petco",
    "Symbol": "WOOF",
    " marketcap ": " $664 067 584 ",
    "price (USD)": "\u0444\u0435\u0432.45",
    "country": "United States"
  },
  {
    "Rank": "5699",
    "Name": "United Natural Foods",
    "Symbol": "UNFI",
    " marketcap ": " $662 720 320 ",
    "price (USD)": "\u043d\u043e\u044f.15",
    "country": "United States"
  },
  {
    "Rank": "5700",
    "Name": "RAK Properties",
    "Symbol": "RAKPROP.AE",
    " marketcap ": " $662 618 782 ",
    "price (USD)": "0.32",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5701",
    "Name": "Synthomer",
    "Symbol": "SYNT.L",
    " marketcap ": " $662 323 882 ",
    "price (USD)": "4.04923",
    "country": "United Kingdom"
  },
  {
    "Rank": "5702",
    "Name": "Old Second Bancorp",
    "Symbol": "OSBC",
    " marketcap ": " $661 472 576 ",
    "price (USD)": "14.75",
    "country": "United States"
  },
  {
    "Rank": "5703",
    "Name": "Tiptree",
    "Symbol": "TIPT",
    " marketcap ": " $661 399 680 ",
    "price (USD)": "17.98",
    "country": "United States"
  },
  {
    "Rank": "5704",
    "Name": "Community Healthcare Trust",
    "Symbol": "CHCT",
    " marketcap ": " $660 673 600 ",
    "price (USD)": "23.85",
    "country": "United States"
  },
  {
    "Rank": "5705",
    "Name": "Hain Celestial",
    "Symbol": "HAIN",
    " marketcap ": " $660 354 112 ",
    "price (USD)": "\u0438\u044e\u043b.35",
    "country": "United States"
  },
  {
    "Rank": "5706",
    "Name": "Kuwait Real Estate Company (AQARAT)",
    "Symbol": "KRE.KW",
    " marketcap ": " $659 863 155 ",
    "price (USD)": "723.598",
    "country": "Kuwait"
  },
  {
    "Rank": "5707",
    "Name": "Univest",
    "Symbol": "UVSP",
    " marketcap ": " $659 198 720 ",
    "price (USD)": "22.52",
    "country": "United States"
  },
  {
    "Rank": "5708",
    "Name": "Dril-Quip",
    "Symbol": "DRQ",
    " marketcap ": " $659 150 656 ",
    "price (USD)": "19.15",
    "country": "United States"
  },
  {
    "Rank": "5709",
    "Name": "CTT - Correios De Portugal",
    "Symbol": "CTT.LS",
    " marketcap ": " $658 524 626 ",
    "price (USD)": "4.77251",
    "country": "Portugal"
  },
  {
    "Rank": "5710",
    "Name": "Maytronics",
    "Symbol": "MTRN.TA",
    " marketcap ": " $658 356 230 ",
    "price (USD)": "5.99913",
    "country": "Israel"
  },
  {
    "Rank": "5711",
    "Name": "DoubleUGames",
    "Symbol": "192080.KS",
    " marketcap ": " $658 282 310 ",
    "price (USD)": "33.1948",
    "country": "South Korea"
  },
  {
    "Rank": "5712",
    "Name": "Heritage Financial",
    "Symbol": "HFWA",
    " marketcap ": " $657 718 592 ",
    "price (USD)": "18.96",
    "country": "United States"
  },
  {
    "Rank": "5713",
    "Name": "Ominvest",
    "Symbol": "OMVS.OM",
    " marketcap ": " $656 383 817 ",
    "price (USD)": "0.982073",
    "country": "Oman"
  },
  {
    "Rank": "5714",
    "Name": "Caf\u0413\u00a9 de Coral",
    "Symbol": "0341.HK",
    " marketcap ": " $655 958 318 ",
    "price (USD)": "1.11995",
    "country": "Hong Kong"
  },
  {
    "Rank": "5715",
    "Name": "EVgo",
    "Symbol": "EVGO",
    " marketcap ": " $655 411 584 ",
    "price (USD)": "\u0444\u0435\u0432.17",
    "country": "United States"
  },
  {
    "Rank": "5716",
    "Name": "Tanmiah Food Company",
    "Symbol": "2281.SR",
    " marketcap ": " $655 405 225 ",
    "price (USD)": "32.7703",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5717",
    "Name": "NuScale Power",
    "Symbol": "SMR",
    " marketcap ": " $655 187 136 ",
    "price (USD)": "07.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5718",
    "Name": "ALAFCO Aviation Lease and Finance Company",
    "Symbol": "ALAFCO.KW",
    " marketcap ": " $654 797 392 ",
    "price (USD)": "687.744",
    "country": "Kuwait"
  },
  {
    "Rank": "5719",
    "Name": "Tarkett",
    "Symbol": "TKTT.PA",
    " marketcap ": " $654 791 026 ",
    "price (USD)": "9.90336",
    "country": "France"
  },
  {
    "Rank": "5720",
    "Name": "AnaptysBio",
    "Symbol": "ANAB",
    " marketcap ": " $654 280 512 ",
    "price (USD)": "23.95",
    "country": "United States"
  },
  {
    "Rank": "5721",
    "Name": "Gabriel India",
    "Symbol": "GABRIEL.NS",
    " marketcap ": " $653 696 317 ",
    "price (USD)": "4.55021",
    "country": "India"
  },
  {
    "Rank": "5722",
    "Name": "Summit Hotel Properties",
    "Symbol": "INN",
    " marketcap ": " $653 479 680 ",
    "price (USD)": "06.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "5723",
    "Name": "UP Fintech (Tiger Brokers)",
    "Symbol": "TIGR",
    " marketcap ": " $653 439 040 ",
    "price (USD)": "\u0430\u043f\u0440.17",
    "country": "China"
  },
  {
    "Rank": "5724",
    "Name": "Earth Corporation",
    "Symbol": "4985.T",
    " marketcap ": " $653 184 681 ",
    "price (USD)": "29.4287",
    "country": "Japan"
  },
  {
    "Rank": "5725",
    "Name": "Soft-World International",
    "Symbol": "5478.TWO",
    " marketcap ": " $652 665 493 ",
    "price (USD)": "\u0430\u043f\u0440.25",
    "country": "Taiwan"
  },
  {
    "Rank": "5726",
    "Name": "iTeos Therapeutics",
    "Symbol": "ITOS",
    " marketcap ": " $651 295 936 ",
    "price (USD)": "18.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "5727",
    "Name": "Auna",
    "Symbol": "AUNA",
    " marketcap ": " $651 214 080 ",
    "price (USD)": "\u0430\u0432\u0433.81",
    "country": "Luxembourg"
  },
  {
    "Rank": "5728",
    "Name": "Eurowag",
    "Symbol": "WPS.L",
    " marketcap ": " $650 932 164 ",
    "price (USD)": "0.943336",
    "country": "United Kingdom"
  },
  {
    "Rank": "5729",
    "Name": "Trican Well Service",
    "Symbol": "TCW.TO",
    " marketcap ": " $649 563 377 ",
    "price (USD)": "3.18193",
    "country": "Canada"
  },
  {
    "Rank": "5730",
    "Name": "United Heavy Machinery",
    "Symbol": "OMZZP.ME",
    " marketcap ": " $649 476 873 ",
    "price (USD)": "231.98",
    "country": "Russia"
  },
  {
    "Rank": "5731",
    "Name": "Vaalco Energy",
    "Symbol": "EGY",
    " marketcap ": " $648 669 120 ",
    "price (USD)": "\u0438\u044e\u043d.27",
    "country": "United States"
  },
  {
    "Rank": "5732",
    "Name": "Preformed Line Products",
    "Symbol": "PLPC",
    " marketcap ": " $648 443 584 ",
    "price (USD)": "131.85",
    "country": "United States"
  },
  {
    "Rank": "5733",
    "Name": "Amadeus Fire",
    "Symbol": "AAD.DE",
    " marketcap ": " $647 682 919 ",
    "price (USD)": "119.231",
    "country": "Germany"
  },
  {
    "Rank": "5734",
    "Name": "HOMAG Group",
    "Symbol": "HG1.F",
    " marketcap ": " $647 349 332 ",
    "price (USD)": "41.264",
    "country": "Germany"
  },
  {
    "Rank": "5735",
    "Name": "Arnoldo Mondadori Editore",
    "Symbol": "MN.MI",
    " marketcap ": " $646 991 491 ",
    "price (USD)": "\u0444\u0435\u0432.67",
    "country": "Italy"
  },
  {
    "Rank": "5736",
    "Name": "Stratasys",
    "Symbol": "SSYS",
    " marketcap ": " $645 888 704 ",
    "price (USD)": "\u0441\u0435\u043d.26",
    "country": "Israel"
  },
  {
    "Rank": "5737",
    "Name": "i3 Verticals",
    "Symbol": "IIIV",
    " marketcap ": " $644 341 760 ",
    "price (USD)": "19.25",
    "country": "United States"
  },
  {
    "Rank": "5738",
    "Name": "American Coastal Insurance Corporation",
    "Symbol": "ACIC",
    " marketcap ": " $644 249 920 ",
    "price (USD)": "13.47",
    "country": "United States"
  },
  {
    "Rank": "5739",
    "Name": "DoubleDown Interactive",
    "Symbol": "DDI",
    " marketcap ": " $644 194 176 ",
    "price (USD)": "13",
    "country": "United States"
  },
  {
    "Rank": "5740",
    "Name": "MetroCity Bankshares",
    "Symbol": "MCBS",
    " marketcap ": " $644 000 512 ",
    "price (USD)": "25.55",
    "country": "United States"
  },
  {
    "Rank": "5741",
    "Name": "Jeju Air",
    "Symbol": "089590.KS",
    " marketcap ": " $643 191 309 ",
    "price (USD)": "\u0438\u044e\u043b.29",
    "country": "South Korea"
  },
  {
    "Rank": "5742",
    "Name": "GH Research",
    "Symbol": "GHRS",
    " marketcap ": " $643 067 328 ",
    "price (USD)": "\u0434\u0435\u043a.36",
    "country": "Ireland"
  },
  {
    "Rank": "5743",
    "Name": "Quanterix",
    "Symbol": "QTRX",
    " marketcap ": " $642 172 288 ",
    "price (USD)": "16.78",
    "country": "United States"
  },
  {
    "Rank": "5744",
    "Name": "Sun Hung Kai &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5745",
    "Name": "Fulgent Genetics",
    "Symbol": "FLGT",
    " marketcap ": " $640 978 496 ",
    "price (USD)": "21.42",
    "country": "United States"
  },
  {
    "Rank": "5746",
    "Name": "Mineralys Therapeutics",
    "Symbol": "MLYS",
    " marketcap ": " $640 962 112 ",
    "price (USD)": "\u0434\u0435\u043a.91",
    "country": "United States"
  },
  {
    "Rank": "5747",
    "Name": "Whitestone REIT",
    "Symbol": "WSR",
    " marketcap ": " $640 707 392 ",
    "price (USD)": "\u0434\u0435\u043a.66",
    "country": "United States"
  },
  {
    "Rank": "5748",
    "Name": "Meeza QSTP LLC (Public)",
    "Symbol": "MEZA.QA",
    " marketcap ": " $640 243 692 ",
    "price (USD)": "0.986538",
    "country": "Qatar"
  },
  {
    "Rank": "5749",
    "Name": "Arko",
    "Symbol": "ARKO",
    " marketcap ": " $640 064 320 ",
    "price (USD)": "\u043c\u0430\u0439.53",
    "country": "United States"
  },
  {
    "Rank": "5750",
    "Name": "Dine Brands Global",
    "Symbol": "DIN",
    " marketcap ": " $640 061 120 ",
    "price (USD)": "41.55",
    "country": "United States"
  },
  {
    "Rank": "5751",
    "Name": "Enerflex",
    "Symbol": "EFXT",
    " marketcap ": " $639 748 480 ",
    "price (USD)": "\u043c\u0430\u0439.15",
    "country": "Canada"
  },
  {
    "Rank": "5752",
    "Name": "Gateway Distriparks",
    "Symbol": "GATEWAY.NS",
    " marketcap ": " $639 661 044 ",
    "price (USD)": "1.28023",
    "country": "India"
  },
  {
    "Rank": "5753",
    "Name": "Torrid",
    "Symbol": "CURV",
    " marketcap ": " $639 640 960 ",
    "price (USD)": "\u0438\u044e\u043d.13",
    "country": "United States"
  },
  {
    "Rank": "5754",
    "Name": "Mesa Laboratories",
    "Symbol": "MLAB",
    " marketcap ": " $639 033 088 ",
    "price (USD)": "118.47",
    "country": "United States"
  },
  {
    "Rank": "5755",
    "Name": "Portillo's",
    "Symbol": "PTLO",
    " marketcap ": " $637 685 248 ",
    "price (USD)": "\u043e\u043a\u0442.35",
    "country": "United States"
  },
  {
    "Rank": "5756",
    "Name": "Boiron",
    "Symbol": "BOI.PA",
    " marketcap ": " $637 252 357 ",
    "price (USD)": "36.7032",
    "country": "France"
  },
  {
    "Rank": "5757",
    "Name": "Great Lakes Dredge &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5758",
    "Name": "Third Harmonic Bio",
    "Symbol": "THRD",
    " marketcap ": " $636 355 200 ",
    "price (USD)": "15.54",
    "country": "United States"
  },
  {
    "Rank": "5759",
    "Name": "Similarweb",
    "Symbol": "SMWB",
    " marketcap ": " $636 285 760 ",
    "price (USD)": "08.\u0441\u0435\u043d",
    "country": "Israel"
  },
  {
    "Rank": "5760",
    "Name": "Pharming Group",
    "Symbol": "PHAR",
    " marketcap ": " $635 052 032 ",
    "price (USD)": "\u0441\u0435\u043d.43",
    "country": "Netherlands"
  },
  {
    "Rank": "5761",
    "Name": "Mercantile Bank",
    "Symbol": "MBWM",
    " marketcap ": " $634 837 120 ",
    "price (USD)": "39.38",
    "country": "United States"
  },
  {
    "Rank": "5762",
    "Name": "Bouvet",
    "Symbol": "BOUV.OL",
    " marketcap ": " $634 549 476 ",
    "price (USD)": "6.15404",
    "country": "Norway"
  },
  {
    "Rank": "5763",
    "Name": "Finnair",
    "Symbol": "FIA1S.HE",
    " marketcap ": " $633 863 325 ",
    "price (USD)": "3.10023",
    "country": "Finland"
  },
  {
    "Rank": "5764",
    "Name": "ProCredit",
    "Symbol": "PCZ.DE",
    " marketcap ": " $633 179 611 ",
    "price (USD)": "\u043e\u043a\u0442.04",
    "country": "Germany"
  },
  {
    "Rank": "5765",
    "Name": "Qatar National Cement Company",
    "Symbol": "QNCD.QA",
    " marketcap ": " $632 163 657 ",
    "price (USD)": "0.967308",
    "country": "Qatar"
  },
  {
    "Rank": "5766",
    "Name": "The Restaurant Group plc",
    "Symbol": "RTN.L",
    " marketcap ": " $630 384 039 ",
    "price (USD)": "0.82",
    "country": "United Kingdom"
  },
  {
    "Rank": "5767",
    "Name": "Zymeworks",
    "Symbol": "ZYME",
    " marketcap ": " $629 980 608 ",
    "price (USD)": "\u0430\u0432\u0433.91",
    "country": "Canada"
  },
  {
    "Rank": "5768",
    "Name": "nLIGHT",
    "Symbol": "LASR",
    " marketcap ": " $629 287 552 ",
    "price (USD)": "13.23",
    "country": "United States"
  },
  {
    "Rank": "5769",
    "Name": "G8 Education",
    "Symbol": "GEM.AX",
    " marketcap ": " $628 850 443 ",
    "price (USD)": "0.776832",
    "country": "Australia"
  },
  {
    "Rank": "5770",
    "Name": "Betterware de Mexico",
    "Symbol": "BWMX",
    " marketcap ": " $628 783 040 ",
    "price (USD)": "16.85",
    "country": "Mexico"
  },
  {
    "Rank": "5771",
    "Name": "AdvanSix",
    "Symbol": "ASIX",
    " marketcap ": " $628 366 848 ",
    "price (USD)": "23.43",
    "country": "United States"
  },
  {
    "Rank": "5772",
    "Name": "Phathom Pharmaceuticals",
    "Symbol": "PHAT",
    " marketcap ": " $628 082 688 ",
    "price (USD)": "\u043e\u043a\u0442.73",
    "country": "United States"
  },
  {
    "Rank": "5773",
    "Name": "Insteel Industries",
    "Symbol": "IIIN",
    " marketcap ": " $627 292 928 ",
    "price (USD)": "32.21",
    "country": "United States"
  },
  {
    "Rank": "5774",
    "Name": "Weave Communications",
    "Symbol": "WEAV",
    " marketcap ": " $626 593 664 ",
    "price (USD)": "\u0430\u0432\u0433.81",
    "country": "United States"
  },
  {
    "Rank": "5775",
    "Name": "Everi Holdings",
    "Symbol": "EVRI",
    " marketcap ": " $624 683 200 ",
    "price (USD)": "\u0438\u044e\u043b.43",
    "country": "United States"
  },
  {
    "Rank": "5776",
    "Name": "Italtile",
    "Symbol": "ITE.JO",
    " marketcap ": " $624 378 400 ",
    "price (USD)": "0.520836",
    "country": "South Africa"
  },
  {
    "Rank": "5777",
    "Name": "KYORIN Pharmaceutical",
    "Symbol": "4569.T",
    " marketcap ": " $623 700 451 ",
    "price (USD)": "\u043e\u043a\u0442.66",
    "country": "Japan"
  },
  {
    "Rank": "5778",
    "Name": "Hutchison Telecommunications Hong Kong Holdings",
    "Symbol": "0215.HK",
    " marketcap ": " $623 697 437 ",
    "price (USD)": "0.129422",
    "country": "Hong Kong"
  },
  {
    "Rank": "5779",
    "Name": "Gulf Oil Lubricants",
    "Symbol": "GULFOILLUB.NS",
    " marketcap ": " $623 414 943 ",
    "price (USD)": "\u0434\u0435\u043a.92",
    "country": "India"
  },
  {
    "Rank": "5780",
    "Name": "HBT Financial",
    "Symbol": "HBT",
    " marketcap ": " $622 984 384 ",
    "price (USD)": "19.72",
    "country": "United States"
  },
  {
    "Rank": "5781",
    "Name": "Marimekko",
    "Symbol": "MEKKO.HE",
    " marketcap ": " $622 074 232 ",
    "price (USD)": "15.3328",
    "country": "Finland"
  },
  {
    "Rank": "5782",
    "Name": "Bank Nizwa",
    "Symbol": "BKNZ.OM",
    " marketcap ": " $621 860 157 ",
    "price (USD)": "0.277994",
    "country": "Oman"
  },
  {
    "Rank": "5783",
    "Name": "OTC Markets Group",
    "Symbol": "OTCM",
    " marketcap ": " $621 341 632 ",
    "price (USD)": "51.9",
    "country": "United States"
  },
  {
    "Rank": "5784",
    "Name": "Sundial Growers",
    "Symbol": "SNDL",
    " marketcap ": " $621 130 752 ",
    "price (USD)": "\u0444\u0435\u0432.36",
    "country": "Canada"
  },
  {
    "Rank": "5785",
    "Name": "SunOpta",
    "Symbol": "STKL",
    " marketcap ": " $620 476 928 ",
    "price (USD)": "\u043c\u0430\u0439.32",
    "country": "Canada"
  },
  {
    "Rank": "5786",
    "Name": "Paragon 28",
    "Symbol": "FNA",
    " marketcap ": " $620 476 480 ",
    "price (USD)": "\u0438\u044e\u043b.48",
    "country": "United States"
  },
  {
    "Rank": "5787",
    "Name": "Ashoka Buildcon",
    "Symbol": "ASHOKA.NS",
    " marketcap ": " $620 459 693 ",
    "price (USD)": "2.21022",
    "country": "India"
  },
  {
    "Rank": "5788",
    "Name": "Hangzhou Electronic Soul Network Technology",
    "Symbol": "603258.SS",
    " marketcap ": " $620 431 929 ",
    "price (USD)": "2.53478",
    "country": "China"
  },
  {
    "Rank": "5789",
    "Name": "1-800-Flowers",
    "Symbol": "FLWS",
    " marketcap ": " $618 986 368 ",
    "price (USD)": "\u0441\u0435\u043d.64",
    "country": "United States"
  },
  {
    "Rank": "5790",
    "Name": "GAMCO Investors",
    "Symbol": "GAMI",
    " marketcap ": " $618 906 304 ",
    "price (USD)": "25.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "5791",
    "Name": "Eagle Bancorp",
    "Symbol": "EGBN",
    " marketcap ": " $618 886 784 ",
    "price (USD)": "20.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5792",
    "Name": "Pediatrix Medical Group",
    "Symbol": "MD",
    " marketcap ": " $618 481 920 ",
    "price (USD)": "\u0438\u044e\u043b.35",
    "country": "United States"
  },
  {
    "Rank": "5793",
    "Name": "Caisse R\u0413\u00a9gionale de Cr\u0413\u00a9dit Agricole Mutuel Alpes Provence",
    "Symbol": "CRAP.PA",
    " marketcap ": " $618 457 735 ",
    "price (USD)": "82.0176",
    "country": "France"
  },
  {
    "Rank": "5794",
    "Name": "Great Southern Bancorp",
    "Symbol": "GSBC",
    " marketcap ": " $617 752 128 ",
    "price (USD)": "52.99",
    "country": "United States"
  },
  {
    "Rank": "5795",
    "Name": "Jumia",
    "Symbol": "JMIA",
    " marketcap ": " $616 477 056 ",
    "price (USD)": "06.\u043c\u0430\u0440",
    "country": "Germany"
  },
  {
    "Rank": "5796",
    "Name": "InnovAge",
    "Symbol": "INNV",
    " marketcap ": " $616 025 664 ",
    "price (USD)": "\u0430\u043f\u0440.53",
    "country": "United States"
  },
  {
    "Rank": "5797",
    "Name": "Lifezone Metals",
    "Symbol": "LZM",
    " marketcap ": " $615 961 472 ",
    "price (USD)": "07.\u0438\u044e\u043b",
    "country": "United Kingdom"
  },
  {
    "Rank": "5798",
    "Name": "VRL Logistics",
    "Symbol": "VRLLOG.NS",
    " marketcap ": " $614 760 816 ",
    "price (USD)": "7.02837",
    "country": "India"
  },
  {
    "Rank": "5799",
    "Name": "Gray Television",
    "Symbol": "GTN",
    " marketcap ": " $614 223 424 ",
    "price (USD)": "\u043c\u0430\u0439.97",
    "country": "United States"
  },
  {
    "Rank": "5800",
    "Name": "Cass Information Systems",
    "Symbol": "CASS",
    " marketcap ": " $614 102 912 ",
    "price (USD)": "45.01",
    "country": "United States"
  },
  {
    "Rank": "5801",
    "Name": "Neighbourly Pharmacy",
    "Symbol": "NBLY.TO",
    " marketcap ": " $612 547 451 ",
    "price (USD)": "13.6369",
    "country": "Canada"
  },
  {
    "Rank": "5802",
    "Name": "Altus Power",
    "Symbol": "AMPS",
    " marketcap ": " $612 321 280 ",
    "price (USD)": "\u043c\u0430\u0440.83",
    "country": "United States"
  },
  {
    "Rank": "5803",
    "Name": "Hagar hf.",
    "Symbol": "HAGA.IC",
    " marketcap ": " $612 205 472 ",
    "price (USD)": "0.564604",
    "country": "Iceland"
  },
  {
    "Rank": "5804",
    "Name": "iDreamSky",
    "Symbol": "1119.HK",
    " marketcap ": " $611 589 289 ",
    "price (USD)": "0.389547",
    "country": "China"
  },
  {
    "Rank": "5805",
    "Name": "BigCommerce",
    "Symbol": "BIGC",
    " marketcap ": " $611 241 280 ",
    "price (USD)": "\u0438\u044e\u043b.91",
    "country": "United States"
  },
  {
    "Rank": "5806",
    "Name": "Titan International",
    "Symbol": "TWI",
    " marketcap ": " $610 656 512 ",
    "price (USD)": "\u0430\u0432\u0433.38",
    "country": "United States"
  },
  {
    "Rank": "5807",
    "Name": "Viant Technology",
    "Symbol": "DSP",
    " marketcap ": " $609 865 600 ",
    "price (USD)": "9.605",
    "country": "United States"
  },
  {
    "Rank": "5808",
    "Name": "Varex Imaging",
    "Symbol": "VREX",
    " marketcap ": " $609 571 520 ",
    "price (USD)": "14.92",
    "country": "United States"
  },
  {
    "Rank": "5809",
    "Name": "Overseas Shipholding Group",
    "Symbol": "OSG",
    " marketcap ": " $608 661 952 ",
    "price (USD)": "\u0430\u0432\u0433.45",
    "country": "United States"
  },
  {
    "Rank": "5810",
    "Name": "Anterix",
    "Symbol": "ATEX",
    " marketcap ": " $607 452 736 ",
    "price (USD)": "32.8",
    "country": "United States"
  },
  {
    "Rank": "5811",
    "Name": "Covenant Logistics",
    "Symbol": "CVLG",
    " marketcap ": " $607 327 872 ",
    "price (USD)": "46.31",
    "country": "United States"
  },
  {
    "Rank": "5812",
    "Name": "National Corporation for Tourism &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "5813",
    "Name": "United Arab Bank",
    "Symbol": "UAB.AE",
    " marketcap ": " $606 516 922 ",
    "price (USD)": "0.29",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "5814",
    "Name": "The Hackett Group",
    "Symbol": "HCKT",
    " marketcap ": " $606 401 216 ",
    "price (USD)": "21.96",
    "country": "United States"
  },
  {
    "Rank": "5815",
    "Name": "Arbutus Biopharma",
    "Symbol": "ABUS",
    " marketcap ": " $605 781 568 ",
    "price (USD)": "\u043c\u0430\u0440.21",
    "country": "United States"
  },
  {
    "Rank": "5816",
    "Name": "Text (LiveChat)",
    "Symbol": "TXT.WA",
    " marketcap ": " $605 015 818 ",
    "price (USD)": "23.4958",
    "country": "Poland"
  },
  {
    "Rank": "5817",
    "Name": "Olympic Steel",
    "Symbol": "ZEUS",
    " marketcap ": " $604 160 768 ",
    "price (USD)": "54.27",
    "country": "United States"
  },
  {
    "Rank": "5818",
    "Name": "Mitek Systems",
    "Symbol": "MITK",
    " marketcap ": " $604 066 624 ",
    "price (USD)": "\u0434\u0435\u043a.91",
    "country": "United States"
  },
  {
    "Rank": "5819",
    "Name": "Biglari",
    "Symbol": "BH",
    " marketcap ": " $604 043 264 ",
    "price (USD)": "195.1",
    "country": "United States"
  },
  {
    "Rank": "5820",
    "Name": "Lexicon Pharmaceuticals",
    "Symbol": "LXRX",
    " marketcap ": " $603 691 648 ",
    "price (USD)": "\u044f\u043d\u0432.67",
    "country": "United States"
  },
  {
    "Rank": "5821",
    "Name": "EyePoint Pharmaceuticals",
    "Symbol": "EYPT",
    " marketcap ": " $603 658 176 ",
    "price (USD)": "\u043d\u043e\u044f.59",
    "country": "United States"
  },
  {
    "Rank": "5822",
    "Name": "Solowin Holdings",
    "Symbol": "SWIN",
    " marketcap ": " $602 925 376 ",
    "price (USD)": "37.73",
    "country": "Hong Kong"
  },
  {
    "Rank": "5823",
    "Name": "Lilium",
    "Symbol": "LILM",
    " marketcap ": " $602 891 264 ",
    "price (USD)": "\u044f\u043d\u0432.14",
    "country": "Germany"
  },
  {
    "Rank": "5824",
    "Name": "Alandalus Property Company",
    "Symbol": "4320.SR",
    " marketcap ": " $602 744 837 ",
    "price (USD)": "6.45798",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5825",
    "Name": "PetIQ",
    "Symbol": "PETQ",
    " marketcap ": " $602 473 920 ",
    "price (USD)": "20.25",
    "country": "United States"
  },
  {
    "Rank": "5826",
    "Name": "SAPTCO (Saudi Public Transport Company)",
    "Symbol": "4040.SR",
    " marketcap ": " $602 433 727 ",
    "price (USD)": "4.81947",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5827",
    "Name": "Shimao Property",
    "Symbol": "0813.HK",
    " marketcap ": " $601 823 280 ",
    "price (USD)": "0.158894",
    "country": "Hong Kong"
  },
  {
    "Rank": "5828",
    "Name": "Wonderla Holidays",
    "Symbol": "WONDERLA.NS",
    " marketcap ": " $601 247 465 ",
    "price (USD)": "\u043e\u043a\u0442.15",
    "country": "India"
  },
  {
    "Rank": "5829",
    "Name": "Asiana Airlines",
    "Symbol": "020560.KS",
    " marketcap ": " $601 126 425 ",
    "price (USD)": "8.07837",
    "country": "South Korea"
  },
  {
    "Rank": "5830",
    "Name": "Oil-Dri Corporation Of America",
    "Symbol": "ODC",
    " marketcap ": " $600 671 552 ",
    "price (USD)": "82.43",
    "country": "United States"
  },
  {
    "Rank": "5831",
    "Name": "Velocity Financial",
    "Symbol": "VEL",
    " marketcap ": " $600 011 712 ",
    "price (USD)": "18.19",
    "country": "United States"
  },
  {
    "Rank": "5832",
    "Name": "Hampi\u0413\u00b0jan",
    "Symbol": "HAMP.IC",
    " marketcap ": " $599 960 818 ",
    "price (USD)": "0.959102",
    "country": "Iceland"
  },
  {
    "Rank": "5833",
    "Name": "Waldencast",
    "Symbol": "WALD",
    " marketcap ": " $599 947 968 ",
    "price (USD)": "\u0430\u043f\u0440.91",
    "country": "United States"
  },
  {
    "Rank": "5834",
    "Name": "Mind Medicine",
    "Symbol": "MNMD",
    " marketcap ": " $599 775 168 ",
    "price (USD)": "8.345",
    "country": "United States"
  },
  {
    "Rank": "5835",
    "Name": "National Fertilizers",
    "Symbol": "NFL.NS",
    " marketcap ": " $599 761 031 ",
    "price (USD)": "1.22256",
    "country": "India"
  },
  {
    "Rank": "5836",
    "Name": "Movado",
    "Symbol": "MOV",
    " marketcap ": " $599 442 496 ",
    "price (USD)": "26.99",
    "country": "United States"
  },
  {
    "Rank": "5837",
    "Name": "ORIC Pharmaceuticals",
    "Symbol": "ORIC",
    " marketcap ": " $599 384 320 ",
    "price (USD)": "\u0430\u0432\u0433.89",
    "country": "United States"
  },
  {
    "Rank": "5838",
    "Name": "Limbach Holdings",
    "Symbol": "LMB",
    " marketcap ": " $598 631 360 ",
    "price (USD)": "53.53",
    "country": "United States"
  },
  {
    "Rank": "5839",
    "Name": "Oman Arab Bank",
    "Symbol": "OAB.OM",
    " marketcap ": " $598 541 387 ",
    "price (USD)": "0.358535",
    "country": "Oman"
  },
  {
    "Rank": "5840",
    "Name": "Valneva SE",
    "Symbol": "VALN",
    " marketcap ": " $597 637 312 ",
    "price (USD)": "08.\u0444\u0435\u0432",
    "country": "France"
  },
  {
    "Rank": "5841",
    "Name": "STRATEC",
    "Symbol": "SBS.F",
    " marketcap ": " $597 052 657 ",
    "price (USD)": "47.5622",
    "country": "Germany"
  },
  {
    "Rank": "5842",
    "Name": "Abraj Energy Services",
    "Symbol": "ABRJ.OM",
    " marketcap ": " $596 309 691 ",
    "price (USD)": "0.774227",
    "country": "Oman"
  },
  {
    "Rank": "5843",
    "Name": "TerrAscend",
    "Symbol": "TSND.TO",
    " marketcap ": " $594 736 343 ",
    "price (USD)": "1.67764",
    "country": "Canada"
  },
  {
    "Rank": "5844",
    "Name": "GDI Integrated Facility Services",
    "Symbol": "GDI.TO",
    " marketcap ": " $594 671 887 ",
    "price (USD)": "25.3308",
    "country": "Canada"
  },
  {
    "Rank": "5845",
    "Name": "Turning Point Brands",
    "Symbol": "TPB",
    " marketcap ": " $594 379 904 ",
    "price (USD)": "33.73",
    "country": "United States"
  },
  {
    "Rank": "5846",
    "Name": "Oman Cables Industry",
    "Symbol": "OCAI.OM",
    " marketcap ": " $594 271 239 ",
    "price (USD)": "\u0438\u044e\u043d.51",
    "country": "Oman"
  },
  {
    "Rank": "5847",
    "Name": "Savara Pharmaceuticals",
    "Symbol": "SVRA",
    " marketcap ": " $594 212 672 ",
    "price (USD)": "04.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "5848",
    "Name": "Stillfront Group",
    "Symbol": "SF.ST",
    " marketcap ": " $594 111 842 ",
    "price (USD)": "1.1588",
    "country": "Sweden"
  },
  {
    "Rank": "5849",
    "Name": "Exscientia",
    "Symbol": "EXAI",
    " marketcap ": " $593 962 496 ",
    "price (USD)": "04.\u0438\u044e\u043b",
    "country": "United Kingdom"
  },
  {
    "Rank": "5850",
    "Name": "Applied Blockchain",
    "Symbol": "APLD",
    " marketcap ": " $592 571 712 ",
    "price (USD)": "\u0430\u043f\u0440.42",
    "country": "United States"
  },
  {
    "Rank": "5851",
    "Name": "BOE Varitronix",
    "Symbol": "0710.HK",
    " marketcap ": " $592 367 925 ",
    "price (USD)": "0.748341",
    "country": "Hong Kong"
  },
  {
    "Rank": "5852",
    "Name": "Care Property Invest NV",
    "Symbol": "CPINV.BR",
    " marketcap ": " $592 045 729 ",
    "price (USD)": "16.0061",
    "country": "Belgium"
  },
  {
    "Rank": "5853",
    "Name": "Liquidity Services",
    "Symbol": "LQDT",
    " marketcap ": " $591 966 272 ",
    "price (USD)": "19.42",
    "country": "United States"
  },
  {
    "Rank": "5854",
    "Name": "Gladstone Commercial",
    "Symbol": "GOOD",
    " marketcap ": " $591 948 480 ",
    "price (USD)": "14.52",
    "country": "United States"
  },
  {
    "Rank": "5855",
    "Name": "Douglas Dynamics",
    "Symbol": "PLOW",
    " marketcap ": " $591 668 288 ",
    "price (USD)": "25.62",
    "country": "United States"
  },
  {
    "Rank": "5856",
    "Name": "Safe Bulkers",
    "Symbol": "SB",
    " marketcap ": " $591 472 576 ",
    "price (USD)": "\u043c\u0430\u0439.54",
    "country": "Monaco"
  },
  {
    "Rank": "5857",
    "Name": "PORR",
    "Symbol": "ABS2.F",
    " marketcap ": " $591 026 761 ",
    "price (USD)": "15.3328",
    "country": "Austria"
  },
  {
    "Rank": "5858",
    "Name": "MarineMax",
    "Symbol": "HZO",
    " marketcap ": " $590 764 096 ",
    "price (USD)": "26.49",
    "country": "United States"
  },
  {
    "Rank": "5859",
    "Name": "Kyverna Therapeutics",
    "Symbol": "KYTX",
    " marketcap ": " $590 678 208 ",
    "price (USD)": "13.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5860",
    "Name": "PowerFleet",
    "Symbol": "PWFL",
    " marketcap ": " $590 425 024 ",
    "price (USD)": "05.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5861",
    "Name": "LendingTree",
    "Symbol": "TREE",
    " marketcap ": " $589 151 488 ",
    "price (USD)": "44.55",
    "country": "United States"
  },
  {
    "Rank": "5862",
    "Name": "Cabaletta Bio",
    "Symbol": "CABA",
    " marketcap ": " $588 490 496 ",
    "price (USD)": "\u0434\u0435\u043a.19",
    "country": "United States"
  },
  {
    "Rank": "5863",
    "Name": "SolarMax Technology",
    "Symbol": "SMXT",
    " marketcap ": " $587 925 184 ",
    "price (USD)": "13.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5864",
    "Name": "Saudi Reinsurance Company",
    "Symbol": "8200.SR",
    " marketcap ": " $586 819 318 ",
    "price (USD)": "6.58608",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5865",
    "Name": "Walaa Cooperative Insurance Company",
    "Symbol": "8060.SR",
    " marketcap ": " $586 757 698 ",
    "price (USD)": "\u0438\u044e\u043d.83",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5866",
    "Name": "CryoPort",
    "Symbol": "CYRX",
    " marketcap ": " $585 670 528 ",
    "price (USD)": "\u043d\u043e\u044f.89",
    "country": "United States"
  },
  {
    "Rank": "5867",
    "Name": "WashTec AG",
    "Symbol": "WSU.DE",
    " marketcap ": " $585 579 359 ",
    "price (USD)": "43.4358",
    "country": "Germany"
  },
  {
    "Rank": "5868",
    "Name": "Karat Packaging",
    "Symbol": "KRT",
    " marketcap ": " $585 467 264 ",
    "price (USD)": "29.31",
    "country": "United States"
  },
  {
    "Rank": "5869",
    "Name": "ATRenew",
    "Symbol": "RERE",
    " marketcap ": " $585 293 312 ",
    "price (USD)": "\u0444\u0435\u0432.64",
    "country": "China"
  },
  {
    "Rank": "5870",
    "Name": "Myers Industries",
    "Symbol": "MYE",
    " marketcap ": " $585 260 416 ",
    "price (USD)": "15.74",
    "country": "United States"
  },
  {
    "Rank": "5871",
    "Name": "enGene",
    "Symbol": "ENGN",
    " marketcap ": " $585 218 944 ",
    "price (USD)": "13.27",
    "country": "Canada"
  },
  {
    "Rank": "5872",
    "Name": "United Fire Group",
    "Symbol": "UFCS",
    " marketcap ": " $585 094 144 ",
    "price (USD)": "23.13",
    "country": "United States"
  },
  {
    "Rank": "5873",
    "Name": "Harrow Health",
    "Symbol": "HROW",
    " marketcap ": " $583 447 552 ",
    "price (USD)": "16.49",
    "country": "United States"
  },
  {
    "Rank": "5874",
    "Name": "Calliditas Therapeutics",
    "Symbol": "CALT",
    " marketcap ": " $582 736 512 ",
    "price (USD)": "21.5001",
    "country": "Sweden"
  },
  {
    "Rank": "5875",
    "Name": "Global Medical REIT",
    "Symbol": "GMRE",
    " marketcap ": " $582 465 856 ",
    "price (USD)": "\u0430\u0432\u0433.88",
    "country": "United States"
  },
  {
    "Rank": "5876",
    "Name": "Riley Permian",
    "Symbol": "REPX",
    " marketcap ": " $581 682 624 ",
    "price (USD)": "27",
    "country": "United States"
  },
  {
    "Rank": "5877",
    "Name": "Vinci Partners",
    "Symbol": "VINP",
    " marketcap ": " $579 835 904 ",
    "price (USD)": "\u043e\u043a\u0442.89",
    "country": "Brazil"
  },
  {
    "Rank": "5878",
    "Name": "Tallink Grupp",
    "Symbol": "T5N.F",
    " marketcap ": " $579 739 715 ",
    "price (USD)": "0.761212",
    "country": "Estonia"
  },
  {
    "Rank": "5879",
    "Name": "SI-BONE",
    "Symbol": "SIBN",
    " marketcap ": " $578 927 424 ",
    "price (USD)": "14.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5880",
    "Name": "Bandwidth",
    "Symbol": "BAND",
    " marketcap ": " $578 234 880 ",
    "price (USD)": "21.41",
    "country": "United States"
  },
  {
    "Rank": "5881",
    "Name": "Hesai Group",
    "Symbol": "HSAI",
    " marketcap ": " $577 475 392 ",
    "price (USD)": "\u0430\u043f\u0440.53",
    "country": "China"
  },
  {
    "Rank": "5882",
    "Name": "Uxin Limited",
    "Symbol": "UXIN",
    " marketcap ": " $576 972 736 ",
    "price (USD)": "03.\u0438\u044e\u043b",
    "country": "China"
  },
  {
    "Rank": "5883",
    "Name": "Avid Bioservices",
    "Symbol": "CDMO",
    " marketcap ": " $576 396 608 ",
    "price (USD)": "09.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "5884",
    "Name": "Nilfisk Holding",
    "Symbol": "NLFSK.CO",
    " marketcap ": " $576 263 910 ",
    "price (USD)": "21.2437",
    "country": "Denmark"
  },
  {
    "Rank": "5885",
    "Name": "Obsidian Energy",
    "Symbol": "OBE",
    " marketcap ": " $576 171 840 ",
    "price (USD)": "\u0438\u044e\u043b.52",
    "country": "Canada"
  },
  {
    "Rank": "5886",
    "Name": "Tunas Ridean",
    "Symbol": "TURI.JK",
    " marketcap ": " $574 991 765 ",
    "price (USD)": "0.1",
    "country": "Indonesia"
  },
  {
    "Rank": "5887",
    "Name": "IsoEnergy",
    "Symbol": "ISO.V",
    " marketcap ": " $573 406 028 ",
    "price (USD)": "3.21126",
    "country": "Canada"
  },
  {
    "Rank": "5888",
    "Name": "Central Pacific Financial",
    "Symbol": "CPF",
    " marketcap ": " $572 485 504 ",
    "price (USD)": "21.17",
    "country": "United States"
  },
  {
    "Rank": "5889",
    "Name": "Perion Network",
    "Symbol": "PERI",
    " marketcap ": " $571 865 024 ",
    "price (USD)": "\u043d\u043e\u044f.81",
    "country": "Israel"
  },
  {
    "Rank": "5890",
    "Name": "Universal Insurance Holdings",
    "Symbol": "UVE",
    " marketcap ": " $570 868 160 ",
    "price (USD)": "19.85",
    "country": "United States"
  },
  {
    "Rank": "5891",
    "Name": "Geopark",
    "Symbol": "GPRK",
    " marketcap ": " $570 835 712 ",
    "price (USD)": "\u043e\u043a\u0442.29",
    "country": "Chile"
  },
  {
    "Rank": "5892",
    "Name": "Accolade",
    "Symbol": "ACCD",
    " marketcap ": " $570 438 208 ",
    "price (USD)": "\u0438\u044e\u043b.28",
    "country": "United States"
  },
  {
    "Rank": "5893",
    "Name": "Aerovate Therapeutics",
    "Symbol": "AVTE",
    " marketcap ": " $570 116 288 ",
    "price (USD)": "19.79",
    "country": "United States"
  },
  {
    "Rank": "5894",
    "Name": "Pacific Century Regional Developments",
    "Symbol": "P15.SI",
    " marketcap ": " $569 893 784 ",
    "price (USD)": "0.215301",
    "country": "Singapore"
  },
  {
    "Rank": "5895",
    "Name": "Nano Dimension",
    "Symbol": "NNDM",
    " marketcap ": " $568 915 776 ",
    "price (USD)": "\u0444\u0435\u0432.57",
    "country": "United States"
  },
  {
    "Rank": "5896",
    "Name": "Acacia Research",
    "Symbol": "ACTG",
    " marketcap ": " $568 124 928 ",
    "price (USD)": "\u043c\u0430\u0439.68",
    "country": "United States"
  },
  {
    "Rank": "5897",
    "Name": "Lux Industries",
    "Symbol": "LUXIND.NS",
    " marketcap ": " $567 636 021 ",
    "price (USD)": "18.8761",
    "country": "India"
  },
  {
    "Rank": "5898",
    "Name": "YG Entertainment",
    "Symbol": "122870.KQ",
    " marketcap ": " $567 586 189 ",
    "price (USD)": "30.6244",
    "country": "South Korea"
  },
  {
    "Rank": "5899",
    "Name": "McEwen Mining",
    "Symbol": "MUX",
    " marketcap ": " $567 212 992 ",
    "price (USD)": "\u043d\u043e\u044f.48",
    "country": "Canada"
  },
  {
    "Rank": "5900",
    "Name": "Transport International Holdings",
    "Symbol": "0062.HK",
    " marketcap ": " $566 941 229 ",
    "price (USD)": "1.14686",
    "country": "Hong Kong"
  },
  {
    "Rank": "5901",
    "Name": "Boohoo Group",
    "Symbol": "BOO.L",
    " marketcap ": " $566 867 447 ",
    "price (USD)": "0.44675",
    "country": "United Kingdom"
  },
  {
    "Rank": "5902",
    "Name": "Shamal Az-Zour Al-Oula Power and Water Company",
    "Symbol": "AZNOULA.KW",
    " marketcap ": " $566 492 829 ",
    "price (USD)": "514.993",
    "country": "Kuwait"
  },
  {
    "Rank": "5903",
    "Name": "Sumou Real Estate Company",
    "Symbol": "4323.SR",
    " marketcap ": " $565 407 080 ",
    "price (USD)": "15.0775",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5904",
    "Name": "Ribbon Communications",
    "Symbol": "RBBN",
    " marketcap ": " $565 207 488 ",
    "price (USD)": "\u043c\u0430\u0440.25",
    "country": "United States"
  },
  {
    "Rank": "5905",
    "Name": "Digimarc",
    "Symbol": "DMRC",
    " marketcap ": " $564 682 560 ",
    "price (USD)": "26.42",
    "country": "United States"
  },
  {
    "Rank": "5906",
    "Name": "Nazara Technologies",
    "Symbol": "NAZARA.NS",
    " marketcap ": " $564 679 048 ",
    "price (USD)": "7.37741",
    "country": "India"
  },
  {
    "Rank": "5907",
    "Name": "Anywhere Real Estate",
    "Symbol": "HOUS",
    " marketcap ": " $563 312 512 ",
    "price (USD)": "05.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5908",
    "Name": "National Real Estate Company - K.P.S.C.",
    "Symbol": "NRE.KW",
    " marketcap ": " $563 097 888 ",
    "price (USD)": "299.218",
    "country": "Kuwait"
  },
  {
    "Rank": "5909",
    "Name": "Aveanna Healthcare",
    "Symbol": "AVAH",
    " marketcap ": " $561 746 688 ",
    "price (USD)": "\u0444\u0435\u0432.92",
    "country": "United States"
  },
  {
    "Rank": "5910",
    "Name": "Allogene Therapeutics",
    "Symbol": "ALLO",
    " marketcap ": " $561 628 992 ",
    "price (USD)": "\u0444\u0435\u0432.69",
    "country": "United States"
  },
  {
    "Rank": "5911",
    "Name": "Jadwa Investment - Jadwa Reit Saudi Fund",
    "Symbol": "4342.SR",
    " marketcap ": " $561 426 281 ",
    "price (USD)": "3.01017",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5912",
    "Name": "Kimball Electronics",
    "Symbol": "KE",
    " marketcap ": " $560 800 448 ",
    "price (USD)": "22.55",
    "country": "United States"
  },
  {
    "Rank": "5913",
    "Name": "Horizon Bancorp",
    "Symbol": "HBNC",
    " marketcap ": " $560 270 656 ",
    "price (USD)": "12.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5914",
    "Name": "Ouster",
    "Symbol": "OUST",
    " marketcap ": " $559 886 720 ",
    "price (USD)": "\u0434\u0435\u043a.38",
    "country": "United States"
  },
  {
    "Rank": "5915",
    "Name": "NHN Corp",
    "Symbol": "181710.KS",
    " marketcap ": " $559 654 112 ",
    "price (USD)": "17.0013",
    "country": "South Korea"
  },
  {
    "Rank": "5916",
    "Name": "ASOS",
    "Symbol": "ASC.L",
    " marketcap ": " $559 522 707 ",
    "price (USD)": "4.68871",
    "country": "United Kingdom"
  },
  {
    "Rank": "5917",
    "Name": "Shenzhen Bingchuan Network",
    "Symbol": "300533.SZ",
    " marketcap ": " $558 888 529 ",
    "price (USD)": "2.41598",
    "country": "China"
  },
  {
    "Rank": "5918",
    "Name": "Golden Matrix Group",
    "Symbol": "GMGI",
    " marketcap ": " $558 754 752 ",
    "price (USD)": "04.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5919",
    "Name": "iRadimed",
    "Symbol": "IRMD",
    " marketcap ": " $558 617 856 ",
    "price (USD)": "44.11",
    "country": "United States"
  },
  {
    "Rank": "5920",
    "Name": "Planet Labs",
    "Symbol": "PL",
    " marketcap ": " $557 990 400 ",
    "price (USD)": "\u044f\u043d\u0432.92",
    "country": "United States"
  },
  {
    "Rank": "5921",
    "Name": "Dave Inc.",
    "Symbol": "DAVE",
    " marketcap ": " $557 746 688 ",
    "price (USD)": "45.21",
    "country": "United States"
  },
  {
    "Rank": "5922",
    "Name": "Waterdrop Inc.",
    "Symbol": "WDH",
    " marketcap ": " $557 284 928 ",
    "price (USD)": "\u044f\u043d\u0432.46",
    "country": "China"
  },
  {
    "Rank": "5923",
    "Name": "New York Mortgage Trust",
    "Symbol": "NYMT",
    " marketcap ": " $556 489 600 ",
    "price (USD)": "06.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "5924",
    "Name": "FRP Holdings",
    "Symbol": "FRPH",
    " marketcap ": " $556 334 976 ",
    "price (USD)": "29.25",
    "country": "United States"
  },
  {
    "Rank": "5925",
    "Name": "Berry Corporation",
    "Symbol": "BRY",
    " marketcap ": " $555 499 584 ",
    "price (USD)": "\u0438\u044e\u043b.22",
    "country": "United States"
  },
  {
    "Rank": "5926",
    "Name": "Frontera Energy",
    "Symbol": "FEC.TO",
    " marketcap ": " $554 976 027 ",
    "price (USD)": "6.56916",
    "country": "Canada"
  },
  {
    "Rank": "5927",
    "Name": "Designer Brands",
    "Symbol": "DBI",
    " marketcap ": " $554 525 760 ",
    "price (USD)": "09.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "5928",
    "Name": "China Yongda Automobiles Services",
    "Symbol": "3669.HK",
    " marketcap ": " $554 201 539 ",
    "price (USD)": "0.288316",
    "country": "China"
  },
  {
    "Rank": "5929",
    "Name": "Farmland Partners",
    "Symbol": "FPI",
    " marketcap ": " $553 934 784 ",
    "price (USD)": "\u043d\u043e\u044f.22",
    "country": "United States"
  },
  {
    "Rank": "5930",
    "Name": "Heidelbergcement India",
    "Symbol": "HEIDELBERG.NS",
    " marketcap ": " $553 823 690 ",
    "price (USD)": "2.44392",
    "country": "India"
  },
  {
    "Rank": "5931",
    "Name": "Orient Electric",
    "Symbol": "ORIENTELEC.NS",
    " marketcap ": " $553 731 216 ",
    "price (USD)": "2.59171",
    "country": "India"
  },
  {
    "Rank": "5932",
    "Name": "Clean Energy Fuels",
    "Symbol": "CLNE",
    " marketcap ": " $553 692 288 ",
    "price (USD)": "\u0444\u0435\u0432.48",
    "country": "United States"
  },
  {
    "Rank": "5933",
    "Name": "National Presto Industries",
    "Symbol": "NPK",
    " marketcap ": " $553 473 216 ",
    "price (USD)": "77.98",
    "country": "United States"
  },
  {
    "Rank": "5934",
    "Name": "York Water",
    "Symbol": "YORW",
    " marketcap ": " $552 410 496 ",
    "price (USD)": "38.51",
    "country": "United States"
  },
  {
    "Rank": "5935",
    "Name": "EZCorp",
    "Symbol": "EZPW",
    " marketcap ": " $552 171 136 ",
    "price (USD)": "10.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "5936",
    "Name": "STEICO SE",
    "Symbol": "ST5.DE",
    " marketcap ": " $551 319 553 ",
    "price (USD)": "39.1465",
    "country": "Germany"
  },
  {
    "Rank": "5937",
    "Name": "Y-mAbs Therapeutics",
    "Symbol": "YMAB",
    " marketcap ": " $551 165 504 ",
    "price (USD)": "\u0434\u0435\u043a.56",
    "country": "United States"
  },
  {
    "Rank": "5938",
    "Name": "Sun Corp",
    "Symbol": "6736.T",
    " marketcap ": " $550 591 764 ",
    "price (USD)": "24.7585",
    "country": "Japan"
  },
  {
    "Rank": "5939",
    "Name": "Ranpak",
    "Symbol": "PACK",
    " marketcap ": " $550 252 224 ",
    "price (USD)": "\u0438\u044e\u043d.63",
    "country": "United States"
  },
  {
    "Rank": "5940",
    "Name": "Caisse R\u0413\u00a9gionale de Cr\u0413\u00a9dit Agricole Mutuel Loire Haute-Loire",
    "Symbol": "CRLO.PA",
    " marketcap ": " $549 950 805 ",
    "price (USD)": "68.4005",
    "country": "France"
  },
  {
    "Rank": "5941",
    "Name": "Compass Minerals",
    "Symbol": "CMP",
    " marketcap ": " $549 326 208 ",
    "price (USD)": "13.29",
    "country": "United States"
  },
  {
    "Rank": "5942",
    "Name": "Independent Bank (Michigan)",
    "Symbol": "IBCP",
    " marketcap ": " $549 106 048 ",
    "price (USD)": "26.27",
    "country": "United States"
  },
  {
    "Rank": "5943",
    "Name": "Tamdeen Real Estate Company",
    "Symbol": "TAM.KW",
    " marketcap ": " $548 783 103 ",
    "price (USD)": "1206",
    "country": "Kuwait"
  },
  {
    "Rank": "5944",
    "Name": "Secureworks",
    "Symbol": "SCWX",
    " marketcap ": " $548 732 992 ",
    "price (USD)": "\u0438\u044e\u043d.21",
    "country": "United States"
  },
  {
    "Rank": "5945",
    "Name": "Thob Al Aseel Company",
    "Symbol": "4012.SR",
    " marketcap ": " $548 661 703 ",
    "price (USD)": "1.37165",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5946",
    "Name": "Birla Carbon (Thailand)",
    "Symbol": "BCT.BK",
    " marketcap ": " $548 544 108 ",
    "price (USD)": "1.82848",
    "country": "Thailand"
  },
  {
    "Rank": "5947",
    "Name": "TrustCo Bank",
    "Symbol": "TRST",
    " marketcap ": " $548 473 472 ",
    "price (USD)": "28.83",
    "country": "United States"
  },
  {
    "Rank": "5948",
    "Name": "Diagnosticos da America (DASA)",
    "Symbol": "DASA3.SA",
    " marketcap ": " $548 450 552 ",
    "price (USD)": "0.734017",
    "country": "Brazil"
  },
  {
    "Rank": "5949",
    "Name": "Ituran",
    "Symbol": "ITRN",
    " marketcap ": " $546 875 072 ",
    "price (USD)": "27.49",
    "country": "Israel"
  },
  {
    "Rank": "5950",
    "Name": "Altimmune",
    "Symbol": "ALT",
    " marketcap ": " $545 946 944 ",
    "price (USD)": "07.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5951",
    "Name": "ADS-TEC Energy",
    "Symbol": "ADSE",
    " marketcap ": " $543 786 624 ",
    "price (USD)": "\u043e\u043a\u0442.75",
    "country": "Ireland"
  },
  {
    "Rank": "5952",
    "Name": "Gree",
    "Symbol": "3632.T",
    " marketcap ": " $543 704 845 ",
    "price (USD)": "3.17958",
    "country": "Japan"
  },
  {
    "Rank": "5953",
    "Name": "Orthofix Medical",
    "Symbol": "OFIX",
    " marketcap ": " $543 424 256 ",
    "price (USD)": "14.48",
    "country": "United States"
  },
  {
    "Rank": "5954",
    "Name": "GeneDx Holdings",
    "Symbol": "WGS",
    " marketcap ": " $542 631 168 ",
    "price (USD)": "20.75",
    "country": "United States"
  },
  {
    "Rank": "5955",
    "Name": "Greene County Bancorp",
    "Symbol": "GCBC",
    " marketcap ": " $542 303 616 ",
    "price (USD)": "31.85",
    "country": "United States"
  },
  {
    "Rank": "5956",
    "Name": "Aarti Drugs",
    "Symbol": "AARTIDRUGS.NS",
    " marketcap ": " $542 040 043 ",
    "price (USD)": "5.89352",
    "country": "India"
  },
  {
    "Rank": "5957",
    "Name": "The Tinplate Company Of India",
    "Symbol": "TINPLATE.NS",
    " marketcap ": " $541 840 231 ",
    "price (USD)": "5.1726",
    "country": "India"
  },
  {
    "Rank": "5958",
    "Name": "Silvaco Group",
    "Symbol": "SVCO",
    " marketcap ": " $541 771 392 ",
    "price (USD)": "18.99",
    "country": "United States"
  },
  {
    "Rank": "5959",
    "Name": "Absci",
    "Symbol": "ABSI",
    " marketcap ": " $541 672 384 ",
    "price (USD)": "\u0430\u043f\u0440.79",
    "country": "United States"
  },
  {
    "Rank": "5960",
    "Name": "Clariane",
    "Symbol": "CLARI.PA",
    " marketcap ": " $541 368 592 ",
    "price (USD)": "5.08198",
    "country": "France"
  },
  {
    "Rank": "5961",
    "Name": "Taysha Gene Therapies",
    "Symbol": "TSHA",
    " marketcap ": " $540 482 048 ",
    "price (USD)": "\u0444\u0435\u0432.89",
    "country": "United States"
  },
  {
    "Rank": "5962",
    "Name": "Cambridge Bancorp",
    "Symbol": "CATC",
    " marketcap ": " $539 605 120 ",
    "price (USD)": "68.76",
    "country": "United States"
  },
  {
    "Rank": "5963",
    "Name": "Medion AG",
    "Symbol": "MDN.DE",
    " marketcap ": " $538 563 961 ",
    "price (USD)": "12.0534",
    "country": "Germany"
  },
  {
    "Rank": "5964",
    "Name": "COMPASS Pathways",
    "Symbol": "CMPS",
    " marketcap ": " $538 157 632 ",
    "price (USD)": "\u0438\u044e\u043b.87",
    "country": "United Kingdom"
  },
  {
    "Rank": "5965",
    "Name": "SIGA Technologies",
    "Symbol": "SIGA",
    " marketcap ": " $537 686 080 ",
    "price (USD)": "\u0438\u044e\u043b.56",
    "country": "United States"
  },
  {
    "Rank": "5966",
    "Name": "GrafTech",
    "Symbol": "EAF",
    " marketcap ": " $537 479 040 ",
    "price (USD)": "02.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "5967",
    "Name": "Pulse Biosciences",
    "Symbol": "PLSE",
    " marketcap ": " $537 342 144 ",
    "price (USD)": "\u0441\u0435\u043d.73",
    "country": "United States"
  },
  {
    "Rank": "5968",
    "Name": "North American Construction Group",
    "Symbol": "NOA",
    " marketcap ": " $537 149 440 ",
    "price (USD)": "20.\u0438\u044e\u043b",
    "country": "Canada"
  },
  {
    "Rank": "5969",
    "Name": "SmarTone Telecommunications",
    "Symbol": "0315.HK",
    " marketcap ": " $536 932 570 ",
    "price (USD)": "0.486934",
    "country": "Hong Kong"
  },
  {
    "Rank": "5970",
    "Name": "Harbour Centre Development",
    "Symbol": "0051.HK",
    " marketcap ": " $535 835 802 ",
    "price (USD)": "0.756029",
    "country": "Hong Kong"
  },
  {
    "Rank": "5971",
    "Name": "Arabi Group Holding",
    "Symbol": "AGHC.KW",
    " marketcap ": " $535 573 351 ",
    "price (USD)": "1548.24",
    "country": "Kuwait"
  },
  {
    "Rank": "5972",
    "Name": "Celesc (Centrais El\u0413\u00a9tricas de Santa Catarina)",
    "Symbol": "CLSC4.SA",
    " marketcap ": " $535 511 520 ",
    "price (USD)": "14.3133",
    "country": "Brazil"
  },
  {
    "Rank": "5973",
    "Name": "Titan Machinery",
    "Symbol": "TITN",
    " marketcap ": " $535 103 232 ",
    "price (USD)": "23.45",
    "country": "United States"
  },
  {
    "Rank": "5974",
    "Name": "Jupiter Fund Management",
    "Symbol": "JUP.L",
    " marketcap ": " $535 010 529 ",
    "price (USD)": "1.04682",
    "country": "United Kingdom"
  },
  {
    "Rank": "5975",
    "Name": "Cognyte Software",
    "Symbol": "CGNT",
    " marketcap ": " $534 807 008 ",
    "price (USD)": "\u0438\u044e\u043b.53",
    "country": "Israel"
  },
  {
    "Rank": "5976",
    "Name": "Gulf Warehousing Company",
    "Symbol": "GWCS.QA",
    " marketcap ": " $534 511 754 ",
    "price (USD)": "0.912088",
    "country": "Qatar"
  },
  {
    "Rank": "5977",
    "Name": "Sun Country Airlines",
    "Symbol": "SNCY",
    " marketcap ": " $534 491 872 ",
    "price (USD)": "\u043e\u043a\u0442.15",
    "country": "United States"
  },
  {
    "Rank": "5978",
    "Name": "Tetra Technologies",
    "Symbol": "TTI",
    " marketcap ": " $533 735 744 ",
    "price (USD)": "04.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5979",
    "Name": "YIT",
    "Symbol": "YIT.HE",
    " marketcap ": " $531 804 973 ",
    "price (USD)": "2.30644",
    "country": "Finland"
  },
  {
    "Rank": "5980",
    "Name": "Magic Software",
    "Symbol": "MGIC",
    " marketcap ": " $531 745 408 ",
    "price (USD)": "\u043e\u043a\u0442.83",
    "country": "Israel"
  },
  {
    "Rank": "5981",
    "Name": "Qatari Investors Group",
    "Symbol": "QIGD.QA",
    " marketcap ": " $531 463 771 ",
    "price (USD)": "0.427473",
    "country": "Qatar"
  },
  {
    "Rank": "5982",
    "Name": "Kaveri Seed",
    "Symbol": "KSCL.NS",
    " marketcap ": " $531 180 059 ",
    "price (USD)": "\u043e\u043a\u0442.22",
    "country": "India"
  },
  {
    "Rank": "5983",
    "Name": "Alamar Foods Company",
    "Symbol": "6014.SR",
    " marketcap ": " $530 101 673 ",
    "price (USD)": "20.7883",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5984",
    "Name": "Entrada Therapeutics",
    "Symbol": "TRDA",
    " marketcap ": " $530 016 288 ",
    "price (USD)": "15.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "5985",
    "Name": "Valhi",
    "Symbol": "VHI",
    " marketcap ": " $529 843 584 ",
    "price (USD)": "18.73",
    "country": "United States"
  },
  {
    "Rank": "5986",
    "Name": "Daily Journal",
    "Symbol": "DJCO",
    " marketcap ": " $529 591 968 ",
    "price (USD)": "384.59",
    "country": "United States"
  },
  {
    "Rank": "5987",
    "Name": "Orient Cement",
    "Symbol": "ORIENTCEM.NS",
    " marketcap ": " $529 244 245 ",
    "price (USD)": "2.58209",
    "country": "India"
  },
  {
    "Rank": "5988",
    "Name": "Herfy Food Services Company",
    "Symbol": "6002.SR",
    " marketcap ": " $529 032 099 ",
    "price (USD)": "8.17922",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "5989",
    "Name": "Supermax Corporation Berhad",
    "Symbol": "7106.KL",
    " marketcap ": " $527 089 246 ",
    "price (USD)": "0.205603",
    "country": "Malaysia"
  },
  {
    "Rank": "5990",
    "Name": "Reservoir Media",
    "Symbol": "RSVR",
    " marketcap ": " $527 005 312 ",
    "price (USD)": "\u0430\u0432\u0433.13",
    "country": "United States"
  },
  {
    "Rank": "5991",
    "Name": "Locaweb",
    "Symbol": "LWSA3.SA",
    " marketcap ": " $526 539 451 ",
    "price (USD)": "0.868716",
    "country": "Brazil"
  },
  {
    "Rank": "5992",
    "Name": "Team17",
    "Symbol": "TM17.L",
    " marketcap ": " $526 441 842 ",
    "price (USD)": "3.61061",
    "country": "United Kingdom"
  },
  {
    "Rank": "5993",
    "Name": "Jain Irrigation Systems",
    "Symbol": "JISLDVREQS.NS",
    " marketcap ": " $526 019 642 ",
    "price (USD)": "0.411525",
    "country": "India"
  },
  {
    "Rank": "5994",
    "Name": "Green Dot",
    "Symbol": "GDOT",
    " marketcap ": " $525 182 688 ",
    "price (USD)": "\u0441\u0435\u043d.87",
    "country": "United States"
  },
  {
    "Rank": "5995",
    "Name": "Bally's Corporation",
    "Symbol": "BALY",
    " marketcap ": " $524 685 600 ",
    "price (USD)": "\u0434\u0435\u043a.96",
    "country": "United States"
  },
  {
    "Rank": "5996",
    "Name": "Universal Health Realty Income Trust",
    "Symbol": "UHT",
    " marketcap ": " $524 386 048 ",
    "price (USD)": "37.93",
    "country": "United States"
  },
  {
    "Rank": "5997",
    "Name": "Equity BancShares",
    "Symbol": "EQBK",
    " marketcap ": " $523 632 096 ",
    "price (USD)": "34.33",
    "country": "United States"
  },
  {
    "Rank": "5998",
    "Name": "Olema Pharmaceuticals",
    "Symbol": "OLMA",
    " marketcap ": " $523 540 352 ",
    "price (USD)": "\u0441\u0435\u043d.36",
    "country": "United States"
  },
  {
    "Rank": "5999",
    "Name": "PlayWay",
    "Symbol": "PLW.WA",
    " marketcap ": " $522 525 283 ",
    "price (USD)": "79.1705",
    "country": "Poland"
  },
  {
    "Rank": "6000",
    "Name": "Shenzhen Zqgame",
    "Symbol": "300052.SZ",
    " marketcap ": " $521 598 347 ",
    "price (USD)": "1.99191",
    "country": "China"
  },
  {
    "Rank": "6001",
    "Name": "Nano-X Imaging",
    "Symbol": "NNOX",
    " marketcap ": " $520 676 192 ",
    "price (USD)": "09.\u044f\u043d\u0432",
    "country": "Israel"
  },
  {
    "Rank": "6002",
    "Name": "Alector",
    "Symbol": "ALEC",
    " marketcap ": " $519 512 992 ",
    "price (USD)": "\u043c\u0430\u0439.39",
    "country": "United States"
  },
  {
    "Rank": "6003",
    "Name": "Varta",
    "Symbol": "VAR1.F",
    " marketcap ": " $519 072 073 ",
    "price (USD)": "12.1729",
    "country": "Germany"
  },
  {
    "Rank": "6004",
    "Name": "Black Box",
    "Symbol": "BBOX.NS",
    " marketcap ": " $518 854 262 ",
    "price (USD)": "3.08794",
    "country": "India"
  },
  {
    "Rank": "6005",
    "Name": "Ur Energy",
    "Symbol": "URG",
    " marketcap ": " $518 823 328 ",
    "price (USD)": "\u044f\u043d\u0432.83",
    "country": "United States"
  },
  {
    "Rank": "6006",
    "Name": "Heron Therapeutics",
    "Symbol": "HRTX",
    " marketcap ": " $518 246 304 ",
    "price (USD)": "\u043c\u0430\u0440.44",
    "country": "United States"
  },
  {
    "Rank": "6007",
    "Name": "Imagicaaworld Entertainment",
    "Symbol": "IMAGICAA.NS",
    " marketcap ": " $518 233 516 ",
    "price (USD)": "0.954618",
    "country": "India"
  },
  {
    "Rank": "6008",
    "Name": "Al-Ahleia Insurance",
    "Symbol": "AINS.KW",
    " marketcap ": " $517 021 538 ",
    "price (USD)": "2385.92",
    "country": "Kuwait"
  },
  {
    "Rank": "6009",
    "Name": "Avon Protection",
    "Symbol": "AVON.L",
    " marketcap ": " $516 893 062 ",
    "price (USD)": "17.2318",
    "country": "United Kingdom"
  },
  {
    "Rank": "6010",
    "Name": "Gladstone Investment",
    "Symbol": "GAIN",
    " marketcap ": " $515 843 136 ",
    "price (USD)": "14.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "6011",
    "Name": "Bahnhof AB",
    "Symbol": "3B7.F",
    " marketcap ": " $515 007 423 ",
    "price (USD)": "4.73993",
    "country": "Sweden"
  },
  {
    "Rank": "6012",
    "Name": "SmartRent",
    "Symbol": "SMRT",
    " marketcap ": " $514 661 376 ",
    "price (USD)": "\u0444\u0435\u0432.55",
    "country": "United States"
  },
  {
    "Rank": "6013",
    "Name": "Adaptive Biotechnologies",
    "Symbol": "ADPT",
    " marketcap ": " $514 314 336 ",
    "price (USD)": "\u043c\u0430\u0440.49",
    "country": "United States"
  },
  {
    "Rank": "6014",
    "Name": "PayPoint",
    "Symbol": "PAY.L",
    " marketcap ": " $514 234 797 ",
    "price (USD)": "7.07375",
    "country": "United Kingdom"
  },
  {
    "Rank": "6015",
    "Name": "Clearfield",
    "Symbol": "CLFD",
    " marketcap ": " $513 679 808 ",
    "price (USD)": "36.09",
    "country": "United States"
  },
  {
    "Rank": "6016",
    "Name": "Gannett",
    "Symbol": "GCI",
    " marketcap ": " $513 467 040 ",
    "price (USD)": "\u043c\u0430\u0440.48",
    "country": "United States"
  },
  {
    "Rank": "6017",
    "Name": "Aurelius Group",
    "Symbol": "AR4.DE",
    " marketcap ": " $513 292 829 ",
    "price (USD)": "19.24",
    "country": "Germany"
  },
  {
    "Rank": "6018",
    "Name": "Heritage Commerce",
    "Symbol": "HTBK",
    " marketcap ": " $512 711 872 ",
    "price (USD)": "\u0430\u0432\u0433.37",
    "country": "United States"
  },
  {
    "Rank": "6019",
    "Name": "Consolidated Communications",
    "Symbol": "CNSL",
    " marketcap ": " $511 617 632 ",
    "price (USD)": "\u0430\u043f\u0440.32",
    "country": "United States"
  },
  {
    "Rank": "6020",
    "Name": "One Liberty Properties",
    "Symbol": "OLP",
    " marketcap ": " $510 836 768 ",
    "price (USD)": "23.96",
    "country": "United States"
  },
  {
    "Rank": "6021",
    "Name": "West Coast Paper Mills",
    "Symbol": "WSTCSTPAPR.NS",
    " marketcap ": " $510 798 095 ",
    "price (USD)": "7.72285",
    "country": "India"
  },
  {
    "Rank": "6022",
    "Name": "Ooredoo Oman",
    "Symbol": "ORDS.OM",
    " marketcap ": " $510 743 459 ",
    "price (USD)": "0.784619",
    "country": "Oman"
  },
  {
    "Rank": "6023",
    "Name": "SandRidge Energy",
    "Symbol": "SD",
    " marketcap ": " $510 102 976 ",
    "price (USD)": "13.74",
    "country": "United States"
  },
  {
    "Rank": "6024",
    "Name": "OmniAb",
    "Symbol": "OABI",
    " marketcap ": " $508 096 832 ",
    "price (USD)": "\u0430\u043f\u0440.32",
    "country": "United States"
  },
  {
    "Rank": "6025",
    "Name": "American National Bank &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6026",
    "Name": "Dubai Refreshment",
    "Symbol": "DRC.AE",
    " marketcap ": " $507 228 638 ",
    "price (USD)": "5.63587",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6027",
    "Name": "Mannai Corporation",
    "Symbol": "MCCS.QA",
    " marketcap ": " $506 448 316 ",
    "price (USD)": "1.11016",
    "country": "Qatar"
  },
  {
    "Rank": "6028",
    "Name": "Artis REIT",
    "Symbol": "AX-UN.TO",
    " marketcap ": " $505 450 692 ",
    "price (USD)": "4.76557",
    "country": "Canada"
  },
  {
    "Rank": "6029",
    "Name": "Radius Recycling (Schnitzer Steel)",
    "Symbol": "RDUS",
    " marketcap ": " $504 798 912 ",
    "price (USD)": "18.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "6030",
    "Name": "Community Health Systems",
    "Symbol": "CYH",
    " marketcap ": " $504 446 592 ",
    "price (USD)": "\u043c\u0430\u0440.63",
    "country": "United States"
  },
  {
    "Rank": "6031",
    "Name": "LanzaTech Global",
    "Symbol": "LNZA",
    " marketcap ": " $504 224 256 ",
    "price (USD)": "\u0444\u0435\u0432.55",
    "country": "United States"
  },
  {
    "Rank": "6032",
    "Name": "HomeTrust Bancshares",
    "Symbol": "HTBI",
    " marketcap ": " $503 805 824 ",
    "price (USD)": "28.88",
    "country": "United States"
  },
  {
    "Rank": "6033",
    "Name": "JTEKT India",
    "Symbol": "JTEKTINDIA.NS",
    " marketcap ": " $503 802 703 ",
    "price (USD)": "1.97893",
    "country": "India"
  },
  {
    "Rank": "6034",
    "Name": "Larimar Therapeutics",
    "Symbol": "LRMR",
    " marketcap ": " $503 397 760 ",
    "price (USD)": "\u0438\u044e\u043b.89",
    "country": "United States"
  },
  {
    "Rank": "6035",
    "Name": "Mobico Group",
    "Symbol": "MCG.L",
    " marketcap ": " $503 326 148 ",
    "price (USD)": "0.819635",
    "country": "United Kingdom"
  },
  {
    "Rank": "6036",
    "Name": "Travere Therapeutics",
    "Symbol": "TVTX",
    " marketcap ": " $503 212 704 ",
    "price (USD)": "\u0438\u044e\u043d.61",
    "country": "United States"
  },
  {
    "Rank": "6037",
    "Name": "Sunnova",
    "Symbol": "NOVA",
    " marketcap ": " $502 127 136 ",
    "price (USD)": "04.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "6038",
    "Name": "Carrols Restaurant Group",
    "Symbol": "TAST",
    " marketcap ": " $502 007 200 ",
    "price (USD)": "\u0441\u0435\u043d.54",
    "country": "United States"
  },
  {
    "Rank": "6039",
    "Name": "Borussia Dortmund",
    "Symbol": "BVB.F",
    " marketcap ": " $501 640 743 ",
    "price (USD)": "4.52275",
    "country": "Germany"
  },
  {
    "Rank": "6040",
    "Name": "Subros",
    "Symbol": "SUBROS.NS",
    " marketcap ": " $500 906 412 ",
    "price (USD)": "\u0438\u044e\u043b.84",
    "country": "India"
  },
  {
    "Rank": "6041",
    "Name": "Knaus Tabbert AG",
    "Symbol": "KTA.DE",
    " marketcap ": " $500 887 358 ",
    "price (USD)": "48.2137",
    "country": "Germany"
  },
  {
    "Rank": "6042",
    "Name": "Cloetta",
    "Symbol": "CLA-B.ST",
    " marketcap ": " $500 789 815 ",
    "price (USD)": "1.75505",
    "country": "Sweden"
  },
  {
    "Rank": "6043",
    "Name": "VNET Group",
    "Symbol": "VNET",
    " marketcap ": " $500 100 896 ",
    "price (USD)": "01.\u0441\u0435\u043d",
    "country": "China"
  },
  {
    "Rank": "6044",
    "Name": "Gravity Co.",
    "Symbol": "GRVY",
    " marketcap ": " $499 695 424 ",
    "price (USD)": "71.91",
    "country": "South Korea"
  },
  {
    "Rank": "6045",
    "Name": "Peakstone Realty Trust",
    "Symbol": "PKST",
    " marketcap ": " $499 402 272 ",
    "price (USD)": "13.74",
    "country": "United States"
  },
  {
    "Rank": "6046",
    "Name": "Five Star Bancorp",
    "Symbol": "FSBC",
    " marketcap ": " $498 463 936 ",
    "price (USD)": "23.38",
    "country": "United States"
  },
  {
    "Rank": "6047",
    "Name": "Pacific Biosciences",
    "Symbol": "PACB",
    " marketcap ": " $498 411 488 ",
    "price (USD)": "\u044f\u043d\u0432.83",
    "country": "United States"
  },
  {
    "Rank": "6048",
    "Name": "Brasil Agro",
    "Symbol": "LND",
    " marketcap ": " $498 077 504 ",
    "price (USD)": "5",
    "country": "Brazil"
  },
  {
    "Rank": "6049",
    "Name": "SurModics",
    "Symbol": "SRDX",
    " marketcap ": " $497 531 392 ",
    "price (USD)": "34.89",
    "country": "United States"
  },
  {
    "Rank": "6050",
    "Name": "IGM Biosciences",
    "Symbol": "IGMS",
    " marketcap ": " $496 388 480 ",
    "price (USD)": "\u0430\u0432\u0433.41",
    "country": "United States"
  },
  {
    "Rank": "6051",
    "Name": "Gladstone Land",
    "Symbol": "LAND",
    " marketcap ": " $496 361 856 ",
    "price (USD)": "13.85",
    "country": "United States"
  },
  {
    "Rank": "6052",
    "Name": "OPAL Fuels",
    "Symbol": "OPAL",
    " marketcap ": " $496 301 408 ",
    "price (USD)": "04.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6053",
    "Name": "Eventbrite",
    "Symbol": "EB",
    " marketcap ": " $496 259 168 ",
    "price (USD)": "05.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "6054",
    "Name": "Metropolitan Bank Holding",
    "Symbol": "MCB",
    " marketcap ": " $495 957 408 ",
    "price (USD)": "44.31",
    "country": "United States"
  },
  {
    "Rank": "6055",
    "Name": "Oculis Holding AG",
    "Symbol": "OCS",
    " marketcap ": " $495 631 424 ",
    "price (USD)": "11.\u0441\u0435\u043d",
    "country": "Switzerland"
  },
  {
    "Rank": "6056",
    "Name": "Hanmi Financial",
    "Symbol": "HAFC",
    " marketcap ": " $495 309 696 ",
    "price (USD)": "16.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6057",
    "Name": "Cross Country Healthcare",
    "Symbol": "CCRN",
    " marketcap ": " $495 183 168 ",
    "price (USD)": "14.24",
    "country": "United States"
  },
  {
    "Rank": "6058",
    "Name": "Lexeo Therapeutics",
    "Symbol": "LXEO",
    " marketcap ": " $494 179 488 ",
    "price (USD)": "15",
    "country": "United States"
  },
  {
    "Rank": "6059",
    "Name": "Daktronics",
    "Symbol": "DAKT",
    " marketcap ": " $493 743 168 ",
    "price (USD)": "\u043d\u043e\u044f.15",
    "country": "United States"
  },
  {
    "Rank": "6060",
    "Name": "Arzan Financial Group for Financing and Investment",
    "Symbol": "ARZAN.KW",
    " marketcap ": " $493 425 606 ",
    "price (USD)": "606.258",
    "country": "Kuwait"
  },
  {
    "Rank": "6061",
    "Name": "Kewal Kiran Clothing",
    "Symbol": "KKCL.NS",
    " marketcap ": " $492 767 613 ",
    "price (USD)": "\u0438\u044e\u043b.62",
    "country": "India"
  },
  {
    "Rank": "6062",
    "Name": "Harpoon Therapeutics",
    "Symbol": "HARP",
    " marketcap ": " $492 349 568 ",
    "price (USD)": "23.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "6063",
    "Name": "Dada Nexus",
    "Symbol": "DADA",
    " marketcap ": " $492 036 960 ",
    "price (USD)": "\u044f\u043d\u0432.86",
    "country": "China"
  },
  {
    "Rank": "6064",
    "Name": "Gulf Investment House Company",
    "Symbol": "GIH.KW",
    " marketcap ": " $491 794 472 ",
    "price (USD)": "1235.33",
    "country": "Kuwait"
  },
  {
    "Rank": "6065",
    "Name": "Franklin Covey",
    "Symbol": "FC",
    " marketcap ": " $491 505 280 ",
    "price (USD)": "37.05",
    "country": "United States"
  },
  {
    "Rank": "6066",
    "Name": "MaxCyte",
    "Symbol": "MXCT",
    " marketcap ": " $491 447 872 ",
    "price (USD)": "\u0430\u043f\u0440.62",
    "country": "United States"
  },
  {
    "Rank": "6067",
    "Name": "Greatland Gold",
    "Symbol": "GGP.L",
    " marketcap ": " $491 189 280 ",
    "price (USD)": "0.0964936",
    "country": "United Kingdom"
  },
  {
    "Rank": "6068",
    "Name": "Mail.ru Group",
    "Symbol": "RL9A.F",
    " marketcap ": " $491 152 151 ",
    "price (USD)": "2.17179",
    "country": "Cyprus"
  },
  {
    "Rank": "6069",
    "Name": "TScan Therapeutics",
    "Symbol": "TCRX",
    " marketcap ": " $490 566 784 ",
    "price (USD)": "\u0441\u0435\u043d.28",
    "country": "United States"
  },
  {
    "Rank": "6070",
    "Name": "Sukoon Insurance",
    "Symbol": "SUKOON.AE",
    " marketcap ": " $490 456 848 ",
    "price (USD)": "1.06189",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6071",
    "Name": "Macatawa Bank",
    "Symbol": "MCBC",
    " marketcap ": " $490 340 032 ",
    "price (USD)": "14.27",
    "country": "United States"
  },
  {
    "Rank": "6072",
    "Name": "Yatsen Holding",
    "Symbol": "YSG",
    " marketcap ": " $490 062 336 ",
    "price (USD)": "\u0430\u043f\u0440.55",
    "country": "China"
  },
  {
    "Rank": "6073",
    "Name": "KalVista Pharmaceuticals",
    "Symbol": "KALV",
    " marketcap ": " $489 806 144 ",
    "price (USD)": "\u043d\u043e\u044f.61",
    "country": "United States"
  },
  {
    "Rank": "6074",
    "Name": "Kvika banki",
    "Symbol": "KVIKA.IC",
    " marketcap ": " $488 784 700 ",
    "price (USD)": "0.103511",
    "country": "Iceland"
  },
  {
    "Rank": "6075",
    "Name": "Allient",
    "Symbol": "ALNT",
    " marketcap ": " $488 676 128 ",
    "price (USD)": "29.13",
    "country": "United States"
  },
  {
    "Rank": "6076",
    "Name": "Almawarid Manpower Company",
    "Symbol": "1833.SR",
    " marketcap ": " $488 351 613 ",
    "price (USD)": "32.5568",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6077",
    "Name": "IGG Inc",
    "Symbol": "0799.HK",
    " marketcap ": " $487 885 102 ",
    "price (USD)": "0.415175",
    "country": "Singapore"
  },
  {
    "Rank": "6078",
    "Name": "Northeast Bank",
    "Symbol": "NBN",
    " marketcap ": " $487 436 832 ",
    "price (USD)": "61.1",
    "country": "United States"
  },
  {
    "Rank": "6079",
    "Name": "Movida Participa\u0413\u00a7\u0413\u00b5es",
    "Symbol": "MOVI3.SA",
    " marketcap ": " $486 118 837 ",
    "price (USD)": "1.27477",
    "country": "Brazil"
  },
  {
    "Rank": "6080",
    "Name": "Gladstone Capital",
    "Symbol": "GLAD",
    " marketcap ": " $485 560 448 ",
    "price (USD)": "22.32",
    "country": "United States"
  },
  {
    "Rank": "6081",
    "Name": "Villeroy &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6082",
    "Name": "Ceres Power",
    "Symbol": "CWR.L",
    " marketcap ": " $484 771 827 ",
    "price (USD)": "2.51156",
    "country": "United Kingdom"
  },
  {
    "Rank": "6083",
    "Name": "PennantPark Investment",
    "Symbol": "PNNT",
    " marketcap ": " $484 618 016 ",
    "price (USD)": "\u0438\u044e\u043b.43",
    "country": "United States"
  },
  {
    "Rank": "6084",
    "Name": "Intchains Group",
    "Symbol": "ICG",
    " marketcap ": " $484 299 040 ",
    "price (USD)": "08.\u0430\u0432\u0433",
    "country": "China"
  },
  {
    "Rank": "6085",
    "Name": "Southern Missouri Bancorp",
    "Symbol": "SMBC",
    " marketcap ": " $483 735 776 ",
    "price (USD)": "42.6",
    "country": "United States"
  },
  {
    "Rank": "6086",
    "Name": "Zengame Technology",
    "Symbol": "2660.HK",
    " marketcap ": " $483 345 719 ",
    "price (USD)": "0.468994",
    "country": "China"
  },
  {
    "Rank": "6087",
    "Name": "Corbus Pharmaceuticals",
    "Symbol": "CRBP",
    " marketcap ": " $483 038 848 ",
    "price (USD)": "45.2",
    "country": "United States"
  },
  {
    "Rank": "6088",
    "Name": "HarborOne Bancorp",
    "Symbol": "HONE",
    " marketcap ": " $482 497 568 ",
    "price (USD)": "10.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6089",
    "Name": "OneSpan",
    "Symbol": "OSPN",
    " marketcap ": " $481 773 184 ",
    "price (USD)": "\u0434\u0435\u043a.73",
    "country": "United States"
  },
  {
    "Rank": "6090",
    "Name": "Fujimori Kogyo",
    "Symbol": "7917.T",
    " marketcap ": " $481 696 367 ",
    "price (USD)": "25.9101",
    "country": "Japan"
  },
  {
    "Rank": "6091",
    "Name": "SunPower",
    "Symbol": "SPWR",
    " marketcap ": " $480 806 944 ",
    "price (USD)": "\u0444\u0435\u0432.74",
    "country": "United States"
  },
  {
    "Rank": "6092",
    "Name": "Acco Brands",
    "Symbol": "ACCO",
    " marketcap ": " $480 111 264 ",
    "price (USD)": "05.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "6093",
    "Name": "Bannerman Energy",
    "Symbol": "BMN.AX",
    " marketcap ": " $480 023 130 ",
    "price (USD)": "3.14067",
    "country": "Australia"
  },
  {
    "Rank": "6094",
    "Name": "Shinpoong Pharm",
    "Symbol": "019170.KS",
    " marketcap ": " $479 806 570 ",
    "price (USD)": "9.73811",
    "country": "South Korea"
  },
  {
    "Rank": "6095",
    "Name": "3D Systems",
    "Symbol": "DDD",
    " marketcap ": " $479 692 192 ",
    "price (USD)": "\u043c\u0430\u0440.59",
    "country": "United States"
  },
  {
    "Rank": "6096",
    "Name": "UroGen Pharma",
    "Symbol": "URGN",
    " marketcap ": " $479 446 432 ",
    "price (USD)": "13.27",
    "country": "United States"
  },
  {
    "Rank": "6097",
    "Name": "CEVA",
    "Symbol": "CEVA",
    " marketcap ": " $478 480 832 ",
    "price (USD)": "20.29",
    "country": "United States"
  },
  {
    "Rank": "6098",
    "Name": "National CineMedia",
    "Symbol": "NCMI",
    " marketcap ": " $478 036 832 ",
    "price (USD)": "\u0430\u043f\u0440.95",
    "country": "United States"
  },
  {
    "Rank": "6099",
    "Name": "Cantaloupe",
    "Symbol": "CTLP",
    " marketcap ": " $477 631 616 ",
    "price (USD)": "\u0438\u044e\u043d.56",
    "country": "United States"
  },
  {
    "Rank": "6100",
    "Name": "Capital City Bank Group",
    "Symbol": "CCBG",
    " marketcap ": " $476 781 632 ",
    "price (USD)": "28.14",
    "country": "United States"
  },
  {
    "Rank": "6101",
    "Name": "Tejon Ranch",
    "Symbol": "TRC",
    " marketcap ": " $476 189 824 ",
    "price (USD)": "17.77",
    "country": "United States"
  },
  {
    "Rank": "6102",
    "Name": "Ocugen",
    "Symbol": "OCGN",
    " marketcap ": " $476 056 800 ",
    "price (USD)": "\u044f\u043d\u0432.85",
    "country": "United States"
  },
  {
    "Rank": "6103",
    "Name": "Calavo Growers",
    "Symbol": "CVGW",
    " marketcap ": " $475 802 016 ",
    "price (USD)": "26.73",
    "country": "United States"
  },
  {
    "Rank": "6104",
    "Name": "Greenlight Reinsurance",
    "Symbol": "GLRE",
    " marketcap ": " $475 775 232 ",
    "price (USD)": "13.47",
    "country": "Cayman Islands"
  },
  {
    "Rank": "6105",
    "Name": "Camden National Bank",
    "Symbol": "CAC",
    " marketcap ": " $475 302 016 ",
    "price (USD)": "32.54",
    "country": "United States"
  },
  {
    "Rank": "6106",
    "Name": "Indian Metals &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6107",
    "Name": "Jin Air",
    "Symbol": "272450.KS",
    " marketcap ": " $474 969 268 ",
    "price (USD)": "9.21669",
    "country": "South Korea"
  },
  {
    "Rank": "6108",
    "Name": "Fulcrum Therapeutics",
    "Symbol": "FULC",
    " marketcap ": " $474 853 504 ",
    "price (USD)": "\u0438\u044e\u043b.64",
    "country": "United States"
  },
  {
    "Rank": "6109",
    "Name": "Rackspace Technology",
    "Symbol": "RXT",
    " marketcap ": " $474 564 096 ",
    "price (USD)": "02.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "6110",
    "Name": "Tellurian",
    "Symbol": "TELL",
    " marketcap ": " $473 889 824 ",
    "price (USD)": "0.5667",
    "country": "United States"
  },
  {
    "Rank": "6111",
    "Name": "Beyond Meat",
    "Symbol": "BYND",
    " marketcap ": " $473 658 336 ",
    "price (USD)": "07.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6112",
    "Name": "Heisco (Heavy Engineering Industries and Shipbuilding Company)",
    "Symbol": "SHIP.KW",
    " marketcap ": " $472 924 381 ",
    "price (USD)": "2623.86",
    "country": "Kuwait"
  },
  {
    "Rank": "6113",
    "Name": "Reginn",
    "Symbol": "REGINN.IC",
    " marketcap ": " $472 409 712 ",
    "price (USD)": "0.165038",
    "country": "Iceland"
  },
  {
    "Rank": "6114",
    "Name": "SelectQuote",
    "Symbol": "SLQT",
    " marketcap ": " $471 953 632 ",
    "price (USD)": "\u0444\u0435\u0432.79",
    "country": "United States"
  },
  {
    "Rank": "6115",
    "Name": "Halwani Bros",
    "Symbol": "6001.SR",
    " marketcap ": " $471 767 666 ",
    "price (USD)": "13.3429",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6116",
    "Name": "ZimVie",
    "Symbol": "ZIMV",
    " marketcap ": " $471 548 768 ",
    "price (USD)": "17.28",
    "country": "United States"
  },
  {
    "Rank": "6117",
    "Name": "Korro Bio",
    "Symbol": "KRRO",
    " marketcap ": " $471 067 872 ",
    "price (USD)": "50.8",
    "country": "United States"
  },
  {
    "Rank": "6118",
    "Name": "Orchid Island Capital",
    "Symbol": "ORC",
    " marketcap ": " $471 011 328 ",
    "price (USD)": "\u0430\u0432\u0433.66",
    "country": "United States"
  },
  {
    "Rank": "6119",
    "Name": "COLOPL",
    "Symbol": "3668.T",
    " marketcap ": " $470 563 087 ",
    "price (USD)": "3.66579",
    "country": "Japan"
  },
  {
    "Rank": "6120",
    "Name": "Adlai Nortye",
    "Symbol": "ANL",
    " marketcap ": " $470 478 816 ",
    "price (USD)": "\u0434\u0435\u043a.75",
    "country": "Cayman Islands"
  },
  {
    "Rank": "6121",
    "Name": "i-80 Gold",
    "Symbol": "IAUX",
    " marketcap ": " $469 574 336 ",
    "price (USD)": "\u044f\u043d\u0432.22",
    "country": "United States"
  },
  {
    "Rank": "6122",
    "Name": "Galiano Gold",
    "Symbol": "GAU",
    " marketcap ": " $467 595 520 ",
    "price (USD)": "\u044f\u043d\u0432.84",
    "country": "Canada"
  },
  {
    "Rank": "6123",
    "Name": "Funko",
    "Symbol": "FNKO",
    " marketcap ": " $467 382 432 ",
    "price (USD)": "\u0430\u0432\u0433.72",
    "country": "United States"
  },
  {
    "Rank": "6124",
    "Name": "Luther Burbank",
    "Symbol": "LBC",
    " marketcap ": " $466 804 608 ",
    "price (USD)": "\u0441\u0435\u043d.15",
    "country": "United States"
  },
  {
    "Rank": "6125",
    "Name": "Talkspace",
    "Symbol": "TALK",
    " marketcap ": " $466 633 728 ",
    "price (USD)": "\u0444\u0435\u0432.75",
    "country": "United States"
  },
  {
    "Rank": "6126",
    "Name": "Verve Therapeutics",
    "Symbol": "VERV",
    " marketcap ": " $465 168 896 ",
    "price (USD)": "\u043c\u0430\u0439.54",
    "country": "United States"
  },
  {
    "Rank": "6127",
    "Name": "CI&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6128",
    "Name": "Washington Trust Bancorp",
    "Symbol": "WASH",
    " marketcap ": " $464 561 856 ",
    "price (USD)": "27.24",
    "country": "United States"
  },
  {
    "Rank": "6129",
    "Name": "Youdao",
    "Symbol": "DAO",
    " marketcap ": " $464 560 352 ",
    "price (USD)": "\u043c\u0430\u0440.74",
    "country": "China"
  },
  {
    "Rank": "6130",
    "Name": "Enhabit",
    "Symbol": "EHAB",
    " marketcap ": " $463 881 024 ",
    "price (USD)": "\u0441\u0435\u043d.27",
    "country": "United States"
  },
  {
    "Rank": "6131",
    "Name": "Consolidated Water",
    "Symbol": "CWCO",
    " marketcap ": " $463 786 752 ",
    "price (USD)": "29.\u043c\u0430\u0440",
    "country": "Cayman Islands"
  },
  {
    "Rank": "6132",
    "Name": "Union Properties",
    "Symbol": "UPP.AE",
    " marketcap ": " $463 677 255 ",
    "price (USD)": "0.108095",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6133",
    "Name": "Lightwave Logic",
    "Symbol": "LWLG",
    " marketcap ": " $463 562 816 ",
    "price (USD)": "\u043c\u0430\u0440.86",
    "country": "United States"
  },
  {
    "Rank": "6134",
    "Name": "Happinet",
    "Symbol": "7552.T",
    " marketcap ": " $463 477 120 ",
    "price (USD)": "20.888",
    "country": "Japan"
  },
  {
    "Rank": "6135",
    "Name": "Jaypee Group",
    "Symbol": "JPASSOCIAT.NS",
    " marketcap ": " $463 326 138 ",
    "price (USD)": "0.188641",
    "country": "India"
  },
  {
    "Rank": "6136",
    "Name": "LSI Industries",
    "Symbol": "LYTS",
    " marketcap ": " $463 163 808 ",
    "price (USD)": "15.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6137",
    "Name": "Chuy's",
    "Symbol": "CHUY",
    " marketcap ": " $463 145 088 ",
    "price (USD)": "26.88",
    "country": "United States"
  },
  {
    "Rank": "6138",
    "Name": "Kalyani Steels",
    "Symbol": "KSL.NS",
    " marketcap ": " $462 663 215 ",
    "price (USD)": "\u043e\u043a\u0442.44",
    "country": "India"
  },
  {
    "Rank": "6139",
    "Name": "Simona",
    "Symbol": "SIM0.F",
    " marketcap ": " $462 590 944 ",
    "price (USD)": "77.0985",
    "country": "Germany"
  },
  {
    "Rank": "6140",
    "Name": "Kaiser (China) Culture",
    "Symbol": "002425.SZ",
    " marketcap ": " $462 520 918 ",
    "price (USD)": "0.483472",
    "country": "China"
  },
  {
    "Rank": "6141",
    "Name": "Stoneridge",
    "Symbol": "SRI",
    " marketcap ": " $462 109 056 ",
    "price (USD)": "16.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6142",
    "Name": "Northern Region Cement Company",
    "Symbol": "3004.SR",
    " marketcap ": " $461 612 344 ",
    "price (USD)": "2.56451",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6143",
    "Name": "Havertys",
    "Symbol": "HVT",
    " marketcap ": " $460 903 520 ",
    "price (USD)": "28.29",
    "country": "United States"
  },
  {
    "Rank": "6144",
    "Name": "Gamania Digital",
    "Symbol": "6180.TWO",
    " marketcap ": " $460 408 434 ",
    "price (USD)": "\u0444\u0435\u0432.35",
    "country": "Taiwan"
  },
  {
    "Rank": "6145",
    "Name": "Clover Health Investments",
    "Symbol": "CLOV",
    " marketcap ": " $460 296 384 ",
    "price (USD)": "0.9272",
    "country": "United States"
  },
  {
    "Rank": "6146",
    "Name": "Nkarta",
    "Symbol": "NKTX",
    " marketcap ": " $460 153 440 ",
    "price (USD)": "\u0438\u044e\u043d.53",
    "country": "United States"
  },
  {
    "Rank": "6147",
    "Name": "SFC Energy AG",
    "Symbol": "F3C.DE",
    " marketcap ": " $460 065 449 ",
    "price (USD)": "26.4958",
    "country": "Germany"
  },
  {
    "Rank": "6148",
    "Name": "Runway Growth Finance",
    "Symbol": "RWAY",
    " marketcap ": " $459 458 496 ",
    "price (USD)": "\u043d\u043e\u044f.65",
    "country": "United States"
  },
  {
    "Rank": "6149",
    "Name": "Voyager Therapeutics",
    "Symbol": "VYGR",
    " marketcap ": " $459 081 952 ",
    "price (USD)": "\u0430\u0432\u0433.44",
    "country": "United States"
  },
  {
    "Rank": "6150",
    "Name": "Evolv Technologies",
    "Symbol": "EVLV",
    " marketcap ": " $458 895 808 ",
    "price (USD)": "\u0444\u0435\u0432.94",
    "country": "United States"
  },
  {
    "Rank": "6151",
    "Name": "Arabian Shield Cooperative Insurance Company",
    "Symbol": "8070.SR",
    " marketcap ": " $458 789 396 ",
    "price (USD)": "5.74814",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6152",
    "Name": "DATAGROUP SE",
    "Symbol": "D6H.DE",
    " marketcap ": " $458 687 180 ",
    "price (USD)": "55.0548",
    "country": "Germany"
  },
  {
    "Rank": "6153",
    "Name": "Eiken Chemical",
    "Symbol": "4549.T",
    " marketcap ": " $458 619 726 ",
    "price (USD)": "13.2557",
    "country": "Japan"
  },
  {
    "Rank": "6154",
    "Name": "The RealReal",
    "Symbol": "REAL",
    " marketcap ": " $457 786 112 ",
    "price (USD)": "\u0430\u043f\u0440.32",
    "country": "United States"
  },
  {
    "Rank": "6155",
    "Name": "PlayAGS",
    "Symbol": "AGS",
    " marketcap ": " $457 672 224 ",
    "price (USD)": "11.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "6156",
    "Name": "SES AI",
    "Symbol": "SES",
    " marketcap ": " $456 975 360 ",
    "price (USD)": "\u044f\u043d\u0432.28",
    "country": "United States"
  },
  {
    "Rank": "6157",
    "Name": "Esperion Therapeutics",
    "Symbol": "ESPR",
    " marketcap ": " $456 598 624 ",
    "price (USD)": "\u0444\u0435\u0432.41",
    "country": "United States"
  },
  {
    "Rank": "6158",
    "Name": "Oppenheimer Holdings",
    "Symbol": "OPY",
    " marketcap ": " $456 231 904 ",
    "price (USD)": "44.17",
    "country": "United States"
  },
  {
    "Rank": "6159",
    "Name": "Hinduja Global Solutions",
    "Symbol": "HGS.NS",
    " marketcap ": " $456 193 339 ",
    "price (USD)": "\u0441\u0435\u043d.37",
    "country": "India"
  },
  {
    "Rank": "6160",
    "Name": "The Manitowoc Company",
    "Symbol": "MTW",
    " marketcap ": " $455 991 040 ",
    "price (USD)": "\u0434\u0435\u043a.83",
    "country": "United States"
  },
  {
    "Rank": "6161",
    "Name": "Arabian Pipes Company",
    "Symbol": "2200.SR",
    " marketcap ": " $455 261 121 ",
    "price (USD)": "45.5261",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6162",
    "Name": "TMC the metals company",
    "Symbol": "TMC",
    " marketcap ": " $455 124 224 ",
    "price (USD)": "\u044f\u043d\u0432.42",
    "country": "Canada"
  },
  {
    "Rank": "6163",
    "Name": "First Financial",
    "Symbol": "THFF",
    " marketcap ": " $454 606 560 ",
    "price (USD)": "38.48",
    "country": "United States"
  },
  {
    "Rank": "6164",
    "Name": "Editas Medicine",
    "Symbol": "EDIT",
    " marketcap ": " $453 131 392 ",
    "price (USD)": "\u043c\u0430\u0439.51",
    "country": "United States"
  },
  {
    "Rank": "6165",
    "Name": "Dutch Lady Milk Industries",
    "Symbol": "3026.KL",
    " marketcap ": " $452 983 941 ",
    "price (USD)": "7.07787",
    "country": "Malaysia"
  },
  {
    "Rank": "6166",
    "Name": "Enento Group",
    "Symbol": "ENENTO.HE",
    " marketcap ": " $452 259 763 ",
    "price (USD)": "19.\u0441\u0435\u043d",
    "country": "Finland"
  },
  {
    "Rank": "6167",
    "Name": "Greenpanel Industries",
    "Symbol": "GREENPANEL.NS",
    " marketcap ": " $450 789 702 ",
    "price (USD)": "3.67128",
    "country": "India"
  },
  {
    "Rank": "6168",
    "Name": "Thinkific Labs",
    "Symbol": "THNC.TO",
    " marketcap ": " $450 429 086 ",
    "price (USD)": "2.77869",
    "country": "Canada"
  },
  {
    "Rank": "6169",
    "Name": "PepGen",
    "Symbol": "PEPG",
    " marketcap ": " $450 274 912 ",
    "price (USD)": "13.89",
    "country": "United States"
  },
  {
    "Rank": "6170",
    "Name": "Volue ASA",
    "Symbol": "VOLUE.OL",
    " marketcap ": " $450 060 962 ",
    "price (USD)": "3.12862",
    "country": "Norway"
  },
  {
    "Rank": "6171",
    "Name": "Tata Steel Long Products",
    "Symbol": "TATASTLLP.NS",
    " marketcap ": " $449 952 913 ",
    "price (USD)": "\u0441\u0435\u043d.98",
    "country": "India"
  },
  {
    "Rank": "6172",
    "Name": "SpiceJet",
    "Symbol": "SPICEJET.BO",
    " marketcap ": " $449 483 196 ",
    "price (USD)": "0.748795",
    "country": "India"
  },
  {
    "Rank": "6173",
    "Name": "Skeena Resources",
    "Symbol": "SKE",
    " marketcap ": " $449 146 784 ",
    "price (USD)": "\u0430\u043f\u0440.94",
    "country": "Canada"
  },
  {
    "Rank": "6174",
    "Name": "Hathway",
    "Symbol": "HATHWAY.NS",
    " marketcap ": " $448 761 954 ",
    "price (USD)": "0.253524",
    "country": "India"
  },
  {
    "Rank": "6175",
    "Name": "Noor Financial Investment Company",
    "Symbol": "NOOR.KW",
    " marketcap ": " $448 142 842 ",
    "price (USD)": "880.052",
    "country": "Kuwait"
  },
  {
    "Rank": "6176",
    "Name": "Chatham Lodging Trust",
    "Symbol": "CLDT",
    " marketcap ": " $447 391 872 ",
    "price (USD)": "\u0430\u0432\u0433.86",
    "country": "United States"
  },
  {
    "Rank": "6177",
    "Name": "Holley",
    "Symbol": "HLLY",
    " marketcap ": " $446 864 032 ",
    "price (USD)": "\u043c\u0430\u0440.78",
    "country": "United States"
  },
  {
    "Rank": "6178",
    "Name": "Hikal",
    "Symbol": "HIKAL.NS",
    " marketcap ": " $446 232 362 ",
    "price (USD)": "3.61782",
    "country": "India"
  },
  {
    "Rank": "6179",
    "Name": "Wing On Company International",
    "Symbol": "0289.HK",
    " marketcap ": " $446 121 365 ",
    "price (USD)": "1.53769",
    "country": "Hong Kong"
  },
  {
    "Rank": "6180",
    "Name": "Latham Group",
    "Symbol": "SWIM",
    " marketcap ": " $446 111 776 ",
    "price (USD)": "\u043c\u0430\u0440.86",
    "country": "United States"
  },
  {
    "Rank": "6181",
    "Name": "Najran Cement Company",
    "Symbol": "3002.SR",
    " marketcap ": " $445 494 072 ",
    "price (USD)": "2.62055",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6182",
    "Name": "Zur Rose Group",
    "Symbol": "ROSE.SW",
    " marketcap ": " $443 857 217 ",
    "price (USD)": "38.4282",
    "country": "Switzerland"
  },
  {
    "Rank": "6183",
    "Name": "Willdan Group",
    "Symbol": "WLDN",
    " marketcap ": " $443 667 104 ",
    "price (USD)": "32.11",
    "country": "United States"
  },
  {
    "Rank": "6184",
    "Name": "Annexon",
    "Symbol": "ANNX",
    " marketcap ": " $443 581 920 ",
    "price (USD)": "04.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6185",
    "Name": "Nykode Therapeutics",
    "Symbol": "NYKD.OL",
    " marketcap ": " $443 577 519 ",
    "price (USD)": "1.35839",
    "country": "Norway"
  },
  {
    "Rank": "6186",
    "Name": "Theravance Biopharma",
    "Symbol": "TBPH",
    " marketcap ": " $443 534 784 ",
    "price (USD)": "09.\u0434\u0435\u043a",
    "country": "Cayman Islands"
  },
  {
    "Rank": "6187",
    "Name": "Willis Lease Finance Corporation",
    "Symbol": "WLFC",
    " marketcap ": " $443 315 776 ",
    "price (USD)": "67.45",
    "country": "United States"
  },
  {
    "Rank": "6188",
    "Name": "Hexagon Composites",
    "Symbol": "HEX.OL",
    " marketcap ": " $443 236 015 ",
    "price (USD)": "2.20457",
    "country": "Norway"
  },
  {
    "Rank": "6189",
    "Name": "Hudson Technologies",
    "Symbol": "HDSN",
    " marketcap ": " $442 821 024 ",
    "price (USD)": "\u0441\u0435\u043d.73",
    "country": "United States"
  },
  {
    "Rank": "6190",
    "Name": "Yellow Corporation",
    "Symbol": "YELLQ",
    " marketcap ": " $442 185 216 ",
    "price (USD)": "06.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "6191",
    "Name": "Village Super Market",
    "Symbol": "VLGEA",
    " marketcap ": " $441 724 992 ",
    "price (USD)": "29.88",
    "country": "United States"
  },
  {
    "Rank": "6192",
    "Name": "Sonida Senior Living",
    "Symbol": "SNDA",
    " marketcap ": " $440 711 648 ",
    "price (USD)": "31.81",
    "country": "United States"
  },
  {
    "Rank": "6193",
    "Name": "Giordano",
    "Symbol": "0709.HK",
    " marketcap ": " $440 196 703 ",
    "price (USD)": "0.272939",
    "country": "Hong Kong"
  },
  {
    "Rank": "6194",
    "Name": "Sichuan Xunyou Network Technology",
    "Symbol": "300467.SZ",
    " marketcap ": " $440 132 932 ",
    "price (USD)": "2.16596",
    "country": "China"
  },
  {
    "Rank": "6195",
    "Name": "RCI Hospitality Holdings",
    "Symbol": "RICK",
    " marketcap ": " $439 772 672 ",
    "price (USD)": "47.16",
    "country": "United States"
  },
  {
    "Rank": "6196",
    "Name": "Xponential Fitness",
    "Symbol": "XPOF",
    " marketcap ": " $439 172 544 ",
    "price (USD)": "\u0441\u0435\u043d.15",
    "country": "United States"
  },
  {
    "Rank": "6197",
    "Name": "The Shyft Group",
    "Symbol": "SHYF",
    " marketcap ": " $438 613 536 ",
    "price (USD)": "\u0434\u0435\u043a.76",
    "country": "United States"
  },
  {
    "Rank": "6198",
    "Name": "Cartesian Therapeutics",
    "Symbol": "RNAC",
    " marketcap ": " $437 784 064 ",
    "price (USD)": "24.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "6199",
    "Name": "Ashiana Housing",
    "Symbol": "ASHIANA.NS",
    " marketcap ": " $437 540 487 ",
    "price (USD)": "4.35255",
    "country": "India"
  },
  {
    "Rank": "6200",
    "Name": "Hippo",
    "Symbol": "HIPO",
    " marketcap ": " $436 070 144 ",
    "price (USD)": "17.85",
    "country": "United States"
  },
  {
    "Rank": "6201",
    "Name": "Lands' End",
    "Symbol": "LE",
    " marketcap ": " $435 849 280 ",
    "price (USD)": "13.84",
    "country": "United States"
  },
  {
    "Rank": "6202",
    "Name": "Seneca Foods",
    "Symbol": "SENEA",
    " marketcap ": " $435 329 760 ",
    "price (USD)": "60.86",
    "country": "United States"
  },
  {
    "Rank": "6203",
    "Name": "Peapack-Gladstone Financial",
    "Symbol": "PGC",
    " marketcap ": " $434 916 576 ",
    "price (USD)": "24.48",
    "country": "United States"
  },
  {
    "Rank": "6204",
    "Name": "MYT Netherlands Parent (Mytheresa)",
    "Symbol": "MYTE",
    " marketcap ": " $434 637 824 ",
    "price (USD)": "05.\u0434\u0435\u043a",
    "country": "Germany"
  },
  {
    "Rank": "6205",
    "Name": "Diamond Hill Investment Group",
    "Symbol": "DHIL",
    " marketcap ": " $434 622 784 ",
    "price (USD)": "156.74",
    "country": "United States"
  },
  {
    "Rank": "6206",
    "Name": "Nucleus Software Exports",
    "Symbol": "NUCLEUS.NS",
    " marketcap ": " $434 603 299 ",
    "price (USD)": "16.2327",
    "country": "India"
  },
  {
    "Rank": "6207",
    "Name": "Asia Financial Holdings",
    "Symbol": "0662.HK",
    " marketcap ": " $434 534 440 ",
    "price (USD)": "0.467713",
    "country": "Hong Kong"
  },
  {
    "Rank": "6208",
    "Name": "Sezzle",
    "Symbol": "SEZL",
    " marketcap ": " $434 518 784 ",
    "price (USD)": "76.67",
    "country": "United States"
  },
  {
    "Rank": "6209",
    "Name": "Skipper Limited",
    "Symbol": "SKIPPER.NS",
    " marketcap ": " $433 754 392 ",
    "price (USD)": "\u043c\u0430\u0440.37",
    "country": "India"
  },
  {
    "Rank": "6210",
    "Name": "Bank of Sharjah",
    "Symbol": "BOS.AE",
    " marketcap ": " $432 924 007 ",
    "price (USD)": "0.14",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6211",
    "Name": "Cardlytics",
    "Symbol": "CDLX",
    " marketcap ": " $432 705 216 ",
    "price (USD)": "\u0430\u0432\u0433.87",
    "country": "United States"
  },
  {
    "Rank": "6212",
    "Name": "Argonaut Gold",
    "Symbol": "AR.TO",
    " marketcap ": " $432 656 798 ",
    "price (USD)": "0.340922",
    "country": "United States"
  },
  {
    "Rank": "6213",
    "Name": "Cigniti Technologies",
    "Symbol": "CIGNITITEC.NS",
    " marketcap ": " $432 576 043 ",
    "price (USD)": "15.8452",
    "country": "India"
  },
  {
    "Rank": "6214",
    "Name": "Donegal Group",
    "Symbol": "DGICA",
    " marketcap ": " $431 883 392 ",
    "price (USD)": "13",
    "country": "United States"
  },
  {
    "Rank": "6215",
    "Name": "Anup Engineering",
    "Symbol": "ANUP.NS",
    " marketcap ": " $431 710 157 ",
    "price (USD)": "21.6817",
    "country": "India"
  },
  {
    "Rank": "6216",
    "Name": "Aker Carbon Capture",
    "Symbol": "ACC.OL",
    " marketcap ": " $431 655 656 ",
    "price (USD)": "0.714376",
    "country": "Norway"
  },
  {
    "Rank": "6217",
    "Name": "Lindblad Expeditions",
    "Symbol": "LIND",
    " marketcap ": " $430 406 112 ",
    "price (USD)": "08.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "6218",
    "Name": "CMGE Technology Group",
    "Symbol": "0302.HK",
    " marketcap ": " $430 168 000 ",
    "price (USD)": "0.156331",
    "country": "China"
  },
  {
    "Rank": "6219",
    "Name": "Vishay Precision Group",
    "Symbol": "VPG",
    " marketcap ": " $429 728 512 ",
    "price (USD)": "32.18",
    "country": "United States"
  },
  {
    "Rank": "6220",
    "Name": "Armah Sports",
    "Symbol": "9590.SR",
    " marketcap ": " $429 669 558 ",
    "price (USD)": "13.0761",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6221",
    "Name": "Digital Domain",
    "Symbol": "0547.HK",
    " marketcap ": " $429 435 553 ",
    "price (USD)": "0.053819",
    "country": "Hong Kong"
  },
  {
    "Rank": "6222",
    "Name": "ACELYRIN",
    "Symbol": "SLRN",
    " marketcap ": " $428 786 912 ",
    "price (USD)": "\u0430\u043f\u0440.33",
    "country": "United States"
  },
  {
    "Rank": "6223",
    "Name": "Reitir fasteignaf\u0413\u00a9lag",
    "Symbol": "REITIR.IC",
    " marketcap ": " $428 133 181 ",
    "price (USD)": "0.593558",
    "country": "Iceland"
  },
  {
    "Rank": "6224",
    "Name": "Mereo BioPharma Group",
    "Symbol": "MREO",
    " marketcap ": " $426 429 888 ",
    "price (USD)": "03.\u0430\u043f\u0440",
    "country": "United Kingdom"
  },
  {
    "Rank": "6225",
    "Name": "Kuwait Cement Company",
    "Symbol": "KCEM.KW",
    " marketcap ": " $425 274 602 ",
    "price (USD)": "596.48",
    "country": "Kuwait"
  },
  {
    "Rank": "6226",
    "Name": "CNB Financial Corp",
    "Symbol": "CCNE",
    " marketcap ": " $424 902 816 ",
    "price (USD)": "20.23",
    "country": "United States"
  },
  {
    "Rank": "6227",
    "Name": "Methode Electronics",
    "Symbol": "MEI",
    " marketcap ": " $424 686 016 ",
    "price (USD)": "12",
    "country": "United States"
  },
  {
    "Rank": "6228",
    "Name": "Boston Omaha",
    "Symbol": "BOC",
    " marketcap ": " $424 383 264 ",
    "price (USD)": "13.49",
    "country": "United States"
  },
  {
    "Rank": "6229",
    "Name": "Ispire Technology",
    "Symbol": "ISPR",
    " marketcap ": " $423 568 512 ",
    "price (USD)": "\u0438\u044e\u043b.51",
    "country": "United States"
  },
  {
    "Rank": "6230",
    "Name": "Festi hf.",
    "Symbol": "FESTI.IC",
    " marketcap ": " $423 042 222 ",
    "price (USD)": "1.40427",
    "country": "Iceland"
  },
  {
    "Rank": "6231",
    "Name": "ADTRAN",
    "Symbol": "ADTN",
    " marketcap ": " $422 482 112 ",
    "price (USD)": "\u043c\u0430\u0439.34",
    "country": "United States"
  },
  {
    "Rank": "6232",
    "Name": "Integrated Holding Company K.S.C.P.",
    "Symbol": "INTEGRATED.KW",
    " marketcap ": " $422 216 428 ",
    "price (USD)": "1668.84",
    "country": "Kuwait"
  },
  {
    "Rank": "6233",
    "Name": "Northfield Bancorp",
    "Symbol": "NFBK",
    " marketcap ": " $422 156 800 ",
    "price (USD)": "\u0441\u0435\u043d.52",
    "country": "United States"
  },
  {
    "Rank": "6234",
    "Name": "LoveSac",
    "Symbol": "LOVE",
    " marketcap ": " $421 939 424 ",
    "price (USD)": "27.24",
    "country": "United States"
  },
  {
    "Rank": "6235",
    "Name": "Fate Therapeutics",
    "Symbol": "FATE",
    " marketcap ": " $421 178 400 ",
    "price (USD)": "03.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6236",
    "Name": "Basler Aktiengesellschaft",
    "Symbol": "BSL.DE",
    " marketcap ": " $420 549 115 ",
    "price (USD)": "13.6823",
    "country": "Germany"
  },
  {
    "Rank": "6237",
    "Name": "Nexxen",
    "Symbol": "NEXN",
    " marketcap ": " $420 372 032 ",
    "price (USD)": "5.985",
    "country": "Israel"
  },
  {
    "Rank": "6238",
    "Name": "Nayifat Finance Company",
    "Symbol": "4081.SR",
    " marketcap ": " $420 142 503 ",
    "price (USD)": "3.50119",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6239",
    "Name": "Genie Energy",
    "Symbol": "GNE",
    " marketcap ": " $419 710 400 ",
    "price (USD)": "15.47",
    "country": "United States"
  },
  {
    "Rank": "6240",
    "Name": "Idorsia",
    "Symbol": "IDIA.SW",
    " marketcap ": " $419 215 450 ",
    "price (USD)": "2.33949",
    "country": "Switzerland"
  },
  {
    "Rank": "6241",
    "Name": "Chegg",
    "Symbol": "CHGG",
    " marketcap ": " $419 089 696 ",
    "price (USD)": "04.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "6242",
    "Name": "Xperi",
    "Symbol": "XPER",
    " marketcap ": " $418 974 368 ",
    "price (USD)": "\u0441\u0435\u043d.28",
    "country": "United States"
  },
  {
    "Rank": "6243",
    "Name": "Global Indemnity",
    "Symbol": "GBLI",
    " marketcap ": " $418 471 360 ",
    "price (USD)": "30.76",
    "country": "Cayman Islands"
  },
  {
    "Rank": "6244",
    "Name": "CapStar Financial",
    "Symbol": "CSTR",
    " marketcap ": " $418 353 376 ",
    "price (USD)": "20.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "6245",
    "Name": "Yiren Digital",
    "Symbol": "YRD",
    " marketcap ": " $418 154 912 ",
    "price (USD)": "\u0430\u043f\u0440.81",
    "country": "China"
  },
  {
    "Rank": "6246",
    "Name": "CGG",
    "Symbol": "CGG.PA",
    " marketcap ": " $417 697 783 ",
    "price (USD)": "0.585297",
    "country": "France"
  },
  {
    "Rank": "6247",
    "Name": "Build-A-Bear",
    "Symbol": "BBW",
    " marketcap ": " $417 279 136 ",
    "price (USD)": "29.58",
    "country": "United States"
  },
  {
    "Rank": "6248",
    "Name": "Dingdong Maicai",
    "Symbol": "DDL",
    " marketcap ": " $417 029 760 ",
    "price (USD)": "\u044f\u043d\u0432.92",
    "country": "China"
  },
  {
    "Rank": "6249",
    "Name": "ITM Power",
    "Symbol": "ITM.L",
    " marketcap ": " $416 511 995 ",
    "price (USD)": "0.675083",
    "country": "United Kingdom"
  },
  {
    "Rank": "6250",
    "Name": "MBM Resources",
    "Symbol": "5983.KL",
    " marketcap ": " $416 414 176 ",
    "price (USD)": "1.0653",
    "country": "Malaysia"
  },
  {
    "Rank": "6251",
    "Name": "Far East Consortium International",
    "Symbol": "0035.HK",
    " marketcap ": " $415 206 168 ",
    "price (USD)": "0.147362",
    "country": "Hong Kong"
  },
  {
    "Rank": "6252",
    "Name": "Devsisters",
    "Symbol": "194480.KQ",
    " marketcap ": " $414 987 316 ",
    "price (USD)": "41.6404",
    "country": "South Korea"
  },
  {
    "Rank": "6253",
    "Name": "Sinad Holding Company",
    "Symbol": "4080.SR",
    " marketcap ": " $414 854 616 ",
    "price (USD)": "3.28236",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6254",
    "Name": "Sj\u0413\u0456v\u0413\u040e-Almennar tryggingar",
    "Symbol": "SJOVA.IC",
    " marketcap ": " $414 733 553 ",
    "price (USD)": "0.269273",
    "country": "Iceland"
  },
  {
    "Rank": "6255",
    "Name": "Spirit Airlines",
    "Symbol": "SAVE",
    " marketcap ": " $413 913 792 ",
    "price (USD)": "\u043c\u0430\u0440.78",
    "country": "United States"
  },
  {
    "Rank": "6256",
    "Name": "Addiko Bank",
    "Symbol": "ZYE1.F",
    " marketcap ": " $413 538 234 ",
    "price (USD)": "21.0121",
    "country": "Austria"
  },
  {
    "Rank": "6257",
    "Name": "Vadilal Industries",
    "Symbol": "VADILALIND.NS",
    " marketcap ": " $412 971 819 ",
    "price (USD)": "57.4543",
    "country": "India"
  },
  {
    "Rank": "6258",
    "Name": "SHL Finance Company",
    "Symbol": "1183.SR",
    " marketcap ": " $412 029 995 ",
    "price (USD)": "4.1203",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6259",
    "Name": "Contineum Therapeutics",
    "Symbol": "CTNM",
    " marketcap ": " $411 572 800 ",
    "price (USD)": "16",
    "country": "United States"
  },
  {
    "Rank": "6260",
    "Name": "Bertrandt",
    "Symbol": "BDT.DE",
    " marketcap ": " $411 514 544 ",
    "price (USD)": "40.721",
    "country": "Germany"
  },
  {
    "Rank": "6261",
    "Name": "Arrow Financial",
    "Symbol": "AROW",
    " marketcap ": " $409 604 416 ",
    "price (USD)": "24.53",
    "country": "United States"
  },
  {
    "Rank": "6262",
    "Name": "Vizsla Silver",
    "Symbol": "VZLA",
    " marketcap ": " $408 798 720 ",
    "price (USD)": "\u044f\u043d\u0432.76",
    "country": "Canada"
  },
  {
    "Rank": "6263",
    "Name": "Sunlight REIT",
    "Symbol": "0435.HK",
    " marketcap ": " $408 529 180 ",
    "price (USD)": "0.238341",
    "country": "Hong Kong"
  },
  {
    "Rank": "6264",
    "Name": "Newegg",
    "Symbol": "NEGG",
    " marketcap ": " $408 490 720 ",
    "price (USD)": "01.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6265",
    "Name": "Al Obeikan Glass Company",
    "Symbol": "9531.SR",
    " marketcap ": " $408 187 228 ",
    "price (USD)": "\u0434\u0435\u043a.59",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6266",
    "Name": "Perpetua Resources",
    "Symbol": "PPTA",
    " marketcap ": " $408 141 824 ",
    "price (USD)": "\u0438\u044e\u043d.32",
    "country": "United States"
  },
  {
    "Rank": "6267",
    "Name": "Bar Harbor Bankshares",
    "Symbol": "BHB",
    " marketcap ": " $407 923 680 ",
    "price (USD)": "26.78",
    "country": "United States"
  },
  {
    "Rank": "6268",
    "Name": "New Pacific Metals",
    "Symbol": "NEWP",
    " marketcap ": " $407 610 688 ",
    "price (USD)": "\u0444\u0435\u0432.38",
    "country": "Canada"
  },
  {
    "Rank": "6269",
    "Name": "Artesian Resources",
    "Symbol": "ARTNA",
    " marketcap ": " $407 528 064 ",
    "price (USD)": "39.96",
    "country": "United States"
  },
  {
    "Rank": "6270",
    "Name": "Erasca",
    "Symbol": "ERAS",
    " marketcap ": " $407 393 664 ",
    "price (USD)": "\u0444\u0435\u0432.35",
    "country": "United States"
  },
  {
    "Rank": "6271",
    "Name": "CTO Realty Growth",
    "Symbol": "CTO",
    " marketcap ": " $407 298 592 ",
    "price (USD)": "17.75",
    "country": "United States"
  },
  {
    "Rank": "6272",
    "Name": "Wing Tai Properties",
    "Symbol": "0369.HK",
    " marketcap ": " $406 954 949 ",
    "price (USD)": "0.299849",
    "country": "Hong Kong"
  },
  {
    "Rank": "6273",
    "Name": "Solaris Oilfield Infrastructure",
    "Symbol": "SOI",
    " marketcap ": " $406 767 904 ",
    "price (USD)": "\u0441\u0435\u043d.24",
    "country": "United States"
  },
  {
    "Rank": "6274",
    "Name": "SP Group A/S",
    "Symbol": "SPG.CO",
    " marketcap ": " $406 235 173 ",
    "price (USD)": "33.5388",
    "country": "Denmark"
  },
  {
    "Rank": "6275",
    "Name": "Lesha Bank",
    "Symbol": "QFBQ.QA",
    " marketcap ": " $406 153 846 ",
    "price (USD)": "0.362637",
    "country": "Qatar"
  },
  {
    "Rank": "6276",
    "Name": "Kuwait National Cinema Company",
    "Symbol": "KCIN.KW",
    " marketcap ": " $405 964 641 ",
    "price (USD)": "4383.96",
    "country": "Kuwait"
  },
  {
    "Rank": "6277",
    "Name": "AerSale",
    "Symbol": "ASLE",
    " marketcap ": " $405 518 848 ",
    "price (USD)": "\u0438\u044e\u043b.65",
    "country": "United States"
  },
  {
    "Rank": "6278",
    "Name": "Dollar Industries",
    "Symbol": "DOLLAR.NS",
    " marketcap ": " $403 323 725 ",
    "price (USD)": "7.11127",
    "country": "India"
  },
  {
    "Rank": "6279",
    "Name": "JCI Hitachi India",
    "Symbol": "JCHAC.NS",
    " marketcap ": " $403 238 977 ",
    "price (USD)": "14.8299",
    "country": "India"
  },
  {
    "Rank": "6280",
    "Name": "OneWater Marine",
    "Symbol": "ONEW",
    " marketcap ": " $402 985 984 ",
    "price (USD)": "25.15",
    "country": "United States"
  },
  {
    "Rank": "6281",
    "Name": "Carriage Services",
    "Symbol": "CSV",
    " marketcap ": " $402 795 680 ",
    "price (USD)": "26.56",
    "country": "United States"
  },
  {
    "Rank": "6282",
    "Name": "Zhihu",
    "Symbol": "ZH",
    " marketcap ": " $402 762 112 ",
    "price (USD)": "\u043c\u0430\u0440.93",
    "country": "China"
  },
  {
    "Rank": "6283",
    "Name": "Olympique Lyonnais Groupe",
    "Symbol": "OLG.PA",
    " marketcap ": " $402 255 220 ",
    "price (USD)": "2.31295",
    "country": "France"
  },
  {
    "Rank": "6284",
    "Name": "The RMR Group",
    "Symbol": "RMR",
    " marketcap ": " $401 869 024 ",
    "price (USD)": "24.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "6285",
    "Name": "WideOpenWest",
    "Symbol": "WOW",
    " marketcap ": " $401 692 768 ",
    "price (USD)": "\u0430\u043f\u0440.75",
    "country": "United States"
  },
  {
    "Rank": "6286",
    "Name": "ElringKlinger",
    "Symbol": "ZIL2.DE",
    " marketcap ": " $399 741 123 ",
    "price (USD)": "6.30905",
    "country": "Germany"
  },
  {
    "Rank": "6287",
    "Name": "Health Catalyst",
    "Symbol": "HCAT",
    " marketcap ": " $399 666 272 ",
    "price (USD)": "\u0438\u044e\u043d.77",
    "country": "United States"
  },
  {
    "Rank": "6288",
    "Name": "Himalaya Shipping",
    "Symbol": "HSHP",
    " marketcap ": " $399 490 016 ",
    "price (USD)": "09.\u044f\u043d\u0432",
    "country": "Bermuda"
  },
  {
    "Rank": "6289",
    "Name": "T\u0432\u0402\u2122way Air",
    "Symbol": "091810.KS",
    " marketcap ": " $399 170 017 ",
    "price (USD)": "1.99022",
    "country": "South Korea"
  },
  {
    "Rank": "6290",
    "Name": "Virgin Galactic",
    "Symbol": "SPCE",
    " marketcap ": " $399 021 152 ",
    "price (USD)": "0.97",
    "country": "United States"
  },
  {
    "Rank": "6291",
    "Name": "Sohu.com",
    "Symbol": "SOHU",
    " marketcap ": " $398 236 832 ",
    "price (USD)": "12.\u043c\u0430\u0439",
    "country": "China"
  },
  {
    "Rank": "6292",
    "Name": "America's Car-Mart",
    "Symbol": "CRMT",
    " marketcap ": " $396 629 792 ",
    "price (USD)": "62.05",
    "country": "United States"
  },
  {
    "Rank": "6293",
    "Name": "C4 Therapeutics",
    "Symbol": "CCCC",
    " marketcap ": " $396 321 408 ",
    "price (USD)": "\u043c\u0430\u0439.76",
    "country": "United States"
  },
  {
    "Rank": "6294",
    "Name": "Palms Sports",
    "Symbol": "PALMS.AE",
    " marketcap ": " $396 166 308 ",
    "price (USD)": "\u0444\u0435\u0432.64",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6295",
    "Name": "SmartFinancial (SmartBank)",
    "Symbol": "SMBK",
    " marketcap ": " $395 854 656 ",
    "price (USD)": "23.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "6296",
    "Name": "Terns Pharmaceuticals",
    "Symbol": "TERN",
    " marketcap ": " $395 823 840 ",
    "price (USD)": "06.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "6297",
    "Name": "ModivCare",
    "Symbol": "MODV",
    " marketcap ": " $395 489 344 ",
    "price (USD)": "27.83",
    "country": "United States"
  },
  {
    "Rank": "6298",
    "Name": "Tide Water Oil",
    "Symbol": "TIDEWATER.NS",
    " marketcap ": " $395 084 946 ",
    "price (USD)": "23.2473",
    "country": "India"
  },
  {
    "Rank": "6299",
    "Name": "GEN Restaurant Group",
    "Symbol": "GENK",
    " marketcap ": " $393 970 624 ",
    "price (USD)": "\u0434\u0435\u043a.16",
    "country": "United States"
  },
  {
    "Rank": "6300",
    "Name": "PSI Software",
    "Symbol": "PSAN.DE",
    " marketcap ": " $393 548 920 ",
    "price (USD)": "25.4099",
    "country": "Germany"
  },
  {
    "Rank": "6301",
    "Name": "ATN International",
    "Symbol": "ATNI",
    " marketcap ": " $393 345 696 ",
    "price (USD)": "25.68",
    "country": "United States"
  },
  {
    "Rank": "6302",
    "Name": "SML Isuzu",
    "Symbol": "SMLISUZU.NS",
    " marketcap ": " $393 092 953 ",
    "price (USD)": "27.1631",
    "country": "India"
  },
  {
    "Rank": "6303",
    "Name": "Scientific and Medical Equipment House Company",
    "Symbol": "4014.SR",
    " marketcap ": " $393 083 003 ",
    "price (USD)": "13.1028",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6304",
    "Name": "Sandhar",
    "Symbol": "SANDHAR.NS",
    " marketcap ": " $393 038 398 ",
    "price (USD)": "\u0438\u044e\u043d.69",
    "country": "India"
  },
  {
    "Rank": "6305",
    "Name": "Telesat",
    "Symbol": "TSAT",
    " marketcap ": " $392 562 688 ",
    "price (USD)": "\u0438\u044e\u043b.88",
    "country": "Canada"
  },
  {
    "Rank": "6306",
    "Name": "Daseke",
    "Symbol": "DSKE",
    " marketcap ": " $391 290 496 ",
    "price (USD)": "\u0430\u0432\u0433.29",
    "country": "United States"
  },
  {
    "Rank": "6307",
    "Name": "Arctic Paper",
    "Symbol": "ARP.ST",
    " marketcap ": " $390 623 874 ",
    "price (USD)": "5.62084",
    "country": "Poland"
  },
  {
    "Rank": "6308",
    "Name": "Flushing Financial Corp",
    "Symbol": "FFIC",
    " marketcap ": " $389 813 952 ",
    "price (USD)": "13.41",
    "country": "United States"
  },
  {
    "Rank": "6309",
    "Name": "Postal Realty Trust",
    "Symbol": "PSTL",
    " marketcap ": " $389 546 368 ",
    "price (USD)": "13.58",
    "country": "United States"
  },
  {
    "Rank": "6310",
    "Name": "Mahindra Logistics",
    "Symbol": "MAHLOG.NS",
    " marketcap ": " $389 395 592 ",
    "price (USD)": "\u043c\u0430\u0439.45",
    "country": "India"
  },
  {
    "Rank": "6311",
    "Name": "Alerus Financial",
    "Symbol": "ALRS",
    " marketcap ": " $389 207 424 ",
    "price (USD)": "19.68",
    "country": "United States"
  },
  {
    "Rank": "6312",
    "Name": "Eastman Kodak Company",
    "Symbol": "KODK",
    " marketcap ": " $389 172 000 ",
    "price (USD)": "\u0430\u043f\u0440.92",
    "country": "United States"
  },
  {
    "Rank": "6313",
    "Name": "Aurora Cannabis",
    "Symbol": "ACB",
    " marketcap ": " $389 089 824 ",
    "price (USD)": "\u0438\u044e\u043b.13",
    "country": "Canada"
  },
  {
    "Rank": "6314",
    "Name": "Consensus Cloud Solutions",
    "Symbol": "CCSI",
    " marketcap ": " $388 824 640 ",
    "price (USD)": "20.23",
    "country": "United States"
  },
  {
    "Rank": "6315",
    "Name": "CARE's Ratings",
    "Symbol": "CARERATING.NS",
    " marketcap ": " $388 685 201 ",
    "price (USD)": "13.0126",
    "country": "India"
  },
  {
    "Rank": "6316",
    "Name": "Delta Corp",
    "Symbol": "DELTACORP.NS",
    " marketcap ": " $386 887 237 ",
    "price (USD)": "1.44484",
    "country": "India"
  },
  {
    "Rank": "6317",
    "Name": "Kearny Financial",
    "Symbol": "KRNY",
    " marketcap ": " $385 977 600 ",
    "price (USD)": "\u043c\u0430\u0439.99",
    "country": "United States"
  },
  {
    "Rank": "6318",
    "Name": "Hingham Institution for Savings",
    "Symbol": "HIFS",
    " marketcap ": " $385 947 872 ",
    "price (USD)": "177.02",
    "country": "United States"
  },
  {
    "Rank": "6319",
    "Name": "Avalon Technologies",
    "Symbol": "AVALON.NS",
    " marketcap ": " $385 739 474 ",
    "price (USD)": "5.87009",
    "country": "India"
  },
  {
    "Rank": "6320",
    "Name": "Greenply",
    "Symbol": "GREENPLY.NS",
    " marketcap ": " $385 542 197 ",
    "price (USD)": "3.11678",
    "country": "India"
  },
  {
    "Rank": "6321",
    "Name": "Shore Bancshares",
    "Symbol": "SHBI",
    " marketcap ": " $384 915 488 ",
    "price (USD)": "\u043d\u043e\u044f.59",
    "country": "United States"
  },
  {
    "Rank": "6322",
    "Name": "SEACOR Marine",
    "Symbol": "SMHI",
    " marketcap ": " $384 771 872 ",
    "price (USD)": "13.94",
    "country": "United States"
  },
  {
    "Rank": "6323",
    "Name": "Immutep",
    "Symbol": "IMMP",
    " marketcap ": " $383 992 096 ",
    "price (USD)": "\u043c\u0430\u0440.23",
    "country": "Australia"
  },
  {
    "Rank": "6324",
    "Name": "Diana Shipping",
    "Symbol": "DSX",
    " marketcap ": " $383 881 600 ",
    "price (USD)": "03.\u0444\u0435\u0432",
    "country": "Greece"
  },
  {
    "Rank": "6325",
    "Name": "Denny's",
    "Symbol": "DENN",
    " marketcap ": " $383 377 088 ",
    "price (USD)": "\u0438\u044e\u043b.37",
    "country": "United States"
  },
  {
    "Rank": "6326",
    "Name": "ECN Capital",
    "Symbol": "ECN.TO",
    " marketcap ": " $383 359 507 ",
    "price (USD)": "1.36369",
    "country": "Canada"
  },
  {
    "Rank": "6327",
    "Name": "Aviat Networks",
    "Symbol": "AVNW",
    " marketcap ": " $382 487 744 ",
    "price (USD)": "30.44",
    "country": "United States"
  },
  {
    "Rank": "6328",
    "Name": "SkyWater Technology",
    "Symbol": "SKYT",
    " marketcap ": " $382 113 664 ",
    "price (USD)": "08.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6329",
    "Name": "Anika Therapeutics",
    "Symbol": "ANIK",
    " marketcap ": " $381 833 888 ",
    "price (USD)": "25.75",
    "country": "United States"
  },
  {
    "Rank": "6330",
    "Name": "BigBear.ai",
    "Symbol": "BBAI",
    " marketcap ": " $381 417 792 ",
    "price (USD)": "\u044f\u043d\u0432.55",
    "country": "United States"
  },
  {
    "Rank": "6331",
    "Name": "Eimskipaf\u0413\u00a9lag \u0413\u040cslands",
    "Symbol": "EIM.IC",
    " marketcap ": " $381 005 993 ",
    "price (USD)": "2.32356",
    "country": "Iceland"
  },
  {
    "Rank": "6332",
    "Name": "Ring Energy",
    "Symbol": "REI",
    " marketcap ": " $380 039 008 ",
    "price (USD)": "\u044f\u043d\u0432.92",
    "country": "United States"
  },
  {
    "Rank": "6333",
    "Name": "Webzen",
    "Symbol": "069080.KQ",
    " marketcap ": " $380 004 542 ",
    "price (USD)": "12.896",
    "country": "South Korea"
  },
  {
    "Rank": "6334",
    "Name": "Ares Commercial Real Estate",
    "Symbol": "ACRE",
    " marketcap ": " $379 367 328 ",
    "price (USD)": "\u0438\u044e\u043d.96",
    "country": "United States"
  },
  {
    "Rank": "6335",
    "Name": "Medios AG",
    "Symbol": "ILM1.DE",
    " marketcap ": " $379 092 106 ",
    "price (USD)": "15.398",
    "country": "Germany"
  },
  {
    "Rank": "6336",
    "Name": "Phnom Penh Autonomous Port",
    "Symbol": "PPAP.KH",
    " marketcap ": " $378 977 614 ",
    "price (USD)": "\u043c\u0430\u0440.31",
    "country": "Cambodia"
  },
  {
    "Rank": "6337",
    "Name": "REC Silicon",
    "Symbol": "RECSI.OL",
    " marketcap ": " $378 812 232 ",
    "price (USD)": "0.900592",
    "country": "Norway"
  },
  {
    "Rank": "6338",
    "Name": "Landsea Homes",
    "Symbol": "LSEA",
    " marketcap ": " $378 072 640 ",
    "price (USD)": "\u043e\u043a\u0442.45",
    "country": "United States"
  },
  {
    "Rank": "6339",
    "Name": "fuboTV",
    "Symbol": "FUBO",
    " marketcap ": " $377 848 800 ",
    "price (USD)": "\u044f\u043d\u0432.26",
    "country": "United States"
  },
  {
    "Rank": "6340",
    "Name": "VIB Verm\u0413\u00b6gen",
    "Symbol": "VIH1.F",
    " marketcap ": " $377 602 780 ",
    "price (USD)": "\u043d\u043e\u044f.36",
    "country": "Germany"
  },
  {
    "Rank": "6341",
    "Name": "Summit Financial Group",
    "Symbol": "SMMF",
    " marketcap ": " $377 448 192 ",
    "price (USD)": "25.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6342",
    "Name": "Limoneira",
    "Symbol": "LMNR",
    " marketcap ": " $377 382 688 ",
    "price (USD)": "20.96",
    "country": "United States"
  },
  {
    "Rank": "6343",
    "Name": "CS Disco",
    "Symbol": "LAW",
    " marketcap ": " $377 249 024 ",
    "price (USD)": "\u0438\u044e\u043d.29",
    "country": "United States"
  },
  {
    "Rank": "6344",
    "Name": "Pangaea Logistics Solutions",
    "Symbol": "PANL",
    " marketcap ": " $377 058 784 ",
    "price (USD)": "08.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "6345",
    "Name": "Nordic Paper",
    "Symbol": "NPAPER.ST",
    " marketcap ": " $375 457 609 ",
    "price (USD)": "5.61148",
    "country": "Sweden"
  },
  {
    "Rank": "6346",
    "Name": "RGP",
    "Symbol": "RGP",
    " marketcap ": " $375 263 264 ",
    "price (USD)": "11.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "6347",
    "Name": "Atlanticus",
    "Symbol": "ATLC",
    " marketcap ": " $374 979 744 ",
    "price (USD)": "25.35",
    "country": "United States"
  },
  {
    "Rank": "6348",
    "Name": "Repco Home Finance",
    "Symbol": "REPCOHOME.NS",
    " marketcap ": " $374 645 892 ",
    "price (USD)": "5.98544",
    "country": "India"
  },
  {
    "Rank": "6349",
    "Name": "Johnson Outdoors",
    "Symbol": "JOUT",
    " marketcap ": " $374 452 224 ",
    "price (USD)": "36.35",
    "country": "United States"
  },
  {
    "Rank": "6350",
    "Name": "Zumiez",
    "Symbol": "ZUMZ",
    " marketcap ": " $372 884 224 ",
    "price (USD)": "18.38",
    "country": "United States"
  },
  {
    "Rank": "6351",
    "Name": "Computer Engineering &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6352",
    "Name": "J.S.B.Co.",
    "Symbol": "3480.T",
    " marketcap ": " $372 281 333 ",
    "price (USD)": "17.3885",
    "country": "Japan"
  },
  {
    "Rank": "6353",
    "Name": "Verrica Pharmaceuticals",
    "Symbol": "VRCA",
    " marketcap ": " $372 024 288 ",
    "price (USD)": "\u0430\u0432\u0433.77",
    "country": "United States"
  },
  {
    "Rank": "6354",
    "Name": "TCNS Clothing",
    "Symbol": "TCNSBRANDS.NS",
    " marketcap ": " $371 610 643 ",
    "price (USD)": "5.87309",
    "country": "India"
  },
  {
    "Rank": "6355",
    "Name": "Sutro Biopharma",
    "Symbol": "STRO",
    " marketcap ": " $371 346 144 ",
    "price (USD)": "\u0430\u043f\u0440.54",
    "country": "United States"
  },
  {
    "Rank": "6356",
    "Name": "NVE Corporation",
    "Symbol": "NVEC",
    " marketcap ": " $371 274 944 ",
    "price (USD)": "76.81",
    "country": "United States"
  },
  {
    "Rank": "6357",
    "Name": "ASA Gold and Precious Metals",
    "Symbol": "ASA",
    " marketcap ": " $370 173 184 ",
    "price (USD)": "19.19",
    "country": "United States"
  },
  {
    "Rank": "6358",
    "Name": "Gulf Medical Projects Company",
    "Symbol": "GMPC.AE",
    " marketcap ": " $369 182 678 ",
    "price (USD)": "0.53",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6359",
    "Name": "Amarin Corporation",
    "Symbol": "AMRN",
    " marketcap ": " $368 385 152 ",
    "price (USD)": "0.8966",
    "country": "Ireland"
  },
  {
    "Rank": "6360",
    "Name": "Anavex Life Sciences",
    "Symbol": "AVXL",
    " marketcap ": " $368 190 528 ",
    "price (USD)": "\u0430\u043f\u0440.35",
    "country": "United States"
  },
  {
    "Rank": "6361",
    "Name": "Civeo",
    "Symbol": "CVEO",
    " marketcap ": " $367 932 288 ",
    "price (USD)": "25.16",
    "country": "United States"
  },
  {
    "Rank": "6362",
    "Name": "\u0413\u2013lger\u0413\u00b0in Egill Skallagr\u0413\u00admsson",
    "Symbol": "OLGERD.IC",
    " marketcap ": " $367 718 942 ",
    "price (USD)": "0.131017",
    "country": "Iceland"
  },
  {
    "Rank": "6363",
    "Name": "Organogenesis",
    "Symbol": "ORGO",
    " marketcap ": " $367 224 448 ",
    "price (USD)": "\u0444\u0435\u0432.77",
    "country": "United States"
  },
  {
    "Rank": "6364",
    "Name": "Shattuck Labs",
    "Symbol": "STTK",
    " marketcap ": " $367 092 928 ",
    "price (USD)": "\u0438\u044e\u043b.72",
    "country": "United States"
  },
  {
    "Rank": "6365",
    "Name": "Faro Technologies",
    "Symbol": "FARO",
    " marketcap ": " $366 448 576 ",
    "price (USD)": "19.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6366",
    "Name": "Nevro",
    "Symbol": "NVRO",
    " marketcap ": " $365 816 864 ",
    "price (USD)": "\u0441\u0435\u043d.96",
    "country": "United States"
  },
  {
    "Rank": "6367",
    "Name": "Mid Penn Bancorp",
    "Symbol": "MPB",
    " marketcap ": " $365 495 648 ",
    "price (USD)": "21.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6368",
    "Name": "Saudi Company for Hardware (SACO)",
    "Symbol": "4008.SR",
    " marketcap ": " $364 563 866 ",
    "price (USD)": "\u043e\u043a\u0442.41",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6369",
    "Name": "Dish TV",
    "Symbol": "DISHTV.NS",
    " marketcap ": " $364 150 516 ",
    "price (USD)": "0.197652",
    "country": "India"
  },
  {
    "Rank": "6370",
    "Name": "NETGEAR",
    "Symbol": "NTGR",
    " marketcap ": " $363 099 296 ",
    "price (USD)": "\u0434\u0435\u043a.49",
    "country": "United States"
  },
  {
    "Rank": "6371",
    "Name": "M1 Kliniken AG",
    "Symbol": "M12.DE",
    " marketcap ": " $362 958 775 ",
    "price (USD)": "19.8176",
    "country": "Germany"
  },
  {
    "Rank": "6372",
    "Name": "Via S.A.",
    "Symbol": "VIIA3.SA",
    " marketcap ": " $362 489 533 ",
    "price (USD)": "0.15",
    "country": "Brazil"
  },
  {
    "Rank": "6373",
    "Name": "OraSure Technologies",
    "Symbol": "OSUR",
    " marketcap ": " $362 400 544 ",
    "price (USD)": "04.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6374",
    "Name": "Branicks Group",
    "Symbol": "DIC.DE",
    " marketcap ": " $362 332 362 ",
    "price (USD)": "4.27299",
    "country": "Germany"
  },
  {
    "Rank": "6375",
    "Name": "Value Line",
    "Symbol": "VALU",
    " marketcap ": " $362 296 224 ",
    "price (USD)": "38.44",
    "country": "United States"
  },
  {
    "Rank": "6376",
    "Name": "B Communications",
    "Symbol": "BCOM.TA",
    " marketcap ": " $362 185 654 ",
    "price (USD)": "3.43314",
    "country": "Israel"
  },
  {
    "Rank": "6377",
    "Name": "SNP Schneider-Neureither &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6378",
    "Name": "Automotive Axles",
    "Symbol": "AUTOAXLES.NS",
    " marketcap ": " $360 984 651 ",
    "price (USD)": "23.8552",
    "country": "India"
  },
  {
    "Rank": "6379",
    "Name": "OppFi",
    "Symbol": "OPFI",
    " marketcap ": " $360 800 000 ",
    "price (USD)": "\u043c\u0430\u0440.28",
    "country": "United States"
  },
  {
    "Rank": "6380",
    "Name": "Nexters",
    "Symbol": "GDEV",
    " marketcap ": " $360 317 376 ",
    "price (USD)": "\u044f\u043d\u0432.99",
    "country": "Cyprus"
  },
  {
    "Rank": "6381",
    "Name": "Prakash Industries",
    "Symbol": "PRAKASH.NS",
    " marketcap ": " $360 199 527 ",
    "price (USD)": "2.01137",
    "country": "India"
  },
  {
    "Rank": "6382",
    "Name": "FibroBiologics",
    "Symbol": "FBLG",
    " marketcap ": " $359 910 112 ",
    "price (USD)": "11",
    "country": "United States"
  },
  {
    "Rank": "6383",
    "Name": "Tourmaline Bio",
    "Symbol": "TRML",
    " marketcap ": " $359 820 384 ",
    "price (USD)": "14.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6384",
    "Name": "A'ayan Leasing and Investment Company",
    "Symbol": "AAYAN.KW",
    " marketcap ": " $359 290 978 ",
    "price (USD)": "541.069",
    "country": "Kuwait"
  },
  {
    "Rank": "6385",
    "Name": "Somany Ceramics",
    "Symbol": "SOMANYCERA.NS",
    " marketcap ": " $358 944 845 ",
    "price (USD)": "8.73575",
    "country": "India"
  },
  {
    "Rank": "6386",
    "Name": "NL Industries",
    "Symbol": "NL",
    " marketcap ": " $358 926 208 ",
    "price (USD)": "\u0438\u044e\u043b.35",
    "country": "United States"
  },
  {
    "Rank": "6387",
    "Name": "ADC Therapeutics",
    "Symbol": "ADCT",
    " marketcap ": " $358 922 624 ",
    "price (USD)": "\u043c\u0430\u0440.73",
    "country": "Switzerland"
  },
  {
    "Rank": "6388",
    "Name": "Com2uS",
    "Symbol": "078340.KQ",
    " marketcap ": " $358 590 000 ",
    "price (USD)": "31.3955",
    "country": "South Korea"
  },
  {
    "Rank": "6389",
    "Name": "Marine Products Corporation",
    "Symbol": "MPX",
    " marketcap ": " $358 274 368 ",
    "price (USD)": "\u043e\u043a\u0442.33",
    "country": "United States"
  },
  {
    "Rank": "6390",
    "Name": "Prime Focus",
    "Symbol": "PFOCUS.NS",
    " marketcap ": " $358 116 856 ",
    "price (USD)": "1.19432",
    "country": "India"
  },
  {
    "Rank": "6391",
    "Name": "Proficient Auto Logistics",
    "Symbol": "PAL",
    " marketcap ": " $356 872 416 ",
    "price (USD)": "14.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6392",
    "Name": "Vst Tillers Tractors",
    "Symbol": "VSTTILLERS.NS",
    " marketcap ": " $354 995 924 ",
    "price (USD)": "41.0708",
    "country": "India"
  },
  {
    "Rank": "6393",
    "Name": "Solar A/S",
    "Symbol": "SOLAR-B.CO",
    " marketcap ": " $354 924 096 ",
    "price (USD)": "48.5985",
    "country": "Denmark"
  },
  {
    "Rank": "6394",
    "Name": "Northwest Pipe Company",
    "Symbol": "NWPX",
    " marketcap ": " $354 577 920 ",
    "price (USD)": "35.76",
    "country": "United States"
  },
  {
    "Rank": "6395",
    "Name": "MasterCraft Boat",
    "Symbol": "MCFT",
    " marketcap ": " $354 053 856 ",
    "price (USD)": "20.85",
    "country": "United States"
  },
  {
    "Rank": "6396",
    "Name": "Gogoro",
    "Symbol": "GGR",
    " marketcap ": " $353 950 592 ",
    "price (USD)": "\u044f\u043d\u0432.44",
    "country": "Taiwan"
  },
  {
    "Rank": "6397",
    "Name": "MeiraGTx",
    "Symbol": "MGTX",
    " marketcap ": " $353 686 304 ",
    "price (USD)": "05.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "6398",
    "Name": "Star Group",
    "Symbol": "SGU",
    " marketcap ": " $353 361 920 ",
    "price (USD)": "10.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6399",
    "Name": "Chimera Investment Corporation",
    "Symbol": "CIM",
    " marketcap ": " $353 276 448 ",
    "price (USD)": "\u0430\u043f\u0440.39",
    "country": "United States"
  },
  {
    "Rank": "6400",
    "Name": "First Foundation",
    "Symbol": "FFWM",
    " marketcap ": " $353 199 360 ",
    "price (USD)": "\u0438\u044e\u043d.25",
    "country": "United States"
  },
  {
    "Rank": "6401",
    "Name": "FuelCell Energy",
    "Symbol": "FCEL",
    " marketcap ": " $353 085 888 ",
    "price (USD)": "0.7813",
    "country": "United States"
  },
  {
    "Rank": "6402",
    "Name": "Innodata",
    "Symbol": "INOD",
    " marketcap ": " $353 085 600 ",
    "price (USD)": "\u0434\u0435\u043a.28",
    "country": "United States"
  },
  {
    "Rank": "6403",
    "Name": "RBB Bancorp",
    "Symbol": "RBB",
    " marketcap ": " $352 578 560 ",
    "price (USD)": "19.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "6404",
    "Name": "11 bit studios",
    "Symbol": "11B.WA",
    " marketcap ": " $352 492 896 ",
    "price (USD)": "145.827",
    "country": "Poland"
  },
  {
    "Rank": "6405",
    "Name": "American Software",
    "Symbol": "AMSWA",
    " marketcap ": " $352 133 088 ",
    "price (USD)": "10.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "6406",
    "Name": "Intrepid Potash",
    "Symbol": "IPI",
    " marketcap ": " $351 498 464 ",
    "price (USD)": "26.49",
    "country": "United States"
  },
  {
    "Rank": "6407",
    "Name": "Precigen",
    "Symbol": "PGEN",
    " marketcap ": " $350 863 808 ",
    "price (USD)": "\u044f\u043d\u0432.39",
    "country": "United States"
  },
  {
    "Rank": "6408",
    "Name": "Marcus Corporation",
    "Symbol": "MCS",
    " marketcap ": " $350 811 040 ",
    "price (USD)": "\u043e\u043a\u0442.91",
    "country": "United States"
  },
  {
    "Rank": "6409",
    "Name": "Naqi Water Company",
    "Symbol": "2282.SR",
    " marketcap ": " $350 652 470 ",
    "price (USD)": "17.5326",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6410",
    "Name": "Turtle Beach Corp",
    "Symbol": "HEAR",
    " marketcap ": " $350 604 800 ",
    "price (USD)": "16.29",
    "country": "United States"
  },
  {
    "Rank": "6411",
    "Name": "8x8",
    "Symbol": "EGHT",
    " marketcap ": " $350 543 200 ",
    "price (USD)": "02.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6412",
    "Name": "MultiPlan",
    "Symbol": "MPLN",
    " marketcap ": " $350 356 736 ",
    "price (USD)": "0.5433",
    "country": "United States"
  },
  {
    "Rank": "6413",
    "Name": "GuangZhou Wahlap Technology",
    "Symbol": "301011.SZ",
    " marketcap ": " $350 352 230 ",
    "price (USD)": "2.38835",
    "country": "China"
  },
  {
    "Rank": "6414",
    "Name": "Homeland Interactive Technology",
    "Symbol": "3798.HK",
    " marketcap ": " $350 290 429 ",
    "price (USD)": "0.272939",
    "country": "China"
  },
  {
    "Rank": "6415",
    "Name": "Zura Bio",
    "Symbol": "ZURA",
    " marketcap ": " $350 260 896 ",
    "price (USD)": "05.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "6416",
    "Name": "Shalby",
    "Symbol": "SHALBY.NS",
    " marketcap ": " $349 792 738 ",
    "price (USD)": "3.26156",
    "country": "India"
  },
  {
    "Rank": "6417",
    "Name": "Forrester Research",
    "Symbol": "FORR",
    " marketcap ": " $349 658 080 ",
    "price (USD)": "18.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6418",
    "Name": "Summit Midstream",
    "Symbol": "SMLP",
    " marketcap ": " $349 383 872 ",
    "price (USD)": "32.81",
    "country": "United States"
  },
  {
    "Rank": "6419",
    "Name": "Fractyl Health",
    "Symbol": "GUTS",
    " marketcap ": " $348 689 440 ",
    "price (USD)": "\u0438\u044e\u043b.28",
    "country": "United States"
  },
  {
    "Rank": "6420",
    "Name": "Jasper Therapeutics",
    "Symbol": "JSPR",
    " marketcap ": " $348 477 376 ",
    "price (USD)": "23.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "6421",
    "Name": "Wendt India",
    "Symbol": "WENDT.NS",
    " marketcap ": " $348 403 773 ",
    "price (USD)": "174.202",
    "country": "India"
  },
  {
    "Rank": "6422",
    "Name": "Park-Ohio Holdings",
    "Symbol": "PKOH",
    " marketcap ": " $348 336 800 ",
    "price (USD)": "26.65",
    "country": "United States"
  },
  {
    "Rank": "6423",
    "Name": "Indoco Remedies",
    "Symbol": "INDOCO.NS",
    " marketcap ": " $348 274 683 ",
    "price (USD)": "3.77762",
    "country": "India"
  },
  {
    "Rank": "6424",
    "Name": "Middle East Specialized Cables Company",
    "Symbol": "2370.SR",
    " marketcap ": " $347 450 164 ",
    "price (USD)": "8.68625",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6425",
    "Name": "YAKUODO HOLDINGS",
    "Symbol": "7679.T",
    " marketcap ": " $347 372 171 ",
    "price (USD)": "17.7276",
    "country": "Japan"
  },
  {
    "Rank": "6426",
    "Name": "Nautilus Biotechnology",
    "Symbol": "NAUT",
    " marketcap ": " $346 984 032 ",
    "price (USD)": "\u0444\u0435\u0432.77",
    "country": "United States"
  },
  {
    "Rank": "6427",
    "Name": "Liva Group",
    "Symbol": "LIVA.OM",
    " marketcap ": " $346 727 474 ",
    "price (USD)": "0.870356",
    "country": "Oman"
  },
  {
    "Rank": "6428",
    "Name": "Viaplay Group",
    "Symbol": "VPLAY-B.ST",
    " marketcap ": " $346 558 624 ",
    "price (USD)": "0.0756872",
    "country": "Sweden"
  },
  {
    "Rank": "6429",
    "Name": "Confidence Petroleum",
    "Symbol": "CONFIPET.NS",
    " marketcap ": " $346 199 123 ",
    "price (USD)": "1.07237",
    "country": "India"
  },
  {
    "Rank": "6430",
    "Name": "Chargeurs",
    "Symbol": "CRI.PA",
    " marketcap ": " $346 119 805 ",
    "price (USD)": "14.3338",
    "country": "France"
  },
  {
    "Rank": "6431",
    "Name": "Selvaag Bolig",
    "Symbol": "SBO.OL",
    " marketcap ": " $345 672 336 ",
    "price (USD)": "3.69149",
    "country": "Norway"
  },
  {
    "Rank": "6432",
    "Name": "MidWestOne Financial Group",
    "Symbol": "MOFG",
    " marketcap ": " $345 671 296 ",
    "price (USD)": "21.94",
    "country": "United States"
  },
  {
    "Rank": "6433",
    "Name": "ioneer",
    "Symbol": "IONR",
    " marketcap ": " $345 134 368 ",
    "price (USD)": "\u0438\u044e\u043d.25",
    "country": "Australia"
  },
  {
    "Rank": "6434",
    "Name": "CSI Compressco",
    "Symbol": "CCLP",
    " marketcap ": " $344 842 720 ",
    "price (USD)": "\u0444\u0435\u0432.42",
    "country": "United States"
  },
  {
    "Rank": "6435",
    "Name": "Qudian",
    "Symbol": "QD",
    " marketcap ": " $344 715 296 ",
    "price (USD)": "\u044f\u043d\u0432.82",
    "country": "China"
  },
  {
    "Rank": "6436",
    "Name": "Bafang Yunji",
    "Symbol": "2753.TW",
    " marketcap ": " $344 362 697 ",
    "price (USD)": "5.17878",
    "country": "Taiwan"
  },
  {
    "Rank": "6437",
    "Name": "Aura Biosciences",
    "Symbol": "AURA",
    " marketcap ": " $344 325 920 ",
    "price (USD)": "\u0438\u044e\u043d.95",
    "country": "United States"
  },
  {
    "Rank": "6438",
    "Name": "The Cross-Harbour Holdings",
    "Symbol": "0032.HK",
    " marketcap ": " $343 846 447 ",
    "price (USD)": "0.922612",
    "country": "Hong Kong"
  },
  {
    "Rank": "6439",
    "Name": "Arnarlax (Icelandic Salmon)",
    "Symbol": "ISLAX.OL",
    " marketcap ": " $342 741 162 ",
    "price (USD)": "11.0698",
    "country": "Iceland"
  },
  {
    "Rank": "6440",
    "Name": "Nerdy",
    "Symbol": "NRDY",
    " marketcap ": " $342 611 104 ",
    "price (USD)": "\u044f\u043d\u0432.95",
    "country": "United States"
  },
  {
    "Rank": "6441",
    "Name": "Sleep Number",
    "Symbol": "SNBR",
    " marketcap ": " $342 265 248 ",
    "price (USD)": "15.33",
    "country": "United States"
  },
  {
    "Rank": "6442",
    "Name": "J.Jill",
    "Symbol": "JILL",
    " marketcap ": " $342 209 952 ",
    "price (USD)": "31.84",
    "country": "United States"
  },
  {
    "Rank": "6443",
    "Name": "Replimune",
    "Symbol": "REPL",
    " marketcap ": " $342 082 112 ",
    "price (USD)": "\u043c\u0430\u0439.57",
    "country": "United States"
  },
  {
    "Rank": "6444",
    "Name": "Cerus",
    "Symbol": "CERS",
    " marketcap ": " $342 046 496 ",
    "price (USD)": "\u044f\u043d\u0432.85",
    "country": "United States"
  },
  {
    "Rank": "6445",
    "Name": "Guaranty Bancshares",
    "Symbol": "GNTY",
    " marketcap ": " $341 712 352 ",
    "price (USD)": "29.67",
    "country": "United States"
  },
  {
    "Rank": "6446",
    "Name": "Alto Neuroscience",
    "Symbol": "ANRO",
    " marketcap ": " $341 157 952 ",
    "price (USD)": "\u0434\u0435\u043a.69",
    "country": "United States"
  },
  {
    "Rank": "6447",
    "Name": "Pulmonx",
    "Symbol": "LUNG",
    " marketcap ": " $340 802 720 ",
    "price (USD)": "\u0430\u0432\u0433.78",
    "country": "United States"
  },
  {
    "Rank": "6448",
    "Name": "W&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6449",
    "Name": "Medicare Group",
    "Symbol": "MCGS.QA",
    " marketcap ": " $339 894 119 ",
    "price (USD)": "1.20769",
    "country": "Qatar"
  },
  {
    "Rank": "6450",
    "Name": "Qatar Islamic Insurance Group",
    "Symbol": "QISI.QA",
    " marketcap ": " $339 560 440 ",
    "price (USD)": "2.26374",
    "country": "Qatar"
  },
  {
    "Rank": "6451",
    "Name": "Nilkamal",
    "Symbol": "NILKAMAL.NS",
    " marketcap ": " $339 439 593 ",
    "price (USD)": "22.6988",
    "country": "India"
  },
  {
    "Rank": "6452",
    "Name": "Luxfer",
    "Symbol": "LXFR",
    " marketcap ": " $339 390 272 ",
    "price (USD)": "\u0434\u0435\u043a.38",
    "country": "United Kingdom"
  },
  {
    "Rank": "6453",
    "Name": "Standard Lithium",
    "Symbol": "SLI",
    " marketcap ": " $338 841 760 ",
    "price (USD)": "\u044f\u043d\u0432.86",
    "country": "Canada"
  },
  {
    "Rank": "6454",
    "Name": "Qatar Industrial Manufacturing Company",
    "Symbol": "QIMD.QA",
    " marketcap ": " $338 123 077 ",
    "price (USD)": "0.711538",
    "country": "Qatar"
  },
  {
    "Rank": "6455",
    "Name": "Stellus Capital",
    "Symbol": "SCM",
    " marketcap ": " $337 758 400 ",
    "price (USD)": "14",
    "country": "United States"
  },
  {
    "Rank": "6456",
    "Name": "Euroapi",
    "Symbol": "EAPI.PA",
    " marketcap ": " $337 730 168 ",
    "price (USD)": "3.55305",
    "country": "France"
  },
  {
    "Rank": "6457",
    "Name": "TrueBlue",
    "Symbol": "TBI",
    " marketcap ": " $337 488 384 ",
    "price (USD)": "11.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "6458",
    "Name": "Forge Global",
    "Symbol": "FRGE",
    " marketcap ": " $336 734 400 ",
    "price (USD)": "\u044f\u043d\u0432.86",
    "country": "United States"
  },
  {
    "Rank": "6459",
    "Name": "Uranium Royalty",
    "Symbol": "UROY",
    " marketcap ": " $336 657 984 ",
    "price (USD)": "02.\u0430\u0432\u0433",
    "country": "Canada"
  },
  {
    "Rank": "6460",
    "Name": "Nanobiotix",
    "Symbol": "NBTX",
    " marketcap ": " $336 541 888 ",
    "price (USD)": "07.\u043d\u043e\u044f",
    "country": "France"
  },
  {
    "Rank": "6461",
    "Name": "Zynex",
    "Symbol": "ZYXI",
    " marketcap ": " $336 181 600 ",
    "price (USD)": "\u043e\u043a\u0442.58",
    "country": "United States"
  },
  {
    "Rank": "6462",
    "Name": "Al Baraka Group",
    "Symbol": "BARKA.BH",
    " marketcap ": " $335 577 533 ",
    "price (USD)": "0.325",
    "country": "Bahrain"
  },
  {
    "Rank": "6463",
    "Name": "Seritage Growth Properties",
    "Symbol": "SRG",
    " marketcap ": " $335 359 072 ",
    "price (USD)": "\u043c\u0430\u0439.96",
    "country": "United States"
  },
  {
    "Rank": "6464",
    "Name": "Fujibo Holdings",
    "Symbol": "3104.T",
    " marketcap ": " $334 774 252 ",
    "price (USD)": "29.5247",
    "country": "Japan"
  },
  {
    "Rank": "6465",
    "Name": "El Pollo Loco",
    "Symbol": "LOCO",
    " marketcap ": " $334 631 712 ",
    "price (USD)": "\u043e\u043a\u0442.76",
    "country": "United States"
  },
  {
    "Rank": "6466",
    "Name": "Anora Group",
    "Symbol": "ANORA.HE",
    " marketcap ": " $334 503 655 ",
    "price (USD)": "4.95168",
    "country": "Finland"
  },
  {
    "Rank": "6467",
    "Name": "Ventyx Biosciences",
    "Symbol": "VTYX",
    " marketcap ": " $334 166 656 ",
    "price (USD)": "\u0430\u043f\u0440.74",
    "country": "United States"
  },
  {
    "Rank": "6468",
    "Name": "Rayonier Advanced Materials",
    "Symbol": "RYAM",
    " marketcap ": " $333 782 368 ",
    "price (USD)": "05.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6469",
    "Name": "Bridgewater Bancshares",
    "Symbol": "BWB",
    " marketcap ": " $333 689 056 ",
    "price (USD)": "\u0434\u0435\u043a.19",
    "country": "United States"
  },
  {
    "Rank": "6470",
    "Name": "MPS Limited",
    "Symbol": "MPSLTD.NS",
    " marketcap ": " $333 337 278 ",
    "price (USD)": "19.4462",
    "country": "India"
  },
  {
    "Rank": "6471",
    "Name": "Huuuge",
    "Symbol": "HUG.WA",
    " marketcap ": " $333 129 415 ",
    "price (USD)": "5.95056",
    "country": "United States"
  },
  {
    "Rank": "6472",
    "Name": "Newtek",
    "Symbol": "NEWT",
    " marketcap ": " $332 422 272 ",
    "price (USD)": "13.44",
    "country": "United States"
  },
  {
    "Rank": "6473",
    "Name": "Aehr Test Systems",
    "Symbol": "AEHR",
    " marketcap ": " $332 229 888 ",
    "price (USD)": "\u043d\u043e\u044f.49",
    "country": "United States"
  },
  {
    "Rank": "6474",
    "Name": "Forward Air",
    "Symbol": "FWRD",
    " marketcap ": " $332 066 304 ",
    "price (USD)": "\u0434\u0435\u043a.56",
    "country": "United States"
  },
  {
    "Rank": "6475",
    "Name": "Neowiz Games",
    "Symbol": "095660.KQ",
    " marketcap ": " $331 332 924 ",
    "price (USD)": "16.1567",
    "country": "South Korea"
  },
  {
    "Rank": "6476",
    "Name": "MM Forgings",
    "Symbol": "MMFL.NS",
    " marketcap ": " $331 250 718 ",
    "price (USD)": "13.7089",
    "country": "India"
  },
  {
    "Rank": "6477",
    "Name": "Eagle Nice",
    "Symbol": "2368.HK",
    " marketcap ": " $331 062 963 ",
    "price (USD)": "0.6202",
    "country": "Hong Kong"
  },
  {
    "Rank": "6478",
    "Name": "Oman Cement Company",
    "Symbol": "OCOI.OM",
    " marketcap ": " $330 958 673 ",
    "price (USD)": "1.00026",
    "country": "Oman"
  },
  {
    "Rank": "6479",
    "Name": "Procaps Group",
    "Symbol": "PROC",
    " marketcap ": " $330 574 336 ",
    "price (USD)": "\u0444\u0435\u0432.93",
    "country": "Luxembourg"
  },
  {
    "Rank": "6480",
    "Name": "AC Immune",
    "Symbol": "ACIU",
    " marketcap ": " $330 322 304 ",
    "price (USD)": "\u043c\u0430\u0440.34",
    "country": "Switzerland"
  },
  {
    "Rank": "6481",
    "Name": "Kuwait Investment Company",
    "Symbol": "KINV.KW",
    " marketcap ": " $330 306 415 ",
    "price (USD)": "599.739",
    "country": "Kuwait"
  },
  {
    "Rank": "6482",
    "Name": "Superior Group of Companies",
    "Symbol": "SGC",
    " marketcap ": " $330 215 328 ",
    "price (USD)": "19.72",
    "country": "United States"
  },
  {
    "Rank": "6483",
    "Name": "New Work",
    "Symbol": "NWO.F",
    " marketcap ": " $330 183 290 ",
    "price (USD)": "58.7469",
    "country": "Germany"
  },
  {
    "Rank": "6484",
    "Name": "Weathernews Inc.",
    "Symbol": "4825.T",
    " marketcap ": " $330 034 045 ",
    "price (USD)": "29.8765",
    "country": "Japan"
  },
  {
    "Rank": "6485",
    "Name": "Bit Digital",
    "Symbol": "BTBT",
    " marketcap ": " $329 130 880 ",
    "price (USD)": "\u0444\u0435\u0432.72",
    "country": "United States"
  },
  {
    "Rank": "6486",
    "Name": "Sequent Scientific",
    "Symbol": "SEQUENT.NS",
    " marketcap ": " $329 122 399 ",
    "price (USD)": "1.31808",
    "country": "India"
  },
  {
    "Rank": "6487",
    "Name": "Doha Insurance Group",
    "Symbol": "DOHI.QA",
    " marketcap ": " $328 296 721 ",
    "price (USD)": "0.656593",
    "country": "Qatar"
  },
  {
    "Rank": "6488",
    "Name": "Tenaya Therapeutics",
    "Symbol": "TNYA",
    " marketcap ": " $328 203 168 ",
    "price (USD)": "\u0430\u043f\u0440.18",
    "country": "United States"
  },
  {
    "Rank": "6489",
    "Name": "TTEC",
    "Symbol": "TTEC",
    " marketcap ": " $328 144 672 ",
    "price (USD)": "06.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6490",
    "Name": "Red River Bancshares",
    "Symbol": "RRBI",
    " marketcap ": " $328 106 720 ",
    "price (USD)": "47.53",
    "country": "United States"
  },
  {
    "Rank": "6491",
    "Name": "Apollo Pipes",
    "Symbol": "APOLLOPIPE.NS",
    " marketcap ": " $328 021 095 ",
    "price (USD)": "7.96496",
    "country": "India"
  },
  {
    "Rank": "6492",
    "Name": "Alembic Limited",
    "Symbol": "ALEMBICLTD.NS",
    " marketcap ": " $327 686 459 ",
    "price (USD)": "1.26882",
    "country": "India"
  },
  {
    "Rank": "6493",
    "Name": "The Beauty Health Company",
    "Symbol": "SKIN",
    " marketcap ": " $327 624 800 ",
    "price (USD)": "\u0444\u0435\u0432.65",
    "country": "United States"
  },
  {
    "Rank": "6494",
    "Name": "BRT Apartments",
    "Symbol": "BRT",
    " marketcap ": " $327 513 568 ",
    "price (USD)": "17.57",
    "country": "United States"
  },
  {
    "Rank": "6495",
    "Name": "Redwire",
    "Symbol": "RDW",
    " marketcap ": " $327 237 696 ",
    "price (USD)": "\u0430\u043f\u0440.99",
    "country": "United States"
  },
  {
    "Rank": "6496",
    "Name": "Emirates Insurance Company",
    "Symbol": "EIC.AE",
    " marketcap ": " $326 735 100 ",
    "price (USD)": "\u0444\u0435\u0432.18",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6497",
    "Name": "Solid Biosciences",
    "Symbol": "SLDB",
    " marketcap ": " $326 608 704 ",
    "price (USD)": "\u0430\u0432\u0433.51",
    "country": "United States"
  },
  {
    "Rank": "6498",
    "Name": "BrainChip",
    "Symbol": "BRN.AX",
    " marketcap ": " $326 157 922 ",
    "price (USD)": "0.166702",
    "country": "Australia"
  },
  {
    "Rank": "6499",
    "Name": "LifeMD",
    "Symbol": "LFMD",
    " marketcap ": " $326 055 904 ",
    "price (USD)": "\u0438\u044e\u043b.71",
    "country": "United States"
  },
  {
    "Rank": "6500",
    "Name": "Unisys",
    "Symbol": "UIS",
    " marketcap ": " $325 373 920 ",
    "price (USD)": "04.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6501",
    "Name": "Unitech Group",
    "Symbol": "UNITECH.NS",
    " marketcap ": " $325 352 152 ",
    "price (USD)": "0.123758",
    "country": "India"
  },
  {
    "Rank": "6502",
    "Name": "Polyplex",
    "Symbol": "POLYPLEX.NS",
    " marketcap ": " $324 982 327 ",
    "price (USD)": "10.341",
    "country": "India"
  },
  {
    "Rank": "6503",
    "Name": "China Motor Bus Company",
    "Symbol": "0026.HK",
    " marketcap ": " $324 901 227 ",
    "price (USD)": "7.17587",
    "country": "Hong Kong"
  },
  {
    "Rank": "6504",
    "Name": "Al Wathba National Insurance",
    "Symbol": "AWNIC.AE",
    " marketcap ": " $324 080 377 ",
    "price (USD)": "\u044f\u043d\u0432.57",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6505",
    "Name": "Kuwait Insurance Company",
    "Symbol": "KINS.KW",
    " marketcap ": " $324 060 834 ",
    "price (USD)": "1753.59",
    "country": "Kuwait"
  },
  {
    "Rank": "6506",
    "Name": "SRA Holdings",
    "Symbol": "3817.T",
    " marketcap ": " $323 683 161 ",
    "price (USD)": "25.7181",
    "country": "Japan"
  },
  {
    "Rank": "6507",
    "Name": "Pizza Pizza",
    "Symbol": "PZA.TO",
    " marketcap ": " $323 548 752 ",
    "price (USD)": "9.83174",
    "country": "Canada"
  },
  {
    "Rank": "6508",
    "Name": "Reach plc",
    "Symbol": "RCH.L",
    " marketcap ": " $322 999 901 ",
    "price (USD)": "1.0158",
    "country": "United Kingdom"
  },
  {
    "Rank": "6509",
    "Name": "Canaan",
    "Symbol": "CAN",
    " marketcap ": " $322 620 416 ",
    "price (USD)": "1.075",
    "country": "China"
  },
  {
    "Rank": "6510",
    "Name": "Al Jouf Cement Company",
    "Symbol": "3091.SR",
    " marketcap ": " $322 563 962 ",
    "price (USD)": "2.96747",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6511",
    "Name": "MiX Telematics",
    "Symbol": "MIXT",
    " marketcap ": " $322 439 648 ",
    "price (USD)": "14.55",
    "country": "United States"
  },
  {
    "Rank": "6512",
    "Name": "Jubilee Metals Group",
    "Symbol": "JLP.L",
    " marketcap ": " $322 332 395 ",
    "price (USD)": "0.108039",
    "country": "United Kingdom"
  },
  {
    "Rank": "6513",
    "Name": "L.B. Foster",
    "Symbol": "FSTR",
    " marketcap ": " $321 565 312 ",
    "price (USD)": "29.33",
    "country": "United States"
  },
  {
    "Rank": "6514",
    "Name": "Enterprise Bancorp",
    "Symbol": "EBTC",
    " marketcap ": " $321 494 688 ",
    "price (USD)": "25.98",
    "country": "United States"
  },
  {
    "Rank": "6515",
    "Name": "Graham Corporation",
    "Symbol": "GHM",
    " marketcap ": " $321 059 104 ",
    "price (USD)": "29.65",
    "country": "United States"
  },
  {
    "Rank": "6516",
    "Name": "Saratoga Investment",
    "Symbol": "SAR",
    " marketcap ": " $320 967 584 ",
    "price (USD)": "23.43",
    "country": "United States"
  },
  {
    "Rank": "6517",
    "Name": "Spok Holdings",
    "Symbol": "SPOK",
    " marketcap ": " $320 691 904 ",
    "price (USD)": "15.84",
    "country": "United States"
  },
  {
    "Rank": "6518",
    "Name": "Mersana Therapeutics",
    "Symbol": "MRSN",
    " marketcap ": " $320 585 792 ",
    "price (USD)": "\u0444\u0435\u0432.62",
    "country": "United States"
  },
  {
    "Rank": "6519",
    "Name": "NexPoint Real Estate Finance",
    "Symbol": "NREF",
    " marketcap ": " $320 421 376 ",
    "price (USD)": "14.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6520",
    "Name": "Ascot Resources",
    "Symbol": "AOT.TO",
    " marketcap ": " $320 321 255 ",
    "price (USD)": "0.513215",
    "country": "Canada"
  },
  {
    "Rank": "6521",
    "Name": "GreenTree Hospitality",
    "Symbol": "GHG",
    " marketcap ": " $319 863 616 ",
    "price (USD)": "\u043c\u0430\u0440.15",
    "country": "China"
  },
  {
    "Rank": "6522",
    "Name": "NI Holdings",
    "Symbol": "NODK",
    " marketcap ": " $319 344 640 ",
    "price (USD)": "15.48",
    "country": "United States"
  },
  {
    "Rank": "6523",
    "Name": "PTC Financial Services",
    "Symbol": "PFS.NS",
    " marketcap ": " $319 107 999 ",
    "price (USD)": "0.496834",
    "country": "India"
  },
  {
    "Rank": "6524",
    "Name": "The Saudi Arabian Amiantit Company",
    "Symbol": "2160.SR",
    " marketcap ": " $318 861 038 ",
    "price (USD)": "7.16516",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6525",
    "Name": "Sierra Bancorp",
    "Symbol": "BSRR",
    " marketcap ": " $316 872 640 ",
    "price (USD)": "21.71",
    "country": "United States"
  },
  {
    "Rank": "6526",
    "Name": "DouYu",
    "Symbol": "DOYU",
    " marketcap ": " $316 672 352 ",
    "price (USD)": "10.\u044f\u043d\u0432",
    "country": "China"
  },
  {
    "Rank": "6527",
    "Name": "Genesco",
    "Symbol": "GCO",
    " marketcap ": " $316 558 400 ",
    "price (USD)": "27.21",
    "country": "United States"
  },
  {
    "Rank": "6528",
    "Name": "ReposiTrak",
    "Symbol": "TRAK",
    " marketcap ": " $316 002 432 ",
    "price (USD)": "17.34",
    "country": "United States"
  },
  {
    "Rank": "6529",
    "Name": "Honda Siel Power Products",
    "Symbol": "HONDAPOWER.NS",
    " marketcap ": " $315 831 696 ",
    "price (USD)": "31.1155",
    "country": "India"
  },
  {
    "Rank": "6530",
    "Name": "Revance Therapeutics",
    "Symbol": "RVNC",
    " marketcap ": " $314 391 488 ",
    "price (USD)": "03.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "6531",
    "Name": "Coelacanth Energy",
    "Symbol": "CEI.V",
    " marketcap ": " $314 386 539 ",
    "price (USD)": "0.593863",
    "country": "Canada"
  },
  {
    "Rank": "6532",
    "Name": "Ice Fish Farm",
    "Symbol": "IFISH.OL",
    " marketcap ": " $314 264 360 ",
    "price (USD)": "2.57044",
    "country": "Iceland"
  },
  {
    "Rank": "6533",
    "Name": "Arteris",
    "Symbol": "AIP",
    " marketcap ": " $313 989 440 ",
    "price (USD)": "\u0430\u0432\u0433.16",
    "country": "United States"
  },
  {
    "Rank": "6534",
    "Name": "Amlak International Finance Company",
    "Symbol": "1182.SR",
    " marketcap ": " $313 883 203 ",
    "price (USD)": "3.07955",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6535",
    "Name": "Aeroporto G. Marconi Bologna",
    "Symbol": "ADB.MI",
    " marketcap ": " $313 044 926 ",
    "price (USD)": "8.66544",
    "country": "Italy"
  },
  {
    "Rank": "6536",
    "Name": "Investors Title Company",
    "Symbol": "ITIC",
    " marketcap ": " $312 626 560 ",
    "price (USD)": "165.95",
    "country": "United States"
  },
  {
    "Rank": "6537",
    "Name": "Banan Real Estate Company",
    "Symbol": "9519.SR",
    " marketcap ": " $312 224 802 ",
    "price (USD)": "1.56112",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6538",
    "Name": "Nektar Therapeutics",
    "Symbol": "NKTR",
    " marketcap ": " $312 162 496 ",
    "price (USD)": "01.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6539",
    "Name": "Blink Charging",
    "Symbol": "BLNK",
    " marketcap ": " $312 056 000 ",
    "price (USD)": "03.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6540",
    "Name": "Vitru",
    "Symbol": "VTRU",
    " marketcap ": " $311 950 848 ",
    "price (USD)": "09.\u043c\u0430\u0440",
    "country": "Brazil"
  },
  {
    "Rank": "6541",
    "Name": "Wallbox",
    "Symbol": "WBX",
    " marketcap ": " $311 797 536 ",
    "price (USD)": "\u044f\u043d\u0432.48",
    "country": "Spain"
  },
  {
    "Rank": "6542",
    "Name": "Delegat",
    "Symbol": "DGL.NZ",
    " marketcap ": " $311 655 395 ",
    "price (USD)": "3.08173",
    "country": "New Zealand"
  },
  {
    "Rank": "6543",
    "Name": "Piedmont Lithium",
    "Symbol": "PLL",
    " marketcap ": " $311 653 664 ",
    "price (USD)": "16.\u0441\u0435\u043d",
    "country": "Australia"
  },
  {
    "Rank": "6544",
    "Name": "Lesaka Technologies",
    "Symbol": "LSAK",
    " marketcap ": " $311 638 528 ",
    "price (USD)": "04.\u0441\u0435\u043d",
    "country": "South Africa"
  },
  {
    "Rank": "6545",
    "Name": "American Public Education",
    "Symbol": "APEI",
    " marketcap ": " $310 903 520 ",
    "price (USD)": "17.69",
    "country": "United States"
  },
  {
    "Rank": "6546",
    "Name": "Transphorm",
    "Symbol": "TGAN",
    " marketcap ": " $310 452 256 ",
    "price (USD)": "04.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6547",
    "Name": "Capacit'e Infraprojects",
    "Symbol": "CAPACITE.NS",
    " marketcap ": " $310 422 350 ",
    "price (USD)": "3.66287",
    "country": "India"
  },
  {
    "Rank": "6548",
    "Name": "Hindustan Oil Exploration Company",
    "Symbol": "HINDOILEXP.NS",
    " marketcap ": " $310 161 782 ",
    "price (USD)": "2.34539",
    "country": "India"
  },
  {
    "Rank": "6549",
    "Name": "Sharecare",
    "Symbol": "SHCR",
    " marketcap ": " $308 954 528 ",
    "price (USD)": "0.8525",
    "country": "United States"
  },
  {
    "Rank": "6550",
    "Name": "Matrix Service",
    "Symbol": "MTRX",
    " marketcap ": " $308 862 528 ",
    "price (USD)": "\u043d\u043e\u044f.31",
    "country": "United States"
  },
  {
    "Rank": "6551",
    "Name": "Immersion Corporation",
    "Symbol": "IMMR",
    " marketcap ": " $308 672 992 ",
    "price (USD)": "\u0441\u0435\u043d.69",
    "country": "United States"
  },
  {
    "Rank": "6552",
    "Name": "Materialise NV",
    "Symbol": "MTLS",
    " marketcap ": " $308 330 784 ",
    "price (USD)": "\u043c\u0430\u0439.22",
    "country": "Belgium"
  },
  {
    "Rank": "6553",
    "Name": "Treace Medical Concepts",
    "Symbol": "TMCI",
    " marketcap ": " $308 180 256 ",
    "price (USD)": "\u0430\u043f\u0440.97",
    "country": "United States"
  },
  {
    "Rank": "6554",
    "Name": "LexinFintech Holdings",
    "Symbol": "LX",
    " marketcap ": " $307 452 288 ",
    "price (USD)": "\u044f\u043d\u0432.87",
    "country": "China"
  },
  {
    "Rank": "6555",
    "Name": "Qurate Retail Group",
    "Symbol": "QRTEA",
    " marketcap ": " $307 122 304 ",
    "price (USD)": "0.7005",
    "country": "United States"
  },
  {
    "Rank": "6556",
    "Name": "Icelandair",
    "Symbol": "ICEAIR.IC",
    " marketcap ": " $306 578 394 ",
    "price (USD)": "0.00745566",
    "country": "Iceland"
  },
  {
    "Rank": "6557",
    "Name": "WhiteHorse Finance",
    "Symbol": "WHF",
    " marketcap ": " $306 576 480 ",
    "price (USD)": "13.19",
    "country": "United States"
  },
  {
    "Rank": "6558",
    "Name": "Immobel",
    "Symbol": "IMMO.BR",
    " marketcap ": " $306 029 562 ",
    "price (USD)": "29.6992",
    "country": "Belgium"
  },
  {
    "Rank": "6559",
    "Name": "Tabuk Cement Company",
    "Symbol": "3090.SR",
    " marketcap ": " $305 980 289 ",
    "price (USD)": "3.39978",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6560",
    "Name": "DocGo",
    "Symbol": "DCGO",
    " marketcap ": " $305 713 664 ",
    "price (USD)": "03.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "6561",
    "Name": "Lumax Industries",
    "Symbol": "LUMAXIND.NS",
    " marketcap ": " $305 696 277 ",
    "price (USD)": "32.7027",
    "country": "India"
  },
  {
    "Rank": "6562",
    "Name": "Verastem Oncology",
    "Symbol": "VSTM",
    " marketcap ": " $305 426 752 ",
    "price (USD)": "12.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "6563",
    "Name": "Tactile Medical",
    "Symbol": "TCMD",
    " marketcap ": " $305 106 656 ",
    "price (USD)": "\u0434\u0435\u043a.84",
    "country": "United States"
  },
  {
    "Rank": "6564",
    "Name": "Oil States International",
    "Symbol": "OIS",
    " marketcap ": " $305 022 208 ",
    "price (USD)": "\u0430\u043f\u0440.75",
    "country": "United States"
  },
  {
    "Rank": "6565",
    "Name": "Kamada",
    "Symbol": "KMDA",
    " marketcap ": " $304 641 376 ",
    "price (USD)": "05.\u043c\u0430\u0440",
    "country": "Israel"
  },
  {
    "Rank": "6566",
    "Name": "Angel Oak REIT",
    "Symbol": "AOMR",
    " marketcap ": " $304 327 008 ",
    "price (USD)": "\u0434\u0435\u043a.19",
    "country": "United States"
  },
  {
    "Rank": "6567",
    "Name": "Atea Pharmaceuticals",
    "Symbol": "AVIR",
    " marketcap ": " $304 045 408 ",
    "price (USD)": "\u043c\u0430\u0440.61",
    "country": "United States"
  },
  {
    "Rank": "6568",
    "Name": "Metalla Royalty & Streaming",
    "Symbol": "MTA",
    " marketcap ": " $303 751 104 ",
    "price (USD)": "\u043c\u0430\u0440.32",
    "country": "Canada"
  },
  {
    "Rank": "6569",
    "Name": "SOPHiA GENETICS",
    "Symbol": "SOPH",
    " marketcap ": " $303 340 448 ",
    "price (USD)": "\u0430\u043f\u0440.64",
    "country": "Switzerland"
  },
  {
    "Rank": "6570",
    "Name": "Innovid",
    "Symbol": "CTV",
    " marketcap ": " $303 267 264 ",
    "price (USD)": "02.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "6571",
    "Name": "Maruzen",
    "Symbol": "5982.T",
    " marketcap ": " $303 247 211 ",
    "price (USD)": "19.2246",
    "country": "Japan"
  },
  {
    "Rank": "6572",
    "Name": "Chinese Estates Holdings",
    "Symbol": "0127.HK",
    " marketcap ": " $303 109 934 ",
    "price (USD)": "0.158894",
    "country": "Hong Kong"
  },
  {
    "Rank": "6573",
    "Name": "AudioCodes",
    "Symbol": "AUDC",
    " marketcap ": " $302 939 744 ",
    "price (USD)": "\u0441\u0435\u043d.99",
    "country": "Israel"
  },
  {
    "Rank": "6574",
    "Name": "Farmers &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6575",
    "Name": "Gilat Satellite Networks",
    "Symbol": "GILT",
    " marketcap ": " $302 755 488 ",
    "price (USD)": "\u043c\u0430\u0439.31",
    "country": "Israel"
  },
  {
    "Rank": "6576",
    "Name": "Home Bancorp",
    "Symbol": "HBCP",
    " marketcap ": " $302 373 888 ",
    "price (USD)": "37.2",
    "country": "United States"
  },
  {
    "Rank": "6577",
    "Name": "Ayr Wellness",
    "Symbol": "AYRWF",
    " marketcap ": " $302 177 056 ",
    "price (USD)": "\u0444\u0435\u0432.64",
    "country": "United States"
  },
  {
    "Rank": "6578",
    "Name": "RPG Life Sciences",
    "Symbol": "RPGLIFE.NS",
    " marketcap ": " $302 066 735 ",
    "price (USD)": "18.2639",
    "country": "India"
  },
  {
    "Rank": "6579",
    "Name": "Northrim BanCorp",
    "Symbol": "NRIM",
    " marketcap ": " $301 981 952 ",
    "price (USD)": "54.91",
    "country": "United States"
  },
  {
    "Rank": "6580",
    "Name": "Wafrah for Industry and Development Company",
    "Symbol": "2100.SR",
    " marketcap ": " $301 798 949 ",
    "price (USD)": "13.0361",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6581",
    "Name": "Geojit Financial Services",
    "Symbol": "GEOJITFSL.NS",
    " marketcap ": " $301 508 000 ",
    "price (USD)": "\u044f\u043d\u0432.74",
    "country": "India"
  },
  {
    "Rank": "6582",
    "Name": "XOMA",
    "Symbol": "XOMA",
    " marketcap ": " $301 439 744 ",
    "price (USD)": "25.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6583",
    "Name": "Cenomi Retail (Fawaz Abdulaziz Al Hokair &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6584",
    "Name": "Universal Stainless & Alloy Products",
    "Symbol": "USAP",
    " marketcap ": " $300 874 400 ",
    "price (USD)": "32.74",
    "country": "United States"
  },
  {
    "Rank": "6585",
    "Name": "MBIA",
    "Symbol": "MBI",
    " marketcap ": " $300 480 288 ",
    "price (USD)": "\u043c\u0430\u0439.86",
    "country": "United States"
  },
  {
    "Rank": "6586",
    "Name": "CompX International",
    "Symbol": "CIX",
    " marketcap ": " $300 456 704 ",
    "price (USD)": "24.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "6587",
    "Name": "Emirates Investment Bank",
    "Symbol": "EIBANK.AE",
    " marketcap ": " $299 499 020 ",
    "price (USD)": "29.9499",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6588",
    "Name": "Chicago Atlantic Real Estate Finance",
    "Symbol": "REFI",
    " marketcap ": " $299 301 696 ",
    "price (USD)": "15.67",
    "country": "United States"
  },
  {
    "Rank": "6589",
    "Name": "Solid Power",
    "Symbol": "SLDP",
    " marketcap ": " $299 207 744 ",
    "price (USD)": "\u044f\u043d\u0432.69",
    "country": "United States"
  },
  {
    "Rank": "6590",
    "Name": "Accelya",
    "Symbol": "ACCELYA.NS",
    " marketcap ": " $299 091 578 ",
    "price (USD)": "20.0073",
    "country": "India"
  },
  {
    "Rank": "6591",
    "Name": "Filatex India",
    "Symbol": "FILATEX.NS",
    " marketcap ": " $299 016 648 ",
    "price (USD)": "0.671056",
    "country": "India"
  },
  {
    "Rank": "6592",
    "Name": "Mangalam Cement",
    "Symbol": "MANGLMCEM.NS",
    " marketcap ": " $298 837 014 ",
    "price (USD)": "\u043e\u043a\u0442.79",
    "country": "India"
  },
  {
    "Rank": "6593",
    "Name": "Hail Cement Company",
    "Symbol": "3001.SR",
    " marketcap ": " $298 432 309 ",
    "price (USD)": "3.09556",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6594",
    "Name": "Gambling.com Group",
    "Symbol": "GAMB",
    " marketcap ": " $298 338 656 ",
    "price (USD)": "08.\u0430\u0432\u0433",
    "country": "Jersey"
  },
  {
    "Rank": "6595",
    "Name": "West Bancorporation",
    "Symbol": "WTBA",
    " marketcap ": " $297 607 808 ",
    "price (USD)": "17.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6596",
    "Name": "Vanda Pharmaceuticals",
    "Symbol": "VNDA",
    " marketcap ": " $297 393 312 ",
    "price (USD)": "05.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "6597",
    "Name": "Nature's Sunshine Products",
    "Symbol": "NATR",
    " marketcap ": " $297 241 920 ",
    "price (USD)": "15.87",
    "country": "United States"
  },
  {
    "Rank": "6598",
    "Name": "Media and Games Invest",
    "Symbol": "M8G.DE",
    " marketcap ": " $296 743 690 ",
    "price (USD)": "1.86339",
    "country": "Malta"
  },
  {
    "Rank": "6599",
    "Name": "Xeris Pharmaceuticals",
    "Symbol": "XERS",
    " marketcap ": " $296 512 000 ",
    "price (USD)": "2",
    "country": "United States"
  },
  {
    "Rank": "6600",
    "Name": "India Glycols",
    "Symbol": "INDIAGLYCO.NS",
    " marketcap ": " $296 420 518 ",
    "price (USD)": "9.57081",
    "country": "India"
  },
  {
    "Rank": "6601",
    "Name": "Quick Heal",
    "Symbol": "QUICKHEAL.NS",
    " marketcap ": " $296 357 941 ",
    "price (USD)": "5.51924",
    "country": "India"
  },
  {
    "Rank": "6602",
    "Name": "Third Coast Bancshares",
    "Symbol": "TCBX",
    " marketcap ": " $296 270 112 ",
    "price (USD)": "21.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6603",
    "Name": "APM Terminals Bahrain",
    "Symbol": "APMTB.BH",
    " marketcap ": " $296 021 220 ",
    "price (USD)": "0.71618",
    "country": "Bahrain"
  },
  {
    "Rank": "6604",
    "Name": "Marimaca Copper",
    "Symbol": "MARI.TO",
    " marketcap ": " $296 006 041 ",
    "price (USD)": "3.1746",
    "country": "Canada"
  },
  {
    "Rank": "6605",
    "Name": "Western Copper and Gold",
    "Symbol": "WRN",
    " marketcap ": " $295 220 992 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "Canada"
  },
  {
    "Rank": "6606",
    "Name": "Playstudios",
    "Symbol": "MYPS",
    " marketcap ": " $295 220 768 ",
    "price (USD)": "\u0444\u0435\u0432.19",
    "country": "United States"
  },
  {
    "Rank": "6607",
    "Name": "Hawesko",
    "Symbol": "HAW.DE",
    " marketcap ": " $294 601 681 ",
    "price (USD)": "32.794",
    "country": "Germany"
  },
  {
    "Rank": "6608",
    "Name": "iRobot",
    "Symbol": "IRBT",
    " marketcap ": " $294 474 752 ",
    "price (USD)": "\u043e\u043a\u0442.24",
    "country": "United States"
  },
  {
    "Rank": "6609",
    "Name": "Arwana Citramulia Tbk",
    "Symbol": "ARNA.JK",
    " marketcap ": " $294 096 328 ",
    "price (USD)": "0.0406402",
    "country": "Indonesia"
  },
  {
    "Rank": "6610",
    "Name": "Independent Petroleum Group K.S.C.P.",
    "Symbol": "IPG.KW",
    " marketcap ": " $294 045 684 ",
    "price (USD)": "1626.47",
    "country": "Kuwait"
  },
  {
    "Rank": "6611",
    "Name": "Regal Hotels International",
    "Symbol": "0078.HK",
    " marketcap ": " $293 690 466 ",
    "price (USD)": "0.326758",
    "country": "Hong Kong"
  },
  {
    "Rank": "6612",
    "Name": "AdTheorent",
    "Symbol": "ADTH",
    " marketcap ": " $293 347 008 ",
    "price (USD)": "\u043c\u0430\u0440.19",
    "country": "United States"
  },
  {
    "Rank": "6613",
    "Name": "Park Aerospace",
    "Symbol": "PKE",
    " marketcap ": " $293 066 688 ",
    "price (USD)": "14.47",
    "country": "United States"
  },
  {
    "Rank": "6614",
    "Name": "James River Group",
    "Symbol": "JRVR",
    " marketcap ": " $292 771 680 ",
    "price (USD)": "\u0438\u044e\u043b.74",
    "country": "Bermuda"
  },
  {
    "Rank": "6615",
    "Name": "RE/MAX Holdings",
    "Symbol": "RMAX",
    " marketcap ": " $292 764 480 ",
    "price (USD)": "\u0441\u0435\u043d.32",
    "country": "United States"
  },
  {
    "Rank": "6616",
    "Name": "Gencor Industries",
    "Symbol": "GENC",
    " marketcap ": " $292 567 680 ",
    "price (USD)": "19.96",
    "country": "United States"
  },
  {
    "Rank": "6617",
    "Name": "Sanghi Industries",
    "Symbol": "SANGHIIND.NS",
    " marketcap ": " $292 508 311 ",
    "price (USD)": "1.12944",
    "country": "India"
  },
  {
    "Rank": "6618",
    "Name": "Gulf Pharmaceutical Industries",
    "Symbol": "JULPHAR.AE",
    " marketcap ": " $292 211 898 ",
    "price (USD)": "0.25",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6619",
    "Name": "Methanol Chemicals Company",
    "Symbol": "2001.SR",
    " marketcap ": " $291 089 585 ",
    "price (USD)": "4.31244",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6620",
    "Name": "Group Five Pipe Saudi Company",
    "Symbol": "9523.SR",
    " marketcap ": " $291 036 230 ",
    "price (USD)": "\u043e\u043a\u0442.42",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6621",
    "Name": "Inozyme Pharma",
    "Symbol": "INZY",
    " marketcap ": " $290 720 832 ",
    "price (USD)": "04.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6622",
    "Name": "Financial Institutions",
    "Symbol": "FISI",
    " marketcap ": " $290 247 264 ",
    "price (USD)": "18.79",
    "country": "United States"
  },
  {
    "Rank": "6623",
    "Name": "Traeger",
    "Symbol": "COOK",
    " marketcap ": " $289 957 504 ",
    "price (USD)": "\u0444\u0435\u0432.25",
    "country": "United States"
  },
  {
    "Rank": "6624",
    "Name": "Aquestive Therapeutics",
    "Symbol": "AQST",
    " marketcap ": " $289 502 432 ",
    "price (USD)": "\u043c\u0430\u0440.18",
    "country": "United States"
  },
  {
    "Rank": "6625",
    "Name": "Penseco Financial Services",
    "Symbol": "PFIS",
    " marketcap ": " $289 347 648 ",
    "price (USD)": "41",
    "country": "United States"
  },
  {
    "Rank": "6626",
    "Name": "Forafric Global PLC",
    "Symbol": "AFRI",
    " marketcap ": " $289 220 192 ",
    "price (USD)": "\u043e\u043a\u0442.76",
    "country": "Gibraltar"
  },
  {
    "Rank": "6627",
    "Name": "Telos",
    "Symbol": "TLS",
    " marketcap ": " $289 184 768 ",
    "price (USD)": "04.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6628",
    "Name": "Cellectis",
    "Symbol": "CLLS",
    " marketcap ": " $289 092 928 ",
    "price (USD)": "\u0444\u0435\u0432.95",
    "country": "France"
  },
  {
    "Rank": "6629",
    "Name": "Gold Royalty Corp",
    "Symbol": "GROY",
    " marketcap ": " $288 891 872 ",
    "price (USD)": "\u044f\u043d\u0432.98",
    "country": "Canada"
  },
  {
    "Rank": "6630",
    "Name": "Novonix",
    "Symbol": "NVX",
    " marketcap ": " $288 479 296 ",
    "price (USD)": "\u0444\u0435\u0432.36",
    "country": "Australia"
  },
  {
    "Rank": "6631",
    "Name": "AMMO",
    "Symbol": "POWW",
    " marketcap ": " $288 346 240 ",
    "price (USD)": "\u0444\u0435\u0432.43",
    "country": "United States"
  },
  {
    "Rank": "6632",
    "Name": "Mobile-health Network Solutions",
    "Symbol": "MNDR",
    " marketcap ": " $288 066 592 ",
    "price (USD)": "01.\u0430\u0432\u0433",
    "country": "Singapore"
  },
  {
    "Rank": "6633",
    "Name": "Poseida Therapeutics",
    "Symbol": "PSTX",
    " marketcap ": " $287 964 064 ",
    "price (USD)": "\u0444\u0435\u0432.97",
    "country": "United States"
  },
  {
    "Rank": "6634",
    "Name": "Vasta Platform",
    "Symbol": "VSTA",
    " marketcap ": " $287 771 744 ",
    "price (USD)": "03.\u0438\u044e\u043d",
    "country": "Brazil"
  },
  {
    "Rank": "6635",
    "Name": "Alta Equipment Group",
    "Symbol": "ALTG",
    " marketcap ": " $287 716 832 ",
    "price (USD)": "\u0430\u0432\u0433.68",
    "country": "United States"
  },
  {
    "Rank": "6636",
    "Name": "CPI Card Group",
    "Symbol": "PMTS",
    " marketcap ": " $287 627 872 ",
    "price (USD)": "25.86",
    "country": "United States"
  },
  {
    "Rank": "6637",
    "Name": "Commercial Facilities Company S.A.K.P.",
    "Symbol": "FACIL.KW",
    " marketcap ": " $287 367 145 ",
    "price (USD)": "567.145",
    "country": "Kuwait"
  },
  {
    "Rank": "6638",
    "Name": "Gran Tierra Energy",
    "Symbol": "GTE",
    " marketcap ": " $287 316 288 ",
    "price (USD)": "\u0441\u0435\u043d.17",
    "country": "Canada"
  },
  {
    "Rank": "6639",
    "Name": "Orrstown Financial Services",
    "Symbol": "ORRF",
    " marketcap ": " $287 314 752 ",
    "price (USD)": "26.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6640",
    "Name": "First Business Financial Services",
    "Symbol": "FBIZ",
    " marketcap ": " $287 286 688 ",
    "price (USD)": "34.66",
    "country": "United States"
  },
  {
    "Rank": "6641",
    "Name": "Kingfa Science & Technology",
    "Symbol": "KINGFA.NS",
    " marketcap ": " $285 266 476 ",
    "price (USD)": "23.5501",
    "country": "India"
  },
  {
    "Rank": "6642",
    "Name": "Khaleeji Bank",
    "Symbol": "KHALEEJI.BH",
    " marketcap ": " $284 859 066 ",
    "price (USD)": "3.28912",
    "country": "Bahrain"
  },
  {
    "Rank": "6643",
    "Name": "Inovio Pharmaceuticals",
    "Symbol": "INO",
    " marketcap ": " $284 758 592 ",
    "price (USD)": "\u043e\u043a\u0442.99",
    "country": "United States"
  },
  {
    "Rank": "6644",
    "Name": "Nyxoah",
    "Symbol": "NYXH",
    " marketcap ": " $284 630 272 ",
    "price (USD)": "\u0441\u0435\u043d.03",
    "country": "Belgium"
  },
  {
    "Rank": "6645",
    "Name": "Mo-BRUK S.A.",
    "Symbol": "MBR.WA",
    " marketcap ": " $284 389 057 ",
    "price (USD)": "82.3629",
    "country": "Poland"
  },
  {
    "Rank": "6646",
    "Name": "Mahanagar Telephone Nigam",
    "Symbol": "MTNL.NS",
    " marketcap ": " $283 105 257 ",
    "price (USD)": "0.449373",
    "country": "India"
  },
  {
    "Rank": "6647",
    "Name": "Vidhi Specialty Food",
    "Symbol": "VIDHIING.NS",
    " marketcap ": " $282 949 861 ",
    "price (USD)": "5.66523",
    "country": "India"
  },
  {
    "Rank": "6648",
    "Name": "Opthea",
    "Symbol": "OPT",
    " marketcap ": " $282 939 232 ",
    "price (USD)": "\u043c\u0430\u0440.39",
    "country": "Australia"
  },
  {
    "Rank": "6649",
    "Name": "Nathan's Famous",
    "Symbol": "NATH",
    " marketcap ": " $282 859 936 ",
    "price (USD)": "69.25",
    "country": "United States"
  },
  {
    "Rank": "6650",
    "Name": "Kyokuyo",
    "Symbol": "1301.T",
    " marketcap ": " $282 670 988 ",
    "price (USD)": "23.7989",
    "country": "Japan"
  },
  {
    "Rank": "6651",
    "Name": "Tile Shop Holdings",
    "Symbol": "TTSH",
    " marketcap ": " $282 296 128 ",
    "price (USD)": "\u0438\u044e\u043d.34",
    "country": "United States"
  },
  {
    "Rank": "6652",
    "Name": "Remedy Entertainment",
    "Symbol": "REMEDY.HE",
    " marketcap ": " $282 268 199 ",
    "price (USD)": "20.8275",
    "country": "Finland"
  },
  {
    "Rank": "6653",
    "Name": "orion-group-holdings",
    "Symbol": "ORN",
    " marketcap ": " $281 902 752 ",
    "price (USD)": "\u0430\u0432\u0433.58",
    "country": "United States"
  },
  {
    "Rank": "6654",
    "Name": "Sasken Technologies",
    "Symbol": "SASKEN.NS",
    " marketcap ": " $281 615 131 ",
    "price (USD)": "18.6736",
    "country": "India"
  },
  {
    "Rank": "6655",
    "Name": "Weyco Group",
    "Symbol": "WEYS",
    " marketcap ": " $281 481 728 ",
    "price (USD)": "29.63",
    "country": "United States"
  },
  {
    "Rank": "6656",
    "Name": "Atai Life Sciences",
    "Symbol": "ATAI",
    " marketcap ": " $281 242 080 ",
    "price (USD)": "\u044f\u043d\u0432.68",
    "country": "Germany"
  },
  {
    "Rank": "6657",
    "Name": "Regional Management",
    "Symbol": "RM",
    " marketcap ": " $280 755 200 ",
    "price (USD)": "28.37",
    "country": "United States"
  },
  {
    "Rank": "6658",
    "Name": "Marathon Gold",
    "Symbol": "MOZ.TO",
    " marketcap ": " $280 624 759 ",
    "price (USD)": "0.6",
    "country": "Canada"
  },
  {
    "Rank": "6659",
    "Name": "KCP Limited",
    "Symbol": "KCP.NS",
    " marketcap ": " $280 374 180 ",
    "price (USD)": "2.17478",
    "country": "India"
  },
  {
    "Rank": "6660",
    "Name": "Combined Group Contracting Company",
    "Symbol": "CGC.KW",
    " marketcap ": " $280 138 957 ",
    "price (USD)": "1649.28",
    "country": "Kuwait"
  },
  {
    "Rank": "6661",
    "Name": "Domo",
    "Symbol": "DOMO",
    " marketcap ": " $279 436 608 ",
    "price (USD)": "\u0438\u044e\u043b.32",
    "country": "United States"
  },
  {
    "Rank": "6662",
    "Name": "Cormedix",
    "Symbol": "CRMD",
    " marketcap ": " $279 193 248 ",
    "price (USD)": "05.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6663",
    "Name": "Citizens &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6664",
    "Name": "Bank7",
    "Symbol": "BSVN",
    " marketcap ": " $278 178 624 ",
    "price (USD)": "30.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6665",
    "Name": "TrueCar",
    "Symbol": "TRUE",
    " marketcap ": " $277 754 336 ",
    "price (USD)": "03.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6666",
    "Name": "Orange County Bancorp",
    "Symbol": "OBT",
    " marketcap ": " $277 385 248 ",
    "price (USD)": "49.03",
    "country": "United States"
  },
  {
    "Rank": "6667",
    "Name": "Connexa Sports Technologies",
    "Symbol": "CNXA",
    " marketcap ": " $277 086 016 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "6668",
    "Name": "ASP Isotopes",
    "Symbol": "ASPI",
    " marketcap ": " $276 930 976 ",
    "price (USD)": "\u043c\u0430\u0439.35",
    "country": "United States"
  },
  {
    "Rank": "6669",
    "Name": "Red Violet",
    "Symbol": "RDVT",
    " marketcap ": " $276 669 568 ",
    "price (USD)": "20.15",
    "country": "United States"
  },
  {
    "Rank": "6670",
    "Name": "Corby Spirit and Wine",
    "Symbol": "CSW-A.TO",
    " marketcap ": " $276 576 637 ",
    "price (USD)": "9.83174",
    "country": "Canada"
  },
  {
    "Rank": "6671",
    "Name": "Prosperity Real Estate Investment Trust",
    "Symbol": "0808.HK",
    " marketcap ": " $276 471 950 ",
    "price (USD)": "0.180678",
    "country": "Hong Kong"
  },
  {
    "Rank": "6672",
    "Name": "Stitch Fix",
    "Symbol": "SFIX",
    " marketcap ": " $276 395 584 ",
    "price (USD)": "02.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6673",
    "Name": "Unity Bancorp",
    "Symbol": "UNTY",
    " marketcap ": " $276 075 264 ",
    "price (USD)": "27.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "6674",
    "Name": "Adaptimmune Therapeutics",
    "Symbol": "ADAP",
    " marketcap ": " $276 006 976 ",
    "price (USD)": "01.\u0430\u0432\u0433",
    "country": "United Kingdom"
  },
  {
    "Rank": "6675",
    "Name": "GE Power India",
    "Symbol": "GEPIL.NS",
    " marketcap ": " $275 988 428 ",
    "price (USD)": "4.08521",
    "country": "India"
  },
  {
    "Rank": "6676",
    "Name": "Euroseas",
    "Symbol": "ESEA",
    " marketcap ": " $275 873 600 ",
    "price (USD)": "39.33",
    "country": "Greece"
  },
  {
    "Rank": "6677",
    "Name": "Sterling Bancorp",
    "Symbol": "SBT",
    " marketcap ": " $275 737 824 ",
    "price (USD)": "05.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6678",
    "Name": "Bonduelle",
    "Symbol": "BON.PA",
    " marketcap ": " $275 543 386 ",
    "price (USD)": "\u0430\u0432\u0433.31",
    "country": "France"
  },
  {
    "Rank": "6679",
    "Name": "Priority Technology Holdings",
    "Symbol": "PRTH",
    " marketcap ": " $275 423 968 ",
    "price (USD)": "\u043c\u0430\u0440.44",
    "country": "United States"
  },
  {
    "Rank": "6680",
    "Name": "Rocky Brands",
    "Symbol": "RCKY",
    " marketcap ": " $275 399 968 ",
    "price (USD)": "37.1",
    "country": "United States"
  },
  {
    "Rank": "6681",
    "Name": "Huhtamaki India",
    "Symbol": "HUHTAMAKI.NS",
    " marketcap ": " $275 266 078 ",
    "price (USD)": "3.64485",
    "country": "India"
  },
  {
    "Rank": "6682",
    "Name": "FREYR Battery",
    "Symbol": "FREY",
    " marketcap ": " $275 218 848 ",
    "price (USD)": "\u044f\u043d\u0432.97",
    "country": "Luxembourg"
  },
  {
    "Rank": "6683",
    "Name": "The Honest Company",
    "Symbol": "HNST",
    " marketcap ": " $275 199 168 ",
    "price (USD)": "\u0444\u0435\u0432.79",
    "country": "United States"
  },
  {
    "Rank": "6684",
    "Name": "Intuitive Machines",
    "Symbol": "LUNR",
    " marketcap ": " $275 064 320 ",
    "price (USD)": "05.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "6685",
    "Name": "ESSA Pharma",
    "Symbol": "EPIX",
    " marketcap ": " $275 050 592 ",
    "price (USD)": "06.\u0444\u0435\u0432",
    "country": "Canada"
  },
  {
    "Rank": "6686",
    "Name": "Pexip",
    "Symbol": "PEXIP.OL",
    " marketcap ": " $274 662 947 ",
    "price (USD)": "2.69708",
    "country": "Norway"
  },
  {
    "Rank": "6687",
    "Name": "First Internet Bancorp",
    "Symbol": "INBK",
    " marketcap ": " $274 650 112 ",
    "price (USD)": "31.73",
    "country": "United States"
  },
  {
    "Rank": "6688",
    "Name": "Backblaze",
    "Symbol": "BLZE",
    " marketcap ": " $274 115 392 ",
    "price (USD)": "\u0438\u044e\u043d.61",
    "country": "United States"
  },
  {
    "Rank": "6689",
    "Name": "Foseco India",
    "Symbol": "FOSECOIND.NS",
    " marketcap ": " $274 022 247 ",
    "price (USD)": "42.9068",
    "country": "India"
  },
  {
    "Rank": "6690",
    "Name": "ACNB Corporation",
    "Symbol": "ACNB",
    " marketcap ": " $273 351 936 ",
    "price (USD)": "32.01",
    "country": "United States"
  },
  {
    "Rank": "6691",
    "Name": "First Bancorp",
    "Symbol": "FNLC",
    " marketcap ": " $273 066 976 ",
    "price (USD)": "24.52",
    "country": "United States"
  },
  {
    "Rank": "6692",
    "Name": "Viemed Healthcare",
    "Symbol": "VMD",
    " marketcap ": " $272 910 240 ",
    "price (USD)": "07.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6693",
    "Name": "P3 Health Partners",
    "Symbol": "PIII",
    " marketcap ": " $272 799 168 ",
    "price (USD)": "0.5321",
    "country": "United States"
  },
  {
    "Rank": "6694",
    "Name": "MISTRAS Group",
    "Symbol": "MG",
    " marketcap ": " $272 199 936 ",
    "price (USD)": "\u0430\u0432\u0433.79",
    "country": "United States"
  },
  {
    "Rank": "6695",
    "Name": "Kuwait Portland Cement",
    "Symbol": "PCEM.KW",
    " marketcap ": " $272 112 412 ",
    "price (USD)": "2715.12",
    "country": "Kuwait"
  },
  {
    "Rank": "6696",
    "Name": "Sera Prognostics",
    "Symbol": "SERA",
    " marketcap ": " $272 006 144 ",
    "price (USD)": "\u0430\u0432\u0433.33",
    "country": "United States"
  },
  {
    "Rank": "6697",
    "Name": "Sanara MedTech",
    "Symbol": "SMTI",
    " marketcap ": " $271 780 064 ",
    "price (USD)": "31.51",
    "country": "United States"
  },
  {
    "Rank": "6698",
    "Name": "Jindal Poly Films",
    "Symbol": "JINDALPOLY.NS",
    " marketcap ": " $271 760 926 ",
    "price (USD)": "6.20592",
    "country": "India"
  },
  {
    "Rank": "6699",
    "Name": "Sight Sciences",
    "Symbol": "SGHT",
    " marketcap ": " $271 669 408 ",
    "price (USD)": "\u043c\u0430\u0439.46",
    "country": "United States"
  },
  {
    "Rank": "6700",
    "Name": "Lucas GC",
    "Symbol": "LGCL",
    " marketcap ": " $271 562 048 ",
    "price (USD)": "\u043c\u0430\u0440.35",
    "country": "China"
  },
  {
    "Rank": "6701",
    "Name": "Emergent BioSolutions",
    "Symbol": "EBS",
    " marketcap ": " $271 441 312 ",
    "price (USD)": "\u043c\u0430\u0439.18",
    "country": "United States"
  },
  {
    "Rank": "6702",
    "Name": "OPTiM",
    "Symbol": "3694.T",
    " marketcap ": " $271 270 450 ",
    "price (USD)": "4.92611",
    "country": "Japan"
  },
  {
    "Rank": "6703",
    "Name": "Grindrod Shipping",
    "Symbol": "GRIN",
    " marketcap ": " $270 676 992 ",
    "price (USD)": "13.75",
    "country": "Singapore"
  },
  {
    "Rank": "6704",
    "Name": "UmweltBank",
    "Symbol": "UBK.DE",
    " marketcap ": " $270 173 700 ",
    "price (USD)": "7.49267",
    "country": "Germany"
  },
  {
    "Rank": "6705",
    "Name": "Federal-Mogul Goetze",
    "Symbol": "FMGOETZE.NS",
    " marketcap ": " $270 045 888 ",
    "price (USD)": "4.82295",
    "country": "India"
  },
  {
    "Rank": "6706",
    "Name": "Cybin",
    "Symbol": "CYBN",
    " marketcap ": " $269 614 720 ",
    "price (USD)": "0.3549",
    "country": "Canada"
  },
  {
    "Rank": "6707",
    "Name": "Allego",
    "Symbol": "ALLG",
    " marketcap ": " $269 601 728 ",
    "price (USD)": "0.9948",
    "country": "Netherlands"
  },
  {
    "Rank": "6708",
    "Name": "Air Asia Company Limited (AACL)",
    "Symbol": "2630.TW",
    " marketcap ": " $269 209 701 ",
    "price (USD)": "1.28539",
    "country": "Taiwan"
  },
  {
    "Rank": "6709",
    "Name": "Astec Lifesciences",
    "Symbol": "ASTEC.NS",
    " marketcap ": " $268 611 671 ",
    "price (USD)": "13.6975",
    "country": "India"
  },
  {
    "Rank": "6710",
    "Name": "Dakota Gold",
    "Symbol": "DC",
    " marketcap ": " $268 387 408 ",
    "price (USD)": "03.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "6711",
    "Name": "Valens Semiconductor",
    "Symbol": "VLN",
    " marketcap ": " $268 288 048 ",
    "price (USD)": "\u0444\u0435\u0432.55",
    "country": "Israel"
  },
  {
    "Rank": "6712",
    "Name": "CommScope",
    "Symbol": "COMM",
    " marketcap ": " $267 469 008 ",
    "price (USD)": "\u044f\u043d\u0432.26",
    "country": "United States"
  },
  {
    "Rank": "6713",
    "Name": "Parag Milk Foods",
    "Symbol": "PARAGMILK.NS",
    " marketcap ": " $267 468 509 ",
    "price (USD)": "2.24386",
    "country": "India"
  },
  {
    "Rank": "6714",
    "Name": "MacroGenics",
    "Symbol": "MGNX",
    " marketcap ": " $266 818 720 ",
    "price (USD)": "\u0430\u043f\u0440.26",
    "country": "United States"
  },
  {
    "Rank": "6715",
    "Name": "Medifast",
    "Symbol": "MED",
    " marketcap ": " $266 758 304 ",
    "price (USD)": "24.39",
    "country": "United States"
  },
  {
    "Rank": "6716",
    "Name": "Agora.io",
    "Symbol": "API",
    " marketcap ": " $266 543 728 ",
    "price (USD)": "\u0444\u0435\u0432.92",
    "country": "China"
  },
  {
    "Rank": "6717",
    "Name": "Primis Financial",
    "Symbol": "FRST",
    " marketcap ": " $266 439 632 ",
    "price (USD)": "\u043e\u043a\u0442.79",
    "country": "United States"
  },
  {
    "Rank": "6718",
    "Name": "IBEX",
    "Symbol": "IBEX",
    " marketcap ": " $266 306 768 ",
    "price (USD)": "15.47",
    "country": "United States"
  },
  {
    "Rank": "6719",
    "Name": "XBiotech",
    "Symbol": "XBIT",
    " marketcap ": " $266 198 544 ",
    "price (USD)": "\u0430\u0432\u0433.74",
    "country": "United States"
  },
  {
    "Rank": "6720",
    "Name": "StealthGas",
    "Symbol": "GASS",
    " marketcap ": " $266 188 336 ",
    "price (USD)": "\u0438\u044e\u043b.35",
    "country": "Greece"
  },
  {
    "Rank": "6721",
    "Name": "Axogen",
    "Symbol": "AXGN",
    " marketcap ": " $266 161 024 ",
    "price (USD)": "06.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6722",
    "Name": "Metagenomi",
    "Symbol": "MGX",
    " marketcap ": " $265 995 824 ",
    "price (USD)": "07.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "6723",
    "Name": "Industrial Logistics Properties Trust",
    "Symbol": "ILPT",
    " marketcap ": " $265 959 264 ",
    "price (USD)": "04.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "6724",
    "Name": "Bank of Marin Bancorp",
    "Symbol": "BMRC",
    " marketcap ": " $265 947 120 ",
    "price (USD)": "16.33",
    "country": "United States"
  },
  {
    "Rank": "6725",
    "Name": "ON24",
    "Symbol": "ONTF",
    " marketcap ": " $265 845 280 ",
    "price (USD)": "\u0438\u044e\u043d.35",
    "country": "United States"
  },
  {
    "Rank": "6726",
    "Name": "Rani Therapeutics",
    "Symbol": "RANI",
    " marketcap ": " $265 645 472 ",
    "price (USD)": "\u043c\u0430\u0439.14",
    "country": "United States"
  },
  {
    "Rank": "6727",
    "Name": "Heritage Insurance",
    "Symbol": "HRTG",
    " marketcap ": " $265 618 464 ",
    "price (USD)": "\u0430\u0432\u0433.67",
    "country": "United States"
  },
  {
    "Rank": "6728",
    "Name": "Seanergy Maritime",
    "Symbol": "SHIP",
    " marketcap ": " $265 564 560 ",
    "price (USD)": "\u0434\u0435\u043a.78",
    "country": "Greece"
  },
  {
    "Rank": "6729",
    "Name": "Pico Far East Holdings",
    "Symbol": "0752.HK",
    " marketcap ": " $265 167 303 ",
    "price (USD)": "0.213995",
    "country": "Hong Kong"
  },
  {
    "Rank": "6730",
    "Name": "Taiga Building Products",
    "Symbol": "TBL.TO",
    " marketcap ": " $265 123 900 ",
    "price (USD)": "\u0444\u0435\u0432.61",
    "country": "Canada"
  },
  {
    "Rank": "6731",
    "Name": "Foghorn Therapeutics",
    "Symbol": "FHTX",
    " marketcap ": " $264 882 416 ",
    "price (USD)": "\u0438\u044e\u043d.22",
    "country": "United States"
  },
  {
    "Rank": "6732",
    "Name": "Enanta Pharmaceuticals",
    "Symbol": "ENTA",
    " marketcap ": " $264 107 120 ",
    "price (USD)": "\u0434\u0435\u043a.47",
    "country": "United States"
  },
  {
    "Rank": "6733",
    "Name": "Actinium Pharmaceuticals",
    "Symbol": "ATNM",
    " marketcap ": " $263 881 792 ",
    "price (USD)": "\u0430\u0432\u0433.86",
    "country": "United States"
  },
  {
    "Rank": "6734",
    "Name": "Invivyd",
    "Symbol": "IVVD",
    " marketcap ": " $263 688 368 ",
    "price (USD)": "\u0444\u0435\u0432.21",
    "country": "United States"
  },
  {
    "Rank": "6735",
    "Name": "International Financial Advisors Holding",
    "Symbol": "IFA.KW",
    " marketcap ": " $263 262 686 ",
    "price (USD)": "1056.06",
    "country": "Kuwait"
  },
  {
    "Rank": "6736",
    "Name": "Monte Rosa Therapeutics",
    "Symbol": "GLUE",
    " marketcap ": " $262 641 408 ",
    "price (USD)": "4.295",
    "country": "United States"
  },
  {
    "Rank": "6737",
    "Name": "K-Bro Linen",
    "Symbol": "KBL.TO",
    " marketcap ": " $261 444 563 ",
    "price (USD)": "25.0009",
    "country": "Canada"
  },
  {
    "Rank": "6738",
    "Name": "Mama's Creations",
    "Symbol": "MAMA",
    " marketcap ": " $260 902 560 ",
    "price (USD)": "\u0438\u044e\u043d.96",
    "country": "United States"
  },
  {
    "Rank": "6739",
    "Name": "Clarus",
    "Symbol": "CLAR",
    " marketcap ": " $260 810 736 ",
    "price (USD)": "\u0438\u044e\u043d.81",
    "country": "United States"
  },
  {
    "Rank": "6740",
    "Name": "Gulf Hotels Group",
    "Symbol": "GHG.BH",
    " marketcap ": " $260 763 302 ",
    "price (USD)": "0.251989",
    "country": "Bahrain"
  },
  {
    "Rank": "6741",
    "Name": "Kamux",
    "Symbol": "KAMUX.HE",
    " marketcap ": " $260 655 741 ",
    "price (USD)": "6.53708",
    "country": "Finland"
  },
  {
    "Rank": "6742",
    "Name": "kneat.com",
    "Symbol": "FOBK.F",
    " marketcap ": " $260 112 846 ",
    "price (USD)": "2.99707",
    "country": "Ireland"
  },
  {
    "Rank": "6743",
    "Name": "Red Sea International Company",
    "Symbol": "4230.SR",
    " marketcap ": " $259 799 779 ",
    "price (USD)": "8.59285",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6744",
    "Name": "Dynamic Materials Corporation",
    "Symbol": "BOOM",
    " marketcap ": " $259 767 296 ",
    "price (USD)": "13",
    "country": "United States"
  },
  {
    "Rank": "6745",
    "Name": "Slam Corp",
    "Symbol": "SLAM",
    " marketcap ": " $259 624 704 ",
    "price (USD)": "11.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6746",
    "Name": "Ascend Wellness (AWH)",
    "Symbol": "AAWH",
    " marketcap ": " $259 526 848 ",
    "price (USD)": "\u044f\u043d\u0432.21",
    "country": "United States"
  },
  {
    "Rank": "6747",
    "Name": "Paysign",
    "Symbol": "PAYS",
    " marketcap ": " $259 064 368 ",
    "price (USD)": "\u0430\u043f\u0440.89",
    "country": "United States"
  },
  {
    "Rank": "6748",
    "Name": "Potbelly Corporation",
    "Symbol": "PBPB",
    " marketcap ": " $259 024 224 ",
    "price (USD)": "\u0430\u0432\u0433.68",
    "country": "United States"
  },
  {
    "Rank": "6749",
    "Name": "AFC Gamma",
    "Symbol": "AFCG",
    " marketcap ": " $257 925 392 ",
    "price (USD)": "\u0434\u0435\u043a.48",
    "country": "United States"
  },
  {
    "Rank": "6750",
    "Name": "Hyliion",
    "Symbol": "HYLN",
    " marketcap ": " $257 573 280 ",
    "price (USD)": "\u044f\u043d\u0432.48",
    "country": "United States"
  },
  {
    "Rank": "6751",
    "Name": "Nouveau Monde Graphite",
    "Symbol": "NMG",
    " marketcap ": " $256 659 744 ",
    "price (USD)": "\u0444\u0435\u0432.25",
    "country": "Canada"
  },
  {
    "Rank": "6752",
    "Name": "World Holdings",
    "Symbol": "2429.T",
    " marketcap ": " $256 589 339 ",
    "price (USD)": "14.5864",
    "country": "Japan"
  },
  {
    "Rank": "6753",
    "Name": "Nat Games (Nexon Games)",
    "Symbol": "225570.KQ",
    " marketcap ": " $256 323 454 ",
    "price (USD)": "\u043e\u043a\u0442.55",
    "country": "South Korea"
  },
  {
    "Rank": "6754",
    "Name": "Takween Advanced Industries",
    "Symbol": "1201.SR",
    " marketcap ": " $256 289 967 ",
    "price (USD)": "3.35175",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6755",
    "Name": "Amplify Energy",
    "Symbol": "AMPY",
    " marketcap ": " $256 289 632 ",
    "price (USD)": "\u0438\u044e\u043d.47",
    "country": "United States"
  },
  {
    "Rank": "6756",
    "Name": "23andMe",
    "Symbol": "ME",
    " marketcap ": " $255 945 984 ",
    "price (USD)": "0.53",
    "country": "United States"
  },
  {
    "Rank": "6757",
    "Name": "Eik fasteignaf\u0413\u00a9lag",
    "Symbol": "EIK.IC",
    " marketcap ": " $255 851 411 ",
    "price (USD)": "0.0749186",
    "country": "Iceland"
  },
  {
    "Rank": "6758",
    "Name": "Quad",
    "Symbol": "QUAD",
    " marketcap ": " $255 535 952 ",
    "price (USD)": "\u0430\u043f\u0440.92",
    "country": "United States"
  },
  {
    "Rank": "6759",
    "Name": "Rupa Company",
    "Symbol": "RUPA.NS",
    " marketcap ": " $254 740 160 ",
    "price (USD)": "3.20329",
    "country": "India"
  },
  {
    "Rank": "6760",
    "Name": "Acrivon Therapeutics",
    "Symbol": "ACRV",
    " marketcap ": " $253 499 344 ",
    "price (USD)": "\u0430\u0432\u0433.21",
    "country": "United States"
  },
  {
    "Rank": "6761",
    "Name": "Lifeway Foods",
    "Symbol": "LWAY",
    " marketcap ": " $253 408 496 ",
    "price (USD)": "17.23",
    "country": "United States"
  },
  {
    "Rank": "6762",
    "Name": "X-Legend Entertainment",
    "Symbol": "4994.TW",
    " marketcap ": " $253 206 745 ",
    "price (USD)": "3.81431",
    "country": "Taiwan"
  },
  {
    "Rank": "6763",
    "Name": "Jagran Prakashan",
    "Symbol": "JAGRAN.NS",
    " marketcap ": " $253 166 590 ",
    "price (USD)": "1.16068",
    "country": "India"
  },
  {
    "Rank": "6764",
    "Name": "HKR International",
    "Symbol": "0480.HK",
    " marketcap ": " $253 135 146 ",
    "price (USD)": "0.170427",
    "country": "Hong Kong"
  },
  {
    "Rank": "6765",
    "Name": "Sembcorp Salalah Power & Water Company",
    "Symbol": "SSPW.OM",
    " marketcap ": " $252 965 287 ",
    "price (USD)": "0.265004",
    "country": "Oman"
  },
  {
    "Rank": "6766",
    "Name": "Lifetime Brands",
    "Symbol": "LCUT",
    " marketcap ": " $252 960 016 ",
    "price (USD)": "\u043d\u043e\u044f.46",
    "country": "United States"
  },
  {
    "Rank": "6767",
    "Name": "E. W. Scripps Company",
    "Symbol": "SSP",
    " marketcap ": " $252 754 400 ",
    "price (USD)": "\u0444\u0435\u0432.96",
    "country": "United States"
  },
  {
    "Rank": "6768",
    "Name": "American Vanguard",
    "Symbol": "AVD",
    " marketcap ": " $252 701 840 ",
    "price (USD)": "09.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6769",
    "Name": "GTL Infrastructure",
    "Symbol": "GTLINFRA.NS",
    " marketcap ": " $252 562 282 ",
    "price (USD)": "0.0192245",
    "country": "India"
  },
  {
    "Rank": "6770",
    "Name": "Restaurant Brands New Zealand",
    "Symbol": "RBD.NZ",
    " marketcap ": " $251 474 770 ",
    "price (USD)": "2.01568",
    "country": "New Zealand"
  },
  {
    "Rank": "6771",
    "Name": "Gulf Union Alahlia Cooperative Insurance",
    "Symbol": "8120.SR",
    " marketcap ": " $251 072 890 ",
    "price (USD)": "5.47061",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6772",
    "Name": "\u0413\u2013KOWORLD",
    "Symbol": "VVV3.DE",
    " marketcap ": " $250 624 754 ",
    "price (USD)": "35.9431",
    "country": "Germany"
  },
  {
    "Rank": "6773",
    "Name": "National Petroleum Services Company",
    "Symbol": "NAPESCO.KW",
    " marketcap ": " $250 290 352 ",
    "price (USD)": "2770.53",
    "country": "Kuwait"
  },
  {
    "Rank": "6774",
    "Name": "Atos",
    "Symbol": "ATO.PA",
    " marketcap ": " $249 677 924 ",
    "price (USD)": "2.21522",
    "country": "France"
  },
  {
    "Rank": "6775",
    "Name": "Waterstone Financial",
    "Symbol": "WSBF",
    " marketcap ": " $249 474 992 ",
    "price (USD)": "12.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6776",
    "Name": "Senseonics Holdings",
    "Symbol": "SENS",
    " marketcap ": " $249 410 240 ",
    "price (USD)": "0.4698",
    "country": "United States"
  },
  {
    "Rank": "6777",
    "Name": "Umm Al-Qura Cement Company",
    "Symbol": "3005.SR",
    " marketcap ": " $249 219 429 ",
    "price (USD)": "4.53126",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6778",
    "Name": "Fabasoft",
    "Symbol": "FAA.DE",
    " marketcap ": " $248 452 583 ",
    "price (USD)": "22.5866",
    "country": "Austria"
  },
  {
    "Rank": "6779",
    "Name": "Qatar General Insurance & Reinsurance Company",
    "Symbol": "QGRI.QA",
    " marketcap ": " $248 095 912 ",
    "price (USD)": "0.283516",
    "country": "Qatar"
  },
  {
    "Rank": "6780",
    "Name": "VersaBank",
    "Symbol": "VBNK",
    " marketcap ": " $247 738 976 ",
    "price (USD)": "\u0441\u0435\u043d.52",
    "country": "Canada"
  },
  {
    "Rank": "6781",
    "Name": "Codexis",
    "Symbol": "CDXS",
    " marketcap ": " $247 657 168 ",
    "price (USD)": "\u043c\u0430\u0440.51",
    "country": "United States"
  },
  {
    "Rank": "6782",
    "Name": "Nam Tai Property",
    "Symbol": "NTPIF",
    " marketcap ": " $247 397 296 ",
    "price (USD)": "\u0430\u043f\u0440.45",
    "country": "China"
  },
  {
    "Rank": "6783",
    "Name": "V\u0413\u040etryggingaf\u0413\u00a9lag \u0413\u040cslands",
    "Symbol": "VIS.IC",
    " marketcap ": " $247 374 736 ",
    "price (USD)": "0.12595",
    "country": "Iceland"
  },
  {
    "Rank": "6784",
    "Name": "Bank Mayapada Internasional",
    "Symbol": "MAYA.JK",
    " marketcap ": " $247 320 965 ",
    "price (USD)": "0.0203826",
    "country": "Indonesia"
  },
  {
    "Rank": "6785",
    "Name": "Barbeque Nation Hospitality",
    "Symbol": "BARBEQUE.NS",
    " marketcap ": " $247 274 102 ",
    "price (USD)": "6.31346",
    "country": "India"
  },
  {
    "Rank": "6786",
    "Name": "Radiant Logistics",
    "Symbol": "RLGT",
    " marketcap ": " $247 231 056 ",
    "price (USD)": "\u043c\u0430\u0439.26",
    "country": "United States"
  },
  {
    "Rank": "6787",
    "Name": "Porch Group",
    "Symbol": "PRCH",
    " marketcap ": " $246 975 136 ",
    "price (USD)": "\u0444\u0435\u0432.49",
    "country": "United States"
  },
  {
    "Rank": "6788",
    "Name": "Atlas Lithium",
    "Symbol": "ATLX",
    " marketcap ": " $246 009 248 ",
    "price (USD)": "16.62",
    "country": "United States"
  },
  {
    "Rank": "6789",
    "Name": "Blade Air Mobility",
    "Symbol": "BLDE",
    " marketcap ": " $245 960 288 ",
    "price (USD)": "\u043c\u0430\u0440.18",
    "country": "United States"
  },
  {
    "Rank": "6790",
    "Name": "National Finance",
    "Symbol": "NFCI.OM",
    " marketcap ": " $245 937 143 ",
    "price (USD)": "0.428683",
    "country": "Oman"
  },
  {
    "Rank": "6791",
    "Name": "Quantum-Si",
    "Symbol": "QSI",
    " marketcap ": " $245 341 680 ",
    "price (USD)": "\u044f\u043d\u0432.73",
    "country": "United States"
  },
  {
    "Rank": "6792",
    "Name": "Siyaram Silk Mills",
    "Symbol": "SIYSIL.NS",
    " marketcap ": " $245 282 798 ",
    "price (USD)": "5.39909",
    "country": "India"
  },
  {
    "Rank": "6793",
    "Name": "Easy Lease Motorcycle Rental",
    "Symbol": "EASYLEASE.AE",
    " marketcap ": " $244 887 957 ",
    "price (USD)": "\u0430\u0432\u0433.16",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6794",
    "Name": "Marvelous",
    "Symbol": "7844.T",
    " marketcap ": " $244 876 367 ",
    "price (USD)": "4.04965",
    "country": "Japan"
  },
  {
    "Rank": "6795",
    "Name": "The Joint Corp.",
    "Symbol": "JYNT",
    " marketcap ": " $244 823 264 ",
    "price (USD)": "16.35",
    "country": "United States"
  },
  {
    "Rank": "6796",
    "Name": "Boundless Bio",
    "Symbol": "BOLD",
    " marketcap ": " $244 576 944 ",
    "price (USD)": "\u043e\u043a\u0442.99",
    "country": "United States"
  },
  {
    "Rank": "6797",
    "Name": "National Cement Company P.S.C.",
    "Symbol": "NCC.AE",
    " marketcap ": " $244 234 487 ",
    "price (USD)": "0.680698",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6798",
    "Name": "Hindustan Sanitaryware &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6799",
    "Name": "Allgeier",
    "Symbol": "AEIN.DE",
    " marketcap ": " $243 575 077 ",
    "price (USD)": "21.2835",
    "country": "Germany"
  },
  {
    "Rank": "6800",
    "Name": "Shen Zhen Shengxunda Technology (gamexun)",
    "Symbol": "300518.SZ",
    " marketcap ": " $243 229 033 ",
    "price (USD)": "1.21973",
    "country": "China"
  },
  {
    "Rank": "6801",
    "Name": "Transcontinental Realty Investors",
    "Symbol": "TCI",
    " marketcap ": " $243 196 848 ",
    "price (USD)": "28.15",
    "country": "United States"
  },
  {
    "Rank": "6802",
    "Name": "Utah Medical Products",
    "Symbol": "UTMD",
    " marketcap ": " $242 509 008 ",
    "price (USD)": "68.73",
    "country": "United States"
  },
  {
    "Rank": "6803",
    "Name": "L'azurde Company for Jewelry",
    "Symbol": "4011.SR",
    " marketcap ": " $241 827 449 ",
    "price (USD)": "4.20569",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6804",
    "Name": "MVB Financial",
    "Symbol": "MVBF",
    " marketcap ": " $241 093 312 ",
    "price (USD)": "18.71",
    "country": "United States"
  },
  {
    "Rank": "6805",
    "Name": "Ranger Energy Services",
    "Symbol": "RNGR",
    " marketcap ": " $240 961 136 ",
    "price (USD)": "\u043e\u043a\u0442.53",
    "country": "United States"
  },
  {
    "Rank": "6806",
    "Name": "United Wire Factories Company",
    "Symbol": "1301.SR",
    " marketcap ": " $240 163 309 ",
    "price (USD)": "8.55282",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6807",
    "Name": "Ceragon Networks",
    "Symbol": "CRNT",
    " marketcap ": " $239 793 680 ",
    "price (USD)": "02.\u0430\u0432\u0433",
    "country": "Israel"
  },
  {
    "Rank": "6808",
    "Name": "Signature Bank",
    "Symbol": "SBNY",
    " marketcap ": " $239 301 200 ",
    "price (USD)": "03.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6809",
    "Name": "GoPro",
    "Symbol": "GPRO",
    " marketcap ": " $239 109 456 ",
    "price (USD)": "\u044f\u043d\u0432.57",
    "country": "United States"
  },
  {
    "Rank": "6810",
    "Name": "HIVE Blockchain Technologies",
    "Symbol": "HIVE",
    " marketcap ": " $239 090 912 ",
    "price (USD)": "\u0444\u0435\u0432.58",
    "country": "Canada"
  },
  {
    "Rank": "6811",
    "Name": "EMX Royalty",
    "Symbol": "EMX",
    " marketcap ": " $239 087 232 ",
    "price (USD)": "02.\u0434\u0435\u043a",
    "country": "Canada"
  },
  {
    "Rank": "6812",
    "Name": "Digital Turbine",
    "Symbol": "APPS",
    " marketcap ": " $238 729 136 ",
    "price (USD)": "\u0444\u0435\u0432.34",
    "country": "United States"
  },
  {
    "Rank": "6813",
    "Name": "ChromaDex",
    "Symbol": "CDXC",
    " marketcap ": " $238 702 608 ",
    "price (USD)": "\u043c\u0430\u0440.16",
    "country": "United States"
  },
  {
    "Rank": "6814",
    "Name": "Southern States Bancshares",
    "Symbol": "SSBK",
    " marketcap ": " $238 659 792 ",
    "price (USD)": "26.79",
    "country": "United States"
  },
  {
    "Rank": "6815",
    "Name": "Coherus BioSciences",
    "Symbol": "CHRS",
    " marketcap ": " $238 630 064 ",
    "price (USD)": "02.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6816",
    "Name": "Vera Bradley",
    "Symbol": "VRA",
    " marketcap ": " $238 366 752 ",
    "price (USD)": "\u0438\u044e\u043b.75",
    "country": "United States"
  },
  {
    "Rank": "6817",
    "Name": "Southern First Bancshares",
    "Symbol": "SFST",
    " marketcap ": " $238 158 416 ",
    "price (USD)": "29.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "6818",
    "Name": "NACCO Industries",
    "Symbol": "NC",
    " marketcap ": " $237 370 384 ",
    "price (USD)": "31.86",
    "country": "United States"
  },
  {
    "Rank": "6819",
    "Name": "Azerion Group",
    "Symbol": "AZRN.AS",
    " marketcap ": " $237 164 687 ",
    "price (USD)": "\u044f\u043d\u0432.85",
    "country": "Netherlands"
  },
  {
    "Rank": "6820",
    "Name": "GTPL Hathway",
    "Symbol": "GTPL.NS",
    " marketcap ": " $237 082 111 ",
    "price (USD)": "2.10809",
    "country": "India"
  },
  {
    "Rank": "6821",
    "Name": "Akebia Therapeutics",
    "Symbol": "AKBA",
    " marketcap ": " $236 843 472 ",
    "price (USD)": "\u044f\u043d\u0432.13",
    "country": "United States"
  },
  {
    "Rank": "6822",
    "Name": "G1 Therapeutics",
    "Symbol": "GTHX",
    " marketcap ": " $236 834 752 ",
    "price (USD)": "\u0430\u043f\u0440.53",
    "country": "United States"
  },
  {
    "Rank": "6823",
    "Name": "Performant Financial",
    "Symbol": "PFMT",
    " marketcap ": " $236 246 928 ",
    "price (USD)": "03.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6824",
    "Name": "Alpine Income Property Trust",
    "Symbol": "PINE",
    " marketcap ": " $235 623 472 ",
    "price (USD)": "15.87",
    "country": "United States"
  },
  {
    "Rank": "6825",
    "Name": "Pyxis Oncology",
    "Symbol": "PYXS",
    " marketcap ": " $235 554 000 ",
    "price (USD)": "4",
    "country": "United States"
  },
  {
    "Rank": "6826",
    "Name": "OptimizeRx",
    "Symbol": "OPRX",
    " marketcap ": " $235 497 728 ",
    "price (USD)": "\u0434\u0435\u043a.89",
    "country": "United States"
  },
  {
    "Rank": "6827",
    "Name": "Air Busan",
    "Symbol": "298690.KS",
    " marketcap ": " $235 448 275 ",
    "price (USD)": "2.01959",
    "country": "South Korea"
  },
  {
    "Rank": "6828",
    "Name": "Central Valley Community Bancorp",
    "Symbol": "CVCY",
    " marketcap ": " $235 332 512 ",
    "price (USD)": "19.89",
    "country": "United States"
  },
  {
    "Rank": "6829",
    "Name": "Rimini Street",
    "Symbol": "RMNI",
    " marketcap ": " $235 065 984 ",
    "price (USD)": "02.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "6830",
    "Name": "Dhofar International Development &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6831",
    "Name": "AngioDynamics",
    "Symbol": "ANGO",
    " marketcap ": " $234 719 376 ",
    "price (USD)": "\u043c\u0430\u0439.86",
    "country": "United States"
  },
  {
    "Rank": "6832",
    "Name": "Sify",
    "Symbol": "SIFY",
    " marketcap ": " $234 664 960 ",
    "price (USD)": "\u044f\u043d\u0432.28",
    "country": "India"
  },
  {
    "Rank": "6833",
    "Name": "Renaissance Services",
    "Symbol": "RNSS.OM",
    " marketcap ": " $234 628 787 ",
    "price (USD)": "0.992466",
    "country": "Oman"
  },
  {
    "Rank": "6834",
    "Name": "Innate Pharma",
    "Symbol": "IPHA",
    " marketcap ": " $234 441 808 ",
    "price (USD)": "02.\u0441\u0435\u043d",
    "country": "France"
  },
  {
    "Rank": "6835",
    "Name": "Aldeyra Therapeutics",
    "Symbol": "ALDX",
    " marketcap ": " $234 093 136 ",
    "price (USD)": "\u043c\u0430\u0440.94",
    "country": "United States"
  },
  {
    "Rank": "6836",
    "Name": "Design Therapeutics",
    "Symbol": "DSGN",
    " marketcap ": " $233 889 296 ",
    "price (USD)": "\u0430\u043f\u0440.14",
    "country": "United States"
  },
  {
    "Rank": "6837",
    "Name": "Agenus",
    "Symbol": "AGEN",
    " marketcap ": " $233 512 208 ",
    "price (USD)": "11.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "6838",
    "Name": "uniQure",
    "Symbol": "QURE",
    " marketcap ": " $233 037 136 ",
    "price (USD)": "04.\u0430\u0432\u0433",
    "country": "Netherlands"
  },
  {
    "Rank": "6839",
    "Name": "Outbrain",
    "Symbol": "OB",
    " marketcap ": " $232 980 160 ",
    "price (USD)": "\u0430\u043f\u0440.77",
    "country": "United States"
  },
  {
    "Rank": "6840",
    "Name": "Southland Holdings",
    "Symbol": "SLND",
    " marketcap ": " $232 924 640 ",
    "price (USD)": "\u0430\u043f\u0440.85",
    "country": "United States"
  },
  {
    "Rank": "6841",
    "Name": "Manazel",
    "Symbol": "MANAZEL.AE",
    " marketcap ": " $232 907 670 ",
    "price (USD)": "0.09",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6842",
    "Name": "Abu Dhabi Ship Building",
    "Symbol": "ADSB.AE",
    " marketcap ": " $232 615 721 ",
    "price (USD)": "01.\u044f\u043d\u0432",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6843",
    "Name": "Hong Leong Capital",
    "Symbol": "5274.KL",
    " marketcap ": " $232 595 977 ",
    "price (USD)": "0.986471",
    "country": "Malaysia"
  },
  {
    "Rank": "6844",
    "Name": "Inspired Entertainment",
    "Symbol": "INSE",
    " marketcap ": " $232 498 880 ",
    "price (USD)": "\u0430\u0432\u0433.75",
    "country": "United States"
  },
  {
    "Rank": "6845",
    "Name": "Civista Bancshares",
    "Symbol": "CIVB",
    " marketcap ": " $231 501 440 ",
    "price (USD)": "14.72",
    "country": "United States"
  },
  {
    "Rank": "6846",
    "Name": "Microvision",
    "Symbol": "MVIS",
    " marketcap ": " $231 459 200 ",
    "price (USD)": "01.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "6847",
    "Name": "Eshraq Investments",
    "Symbol": "ESHRAQ.AE",
    " marketcap ": " $231 042 658 ",
    "price (USD)": "0.09",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6848",
    "Name": "Cooper Standard",
    "Symbol": "CPS",
    " marketcap ": " $230 822 848 ",
    "price (USD)": "13.35",
    "country": "United States"
  },
  {
    "Rank": "6849",
    "Name": "Lion Electric",
    "Symbol": "LEV",
    " marketcap ": " $230 740 320 ",
    "price (USD)": "01.\u0444\u0435\u0432",
    "country": "Canada"
  },
  {
    "Rank": "6850",
    "Name": "Qingci Games",
    "Symbol": "6633.HK",
    " marketcap ": " $230 327 618 ",
    "price (USD)": "0.333165",
    "country": "China"
  },
  {
    "Rank": "6851",
    "Name": "PlaySide Studios",
    "Symbol": "PLY.AX",
    " marketcap ": " $230 256 417 ",
    "price (USD)": "0.563454",
    "country": "Australia"
  },
  {
    "Rank": "6852",
    "Name": "Arab Insurance Group",
    "Symbol": "ARIG.BH",
    " marketcap ": " $229 900 000 ",
    "price (USD)": "0.435",
    "country": "Bahrain"
  },
  {
    "Rank": "6853",
    "Name": "BayCom (United Business Bank)",
    "Symbol": "BCML",
    " marketcap ": " $229 465 312 ",
    "price (USD)": "20.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "6854",
    "Name": "Br\u0413\u0451drene A &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6855",
    "Name": "Acumen Pharmaceuticals",
    "Symbol": "ABOS",
    " marketcap ": " $228 904 032 ",
    "price (USD)": "\u043c\u0430\u0440.81",
    "country": "United States"
  },
  {
    "Rank": "6856",
    "Name": "Aaron's",
    "Symbol": "AAN",
    " marketcap ": " $228 772 480 ",
    "price (USD)": "\u0438\u044e\u043b.47",
    "country": "United States"
  },
  {
    "Rank": "6857",
    "Name": "NeuroPace",
    "Symbol": "NPCE",
    " marketcap ": " $228 706 384 ",
    "price (USD)": "\u0438\u044e\u043b.95",
    "country": "United States"
  },
  {
    "Rank": "6858",
    "Name": "ThredUp",
    "Symbol": "TDUP",
    " marketcap ": " $228 229 920 ",
    "price (USD)": "02.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "6859",
    "Name": "Hyderabad Industries Limited",
    "Symbol": "HIL.NS",
    " marketcap ": " $227 999 027 ",
    "price (USD)": "30.2162",
    "country": "India"
  },
  {
    "Rank": "6860",
    "Name": "Butterfly Network",
    "Symbol": "BFLY",
    " marketcap ": " $227 564 656 ",
    "price (USD)": "01.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "6861",
    "Name": "Los Andes Copper",
    "Symbol": "LA.V",
    " marketcap ": " $227 446 508 ",
    "price (USD)": "7.69823",
    "country": "Canada"
  },
  {
    "Rank": "6862",
    "Name": "Hallador Energy Company",
    "Symbol": "HNRG",
    " marketcap ": " $226 236 192 ",
    "price (USD)": "06.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "6863",
    "Name": "MT H\u0413\u0451jgaard Holding",
    "Symbol": "MTHH.CO",
    " marketcap ": " $226 203 939 ",
    "price (USD)": "29.3919",
    "country": "Denmark"
  },
  {
    "Rank": "6864",
    "Name": "Television Broadcasts (TVB)",
    "Symbol": "0511.HK",
    " marketcap ": " $225 737 061 ",
    "price (USD)": "0.515125",
    "country": "Hong Kong"
  },
  {
    "Rank": "6865",
    "Name": "Skel fj\u0413\u040erfestingaf\u0413\u00a9lag",
    "Symbol": "SKEL.IC",
    " marketcap ": " $225 621 447 ",
    "price (USD)": "0.11654",
    "country": "Iceland"
  },
  {
    "Rank": "6866",
    "Name": "Generation Bio",
    "Symbol": "GBIO",
    " marketcap ": " $225 532 640 ",
    "price (USD)": "\u043c\u0430\u0440.39",
    "country": "United States"
  },
  {
    "Rank": "6867",
    "Name": "2seventy bio",
    "Symbol": "TSVT",
    " marketcap ": " $225 155 664 ",
    "price (USD)": "\u0430\u043f\u0440.38",
    "country": "United States"
  },
  {
    "Rank": "6868",
    "Name": "Emirates Reem Investments Company",
    "Symbol": "ERC.AE",
    " marketcap ": " $224 703 134 ",
    "price (USD)": "0.70248",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6869",
    "Name": "Prelude Therapeutics",
    "Symbol": "PRLD",
    " marketcap ": " $224 662 080 ",
    "price (USD)": "04.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "6870",
    "Name": "Melbourne Enterprises",
    "Symbol": "0158.HK",
    " marketcap ": " $224 245 989 ",
    "price (USD)": "8.96984",
    "country": "Hong Kong"
  },
  {
    "Rank": "6871",
    "Name": "Phoenix Power Company",
    "Symbol": "PHPC.OM",
    " marketcap ": " $224 197 158 ",
    "price (USD)": "0.153287",
    "country": "Oman"
  },
  {
    "Rank": "6872",
    "Name": "Pure Cycle (water)",
    "Symbol": "PCYO",
    " marketcap ": " $224 024 912 ",
    "price (USD)": "09.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6873",
    "Name": "AirSculpt Technologies",
    "Symbol": "AIRS",
    " marketcap ": " $223 947 312 ",
    "price (USD)": "\u043c\u0430\u0440.89",
    "country": "United States"
  },
  {
    "Rank": "6874",
    "Name": "Merrimack Pharmaceuticals",
    "Symbol": "MACK",
    " marketcap ": " $223 748 496 ",
    "price (USD)": "15.13",
    "country": "United States"
  },
  {
    "Rank": "6875",
    "Name": "Forum Energy Technologies",
    "Symbol": "FET",
    " marketcap ": " $223 686 160 ",
    "price (USD)": "18.21",
    "country": "United States"
  },
  {
    "Rank": "6876",
    "Name": "NexPoint Diversified Real Estate Trust",
    "Symbol": "NXDT",
    " marketcap ": " $223 630 512 ",
    "price (USD)": "\u043c\u0430\u0439.64",
    "country": "United States"
  },
  {
    "Rank": "6877",
    "Name": "FriendTimes",
    "Symbol": "6820.HK",
    " marketcap ": " $223 564 273 ",
    "price (USD)": "0.102512",
    "country": "China"
  },
  {
    "Rank": "6878",
    "Name": "Saudi Printing and Packaging Company",
    "Symbol": "4270.SR",
    " marketcap ": " $223 520 935 ",
    "price (USD)": "3.72535",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6879",
    "Name": "908 Devices",
    "Symbol": "MASS",
    " marketcap ": " $223 464 096 ",
    "price (USD)": "\u0438\u044e\u043d.48",
    "country": "United States"
  },
  {
    "Rank": "6880",
    "Name": "Kingsway Financial Services",
    "Symbol": "KFS",
    " marketcap ": " $223 372 000 ",
    "price (USD)": "8",
    "country": "Canada"
  },
  {
    "Rank": "6881",
    "Name": "National General Insurance Company",
    "Symbol": "NGI.AE",
    " marketcap ": " $222 316 678 ",
    "price (USD)": "1.34778",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6882",
    "Name": "Perfect Corp.",
    "Symbol": "PERF",
    " marketcap ": " $222 030 832 ",
    "price (USD)": "\u0444\u0435\u0432.18",
    "country": "Taiwan"
  },
  {
    "Rank": "6883",
    "Name": "Raoom trading Company",
    "Symbol": "9529.SR",
    " marketcap ": " $221 492 808 ",
    "price (USD)": "35.4389",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6884",
    "Name": "The Original BARK Company",
    "Symbol": "BARK",
    " marketcap ": " $221 473 760 ",
    "price (USD)": "\u044f\u043d\u0432.25",
    "country": "United States"
  },
  {
    "Rank": "6885",
    "Name": "Arizona Metals",
    "Symbol": "AMC.TO",
    " marketcap ": " $221 312 136 ",
    "price (USD)": "1.86224",
    "country": "Canada"
  },
  {
    "Rank": "6886",
    "Name": "SWK Holdings",
    "Symbol": "SWKH",
    " marketcap ": " $221 140 960 ",
    "price (USD)": "17.73",
    "country": "United States"
  },
  {
    "Rank": "6887",
    "Name": "Gallantt Ispat",
    "Symbol": "GALLISPAT.NS",
    " marketcap ": " $221 113 575 ",
    "price (USD)": "0.78",
    "country": "India"
  },
  {
    "Rank": "6888",
    "Name": "RumbleON",
    "Symbol": "RMBL",
    " marketcap ": " $221 062 640 ",
    "price (USD)": "\u0438\u044e\u043d.27",
    "country": "United States"
  },
  {
    "Rank": "6889",
    "Name": "Tamil Nadu Newsprint and Papers Limited",
    "Symbol": "TNPL.NS",
    " marketcap ": " $220 785 811 ",
    "price (USD)": "3.18887",
    "country": "India"
  },
  {
    "Rank": "6890",
    "Name": "Ovid Therapeutics",
    "Symbol": "OVID",
    " marketcap ": " $220 637 696 ",
    "price (USD)": "03.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "6891",
    "Name": "American Realty Investors",
    "Symbol": "ARL",
    " marketcap ": " $220 636 320 ",
    "price (USD)": "13.66",
    "country": "United States"
  },
  {
    "Rank": "6892",
    "Name": "Rane Holdings",
    "Symbol": "RANEHOLDIN.NS",
    " marketcap ": " $220 444 974 ",
    "price (USD)": "15.4397",
    "country": "India"
  },
  {
    "Rank": "6893",
    "Name": "Koenig &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6894",
    "Name": "BMMI Group",
    "Symbol": "BMMI.BH",
    " marketcap ": " $219 448 621 ",
    "price (USD)": "2.77188",
    "country": "Bahrain"
  },
  {
    "Rank": "6895",
    "Name": "Ottakringer Getr\u0413\u00a4nke",
    "Symbol": "OTS.VI",
    " marketcap ": " $218 873 514 ",
    "price (USD)": "97.76",
    "country": "Austria"
  },
  {
    "Rank": "6896",
    "Name": "PCB Bancorp",
    "Symbol": "PCB",
    " marketcap ": " $218 283 568 ",
    "price (USD)": "15.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "6897",
    "Name": "Aker Horizons",
    "Symbol": "AKH.OL",
    " marketcap ": " $218 250 491 ",
    "price (USD)": "0.316145",
    "country": "Norway"
  },
  {
    "Rank": "6898",
    "Name": "Spire Global",
    "Symbol": "SPIR",
    " marketcap ": " $218 128 880 ",
    "price (USD)": "\u0430\u0432\u0433.97",
    "country": "United States"
  },
  {
    "Rank": "6899",
    "Name": "Codorus Valley Bancorp",
    "Symbol": "CVLY",
    " marketcap ": " $218 079 920 ",
    "price (USD)": "22.57",
    "country": "United States"
  },
  {
    "Rank": "6900",
    "Name": "GPA",
    "Symbol": "CBD",
    " marketcap ": " $218 056 672 ",
    "price (USD)": "0.445",
    "country": "Brazil"
  },
  {
    "Rank": "6901",
    "Name": "Belpointe OZ",
    "Symbol": "OZ",
    " marketcap ": " $217 865 696 ",
    "price (USD)": "59.99",
    "country": "United States"
  },
  {
    "Rank": "6902",
    "Name": "1stdibs.Com",
    "Symbol": "DIBS",
    " marketcap ": " $217 748 176 ",
    "price (USD)": "\u043c\u0430\u0439.53",
    "country": "United States"
  },
  {
    "Rank": "6903",
    "Name": "Hong Kong Technology Venture Company (HKTV)",
    "Symbol": "1137.HK",
    " marketcap ": " $217 470 277 ",
    "price (USD)": "0.244748",
    "country": "Hong Kong"
  },
  {
    "Rank": "6904",
    "Name": "Rico Auto Industries",
    "Symbol": "RICOAUTO.NS",
    " marketcap ": " $217 409 823 ",
    "price (USD)": "1.60705",
    "country": "India"
  },
  {
    "Rank": "6905",
    "Name": "Werewolf Therapeutics",
    "Symbol": "HOWL",
    " marketcap ": " $217 276 992 ",
    "price (USD)": "5",
    "country": "United States"
  },
  {
    "Rank": "6906",
    "Name": "Maiden Holdings",
    "Symbol": "MHLD",
    " marketcap ": " $216 451 456 ",
    "price (USD)": "\u0444\u0435\u0432.16",
    "country": "Bermuda"
  },
  {
    "Rank": "6907",
    "Name": "Jakks Pacific",
    "Symbol": "JAKK",
    " marketcap ": " $215 477 968 ",
    "price (USD)": "19.95",
    "country": "United States"
  },
  {
    "Rank": "6908",
    "Name": "GoHealth",
    "Symbol": "GOCO",
    " marketcap ": " $215 463 328 ",
    "price (USD)": "\u0441\u0435\u043d.48",
    "country": "United States"
  },
  {
    "Rank": "6909",
    "Name": "Gati",
    "Symbol": "GATI.NS",
    " marketcap ": " $215 137 993 ",
    "price (USD)": "\u044f\u043d\u0432.65",
    "country": "India"
  },
  {
    "Rank": "6910",
    "Name": "Maisons du Monde",
    "Symbol": "MDM.PA",
    " marketcap ": " $214 873 971 ",
    "price (USD)": "5.57064",
    "country": "France"
  },
  {
    "Rank": "6911",
    "Name": "Softstar Entertainment",
    "Symbol": "6111.TWO",
    " marketcap ": " $214 548 453 ",
    "price (USD)": "2.24517",
    "country": "Taiwan"
  },
  {
    "Rank": "6912",
    "Name": "Cantabil Retail India",
    "Symbol": "CANTABIL.NS",
    " marketcap ": " $213 348 421 ",
    "price (USD)": "2.55085",
    "country": "India"
  },
  {
    "Rank": "6913",
    "Name": "Salam International Investment",
    "Symbol": "SIIS.QA",
    " marketcap ": " $212 613 327 ",
    "price (USD)": "0.185989",
    "country": "Qatar"
  },
  {
    "Rank": "6914",
    "Name": "D-Wave Quantum",
    "Symbol": "QBTS",
    " marketcap ": " $212 374 800 ",
    "price (USD)": "\u044f\u043d\u0432.24",
    "country": "Canada"
  },
  {
    "Rank": "6915",
    "Name": "Arabia Insurance Cooperative Company",
    "Symbol": "8160.SR",
    " marketcap ": " $211 304 130 ",
    "price (USD)": "3.98687",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6916",
    "Name": "Wheels India",
    "Symbol": "WHEELS.NS",
    " marketcap ": " $211 077 257 ",
    "price (USD)": "8.63902",
    "country": "India"
  },
  {
    "Rank": "6917",
    "Name": "Response Plus Holding",
    "Symbol": "RPM.AE",
    " marketcap ": " $210 199 581 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6918",
    "Name": "Virco Manufacturing",
    "Symbol": "VIRC",
    " marketcap ": " $210 062 816 ",
    "price (USD)": "\u0434\u0435\u043a.85",
    "country": "United States"
  },
  {
    "Rank": "6919",
    "Name": "Avita Medical",
    "Symbol": "RCEL",
    " marketcap ": " $210 009 568 ",
    "price (USD)": "\u0430\u0432\u0433.14",
    "country": "United States"
  },
  {
    "Rank": "6920",
    "Name": "Al Ramz Corporation Investment and Development",
    "Symbol": "ALRAMZ.AE",
    " marketcap ": " $209 623 011 ",
    "price (USD)": "0.381191",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6921",
    "Name": "RGC Resources",
    "Symbol": "RGCO",
    " marketcap ": " $209 527 040 ",
    "price (USD)": "20.58",
    "country": "United States"
  },
  {
    "Rank": "6922",
    "Name": "Bahrain Duty Free Shop Complex",
    "Symbol": "DUTYF.BH",
    " marketcap ": " $209 445 427 ",
    "price (USD)": "1.49867",
    "country": "Bahrain"
  },
  {
    "Rank": "6923",
    "Name": "PLAID,Inc.",
    "Symbol": "4165.T",
    " marketcap ": " $209 188 823 ",
    "price (USD)": "5.18841",
    "country": "Japan"
  },
  {
    "Rank": "6924",
    "Name": "Orion Office REIT",
    "Symbol": "ONL",
    " marketcap ": " $208 953 056 ",
    "price (USD)": "\u043c\u0430\u0440.74",
    "country": "United States"
  },
  {
    "Rank": "6925",
    "Name": "Alico",
    "Symbol": "ALCO",
    " marketcap ": " $208 826 288 ",
    "price (USD)": "27.39",
    "country": "United States"
  },
  {
    "Rank": "6926",
    "Name": "City Office REIT",
    "Symbol": "CIO",
    " marketcap ": " $208 399 776 ",
    "price (USD)": "\u043c\u0430\u0439.19",
    "country": "Canada"
  },
  {
    "Rank": "6927",
    "Name": "Damaan Islamic Insurance Company (Beema)",
    "Symbol": "BEMA.QA",
    " marketcap ": " $208 241 758 ",
    "price (USD)": "1.04121",
    "country": "Qatar"
  },
  {
    "Rank": "6928",
    "Name": "Whole Earth Brands",
    "Symbol": "FREE",
    " marketcap ": " $208 210 992 ",
    "price (USD)": "\u0430\u043f\u0440.82",
    "country": "United States"
  },
  {
    "Rank": "6929",
    "Name": "Plumas Bancorp",
    "Symbol": "PLBC",
    " marketcap ": " $207 701 984 ",
    "price (USD)": "35.23",
    "country": "United States"
  },
  {
    "Rank": "6930",
    "Name": "Arabian International Healthcare Holding",
    "Symbol": "9530.SR",
    " marketcap ": " $207 349 291 ",
    "price (USD)": "\u043e\u043a\u0442.75",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6931",
    "Name": "Shell Oman Marketing Company",
    "Symbol": "SOMS.OM",
    " marketcap ": " $207 326 578 ",
    "price (USD)": "2.18239",
    "country": "Oman"
  },
  {
    "Rank": "6932",
    "Name": "Tucows",
    "Symbol": "TCX",
    " marketcap ": " $207 187 248 ",
    "price (USD)": "18.92",
    "country": "Canada"
  },
  {
    "Rank": "6933",
    "Name": "FutureFuel",
    "Symbol": "FF",
    " marketcap ": " $206 999 936 ",
    "price (USD)": "\u0430\u043f\u0440.73",
    "country": "United States"
  },
  {
    "Rank": "6934",
    "Name": "Ponce Financial Group",
    "Symbol": "PDLB",
    " marketcap ": " $206 838 752 ",
    "price (USD)": "\u0441\u0435\u043d.23",
    "country": "United States"
  },
  {
    "Rank": "6935",
    "Name": "LCNB",
    "Symbol": "LCNB",
    " marketcap ": " $206 770 656 ",
    "price (USD)": "14.62",
    "country": "United States"
  },
  {
    "Rank": "6936",
    "Name": "Cadiz",
    "Symbol": "CDZI",
    " marketcap ": " $206 770 480 ",
    "price (USD)": "03.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "6937",
    "Name": "Mondee",
    "Symbol": "MOND",
    " marketcap ": " $206 625 328 ",
    "price (USD)": "\u0444\u0435\u0432.33",
    "country": "United States"
  },
  {
    "Rank": "6938",
    "Name": "Hong Kong Ferry",
    "Symbol": "0050.HK",
    " marketcap ": " $206 352 235 ",
    "price (USD)": "0.579195",
    "country": "Hong Kong"
  },
  {
    "Rank": "6939",
    "Name": "Timberland Bancorp",
    "Symbol": "TSBK",
    " marketcap ": " $205 858 896 ",
    "price (USD)": "25.66",
    "country": "United States"
  },
  {
    "Rank": "6940",
    "Name": "Caesarstone",
    "Symbol": "CSTE",
    " marketcap ": " $205 490 384 ",
    "price (USD)": "\u043c\u0430\u0439.95",
    "country": "Israel"
  },
  {
    "Rank": "6941",
    "Name": "Braemar Hotels &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "6942",
    "Name": "Atossa Therapeutics",
    "Symbol": "ATOS",
    " marketcap ": " $204 983 904 ",
    "price (USD)": "\u044f\u043d\u0432.63",
    "country": "United States"
  },
  {
    "Rank": "6943",
    "Name": "Shankara Building",
    "Symbol": "SHANKARA.NS",
    " marketcap ": " $204 683 344 ",
    "price (USD)": "8.43777",
    "country": "India"
  },
  {
    "Rank": "6944",
    "Name": "Omaxe",
    "Symbol": "OMAXE.NS",
    " marketcap ": " $204 489 560 ",
    "price (USD)": "1.11683",
    "country": "India"
  },
  {
    "Rank": "6945",
    "Name": "Tidewater Renewables",
    "Symbol": "LCFS.TO",
    " marketcap ": " $204 224 495 ",
    "price (USD)": "5.86532",
    "country": "Canada"
  },
  {
    "Rank": "6946",
    "Name": "Al Buhaira National Insurance Company",
    "Symbol": "ABNIC.AE",
    " marketcap ": " $204 209 437 ",
    "price (USD)": "0.82",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "6947",
    "Name": "Banque nationale de Belgique",
    "Symbol": "BNB.BR",
    " marketcap ": " $204 148 116 ",
    "price (USD)": "510.37",
    "country": "Belgium"
  },
  {
    "Rank": "6948",
    "Name": "Elevation Oncology",
    "Symbol": "ELEV",
    " marketcap ": " $203 800 864 ",
    "price (USD)": "\u043c\u0430\u0440.73",
    "country": "United States"
  },
  {
    "Rank": "6949",
    "Name": "Franklin Street Properties",
    "Symbol": "FSP",
    " marketcap ": " $203 757 104 ",
    "price (USD)": "\u044f\u043d\u0432.97",
    "country": "United States"
  },
  {
    "Rank": "6950",
    "Name": "Veru",
    "Symbol": "VERU",
    " marketcap ": " $203 473 760 ",
    "price (USD)": "\u044f\u043d\u0432.39",
    "country": "United States"
  },
  {
    "Rank": "6951",
    "Name": "Caledonia Mining",
    "Symbol": "CMCL",
    " marketcap ": " $203 465 952 ",
    "price (USD)": "10.\u0438\u044e\u043d",
    "country": "Jersey"
  },
  {
    "Rank": "6952",
    "Name": "AFC Energy",
    "Symbol": "AFC.L",
    " marketcap ": " $203 223 942 ",
    "price (USD)": "0.271902",
    "country": "United Kingdom"
  },
  {
    "Rank": "6953",
    "Name": "AG Mortgage Investment Trust",
    "Symbol": "MITT",
    " marketcap ": " $203 073 792 ",
    "price (USD)": "\u0438\u044e\u043d.89",
    "country": "United States"
  },
  {
    "Rank": "6954",
    "Name": "Inogen",
    "Symbol": "INGN",
    " marketcap ": " $202 998 816 ",
    "price (USD)": "\u0430\u0432\u0433.61",
    "country": "United States"
  },
  {
    "Rank": "6955",
    "Name": "Parke Bancorp",
    "Symbol": "PKBK",
    " marketcap ": " $202 769 472 ",
    "price (USD)": "16.95",
    "country": "United States"
  },
  {
    "Rank": "6956",
    "Name": "Ellomay Capital",
    "Symbol": "ELLO",
    " marketcap ": " $202 664 944 ",
    "price (USD)": "15.7684",
    "country": "Israel"
  },
  {
    "Rank": "6957",
    "Name": "Morabaha Marina Financing Company",
    "Symbol": "4082.SR",
    " marketcap ": " $202 431 541 ",
    "price (USD)": "2.83404",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6958",
    "Name": "Smith-Midland",
    "Symbol": "SMID",
    " marketcap ": " $202 410 288 ",
    "price (USD)": "38.5",
    "country": "United States"
  },
  {
    "Rank": "6959",
    "Name": "Alarum Technologies",
    "Symbol": "ALAR",
    " marketcap ": " $202 071 648 ",
    "price (USD)": "31.43",
    "country": "Israel"
  },
  {
    "Rank": "6960",
    "Name": "Terran Orbital",
    "Symbol": "LLAP",
    " marketcap ": " $202 052 992 ",
    "price (USD)": "1",
    "country": "United States"
  },
  {
    "Rank": "6961",
    "Name": "Nelco",
    "Symbol": "NELCO.NS",
    " marketcap ": " $201 721 056 ",
    "price (USD)": "8.84028",
    "country": "India"
  },
  {
    "Rank": "6962",
    "Name": "Orr\u0413\u00b6n Energy",
    "Symbol": "ORRON.ST",
    " marketcap ": " $201 581 600 ",
    "price (USD)": "0.705016",
    "country": "Sweden"
  },
  {
    "Rank": "6963",
    "Name": "Jazan Development and Investment (JAZADCO)",
    "Symbol": "6090.SR",
    " marketcap ": " $201 211 539 ",
    "price (USD)": "4.02423",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6964",
    "Name": "Puma Biotechnology",
    "Symbol": "PBYI",
    " marketcap ": " $201 156 224 ",
    "price (USD)": "\u0430\u043f\u0440.17",
    "country": "United States"
  },
  {
    "Rank": "6965",
    "Name": "Galectin Therapeutics",
    "Symbol": "GALT",
    " marketcap ": " $200 738 368 ",
    "price (USD)": "\u043c\u0430\u0440.23",
    "country": "United States"
  },
  {
    "Rank": "6966",
    "Name": "stem",
    "Symbol": "STEM",
    " marketcap ": " $200 447 248 ",
    "price (USD)": "\u044f\u043d\u0432.24",
    "country": "United States"
  },
  {
    "Rank": "6967",
    "Name": "Desktop Metal",
    "Symbol": "DM",
    " marketcap ": " $200 219 984 ",
    "price (USD)": "0.606",
    "country": "United States"
  },
  {
    "Rank": "6968",
    "Name": "Capricor Therapeutics",
    "Symbol": "CAPR",
    " marketcap ": " $200 094 336 ",
    "price (USD)": "\u0438\u044e\u043d.29",
    "country": "United States"
  },
  {
    "Rank": "6969",
    "Name": "Liva Insurance Company",
    "Symbol": "8280.SR",
    " marketcap ": " $200 037 360 ",
    "price (USD)": "5.00093",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "6970",
    "Name": "Iteris",
    "Symbol": "ITI",
    " marketcap ": " $199 675 200 ",
    "price (USD)": "\u0430\u043f\u0440.67",
    "country": "United States"
  },
  {
    "Rank": "6971",
    "Name": "PrimeEnergy Resources",
    "Symbol": "PNRG",
    " marketcap ": " $199 635 472 ",
    "price (USD)": "111.85",
    "country": "United States"
  },
  {
    "Rank": "6972",
    "Name": "Destination XL",
    "Symbol": "DXLG",
    " marketcap ": " $198 902 624 ",
    "price (USD)": "\u043c\u0430\u0440.43",
    "country": "United States"
  },
  {
    "Rank": "6973",
    "Name": "Twin Disc",
    "Symbol": "TWIN",
    " marketcap ": " $198 890 272 ",
    "price (USD)": "14.21",
    "country": "United States"
  },
  {
    "Rank": "6974",
    "Name": "Profound Medical",
    "Symbol": "PROF",
    " marketcap ": " $198 729 104 ",
    "price (USD)": "8.135",
    "country": "Canada"
  },
  {
    "Rank": "6975",
    "Name": "Ooma",
    "Symbol": "OOMA",
    " marketcap ": " $198 688 176 ",
    "price (USD)": "\u0438\u044e\u043b.52",
    "country": "United States"
  },
  {
    "Rank": "6976",
    "Name": "Stratus Properties",
    "Symbol": "STRS",
    " marketcap ": " $198 366 944 ",
    "price (USD)": "24.56",
    "country": "United States"
  },
  {
    "Rank": "6977",
    "Name": "Aimia",
    "Symbol": "AIM.TO",
    " marketcap ": " $198 051 037 ",
    "price (USD)": "1.98688",
    "country": "Canada"
  },
  {
    "Rank": "6978",
    "Name": "Planet13",
    "Symbol": "PLTH.CN",
    " marketcap ": " $197 870 972 ",
    "price (USD)": "0.608527",
    "country": "United States"
  },
  {
    "Rank": "6979",
    "Name": "OrganiGram Holdings",
    "Symbol": "OGI",
    " marketcap ": " $197 758 080 ",
    "price (USD)": "\u044f\u043d\u0432.92",
    "country": "Canada"
  },
  {
    "Rank": "6980",
    "Name": "Igarashi Motors India",
    "Symbol": "IGARASHI.NS",
    " marketcap ": " $197 622 041 ",
    "price (USD)": "6.272",
    "country": "India"
  },
  {
    "Rank": "6981",
    "Name": "Bahrain Islamic Bank",
    "Symbol": "BISB.BH",
    " marketcap ": " $197 570 560 ",
    "price (USD)": "1.47215",
    "country": "Bahrain"
  },
  {
    "Rank": "6982",
    "Name": "Boyaa Interactive",
    "Symbol": "0434.HK",
    " marketcap ": " $197 308 275 ",
    "price (USD)": "0.278065",
    "country": "China"
  },
  {
    "Rank": "6983",
    "Name": "Al Imtiaz Investment Group Company",
    "Symbol": "ALIMTIAZ.KW",
    " marketcap ": " $197 146 154 ",
    "price (USD)": "192.308",
    "country": "Kuwait"
  },
  {
    "Rank": "6984",
    "Name": "Ocwen",
    "Symbol": "OCN",
    " marketcap ": " $196 255 744 ",
    "price (USD)": "25.13",
    "country": "United States"
  },
  {
    "Rank": "6985",
    "Name": "Princeton Bancorp",
    "Symbol": "BPRN",
    " marketcap ": " $195 773 776 ",
    "price (USD)": "30.98",
    "country": "United States"
  },
  {
    "Rank": "6986",
    "Name": "TPI Composites",
    "Symbol": "TPIC",
    " marketcap ": " $195 570 208 ",
    "price (USD)": "04.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "6987",
    "Name": "Middlefield Banc",
    "Symbol": "MBCN",
    " marketcap ": " $195 386 128 ",
    "price (USD)": "24.22",
    "country": "United States"
  },
  {
    "Rank": "6988",
    "Name": "Asure Software",
    "Symbol": "ASUR",
    " marketcap ": " $195 147 040 ",
    "price (USD)": "\u0438\u044e\u043b.56",
    "country": "United States"
  },
  {
    "Rank": "6989",
    "Name": "UNITED",
    "Symbol": "2497.T",
    " marketcap ": " $194 793 824 ",
    "price (USD)": "4.97089",
    "country": "Japan"
  },
  {
    "Rank": "6990",
    "Name": "Omeros Corporation",
    "Symbol": "OMER",
    " marketcap ": " $194 692 512 ",
    "price (USD)": "\u043c\u0430\u0440.36",
    "country": "United States"
  },
  {
    "Rank": "6991",
    "Name": "Analogue Holdings (ATAL)",
    "Symbol": "1977.HK",
    " marketcap ": " $193 748 534 ",
    "price (USD)": "0.138392",
    "country": "Hong Kong"
  },
  {
    "Rank": "6992",
    "Name": "Zevra Therapeutics",
    "Symbol": "ZVRA",
    " marketcap ": " $193 363 168 ",
    "price (USD)": "\u0430\u043f\u0440.62",
    "country": "United States"
  },
  {
    "Rank": "6993",
    "Name": "Ultralife Corporation",
    "Symbol": "ULBI",
    " marketcap ": " $193 153 216 ",
    "price (USD)": "\u043d\u043e\u044f.73",
    "country": "United States"
  },
  {
    "Rank": "6994",
    "Name": "Seven Hills Realty Trust",
    "Symbol": "SEVN",
    " marketcap ": " $192 767 616 ",
    "price (USD)": "13.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "6995",
    "Name": "Trevi Therapeutics",
    "Symbol": "TRVI",
    " marketcap ": " $192 287 840 ",
    "price (USD)": "\u0444\u0435\u0432.73",
    "country": "United States"
  },
  {
    "Rank": "6996",
    "Name": "bluebird bio",
    "Symbol": "BLUE",
    " marketcap ": " $192 105 952 ",
    "price (USD)": "0.9967",
    "country": "United States"
  },
  {
    "Rank": "6997",
    "Name": "Smart Good Things Holding",
    "Symbol": "MLSGT.PA",
    " marketcap ": " $191 309 267 ",
    "price (USD)": "7.60126",
    "country": "France"
  },
  {
    "Rank": "6998",
    "Name": "Bankwell Financial Group",
    "Symbol": "BWFG",
    " marketcap ": " $190 826 304 ",
    "price (USD)": "24.16",
    "country": "United States"
  },
  {
    "Rank": "6999",
    "Name": "Innoviz",
    "Symbol": "INVZ",
    " marketcap ": " $190 716 000 ",
    "price (USD)": "\u044f\u043d\u0432.15",
    "country": "Israel"
  },
  {
    "Rank": "7000",
    "Name": "Lineage Cell Therapeutics",
    "Symbol": "LCTX",
    " marketcap ": " $190 712 240 ",
    "price (USD)": "01.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7001",
    "Name": "Kandi Technologies Group",
    "Symbol": "KNDI",
    " marketcap ": " $190 440 880 ",
    "price (USD)": "\u0444\u0435\u0432.18",
    "country": "China"
  },
  {
    "Rank": "7002",
    "Name": "Outset Medical",
    "Symbol": "OM",
    " marketcap ": " $190 338 432 ",
    "price (USD)": "\u043c\u0430\u0440.68",
    "country": "United States"
  },
  {
    "Rank": "7003",
    "Name": "ReconAfrica",
    "Symbol": "0XD.F",
    " marketcap ": " $190 317 959 ",
    "price (USD)": "0.827451",
    "country": "Canada"
  },
  {
    "Rank": "7004",
    "Name": "Arab Sea Information Systems Company",
    "Symbol": "7201.SR",
    " marketcap ": " $190 270 328 ",
    "price (USD)": "\u044f\u043d\u0432.27",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7005",
    "Name": "Magnachip",
    "Symbol": "MX",
    " marketcap ": " $189 808 288 ",
    "price (USD)": "\u0430\u043f\u0440.96",
    "country": "Luxembourg"
  },
  {
    "Rank": "7006",
    "Name": "AGBA Group",
    "Symbol": "AGBA",
    " marketcap ": " $189 638 192 ",
    "price (USD)": "\u0444\u0435\u0432.32",
    "country": "Hong Kong"
  },
  {
    "Rank": "7007",
    "Name": "Baozun",
    "Symbol": "BZUN",
    " marketcap ": " $189 612 592 ",
    "price (USD)": "03.\u0441\u0435\u043d",
    "country": "China"
  },
  {
    "Rank": "7008",
    "Name": "High Tide",
    "Symbol": "HITI",
    " marketcap ": " $189 450 048 ",
    "price (USD)": "\u0444\u0435\u0432.39",
    "country": "Canada"
  },
  {
    "Rank": "7009",
    "Name": "Quest Resource Holding",
    "Symbol": "QRHC",
    " marketcap ": " $189 350 928 ",
    "price (USD)": "\u0441\u0435\u043d.36",
    "country": "United States"
  },
  {
    "Rank": "7010",
    "Name": "HomeStreet Bank",
    "Symbol": "HMST",
    " marketcap ": " $189 330 304 ",
    "price (USD)": "10.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "7011",
    "Name": "Lanvin Group",
    "Symbol": "LANV",
    " marketcap ": " $189 178 496 ",
    "price (USD)": "\u044f\u043d\u0432.25",
    "country": "China"
  },
  {
    "Rank": "7012",
    "Name": "Alpha Tau Medical",
    "Symbol": "DRTS",
    " marketcap ": " $189 149 328 ",
    "price (USD)": "\u0444\u0435\u0432.71",
    "country": "Israel"
  },
  {
    "Rank": "7013",
    "Name": "Rigetti Computing",
    "Symbol": "RGTI",
    " marketcap ": " $189 110 912 ",
    "price (USD)": "01.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7014",
    "Name": "Ames National Corp.",
    "Symbol": "ATLO",
    " marketcap ": " $189 105 344 ",
    "price (USD)": "21.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "7015",
    "Name": "Platinum Group Metals",
    "Symbol": "PLG",
    " marketcap ": " $188 563 200 ",
    "price (USD)": "\u044f\u043d\u0432.84",
    "country": "Canada"
  },
  {
    "Rank": "7016",
    "Name": "Tredegar",
    "Symbol": "TG",
    " marketcap ": " $188 287 552 ",
    "price (USD)": "\u043c\u0430\u0439.46",
    "country": "United States"
  },
  {
    "Rank": "7017",
    "Name": "a.k.a. Brands",
    "Symbol": "AKA",
    " marketcap ": " $188 203 968 ",
    "price (USD)": "17.95",
    "country": "United States"
  },
  {
    "Rank": "7018",
    "Name": "QLM Life &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7019",
    "Name": "eGain",
    "Symbol": "EGAN",
    " marketcap ": " $187 908 208 ",
    "price (USD)": "06.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "7020",
    "Name": "Osisko Development",
    "Symbol": "ODV",
    " marketcap ": " $187 647 808 ",
    "price (USD)": "\u0444\u0435\u0432.23",
    "country": "Canada"
  },
  {
    "Rank": "7021",
    "Name": "California BanCorp",
    "Symbol": "CALB",
    " marketcap ": " $187 349 808 ",
    "price (USD)": "22.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7022",
    "Name": "Sow Good",
    "Symbol": "SOWG",
    " marketcap ": " $186 823 008 ",
    "price (USD)": "18.42",
    "country": "United States"
  },
  {
    "Rank": "7023",
    "Name": "Navkar Corp",
    "Symbol": "NAVKARCORP.NS",
    " marketcap ": " $186 731 323 ",
    "price (USD)": "1.24058",
    "country": "India"
  },
  {
    "Rank": "7024",
    "Name": "Escalade Sports",
    "Symbol": "ESCA",
    " marketcap ": " $186 577 136 ",
    "price (USD)": "13.46",
    "country": "United States"
  },
  {
    "Rank": "7025",
    "Name": "Southern Petrochemical Industries Corp",
    "Symbol": "SPIC.NS",
    " marketcap ": " $186 519 564 ",
    "price (USD)": "0.915568",
    "country": "India"
  },
  {
    "Rank": "7026",
    "Name": "Hooker Furniture",
    "Symbol": "HOFT",
    " marketcap ": " $186 321 056 ",
    "price (USD)": "17.48",
    "country": "United States"
  },
  {
    "Rank": "7027",
    "Name": "Emperor International",
    "Symbol": "0163.HK",
    " marketcap ": " $186 141 126 ",
    "price (USD)": "0.0506155",
    "country": "Hong Kong"
  },
  {
    "Rank": "7028",
    "Name": "Leifheit",
    "Symbol": "LEI.DE",
    " marketcap ": " $186 091 728 ",
    "price (USD)": "19.5461",
    "country": "Germany"
  },
  {
    "Rank": "7029",
    "Name": "Oxford Square Capital",
    "Symbol": "OXSQ",
    " marketcap ": " $185 733 552 ",
    "price (USD)": "03.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "7030",
    "Name": "ShotSpotter",
    "Symbol": "SSTI",
    " marketcap ": " $185 377 808 ",
    "price (USD)": "14.49",
    "country": "United States"
  },
  {
    "Rank": "7031",
    "Name": "Graphite Bio",
    "Symbol": "GRPH",
    " marketcap ": " $185 193 344 ",
    "price (USD)": "\u043c\u0430\u0440.18",
    "country": "United States"
  },
  {
    "Rank": "7032",
    "Name": "Avacta Group",
    "Symbol": "AVCT.L",
    " marketcap ": " $184 868 480 ",
    "price (USD)": "0.514894",
    "country": "United Kingdom"
  },
  {
    "Rank": "7033",
    "Name": "Al-Maha Petroleum",
    "Symbol": "MHAS.OM",
    " marketcap ": " $184 645 362 ",
    "price (USD)": "2.67602",
    "country": "Oman"
  },
  {
    "Rank": "7034",
    "Name": "Outlook Therapeutics",
    "Symbol": "OTLK",
    " marketcap ": " $184 202 064 ",
    "price (USD)": "\u0438\u044e\u043b.87",
    "country": "United States"
  },
  {
    "Rank": "7035",
    "Name": "Oman Flour Mills",
    "Symbol": "OFMI.OM",
    " marketcap ": " $184 138 737 ",
    "price (USD)": "1.16913",
    "country": "Oman"
  },
  {
    "Rank": "7036",
    "Name": "India Nippon Electricals",
    "Symbol": "INDNIPPON.NS",
    " marketcap ": " $184 106 181 ",
    "price (USD)": "8.13859",
    "country": "India"
  },
  {
    "Rank": "7037",
    "Name": "Flexsteel Industries",
    "Symbol": "FLXS",
    " marketcap ": " $184 079 552 ",
    "price (USD)": "35.7",
    "country": "United States"
  },
  {
    "Rank": "7038",
    "Name": "Cimbeton",
    "Symbol": "CMBTN.IS",
    " marketcap ": " $183 910 535 ",
    "price (USD)": "103.904",
    "country": "Turkey"
  },
  {
    "Rank": "7039",
    "Name": "Absa Bank",
    "Symbol": "ABSP.JO",
    " marketcap ": " $183 604 600 ",
    "price (USD)": "40.9557",
    "country": "South Africa"
  },
  {
    "Rank": "7040",
    "Name": "Orchestra BioMed",
    "Symbol": "OBIO",
    " marketcap ": " $183 595 008 ",
    "price (USD)": "\u043c\u0430\u0439.13",
    "country": "United States"
  },
  {
    "Rank": "7041",
    "Name": "Westwing Group",
    "Symbol": "WEW.DE",
    " marketcap ": " $183 357 672 ",
    "price (USD)": "8.94777",
    "country": "Germany"
  },
  {
    "Rank": "7042",
    "Name": "National Bankshares",
    "Symbol": "NKSH",
    " marketcap ": " $183 355 504 ",
    "price (USD)": "31.11",
    "country": "United States"
  },
  {
    "Rank": "7043",
    "Name": "Energy Vault",
    "Symbol": "NRGV",
    " marketcap ": " $183 085 504 ",
    "price (USD)": "\u044f\u043d\u0432.23",
    "country": "United States"
  },
  {
    "Rank": "7044",
    "Name": "S\u0413\u00adminn hf.",
    "Symbol": "SIMINN.IC",
    " marketcap ": " $182 930 689 ",
    "price (USD)": "0.0703945",
    "country": "Iceland"
  },
  {
    "Rank": "7045",
    "Name": "HireQuest",
    "Symbol": "HQI",
    " marketcap ": " $182 840 000 ",
    "price (USD)": "13.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7046",
    "Name": "Nama Chemicals Company",
    "Symbol": "2210.SR",
    " marketcap ": " $182 332 880 ",
    "price (USD)": "7.75225",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7047",
    "Name": "Lifecore Biomedical",
    "Symbol": "LFCR",
    " marketcap ": " $182 059 520 ",
    "price (USD)": "\u043c\u0430\u0439.96",
    "country": "United States"
  },
  {
    "Rank": "7048",
    "Name": "Cheetah Mobile",
    "Symbol": "CMCM",
    " marketcap ": " $181 989 904 ",
    "price (USD)": "06.\u0441\u0435\u043d",
    "country": "China"
  },
  {
    "Rank": "7049",
    "Name": "Portman Ridge",
    "Symbol": "PTMN",
    " marketcap ": " $181 655 472 ",
    "price (USD)": "19.52",
    "country": "United States"
  },
  {
    "Rank": "7050",
    "Name": "Theseus Pharmaceuticals",
    "Symbol": "THRX",
    " marketcap ": " $181 275 744 ",
    "price (USD)": "04.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7051",
    "Name": "Oman Refreshment Company (Pepsi Oman)",
    "Symbol": "ORCI.OM",
    " marketcap ": " $180 566 381 ",
    "price (USD)": "3.61133",
    "country": "Oman"
  },
  {
    "Rank": "7052",
    "Name": "ESSA Bancorp",
    "Symbol": "ESSA",
    " marketcap ": " $180 442 016 ",
    "price (USD)": "17.81",
    "country": "United States"
  },
  {
    "Rank": "7053",
    "Name": "Biodesix",
    "Symbol": "BDSX",
    " marketcap ": " $180 057 024 ",
    "price (USD)": "\u044f\u043d\u0432.57",
    "country": "United States"
  },
  {
    "Rank": "7054",
    "Name": "NN, Inc.",
    "Symbol": "NNBR",
    " marketcap ": " $179 517 232 ",
    "price (USD)": "\u043c\u0430\u0440.59",
    "country": "United States"
  },
  {
    "Rank": "7055",
    "Name": "CVRx",
    "Symbol": "CVRX",
    " marketcap ": " $179 459 440 ",
    "price (USD)": "\u0430\u0432\u0433.31",
    "country": "United States"
  },
  {
    "Rank": "7056",
    "Name": "Tillys",
    "Symbol": "TLYS",
    " marketcap ": " $179 137 936 ",
    "price (USD)": "\u043c\u0430\u0439.96",
    "country": "United States"
  },
  {
    "Rank": "7057",
    "Name": "Hester Biosciences",
    "Symbol": "HESTERBIO.NS",
    " marketcap ": " $178 872 310 ",
    "price (USD)": "21.0268",
    "country": "India"
  },
  {
    "Rank": "7058",
    "Name": "BCB Bancorp",
    "Symbol": "BCBP",
    " marketcap ": " $178 222 272 ",
    "price (USD)": "\u043e\u043a\u0442.51",
    "country": "United States"
  },
  {
    "Rank": "7059",
    "Name": "Aenza",
    "Symbol": "AENZ",
    " marketcap ": " $177 853 952 ",
    "price (USD)": "\u044f\u043d\u0432.94",
    "country": "Peru"
  },
  {
    "Rank": "7060",
    "Name": "Commercial Vehicle Group (CVG)",
    "Symbol": "CVGI",
    " marketcap ": " $177 733 232 ",
    "price (USD)": "\u043c\u0430\u0439.17",
    "country": "United States"
  },
  {
    "Rank": "7061",
    "Name": "Canoo",
    "Symbol": "GOEV",
    " marketcap ": " $177 589 824 ",
    "price (USD)": "\u0444\u0435\u0432.59",
    "country": "United States"
  },
  {
    "Rank": "7062",
    "Name": "Abeona Therapeutics",
    "Symbol": "ABEO",
    " marketcap ": " $177 511 664 ",
    "price (USD)": "\u0430\u043f\u0440.31",
    "country": "United States"
  },
  {
    "Rank": "7063",
    "Name": "I.g. Petrochemicals",
    "Symbol": "IGPL.NS",
    " marketcap ": " $177 401 181 ",
    "price (USD)": "5.76075",
    "country": "India"
  },
  {
    "Rank": "7064",
    "Name": "Kokuyo Camlin",
    "Symbol": "KOKUYOCMLN.NS",
    " marketcap ": " $177 222 580 ",
    "price (USD)": "1.76685",
    "country": "India"
  },
  {
    "Rank": "7065",
    "Name": "Bang &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7066",
    "Name": "Achieve Life Sciences",
    "Symbol": "ACHV",
    " marketcap ": " $176 857 696 ",
    "price (USD)": "\u043c\u0430\u0439.15",
    "country": "Canada"
  },
  {
    "Rank": "7067",
    "Name": "Mammoth Energy Services",
    "Symbol": "TUSK",
    " marketcap ": " $176 670 544 ",
    "price (USD)": "\u043c\u0430\u0440.68",
    "country": "United States"
  },
  {
    "Rank": "7068",
    "Name": "Arctic Fish Holding",
    "Symbol": "AFISH.OL",
    " marketcap ": " $176 433 887 ",
    "price (USD)": "5.53489",
    "country": "Iceland"
  },
  {
    "Rank": "7069",
    "Name": "Northern Dynasty Minerals",
    "Symbol": "NAK",
    " marketcap ": " $176 351 536 ",
    "price (USD)": "0.3275",
    "country": "Canada"
  },
  {
    "Rank": "7070",
    "Name": "Kitex Garments",
    "Symbol": "KITEX.NS",
    " marketcap ": " $176 343 616 ",
    "price (USD)": "2.65178",
    "country": "India"
  },
  {
    "Rank": "7071",
    "Name": "Full House Resorts",
    "Symbol": "FLL",
    " marketcap ": " $176 304 368 ",
    "price (USD)": "05.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "7072",
    "Name": "Dhampur Sugar Mills",
    "Symbol": "DHAMPURSUG.NS",
    " marketcap ": " $176 261 415 ",
    "price (USD)": "2.69564",
    "country": "India"
  },
  {
    "Rank": "7073",
    "Name": "Al Khaleej Takaful Insurance Company",
    "Symbol": "AKHI.QA",
    " marketcap ": " $175 749 785 ",
    "price (USD)": "0.688462",
    "country": "Qatar"
  },
  {
    "Rank": "7074",
    "Name": "Cosmo First",
    "Symbol": "COSMOFIRST.NS",
    " marketcap ": " $175 729 945 ",
    "price (USD)": "6.77184",
    "country": "India"
  },
  {
    "Rank": "7075",
    "Name": "Ten Square Games",
    "Symbol": "TEN.WA",
    " marketcap ": " $175 521 667 ",
    "price (USD)": "23.9299",
    "country": "Poland"
  },
  {
    "Rank": "7076",
    "Name": "GEOX",
    "Symbol": "GEO.MI",
    " marketcap ": " $175 422 652 ",
    "price (USD)": "0.685199",
    "country": "Italy"
  },
  {
    "Rank": "7077",
    "Name": "TH International (Tims China)",
    "Symbol": "THCH",
    " marketcap ": " $175 322 288 ",
    "price (USD)": "01.\u043d\u043e\u044f",
    "country": "China"
  },
  {
    "Rank": "7078",
    "Name": "FuRyu",
    "Symbol": "6238.T",
    " marketcap ": " $175 240 488 ",
    "price (USD)": "6.62786",
    "country": "Japan"
  },
  {
    "Rank": "7079",
    "Name": "Zomedica Pharmaceuticals",
    "Symbol": "ZOM",
    " marketcap ": " $174 921 072 ",
    "price (USD)": "0.1785",
    "country": "United States"
  },
  {
    "Rank": "7080",
    "Name": "INEOS Styrolution",
    "Symbol": "INEOSSTYRO.NS",
    " marketcap ": " $174 838 743 ",
    "price (USD)": "\u0441\u0435\u043d.94",
    "country": "India"
  },
  {
    "Rank": "7081",
    "Name": "Kaltura",
    "Symbol": "KLTR",
    " marketcap ": " $174 824 112 ",
    "price (USD)": "\u044f\u043d\u0432.19",
    "country": "United States"
  },
  {
    "Rank": "7082",
    "Name": "First Western Financial",
    "Symbol": "MYFW",
    " marketcap ": " $174 626 768 ",
    "price (USD)": "18.15",
    "country": "United States"
  },
  {
    "Rank": "7083",
    "Name": "Greenwich LifeSciences",
    "Symbol": "GLSI",
    " marketcap ": " $174 395 200 ",
    "price (USD)": "13.54",
    "country": "United States"
  },
  {
    "Rank": "7084",
    "Name": "Aeva Technologies",
    "Symbol": "AEVA",
    " marketcap ": " $174 395 104 ",
    "price (USD)": "03.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "7085",
    "Name": "Stereotaxis",
    "Symbol": "STXS",
    " marketcap ": " $174 377 136 ",
    "price (USD)": "02.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "7086",
    "Name": "Peninsula Energy",
    "Symbol": "PEN.AX",
    " marketcap ": " $174 249 963 ",
    "price (USD)": "0.0800171",
    "country": "Australia"
  },
  {
    "Rank": "7087",
    "Name": "Baazeem Trading Company",
    "Symbol": "4051.SR",
    " marketcap ": " $174 005 280 ",
    "price (USD)": "17.1857",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7088",
    "Name": "RCM Technologies",
    "Symbol": "RCMT",
    " marketcap ": " $173 987 872 ",
    "price (USD)": "22.44",
    "country": "United States"
  },
  {
    "Rank": "7089",
    "Name": "Knights Group",
    "Symbol": "KGH.L",
    " marketcap ": " $173 423 772 ",
    "price (USD)": "2.02093",
    "country": "United Kingdom"
  },
  {
    "Rank": "7090",
    "Name": "Alligator Energy",
    "Symbol": "AGE.AX",
    " marketcap ": " $172 844 618 ",
    "price (USD)": "0.0446762",
    "country": "Australia"
  },
  {
    "Rank": "7091",
    "Name": "374Water",
    "Symbol": "SCWO",
    " marketcap ": " $172 470 992 ",
    "price (USD)": "01.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "7092",
    "Name": "Townsquare Media",
    "Symbol": "TSQ",
    " marketcap ": " $172 379 392 ",
    "price (USD)": "11.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "7093",
    "Name": "Archosaur Games",
    "Symbol": "9990.HK",
    " marketcap ": " $171 914 137 ",
    "price (USD)": "0.215276",
    "country": "China"
  },
  {
    "Rank": "7094",
    "Name": "LiveOne",
    "Symbol": "LVO",
    " marketcap ": " $171 486 896 ",
    "price (USD)": "01.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "7095",
    "Name": "Rottneros",
    "Symbol": "RROS.ST",
    " marketcap ": " $169 945 737 ",
    "price (USD)": "1.11387",
    "country": "Sweden"
  },
  {
    "Rank": "7096",
    "Name": "Monte Carlo Fashions",
    "Symbol": "MONTECARLO.NS",
    " marketcap ": " $169 763 733 ",
    "price (USD)": "8.18845",
    "country": "India"
  },
  {
    "Rank": "7097",
    "Name": "Granite Point Mortgage Trust",
    "Symbol": "GPMT",
    " marketcap ": " $169 435 536 ",
    "price (USD)": "\u043c\u0430\u0440.32",
    "country": "United States"
  },
  {
    "Rank": "7098",
    "Name": "Virginia National Bankshares",
    "Symbol": "VABK",
    " marketcap ": " $169 237 376 ",
    "price (USD)": "31.51",
    "country": "United States"
  },
  {
    "Rank": "7099",
    "Name": "trivago",
    "Symbol": "TRVG",
    " marketcap ": " $168 960 048 ",
    "price (USD)": "\u0444\u0435\u0432.42",
    "country": "Germany"
  },
  {
    "Rank": "7100",
    "Name": "Telomir Pharmaceuticals",
    "Symbol": "TELO",
    " marketcap ": " $168 775 856 ",
    "price (USD)": "05.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "7101",
    "Name": "Kodiak Sciences",
    "Symbol": "KOD",
    " marketcap ": " $168 637 024 ",
    "price (USD)": "\u043c\u0430\u0440.21",
    "country": "United States"
  },
  {
    "Rank": "7102",
    "Name": "Sporting Clube de Portugal",
    "Symbol": "SCP.LS",
    " marketcap ": " $168 410 416 ",
    "price (USD)": "1.11847",
    "country": "Portugal"
  },
  {
    "Rank": "7103",
    "Name": "SMN Power Company",
    "Symbol": "SMNP.OM",
    " marketcap ": " $168 048 673 ",
    "price (USD)": "0.841777",
    "country": "Oman"
  },
  {
    "Rank": "7104",
    "Name": "Entravision Communications",
    "Symbol": "EVC",
    " marketcap ": " $167 983 520 ",
    "price (USD)": "02.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "7105",
    "Name": "NACL Industries",
    "Symbol": "NACLIND.NS",
    " marketcap ": " $167 936 104 ",
    "price (USD)": "0.842275",
    "country": "India"
  },
  {
    "Rank": "7106",
    "Name": "Pkp Cargo",
    "Symbol": "PKP.WA",
    " marketcap ": " $167 910 839 ",
    "price (USD)": "3.74911",
    "country": "Poland"
  },
  {
    "Rank": "7107",
    "Name": "Vericity",
    "Symbol": "VERY",
    " marketcap ": " $167 790 000 ",
    "price (USD)": "\u043d\u043e\u044f.28",
    "country": "United States"
  },
  {
    "Rank": "7108",
    "Name": "FingerMotion",
    "Symbol": "FNGR",
    " marketcap ": " $167 626 704 ",
    "price (USD)": "\u043c\u0430\u0440.18",
    "country": "United States"
  },
  {
    "Rank": "7109",
    "Name": "BlackSky Technology",
    "Symbol": "BKSY",
    " marketcap ": " $167 553 888 ",
    "price (USD)": "\u044f\u043d\u0432.16",
    "country": "United States"
  },
  {
    "Rank": "7110",
    "Name": "Global Cord Blood",
    "Symbol": "CORBF",
    " marketcap ": " $167 393 744 ",
    "price (USD)": "\u044f\u043d\u0432.25",
    "country": "Hong Kong"
  },
  {
    "Rank": "7111",
    "Name": "Massimo Motor",
    "Symbol": "MAMO",
    " marketcap ": " $167 265 008 ",
    "price (USD)": "04.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7112",
    "Name": "Sangoma Technologies",
    "Symbol": "SANG",
    " marketcap ": " $167 096 000 ",
    "price (USD)": "5",
    "country": "Canada"
  },
  {
    "Rank": "7113",
    "Name": "Tingo Group",
    "Symbol": "TIO",
    " marketcap ": " $166 947 568 ",
    "price (USD)": "0.69",
    "country": "United States"
  },
  {
    "Rank": "7114",
    "Name": "HF Foods Group",
    "Symbol": "HFFG",
    " marketcap ": " $166 776 240 ",
    "price (USD)": "\u043c\u0430\u0440.17",
    "country": "United States"
  },
  {
    "Rank": "7115",
    "Name": "Compugen",
    "Symbol": "CGEN",
    " marketcap ": " $166 526 176 ",
    "price (USD)": "\u044f\u043d\u0432.86",
    "country": "Israel"
  },
  {
    "Rank": "7116",
    "Name": "Semler Scientific",
    "Symbol": "SMLR",
    " marketcap ": " $166 329 888 ",
    "price (USD)": "23.54",
    "country": "United States"
  },
  {
    "Rank": "7117",
    "Name": "Provident Bancorp",
    "Symbol": "PVBC",
    " marketcap ": " $166 323 296 ",
    "price (USD)": "\u0441\u0435\u043d.42",
    "country": "United States"
  },
  {
    "Rank": "7118",
    "Name": "Kuantum Papers",
    "Symbol": "KUANTUM.NS",
    " marketcap ": " $166 292 170 ",
    "price (USD)": "1.90443",
    "country": "India"
  },
  {
    "Rank": "7119",
    "Name": "The ONE Group Hospitality",
    "Symbol": "STKS",
    " marketcap ": " $166 211 264 ",
    "price (USD)": "\u043c\u0430\u0439.29",
    "country": "United States"
  },
  {
    "Rank": "7120",
    "Name": "Celtic",
    "Symbol": "CCPC.L",
    " marketcap ": " $165 975 473 ",
    "price (USD)": "3.47077",
    "country": "United Kingdom"
  },
  {
    "Rank": "7121",
    "Name": "Himatsingka Seide",
    "Symbol": "HIMATSEIDE.NS",
    " marketcap ": " $165 619 429 ",
    "price (USD)": "1.68215",
    "country": "India"
  },
  {
    "Rank": "7122",
    "Name": "GoldMining Inc.",
    "Symbol": "GLDG",
    " marketcap ": " $165 610 048 ",
    "price (USD)": "0.885",
    "country": "Canada"
  },
  {
    "Rank": "7123",
    "Name": "Sadr Logistics Company",
    "Symbol": "1832.SR",
    " marketcap ": " $165 319 021 ",
    "price (USD)": "0.94468",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7124",
    "Name": "Taylor Devices",
    "Symbol": "TAYD",
    " marketcap ": " $165 310 288 ",
    "price (USD)": "53.43",
    "country": "United States"
  },
  {
    "Rank": "7125",
    "Name": "Quicklogic",
    "Symbol": "QUIK",
    " marketcap ": " $164 866 320 ",
    "price (USD)": "\u043d\u043e\u044f.43",
    "country": "United States"
  },
  {
    "Rank": "7126",
    "Name": "Clipper Realty",
    "Symbol": "CLPR",
    " marketcap ": " $164 491 440 ",
    "price (USD)": "\u043c\u0430\u0440.88",
    "country": "United States"
  },
  {
    "Rank": "7127",
    "Name": "System1",
    "Symbol": "SST",
    " marketcap ": " $163 787 184 ",
    "price (USD)": "\u044f\u043d\u0432.46",
    "country": "United States"
  },
  {
    "Rank": "7128",
    "Name": "Seef Properties",
    "Symbol": "SEEF.BH",
    " marketcap ": " $163 501 326 ",
    "price (USD)": "0.185676",
    "country": "Bahrain"
  },
  {
    "Rank": "7129",
    "Name": "Mengly J. Quach Education",
    "Symbol": "MJQE.KH",
    " marketcap ": " $163 424 846 ",
    "price (USD)": "0.5",
    "country": "Cambodia"
  },
  {
    "Rank": "7130",
    "Name": "Adverum Biotechnologies",
    "Symbol": "ADVM",
    " marketcap ": " $163 148 448 ",
    "price (USD)": "\u0438\u044e\u043b.86",
    "country": "United States"
  },
  {
    "Rank": "7131",
    "Name": "Gevo",
    "Symbol": "GEVO",
    " marketcap ": " $163 118 880 ",
    "price (USD)": "0.6905",
    "country": "United States"
  },
  {
    "Rank": "7132",
    "Name": "MediWound",
    "Symbol": "MDWD",
    " marketcap ": " $163 067 760 ",
    "price (USD)": "17.18",
    "country": "Israel"
  },
  {
    "Rank": "7133",
    "Name": "Quantafuel",
    "Symbol": "QFUEL.OL",
    " marketcap ": " $162 947 734 ",
    "price (USD)": "0.54",
    "country": "Norway"
  },
  {
    "Rank": "7134",
    "Name": "Excel Industries",
    "Symbol": "EXCELINDUS.NS",
    " marketcap ": " $162 587 083 ",
    "price (USD)": "\u0434\u0435\u043a.97",
    "country": "India"
  },
  {
    "Rank": "7135",
    "Name": "Emperor Watch &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7136",
    "Name": "Cerence",
    "Symbol": "CRNC",
    " marketcap ": " $161 886 656 ",
    "price (USD)": "3.875",
    "country": "United States"
  },
  {
    "Rank": "7137",
    "Name": "UBM Development",
    "Symbol": "UBS.VI",
    " marketcap ": " $161 874 253 ",
    "price (USD)": "21.6636",
    "country": "Austria"
  },
  {
    "Rank": "7138",
    "Name": "Vertical Aerospace",
    "Symbol": "EVTL",
    " marketcap ": " $161 511 776 ",
    "price (USD)": "0.73",
    "country": "United Kingdom"
  },
  {
    "Rank": "7139",
    "Name": "Texwinca Holdings",
    "Symbol": "0321.HK",
    " marketcap ": " $161 117 148 ",
    "price (USD)": "0.116608",
    "country": "Hong Kong"
  },
  {
    "Rank": "7140",
    "Name": "Aemetis",
    "Symbol": "AMTX",
    " marketcap ": " $160 720 032 ",
    "price (USD)": "\u043c\u0430\u0440.62",
    "country": "United States"
  },
  {
    "Rank": "7141",
    "Name": "NIU",
    "Symbol": "NIU",
    " marketcap ": " $160 628 880 ",
    "price (USD)": "02.\u0438\u044e\u043b",
    "country": "China"
  },
  {
    "Rank": "7142",
    "Name": "Laramide Resources",
    "Symbol": "LAM.TO",
    " marketcap ": " $160 560 724 ",
    "price (USD)": "0.645185",
    "country": "Canada"
  },
  {
    "Rank": "7143",
    "Name": "CervoMed",
    "Symbol": "CRVO",
    " marketcap ": " $160 452 704 ",
    "price (USD)": "19.44",
    "country": "United States"
  },
  {
    "Rank": "7144",
    "Name": "Rigel Pharmaceuticals",
    "Symbol": "RIGL",
    " marketcap ": " $160 321 072 ",
    "price (USD)": "0.914",
    "country": "United States"
  },
  {
    "Rank": "7145",
    "Name": "RAPT Therapeutics",
    "Symbol": "RAPT",
    " marketcap ": " $160 207 072 ",
    "price (USD)": "\u0430\u043f\u0440.59",
    "country": "United States"
  },
  {
    "Rank": "7146",
    "Name": "Shengfeng Development",
    "Symbol": "SFWL",
    " marketcap ": " $160 045 168 ",
    "price (USD)": "\u044f\u043d\u0432.94",
    "country": "China"
  },
  {
    "Rank": "7147",
    "Name": "Mangalore Chemicals and Fertilizers",
    "Symbol": "MANGCHEFER.NS",
    " marketcap ": " $159 984 248 ",
    "price (USD)": "1.34572",
    "country": "India"
  },
  {
    "Rank": "7148",
    "Name": "Parken Sport (F.C. Copenhagen)",
    "Symbol": "PARKEN.CO",
    " marketcap ": " $159 919 598 ",
    "price (USD)": "16.3693",
    "country": "Denmark"
  },
  {
    "Rank": "7149",
    "Name": "Akatsuki Inc",
    "Symbol": "3932.T",
    " marketcap ": " $159 584 103 ",
    "price (USD)": "13.422",
    "country": "Japan"
  },
  {
    "Rank": "7150",
    "Name": "Finance House",
    "Symbol": "FH.AE",
    " marketcap ": " $159 140 931 ",
    "price (USD)": "0.53",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7151",
    "Name": "Eurobio Scientific",
    "Symbol": "ALERS.PA",
    " marketcap ": " $159 016 840 ",
    "price (USD)": "15.8323",
    "country": "France"
  },
  {
    "Rank": "7152",
    "Name": "Salama Cooperative Insurance Company",
    "Symbol": "8050.SR",
    " marketcap ": " $158 780 989 ",
    "price (USD)": "7.93905",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7153",
    "Name": "Investar Holding",
    "Symbol": "ISTR",
    " marketcap ": " $157 955 248 ",
    "price (USD)": "16.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "7154",
    "Name": "Perma-Fix Environmental Services",
    "Symbol": "PESI",
    " marketcap ": " $157 818 592 ",
    "price (USD)": "\u043d\u043e\u044f.49",
    "country": "United States"
  },
  {
    "Rank": "7155",
    "Name": "Peoples Bancorp of North Carolina",
    "Symbol": "PEBK",
    " marketcap ": " $157 672 688 ",
    "price (USD)": "29.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "7156",
    "Name": "United Projects Company For Aviation Services",
    "Symbol": "UPAC.KW",
    " marketcap ": " $157 570 169 ",
    "price (USD)": "417.21",
    "country": "Kuwait"
  },
  {
    "Rank": "7157",
    "Name": "iHeartMedia",
    "Symbol": "IHRT",
    " marketcap ": " $157 282 512 ",
    "price (USD)": "01.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "7158",
    "Name": "Buruj Cooperative Insurance Company",
    "Symbol": "8270.SR",
    " marketcap ": " $157 073 093 ",
    "price (USD)": "5.23577",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7159",
    "Name": "ryde",
    "Symbol": "RYDE",
    " marketcap ": " $156 921 008 ",
    "price (USD)": "\u0430\u0432\u0433.21",
    "country": "Singapore"
  },
  {
    "Rank": "7160",
    "Name": "Aptech",
    "Symbol": "APTECHT.NS",
    " marketcap ": " $156 781 988 ",
    "price (USD)": "2.70105",
    "country": "India"
  },
  {
    "Rank": "7161",
    "Name": "WM Technology",
    "Symbol": "MAPS",
    " marketcap ": " $156 611 856 ",
    "price (USD)": "0.9537",
    "country": "United States"
  },
  {
    "Rank": "7162",
    "Name": "Evans Bancorp",
    "Symbol": "EVBN",
    " marketcap ": " $156 299 792 ",
    "price (USD)": "28.31",
    "country": "United States"
  },
  {
    "Rank": "7163",
    "Name": "eHealth",
    "Symbol": "EHTH",
    " marketcap ": " $156 101 968 ",
    "price (USD)": "\u043c\u0430\u0439.36",
    "country": "United States"
  },
  {
    "Rank": "7164",
    "Name": "GrowGeneration",
    "Symbol": "GRWG",
    " marketcap ": " $156 021 360 ",
    "price (USD)": "\u0444\u0435\u0432.57",
    "country": "United States"
  },
  {
    "Rank": "7165",
    "Name": "Duluth Holdings",
    "Symbol": "DLTH",
    " marketcap ": " $155 540 880 ",
    "price (USD)": "\u0430\u043f\u0440.52",
    "country": "United States"
  },
  {
    "Rank": "7166",
    "Name": "ProQR",
    "Symbol": "PRQR",
    " marketcap ": " $155 158 176 ",
    "price (USD)": "01.\u0441\u0435\u043d",
    "country": "Netherlands"
  },
  {
    "Rank": "7167",
    "Name": "Sterling Tools",
    "Symbol": "STERTOOLS.NS",
    " marketcap ": " $155 152 474 ",
    "price (USD)": "\u0430\u043f\u0440.69",
    "country": "India"
  },
  {
    "Rank": "7168",
    "Name": "The Pearl REIF",
    "Symbol": "PRFD.OM",
    " marketcap ": " $154 450 805 ",
    "price (USD)": "0.303975",
    "country": "Oman"
  },
  {
    "Rank": "7169",
    "Name": "Information Services Group",
    "Symbol": "III",
    " marketcap ": " $154 269 328 ",
    "price (USD)": "\u043c\u0430\u0440.17",
    "country": "United States"
  },
  {
    "Rank": "7170",
    "Name": "Coffee Day Enterprises",
    "Symbol": "COFFEEDAY.NS",
    " marketcap ": " $154 199 466 ",
    "price (USD)": "0.729931",
    "country": "India"
  },
  {
    "Rank": "7171",
    "Name": "Sylogist",
    "Symbol": "SYZ.TO",
    " marketcap ": " $153 944 224 ",
    "price (USD)": "6.56916",
    "country": "Canada"
  },
  {
    "Rank": "7172",
    "Name": "BHM Capital Financial Services",
    "Symbol": "BHMCAPITAL.AE",
    " marketcap ": " $153 549 744 ",
    "price (USD)": "0.950255",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7173",
    "Name": "People Can Fly",
    "Symbol": "PCF.WA",
    " marketcap ": " $153 468 636 ",
    "price (USD)": "\u0430\u043f\u0440.01",
    "country": "Poland"
  },
  {
    "Rank": "7174",
    "Name": "Bahrain National Holding",
    "Symbol": "BNH.BH",
    " marketcap ": " $153 315 318 ",
    "price (USD)": "0.355438",
    "country": "Bahrain"
  },
  {
    "Rank": "7175",
    "Name": "Digital Bros",
    "Symbol": "DIB.MI",
    " marketcap ": " $153 199 644 ",
    "price (USD)": "\u043e\u043a\u0442.23",
    "country": "Italy"
  },
  {
    "Rank": "7176",
    "Name": "Sagimet Biosciences",
    "Symbol": "SGMT",
    " marketcap ": " $152 867 584 ",
    "price (USD)": "\u0430\u043f\u0440.79",
    "country": "United States"
  },
  {
    "Rank": "7177",
    "Name": "Penns Woods Bancorp",
    "Symbol": "PWOD",
    " marketcap ": " $152 398 096 ",
    "price (USD)": "20.24",
    "country": "United States"
  },
  {
    "Rank": "7178",
    "Name": "Bushiroad",
    "Symbol": "7803.T",
    " marketcap ": " $152 287 846 ",
    "price (USD)": "2.17516",
    "country": "Japan"
  },
  {
    "Rank": "7179",
    "Name": "Context Therapeutics",
    "Symbol": "CNTX",
    " marketcap ": " $152 246 560 ",
    "price (USD)": "02.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "7180",
    "Name": "Purple Innovation",
    "Symbol": "PRPL",
    " marketcap ": " $152 084 192 ",
    "price (USD)": "1.415",
    "country": "United States"
  },
  {
    "Rank": "7181",
    "Name": "Vaxart",
    "Symbol": "VXRT",
    " marketcap ": " $152 062 992 ",
    "price (USD)": "0.8599",
    "country": "United States"
  },
  {
    "Rank": "7182",
    "Name": "Serverworks",
    "Symbol": "4434.T",
    " marketcap ": " $151 886 147 ",
    "price (USD)": "19.3846",
    "country": "Japan"
  },
  {
    "Rank": "7183",
    "Name": "Gossamer Bio",
    "Symbol": "GOSS",
    " marketcap ": " $151 566 736 ",
    "price (USD)": "0.67",
    "country": "United States"
  },
  {
    "Rank": "7184",
    "Name": "Universal Electronics",
    "Symbol": "UEIC",
    " marketcap ": " $151 336 816 ",
    "price (USD)": "\u043d\u043e\u044f.74",
    "country": "United States"
  },
  {
    "Rank": "7185",
    "Name": "Syros Pharmaceuticals",
    "Symbol": "SYRS",
    " marketcap ": " $151 014 896 ",
    "price (USD)": "\u043c\u0430\u0439.65",
    "country": "United States"
  },
  {
    "Rank": "7186",
    "Name": "TELA Bio",
    "Symbol": "TELA",
    " marketcap ": " $150 891 040 ",
    "price (USD)": "06.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "7187",
    "Name": "Accuray",
    "Symbol": "ARAY",
    " marketcap ": " $150 851 184 ",
    "price (USD)": "\u044f\u043d\u0432.52",
    "country": "United States"
  },
  {
    "Rank": "7188",
    "Name": "India Motor Parts and Accessories",
    "Symbol": "IMPAL.NS",
    " marketcap ": " $150 813 476 ",
    "price (USD)": "12.0784",
    "country": "India"
  },
  {
    "Rank": "7189",
    "Name": "X4 Pharmaceuticals",
    "Symbol": "XFOR",
    " marketcap ": " $150 590 016 ",
    "price (USD)": "0.8967",
    "country": "United States"
  },
  {
    "Rank": "7190",
    "Name": "Sachem Capital",
    "Symbol": "SACH",
    " marketcap ": " $150 404 144 ",
    "price (USD)": "\u043c\u0430\u0440.17",
    "country": "United States"
  },
  {
    "Rank": "7191",
    "Name": "InterCure",
    "Symbol": "INCR",
    " marketcap ": " $150 389 904 ",
    "price (USD)": "03.\u043c\u0430\u0440",
    "country": "Israel"
  },
  {
    "Rank": "7192",
    "Name": "First Guaranty Bancshares",
    "Symbol": "FGBI",
    " marketcap ": " $149 931 344 ",
    "price (USD)": "\u043d\u043e\u044f.99",
    "country": "United States"
  },
  {
    "Rank": "7193",
    "Name": "Richardson Electronics",
    "Symbol": "RELL",
    " marketcap ": " $149 637 632 ",
    "price (USD)": "\u043e\u043a\u0442.48",
    "country": "United States"
  },
  {
    "Rank": "7194",
    "Name": "Offerpad",
    "Symbol": "OPAD",
    " marketcap ": " $149 614 416 ",
    "price (USD)": "\u043c\u0430\u0439.48",
    "country": "United States"
  },
  {
    "Rank": "7195",
    "Name": "Forsys Metals",
    "Symbol": "FSY.TO",
    " marketcap ": " $148 814 652 ",
    "price (USD)": "0.762491",
    "country": "Canada"
  },
  {
    "Rank": "7196",
    "Name": "Expensify",
    "Symbol": "EXFY",
    " marketcap ": " $148 769 344 ",
    "price (USD)": "\u044f\u043d\u0432.72",
    "country": "United States"
  },
  {
    "Rank": "7197",
    "Name": "OP Bancorp (Open Bank)",
    "Symbol": "OPBK",
    " marketcap ": " $148 666 608 ",
    "price (USD)": "\u0441\u0435\u043d.94",
    "country": "United States"
  },
  {
    "Rank": "7198",
    "Name": "C&amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7199",
    "Name": "QuantaSing Group",
    "Symbol": "QSG",
    " marketcap ": " $148 554 768 ",
    "price (USD)": "\u0444\u0435\u0432.63",
    "country": "China"
  },
  {
    "Rank": "7200",
    "Name": "Citizens Inc",
    "Symbol": "CIA",
    " marketcap ": " $148 404 768 ",
    "price (USD)": "\u0444\u0435\u0432.99",
    "country": "United States"
  },
  {
    "Rank": "7201",
    "Name": "Modiv",
    "Symbol": "MDV",
    " marketcap ": " $148 033 984 ",
    "price (USD)": "15.66",
    "country": "United States"
  },
  {
    "Rank": "7202",
    "Name": "Silvercrest Asset Management Group",
    "Symbol": "SAMG",
    " marketcap ": " $147 540 240 ",
    "price (USD)": "15.56",
    "country": "United States"
  },
  {
    "Rank": "7203",
    "Name": "Acme United",
    "Symbol": "ACU",
    " marketcap ": " $147 207 584 ",
    "price (USD)": "40.2",
    "country": "United States"
  },
  {
    "Rank": "7204",
    "Name": "Al Suwadi Power",
    "Symbol": "SUWP.OM",
    " marketcap ": " $146 630 556 ",
    "price (USD)": "0.205248",
    "country": "Oman"
  },
  {
    "Rank": "7205",
    "Name": "Eos Energy Enterprises",
    "Symbol": "EOSE",
    " marketcap ": " $145 960 176 ",
    "price (USD)": "0.7013",
    "country": "United States"
  },
  {
    "Rank": "7206",
    "Name": "CytomX Therapeutics",
    "Symbol": "CTMX",
    " marketcap ": " $145 709 280 ",
    "price (USD)": "\u044f\u043d\u0432.87",
    "country": "United States"
  },
  {
    "Rank": "7207",
    "Name": "Ellington Residential Mortgage REIT",
    "Symbol": "EARN",
    " marketcap ": " $145 371 088 ",
    "price (USD)": "\u0438\u044e\u043b.22",
    "country": "United States"
  },
  {
    "Rank": "7208",
    "Name": "Sierra Metals",
    "Symbol": "SMT.TO",
    " marketcap ": " $144 795 630 ",
    "price (USD)": "0.689175",
    "country": "Canada"
  },
  {
    "Rank": "7209",
    "Name": "Repare Therapeutics",
    "Symbol": "RPTX",
    " marketcap ": " $144 314 368 ",
    "price (USD)": "03.\u0430\u043f\u0440",
    "country": "Canada"
  },
  {
    "Rank": "7210",
    "Name": "AXT Inc",
    "Symbol": "AXTI",
    " marketcap ": " $144 296 096 ",
    "price (USD)": "\u043c\u0430\u0440.25",
    "country": "United States"
  },
  {
    "Rank": "7211",
    "Name": "Western New England Bancorp",
    "Symbol": "WNEB",
    " marketcap ": " $143 824 208 ",
    "price (USD)": "\u0438\u044e\u043d.65",
    "country": "United States"
  },
  {
    "Rank": "7212",
    "Name": "Serviceware",
    "Symbol": "SJJ.DE",
    " marketcap ": " $143 663 816 ",
    "price (USD)": "13.6823",
    "country": "Germany"
  },
  {
    "Rank": "7213",
    "Name": "RADCOM",
    "Symbol": "RDCM",
    " marketcap ": " $143 571 808 ",
    "price (USD)": "\u0441\u0435\u043d.28",
    "country": "Israel"
  },
  {
    "Rank": "7214",
    "Name": "Maxeon Solar Technologies",
    "Symbol": "MAXN",
    " marketcap ": " $143 034 080 ",
    "price (USD)": "\u0444\u0435\u0432.71",
    "country": "Singapore"
  },
  {
    "Rank": "7215",
    "Name": "Salalah Port Services Company",
    "Symbol": "SPSI.OM",
    " marketcap ": " $142 972 836 ",
    "price (USD)": "0.795012",
    "country": "Oman"
  },
  {
    "Rank": "7216",
    "Name": "Avino Silver &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7217",
    "Name": "I-Mab Biopharma",
    "Symbol": "IMAB",
    " marketcap ": " $142 353 904 ",
    "price (USD)": "\u044f\u043d\u0432.76",
    "country": "China"
  },
  {
    "Rank": "7218",
    "Name": "ZeroFox",
    "Symbol": "ZFOX",
    " marketcap ": " $142 321 024 ",
    "price (USD)": "\u044f\u043d\u0432.14",
    "country": "United States"
  },
  {
    "Rank": "7219",
    "Name": "American Well",
    "Symbol": "AMWL",
    " marketcap ": " $142 302 240 ",
    "price (USD)": "0.48",
    "country": "United States"
  },
  {
    "Rank": "7220",
    "Name": "Jay Bharat Maruti",
    "Symbol": "JAYBARMARU.NS",
    " marketcap ": " $142 160 616 ",
    "price (USD)": "1.31207",
    "country": "India"
  },
  {
    "Rank": "7221",
    "Name": "Bragg Gaming Group",
    "Symbol": "BRAG",
    " marketcap ": " $142 133 040 ",
    "price (USD)": "06.\u044f\u043d\u0432",
    "country": "Canada"
  },
  {
    "Rank": "7222",
    "Name": "Renovaro Biosciences",
    "Symbol": "RENB",
    " marketcap ": " $141 604 784 ",
    "price (USD)": "0.96",
    "country": "United States"
  },
  {
    "Rank": "7223",
    "Name": "InfuSystem",
    "Symbol": "INFU",
    " marketcap ": " $141 187 840 ",
    "price (USD)": "\u0438\u044e\u043d.63",
    "country": "United States"
  },
  {
    "Rank": "7224",
    "Name": "The Children's Place",
    "Symbol": "PLCE",
    " marketcap ": " $141 060 528 ",
    "price (USD)": "11.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "7225",
    "Name": "Lantronix",
    "Symbol": "LTRX",
    " marketcap ": " $140 549 952 ",
    "price (USD)": "\u043c\u0430\u0440.74",
    "country": "United States"
  },
  {
    "Rank": "7226",
    "Name": "\u0414\u00b0\u0415\u045fbir Holding",
    "Symbol": "ISBIR.IS",
    " marketcap ": " $140 340 207 ",
    "price (USD)": "4.33323",
    "country": "Turkey"
  },
  {
    "Rank": "7227",
    "Name": "Chinese Gamer International",
    "Symbol": "3083.TWO",
    " marketcap ": " $140 245 154 ",
    "price (USD)": "1.62186",
    "country": "Taiwan"
  },
  {
    "Rank": "7228",
    "Name": "Oriental Aromatics",
    "Symbol": "OAL.NS",
    " marketcap ": " $140 130 665 ",
    "price (USD)": "4.16391",
    "country": "India"
  },
  {
    "Rank": "7229",
    "Name": "Frontier Developments",
    "Symbol": "FDEV.L",
    " marketcap ": " $139 335 057 ",
    "price (USD)": "3.53433",
    "country": "United Kingdom"
  },
  {
    "Rank": "7230",
    "Name": "Al Omaniya Financial Services",
    "Symbol": "AOFS.OM",
    " marketcap ": " $139 311 225 ",
    "price (USD)": "0.441673",
    "country": "Oman"
  },
  {
    "Rank": "7231",
    "Name": "Arbe Robotics",
    "Symbol": "ARBE",
    " marketcap ": " $139 234 448 ",
    "price (USD)": "\u044f\u043d\u0432.78",
    "country": "Israel"
  },
  {
    "Rank": "7232",
    "Name": "Tuniu Corporation",
    "Symbol": "TOUR",
    " marketcap ": " $138 707 520 ",
    "price (USD)": "01.\u0434\u0435\u043a",
    "country": "China"
  },
  {
    "Rank": "7233",
    "Name": "Abu Dhabi National Takaful",
    "Symbol": "TKFL.AE",
    " marketcap ": " $138 658 208 ",
    "price (USD)": "\u044f\u043d\u0432.32",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7234",
    "Name": "Userjoy Technology",
    "Symbol": "3546.TWO",
    " marketcap ": " $138 359 691 ",
    "price (USD)": "2.73514",
    "country": "Taiwan"
  },
  {
    "Rank": "7235",
    "Name": "Fairwood Holdings",
    "Symbol": "0052.HK",
    " marketcap ": " $138 120 275 ",
    "price (USD)": "1.06613",
    "country": "Hong Kong"
  },
  {
    "Rank": "7236",
    "Name": "DBV Technologies",
    "Symbol": "DBVT",
    " marketcap ": " $138 029 184 ",
    "price (USD)": "0.611",
    "country": "France"
  },
  {
    "Rank": "7237",
    "Name": "scPharmaceuticals",
    "Symbol": "SCPH",
    " marketcap ": " $137 908 080 ",
    "price (USD)": "3.825",
    "country": "United States"
  },
  {
    "Rank": "7238",
    "Name": "Manitex International",
    "Symbol": "MNTX",
    " marketcap ": " $137 864 272 ",
    "price (USD)": "\u0438\u044e\u043d.77",
    "country": "United States"
  },
  {
    "Rank": "7239",
    "Name": "Totens Sparebank",
    "Symbol": "TOTG.OL",
    " marketcap ": " $137 863 771 ",
    "price (USD)": "22.5101",
    "country": "Norway"
  },
  {
    "Rank": "7240",
    "Name": "Mekdam Holding Group",
    "Symbol": "MKDM.QA",
    " marketcap ": " $137 855 771 ",
    "price (USD)": "1.02115",
    "country": "Qatar"
  },
  {
    "Rank": "7241",
    "Name": "Seres Therapeutics",
    "Symbol": "MCRB",
    " marketcap ": " $137 832 816 ",
    "price (USD)": "0.9101",
    "country": "United States"
  },
  {
    "Rank": "7242",
    "Name": "Al Gassim Investment Holding",
    "Symbol": "6020.SR",
    " marketcap ": " $137 539 028 ",
    "price (USD)": "4.58463",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7243",
    "Name": "Caltagirone Editore",
    "Symbol": "CED.MI",
    " marketcap ": " $137 454 143 ",
    "price (USD)": "1.25964",
    "country": "Italy"
  },
  {
    "Rank": "7244",
    "Name": "Village Farms International",
    "Symbol": "VFF",
    " marketcap ": " $137 260 000 ",
    "price (USD)": "1.245",
    "country": "Canada"
  },
  {
    "Rank": "7245",
    "Name": "Hawthorn Bancshares",
    "Symbol": "HWBK",
    " marketcap ": " $137 235 680 ",
    "price (USD)": "19.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7246",
    "Name": "Bliss GVS Pharma",
    "Symbol": "BLISSGVS.NS",
    " marketcap ": " $136 794 222 ",
    "price (USD)": "1.30487",
    "country": "India"
  },
  {
    "Rank": "7247",
    "Name": "POET Technologies",
    "Symbol": "POET",
    " marketcap ": " $136 733 568 ",
    "price (USD)": "\u0444\u0435\u0432.23",
    "country": "Canada"
  },
  {
    "Rank": "7248",
    "Name": "Corvus Pharmaceuticals",
    "Symbol": "CRVS",
    " marketcap ": " $136 361 840 ",
    "price (USD)": "\u0444\u0435\u0432.18",
    "country": "United States"
  },
  {
    "Rank": "7249",
    "Name": "Orient Paper Mills",
    "Symbol": "ORIENTPPR.NS",
    " marketcap ": " $136 217 375 ",
    "price (USD)": "0.640417",
    "country": "India"
  },
  {
    "Rank": "7250",
    "Name": "RAK Co. for White Cement &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7251",
    "Name": "MainStreet Bancshares",
    "Symbol": "MNSB",
    " marketcap ": " $135 967 200 ",
    "price (USD)": "17.85",
    "country": "United States"
  },
  {
    "Rank": "7252",
    "Name": "Drecom",
    "Symbol": "3793.T",
    " marketcap ": " $135 775 418 ",
    "price (USD)": "4.74698",
    "country": "Japan"
  },
  {
    "Rank": "7253",
    "Name": "Satellogic",
    "Symbol": "SATL",
    " marketcap ": " $135 564 064 ",
    "price (USD)": "1.465",
    "country": "United States"
  },
  {
    "Rank": "7254",
    "Name": "Genelux",
    "Symbol": "GNLX",
    " marketcap ": " $135 523 440 ",
    "price (USD)": "05.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7255",
    "Name": "Weight Watchers",
    "Symbol": "WW",
    " marketcap ": " $135 440 048 ",
    "price (USD)": "\u044f\u043d\u0432.71",
    "country": "United States"
  },
  {
    "Rank": "7256",
    "Name": "Quipt Home Medical",
    "Symbol": "QIPT",
    " marketcap ": " $135 377 376 ",
    "price (USD)": "\u043c\u0430\u0440.18",
    "country": "United States"
  },
  {
    "Rank": "7257",
    "Name": "aTyr Pharma",
    "Symbol": "LIFE",
    " marketcap ": " $134 571 248 ",
    "price (USD)": "\u044f\u043d\u0432.95",
    "country": "United States"
  },
  {
    "Rank": "7258",
    "Name": "Scilex Holding",
    "Symbol": "SCLX",
    " marketcap ": " $134 444 304 ",
    "price (USD)": "01.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "7259",
    "Name": "TAT Technologies",
    "Symbol": "TATT",
    " marketcap ": " $134 364 576 ",
    "price (USD)": "13.\u043c\u0430\u0440",
    "country": "Israel"
  },
  {
    "Rank": "7260",
    "Name": "Saudi Cable Company",
    "Symbol": "2110.SR",
    " marketcap ": " $134 088 582 ",
    "price (USD)": "20.0945",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7261",
    "Name": "FinWise Bancorp",
    "Symbol": "FINW",
    " marketcap ": " $134 076 920 ",
    "price (USD)": "\u043e\u043a\u0442.48",
    "country": "United States"
  },
  {
    "Rank": "7262",
    "Name": "Jushi Holdings",
    "Symbol": "JUSHF",
    " marketcap ": " $133 894 216 ",
    "price (USD)": "0.6809",
    "country": "United States"
  },
  {
    "Rank": "7263",
    "Name": "Geospace Technologies",
    "Symbol": "GEOS",
    " marketcap ": " $133 888 248 ",
    "price (USD)": "10.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7264",
    "Name": "Seer",
    "Symbol": "SEER",
    " marketcap ": " $133 769 600 ",
    "price (USD)": "02.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7265",
    "Name": "Tanzanian Gold Corporation",
    "Symbol": "TRX",
    " marketcap ": " $133 474 800 ",
    "price (USD)": "0.478",
    "country": "Canada"
  },
  {
    "Rank": "7266",
    "Name": "Widam Food Company",
    "Symbol": "WDAM.QA",
    " marketcap ": " $133 467 024 ",
    "price (USD)": "0.741484",
    "country": "Qatar"
  },
  {
    "Rank": "7267",
    "Name": "Computer Programs and Systems",
    "Symbol": "CPSI",
    " marketcap ": " $133 326 672 ",
    "price (USD)": "\u0441\u0435\u043d.19",
    "country": "United States"
  },
  {
    "Rank": "7268",
    "Name": "Idaho Strategic Resources",
    "Symbol": "IDR",
    " marketcap ": " $133 264 584 ",
    "price (USD)": "\u043e\u043a\u0442.46",
    "country": "United States"
  },
  {
    "Rank": "7269",
    "Name": "Al Batinah Power",
    "Symbol": "BATP.OM",
    " marketcap ": " $133 259 144 ",
    "price (USD)": "0.197454",
    "country": "Oman"
  },
  {
    "Rank": "7270",
    "Name": "Rekor Systems",
    "Symbol": "REKR",
    " marketcap ": " $133 158 952 ",
    "price (USD)": "\u044f\u043d\u0432.56",
    "country": "United States"
  },
  {
    "Rank": "7271",
    "Name": "Richmond Mutual Bancorporation",
    "Symbol": "RMBI",
    " marketcap ": " $132 786 000 ",
    "price (USD)": "12",
    "country": "United States"
  },
  {
    "Rank": "7272",
    "Name": "Lument Finance Trust",
    "Symbol": "LFT",
    " marketcap ": " $132 733 544 ",
    "price (USD)": "\u0444\u0435\u0432.54",
    "country": "United States"
  },
  {
    "Rank": "7273",
    "Name": "Indorama Synthetics",
    "Symbol": "INDORAMA.NS",
    " marketcap ": " $132 710 292 ",
    "price (USD)": "0.508249",
    "country": "India"
  },
  {
    "Rank": "7274",
    "Name": "Origin Materials",
    "Symbol": "ORGN",
    " marketcap ": " $132 319 800 ",
    "price (USD)": "0.9",
    "country": "United States"
  },
  {
    "Rank": "7275",
    "Name": "Adicet Bio",
    "Symbol": "ACET",
    " marketcap ": " $132 299 344 ",
    "price (USD)": "\u044f\u043d\u0432.61",
    "country": "United States"
  },
  {
    "Rank": "7276",
    "Name": "ESS Tech",
    "Symbol": "GWH",
    " marketcap ": " $132 291 240 ",
    "price (USD)": "0.7563",
    "country": "United States"
  },
  {
    "Rank": "7277",
    "Name": "Lai Sun Development Company",
    "Symbol": "0488.HK",
    " marketcap ": " $132 223 677 ",
    "price (USD)": "0.0909798",
    "country": "Hong Kong"
  },
  {
    "Rank": "7278",
    "Name": "Mayar Holding Company",
    "Symbol": "9568.SR",
    " marketcap ": " $131 932 790 ",
    "price (USD)": "1.09946",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7279",
    "Name": "Citius Pharmaceuticals",
    "Symbol": "CTXR",
    " marketcap ": " $131 891 288 ",
    "price (USD)": "0.73",
    "country": "United States"
  },
  {
    "Rank": "7280",
    "Name": "Karyopharm Therapeutics",
    "Symbol": "KPTI",
    " marketcap ": " $131 835 200 ",
    "price (USD)": "01.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "7281",
    "Name": "Vigil Neuroscience",
    "Symbol": "VIGL",
    " marketcap ": " $131 545 048 ",
    "price (USD)": "03.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7282",
    "Name": "Everspin Technologies",
    "Symbol": "MRAM",
    " marketcap ": " $131 279 320 ",
    "price (USD)": "06.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7283",
    "Name": "OptiNose",
    "Symbol": "OPTN",
    " marketcap ": " $131 125 240 ",
    "price (USD)": "\u044f\u043d\u0432.16",
    "country": "United States"
  },
  {
    "Rank": "7284",
    "Name": "Bright Health",
    "Symbol": "BHG",
    " marketcap ": " $130 805 400 ",
    "price (USD)": "16.35",
    "country": "United States"
  },
  {
    "Rank": "7285",
    "Name": "PDS Biotechnology",
    "Symbol": "PDSB",
    " marketcap ": " $130 578 304 ",
    "price (USD)": "\u043c\u0430\u0440.56",
    "country": "United States"
  },
  {
    "Rank": "7286",
    "Name": "Allied Tecnologia",
    "Symbol": "ALLD3.SA",
    " marketcap ": " $130 477 690 ",
    "price (USD)": "\u044f\u043d\u0432.58",
    "country": "Brazil"
  },
  {
    "Rank": "7287",
    "Name": "Andrew Peller",
    "Symbol": "ADW-A.TO",
    " marketcap ": " $130 447 585 ",
    "price (USD)": "2.90333",
    "country": "Canada"
  },
  {
    "Rank": "7288",
    "Name": "Akoya Biosciences",
    "Symbol": "AKYA",
    " marketcap ": " $130 379 576 ",
    "price (USD)": "\u0444\u0435\u0432.64",
    "country": "United States"
  },
  {
    "Rank": "7289",
    "Name": "Lakeland Industries",
    "Symbol": "LAKE",
    " marketcap ": " $130 292 304 ",
    "price (USD)": "17.66",
    "country": "United States"
  },
  {
    "Rank": "7290",
    "Name": "Bj\u0413\u00b6rn Borg",
    "Symbol": "BORG.ST",
    " marketcap ": " $130 173 919 ",
    "price (USD)": "5.17623",
    "country": "Sweden"
  },
  {
    "Rank": "7291",
    "Name": "NGM Biopharmaceuticals",
    "Symbol": "NGM",
    " marketcap ": " $128 532 096 ",
    "price (USD)": "\u044f\u043d\u0432.54",
    "country": "United States"
  },
  {
    "Rank": "7292",
    "Name": "Alliance Entertainment",
    "Symbol": "AENT",
    " marketcap ": " $128 345 616 ",
    "price (USD)": "\u0444\u0435\u0432.52",
    "country": "United States"
  },
  {
    "Rank": "7293",
    "Name": "BankFinancial",
    "Symbol": "BFIN",
    " marketcap ": " $128 095 992 ",
    "price (USD)": "\u043e\u043a\u0442.28",
    "country": "United States"
  },
  {
    "Rank": "7294",
    "Name": "Al-Mazaya Holding Company",
    "Symbol": "MAZAYA.KW",
    " marketcap ": " $128 042 947 ",
    "price (USD)": "256.519",
    "country": "Kuwait"
  },
  {
    "Rank": "7295",
    "Name": "Alto Ingredients",
    "Symbol": "ALTO",
    " marketcap ": " $127 971 592 ",
    "price (USD)": "\u044f\u043d\u0432.67",
    "country": "United States"
  },
  {
    "Rank": "7296",
    "Name": "Friedman Industries",
    "Symbol": "FRD",
    " marketcap ": " $127 666 464 ",
    "price (USD)": "18.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "7297",
    "Name": "Oman Oil Marketing Company (oomco)",
    "Symbol": "OOMS.OM",
    " marketcap ": " $127 357 755 ",
    "price (USD)": "2.07846",
    "country": "Oman"
  },
  {
    "Rank": "7298",
    "Name": "Hyzon Motors",
    "Symbol": "HYZN",
    " marketcap ": " $127 344 880 ",
    "price (USD)": "0.5163",
    "country": "United States"
  },
  {
    "Rank": "7299",
    "Name": "Devolver Digital",
    "Symbol": "DEVO.L",
    " marketcap ": " $127 245 128 ",
    "price (USD)": "0.286052",
    "country": "United States"
  },
  {
    "Rank": "7300",
    "Name": "Great Ajax",
    "Symbol": "AJX",
    " marketcap ": " $127 221 520 ",
    "price (USD)": "\u043c\u0430\u0440.44",
    "country": "United States"
  },
  {
    "Rank": "7301",
    "Name": "Loop Industries",
    "Symbol": "LOOP",
    " marketcap ": " $126 902 168 ",
    "price (USD)": "\u0444\u0435\u0432.67",
    "country": "Canada"
  },
  {
    "Rank": "7302",
    "Name": "Canacol Energy",
    "Symbol": "CNE.TO",
    " marketcap ": " $126 795 534 ",
    "price (USD)": "3.71715",
    "country": "Canada"
  },
  {
    "Rank": "7303",
    "Name": "Mynaric",
    "Symbol": "MYNA",
    " marketcap ": " $126 745 080 ",
    "price (USD)": "\u0430\u043f\u0440.84",
    "country": "Germany"
  },
  {
    "Rank": "7304",
    "Name": "The Cannabist Company",
    "Symbol": "CBSTF",
    " marketcap ": " $126 663 552 ",
    "price (USD)": "0.2662",
    "country": "United States"
  },
  {
    "Rank": "7305",
    "Name": "Allakos",
    "Symbol": "ALLK",
    " marketcap ": " $126 618 624 ",
    "price (USD)": "\u044f\u043d\u0432.43",
    "country": "United States"
  },
  {
    "Rank": "7306",
    "Name": "Elevate Uranium",
    "Symbol": "EL8.AX",
    " marketcap ": " $126 490 259 ",
    "price (USD)": "0.410087",
    "country": "Australia"
  },
  {
    "Rank": "7307",
    "Name": "Wielton",
    "Symbol": "WLT.WA",
    " marketcap ": " $126 436 555 ",
    "price (USD)": "2.09419",
    "country": "Poland"
  },
  {
    "Rank": "7308",
    "Name": "Coya Therapeutics",
    "Symbol": "COYA",
    " marketcap ": " $126 336 792 ",
    "price (USD)": "08.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "7309",
    "Name": "Dubai National Insurance & Reinsurance Company",
    "Symbol": "DNIR.AE",
    " marketcap ": " $125 789 588 ",
    "price (USD)": "1.08909",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7310",
    "Name": "Amprius Technologies",
    "Symbol": "AMPX",
    " marketcap ": " $125 648 704 ",
    "price (USD)": "\u044f\u043d\u0432.33",
    "country": "United States"
  },
  {
    "Rank": "7311",
    "Name": "ContextLogic (wish.com)",
    "Symbol": "WISH",
    " marketcap ": " $125 645 504 ",
    "price (USD)": "\u043c\u0430\u0439.13",
    "country": "United States"
  },
  {
    "Rank": "7312",
    "Name": "AlphaPolis",
    "Symbol": "9467.T",
    " marketcap ": " $125 435 042 ",
    "price (USD)": "\u0434\u0435\u043a.86",
    "country": "Japan"
  },
  {
    "Rank": "7313",
    "Name": "Microvast",
    "Symbol": "MVST",
    " marketcap ": " $125 383 272 ",
    "price (USD)": "0.3974",
    "country": "United States"
  },
  {
    "Rank": "7314",
    "Name": "Sportsman's Warehouse",
    "Symbol": "SPWH",
    " marketcap ": " $125 291 248 ",
    "price (USD)": "\u043c\u0430\u0440.33",
    "country": "United States"
  },
  {
    "Rank": "7315",
    "Name": "Kinnate Biopharma",
    "Symbol": "KNTE",
    " marketcap ": " $124 990 968 ",
    "price (USD)": "\u0444\u0435\u0432.65",
    "country": "United States"
  },
  {
    "Rank": "7316",
    "Name": "SRP Groupe (Showroomprive.com)",
    "Symbol": "SRP.PA",
    " marketcap ": " $124 595 504 ",
    "price (USD)": "1.08589",
    "country": "France"
  },
  {
    "Rank": "7317",
    "Name": "Bassett Furniture",
    "Symbol": "BSET",
    " marketcap ": " $124 573 656 ",
    "price (USD)": "14.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "7318",
    "Name": "BBX Capital Corporation",
    "Symbol": "BBXIA",
    " marketcap ": " $124 558 000 ",
    "price (USD)": "\u0430\u0432\u0433.75",
    "country": "United States"
  },
  {
    "Rank": "7319",
    "Name": "A'Saffa Foods",
    "Symbol": "SPFI.OM",
    " marketcap ": " $124 395 947 ",
    "price (USD)": "1.03663",
    "country": "Oman"
  },
  {
    "Rank": "7320",
    "Name": "Bloober Team",
    "Symbol": "6BO.SG",
    " marketcap ": " $124 036 990 ",
    "price (USD)": "5.86383",
    "country": "Poland"
  },
  {
    "Rank": "7321",
    "Name": "Sangamo Therapeutics",
    "Symbol": "SGMO",
    " marketcap ": " $123 966 472 ",
    "price (USD)": "0.5974",
    "country": "United States"
  },
  {
    "Rank": "7322",
    "Name": "Regulus Therapeutics",
    "Symbol": "RGLS",
    " marketcap ": " $123 730 552 ",
    "price (USD)": "\u044f\u043d\u0432.89",
    "country": "United States"
  },
  {
    "Rank": "7323",
    "Name": "NaaS Technology",
    "Symbol": "NAAS",
    " marketcap ": " $123 687 992 ",
    "price (USD)": "0.4802",
    "country": "China"
  },
  {
    "Rank": "7324",
    "Name": "Xunlei",
    "Symbol": "XNET",
    " marketcap ": " $123 600 000 ",
    "price (USD)": "\u044f\u043d\u0432.92",
    "country": "China"
  },
  {
    "Rank": "7325",
    "Name": "Trinseo",
    "Symbol": "TSE",
    " marketcap ": " $123 529 696 ",
    "price (USD)": "03.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7326",
    "Name": "Oportun Financial",
    "Symbol": "OPRT",
    " marketcap ": " $123 494 872 ",
    "price (USD)": "\u043c\u0430\u0440.47",
    "country": "United States"
  },
  {
    "Rank": "7327",
    "Name": "Imperial Petroleum",
    "Symbol": "IMPP",
    " marketcap ": " $123 318 824 ",
    "price (USD)": "\u0430\u043f\u0440.19",
    "country": "Greece"
  },
  {
    "Rank": "7328",
    "Name": "Molecular Partners",
    "Symbol": "MOLN",
    " marketcap ": " $122 596 736 ",
    "price (USD)": "\u043c\u0430\u0440.58",
    "country": "Switzerland"
  },
  {
    "Rank": "7329",
    "Name": "Amylyx Pharmaceuticals",
    "Symbol": "AMLX",
    " marketcap ": " $122 410 440 ",
    "price (USD)": "01.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "7330",
    "Name": "inTEST Corporation",
    "Symbol": "INTT",
    " marketcap ": " $122 273 184 ",
    "price (USD)": "\u0441\u0435\u043d.79",
    "country": "United States"
  },
  {
    "Rank": "7331",
    "Name": "Caisse R\u0413\u00a9gionale de Cr\u0413\u00a9dit Agricole du Morbihan",
    "Symbol": "CMO.PA",
    " marketcap ": " $122 001 876 ",
    "price (USD)": "77.6414",
    "country": "France"
  },
  {
    "Rank": "7332",
    "Name": "Raydan Food",
    "Symbol": "6012.SR",
    " marketcap ": " $121 707 691 ",
    "price (USD)": "7.69888",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7333",
    "Name": "Saga Communications",
    "Symbol": "SGA",
    " marketcap ": " $121 694 752 ",
    "price (USD)": "19.43",
    "country": "United States"
  },
  {
    "Rank": "7334",
    "Name": "Kaldal\u0413\u0456n",
    "Symbol": "KALD.IC",
    " marketcap ": " $121 553 749 ",
    "price (USD)": "0.108578",
    "country": "Iceland"
  },
  {
    "Rank": "7335",
    "Name": "Omega Therapeutics",
    "Symbol": "OMGA",
    " marketcap ": " $120 789 456 ",
    "price (USD)": "\u0444\u0435\u0432.19",
    "country": "United States"
  },
  {
    "Rank": "7336",
    "Name": "CBAK Energy",
    "Symbol": "CBAT",
    " marketcap ": " $120 518 528 ",
    "price (USD)": "\u044f\u043d\u0432.34",
    "country": "China"
  },
  {
    "Rank": "7337",
    "Name": "Rent the Runway",
    "Symbol": "RENT",
    " marketcap ": " $120 302 576 ",
    "price (USD)": "32.76",
    "country": "United States"
  },
  {
    "Rank": "7338",
    "Name": "PHX Minerals",
    "Symbol": "PHX",
    " marketcap ": " $120 241 784 ",
    "price (USD)": "\u043c\u0430\u0440.21",
    "country": "United States"
  },
  {
    "Rank": "7339",
    "Name": "Hanover Bancorp",
    "Symbol": "HNVR",
    " marketcap ": " $120 123 712 ",
    "price (USD)": "16.57",
    "country": "United States"
  },
  {
    "Rank": "7340",
    "Name": "Transaction Capital",
    "Symbol": "TCP.JO",
    " marketcap ": " $119 380 600 ",
    "price (USD)": "0.142801",
    "country": "South Africa"
  },
  {
    "Rank": "7341",
    "Name": "Solo Brands",
    "Symbol": "DTC",
    " marketcap ": " $119 303 232 ",
    "price (USD)": "02.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7342",
    "Name": "ARC Document Solutions",
    "Symbol": "ARC",
    " marketcap ": " $118 743 072 ",
    "price (USD)": "\u0444\u0435\u0432.75",
    "country": "United States"
  },
  {
    "Rank": "7343",
    "Name": "FibroGen",
    "Symbol": "FGEN",
    " marketcap ": " $118 375 728 ",
    "price (USD)": "\u044f\u043d\u0432.19",
    "country": "United States"
  },
  {
    "Rank": "7344",
    "Name": "VistaGen Therapeutics",
    "Symbol": "VTGN",
    " marketcap ": " $118 370 376 ",
    "price (USD)": "\u0430\u043f\u0440.38",
    "country": "United States"
  },
  {
    "Rank": "7345",
    "Name": "Nacon",
    "Symbol": "NACON.PA",
    " marketcap ": " $118 048 535 ",
    "price (USD)": "1.32913",
    "country": "France"
  },
  {
    "Rank": "7346",
    "Name": "Semantix",
    "Symbol": "STIX",
    " marketcap ": " $117 666 008 ",
    "price (USD)": "0.3",
    "country": "Brazil"
  },
  {
    "Rank": "7347",
    "Name": "Al Ain Alahlia Insurance",
    "Symbol": "ALAIN.AE",
    " marketcap ": " $117 624 636 ",
    "price (USD)": "\u0438\u044e\u043b.84",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7348",
    "Name": "Vor Biopharma",
    "Symbol": "VOR",
    " marketcap ": " $117 406 512 ",
    "price (USD)": "\u044f\u043d\u0432.72",
    "country": "United States"
  },
  {
    "Rank": "7349",
    "Name": "Martin Midstream Partners",
    "Symbol": "MMLP",
    " marketcap ": " $116 613 288 ",
    "price (USD)": "\u0444\u0435\u0432.99",
    "country": "United States"
  },
  {
    "Rank": "7350",
    "Name": "Iceland Seafood International",
    "Symbol": "ICESEA.IC",
    " marketcap ": " $116 456 897 ",
    "price (USD)": "0.0380022",
    "country": "Iceland"
  },
  {
    "Rank": "7351",
    "Name": "Largo",
    "Symbol": "LGO",
    " marketcap ": " $116 155 120 ",
    "price (USD)": "\u044f\u043d\u0432.81",
    "country": "Canada"
  },
  {
    "Rank": "7352",
    "Name": "Societal CDMO",
    "Symbol": "SCTL",
    " marketcap ": " $116 130 304 ",
    "price (USD)": "01.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7353",
    "Name": "Nusantara Pelabuhan Handal",
    "Symbol": "PORT.JK",
    " marketcap ": " $116 118 565 ",
    "price (USD)": "0.0412655",
    "country": "Indonesia"
  },
  {
    "Rank": "7354",
    "Name": "Veritone",
    "Symbol": "VERI",
    " marketcap ": " $115 857 808 ",
    "price (USD)": "03.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "7355",
    "Name": "ECB Bancorp",
    "Symbol": "ECBK",
    " marketcap ": " $115 638 904 ",
    "price (USD)": "\u0434\u0435\u043a.61",
    "country": "United States"
  },
  {
    "Rank": "7356",
    "Name": "Vox Royalty",
    "Symbol": "VOXR",
    " marketcap ": " $115 569 248 ",
    "price (USD)": "02.\u043c\u0430\u0440",
    "country": "Canada"
  },
  {
    "Rank": "7357",
    "Name": "Hurco Companies",
    "Symbol": "HURC",
    " marketcap ": " $115 482 032 ",
    "price (USD)": "17.75",
    "country": "United States"
  },
  {
    "Rank": "7358",
    "Name": "Nok Air",
    "Symbol": "NOKPF",
    " marketcap ": " $115 461 440 ",
    "price (USD)": "0.0032",
    "country": "Thailand"
  },
  {
    "Rank": "7359",
    "Name": "So-Young International",
    "Symbol": "SY",
    " marketcap ": " $114 998 240 ",
    "price (USD)": "01.\u0434\u0435\u043a",
    "country": "China"
  },
  {
    "Rank": "7360",
    "Name": "Serve Robotics",
    "Symbol": "SERV",
    " marketcap ": " $114 950 168 ",
    "price (USD)": "03.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7361",
    "Name": "Unifi",
    "Symbol": "UFI",
    " marketcap ": " $114 801 936 ",
    "price (USD)": "\u0438\u044e\u043d.29",
    "country": "United States"
  },
  {
    "Rank": "7362",
    "Name": "Enad Global 7",
    "Symbol": "EG7.ST",
    " marketcap ": " $114 699 511 ",
    "price (USD)": "1.29453",
    "country": "Sweden"
  },
  {
    "Rank": "7363",
    "Name": "Zentek",
    "Symbol": "ZTEK",
    " marketcap ": " $114 628 640 ",
    "price (USD)": "01.\u0434\u0435\u043a",
    "country": "Canada"
  },
  {
    "Rank": "7364",
    "Name": "Skillz",
    "Symbol": "SKLZ",
    " marketcap ": " $114 491 136 ",
    "price (USD)": "\u0438\u044e\u043d.35",
    "country": "United States"
  },
  {
    "Rank": "7365",
    "Name": "Immunic",
    "Symbol": "IMUX",
    " marketcap ": " $114 400 328 ",
    "price (USD)": "\u044f\u043d\u0432.27",
    "country": "United States"
  },
  {
    "Rank": "7366",
    "Name": "Adagene",
    "Symbol": "ADAG",
    " marketcap ": " $114 366 624 ",
    "price (USD)": "\u0444\u0435\u0432.59",
    "country": "China"
  },
  {
    "Rank": "7367",
    "Name": "Westwood Holdings Group",
    "Symbol": "WHG",
    " marketcap ": " $113 993 808 ",
    "price (USD)": "\u0434\u0435\u043a.24",
    "country": "United States"
  },
  {
    "Rank": "7368",
    "Name": "Atlantic Sapphire",
    "Symbol": "ASA.OL",
    " marketcap ": " $113 794 309 ",
    "price (USD)": "0.101504",
    "country": "Norway"
  },
  {
    "Rank": "7369",
    "Name": "Synchronoss",
    "Symbol": "SNCR",
    " marketcap ": " $113 749 784 ",
    "price (USD)": "\u043e\u043a\u0442.54",
    "country": "United States"
  },
  {
    "Rank": "7370",
    "Name": "Office Properties Income Trust",
    "Symbol": "OPI",
    " marketcap ": " $113 587 264 ",
    "price (USD)": "\u0444\u0435\u0432.33",
    "country": "United States"
  },
  {
    "Rank": "7371",
    "Name": "Atomera",
    "Symbol": "ATOM",
    " marketcap ": " $113 464 824 ",
    "price (USD)": "\u0430\u043f\u0440.22",
    "country": "United States"
  },
  {
    "Rank": "7372",
    "Name": "ReneSola",
    "Symbol": "SOL",
    " marketcap ": " $113 417 368 ",
    "price (USD)": "\u044f\u043d\u0432.98",
    "country": "United States"
  },
  {
    "Rank": "7373",
    "Name": "William Penn Bancorp",
    "Symbol": "WMPN",
    " marketcap ": " $113 227 200 ",
    "price (USD)": "12",
    "country": "United States"
  },
  {
    "Rank": "7374",
    "Name": "Gulf Island Fabrication",
    "Symbol": "GIFI",
    " marketcap ": " $113 163 368 ",
    "price (USD)": "\u0438\u044e\u043d.95",
    "country": "United States"
  },
  {
    "Rank": "7375",
    "Name": "Ohio Valley Banc Corp",
    "Symbol": "OVBC",
    " marketcap ": " $113 130 616 ",
    "price (USD)": "23.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7376",
    "Name": "Kolibri Global Energy",
    "Symbol": "KGEI",
    " marketcap ": " $112 958 344 ",
    "price (USD)": "03.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "7377",
    "Name": "Brooge Energy",
    "Symbol": "BROG",
    " marketcap ": " $112 875 640 ",
    "price (USD)": "01.\u043c\u0430\u0440",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7378",
    "Name": "Flotek Industries",
    "Symbol": "FTK",
    " marketcap ": " $112 695 840 ",
    "price (USD)": "03.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "7379",
    "Name": "Umm Al Qaiwain General Investment",
    "Symbol": "QIC.AE",
    " marketcap ": " $112 674 599 ",
    "price (USD)": "0.31",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7380",
    "Name": "Bank of Innovation",
    "Symbol": "4393.T",
    " marketcap ": " $112 642 910 ",
    "price (USD)": "28.3411",
    "country": "Japan"
  },
  {
    "Rank": "7381",
    "Name": "BioAtla",
    "Symbol": "BCAB",
    " marketcap ": " $112 110 040 ",
    "price (USD)": "\u0444\u0435\u0432.33",
    "country": "United States"
  },
  {
    "Rank": "7382",
    "Name": "Advanced Emissions Solutions",
    "Symbol": "ADES",
    " marketcap ": " $111 681 024 ",
    "price (USD)": "\u043c\u0430\u0440.36",
    "country": "United States"
  },
  {
    "Rank": "7383",
    "Name": "Nuvectis Pharma",
    "Symbol": "NVCT",
    " marketcap ": " $111 605 088 ",
    "price (USD)": "06.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "7384",
    "Name": "Kellton Tech Solutions",
    "Symbol": "KELLTONTEC.NS",
    " marketcap ": " $111 538 577 ",
    "price (USD)": "1.15107",
    "country": "India"
  },
  {
    "Rank": "7385",
    "Name": "Clearside Biomedical",
    "Symbol": "CLSD",
    " marketcap ": " $111 349 344 ",
    "price (USD)": "\u044f\u043d\u0432.49",
    "country": "United States"
  },
  {
    "Rank": "7386",
    "Name": "Myomo",
    "Symbol": "MYO",
    " marketcap ": " $111 224 352 ",
    "price (USD)": "\u043c\u0430\u0440.86",
    "country": "United States"
  },
  {
    "Rank": "7387",
    "Name": "HUB Cyber Security",
    "Symbol": "HUBC",
    " marketcap ": " $111 214 625 ",
    "price (USD)": "0.8915",
    "country": "Israel"
  },
  {
    "Rank": "7388",
    "Name": "Bodal Chemicals",
    "Symbol": "BODALCHEM.NS",
    " marketcap ": " $111 012 963 ",
    "price (USD)": "0.882526",
    "country": "India"
  },
  {
    "Rank": "7389",
    "Name": "Mega Uranium",
    "Symbol": "MGA.TO",
    " marketcap ": " $110 576 605 ",
    "price (USD)": "0.300598",
    "country": "Canada"
  },
  {
    "Rank": "7390",
    "Name": "111, Inc.",
    "Symbol": "YI",
    " marketcap ": " $110 506 952 ",
    "price (USD)": "\u044f\u043d\u0432.29",
    "country": "China"
  },
  {
    "Rank": "7391",
    "Name": "Allbirds",
    "Symbol": "BIRD",
    " marketcap ": " $110 476 392 ",
    "price (USD)": "0.7089",
    "country": "United States"
  },
  {
    "Rank": "7392",
    "Name": "Red Robin",
    "Symbol": "RRGB",
    " marketcap ": " $110 318 872 ",
    "price (USD)": "07.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "7393",
    "Name": "NANO Nuclear Energy",
    "Symbol": "NNE",
    " marketcap ": " $110 278 264 ",
    "price (USD)": "\u043c\u0430\u0440.86",
    "country": "United States"
  },
  {
    "Rank": "7394",
    "Name": "PMV Pharmaceuticals",
    "Symbol": "PMVP",
    " marketcap ": " $109 574 664 ",
    "price (USD)": "\u0444\u0435\u0432.13",
    "country": "United States"
  },
  {
    "Rank": "7395",
    "Name": "China Automotive Systems",
    "Symbol": "CAAS",
    " marketcap ": " $109 574 096 ",
    "price (USD)": "\u043c\u0430\u0440.63",
    "country": "China"
  },
  {
    "Rank": "7396",
    "Name": "DHI Group",
    "Symbol": "DHX",
    " marketcap ": " $109 248 624 ",
    "price (USD)": "\u0444\u0435\u0432.26",
    "country": "United States"
  },
  {
    "Rank": "7397",
    "Name": "Travelzoo",
    "Symbol": "TZOO",
    " marketcap ": " $109 237 320 ",
    "price (USD)": "\u0430\u0432\u0433.34",
    "country": "United States"
  },
  {
    "Rank": "7398",
    "Name": "Airship AI",
    "Symbol": "AISP",
    " marketcap ": " $109 079 360 ",
    "price (USD)": "\u0430\u043f\u0440.71",
    "country": "United States"
  },
  {
    "Rank": "7399",
    "Name": "Ringmetall",
    "Symbol": "HP3A.DE",
    " marketcap ": " $108 902 213 ",
    "price (USD)": "3.74634",
    "country": "Germany"
  },
  {
    "Rank": "7400",
    "Name": "Li-Cycle",
    "Symbol": "LICY",
    " marketcap ": " $108 792 928 ",
    "price (USD)": "0.6075",
    "country": "Canada"
  },
  {
    "Rank": "7401",
    "Name": "Troops",
    "Symbol": "TROO",
    " marketcap ": " $108 709 864 ",
    "price (USD)": "01.\u0438\u044e\u043b",
    "country": "Hong Kong"
  },
  {
    "Rank": "7402",
    "Name": "Vacasa",
    "Symbol": "VCSA",
    " marketcap ": " $108 567 496 ",
    "price (USD)": "\u0430\u043f\u0440.84",
    "country": "United States"
  },
  {
    "Rank": "7403",
    "Name": "Nova Kl\u0413\u0454bburinn",
    "Symbol": "NOVA.IC",
    " marketcap ": " $108 291 040 ",
    "price (USD)": "0.028375",
    "country": "Iceland"
  },
  {
    "Rank": "7404",
    "Name": "Union Bankshares",
    "Symbol": "UNB",
    " marketcap ": " $108 239 392 ",
    "price (USD)": "23.95",
    "country": "United States"
  },
  {
    "Rank": "7405",
    "Name": "Planet Image International",
    "Symbol": "YIBO",
    " marketcap ": " $107 763 200 ",
    "price (USD)": "2",
    "country": "China"
  },
  {
    "Rank": "7406",
    "Name": "4Front Ventures",
    "Symbol": "FFNTF",
    " marketcap ": " $107 568 856 ",
    "price (USD)": "0.1177",
    "country": "United States"
  },
  {
    "Rank": "7407",
    "Name": "VirTra",
    "Symbol": "VTSI",
    " marketcap ": " $107 541 896 ",
    "price (USD)": "\u0441\u0435\u043d.68",
    "country": "United States"
  },
  {
    "Rank": "7408",
    "Name": "Alithya Group",
    "Symbol": "ALYA",
    " marketcap ": " $106 977 208 ",
    "price (USD)": "\u044f\u043d\u0432.13",
    "country": "Canada"
  },
  {
    "Rank": "7409",
    "Name": "Westport Fuel Systems",
    "Symbol": "WPRT",
    " marketcap ": " $106 378 824 ",
    "price (USD)": "\u0438\u044e\u043d.17",
    "country": "Canada"
  },
  {
    "Rank": "7410",
    "Name": "Mister Spex",
    "Symbol": "MRX.F",
    " marketcap ": " $106 195 296 ",
    "price (USD)": "3.11652",
    "country": "Germany"
  },
  {
    "Rank": "7411",
    "Name": "iHuman",
    "Symbol": "IH",
    " marketcap ": " $106 009 408 ",
    "price (USD)": "02.\u044f\u043d\u0432",
    "country": "China"
  },
  {
    "Rank": "7412",
    "Name": "Cato Fashion",
    "Symbol": "CATO",
    " marketcap ": " $105 902 544 ",
    "price (USD)": "\u043c\u0430\u0439.15",
    "country": "United States"
  },
  {
    "Rank": "7413",
    "Name": "Superior Industries International",
    "Symbol": "SUP",
    " marketcap ": " $105 534 736 ",
    "price (USD)": "\u043c\u0430\u0440.69",
    "country": "United States"
  },
  {
    "Rank": "7414",
    "Name": "Landmark Bancorp",
    "Symbol": "LARK",
    " marketcap ": " $105 372 000 ",
    "price (USD)": "19.25",
    "country": "United States"
  },
  {
    "Rank": "7415",
    "Name": "First Northwest Bancorp",
    "Symbol": "FNWB",
    " marketcap ": " $105 186 000 ",
    "price (USD)": "\u043d\u043e\u044f.14",
    "country": "United States"
  },
  {
    "Rank": "7416",
    "Name": "Gaia",
    "Symbol": "GAIA",
    " marketcap ": " $104 803 616 ",
    "price (USD)": "\u0430\u043f\u0440.47",
    "country": "United States"
  },
  {
    "Rank": "7417",
    "Name": "Luna Innovations",
    "Symbol": "LUNA",
    " marketcap ": " $104 784 936 ",
    "price (USD)": "03.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7418",
    "Name": "Intevac",
    "Symbol": "IVAC",
    " marketcap ": " $104 741 352 ",
    "price (USD)": "\u043c\u0430\u0440.94",
    "country": "United States"
  },
  {
    "Rank": "7419",
    "Name": "M\u0413\u00a9liuz",
    "Symbol": "CASH3.SA",
    " marketcap ": " $104 687 820 ",
    "price (USD)": "1.11274",
    "country": "Brazil"
  },
  {
    "Rank": "7420",
    "Name": "BeyondSpring",
    "Symbol": "BYSI",
    " marketcap ": " $104 207 968 ",
    "price (USD)": "\u0444\u0435\u0432.67",
    "country": "United States"
  },
  {
    "Rank": "7421",
    "Name": "ACRES Commercial Realty",
    "Symbol": "ACR",
    " marketcap ": " $103 622 408 ",
    "price (USD)": "13.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7422",
    "Name": "Development Works Food Company",
    "Symbol": "6013.SR",
    " marketcap ": " $103 274 358 ",
    "price (USD)": "34.4248",
    "country": "Saudi Arabia"
  },
  {
    "Rank": "7423",
    "Name": "KVH Industries",
    "Symbol": "KVHI",
    " marketcap ": " $103 115 728 ",
    "price (USD)": "\u043c\u0430\u0439.23",
    "country": "United States"
  },
  {
    "Rank": "7424",
    "Name": "Spencer's Retail",
    "Symbol": "SPENCERS.NS",
    " marketcap ": " $102 918 746 ",
    "price (USD)": "1.13845",
    "country": "India"
  },
  {
    "Rank": "7425",
    "Name": "Big Lots",
    "Symbol": "BIG",
    " marketcap ": " $101 818 472 ",
    "price (USD)": "\u043c\u0430\u0440.45",
    "country": "United States"
  },
  {
    "Rank": "7426",
    "Name": "Silicom",
    "Symbol": "SILC",
    " marketcap ": " $101 608 176 ",
    "price (USD)": "16.66",
    "country": "Israel"
  },
  {
    "Rank": "7427",
    "Name": "Aura Energy",
    "Symbol": "AURA.L",
    " marketcap ": " $101 334 289 ",
    "price (USD)": "0.127007",
    "country": "Australia"
  },
  {
    "Rank": "7428",
    "Name": "Babcock &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7429",
    "Name": "KAP AG",
    "Symbol": "IUR.F",
    " marketcap ": " $101 216 983 ",
    "price (USD)": "13.0307",
    "country": "Germany"
  },
  {
    "Rank": "7430",
    "Name": "Sharjah Cement and Industrial Development",
    "Symbol": "SCIDC.AE",
    " marketcap ": " $101 025 073 ",
    "price (USD)": "0.17",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7431",
    "Name": "Samsung Heavy Industries",
    "Symbol": "010145.KS",
    " marketcap ": " $100 967 627 ",
    "price (USD)": "\u0430\u043f\u0440.97",
    "country": "South Korea"
  },
  {
    "Rank": "7432",
    "Name": "SCYNEXIS",
    "Symbol": "SCYX",
    " marketcap ": " $100 872 072 ",
    "price (USD)": "\u0444\u0435\u0432.67",
    "country": "United States"
  },
  {
    "Rank": "7433",
    "Name": "Bakkt Holdings",
    "Symbol": "BKKT",
    " marketcap ": " $100 830 848 ",
    "price (USD)": "16.18",
    "country": "United States"
  },
  {
    "Rank": "7434",
    "Name": "Yatra",
    "Symbol": "YTRA",
    " marketcap ": " $100 768 416 ",
    "price (USD)": "\u044f\u043d\u0432.57",
    "country": "India"
  },
  {
    "Rank": "7435",
    "Name": "G5 Entertainment",
    "Symbol": "G5EN.ST",
    " marketcap ": " $100 727 012 ",
    "price (USD)": "\u0434\u0435\u043a.64",
    "country": "Sweden"
  },
  {
    "Rank": "7436",
    "Name": "Tethys Oil",
    "Symbol": "TETY.ST",
    " marketcap ": " $100 114 470 ",
    "price (USD)": "3.10761",
    "country": "Sweden"
  },
  {
    "Rank": "7437",
    "Name": "5E Advanced Materials",
    "Symbol": "FEAM",
    " marketcap ": " $99 991 568 ",
    "price (USD)": "\u044f\u043d\u0432.58",
    "country": "United States"
  },
  {
    "Rank": "7438",
    "Name": "Fujairah Building Industries",
    "Symbol": "FBI.AE",
    " marketcap ": " $99 971 751 ",
    "price (USD)": "0.74",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7439",
    "Name": "Vuzix",
    "Symbol": "VUZI",
    " marketcap ": " $99 678 192 ",
    "price (USD)": "\u044f\u043d\u0432.54",
    "country": "United States"
  },
  {
    "Rank": "7440",
    "Name": "ProPhase Labs",
    "Symbol": "PRPH",
    " marketcap ": " $99 398 984 ",
    "price (USD)": "\u043c\u0430\u0439.21",
    "country": "United States"
  },
  {
    "Rank": "7441",
    "Name": "Identiv",
    "Symbol": "INVE",
    " marketcap ": " $99 141 792 ",
    "price (USD)": "\u0430\u043f\u0440.24",
    "country": "United States"
  },
  {
    "Rank": "7442",
    "Name": "American Resources Corp",
    "Symbol": "AREC",
    " marketcap ": " $99 063 040 ",
    "price (USD)": "\u044f\u043d\u0432.28",
    "country": "United States"
  },
  {
    "Rank": "7443",
    "Name": "Ras Alkhaima National Insurance",
    "Symbol": "RAKNIC.AE",
    " marketcap ": " $99 061 998 ",
    "price (USD)": "0.82",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7444",
    "Name": "Siebert Financial",
    "Symbol": "SIEB",
    " marketcap ": " $99 007 664 ",
    "price (USD)": "\u0444\u0435\u0432.57",
    "country": "United States"
  },
  {
    "Rank": "7445",
    "Name": "Kopin Corporation",
    "Symbol": "KOPN",
    " marketcap ": " $98 982 696 ",
    "price (USD)": "0.8581",
    "country": "United States"
  },
  {
    "Rank": "7446",
    "Name": "Postmedia Network Canada",
    "Symbol": "PNC-A.TO",
    " marketcap ": " $98 758 529 ",
    "price (USD)": "1.00444",
    "country": "Canada"
  },
  {
    "Rank": "7447",
    "Name": "Innovative Solutions and Support",
    "Symbol": "ISSC",
    " marketcap ": " $98 664 464 ",
    "price (USD)": "\u043c\u0430\u0439.64",
    "country": "United States"
  },
  {
    "Rank": "7448",
    "Name": "Vivani Medical",
    "Symbol": "VANI",
    " marketcap ": " $98 136 624 ",
    "price (USD)": "1.785",
    "country": "United States"
  },
  {
    "Rank": "7449",
    "Name": "Xtant Medical",
    "Symbol": "XTNT",
    " marketcap ": " $98 118 504 ",
    "price (USD)": "0.7535",
    "country": "United States"
  },
  {
    "Rank": "7450",
    "Name": "Relmada Therapeutics",
    "Symbol": "RLMD",
    " marketcap ": " $97 764 408 ",
    "price (USD)": "\u043c\u0430\u0440.24",
    "country": "United States"
  },
  {
    "Rank": "7451",
    "Name": "Brightcove",
    "Symbol": "BCOV",
    " marketcap ": " $97 635 680 ",
    "price (USD)": "\u0444\u0435\u0432.19",
    "country": "United States"
  },
  {
    "Rank": "7452",
    "Name": "SuRo Capital",
    "Symbol": "SSSS",
    " marketcap ": " $97 616 792 ",
    "price (USD)": "\u0430\u043f\u0440.18",
    "country": "United States"
  },
  {
    "Rank": "7453",
    "Name": "Great Elm Capital",
    "Symbol": "GECC",
    " marketcap ": " $97 548 560 ",
    "price (USD)": "\u043e\u043a\u0442.32",
    "country": "United States"
  },
  {
    "Rank": "7454",
    "Name": "Islamic Arab Insurance",
    "Symbol": "SALAMA.AE",
    " marketcap ": " $97 484 275 ",
    "price (USD)": "0.105644",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7455",
    "Name": "KORU Medical Systems",
    "Symbol": "KRMD",
    " marketcap ": " $97 477 752 ",
    "price (USD)": "\u0444\u0435\u0432.13",
    "country": "United States"
  },
  {
    "Rank": "7456",
    "Name": "Athira Pharma",
    "Symbol": "ATHA",
    " marketcap ": " $97 354 896 ",
    "price (USD)": "\u0444\u0435\u0432.54",
    "country": "United States"
  },
  {
    "Rank": "7457",
    "Name": "BowFlex",
    "Symbol": "BFX",
    " marketcap ": " $97 190 336 ",
    "price (USD)": "0.195",
    "country": "United States"
  },
  {
    "Rank": "7458",
    "Name": "Al Mahhar Holding Company",
    "Symbol": "MHAR.QA",
    " marketcap ": " $97 073 899 ",
    "price (USD)": "0.468956",
    "country": "Qatar"
  },
  {
    "Rank": "7459",
    "Name": "Assertio Therapeutics",
    "Symbol": "ASRT",
    " marketcap ": " $97 027 088 ",
    "price (USD)": "01.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7460",
    "Name": "MacroWell OMG Digital Entertainment",
    "Symbol": "3687.TWO",
    " marketcap ": " $96 946 687 ",
    "price (USD)": "3.22511",
    "country": "Taiwan"
  },
  {
    "Rank": "7461",
    "Name": "Tupperware Brands",
    "Symbol": "TUP",
    " marketcap ": " $96 783 648 ",
    "price (USD)": "02.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "7462",
    "Name": "Hily Holding",
    "Symbol": "HH.AE",
    " marketcap ": " $96 713 589 ",
    "price (USD)": "0.81",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7463",
    "Name": "Smart Sand",
    "Symbol": "SND",
    " marketcap ": " $96 647 296 ",
    "price (USD)": "\u0444\u0435\u0432.27",
    "country": "United States"
  },
  {
    "Rank": "7464",
    "Name": "Kaleyra",
    "Symbol": "KLR",
    " marketcap ": " $96 479 512 ",
    "price (USD)": "\u0438\u044e\u043b.24",
    "country": "Italy"
  },
  {
    "Rank": "7465",
    "Name": "Creepy Jar",
    "Symbol": "CRJ.WA",
    " marketcap ": " $96 449 223 ",
    "price (USD)": "137.91",
    "country": "Poland"
  },
  {
    "Rank": "7466",
    "Name": "Sunlight Financial",
    "Symbol": "SUNL",
    " marketcap ": " $96 130 248 ",
    "price (USD)": "0.25",
    "country": "United States"
  },
  {
    "Rank": "7467",
    "Name": "Leap Therapeutics",
    "Symbol": "LPTX",
    " marketcap ": " $96 043 896 ",
    "price (USD)": "\u0444\u0435\u0432.51",
    "country": "United States"
  },
  {
    "Rank": "7468",
    "Name": "Battalion Oil",
    "Symbol": "BATL",
    " marketcap ": " $95 941 976 ",
    "price (USD)": "\u043c\u0430\u0439.83",
    "country": "United States"
  },
  {
    "Rank": "7469",
    "Name": "BAIOO Family Interactive",
    "Symbol": "2100.HK",
    " marketcap ": " $95 713 105 ",
    "price (USD)": "0.0333165",
    "country": "China"
  },
  {
    "Rank": "7470",
    "Name": "Motorcar Parts of America",
    "Symbol": "MPAA",
    " marketcap ": " $95 559 264 ",
    "price (USD)": "\u0430\u043f\u0440.86",
    "country": "United States"
  },
  {
    "Rank": "7471",
    "Name": "gumi",
    "Symbol": "3903.T",
    " marketcap ": " $95 466 065 ",
    "price (USD)": "2.41187",
    "country": "Japan"
  },
  {
    "Rank": "7472",
    "Name": "Vertex Energy",
    "Symbol": "VTNR",
    " marketcap ": " $95 384 592 ",
    "price (USD)": "01.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7473",
    "Name": "Alijarah Holding",
    "Symbol": "NLCS.QA",
    " marketcap ": " $95 154 224 ",
    "price (USD)": "0.192308",
    "country": "Qatar"
  },
  {
    "Rank": "7474",
    "Name": "TOP Financial Group Limited",
    "Symbol": "TOP",
    " marketcap ": " $94 760 448 ",
    "price (USD)": "\u0444\u0435\u0432.56",
    "country": "Hong Kong"
  },
  {
    "Rank": "7475",
    "Name": "United Foods Company",
    "Symbol": "UFC.AE",
    " marketcap ": " $94 719 146 ",
    "price (USD)": "3.13121",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7476",
    "Name": "Cambium Networks",
    "Symbol": "CMBM",
    " marketcap ": " $94 566 424 ",
    "price (USD)": "\u043c\u0430\u0440.39",
    "country": "United States"
  },
  {
    "Rank": "7477",
    "Name": "Foodco National Foodstuff",
    "Symbol": "FNF.AE",
    " marketcap ": " $94 535 355 ",
    "price (USD)": "0.34",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7478",
    "Name": "OneConnect",
    "Symbol": "OCFT",
    " marketcap ": " $94 511 928 ",
    "price (USD)": "\u0444\u0435\u0432.32",
    "country": "China"
  },
  {
    "Rank": "7479",
    "Name": "Sawaeed Holding",
    "Symbol": "SAWAEED.AE",
    " marketcap ": " $94 333 324 ",
    "price (USD)": "\u044f\u043d\u0432.85",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7480",
    "Name": "Conn's",
    "Symbol": "CONN",
    " marketcap ": " $94 317 936 ",
    "price (USD)": "\u043c\u0430\u0440.79",
    "country": "United States"
  },
  {
    "Rank": "7481",
    "Name": "Danimer Scientific",
    "Symbol": "DNMR",
    " marketcap ": " $94 155 808 ",
    "price (USD)": "0.8086",
    "country": "United States"
  },
  {
    "Rank": "7482",
    "Name": "Yellow Pages (Canada)",
    "Symbol": "Y.TO",
    " marketcap ": " $94 134 835 ",
    "price (USD)": "6.94307",
    "country": "Canada"
  },
  {
    "Rank": "7483",
    "Name": "KLX Energy Services",
    "Symbol": "KLXE",
    " marketcap ": " $94 118 976 ",
    "price (USD)": "\u043c\u0430\u0439.58",
    "country": "United States"
  },
  {
    "Rank": "7484",
    "Name": "Al Jazeera Steel Products",
    "Symbol": "ATMI.OM",
    " marketcap ": " $94 103 425 ",
    "price (USD)": "0.753442",
    "country": "Oman"
  },
  {
    "Rank": "7485",
    "Name": "Oramed Pharmaceuticals",
    "Symbol": "ORMP",
    " marketcap ": " $93 852 760 ",
    "price (USD)": "\u0444\u0435\u0432.31",
    "country": "United States"
  },
  {
    "Rank": "7486",
    "Name": "Asian Granito India",
    "Symbol": "ASIANTILES.NS",
    " marketcap ": " $93 735 492 ",
    "price (USD)": "0.738342",
    "country": "India"
  },
  {
    "Rank": "7487",
    "Name": "NeoVolta",
    "Symbol": "NEOV",
    " marketcap ": " $93 725 800 ",
    "price (USD)": "\u0444\u0435\u0432.82",
    "country": "United States"
  },
  {
    "Rank": "7488",
    "Name": "Akatsuki Corp.",
    "Symbol": "8737.T",
    " marketcap ": " $93 673 852 ",
    "price (USD)": "3.07082",
    "country": "Japan"
  },
  {
    "Rank": "7489",
    "Name": "Americanas",
    "Symbol": "AMER3.SA",
    " marketcap ": " $93 379 530 ",
    "price (USD)": "0.103465",
    "country": "Brazil"
  },
  {
    "Rank": "7490",
    "Name": "Oman Education and Training Investments (OETI)",
    "Symbol": "OETI.OM",
    " marketcap ": " $93 296 960 ",
    "price (USD)": "1.33281",
    "country": "Oman"
  },
  {
    "Rank": "7491",
    "Name": "Velan",
    "Symbol": "VLN.TO",
    " marketcap ": " $93 213 962 ",
    "price (USD)": "4.31834",
    "country": "Canada"
  },
  {
    "Rank": "7492",
    "Name": "Fonar Corporation",
    "Symbol": "FONR",
    " marketcap ": " $93 030 096 ",
    "price (USD)": "14.41",
    "country": "United States"
  },
  {
    "Rank": "7493",
    "Name": "Noodles &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7494",
    "Name": "Armata Pharmaceuticals",
    "Symbol": "ARMP",
    " marketcap ": " $92 917 320 ",
    "price (USD)": "\u0444\u0435\u0432.57",
    "country": "United States"
  },
  {
    "Rank": "7495",
    "Name": "Urban One",
    "Symbol": "UONE",
    " marketcap ": " $92 823 088 ",
    "price (USD)": "\u0444\u0435\u0432.29",
    "country": "United States"
  },
  {
    "Rank": "7496",
    "Name": "SKYX Platforms",
    "Symbol": "SKYX",
    " marketcap ": " $92 154 560 ",
    "price (USD)": "0.92",
    "country": "United States"
  },
  {
    "Rank": "7497",
    "Name": "ALBA SE",
    "Symbol": "ABA.F",
    " marketcap ": " $91 892 714 ",
    "price (USD)": "9.33869",
    "country": "Germany"
  },
  {
    "Rank": "7498",
    "Name": "Hindustan Media Ventures",
    "Symbol": "HMVL.NS",
    " marketcap ": " $91 863 693 ",
    "price (USD)": "1.24959",
    "country": "India"
  },
  {
    "Rank": "7499",
    "Name": "Milestone Pharmaceuticals",
    "Symbol": "MIST",
    " marketcap ": " $91 608 064 ",
    "price (USD)": "\u044f\u043d\u0432.72",
    "country": "Canada"
  },
  {
    "Rank": "7500",
    "Name": "Buzzfeed",
    "Symbol": "BZFD",
    " marketcap ": " $91 522 248 ",
    "price (USD)": "02.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7501",
    "Name": "AlloVir",
    "Symbol": "ALVR",
    " marketcap ": " $91 519 384 ",
    "price (USD)": "0.7958",
    "country": "United States"
  },
  {
    "Rank": "7502",
    "Name": "Markforged",
    "Symbol": "MKFG",
    " marketcap ": " $91 419 704 ",
    "price (USD)": "0.454",
    "country": "United States"
  },
  {
    "Rank": "7503",
    "Name": "MariMed",
    "Symbol": "MRMD",
    " marketcap ": " $91 114 560 ",
    "price (USD)": "0.24",
    "country": "United States"
  },
  {
    "Rank": "7504",
    "Name": "Sudatel Telecommunications Group",
    "Symbol": "SUDATEL.AE",
    " marketcap ": " $91 106 930 ",
    "price (USD)": "0.07",
    "country": "Sudan"
  },
  {
    "Rank": "7505",
    "Name": "1-800-PetMeds",
    "Symbol": "PETS",
    " marketcap ": " $90 939 416 ",
    "price (USD)": "04.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "7506",
    "Name": "Lifevantage",
    "Symbol": "LFVN",
    " marketcap ": " $90 936 296 ",
    "price (USD)": "\u0438\u044e\u043b.16",
    "country": "United States"
  },
  {
    "Rank": "7507",
    "Name": "M-tron Industries",
    "Symbol": "MPTI",
    " marketcap ": " $90 897 880 ",
    "price (USD)": "32.48",
    "country": "United States"
  },
  {
    "Rank": "7508",
    "Name": "SHUAA Capital",
    "Symbol": "SHUAA.AE",
    " marketcap ": " $90 445 529 ",
    "price (USD)": "0.0356686",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7509",
    "Name": "Wayi International Digital Entertainment",
    "Symbol": "3086.TWO",
    " marketcap ": " $90 426 876 ",
    "price (USD)": "3.82981",
    "country": "Taiwan"
  },
  {
    "Rank": "7510",
    "Name": "Precision BioSciences",
    "Symbol": "DTIL",
    " marketcap ": " $90 379 080 ",
    "price (USD)": "13.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7511",
    "Name": "Scully Royalty",
    "Symbol": "SRL",
    " marketcap ": " $90 267 808 ",
    "price (USD)": "06.\u0441\u0435\u043d",
    "country": "China"
  },
  {
    "Rank": "7512",
    "Name": "Americas Gold and Silver Corp",
    "Symbol": "USAS",
    " marketcap ": " $90 171 888 ",
    "price (USD)": "0.3386",
    "country": "Canada"
  },
  {
    "Rank": "7513",
    "Name": "Gritstone bio",
    "Symbol": "GRTS",
    " marketcap ": " $90 047 128 ",
    "price (USD)": "0.8294",
    "country": "United States"
  },
  {
    "Rank": "7514",
    "Name": "Benitec Biopharma",
    "Symbol": "BNTC",
    " marketcap ": " $89 927 808 ",
    "price (USD)": "09.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7515",
    "Name": "Nectar Lifesciences",
    "Symbol": "NECLIFE.NS",
    " marketcap ": " $89 729 186 ",
    "price (USD)": "0.400111",
    "country": "India"
  },
  {
    "Rank": "7516",
    "Name": "InflaRx",
    "Symbol": "IFRX",
    " marketcap ": " $89 502 616 ",
    "price (USD)": "\u044f\u043d\u0432.52",
    "country": "Germany"
  },
  {
    "Rank": "7517",
    "Name": "AMCON Distributing Company",
    "Symbol": "DIT",
    " marketcap ": " $89 442 064 ",
    "price (USD)": "141.89",
    "country": "United States"
  },
  {
    "Rank": "7518",
    "Name": "WiMi Hologram Cloud",
    "Symbol": "WIMI",
    " marketcap ": " $89 369 280 ",
    "price (USD)": "0.91",
    "country": "China"
  },
  {
    "Rank": "7519",
    "Name": "Oman Chlorine",
    "Symbol": "OCHL.OM",
    " marketcap ": " $88 991 257 ",
    "price (USD)": "1.24448",
    "country": "Oman"
  },
  {
    "Rank": "7520",
    "Name": "McPhy Energy",
    "Symbol": "MCPHY.PA",
    " marketcap ": " $88 920 195 ",
    "price (USD)": "3.19796",
    "country": "France"
  },
  {
    "Rank": "7521",
    "Name": "Gateway Real Estate",
    "Symbol": "GTY.F",
    " marketcap ": " $88 497 235 ",
    "price (USD)": "0.325768",
    "country": "Germany"
  },
  {
    "Rank": "7522",
    "Name": "FAT Brands",
    "Symbol": "FAT",
    " marketcap ": " $88 376 880 ",
    "price (USD)": "\u043c\u0430\u0439.19",
    "country": "United States"
  },
  {
    "Rank": "7523",
    "Name": "Balaji Telefilms",
    "Symbol": "BALAJITELE.NS",
    " marketcap ": " $88 114 411 ",
    "price (USD)": "0.867507",
    "country": "India"
  },
  {
    "Rank": "7524",
    "Name": "Protalix BioTherapeutics",
    "Symbol": "PLX",
    " marketcap ": " $87 979 320 ",
    "price (USD)": "01.\u0444\u0435\u0432",
    "country": "Israel"
  },
  {
    "Rank": "7525",
    "Name": "IO Biotech",
    "Symbol": "IOBT",
    " marketcap ": " $87 951 008 ",
    "price (USD)": "1.335",
    "country": "Denmark"
  },
  {
    "Rank": "7526",
    "Name": "Rane Brake Lining",
    "Symbol": "RBL.NS",
    " marketcap ": " $87 819 805 ",
    "price (USD)": "\u043d\u043e\u044f.11",
    "country": "India"
  },
  {
    "Rank": "7527",
    "Name": "MoneyHero",
    "Symbol": "MNY",
    " marketcap ": " $87 523 280 ",
    "price (USD)": "\u0444\u0435\u0432.22",
    "country": "Singapore"
  },
  {
    "Rank": "7528",
    "Name": "Chimerix",
    "Symbol": "CMRX",
    " marketcap ": " $87 389 160 ",
    "price (USD)": "0.975",
    "country": "United States"
  },
  {
    "Rank": "7529",
    "Name": "Anixa Biosciences",
    "Symbol": "ANIX",
    " marketcap ": " $87 086 456 ",
    "price (USD)": "\u0444\u0435\u0432.73",
    "country": "United States"
  },
  {
    "Rank": "7530",
    "Name": "Galfar Engineering and Contracting",
    "Symbol": "GECS.OM",
    " marketcap ": " $87 016 793 ",
    "price (USD)": "0.428683",
    "country": "Oman"
  },
  {
    "Rank": "7531",
    "Name": "Century Casinos",
    "Symbol": "CNTY",
    " marketcap ": " $86 831 752 ",
    "price (USD)": "\u0444\u0435\u0432.83",
    "country": "United States"
  },
  {
    "Rank": "7532",
    "Name": "Appen",
    "Symbol": "APX.AX",
    " marketcap ": " $86 764 648 ",
    "price (USD)": "0.390083",
    "country": "Australia"
  },
  {
    "Rank": "7533",
    "Name": "BioLargo",
    "Symbol": "BLGO",
    " marketcap ": " $86 692 120 ",
    "price (USD)": "0.29205",
    "country": "United States"
  },
  {
    "Rank": "7534",
    "Name": "PEDEVCO",
    "Symbol": "PED",
    " marketcap ": " $86 674 640 ",
    "price (USD)": "0.97",
    "country": "United States"
  },
  {
    "Rank": "7535",
    "Name": "Provident Financial Holdings",
    "Symbol": "PROV",
    " marketcap ": " $86 111 936 ",
    "price (USD)": "\u0434\u0435\u043a.52",
    "country": "United States"
  },
  {
    "Rank": "7536",
    "Name": "Toro Corp.",
    "Symbol": "TORO",
    " marketcap ": " $85 985 992 ",
    "price (USD)": "\u0430\u043f\u0440.69",
    "country": "Cyprus"
  },
  {
    "Rank": "7537",
    "Name": "Forian",
    "Symbol": "FORA",
    " marketcap ": " $85 011 384 ",
    "price (USD)": "\u0444\u0435\u0432.73",
    "country": "United States"
  },
  {
    "Rank": "7538",
    "Name": "Doma",
    "Symbol": "DOMA",
    " marketcap ": " $84 633 688 ",
    "price (USD)": "06.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "7539",
    "Name": "Voxx International",
    "Symbol": "VOXX",
    " marketcap ": " $84 532 872 ",
    "price (USD)": "\u043c\u0430\u0440.75",
    "country": "United States"
  },
  {
    "Rank": "7540",
    "Name": "Argo Blockchain",
    "Symbol": "ARBK",
    " marketcap ": " $84 416 768 ",
    "price (USD)": "\u044f\u043d\u0432.46",
    "country": "United Kingdom"
  },
  {
    "Rank": "7541",
    "Name": "Barinthus Biotherapeutics",
    "Symbol": "BRNS",
    " marketcap ": " $84 108 512 ",
    "price (USD)": "2.1513",
    "country": "United Kingdom"
  },
  {
    "Rank": "7542",
    "Name": "Aclaris Therapeutics",
    "Symbol": "ACRS",
    " marketcap ": " $84 092 464 ",
    "price (USD)": "\u044f\u043d\u0432.18",
    "country": "United States"
  },
  {
    "Rank": "7543",
    "Name": "S\u0413\u0405n hf.",
    "Symbol": "SYN.IC",
    " marketcap ": " $84 041 237 ",
    "price (USD)": "0.288093",
    "country": "Iceland"
  },
  {
    "Rank": "7544",
    "Name": "Gamesparcs",
    "Symbol": "6542.TWO",
    " marketcap ": " $83 748 521 ",
    "price (USD)": "1.99398",
    "country": "Taiwan"
  },
  {
    "Rank": "7545",
    "Name": "T2 Biosystems",
    "Symbol": "TTOO",
    " marketcap ": " $83 745 240 ",
    "price (USD)": "\u043c\u0430\u0439.45",
    "country": "United States"
  },
  {
    "Rank": "7546",
    "Name": "Oncolytics Biotech",
    "Symbol": "ONCY",
    " marketcap ": " $83 715 976 ",
    "price (USD)": "01.\u043d\u043e\u044f",
    "country": "Canada"
  },
  {
    "Rank": "7547",
    "Name": "Riverview Bancorp",
    "Symbol": "RVSB",
    " marketcap ": " $83 599 560 ",
    "price (USD)": "\u043c\u0430\u0440.96",
    "country": "United States"
  },
  {
    "Rank": "7548",
    "Name": "Atara Biotherapeutics",
    "Symbol": "ATRA",
    " marketcap ": " $83 484 416 ",
    "price (USD)": "0.6933",
    "country": "United States"
  },
  {
    "Rank": "7549",
    "Name": "Tiziana Life Sciences",
    "Symbol": "TLSA",
    " marketcap ": " $83 241 480 ",
    "price (USD)": "0.82",
    "country": "United Kingdom"
  },
  {
    "Rank": "7550",
    "Name": "American Battery Technology Company",
    "Symbol": "ABAT",
    " marketcap ": " $83 209 296 ",
    "price (USD)": "\u044f\u043d\u0432.42",
    "country": "United States"
  },
  {
    "Rank": "7551",
    "Name": "Heritage Global",
    "Symbol": "HGBL",
    " marketcap ": " $82 897 464 ",
    "price (USD)": "\u0444\u0435\u0432.22",
    "country": "United States"
  },
  {
    "Rank": "7552",
    "Name": "Allot",
    "Symbol": "ALLT",
    " marketcap ": " $82 803 640 ",
    "price (USD)": "2.154",
    "country": "Israel"
  },
  {
    "Rank": "7553",
    "Name": "Elutia",
    "Symbol": "ELUT",
    " marketcap ": " $82 302 664 ",
    "price (USD)": "\u043c\u0430\u0440.38",
    "country": "United States"
  },
  {
    "Rank": "7554",
    "Name": "CI Games",
    "Symbol": "CI7.F",
    " marketcap ": " $82 256 549 ",
    "price (USD)": "0.413291",
    "country": "Poland"
  },
  {
    "Rank": "7555",
    "Name": "Sellas Life Sciences",
    "Symbol": "SLS",
    " marketcap ": " $82 011 952 ",
    "price (USD)": "\u044f\u043d\u0432.42",
    "country": "United States"
  },
  {
    "Rank": "7556",
    "Name": "Trilogy Metals",
    "Symbol": "TMQ",
    " marketcap ": " $82 005 512 ",
    "price (USD)": "0.512",
    "country": "Canada"
  },
  {
    "Rank": "7557",
    "Name": "Richtech Robotics",
    "Symbol": "RR",
    " marketcap ": " $81 734 680 ",
    "price (USD)": "\u044f\u043d\u0432.19",
    "country": "United States"
  },
  {
    "Rank": "7558",
    "Name": "Artifex Mundi",
    "Symbol": "ART.WA",
    " marketcap ": " $81 731 862 ",
    "price (USD)": "6.86996",
    "country": "Poland"
  },
  {
    "Rank": "7559",
    "Name": "Katapult Holdings",
    "Symbol": "KPLT",
    " marketcap ": " $81 620 120 ",
    "price (USD)": "19.88",
    "country": "United States"
  },
  {
    "Rank": "7560",
    "Name": "Beamr Imaging",
    "Symbol": "BMR",
    " marketcap ": " $81 568 624 ",
    "price (USD)": "05.\u0430\u043f\u0440",
    "country": "Israel"
  },
  {
    "Rank": "7561",
    "Name": "Spero Therapeutics",
    "Symbol": "SPRO",
    " marketcap ": " $81 519 768 ",
    "price (USD)": "\u044f\u043d\u0432.51",
    "country": "United States"
  },
  {
    "Rank": "7562",
    "Name": "Ebixcash India",
    "Symbol": "EBIXFOREX.NS",
    " marketcap ": " $81 507 586 ",
    "price (USD)": "\u0438\u044e\u043b.31",
    "country": "India"
  },
  {
    "Rank": "7563",
    "Name": "Apex Frozen Foods",
    "Symbol": "APEX.NS",
    " marketcap ": " $81 404 109 ",
    "price (USD)": "2.60432",
    "country": "India"
  },
  {
    "Rank": "7564",
    "Name": "Aileron Therapeutics",
    "Symbol": "ALRN",
    " marketcap ": " $81 392 792 ",
    "price (USD)": "\u043c\u0430\u0440.77",
    "country": "United States"
  },
  {
    "Rank": "7565",
    "Name": "Natural Health Trends",
    "Symbol": "NHTC",
    " marketcap ": " $81 270 608 ",
    "price (USD)": "7.0567",
    "country": "United States"
  },
  {
    "Rank": "7566",
    "Name": "PyroGenesis Canada",
    "Symbol": "PYR.TO",
    " marketcap ": " $81 248 929 ",
    "price (USD)": "0.454209",
    "country": "Canada"
  },
  {
    "Rank": "7567",
    "Name": "Red Cat Holdings",
    "Symbol": "RCAT",
    " marketcap ": " $80 966 840 ",
    "price (USD)": "01.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "7568",
    "Name": "Odyssey Marine Exploration",
    "Symbol": "OMEX",
    " marketcap ": " $80 702 848 ",
    "price (USD)": "\u043c\u0430\u0440.95",
    "country": "United States"
  },
  {
    "Rank": "7569",
    "Name": "Sport Lisboa e Benfica",
    "Symbol": "SLBEN.LS",
    " marketcap ": " $80 671 083 ",
    "price (USD)": "3.50744",
    "country": "Portugal"
  },
  {
    "Rank": "7570",
    "Name": "Xiao-I",
    "Symbol": "AIXI",
    " marketcap ": " $80 639 368 ",
    "price (USD)": "1.105",
    "country": "China"
  },
  {
    "Rank": "7571",
    "Name": "Hycroft Mining",
    "Symbol": "HYMC",
    " marketcap ": " $80 617 952 ",
    "price (USD)": "\u043c\u0430\u0440.49",
    "country": "United States"
  },
  {
    "Rank": "7572",
    "Name": "NioCorp Developments",
    "Symbol": "NB",
    " marketcap ": " $80 263 920 ",
    "price (USD)": "02.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7573",
    "Name": "Workhorse Group",
    "Symbol": "WKHS",
    " marketcap ": " $79 923 776 ",
    "price (USD)": "0.213",
    "country": "United States"
  },
  {
    "Rank": "7574",
    "Name": "Via Renewables",
    "Symbol": "VIA",
    " marketcap ": " $79 342 720 ",
    "price (USD)": "\u043e\u043a\u0442.97",
    "country": "United States"
  },
  {
    "Rank": "7575",
    "Name": "Ateam",
    "Symbol": "3662.T",
    " marketcap ": " $79 167 792 ",
    "price (USD)": "4.26716",
    "country": "Japan"
  },
  {
    "Rank": "7576",
    "Name": "MAIA Biotechnology",
    "Symbol": "MAIA",
    " marketcap ": " $79 050 296 ",
    "price (USD)": "\u043c\u0430\u0440.62",
    "country": "United States"
  },
  {
    "Rank": "7577",
    "Name": "Burning Rock Biotech",
    "Symbol": "BNR",
    " marketcap ": " $78 581 640 ",
    "price (USD)": "\u0438\u044e\u043b.66",
    "country": "China"
  },
  {
    "Rank": "7578",
    "Name": "Inseego",
    "Symbol": "INSG",
    " marketcap ": " $78 427 136 ",
    "price (USD)": "06.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7579",
    "Name": "Affimed",
    "Symbol": "AFMD",
    " marketcap ": " $78 421 624 ",
    "price (USD)": "\u043c\u0430\u0439.15",
    "country": "Germany"
  },
  {
    "Rank": "7580",
    "Name": "Bear Creek Mining",
    "Symbol": "BCM.V",
    " marketcap ": " $78 419 825 ",
    "price (USD)": "0.344587",
    "country": "Canada"
  },
  {
    "Rank": "7581",
    "Name": "OQIC Oman Qatar Insurance Company",
    "Symbol": "OQIC.OM",
    " marketcap ": " $78 326 507 ",
    "price (USD)": "0.48584",
    "country": "Oman"
  },
  {
    "Rank": "7582",
    "Name": "Glatfelter",
    "Symbol": "GLT",
    " marketcap ": " $78 286 824 ",
    "price (USD)": "\u044f\u043d\u0432.73",
    "country": "United States"
  },
  {
    "Rank": "7583",
    "Name": "Broadwind",
    "Symbol": "BWEN",
    " marketcap ": " $78 241 320 ",
    "price (USD)": "03.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7584",
    "Name": "LightInTheBox Holding",
    "Symbol": "LITB",
    " marketcap ": " $78 195 576 ",
    "price (USD)": "0.7034",
    "country": "Singapore"
  },
  {
    "Rank": "7585",
    "Name": "3i Infotech",
    "Symbol": "3IINFOLTD.NS",
    " marketcap ": " $77 412 050 ",
    "price (USD)": "0.458385",
    "country": "India"
  },
  {
    "Rank": "7586",
    "Name": "Sono-Tek Corporation",
    "Symbol": "SOTK",
    " marketcap ": " $77 307 360 ",
    "price (USD)": "\u0430\u043f\u0440.99",
    "country": "United States"
  },
  {
    "Rank": "7587",
    "Name": "National International Holding Company (Kuwait)",
    "Symbol": "NIH.KW",
    " marketcap ": " $77 200 684 ",
    "price (USD)": "345.502",
    "country": "Kuwait"
  },
  {
    "Rank": "7588",
    "Name": "Genasys",
    "Symbol": "GNSS",
    " marketcap ": " $76 702 712 ",
    "price (USD)": "\u044f\u043d\u0432.72",
    "country": "United States"
  },
  {
    "Rank": "7589",
    "Name": "Lee Enterprises",
    "Symbol": "LEE",
    " marketcap ": " $76 666 136 ",
    "price (USD)": "\u0434\u0435\u043a.48",
    "country": "United States"
  },
  {
    "Rank": "7590",
    "Name": "Al Fujairah National Insurance Company",
    "Symbol": "AFNIC.AE",
    " marketcap ": " $76 104 773 ",
    "price (USD)": "57.18",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7591",
    "Name": "SurgePays",
    "Symbol": "SURG",
    " marketcap ": " $76 093 080 ",
    "price (USD)": "\u043c\u0430\u0440.92",
    "country": "United States"
  },
  {
    "Rank": "7592",
    "Name": "Mirza International",
    "Symbol": "MIRZAINT.NS",
    " marketcap ": " $75 803 784 ",
    "price (USD)": "0.5485",
    "country": "India"
  },
  {
    "Rank": "7593",
    "Name": "Nihon Falcom",
    "Symbol": "3723.T",
    " marketcap ": " $75 695 318 ",
    "price (USD)": "7.36357",
    "country": "Japan"
  },
  {
    "Rank": "7594",
    "Name": "MDxHealth",
    "Symbol": "MDXH",
    " marketcap ": " $75 588 040 ",
    "price (USD)": "\u0444\u0435\u0432.77",
    "country": "Belgium"
  },
  {
    "Rank": "7595",
    "Name": "BioXcel Therapeutics",
    "Symbol": "BTAI",
    " marketcap ": " $75 436 904 ",
    "price (USD)": "02.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7596",
    "Name": "Personalis",
    "Symbol": "PSNL",
    " marketcap ": " $75 311 264 ",
    "price (USD)": "\u044f\u043d\u0432.45",
    "country": "United States"
  },
  {
    "Rank": "7597",
    "Name": "Infinities Tech (Jiu Zun Digital)",
    "Symbol": "1961.HK",
    " marketcap ": " $75 275 000 ",
    "price (USD)": "0.102512",
    "country": "China"
  },
  {
    "Rank": "7598",
    "Name": "Old Point Financial",
    "Symbol": "OPOF",
    " marketcap ": " $75 169 640 ",
    "price (USD)": "14.81",
    "country": "United States"
  },
  {
    "Rank": "7599",
    "Name": "Lazydays Holdings",
    "Symbol": "LAZY",
    " marketcap ": " $75 106 032 ",
    "price (USD)": "\u043c\u0430\u0439.34",
    "country": "United States"
  },
  {
    "Rank": "7600",
    "Name": "Oconee Federal Financial",
    "Symbol": "OFED",
    " marketcap ": " $74 848 416 ",
    "price (USD)": "\u0434\u0435\u043a.82",
    "country": "United States"
  },
  {
    "Rank": "7601",
    "Name": "BG Staffing",
    "Symbol": "BGSF",
    " marketcap ": " $74 746 152 ",
    "price (USD)": "\u0438\u044e\u043d.83",
    "country": "United States"
  },
  {
    "Rank": "7602",
    "Name": "Tempest Therapeutics",
    "Symbol": "TPST",
    " marketcap ": " $74 650 128 ",
    "price (USD)": "\u043c\u0430\u0440.36",
    "country": "United States"
  },
  {
    "Rank": "7603",
    "Name": "Fossil Group",
    "Symbol": "FOSL",
    " marketcap ": " $74 635 808 ",
    "price (USD)": "\u044f\u043d\u0432.41",
    "country": "United States"
  },
  {
    "Rank": "7604",
    "Name": "Integra Resources",
    "Symbol": "ITRG",
    " marketcap ": " $74 508 768 ",
    "price (USD)": "0.8423",
    "country": "Canada"
  },
  {
    "Rank": "7605",
    "Name": "Territorial Bancorp",
    "Symbol": "TBNK",
    " marketcap ": " $74 367 464 ",
    "price (USD)": "\u0430\u0432\u0433.42",
    "country": "United States"
  },
  {
    "Rank": "7606",
    "Name": "AL KHALEEJ Investment",
    "Symbol": "KICO.AE",
    " marketcap ": " $74 332 235 ",
    "price (USD)": "0.71",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7607",
    "Name": "authID",
    "Symbol": "AUID",
    " marketcap ": " $74 184 224 ",
    "price (USD)": "\u0438\u044e\u043b.85",
    "country": "United States"
  },
  {
    "Rank": "7608",
    "Name": "Pathfinder Bancorp",
    "Symbol": "PBHC",
    " marketcap ": " $74 176 848 ",
    "price (USD)": "\u0434\u0435\u043a.16",
    "country": "United States"
  },
  {
    "Rank": "7609",
    "Name": "Latch",
    "Symbol": "LTCH",
    " marketcap ": " $74 102 152 ",
    "price (USD)": "0.425",
    "country": "United States"
  },
  {
    "Rank": "7610",
    "Name": "Solitario Zinc",
    "Symbol": "XPL",
    " marketcap ": " $73 971 808 ",
    "price (USD)": "0.91",
    "country": "United States"
  },
  {
    "Rank": "7611",
    "Name": "Upland Software",
    "Symbol": "UPLD",
    " marketcap ": " $73 948 976 ",
    "price (USD)": "\u0444\u0435\u0432.68",
    "country": "United States"
  },
  {
    "Rank": "7612",
    "Name": "Steel Connect",
    "Symbol": "STCN",
    " marketcap ": " $73 782 592 ",
    "price (USD)": "\u043d\u043e\u044f.27",
    "country": "United States"
  },
  {
    "Rank": "7613",
    "Name": "Stabilis Solutions",
    "Symbol": "SLNG",
    " marketcap ": " $73 782 448 ",
    "price (USD)": "\u043c\u0430\u0440.97",
    "country": "United States"
  },
  {
    "Rank": "7614",
    "Name": "Big 5 Sporting Goods",
    "Symbol": "BGFV",
    " marketcap ": " $73 528 648 ",
    "price (USD)": "\u043c\u0430\u0440.25",
    "country": "United States"
  },
  {
    "Rank": "7615",
    "Name": "Neuronetics",
    "Symbol": "STIM",
    " marketcap ": " $73 194 144 ",
    "price (USD)": "\u0444\u0435\u0432.44",
    "country": "United States"
  },
  {
    "Rank": "7616",
    "Name": "Lulu's Fashion Lounge",
    "Symbol": "LVLU",
    " marketcap ": " $73 148 616 ",
    "price (USD)": "\u044f\u043d\u0432.77",
    "country": "United States"
  },
  {
    "Rank": "7617",
    "Name": "Wag! Group",
    "Symbol": "PET",
    " marketcap ": " $73 116 360 ",
    "price (USD)": "01.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "7618",
    "Name": "Marinus Pharmaceuticals",
    "Symbol": "MRNS",
    " marketcap ": " $73 061 960 ",
    "price (USD)": "\u044f\u043d\u0432.33",
    "country": "United States"
  },
  {
    "Rank": "7619",
    "Name": "Oman Reinsurance",
    "Symbol": "ORIC.OM",
    " marketcap ": " $73 047 353 ",
    "price (USD)": "0.220837",
    "country": "Oman"
  },
  {
    "Rank": "7620",
    "Name": "Cryo-Cell",
    "Symbol": "CCEL",
    " marketcap ": " $73 021 368 ",
    "price (USD)": "09.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7621",
    "Name": "Wrap Technologies",
    "Symbol": "WRAP",
    " marketcap ": " $72 953 432 ",
    "price (USD)": "\u044f\u043d\u0432.65",
    "country": "United States"
  },
  {
    "Rank": "7622",
    "Name": "Magyar Bancorp",
    "Symbol": "MGYR",
    " marketcap ": " $72 928 096 ",
    "price (USD)": "11.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7623",
    "Name": "Radio City",
    "Symbol": "RADIOCITY.NS",
    " marketcap ": " $72 686 814 ",
    "price (USD)": "0.210268",
    "country": "India"
  },
  {
    "Rank": "7624",
    "Name": "Instil Bio",
    "Symbol": "TIL",
    " marketcap ": " $72 669 488 ",
    "price (USD)": "11.1732",
    "country": "United States"
  },
  {
    "Rank": "7625",
    "Name": "Taageer Finance",
    "Symbol": "TFCI.OM",
    " marketcap ": " $72 544 353 ",
    "price (USD)": "0.267602",
    "country": "Oman"
  },
  {
    "Rank": "7626",
    "Name": "KULR Technology",
    "Symbol": "KULR",
    " marketcap ": " $72 157 416 ",
    "price (USD)": "0.395",
    "country": "United States"
  },
  {
    "Rank": "7627",
    "Name": "Fury Gold Mines",
    "Symbol": "FURY",
    " marketcap ": " $71 869 880 ",
    "price (USD)": "0.492",
    "country": "Canada"
  },
  {
    "Rank": "7628",
    "Name": "Qatar Oman Investment Company",
    "Symbol": "QOIS.QA",
    " marketcap ": " $71 826 923 ",
    "price (USD)": "0.228022",
    "country": "Qatar"
  },
  {
    "Rank": "7629",
    "Name": "Prenetics",
    "Symbol": "PRE",
    " marketcap ": " $71 714 960 ",
    "price (USD)": "\u043c\u0430\u0439.87",
    "country": "Hong Kong"
  },
  {
    "Rank": "7630",
    "Name": "Regencell Bioscience",
    "Symbol": "RGC",
    " marketcap ": " $71 180 560 ",
    "price (USD)": "\u043c\u0430\u0439.47",
    "country": "Hong Kong"
  },
  {
    "Rank": "7631",
    "Name": "Cel-Sci",
    "Symbol": "CVM",
    " marketcap ": " $70 949 464 ",
    "price (USD)": "\u044f\u043d\u0432.31",
    "country": "United States"
  },
  {
    "Rank": "7632",
    "Name": "Silver Spike Investment",
    "Symbol": "SSIC",
    " marketcap ": " $70 911 960 ",
    "price (USD)": "\u043d\u043e\u044f.99",
    "country": "United States"
  },
  {
    "Rank": "7633",
    "Name": "vTv Therapeutics",
    "Symbol": "VTVT",
    " marketcap ": " $70 577 272 ",
    "price (USD)": "29.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7634",
    "Name": "Perma-Pipe International",
    "Symbol": "PPIH",
    " marketcap ": " $70 273 496 ",
    "price (USD)": "\u0430\u0432\u0433.89",
    "country": "United States"
  },
  {
    "Rank": "7635",
    "Name": "Bionano Genomics",
    "Symbol": "BNGO",
    " marketcap ": " $70 199 640 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7636",
    "Name": "Lake Shore Bancorp",
    "Symbol": "LSBK",
    " marketcap ": " $69 705 032 ",
    "price (USD)": "\u0434\u0435\u043a.15",
    "country": "United States"
  },
  {
    "Rank": "7637",
    "Name": "United Fidelity Insurance Company",
    "Symbol": "FIDELITYUNITED.AE",
    " marketcap ": " $69 703 488 ",
    "price (USD)": "0.44",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7638",
    "Name": "Lava Therapeutics",
    "Symbol": "LVTX",
    " marketcap ": " $69 666 120 ",
    "price (USD)": "\u0444\u0435\u0432.65",
    "country": "Netherlands"
  },
  {
    "Rank": "7639",
    "Name": "Fire Rock",
    "Symbol": "1909.HK",
    " marketcap ": " $69 380 428 ",
    "price (USD)": "0.0180678",
    "country": "China"
  },
  {
    "Rank": "7640",
    "Name": "PLBY Group (Playboy)",
    "Symbol": "PLBY",
    " marketcap ": " $69 029 352 ",
    "price (USD)": "0.9481",
    "country": "United States"
  },
  {
    "Rank": "7641",
    "Name": "Liberty TripAdvisor Holdings",
    "Symbol": "LTRPA",
    " marketcap ": " $68 899 064 ",
    "price (USD)": "0.615",
    "country": "United States"
  },
  {
    "Rank": "7642",
    "Name": "Unikai Foods",
    "Symbol": "UNIKAI.AE",
    " marketcap ": " $68 741 388 ",
    "price (USD)": "1.76982",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7643",
    "Name": "FreightCar America",
    "Symbol": "RAIL",
    " marketcap ": " $68 667 904 ",
    "price (USD)": "\u043c\u0430\u0440.67",
    "country": "United States"
  },
  {
    "Rank": "7644",
    "Name": "Pollux Properti Indonesia",
    "Symbol": "POLL.JK",
    " marketcap ": " $68 656 008 ",
    "price (USD)": "0.0082531",
    "country": "Indonesia"
  },
  {
    "Rank": "7645",
    "Name": "U.S. GoldMining",
    "Symbol": "USGO",
    " marketcap ": " $68 192 848 ",
    "price (USD)": "05.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7646",
    "Name": "MediciNova",
    "Symbol": "MNOV",
    " marketcap ": " $68 174 216 ",
    "price (USD)": "\u044f\u043d\u0432.39",
    "country": "United States"
  },
  {
    "Rank": "7647",
    "Name": "Kayak Inc",
    "Symbol": "3904.T",
    " marketcap ": " $68 119 663 ",
    "price (USD)": "4.22878",
    "country": "Japan"
  },
  {
    "Rank": "7648",
    "Name": "Comscore",
    "Symbol": "SCOR",
    " marketcap ": " $67 866 832 ",
    "price (USD)": "14.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "7649",
    "Name": "Swvl Holdings",
    "Symbol": "SWVL",
    " marketcap ": " $67 848 080 ",
    "price (USD)": "\u0441\u0435\u043d.99",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7650",
    "Name": "Gentili Mosconi",
    "Symbol": "GM.MI",
    " marketcap ": " $67 672 929 ",
    "price (USD)": "3.56173",
    "country": "Italy"
  },
  {
    "Rank": "7651",
    "Name": "Lantern Pharma",
    "Symbol": "LTRN",
    " marketcap ": " $67 565 264 ",
    "price (USD)": "\u0438\u044e\u043d.28",
    "country": "United States"
  },
  {
    "Rank": "7652",
    "Name": "Asensus Surgical",
    "Symbol": "ASXC",
    " marketcap ": " $67 538 336 ",
    "price (USD)": "0.248",
    "country": "United States"
  },
  {
    "Rank": "7653",
    "Name": "Journey Medical",
    "Symbol": "DERM",
    " marketcap ": " $67 443 472 ",
    "price (USD)": "\u043c\u0430\u0440.37",
    "country": "United States"
  },
  {
    "Rank": "7654",
    "Name": "Profire Energy",
    "Symbol": "PFIE",
    " marketcap ": " $67 354 712 ",
    "price (USD)": "\u044f\u043d\u0432.43",
    "country": "United States"
  },
  {
    "Rank": "7655",
    "Name": "Spruce Power",
    "Symbol": "SPRU",
    " marketcap ": " $67 324 968 ",
    "price (USD)": "\u043c\u0430\u0440.66",
    "country": "United States"
  },
  {
    "Rank": "7656",
    "Name": "Vista Gold",
    "Symbol": "VGZ",
    " marketcap ": " $67 305 608 ",
    "price (USD)": "0.5528",
    "country": "United States"
  },
  {
    "Rank": "7657",
    "Name": "Quantum Computing",
    "Symbol": "QUBT",
    " marketcap ": " $67 284 872 ",
    "price (USD)": "0.7365",
    "country": "United States"
  },
  {
    "Rank": "7658",
    "Name": "Asiasoft",
    "Symbol": "AS.BK",
    " marketcap ": " $67 263 616 ",
    "price (USD)": "0.13473",
    "country": "Thailand"
  },
  {
    "Rank": "7659",
    "Name": "Arqit Quantum",
    "Symbol": "ARQQ",
    " marketcap ": " $67 137 600 ",
    "price (USD)": "0.4",
    "country": "United Kingdom"
  },
  {
    "Rank": "7660",
    "Name": "Dlala Brokerage and Investment Holding Company",
    "Symbol": "DBIS.QA",
    " marketcap ": " $66 949 275 ",
    "price (USD)": "0.351648",
    "country": "Qatar"
  },
  {
    "Rank": "7661",
    "Name": "MarketWise",
    "Symbol": "MKTW",
    " marketcap ": " $66 918 612 ",
    "price (USD)": "\u044f\u043d\u0432.55",
    "country": "United States"
  },
  {
    "Rank": "7662",
    "Name": "Rallybio",
    "Symbol": "RLYB",
    " marketcap ": " $66 733 372 ",
    "price (USD)": "\u044f\u043d\u0432.61",
    "country": "United States"
  },
  {
    "Rank": "7663",
    "Name": "Ikena Oncology",
    "Symbol": "IKNA",
    " marketcap ": " $66 596 176 ",
    "price (USD)": "\u044f\u043d\u0432.38",
    "country": "United States"
  },
  {
    "Rank": "7664",
    "Name": "Dragonfly Energy",
    "Symbol": "DFLI",
    " marketcap ": " $66 560 452 ",
    "price (USD)": "01.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7665",
    "Name": "Intensity Therapeutics",
    "Symbol": "INTS",
    " marketcap ": " $66 365 600 ",
    "price (USD)": "\u0430\u043f\u0440.84",
    "country": "United States"
  },
  {
    "Rank": "7666",
    "Name": "INMA Holding Company",
    "Symbol": "IHGS.QA",
    " marketcap ": " $66 158 079 ",
    "price (USD)": "1.16813",
    "country": "Qatar"
  },
  {
    "Rank": "7667",
    "Name": "SYLA Technologies",
    "Symbol": "SYT",
    " marketcap ": " $66 005 424 ",
    "price (USD)": "\u0444\u0435\u0432.53",
    "country": "Japan"
  },
  {
    "Rank": "7668",
    "Name": "Where Food Comes From",
    "Symbol": "WFCF",
    " marketcap ": " $65 852 644 ",
    "price (USD)": "\u0434\u0435\u043a.99",
    "country": "United States"
  },
  {
    "Rank": "7669",
    "Name": "Skillsoft",
    "Symbol": "SKIL",
    " marketcap ": " $65 803 488 ",
    "price (USD)": "\u0430\u0432\u0433.13",
    "country": "United States"
  },
  {
    "Rank": "7670",
    "Name": "Celularity",
    "Symbol": "CELU",
    " marketcap ": " $65 784 356 ",
    "price (USD)": "03.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7671",
    "Name": "Nine Energy Service",
    "Symbol": "NINE",
    " marketcap ": " $65 704 316 ",
    "price (USD)": "\u044f\u043d\u0432.86",
    "country": "United States"
  },
  {
    "Rank": "7672",
    "Name": "Pro-Dex",
    "Symbol": "PDEX",
    " marketcap ": " $65 489 248 ",
    "price (USD)": "19.154",
    "country": "United States"
  },
  {
    "Rank": "7673",
    "Name": "enVVeno Medical Corporation",
    "Symbol": "NVNO",
    " marketcap ": " $65 449 316 ",
    "price (USD)": "\u0430\u043f\u0440.91",
    "country": "United States"
  },
  {
    "Rank": "7674",
    "Name": "Village Bank and Trust Financial",
    "Symbol": "VBFC",
    " marketcap ": " $65 417 188 ",
    "price (USD)": "43.75",
    "country": "United States"
  },
  {
    "Rank": "7675",
    "Name": "Sharjah Insurance",
    "Symbol": "SICO.AE",
    " marketcap ": " $65 347 020 ",
    "price (USD)": "0.44",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7676",
    "Name": "Aiming Inc",
    "Symbol": "3911.T",
    " marketcap ": " $65 131 249 ",
    "price (USD)": "1.39466",
    "country": "Japan"
  },
  {
    "Rank": "7677",
    "Name": "CXApp",
    "Symbol": "CXAI",
    " marketcap ": " $65 128 940 ",
    "price (USD)": "\u043c\u0430\u0440.14",
    "country": "United States"
  },
  {
    "Rank": "7678",
    "Name": "Summit State Bank",
    "Symbol": "SSBI",
    " marketcap ": " $65 059 520 ",
    "price (USD)": "\u0441\u0435\u043d.59",
    "country": "United States"
  },
  {
    "Rank": "7679",
    "Name": "Turnstone Biologics",
    "Symbol": "TSBX",
    " marketcap ": " $64 991 084 ",
    "price (USD)": "\u0444\u0435\u0432.81",
    "country": "United States"
  },
  {
    "Rank": "7680",
    "Name": "Blue Hat",
    "Symbol": "BHAT",
    " marketcap ": " $64 810 432 ",
    "price (USD)": "1.1098",
    "country": "China"
  },
  {
    "Rank": "7681",
    "Name": "Lead Real Estate",
    "Symbol": "LRE",
    " marketcap ": " $64 662 604 ",
    "price (USD)": "\u0430\u043f\u0440.74",
    "country": "Japan"
  },
  {
    "Rank": "7682",
    "Name": "AN2 Therapeutics",
    "Symbol": "ANTX",
    " marketcap ": " $64 579 784 ",
    "price (USD)": "2.165",
    "country": "United States"
  },
  {
    "Rank": "7683",
    "Name": "AEON Biopharma",
    "Symbol": "AEON",
    " marketcap ": " $64 551 628 ",
    "price (USD)": "\u044f\u043d\u0432.65",
    "country": "United States"
  },
  {
    "Rank": "7684",
    "Name": "Comtech Telecommunications",
    "Symbol": "CMTL",
    " marketcap ": " $64 066 048 ",
    "price (USD)": "\u0444\u0435\u0432.25",
    "country": "United States"
  },
  {
    "Rank": "7685",
    "Name": "Feiyu Technology International Company",
    "Symbol": "1022.HK",
    " marketcap ": " $63 879 798 ",
    "price (USD)": "0.0365201",
    "country": "China"
  },
  {
    "Rank": "7686",
    "Name": "Mural Oncology",
    "Symbol": "MURA",
    " marketcap ": " $63 803 104 ",
    "price (USD)": "\u043c\u0430\u0440.77",
    "country": "Ireland"
  },
  {
    "Rank": "7687",
    "Name": "Sarcos Technology and Robotics",
    "Symbol": "STRC",
    " marketcap ": " $63 659 880 ",
    "price (USD)": "\u0444\u0435\u0432.46",
    "country": "United States"
  },
  {
    "Rank": "7688",
    "Name": "Curis",
    "Symbol": "CRIS",
    " marketcap ": " $63 626 596 ",
    "price (USD)": "10.795",
    "country": "United States"
  },
  {
    "Rank": "7689",
    "Name": "Investigator Resources",
    "Symbol": "IVR.AX",
    " marketcap ": " $63 368 713 ",
    "price (USD)": "0.0400085",
    "country": "Australia"
  },
  {
    "Rank": "7690",
    "Name": "Reneo Pharmaceuticals",
    "Symbol": "RPHM",
    " marketcap ": " $63 165 312 ",
    "price (USD)": "\u044f\u043d\u0432.89",
    "country": "United States"
  },
  {
    "Rank": "7691",
    "Name": "CAVE Interactive",
    "Symbol": "3760.T",
    " marketcap ": " $63 069 170 ",
    "price (USD)": "\u043e\u043a\u0442.28",
    "country": "Japan"
  },
  {
    "Rank": "7692",
    "Name": "Monogram Orthopaedics",
    "Symbol": "MGRM",
    " marketcap ": " $63 024 096 ",
    "price (USD)": "\u044f\u043d\u0432.99",
    "country": "United States"
  },
  {
    "Rank": "7693",
    "Name": "Pixelworks",
    "Symbol": "PXLW",
    " marketcap ": " $63 009 960 ",
    "price (USD)": "01.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "7694",
    "Name": "KORE",
    "Symbol": "KORE",
    " marketcap ": " $62 846 864 ",
    "price (USD)": "0.7554",
    "country": "United States"
  },
  {
    "Rank": "7695",
    "Name": "XOS",
    "Symbol": "XOS",
    " marketcap ": " $62 750 676 ",
    "price (USD)": "\u0438\u044e\u043b.97",
    "country": "United States"
  },
  {
    "Rank": "7696",
    "Name": "Focus Entertainment",
    "Symbol": "ALFOC.PA",
    " marketcap ": " $62 731 914 ",
    "price (USD)": "9.90336",
    "country": "France"
  },
  {
    "Rank": "7697",
    "Name": "INNOVATE Corp.",
    "Symbol": "VATE",
    " marketcap ": " $62 641 676 ",
    "price (USD)": "0.7353",
    "country": "United States"
  },
  {
    "Rank": "7698",
    "Name": "Vicarious Surgical",
    "Symbol": "RBOT",
    " marketcap ": " $62 580 448 ",
    "price (USD)": "0.3555",
    "country": "United States"
  },
  {
    "Rank": "7699",
    "Name": "Gryphon Digital Mining",
    "Symbol": "GRYP",
    " marketcap ": " $62 442 800 ",
    "price (USD)": "\u044f\u043d\u0432.59",
    "country": "United States"
  },
  {
    "Rank": "7700",
    "Name": "HeartBeam",
    "Symbol": "BEAT",
    " marketcap ": " $62 399 728 ",
    "price (USD)": "\u0444\u0435\u0432.37",
    "country": "United States"
  },
  {
    "Rank": "7701",
    "Name": "Qatari German Company for Medical Devices",
    "Symbol": "QGMD.QA",
    " marketcap ": " $62 192 308 ",
    "price (USD)": "0.538462",
    "country": "Qatar"
  },
  {
    "Rank": "7702",
    "Name": "AVROBIO",
    "Symbol": "AVRO",
    " marketcap ": " $61 953 444 ",
    "price (USD)": "\u044f\u043d\u0432.38",
    "country": "United States"
  },
  {
    "Rank": "7703",
    "Name": "Edgio",
    "Symbol": "EGIO",
    " marketcap ": " $61 891 048 ",
    "price (USD)": "\u043e\u043a\u0442.57",
    "country": "United States"
  },
  {
    "Rank": "7704",
    "Name": "Bigtincan",
    "Symbol": "BTH.AX",
    " marketcap ": " $61 638 451 ",
    "price (USD)": "0.100021",
    "country": "Australia"
  },
  {
    "Rank": "7705",
    "Name": "Synlait Milk",
    "Symbol": "SML.NZ",
    " marketcap ": " $61 602 573 ",
    "price (USD)": "0.281828",
    "country": "New Zealand"
  },
  {
    "Rank": "7706",
    "Name": "Zevia",
    "Symbol": "ZVIA",
    " marketcap ": " $61 303 500 ",
    "price (USD)": "0.95",
    "country": "United States"
  },
  {
    "Rank": "7707",
    "Name": "Kronos Bio",
    "Symbol": "KRON",
    " marketcap ": " $61 296 288 ",
    "price (USD)": "01.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7708",
    "Name": "Aram Group",
    "Symbol": "ARAM.AE",
    " marketcap ": " $61 226 916 ",
    "price (USD)": "0.78",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7709",
    "Name": "Theratechnologies",
    "Symbol": "THTX",
    " marketcap ": " $61 153 400 ",
    "price (USD)": "\u044f\u043d\u0432.33",
    "country": "Canada"
  },
  {
    "Rank": "7710",
    "Name": "Manhattan Bridge Capital",
    "Symbol": "LOAN",
    " marketcap ": " $61 082 660 ",
    "price (USD)": "\u043c\u0430\u0439.34",
    "country": "United States"
  },
  {
    "Rank": "7711",
    "Name": "Top Ships",
    "Symbol": "TOPS",
    " marketcap ": " $61 065 840 ",
    "price (USD)": "13.\u0444\u0435\u0432",
    "country": "Greece"
  },
  {
    "Rank": "7712",
    "Name": "GAN",
    "Symbol": "GAN",
    " marketcap ": " $60 823 004 ",
    "price (USD)": "\u044f\u043d\u0432.34",
    "country": "United Kingdom"
  },
  {
    "Rank": "7713",
    "Name": "Ashford Hospitality Trust",
    "Symbol": "AHT",
    " marketcap ": " $60 762 252 ",
    "price (USD)": "\u044f\u043d\u0432.31",
    "country": "United States"
  },
  {
    "Rank": "7714",
    "Name": "Milestone Scientific",
    "Symbol": "MLSS",
    " marketcap ": " $60 623 744 ",
    "price (USD)": "0.785",
    "country": "United States"
  },
  {
    "Rank": "7715",
    "Name": "Bakhu Holdings",
    "Symbol": "BKUH",
    " marketcap ": " $60 260 604 ",
    "price (USD)": "0.2",
    "country": "United States"
  },
  {
    "Rank": "7716",
    "Name": "Logan Ridge Finance",
    "Symbol": "LRFC",
    " marketcap ": " $60 049 440 ",
    "price (USD)": "22.44",
    "country": "United States"
  },
  {
    "Rank": "7717",
    "Name": "LivePerson",
    "Symbol": "LPSN",
    " marketcap ": " $59 920 848 ",
    "price (USD)": "0.6762",
    "country": "United States"
  },
  {
    "Rank": "7718",
    "Name": "Imagineer",
    "Symbol": "4644.T",
    " marketcap ": " $59 894 869 ",
    "price (USD)": "6.22481",
    "country": "Japan"
  },
  {
    "Rank": "7719",
    "Name": "KLab",
    "Symbol": "3656.T",
    " marketcap ": " $59 779 511 ",
    "price (USD)": "1.47783",
    "country": "Japan"
  },
  {
    "Rank": "7720",
    "Name": "U.S. Gold Corp",
    "Symbol": "USAU",
    " marketcap ": " $59 726 592 ",
    "price (USD)": "06.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "7721",
    "Name": "Reading International",
    "Symbol": "RDI",
    " marketcap ": " $59 646 952 ",
    "price (USD)": "\u044f\u043d\u0432.66",
    "country": "United States"
  },
  {
    "Rank": "7722",
    "Name": "VolitionRx",
    "Symbol": "VNRX",
    " marketcap ": " $59 637 776 ",
    "price (USD)": "0.72005",
    "country": "United States"
  },
  {
    "Rank": "7723",
    "Name": "Farmer Brothers",
    "Symbol": "FARM",
    " marketcap ": " $59 540 040 ",
    "price (USD)": "02.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "7724",
    "Name": "Hayah Insurance Company",
    "Symbol": "HAYAH.AE",
    " marketcap ": " $59 356 876 ",
    "price (USD)": "0.3",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7725",
    "Name": "Beyond Air",
    "Symbol": "XAIR",
    " marketcap ": " $59 212 032 ",
    "price (USD)": "\u044f\u043d\u0432.29",
    "country": "United States"
  },
  {
    "Rank": "7726",
    "Name": "illumin",
    "Symbol": "ILLM.TO",
    " marketcap ": " $59 009 225 ",
    "price (USD)": "1.12907",
    "country": "Canada"
  },
  {
    "Rank": "7727",
    "Name": "Carisma Therapeutics",
    "Symbol": "CARM",
    " marketcap ": " $58 990 632 ",
    "price (USD)": "\u044f\u043d\u0432.42",
    "country": "United States"
  },
  {
    "Rank": "7728",
    "Name": "freelancer.com",
    "Symbol": "FLN.AX",
    " marketcap ": " $58 815 577 ",
    "price (USD)": "0.130028",
    "country": "Australia"
  },
  {
    "Rank": "7729",
    "Name": "AXIL Brands",
    "Symbol": "AXIL",
    " marketcap ": " $58 784 696 ",
    "price (USD)": "\u0441\u0435\u043d.92",
    "country": "United States"
  },
  {
    "Rank": "7730",
    "Name": "Augmedix",
    "Symbol": "AUGX",
    " marketcap ": " $58 761 244 ",
    "price (USD)": "01.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7731",
    "Name": "the Marygold Companies",
    "Symbol": "MGLD",
    " marketcap ": " $58 754 872 ",
    "price (USD)": "\u044f\u043d\u0432.49",
    "country": "United States"
  },
  {
    "Rank": "7732",
    "Name": "Xebec Adsorption",
    "Symbol": "XBC.TO",
    " marketcap ": " $58 696 946 ",
    "price (USD)": "0.38",
    "country": "Canada"
  },
  {
    "Rank": "7733",
    "Name": "Ideal Power",
    "Symbol": "IPWR",
    " marketcap ": " $58 553 908 ",
    "price (USD)": "\u0438\u044e\u043b.62",
    "country": "United States"
  },
  {
    "Rank": "7734",
    "Name": "Natuzzi",
    "Symbol": "NTZ",
    " marketcap ": " $58 377 384 ",
    "price (USD)": "05.\u043c\u0430\u0440",
    "country": "Italy"
  },
  {
    "Rank": "7735",
    "Name": "Genius Group",
    "Symbol": "GNS",
    " marketcap ": " $58 335 964 ",
    "price (USD)": "0.3134",
    "country": "Singapore"
  },
  {
    "Rank": "7736",
    "Name": "Cenntro Electric Group",
    "Symbol": "CENN",
    " marketcap ": " $58 266 432 ",
    "price (USD)": "\u044f\u043d\u0432.89",
    "country": "United States"
  },
  {
    "Rank": "7737",
    "Name": "ATARI",
    "Symbol": "ALATA.PA",
    " marketcap ": " $58 170 794 ",
    "price (USD)": "0.131393",
    "country": "France"
  },
  {
    "Rank": "7738",
    "Name": "Silver One Resources",
    "Symbol": "SVE.V",
    " marketcap ": " $58 131 627 ",
    "price (USD)": "0.234613",
    "country": "Canada"
  },
  {
    "Rank": "7739",
    "Name": "InspireMD",
    "Symbol": "NSPR",
    " marketcap ": " $58 086 432 ",
    "price (USD)": "\u0444\u0435\u0432.33",
    "country": "Israel"
  },
  {
    "Rank": "7740",
    "Name": "Velo3D",
    "Symbol": "VLD",
    " marketcap ": " $57 786 276 ",
    "price (USD)": "0.1951",
    "country": "United States"
  },
  {
    "Rank": "7741",
    "Name": "Union Insurance Company",
    "Symbol": "UNION.AE",
    " marketcap ": " $57 759 146 ",
    "price (USD)": "0.17",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7742",
    "Name": "CarParts.com",
    "Symbol": "PRTS",
    " marketcap ": " $57 673 972 ",
    "price (USD)": "01.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "7743",
    "Name": "Marchex",
    "Symbol": "MCHX",
    " marketcap ": " $57 655 756 ",
    "price (USD)": "\u044f\u043d\u0432.32",
    "country": "United States"
  },
  {
    "Rank": "7744",
    "Name": "Grove Collaborative",
    "Symbol": "GROV",
    " marketcap ": " $57 654 820 ",
    "price (USD)": "\u044f\u043d\u0432.51",
    "country": "United States"
  },
  {
    "Rank": "7745",
    "Name": "TuSimple",
    "Symbol": "TSP",
    " marketcap ": " $57 472 752 ",
    "price (USD)": "0.25",
    "country": "United States"
  },
  {
    "Rank": "7746",
    "Name": "Reliance Communications",
    "Symbol": "RCOM.NS",
    " marketcap ": " $57 073 487 ",
    "price (USD)": "0.0204261",
    "country": "India"
  },
  {
    "Rank": "7747",
    "Name": "Know Labs",
    "Symbol": "KNW",
    " marketcap ": " $56 951 124 ",
    "price (USD)": "0.666",
    "country": "United States"
  },
  {
    "Rank": "7748",
    "Name": "Phunware",
    "Symbol": "PHUN",
    " marketcap ": " $56 829 256 ",
    "price (USD)": "\u0438\u044e\u043d.87",
    "country": "United States"
  },
  {
    "Rank": "7749",
    "Name": "Airgain",
    "Symbol": "AIRG",
    " marketcap ": " $56 796 896 ",
    "price (USD)": "\u043c\u0430\u0439.27",
    "country": "United States"
  },
  {
    "Rank": "7750",
    "Name": "Eagle Pharmaceuticals",
    "Symbol": "EGRX",
    " marketcap ": " $56 627 332 ",
    "price (USD)": "\u0430\u043f\u0440.37",
    "country": "United States"
  },
  {
    "Rank": "7751",
    "Name": "Clean Energy Technologies",
    "Symbol": "CETY",
    " marketcap ": " $56 545 108 ",
    "price (USD)": "\u044f\u043d\u0432.32",
    "country": "United States"
  },
  {
    "Rank": "7752",
    "Name": "Kezar Life Sciences",
    "Symbol": "KZR",
    " marketcap ": " $56 486 608 ",
    "price (USD)": "0.7759",
    "country": "United States"
  },
  {
    "Rank": "7753",
    "Name": "Viomi Technology",
    "Symbol": "VIOT",
    " marketcap ": " $56 421 372 ",
    "price (USD)": "0.8269",
    "country": "China"
  },
  {
    "Rank": "7754",
    "Name": "Ocean Biomedical",
    "Symbol": "OCEA",
    " marketcap ": " $56 304 624 ",
    "price (USD)": "1.625",
    "country": "United States"
  },
  {
    "Rank": "7755",
    "Name": "Sotherly Hotels",
    "Symbol": "SOHO",
    " marketcap ": " $55 874 280 ",
    "price (USD)": "01.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "7756",
    "Name": "REE Automotive",
    "Symbol": "REE",
    " marketcap ": " $55 762 140 ",
    "price (USD)": "\u043c\u0430\u0439.15",
    "country": "Israel"
  },
  {
    "Rank": "7757",
    "Name": "The Beachbody Company",
    "Symbol": "BODY",
    " marketcap ": " $55 603 528 ",
    "price (USD)": "\u0430\u0432\u0433.14",
    "country": "United States"
  },
  {
    "Rank": "7758",
    "Name": "Petropavlovsk",
    "Symbol": "POG.L",
    " marketcap ": " $55 504 929 ",
    "price (USD)": "01.\u0430\u043f\u0440",
    "country": "United Kingdom"
  },
  {
    "Rank": "7759",
    "Name": "uCloudlink Group",
    "Symbol": "UCL",
    " marketcap ": " $55 498 812 ",
    "price (USD)": "\u044f\u043d\u0432.03",
    "country": "Hong Kong"
  },
  {
    "Rank": "7760",
    "Name": "Kingstone Companies",
    "Symbol": "KINS",
    " marketcap ": " $55 480 320 ",
    "price (USD)": "05.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "7761",
    "Name": "Apyx Medical",
    "Symbol": "APYX",
    " marketcap ": " $55 430 240 ",
    "price (USD)": "01.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7762",
    "Name": "N.B.I. Industrial Finance",
    "Symbol": "NBIFIN.NS",
    " marketcap ": " $55 345 900 ",
    "price (USD)": "22.5275",
    "country": "India"
  },
  {
    "Rank": "7763",
    "Name": "Genenta Science",
    "Symbol": "GNTA",
    " marketcap ": " $55 153 792 ",
    "price (USD)": "3.0276",
    "country": "Italy"
  },
  {
    "Rank": "7764",
    "Name": "Inotiv",
    "Symbol": "NOTV",
    " marketcap ": " $55 059 364 ",
    "price (USD)": "02.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "7765",
    "Name": "Selina Hospitality",
    "Symbol": "SLNA",
    " marketcap ": " $54 910 572 ",
    "price (USD)": "0.101",
    "country": "United Kingdom"
  },
  {
    "Rank": "7766",
    "Name": "Rockwell Medical",
    "Symbol": "RMTI",
    " marketcap ": " $54 568 260 ",
    "price (USD)": "01.\u0430\u0432\u0433",
    "country": "United States"
  },
  {
    "Rank": "7767",
    "Name": "Allied Esports",
    "Symbol": "AESE",
    " marketcap ": " $54 324 936 ",
    "price (USD)": "\u044f\u043d\u0432.99",
    "country": "United States"
  },
  {
    "Rank": "7768",
    "Name": "Naked Wines",
    "Symbol": "WINE.L",
    " marketcap ": " $54 200 801 ",
    "price (USD)": "0.732403",
    "country": "United Kingdom"
  },
  {
    "Rank": "7769",
    "Name": "Culp",
    "Symbol": "CULP",
    " marketcap ": " $54 119 368 ",
    "price (USD)": "\u0430\u043f\u0440.34",
    "country": "United States"
  },
  {
    "Rank": "7770",
    "Name": "Enzo Biochem",
    "Symbol": "ENZ",
    " marketcap ": " $53 786 984 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7771",
    "Name": "Harte Hanks",
    "Symbol": "HHS",
    " marketcap ": " $53 365 432 ",
    "price (USD)": "\u0438\u044e\u043b.37",
    "country": "United States"
  },
  {
    "Rank": "7772",
    "Name": "Intellicheck",
    "Symbol": "IDN",
    " marketcap ": " $53 341 772 ",
    "price (USD)": "\u0444\u0435\u0432.74",
    "country": "United States"
  },
  {
    "Rank": "7773",
    "Name": "Satixfy Communications",
    "Symbol": "SATX",
    " marketcap ": " $53 077 700 ",
    "price (USD)": "0.635001",
    "country": "Israel"
  },
  {
    "Rank": "7774",
    "Name": "HanseYachts AG",
    "Symbol": "H9Y.DE",
    " marketcap ": " $52 974 959 ",
    "price (USD)": "2.77989",
    "country": "Germany"
  },
  {
    "Rank": "7775",
    "Name": "Fisker",
    "Symbol": "FSR",
    " marketcap ": " $52 815 864 ",
    "price (USD)": "0.08965",
    "country": "United States"
  },
  {
    "Rank": "7776",
    "Name": "LightPath Technologies",
    "Symbol": "LPTH",
    " marketcap ": " $52 195 956 ",
    "price (USD)": "1.345",
    "country": "United States"
  },
  {
    "Rank": "7777",
    "Name": "Aeria",
    "Symbol": "3758.T",
    " marketcap ": " $51 582 741 ",
    "price (USD)": "2.31591",
    "country": "Japan"
  },
  {
    "Rank": "7778",
    "Name": "Gulf Cement",
    "Symbol": "GCEM.AE",
    " marketcap ": " $51 420 554 ",
    "price (USD)": "0.13",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7779",
    "Name": "GRIID Infrastructure",
    "Symbol": "GRDI.NE",
    " marketcap ": " $51 250 738 ",
    "price (USD)": "0.75516",
    "country": "USA"
  },
  {
    "Rank": "7780",
    "Name": "Global Fashion Group",
    "Symbol": "GFG.DE",
    " marketcap ": " $51 212 379 ",
    "price (USD)": "0.222608",
    "country": "Luxembourg"
  },
  {
    "Rank": "7781",
    "Name": "Cytosorbents",
    "Symbol": "CTSO",
    " marketcap ": " $51 048 016 ",
    "price (USD)": "0.94",
    "country": "United States"
  },
  {
    "Rank": "7782",
    "Name": "DZS Inc",
    "Symbol": "DZSI",
    " marketcap ": " $50 889 464 ",
    "price (USD)": "1.355",
    "country": "United States"
  },
  {
    "Rank": "7783",
    "Name": "Mesa Air",
    "Symbol": "MESA",
    " marketcap ": " $50 765 972 ",
    "price (USD)": "\u044f\u043d\u0432.24",
    "country": "United States"
  },
  {
    "Rank": "7784",
    "Name": "S.S. Lazio",
    "Symbol": "SSL.MI",
    " marketcap ": " $50 754 523 ",
    "price (USD)": "0.749267",
    "country": "Italy"
  },
  {
    "Rank": "7785",
    "Name": "Interlink Electronics",
    "Symbol": "LINK",
    " marketcap ": " $50 485 092 ",
    "price (USD)": "05.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "7786",
    "Name": "Qatar Cinema and Film Distribution Company",
    "Symbol": "QCFS.QA",
    " marketcap ": " $50 211 890 ",
    "price (USD)": "0.799451",
    "country": "Qatar"
  },
  {
    "Rank": "7787",
    "Name": "The InterGroup Corporation",
    "Symbol": "INTG",
    " marketcap ": " $50 152 724 ",
    "price (USD)": "22.93",
    "country": "United States"
  },
  {
    "Rank": "7788",
    "Name": "Zepp Health",
    "Symbol": "ZEPP",
    " marketcap ": " $50 083 384 ",
    "price (USD)": "0.835",
    "country": "China"
  },
  {
    "Rank": "7789",
    "Name": "Quantum",
    "Symbol": "QMCO",
    " marketcap ": " $49 981 852 ",
    "price (USD)": "0.5259",
    "country": "United States"
  },
  {
    "Rank": "7790",
    "Name": "BioLineRx",
    "Symbol": "BLRX",
    " marketcap ": " $49 794 188 ",
    "price (USD)": "0.6229",
    "country": "Israel"
  },
  {
    "Rank": "7791",
    "Name": "Direct Digital Holdings",
    "Symbol": "DRCT",
    " marketcap ": " $49 783 396 ",
    "price (USD)": "\u043c\u0430\u0440.47",
    "country": "United States"
  },
  {
    "Rank": "7792",
    "Name": "LL Flooring",
    "Symbol": "LL",
    " marketcap ": " $49 664 988 ",
    "price (USD)": "\u044f\u043d\u0432.62",
    "country": "United States"
  },
  {
    "Rank": "7793",
    "Name": "DocCheck",
    "Symbol": "AJ91.DE",
    " marketcap ": " $49 586 687 ",
    "price (USD)": "9.77305",
    "country": "Germany"
  },
  {
    "Rank": "7794",
    "Name": "Mullen Automotive",
    "Symbol": "MULN",
    " marketcap ": " $49 245 368 ",
    "price (USD)": "4.315",
    "country": "United States"
  },
  {
    "Rank": "7795",
    "Name": "Okyo Pharma",
    "Symbol": "OKYO",
    " marketcap ": " $48 856 920 ",
    "price (USD)": "\u044f\u043d\u0432.47",
    "country": "United Kingdom"
  },
  {
    "Rank": "7796",
    "Name": "Koss",
    "Symbol": "KOSS",
    " marketcap ": " $48 587 700 ",
    "price (USD)": "\u043c\u0430\u0439.25",
    "country": "United States"
  },
  {
    "Rank": "7797",
    "Name": "Fluent",
    "Symbol": "FLNT",
    " marketcap ": " $48 495 128 ",
    "price (USD)": "\u043c\u0430\u0440.55",
    "country": "United States"
  },
  {
    "Rank": "7798",
    "Name": "Hinduja Ventures",
    "Symbol": "NXTDIGITAL.NS",
    " marketcap ": " $48 138 727 ",
    "price (USD)": "\u044f\u043d\u0432.43",
    "country": "India"
  },
  {
    "Rank": "7799",
    "Name": "Azure Power",
    "Symbol": "AZREF",
    " marketcap ": " $48 124 800 ",
    "price (USD)": "0.75",
    "country": "India"
  },
  {
    "Rank": "7800",
    "Name": "Nicholas Financial",
    "Symbol": "NICK",
    " marketcap ": " $48 044 792 ",
    "price (USD)": "\u0438\u044e\u043d.59",
    "country": "United States"
  },
  {
    "Rank": "7801",
    "Name": "Gorilla Technology",
    "Symbol": "GRRR",
    " marketcap ": " $47 511 088 ",
    "price (USD)": "\u043c\u0430\u0439.59",
    "country": "Taiwan"
  },
  {
    "Rank": "7802",
    "Name": "Lucid Diagnostics",
    "Symbol": "LUCD",
    " marketcap ": " $47 408 468 ",
    "price (USD)": "0.9097",
    "country": "United States"
  },
  {
    "Rank": "7803",
    "Name": "Moolec Science",
    "Symbol": "MLEC",
    " marketcap ": " $47 330 388 ",
    "price (USD)": "\u044f\u043d\u0432.26",
    "country": "Luxembourg"
  },
  {
    "Rank": "7804",
    "Name": "Ondas Holdings",
    "Symbol": "ONDS",
    " marketcap ": " $47 119 608 ",
    "price (USD)": "0.711",
    "country": "United States"
  },
  {
    "Rank": "7805",
    "Name": "Verde Clean Fuels",
    "Symbol": "VGAS",
    " marketcap ": " $46 578 272 ",
    "price (USD)": "\u0430\u043f\u0440.94",
    "country": "United States"
  },
  {
    "Rank": "7806",
    "Name": "Perfect Moment",
    "Symbol": "PMNT",
    " marketcap ": " $46 490 600 ",
    "price (USD)": "\u0444\u0435\u0432.97",
    "country": "United Kingdom"
  },
  {
    "Rank": "7807",
    "Name": "CROOZ",
    "Symbol": "2138.T",
    " marketcap ": " $46 230 633 ",
    "price (USD)": "4.47828",
    "country": "Japan"
  },
  {
    "Rank": "7808",
    "Name": "PermRock Royalty Trust",
    "Symbol": "PRT",
    " marketcap ": " $45 986 344 ",
    "price (USD)": "\u043c\u0430\u0440.78",
    "country": "United States"
  },
  {
    "Rank": "7809",
    "Name": "Zion Oil &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7810",
    "Name": "Cutera",
    "Symbol": "CUTR",
    " marketcap ": " $45 764 388 ",
    "price (USD)": "\u0444\u0435\u0432.28",
    "country": "United States"
  },
  {
    "Rank": "7811",
    "Name": "Immuneering",
    "Symbol": "IMRX",
    " marketcap ": " $45 666 236 ",
    "price (USD)": "\u044f\u043d\u0432.54",
    "country": "United States"
  },
  {
    "Rank": "7812",
    "Name": "Aadi Bioscience",
    "Symbol": "AADI",
    " marketcap ": " $45 425 272 ",
    "price (USD)": "\u044f\u043d\u0432.85",
    "country": "United States"
  },
  {
    "Rank": "7813",
    "Name": "Movano",
    "Symbol": "MOVE",
    " marketcap ": " $45 300 212 ",
    "price (USD)": "0.461",
    "country": "United States"
  },
  {
    "Rank": "7814",
    "Name": "Al Faleh Educational Holding",
    "Symbol": "FALH.QA",
    " marketcap ": " $45 296 703 ",
    "price (USD)": "0.188736",
    "country": "Qatar"
  },
  {
    "Rank": "7815",
    "Name": "Enviva",
    "Symbol": "EVA",
    " marketcap ": " $45 062 932 ",
    "price (USD)": "0.6049",
    "country": "United States"
  },
  {
    "Rank": "7816",
    "Name": "Lightbridge Corporation",
    "Symbol": "LTBR",
    " marketcap ": " $45 035 640 ",
    "price (USD)": "03.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "7817",
    "Name": "Altisource Portfolio",
    "Symbol": "ASPS",
    " marketcap ": " $45 022 696 ",
    "price (USD)": "\u044f\u043d\u0432.67",
    "country": "Luxembourg"
  },
  {
    "Rank": "7818",
    "Name": "Ocuphire Pharma",
    "Symbol": "OCUP",
    " marketcap ": " $44 848 868 ",
    "price (USD)": "\u044f\u043d\u0432.73",
    "country": "United States"
  },
  {
    "Rank": "7819",
    "Name": "Webuy Global",
    "Symbol": "WBUY",
    " marketcap ": " $44 619 116 ",
    "price (USD)": "0.74",
    "country": "Singapore"
  },
  {
    "Rank": "7820",
    "Name": "The Oncology Institute",
    "Symbol": "TOI",
    " marketcap ": " $44 364 992 ",
    "price (USD)": "0.596",
    "country": "United States"
  },
  {
    "Rank": "7821",
    "Name": "Xilio Therapeutics",
    "Symbol": "XLO",
    " marketcap ": " $44 294 880 ",
    "price (USD)": "01.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7822",
    "Name": "Mogo",
    "Symbol": "MOGO",
    " marketcap ": " $44 266 816 ",
    "price (USD)": "\u044f\u043d\u0432.77",
    "country": "Canada"
  },
  {
    "Rank": "7823",
    "Name": "Renalytix",
    "Symbol": "RNLX",
    " marketcap ": " $44 128 024 ",
    "price (USD)": "0.4356",
    "country": "United Kingdom"
  },
  {
    "Rank": "7824",
    "Name": "Rain Therapeutics",
    "Symbol": "RAIN",
    " marketcap ": " $44 014 600 ",
    "price (USD)": "\u044f\u043d\u0432.21",
    "country": "United States"
  },
  {
    "Rank": "7825",
    "Name": "Courtside Group (PodcastOne)",
    "Symbol": "PODC",
    " marketcap ": " $43 985 188 ",
    "price (USD)": "01.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "7826",
    "Name": "Usio",
    "Symbol": "USIO",
    " marketcap ": " $43 875 128 ",
    "price (USD)": "\u044f\u043d\u0432.66",
    "country": "United States"
  },
  {
    "Rank": "7827",
    "Name": "NCS Multistage",
    "Symbol": "NCSM",
    " marketcap ": " $43 844 852 ",
    "price (USD)": "17.52",
    "country": "United States"
  },
  {
    "Rank": "7828",
    "Name": "The9",
    "Symbol": "NCTY",
    " marketcap ": " $43 668 992 ",
    "price (USD)": "\u0438\u044e\u043b.82",
    "country": "China"
  },
  {
    "Rank": "7829",
    "Name": "BrainStorm Cell Therapeutics",
    "Symbol": "BCLI",
    " marketcap ": " $43 449 908 ",
    "price (USD)": "0.62",
    "country": "United States"
  },
  {
    "Rank": "7830",
    "Name": "Sequans Communications",
    "Symbol": "SQNS",
    " marketcap ": " $43 351 036 ",
    "price (USD)": "0.6999",
    "country": "France"
  },
  {
    "Rank": "7831",
    "Name": "iCAD",
    "Symbol": "ICAD",
    " marketcap ": " $43 260 200 ",
    "price (USD)": "\u044f\u043d\u0432.63",
    "country": "United States"
  },
  {
    "Rank": "7832",
    "Name": "East Side Games",
    "Symbol": "EAGR.TO",
    " marketcap ": " $43 007 899 ",
    "price (USD)": "0.527469",
    "country": "Canada"
  },
  {
    "Rank": "7833",
    "Name": "Dare Bioscience",
    "Symbol": "DARE",
    " marketcap ": " $42 903 868 ",
    "price (USD)": "0.4244",
    "country": "United States"
  },
  {
    "Rank": "7834",
    "Name": "Cepton",
    "Symbol": "CPTN",
    " marketcap ": " $42 827 220 ",
    "price (USD)": "\u0444\u0435\u0432.69",
    "country": "United States"
  },
  {
    "Rank": "7835",
    "Name": "IZEA Worldwide",
    "Symbol": "IZEA",
    " marketcap ": " $42 810 536 ",
    "price (USD)": "\u0444\u0435\u0432.62",
    "country": "United States"
  },
  {
    "Rank": "7836",
    "Name": "5th Planet Games",
    "Symbol": "5PG.OL",
    " marketcap ": " $42 801 020 ",
    "price (USD)": "0.15948",
    "country": "Denmark"
  },
  {
    "Rank": "7837",
    "Name": "coly",
    "Symbol": "4175.T",
    " marketcap ": " $42 597 480 ",
    "price (USD)": "7.74103",
    "country": "Japan"
  },
  {
    "Rank": "7838",
    "Name": "Incannex Healthcare",
    "Symbol": "IXHL",
    " marketcap ": " $42 531 868 ",
    "price (USD)": "\u0444\u0435\u0432.68",
    "country": "Australia"
  },
  {
    "Rank": "7839",
    "Name": "Alta Global Group",
    "Symbol": "MMA",
    " marketcap ": " $42 492 312 ",
    "price (USD)": "4.1565",
    "country": "Australia"
  },
  {
    "Rank": "7840",
    "Name": "Jianzhi Education Technology Group",
    "Symbol": "JZ",
    " marketcap ": " $42 489 424 ",
    "price (USD)": "2.105",
    "country": "China"
  },
  {
    "Rank": "7841",
    "Name": "Don't Nod Entertainment",
    "Symbol": "ALDNE.PA",
    " marketcap ": " $42 210 572 ",
    "price (USD)": "3.23596",
    "country": "France"
  },
  {
    "Rank": "7842",
    "Name": "Jaguar Health",
    "Symbol": "JAGX",
    " marketcap ": " $41 832 280 ",
    "price (USD)": "0.1426",
    "country": "United States"
  },
  {
    "Rank": "7843",
    "Name": "VCI Global",
    "Symbol": "VCIG",
    " marketcap ": " $41 488 552 ",
    "price (USD)": "0.86",
    "country": "Malaysia"
  },
  {
    "Rank": "7844",
    "Name": "Benson Hill",
    "Symbol": "BHIL",
    " marketcap ": " $41 447 564 ",
    "price (USD)": "0.1955",
    "country": "United States"
  },
  {
    "Rank": "7845",
    "Name": "Scienjoy",
    "Symbol": "SJ",
    " marketcap ": " $41 437 856 ",
    "price (USD)": "0.9999",
    "country": "China"
  },
  {
    "Rank": "7846",
    "Name": "CASI Pharmaceuticals",
    "Symbol": "CASI",
    " marketcap ": " $41 410 324 ",
    "price (USD)": "03.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "7847",
    "Name": "Matinas BioPharma",
    "Symbol": "MTNB",
    " marketcap ": " $41 384 640 ",
    "price (USD)": "0.165",
    "country": "United States"
  },
  {
    "Rank": "7848",
    "Name": "Kartoon Studios",
    "Symbol": "TOON",
    " marketcap ": " $41 356 872 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7849",
    "Name": "NRx Pharmaceuticals",
    "Symbol": "NRXP",
    " marketcap ": " $41 304 316 ",
    "price (USD)": "\u043c\u0430\u0440.86",
    "country": "United States"
  },
  {
    "Rank": "7850",
    "Name": "Cara Therapeutics",
    "Symbol": "CARA",
    " marketcap ": " $41 214 768 ",
    "price (USD)": "0.7538",
    "country": "United States"
  },
  {
    "Rank": "7851",
    "Name": "reAlpha Tech",
    "Symbol": "AIRE",
    " marketcap ": " $41 121 796 ",
    "price (USD)": "0.932",
    "country": "United States"
  },
  {
    "Rank": "7852",
    "Name": "Starbreeze",
    "Symbol": "STAR-B.ST",
    " marketcap ": " $41 100 182 ",
    "price (USD)": "0.0275566",
    "country": "Sweden"
  },
  {
    "Rank": "7853",
    "Name": "Nano Labs",
    "Symbol": null,
    " marketcap ": " $40 956 636 ",
    "price (USD)": "0.5836",
    "country": "China"
  },
  {
    "Rank": "7854",
    "Name": "electroCore",
    "Symbol": "ECOR",
    " marketcap ": " $40 943 312 ",
    "price (USD)": "6.817",
    "country": "United States"
  },
  {
    "Rank": "7855",
    "Name": "Shimmick",
    "Symbol": "SHIM",
    " marketcap ": " $40 385 424 ",
    "price (USD)": "\u044f\u043d\u0432.57",
    "country": "United States"
  },
  {
    "Rank": "7856",
    "Name": "Inuvo",
    "Symbol": "INUV",
    " marketcap ": " $40 365 792 ",
    "price (USD)": "0.288",
    "country": "United States"
  },
  {
    "Rank": "7857",
    "Name": "Pestech Cambodia",
    "Symbol": "PEPC.KH",
    " marketcap ": " $40 191 882 ",
    "price (USD)": "0.54",
    "country": "Cambodia"
  },
  {
    "Rank": "7858",
    "Name": "The National Investor PRJSC",
    "Symbol": "TNI.AE",
    " marketcap ": " $40 118 986 ",
    "price (USD)": "0.14",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7859",
    "Name": "RAPCO Investment",
    "Symbol": "RAPCO.AE",
    " marketcap ": " $40 110 001 ",
    "price (USD)": "0.42",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7860",
    "Name": "S\u0413\u00b6ktas Tekstil",
    "Symbol": "SKTAS.IS",
    " marketcap ": " $39 996 148 ",
    "price (USD)": "0.180163",
    "country": "Turkey"
  },
  {
    "Rank": "7861",
    "Name": "BoomBit",
    "Symbol": "BBT.WA",
    " marketcap ": " $39 939 475 ",
    "price (USD)": "2.94974",
    "country": "Poland"
  },
  {
    "Rank": "7862",
    "Name": "Eyenovia",
    "Symbol": "EYEN",
    " marketcap ": " $39 713 556 ",
    "price (USD)": "0.7372",
    "country": "United States"
  },
  {
    "Rank": "7863",
    "Name": "Knightscope",
    "Symbol": "KSCP",
    " marketcap ": " $39 696 628 ",
    "price (USD)": "0.371",
    "country": "United States"
  },
  {
    "Rank": "7864",
    "Name": "Fortress Biotech",
    "Symbol": "FBIO",
    " marketcap ": " $39 433 880 ",
    "price (USD)": "\u044f\u043d\u0432.98",
    "country": "United States"
  },
  {
    "Rank": "7865",
    "Name": "Rafael Holdings",
    "Symbol": "RFL",
    " marketcap ": " $39 335 040 ",
    "price (USD)": "01.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "7866",
    "Name": "VYNE Therapeutics",
    "Symbol": "VYNE",
    " marketcap ": " $39 226 140 ",
    "price (USD)": "02.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "7867",
    "Name": "Phnom Penh SEZ",
    "Symbol": "PPSP.KH",
    " marketcap ": " $38 899 139 ",
    "price (USD)": "0.54",
    "country": "Cambodia"
  },
  {
    "Rank": "7868",
    "Name": "Sonder Holdings",
    "Symbol": "SOND",
    " marketcap ": " $38 726 448 ",
    "price (USD)": "03.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7869",
    "Name": "GEE Group",
    "Symbol": "JOB",
    " marketcap ": " $38 450 904 ",
    "price (USD)": "0.3535",
    "country": "United States"
  },
  {
    "Rank": "7870",
    "Name": "Hour Loop",
    "Symbol": "HOUR",
    " marketcap ": " $38 268 592 ",
    "price (USD)": "01.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "7871",
    "Name": "Cheetah Net Supply Chain Service",
    "Symbol": "CTNT",
    " marketcap ": " $38 229 992 ",
    "price (USD)": "\u044f\u043d\u0432.18",
    "country": "United States"
  },
  {
    "Rank": "7872",
    "Name": "The Container Store",
    "Symbol": "TCS",
    " marketcap ": " $38 148 396 ",
    "price (USD)": "0.769",
    "country": "United States"
  },
  {
    "Rank": "7873",
    "Name": "Pioneer Power Solutions",
    "Symbol": "PPSI",
    " marketcap ": " $38 031 976 ",
    "price (USD)": "\u043c\u0430\u0440.83",
    "country": "United States"
  },
  {
    "Rank": "7874",
    "Name": "Stronghold Digital Mining",
    "Symbol": "SDIG",
    " marketcap ": " $37 858 968 ",
    "price (USD)": "\u0444\u0435\u0432.92",
    "country": "United States"
  },
  {
    "Rank": "7875",
    "Name": "Inspira Technologies",
    "Symbol": "IINN",
    " marketcap ": " $37 835 428 ",
    "price (USD)": "\u0444\u0435\u0432.18",
    "country": "Israel"
  },
  {
    "Rank": "7876",
    "Name": "Hydrofarm",
    "Symbol": "HYFM",
    " marketcap ": " $37 711 812 ",
    "price (USD)": "0.8202",
    "country": "United States"
  },
  {
    "Rank": "7877",
    "Name": "OncoCyte",
    "Symbol": "OCX",
    " marketcap ": " $37 688 172 ",
    "price (USD)": "\u0444\u0435\u0432.82",
    "country": "United States"
  },
  {
    "Rank": "7878",
    "Name": "TENDA",
    "Symbol": "4198.T",
    " marketcap ": " $37 476 452 ",
    "price (USD)": "17.1582",
    "country": "Japan"
  },
  {
    "Rank": "7879",
    "Name": "PopReach",
    "Symbol": "POPR.V",
    " marketcap ": " $37 326 899 ",
    "price (USD)": "0.13",
    "country": "Canada"
  },
  {
    "Rank": "7880",
    "Name": "Quince Therapeutics",
    "Symbol": "QNCX",
    " marketcap ": " $37 165 072 ",
    "price (USD)": "0.86",
    "country": "United States"
  },
  {
    "Rank": "7881",
    "Name": "Astro Corporation",
    "Symbol": "3064.TWO",
    " marketcap ": " $36 839 082 ",
    "price (USD)": "2.83127",
    "country": "Taiwan"
  },
  {
    "Rank": "7882",
    "Name": "FC Porto",
    "Symbol": "FCP.LS",
    " marketcap ": " $36 648 765 ",
    "price (USD)": "1.62884",
    "country": "Portugal"
  },
  {
    "Rank": "7883",
    "Name": "Rapid Micro Biosystems",
    "Symbol": "RPID",
    " marketcap ": " $36 321 088 ",
    "price (USD)": "0.8474",
    "country": "United States"
  },
  {
    "Rank": "7884",
    "Name": "Nutex Health",
    "Symbol": "NUTX",
    " marketcap ": " $36 250 412 ",
    "price (USD)": "0.7291",
    "country": "United States"
  },
  {
    "Rank": "7885",
    "Name": "Gala Incorporated",
    "Symbol": "4777.T",
    " marketcap ": " $36 165 334 ",
    "price (USD)": "1.41386",
    "country": "Japan"
  },
  {
    "Rank": "7886",
    "Name": "Pixie Dust Technologies",
    "Symbol": "PXDT",
    " marketcap ": " $35 824 412 ",
    "price (USD)": "\u0444\u0435\u0432.41",
    "country": "Japan"
  },
  {
    "Rank": "7887",
    "Name": "TransAct Technologies",
    "Symbol": "TACT",
    " marketcap ": " $35 581 880 ",
    "price (USD)": "\u043c\u0430\u0440.56",
    "country": "United States"
  },
  {
    "Rank": "7888",
    "Name": "Comstock Mining",
    "Symbol": "LODE",
    " marketcap ": " $35 169 528 ",
    "price (USD)": "0.2544",
    "country": "United States"
  },
  {
    "Rank": "7889",
    "Name": "Lipocine",
    "Symbol": "LPCN",
    " marketcap ": " $35 135 968 ",
    "price (USD)": "\u0438\u044e\u043d.57",
    "country": "United States"
  },
  {
    "Rank": "7890",
    "Name": "DIRTT Environmental Solutions",
    "Symbol": "DRTT",
    " marketcap ": " $35 057 372 ",
    "price (USD)": "0.3343",
    "country": "Canada"
  },
  {
    "Rank": "7891",
    "Name": "Fathom Digital Manufacturing",
    "Symbol": "FATH",
    " marketcap ": " $34 682 392 ",
    "price (USD)": "05.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "7892",
    "Name": "Science 37",
    "Symbol": "SNCE",
    " marketcap ": " $34 661 976 ",
    "price (USD)": "\u043c\u0430\u0439.75",
    "country": "United States"
  },
  {
    "Rank": "7893",
    "Name": "Home Federal Bancorp (HFB Bank)",
    "Symbol": "HFBL",
    " marketcap ": " $34 532 024 ",
    "price (USD)": "11.0024",
    "country": "United States"
  },
  {
    "Rank": "7894",
    "Name": "Owlet",
    "Symbol": "OWLT",
    " marketcap ": " $34 472 424 ",
    "price (USD)": "\u043c\u0430\u0440.81",
    "country": "United States"
  },
  {
    "Rank": "7895",
    "Name": "LianBio",
    "Symbol": "LIAN",
    " marketcap ": " $34 472 096 ",
    "price (USD)": "0.319",
    "country": "United States"
  },
  {
    "Rank": "7896",
    "Name": "Co-Diagnostics",
    "Symbol": "CODX",
    " marketcap ": " $34 406 240 ",
    "price (USD)": "01.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7897",
    "Name": "MiNK Therapeutics",
    "Symbol": "INKT",
    " marketcap ": " $34 380 324 ",
    "price (USD)": "0.99",
    "country": "United States"
  },
  {
    "Rank": "7898",
    "Name": "India Globalization Capital",
    "Symbol": "IGC",
    " marketcap ": " $34 268 336 ",
    "price (USD)": "0.5129",
    "country": "United States"
  },
  {
    "Rank": "7899",
    "Name": "GreenPower Motor Company",
    "Symbol": "GP",
    " marketcap ": " $34 173 648 ",
    "price (USD)": "\u044f\u043d\u0432.29",
    "country": "Canada"
  },
  {
    "Rank": "7900",
    "Name": "Indonesia Energy",
    "Symbol": "INDO",
    " marketcap ": " $34 077 016 ",
    "price (USD)": "\u043c\u0430\u0440.34",
    "country": "Indonesia"
  },
  {
    "Rank": "7901",
    "Name": "Fun Yours Technology",
    "Symbol": "6482.TWO",
    " marketcap ": " $33 635 375 ",
    "price (USD)": "1.55053",
    "country": "Taiwan"
  },
  {
    "Rank": "7902",
    "Name": "enish",
    "Symbol": "3667.T",
    " marketcap ": " $33 560 904 ",
    "price (USD)": "1.50342",
    "country": "Japan"
  },
  {
    "Rank": "7903",
    "Name": "Tose Software",
    "Symbol": "4728.T",
    " marketcap ": " $33 459 196 ",
    "price (USD)": "4.41431",
    "country": "Japan"
  },
  {
    "Rank": "7904",
    "Name": "Palatin Technologies",
    "Symbol": "PTN",
    " marketcap ": " $33 402 760 ",
    "price (USD)": "02.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "7905",
    "Name": "Nippon Ichi Software",
    "Symbol": "3851.T",
    " marketcap ": " $33 182 239 ",
    "price (USD)": "6.58307",
    "country": "Japan"
  },
  {
    "Rank": "7906",
    "Name": "Orion Energy Systems",
    "Symbol": "OESX",
    " marketcap ": " $32 558 344 ",
    "price (USD)": "0.9999",
    "country": "United States"
  },
  {
    "Rank": "7907",
    "Name": "Mobile Factory",
    "Symbol": "3912.T",
    " marketcap ": " $32 526 894 ",
    "price (USD)": "4.31194",
    "country": "Japan"
  },
  {
    "Rank": "7908",
    "Name": "TechPrecision",
    "Symbol": "TPCS",
    " marketcap ": " $32 295 876 ",
    "price (USD)": "\u043c\u0430\u0440.55",
    "country": "United States"
  },
  {
    "Rank": "7909",
    "Name": "Akili",
    "Symbol": "AKLI",
    " marketcap ": " $32 289 264 ",
    "price (USD)": "0.4102",
    "country": "United States"
  },
  {
    "Rank": "7910",
    "Name": "Toro Energy",
    "Symbol": "TOE.AX",
    " marketcap ": " $31 681 020 ",
    "price (USD)": "0.26339",
    "country": "Australia"
  },
  {
    "Rank": "7911",
    "Name": "Team Inc",
    "Symbol": "TISI",
    " marketcap ": " $31 656 984 ",
    "price (USD)": "\u0438\u044e\u043b.17",
    "country": "United States"
  },
  {
    "Rank": "7912",
    "Name": "Spruce Biosciences",
    "Symbol": "SPRB",
    " marketcap ": " $31 561 616 ",
    "price (USD)": "0.7669",
    "country": "United States"
  },
  {
    "Rank": "7913",
    "Name": "Viracta Therapeutics",
    "Symbol": "VIRX",
    " marketcap ": " $31 406 140 ",
    "price (USD)": "0.7997",
    "country": "United States"
  },
  {
    "Rank": "7914",
    "Name": "Snail Inc",
    "Symbol": "SNAL",
    " marketcap ": " $31 242 686 ",
    "price (USD)": "0.85",
    "country": "China"
  },
  {
    "Rank": "7915",
    "Name": "Milkfood Limited",
    "Symbol": "MLKFOOD.BO",
    " marketcap ": " $31 082 240 ",
    "price (USD)": "6.36092",
    "country": "India"
  },
  {
    "Rank": "7916",
    "Name": "Games Operators",
    "Symbol": "GOP.WA",
    " marketcap ": " $30 968 097 ",
    "price (USD)": "5.63132",
    "country": "Poland"
  },
  {
    "Rank": "7917",
    "Name": "geechs",
    "Symbol": "7060.T",
    " marketcap ": " $30 783 546 ",
    "price (USD)": "2.98126",
    "country": "Japan"
  },
  {
    "Rank": "7918",
    "Name": "Surf Air Mobility",
    "Symbol": "SRFM",
    " marketcap ": " $30 781 184 ",
    "price (USD)": "0.3707",
    "country": "United States"
  },
  {
    "Rank": "7919",
    "Name": "Scandinavian Airlines System (SAS)",
    "Symbol": "SAS.ST",
    " marketcap ": " $30 772 891 ",
    "price (USD)": "0.00406236",
    "country": "Sweden"
  },
  {
    "Rank": "7920",
    "Name": "Appirits",
    "Symbol": "4174.T",
    " marketcap ": " $30 624 564 ",
    "price (USD)": "7.42115",
    "country": "Japan"
  },
  {
    "Rank": "7921",
    "Name": "CCSC Technology International Holdings",
    "Symbol": "CCTG",
    " marketcap ": " $30 458 558 ",
    "price (USD)": "\u0444\u0435\u0432.63",
    "country": "Hong Kong"
  },
  {
    "Rank": "7922",
    "Name": "Fujairah Cement Industries",
    "Symbol": "FCI.AE",
    " marketcap ": " $30 424 949 ",
    "price (USD)": "0.09",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7923",
    "Name": "Trophy Games",
    "Symbol": "TGAMES.CO",
    " marketcap ": " $30 417 610 ",
    "price (USD)": "1.12766",
    "country": "Denmark"
  },
  {
    "Rank": "7924",
    "Name": "SigmaTron International",
    "Symbol": "SGMA",
    " marketcap ": " $30 410 506 ",
    "price (USD)": "\u0430\u043f\u0440.99",
    "country": "United States"
  },
  {
    "Rank": "7925",
    "Name": "Insurance House",
    "Symbol": "IH.AE",
    " marketcap ": " $30 368 636 ",
    "price (USD)": "0.26",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7926",
    "Name": "ATA Creativity Global",
    "Symbol": "AACG",
    " marketcap ": " $30 355 696 ",
    "price (USD)": "0.9501",
    "country": "China"
  },
  {
    "Rank": "7927",
    "Name": "JanOne",
    "Symbol": "JAN",
    " marketcap ": " $30 338 136 ",
    "price (USD)": "\u043c\u0430\u0440.35",
    "country": "United States"
  },
  {
    "Rank": "7928",
    "Name": "Camber Energy",
    "Symbol": "CEI",
    " marketcap ": " $30 114 538 ",
    "price (USD)": "0.1713",
    "country": "United States"
  },
  {
    "Rank": "7929",
    "Name": "Singular Genomics Systems",
    "Symbol": "OMIC",
    " marketcap ": " $29 911 344 ",
    "price (USD)": "0.4037",
    "country": "United States"
  },
  {
    "Rank": "7930",
    "Name": "ImmunoPrecise Antibodies",
    "Symbol": "IPA",
    " marketcap ": " $29 691 552 ",
    "price (USD)": "1.1283",
    "country": "United States"
  },
  {
    "Rank": "7931",
    "Name": "BIT Mining (500.com)",
    "Symbol": "BTCM",
    " marketcap ": " $29 669 842 ",
    "price (USD)": "\u0444\u0435\u0432.67",
    "country": "China"
  },
  {
    "Rank": "7932",
    "Name": "Cazoo",
    "Symbol": "CZOO",
    " marketcap ": " $29 541 640 ",
    "price (USD)": "06.\u0430\u043f\u0440",
    "country": "United Kingdom"
  },
  {
    "Rank": "7933",
    "Name": "Smith Micro Software",
    "Symbol": "SMSI",
    " marketcap ": " $28 906 486 ",
    "price (USD)": "\u0444\u0435\u0432.71",
    "country": "United States"
  },
  {
    "Rank": "7934",
    "Name": "Barnes &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "7935",
    "Name": "Femasys",
    "Symbol": "FEMY",
    " marketcap ": " $28 442 496 ",
    "price (USD)": "\u044f\u043d\u0432.28",
    "country": "United States"
  },
  {
    "Rank": "7936",
    "Name": "Charlotte's Web",
    "Symbol": "CWEB.TO",
    " marketcap ": " $28 242 135 ",
    "price (USD)": "0.179625",
    "country": "United States"
  },
  {
    "Rank": "7937",
    "Name": "Guardforce AI",
    "Symbol": "GFAI",
    " marketcap ": " $27 915 154 ",
    "price (USD)": "\u0444\u0435\u0432.84",
    "country": "Singapore"
  },
  {
    "Rank": "7938",
    "Name": "Rave Restaurant Group",
    "Symbol": "RAVE",
    " marketcap ": " $27 860 406 ",
    "price (USD)": "\u044f\u043d\u0432.91",
    "country": "United States"
  },
  {
    "Rank": "7939",
    "Name": "AgeX Therapeutics",
    "Symbol": "AGE",
    " marketcap ": " $27 758 326 ",
    "price (USD)": "11.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "7940",
    "Name": "Aprea Therapeutics",
    "Symbol": "APRE",
    " marketcap ": " $27 675 660 ",
    "price (USD)": "5.0966",
    "country": "United States"
  },
  {
    "Rank": "7941",
    "Name": "bioAffinity Technologies",
    "Symbol": "BIAF",
    " marketcap ": " $27 628 274 ",
    "price (USD)": "\u0444\u0435\u0432.37",
    "country": "United States"
  },
  {
    "Rank": "7942",
    "Name": "Local Bounti",
    "Symbol": "LOCL",
    " marketcap ": " $27 462 042 ",
    "price (USD)": "\u043c\u0430\u0440.54",
    "country": "United States"
  },
  {
    "Rank": "7943",
    "Name": "Westwater Resources",
    "Symbol": "WWR",
    " marketcap ": " $27 449 712 ",
    "price (USD)": "0.48",
    "country": "United States"
  },
  {
    "Rank": "7944",
    "Name": "Retractable Technologies",
    "Symbol": "RVP",
    " marketcap ": " $27 392 538 ",
    "price (USD)": "0.915",
    "country": "United States"
  },
  {
    "Rank": "7945",
    "Name": "Urgent.ly Inc.",
    "Symbol": "ULY",
    " marketcap ": " $27 113 248 ",
    "price (USD)": "02.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "7946",
    "Name": "2U",
    "Symbol": "TWOU",
    " marketcap ": " $26 947 904 ",
    "price (USD)": "0.3202",
    "country": "United States"
  },
  {
    "Rank": "7947",
    "Name": "Greenidge Generation Holdings",
    "Symbol": "GREE",
    " marketcap ": " $26 878 112 ",
    "price (USD)": "\u0444\u0435\u0432.74",
    "country": "United States"
  },
  {
    "Rank": "7948",
    "Name": "Drive Shack",
    "Symbol": "DSHK",
    " marketcap ": " $26 795 600 ",
    "price (USD)": "0.26",
    "country": "United States"
  },
  {
    "Rank": "7949",
    "Name": "Performance Shipping",
    "Symbol": "PSHG",
    " marketcap ": " $26 524 154 ",
    "price (USD)": "\u0444\u0435\u0432.16",
    "country": "Greece"
  },
  {
    "Rank": "7950",
    "Name": "CleanCore Solutions",
    "Symbol": "ZONE",
    " marketcap ": " $26 438 554 ",
    "price (USD)": "\u043c\u0430\u0440.32",
    "country": "United States"
  },
  {
    "Rank": "7951",
    "Name": "Methaq Takaful Insurance Compnay",
    "Symbol": "METHAQ.AE",
    " marketcap ": " $26 343 017 ",
    "price (USD)": "0.18",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7952",
    "Name": "Adler Group",
    "Symbol": "ADJ.DE",
    " marketcap ": " $26 311 037 ",
    "price (USD)": "0.173526",
    "country": "Luxembourg"
  },
  {
    "Rank": "7953",
    "Name": "Ourgame International",
    "Symbol": "6899.HK",
    " marketcap ": " $26 240 879 ",
    "price (USD)": "0.0243467",
    "country": "China"
  },
  {
    "Rank": "7954",
    "Name": "Fly Play",
    "Symbol": "PLAY.IC",
    " marketcap ": " $25 773 553 ",
    "price (USD)": "0.0296779",
    "country": "Iceland"
  },
  {
    "Rank": "7955",
    "Name": "NanoViricides",
    "Symbol": "NNVC",
    " marketcap ": " $25 754 520 ",
    "price (USD)": "\u0444\u0435\u0432.18",
    "country": "United States"
  },
  {
    "Rank": "7956",
    "Name": "AEye",
    "Symbol": "LIDR",
    " marketcap ": " $25 723 354 ",
    "price (USD)": "\u043c\u0430\u0440.88",
    "country": "United States"
  },
  {
    "Rank": "7957",
    "Name": "Acasti Pharma",
    "Symbol": "ACST",
    " marketcap ": " $25 660 362 ",
    "price (USD)": "\u0444\u0435\u0432.73",
    "country": "Canada"
  },
  {
    "Rank": "7958",
    "Name": "Biora Therapeutics",
    "Symbol": "BIOR",
    " marketcap ": " $25 549 266 ",
    "price (USD)": "0.712",
    "country": "United States"
  },
  {
    "Rank": "7959",
    "Name": "Global Mofy Metaverse",
    "Symbol": "GMM",
    " marketcap ": " $25 476 858 ",
    "price (USD)": "0.8925",
    "country": "China"
  },
  {
    "Rank": "7960",
    "Name": "Electra Meccanica",
    "Symbol": "SOLO",
    " marketcap ": " $25 356 840 ",
    "price (USD)": "0.2122",
    "country": "Canada"
  },
  {
    "Rank": "7961",
    "Name": "CBL International",
    "Symbol": "BANL",
    " marketcap ": " $25 250 000 ",
    "price (USD)": "01.\u044f\u043d\u0432",
    "country": "Malaysia"
  },
  {
    "Rank": "7962",
    "Name": "Starbox Group",
    "Symbol": "STBX",
    " marketcap ": " $24 960 974 ",
    "price (USD)": "0.195",
    "country": "Malaysia"
  },
  {
    "Rank": "7963",
    "Name": "ZK International Group",
    "Symbol": "ZKIN",
    " marketcap ": " $24 879 048 ",
    "price (USD)": "0.7416",
    "country": "China"
  },
  {
    "Rank": "7964",
    "Name": "Faraday Future",
    "Symbol": "FFIE",
    " marketcap ": " $24 740 610 ",
    "price (USD)": "\u044f\u043d\u0432.39",
    "country": "United States"
  },
  {
    "Rank": "7965",
    "Name": "tinyBuild",
    "Symbol": "8Z3.F",
    " marketcap ": " $24 696 788 ",
    "price (USD)": "0.0488652",
    "country": "United States"
  },
  {
    "Rank": "7966",
    "Name": "Davis Commodities",
    "Symbol": "DTCK",
    " marketcap ": " $24 623 102 ",
    "price (USD)": "1.005",
    "country": "Singapore"
  },
  {
    "Rank": "7967",
    "Name": "Kirkland's",
    "Symbol": "KIRK",
    " marketcap ": " $24 513 320 ",
    "price (USD)": "\u044f\u043d\u0432.88",
    "country": "United States"
  },
  {
    "Rank": "7968",
    "Name": "Unity Biotechnology",
    "Symbol": "UBX",
    " marketcap ": " $24 512 816 ",
    "price (USD)": "\u044f\u043d\u0432.46",
    "country": "United States"
  },
  {
    "Rank": "7969",
    "Name": "Sonim Technologies",
    "Symbol": "SONM",
    " marketcap ": " $24 209 214 ",
    "price (USD)": "0.5182",
    "country": "United States"
  },
  {
    "Rank": "7970",
    "Name": "TherapeuticsMD",
    "Symbol": "TXMD",
    " marketcap ": " $24 102 716 ",
    "price (USD)": "02.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "7971",
    "Name": "Bullfrog AI",
    "Symbol": "BFRG",
    " marketcap ": " $24 101 188 ",
    "price (USD)": "03.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "7972",
    "Name": "Cielo Waste Solutions",
    "Symbol": "CMC.V",
    " marketcap ": " $24 090 231 ",
    "price (USD)": "0.212618",
    "country": "Canada"
  },
  {
    "Rank": "7973",
    "Name": "Linekong Interactive",
    "Symbol": "8267.HK",
    " marketcap ": " $24 047 787 ",
    "price (USD)": "0.0653517",
    "country": "China"
  },
  {
    "Rank": "7974",
    "Name": "Erayak Power Solution",
    "Symbol": "RAYA",
    " marketcap ": " $24 009 500 ",
    "price (USD)": "0.7745",
    "country": "China"
  },
  {
    "Rank": "7975",
    "Name": "Ekso Bionics",
    "Symbol": "EKSO",
    " marketcap ": " $23 990 208 ",
    "price (USD)": "\u044f\u043d\u0432.32",
    "country": "United States"
  },
  {
    "Rank": "7976",
    "Name": "Accelerate Diagnostics",
    "Symbol": "AXDX",
    " marketcap ": " $23 818 950 ",
    "price (USD)": "1.0802",
    "country": "United States"
  },
  {
    "Rank": "7977",
    "Name": "Big Cheese Studio",
    "Symbol": "BCS.WA",
    " marketcap ": " $23 549 519 ",
    "price (USD)": "5.69517",
    "country": "Poland"
  },
  {
    "Rank": "7978",
    "Name": "CytoMed Therapeutics",
    "Symbol": "GDTC",
    " marketcap ": " $23 541 600 ",
    "price (USD)": "02.\u0430\u043f\u0440",
    "country": "Singapore"
  },
  {
    "Rank": "7979",
    "Name": "YanGuFang International Group",
    "Symbol": "YGF",
    " marketcap ": " $23 462 400 ",
    "price (USD)": "0.7332",
    "country": "China"
  },
  {
    "Rank": "7980",
    "Name": "AppTech Payments",
    "Symbol": "APCX",
    " marketcap ": " $23 431 580 ",
    "price (USD)": "0.9475",
    "country": "United States"
  },
  {
    "Rank": "7981",
    "Name": "Iterum Therapeutics",
    "Symbol": "ITRM",
    " marketcap ": " $23 342 408 ",
    "price (USD)": "\u044f\u043d\u0432.41",
    "country": "Ireland"
  },
  {
    "Rank": "7982",
    "Name": "Zee Learn",
    "Symbol": "ZEELEARN.NS",
    " marketcap ": " $23 116 882 ",
    "price (USD)": "0.0708905",
    "country": "India"
  },
  {
    "Rank": "7983",
    "Name": "NantHealth",
    "Symbol": "NHIQ",
    " marketcap ": " $23 077 266 ",
    "price (USD)": "0.84005",
    "country": "United States"
  },
  {
    "Rank": "7984",
    "Name": "The Arena Group",
    "Symbol": "AREN",
    " marketcap ": " $22 673 522 ",
    "price (USD)": "0.766",
    "country": "United States"
  },
  {
    "Rank": "7985",
    "Name": "Maison Solutions",
    "Symbol": "MSS",
    " marketcap ": " $22 447 170 ",
    "price (USD)": "\u044f\u043d\u0432.14",
    "country": "United States"
  },
  {
    "Rank": "7986",
    "Name": "Grand Twins International Cambodia",
    "Symbol": "GTI.KH",
    " marketcap ": " $22 435 424 ",
    "price (USD)": "0.56",
    "country": "Cambodia"
  },
  {
    "Rank": "7987",
    "Name": "Presto Automation",
    "Symbol": "PRST",
    " marketcap ": " $22 418 676 ",
    "price (USD)": "0.2152",
    "country": "United States"
  },
  {
    "Rank": "7988",
    "Name": "Aterian",
    "Symbol": "ATER",
    " marketcap ": " $22 354 552 ",
    "price (USD)": "\u0444\u0435\u0432.65",
    "country": "United States"
  },
  {
    "Rank": "7989",
    "Name": "Sol-Gel Technologies",
    "Symbol": "SLGL",
    " marketcap ": " $22 277 724 ",
    "price (USD)": "0.7997",
    "country": "Israel"
  },
  {
    "Rank": "7990",
    "Name": "Hanryu Holdings",
    "Symbol": "HRYU",
    " marketcap ": " $22 269 386 ",
    "price (USD)": "0.4217",
    "country": "South Korea"
  },
  {
    "Rank": "7991",
    "Name": "Meta Materials",
    "Symbol": "MMAT",
    " marketcap ": " $22 095 282 ",
    "price (USD)": "03.\u043c\u0430\u0440",
    "country": "Canada"
  },
  {
    "Rank": "7992",
    "Name": "All in! Games",
    "Symbol": "ALG.WA",
    " marketcap ": " $22 065 363 ",
    "price (USD)": "0.36776",
    "country": "Poland"
  },
  {
    "Rank": "7993",
    "Name": "Takaful Emarat - Insurance",
    "Symbol": "TAKAFUL-EM.AE",
    " marketcap ": " $22 054 619 ",
    "price (USD)": "0.147031",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "7994",
    "Name": "Primech Holdings",
    "Symbol": "PMEC",
    " marketcap ": " $22 051 664 ",
    "price (USD)": "0.6203",
    "country": "Singapore"
  },
  {
    "Rank": "7995",
    "Name": "BioSig Technologies",
    "Symbol": "BSGM",
    " marketcap ": " $22 046 144 ",
    "price (USD)": "\u044f\u043d\u0432.84",
    "country": "United States"
  },
  {
    "Rank": "7996",
    "Name": "Yuke's",
    "Symbol": "4334.T",
    " marketcap ": " $22 043 631 ",
    "price (USD)": "2.62299",
    "country": "Japan"
  },
  {
    "Rank": "7997",
    "Name": "Globavend",
    "Symbol": "GVH",
    " marketcap ": " $21 900 000 ",
    "price (USD)": "\u044f\u043d\u0432.46",
    "country": "Australia"
  },
  {
    "Rank": "7998",
    "Name": "MAG Interactive",
    "Symbol": "MAGI.ST",
    " marketcap ": " $21 823 789 ",
    "price (USD)": "0.823704",
    "country": "Sweden"
  },
  {
    "Rank": "7999",
    "Name": "Sphere 3D",
    "Symbol": "ANY",
    " marketcap ": " $21 691 660 ",
    "price (USD)": "1.185",
    "country": "Canada"
  },
  {
    "Rank": "8000",
    "Name": "Lyra Therapeutics",
    "Symbol": "LYRA",
    " marketcap ": " $21 666 926 ",
    "price (USD)": "0.3554",
    "country": "United States"
  },
  {
    "Rank": "8001",
    "Name": "NJ Holdings",
    "Symbol": "9421.T",
    " marketcap ": " $21 637 331 ",
    "price (USD)": "4.08803",
    "country": "Japan"
  },
  {
    "Rank": "8002",
    "Name": "Dolphin Entertainment",
    "Symbol": "DLPN",
    " marketcap ": " $21 608 586 ",
    "price (USD)": "\u044f\u043d\u0432.14",
    "country": "United States"
  },
  {
    "Rank": "8003",
    "Name": "ATI Physical Therapy",
    "Symbol": "ATIP",
    " marketcap ": " $21 450 626 ",
    "price (USD)": "\u0430\u043f\u0440.88",
    "country": "United States"
  },
  {
    "Rank": "8004",
    "Name": "CaliberCos",
    "Symbol": "CWD",
    " marketcap ": " $21 390 558 ",
    "price (USD)": "0.98",
    "country": "United States"
  },
  {
    "Rank": "8005",
    "Name": "Vincerx Pharma",
    "Symbol": "VINC",
    " marketcap ": " $21 252 810 ",
    "price (USD)": "0.7196",
    "country": "United States"
  },
  {
    "Rank": "8006",
    "Name": "Beasley Broadcast Group",
    "Symbol": "BBGI",
    " marketcap ": " $21 241 010 ",
    "price (USD)": "0.7",
    "country": "United States"
  },
  {
    "Rank": "8007",
    "Name": "Nexstim",
    "Symbol": "NXTMH.HE",
    " marketcap ": " $21 158 447 ",
    "price (USD)": "3.12738",
    "country": "Finland"
  },
  {
    "Rank": "8008",
    "Name": "Forever Entertainment",
    "Symbol": "8FE.SG",
    " marketcap ": " $21 143 890 ",
    "price (USD)": "0.688457",
    "country": "Poland"
  },
  {
    "Rank": "8009",
    "Name": "Urban-gro",
    "Symbol": "UGRO",
    " marketcap ": " $21 065 148 ",
    "price (USD)": "\u044f\u043d\u0432.71",
    "country": "United States"
  },
  {
    "Rank": "8010",
    "Name": "Aptorum Group",
    "Symbol": "APM",
    " marketcap ": " $21 063 734 ",
    "price (USD)": "\u043c\u0430\u0440.85",
    "country": "Hong Kong"
  },
  {
    "Rank": "8011",
    "Name": "AIM ImmunoTech",
    "Symbol": "AIM",
    " marketcap ": " $21 025 374 ",
    "price (USD)": "0.41",
    "country": "United States"
  },
  {
    "Rank": "8012",
    "Name": "Onconova Therapeutics",
    "Symbol": "ONTX",
    " marketcap ": " $20 904 684 ",
    "price (USD)": "0.9953",
    "country": "United States"
  },
  {
    "Rank": "8013",
    "Name": "Sporting Clube de Braga",
    "Symbol": "SCB.LS",
    " marketcap ": " $20 718 862 ",
    "price (USD)": "17.2657",
    "country": "Portugal"
  },
  {
    "Rank": "8014",
    "Name": "FingerTango",
    "Symbol": "6860.HK",
    " marketcap ": " $20 645 950 ",
    "price (USD)": "0.0107638",
    "country": "China"
  },
  {
    "Rank": "8015",
    "Name": "CyberStep",
    "Symbol": "3810.T",
    " marketcap ": " $20 594 575 ",
    "price (USD)": "1.66336",
    "country": "Japan"
  },
  {
    "Rank": "8016",
    "Name": "J-Long Group",
    "Symbol": "JL",
    " marketcap ": " $20 504 200 ",
    "price (USD)": "0.653",
    "country": "Hong Kong"
  },
  {
    "Rank": "8017",
    "Name": "MGO Global",
    "Symbol": "MGOL",
    " marketcap ": " $20 504 124 ",
    "price (USD)": "\u044f\u043d\u0432.25",
    "country": "United States"
  },
  {
    "Rank": "8018",
    "Name": "Lumos Pharma",
    "Symbol": "LUMO",
    " marketcap ": " $20 453 554 ",
    "price (USD)": "\u0444\u0435\u0432.52",
    "country": "United States"
  },
  {
    "Rank": "8019",
    "Name": "Marpai",
    "Symbol": "MRAI",
    " marketcap ": " $20 306 760 ",
    "price (USD)": "\u044f\u043d\u0432.97",
    "country": "United States"
  },
  {
    "Rank": "8020",
    "Name": "Mobcast",
    "Symbol": "3664.T",
    " marketcap ": " $20 275 903 ",
    "price (USD)": "0.454226",
    "country": "Japan"
  },
  {
    "Rank": "8021",
    "Name": "SPI Energy",
    "Symbol": "SPI",
    " marketcap ": " $20 222 824 ",
    "price (USD)": "0.6399",
    "country": "United States"
  },
  {
    "Rank": "8022",
    "Name": "Laser Photonics",
    "Symbol": "LASE",
    " marketcap ": " $20 116 834 ",
    "price (USD)": "\u0444\u0435\u0432.17",
    "country": "United States"
  },
  {
    "Rank": "8023",
    "Name": "Almaden Minerals",
    "Symbol": "AAU",
    " marketcap ": " $20 102 876 ",
    "price (USD)": "0.1465",
    "country": "Canada"
  },
  {
    "Rank": "8024",
    "Name": "iBio",
    "Symbol": "IBIO",
    " marketcap ": " $20 093 174 ",
    "price (USD)": "\u0444\u0435\u0432.33",
    "country": "United States"
  },
  {
    "Rank": "8025",
    "Name": "Silicon Studio",
    "Symbol": "3907.T",
    " marketcap ": " $20 048 416 ",
    "price (USD)": "7.0373",
    "country": "Japan"
  },
  {
    "Rank": "8026",
    "Name": "SOS Limited",
    "Symbol": "SOS",
    " marketcap ": " $19 947 150 ",
    "price (USD)": "\u044f\u043d\u0432.14",
    "country": "China"
  },
  {
    "Rank": "8027",
    "Name": "Draganfly",
    "Symbol": "DPRO",
    " marketcap ": " $19 937 062 ",
    "price (USD)": "0.2794",
    "country": "Canada"
  },
  {
    "Rank": "8028",
    "Name": "Neo-Concept International Group",
    "Symbol": "NCI",
    " marketcap ": " $19 913 600 ",
    "price (USD)": "0.98",
    "country": "Hong Kong"
  },
  {
    "Rank": "8029",
    "Name": "Vroom",
    "Symbol": "VRM",
    " marketcap ": " $19 901 970 ",
    "price (USD)": "11",
    "country": "United States"
  },
  {
    "Rank": "8030",
    "Name": "Streamline Health Solutions",
    "Symbol": "STRM",
    " marketcap ": " $19 882 560 ",
    "price (USD)": "0.32",
    "country": "United States"
  },
  {
    "Rank": "8031",
    "Name": "La Rosa Holdings",
    "Symbol": "LRHC",
    " marketcap ": " $19 855 718 ",
    "price (USD)": "\u044f\u043d\u0432.34",
    "country": "United States"
  },
  {
    "Rank": "8032",
    "Name": "Vince Holding",
    "Symbol": "VNCE",
    " marketcap ": " $19 824 230 ",
    "price (USD)": "1.585",
    "country": "United States"
  },
  {
    "Rank": "8033",
    "Name": "Agape ATP",
    "Symbol": "ATPC",
    " marketcap ": " $19 780 442 ",
    "price (USD)": "0.257",
    "country": "Malaysia"
  },
  {
    "Rank": "8034",
    "Name": "Sunrise New Energy",
    "Symbol": "EPOW",
    " marketcap ": " $19 732 982 ",
    "price (USD)": "0.755",
    "country": "China"
  },
  {
    "Rank": "8035",
    "Name": "Rail Vision",
    "Symbol": "RVSN",
    " marketcap ": " $19 616 912 ",
    "price (USD)": "\u044f\u043d\u0432.19",
    "country": "Israel"
  },
  {
    "Rank": "8036",
    "Name": "Focus Universal",
    "Symbol": "FCUV",
    " marketcap ": " $19 386 198 ",
    "price (USD)": "0.2993",
    "country": "United States"
  },
  {
    "Rank": "8037",
    "Name": "A2Z Smart Technologies",
    "Symbol": "AZ",
    " marketcap ": " $19 372 266 ",
    "price (USD)": "0.3822",
    "country": "Canada"
  },
  {
    "Rank": "8038",
    "Name": "Cocrystal Pharma",
    "Symbol": "COCP",
    " marketcap ": " $19 330 220 ",
    "price (USD)": "01.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "8039",
    "Name": "Synlogic",
    "Symbol": "SYBX",
    " marketcap ": " $19 316 550 ",
    "price (USD)": "\u044f\u043d\u0432.65",
    "country": "United States"
  },
  {
    "Rank": "8040",
    "Name": "Phoenix Motor",
    "Symbol": "PEV",
    " marketcap ": " $19 076 860 ",
    "price (USD)": "0.55",
    "country": "United States"
  },
  {
    "Rank": "8041",
    "Name": "The Glimpse Group",
    "Symbol": "VRAR",
    " marketcap ": " $19 055 610 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "8042",
    "Name": "Aptose Biosciences",
    "Symbol": "APTO",
    " marketcap ": " $18 913 360 ",
    "price (USD)": "\u044f\u043d\u0432.15",
    "country": "Canada"
  },
  {
    "Rank": "8043",
    "Name": "Cue Health",
    "Symbol": "HLTH",
    " marketcap ": " $18 772 856 ",
    "price (USD)": "0.118",
    "country": "United States"
  },
  {
    "Rank": "8044",
    "Name": "Real Good Food plc",
    "Symbol": "RGF",
    " marketcap ": " $18 711 318 ",
    "price (USD)": "0.5514",
    "country": "United Kingdom"
  },
  {
    "Rank": "8045",
    "Name": "OceanPal",
    "Symbol": "OP",
    " marketcap ": " $18 629 950 ",
    "price (USD)": "02.\u043c\u0430\u0439",
    "country": "Greece"
  },
  {
    "Rank": "8046",
    "Name": "VBI Vaccines",
    "Symbol": "VBIV",
    " marketcap ": " $18 626 286 ",
    "price (USD)": "0.6494",
    "country": "United States"
  },
  {
    "Rank": "8047",
    "Name": "Kala Pharmaceuticals",
    "Symbol": "KALA",
    " marketcap ": " $18 532 240 ",
    "price (USD)": "\u0438\u044e\u043d.58",
    "country": "United States"
  },
  {
    "Rank": "8048",
    "Name": "Mynet",
    "Symbol": "3928.T",
    " marketcap ": " $18 376 848 ",
    "price (USD)": "2.18156",
    "country": "Japan"
  },
  {
    "Rank": "8049",
    "Name": "Gaming Factory",
    "Symbol": "GIF.WA",
    " marketcap ": " $18 324 950 ",
    "price (USD)": "3.25621",
    "country": "Poland"
  },
  {
    "Rank": "8050",
    "Name": "MEP Infrastructure",
    "Symbol": "MEP.NS",
    " marketcap ": " $18 294 567 ",
    "price (USD)": "0.0997273",
    "country": "India"
  },
  {
    "Rank": "8051",
    "Name": "Nymox Pharmaceutical",
    "Symbol": "NYMX",
    " marketcap ": " $18 253 022 ",
    "price (USD)": "0.2",
    "country": "Bahamas"
  },
  {
    "Rank": "8052",
    "Name": "WonderPlanet",
    "Symbol": "4199.T",
    " marketcap ": " $18 243 090 ",
    "price (USD)": "7.17165",
    "country": "Japan"
  },
  {
    "Rank": "8053",
    "Name": "DDC Enterprise",
    "Symbol": "DDC",
    " marketcap ": " $18 046 826 ",
    "price (USD)": "0.804",
    "country": "Hong Kong"
  },
  {
    "Rank": "8054",
    "Name": "Pintec Technology",
    "Symbol": "PT",
    " marketcap ": " $18 021 240 ",
    "price (USD)": "\u044f\u043d\u0432.13",
    "country": "China"
  },
  {
    "Rank": "8055",
    "Name": "iCandy Interactive",
    "Symbol": "ICI.AX",
    " marketcap ": " $17 935 025 ",
    "price (USD)": "0.0133362",
    "country": "Australia"
  },
  {
    "Rank": "8056",
    "Name": "Talphera",
    "Symbol": "TLPH",
    " marketcap ": " $17 842 650 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "8057",
    "Name": "Alpine Summit Energy Partners",
    "Symbol": "ALPSQ",
    " marketcap ": " $17 784 200 ",
    "price (USD)": "0.0001",
    "country": "United States"
  },
  {
    "Rank": "8058",
    "Name": "GlycoMimetics",
    "Symbol": "GLYC",
    " marketcap ": " $17 753 496 ",
    "price (USD)": "0.2754",
    "country": "United States"
  },
  {
    "Rank": "8059",
    "Name": "Cyngn",
    "Symbol": "CYN",
    " marketcap ": " $17 650 414 ",
    "price (USD)": "0.1247",
    "country": "United States"
  },
  {
    "Rank": "8060",
    "Name": "Foresight Autonomous Holdings",
    "Symbol": "FRSX",
    " marketcap ": " $17 624 784 ",
    "price (USD)": "\u044f\u043d\u0432.15",
    "country": "Israel"
  },
  {
    "Rank": "8061",
    "Name": "AltPlus",
    "Symbol": "3672.T",
    " marketcap ": " $17 599 972 ",
    "price (USD)": "0.844476",
    "country": "Japan"
  },
  {
    "Rank": "8062",
    "Name": "Tonix Pharmaceuticals",
    "Symbol": "TNXP",
    " marketcap ": " $17 580 060 ",
    "price (USD)": "0.184",
    "country": "United States"
  },
  {
    "Rank": "8063",
    "Name": "Exela Technologies",
    "Symbol": "XELA",
    " marketcap ": " $17 504 712 ",
    "price (USD)": "\u0444\u0435\u0432.75",
    "country": "United States"
  },
  {
    "Rank": "8064",
    "Name": "BILDCO (Abu Dhabi National Building Materials Co.)",
    "Symbol": "BILDCO.AE",
    " marketcap ": " $17 480 328 ",
    "price (USD)": "0.06",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "8065",
    "Name": "VIA optronics AG",
    "Symbol": "VIAO",
    " marketcap ": " $17 465 854 ",
    "price (USD)": "0.2231",
    "country": "Germany"
  },
  {
    "Rank": "8066",
    "Name": "Aytu BioScience",
    "Symbol": "AYTU",
    " marketcap ": " $17 428 342 ",
    "price (USD)": "\u043c\u0430\u0440.13",
    "country": "United States"
  },
  {
    "Rank": "8067",
    "Name": "HomeBiogas",
    "Symbol": "HMGS.TA",
    " marketcap ": " $17 382 297 ",
    "price (USD)": "0.722895",
    "country": "Israel"
  },
  {
    "Rank": "8068",
    "Name": "PAVmed",
    "Symbol": "PAVM",
    " marketcap ": " $17 354 366 ",
    "price (USD)": "\u044f\u043d\u0432.84",
    "country": "United States"
  },
  {
    "Rank": "8069",
    "Name": "Poseidon Nickel",
    "Symbol": "POS.AX",
    " marketcap ": " $17 333 506 ",
    "price (USD)": "0.00466766",
    "country": "Australia"
  },
  {
    "Rank": "8070",
    "Name": "Senti Biosciences",
    "Symbol": "SNTI",
    " marketcap ": " $17 277 088 ",
    "price (USD)": "0.3776",
    "country": "United States"
  },
  {
    "Rank": "8071",
    "Name": "Minerva Neurosciences",
    "Symbol": "NERV",
    " marketcap ": " $17 203 788 ",
    "price (USD)": "\u0444\u0435\u0432.46",
    "country": "United States"
  },
  {
    "Rank": "8072",
    "Name": "Alaunos Therapeutics",
    "Symbol": "TCRT",
    " marketcap ": " $17 133 376 ",
    "price (USD)": "01.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "8073",
    "Name": "Loop Media",
    "Symbol": "LPTV",
    " marketcap ": " $17 110 156 ",
    "price (USD)": "0.2404",
    "country": "United States"
  },
  {
    "Rank": "8074",
    "Name": "Graphex Group",
    "Symbol": "GRFX",
    " marketcap ": " $17 097 812 ",
    "price (USD)": "0.3271",
    "country": "Hong Kong"
  },
  {
    "Rank": "8075",
    "Name": "Duos Technologies Group",
    "Symbol": "DUOT",
    " marketcap ": " $16 943 984 ",
    "price (USD)": "\u0444\u0435\u0432.25",
    "country": "United States"
  },
  {
    "Rank": "8076",
    "Name": "InterServ International",
    "Symbol": "6169.TWO",
    " marketcap ": " $16 940 281 ",
    "price (USD)": "0.724098",
    "country": "Taiwan"
  },
  {
    "Rank": "8077",
    "Name": "Ashford Inc",
    "Symbol": "AINC",
    " marketcap ": " $16 603 621 ",
    "price (USD)": "\u0430\u043f\u0440.84",
    "country": "United States"
  },
  {
    "Rank": "8078",
    "Name": "Sorrento Therapeutics",
    "Symbol": "SRNEQ",
    " marketcap ": " $16 538 430 ",
    "price (USD)": "0.03",
    "country": "United States"
  },
  {
    "Rank": "8079",
    "Name": "Astrotech",
    "Symbol": "ASTC",
    " marketcap ": " $16 166 435 ",
    "price (USD)": "09.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "8080",
    "Name": "Talis Biomedical",
    "Symbol": "TLIS",
    " marketcap ": " $16 126 028 ",
    "price (USD)": "\u0430\u0432\u0433.85",
    "country": "United States"
  },
  {
    "Rank": "8081",
    "Name": "Vintage Wine Estates",
    "Symbol": "VWE",
    " marketcap ": " $15 884 762 ",
    "price (USD)": "0.265",
    "country": "United States"
  },
  {
    "Rank": "8082",
    "Name": "Witbe S.A.",
    "Symbol": "ALWIT.PA",
    " marketcap ": " $15 708 091 ",
    "price (USD)": "3.82235",
    "country": "France"
  },
  {
    "Rank": "8083",
    "Name": "Houston American Energy",
    "Symbol": "HUSA",
    " marketcap ": " $15 378 024 ",
    "price (USD)": "\u044f\u043d\u0432.41",
    "country": "United States"
  },
  {
    "Rank": "8084",
    "Name": "Yunji",
    "Symbol": "YJ",
    " marketcap ": " $15 239 445 ",
    "price (USD)": "0.775",
    "country": "China"
  },
  {
    "Rank": "8085",
    "Name": "Psychemedics",
    "Symbol": "PMD",
    " marketcap ": " $15 201 410 ",
    "price (USD)": "\u0444\u0435\u0432.84",
    "country": "United States"
  },
  {
    "Rank": "8086",
    "Name": "Redhill Biopharma",
    "Symbol": "RDHL",
    " marketcap ": " $15 127 265 ",
    "price (USD)": "0.4747",
    "country": "Israel"
  },
  {
    "Rank": "8087",
    "Name": "Ultimate Games",
    "Symbol": "ULG.WA",
    " marketcap ": " $15 026 433 ",
    "price (USD)": "2.87312",
    "country": "Poland"
  },
  {
    "Rank": "8088",
    "Name": "GigaMedia",
    "Symbol": "GIGM",
    " marketcap ": " $14 975 731 ",
    "price (USD)": "1.355",
    "country": "Taiwan"
  },
  {
    "Rank": "8089",
    "Name": "Verb Technology",
    "Symbol": "VERB",
    " marketcap ": " $14 872 271 ",
    "price (USD)": "0.1422",
    "country": "United States"
  },
  {
    "Rank": "8090",
    "Name": "Astra Space",
    "Symbol": "ASTR",
    " marketcap ": " $14 800 759 ",
    "price (USD)": "0.6517",
    "country": "United States"
  },
  {
    "Rank": "8091",
    "Name": "Brera Holdings",
    "Symbol": "BREA",
    " marketcap ": " $14 795 200 ",
    "price (USD)": "01.\u0434\u0435\u043a",
    "country": "Ireland"
  },
  {
    "Rank": "8092",
    "Name": "Pieris Pharmaceuticals",
    "Symbol": "PIRS",
    " marketcap ": " $14 760 284 ",
    "price (USD)": "\u043d\u043e\u044f.18",
    "country": "United States"
  },
  {
    "Rank": "8093",
    "Name": "Trinity Biotech",
    "Symbol": "TRIB",
    " marketcap ": " $14 671 540 ",
    "price (USD)": "\u044f\u043d\u0432.55",
    "country": "Ireland"
  },
  {
    "Rank": "8094",
    "Name": "Forgame",
    "Symbol": "0484.HK",
    " marketcap ": " $14 511 471 ",
    "price (USD)": "0.101231",
    "country": "China"
  },
  {
    "Rank": "8095",
    "Name": "Microbot Medical",
    "Symbol": "MBOT",
    " marketcap ": " $14 255 010 ",
    "price (USD)": "0.99",
    "country": "United States"
  },
  {
    "Rank": "8096",
    "Name": "FaZe Clan",
    "Symbol": "FAZE",
    " marketcap ": " $14 124 023 ",
    "price (USD)": "0.1825",
    "country": "United States"
  },
  {
    "Rank": "8097",
    "Name": "Air Industries Group",
    "Symbol": "AIRI",
    " marketcap ": " $13 997 324 ",
    "price (USD)": "\u0430\u043f\u0440.21",
    "country": "United States"
  },
  {
    "Rank": "8098",
    "Name": "Austin Gold",
    "Symbol": "AUST",
    " marketcap ": " $13 935 389 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "United States"
  },
  {
    "Rank": "8099",
    "Name": "Magic Empire Global (Giraffe Capital)",
    "Symbol": "MEGL",
    " marketcap ": " $13 849 096 ",
    "price (USD)": "0.6837",
    "country": "Hong Kong"
  },
  {
    "Rank": "8100",
    "Name": "U Power",
    "Symbol": "UCAR",
    " marketcap ": " $13 658 217 ",
    "price (USD)": "\u043c\u0430\u0439.55",
    "country": "China"
  },
  {
    "Rank": "8101",
    "Name": "Oragenics",
    "Symbol": "OGEN",
    " marketcap ": " $13 621 297 ",
    "price (USD)": "03.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "8102",
    "Name": "Akoustis Technologies",
    "Symbol": "AKTS",
    " marketcap ": " $13 586 763 ",
    "price (USD)": "0.1377",
    "country": "United States"
  },
  {
    "Rank": "8103",
    "Name": "Heliogen",
    "Symbol": "HLGN",
    " marketcap ": " $13 493 036 ",
    "price (USD)": "\u0444\u0435\u0432.26",
    "country": "United States"
  },
  {
    "Rank": "8104",
    "Name": "Modern Dairies Limited",
    "Symbol": "MODAIRY.BO",
    " marketcap ": " $13 485 850 ",
    "price (USD)": "0.578298",
    "country": "India"
  },
  {
    "Rank": "8105",
    "Name": "SeaChange",
    "Symbol": "SEAC",
    " marketcap ": " $13 438 308 ",
    "price (USD)": "05.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "8106",
    "Name": "Organovo",
    "Symbol": "ONVO",
    " marketcap ": " $13 382 584 ",
    "price (USD)": "01.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "8107",
    "Name": "Imunon",
    "Symbol": "IMNN",
    " marketcap ": " $13 349 263 ",
    "price (USD)": "\u044f\u043d\u0432.42",
    "country": "United States"
  },
  {
    "Rank": "8108",
    "Name": "WeTrade Group",
    "Symbol": "WETG",
    " marketcap ": " $13 256 907 ",
    "price (USD)": "05.\u043c\u0430\u0439",
    "country": "China"
  },
  {
    "Rank": "8109",
    "Name": "Edia",
    "Symbol": "3935.T",
    " marketcap ": " $13 250 698 ",
    "price (USD)": "2.16237",
    "country": "Japan"
  },
  {
    "Rank": "8110",
    "Name": "Document Security Systems",
    "Symbol": "DSS",
    " marketcap ": " $13 214 860 ",
    "price (USD)": "\u044f\u043d\u0432.87",
    "country": "United States"
  },
  {
    "Rank": "8111",
    "Name": "Turbo Energy",
    "Symbol": "TURB",
    " marketcap ": " $13 110 350 ",
    "price (USD)": "\u044f\u043d\u0432.19",
    "country": "Spain"
  },
  {
    "Rank": "8112",
    "Name": "Advanced Health Intelligence",
    "Symbol": "AHI",
    " marketcap ": " $13 100 460 ",
    "price (USD)": "01.\u043c\u0430\u0439",
    "country": "Australia"
  },
  {
    "Rank": "8113",
    "Name": "Sidus Space",
    "Symbol": "SIDU",
    " marketcap ": " $13 045 780 ",
    "price (USD)": "03.\u0434\u0435\u043a",
    "country": "United States"
  },
  {
    "Rank": "8114",
    "Name": "Future Retail",
    "Symbol": "FRETAIL.NS",
    " marketcap ": " $13 031 445 ",
    "price (USD)": "0.0240307",
    "country": "India"
  },
  {
    "Rank": "8115",
    "Name": "Vislink Technologies",
    "Symbol": "VISL",
    " marketcap ": " $12 976 944 ",
    "price (USD)": "05.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "8116",
    "Name": "CareMax",
    "Symbol": "CMAX",
    " marketcap ": " $12 967 821 ",
    "price (USD)": "\u043c\u0430\u0440.41",
    "country": "United States"
  },
  {
    "Rank": "8117",
    "Name": "Axel Mark",
    "Symbol": "3624.T",
    " marketcap ": " $12 940 932 ",
    "price (USD)": "1.21553",
    "country": "Japan"
  },
  {
    "Rank": "8118",
    "Name": "Ontrak",
    "Symbol": "OTRK",
    " marketcap ": " $12 855 264 ",
    "price (USD)": "0.268",
    "country": "United States"
  },
  {
    "Rank": "8119",
    "Name": "Advaxis",
    "Symbol": "ADXS",
    " marketcap ": " $12 778 171 ",
    "price (USD)": "0.3",
    "country": "United States"
  },
  {
    "Rank": "8120",
    "Name": "Elevai Labs",
    "Symbol": "ELAB",
    " marketcap ": " $12 752 168 ",
    "price (USD)": "0.675",
    "country": "United States"
  },
  {
    "Rank": "8121",
    "Name": "Castellum",
    "Symbol": "CTM",
    " marketcap ": " $12 727 176 ",
    "price (USD)": "0.24",
    "country": "United States"
  },
  {
    "Rank": "8122",
    "Name": "Mainz Biomed",
    "Symbol": "MYNZ",
    " marketcap ": " $12 716 114 ",
    "price (USD)": "0.581",
    "country": "Germany"
  },
  {
    "Rank": "8123",
    "Name": "Rubicon Technologies",
    "Symbol": "RBT",
    " marketcap ": " $12 706 210 ",
    "price (USD)": "0.2318",
    "country": "United States"
  },
  {
    "Rank": "8124",
    "Name": "Srei Infrastructure Finance",
    "Symbol": "SREINFRA.NS",
    " marketcap ": " $12 675 992 ",
    "price (USD)": "0.03",
    "country": "India"
  },
  {
    "Rank": "8125",
    "Name": "Bionomics",
    "Symbol": "BNOX",
    " marketcap ": " $12 618 211 ",
    "price (USD)": "\u044f\u043d\u0432.18",
    "country": "Australia"
  },
  {
    "Rank": "8126",
    "Name": "Oman &amp",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": "8127",
    "Name": "Thunderful Group",
    "Symbol": "THUNDR.ST",
    " marketcap ": " $12 566 637 ",
    "price (USD)": "0.178781",
    "country": "Sweden"
  },
  {
    "Rank": "8128",
    "Name": "Ideanomics",
    "Symbol": "IDEX",
    " marketcap ": " $12 451 192 ",
    "price (USD)": "01.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "8129",
    "Name": "Cano Health",
    "Symbol": "CANO",
    " marketcap ": " $12 434 950 ",
    "price (USD)": "02.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "8130",
    "Name": "DermTech",
    "Symbol": "DMTK",
    " marketcap ": " $12 411 865 ",
    "price (USD)": "0.355",
    "country": "United States"
  },
  {
    "Rank": "8131",
    "Name": "Ohmyhome",
    "Symbol": "OMH",
    " marketcap ": " $12 395 095 ",
    "price (USD)": "0.544",
    "country": "Singapore"
  },
  {
    "Rank": "8132",
    "Name": "Unusual Machines",
    "Symbol": "UMAC",
    " marketcap ": " $12 320 009 ",
    "price (USD)": "\u044f\u043d\u0432.32",
    "country": "United States"
  },
  {
    "Rank": "8133",
    "Name": "Janover",
    "Symbol": "JNVR",
    " marketcap ": " $12 281 706 ",
    "price (USD)": "01.\u043d\u043e\u044f",
    "country": "United States"
  },
  {
    "Rank": "8134",
    "Name": "Can Fite Biopharma",
    "Symbol": "CANF",
    " marketcap ": " $12 251 505 ",
    "price (USD)": "2.455",
    "country": "Israel"
  },
  {
    "Rank": "8135",
    "Name": "Regis Corporation",
    "Symbol": "RGS",
    " marketcap ": " $12 106 534 ",
    "price (USD)": "\u043c\u0430\u0439.31",
    "country": "United States"
  },
  {
    "Rank": "8136",
    "Name": "LuxUrban Hotels",
    "Symbol": "LUXH",
    " marketcap ": " $12 025 638 ",
    "price (USD)": "0.27",
    "country": "United States"
  },
  {
    "Rank": "8137",
    "Name": "Expion360",
    "Symbol": "XPON",
    " marketcap ": " $11 986 869 ",
    "price (USD)": "\u044f\u043d\u0432.61",
    "country": "United States"
  },
  {
    "Rank": "8138",
    "Name": "Kaixin Auto",
    "Symbol": "KXIN",
    " marketcap ": " $11 911 146 ",
    "price (USD)": "0.1997",
    "country": "China"
  },
  {
    "Rank": "8139",
    "Name": "ShiftPixy",
    "Symbol": "PIXY",
    " marketcap ": " $11 890 014 ",
    "price (USD)": "\u044f\u043d\u0432.76",
    "country": "United States"
  },
  {
    "Rank": "8140",
    "Name": "Bruush Oral Care (Br\u0413\u0458ush)",
    "Symbol": "BRSH",
    " marketcap ": " $11 884 287 ",
    "price (USD)": "0.1177",
    "country": "Canada"
  },
  {
    "Rank": "8141",
    "Name": "Digital Hollywood Interactive",
    "Symbol": "2022.HK",
    " marketcap ": " $11 788 932 ",
    "price (USD)": "0.00589447",
    "country": "China"
  },
  {
    "Rank": "8142",
    "Name": "SIMPPLE",
    "Symbol": "SPPL",
    " marketcap ": " $11 682 720 ",
    "price (USD)": "0.72",
    "country": "Singapore"
  },
  {
    "Rank": "8143",
    "Name": "Jump Networks",
    "Symbol": "JUMPNET.NS",
    " marketcap ": " $11 669 324 ",
    "price (USD)": "0.12",
    "country": "India"
  },
  {
    "Rank": "8144",
    "Name": "22nd Century Group",
    "Symbol": "XXII",
    " marketcap ": " $11 526 603 ",
    "price (USD)": "\u044f\u043d\u0432.39",
    "country": "United States"
  },
  {
    "Rank": "8145",
    "Name": "Socket Mobile",
    "Symbol": "SCKT",
    " marketcap ": " $11 471 349 ",
    "price (USD)": "\u044f\u043d\u0432.52",
    "country": "United States"
  },
  {
    "Rank": "8146",
    "Name": "VivoPower",
    "Symbol": "VVPR",
    " marketcap ": " $11 447 100 ",
    "price (USD)": "03.\u043c\u0430\u0439",
    "country": "United Kingdom"
  },
  {
    "Rank": "8147",
    "Name": "CMON",
    "Symbol": "1792.HK",
    " marketcap ": " $11 385 956 ",
    "price (USD)": "0.00525376",
    "country": "Singapore"
  },
  {
    "Rank": "8148",
    "Name": "Eterna Therapeutics",
    "Symbol": "ERNA",
    " marketcap ": " $11 377 924 ",
    "price (USD)": "2.103",
    "country": "United States"
  },
  {
    "Rank": "8149",
    "Name": "Orosur Mining",
    "Symbol": "OMI.V",
    " marketcap ": " $11 304 521 ",
    "price (USD)": "0.0549874",
    "country": "Canada"
  },
  {
    "Rank": "8150",
    "Name": "Golden Sun Education Group",
    "Symbol": "GSUN",
    " marketcap ": " $11 241 359 ",
    "price (USD)": "\u043c\u0430\u0439.89",
    "country": "China"
  },
  {
    "Rank": "8151",
    "Name": "SINTX Technologies",
    "Symbol": "SINT",
    " marketcap ": " $11 202 328 ",
    "price (USD)": "0.0913",
    "country": "United States"
  },
  {
    "Rank": "8152",
    "Name": "Strong Global Entertainment",
    "Symbol": "SGE",
    " marketcap ": " $11 117 208 ",
    "price (USD)": "\u044f\u043d\u0432.12",
    "country": "United States"
  },
  {
    "Rank": "8153",
    "Name": "Biomerica",
    "Symbol": "BMRA",
    " marketcap ": " $11 068 613 ",
    "price (USD)": "0.658",
    "country": "United States"
  },
  {
    "Rank": "8154",
    "Name": "Ocean Power Technologies",
    "Symbol": "OPTT",
    " marketcap ": " $10 994 820 ",
    "price (USD)": "0.1849",
    "country": "United States"
  },
  {
    "Rank": "8155",
    "Name": "FGI Industries",
    "Symbol": "FGI",
    " marketcap ": " $10 883 320 ",
    "price (USD)": "1.1399",
    "country": "United States"
  },
  {
    "Rank": "8156",
    "Name": "ASLAN Pharmaceuticals",
    "Symbol": "ASLN",
    " marketcap ": " $10 860 864 ",
    "price (USD)": "0.48",
    "country": "Singapore"
  },
  {
    "Rank": "8157",
    "Name": "Netmarble Joybomb",
    "Symbol": "6468.TWO",
    " marketcap ": " $10 795 915 ",
    "price (USD)": "0.94",
    "country": "Taiwan"
  },
  {
    "Rank": "8158",
    "Name": "Monopar Therapeutics",
    "Symbol": "MNPR",
    " marketcap ": " $10 684 595 ",
    "price (USD)": "0.6111",
    "country": "United States"
  },
  {
    "Rank": "8159",
    "Name": "Superior Resources",
    "Symbol": "SPQ.AX",
    " marketcap ": " $10 675 451 ",
    "price (USD)": "0.00533447",
    "country": "Australia"
  },
  {
    "Rank": "8160",
    "Name": "Genetic Technologies",
    "Symbol": "GENE",
    " marketcap ": " $10 582 680 ",
    "price (USD)": "\u0444\u0435\u0432.32",
    "country": "Australia"
  },
  {
    "Rank": "8161",
    "Name": "Voltage",
    "Symbol": "3639.T",
    " marketcap ": " $10 558 999 ",
    "price (USD)": "1.64417",
    "country": "Japan"
  },
  {
    "Rank": "8162",
    "Name": "Vaxxinity",
    "Symbol": "VAXX",
    " marketcap ": " $10 548 512 ",
    "price (USD)": "0.0832",
    "country": "United States"
  },
  {
    "Rank": "8163",
    "Name": "PREOS Real Estate",
    "Symbol": "PAG.F",
    " marketcap ": " $10 473 173 ",
    "price (USD)": "0.0597242",
    "country": "Germany"
  },
  {
    "Rank": "8164",
    "Name": "Delta Apparel",
    "Symbol": "DLA",
    " marketcap ": " $10 435 702 ",
    "price (USD)": "\u044f\u043d\u0432.48",
    "country": "United States"
  },
  {
    "Rank": "8165",
    "Name": "Soluna Holdings",
    "Symbol": "SLNH",
    " marketcap ": " $10 391 975 ",
    "price (USD)": "\u0444\u0435\u0432.65",
    "country": "United States"
  },
  {
    "Rank": "8166",
    "Name": "AgileThought",
    "Symbol": "AGIL",
    " marketcap ": " $10 323 667 ",
    "price (USD)": "0.197",
    "country": "United States"
  },
  {
    "Rank": "8167",
    "Name": "Fresh Vine Wine",
    "Symbol": "VINE",
    " marketcap ": " $10 311 039 ",
    "price (USD)": "0.6454",
    "country": "United States"
  },
  {
    "Rank": "8168",
    "Name": "Aeterna Zentaris",
    "Symbol": "AEZS",
    " marketcap ": " $10 282 249 ",
    "price (USD)": "\u0430\u0432\u0433.01",
    "country": "United States"
  },
  {
    "Rank": "8169",
    "Name": "ADVFN",
    "Symbol": "AFN.L",
    " marketcap ": " $10 264 620 ",
    "price (USD)": "0.223121",
    "country": "United Kingdom"
  },
  {
    "Rank": "8170",
    "Name": "Inpixon",
    "Symbol": "INPX",
    " marketcap ": " $10 239 505 ",
    "price (USD)": "0.0527",
    "country": "United States"
  },
  {
    "Rank": "8171",
    "Name": "Aurora Energy Metals",
    "Symbol": "1AE.AX",
    " marketcap ": " $10 149 125 ",
    "price (USD)": "0.0566788",
    "country": "Australia"
  },
  {
    "Rank": "8172",
    "Name": "Sino-Entertainment Technology",
    "Symbol": "6933.HK",
    " marketcap ": " $10 099 940 ",
    "price (USD)": "0.0243467",
    "country": "China"
  },
  {
    "Rank": "8173",
    "Name": "Trio Petroleum",
    "Symbol": "TPET",
    " marketcap ": " $10 085 830 ",
    "price (USD)": "0.2678",
    "country": "United States"
  },
  {
    "Rank": "8174",
    "Name": "CISO Global (Cerberus Cyber Sentinel)",
    "Symbol": "CISO",
    " marketcap ": " $10 007 326 ",
    "price (USD)": "0.8181",
    "country": "United States"
  },
  {
    "Rank": "8175",
    "Name": "Nitro Games",
    "Symbol": "NITRO.ST",
    " marketcap ": " $9 985 205 ",
    "price (USD)": "0.40062",
    "country": "Finland"
  },
  {
    "Rank": "8176",
    "Name": "Prestige Wealth",
    "Symbol": "PWM",
    " marketcap ": " $9 836 250 ",
    "price (USD)": "1.075",
    "country": "Hong Kong"
  },
  {
    "Rank": "8177",
    "Name": "Carver Bancorp",
    "Symbol": "CARV",
    " marketcap ": " $9 821 652 ",
    "price (USD)": "\u044f\u043d\u0432.97",
    "country": "United States"
  },
  {
    "Rank": "8178",
    "Name": "Upexi",
    "Symbol": "UPXI",
    " marketcap ": " $9 765 536 ",
    "price (USD)": "0.4691",
    "country": "United States"
  },
  {
    "Rank": "8179",
    "Name": "Energous",
    "Symbol": "WATT",
    " marketcap ": " $9 741 978 ",
    "price (USD)": "\u044f\u043d\u0432.49",
    "country": "United States"
  },
  {
    "Rank": "8180",
    "Name": "Blackboxstocks",
    "Symbol": "BLBX",
    " marketcap ": " $9 600 348 ",
    "price (USD)": "\u0444\u0435\u0432.58",
    "country": "United States"
  },
  {
    "Rank": "8181",
    "Name": "BioNexus Gene Lab",
    "Symbol": "BGLC",
    " marketcap ": " $9 558 226 ",
    "price (USD)": "0.541",
    "country": "Malaysia"
  },
  {
    "Rank": "8182",
    "Name": "Pineapple Financial",
    "Symbol": "PAPL",
    " marketcap ": " $9 408 393 ",
    "price (USD)": "\u044f\u043d\u0432.31",
    "country": "Canada"
  },
  {
    "Rank": "8183",
    "Name": "SaverOne 2014",
    "Symbol": "SVRE",
    " marketcap ": " $9 282 530 ",
    "price (USD)": "0.543",
    "country": "Israel"
  },
  {
    "Rank": "8184",
    "Name": "Motorsport Gaming",
    "Symbol": "MSGM",
    " marketcap ": " $9 241 371 ",
    "price (USD)": "02.\u0438\u044e\u043b",
    "country": "United States"
  },
  {
    "Rank": "8185",
    "Name": "Liquid Media Group",
    "Symbol": "YVR",
    " marketcap ": " $9 171 556 ",
    "price (USD)": "0.43",
    "country": "Canada"
  },
  {
    "Rank": "8186",
    "Name": "Novo Integrated Sciences",
    "Symbol": "NVOS",
    " marketcap ": " $9 094 713 ",
    "price (USD)": "0.4773",
    "country": "United States"
  },
  {
    "Rank": "8187",
    "Name": "Reborn Coffee",
    "Symbol": "REBN",
    " marketcap ": " $9 067 078 ",
    "price (USD)": "\u043c\u0430\u0440.92",
    "country": "United States"
  },
  {
    "Rank": "8188",
    "Name": "Arrival",
    "Symbol": "ARVL",
    " marketcap ": " $9 003 799 ",
    "price (USD)": "0.49",
    "country": "United Kingdom"
  },
  {
    "Rank": "8189",
    "Name": "ReWalk Robotics",
    "Symbol": "RWLK",
    " marketcap ": " $8 922 867 ",
    "price (USD)": "1.0501",
    "country": "Israel"
  },
  {
    "Rank": "8190",
    "Name": "Zoom Telephonics",
    "Symbol": "MINM",
    " marketcap ": " $8 779 064 ",
    "price (USD)": "\u0444\u0435\u0432.96",
    "country": "United States"
  },
  {
    "Rank": "8191",
    "Name": "Northann Corp",
    "Symbol": "NCL",
    " marketcap ": " $8 765 800 ",
    "price (USD)": "0.41",
    "country": "United States"
  },
  {
    "Rank": "8192",
    "Name": "IM Cannabis",
    "Symbol": "IMCC",
    " marketcap ": " $8 749 366 ",
    "price (USD)": "0.6349",
    "country": "Israel"
  },
  {
    "Rank": "8193",
    "Name": "Trinity Place Holdings",
    "Symbol": "TPHS",
    " marketcap ": " $8 719 867 ",
    "price (USD)": "0.136149",
    "country": "United States"
  },
  {
    "Rank": "8194",
    "Name": "Salem Media Group",
    "Symbol": "SALM",
    " marketcap ": " $8 712 098 ",
    "price (USD)": "0.3201",
    "country": "United States"
  },
  {
    "Rank": "8195",
    "Name": "Nauticus Robotics",
    "Symbol": "KITT",
    " marketcap ": " $8 696 750 ",
    "price (USD)": "0.1393",
    "country": "United States"
  },
  {
    "Rank": "8196",
    "Name": "Precipio",
    "Symbol": "PRPO",
    " marketcap ": " $8 670 286 ",
    "price (USD)": "05.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "8197",
    "Name": "Marin Software",
    "Symbol": "MRIN",
    " marketcap ": " $8 635 681 ",
    "price (USD)": "\u0444\u0435\u0432.78",
    "country": "United States"
  },
  {
    "Rank": "8198",
    "Name": "GAME HOURS",
    "Symbol": "6626.TWO",
    " marketcap ": " $8 596 316 ",
    "price (USD)": "0.316308",
    "country": "Taiwan"
  },
  {
    "Rank": "8199",
    "Name": "Digital Ally",
    "Symbol": "DGLY",
    " marketcap ": " $8 584 299 ",
    "price (USD)": "3.065",
    "country": "United States"
  },
  {
    "Rank": "8200",
    "Name": "Vaccinex",
    "Symbol": "VCNX",
    " marketcap ": " $8 555 220 ",
    "price (USD)": "05.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "8201",
    "Name": "Polar Power",
    "Symbol": "POLA",
    " marketcap ": " $8 517 376 ",
    "price (USD)": "0.485",
    "country": "United States"
  },
  {
    "Rank": "8202",
    "Name": "eFFECTOR Therapeutics",
    "Symbol": "EFTR",
    " marketcap ": " $8 420 894 ",
    "price (USD)": "\u044f\u043d\u0432.79",
    "country": "United States"
  },
  {
    "Rank": "8203",
    "Name": "Jet.AI",
    "Symbol": "JTAI",
    " marketcap ": " $8 396 190 ",
    "price (USD)": "0.66",
    "country": "United States"
  },
  {
    "Rank": "8204",
    "Name": "Mighty Kingdom",
    "Symbol": "MKL.AX",
    " marketcap ": " $8 327 110 ",
    "price (USD)": "0.00333404",
    "country": "Australia"
  },
  {
    "Rank": "8205",
    "Name": "AgEagle Aerial Systems",
    "Symbol": "UAVS",
    " marketcap ": " $8 292 108 ",
    "price (USD)": "0.6944",
    "country": "United States"
  },
  {
    "Rank": "8206",
    "Name": "TRxADE HEALTH",
    "Symbol": "MEDS",
    " marketcap ": " $8 269 338 ",
    "price (USD)": "\u043c\u0430\u0439.88",
    "country": "United States"
  },
  {
    "Rank": "8207",
    "Name": "VS Media",
    "Symbol": "VSME",
    " marketcap ": " $8 250 000 ",
    "price (USD)": "0.375",
    "country": "Hong Kong"
  },
  {
    "Rank": "8208",
    "Name": "LL Lucky Games",
    "Symbol": "LADYLU.ST",
    " marketcap ": " $8 219 480 ",
    "price (USD)": "0.0608418",
    "country": "Sweden"
  },
  {
    "Rank": "8209",
    "Name": "GTI Energy",
    "Symbol": "GTR.AX",
    " marketcap ": " $8 201 550 ",
    "price (USD)": "0.00400085",
    "country": "Australia"
  },
  {
    "Rank": "8210",
    "Name": "EMCORE Corporation",
    "Symbol": "EMKR",
    " marketcap ": " $8 185 325 ",
    "price (USD)": "0.9901",
    "country": "United States"
  },
  {
    "Rank": "8211",
    "Name": "ProSomnus",
    "Symbol": "OSA",
    " marketcap ": " $8 175 227 ",
    "price (USD)": "0.47",
    "country": "United States"
  },
  {
    "Rank": "8212",
    "Name": "Missfresh",
    "Symbol": "MF",
    " marketcap ": " $8 143 030 ",
    "price (USD)": "1",
    "country": "China"
  },
  {
    "Rank": "8213",
    "Name": "Energy Focus",
    "Symbol": "EFOI",
    " marketcap ": " $8 128 978 ",
    "price (USD)": "\u044f\u043d\u0432.72",
    "country": "United States"
  },
  {
    "Rank": "8214",
    "Name": "Advent Technologies",
    "Symbol": "ADN",
    " marketcap ": " $7 998 774 ",
    "price (USD)": "03.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "8215",
    "Name": "Adamas One",
    "Symbol": "JEWL",
    " marketcap ": " $7 978 290 ",
    "price (USD)": "0.285",
    "country": "United States"
  },
  {
    "Rank": "8216",
    "Name": "Mangoceuticals",
    "Symbol": "MGRX",
    " marketcap ": " $7 891 820 ",
    "price (USD)": "0.5153",
    "country": "United States"
  },
  {
    "Rank": "8217",
    "Name": "NuCana",
    "Symbol": "NCNA",
    " marketcap ": " $7 819 080 ",
    "price (USD)": "\u043c\u0430\u0440.45",
    "country": "United Kingdom"
  },
  {
    "Rank": "8218",
    "Name": "ParaZero Technologies",
    "Symbol": "PRZO",
    " marketcap ": " $7 735 364 ",
    "price (USD)": "0.7158",
    "country": "Israel"
  },
  {
    "Rank": "8219",
    "Name": "Sl\u0413\u040eturf\u0413\u00a9lags Su\u0413\u00b0urlands",
    "Symbol": "SFS-B.IC",
    " marketcap ": " $7 723 837 ",
    "price (USD)": "0.014477",
    "country": "Iceland"
  },
  {
    "Rank": "8220",
    "Name": "Earlyworks",
    "Symbol": "ELWS",
    " marketcap ": " $7 609 936 ",
    "price (USD)": "\u0444\u0435\u0432.53",
    "country": "Japan"
  },
  {
    "Rank": "8221",
    "Name": "Shapeways",
    "Symbol": "SHPW",
    " marketcap ": " $7 608 929 ",
    "price (USD)": "\u044f\u043d\u0432.15",
    "country": "United States"
  },
  {
    "Rank": "8222",
    "Name": "Remark Holdings",
    "Symbol": "MARK",
    " marketcap ": " $7 571 743 ",
    "price (USD)": "0.1777",
    "country": "United States"
  },
  {
    "Rank": "8223",
    "Name": "Longeveron",
    "Symbol": "LGVN",
    " marketcap ": " $7 554 858 ",
    "price (USD)": "\u044f\u043d\u0432.19",
    "country": "United States"
  },
  {
    "Rank": "8224",
    "Name": "Trevena",
    "Symbol": "TRVN",
    " marketcap ": " $7 519 810 ",
    "price (USD)": "0.41",
    "country": "United States"
  },
  {
    "Rank": "8225",
    "Name": "AquaBounty",
    "Symbol": "AQB",
    " marketcap ": " $7 431 358 ",
    "price (USD)": "\u044f\u043d\u0432.65",
    "country": "United States"
  },
  {
    "Rank": "8226",
    "Name": "Pulmatrix",
    "Symbol": "PULM",
    " marketcap ": " $7 304 560 ",
    "price (USD)": "2",
    "country": "United States"
  },
  {
    "Rank": "8227",
    "Name": "Boxlight",
    "Symbol": "BOXL",
    " marketcap ": " $7 245 557 ",
    "price (USD)": "0.741",
    "country": "United States"
  },
  {
    "Rank": "8228",
    "Name": "Trust Stamp",
    "Symbol": "IDAI",
    " marketcap ": " $7 199 384 ",
    "price (USD)": "0.6792",
    "country": "United States"
  },
  {
    "Rank": "8229",
    "Name": "OLB Group",
    "Symbol": "OLB",
    " marketcap ": " $7 182 881 ",
    "price (USD)": "\u043c\u0430\u0440.97",
    "country": "United States"
  },
  {
    "Rank": "8230",
    "Name": "Golden Minerals",
    "Symbol": "AUMN",
    " marketcap ": " $7 177 320 ",
    "price (USD)": "0.4924",
    "country": "United States"
  },
  {
    "Rank": "8231",
    "Name": "Maximum Entertainment",
    "Symbol": "8R7.F",
    " marketcap ": " $7 172 680 ",
    "price (USD)": "0.146053",
    "country": "Sweden"
  },
  {
    "Rank": "8232",
    "Name": "Warrantee Inc.",
    "Symbol": "WRNT",
    " marketcap ": " $7 169 280 ",
    "price (USD)": "0.32",
    "country": "Japan"
  },
  {
    "Rank": "8233",
    "Name": "Telesis Bio",
    "Symbol": "TBIO",
    " marketcap ": " $7 141 148 ",
    "price (USD)": "\u0430\u043f\u0440.27",
    "country": "United States"
  },
  {
    "Rank": "8234",
    "Name": "BranchOut Food",
    "Symbol": "BOF",
    " marketcap ": " $7 060 461 ",
    "price (USD)": "\u044f\u043d\u0432.66",
    "country": "United States"
  },
  {
    "Rank": "8235",
    "Name": "Momentus",
    "Symbol": "MNTS",
    " marketcap ": " $6 912 255 ",
    "price (USD)": "0.52",
    "country": "United States"
  },
  {
    "Rank": "8236",
    "Name": "Greene Concepts",
    "Symbol": "INKW",
    " marketcap ": " $6 812 010 ",
    "price (USD)": "0.003",
    "country": "United States"
  },
  {
    "Rank": "8237",
    "Name": "Capstone Green Energy",
    "Symbol": "CGRN",
    " marketcap ": " $6 788 686 ",
    "price (USD)": "0.37",
    "country": "United States"
  },
  {
    "Rank": "8238",
    "Name": "Cadrenal Therapeutics",
    "Symbol": "CVKD",
    " marketcap ": " $6 723 570 ",
    "price (USD)": "0.42",
    "country": "United States"
  },
  {
    "Rank": "8239",
    "Name": "Kaival Brands Innovations",
    "Symbol": "KAVL",
    " marketcap ": " $6 685 105 ",
    "price (USD)": "2.335",
    "country": "United States"
  },
  {
    "Rank": "8240",
    "Name": "SG Blocks",
    "Symbol": "SGBX",
    " marketcap ": " $6 565 149 ",
    "price (USD)": "\u0430\u043f\u0440.87",
    "country": "United States"
  },
  {
    "Rank": "8241",
    "Name": "Cyclerion Therapeutics",
    "Symbol": "CYCN",
    " marketcap ": " $6 498 960 ",
    "price (USD)": "02.\u0438\u044e\u043d",
    "country": "United States"
  },
  {
    "Rank": "8242",
    "Name": "Al Khazna Insurance",
    "Symbol": "AKIC.AE",
    " marketcap ": " $6 480 246 ",
    "price (USD)": "0.06",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "8243",
    "Name": "Forza X1",
    "Symbol": "FRZA",
    " marketcap ": " $6 478 511 ",
    "price (USD)": "0.411",
    "country": "United States"
  },
  {
    "Rank": "8244",
    "Name": "Hepion Pharmaceuticals",
    "Symbol": "HEPA",
    " marketcap ": " $6 402 766 ",
    "price (USD)": "\u044f\u043d\u0432.17",
    "country": "United States"
  },
  {
    "Rank": "8245",
    "Name": "ManyDev Studio",
    "Symbol": "MAN.WA",
    " marketcap ": " $6 291 245 ",
    "price (USD)": "0.278374",
    "country": "Poland"
  },
  {
    "Rank": "8246",
    "Name": "Stryve Foods",
    "Symbol": "SNAX",
    " marketcap ": " $6 274 728 ",
    "price (USD)": "\u044f\u043d\u0432.94",
    "country": "United States"
  },
  {
    "Rank": "8247",
    "Name": "Wheeler Real Estate Investment Trust",
    "Symbol": "WHLR",
    " marketcap ": " $6 235 504 ",
    "price (USD)": "02.\u0444\u0435\u0432",
    "country": "United States"
  },
  {
    "Rank": "8248",
    "Name": "Kidpik",
    "Symbol": "PIK",
    " marketcap ": " $6 167 182 ",
    "price (USD)": "\u043c\u0430\u0440.16",
    "country": "United States"
  },
  {
    "Rank": "8249",
    "Name": "CalAmp",
    "Symbol": "CAMP",
    " marketcap ": " $6 141 125 ",
    "price (USD)": "\u043c\u0430\u0440.72",
    "country": "United States"
  },
  {
    "Rank": "8250",
    "Name": "Gamer Pakistan",
    "Symbol": "GPAK",
    " marketcap ": " $6 136 474 ",
    "price (USD)": "0.2399",
    "country": "United States"
  },
  {
    "Rank": "8251",
    "Name": "Soligenix",
    "Symbol": "SNGX",
    " marketcap ": " $5 940 724 ",
    "price (USD)": "0.376",
    "country": "United States"
  },
  {
    "Rank": "8252",
    "Name": "Adial Pharmaceuticals",
    "Symbol": "ADIL",
    " marketcap ": " $5 926 634 ",
    "price (USD)": "01.\u0430\u043f\u0440",
    "country": "United States"
  },
  {
    "Rank": "8253",
    "Name": "F45 Training",
    "Symbol": "FXLV",
    " marketcap ": " $5 851 008 ",
    "price (USD)": "0.06",
    "country": "United States"
  },
  {
    "Rank": "8254",
    "Name": "Sonendo",
    "Symbol": "SONX",
    " marketcap ": " $5 805 525 ",
    "price (USD)": "0.0824",
    "country": "United States"
  },
  {
    "Rank": "8255",
    "Name": "Titan Pharmaceuticals",
    "Symbol": "TTNP",
    " marketcap ": " $5 805 477 ",
    "price (USD)": "\u0438\u044e\u043d.01",
    "country": "United States"
  },
  {
    "Rank": "8256",
    "Name": "Treasure Global",
    "Symbol": "TGL",
    " marketcap ": " $5 801 479 ",
    "price (USD)": "\u0430\u043f\u0440.66",
    "country": "Malaysia"
  },
  {
    "Rank": "8257",
    "Name": "Hoth Therapeutics",
    "Symbol": "HOTH",
    " marketcap ": " $5 792 250 ",
    "price (USD)": "1.1848",
    "country": "United States"
  },
  {
    "Rank": "8258",
    "Name": "Gaming Corps",
    "Symbol": "GCOR.ST",
    " marketcap ": " $5 785 701 ",
    "price (USD)": "0.0973468",
    "country": "Sweden"
  },
  {
    "Rank": "8259",
    "Name": "Azitra",
    "Symbol": "AZTR",
    " marketcap ": " $5 760 920 ",
    "price (USD)": "0.2",
    "country": "United States"
  },
  {
    "Rank": "8260",
    "Name": "Xenetic Biosciences",
    "Symbol": "XBIO",
    " marketcap ": " $5 731 329 ",
    "price (USD)": "\u043c\u0430\u0440.72",
    "country": "United States"
  },
  {
    "Rank": "8261",
    "Name": "Biofrontera",
    "Symbol": "BFRI",
    " marketcap ": " $5 674 692 ",
    "price (USD)": "1.115",
    "country": "United States"
  },
  {
    "Rank": "8262",
    "Name": "Invitae",
    "Symbol": "NVTA",
    " marketcap ": " $5 586 613 ",
    "price (USD)": "0.0195",
    "country": "United States"
  },
  {
    "Rank": "8263",
    "Name": "Spark Networks",
    "Symbol": "LOV",
    " marketcap ": " $5 566 017 ",
    "price (USD)": "0.212",
    "country": "Germany"
  },
  {
    "Rank": "8264",
    "Name": "Playgon Games",
    "Symbol": "DEAL.V",
    " marketcap ": " $5 562 044 ",
    "price (USD)": "0.0183291",
    "country": "Canada"
  },
  {
    "Rank": "8265",
    "Name": "Asset Entities",
    "Symbol": "ASST",
    " marketcap ": " $5 544 451 ",
    "price (USD)": "0.3685",
    "country": "United States"
  },
  {
    "Rank": "8266",
    "Name": "Lipella Pharmaceuticals",
    "Symbol": "LIPO",
    " marketcap ": " $5 538 427 ",
    "price (USD)": "0.7282",
    "country": "United States"
  },
  {
    "Rank": "8267",
    "Name": "Greenbrook TMS",
    "Symbol": "GBNH",
    " marketcap ": " $5 517 878 ",
    "price (USD)": "0.121",
    "country": "Canada"
  },
  {
    "Rank": "8268",
    "Name": "Addentax Group",
    "Symbol": "ATXG",
    " marketcap ": " $5 491 984 ",
    "price (USD)": "1.0201",
    "country": "China"
  },
  {
    "Rank": "8269",
    "Name": "Nxu",
    "Symbol": "NXU",
    " marketcap ": " $5 473 085 ",
    "price (USD)": "0.449",
    "country": "United States"
  },
  {
    "Rank": "8270",
    "Name": "Baosheng Media Group",
    "Symbol": "BAOS",
    " marketcap ": " $5 348 004 ",
    "price (USD)": "\u043c\u0430\u0440.52",
    "country": "China"
  },
  {
    "Rank": "8271",
    "Name": "UpHealth",
    "Symbol": "UPH",
    " marketcap ": " $5 332 650 ",
    "price (USD)": "0.3",
    "country": "United States"
  },
  {
    "Rank": "8272",
    "Name": "Biolase",
    "Symbol": "BIOL",
    " marketcap ": " $5 326 502 ",
    "price (USD)": "0.1595",
    "country": "United States"
  },
  {
    "Rank": "8273",
    "Name": "Agrify",
    "Symbol": "AGFY",
    " marketcap ": " $5 236 419 ",
    "price (USD)": "0.368",
    "country": "United States"
  },
  {
    "Rank": "8274",
    "Name": "Farmmi",
    "Symbol": "FAMI",
    " marketcap ": " $5 228 477 ",
    "price (USD)": "0.831",
    "country": "China"
  },
  {
    "Rank": "8275",
    "Name": "Ensysce Biosciences",
    "Symbol": "ENSC",
    " marketcap ": " $5 157 915 ",
    "price (USD)": "0.68",
    "country": "United States"
  },
  {
    "Rank": "8276",
    "Name": "NanoString Technologies",
    "Symbol": "NSTG",
    " marketcap ": " $5 066 857 ",
    "price (USD)": "0.1053",
    "country": "United States"
  },
  {
    "Rank": "8277",
    "Name": "Avinger",
    "Symbol": "AVGR",
    " marketcap ": " $5 021 578 ",
    "price (USD)": "\u0444\u0435\u0432.95",
    "country": "United States"
  },
  {
    "Rank": "8278",
    "Name": "Cingulate",
    "Symbol": "CING",
    " marketcap ": " $5 018 578 ",
    "price (USD)": "0.83",
    "country": "United States"
  },
  {
    "Rank": "8279",
    "Name": "Sabre Resources",
    "Symbol": "SBR.AX",
    " marketcap ": " $4 991 225 ",
    "price (USD)": "0.0133362",
    "country": "Australia"
  },
  {
    "Rank": "8280",
    "Name": "Vapotherm",
    "Symbol": "VAPO",
    " marketcap ": " $4 972 152 ",
    "price (USD)": "0.8",
    "country": "United States"
  },
  {
    "Rank": "8281",
    "Name": "Mobilicom",
    "Symbol": "MOB",
    " marketcap ": " $4 939 369 ",
    "price (USD)": "0.93",
    "country": "Australia"
  },
  {
    "Rank": "8282",
    "Name": "Genprex",
    "Symbol": "GNPX",
    " marketcap ": " $4 931 945 ",
    "price (USD)": "\u0444\u0435\u0432.35",
    "country": "United States"
  },
  {
    "Rank": "8283",
    "Name": "Portage Biotech",
    "Symbol": "PRTG",
    " marketcap ": " $4 914 445 ",
    "price (USD)": "0.2484",
    "country": "British Virgin Islands"
  },
  {
    "Rank": "8284",
    "Name": "Grom Social Enterprises",
    "Symbol": "GROM",
    " marketcap ": " $4 908 579 ",
    "price (USD)": "0.55",
    "country": "United States"
  },
  {
    "Rank": "8285",
    "Name": "DAVIDsTEA",
    "Symbol": "DTEAF",
    " marketcap ": " $4 881 093 ",
    "price (USD)": "0.1818",
    "country": "Canada"
  },
  {
    "Rank": "8286",
    "Name": "Society Pass",
    "Symbol": "SOPA",
    " marketcap ": " $4 836 388 ",
    "price (USD)": "1.832",
    "country": "Singapore"
  },
  {
    "Rank": "8287",
    "Name": "MyMD Pharmaceuticals",
    "Symbol": "MYMD",
    " marketcap ": " $4 822 946 ",
    "price (USD)": "02.\u0441\u0435\u043d",
    "country": "United States"
  },
  {
    "Rank": "8288",
    "Name": "Fragbite Group",
    "Symbol": "FRAG.ST",
    " marketcap ": " $4 723 579 ",
    "price (USD)": "0.0435253",
    "country": "Sweden"
  },
  {
    "Rank": "8289",
    "Name": "Nuwellis",
    "Symbol": "NUWE",
    " marketcap ": " $4 693 286 ",
    "price (USD)": "0.26",
    "country": "United States"
  },
  {
    "Rank": "8290",
    "Name": "Zoomd Technologies",
    "Symbol": "ZOMD.V",
    " marketcap ": " $4 685 952 ",
    "price (USD)": "0.0476557",
    "country": "Canada"
  },
  {
    "Rank": "8291",
    "Name": "Vivid Games",
    "Symbol": "VVD.WA",
    " marketcap ": " $4 669 059 ",
    "price (USD)": "0.144616",
    "country": "Poland"
  },
  {
    "Rank": "8292",
    "Name": "Signing Day Sports",
    "Symbol": "SGN",
    " marketcap ": " $4 648 349 ",
    "price (USD)": "0.3022",
    "country": "United States"
  },
  {
    "Rank": "8293",
    "Name": "EZGO Technologies",
    "Symbol": "EZGO",
    " marketcap ": " $4 622 993 ",
    "price (USD)": "\u044f\u043d\u0432.81",
    "country": "China"
  },
  {
    "Rank": "8294",
    "Name": "Tharimmune",
    "Symbol": "THAR",
    " marketcap ": " $4 603 878 ",
    "price (USD)": "0.3905",
    "country": "United States"
  },
  {
    "Rank": "8295",
    "Name": "SOBR Safe",
    "Symbol": "SOBR",
    " marketcap ": " $4 598 873 ",
    "price (USD)": "0.23",
    "country": "United States"
  },
  {
    "Rank": "8296",
    "Name": "Titan Medical",
    "Symbol": "TMD.TO",
    " marketcap ": " $4 598 556 ",
    "price (USD)": "0.0403241",
    "country": "Canada"
  },
  {
    "Rank": "8297",
    "Name": "Petros Pharmaceuticals",
    "Symbol": "PTPI",
    " marketcap ": " $4 548 030 ",
    "price (USD)": "0.6497",
    "country": "United States"
  },
  {
    "Rank": "8298",
    "Name": "Mallinckrodt Pharmaceuticals",
    "Symbol": "MNK",
    " marketcap ": " $4 520 986 ",
    "price (USD)": "0.3402",
    "country": "United Kingdom"
  },
  {
    "Rank": "8299",
    "Name": "IMTE",
    "Symbol": "IMTE",
    " marketcap ": " $4 490 365 ",
    "price (USD)": "02.\u0441\u0435\u043d",
    "country": "Australia"
  },
  {
    "Rank": "8300",
    "Name": "OpGen",
    "Symbol": "OPGN",
    " marketcap ": " $4 393 339 ",
    "price (USD)": "\u043c\u0430\u0440.99",
    "country": "United States"
  },
  {
    "Rank": "8301",
    "Name": "Gamida Cell",
    "Symbol": "GMDA",
    " marketcap ": " $4 337 295 ",
    "price (USD)": "0.0327",
    "country": "Israel"
  },
  {
    "Rank": "8302",
    "Name": "Arcimoto",
    "Symbol": "FUV",
    " marketcap ": " $4 242 586 ",
    "price (USD)": "0.38",
    "country": "United States"
  },
  {
    "Rank": "8303",
    "Name": "Arcadia Biosciences",
    "Symbol": "RKDA",
    " marketcap ": " $4 231 618 ",
    "price (USD)": "3.105",
    "country": "United States"
  },
  {
    "Rank": "8304",
    "Name": "Onfolio Holdings",
    "Symbol": "ONFO",
    " marketcap ": " $4 127 800 ",
    "price (USD)": "0.8082",
    "country": "United States"
  },
  {
    "Rank": "8305",
    "Name": "USD Partners",
    "Symbol": "USDP",
    " marketcap ": " $4 118 112 ",
    "price (USD)": "0.12193",
    "country": "United States"
  },
  {
    "Rank": "8306",
    "Name": "Cemtrex",
    "Symbol": "CETX",
    " marketcap ": " $4 075 570 ",
    "price (USD)": "0.3826",
    "country": "United States"
  },
  {
    "Rank": "8307",
    "Name": "JOANN",
    "Symbol": "JOAN",
    " marketcap ": " $4 061 243 ",
    "price (USD)": "0.0969",
    "country": "United States"
  },
  {
    "Rank": "8308",
    "Name": "Leafly Holdings",
    "Symbol": "LFLY",
    " marketcap ": " $3 997 002 ",
    "price (USD)": "\u044f\u043d\u0432.69",
    "country": "United States"
  },
  {
    "Rank": "8309",
    "Name": "PunkPirates",
    "Symbol": "PUN.WA",
    " marketcap ": " $3 942 991 ",
    "price (USD)": "0.13",
    "country": "Poland"
  },
  {
    "Rank": "8310",
    "Name": "Hempacco",
    "Symbol": "HPCO",
    " marketcap ": " $3 938 575 ",
    "price (USD)": "01.\u043c\u0430\u0440",
    "country": "United States"
  },
  {
    "Rank": "8311",
    "Name": "Evoke Pharma",
    "Symbol": "EVOK",
    " marketcap ": " $3 877 432 ",
    "price (USD)": "0.451",
    "country": "United States"
  },
  {
    "Rank": "8312",
    "Name": "Locafy",
    "Symbol": "LCFY",
    " marketcap ": " $3 867 037 ",
    "price (USD)": "03.\u043c\u0430\u0440",
    "country": "Australia"
  },
  {
    "Rank": "8313",
    "Name": "Polished.com",
    "Symbol": "POL",
    " marketcap ": " $3 843 876 ",
    "price (USD)": "\u044f\u043d\u0432.22",
    "country": "United States"
  },
  {
    "Rank": "8314",
    "Name": "Field Trip Health",
    "Symbol": "FTHW.V",
    " marketcap ": " $3 701 866 ",
    "price (USD)": "0.04",
    "country": "Canada"
  },
  {
    "Rank": "8315",
    "Name": "Heart Test Laboratories",
    "Symbol": "HSCS",
    " marketcap ": " $3 691 118 ",
    "price (USD)": "\u043c\u0430\u0439.63",
    "country": "United States"
  },
  {
    "Rank": "8316",
    "Name": "Versus Systems",
    "Symbol": "VS",
    " marketcap ": " $3 558 548 ",
    "price (USD)": "\u044f\u043d\u0432.42",
    "country": "Canada"
  },
  {
    "Rank": "8317",
    "Name": "Fr8Tech ",
    "Symbol": null,
    " marketcap ": null,
    "price (USD)": null,
    "country": null
  },
  {
    "Rank": " (Freight Technologies)\"",
    "Name": "FRGT",
    "Symbol": "3556956",
    " marketcap ": " 0.734 ",
    "price (USD)": "United States",
    "country": null
  },
  {
    "Rank": "8318",
    "Name": "Innovative Eyewear",
    "Symbol": "LUCY",
    " marketcap ": " $3 500 220 ",
    "price (USD)": "0.2",
    "country": "United States"
  },
  {
    "Rank": "8319",
    "Name": "Phio Pharmaceuticals",
    "Symbol": "PHIO",
    " marketcap ": " $3 489 232 ",
    "price (USD)": "0.7599",
    "country": "United States"
  },
  {
    "Rank": "8320",
    "Name": "Casa Systems",
    "Symbol": "CASA",
    " marketcap ": " $3 468 815 ",
    "price (USD)": "0.035",
    "country": "United States"
  },
  {
    "Rank": "8321",
    "Name": "Helius Medical Technologies",
    "Symbol": "HSDT",
    " marketcap ": " $3 465 908 ",
    "price (USD)": "\u044f\u043d\u0432.37",
    "country": "United States"
  },
  {
    "Rank": "8322",
    "Name": "Oblong",
    "Symbol": "OBLG",
    " marketcap ": " $3 430 481 ",
    "price (USD)": "0.1691",
    "country": "United States"
  },
  {
    "Rank": "8323",
    "Name": "Sunworks",
    "Symbol": "SUNW",
    " marketcap ": " $3 407 046 ",
    "price (USD)": "0.06",
    "country": "United States"
  },
  {
    "Rank": "8324",
    "Name": "Ascent Solar Technologies",
    "Symbol": "ASTI",
    " marketcap ": " $3 396 272 ",
    "price (USD)": "0.1105",
    "country": "United States"
  },
  {
    "Rank": "8325",
    "Name": "Seelos Therapeutics",
    "Symbol": "SEEL",
    " marketcap ": " $3 384 108 ",
    "price (USD)": "\u044f\u043d\u0432.63",
    "country": "United States"
  },
  {
    "Rank": "8326",
    "Name": "Altamira Therapeutics",
    "Symbol": "CYTO",
    " marketcap ": " $3 315 570 ",
    "price (USD)": "\u044f\u043d\u0432.48",
    "country": "Bermuda"
  },
  {
    "Rank": "8327",
    "Name": "Afristrat Investment",
    "Symbol": "ATI.JO",
    " marketcap ": " $3 290 200 ",
    "price (USD)": "0.00664191",
    "country": "South Africa"
  },
  {
    "Rank": "8328",
    "Name": "Wolverine Energy and Infrastructure",
    "Symbol": "WEII.V",
    " marketcap ": " $3 274 071 ",
    "price (USD)": "0.03",
    "country": "Canada"
  },
  {
    "Rank": "8329",
    "Name": "Solid Clouds",
    "Symbol": "SOLID.IC",
    " marketcap ": " $3 253 333 ",
    "price (USD)": "0.017662",
    "country": "Iceland"
  },
  {
    "Rank": "8330",
    "Name": "Avalon GloboCare",
    "Symbol": "ALBT",
    " marketcap ": " $3 221 415 ",
    "price (USD)": "0.2901",
    "country": "United States"
  },
  {
    "Rank": "8331",
    "Name": "Akanda",
    "Symbol": "AKAN",
    " marketcap ": " $3 209 141 ",
    "price (USD)": "0.093",
    "country": "United Kingdom"
  },
  {
    "Rank": "8332",
    "Name": "RVL Pharmaceuticals",
    "Symbol": "RVLP",
    " marketcap ": " $3 141 649 ",
    "price (USD)": "0.0282",
    "country": "United States"
  },
  {
    "Rank": "8333",
    "Name": "Express",
    "Symbol": "EXPR",
    " marketcap ": " $3 109 395 ",
    "price (USD)": "0.83",
    "country": "United States"
  },
  {
    "Rank": "8334",
    "Name": "Sonoma Pharmaceuticals",
    "Symbol": "SNOA",
    " marketcap ": " $3 105 872 ",
    "price (USD)": "0.199",
    "country": "United States"
  },
  {
    "Rank": "8335",
    "Name": "Netcapital",
    "Symbol": "NCPL",
    " marketcap ": " $3 085 237 ",
    "price (USD)": "0.1491",
    "country": "United States"
  },
  {
    "Rank": "8336",
    "Name": "BIO-key International",
    "Symbol": "BKYI",
    " marketcap ": " $3 078 653 ",
    "price (USD)": "\u044f\u043d\u0432.05",
    "country": "United States"
  },
  {
    "Rank": "8337",
    "Name": "Quoin Pharmaceuticals",
    "Symbol": "QNRX",
    " marketcap ": " $2 985 375 ",
    "price (USD)": "0.7501",
    "country": "United States"
  },
  {
    "Rank": "8338",
    "Name": "CURO Group",
    "Symbol": "CURO",
    " marketcap ": " $2 891 035 ",
    "price (USD)": "0.07",
    "country": "United States"
  },
  {
    "Rank": "8339",
    "Name": "NuZee",
    "Symbol": "NUZE",
    " marketcap ": " $2 847 965 ",
    "price (USD)": "\u044f\u043d\u0432.89",
    "country": "United States"
  },
  {
    "Rank": "8340",
    "Name": "Tivic Health Systems",
    "Symbol": "TIVC",
    " marketcap ": " $2 842 596 ",
    "price (USD)": "0.4597",
    "country": "United States"
  },
  {
    "Rank": "8341",
    "Name": "Gameone",
    "Symbol": "8282.HK",
    " marketcap ": " $2 813 967 ",
    "price (USD)": "0.0781657",
    "country": "Hong Kong"
  },
  {
    "Rank": "8342",
    "Name": "cbdMD",
    "Symbol": "YCBD",
    " marketcap ": " $2 704 487 ",
    "price (USD)": "0.699",
    "country": "United States"
  },
  {
    "Rank": "8343",
    "Name": "Agile Therapeutics",
    "Symbol": "AGRX",
    " marketcap ": " $2 694 498 ",
    "price (USD)": "0.393",
    "country": "United States"
  },
  {
    "Rank": "8344",
    "Name": "PREIT (Pennsylvania Real Estate Investment Trust)",
    "Symbol": "PRET",
    " marketcap ": " $2 690 436 ",
    "price (USD)": "0.4974",
    "country": "United States"
  },
  {
    "Rank": "8345",
    "Name": "Playground Ventures",
    "Symbol": "PLAY.CN",
    " marketcap ": " $2 647 239 ",
    "price (USD)": "0.0329924",
    "country": "Canada"
  },
  {
    "Rank": "8346",
    "Name": "Future Supply Chain Solutions",
    "Symbol": "FSC.NS",
    " marketcap ": " $2 641 451 ",
    "price (USD)": "0.0600767",
    "country": "India"
  },
  {
    "Rank": "8347",
    "Name": "Staffing 360 Solutions",
    "Symbol": "STAF",
    " marketcap ": " $2 573 305 ",
    "price (USD)": "0.3294",
    "country": "United States"
  },
  {
    "Rank": "8348",
    "Name": "iSpecimen",
    "Symbol": "ISPC",
    " marketcap ": " $2 451 830 ",
    "price (USD)": "0.2457",
    "country": "United States"
  },
  {
    "Rank": "8349",
    "Name": "Edible Garden",
    "Symbol": "EDBL",
    " marketcap ": " $2 378 867 ",
    "price (USD)": "\u0430\u043f\u0440.33",
    "country": "United States"
  },
  {
    "Rank": "8350",
    "Name": "Galmed Pharmaceuticals",
    "Symbol": "GLMD",
    " marketcap ": " $2 340 758 ",
    "price (USD)": "0.3895",
    "country": "Israel"
  },
  {
    "Rank": "8351",
    "Name": "ToughBuilt Industries",
    "Symbol": "TBLT",
    " marketcap ": " $2 331 236 ",
    "price (USD)": "03.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "8352",
    "Name": "PaxMedica",
    "Symbol": "PXMD",
    " marketcap ": " $2 309 062 ",
    "price (USD)": "0.2968",
    "country": "United States"
  },
  {
    "Rank": "8353",
    "Name": "Lucy Scientific Discovery",
    "Symbol": "LSDI",
    " marketcap ": " $2 223 597 ",
    "price (USD)": "\u044f\u043d\u0432.26",
    "country": "Canada"
  },
  {
    "Rank": "8354",
    "Name": "Sientra",
    "Symbol": "SIEN",
    " marketcap ": " $2 080 639 ",
    "price (USD)": "0.174",
    "country": "United States"
  },
  {
    "Rank": "8355",
    "Name": "Jeffs' Brands",
    "Symbol": "JFBR",
    " marketcap ": " $2 025 003 ",
    "price (USD)": "0.3375",
    "country": "Israel"
  },
  {
    "Rank": "8356",
    "Name": "Greenlane",
    "Symbol": "GNLN",
    " marketcap ": " $2 012 739 ",
    "price (USD)": "0.539",
    "country": "United States"
  },
  {
    "Rank": "8357",
    "Name": "LMP Automotive Holdings",
    "Symbol": "LMPX",
    " marketcap ": " $1 909 032 ",
    "price (USD)": "0.12",
    "country": "United States"
  },
  {
    "Rank": "8358",
    "Name": "180 Life Sciences",
    "Symbol": "ATNF",
    " marketcap ": " $1 873 764 ",
    "price (USD)": "\u044f\u043d\u0432.99",
    "country": "United States"
  },
  {
    "Rank": "8359",
    "Name": "Virax Biolabs",
    "Symbol": "VRAX",
    " marketcap ": " $1 868 499 ",
    "price (USD)": "0.7911",
    "country": "United Kingdom"
  },
  {
    "Rank": "8360",
    "Name": "PainReform",
    "Symbol": "PRFX",
    " marketcap ": " $1 855 305 ",
    "price (USD)": "0.75",
    "country": "Israel"
  },
  {
    "Rank": "8361",
    "Name": "Applied DNA Sciences",
    "Symbol": "APDN",
    " marketcap ": " $1 846 365 ",
    "price (USD)": "1.875",
    "country": "United States"
  },
  {
    "Rank": "8362",
    "Name": "Virtual Interactive Technologies",
    "Symbol": "VRVR",
    " marketcap ": " $1 815 281 ",
    "price (USD)": "0.22",
    "country": "Bermuda"
  },
  {
    "Rank": "8363",
    "Name": "Actelis Networks",
    "Symbol": "ASNS",
    " marketcap ": " $1 777 863 ",
    "price (USD)": "0.53",
    "country": "United States"
  },
  {
    "Rank": "8364",
    "Name": "G Medical Innovations",
    "Symbol": "GMVD",
    " marketcap ": " $1 776 616 ",
    "price (USD)": "0.181",
    "country": "Israel"
  },
  {
    "Rank": "8365",
    "Name": "Eastside Distilling",
    "Symbol": "EAST",
    " marketcap ": " $1 673 595 ",
    "price (USD)": "0.98",
    "country": "United States"
  },
  {
    "Rank": "8366",
    "Name": "Qiiwi Games",
    "Symbol": "QIIWI.ST",
    " marketcap ": " $1 662 293 ",
    "price (USD)": "0.179717",
    "country": "Sweden"
  },
  {
    "Rank": "8367",
    "Name": "CorEnergy Infrastructure Trust",
    "Symbol": "CORR",
    " marketcap ": " $1 627 350 ",
    "price (USD)": "0.0198",
    "country": "United States"
  },
  {
    "Rank": "8368",
    "Name": "VIP Gloves",
    "Symbol": "VIP.AX",
    " marketcap ": " $1 573 898 ",
    "price (USD)": "0.00200043",
    "country": "Malaysia"
  },
  {
    "Rank": "8369",
    "Name": "Hallmark Financial Services",
    "Symbol": "HALL",
    " marketcap ": " $1 491 170 ",
    "price (USD)": "0.82",
    "country": "United States"
  },
  {
    "Rank": "8370",
    "Name": "Tapinator",
    "Symbol": "TAPM",
    " marketcap ": " $1 437 669 ",
    "price (USD)": "0.5275",
    "country": "United States"
  },
  {
    "Rank": "8371",
    "Name": "T-Bull",
    "Symbol": "TBL.WA",
    " marketcap ": " $1 389 931 ",
    "price (USD)": "1.16968",
    "country": "Poland"
  },
  {
    "Rank": "8372",
    "Name": "Leoni AG",
    "Symbol": "LEO.DE",
    " marketcap ": " $1 366 918 ",
    "price (USD)": "0.04",
    "country": "Germany"
  },
  {
    "Rank": "8373",
    "Name": "Yield10 Bioscience",
    "Symbol": "YTEN",
    " marketcap ": " $1 349 346 ",
    "price (USD)": "02.\u044f\u043d\u0432",
    "country": "United States"
  },
  {
    "Rank": "8374",
    "Name": "View, Inc.",
    "Symbol": "VIEW",
    " marketcap ": " $1 342 123 ",
    "price (USD)": "0.33",
    "country": "United States"
  },
  {
    "Rank": "8375",
    "Name": "Compleo Charging Solutions",
    "Symbol": "C0M.F",
    " marketcap ": " $1 321 259 ",
    "price (USD)": "0.260615",
    "country": "Germany"
  },
  {
    "Rank": "8376",
    "Name": "Wearable Health Solutions",
    "Symbol": "WHSI",
    " marketcap ": " $1 187 361 ",
    "price (USD)": "0.00065",
    "country": "United States"
  },
  {
    "Rank": "8377",
    "Name": "Aethlon Medical",
    "Symbol": "AEMD",
    " marketcap ": " $1 130 783 ",
    "price (USD)": "0.43",
    "country": "United States"
  },
  {
    "Rank": "8378",
    "Name": "HELMA Eigenheimbau",
    "Symbol": "H5E.DE",
    " marketcap ": " $1 129 329 ",
    "price (USD)": "0.282332",
    "country": "Germany"
  },
  {
    "Rank": "8379",
    "Name": "Freeze Tag",
    "Symbol": "FRZT",
    " marketcap ": " $1 119 837 ",
    "price (USD)": "0.01492",
    "country": "United States"
  },
  {
    "Rank": "8380",
    "Name": "Impac Mortgage Holdings",
    "Symbol": "IMPM",
    " marketcap ": " $1 097 067 ",
    "price (USD)": "0.03",
    "country": "United States"
  },
  {
    "Rank": "8381",
    "Name": "Movella",
    "Symbol": "MVLA",
    " marketcap ": " $1 079 239 ",
    "price (USD)": "0.0212",
    "country": "United States"
  },
  {
    "Rank": "8382",
    "Name": "Baudax Bio",
    "Symbol": "BXRX",
    " marketcap ": " $950 329 ",
    "price (USD)": "0.0218",
    "country": "United States"
  },
  {
    "Rank": "8383",
    "Name": "Sozap",
    "Symbol": "SOZAP.ST",
    " marketcap ": " $909 825 ",
    "price (USD)": "0.0772222",
    "country": "Sweden"
  },
  {
    "Rank": "8384",
    "Name": "Neptune Wellness Solutions",
    "Symbol": "NEPT",
    " marketcap ": " $906 408 ",
    "price (USD)": "0.2",
    "country": "Canada"
  },
  {
    "Rank": "8385",
    "Name": "Evofem Biosciences",
    "Symbol": "EVFM",
    " marketcap ": " $862 639 ",
    "price (USD)": "0.0139",
    "country": "United States"
  },
  {
    "Rank": "8386",
    "Name": "Triterras",
    "Symbol": "TRIRF",
    " marketcap ": " $826 460 ",
    "price (USD)": "0.0108",
    "country": "Singapore"
  },
  {
    "Rank": "8387",
    "Name": "Acorda Therapeutics",
    "Symbol": "ACOR",
    " marketcap ": " $821 028 ",
    "price (USD)": "0.661",
    "country": "United States"
  },
  {
    "Rank": "8388",
    "Name": "Bellerophon Therapeutics",
    "Symbol": "BLPH",
    " marketcap ": " $795 119 ",
    "price (USD)": "0.065",
    "country": "United States"
  },
  {
    "Rank": "8389",
    "Name": "Trillium Gold Mines",
    "Symbol": "TGM.V",
    " marketcap ": " $775 193 ",
    "price (USD)": "0.05",
    "country": "Canada"
  },
  {
    "Rank": "8390",
    "Name": "Esports Entertainment",
    "Symbol": "GMBL",
    " marketcap ": " $744 887 ",
    "price (USD)": "0.65",
    "country": "Malta"
  },
  {
    "Rank": "8391",
    "Name": "Kuuhubb",
    "Symbol": "KUU.V",
    " marketcap ": " $712 506 ",
    "price (USD)": "0.01",
    "country": "Canada"
  },
  {
    "Rank": "8392",
    "Name": "Skylight Health Group",
    "Symbol": "SLHG.V",
    " marketcap ": " $581 373 ",
    "price (USD)": "0.01",
    "country": "Canada"
  },
  {
    "Rank": "8393",
    "Name": "Lightning eMotors",
    "Symbol": "ZEVY",
    " marketcap ": " $537 371 ",
    "price (USD)": "0.0815",
    "country": "United States"
  },
  {
    "Rank": "8394",
    "Name": "iEntertainment Network",
    "Symbol": "IENT",
    " marketcap ": " $431 871 ",
    "price (USD)": "0.0033",
    "country": "United States"
  },
  {
    "Rank": "8395",
    "Name": "Mobile Global Esports (Mogo)",
    "Symbol": "MGAM",
    " marketcap ": " $424 730 ",
    "price (USD)": "0.02",
    "country": "United States"
  },
  {
    "Rank": "8396",
    "Name": "Republic First Bancorp",
    "Symbol": "FRBK",
    " marketcap ": " $394 301 ",
    "price (USD)": "0.0056",
    "country": "United States"
  },
  {
    "Rank": "8397",
    "Name": "Youngevity International",
    "Symbol": "YGYI",
    " marketcap ": " $377 890 ",
    "price (USD)": "0.0111",
    "country": "United States"
  },
  {
    "Rank": "8398",
    "Name": "Super League Gaming",
    "Symbol": "SLGG",
    " marketcap ": " $291 827 ",
    "price (USD)": "0.0856",
    "country": "United States"
  },
  {
    "Rank": "8399",
    "Name": "Ampio Pharmaceuticals",
    "Symbol": "AMPE",
    " marketcap ": " $273 621 ",
    "price (USD)": "0.241",
    "country": "United States"
  },
  {
    "Rank": "8400",
    "Name": "The NFT Gaming Company",
    "Symbol": "NFTG",
    " marketcap ": " $272 488 ",
    "price (USD)": "0.2501",
    "country": "United States"
  },
  {
    "Rank": "8401",
    "Name": "Solar Integrated Roofing",
    "Symbol": "SIRC",
    " marketcap ": " $256 722 ",
    "price (USD)": "0.0001",
    "country": "United States"
  },
  {
    "Rank": "8402",
    "Name": "Akerna",
    "Symbol": "KERN",
    " marketcap ": " $162 320 ",
    "price (USD)": "0.3136",
    "country": "United States"
  },
  {
    "Rank": "8403",
    "Name": "Endo International",
    "Symbol": "ENDPQ",
    " marketcap ": " $141 132 ",
    "price (USD)": "0.0006",
    "country": "Ireland"
  },
  {
    "Rank": "8404",
    "Name": "Calithera Biosciences",
    "Symbol": "CALA",
    " marketcap ": " $97 450 ",
    "price (USD)": "0.02",
    "country": "United States"
  },
  {
    "Rank": "8405",
    "Name": "iFresh",
    "Symbol": "IFMK",
    " marketcap ": " $67 391 ",
    "price (USD)": "0.0007",
    "country": "United States"
  },
  {
    "Rank": "8406",
    "Name": "Kaspien",
    "Symbol": "KSPN",
    " marketcap ": " $46 964 ",
    "price (USD)": "0.00945",
    "country": "United States"
  },
  {
    "Rank": "8407",
    "Name": "Vinco Ventures",
    "Symbol": "BBIG",
    " marketcap ": " $41 600 ",
    "price (USD)": "0.0032",
    "country": "United States"
  },
  {
    "Rank": "8408",
    "Name": "Alkaline Water Company",
    "Symbol": "WTER",
    " marketcap ": " $18 233 ",
    "price (USD)": "0.0014",
    "country": "United States"
  },
  {
    "Rank": "8409",
    "Name": "Onion Global",
    "Symbol": "OGBLY",
    " marketcap ": " $10 512 ",
    "price (USD)": "0.0001",
    "country": "China"
  },
  {
    "Rank": "8410",
    "Name": "Minerva Surgical",
    "Symbol": "UTRS",
    " marketcap ": " $8 879 ",
    "price (USD)": "0.001",
    "country": "United States"
  },
  {
    "Rank": "8411",
    "Name": "Gaming Technologies (Gametech)",
    "Symbol": "GMGT",
    " marketcap ": " $4 570 ",
    "price (USD)": "0.0001",
    "country": "United States"
  },
  {
    "Rank": "8412",
    "Name": "Viveve Medical",
    "Symbol": "VIVE",
    " marketcap ": " $3 217 ",
    "price (USD)": "0.0003",
    "country": "United States"
  },
  {
    "Rank": "8413",
    "Name": "Trulite",
    "Symbol": "TRUL",
    " marketcap ": " $2 120 ",
    "price (USD)": "1.0E-6",
    "country": "United States"
  },
  {
    "Rank": "8414",
    "Name": "Great Panther Mining",
    "Symbol": "GPLDF",
    " marketcap ": " $47 ",
    "price (USD)": "1.0E-6",
    "country": "Canada"
  },
  {
    "Rank": "8415",
    "Name": "Zovio",
    "Symbol": "ZVOI",
    " marketcap ": " $34 ",
    "price (USD)": "1.0E-6",
    "country": "United States"
  },
  {
    "Rank": "8416",
    "Name": "Qiwi",
    "Symbol": "QIWI.ME",
    " marketcap ": " $- ",
    "price (USD)": "02.\u0430\u0432\u0433",
    "country": "Cyprus"
  },
  {
    "Rank": "8417",
    "Name": "Rosseti",
    "Symbol": "RSTI.ME",
    " marketcap ": " $- ",
    "price (USD)": "0",
    "country": "Russia"
  },
  {
    "Rank": "8418",
    "Name": "Abu Dhabi Aviation",
    "Symbol": "ADAVIATION.AE",
    " marketcap ": " $- ",
    "price (USD)": "0",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "8419",
    "Name": "Al Dhafra Insurance",
    "Symbol": "DHAFRA.AE",
    " marketcap ": " $- ",
    "price (USD)": "0",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "8420",
    "Name": "Emirates Islamic Bank",
    "Symbol": "EIB.AE",
    " marketcap ": " $- ",
    "price (USD)": "0",
    "country": "United Arab Emirates"
  },
  {
    "Rank": "8421",
    "Name": "X5 Retail Group",
    "Symbol": "FIVE.ME",
    " marketcap ": " $- ",
    "price (USD)": "30.99",
    "country": "Netherlands"
  },
  {
    "Rank": "8422",
    "Name": "Ozon",
    "Symbol": "OZON.ME",
    " marketcap ": " $- ",
    "price (USD)": "51.07",
    "country": "United States"
  }
]
